import * as i0 from '@angular/core';
import { Directive, ContentChild, Input, Injectable, EventEmitter, ViewEncapsulation, Component, Output, ViewChildren, ContentChildren, Pipe, forwardRef, Inject, ViewChild, NgModule, signal, computed, effect, ViewContainerRef, ChangeDetectionStrategy, HostListener, HostBinding, isDevMode, inject, ChangeDetectorRef, ElementRef, Optional, NgZone, InjectionToken, TemplateRef, model, input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, APP_BASE_HREF, PlatformLocation, DOCUMENT } from '@angular/common';
import * as i2$1 from '@angular/forms';
import { FormsModule, NG_VALUE_ACCESSOR, UntypedFormGroup, UntypedFormControl, Validators, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import moment$1 from 'moment-timezone';
import * as i1$1 from '@ngx-translate/core';
import { TranslateModule, TranslateService, TranslateCompiler, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
export { TranslateModule } from '@ngx-translate/core';
import * as i2 from '@angular/common/http';
import { HttpHeaders, HttpHandler, HttpClient, HttpBackend, provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import * as i1$2 from '@perfectmemory/ngx-contextmenu';
import { ContextMenuComponent, ContextMenuModule } from '@perfectmemory/ngx-contextmenu';
import * as i1$3 from 'ngx-bootstrap/modal';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import * as i1$6 from 'ngx-image-cropper';
import { ImageCropperModule } from 'ngx-image-cropper';
import * as i1$7 from '@angular/router';
import { RouterModule, NavigationEnd, PRIMARY_OUTLET } from '@angular/router';
import * as i1$4 from '@ng-bootstrap/ng-bootstrap';
import { NgbModule, NgbDateAdapter, NgbDate, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { take, debounceTime, takeUntil, throttleTime, shareReplay, map, filter, distinctUntilChanged, switchMap, tap, delay, catchError } from 'rxjs/operators';
import * as i6 from '@angular/cdk/listbox';
import { CdkListbox, CdkOption, CdkListboxModule } from '@angular/cdk/listbox';
import * as i3 from '@angular/cdk/a11y';
import { A11yModule, CdkTrapFocus } from '@angular/cdk/a11y';
import { ScrollingModule } from '@angular/cdk/scrolling';
import * as _ from 'lodash';
import { size, isObject, cloneDeep, isNaN as isNaN$1, isEmpty, isUndefined, isNumber, isArray } from 'lodash';
import $$1 from 'jquery';
import { Observable, ReplaySubject, fromEvent, asyncScheduler, Subject, BehaviorSubject, of, Subscriber, noop, throwError, interval, forkJoin } from 'rxjs';
import * as i1$5 from '@angular/platform-browser';
import Flow from '@flowjs/flow.js/dist/flow.js';
import * as i5 from '@flowjs/ngx-flow';
import { NgxFlowModule, FlowInjectionToken } from '@flowjs/ngx-flow';
import * as i4 from '@tinymce/tinymce-angular';
import { EditorModule } from '@tinymce/tinymce-angular';
import * as i3$1 from 'ngx-bootstrap/typeahead';
import { TypeaheadConfig, TypeaheadModule } from 'ngx-bootstrap/typeahead';
import * as i4$1 from 'ngx-bootstrap/timepicker';
import { TimepickerConfig, TimepickerComponent, TimepickerModule } from 'ngx-bootstrap/timepicker';
import * as i8 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import * as i10 from 'ngx-bootstrap/dropdown';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import * as i3$2 from 'ngx-bootstrap/tooltip';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import * as socketClusterClient from 'socketcluster-client';
import * as moment_ from 'moment';
import { defineCustomElements } from '@symplicity/duetds-date-picker/dist/loader';
import { Toast, Tooltip } from '@symplicity/bootstrap';
import * as i12 from 'ngx-skeleton-loader';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
const _c0$1I = ["dataTableCell"];
const _c1$1m = ["dataTableHeader"];
class DataTableColumn {
  constructor() {
    this.header = '';
    this.sortable = false;
    this.resizable = false;
    this.property = '';
    this.assign = false;
    this.styleClass = '';
    this.type = '';
    this.active = false;
    this.width = 0;
    this.visible = true;
    this.emptyHeader = '';
    this.styleClassObject = {}; // for [ngClass]
  }
  getCellColor(row, index) {
    if (this.cellColors !== undefined) {
      return this.cellColors(row.item, row, this, index);
    }
  }
  ngOnInit() {
    this._initCellClass();
  }
  _initCellClass() {
    if (!this.styleClass && this.property) {
      if (/^[a-zA-Z0-9_]+$/.test(this.property)) {
        this.styleClass = 'column-' + this.property;
      } else {
        this.styleClass = 'column-' + this.property.replace(/[^a-zA-Z0-9_]/g, '');
      }
    }
    if (this.styleClass != null) {
      this.styleClassObject = {
        [this.styleClass]: true
      };
    }
  }
  static {
    this.ɵfac = function DataTableColumn_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DataTableColumn)();
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: DataTableColumn,
      selectors: [["data-table-column"]],
      contentQueries: function DataTableColumn_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c0$1I, 7);
          i0.ɵɵcontentQuery(dirIndex, _c1$1m, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cellTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        }
      },
      inputs: {
        header: "header",
        sortable: "sortable",
        resizable: "resizable",
        property: "property",
        assign: "assign",
        styleClass: "styleClass",
        type: "type",
        active: "active",
        cellColors: "cellColors",
        width: "width",
        visible: "visible",
        emptyHeader: "emptyHeader"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableColumn, [{
    type: Directive,
    args: [{
      selector: 'data-table-column',
      standalone: false
    }]
  }], () => [], {
    header: [{
      type: Input
    }],
    sortable: [{
      type: Input
    }],
    resizable: [{
      type: Input
    }],
    property: [{
      type: Input
    }],
    assign: [{
      type: Input
    }],
    styleClass: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    active: [{
      type: Input
    }],
    cellColors: [{
      type: Input
    }],
    width: [{
      type: Input
    }],
    visible: [{
      type: Input
    }],
    emptyHeader: [{
      type: Input
    }],
    cellTemplate: [{
      type: ContentChild,
      args: ['dataTableCell', {
        static: true
      }]
    }],
    headerTemplate: [{
      type: ContentChild,
      args: ['dataTableHeader', {
        static: true
      }]
    }]
  });
})();
class HtmlFormatterService {
  constructor(_datePipe) {
    this._datePipe = _datePipe;
  }
  getToolTipHTML(tipId, label, tipLabel, link) {
    return "<span class='a11y-tip a11y-tip--delay'>" + "<a href='" + link + "' role='button' class='a11y-tip__trigger' attr.aria-describedby='tt-" + tipId + "'>" + label + "</a>" + "<span attr.id='tt-" + tipId + "' role='tooltip' class='a11y-tip__help a11y-tip__help--top'>" + tipLabel + "</span>" + "</span>";
  }
  formatDate(date, type = 'medium', tzOffset = '') {
    if (date) {
      const simpleDateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
      let momentDateTime;
      if (simpleDateRegex.test(date)) {
        momentDateTime = moment$1.tz(date + 'T00:00:00', moment$1.tz.guess());
      } else {
        momentDateTime = moment$1.tz(date, moment$1.tz.guess());
      }
      if (momentDateTime.isValid()) {
        const dateObj = momentDateTime.toDate();
        return tzOffset ? this._datePipe.transform(dateObj, type, tzOffset) : this._datePipe.transform(dateObj, type);
      }
    }
    return '';
  }
  formatTime(date, format, inputFormat, skipTzConvert = false) {
    const momentDate = inputFormat ? moment$1(date, inputFormat) : moment$1(date);
    if (!format) {
      format = 'HH:mm';
    }
    if (momentDate.isValid()) {
      if (!skipTzConvert) {
        momentDate.tz('UTC');
      }
      return momentDate.format(format);
    }
    return date;
  }
  formatTzDate(date, type = 'medium', tz = '') {
    if (tz === '' && window.USER_TZ) {
      tz = window.USER_TZ;
    }
    const tzOffset = moment$1(date).tz(tz).format('Z');
    return this.formatDate(date, type, tzOffset);
  }
  static {
    this.ɵfac = function HtmlFormatterService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HtmlFormatterService)(i0.ɵɵinject(i1.DatePipe));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: HtmlFormatterService,
      factory: HtmlFormatterService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HtmlFormatterService, [{
    type: Injectable
  }], () => [{
    type: i1.DatePipe
  }], null);
})();
function isBlank(obj) {
  return obj === undefined || obj === null;
}
class Hide {
  constructor(_elementRef, _renderer) {
    this._elementRef = _elementRef;
    this._renderer = _renderer;
    this._prevCondition = null;
  }
  set hide(newCondition) {
    this.initDisplayStyle();
    if (newCondition && (isBlank(this._prevCondition) || !this._prevCondition)) {
      this._prevCondition = true;
      this._renderer.setStyle(this._elementRef.nativeElement, 'display', 'none');
    } else if (!newCondition && (isBlank(this._prevCondition) || this._prevCondition)) {
      this._prevCondition = false;
      this._renderer.setStyle(this._elementRef.nativeElement, 'display', this._displayStyle);
    }
  }
  initDisplayStyle() {
    if (this._displayStyle === undefined) {
      let displayStyle = window.getComputedStyle(this._elementRef.nativeElement, null).display;
      if (displayStyle && displayStyle !== 'none') {
        this._displayStyle = displayStyle;
      }
    }
  }
  static {
    this.ɵfac = function Hide_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Hide)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: Hide,
      selectors: [["", "hide", ""]],
      inputs: {
        hide: "hide"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Hide, [{
    type: Directive,
    args: [{
      selector: '[hide]',
      inputs: ['hide'],
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], null);
})();
const _c0$1H = ["dataTableRow", ""];
const _c1$1l = (a0, a1, a2) => ({
  column: a0,
  row: a1,
  item: a2
});
function DataTableRow_td_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.displayIndex);
  }
}
function DataTableRow_td_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
  }
  if (rf & 2) {
    const column_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.item[column_r2.property]);
  }
}
function DataTableRow_td_5_div_2_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function DataTableRow_td_5_div_2_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.dataTable.viewItem(ctx_r0.item));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", ctx_r0.item.viewAriaLabel || i0.ɵɵpipeBind1(1, 2, "misc.View"))("title", i0.ɵɵpipeBind1(2, 4, "misc.View"));
  }
}
function DataTableRow_td_5_div_2_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function DataTableRow_td_5_div_2_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.dataTable.editItem(ctx_r0.item));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", ctx_r0.item.editAriaLabel || i0.ɵɵpipeBind1(1, 2, "misc.Edit"))("title", i0.ɵɵpipeBind1(2, 4, "misc.Edit"));
  }
}
function DataTableRow_td_5_div_2_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function DataTableRow_td_5_div_2_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.dataTable.deleteItem(ctx_r0.item));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", ctx_r0.item.deleteAriaLabel || i0.ɵɵpipeBind1(1, 2, "misc.Delete"))("title", i0.ɵɵpipeBind1(2, 4, "misc.Delete"));
  }
}
function DataTableRow_td_5_div_2_span_6_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function DataTableRow_td_5_div_2_span_6_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const customAction_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(customAction_r7.fn(ctx_r0.item));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customAction_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMapInterpolate1("icn-btn list-action-icn icn-", customAction_r7.icon, "");
    i0.ɵɵattribute("aria-label", customAction_r7.ariaLabel || customAction_r7.label)("title", customAction_r7.label);
  }
}
function DataTableRow_td_5_div_2_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, DataTableRow_td_5_div_2_span_6_button_1_Template, 1, 5, "button", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customAction_r7 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !customAction_r7.canUse || customAction_r7.canUse(ctx_r0.item));
  }
}
function DataTableRow_td_5_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 11)(2, "span", 12);
    i0.ɵɵtemplate(3, DataTableRow_td_5_div_2_button_3_Template, 3, 6, "button", 13)(4, DataTableRow_td_5_div_2_button_4_Template, 3, 6, "button", 14)(5, DataTableRow_td_5_div_2_button_5_Template, 3, 6, "button", 15)(6, DataTableRow_td_5_div_2_span_6_Template, 2, 1, "span", 16);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.dataTable.canView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dataTable.canEdit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dataTable.canDelete);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.dataTable.customRowActions);
  }
}
function DataTableRow_td_5_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 22);
  }
  if (rf & 2) {
    const column_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", column_r2.cellTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c1$1l, column_r2, ctx_r0._this, ctx_r0.item));
  }
}
function DataTableRow_td_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 6);
    i0.ɵɵtemplate(1, DataTableRow_td_5_div_1_Template, 1, 1, "div", 7)(2, DataTableRow_td_5_div_2_Template, 7, 4, "div", 8)(3, DataTableRow_td_5_div_3_Template, 1, 6, "div", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background-color", column_r2.getCellColor(ctx_r0._this, ctx_r0.index));
    i0.ɵɵproperty("hide", !column_r2.visible)("ngClass", column_r2.styleClassObject);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !column_r2.cellTemplate && column_r2.property !== "display" && ctx_r0.item[column_r2.property]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !column_r2.cellTemplate && column_r2.property === "Actions");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r2.cellTemplate);
  }
}
class DataTableRow {
  constructor(_htmlFormatter) {
    this._htmlFormatter = _htmlFormatter;
    this.themePath = '/themes/dawn/dawn';
    // row selection:
    this._selected = false;
    this.selectedChange = new EventEmitter();
    this._this = this; // FIXME is there no template keyword for this in angular 2?
  }
  get selected() {
    return this._selected;
  }
  set selected(selected) {
    this._selected = selected;
    this.selectedChange.emit(selected);
  }
  // other:
  ngOnInit() {
    if (this.item.checked_row) {
      this.selected = this.item.checked_row;
    }
    Object.keys(this.item).forEach(property => {
      let columnType = this.dataTable.getColumnType(property);
      if (columnType === 'datetime') {
        this.item[property] = this._htmlFormatter.formatTzDate(this.item[property]);
      } else if (columnType === 'date') {
        this.item[property] = this._htmlFormatter.formatDate(this.item[property], 'mediumDate');
      }
    });
  }
  get displayIndex() {
    if (this.dataTable.pagination) {
      return this.dataTable.displayParams.offset + this.index + 1;
    } else {
      return this.index + 1;
    }
  }
  ngOnDestroy() {
    this.selected = false;
  }
  static {
    this.ɵfac = function DataTableRow_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DataTableRow)(i0.ɵɵdirectiveInject(HtmlFormatterService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: DataTableRow,
      selectors: [["", "dataTableRow", ""]],
      inputs: {
        themePath: "themePath",
        item: "item",
        index: "index",
        dataTable: "dataTable"
      },
      outputs: {
        selectedChange: "selectedChange"
      },
      standalone: false,
      attrs: _c0$1H,
      decls: 6,
      vars: 8,
      consts: [["class", "index-column table-column-padding", 3, "textContent", 4, "ngIf"], [1, "select-column", "table-column-padding", "lst_td", 3, "hide"], [1, "acc_hide2", 3, "for"], ["type", "checkbox", 3, "change", "id", "checked"], ["class", "data-column table-column-padding", "role", "cell", 3, "hide", "ngClass", "background-color", 4, "ngFor", "ngForOf"], [1, "index-column", "table-column-padding", 3, "textContent"], ["role", "cell", 1, "data-column", "table-column-padding", 3, "hide", "ngClass"], [3, "textContent", 4, "ngIf"], [4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [3, "textContent"], [1, "list-action-buttons"], [2, "white-space", "nowrap", "text-align", "center"], ["type", "button", "class", "icn-btn list-action-icn icn-page_view", 3, "click", 4, "ngIf"], ["type", "button", "class", "icn-btn list-action-icn icn-edit", 3, "click", 4, "ngIf"], ["type", "button", "class", "icn-btn list-action-icn icn-delete", 3, "click", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["type", "button", 1, "icn-btn", "list-action-icn", "icn-page_view", 3, "click"], ["type", "button", 1, "icn-btn", "list-action-icn", "icn-edit", 3, "click"], ["type", "button", 1, "icn-btn", "list-action-icn", "icn-delete", 3, "click"], ["type", "button", 3, "class", "click", 4, "ngIf"], ["type", "button", 3, "click"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function DataTableRow_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, DataTableRow_td_0_Template, 1, 1, "td", 0);
          i0.ɵɵelementStart(1, "td", 1)(2, "label", 2);
          i0.ɵɵtext(3, "Select this item");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "input", 3);
          i0.ɵɵlistener("change", function DataTableRow_Template_input_change_4_listener() {
            return ctx.dataTable.onCheckboxSelect(ctx, ctx.selected);
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(5, DataTableRow_td_5_Template, 4, 7, "td", 4);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.dataTable.indexColumnVisible);
          i0.ɵɵadvance();
          i0.ɵɵproperty("hide", !ctx.dataTable.selectColumnVisible);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate1("for", "checkbox_", ctx.index, "");
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate1("id", "checkbox_", ctx.index, "");
          i0.ɵɵproperty("checked", ctx.selected);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.dataTable.columns);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, Hide, i1$1.TranslatePipe],
      styles: [".clickable{cursor:pointer}.clicked-image{object-position:0 -32px}.default-image{object-position:0 0}.row-expand-button{cursor:pointer;text-align:center}.select-column{text-align:center}.table-column-padding{padding:8px}.name-redirect-link{text-transform:none!important}.name-redirect-link.btn{height:auto;font-weight:initial;margin:0}.name-redirect-link:hover{text-decoration:underline!important;color:initial;cursor:pointer}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableRow, [{
    type: Component,
    args: [{
      selector: '[dataTableRow]',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<td *ngIf=\"dataTable.indexColumnVisible\" class=\"index-column table-column-padding\" [textContent]=\"displayIndex\"></td>\n<td [hide]=\"!dataTable.selectColumnVisible\" class=\"select-column table-column-padding lst_td\">\n    <label for=\"checkbox_{{index}}\" class=\"acc_hide2\">Select this item</label>\n    <input id=\"checkbox_{{index}}\" type=\"checkbox\" [checked]=\"selected\" (change)=\"dataTable.onCheckboxSelect(this, selected)\"/>\n</td>\n<td *ngFor=\"let column of dataTable.columns\" [hide]=\"!column.visible\" [ngClass]=\"column.styleClassObject\" class=\"data-column table-column-padding\"\n    [style.background-color]=\"column.getCellColor(_this, index)\" role=\"cell\">\n    <div *ngIf=\"!column.cellTemplate && column.property!=='display' && item[column.property]\" [textContent]=\"item[column.property]\"></div>\n    <div *ngIf=\"!column.cellTemplate && column.property==='Actions'\">\n        <div class=\"list-action-buttons\">\n            <span style=\"white-space:nowrap;text-align:center\">\n                <button\n                    *ngIf=\"dataTable.canView\"\n                    type=\"button\"\n                    class=\"icn-btn list-action-icn icn-page_view\"\n                    [attr.aria-label]=\"item.viewAriaLabel || ('misc.View' | translate)\"\n                    [attr.title]=\"'misc.View' | translate\"\n                    (click)=\"dataTable.viewItem(item)\"\n                >\n\n                </button>\n                <button\n                    *ngIf=\"dataTable.canEdit\"\n                    type=\"button\"\n                    class=\"icn-btn list-action-icn icn-edit\"\n                    [attr.aria-label]=\"item.editAriaLabel || ('misc.Edit' | translate)\"\n                    [attr.title]=\"'misc.Edit' | translate\"\n                    (click)=\"dataTable.editItem(item)\"\n                >\n\n                </button>\n                <button\n                    *ngIf=\"dataTable.canDelete\"\n                    type=\"button\"\n                    class=\"icn-btn list-action-icn icn-delete\"\n                    [attr.aria-label]=\"item.deleteAriaLabel || ('misc.Delete' | translate)\"\n                    [attr.title]=\"'misc.Delete' | translate\"\n                    (click)=\"dataTable.deleteItem(item)\"\n                >\n                </button>\n                <span *ngFor='let customAction of dataTable.customRowActions'>\n                    <button\n                        *ngIf=\"!customAction.canUse || customAction.canUse(item)\"\n                        type=\"button\"\n                        class=\"icn-btn list-action-icn icn-{{customAction.icon}}\"\n                        [attr.aria-label]=\"customAction.ariaLabel || customAction.label\"\n                        [attr.title]=\"customAction.label\"\n                        (click)=\"customAction.fn(item)\"\n                    >\n                    </button>\n                </span>\n            </span>\n        </div>\n    </div>\n    <div *ngIf=\"column.cellTemplate\" [ngTemplateOutlet]=\"column.cellTemplate\" [ngTemplateOutletContext]=\"{column: column, row: _this, item: item}\"></div>\n</td>\n",
      styles: [".clickable{cursor:pointer}.clicked-image{object-position:0 -32px}.default-image{object-position:0 0}.row-expand-button{cursor:pointer;text-align:center}.select-column{text-align:center}.table-column-padding{padding:8px}.name-redirect-link{text-transform:none!important}.name-redirect-link.btn{height:auto;font-weight:initial;margin:0}.name-redirect-link:hover{text-decoration:underline!important;color:initial;cursor:pointer}\n"]
    }]
  }], () => [{
    type: HtmlFormatterService
  }], {
    themePath: [{
      type: Input
    }],
    item: [{
      type: Input
    }],
    index: [{
      type: Input
    }],
    dataTable: [{
      type: Input
    }],
    selectedChange: [{
      type: Output
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DataTableRow, {
    className: "DataTableRow",
    filePath: "data-table/components/row.ts",
    lineNumber: 14
  });
})();
var defaultTranslations = {
  indexColumn: 'index',
  selectColumn: 'select',
  expandColumn: 'expand',
  paginationLimit: 'Limit',
  paginationRange: 'Results'
};
class EmptyStateModel {
  constructor(init) {
    this.src = '';
    this.title = 'misc.No results found';
    this.icon = 'icn-binoculars';
    this.message = '';
    this.titleStyleClass = '';
    this.messageStyleClass = '';
    Object.assign(this, init);
  }
}
class EmptyStateActionButtonModel {
  constructor(init) {
    this.label = '';
    this.icon = null;
    this.styleClass = '';
    Object.assign(this, init);
  }
}
function drag(event, {
  move: move,
  up: up
}) {
  let startX = event.pageX;
  let startY = event.pageY;
  let x = startX;
  let y = startY;
  let moved = false;
  function mouseMoveHandler(event) {
    let dx = event.pageX - x;
    let dy = event.pageY - y;
    x = event.pageX;
    y = event.pageY;
    if (dx || dy) moved = true;
    move(event, dx, dy, x, y);
    event.preventDefault(); // to avoid text selection
  }
  function mouseUpHandler(event) {
    x = event.pageX;
    y = event.pageY;
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);
    if (up) up(event, x, y, moved);
  }
  document.addEventListener('mousemove', mouseMoveHandler);
  document.addEventListener('mouseup', mouseUpHandler);
}
const defaultPaginationState = {
  'limit': 20,
  'page': 1,
  'sortBy': 'display',
  'sortAsc': true
};
const dbMapping = {
  'active': {
    'display': 'name',
    'category_name': 'category',
    'modified': 'modified',
    'published_on': 'published_on',
    'participant_count': 'participant_count'
  },
  'archived': {
    'display': 'name',
    'category_name': 'category',
    'modified': 'modified',
    'published_on': 'published_on',
    'participant_count': 'participant_count'
  },
  'eligibleStudent': {
    'display': 'lname',
    'fname': 'fname',
    'resolveMajor': 'major',
    'email': 'email',
    'year': 'year',
    'graduation_date': 'graduation_date'
  },
  'participant': {
    'lname': 'lname',
    'fname': 'fname',
    'resolveMajor': 'major',
    'year': 'year',
    'percent_task_complete': 'percent_task_complete',
    'started_on': 'started_on',
    'display': 'started_on',
    'completed_on': 'completed_on'
  }
};
class GlobalService {
  constructor(location) {
    this.warningMsgs = {
      'default': 'Are you sure?',
      'deleteWarning': 'Are you sure you want to delete this entry?\n' + 'Doing so will permanently delete it.',
      'archiveWarning': 'Are you sure you want to archive this entry?',
      'unarchiveWarning': 'Are you sure you want to unarchive this entry?'
    };
    this.SYSTEM_URL = window.location.protocol + '//' + window.location.host + '/';
    this.API_URL = this.SYSTEM_URL;
    this.API_KEY = 'Basic 389a31571f68ca0e41f75e03d30b3e30';
  }
  get defaultPaginationState() {
    return defaultPaginationState;
  }
  getWarningMsg(type) {
    return this.warningMsgs[type] ? this.warningMsgs[type] : this.warningMsgs['default'];
  }
  paramsToQueryString(params, paramsMapName) {
    let output = '';
    if (params) {
      let result = [];
      if (params.page != null) {
        result.push(['page', params.page]);
      }
      if (params.limit != null) {
        result.push(['perPage', params.limit]);
      }
      if (params.sortBy != null) {
        result.push(['sort', params.sortAsc ? this.mapToDB(params.sortBy, paramsMapName) : '!' + this.mapToDB(params.sortBy, paramsMapName)]);
      }
      output = '?' + result.map(param => param.join('=')).join('&');
      if (params.filters && params.filters.length) {
        output = `${output}&${params.filters.join('&')}`;
      }
    }
    return output;
  }
  mapToDB(param, mapName) {
    return dbMapping[mapName][param];
  }
  static {
    this.ɵfac = function GlobalService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GlobalService)(i0.ɵɵinject(i1.Location));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: GlobalService,
      factory: GlobalService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.Location
  }], null);
})();
class BackendService {
  constructor(http, globalService) {
    this.http = http;
    this.globalService = globalService;
    this.dependentDynamicPickCalls = {
      'getApplicationSetupForTerm': this.getApplicationSetupForTerm.bind(this)
    };
    this.url = globalService.API_URL + 'api';
    this.systemUrl = globalService.API_URL;
    this.apiKey = globalService.API_KEY;
  }
  setCheck(params = '', resource) {
    return this.http.get(`${this.systemUrl}${resource}${params}`, {
      headers: this.setHeader()
    });
  }
  getAll(params = '', resource, api_prefix = 'v2') {
    return this.http.get(`${this.url}/${api_prefix}/${resource}${params}`, {
      headers: this.setHeader()
    });
  }
  getOne(id, resource, api_prefix = 'v2') {
    return this.http.get(`${this.url}/${api_prefix}/${resource}/${id}`, {
      headers: this.setHeader()
    });
  }
  create(resource, payload, api_prefix = 'v2', params = {}) {
    return this.http.post(`${this.url}/${api_prefix}/${resource}`, payload, {
      headers: this.setHeader(),
      params: params
    });
  }
  update(id, resource, payload, api_prefix = 'v2', params = {}) {
    return this.http.put(`${this.url}/${api_prefix}/${resource}/${id}`, payload, {
      headers: this.setHeader(),
      params: params
    });
  }
  deleteOne(id, resource, api_prefix = 'v2', params = {}) {
    return this.http.delete(`${this.url}/${api_prefix}/${resource}/${id}`, {
      headers: this.setHeader(),
      params: params
    });
  }
  patchOne(id, resource, payload, api_prefix = 'v2', params = {}) {
    return this.http.patch(`${this.url}/${api_prefix}/${resource}/${id}`, payload, {
      headers: this.setHeader(),
      params: params
    });
  }
  getDynamicPicks(callbackName, param) {
    return this.dependentDynamicPickCalls[callbackName](param);
  }
  getApplicationSetupForTerm(termID, api_prefix = 'v2') {
    return this.http.get(`${this.url}/${api_prefix}/application-setups/pick-values?term=${termID}`, {
      headers: this.setHeader()
    });
  }
  updateOrder(id, resource, params, payload, api_prefix = 'v2') {
    return this.http.put(`${this.url}/${api_prefix}/${resource}/${id}/${params}`, payload, {});
  }
  getPicklistArray(className, fieldName, api_prefix = 'v2') {
    return this.http.get(`${this.url}/${api_prefix}/picklists/${className}/${fieldName}`, {
      headers: this.setHeader()
    });
  }
  getStats(id, resource, api_prefix = 'v2') {
    return this.http.get(`${this.url}/${api_prefix}/${resource}/${id}/stats`, {
      headers: this.setHeader()
    });
  }
  setHeader() {
    return new HttpHeaders({
      'Authorization': this.apiKey,
      'x-requested-system-user': 'manager'
    });
  }
  static {
    this.ɵfac = function BackendService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BackendService)(i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(GlobalService));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: BackendService,
      factory: BackendService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BackendService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i2.HttpClient
  }, {
    type: GlobalService
  }], null);
})();
const _c0$1G = ["dataTableExpand"];
const _c1$1k = a0 => ({
  "display": a0
});
const _c2$Z = a0 => ({
  "active_col": a0
});
const _c3$H = (a0, a1, a2) => ({
  "align-column": a0,
  "sort_asc ": a1,
  "sort_desc": a2
});
const _c4$x = a0 => ({
  column: a0
});
const _c5$n = a0 => ({
  list_title: a0
});
function DataTable_div_0_data_table_header_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "data-table-header", 28);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("header", ctx_r1.header);
  }
}
function DataTable_div_0_th_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 29);
    i0.ɵɵelement(1, "span", 30);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r1.indexColumnHeader);
  }
}
function DataTable_div_0_th_23_a_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "a", 37);
  }
  if (rf & 2) {
    const column_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", column_r4.header)("ngClass", i0.ɵɵpureFunction3(2, _c3$H, !column_r4.sortable, column_r4.sortable && column_r4.property !== ctx_r1.sortBy || column_r4.sortable && column_r4.property === ctx_r1.sortBy && ctx_r1.sortAsc, column_r4.sortable && column_r4.property === ctx_r1.sortBy && !ctx_r1.sortAsc));
  }
}
function DataTable_div_0_th_23_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 38);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, column_r4.emptyHeader));
  }
}
function DataTable_div_0_th_23_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 39);
  }
  if (rf & 2) {
    const column_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", column_r4.headerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c4$x, column_r4));
  }
}
function DataTable_div_0_th_23_span_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 40);
    i0.ɵɵlistener("mousedown", function DataTable_div_0_th_23_span_6_Template_span_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const column_r4 = i0.ɵɵnextContext().$implicit;
      const th_r6 = i0.ɵɵreference(1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.resizeColumnStart($event, column_r4, th_r6));
    });
    i0.ɵɵelementEnd();
  }
}
function DataTable_div_0_th_23_i_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 41);
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-disabled", true);
  }
}
function DataTable_div_0_th_23_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 31, 0);
    i0.ɵɵpipe(2, "px");
    i0.ɵɵlistener("keyup.enter", function DataTable_div_0_th_23_Template_th_keyup_enter_0_listener($event) {
      const column_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.headerClicked(column_r4, $event));
    })("click", function DataTable_div_0_th_23_Template_th_click_0_listener($event) {
      const column_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.headerClicked(column_r4, $event));
    });
    i0.ɵɵtemplate(3, DataTable_div_0_th_23_a_3_Template, 1, 6, "a", 32)(4, DataTable_div_0_th_23_span_4_Template, 3, 3, "span", 33)(5, DataTable_div_0_th_23_span_5_Template, 1, 4, "span", 34)(6, DataTable_div_0_th_23_span_6_Template, 1, 0, "span", 35)(7, DataTable_div_0_th_23_i_7_Template, 1, 1, "i", 36);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("width", i0.ɵɵpipeBind1(2, 15, column_r4.width));
    i0.ɵɵclassProp("sortable", column_r4.sortable)("resizable", column_r4.resizable);
    i0.ɵɵproperty("hide", !column_r4.visible)("ngClass", i0.ɵɵpureFunction1(17, _c2$Z, column_r4.active))("ngClass", column_r4.styleClassObject);
    i0.ɵɵattribute("aria-sort", column_r4.sortable && column_r4.property === ctx_r1.sortBy ? ctx_r1.sortAsc ? "ascending" : "descending" : null);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !column_r4.headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !column_r4.header);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r4.headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r4.resizable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r4.sortable);
  }
}
function DataTable_div_0_tr_25_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 42, 1);
    i0.ɵɵlistener("dblclick", function DataTable_div_0_tr_25_Template_tr_dblclick_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const row_r8 = i0.ɵɵreference(1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.rowDoubleClicked(row_r8, $event));
    })("click", function DataTable_div_0_tr_25_Template_tr_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const row_r8 = i0.ɵɵreference(1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.rowClicked(row_r8, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const idx_r10 = ctx.index;
    const row_r8 = i0.ɵɵreference(1);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("background-color", ctx_r1.getRowColor(item_r9, idx_r10, row_r8));
    i0.ɵɵclassProp("row-odd", idx_r10 % 2 === 0)("row-even", idx_r10 % 2 === 1)("row_content_style", true)("active_row", ctx_r1.selected)("clickable", ctx_r1.selectOnRowClick);
    i0.ɵɵproperty("dataTable", ctx_r1)("item", item_r9)("index", idx_r10)("themePath", "/components/unicon/assets/svg-output/")("title", ctx_r1.getTooltip(item_r9, row_r8, idx_r10));
  }
}
function DataTable_div_0_div_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 43);
  }
}
function DataTable_div_0_data_table_header_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "data-table-header", 44);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("header", ctx_r1.header)("batchOptionsButton", false);
  }
}
function DataTable_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, DataTable_div_0_data_table_header_1_Template, 1, 1, "data-table-header", 6);
    i0.ɵɵelementStart(2, "div", 7)(3, "table", 8)(4, "thead", 9)(5, "tr", 10);
    i0.ɵɵtemplate(6, DataTable_div_0_th_6_Template, 2, 1, "th", 11);
    i0.ɵɵelementStart(7, "th", 12)(8, "div", 13);
    i0.ɵɵlistener("keyup.enter", function DataTable_div_0_Template_div_keyup_enter_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.show_options = !ctx_r1.show_options);
    })("click", function DataTable_div_0_Template_div_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.show_options = !ctx_r1.show_options);
    });
    i0.ɵɵelementStart(9, "span", 14)(10, "img", 15);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵlistener("keyup.enter", function DataTable_div_0_Template_img_keyup_enter_10_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onSelectAllChanged($event, true));
    })("click", function DataTable_div_0_Template_img_click_10_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onSelectAllChanged($event, true));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "span", 16)(13, "img", 17);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵlistener("keyup.enter", function DataTable_div_0_Template_img_keyup_enter_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onSelectAllChanged($event, false));
    })("click", function DataTable_div_0_Template_img_click_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onSelectAllChanged($event, false));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "span", 18)(16, "img", 19);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵlistener("keyup.enter", function DataTable_div_0_Template_img_keyup_enter_16_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onSelectAllChanged($event, false));
    })("click", function DataTable_div_0_Template_img_click_16_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onSelectAllChanged($event, false));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(18, "div", 20)(19, "button", 21);
    i0.ɵɵlistener("keyup.enter", function DataTable_div_0_Template_button_keyup_enter_19_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onSelectAllChanged($event, true));
    })("click", function DataTable_div_0_Template_button_click_19_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onSelectAllChanged($event, true));
    });
    i0.ɵɵtext(20, "misc.Select All");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "button", 22);
    i0.ɵɵlistener("keyup.enter", function DataTable_div_0_Template_button_keyup_enter_21_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onSelectAllChanged($event, false));
    })("click", function DataTable_div_0_Template_button_click_21_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onSelectAllChanged($event, false));
    });
    i0.ɵɵtext(22, "misc.Select None");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(23, DataTable_div_0_th_23_Template, 8, 19, "th", 23);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "tbody", 24);
    i0.ɵɵtemplate(25, DataTable_div_0_tr_25_Template, 2, 17, "tr", 25);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(26, DataTable_div_0_div_26_Template, 1, 0, "div", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, DataTable_div_0_data_table_header_27_Template, 1, 2, "data-table-header", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.header);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.indexColumnVisible);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hide", !ctx_r1.selectColumnVisible);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-expanded", ctx_r1.show_options);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hide", ctx_r1.selected_one || ctx_r1.selected);
    i0.ɵɵadvance();
    i0.ɵɵattribute("alt", i0.ɵɵpipeBind1(11, 15, "misc.select all"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hide", !ctx_r1.selected_one);
    i0.ɵɵadvance();
    i0.ɵɵattribute("alt", i0.ɵɵpipeBind1(14, 17, "misc.select none"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hide", !ctx_r1.selected);
    i0.ɵɵadvance();
    i0.ɵɵattribute("alt", i0.ɵɵpipeBind1(17, 19, "misc.select none"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(21, _c1$1k, ctx_r1.show_options ? "block" : "none"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r1.columns);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.items);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showReloading && ctx_r1.reloading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.header);
  }
}
function DataTable_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelement(1, "img", 46);
    i0.ɵɵelementStart(2, "div", 47);
    i0.ɵɵtext(3, "misc.Loading");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("src", "", ctx_r1.themePath, "spinner.gif", i0.ɵɵsanitizeUrl);
  }
}
function DataTable_div_2_ng_container_1_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵtext(1, "misc.Once you create new records, they will appear here");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("translateParams", i0.ɵɵpureFunction1(1, _c5$n, ctx_r1.tabTitle));
  }
}
function DataTable_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 51);
    i0.ɵɵelement(2, "img", 52);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 53)(5, "h3", 54);
    i0.ɵɵtext(6, "misc.No list records yet");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, DataTable_div_2_ng_container_1_div_7_Template, 2, 3, "div", 55);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("src", "", ctx_r1.themePath, "emptystate-document.png", i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("alt", i0.ɵɵpipeBind1(3, 5, "misc.Empty List"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("translateParams", i0.ɵɵpureFunction1(7, _c5$n, ctx_r1.tabTitle));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.customButtons || ctx_r1.showAddNewMsg);
  }
}
function DataTable_div_2_ng_container_2_img_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 52);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("src", ctx_r1.emptyState.src, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("alt", i0.ɵɵpipeBind1(1, 2, "misc.Empty List"));
  }
}
function DataTable_div_2_ng_container_2_i_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("icn ", ctx_r1.emptyState.icon, "");
  }
}
function DataTable_div_2_ng_container_2_div_3_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 60);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHTML", ctx_r1.emptyState.message, i0.ɵɵsanitizeHtml)("ngClass", ctx_r1.emptyState.messageStyleClass);
  }
}
function DataTable_div_2_ng_container_2_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "h3", 58);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DataTable_div_2_ng_container_2_div_3_div_3_Template, 1, 2, "div", 59);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.emptyState.titleStyleClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.emptyState.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.customButtons || ctx_r1.emptyState.message);
  }
}
function DataTable_div_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTable_div_2_ng_container_2_img_1_Template, 2, 4, "img", 56)(2, DataTable_div_2_ng_container_2_i_2_Template, 1, 3, "i", 57)(3, DataTable_div_2_ng_container_2_div_3_Template, 4, 3, "div", 49);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.emptyState.src);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.emptyState.icon && !ctx_r1.emptyState.src);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.emptyState.title || ctx_r1.emptyState.message);
  }
}
function DataTable_div_2_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 61)(1, "input", 62);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function DataTable_div_2_div_3_Template_input_click_1_listener() {
      const button_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.customButtonEvent(button_r12.id));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const button_r12 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("input-button ", button_r12.styleClass, "");
    i0.ɵɵpropertyInterpolate("value", i0.ɵɵpipeBind1(2, 4, button_r12.display));
  }
}
function DataTable_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵtemplate(1, DataTable_div_2_ng_container_1_Template, 8, 9, "ng-container", 49)(2, DataTable_div_2_ng_container_2_Template, 4, 3, "ng-container", 49)(3, DataTable_div_2_div_3_Template, 3, 6, "div", 50);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.useCustomEmptyState);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.useCustomEmptyState && ctx_r1.emptyState);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.customButtons)("ngForTrackBy", ctx_r1.trackByIndex);
  }
}
class DataTable {
  constructor(backendService, translate) {
    this.backendService = backendService;
    this.translate = translate;
    this._items = [];
    this.multiSelectFlag = false;
    this.columnTypes = {};
    this.themePath = '/themes/dawn/dawn/';
    this.header = true;
    this.pagination = true;
    this.indexColumn = false;
    this.indexColumnHeader = '#';
    this.selectColumn = false;
    this.multiSelect = true;
    this.expandableRows = false;
    this.translations = defaultTranslations;
    this.selectOnRowClick = false;
    this.autoReload = true;
    this.showReloading = true;
    this.customButtons = [];
    this.customRowActions = [];
    this.canEdit = true;
    this.canView = true;
    this.canDelete = false;
    this.mergeList = false;
    this.sesskey = null;
    this.secondaryId = '';
    this.setCheckUrl = '/utils/setCheck.php';
    this.skipSelectedRowsCheck = ['saveEntireList', 'saveThisPage'];
    this.showAddNewMsg = false;
    this.useCustomEmptyState = false;
    this.emptyState = new EmptyStateModel();
    this.preventReload = false;
    this._sortAsc = true;
    this._offset = 0;
    this._page = 1;
    this._limit = 10;
    this._reloading = false;
    this._initiated = false;
    this.reload = new EventEmitter();
    this.view = new EventEmitter();
    this.delete = new EventEmitter();
    this.edit = new EventEmitter();
    this.customButtonClick = new EventEmitter();
    this.customRowAction = new EventEmitter();
    this._displayParams = {}; // params of the last finished reload
    this._scheduledReload = null;
    // event handlers:
    this.rowClick = new EventEmitter();
    this.rowDoubleClick = new EventEmitter();
    this.headerClick = new EventEmitter();
    this.itemsLoaded = new EventEmitter();
    this.cellClick = new EventEmitter();
    this.selectedRows = [];
    this._selectAllCheckbox = false;
    this.batchAction = new EventEmitter();
    this._resizeInProgress = false;
    this.resizeLimit = 30;
  }
  get items() {
    return this._items;
  }
  set items(items) {
    this._items = items;
    if (items) {
      // Should only be null on initial null value passed by Data Storage Service
      this._onReloadFinished();
      this.itemsLoaded.emit(items);
    } else {
      this._reloading = true;
    }
  }
  get sortBy() {
    return this._sortBy;
  }
  set sortBy(value) {
    if (this._initiated && this._sortBy !== value) {
      this._triggerReload();
    }
    this._sortBy = value;
  }
  get sortAsc() {
    return this._sortAsc;
  }
  set sortAsc(value) {
    if (this._initiated && this._sortAsc !== value) {
      this._triggerReload();
    }
    this._sortAsc = value;
  }
  get offset() {
    return this._offset;
  }
  set offset(value) {
    if (this._initiated && this._offset !== value) {
      this._triggerReload();
    }
    this._offset = value;
  }
  get limit() {
    return this._limit;
  }
  set limit(value) {
    if (this._initiated && this._limit != value) {
      this._triggerReload();
    }
    this._limit = value;
    this.offset = (this.page - 1) * value;
  }
  // calculated property:
  get page() {
    return this._page;
  }
  set page(value) {
    this._page = value;
    this.offset = (value - 1) * this.limit;
  }
  get lastPage() {
    return Math.ceil(this.itemCount / this.limit);
  }
  sort(sortBy, asc) {
    this.sortBy = sortBy;
    this.sortAsc = asc;
  }
  ngOnInit() {
    this._initDefaultValues();
    this._initDefaultClickEvents();
    this._updateDisplayParams();
    this._initiated = true;
    if (!this.items) {
      // Initial Null Value Passed From Behavior Subject
      this._reloading = true;
    }
    if (this.autoReload && this._scheduledReload == null && (this._items && this._items.length === 0 || !this._items)) {
      this.reloadItems();
    }
  }
  _initDefaultValues() {
    this.indexColumnVisible = this.indexColumn;
    this.selectColumnVisible = this.selectColumn;
    this.expandColumnVisible = this.expandableRows;
  }
  _initDefaultClickEvents() {
    this.headerClick.subscribe(tableEvent => this.sortColumn(tableEvent.column));
    if (this.selectOnRowClick) {
      this.rowClick.subscribe(tableEvent => tableEvent.row.selected = !tableEvent.row.selected);
    }
  }
  get reloading() {
    return this._reloading;
  }
  reloadItems() {
    if (!this.preventReload) {
      this._reloading = true;
    }
    this.reload.emit(this._getRemoteParameters());
  }
  viewItem(item) {
    this.view.emit(item);
  }
  deleteItem(item) {
    this.delete.emit(item);
  }
  editItem(item) {
    this.edit.emit(item);
  }
  customButtonEvent(id) {
    this.customButtonClick.emit(id);
  }
  actionButtonEvent(id, item) {
    let event = {
      'id': id,
      'item': item
    };
    this.customRowAction.emit(event);
  }
  _onReloadFinished() {
    this._updateDisplayParams();
    this._selectAllCheckbox = false;
    setTimeout(() => {
      this._reloading = false;
    });
  }
  get displayParams() {
    return this._displayParams;
  }
  _updateDisplayParams() {
    this._displayParams = {
      sortBy: this.sortBy,
      sortAsc: this.sortAsc,
      offset: this.offset,
      limit: this.limit
    };
  }
  // avoid cascading reloads if multiple params are set at once:
  _triggerReload() {
    if (this._scheduledReload) {
      clearTimeout(this._scheduledReload);
    }
    this._scheduledReload = setTimeout(() => {
      this.reloadItems();
    });
  }
  rowClicked(row, event) {
    if (event.target.className !== 'name-redirect-link' && event.target.className !== 'data-column table-column-padding column-studentDisplay' && event.target.className !== 'actionButton') {
      this.rowClick.emit({
        row,
        event
      });
    }
  }
  rowDoubleClicked(row, event) {
    this.rowDoubleClick.emit({
      row,
      event
    });
  }
  headerClicked(column, event) {
    if (!this._resizeInProgress) {
      this.headerClick.emit({
        column,
        event
      });
      this.addActiveColClass(column);
    } else {
      this._resizeInProgress = false; // because we can not prevent click from mouseup at the drag end
    }
  }
  addActiveColClass(column) {
    this.columns['_results'].forEach(col => {
      if (column.header !== col.header) {
        col.active = false;
      } else {
        col.active = true;
      }
      col.active = column.header === col.header;
    });
  }
  getColumnType(columnName) {
    if (typeof this.columnTypes[columnName] === 'undefined') {
      this.columnTypes[columnName] = '';
      if (this.columns['_results'].length > 0) {
        this.columns['_results'].forEach(column => {
          if (typeof column.type === 'undefined') {
            this.columnTypes[column.property] = '';
          } else {
            this.columnTypes[column.property] = column.type;
          }
        });
      }
    }
    return this.columnTypes[columnName];
  }
  cellClicked(column, row, event) {
    this.cellClick.emit({
      row,
      column,
      event
    });
  }
  _getRemoteParameters() {
    let params = {};
    if (this.sortBy) {
      params.sortBy = this.sortBy;
      params.sortAsc = this.sortAsc;
    }
    if (this.pagination) {
      params.offset = this.offset;
      params.limit = this.limit;
      params.page = this.page;
    }
    return params;
  }
  sortColumn(column) {
    if (column.sortable) {
      let ascending = this.sortBy === column.property ? !this.sortAsc : true;
      this.sort(column.property, ascending);
    }
  }
  get columnCount() {
    let count = 0;
    count += this.indexColumnVisible ? 1 : 0;
    count += this.selectColumnVisible ? 1 : 0;
    count += this.expandColumnVisible ? 1 : 0;
    this.columns.toArray().forEach(column => {
      count += column.visible ? 1 : 0;
    });
    return count;
  }
  getRowColor(item, index, row) {
    if (this.rowColors !== undefined) {
      return this.rowColors(item, row, index);
    }
  }
  get selectAllCheckbox() {
    return this._selectAllCheckbox;
  }
  _onSelectAllChanged($event, value) {
    $event.stopPropagation();
    const target = $event.target;
    let checked = 0;
    if (value) {
      checked = 1;
    }
    this.setCheckbox('ALL', checked, 'ALL');
    this.multiSelectFlag = true;
    this.rows.toArray().forEach(row => row.selected = value);
    this.multiSelectFlag = false;
    this.selected_one = false;
    this.selected = value;
    if (target['id'] === 'select-all' || target['id'] === 'select-none') {
      this.show_options = false;
    }
  }
  onCheckboxSelect(row, value) {
    if (!this.selectOnRowClick) {
      value = !value;
      row.selected = value;
    }
    this.updateCheckboxState(value);
    if (!this.selectOnRowClick) {
      this.onRowSelectChanged(row);
    }
  }
  updateCheckboxState(value) {
    this.selected = false;
    let rowsSelected = this.rows.toArray().find(row => row.selected);
    if (rowsSelected) {
      value = true;
    }
    this.selected_one = value;
  }
  onRowSelectChanged(row) {
    // maintain the selectedRow(s) view
    let checked = 1;
    let checkId = row.item[this.setCheckId];
    let secondaryId = '';
    if (this.secondaryId) {
      secondaryId = row.item[this.secondaryId];
    }
    if (row.selected) {
      this.selectedRow = row;
    } else {
      this.selectedRow = undefined;
      checked = 0;
    }
    if (!this.multiSelectFlag) {
      this.setCheckbox(checkId, checked, secondaryId);
    }
  }
  setCheckbox(id, checked, secondaryId = '') {
    let params = this.setCheckParams ? this.setCheckParams : '?api=1&cursite=' + this.currSite + '&key_suffix=' + this.keySuffix + '&class_pkey=' + this.classKey;
    params += this.sesskey ? '&sesskey=' + this.sesskey : '';
    return this.backendService.setCheck(params + '&id=' + id + '&state=' + checked + '&secondaryId=' + secondaryId + '&mergeList=' + this.mergeList, this.setCheckUrl).subscribe(res => {
      this.totalCheckedRows = res.totalCheckedRows;
    }, error => console.log('Could not set session with request status', error));
  }
  get substituteItems() {
    return Array.from({
      length: this.displayParams.limit - this.items.length
    });
  }
  resizeColumnStart(event, column, columnElement) {
    this._resizeInProgress = true;
    drag(event, {
      move: (moveEvent, dx) => {
        if (this._isResizeInLimit(columnElement, dx)) {
          column.width = columnElement.offsetWidth + dx;
        }
      }
    });
  }
  _isResizeInLimit(columnElement, dx) {
    /* This is needed because CSS min-width didn't work on table-layout: fixed.
     Without the limits, resizing can make the next column disappear completely,
     and even increase the table width. The current implementation suffers from the fact,
     that offsetWidth sometimes contains out-of-date values. */
    if (dx < 0 && columnElement.offsetWidth + dx <= this.resizeLimit || !columnElement.nextElementSibling ||
    // resizing doesn't make sense for the last visible column
    dx >= 0 && columnElement.nextElementSibling.offsetWidth + dx <= this.resizeLimit) {
      return false;
    }
    return true;
  }
  getTooltip(item, row, index) {
    if (this.rowTooltip) {
      return this.rowTooltip(item, row, index);
    }
    return '';
  }
  trackByIndex(index, item) {
    return index;
  }
  static {
    this.ɵfac = function DataTable_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DataTable)(i0.ɵɵdirectiveInject(BackendService), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: DataTable,
      selectors: [["data-table"]],
      contentQueries: function DataTable_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c0$1G, 7);
          i0.ɵɵcontentQuery(dirIndex, DataTableColumn, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expandTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columns = _t);
        }
      },
      viewQuery: function DataTable_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(DataTableRow, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rows = _t);
        }
      },
      inputs: {
        items: "items",
        itemCount: "itemCount",
        totalCheckedRows: "totalCheckedRows",
        headerTitle: "headerTitle",
        tabTitle: "tabTitle",
        header: "header",
        pagination: "pagination",
        indexColumn: "indexColumn",
        indexColumnHeader: "indexColumnHeader",
        rowColors: "rowColors",
        rowTooltip: "rowTooltip",
        selectColumn: "selectColumn",
        multiSelect: "multiSelect",
        expandableRows: "expandableRows",
        translations: "translations",
        selectOnRowClick: "selectOnRowClick",
        autoReload: "autoReload",
        showReloading: "showReloading",
        customButtons: "customButtons",
        customRowActions: "customRowActions",
        canEdit: "canEdit",
        canView: "canView",
        canDelete: "canDelete",
        mergeList: "mergeList",
        currSite: "currSite",
        keySuffix: "keySuffix",
        sesskey: "sesskey",
        classKey: "classKey",
        setCheckId: "setCheckId",
        secondaryId: "secondaryId",
        setCheckUrl: "setCheckUrl",
        setCheckParams: "setCheckParams",
        batchOptions: "batchOptions",
        skipSelectedRowsCheck: "skipSelectedRowsCheck",
        listName: "listName",
        showAddNewMsg: "showAddNewMsg",
        useCustomEmptyState: "useCustomEmptyState",
        emptyState: "emptyState",
        preventReload: "preventReload",
        sortBy: "sortBy",
        sortAsc: "sortAsc",
        offset: "offset",
        limit: "limit",
        page: "page"
      },
      outputs: {
        reload: "reload",
        view: "view",
        delete: "delete",
        edit: "edit",
        customButtonClick: "customButtonClick",
        customRowAction: "customRowAction",
        rowClick: "rowClick",
        rowDoubleClick: "rowDoubleClick",
        headerClick: "headerClick",
        itemsLoaded: "itemsLoaded",
        cellClick: "cellClick",
        batchAction: "batchAction"
      },
      standalone: false,
      decls: 3,
      vars: 3,
      consts: [["th", ""], ["row", ""], ["id", "list_wrap", "class", "data-table-wrapper list_wrap", 4, "ngIf"], ["class", "loading-table loading-spinner", 4, "ngIf"], ["class", "loading-table list-no-records", 4, "ngIf"], ["id", "list_wrap", 1, "data-table-wrapper", "list_wrap"], [3, "header", 4, "ngIf"], [1, "data-table-box"], ["role", "presentation", 1, "table", "table-condensed", "list_maincol"], ["role", "rowgroup"], ["role", "row"], ["class", "index-column-header cspList_bothead vertical-align-middle", "role", "columnheader", 4, "ngIf"], ["role", "columnheader", 1, "cspList_leftbothead", "vertical-align-middle", "check_col", 3, "hide"], ["id", "checkbox-container", "tabindex", "0", 1, "vertical-align-middle", 3, "keyup.enter", "click"], ["id", "checkbox-empty", 1, "btn_link", 3, "hide"], ["src", "/themes/modern/images/svgs/checkbox_empty.svg", "alt", "checkbox empty", 3, "keyup.enter", "click"], ["id", "checkbox-partial", 1, "btn_link", 3, "hide"], ["src", "/themes/modern/images/svgs/checkbox_partial.svg", 3, "keyup.enter", "click"], ["id", "checkbox-selected", 1, "btn_link", 3, "hide"], ["src", "/themes/modern/images/svgs/checkbox_selected.svg", 3, "keyup.enter", "click"], ["id", "checkbox-menu-container", "aria-role", "menu", 3, "ngStyle"], ["id", "select-all", "aria-role", "menuitem", "translate", "", 1, "checkbox-menu-item", 3, "keyup.enter", "click"], ["id", "select-none", "aria-role", "menuitem", "translate", "", 1, "checkbox-menu-item", 3, "keyup.enter", "click"], ["class", "column-header cspList_bothead vertical-align-middle", "role", "columnheader", 3, "hide", "ngClass", "sortable", "resizable", "width", "keyup.enter", "click", 4, "ngFor", "ngForOf"], ["role", "rowgroup", 1, "data-table-row-wrapper"], ["class", "data-table-row", "dataTableRow", "", "role", "row", 3, "dataTable", "item", "index", "themePath", "title", "background-color", "row-odd", "row-even", "row_content_style", "active_row", "clickable", "dblclick", "click", 4, "ngFor", "ngForOf"], ["class", "loading-cover", 4, "ngIf"], [3, "header", "batchOptionsButton", 4, "ngIf"], [3, "header"], ["role", "columnheader", 1, "index-column-header", "cspList_bothead", "vertical-align-middle"], [3, "textContent"], ["role", "columnheader", 1, "column-header", "cspList_bothead", "vertical-align-middle", 3, "keyup.enter", "click", "hide", "ngClass"], ["role", "button", "translate", "", 3, "textContent", "ngClass", 4, "ngIf"], ["class", "acc_hide", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], ["class", "column-resize-handle", 3, "mousedown", 4, "ngIf"], ["tabindex", "0", "role", "link", "class", "sort-icn", 4, "ngIf"], ["role", "button", "translate", "", 3, "textContent", "ngClass"], [1, "acc_hide"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "column-resize-handle", 3, "mousedown"], ["tabindex", "0", "role", "link", 1, "sort-icn"], ["dataTableRow", "", "role", "row", 1, "data-table-row", 3, "dblclick", "click", "dataTable", "item", "index", "themePath", "title"], [1, "loading-cover"], [3, "header", "batchOptionsButton"], [1, "loading-table", "loading-spinner"], [3, "src"], ["translate", "", 1, "loading-text"], [1, "loading-table", "list-no-records"], [4, "ngIf"], ["class", "button-panel display-inline", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "emptystate-img-container"], [1, "emptystate-img", 3, "src"], [1, "no-result-text-container"], ["translate", "", 3, "translateParams"], ["translate", "", 3, "translateParams", 4, "ngIf"], ["class", "emptystate-img", 3, "src", 4, "ngIf"], [3, "class", 4, "ngIf"], [3, "ngClass"], [3, "innerHTML", "ngClass", 4, "ngIf"], [3, "innerHTML", "ngClass"], [1, "button-panel", "display-inline"], ["type", "button", 3, "click", "value"]],
      template: function DataTable_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, DataTable_div_0_Template, 28, 23, "div", 2)(1, DataTable_div_1_Template, 4, 2, "div", 3)(2, DataTable_div_2_Template, 4, 4, "div", 4);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.reloading && ctx.items && ctx.items.length > 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showReloading && ctx.reloading);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.reloading && (ctx.items == null ? null : ctx.items.length) == 0);
        }
      },
      styles: [":host ::ng-deep .data-table.table>tbody+tbody{border-top:none}:host ::ng-deep .data-table.table td{vertical-align:middle;border:1px solid #ccc}:host ::ng-deep .data-table>thead>tr>th,:host ::ng-deep .data-table>tbody>tr>td{overflow:visible}:host ::ng-deep .row-odd{background-color:#f6f6f6}.data-table .substitute-rows>tr:hover,:host ::ng-deep .data-table .data-table-row:hover{background-color:#ececec}.data-table{table-layout:fixed}.column-header{border:1px solid #ccc;border-right:1px solid rgba(255,255,255,.1)}.vertical-align-middle{vertical-align:middle}.expand-column-header{width:50px}.select-column-header{width:50px;border:1px solid #ccc;border-right:1px solid rgba(255,255,255,.1);border-left:1px solid rgba(255,255,255,.1);text-align:center}.index-column-header{width:40px}.column-header.sortable{cursor:pointer;white-space:nowrap}.column-header .column-sort-icon{float:right}.column-header.resizable .column-sort-icon{margin-right:8px}.column-header .column-sort-icon .column-sortable-icon{color:#d3d3d3}.column-header .column-resize-handle{position:absolute;top:0;right:0;margin:0;padding:0;width:8px;height:100%;cursor:col-resize}.data-table-box{position:relative}.loading-cover{position:absolute;width:100%;height:100%;background-color:#ffffff4d;top:0}.data-table th,.data-table-row-wrapper td{padding:8px}.select-column-header a{cursor:pointer;display:inline-block;width:10px}.select-column-header span{font-size:0}.select-column-header img{height:9px;width:9px}.loading-table{text-align:center;width:100%;margin-top:50px;margin-bottom:65px}.loading-spinner{margin-top:70px}.loading-text{margin-top:10px;font-size:14px;color:#333}.emptystate-img-container{height:120px;display:flex}.emptystate-img{margin:auto}.no-result-text-container{font-size:16px;color:#333;margin:10px 0 5px}.align-column{margin-bottom:5px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTable, [{
    type: Component,
    args: [{
      selector: 'data-table',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div id=\"list_wrap\" class=\"data-table-wrapper list_wrap\" *ngIf=\"!reloading && items && items.length>0\">\n    <data-table-header [header]=\"header\" *ngIf=\"header\"></data-table-header>\n    <div class=\"data-table-box\">\n        <table class=\"table table-condensed list_maincol\" role=\"presentation\">\n            <thead role=\"rowgroup\">\n            <tr role=\"row\">\n                <th *ngIf=\"indexColumnVisible\"\n                    class=\"index-column-header cspList_bothead vertical-align-middle\"\n                    role=\"columnheader\">\n                    <span [textContent]=\"indexColumnHeader\"></span>\n                </th>\n                <th [hide]=\"!selectColumnVisible\"\n                    class=\"cspList_leftbothead vertical-align-middle check_col\"\n                    role=\"columnheader\">\n                    <div id=\"checkbox-container\"\n                         tabindex=\"0\"\n                         class=\"vertical-align-middle\"\n                         [attr.aria-expanded]=\"show_options\"\n                         (keyup.enter)=\"show_options = !show_options\"\n                         (click)=\"show_options = !show_options\">\n                             <span id=\"checkbox-empty\"\n                                   class=\"btn_link\"\n                                   [hide]=\"selected_one || selected\">\n                                <img (keyup.enter)=\"_onSelectAllChanged($event, true)\"\n                                     (click)=\"_onSelectAllChanged($event, true)\"\n                                     src=\"/themes/modern/images/svgs/checkbox_empty.svg\"\n                                     [attr.alt]=\"'misc.select all' | translate\" alt=\"checkbox empty\"/>\n                            </span>\n                        <span id=\"checkbox-partial\"\n                              class=\"btn_link\"\n                              [hide]=\"!selected_one\">\n                                <img (keyup.enter)=\"_onSelectAllChanged($event, false)\"\n                                     (click)=\"_onSelectAllChanged($event, false)\"\n                                     src=\"/themes/modern/images/svgs/checkbox_partial.svg\"\n                                     [attr.alt]=\"'misc.select none' | translate\" />\n                            </span>\n                        <span id=\"checkbox-selected\"\n                              class=\"btn_link\"\n                              [hide]=\"!selected\">\n                                <img (keyup.enter)=\"_onSelectAllChanged($event, false)\"\n                                     (click)=\"_onSelectAllChanged($event, false)\"\n                                     src=\"/themes/modern/images/svgs/checkbox_selected.svg\"\n                                     [attr.alt]=\"'misc.select none' | translate\" />\n                            </span>\n                    </div>\n                    <div id=\"checkbox-menu-container\"\n                         aria-role=\"menu\"\n                         [ngStyle]=\"{'display':show_options ? 'block' : 'none' }\">\n                        <button class=\"checkbox-menu-item\"\n                                id=\"select-all\"\n                                aria-role=\"menuitem\"\n                                (keyup.enter)=\"_onSelectAllChanged($event, true)\"\n                                (click)=\"_onSelectAllChanged($event, true)\"\n                                translate>misc.Select All</button>\n                        <button class=\"checkbox-menu-item\"\n                                id=\"select-none\"\n                                aria-role=\"menuitem\"\n                                (keyup.enter)=\"_onSelectAllChanged($event, false)\"\n                                (click)=\"_onSelectAllChanged($event, false)\"\n                                translate>misc.Select None</button>\n                    </div>\n                </th>\n                <!-- keeping it for future use -->\n                <!-- <th [hide]=\"!expandColumnVisible\" class=\"expand-column-header cspList_bothead vertical-align-middle\"> -->\n                <th *ngFor=\"let column of columns\" #th [hide]=\"!column.visible\"\n                    (keyup.enter)=\"headerClicked(column, $event)\" (click)=\"headerClicked(column, $event)\"\n                    [ngClass]=\"{'active_col' : column.active}\"\n                    [class.sortable]=\"column.sortable\" [class.resizable]=\"column.resizable\"\n                    [ngClass]=\"column.styleClassObject\" class=\"column-header cspList_bothead vertical-align-middle\"\n                    [style.width]=\"column.width | px\"\n                    [attr.aria-sort]=\"(column.sortable && column.property === sortBy) ? (sortAsc ? 'ascending' : 'descending') : null\"\n                    role=\"columnheader\">\n                    <a *ngIf=\"!column.headerTemplate\" [textContent]=\"column.header\"\n                       [ngClass]=\"{'align-column': !column.sortable,'sort_asc ': (column.sortable && column.property!==sortBy)||(column.sortable && column.property===sortBy && sortAsc ),'sort_desc': column.sortable && column.property===sortBy && !sortAsc }\"\n                       role=\"button\" translate></a>\n                    <span *ngIf=\"!column.header\" class=\"acc_hide\">{{column.emptyHeader | translate}}</span>\n                    <span *ngIf=\"column.headerTemplate\" [ngTemplateOutlet]=\"column.headerTemplate\"\n                          [ngTemplateOutletContext]=\"{column: column}\"></span>\n                    <span *ngIf=\"column.resizable\" class=\"column-resize-handle\"\n                          (mousedown)=\"resizeColumnStart($event, column, th)\"></span>\n                    <i tabindex=\"0\" role=\"link\" *ngIf=\"column.sortable\" class=\"sort-icn\" [attr.aria-disabled]=\"true\"></i>\n                </th>\n            </tr>\n            </thead>\n            <tbody class=\"data-table-row-wrapper\" role=\"rowgroup\">\n                <tr\tclass=\"data-table-row\"\n                    *ngFor=\"let item of items; let idx=index\"\n                    dataTableRow\n                    #row\n                    [dataTable]=\"this\"\n                    [item]=\"item\"\n                    [index]=\"idx\"\n                    [themePath]=\"'/components/unicon/assets/svg-output/'\"\n                    role=\"row\"\n                    [title]=\"getTooltip(item, row, idx)\"\n                    [style.background-color]=\"getRowColor(item, idx, row)\"\n                    [class.row-odd]=\"idx % 2 === 0\"\n                    [class.row-even]=\"idx % 2 === 1\"\n                    [class.row_content_style] = \"true\"\n                    [class.active_row]=\"selected\"\n                    [class.clickable]=\"selectOnRowClick\"\n                    (dblclick)=\"rowDoubleClicked(row, $event)\"\n                    (click)=\"rowClicked(row, $event)\"\n                ></tr>\n            </tbody>\n        </table>\n        <div class=\"loading-cover\" *ngIf=\"showReloading && reloading\"></div>\n    </div>\n    <data-table-header *ngIf=\"header\" [header]=\"header\" [batchOptionsButton]=\"false\"></data-table-header>\n</div>\n<div *ngIf=\"showReloading && reloading\" class=\"loading-table loading-spinner\">\n    <img src=\"{{themePath}}spinner.gif\">\n    <div class=\"loading-text\" translate>misc.Loading</div>\n</div>\n<div *ngIf=\"!reloading && items?.length==0\" class=\"loading-table list-no-records\">\n    <ng-container *ngIf=\"!useCustomEmptyState\">\n        <div class=\"emptystate-img-container\">\n            <img src=\"{{themePath}}emptystate-document.png\" class=\"emptystate-img\"\n                [attr.alt]=\"'misc.Empty List' | translate\">\n        </div>\n        <div class=\"no-result-text-container\">\n            <h3 translate [translateParams]=\"{list_title: tabTitle}\">misc.No list records yet</h3>\n            <div *ngIf=\"!customButtons || showAddNewMsg\" [translateParams]=\"{list_title: tabTitle}\" translate>misc.Once you create new records, they will appear here</div>\n        </div>\n    </ng-container>\n    <ng-container *ngIf=\"useCustomEmptyState && emptyState\">\n        <img *ngIf=\"emptyState.src\" src=\"{{emptyState.src}}\" class=\"emptystate-img\" [attr.alt]=\"'misc.Empty List' | translate\">\n        <i *ngIf=\"emptyState.icon && !emptyState.src\" class=\"icn {{emptyState.icon}}\"></i>\n        <div *ngIf=\"emptyState.title || emptyState.message\">\n            <h3 [ngClass]=\"emptyState.titleStyleClass\">{{emptyState.title}}</h3>\n            <div *ngIf=\"!customButtons || emptyState.message\" [innerHTML]=\"emptyState.message\" [ngClass]=\"emptyState.messageStyleClass\"></div>\n        </div>\n    </ng-container>\n    <div class=\"button-panel display-inline\" *ngFor='let button of customButtons; trackBy: trackByIndex'>\n        <input type=\"button\" class=\"input-button {{button.styleClass}}\" (click)=\"customButtonEvent(button.id)\"\n            value=\"{{button.display | translate}}\">\n    </div>\n</div>\n",
      styles: [":host ::ng-deep .data-table.table>tbody+tbody{border-top:none}:host ::ng-deep .data-table.table td{vertical-align:middle;border:1px solid #ccc}:host ::ng-deep .data-table>thead>tr>th,:host ::ng-deep .data-table>tbody>tr>td{overflow:visible}:host ::ng-deep .row-odd{background-color:#f6f6f6}.data-table .substitute-rows>tr:hover,:host ::ng-deep .data-table .data-table-row:hover{background-color:#ececec}.data-table{table-layout:fixed}.column-header{border:1px solid #ccc;border-right:1px solid rgba(255,255,255,.1)}.vertical-align-middle{vertical-align:middle}.expand-column-header{width:50px}.select-column-header{width:50px;border:1px solid #ccc;border-right:1px solid rgba(255,255,255,.1);border-left:1px solid rgba(255,255,255,.1);text-align:center}.index-column-header{width:40px}.column-header.sortable{cursor:pointer;white-space:nowrap}.column-header .column-sort-icon{float:right}.column-header.resizable .column-sort-icon{margin-right:8px}.column-header .column-sort-icon .column-sortable-icon{color:#d3d3d3}.column-header .column-resize-handle{position:absolute;top:0;right:0;margin:0;padding:0;width:8px;height:100%;cursor:col-resize}.data-table-box{position:relative}.loading-cover{position:absolute;width:100%;height:100%;background-color:#ffffff4d;top:0}.data-table th,.data-table-row-wrapper td{padding:8px}.select-column-header a{cursor:pointer;display:inline-block;width:10px}.select-column-header span{font-size:0}.select-column-header img{height:9px;width:9px}.loading-table{text-align:center;width:100%;margin-top:50px;margin-bottom:65px}.loading-spinner{margin-top:70px}.loading-text{margin-top:10px;font-size:14px;color:#333}.emptystate-img-container{height:120px;display:flex}.emptystate-img{margin:auto}.no-result-text-container{font-size:16px;color:#333;margin:10px 0 5px}.align-column{margin-bottom:5px}\n"]
    }]
  }], () => [{
    type: BackendService
  }, {
    type: i1$1.TranslateService
  }], {
    items: [{
      type: Input
    }],
    itemCount: [{
      type: Input
    }],
    totalCheckedRows: [{
      type: Input
    }],
    columns: [{
      type: ContentChildren,
      args: [DataTableColumn]
    }],
    rows: [{
      type: ViewChildren,
      args: [DataTableRow]
    }],
    expandTemplate: [{
      type: ContentChild,
      args: ['dataTableExpand', {
        static: true
      }]
    }],
    headerTitle: [{
      type: Input
    }],
    tabTitle: [{
      type: Input
    }],
    header: [{
      type: Input
    }],
    pagination: [{
      type: Input
    }],
    indexColumn: [{
      type: Input
    }],
    indexColumnHeader: [{
      type: Input
    }],
    rowColors: [{
      type: Input
    }],
    rowTooltip: [{
      type: Input
    }],
    selectColumn: [{
      type: Input
    }],
    multiSelect: [{
      type: Input
    }],
    expandableRows: [{
      type: Input
    }],
    translations: [{
      type: Input
    }],
    selectOnRowClick: [{
      type: Input
    }],
    autoReload: [{
      type: Input
    }],
    showReloading: [{
      type: Input
    }],
    customButtons: [{
      type: Input
    }],
    customRowActions: [{
      type: Input
    }],
    canEdit: [{
      type: Input
    }],
    canView: [{
      type: Input
    }],
    canDelete: [{
      type: Input
    }],
    mergeList: [{
      type: Input
    }],
    currSite: [{
      type: Input
    }],
    keySuffix: [{
      type: Input
    }],
    sesskey: [{
      type: Input
    }],
    classKey: [{
      type: Input
    }],
    setCheckId: [{
      type: Input
    }],
    secondaryId: [{
      type: Input
    }],
    setCheckUrl: [{
      type: Input
    }],
    setCheckParams: [{
      type: Input
    }],
    batchOptions: [{
      type: Input
    }],
    skipSelectedRowsCheck: [{
      type: Input
    }],
    listName: [{
      type: Input
    }],
    showAddNewMsg: [{
      type: Input
    }],
    useCustomEmptyState: [{
      type: Input
    }],
    emptyState: [{
      type: Input
    }],
    preventReload: [{
      type: Input
    }],
    sortBy: [{
      type: Input
    }],
    sortAsc: [{
      type: Input
    }],
    offset: [{
      type: Input
    }],
    limit: [{
      type: Input
    }],
    page: [{
      type: Input
    }],
    reload: [{
      type: Output
    }],
    view: [{
      type: Output
    }],
    delete: [{
      type: Output
    }],
    edit: [{
      type: Output
    }],
    customButtonClick: [{
      type: Output
    }],
    customRowAction: [{
      type: Output
    }],
    rowClick: [{
      type: Output
    }],
    rowDoubleClick: [{
      type: Output
    }],
    headerClick: [{
      type: Output
    }],
    itemsLoaded: [{
      type: Output
    }],
    cellClick: [{
      type: Output
    }],
    batchAction: [{
      type: Output
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DataTable, {
    className: "DataTable",
    filePath: "data-table/components/table.ts",
    lineNumber: 19
  });
})();
class DisableRightClickDirective {
  constructor(el) {
    this.el = el;
  }
  ngAfterViewInit() {
    this.disableRightClick();
  }
  disableRightClick() {
    window.addEventListener('contextmenu', function (e) {
      e.stopPropagation();
      return false;
    }, true);
  }
  static {
    this.ɵfac = function DisableRightClickDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DisableRightClickDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: DisableRightClickDirective,
      selectors: [["", "disable-right-click", ""]],
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DisableRightClickDirective, [{
    type: Directive,
    args: [{
      selector: '[disable-right-click]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }], null);
})();
let MinPipe$1 = class MinPipe {
  transform(value, args) {
    return Math.min.apply(null, value);
  }
  static {
    this.ɵfac = function MinPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MinPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "min",
      type: MinPipe,
      pure: true,
      standalone: false
    });
  }
};
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MinPipe$1, [{
    type: Pipe,
    args: [{
      name: 'min',
      standalone: false
    }]
  }], null, null);
})();
const _c0$1F = ["noSelection"];
const _c1$1j = (a0, a1) => [a0, a1];
const _c2$Y = (a0, a1, a2) => ({
  start: a0,
  end: a1,
  total: a2
});
const _c3$G = a0 => ({
  total: a0
});
function DataTableHeader_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "button", 20);
    i0.ɵɵlistener("click", function DataTableHeader_div_1_Template_button_click_1_listener() {
      const button_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.dataTable.customButtonEvent(button_r3.id));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const button_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("input-button ", button_r3.styleClass, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, button_r3.display));
  }
}
function DataTableHeader_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "button", 22, 2);
    i0.ɵɵlistener("click", function DataTableHeader_div_2_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ngxContextMenu_r6 = i0.ɵɵreference(2);
      return i0.ɵɵresetView(ngxContextMenu_r6.open($event));
    });
    i0.ɵɵtext(3, "misc.Batch Options ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const basicMenu_r7 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("contextMenu", basicMenu_r7)("contextMenuValue", ctx_r3.item);
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, "misc.Mail"), " ");
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_4_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const message_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", message_r9.label, " ");
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_4_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_4_1_ng_template_0_Template, 1, 1, "ng-template", 25);
    i0.ɵɵlistener("execute", function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_4_1_Template_ng_template_execute_0_listener() {
      const message_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r3.redirect(message_r9));
    });
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_4_1_Template, 1, 0, null, 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const batchOption_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", batchOption_r10.newMail);
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_5_ng_container_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const category_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, category_r11), " ");
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_5_ng_container_1_ng_container_4_ng_container_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const categoryMessage_r13 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" ", categoryMessage_r13.label, " ");
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_5_ng_container_1_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_5_ng_container_1_ng_container_4_ng_container_1_ng_template_1_Template, 1, 1, "ng-template", 25);
    i0.ɵɵlistener("execute", function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_5_ng_container_1_ng_container_4_ng_container_1_Template_ng_template_execute_1_listener() {
      i0.ɵɵrestoreView(_r12);
      const categoryMessage_r13 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r3.redirect(categoryMessage_r13));
    });
    i0.ɵɵelementContainerEnd();
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_5_ng_container_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_5_ng_container_1_ng_container_4_ng_container_1_Template, 2, 0, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const categoryMessage_r13 = ctx.$implicit;
    const category_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", categoryMessage_r13.category == category_r11);
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_5_ng_container_1_ng_template_1_Template, 2, 3, "ng-template", 24);
    i0.ɵɵelementStart(2, "context-menu", null, 4);
    i0.ɵɵtemplate(4, DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_5_ng_container_1_ng_container_4_Template, 2, 1, "ng-container", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const saySubMenu1_r14 = i0.ɵɵreference(3);
    const batchOption_r10 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("subMenu", saySubMenu1_r14);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", batchOption_r10.categoryMessages);
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_5_ng_container_1_Template, 5, 2, "ng-container", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const batchOption_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", batchOption_r10.categories);
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_6_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const batchOptionMail_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", batchOptionMail_r16.label, " ");
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, DataTableHeader_ng_container_5_ng_container_1_ng_container_1_6_ng_template_0_Template, 1, 1, "ng-template", 25);
    i0.ɵɵlistener("execute", function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_6_Template_ng_template_execute_0_listener() {
      const batchOptionMail_r16 = i0.ɵɵrestoreView(_r15).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3.redirect(batchOptionMail_r16));
    });
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_template_1_Template, 2, 3, "ng-template", 24);
    i0.ɵɵelementStart(2, "context-menu", null, 3);
    i0.ɵɵtemplate(4, DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_4_Template, 2, 1, "ng-container", 11)(5, DataTableHeader_ng_container_5_ng_container_1_ng_container_1_ng_container_5_Template, 2, 1, "ng-container", 11)(6, DataTableHeader_ng_container_5_ng_container_1_ng_container_1_6_Template, 1, 0, null, 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const saySubMenu_r17 = i0.ɵɵreference(3);
    const batchOption_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("subMenu", saySubMenu_r17);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", batchOption_r10.newMail);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", batchOption_r10.categories);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", batchOption_r10.mail);
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_2_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const batchOption_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, batchOption_r10.mainmenu.label), " ");
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableHeader_ng_container_5_ng_container_1_ng_container_2_ng_template_1_Template, 2, 3, "ng-template", 25);
    i0.ɵɵlistener("execute", function DataTableHeader_ng_container_5_ng_container_1_ng_container_2_Template_ng_template_execute_1_listener() {
      i0.ɵɵrestoreView(_r18);
      const batchOption_r10 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.batchAction(ctx_r3.dataTable.keySuffix, batchOption_r10.mainmenu));
    });
    i0.ɵɵelementContainerEnd();
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const batchOption_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, batchOption_r10.submenu.parentLabel), " ");
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_container_4_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const batchOption_r10 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, batchOption_r10.submenu.childLabel), " ");
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_container_4_ng_template_1_Template, 2, 3, "ng-template", 25);
    i0.ɵɵlistener("execute", function DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_container_4_Template_ng_template_execute_1_listener() {
      i0.ɵɵrestoreView(_r19);
      const batchOption_r10 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.batchAction(ctx_r3.dataTable.keySuffix, batchOption_r10.submenu));
    });
    i0.ɵɵelementContainerEnd();
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_container_5_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const item_r21 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, item_r21.label), " ");
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_container_5_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_container_5_1_ng_template_0_Template, 2, 3, "ng-template", 25);
    i0.ɵɵlistener("execute", function DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_container_5_1_Template_ng_template_execute_0_listener() {
      const item_r21 = i0.ɵɵrestoreView(_r20).$implicit;
      const batchOption_r10 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.batchAction(ctx_r3.dataTable.keySuffix, {
        id: batchOption_r10.submenu.id,
        parentLabel: batchOption_r10.submenu.parentLabel,
        label: item_r21.label,
        itemId: item_r21.id
      }));
    });
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_container_5_1_Template, 1, 0, null, 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const batchOption_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", batchOption_r10.submenu.subitems);
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_template_1_Template, 2, 3, "ng-template", 24);
    i0.ɵɵelementStart(2, "context-menu", null, 4);
    i0.ɵɵtemplate(4, DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_container_4_Template, 2, 0, "ng-container", 11)(5, DataTableHeader_ng_container_5_ng_container_1_ng_container_3_ng_container_5_Template, 2, 1, "ng-container", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const saySubMenu1_r22 = i0.ɵɵreference(3);
    const batchOption_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("subMenu", saySubMenu1_r22);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", batchOption_r10.submenu.childLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", batchOption_r10.submenu.subitems);
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_4_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const batchOption_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" ", batchOption_r10.hierarchalMenu.label, " ");
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_4_ng_container_5_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const category_r23 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", category_r23.label, " ");
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_4_ng_container_5_4_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const subcategory_r25 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", subcategory_r25.label, " ");
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_4_ng_container_5_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, DataTableHeader_ng_container_5_ng_container_1_ng_container_4_ng_container_5_4_ng_template_0_Template, 1, 1, "ng-template", 25);
    i0.ɵɵlistener("execute", function DataTableHeader_ng_container_5_ng_container_1_ng_container_4_ng_container_5_4_Template_ng_template_execute_0_listener() {
      const subcategory_r25 = i0.ɵɵrestoreView(_r24).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r3.batchAction(ctx_r3.dataTable.keySuffix, subcategory_r25));
    });
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_4_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableHeader_ng_container_5_ng_container_1_ng_container_4_ng_container_5_ng_template_1_Template, 1, 1, "ng-template", 24);
    i0.ɵɵelementStart(2, "context-menu", null, 5);
    i0.ɵɵtemplate(4, DataTableHeader_ng_container_5_ng_container_1_ng_container_4_ng_container_5_4_Template, 1, 0, null, 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const category_r23 = ctx.$implicit;
    const saySubMenu2_r26 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("subMenu", saySubMenu2_r26);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", category_r23.subcategories);
  }
}
function DataTableHeader_ng_container_5_ng_container_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1);
    i0.ɵɵtemplate(2, DataTableHeader_ng_container_5_ng_container_1_ng_container_4_ng_template_2_Template, 1, 1, "ng-template", 24);
    i0.ɵɵelementStart(3, "context-menu", null, 4);
    i0.ɵɵtemplate(5, DataTableHeader_ng_container_5_ng_container_1_ng_container_4_ng_container_5_Template, 5, 2, "ng-container", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const saySubMenu1_r27 = i0.ɵɵreference(4);
    const batchOption_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("subMenu", saySubMenu1_r27);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", batchOption_r10.hierarchalMenu.categories);
  }
}
function DataTableHeader_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableHeader_ng_container_5_ng_container_1_ng_container_1_Template, 7, 4, "ng-container", 11)(2, DataTableHeader_ng_container_5_ng_container_1_ng_container_2_Template, 2, 0, "ng-container", 11)(3, DataTableHeader_ng_container_5_ng_container_1_ng_container_3_Template, 6, 3, "ng-container", 11)(4, DataTableHeader_ng_container_5_ng_container_1_ng_container_4_Template, 6, 2, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const batchOption_r10 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", batchOption_r10.mail);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", batchOption_r10.mainmenu);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", batchOption_r10.submenu);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", batchOption_r10.hierarchalMenu);
  }
}
function DataTableHeader_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableHeader_ng_container_5_ng_container_1_Template, 5, 4, "ng-container", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.dataTable.batchOptions);
  }
}
function DataTableHeader_span_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" (", i0.ɵɵpipeBind2(2, 1, "misc.List items selected", i0.ɵɵpureFunction1(4, _c3$G, ctx_r3.dataTable.totalCheckedRows)), ")");
  }
}
function DataTableHeader_div_13_option_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pp_r30 = ctx.$implicit;
    i0.ɵɵproperty("value", pp_r30);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(pp_r30);
  }
}
function DataTableHeader_div_13_div_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34)(1, "button", 35);
    i0.ɵɵlistener("click", function DataTableHeader_div_13_div_11_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r31);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.pageBack());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " \u00A0| ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" < ", i0.ɵɵpipeBind1(3, 1, "misc.Previous"), "");
  }
}
function DataTableHeader_div_13_option_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const page_r33 = ctx.$implicit;
    i0.ɵɵproperty("value", page_r33);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(page_r33);
  }
}
function DataTableHeader_div_13_div_19_Template(rf, ctx) {
  if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtext(1, " |\u00A0 ");
    i0.ɵɵelementStart(2, "button", 35);
    i0.ɵɵlistener("click", function DataTableHeader_div_13_div_19_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r34);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.pageForward());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 1, "misc.Next"), " > ");
  }
}
function DataTableHeader_div_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "div", 27)(2, "label", 28);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "select", 29, 6);
    i0.ɵɵlistener("change", function DataTableHeader_div_13_Template_select_change_6_listener() {
      i0.ɵɵrestoreView(_r28);
      const limitInput_r29 = i0.ɵɵreference(7);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.limit = +limitInput_r29.value);
    });
    i0.ɵɵtemplate(8, DataTableHeader_div_13_option_8_Template, 2, 2, "option", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, DataTableHeader_div_13_div_11_Template, 5, 3, "div", 31);
    i0.ɵɵelementStart(12, "label", 32);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementStart(15, "select", 29, 7);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵlistener("change", function DataTableHeader_div_13_Template_select_change_15_listener() {
      i0.ɵɵrestoreView(_r28);
      const pageInput_r32 = i0.ɵɵreference(16);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.page = +pageInput_r32.value);
    });
    i0.ɵɵtemplate(18, DataTableHeader_div_13_option_18_Template, 2, 2, "option", 30);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(19, DataTableHeader_div_13_div_19_Template, 5, 3, "div", 31);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 11, "misc.Number of Items Showing"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 13, "misc.Showing"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r3.limit);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.perPage);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 15, "misc.per page"), "\u00A0| ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.page > 1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" \u00A0", i0.ɵɵpipeBind1(14, 17, "misc.Page"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r3.page);
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(17, 19, "misc.Jump to page"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r3.pages);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.page != ctx_r3.maxPage);
  }
}
function DataTableHeader_div_19_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39)(1, "label", 40)(2, "input", 41);
    i0.ɵɵtwoWayListener("ngModelChange", function DataTableHeader_div_19_div_1_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r35);
      const ctx_r3 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r3.dataTable.expandColumnVisible, $event) || (ctx_r3.dataTable.expandColumnVisible = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 42);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.dataTable.expandColumnVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.dataTable.translations.expandColumn);
  }
}
function DataTableHeader_div_19_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39)(1, "label", 40)(2, "input", 41);
    i0.ɵɵtwoWayListener("ngModelChange", function DataTableHeader_div_19_div_2_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r3 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r3.dataTable.indexColumnVisible, $event) || (ctx_r3.dataTable.indexColumnVisible = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 42);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.dataTable.indexColumnVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.dataTable.translations.indexColumn);
  }
}
function DataTableHeader_div_19_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39)(1, "label", 40)(2, "input", 41);
    i0.ɵɵtwoWayListener("ngModelChange", function DataTableHeader_div_19_div_3_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r37);
      const ctx_r3 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r3.dataTable.selectColumnVisible, $event) || (ctx_r3.dataTable.selectColumnVisible = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 42);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.dataTable.selectColumnVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.dataTable.translations.selectColumn);
  }
}
function DataTableHeader_div_19_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43)(1, "label", 40)(2, "input", 41);
    i0.ɵɵtwoWayListener("ngModelChange", function DataTableHeader_div_19_div_4_Template_input_ngModelChange_2_listener($event) {
      const column_r39 = i0.ɵɵrestoreView(_r38).$implicit;
      i0.ɵɵtwoWayBindingSet(column_r39.visible, $event) || (column_r39.visible = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 44);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const column_r39 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", column_r39.visible);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", column_r39.header);
  }
}
function DataTableHeader_div_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtemplate(1, DataTableHeader_div_19_div_1_Template, 5, 2, "div", 37)(2, DataTableHeader_div_19_div_2_Template, 5, 2, "div", 37)(3, DataTableHeader_div_19_div_3_Template, 5, 2, "div", 37)(4, DataTableHeader_div_19_div_4_Template, 4, 2, "div", 38);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.dataTable.expandableRows);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.dataTable.indexColumn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.dataTable.selectColumn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.dataTable.columns);
  }
}
function DataTableHeader_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45)(1, "h3", 46);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 47);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵlistener("click", function DataTableHeader_ng_template_20_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r40);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.noSelectionModalRef.hide());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 48)(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 49)(11, "button", 50);
    i0.ɵɵlistener("click", function DataTableHeader_ng_template_20_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r40);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.noSelectionModalRef.hide());
    });
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "misc.No selection"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 6, "misc.Close"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 8, "misc.To perform this action, you must select at least one record."));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 10, "misc.OK"));
  }
}
class DataTableHeader {
  redirect(batchOptions) {
    if (!this.dataTable.totalCheckedRows) {
      this.noSelectionModal();
      return;
    }
    let messageId = batchOptions.message_id;
    let sesskey = batchOptions.sesskey;
    let urlSection = batchOptions.urlSection || 'students';
    window.location.href = `/manager/index.php?s=${urlSection}&curr_mode=list&mode=mailwiz&msg=${messageId}&sesskey=${sesskey}`;
  }
  constructor(dataTable, contextMenuService, modalService) {
    this.dataTable = dataTable;
    this.contextMenuService = contextMenuService;
    this.modalService = modalService;
    this.batchOptionsButton = true;
    this.columnSelectorOpen = false;
    this.batchOptions = false;
  }
  pageBack() {
    if (this.dataTable.offset > 1) {
      this.dataTable.offset -= Math.min(this.dataTable.limit, this.dataTable.offset);
      this.dataTable.page -= 1;
    }
  }
  pageForward() {
    if (this.dataTable.offset + this.dataTable.limit <= this.dataTable.itemCount) {
      this.dataTable.offset += this.dataTable.limit;
      this.dataTable.page += 1;
    }
  }
  pageFirst() {
    this.dataTable.offset = 0;
    this.dataTable.page = 1;
  }
  pageLast() {
    this.dataTable.offset = (this.maxPage - 1) * this.dataTable.limit;
    this.dataTable.page = this.maxPage;
  }
  showBatchOptions() {
    this.batchOptions = !this.batchOptions;
  }
  get totalCheckedRows() {
    return this.dataTable.totalCheckedRows;
  }
  get maxPage() {
    return Math.ceil(this.dataTable.itemCount / this.dataTable.limit);
  }
  get limit() {
    if (this.dataTable.itemCount < 20) {
      return 20;
    } else {
      return this.dataTable.limit;
    }
  }
  set limit(value) {
    if (this.dataTable.itemCount && this.dataTable.page) {
      let page = this.dataTable.page;
      while (value * page > this.dataTable.itemCount && page > 1) {
        page--;
      }
      this.dataTable.page = page;
    }
    this.dataTable.limit = Number(value); // TODO better way to handle that value of number <input> is string?
  }
  get page() {
    return this.dataTable.page;
  }
  set page(value) {
    this.dataTable.page = Number(value);
  }
  get perPage() {
    let perPage = [20, 50, 100, 250];
    return perPage;
  }
  get pages() {
    let pages = [];
    if (this.dataTable.itemCount && this.dataTable.limit) {
      let num = Math.ceil(this.dataTable.itemCount / this.dataTable.limit);
      while (num > 0) {
        pages.push(num);
        num--;
      }
      pages = pages.sort(function (a, b) {
        return a - b;
      });
    }
    return pages;
  }
  batchAction(keySuffix, menu) {
    if (!this.dataTable.totalCheckedRows && !this.dataTable.skipSelectedRowsCheck.includes(menu?.itemId)) {
      this.noSelectionModal();
      return;
    }
    this.dataTable.batchAction.emit({
      keySuffix: keySuffix,
      menu: menu
    });
  }
  noSelectionModal() {
    this.noSelectionModalRef = this.modalService.show(this.noSelectionTemplate, {
      class: 'modal-sm',
      ariaLabelledBy: 'ax-title'
    });
  }
  static {
    this.ɵfac = function DataTableHeader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DataTableHeader)(i0.ɵɵdirectiveInject(forwardRef(() => DataTable)), i0.ɵɵdirectiveInject(i1$2.ContextMenuService), i0.ɵɵdirectiveInject(i1$3.BsModalService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: DataTableHeader,
      selectors: [["data-table-header"]],
      viewQuery: function DataTableHeader_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(ContextMenuComponent, 7);
          i0.ɵɵviewQuery(_c0$1F, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.basicMenu = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noSelectionTemplate = _t.first);
        }
      },
      inputs: {
        header: "header",
        contextMenu: "contextMenu",
        batchOptionsButton: "batchOptionsButton"
      },
      standalone: false,
      decls: 22,
      vars: 25,
      consts: [["basicMenu", ""], ["noSelection", ""], ["ngxContextMenu", "ngxContextMenu"], ["saySubMenu", ""], ["saySubMenu1", ""], ["saySubMenu2", ""], ["limitInput", ""], ["pageInput", ""], [1, "pagination-box", "clearfix"], ["class", "button-panel display-inline-block", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "tools_options", 4, "ngIf"], [4, "ngIf"], [1, "ListHeadResultInfo", "display-inline"], [1, "float-right"], ["class", "pagination-limit", 4, "ngIf"], [1, "select-panel", "float-right"], [1, "btn", "btn_generic", "column-selector-button", 3, "click"], [1, "column-selector-wrapper", 3, "click"], ["class", "column-selector-box panel panel-default", 4, "ngIf"], [1, "button-panel", "display-inline-block"], ["type", "button", 3, "click"], [1, "tools_options"], ["disable-right-click", "", "translate", "", 1, "input-button", "btn", "btn_primary", "hp_selection", 3, "click", "contextMenu", "contextMenuValue"], [4, "ngFor", "ngForOf"], ["contextMenuItem", "", 3, "subMenu"], ["contextMenuItem", "", 3, "execute"], [1, "pagination-limit"], [1, "input-group"], [1, "font-weight-normal", "per-page-container"], [1, "pagination-select", 3, "change", "ngModel"], [3, "value", 4, "ngFor", "ngForOf"], ["class", "page-link-container", 4, "ngIf"], [1, "font-weight-normal"], [3, "value"], [1, "page-link-container"], ["role", "link", 1, "page-link-tag", "btn", "btn-link", "no-margin", 3, "click"], [1, "column-selector-box", "panel", "panel-default"], ["class", "column-selector-fixed-column checkbox", 4, "ngIf"], ["class", "column-selector-column checkbox", 4, "ngFor", "ngForOf"], [1, "column-selector-fixed-column", "checkbox"], [1, "column-selector-label"], ["type", "checkbox", 3, "ngModelChange", "ngModel"], [1, "column-label-span"], [1, "column-selector-column", "checkbox"], ["translate", "", 1, "column-label-span", 3, "textContent"], [1, "modal-header"], ["id", "ax-title", "tabindex", "-1", 1, "modal-title"], [1, "modal-close", 3, "click"], [1, "modal-body"], [1, "modal-footer"], [1, "btn", "btn_primary", 3, "click"]],
      template: function DataTableHeader_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 8);
          i0.ɵɵtemplate(1, DataTableHeader_div_1_Template, 4, 6, "div", 9)(2, DataTableHeader_div_2_Template, 4, 2, "div", 10);
          i0.ɵɵelementStart(3, "context-menu", null, 0);
          i0.ɵɵtemplate(5, DataTableHeader_ng_container_5_Template, 2, 1, "ng-container", 11);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "div", 12)(7, "span");
          i0.ɵɵtext(8);
          i0.ɵɵpipe(9, "min");
          i0.ɵɵpipe(10, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(11, DataTableHeader_span_11_Template, 3, 6, "span", 11);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "div", 13);
          i0.ɵɵtemplate(13, DataTableHeader_div_13_Template, 20, 21, "div", 14);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(14, "div", 15)(15, "button", 16);
          i0.ɵɵlistener("click", function DataTableHeader_Template_button_click_15_listener($event) {
            i0.ɵɵrestoreView(_r1);
            ctx.columnSelectorOpen = !ctx.columnSelectorOpen;
            return i0.ɵɵresetView($event.stopPropagation());
          });
          i0.ɵɵtext(16);
          i0.ɵɵpipe(17, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(18, "div", 17);
          i0.ɵɵlistener("click", function DataTableHeader_Template_div_click_18_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView($event.stopPropagation());
          });
          i0.ɵɵtemplate(19, DataTableHeader_div_19_Template, 5, 4, "div", 18);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(20, DataTableHeader_ng_template_20_Template, 14, 12, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.dataTable.customButtons)("ngForTrackBy", ctx.dataTable.trackByIndex);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.batchOptionsButton && ctx.dataTable.batchOptions);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.dataTable.batchOptions);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(10, 13, "misc.List items range", i0.ɵɵpureFunction3(21, _c2$Y, ctx.dataTable.offset + 1, i0.ɵɵpipeBind1(9, 11, i0.ɵɵpureFunction2(18, _c1$1j, ctx.dataTable.offset + ctx.dataTable.limit, ctx.dataTable.itemCount)), ctx.dataTable.itemCount)), "");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.dataTable.totalCheckedRows);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.dataTable.pagination);
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("active", ctx.columnSelectorOpen);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 16, "misc.Show Columns"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.columnSelectorOpen);
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.CheckboxControlValueAccessor, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$1.TranslateDirective, DisableRightClickDirective, i1$2.ContextMenuDirective, i1$2.ContextMenuComponent, i1$2.ContextMenuItemDirective, i1$1.TranslatePipe, MinPipe$1],
      styles: [".syng-batchtool-dropdown{left:15px;position:absolute;top:28px;visibility:visible;z-index:900;background-color:#fff}.syng-batchtool-menu{margin-bottom:0;padding:4px}.syng-batchtool-menu .yuimenuitem:hover{background-color:#fff;outline:-webkit-focus-ring-color auto 5px}.column-label-span{float:inherit;font-weight:400;margin-left:5px}.column-selector-button{background-image:url(/components/unicon/assets/svg-output/chevron_down_light.svg);background-position:right 10px center;background-size:18px;background-repeat:no-repeat;padding:0 35px 0 12px}.column-selector-fixed-column,.column-selector-column{padding-left:15px;padding-right:10px}.column-selector-fixed-column:hover,.column-selector-column:hover{background-color:#e2ecf5}.column-selector-label{padding:4px 0}.column-selector-wrapper{background:#fff;border:1px solid #ccc;border-radius:3px;box-shadow:0 1px 3px #bbb;margin-top:2px;position:absolute;z-index:900}.float-right{float:right}.font-weight-normal{font-weight:400}.display-inline{display:inline}.page-link-container{align-items:center;display:flex}.page-link-tag{cursor:pointer;margin-bottom:0}.pagination-box{margin-bottom:10px;margin-top:-5px;padding-left:15px;position:relative}.pagination-box button{outline:none!important;display:flex;justify-content:space-between;align-items:center}.pagination-box .hp_selection{min-width:150px}.pagination-box .tools_options{display:inline-block}.ngx-contextmenu>ul,context-menu-content ul{overflow:auto;max-height:400px}.ngx-contextmenu .dropdown-item{padding-left:8px;padding-right:0}.ngx-contextmenu .dropdown-item:before{margin-right:4px}.pagination-controllers input{min-width:60px;text-align:right}.pagination-limit{display:inline-table;margin-right:15px;width:100%}.pagination-page{display:inline-table;width:110px}.pagination-prevpage,.pagination-nextpage,.pagination-firstpage,.pagination-lastpage{vertical-align:top}.pagination-reload{color:gray;font-size:12px}.pagination-select{height:24px;width:44px}.panel-default{padding:5px 0}.select-panel{min-height:20px}.select-panel button{outline:none!important}.per-page-container{margin-right:2px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableHeader, [{
    type: Component,
    args: [{
      selector: 'data-table-header',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"pagination-box clearfix\">\n    <div class=\"button-panel display-inline-block\"\n         *ngFor='let button of dataTable.customButtons; trackBy: dataTable.trackByIndex'>\n        <button type=\"button\" class=\"input-button {{button.styleClass}}\"\n                (click)=\"dataTable.customButtonEvent(button.id)\">{{button.display | translate}}</button>\n    </div>\n    <div *ngIf=\"batchOptionsButton && dataTable.batchOptions\" class=\"tools_options\">\n        <button class=\"input-button btn btn_primary hp_selection\"\n                #ngxContextMenu=\"ngxContextMenu\"\n                (click)=\"ngxContextMenu.open($event)\"\n                disable-right-click\n                [contextMenu]=\"basicMenu\"\n                [contextMenuValue]=\"item\"\n                translate>misc.Batch Options\n        </button>\n    </div>\n    <context-menu #basicMenu>\n        <ng-container *ngIf=\"dataTable.batchOptions\">\n            <ng-container *ngFor=\"let batchOption of dataTable.batchOptions\">\n                <ng-container *ngIf=\"batchOption.mail\">\n                    <ng-template contextMenuItem [subMenu]=\"saySubMenu\">\n                        {{'misc.Mail' | translate}}\n                    </ng-template>\n                    <context-menu #saySubMenu>\n                        <ng-container *ngIf=\"batchOption.newMail\">\n                            <ng-template contextMenuItem *ngFor=\"let message of batchOption.newMail\" (execute)='redirect(message)' let-item>\n                                {{message.label}}\n                            </ng-template>\n                        </ng-container>\n                        <ng-container *ngIf=\"batchOption.categories\">\n                            <ng-container *ngFor=\"let category of batchOption.categories\">\n                                <ng-template contextMenuItem [subMenu]=\"saySubMenu1\">\n                                    {{category | translate}}\n                                </ng-template>\n                                <context-menu #saySubMenu1>\n                                    <ng-container *ngFor=\"let categoryMessage of batchOption.categoryMessages\">\n                                        <ng-container *ngIf=\"categoryMessage.category == category\">\n                                            <ng-template contextMenuItem (execute)='redirect(categoryMessage)' let-item>\n                                                {{categoryMessage.label}}\n                                             </ng-template>\n                                        </ng-container>\n                                    </ng-container>\n                                </context-menu>\n                            </ng-container>\n                       </ng-container>\n                       <ng-template contextMenuItem *ngFor=\"let batchOptionMail of batchOption.mail\" (execute)='redirect(batchOptionMail)' let-item>\n                          {{batchOptionMail.label}}\n                       </ng-template>\n                   </context-menu>\n                </ng-container>\n                <ng-container *ngIf=\"batchOption.mainmenu\">\n                    <ng-template contextMenuItem (execute)='batchAction(dataTable.keySuffix, batchOption.mainmenu)' let-item>\n                        {{batchOption.mainmenu.label | translate}}\n                    </ng-template>\n                </ng-container>\n                <ng-container *ngIf=\"batchOption.submenu\">\n                    <ng-template contextMenuItem [subMenu]=\"saySubMenu1\">\n                        {{batchOption.submenu.parentLabel | translate}}\n                    </ng-template>\n                    <context-menu #saySubMenu1>\n                        <ng-container *ngIf=\"batchOption.submenu.childLabel\">\n                            <ng-template contextMenuItem (execute)='batchAction(dataTable.keySuffix, batchOption.submenu)' let-item>\n                                {{batchOption.submenu.childLabel | translate}}\n                            </ng-template>\n                        </ng-container>\n                        <ng-container *ngIf=\"batchOption.submenu.subitems\">\n                            <ng-template contextMenuItem *ngFor=\"let item of batchOption.submenu.subitems\" (execute)='batchAction(dataTable.keySuffix, { id: batchOption.submenu.id, parentLabel: batchOption.submenu.parentLabel, label: item.label, itemId: item.id })'>\n                                {{item.label | translate}}\n                            </ng-template>\n                        </ng-container>\n                    </context-menu>\n                </ng-container>\n                <ng-container *ngIf=\"batchOption.hierarchalMenu\">\n                    <ng-container>\n                        <ng-template contextMenuItem [subMenu]=\"saySubMenu1\">\n                            {{ batchOption.hierarchalMenu.label }}\n                        </ng-template>\n                        <context-menu #saySubMenu1>\n                            <ng-container *ngFor=\"let category of batchOption.hierarchalMenu.categories\">\n                                <ng-template contextMenuItem\n                                             [subMenu]=\"saySubMenu2\">\n                                    {{ category.label }}\n                                </ng-template>\n                                <context-menu #saySubMenu2>\n                                    <ng-template contextMenuItem *ngFor=\"let subcategory of category.subcategories\"\n                                                 (execute)='batchAction(dataTable.keySuffix, subcategory)' let-item>\n                                        {{ subcategory.label }}\n                                    </ng-template>\n                                </context-menu>\n                            </ng-container>\n                        </context-menu>\n                    </ng-container>\n                </ng-container>\n            </ng-container>\n        </ng-container>\n    </context-menu>\n    <div class=\"ListHeadResultInfo display-inline\">\n        <span> {{'misc.List items range' | translate: {\n                start: (dataTable.offset + 1),\n                end: [dataTable.offset + dataTable.limit , dataTable.itemCount] | min,\n                total: dataTable.itemCount}\n            }}</span>\n        <span *ngIf=\"dataTable.totalCheckedRows\"> ({{'misc.List items selected' | translate: {\n                total: dataTable.totalCheckedRows}\n            }})</span>\n    </div>\n    <div class=\"float-right\">\n        <div class=\"pagination-limit\" *ngIf=\"dataTable.pagination\">\n            <div class=\"input-group\">\n                <label class=\"font-weight-normal per-page-container\" [attr.aria-label]=\"'misc.Number of Items Showing' | translate\">\n                    {{'misc.Showing' | translate}}\n                    <select #limitInput (change)=\"limit = +limitInput.value\"\n                            [ngModel]=\"limit\"\n                            class=\"pagination-select\">\n                        <option *ngFor=\"let pp of perPage\" [value]=\"pp\">{{pp}}</option>\n                    </select>\n                    {{'misc.per page' | translate}}&nbsp;|\n                </label>\n\n                <div *ngIf=\"page > 1\" class=\"page-link-container\">\n                    <button role=\"link\" (click)=\"pageBack()\" class=\"page-link-tag btn btn-link no-margin\"> < {{'misc.Previous' | translate}}</button>\n                    &nbsp;|\n                </div>\n\n                <label class=\"font-weight-normal\">\n                    &nbsp;{{'misc.Page' | translate}}\n                    <select #pageInput (change)=\"page = +pageInput.value\"\n                            [ngModel]=\"page\"\n                            [attr.title]=\"'misc.Jump to page' | translate\"\n                            class=\"pagination-select\">\n                        <option *ngFor=\"let page of pages\" [value]=\"page\">{{page}}</option>\n                    </select>\n                </label>\n                <div *ngIf=\"page != maxPage\" class=\"page-link-container\">\n                    |&nbsp;\n                    <button role=\"link\" (click)=\"pageForward()\" class=\"page-link-tag btn btn-link no-margin\" >{{'misc.Next' | translate}} > </button>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"select-panel float-right\">\n        <button class=\"btn btn_generic column-selector-button\" [class.active]=\"columnSelectorOpen\"\n                (click)=\"columnSelectorOpen = !columnSelectorOpen; $event.stopPropagation()\">{{ 'misc.Show Columns' | translate }}</button>\n        <div class=\"column-selector-wrapper\" (click)=\"$event.stopPropagation()\">\n            <div *ngIf=\"columnSelectorOpen\" class=\"column-selector-box panel panel-default\">\n                <div *ngIf=\"dataTable.expandableRows\" class=\"column-selector-fixed-column checkbox\">\n                    <label class=\"column-selector-label\">\n                        <input type=\"checkbox\" [(ngModel)]=\"dataTable.expandColumnVisible\"/>\n                        <span class=\"column-label-span\">{{dataTable.translations.expandColumn}}</span>\n                    </label>\n                </div>\n                <div *ngIf=\"dataTable.indexColumn\" class=\"column-selector-fixed-column checkbox\">\n                    <label class=\"column-selector-label\">\n                        <input type=\"checkbox\" [(ngModel)]=\"dataTable.indexColumnVisible\"/>\n                        <span class=\"column-label-span\">{{dataTable.translations.indexColumn}}</span>\n                    </label>\n                </div>\n                <div *ngIf=\"dataTable.selectColumn\" class=\"column-selector-fixed-column checkbox\">\n                    <label class=\"column-selector-label\">\n                        <input type=\"checkbox\" [(ngModel)]=\"dataTable.selectColumnVisible\"/>\n                        <span class=\"column-label-span\">{{dataTable.translations.selectColumn}}</span>\n                    </label>\n                </div>\n                <div *ngFor=\"let column of dataTable.columns\" class=\"column-selector-column checkbox\">\n                    <label class=\"column-selector-label\">\n                        <input type=\"checkbox\" [(ngModel)]=\"column.visible\"/>\n                        <span class=\"column-label-span\" [textContent]=\"column.header\" translate></span>\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<ng-template #noSelection>\n    <div class=\"modal-header\">\n        <h3 id=\"ax-title\" class=\"modal-title\" tabindex=\"-1\">{{ 'misc.No selection' | translate }}</h3>\n        <button class=\"modal-close\" [attr.aria-label]=\"'misc.Close' | translate\" (click)=\"noSelectionModalRef.hide()\"></button>\n    </div>\n    <div class=\"modal-body\">\n        <span>{{ 'misc.To perform this action, you must select at least one record.' | translate}}</span>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn_primary\" (click)=\"noSelectionModalRef.hide()\">{{ 'misc.OK' | translate}}</button>\n</div>\n</ng-template>\n",
      styles: [".syng-batchtool-dropdown{left:15px;position:absolute;top:28px;visibility:visible;z-index:900;background-color:#fff}.syng-batchtool-menu{margin-bottom:0;padding:4px}.syng-batchtool-menu .yuimenuitem:hover{background-color:#fff;outline:-webkit-focus-ring-color auto 5px}.column-label-span{float:inherit;font-weight:400;margin-left:5px}.column-selector-button{background-image:url(/components/unicon/assets/svg-output/chevron_down_light.svg);background-position:right 10px center;background-size:18px;background-repeat:no-repeat;padding:0 35px 0 12px}.column-selector-fixed-column,.column-selector-column{padding-left:15px;padding-right:10px}.column-selector-fixed-column:hover,.column-selector-column:hover{background-color:#e2ecf5}.column-selector-label{padding:4px 0}.column-selector-wrapper{background:#fff;border:1px solid #ccc;border-radius:3px;box-shadow:0 1px 3px #bbb;margin-top:2px;position:absolute;z-index:900}.float-right{float:right}.font-weight-normal{font-weight:400}.display-inline{display:inline}.page-link-container{align-items:center;display:flex}.page-link-tag{cursor:pointer;margin-bottom:0}.pagination-box{margin-bottom:10px;margin-top:-5px;padding-left:15px;position:relative}.pagination-box button{outline:none!important;display:flex;justify-content:space-between;align-items:center}.pagination-box .hp_selection{min-width:150px}.pagination-box .tools_options{display:inline-block}.ngx-contextmenu>ul,context-menu-content ul{overflow:auto;max-height:400px}.ngx-contextmenu .dropdown-item{padding-left:8px;padding-right:0}.ngx-contextmenu .dropdown-item:before{margin-right:4px}.pagination-controllers input{min-width:60px;text-align:right}.pagination-limit{display:inline-table;margin-right:15px;width:100%}.pagination-page{display:inline-table;width:110px}.pagination-prevpage,.pagination-nextpage,.pagination-firstpage,.pagination-lastpage{vertical-align:top}.pagination-reload{color:gray;font-size:12px}.pagination-select{height:24px;width:44px}.panel-default{padding:5px 0}.select-panel{min-height:20px}.select-panel button{outline:none!important}.per-page-container{margin-right:2px}\n"]
    }]
  }], () => [{
    type: DataTable,
    decorators: [{
      type: Inject,
      args: [forwardRef(() => DataTable)]
    }]
  }, {
    type: i1$2.ContextMenuService
  }, {
    type: i1$3.BsModalService
  }], {
    header: [{
      type: Input
    }],
    contextMenu: [{
      type: Input
    }],
    batchOptionsButton: [{
      type: Input
    }],
    basicMenu: [{
      type: ViewChild,
      args: [ContextMenuComponent, {
        static: true
      }]
    }],
    noSelectionTemplate: [{
      type: ViewChild,
      args: ['noSelection']
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DataTableHeader, {
    className: "DataTableHeader",
    filePath: "data-table/components/header.ts",
    lineNumber: 13
  });
})();
class PixelConverter {
  transform(value, args) {
    if (value === undefined) {
      return;
    }
    if (typeof value === 'string') {
      return value;
    }
    if (typeof value === 'number') {
      return value + 'px';
    }
  }
  static {
    this.ɵfac = function PixelConverter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PixelConverter)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "px",
      type: PixelConverter,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PixelConverter, [{
    type: Pipe,
    args: [{
      name: 'px',
      standalone: false
    }]
  }], null, null);
})();
function HttpLoaderFactory(http) {
  let files;
  if (window.NG_ASSETS_DIR) {
    // TODO: Remove if Advocate switches to a new model for frontend localizations
    // At that time we can also remove MultiTranslateHttpLoader since we will always load one file per page
    files = [{
      prefix: window.NG_ASSETS_DIR + '/lang/',
      suffix: '-common.lang.json?' + window.LANG_TIMESTAMP
    }];
  } else {
    files = [{
      prefix: '/local/' + (window.LANG ? window.LANG + '-' : ''),
      suffix: (window.SUB_SYSTEM ? '-' + window.SUB_SYSTEM : '') + '-ngx.lang.json?' + window.LANG_TIMESTAMP
    }];
  }
  return new MultiTranslateHttpLoader(http, files);
}
class MyMissingTranslationHandler {
  handle(params) {
    let key = params.key;
    let parts = key.split('.', 2);
    if (!parts.length) {
      key = (typeof window.CURRENT_SECTION === undefined ? 'misc' : window.CURRENT_SECTION) + '.' + key;
      return params.translateService.get(key, params.interpolateParams);
    }
    return key;
  }
}
class TranslationMenu {
  constructor(label, menuItems) {
    this.label = label;
    this.menuItems = menuItems;
  }
}
class TranslationMenuItem {
  constructor(label, link, target = '_self') {
    this.label = label;
    this.link = link;
    this.target = target;
  }
}
class TranslationButton extends TranslationMenuItem {}
class TranslationsModule {
  static forRoot() {
    return {
      ngModule: TranslationsModule,
      providers: [TranslateModule.forRoot({
        useDefaultLang: false,
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useClass: MyMissingTranslationHandler
        },
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpHandler]
        },
        compiler: {
          provide: TranslateCompiler,
          useFactory: TranslateMessageFormatCompilerFactory
        }
      }).providers, TranslateService]
    };
  }
  static forChild() {
    return {
      ngModule: TranslationsModule,
      providers: [TranslateModule.forChild({
        useDefaultLang: false,
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useClass: MyMissingTranslationHandler
        },
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        },
        compiler: {
          provide: TranslateCompiler,
          useClass: TranslateMessageFormatCompiler
        }
      }).providers]
    };
  }
  static standalone() {
    return {
      providers: [{
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler
      }, {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }, {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler
      }, TranslateService]
    };
  }
  static {
    this.ɵfac = function TranslationsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TranslationsModule)();
    };
  }
  static {
    this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
      type: TranslationsModule
    });
  }
  static {
    this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
      imports: [CommonModule, TranslateModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslationsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      exports: [TranslateModule]
    }]
  }], null, null);
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TranslationsModule, {
    imports: [CommonModule],
    exports: [TranslateModule]
  });
})();
function TranslateMessageFormatCompilerFactory() {
  return new TranslateMessageFormatCompiler();
}
function PaginationComponent_option_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pp_r1 = ctx.$implicit;
    i0.ɵɵproperty("selected", pp_r1.isSelected);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(pp_r1.value);
  }
}
function PaginationComponent_option_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const page_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(page_r2.value);
  }
}
class PaginationComponent {
  ngOnInit() {
    this.setPages(this.page_summary.total, this.page_summary.perPage);
    this.setPerPage(this.page_summary.perPage);
  }
  setPerPage(perPage) {
    this.perPage = [20, 50, 100, 250].map(num => ({
      value: num,
      isSelected: num === perPage
    }));
  }
  setPages(total, perPage) {
    let num = Math.ceil(total / perPage);
    let arr = [];
    for (let i = 0; i < num; i++) {
      arr.push({
        label: i + 1,
        value: i + 1,
        isSelected: false
      });
    }
    this.pages = arr;
  }
  static {
    this.ɵfac = function PaginationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaginationComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: PaginationComponent,
      selectors: [["app-pagination"]],
      inputs: {
        page_summary: "page_summary"
      },
      standalone: false,
      decls: 11,
      vars: 2,
      consts: [["size", "1"], [3, "selected", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], ["href", "#"], [3, "selected"]],
      template: function PaginationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "label");
          i0.ɵɵtext(1, " Showing ");
          i0.ɵɵelementStart(2, "select", 0);
          i0.ɵɵtemplate(3, PaginationComponent_option_3_Template, 2, 2, "option", 1);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "label");
          i0.ɵɵtext(5, " Jump ");
          i0.ɵɵelementStart(6, "select", 0);
          i0.ɵɵtemplate(7, PaginationComponent_option_7_Template, 2, 1, "option", 2);
          i0.ɵɵelementEnd()();
          i0.ɵɵtext(8, "\n| ");
          i0.ɵɵelementStart(9, "a", 3);
          i0.ɵɵtext(10, "Next");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngForOf", ctx.perPage);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngForOf", ctx.pages);
        }
      },
      dependencies: [i1.NgForOf],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationComponent, [{
    type: Component,
    args: [{
      selector: 'app-pagination',
      standalone: false,
      template: "<label>\n\tShowing\n\t<select size=\"1\">\n\t  <option *ngFor=\"let pp of perPage\" [selected]=\"pp.isSelected\">{{pp.value}}</option>\n\t</select>\n</label>\n<label>\n\tJump\n    <select size=\"1\">\n\t  <option *ngFor=\"let page of pages\">{{page.value}}</option>\n    </select>\n</label>\n| <a href=\"#\">Next</a>"
    }]
  }], null, {
    page_summary: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PaginationComponent, {
    className: "PaginationComponent",
    filePath: "common/pagination.component.ts",
    lineNumber: 8
  });
})();
const _c0$1E = ["*"];
class ModalComponent {
  static {
    this.ɵfac = function ModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ModalComponent,
      selectors: [["waitlist-modal"]],
      inputs: {
        modal_id: "modal_id",
        modal_size: "modal_size",
        modal_title: "modal_title"
      },
      standalone: false,
      ngContentSelectors: _c0$1E,
      decls: 13,
      vars: 7,
      consts: [["tabindex", "-1", "role", "dialog", "aria-labelledby", "myModalLabel", 1, "modal", "fade", 3, "id"], ["role", "document"], [1, "modal-content"], [1, "modal-header"], ["id", "myModalLabel", 1, "modal-title"], ["type", "button", "data-dismiss", "modal", "aria-label", "Close", 1, "modal-close"], [1, "modal-body"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", "flow-btn", "", "translate", "", 1, "btn", "btn-default"]],
      template: function ModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "h3", 4);
          i0.ɵɵtext(5);
          i0.ɵɵpipe(6, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(7, "button", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "div", 6);
          i0.ɵɵprojection(9);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "div", 7)(11, "button", 8);
          i0.ɵɵtext(12, "misc.Close");
          i0.ɵɵelementEnd()()()()();
        }
        if (rf & 2) {
          i0.ɵɵpropertyInterpolate("id", ctx.modal_id);
          i0.ɵɵadvance();
          i0.ɵɵclassMapInterpolate1("modal-dialog ", ctx.modal_size, "");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 5, ctx.modal_title));
        }
      },
      dependencies: [i1$1.TranslateDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalComponent, [{
    type: Component,
    args: [{
      selector: 'waitlist-modal',
      standalone: false,
      template: "<div class=\"modal fade\" id=\"{{modal_id}}\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\">\n\t<div class=\"modal-dialog {{modal_size}}\" role=\"document\">\n\t\t<div class=\"modal-content\">\n\t\t\t<div class=\"modal-header\">\n\t\t\t\t<h3 class=\"modal-title\" id=\"myModalLabel\">{{modal_title | translate}}</h3>\n\t\t\t\t<button type=\"button\" class=\"modal-close\" data-dismiss=\"modal\" aria-label=\"Close\"></button>\n\t\t\t</div>\n\t\t\t<div class=\"modal-body\">\n\t\t\t\t<ng-content></ng-content>\n\t\t\t</div>\n\t\t\t<div class=\"modal-footer\">\n\t\t\t\t<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" flow-btn translate>misc.Close</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n"
    }]
  }], null, {
    modal_id: [{
      type: Input
    }],
    modal_size: [{
      type: Input
    }],
    modal_title: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ModalComponent, {
    className: "ModalComponent",
    filePath: "common/modal.component.ts",
    lineNumber: 8
  });
})();
const _c0$1D = ["*"];
class TabsComponent {
  ngOnInit() {}
  static {
    this.ɵfac = function TabsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabsComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: TabsComponent,
      selectors: [["app-tabs"]],
      standalone: false,
      ngContentSelectors: _c0$1D,
      decls: 2,
      vars: 0,
      consts: [[1, "nav-tabs"]],
      template: function TabsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "ul", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsComponent, [{
    type: Component,
    args: [{
      selector: 'app-tabs',
      standalone: false,
      template: "<ul class=\"nav-tabs\">\n  <ng-content></ng-content>\n</ul>\n"
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TabsComponent, {
    className: "TabsComponent",
    filePath: "common/tabs.component.ts",
    lineNumber: 9
  });
})();
const _c0$1C = a0 => ({
  "width": a0
});
class ProgressBarComponent {
  ngOnInit() {}
  static {
    this.ɵfac = function ProgressBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProgressBarComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ProgressBarComponent,
      selectors: [["app-progress-bar"]],
      inputs: {
        progress_level: "progress_level"
      },
      standalone: false,
      decls: 6,
      vars: 4,
      consts: [[2, "display", "flex", "justify-content", "space-between", "flex-basis", "20%"], [1, "glyphicon", "glyphicon-user", 2, "margin-right", "10px"], [1, "progress", 2, "width", "100%"], ["role", "progressbar", 1, "progress-bar", 2, "padding", "0 10px", "text-align", "left", 3, "ngStyle"], [1, "", 2, "white-space", "nowrap"]],
      template: function ProgressBarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "i", 1);
          i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "span", 4);
          i0.ɵɵtext(5);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c0$1C, ctx.progress_level + "%"));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1("Match ", ctx.progress_level, "%");
        }
      },
      dependencies: [i1.NgStyle],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressBarComponent, [{
    type: Component,
    args: [{
      selector: 'app-progress-bar',
      standalone: false,
      template: "<div style=\"display:flex; justify-content: space-between; flex-basis:20%\">\n  <i class=\"glyphicon glyphicon-user\" style=\"margin-right:10px\"></i>\n  <div class=\"progress\" style=\"width:100%\">\n    <div style=\"padding: 0 10px; text-align: left;\" class=\"progress-bar\" role=\"progressbar\" [ngStyle]=\"{ 'width': progress_level + '%'}\">\n      <span class=\"\" style=\"white-space: nowrap\">Match {{progress_level}}%</span>\n    </div>\n  </div>\n</div>\n"
    }]
  }], null, {
    progress_level: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ProgressBarComponent, {
    className: "ProgressBarComponent",
    filePath: "common/progress-bar.component.ts",
    lineNumber: 8
  });
})();
function WarningModalComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "button", 8);
    i0.ɵɵlistener("click", function WarningModalComponent_div_9_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.proceed());
    });
    i0.ɵɵtext(2, "Ok");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 8);
    i0.ɵɵlistener("click", function WarningModalComponent_div_9_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.cancel());
    });
    i0.ɵɵtext(4, "Cancel");
    i0.ɵɵelementEnd()();
  }
}
function WarningModalComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "button", 8);
    i0.ɵɵlistener("click", function WarningModalComponent_ng_template_10_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.proceed());
    });
    i0.ɵɵtext(2, "Ok");
    i0.ɵɵelementEnd()();
  }
}
class WarningModalComponent {
  constructor(modalService, activeModal) {
    this.modalService = modalService;
    this.activeModal = activeModal;
    this.confirm = true;
  }
  proceed() {
    this.activeModal.close(true);
  }
  cancel() {
    this.activeModal.close(false);
  }
  static {
    this.ɵfac = function WarningModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || WarningModalComponent)(i0.ɵɵdirectiveInject(i1$4.NgbModal), i0.ɵɵdirectiveInject(i1$4.NgbActiveModal));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: WarningModalComponent,
      selectors: [["warning-modal"]],
      inputs: {
        msg: "msg",
        confirm: "confirm"
      },
      standalone: false,
      decls: 12,
      vars: 3,
      consts: [["alert", ""], [1, "modal-header"], [1, "modal-title"], ["type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], ["class", "modal-footer", 4, "ngIf", "ngIfElse"], [1, "modal-footer"], ["type", "button", "flow-btn", "", 1, "btn", "btn-outline-dark", 3, "click"]],
      template: function WarningModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1)(1, "h4", 2);
          i0.ɵɵtext(2, "Warning");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "button", 3);
          i0.ɵɵlistener("click", function WarningModalComponent_Template_button_click_3_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.cancel());
          });
          i0.ɵɵelementStart(4, "span", 4);
          i0.ɵɵtext(5, "\u00D7");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(6, "div", 5)(7, "p");
          i0.ɵɵtext(8);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(9, WarningModalComponent_div_9_Template, 5, 0, "div", 6)(10, WarningModalComponent_ng_template_10_Template, 3, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const alert_r5 = i0.ɵɵreference(11);
          i0.ɵɵadvance(8);
          i0.ɵɵtextInterpolate(ctx.msg);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.confirm)("ngIfElse", alert_r5);
        }
      },
      dependencies: [i1.NgIf],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WarningModalComponent, [{
    type: Component,
    args: [{
      selector: 'warning-modal',
      standalone: false,
      template: "  <div class=\"modal-header\">\n    <h4 class=\"modal-title\">Warning</h4>\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"cancel()\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n  </div>\n  <div class=\"modal-body\">\n    <p>{{msg}}</p>\n  </div>\n  <div class=\"modal-footer\" *ngIf=\"confirm; else alert\">\n    <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"proceed()\" flow-btn>Ok</button>\n    <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"cancel()\" flow-btn>Cancel</button>\n  </div>\n  <ng-template #alert>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"proceed()\" flow-btn>Ok</button>\n    </div>\n  </ng-template>"
    }]
  }], () => [{
    type: i1$4.NgbModal
  }, {
    type: i1$4.NgbActiveModal
  }], {
    msg: [{
      type: Input
    }],
    confirm: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(WarningModalComponent, {
    className: "WarningModalComponent",
    filePath: "common/warning-modal.component.ts",
    lineNumber: 9
  });
})();
const _c0$1B = [[["", "well-buttons", ""]], [["", "well-content", ""]]];
const _c1$1i = ["[well-buttons]", "[well-content]"];
function CollapsableWellComponent_ng_content_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1, ["*ngIf", "isVisible"]);
  }
}
class CollapsableWellComponent {
  constructor() {
    this.isVisible = false;
  }
  toggleContent() {
    this.isVisible = !this.isVisible;
  }
  static {
    this.ɵfac = function CollapsableWellComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CollapsableWellComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: CollapsableWellComponent,
      selectors: [["collapsable-well"]],
      standalone: false,
      ngContentSelectors: _c1$1i,
      decls: 2,
      vars: 1,
      consts: [[4, "ngIf"]],
      template: function CollapsableWellComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c0$1B);
          i0.ɵɵtemplate(0, CollapsableWellComponent_ng_content_0_Template, 1, 0, "ng-content", 0);
          i0.ɵɵprojection(1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.isVisible);
        }
      },
      dependencies: [i1.NgIf],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollapsableWellComponent, [{
    type: Component,
    args: [{
      selector: 'collapsable-well',
      standalone: false,
      template: "<ng-content select=\"[well-content]\" *ngIf=\"isVisible\"></ng-content>\n<ng-content select=\"[well-buttons]\"></ng-content>"
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CollapsableWellComponent, {
    className: "CollapsableWellComponent",
    filePath: "common/collapsable-well.component.ts",
    lineNumber: 9
  });
})();
class HighlightSearchPipe {
  transform(value, args) {
    if (!args) {
      return value;
    }
    var re = new RegExp(args.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), 'gi'); //'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
    return value.replace(re, "<mark>$&</mark>");
  }
  static {
    this.ɵfac = function HighlightSearchPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HighlightSearchPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "highlight",
      type: HighlightSearchPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HighlightSearchPipe, [{
    type: Pipe,
    args: [{
      name: 'highlight',
      standalone: true
    }]
  }], null, null);
})();
const hasRequiredField = abstractControl => {
  if (abstractControl.validator) {
    const validator = abstractControl.validator({});
    if (validator && validator.required) {
      return true;
    }
  }
  if (abstractControl['controls']) {
    for (const controlName in abstractControl['controls']) {
      if (abstractControl['controls'][controlName]) {
        if (hasRequiredField(abstractControl['controls'][controlName])) {
          return true;
        }
      }
    }
  }
  return false;
};
const debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};
const getRandomId = (loop = 1) => {
  let id = '';
  for (let i = 0; i < loop; i++) {
    id += String.fromCharCode(65 + Math.floor(Math.random() * 26));
  }
  return id + Date.now();
};
const uniqueElementId = (name = '') => {
  let id = '';
  let prefix = name.replace(/\W/gi, '_');
  do {
    id = (prefix ? prefix + '_' : prefix) + getRandomId(3);
  } while (document.getElementById(id));
  return id;
};
const convertSoDependencies = (config, SoDependenciesKey = 'SoDependencies') => {
  let controls = config.controlGroups || config.controls;
  let dependencies = getSoDependencies(controls, SoDependenciesKey);
  if (size(dependencies)) {
    setFormDependencies(controls, dependencies);
  }
};
const getSoDependencies = (controls, SoDependenciesKey, collection = {}) => {
  controls.forEach(item => {
    let fieldDependencies = item[SoDependenciesKey];
    if (isObject(fieldDependencies) && size(fieldDependencies)) {
      for (let key in fieldDependencies) {
        if (!isObject(collection[key])) {
          collection[key] = {};
        }
        let depValue = fieldDependencies[key];
        if (Array.isArray(depValue)) {
          if (depValue.length) {
            collection[key][item.name] = depValue;
          }
        } else {
          collection[key][item.name] = [depValue];
        }
      }
    }
    let children = item.controlGroups || item.controls;
    if (Array.isArray(children) && children.length) {
      collection = getSoDependencies(children, SoDependenciesKey, collection);
    }
  });
  return collection;
};
const setFormDependencies = (controls, value) => {
  let dependenciesKeys = Object.keys(value);
  if (!dependenciesKeys.length) {
    return;
  }
  controls.forEach(item => {
    if (dependenciesKeys.includes(item.name)) {
      item['dependencies'] = value[item.name];
      delete value[item.name];
    }
    let children = item.controlGroups || item.controls;
    if (Array.isArray(children) && children.length) {
      setFormDependencies(children, value);
    }
  });
};
const getKeyboardFocusableElements = (element = document, getOnlyVisibleItems = false) => {
  let elements = element.querySelectorAll('a[href], button, input:not([type=hidden]), textarea, select, details,[tabindex]:not([tabindex="-1"])');
  return Array.from(elements).filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden') && (getOnlyVisibleItems ? el.checkVisibility() : true));
};
const getCurrentCssVariableBreakpoint = type => {
  const map = {
    janus: {
      xs: '--bs-breakpoint-xs',
      sm: '--bs-breakpoint-sm',
      md: '--bs-breakpoint-md',
      lg: '--bs-breakpoint-lg',
      xl: '--bs-breakpoint-xl',
      xxl: '--bs-breakpoint-xxl',
      super: '--bs-breakpoint-super'
    }
  };
  const breakpoints = map[type];
  if (!breakpoints) return null;
  const styles = getComputedStyle(document.documentElement);
  const bodyWidth = document.body.clientWidth;
  const sortedBreakpoints = Object.entries(breakpoints).map(([key, variable]) => {
    const value = styles.getPropertyValue(variable);
    const width = parseInt(value.replace('px', '').trim(), 10);
    return [key, isNaN(width) ? 0 : width];
  }).sort(([, a], [, b]) => a - b);
  for (const [key, width] of sortedBreakpoints) {
    if (bodyWidth < width) break;
    type = key;
  }
  return type;
};
let SearchTextPipe$1 = class SearchTextPipe {
  transform(value, keys, term) {
    if (!term) return value;
    let filter = (item, keys, idx = 0) => {
      let result = false;
      if (keys) {
        let key = keys.split('.')[idx];
        if (item.hasOwnProperty(key)) {
          if (keys.split('.')[idx + 1]) {
            result = filter(item[key], keys, idx + 1);
          } else {
            result = item.hasOwnProperty(key) && item[key].toLowerCase().indexOf(term.toLowerCase()) !== -1;
          }
        }
      } else {
        result = item.toLowerCase().indexOf(term.toLowerCase()) !== -1;
      }
      return result;
    };
    return (value || []).filter(item => filter(item, keys));
  }
  static {
    this.ɵfac = function SearchTextPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SearchTextPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "searchText",
      type: SearchTextPipe,
      pure: true,
      standalone: false
    });
  }
};
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchTextPipe$1, [{
    type: Pipe,
    args: [{
      name: 'searchText',
      standalone: false
    }]
  }], null, null);
})();
const _c0$1A = ["defaultTemplate"];
const _c1$1h = ["janusTemplate"];
const _c2$X = ["dynamicTemplate"];
const _c3$F = ["list"];
const _c4$w = ["header"];
const _c5$m = ["searchField"];
const _c6$g = ["listItem"];
const _c7$b = () => ({
  "active": true
});
const _c8$a = () => ({
  "selected": true
});
const _c9$8 = () => ({});
const _c10$6 = (a0, a1) => ({
  "py-md-10": a0,
  "d-none": a1
});
const _c11$4 = a0 => ({
  "text-md-center": a0
});
const _c12$3 = () => ({
  "bg-primary": true,
  "bg-opacity-10": true
});
const _c13$3 = a0 => ({
  "hoverable": a0
});
function hierarchicalListWidgetComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, null, 4);
  }
}
function hierarchicalListWidgetComponent_ng_template_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13, 5)(2, "button", 16);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("click", function hierarchicalListWidgetComponent_ng_template_1_Conditional_0_Template_button_click_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.back($event));
    });
    i0.ɵɵelement(4, "span", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 3, "misc.Previous"));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("id", ctx_r1.config.id + "-level-title");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.navTitle);
  }
}
function hierarchicalListWidgetComponent_ng_template_1_Conditional_1_ng_container_3_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li", 22, 7);
    i0.ɵɵlistener("click", function hierarchicalListWidgetComponent_ng_template_1_Conditional_1_ng_container_3_Conditional_1_ng_container_0_Template_li_click_1_listener($event) {
      const groupItem_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.select(groupItem_r5, $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const groupItem_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(5);
    const defaultListItemDirectiveTemplate_r6 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cdkOption", groupItem_r5)("item", groupItem_r5)("level", ctx_r1.listTreeLevel)("isSelected", ctx_r1.isSelectedItem(groupItem_r5))("config", ctx_r1.config)("itemTemplate", defaultListItemDirectiveTemplate_r6)("ngClass", ctx_r1.isFocused && groupItem_r5.id === (ctx_r1.cdkListKeyManager == null ? null : ctx_r1.cdkListKeyManager.activeItem == null ? null : ctx_r1.cdkListKeyManager.activeItem.value == null ? null : ctx_r1.cdkListKeyManager.activeItem.value.id) ? i0.ɵɵpureFunction0(7, _c7$b) : ctx_r1.isSelectedItem(groupItem_r5) ? i0.ɵɵpureFunction0(8, _c8$a) : i0.ɵɵpureFunction0(9, _c9$8));
  }
}
function hierarchicalListWidgetComponent_ng_template_1_Conditional_1_ng_container_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, hierarchicalListWidgetComponent_ng_template_1_Conditional_1_ng_container_3_Conditional_1_ng_container_0_Template, 3, 10, "ng-container", 20);
  }
  if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngForOf", item_r7.children);
  }
}
function hierarchicalListWidgetComponent_ng_template_1_Conditional_1_ng_container_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 22, 7);
    i0.ɵɵlistener("click", function hierarchicalListWidgetComponent_ng_template_1_Conditional_1_ng_container_3_Conditional_2_Template_li_click_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const item_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.select(item_r7, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const defaultListItemDirectiveTemplate_r6 = i0.ɵɵreference(6);
    i0.ɵɵproperty("cdkOption", item_r7)("item", item_r7)("level", ctx_r1.listTreeLevel)("isSelected", ctx_r1.isSelectedItem(item_r7))("config", ctx_r1.config)("itemTemplate", defaultListItemDirectiveTemplate_r6)("ngClass", ctx_r1.isFocused && item_r7.id === (ctx_r1.cdkListKeyManager == null ? null : ctx_r1.cdkListKeyManager.activeItem == null ? null : ctx_r1.cdkListKeyManager.activeItem.value == null ? null : ctx_r1.cdkListKeyManager.activeItem.value.id) ? i0.ɵɵpureFunction0(7, _c7$b) : ctx_r1.isSelectedItem(item_r7) ? i0.ɵɵpureFunction0(8, _c8$a) : i0.ɵɵpureFunction0(9, _c9$8));
  }
}
function hierarchicalListWidgetComponent_ng_template_1_Conditional_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, hierarchicalListWidgetComponent_ng_template_1_Conditional_1_ng_container_3_Conditional_1_Template, 1, 1, "ng-container")(2, hierarchicalListWidgetComponent_ng_template_1_Conditional_1_ng_container_3_Conditional_2_Template, 2, 10, "li", 21);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r7.isGroup && (item_r7.children == null ? null : item_r7.children.length) ? 1 : 2);
  }
}
function hierarchicalListWidgetComponent_ng_template_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul", 19, 6);
    i0.ɵɵlistener("focusin", function hierarchicalListWidgetComponent_ng_template_1_Conditional_1_Template_ul_focusin_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.isFocused = true);
    })("focusout", function hierarchicalListWidgetComponent_ng_template_1_Conditional_1_Template_ul_focusout_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.isFocused = false);
    })("keydown", function hierarchicalListWidgetComponent_ng_template_1_Conditional_1_Template_ul_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.listItemKeyDownEvent($event));
    });
    i0.ɵɵtemplate(3, hierarchicalListWidgetComponent_ng_template_1_Conditional_1_ng_container_3_Template, 3, 1, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cdkListboxMultiple", !!ctx_r1.config.multiple);
    i0.ɵɵattribute("id", ctx_r1.config.id + "-list")("aria-multiselectable", ctx_r1.config.multiple)("aria-labelledby", ctx_r1.config.id + "-level-title")("tabindex", -1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.items());
  }
}
function hierarchicalListWidgetComponent_ng_template_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "misc.No results found"));
  }
}
function hierarchicalListWidgetComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, hierarchicalListWidgetComponent_ng_template_1_Conditional_0_Template, 8, 5, "div", 13)(1, hierarchicalListWidgetComponent_ng_template_1_Conditional_1_Template, 4, 6, "ul", 14)(2, hierarchicalListWidgetComponent_ng_template_1_Conditional_2_Template, 3, 3, "div", 15);
  }
  if (rf & 2) {
    let tmp_6_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.isNavigatingSubTrees ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(((tmp_6_0 = ctx_r1.items()) == null ? null : tmp_6_0.length) ? 1 : !ctx_r1.isWaitingListUpdate && (ctx_r1.config.multiple || !ctx_r1.config.multiple && ctx_r1.isSearching) ? 2 : -1);
  }
}
function hierarchicalListWidgetComponent_ng_template_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nav", 24, 5)(2, "button", 28);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("click", function hierarchicalListWidgetComponent_ng_template_3_Conditional_2_Template_button_click_2_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.back($event));
    });
    i0.ɵɵelementStart(4, "span", 29);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(5, "svg", 30);
    i0.ɵɵelement(6, "use");
    i0.ɵɵelementEnd()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(7, "span", 31);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 32);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵlistener("click", function hierarchicalListWidgetComponent_ng_template_3_Conditional_2_Template_button_click_9_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.emitNavigation("close", $event));
    });
    i0.ɵɵelementStart(11, "span", 29);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(12, "svg", 30);
    i0.ɵɵelement(13, "use");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(16, _c10$6, ctx_r1.states().mobileUI, !ctx_r1.isNavigatingSubTrees));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 12, "misc.Previous"));
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite.svg#tabler-chevron-left");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c11$4, ctx_r1.states().mobileUI));
    i0.ɵɵattribute("id", ctx_r1.config.id + "-level-title");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.navTitle);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("py-md-10", ctx_r1.states().mobileUI)("invisible", !ctx_r1.states().mobileView);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(10, 14, "misc.Close"));
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite.svg#tabler-x");
  }
}
function hierarchicalListWidgetComponent_ng_template_3_Conditional_3_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("mousedown", function hierarchicalListWidgetComponent_ng_template_3_Conditional_3_Conditional_8_Template_button_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(3);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.clearSearch());
    })("keydown.enter", function hierarchicalListWidgetComponent_ng_template_3_Conditional_3_Conditional_8_Template_button_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clearSearch());
    })("keydown.space", function hierarchicalListWidgetComponent_ng_template_3_Conditional_3_Conditional_8_Template_button_keydown_space_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clearSearch());
    });
    i0.ɵɵelementStart(2, "span", 38);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 34);
    i0.ɵɵelement(4, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "misc.Clear"));
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-x");
  }
}
function hierarchicalListWidgetComponent_ng_template_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25)(1, "span", 33);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 34);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "input", 35, 8);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵlistener("ngModelChange", function hierarchicalListWidgetComponent_ng_template_3_Conditional_3_Template_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.debounceFn($event, ctx_r1.searchItems));
    })("keypress", function hierarchicalListWidgetComponent_ng_template_3_Conditional_3_Template_input_keypress_4_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.debounceFn($event, ctx_r1.emitSearchKeyEvent));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, hierarchicalListWidgetComponent_ng_template_3_Conditional_3_Conditional_8_Template, 5, 4, "button", 36);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_10_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite.svg#tabler-search");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngModel", ctx_r1._search())("placeholder", (tmp_10_0 = ctx_r1.config.placeholder) !== null && tmp_10_0 !== undefined ? tmp_10_0 : i0.ɵɵpipeBind1(6, 9, "misc.Search"));
    i0.ɵɵattribute("aria-autocomplete", "list")("aria-expanded", true)("aria-owns", ctx_r1.config.id + "-list")("role", "combobox")("aria-label", i0.ɵɵpipeBind1(7, 11, "misc.Search Text"));
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r1._search() ? 8 : -1);
  }
}
function hierarchicalListWidgetComponent_ng_template_3_Conditional_4_ng_container_4_Conditional_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li", 44, 7);
    i0.ɵɵlistener("click", function hierarchicalListWidgetComponent_ng_template_3_Conditional_4_ng_container_4_Conditional_1_ng_container_4_Template_li_click_1_listener($event) {
      const groupItem_r14 = i0.ɵɵrestoreView(_r13).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.select(groupItem_r14, $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const groupItem_r14 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(5);
    const janusListItemDirectiveTemplate_r15 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cdkOption", groupItem_r14)("item", groupItem_r14)("level", ctx_r1.listTreeLevel)("config", ctx_r1.config)("itemTemplate", janusListItemDirectiveTemplate_r15)("ngClass", ctx_r1.isSelectedItem(groupItem_r14) ? i0.ɵɵpureFunction0(6, _c12$3) : null);
  }
}
function hierarchicalListWidgetComponent_ng_template_3_Conditional_4_ng_container_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 40)(1, "div", 42);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul", 43);
    i0.ɵɵtemplate(4, hierarchicalListWidgetComponent_ng_template_3_Conditional_4_ng_container_4_Conditional_1_ng_container_4_Template, 3, 7, "ng-container", 20);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r16.display);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", item_r16.display);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", item_r16.children);
  }
}
function hierarchicalListWidgetComponent_ng_template_3_Conditional_4_ng_container_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 44, 7);
    i0.ɵɵlistener("click", function hierarchicalListWidgetComponent_ng_template_3_Conditional_4_ng_container_4_Conditional_2_Template_li_click_0_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const item_r16 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.select(item_r16, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const janusListItemDirectiveTemplate_r15 = i0.ɵɵreference(8);
    i0.ɵɵproperty("cdkOption", item_r16)("item", item_r16)("level", ctx_r1.listTreeLevel)("config", ctx_r1.config)("itemTemplate", janusListItemDirectiveTemplate_r15)("ngClass", ctx_r1.isSelectedItem(item_r16) ? i0.ɵɵpureFunction0(6, _c12$3) : null);
  }
}
function hierarchicalListWidgetComponent_ng_template_3_Conditional_4_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, hierarchicalListWidgetComponent_ng_template_3_Conditional_4_ng_container_4_Conditional_1_Template, 5, 3, "li", 40)(2, hierarchicalListWidgetComponent_ng_template_3_Conditional_4_ng_container_4_Conditional_2_Template, 2, 7, "li", 41);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r16 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r16.isGroup ? 1 : 2);
  }
}
function hierarchicalListWidgetComponent_ng_template_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26, 9)(2, "ul", 39, 10);
    i0.ɵɵlistener("focusin", function hierarchicalListWidgetComponent_ng_template_3_Conditional_4_Template_ul_focusin_2_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.isFocused = true);
    })("focusout", function hierarchicalListWidgetComponent_ng_template_3_Conditional_4_Template_ul_focusout_2_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.isFocused = false);
    })("keydown", function hierarchicalListWidgetComponent_ng_template_3_Conditional_4_Template_ul_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.listItemKeyDownEvent($event));
    });
    i0.ɵɵtemplate(4, hierarchicalListWidgetComponent_ng_template_3_Conditional_4_ng_container_4_Template, 3, 1, "ng-container", 20);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.config.id, "-list");
    i0.ɵɵproperty("cdkListboxMultiple", !!ctx_r1.config.multiple);
    i0.ɵɵattribute("aria-labelledby", ctx_r1.config.id + "-level-title")("tabindex", ctx_r1.states().mobileUI ? "0" : "-1")("aria-label", ctx_r1.getListAriaLabel());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.items());
  }
}
function hierarchicalListWidgetComponent_ng_template_3_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "misc.No results found"));
  }
}
function hierarchicalListWidgetComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23, 5);
    i0.ɵɵtemplate(2, hierarchicalListWidgetComponent_ng_template_3_Conditional_2_Template, 14, 21, "nav", 24)(3, hierarchicalListWidgetComponent_ng_template_3_Conditional_3_Template, 9, 13, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, hierarchicalListWidgetComponent_ng_template_3_Conditional_4_Template, 5, 7, "div", 26)(5, hierarchicalListWidgetComponent_ng_template_3_Conditional_5_Template, 3, 3, "div", 27);
  }
  if (rf & 2) {
    let tmp_9_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.config.id, "-dropdown-nav");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.isNavigatingSubTrees || ctx_r1.states().mobileView ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showSearchField() ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(((tmp_9_0 = ctx_r1.items()) == null ? null : tmp_9_0.length) ? 4 : !(ctx_r1.config.externalSearch && !ctx_r1.isSearching) ? 5 : -1);
  }
}
function hierarchicalListWidgetComponent_ng_template_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "input", 50, 11);
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    const item_r19 = ctx_r17.item;
    const idPrefix_r20 = ctx_r17.idPrefix;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("pointer-events", "none");
    i0.ɵɵpropertyInterpolate("id", idPrefix_r20 + "-checkbox");
    i0.ɵɵproperty("checked", ctx_r1.isSelectedItem(item_r19));
    i0.ɵɵattribute("tabindex", -1);
  }
}
function hierarchicalListWidgetComponent_ng_template_5_Conditional_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 48);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const extraLabel_r21 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(extraLabel_r21);
  }
}
function hierarchicalListWidgetComponent_ng_template_5_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, hierarchicalListWidgetComponent_ng_template_5_Conditional_5_ng_container_0_Template, 3, 1, "ng-container", 20);
  }
  if (rf & 2) {
    const item_r19 = i0.ɵɵnextContext().item;
    i0.ɵɵproperty("ngForOf", item_r19.extraLabels);
  }
}
function hierarchicalListWidgetComponent_ng_template_5_Conditional_6_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " > ");
  }
}
function hierarchicalListWidgetComponent_ng_template_5_Conditional_6_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵtemplate(1, hierarchicalListWidgetComponent_ng_template_5_Conditional_6_For_2_Conditional_1_Template, 1, 0);
  }
  if (rf & 2) {
    const treeLabel_r22 = ctx.$implicit;
    const ɵ$index_147_r23 = ctx.$index;
    const ɵ$count_147_r24 = ctx.$count;
    i0.ɵɵtextInterpolate1(" ", treeLabel_r22, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(ɵ$index_147_r23 === ɵ$count_147_r24 - 1) ? 1 : -1);
  }
}
function hierarchicalListWidgetComponent_ng_template_5_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵrepeaterCreate(1, hierarchicalListWidgetComponent_ng_template_5_Conditional_6_For_2_Template, 2, 2, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r19 = i0.ɵɵnextContext().item;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(item_r19.treeRoute);
  }
}
function hierarchicalListWidgetComponent_ng_template_5_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 49)(1, "button", 51);
    i0.ɵɵlistener("click", function hierarchicalListWidgetComponent_ng_template_5_Conditional_7_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r25);
      const item_r19 = i0.ɵɵnextContext().item;
      const ctx_r1 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.next(item_r19, $event));
    });
    i0.ɵɵelement(2, "i", 52);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c13$3, ctx_r1.config.parentSelectable))("disabled", !ctx_r1.config.parentSelectable);
  }
}
function hierarchicalListWidgetComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, hierarchicalListWidgetComponent_ng_template_5_Conditional_1_Template, 2, 5, "input", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 46);
    i0.ɵɵelement(3, "label", 47);
    i0.ɵɵpipe(4, "highlight");
    i0.ɵɵtemplate(5, hierarchicalListWidgetComponent_ng_template_5_Conditional_5_Template, 1, 1, "ng-container")(6, hierarchicalListWidgetComponent_ng_template_5_Conditional_6_Template, 3, 0, "div", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, hierarchicalListWidgetComponent_ng_template_5_Conditional_7_Template, 3, 4, "div", 49);
  }
  if (rf & 2) {
    const item_r19 = ctx.item;
    const idPrefix_r20 = ctx.idPrefix;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isCheckboxAvailable ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("for", idPrefix_r20 + "-checkbox");
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 6, ctx_r1.getItemLabel(item_r19), ctx_r1._search()), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((item_r19.extraLabels == null ? null : item_r19.extraLabels.length) ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isSearching && item_r19.treeRoute ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((item_r19.children == null ? null : item_r19.children.length) ? 7 : -1);
  }
}
function hierarchicalListWidgetComponent_ng_template_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "input", 56);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext();
    const item_r27 = ctx_r25.item;
    const idPrefix_r28 = ctx_r25.idPrefix;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", idPrefix_r28, "-checkbox");
    i0.ɵɵproperty("checked", ctx_r1.isSelectedItem(item_r27))("disabled", !!item_r27.disabled || null);
  }
}
function hierarchicalListWidgetComponent_ng_template_7_Conditional_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 55);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const extraLabel_r29 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(extraLabel_r29);
  }
}
function hierarchicalListWidgetComponent_ng_template_7_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, hierarchicalListWidgetComponent_ng_template_7_Conditional_5_ng_container_0_Template, 3, 1, "ng-container", 20);
  }
  if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext().item;
    i0.ɵɵproperty("ngForOf", item_r27.extraLabels);
  }
}
function hierarchicalListWidgetComponent_ng_template_7_Conditional_6_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " > ");
  }
}
function hierarchicalListWidgetComponent_ng_template_7_Conditional_6_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵtemplate(1, hierarchicalListWidgetComponent_ng_template_7_Conditional_6_For_2_Conditional_1_Template, 1, 0);
  }
  if (rf & 2) {
    const treeLabel_r30 = ctx.$implicit;
    const ɵ$index_183_r31 = ctx.$index;
    const ɵ$count_183_r32 = ctx.$count;
    i0.ɵɵtextInterpolate1(" ", treeLabel_r30, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(ɵ$index_183_r31 === ɵ$count_183_r32 - 1) ? 1 : -1);
  }
}
function hierarchicalListWidgetComponent_ng_template_7_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 55);
    i0.ɵɵrepeaterCreate(1, hierarchicalListWidgetComponent_ng_template_7_Conditional_6_For_2_Template, 2, 2, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext().item;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(item_r27.treeRoute);
  }
}
function hierarchicalListWidgetComponent_ng_template_7_Conditional_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 59);
    i0.ɵɵlistener("click", function hierarchicalListWidgetComponent_ng_template_7_Conditional_7_Conditional_0_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r33);
      const item_r27 = i0.ɵɵnextContext(2).item;
      const ctx_r1 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.next(item_r27, $event));
    });
    i0.ɵɵelementStart(1, "span", 60);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 30);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-chevron-right");
  }
}
function hierarchicalListWidgetComponent_ng_template_7_Conditional_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 58)(1, "span", 60);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 30);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-chevron-right");
  }
}
function hierarchicalListWidgetComponent_ng_template_7_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, hierarchicalListWidgetComponent_ng_template_7_Conditional_7_Conditional_0_Template, 4, 1, "button", 57)(1, hierarchicalListWidgetComponent_ng_template_7_Conditional_7_Conditional_1_Template, 4, 1, "div", 58);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.config.parentSelectable ? 0 : 1);
  }
}
function hierarchicalListWidgetComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 53);
    i0.ɵɵtemplate(1, hierarchicalListWidgetComponent_ng_template_7_Conditional_1_Template, 2, 4, "span");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵelement(3, "label", 54);
    i0.ɵɵpipe(4, "highlight");
    i0.ɵɵtemplate(5, hierarchicalListWidgetComponent_ng_template_7_Conditional_5_Template, 1, 1, "ng-container")(6, hierarchicalListWidgetComponent_ng_template_7_Conditional_6_Template, 3, 0, "div", 55);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, hierarchicalListWidgetComponent_ng_template_7_Conditional_7_Template, 2, 1);
  }
  if (rf & 2) {
    const item_r27 = ctx.item;
    const idPrefix_r28 = ctx.idPrefix;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isCheckboxAvailable ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("for", "", idPrefix_r28, "-checkbox");
    i0.ɵɵpropertyInterpolate("title", ctx_r1.getItemLabel(item_r27));
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 8, ctx_r1.getItemLabel(item_r27), ctx_r1._search()), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((item_r27.extraLabels == null ? null : item_r27.extraLabels.length) ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isSearching && item_r27.treeRoute ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((item_r27.children == null ? null : item_r27.children.length) ? 7 : -1);
  }
}
/**
 * Directive to generate a hierarchical picklist item.
 *
 * @directive hierarchicalListItemDirective
 * @selector [hierarchical-list-item]
 *
 * @inputs
 * - item: any - The data item to be rendered
 * - index: number - Index of the item in the list
 * - total: number - Total number of items in the list
 * - level: number | string - Hierarchical level of the item
 * - activedescendantId: string - ID of the active descendant for accessibility
 * - itemTemplate: TemplateRef<any> - Template for rendering the item
 * - config: any - Configuration for the list
 * - styles: object - Styles classes for active and selected states
 * - isSelected: boolean - Whether the item is selected
 * - currentActivedescendant: string - Current active descendant ID on list
 */
class hierarchicalListItemDirective {
  set isSelected(value) {
    this._isSelected = value;
    if (this.isInit && value !== this._lastSelected) {
      this.updateAriaSelected();
    }
    this._lastSelected = value;
  }
  constructor(viewContainer, el, renderer) {
    this.viewContainer = viewContainer;
    this.el = el;
    this.renderer = renderer;
    this.isInit = false;
  }
  ngOnInit() {
    this.setAttributes();
    this.renderTemplate();
    this.isInit = true;
  }
  renderTemplate() {
    this.viewContainer.clear();
    const embeddedViewRef = this.viewContainer.createEmbeddedView(this.itemTemplate, {
      $implicit: this.item,
      item: this.item,
      idPrefix: this.el.nativeElement.id
    });
    embeddedViewRef.rootNodes.forEach(node => {
      this.renderer.appendChild(this.el.nativeElement, node);
    });
    embeddedViewRef.detectChanges();
  }
  updateAriaSelected() {
    if (this.isMultipleAndParentSelectable()) {
      this.renderer.setAttribute(this.el.nativeElement, 'aria-checked', String(this._isSelected));
    } else {
      this.renderer.setAttribute(this.el.nativeElement, 'aria-selected', String(this._isSelected));
    }
  }
  setAttributes() {
    const element = this.el.nativeElement;
    if (!element.hasAttribute('role')) {
      this.renderer.setAttribute(element, 'role', 'treeitem');
    }
    this.renderer.setAttribute(element, 'aria-level', String(this.level));
    this.updateAriaSelected();
    if (this.item.disabled) {
      this.renderer.setAttribute(element, 'aria-disabled', 'true');
    }
    if (this.item.children?.length) {
      this.renderer.setAttribute(element, 'aria-expanded', String(!this.item.children.length));
    }
  }
  isMultipleAndParentSelectable() {
    return this.config?.multiple && this.config?.parentSelectable;
  }
  static {
    this.ɵfac = function hierarchicalListItemDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || hierarchicalListItemDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: hierarchicalListItemDirective,
      selectors: [["", "hierarchical-list-item", ""]],
      inputs: {
        item: "item",
        level: "level",
        itemTemplate: "itemTemplate",
        config: "config",
        isSelected: "isSelected"
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(hierarchicalListItemDirective, [{
    type: Directive,
    args: [{
      selector: '[hierarchical-list-item]',
      standalone: true
    }]
  }], () => [{
    type: i0.ViewContainerRef
  }, {
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    item: [{
      type: Input
    }],
    level: [{
      type: Input
    }],
    itemTemplate: [{
      type: Input
    }],
    config: [{
      type: Input
    }],
    isSelected: [{
      type: Input
    }]
  });
})();
/**
 * Component to generate a hierarchical picklist.
 *
 * @component hierarchicalListWidgetComponent
 * @description A standalone Angular component for rendering a hierarchical list with search functionality.
 *
 * @inputs
 * - config: Config (required) - Configuration object for the component.
 * - list: ListItem[] - Array of list items to display.
 * - search: string - Search term to search items.
 * - values: string | string[] - Selected values.
 * - assetsPath: string - Path to assets directory (default: '/images/tabler-icons/')
 * - customTemplateRef: TemplateRef<any> - Can use a custom template if set.
 *
 * @outputs
 * - selection: EventEmitter<ListItem[]> - Emits selected list items
 * - navigationChanged: EventEmitter<NavigationEvent> - Emits navigation events
 * - searchChanged: EventEmitter<string> - Emits when search term changes
 * - statesChanged: EventEmitter<Partial<State>> - Emits state changes
 * - searchKeyEvent: EventEmitter<any> - Emits search key events
 */
class hierarchicalListWidgetComponent {
  get cdkListKeyManager() {
    // @ts-ignore
    return this.cdkListbox?.listKeyManager;
  }
  constructor(ngZone, searchTextPipe, cdr, elementRef, translate) {
    this.ngZone = ngZone;
    this.searchTextPipe = searchTextPipe;
    this.cdr = cdr;
    this.elementRef = elementRef;
    this.translate = translate;
    this.list = [];
    this.search = '';
    this.assetsPath = '/images/tabler-icons/';
    this.selection = new EventEmitter();
    this.navigationChanged = new EventEmitter();
    this.searchChanged = new EventEmitter();
    this.statesChanged = new EventEmitter();
    this.searchKeyEvent = new EventEmitter();
    this.isInit = false;
    this._items = [];
    this._search = signal('');
    this.debounceFn = debounce((e, fn) => {
      fn.apply(this, [e]);
    });
    this.items = signal([]);
    this.selects = signal([]);
    this.treeSelection = signal([]);
    this.states = signal({
      search: '',
      activedescendant: -1,
      multiple: false,
      parentSelectable: false,
      isRTL: document.dir === 'rtl',
      mobileUI: false,
      mobileView: false
    });
    this.isSearching = false;
    this.isCheckboxAvailable = false;
    this.navTitle = '';
    this.isNavigatingSubTrees = false;
    this.isWaitingListUpdate = false;
    this.selectedItemsMap = computed(() => {
      const map = new Map();
      this.selects().forEach(item => map.set(item.id, true));
      return map;
    });
    this.isFocused = false;
    this.flattedItemsAtCurrentLevel = [];
    this.trapEnabled = false;
    effect(() => {
      if (this.isInit) {
        this.onStatesUpdate(this.states());
        this.statesChanged.emit(this.states());
      }
    });
    effect(() => {
      this.onTreeSelectionUpdate(this.treeSelection());
      // Re-generate the list by treeSelection changes.
      if (this.treeSelection().length) {
        this.updateItemsForLevel(this.treeSelection());
      } else {
        this.setListItems(this._items);
      }
    }, {
      allowSignalWrites: true
    });
  }
  ngOnInit() {
    this.initializeStates();
    this.widgetSetup();
    this.setOptionItems(_.cloneDeep(this.list));
    if (!_.isEmpty(this.values)) {
      this.updateItemsSelect(this.values);
    }
    if (!_.isEmpty(this.search)) {
      this.searchItems(this.search);
    }
    this.isInit = true;
  }
  ngAfterViewInit() {
    this.initializeScrollPosition();
    this.autoFocusToContent();
    this.emitNavigation('init');
  }
  ngOnChanges(changes) {
    if (changes['config']) {
      this.updateStatesFromConfig();
      this.widgetSetup();
    }
    if (changes['search'] && !changes['search'].firstChange) {
      this.searchItems(changes['search'].currentValue);
    }
    if (changes['list'] && !changes['list'].firstChange) {
      this.treeSelection.set([]);
      this.setOptionItems(_.cloneDeep(this.list));
    }
    if (changes['values'] && !changes['values'].firstChange) {
      this.updateItemsSelect(changes['values'].currentValue);
    }
  }
  widgetSetup() {
    this.id = this.config.id || uniqueElementId('hierpicklist');
    this.isMultipleAndParentSelectable = this.config.multiple && this.config.parentSelectable;
    this.isCheckboxAvailable = !this.config.hideCheckbox && this.isMultipleAndParentSelectable;
    this.resize();
  }
  initializeStates() {
    this.states.update(state => ({
      ...state,
      multiple: this.config.multiple ?? state.multiple,
      parentSelectable: this.config.parentSelectable ?? state.parentSelectable,
      activedescendant: this.config.defaultActivedescendant ?? state.activedescendant
    }));
  }
  updateStatesFromConfig() {
    this.states.update(state => ({
      ...state,
      multiple: this.config.multiple ?? state.multiple,
      parentSelectable: this.config.parentSelectable ?? state.parentSelectable,
      activedescendant: this.config.defaultActivedescendant ?? state.activedescendant
    }));
  }
  autoFocusToContent() {
    if (this.config.autoFocusToContent) {
      const focusables = getKeyboardFocusableElements(this.elementRef.nativeElement);
      focusables?.[0].focus();
    }
  }
  initializeScrollPosition() {
    if (this.config.autoScrollWhenInit && this.selects().length) {
      const selectsId = this.selects().map(s => s.id);
      const selectedItemIdx = this.flattedItemsAtCurrentLevel.findIndex(item => selectsId.includes(item.id));
      if (selectedItemIdx >= 0) {
        this.setActivedescendant(selectedItemIdx);
      }
    }
  }
  setOptionItems(options) {
    this.isWaitingListUpdate = false;
    this.ngZone.runOutsideAngular(() => {
      this._items = this.setupItems(options);
      this.setListItems(this._items);
      this.ngZone.run(() => {
        this.cdr.detectChanges();
      });
    });
  }
  addGroupItemsAttributes(items) {
    let groupIndex = 0;
    for (let item of items) {
      if (item.isGroup) {
        if (!item.id) {
          item['id'] = `hp-group-item-${groupIndex++}`;
        }
      }
    }
  }
  setupItems(items) {
    if (items?.some(d => d.children)) {
      items = this.addHierarchicalPath(items);
      if (this.config.addFullParentData) {
        items = this.addHierarchicalPath(items, 'parents', false);
      }
    }
    return items;
  }
  isMatchSelection(newVal) {
    return _.isEqual(_.sortBy(newVal), _.sortBy(this.selects().map(v => v.id)));
  }
  setSingleSelectItemLabelToInputField(item) {
    const label = item ? this.getItemLabel(item) : '';
    if (!this.states().multiple && !this.config.noInputUpdateOnChange && this.states().search !== label) {
      this.states.update(state => ({
        ...state,
        search: label
      }));
    }
  }
  updateItemsSelect(newVal = []) {
    if (_.isEmpty(newVal) && _.isEmpty(this.selects())) {
      return;
    }
    const _newVal = _.isArray(newVal) ? newVal : _.isNil(newVal) ? [] : [newVal];
    if (_.isObject(_newVal[0])) {
      if (!this.isMatchSelection(_newVal)) {
        this.selects.set(newVal);
        this.setSingleSelectItemLabelToInputField(newVal[0]);
      }
    } else {
      this.ngZone.runOutsideAngular(() => {
        const values = _.uniqWith(this.findItem(this._items, 'id', newVal), _.isEqual);
        if (!this.isMatchSelection(values)) {
          this.selects.set(values);
          this.ngZone.run(() => {
            this.cdr.detectChanges();
            this.setSingleSelectItemLabelToInputField(values[0]);
          });
        }
      });
    }
  }
  searchItems(text) {
    if (this._search() === text) {
      return;
    }
    if (_.isEmpty(text)) {
      this.resetToRootItems();
      return;
    }
    this._search.set(text);
    this.searchChanged.emit(text);
    if (!this.config.externalSearch) {
      this.ngZone.runOutsideAngular(() => {
        let searchedItems = this.searchMatchItems(this._items, text);
        this.treeSelection.set([{
          key: text,
          label: text,
          type: 'search',
          data: searchedItems
        }]);
        this.ngZone.run(() => {
          this.cdr.detectChanges();
          this.emitNavigation('search');
        });
      });
    } else {
      if (!this.config.multiple) {
        this.isSearching = !!text;
      }
      this.isWaitingListUpdate = true;
    }
  }
  setListItems(items) {
    const updatedItem = _.cloneDeep(items);
    this.addGroupItemsAttributes(updatedItem);
    this.items.set(updatedItem);
    this.flattedItemsAtCurrentLevel = this.getItemsAtCurrentLevel();
  }
  searchMatchItems(items, query, key = undefined, parentGroup = null) {
    if (!key) {
      key = this.getKeyForLabel(items[0]);
    }
    let result = [];
    items.forEach(item => {
      if (!item) return;
      if (item.isGroup) {
        if (item.children && item.children.length) {
          const childrenResults = this.searchMatchItems(item.children, query, key, item);
          if (childrenResults.length > 0) {
            result = _.concat(result, childrenResults);
          }
        }
      } else {
        const matchedItems = this.findMatchTextItems([item], key, query);
        if (matchedItems.length > 0) {
          const matchedItem = matchedItems[0];
          if (parentGroup && parentGroup.isGroup) {
            let matchingGroupInResults = result.find(r => r && r.isGroup && parentGroup[key] && r[key] === parentGroup[key]);
            if (!matchingGroupInResults) {
              matchingGroupInResults = _.cloneDeep(parentGroup);
              matchingGroupInResults.children = [];
              result.push(matchingGroupInResults);
            }
            matchingGroupInResults.children.push(matchedItem);
          } else {
            result.push(matchedItem);
          }
        }
        if (item.children && item.children.length) {
          const childrenResults = this.searchMatchItems(item.children, query, key, item);
          if (childrenResults.length > 0) {
            result = _.concat(result, childrenResults);
          }
        }
      }
    });
    return result;
  }
  findMatchTextItems(value, keys, term) {
    if (!term) return value || [];
    let filter = (item, keys, idx = 0) => {
      let result = false;
      if (!item || item.isGroup) return result;
      if (keys) {
        let key = keys.split('.')[idx];
        if (item.hasOwnProperty(key)) {
          if (keys.split('.')[idx + 1]) {
            result = filter(item[key], keys, idx + 1);
          } else {
            result = item[key] && item[key].toLowerCase().indexOf(term.toLowerCase()) !== -1;
          }
        }
      } else {
        result = item.toLowerCase().indexOf(term.toLowerCase()) !== -1;
      }
      return result;
    };
    return (value || []).filter(item => filter(item, keys));
  }
  select(item, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (item.disabled) {
      return;
    }
    if (!this.states().parentSelectable && item.children?.length) {
      this.next(item, event);
      return;
    }
    this.updateSelection(item);
  }
  updateSelection(item) {
    const currentSelects = this.selects();
    const itemIndex = currentSelects.findIndex(s => s.id === item.id);
    if (itemIndex > -1) {
      // Item is already selected, remove it
      this.selects.update(selects => selects.filter(s => s.id !== item.id));
      this.emitSelects();
    } else {
      // Item is not selected, add it
      if (this.states().multiple && !item.isExclusiveSelect) {
        this.selects.update(selects => {
          const newSelects = selects.filter(item => !item.isExclusiveSelect);
          return [...newSelects, item];
        });
        this.emitSelects();
      } else {
        this.selects.set([item]);
        this.emitSelects();
        this.states.update(state => ({
          ...state,
          search: this.getItemLabel(item)
        }));
      }
    }
    if (!this.states().multiple) {
      this.resetActivedescendant();
    }
  }
  async next(item, event) {
    if (!item?.children?.length) {
      return;
    }
    this.treeSelection.update(selection => [...selection, {
      key: item.id,
      label: this.getItemLabel(item),
      type: 'click'
    }]);
    this.changeSearchTextForFocusShift();
    if (event instanceof KeyboardEvent) {
      await this.waitForListTemplateUpdate();
      this.setActivedescendant(0);
    }
    this.emitNavigation('forward', event);
  }
  async back(event) {
    // If back is triggered from the root level
    const _this = this;
    const fromTreeLevel = _.last(this.treeSelection());
    if (!fromTreeLevel) {
      this.emitNavigation('backwardFromRoot', event);
      return;
    }
    const parentId = fromTreeLevel.key;
    // Navigate up one level in the tree hierarchy
    this.treeSelection.update(selection => {
      return selection.slice(0, -1);
    });
    this.changeSearchTextForFocusShift();
    const toTreeLevel = _.last(this.treeSelection());
    // Clear the search term if returning to the root level after viewing search results.
    if (!toTreeLevel && fromTreeLevel.type === 'search') {
      this.clearSearch(false);
    }
    // If the level navigating back to is a search results level, re-apply that search text
    if (toTreeLevel && toTreeLevel.type === 'search') {
      this._search.set(this.treeSelection()[this.treeSelection().length - 1].key);
    }
    // Focus a parent item it navigated up from.
    await this.waitForListTemplateUpdate();
    const parentItemIndex = this.flattedItemsAtCurrentLevel.findIndex(item => item.id === parentId);
    if (event instanceof KeyboardEvent) {
      this.setActivedescendant(parentItemIndex < 0 ? 0 : parentItemIndex);
    } else {
      const parentItemElement = this.cdkListKeyManager?._items.toArray()[parentItemIndex].element;
      parentItemElement?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
    this.emitNavigation('backward', event);
  }
  changeSearchTextForFocusShift() {
    if (this.config.multiple) {
      this._search.set('');
    } else if (this.selects()[0] && this._search() !== this.selects()[0].display) {
      this._search.set(this.selects()[0].display);
    } else if (_.isEmpty(this.selects())) {
      this._search.set('');
    }
  }
  clearSearch(resetList = true) {
    this._search.set('');
    this.states.update(state => ({
      ...state,
      search: ''
    }));
    if (resetList) {
      this.resetToRootItems();
    }
    this.searchChanged.emit('');
  }
  resetToRootItems(resetActivedescendant = true) {
    this.treeSelection.set([]);
    if (resetActivedescendant) {
      this.resetActivedescendant();
    }
    this.emitNavigation('root');
  }
  getSelectedTreeItems(selects, items) {
    let result;
    if (selects[0].type === 'search') {
      result = selects[0].data;
    } else {
      let index = 0;
      while (index < items.length && !result?.length) {
        const item = items[index];
        if (item.isGroup) {
          result = item.children.find(ci => ci.id === selects[0].key)?.children || [];
        } else if (item.id === selects[0].key) {
          result = item.children || [];
        }
        index++;
      }
    }
    return _.isUndefined(selects[1]) ? result : this.getSelectedTreeItems(_.drop(selects), result);
  }
  updateItemsForLevel(selection) {
    if (selection.length === 0) {
      this.resetToRootItems(true);
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      let items = selection[selection.length - 1].type === 'search' ? selection[selection.length - 1].data : this.getSelectedTreeItems(selection, this._items);
      this.setListItems(items);
      this.ngZone.run(() => {
        this.cdr.detectChanges();
      });
    });
  }
  getItemsAtCurrentLevel(dataArray = this.items()) {
    return dataArray.flatMap(topLevelObj => {
      if (topLevelObj.isGroup) {
        return topLevelObj.children?.length ? topLevelObj.children : [];
      } else {
        return topLevelObj;
      }
    });
  }
  focusToFirstItem() {
    this.setActivedescendant(0);
  }
  setActivedescendant(index) {
    if (!this.items().length) {
      if (this.headerElement?.nativeElement) {
        const focusableElements = getKeyboardFocusableElements(this.headerElement.nativeElement);
        focusableElements?.[0].focus();
      }
      return;
    }
    this.cdkListKeyManager.setActiveItem(index);
    this.cdr.detectChanges();
    this.states.update(state => ({
      ...state,
      activedescendant: index
    }));
    if (index > -1) {
      // Focus to item forcibly if loose a focus handler
      setTimeout(() => {
        if (!this.elementRef.nativeElement.contains(document.activeElement)) {
          const focusableElement = this.cdkListKeyManager?._items.toArray()[index]?.element;
          focusableElement?.focus();
        }
      }, 5);
    }
  }
  async waitForListTemplateUpdate() {
    return new Promise(resolve => {
      this.listItems.changes.pipe(take(1)).subscribe(() => {
        resolve();
      });
    });
  }
  resetActivedescendant(autoSelectFirstItem = false) {
    this.setActivedescendant(autoSelectFirstItem ? 0 : -1);
  }
  emitNavigation(type, event) {
    this.navigationChanged.emit({
      type,
      currentLevel: this.treeSelection().filter(tree => tree.type === 'click').length,
      items: this.items(),
      treeSelection: this.treeSelection(),
      event: event ?? undefined
    });
  }
  resize() {
    if (this.config.templateType === 'janus') {
      const breakpoint = getCurrentCssVariableBreakpoint('janus');
      const isMobileView = ['xs'].includes(breakpoint);
      this.states.update(state => ({
        ...state,
        mobileView: isMobileView,
        mobileUI: this.config.forceMobileUI ?? isMobileView
      }));
    }
  }
  isSelectedItem(item) {
    return this.selectedItemsMap().get(item.id) || false;
  }
  getElements() {
    return {
      list: this.listElement?.nativeElement,
      header: this.headerElement?.nativeElement,
      items: this.listItems?.toArray()
    };
  }
  listItemKeyDownEvent(e) {
    const activeItem = this.cdkListKeyManager.activeItem?.value;
    const actions = {
      ArrowLeft: () => {
        const isRTL = this.states().isRTL;
        isRTL ? this.next(activeItem, e) : this.back(e);
      },
      ArrowRight: () => {
        const isRTL = this.states().isRTL;
        isRTL ? this.back(e) : this.next(activeItem, e);
      },
      Enter: () => this.select(activeItem, e),
      Space: () => this.select(activeItem, e),
      Escape: () => this.emitNavigation('escape', e),
      Tab: () => {
        if (!this.states().mobileUI) {
          this.emitNavigation('tab', e);
        }
      }
    };
    if (actions[e.key]) {
      actions[e.key]();
    }
  }
  addHierarchicalPath(items, treeKey = 'treeRoute', labelOnly = true, parent) {
    let _items = items;
    return _items.map(item => {
      if (!item.hasOwnProperty(treeKey)) {
        item[treeKey] = [];
      }
      if (parent && !item[treeKey].length) {
        item[treeKey] = [...parent[treeKey], labelOnly ? this.getItemLabel(parent) : parent];
      }
      if (item.children?.length) {
        item.children = this.addHierarchicalPath(item.children, treeKey, labelOnly, item.isGroup ? parent : item);
      }
      return item;
    });
  }
  getItemLabel(item) {
    return item[this.getKeyForLabel(item)];
  }
  getKeyForLabel(item) {
    return item.hasOwnProperty('display') ? 'display' : 'value';
  }
  findItem(items = [], key, value) {
    const currentLevel = items.filter(i => Array.isArray(value) ? value.includes(i[key]) : i[key] === value);
    const childrenLevel = items.flatMap(i => i.children ? this.findItem(i.children, key, value) : []);
    return [...currentLevel, ...childrenLevel];
  }
  showSearchField() {
    const viewable = this.config.showSearchFieldOnDesktop || this.states().mobileUI;
    return !this.config.hideSearchField && viewable && !this.isNavigatingSubTrees;
  }
  getTemplateToUse() {
    return this.customTemplateRef || (this.config.templateType === 'janus' ? this.janusTemplate : this.defaultTemplate);
  }
  onStatesUpdate(states) {
    this.trapEnabled = !!states?.mobileView;
  }
  onTreeSelectionUpdate(treeSelection) {
    this.isSearching = treeSelection.length && treeSelection[treeSelection.length - 1].type === 'search';
    this.isNavigatingSubTrees = treeSelection.length && treeSelection[treeSelection.length - 1].type === 'click';
    const lastTreeSelection = _.last(treeSelection);
    this.navTitle = lastTreeSelection && lastTreeSelection.type === 'click' ? lastTreeSelection.label : this.config.defaultLabel ?? '';
    this.listTreeLevel = treeSelection.filter(tree => tree.type !== 'search').length;
  }
  getListAriaLabel() {
    let ariaLabel = null;
    if (this.treeSelection().length) {
      const last = _.last(this.treeSelection());
      if (last.type === 'search') {
        ariaLabel = `${this.translate.instant('misc.Search')}: ${last.label}`;
      } else {
        ariaLabel = last.label;
      }
      return ariaLabel;
    }
  }
  emitSelects(newVal = this.selects()) {
    this.selection.emit(newVal);
  }
  emitSearchKeyEvent(event) {
    this.searchKeyEvent.emit({
      value: this._search(),
      event: event
    });
  }
  static {
    this.ɵfac = function hierarchicalListWidgetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || hierarchicalListWidgetComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(SearchTextPipe$1), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: hierarchicalListWidgetComponent,
      selectors: [["hierarchical-list-widget"]],
      viewQuery: function hierarchicalListWidgetComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$1A, 7);
          i0.ɵɵviewQuery(_c1$1h, 7);
          i0.ɵɵviewQuery(_c2$X, 5, ViewContainerRef);
          i0.ɵɵviewQuery(_c3$F, 5);
          i0.ɵɵviewQuery(_c4$w, 5);
          i0.ɵɵviewQuery(_c5$m, 5);
          i0.ɵɵviewQuery(CdkListbox, 5);
          i0.ɵɵviewQuery(_c6$g, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.janusTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dynamicTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listElement = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElement = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchField = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cdkListbox = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listItems = _t);
        }
      },
      hostVars: 1,
      hostBindings: function hierarchicalListWidgetComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("resize", function hierarchicalListWidgetComponent_resize_HostBindingHandler($event) {
            return ctx.resize($event);
          }, false, i0.ɵɵresolveWindow);
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("cdkTrapFocus", ctx.trapEnabled);
        }
      },
      inputs: {
        config: "config",
        list: "list",
        search: "search",
        values: "values",
        assetsPath: "assetsPath",
        customTemplateRef: "customTemplateRef"
      },
      outputs: {
        selection: "selection",
        navigationChanged: "navigationChanged",
        searchChanged: "searchChanged",
        statesChanged: "statesChanged",
        searchKeyEvent: "searchKeyEvent"
      },
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: i3.CdkTrapFocus,
        inputs: ["cdkTrapFocusAutoCapture", "autoCapture", "cdkTrapFocus", "enabled"]
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 9,
      vars: 1,
      consts: [["defaultTemplate", ""], ["janusTemplate", ""], ["defaultListItemDirectiveTemplate", ""], ["janusListItemDirectiveTemplate", ""], ["container", ""], ["header", ""], ["list", "", "listbox", "cdkListbox"], ["listItem", ""], ["searchField", ""], ["list", ""], ["listbox", "cdkListbox"], ["inputField", ""], [4, "ngTemplateOutlet"], [1, "dropdown-nav"], ["role", "tree", "cdkListbox", "", 1, "picklist-item-list", 3, "cdkListboxMultiple"], ["role", "alert", 1, "empty-state"], ["type", "button", 1, "nav-button", 3, "click"], ["aria-hidden", "true", 1, "icn-chevron_left"], [1, "nav-title"], ["role", "tree", "cdkListbox", "", 1, "picklist-item-list", 3, "focusin", "focusout", "keydown", "cdkListboxMultiple"], [4, "ngFor", "ngForOf"], ["hierarchical-list-item", "", 1, "picklist-item", "flexbox", 3, "cdkOption", "item", "level", "isSelected", "config", "itemTemplate", "ngClass"], ["hierarchical-list-item", "", 1, "picklist-item", "flexbox", 3, "click", "cdkOption", "item", "level", "isSelected", "config", "itemTemplate", "ngClass"], [1, "position-sticky", "top-0", "bg-white", 2, "z-index", "1", 3, "id"], [1, "d-flex", "justify-content-between", "align-items-center", "mb-0", "ps-3", "border-bottom", "border-light"], [1, "position-relative", "d-flex", "align-items-center", "p-2"], [1, "position-relative"], ["role", "alert", 1, "px-3", "py-2", "text-gray-600", "fs-5"], ["type", "button", "tabindex", "-1", 1, "border-0", "bg-transparent", "px-3", "py-6", "ms-n3", 3, "click", "ngClass"], [1, "d-flex", "ms-n2"], ["width", "1.25rem", "height", "1.25rem"], [1, "w-100", "fw-semibold", "py-6", 3, "ngClass"], ["type", "button", 1, "bg-transparent", "border-0", "px-3", "py-6", 3, "click"], [1, "d-inline-flex", "align-items-center", "text-muted", "position-absolute", "ms-6"], ["width", "1rem", "height", "1rem", "focusable", "false", 1, "filter-remove"], ["type", "search", 1, "form-control", "w-100", "px-9", 3, "ngModelChange", "keypress", "ngModel", "placeholder"], ["type", "button", "tabindex", "-1", 1, "position-absolute", "bg-transparent", "text-muted", "border-0", "end-0", "px-1", "me-4"], ["type", "button", "tabindex", "-1", 1, "position-absolute", "bg-transparent", "text-muted", "border-0", "end-0", "px-1", "me-4", 3, "mousedown", "keydown.enter", "keydown.space"], [1, "d-flex", "align-items-center"], ["role", "tree", "cdkListbox", "", 1, "picklist-item-list", "list-children", "list-unstyled", "mb-0", "overflow-auto", 3, "focusin", "focusout", "keydown", "id", "cdkListboxMultiple"], ["role", "presentation", 1, "d-block", "picklist-item"], ["hierarchical-list-item", "", 1, "picklist-item", "d-flex", "dropdown-item", "px-0", "py-0", 3, "cdkOption", "item", "level", "config", "itemTemplate", "ngClass"], [1, "text-gray-600", "fs-6", "fw-semibold", "px-2", "py-2"], [1, "m-0", "p-0", "list-unstyled", "hp-group-list"], ["hierarchical-list-item", "", 1, "picklist-item", "d-flex", "dropdown-item", "px-0", "py-0", 3, "click", "cdkOption", "item", "level", "config", "itemTemplate", "ngClass"], ["type", "checkbox", 3, "checked", "id", "pointer-events"], [1, "picklist-item-label-wrapper"], [1, "picklist-item-label", 3, "for", "innerHTML"], [1, "xs-text"], [1, "align-items-start"], ["type", "checkbox", 3, "checked", "id"], ["type", "button", "tabindex", "-1", "aria-hidden", "true", 1, "nav-button", 3, "click", "ngClass", "disabled"], ["aria-hidden", "true", 1, "icn-chevron_right"], [1, "w-100", "d-flex", "px-2", "py-1"], [1, "list-group-item", "text-truncate-2", "text-break", "border-0", "p-0", "bg-transparent", "text-wrap", 3, "for", "innerHTML", "title"], [1, "text-muted", "fs-5"], ["type", "checkbox", "tabindex", "-1", 1, "form-check-input", "me-2", "pe-none", 3, "id", "checked", "disabled"], ["type", "button", "tabindex", "-1", "aria-hidden", "true", 1, "btn", "next-button", "py-0", "px-2", "rounded-0"], [1, "d-flex", "py-0", "px-2"], ["type", "button", "tabindex", "-1", "aria-hidden", "true", 1, "btn", "next-button", "py-0", "px-2", "rounded-0", 3, "click"], ["aria-hidden", "true", 1, "d-flex", "align-items-center", "text-black-50"]],
      template: function hierarchicalListWidgetComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, hierarchicalListWidgetComponent_ng_container_0_Template, 2, 0, "ng-container", 12)(1, hierarchicalListWidgetComponent_ng_template_1_Template, 3, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, hierarchicalListWidgetComponent_ng_template_3_Template, 6, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, hierarchicalListWidgetComponent_ng_template_5_Template, 8, 9, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(7, hierarchicalListWidgetComponent_ng_template_7_Template, 8, 11, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngTemplateOutlet", ctx.getTemplateToUse());
        }
      },
      dependencies: [CommonModule, i1.NgClass, i1.NgForOf, i1.NgTemplateOutlet, FormsModule, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, TranslateModule, i1$1.TranslatePipe, HighlightSearchPipe, ScrollingModule, hierarchicalListItemDirective, CdkListbox, CdkOption, A11yModule],
      styles: ["input[type=search][_ngcontent-%COMP%]::-webkit-search-decoration, input[type=search][_ngcontent-%COMP%]::-webkit-search-cancel-button, input[type=search][_ngcontent-%COMP%]::-webkit-search-results-button, input[type=search][_ngcontent-%COMP%]::-webkit-search-results-decoration{-webkit-appearance:none}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(hierarchicalListWidgetComponent, [{
    type: Component,
    args: [{
      selector: 'hierarchical-list-widget',
      imports: [CommonModule, FormsModule, TranslateModule, HighlightSearchPipe, ScrollingModule, hierarchicalListItemDirective, CommonModule, CdkListbox, CdkOption, A11yModule],
      hostDirectives: [{
        directive: CdkTrapFocus,
        inputs: ['cdkTrapFocusAutoCapture: autoCapture', 'cdkTrapFocus: enabled']
      }],
      standalone: true,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<ng-container #container *ngTemplateOutlet=\"getTemplateToUse()\"></ng-container>\n\n<ng-template #defaultTemplate>\n    @if (isNavigatingSubTrees) {\n        <div class=\"dropdown-nav\" #header>\n            <button type=\"button\" class=\"nav-button\" (click)=\"back($event)\" [attr.aria-label]=\"'misc.Previous' | translate\">\n                <span class=\"icn-chevron_left\" aria-hidden=\"true\"></span>\n            </button>\n            <div [attr.id]=\"config.id + '-level-title'\" class=\"nav-title\">{{ navTitle }}</div>\n            <div></div>\n        </div>\n    }\n\n    @if (items()?.length) {\n            <ul #list\n                class=\"picklist-item-list\"\n                [attr.id]=\"config.id + '-list'\"\n                [attr.aria-multiselectable]=\"config.multiple\"\n                [attr.aria-labelledby]=\"config.id + '-level-title'\"\n                [attr.tabindex]=\"-1\"\n                role=\"tree\"\n                (focusin)=\"isFocused = true\"\n                (focusout)=\"isFocused = false\"\n\n                cdkListbox\n                [cdkListboxMultiple]=\"!!config.multiple\"\n                (keydown)=\"listItemKeyDownEvent($event)\"\n                #listbox=\"cdkListbox\"\n            >\n                <ng-container *ngFor=\"let item of items();\">\n                    @if (item.isGroup && item.children?.length) {\n                        <ng-container *ngFor=\"let groupItem of item.children\">\n                            <li hierarchical-list-item\n                                #listItem\n                                class=\"picklist-item flexbox\"\n                                [cdkOption]=\"groupItem\"\n                                [item]=\"groupItem\"\n                                [level]=\"listTreeLevel\"\n                                [isSelected]=\"isSelectedItem(groupItem)\"\n                                [config]=\"config\"\n                                [itemTemplate]=\"defaultListItemDirectiveTemplate\"\n                                [ngClass]=\"(isFocused && groupItem.id === cdkListKeyManager?.activeItem?.value?.id)\n                            ? {'active': true}\n                            : (isSelectedItem(groupItem) ? {'selected': true} : {})\"\n                                (click)=\"select(groupItem, $event)\"\n                            ></li>\n                        </ng-container>\n                    } @else {\n                        <li hierarchical-list-item\n                            #listItem\n                            class=\"picklist-item flexbox\"\n                            [cdkOption]=\"item\"\n                            [item]=\"item\"\n                            [level]=\"listTreeLevel\"\n                            [isSelected]=\"isSelectedItem(item)\"\n                            [config]=\"config\"\n                            [itemTemplate]=\"defaultListItemDirectiveTemplate\"\n                            [ngClass]=\"(isFocused && item.id === cdkListKeyManager?.activeItem?.value?.id)\n                            ? {'active': true}\n                            : (isSelectedItem(item) ? {'selected': true} : {})\"\n                            (click)=\"select(item, $event)\"\n                        ></li>\n                    }\n                </ng-container>\n            </ul>\n    } @else if (!isWaitingListUpdate && ((config.multiple) || (!config.multiple && isSearching))) {\n        <div class=\"empty-state\" role=\"alert\">{{ 'misc.No results found' | translate }}</div>\n    }\n</ng-template>\n\n<ng-template #janusTemplate>\n    \n    <div id=\"{{config.id}}-dropdown-nav\" #header class=\"position-sticky top-0 bg-white\" style=\"z-index: 1\">\n        @if (isNavigatingSubTrees || states().mobileView) {\n            <nav #header class=\"d-flex justify-content-between align-items-center mb-0 ps-3 border-bottom border-light\">\n                <button type=\"button\"\n                        class=\"border-0 bg-transparent px-3 py-6 ms-n3\"\n                        [ngClass]=\"{'py-md-10': states().mobileUI, 'd-none': !isNavigatingSubTrees}\"\n                        [attr.aria-label]=\"'misc.Previous' | translate\"\n                        (click)=\"back($event)\"\n                        tabindex=\"-1\"\n                >\n                    <span class=\"d-flex ms-n2\">\n                        <svg width=\"1.25rem\" height=\"1.25rem\">\n                            <use [attr.href]=\"assetsPath + 'tabler-sprite.svg#tabler-chevron-left'\"></use>\n                        </svg>\n                    </span>\n                </button>\n\n                <span class=\"w-100 fw-semibold py-6\" \n                      [ngClass]=\"{'text-md-center': states().mobileUI}\"\n                      [attr.id]=\"config.id + '-level-title'\"\n                >{{ navTitle }}</span>\n\n                <button type=\"button\"\n                        class=\"bg-transparent border-0 px-3 py-6\"\n                        [class.py-md-10]=\"states().mobileUI\"\n                        [class.invisible]=\"!states().mobileView\"\n                        [attr.aria-label]=\"'misc.Close' | translate\"\n                        (click)=\"emitNavigation('close', $event)\"\n                >\n                    <span class=\"d-flex ms-n2\">\n                        <svg width=\"1.25rem\" height=\"1.25rem\">\n                            <use [attr.href]=\"assetsPath + 'tabler-sprite.svg#tabler-x'\"></use>\n                        </svg>\n                    </span>\n                </button>\n            </nav>\n        }\n        \n        @if (showSearchField()) {\n            <div class=\"position-relative d-flex align-items-center p-2\">\n                <span class=\"d-inline-flex align-items-center text-muted position-absolute ms-6\">\n                    <svg width=\"1rem\" height=\"1rem\" class=\"filter-remove\" focusable=\"false\">\n                        <use [attr.href]=\"assetsPath + 'tabler-sprite.svg#tabler-search'\"></use>\n                    </svg>\n                </span>\n                <input  #searchField\n                        type=\"search\"\n                        class=\"form-control w-100 px-9\"\n                        [ngModel]=\"_search()\"\n                        (ngModelChange)=\"debounceFn($event, searchItems)\"\n                        (keypress)=\"debounceFn($event, emitSearchKeyEvent)\"\n                        [placeholder]=\"config.placeholder ?? ('misc.Search' | translate)\"\n                        [attr.aria-autocomplete]=\"'list'\"\n                        [attr.aria-expanded]=\"true\"\n                        [attr.aria-owns]=\"config.id + '-list'\"\n                        [attr.role]=\"'combobox'\"\n                        [attr.aria-label]=\"'misc.Search Text' | translate\"\n                />\n                @if (_search()) {\n                    <button type=\"button\"\n                            class=\"position-absolute bg-transparent text-muted border-0 end-0 px-1 me-4\"\n                            tabindex=\"-1\"\n                            [attr.aria-label]=\"'misc.Clear' | translate\"\n                            (mousedown)=\"$event.stopPropagation(); clearSearch();\"\n                            (keydown.enter)=\"clearSearch();\"\n                            (keydown.space)=\"clearSearch();\"\n                    >\n                        <span class=\"d-flex align-items-center\">\n                            <svg width=\"1rem\" height=\"1rem\" class=\"filter-remove\" focusable=\"false\">\n                                <use [attr.href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-x'\"></use>\n                            </svg>\n                        </span>\n                    </button>\n                }\n            </div>\n        }\n    </div>\n\n    @if (items()?.length) {\n        <div #list class=\"position-relative\">\n            <ul id=\"{{config.id}}-list\"\n                [attr.aria-labelledby]=\"config.id + '-level-title'\"\n                [attr.tabindex]=\"states().mobileUI ? '0' : '-1'\"\n                (focusin)=\"isFocused = true\"\n                (focusout)=\"isFocused = false\"\n                role=\"tree\"\n                class=\"picklist-item-list list-children list-unstyled mb-0 overflow-auto\"\n\n                cdkListbox\n                [cdkListboxMultiple]=\"!!config.multiple\"\n                (keydown)=\"listItemKeyDownEvent($event)\"\n                #listbox=\"cdkListbox\"\n                [attr.aria-label]=\"this.getListAriaLabel()\"\n            >\n                <ng-container *ngFor=\"let item of items();\">\n                    @if (item.isGroup) {\n                        <li class=\"d-block picklist-item\" role=\"presentation\">\n                            <div class=\"text-gray-600 fs-6 fw-semibold px-2 py-2\">{{ item.display }}</div>\n                            <ul class=\"m-0 p-0 list-unstyled hp-group-list\" [attr.aria-label]=\"item.display\">\n                                <ng-container *ngFor=\"let groupItem of item.children\">\n                                    <li hierarchical-list-item\n                                        #listItem\n                                        [cdkOption]=\"groupItem\"\n                                        class=\"picklist-item d-flex dropdown-item px-0 py-0\"\n                                        [item]=\"groupItem\"\n                                        [level]=\"listTreeLevel\"\n                                        [config]=\"config\"\n                                        [itemTemplate]=\"janusListItemDirectiveTemplate\"\n                                        [ngClass]=\"isSelectedItem(groupItem) ? {'bg-primary': true, 'bg-opacity-10': true } : null\"\n                                        (click)=\"select(groupItem, $event)\"\n                                    ></li>\n                                </ng-container>\n                            </ul>\n                        </li>\n                    } @else {\n                        <li hierarchical-list-item\n                            #listItem\n                            [cdkOption]=\"item\"\n                            class=\"picklist-item d-flex dropdown-item px-0 py-0\"\n                            [item]=\"item\"\n                            [level]=\"listTreeLevel\"\n                            [config]=\"config\"\n                            [itemTemplate]=\"janusListItemDirectiveTemplate\"\n                            [ngClass]=\"isSelectedItem(item) ? {'bg-primary': true, 'bg-opacity-10': true } : null\"\n                            (click)=\"select(item, $event)\"\n                        ></li>\n                    }\n                </ng-container>\n            </ul>\n        </div>\n    } @else if (!(config.externalSearch && !isSearching)) {\n        <div class=\"px-3 py-2 text-gray-600 fs-5\" role=\"alert\">{{ 'misc.No results found' | translate }}</div>\n    }\n</ng-template>\n\n<ng-template #defaultListItemDirectiveTemplate let-item=\"item\" let-idPrefix=\"idPrefix\">\n    <div>\n        @if (isCheckboxAvailable) {\n            <input\n                    type=\"checkbox\"\n                    #inputField\n                    [checked]=\"isSelectedItem(item)\"\n                    id=\"{{ idPrefix + '-checkbox' }}\"\n                    [attr.tabindex]=\"-1\"\n                    [style.pointer-events]=\"'none'\"\n            >\n        }\n    </div>\n    <div class=\"picklist-item-label-wrapper\">\n        <label\n                class=\"picklist-item-label\"\n                for=\"{{ idPrefix + '-checkbox' }}\"\n                [innerHTML]=\"getItemLabel(item) | highlight: _search()\"\n        ></label>\n        \n        @if (item.extraLabels?.length) {\n            <ng-container *ngFor=\"let extraLabel of item.extraLabels\">\n                <div class=\"xs-text\">{{ extraLabel }}</div>\n            </ng-container>\n        }\n        \n        @if (isSearching && item.treeRoute) {\n            <div class=\"xs-text\">\n                @for (treeLabel of item.treeRoute; track treeLabel; let i = $index; let last = $last) {\n                    {{ treeLabel }} @if (!last) { > }\n                }\n            </div>\n        }\n    </div>\n    @if (item.children?.length) {\n        <div class=\"align-items-start\">\n            <button type=\"button\"\n                    class=\"nav-button\"\n                    [ngClass]=\"{'hoverable': config.parentSelectable}\"\n                    (click)=\"$event.stopPropagation(); next(item, $event)\"\n                    [disabled]=\"!config.parentSelectable\"\n                    tabindex=\"-1\"\n                    aria-hidden=\"true\">\n                <i class=\"icn-chevron_right\" aria-hidden=\"true\"></i>\n            </button>\n        </div>\n    }\n</ng-template>\n\n<ng-template #janusListItemDirectiveTemplate let-item=\"item\" let-idPrefix=\"idPrefix\">\n    <span class=\"w-100 d-flex px-2 py-1\">\n        @if (isCheckboxAvailable) {\n            <span>\n                <input class=\"form-check-input me-2 pe-none\"\n                       type=\"checkbox\"\n                       id=\"{{ idPrefix }}-checkbox\"\n                       tabindex=\"-1\"\n                       [checked]=\"isSelectedItem(item)\"\n                       [disabled]=\"!!item.disabled || null\"\n                >\n            </span>\n        }\n        <span>\n            <label class=\"list-group-item text-truncate-2 text-break border-0 p-0 bg-transparent text-wrap\"\n                   for=\"{{ idPrefix }}-checkbox\"\n                   [innerHTML]=\"getItemLabel(item) | highlight: _search()\"\n                   title=\"{{ getItemLabel(item) }}\"\n            ></label>\n            \n            @if (item.extraLabels?.length) {\n                <ng-container *ngFor=\"let extraLabel of item.extraLabels\">\n                    <div class=\"text-muted fs-5\">{{ extraLabel }}</div>\n                </ng-container>\n            }\n\n            @if (isSearching && item.treeRoute) {\n                <div class=\"text-muted fs-5\">\n                    @for (treeLabel of item.treeRoute; track treeLabel; let i = $index; let last = $last) {\n                        {{ treeLabel }} @if (!last) { > }\n                    }\n                </div>\n            }\n        </span>\n    </span>\n    @if (item.children?.length) {\n        @if (config.parentSelectable) {\n            <button type=\"button\"\n                    class=\"btn next-button py-0 px-2 rounded-0\"\n                    (click)=\"$event.stopPropagation(); next(item, $event)\"\n                    tabindex=\"-1\"\n                    aria-hidden=\"true\">\n                <span class=\"d-flex align-items-center text-black-50\" aria-hidden=\"true\">\n                    <svg width=\"1.25rem\" height=\"1.25rem\">\n                        <use [attr.href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-chevron-right'\"></use>\n                    </svg>\n                </span>\n            </button>\n        } @else {\n            <div class=\"d-flex py-0 px-2\">\n                <span class=\"d-flex align-items-center text-black-50\" aria-hidden=\"true\">\n                    <svg width=\"1.25rem\" height=\"1.25rem\">\n                        <use [attr.href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-chevron-right'\"></use>\n                    </svg>\n                </span>\n            </div>\n        }\n    }\n</ng-template>",
      styles: ["input[type=search]::-webkit-search-decoration,input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-results-button,input[type=search]::-webkit-search-results-decoration{-webkit-appearance:none}\n"]
    }]
  }], () => [{
    type: i0.NgZone
  }, {
    type: SearchTextPipe$1
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.ElementRef
  }, {
    type: i1$1.TranslateService
  }], {
    config: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    list: [{
      type: Input
    }],
    search: [{
      type: Input
    }],
    values: [{
      type: Input
    }],
    assetsPath: [{
      type: Input
    }],
    customTemplateRef: [{
      type: Input
    }],
    selection: [{
      type: Output
    }],
    navigationChanged: [{
      type: Output
    }],
    searchChanged: [{
      type: Output
    }],
    statesChanged: [{
      type: Output
    }],
    searchKeyEvent: [{
      type: Output
    }],
    listItems: [{
      type: ViewChildren,
      args: ['listItem']
    }],
    defaultTemplate: [{
      type: ViewChild,
      args: ['defaultTemplate', {
        static: true
      }]
    }],
    janusTemplate: [{
      type: ViewChild,
      args: ['janusTemplate', {
        static: true
      }]
    }],
    dynamicTemplate: [{
      type: ViewChild,
      args: ['dynamicTemplate', {
        read: ViewContainerRef
      }]
    }],
    listElement: [{
      type: ViewChild,
      args: ['list', {
        static: false
      }]
    }],
    headerElement: [{
      type: ViewChild,
      args: ['header', {
        static: false
      }]
    }],
    searchField: [{
      type: ViewChild,
      args: ['searchField', {
        static: false
      }]
    }],
    cdkListbox: [{
      type: ViewChild,
      args: [CdkListbox]
    }],
    trapEnabled: [{
      type: HostBinding,
      args: ['cdkTrapFocus']
    }],
    resize: [{
      type: HostListener,
      args: ['window:resize', ['$event']]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(hierarchicalListWidgetComponent, {
    className: "hierarchicalListWidgetComponent",
    filePath: "common/hierarchical-list-widget.component.ts",
    lineNumber: 155
  });
})();
class ReadMoreDirective {
  constructor(el, translate) {
    this.el = el;
    this.translate = translate;
  }
  ngAfterViewInit() {
    this.truncateHtmlContent(this.el.nativeElement);
    let self = this;
    $$1(document).on('click', '.html-expand-toggle', function (e) {
      e.preventDefault();
      if (e.handled !== true) {
        // This will prevent event triggering more then once
        e.handled = true;
        self.handleTruncatedHtmlContent(this);
      }
    });
  }
  truncateHtmlContent(el) {
    var overflowText = '';
    var contentElem = this.getPreviousMatchingElement(el, '.html-expandable-content');
    for (var x = 0; x < contentElem.textContent.length; x++) {
      if (this.checkHtmlContentOverflow(contentElem)) {
        var text = contentElem.textContent;
        overflowText = text.slice(-1) + overflowText;
      } else {
        break;
      }
    }
    if (!overflowText) {
      contentElem.style.height = 'auto';
      el.parentNode.removeChild(el);
      var fadeOutElem = contentElem.querySelector('.fade-out-text');
      fadeOutElem.parentNode.removeChild(fadeOutElem);
    }
  }
  checkHtmlContentOverflow(el) {
    var curOverflow = el.style.overflow;
    if (!curOverflow || curOverflow === "visible") el.style.overflow = "hidden";
    var isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
    el.style.overflow = curOverflow;
    return isOverflowing;
  }
  handleTruncatedHtmlContent(el) {
    var contentElem = this.getPreviousMatchingElement(el, '.html-expandable-content');
    if (contentElem.style.height) {
      contentElem.style.height = '';
      if (contentElem.querySelector('.fade-out-text').classList) {
        contentElem.querySelector('.fade-out-text').classList.add('html-truncate-gradient');
      } else {
        contentElem.querySelector('.fade-out-text').className += ' ' + 'html-truncate-gradient';
      }
      el.textContent = this.translate.instant('misc.Read More') + '...';
    } else {
      contentElem.style.height = 'auto';
      if (contentElem.querySelector('.fade-out-text').classList) {
        contentElem.querySelector('.fade-out-text').classList.remove('html-truncate-gradient');
      } else {
        contentElem.querySelector('.fade-out-text').className = el.querySelector('.fade-out-text').className.replace(new RegExp('(^|\\b)' + contentElem.querySelector('.fade-out-text').className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
      }
      el.textContent = this.translate.instant('misc.Read Less');
    }
  }
  getPreviousMatchingElement(el, selector) {
    var sibling = el.previousElementSibling;
    if (!selector) {
      return sibling;
    }
    while (sibling) {
      if (sibling.matches) {
        if (sibling.matches(selector)) {
          return sibling;
        }
      } else if (sibling.msMatchesSelector) {
        if (sibling.msMatchesSelector(selector)) {
          return sibling;
        }
      }
      sibling = sibling.previousElementSibling;
    }
  }
  static {
    this.ɵfac = function ReadMoreDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReadMoreDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: ReadMoreDirective,
      selectors: [["", "htmlExpand", ""]],
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReadMoreDirective, [{
    type: Directive,
    args: [{
      selector: '[htmlExpand]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i1$1.TranslateService
  }], null);
})();

/*
    Observable wrapper
*/
function fromMutationObserver(element, options) {
  let observable = new Observable(subscriber => {
    let observer = new MutationObserver((entries, observer) => {
      subscriber.next(entries);
    });
    observer.observe(element, options);
    return function unsubscribe() {
      observer.disconnect();
    };
  });
  return observable;
}
class KeyboardTrapDirective {
  constructor(el) {
    this.el = el;
  }
  ngAfterViewInit() {
    this.refreshItems();
    this.mutationSubscription = fromMutationObserver(this.el.nativeElement, {
      subtree: true,
      childList: true
    }).pipe(debounceTime(100)).subscribe(e => {
      this.refreshItems();
    });
  }
  refreshItems() {
    const focusableElementsString = "a[href], button, input, textarea, select, details, [tabindex]:not([tabindex='-1'])";
    const focusableElements = [...this.el.nativeElement.querySelectorAll(focusableElementsString)].filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden') && el.checkVisibility());
    this.firstFocusableEl = focusableElements[0];
    this.lastFocusableEl = focusableElements[focusableElements.length - 1];
  }
  keydownHandler(e) {
    const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    if (!isTabPressed) return; // Stop if key is not "TAB"
    if (e.shiftKey) {
      if (document.activeElement === this.firstFocusableEl) {
        e.preventDefault();
        this.lastFocusableEl.focus();
      }
    } else {
      if (document.activeElement === this.lastFocusableEl) {
        e.preventDefault();
        this.firstFocusableEl.focus();
      }
    }
  }
  ngOnDestroy() {
    this.mutationSubscription && this.mutationSubscription.unsubscribe();
  }
  static {
    this.ɵfac = function KeyboardTrapDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || KeyboardTrapDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: KeyboardTrapDirective,
      selectors: [["", "keyboardTrap", ""]],
      hostBindings: function KeyboardTrapDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function KeyboardTrapDirective_keydown_HostBindingHandler($event) {
            return ctx.keydownHandler($event);
          });
        }
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(KeyboardTrapDirective, [{
    type: Directive,
    args: [{
      selector: '[keyboardTrap]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    keydownHandler: [{
      type: HostListener,
      args: ['keydown', ['$event']]
    }]
  });
})();
class DestroyEmitter extends ReplaySubject {
  constructor() {
    super(1);
  }
  ngOnDestroy() {
    this.next();
    this.complete();
  }
  static {
    this.ɵfac = function DestroyEmitter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DestroyEmitter)();
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: DestroyEmitter,
      factory: DestroyEmitter.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DestroyEmitter, [{
    type: Injectable
  }], () => [], null);
})();
class DragTableDirective {
  constructor(elementRef, destroyed$) {
    this.elementRef = elementRef;
    this.destroyed$ = destroyed$;
  }
  ngAfterViewInit() {
    let listMaincol = document.querySelector('.list-maincol');
    let listWrap = document.querySelector('.list-wrap');
    let listMaincolParent = listMaincol.parentElement;
    if ([listMaincol, listWrap, listMaincolParent].some(el => !el)) {
      return;
    }
    if (listMaincol.scrollWidth > listWrap.clientWidth) {
      listWrap.classList.add('vignette-right');
    }
    fromEvent(listMaincol, 'scroll').pipe(takeUntil(this.destroyed$), throttleTime(250, asyncScheduler, {
      leading: true,
      trailing: true
    })).subscribe(e => {
      if (listMaincol.scrollWidth - listMaincol.offsetWidth === listMaincol.scrollLeft) {
        listWrap.classList.remove('vignette-right');
        listMaincolParent.classList.add('vignette-left');
      }
      if (listMaincol.scrollLeft === 0) {
        listMaincolParent.classList.remove('vignette-left');
        listWrap.classList.add('vignette-right');
      }
      if (listMaincol.scrollLeft != 0 && listMaincol.scrollWidth - listMaincol.offsetWidth > listMaincol.scrollLeft) {
        listMaincol.classList.remove('vignette-left');
        listWrap.classList.add('vignette-right');
        listMaincolParent.classList.add('vignette-left');
      }
    });
    fromEvent(window, 'resize').pipe(takeUntil(this.destroyed$), throttleTime(250, asyncScheduler, {
      leading: true,
      trailing: true
    })).subscribe(e => {
      let maxScrollLeft = listMaincol.scrollWidth - listMaincol.clientWidth;
      if (listMaincol.scrollLeft == maxScrollLeft && listMaincol.scrollLeft != 0) {
        listWrap.classList.remove('vignette-right');
      } else if (listMaincol.scrollLeft == maxScrollLeft && listMaincol.scrollLeft === 0) {
        listWrap.classList.add('vignette-right');
        listMaincolParent.classList.add('vignette-left');
      } else if (listMaincol.scrollLeft == maxScrollLeft && listMaincol.scrollLeft != 0) {
        listWrap.classList.add('vignette-right');
      } else {
        listWrap.classList.add('vignette-right');
        listMaincolParent.classList.add('vignette-left');
      }
      if (listMaincol.scrollWidth > listMaincol.clientWidth) {
        if (listMaincol.scrollLeft === 0) {
          listMaincolParent.classList.remove('vignette-left');
          listWrap.classList.add('vignette-right');
        }
      } else {
        listMaincolParent.classList.remove('vignette-left');
        listWrap.classList.remove('vignette-right');
      }
    });
  }
  mousemove(e) {
    this.mx2 = e.pageX - this.elementRef.nativeElement.offsetLeft;
    if (this.mx) {
      this.elementRef.nativeElement.scrollLeft = this.sx + this.mx - this.mx2;
    }
  }
  mousedown(e) {
    this.sx = this.elementRef.nativeElement.scrollLeft;
    this.mx = e.pageX - this.elementRef.nativeElement.offsetLeft;
  }
  mouseup() {
    this.sx = this.elementRef.nativeElement.scrollLeft;
    this.mx = 0;
  }
  static {
    this.ɵfac = function DragTableDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DragTableDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(DestroyEmitter));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: DragTableDirective,
      selectors: [["", "dragTable", ""]],
      hostBindings: function DragTableDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mousemove", function DragTableDirective_mousemove_HostBindingHandler($event) {
            return ctx.mousemove($event);
          })("mousedown", function DragTableDirective_mousedown_HostBindingHandler($event) {
            return ctx.mousedown($event);
          })("mouseup", function DragTableDirective_mouseup_HostBindingHandler() {
            return ctx.mouseup();
          });
        }
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([DestroyEmitter])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DragTableDirective, [{
    type: Directive,
    args: [{
      selector: '[dragTable]',
      providers: [DestroyEmitter],
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: DestroyEmitter
  }], {
    mousemove: [{
      type: HostListener,
      args: ['mousemove', ['$event']]
    }],
    mousedown: [{
      type: HostListener,
      args: ['mousedown', ['$event']]
    }],
    mouseup: [{
      type: HostListener,
      args: ['mouseup']
    }]
  });
})();
class CallbackPipe {
  transform(items, callback) {
    if (!items || !callback) {
      return items;
    }
    return items.filter(item => callback(item));
  }
  static {
    this.ɵfac = function CallbackPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CallbackPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "callback",
      type: CallbackPipe,
      pure: false,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CallbackPipe, [{
    type: Pipe,
    args: [{
      name: 'callback',
      pure: false,
      standalone: false
    }]
  }], null, null);
})();
class FilterPipe {
  transform(items, filter) {
    return items.filter(item => {
      let notMatchingField = Object.keys(filter).find(key => item[key] !== filter[key]);
      return !notMatchingField; // true if matches all fields
    });
  }
  static {
    this.ɵfac = function FilterPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FilterPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "filter",
      type: FilterPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterPipe, [{
    type: Pipe,
    args: [{
      name: 'filter',
      standalone: false
    }]
  }], null, null);
})();
class KeysPipe {
  transform(value, args) {
    return Object.keys(value);
  }
  static {
    this.ɵfac = function KeysPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || KeysPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "keys",
      type: KeysPipe,
      pure: false,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(KeysPipe, [{
    type: Pipe,
    args: [{
      name: 'keys',
      pure: false,
      standalone: false
    }]
  }], null, null);
})();
class MonogramPipe {
  transform(value, args) {
    let initials = value.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
  }
  static {
    this.ɵfac = function MonogramPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MonogramPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "monogram",
      type: MonogramPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonogramPipe, [{
    type: Pipe,
    args: [{
      name: 'monogram',
      standalone: false
    }]
  }], null, null);
})();
class OrderByPipe {
  transform(records, args) {
    return records.sort(function (a, b) {
      if (a[args.property] < b[args.property]) {
        return -1 * args.direction;
      } else if (a[args.property] > b[args.property]) {
        return 1 * args.direction;
      } else {
        return 0;
      }
    });
  }
  static {
    this.ɵfac = function OrderByPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderByPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "orderBy",
      type: OrderByPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderByPipe, [{
    type: Pipe,
    args: [{
      name: 'orderBy',
      standalone: false
    }]
  }], null, null);
})();
class SanitizeHtmlPipe {
  constructor(_sanitizer) {
    this._sanitizer = _sanitizer;
  }
  transform(v) {
    return this._sanitizer.bypassSecurityTrustHtml(v);
  }
  static {
    this.ɵfac = function SanitizeHtmlPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SanitizeHtmlPipe)(i0.ɵɵdirectiveInject(i1$5.DomSanitizer, 16));
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "sanitizeInputHtml",
      type: SanitizeHtmlPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SanitizeHtmlPipe, [{
    type: Pipe,
    args: [{
      name: 'sanitizeInputHtml',
      standalone: false
    }]
  }], () => [{
    type: i1$5.DomSanitizer
  }], null);
})();
class StripUnderscorePipe {
  transform(input) {
    return input.replace(/_/g, ' ');
  }
  static {
    this.ɵfac = function StripUnderscorePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StripUnderscorePipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "strip_underscore",
      type: StripUnderscorePipe,
      pure: false,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StripUnderscorePipe, [{
    type: Pipe,
    args: [{
      name: 'strip_underscore',
      pure: false,
      standalone: false
    }]
  }], null, null);
})();
class TrueFalseValueDirective {
  constructor(elementRef, renderer) {
    this.elementRef = elementRef;
    this.renderer = renderer;
    this.propagateChange = _ => {};
    this.trueValue = true;
    this.falseValue = false;
  }
  onHostChange(ev) {
    this.propagateChange(ev.target.checked ? this.trueValue : this.falseValue);
  }
  writeValue(obj) {
    if (obj === this.trueValue) {
      this.renderer.setProperty(this.elementRef.nativeElement, 'checked', true);
    } else {
      this.renderer.setProperty(this.elementRef.nativeElement, 'checked', false);
    }
  }
  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn) {}
  setDisabledState(isDisabled) {}
  static {
    this.ɵfac = function TrueFalseValueDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TrueFalseValueDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: TrueFalseValueDirective,
      selectors: [["input", "type", "checkbox", "trueFalseValue", ""]],
      hostBindings: function TrueFalseValueDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("change", function TrueFalseValueDirective_change_HostBindingHandler($event) {
            return ctx.onHostChange($event);
          });
        }
      },
      inputs: {
        trueValue: "trueValue",
        falseValue: "falseValue"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TrueFalseValueDirective),
        multi: true
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrueFalseValueDirective, [{
    type: Directive,
    args: [{
      selector: 'input[type=checkbox][trueFalseValue]',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TrueFalseValueDirective),
        multi: true
      }],
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    trueValue: [{
      type: Input
    }],
    falseValue: [{
      type: Input
    }],
    onHostChange: [{
      type: HostListener,
      args: ['change', ['$event']]
    }]
  });
})();
class TruncateTextPipe {
  transform(value, args) {
    const limit = args.length > 0 ? parseInt(args[0], 10) : 20;
    const trail = args.length > 1 ? args[1] : '...';
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
  static {
    this.ɵfac = function TruncateTextPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TruncateTextPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "truncateText",
      type: TruncateTextPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TruncateTextPipe, [{
    type: Pipe,
    args: [{
      name: 'truncateText',
      standalone: false
    }]
  }], null, null);
})();
class ToastAlert {
  constructor(init) {
    Object.assign(this, init);
  }
}
var ToastAlertType;
(function (ToastAlertType) {
  ToastAlertType["Success"] = "success";
  ToastAlertType["SuccessBulb"] = "success-bulb";
  ToastAlertType["Error"] = "error";
  ToastAlertType["Info"] = "info";
  ToastAlertType["Warning"] = "warning";
  ToastAlertType["Neutral"] = "neutral";
})(ToastAlertType || (ToastAlertType = {}));
class ToastAlertService {
  constructor() {
    this.subject = new Subject();
  }
  getAlert() {
    return this.subject.asObservable();
  }
  success(message, timer = 4000, dismissable = false, title) {
    this.alert(new ToastAlert({
      message,
      timer: timer,
      dismissable: dismissable,
      title: title ? title : '',
      type: ToastAlertType.Success
    }));
  }
  error(message, timer = 4000, dismissable = false, title) {
    this.alert(new ToastAlert({
      message,
      timer: timer,
      dismissable: dismissable,
      title: title ? title : '',
      type: ToastAlertType.Error
    }));
  }
  info(message, timer = 4000, dismissable = false, title) {
    this.alert(new ToastAlert({
      message,
      timer: timer,
      dismissable: dismissable,
      title: title ? title : '',
      type: ToastAlertType.Info
    }));
  }
  warning(message, timer = 4000, dismissable = false, title) {
    this.alert(new ToastAlert({
      message,
      timer: timer,
      dismissable: dismissable,
      title: title ? title : '',
      type: ToastAlertType.Warning
    }));
  }
  neutral(message, timer = 4000, dismissable = false, title) {
    this.alert(new ToastAlert({
      message,
      timer: timer,
      dismissable: dismissable,
      title: title ? title : '',
      type: ToastAlertType.Neutral
    }));
  }
  action(message, timer = 4000, dismissable = false, type, config, title) {
    this.alert(new ToastAlert({
      message,
      timer: timer,
      dismissable: dismissable,
      title: title ? title : '',
      type: ToastAlertType[type],
      config
    }));
  }
  custom(message, timer = 4000, dismissable = false, type = ToastAlertType.Neutral, position, title = '') {
    this.alert(new ToastAlert({
      message,
      timer,
      dismissable,
      title,
      type,
      position
    }));
  }
  alert(alert) {
    this.subject.next(alert);
  }
  clear() {
    this.subject.next(new ToastAlert({}));
  }
  static {
    this.ɵfac = function ToastAlertService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastAlertService)();
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: ToastAlertService,
      factory: ToastAlertService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastAlertService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class SafeHtmlPipe {
  constructor(sanitized) {
    this.sanitized = sanitized;
  }
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
  static {
    this.ɵfac = function SafeHtmlPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SafeHtmlPipe)(i0.ɵɵdirectiveInject(i1$5.DomSanitizer, 16));
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "safeHtml",
      type: SafeHtmlPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafeHtmlPipe, [{
    type: Pipe,
    args: [{
      name: 'safeHtml',
      standalone: false
    }]
  }], () => [{
    type: i1$5.DomSanitizer
  }], null);
})();
function ToastAlertComponent_div_0_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const alert_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("", ctx_r1.alertIcon(alert_r1), " space-right-sm margin-right-sm");
  }
}
function ToastAlertComponent_div_0_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function ToastAlertComponent_div_0_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const alert_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.removeAlert(alert_r1));
    });
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵelementEnd();
  }
}
function ToastAlertComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div")(2, "div", 2);
    i0.ɵɵtemplate(3, ToastAlertComponent_div_0_i_3_Template, 1, 3, "i", 3);
    i0.ɵɵelement(4, "span", 4);
    i0.ɵɵpipe(5, "safeHtml");
    i0.ɵɵtemplate(6, ToastAlertComponent_div_0_button_6_Template, 2, 0, "button", 5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const alert_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("", ctx_r1.cssClass(alert_r1), " growl-item inline-block");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.alertIcon(alert_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(5, 6, alert_r1.message), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", alert_r1.dismissable);
  }
}
class ToastAlertComponent {
  constructor(toastAlertService) {
    this.toastAlertService = toastAlertService;
    this.alerts = [];
  }
  ngOnInit() {
    this.getAlert();
  }
  getAlert() {
    this.toastAlertService.getAlert().subscribe(alert => {
      if (!alert.message) {
        this.alerts = [];
        return;
      }
      this.alerts.push(alert);
    });
  }
  removeAlert(alert) {
    this.alerts = this.alerts.filter(x => x !== alert);
  }
  cssClass(alert) {
    if (!alert) {
      return;
    }
    setTimeout(d => {
      this.removeAlert(alert);
    }, alert.timer);
    switch (alert.type) {
      case ToastAlertType.Success:
        return 'alert alert-success';
      case ToastAlertType.SuccessBulb:
        return 'alert alert-success';
      case ToastAlertType.Error:
        return 'alert alert-error';
      case ToastAlertType.Info:
        return 'alert alert-info';
    }
  }
  alertIcon(alert) {
    if (!alert || alert.type === ToastAlertType.Info) {
      return;
    }
    switch (alert.type) {
      case ToastAlertType.Success:
        return 'icn-check_circle_filled';
      case ToastAlertType.SuccessBulb:
        return 'icn-light_bulb_on';
      case ToastAlertType.Error:
        return 'icn-error_filled';
    }
  }
  static {
    this.ɵfac = function ToastAlertComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastAlertComponent)(i0.ɵɵdirectiveInject(ToastAlertService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ToastAlertComponent,
      selectors: [["toast-alert"]],
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["role", "alert", "class", "growl-container space-bottom-sm text-center", 4, "ngFor", "ngForOf"], ["role", "alert", 1, "growl-container", "space-bottom-sm", "text-center"], [1, "flexbox", "flex-row", "align-items-center"], [3, "class", 4, "ngIf"], [3, "innerHTML"], ["class", "space-left-lg margin-left-lg btn-reset", 3, "click", 4, "ngIf"], [1, "space-left-lg", "margin-left-lg", "btn-reset", 3, "click"], [1, "icn-close"]],
      template: function ToastAlertComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ToastAlertComponent_div_0_Template, 7, 8, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngForOf", ctx.alerts);
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastAlertComponent, [{
    type: Component,
    args: [{
      selector: 'toast-alert',
      standalone: false,
      template: "<div *ngFor=\"let alert of alerts\" role=\"alert\" class=\"growl-container space-bottom-sm text-center\">\n    <div class=\"{{ cssClass(alert) }} growl-item inline-block\">\n        <div class=\"flexbox flex-row align-items-center \">\n            <i *ngIf=\"alertIcon(alert)\" class=\"{{ alertIcon(alert) }} space-right-sm margin-right-sm\"></i>\n            <span [innerHTML]=\"alert.message | safeHtml\"></span>\n            <button *ngIf=\"alert.dismissable\" (click)=\"removeAlert(alert)\" class=\"space-left-lg margin-left-lg btn-reset\"><i class=\"icn-close\"></i></button>\n        </div>\n    </div>\n</div>"
    }]
  }], () => [{
    type: ToastAlertService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ToastAlertComponent, {
    className: "ToastAlertComponent",
    filePath: "common/toast/toast-alert.component.ts",
    lineNumber: 11
  });
})();
const SYMBOLS = {
  byte: 'bytes',
  kilobybe: 'KB',
  megabyte: 'MB',
  gigabyte: 'GB'
};
const UNITS = {
  byte: 1,
  kilobybe: 1024,
  megabyte: Math.pow(1024, 2),
  gigabyte: Math.pow(1024, 3)
};
class FileSizePipe {
  transform(size) {
    if (!size || !(typeof size === 'number' || typeof size === 'string')) {
      return '';
    }
    if (typeof size === 'string') {
      size = parseInt(size);
    }
    if (size < UNITS.kilobybe) {
      return `${size} ${SYMBOLS.byte}`;
    } else if (size < UNITS.megabyte) {
      return `${Math.round(size / UNITS.kilobybe)} ${SYMBOLS.kilobybe}`;
    } else {
      const unit = size < UNITS.gigabyte ? 'megabyte' : 'gigabyte';
      return `${(size / UNITS[unit]).toFixed(2)} ${SYMBOLS[unit]}`;
    }
  }
  static {
    this.ɵfac = function FileSizePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FileSizePipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "fileSize",
      type: FileSizePipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileSizePipe, [{
    type: Pipe,
    args: [{
      name: 'fileSize',
      standalone: false
    }]
  }], null, null);
})();
class FileExtensionPipe {
  transform(fileName) {
    if (!fileName || typeof fileName !== 'string') {
      return '';
    }
    return fileName.substring(fileName.lastIndexOf('.') + 1);
  }
  static {
    this.ɵfac = function FileExtensionPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FileExtensionPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "fileExtension",
      type: FileExtensionPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileExtensionPipe, [{
    type: Pipe,
    args: [{
      name: 'fileExtension',
      standalone: false
    }]
  }], null, null);
})();
const _c0$1z = a0 => ({
  "indeterminate": a0
});
class ProgressSpinnerComponent {
  set mode(mode) {
    if (typeof mode === 'undefined') return;
    this.config.mode = mode;
    this.setStrokesStyles();
  }
  get mode() {
    return this.config.mode;
  }
  set strokeColor(strokeColor) {
    if (typeof strokeColor === 'undefined') return;
    if (!strokeColor.startsWith('--')) throw new Error(`"strokeColor" should be a CSS variable.`);
    this.config.strokeColor = `var(${strokeColor})`;
    this.setStrokesStyles();
  }
  get strokeColor() {
    return this.config.strokeColor;
  }
  set strokeWidth(strokeWidth) {
    if (typeof strokeWidth === 'undefined') return;
    this.config.strokeWidth = strokeWidth;
    this.setStrokesStyles();
  }
  get strokeWidth() {
    return this.config.strokeWidth;
  }
  set radius(radius) {
    if (typeof radius === 'undefined') return;
    this.config.r = radius;
    this.setStrokesStyles();
  }
  get radius() {
    return this.config.r;
  }
  set progress(progress) {
    if (typeof progress === 'undefined') return;
    this.config.progress = progress;
    this.setStrokesStyles();
  }
  get progress() {
    return this.config.progress;
  }
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.config = {
      mode: 'indeterminate',
      viewBox: '',
      cx: 0,
      cy: 0,
      r: 20,
      strokeWidth: 5,
      progress: 0
    };
    this.viewInit = false;
    this.styles = {};
  }
  ngOnInit() {
    this.viewInit = true;
    this.setStrokesStyles();
  }
  setStrokesStyles() {
    if (!this.viewInit) {
      return;
    }
    const size = (this.config.r + this.config.strokeWidth) * 2;
    const perimeter = this.config.r * 2 * Math.PI;
    this.config.viewBox = `0 0 ${size} ${size}`;
    this.config.cx = size / 2;
    this.config.cy = size / 2;
    this.setStyles({
      width: `${size}px`,
      height: `${size}px`
    });
    if (typeof this.config.strokeColor === 'string') {
      this.setStyles({
        '--stroke-color': this.config.strokeColor
      });
    }
    if (this.config.mode === 'indeterminate') {
      this.setStyles({
        '--stroke-dasharray-0': `1,${perimeter}`,
        '--stroke-dashoffset-0': `0`,
        '--stroke-dasharray-50': `${perimeter * 0.75},${perimeter}`,
        '--stroke-dashoffset-50': `${perimeter * -0.25}`,
        '--stroke-dasharray-100': `${perimeter * 0.75},${perimeter}`,
        '--stroke-dashoffset-100': `${perimeter * -1}`
      });
    } else {
      this.setStyles({
        '--stroke-dasharray': `${this.config.progress * perimeter / 100},${perimeter}`
      });
    }
    this.applyStyles();
  }
  setStyles(styles) {
    this.styles = {
      ...this.styles,
      ...styles
    };
  }
  applyStyles() {
    const styles = [];
    for (const key in this.styles) {
      styles.push(`${key}: ${this.styles[key]};`);
    }
    this.elementRef.nativeElement.setAttribute('style', styles.join(' '));
  }
  static {
    this.ɵfac = function ProgressSpinnerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProgressSpinnerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ProgressSpinnerComponent,
      selectors: [["progress-spinner"]],
      inputs: {
        mode: "mode",
        strokeColor: "strokeColor",
        strokeWidth: "strokeWidth",
        radius: "radius",
        progress: "progress"
      },
      standalone: false,
      decls: 5,
      vars: 11,
      consts: [[1, "spinner", 3, "ngClass"], ["fill", "none"], [1, "sr-only"]],
      template: function ProgressSpinnerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg", 0);
          i0.ɵɵelement(1, "circle", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵnamespaceHTML();
          i0.ɵɵelementStart(2, "span", 2);
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "translate");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$1z, ctx.config.mode === "indeterminate"));
          i0.ɵɵattribute("viewBox", ctx.config.viewBox);
          i0.ɵɵadvance();
          i0.ɵɵattribute("cx", ctx.config.cx)("cy", ctx.config.cy)("r", ctx.config.r)("stroke-width", ctx.config.strokeWidth);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, "misc.Loading..."), "\n");
        }
      },
      dependencies: [i1.NgClass, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressSpinnerComponent, [{
    type: Component,
    args: [{
      selector: 'progress-spinner',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<svg \n    class=\"spinner\" \n    [ngClass]=\"{ 'indeterminate': config.mode === 'indeterminate' }\" \n    [attr.viewBox]=\"config.viewBox\"\n>\n    <circle \n        fill=\"none\" \n        [attr.cx]=\"config.cx\" \n        [attr.cy]=\"config.cy\" \n        [attr.r]=\"config.r\" \n        [attr.stroke-width]=\"config.strokeWidth\"\n    >\n    </circle>\n</svg>\n\n<span class=\"sr-only\">\n    {{ 'misc.Loading...' | translate }}\n</span>\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    mode: [{
      type: Input
    }],
    strokeColor: [{
      type: Input
    }],
    strokeWidth: [{
      type: Input
    }],
    radius: [{
      type: Input
    }],
    progress: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ProgressSpinnerComponent, {
    className: "ProgressSpinnerComponent",
    filePath: "common/progress-spinner/progress-spinner.component.ts",
    lineNumber: 10
  });
})();
class FormErrorService {
  constructor() {
    this.formErrors = new BehaviorSubject([]);
  }
  getFormErrors() {
    return this.formErrors.asObservable();
  }
  setFormErrors(errors) {
    this.formErrors.next(errors);
  }
  static {
    this.ɵfac = function FormErrorService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormErrorService)();
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: FormErrorService,
      factory: FormErrorService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormErrorService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class ValkyrieBackendService {
  constructor(http, location) {
    this.http = http;
    this.systemUrl = window.location.protocol + "//" + window.location.host + "/";
    this.API_URL = this.systemUrl;
    this.API_PREFIX = 'v2';
    this.url = this.API_URL + 'api';
    this.apiKey = 'Basic 389a31571f68ca0e41f75e03d30b3e30';
    this.subsystem = window.SUB_SYSTEM;
  }
  setCheck(params = '', resource, headers) {
    return this.http.get(`${this.systemUrl}${resource}${params}`, {
      headers: this.setHeader(undefined, headers)
    });
  }
  getAll(resource, api_prefix = this.API_PREFIX, params = {}, headers) {
    return this.http.get(`${this.url}/${api_prefix}/${resource}`, {
      headers: this.setHeader(undefined, headers),
      params: params
    });
  }
  getOne(id, resource, api_prefix = this.API_PREFIX, params = {}, headers) {
    return this.http.get(`${this.url}/${api_prefix}/${resource}/${id}`, {
      headers: this.setHeader(undefined, headers),
      params: params
    });
  }
  save(resource, payload, api_prefix = this.API_PREFIX, params = {}, headers) {
    if (!api_prefix.length) {
      api_prefix = this.API_PREFIX;
    }
    return this.http.post(`${this.url}/${api_prefix}/${resource}`, payload, {
      headers: this.setHeader(undefined, headers),
      params: params
    });
  }
  updateWithParams(resource, api_prefix = this.API_PREFIX, params = {}, headers) {
    return this.http.put(`${this.url}/${api_prefix}/${resource}${params}`, {
      headers: this.setHeader(undefined, headers),
      params: params
    });
  }
  update(id, resource, payload, api_prefix = this.API_PREFIX, params = {}, headers) {
    return this.http.put(`${this.url}/${api_prefix}/${resource}/${id}`, payload, {
      headers: this.setHeader(undefined, headers),
      params: params
    });
  }
  updateWithoutID(resource, payload, api_prefix = this.API_PREFIX, headers) {
    return this.http.put(`${this.url}/${api_prefix}/${resource}`, payload, {
      headers: this.setHeader(undefined, headers)
    });
  }
  patch(resource, payload, api_prefix = this.API_PREFIX, headers) {
    return this.http.patch(`${this.url}/${api_prefix}/${resource}`, payload, {
      headers: this.setHeader(undefined, headers)
    });
  }
  delete(id, resource, api_prefix = this.API_PREFIX, headers) {
    return this.http.delete(`${this.url}/${api_prefix}/${resource}/${id}`, {
      headers: this.setHeader(undefined, headers)
    });
  }
  fetchSiteStructure(usertype = 'student', api_prefix = this.API_PREFIX) {
    return this.http.get(`${this.url}/${api_prefix}/${usertype}-site-structure`, {
      headers: new HttpHeaders({
        'x-requested-system-user': this.subsystem
      })
    });
  }
  setHeader(user = this.subsystem, additionalParams) {
    let params = {
      'Authorization': this.apiKey,
      'x-requested-system-user': user
    };
    if (additionalParams) {
      params = {
        ...params,
        ...additionalParams
      };
    }
    return new HttpHeaders(params);
  }
  static {
    this.ɵfac = function ValkyrieBackendService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ValkyrieBackendService)(i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i1.Location));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: ValkyrieBackendService,
      factory: ValkyrieBackendService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValkyrieBackendService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i2.HttpClient
  }, {
    type: i1.Location
  }], null);
})();
class HelpService {
  constructor(backendService) {
    this.backendService = backendService;
    this.hintsCache = new Map();
  }
  getHelpHints(section, subsection) {
    if (subsection == "doclib") {
      subsection = "doclibrary";
    }
    if (!section || !subsection) {
      if (isDevMode()) {
        console.error('getHelpHints expects both a section and a subsection');
      }
      return of({
        models: []
      });
    }
    const cacheKey = `${section}-${subsection}`;
    if (this.hintsCache.get(cacheKey)) {
      return this.hintsCache.get(cacheKey);
    }
    this.hintsCache.set(cacheKey, this.fetchHints(section, subsection));
    return this.hintsCache.get(cacheKey);
  }
  fetchHints(section, tab) {
    return this.backendService.getAll('help', 'v2', {
      section,
      tab
    }).pipe(shareReplay(1));
  }
  dismissHint(id) {
    return this.backendService.patch('help/' + id + '/dismiss', {});
  }
  static {
    this.ɵfac = function HelpService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HelpService)(i0.ɵɵinject(ValkyrieBackendService));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: HelpService,
      factory: HelpService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpService, [{
    type: Injectable
  }], () => [{
    type: ValkyrieBackendService
  }], null);
})();
const _c0$1y = a0 => ({
  "hint": a0
});
const _c1$1g = a0 => ({
  "inline-warning": a0
});
function HelpComponent_div_0_ng_container_2_li_1_b_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, "misc.Note"), ": ");
  }
}
function HelpComponent_div_0_ng_container_2_li_1_b_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, "misc.Warning"), ": ");
  }
}
function HelpComponent_div_0_ng_container_2_li_1_a_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function HelpComponent_div_0_ng_container_2_li_1_a_6_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const help_r2 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.dismissHint(help_r2));
    });
    i0.ɵɵelement(2, "span", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "misc.Dismiss"));
  }
}
function HelpComponent_div_0_ng_container_2_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 4)(1, "div", 5);
    i0.ɵɵtemplate(2, HelpComponent_div_0_ng_container_2_li_1_b_2_Template, 3, 3, "b", 6)(3, HelpComponent_div_0_ng_container_2_li_1_b_3_Template, 3, 3, "b", 6);
    i0.ɵɵelement(4, "span", 7);
    i0.ɵɵpipe(5, "safeHtml");
    i0.ɵɵtemplate(6, HelpComponent_div_0_ng_container_2_li_1_a_6_Template, 3, 3, "a", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const help_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c0$1y, help_r2.system !== "manager"));
    i0.ɵɵadvance();
    i0.ɵɵclassMap("user_hint dismissible " + ctx_r2.styleClass);
    i0.ɵɵpropertyInterpolate("id", help_r2.help_id);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c1$1g, help_r2.type === "warning"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", help_r2.type === "notice");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", help_r2.type === "warning");
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(5, 9, help_r2.answer), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", help_r2.dismissible);
  }
}
function HelpComponent_div_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HelpComponent_div_0_ng_container_2_li_1_Template, 7, 15, "li", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const help_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !help_r2.dismissed);
  }
}
function HelpComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "ul");
    i0.ɵɵtemplate(2, HelpComponent_div_0_ng_container_2_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.helpHints);
  }
}
class HelpComponent {
  constructor(helpService) {
    this.helpService = helpService;
    this.styleClass = '';
  }
  ngOnInit() {}
  dismissHint(help) {
    help.dismissed = true;
    this.helpService.dismissHint(help.help_id).subscribe(res => {});
  }
  static {
    this.ɵfac = function HelpComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HelpComponent)(i0.ɵɵdirectiveInject(HelpService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: HelpComponent,
      selectors: [["help"]],
      inputs: {
        helpHints: "helpHints",
        styleClass: "styleClass"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["id", "all_user_hints", 4, "ngIf"], ["id", "all_user_hints"], [4, "ngFor", "ngForOf"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], [3, "id", "ngClass"], ["class", "text-uppercase", 4, "ngIf"], [1, "hint_answer", 3, "innerHTML"], ["class", "dismiss_link", 3, "title", "click", 4, "ngIf"], [1, "text-uppercase"], [1, "dismiss_link", 3, "click", "title"], [1, "icn-close"]],
      template: function HelpComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, HelpComponent_div_0_Template, 3, 1, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.helpHints.length > 0);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpComponent, [{
    type: Component,
    args: [{
      selector: 'help',
      standalone: false,
      template: "<div id='all_user_hints' *ngIf='helpHints.length > 0'>\n    <ul>\n        <ng-container *ngFor=\"let help of helpHints;\">\n            <li [ngClass]=\"{ 'hint': help.system !== 'manager'}\" *ngIf=\"!help.dismissed\">\n                <div id=\"{{help.help_id}}\" [class]=\"'user_hint dismissible ' + styleClass\" [ngClass]=\"{ 'inline-warning': help.type === 'warning' }\">\n                    <b *ngIf=\"help.type === 'notice'\" class=\"text-uppercase\">{{ 'misc.Note' | translate }}: </b>\n                    <b *ngIf=\"help.type === 'warning'\" class=\"text-uppercase\">{{ 'misc.Warning' | translate }}: </b>\n                    <span [innerHTML]=\"help.answer | safeHtml\" class=\"hint_answer\"></span>\n                    <a *ngIf=\"help.dismissible\" title=\"{{'misc.Dismiss' | translate}}\" class=\"dismiss_link\" (click)=\"dismissHint(help)\"><span class=\"icn-close\"></span></a>\n                </div>\n            </li>\n        </ng-container>\n    </ul>\n</div>"
    }]
  }], () => [{
    type: HelpService
  }], {
    helpHints: [{
      type: Input
    }],
    styleClass: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(HelpComponent, {
    className: "HelpComponent",
    filePath: "common/help.component.ts",
    lineNumber: 11
  });
})();
class Help {}
class ImageCropComponent {
  constructor() {
    this.onCropped = new EventEmitter();
    this.croppedImage = '';
    this.ImageCropperConfig = {
      imageChangedEvent: null,
      maintainAspectRatio: true,
      aspectRatio: 14 / 3,
      imageAltText: '',
      format: 'png',
      roundCorner: false,
      autoCrop: true,
      alignImage: null,
      disabled: false,
      hidden: false,
      croppedImage: null
    };
  }
  imageCropped(event) {
    const reader = new FileReader();
    reader.onload = event => {
      const base64String = event.target.result;
      this.onCropped.emit(base64String);
    };
    reader.readAsDataURL(event.blob);
  }
  imageLoaded() {}
  cropperReady() {}
  loadImageFailed() {}
  static {
    this.ɵfac = function ImageCropComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImageCropComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ImageCropComponent,
      selectors: [["image-crop"]],
      inputs: {
        cropAreaRatio: "cropAreaRatio",
        roundCorners: "roundCorners",
        url: "url"
      },
      outputs: {
        onCropped: "onCropped"
      },
      standalone: false,
      decls: 1,
      vars: 4,
      consts: [["format", "png", 1, "no-padding-x", 3, "imageCropped", "imageLoaded", "cropperReady", "loadImageFailed", "maintainAspectRatio", "aspectRatio", "imageAltText", "imageBase64"]],
      template: function ImageCropComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "image-cropper", 0);
          i0.ɵɵlistener("imageCropped", function ImageCropComponent_Template_image_cropper_imageCropped_0_listener($event) {
            return ctx.imageCropped($event);
          })("imageLoaded", function ImageCropComponent_Template_image_cropper_imageLoaded_0_listener() {
            return ctx.imageLoaded();
          })("cropperReady", function ImageCropComponent_Template_image_cropper_cropperReady_0_listener() {
            return ctx.cropperReady();
          })("loadImageFailed", function ImageCropComponent_Template_image_cropper_loadImageFailed_0_listener() {
            return ctx.loadImageFailed();
          });
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("maintainAspectRatio", ctx.ImageCropperConfig.maintainAspectRatio)("aspectRatio", ctx.roundCorners ? 1 / 1 : 14 / 3)("imageAltText", ctx.selectedFile)("imageBase64", ctx.url);
        }
      },
      dependencies: [i1$6.ImageCropperComponent],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageCropComponent, [{
    type: Component,
    args: [{
      selector: 'image-crop',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<image-cropper\n        class=\"no-padding-x\"\n        [maintainAspectRatio]=\"ImageCropperConfig.maintainAspectRatio\"\n        [aspectRatio]=\"roundCorners ? 1 / 1 : 14 / 3\"\n        [imageAltText]=\"selectedFile\"\n        [imageBase64]=\"url\"\n        format=\"png\"\n        (imageCropped)=\"imageCropped($event)\"\n        (imageLoaded)=\"imageLoaded()\"\n        (cropperReady)=\"cropperReady()\"\n        (loadImageFailed)=\"loadImageFailed()\"\n></image-cropper>\n"
    }]
  }], null, {
    cropAreaRatio: [{
      type: Input
    }],
    roundCorners: [{
      type: Input
    }],
    url: [{
      type: Input
    }],
    onCropped: [{
      type: Output
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ImageCropComponent, {
    className: "ImageCropComponent",
    filePath: "common/image-crop.component.ts",
    lineNumber: 12
  });
})();
class CatchClickDirective {
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.pendingBlurElement = null;
    this.blurPreventionListener = null;
  }
  isButtonElement(element) {
    if (!element) return false;
    const tag = element.tagName.toLowerCase();
    // Check if element is a button or inside a button
    return tag === 'button' || element.closest('button') !== null || tag === 'input' && (element.type === 'submit' || element.type === 'button');
  }
  onMouseDown(event) {
    const clickTarget = event.target;
    const directiveElement = this.elementRef.nativeElement;
    const active = document.activeElement;
    // Check if the directive is on a button (more reliable than checking clickTarget)
    const isDirectiveOnButton = this.isButtonElement(directiveElement);
    if (active && (active.tagName === 'INPUT' || active.tagName === 'SELECT' || active.tagName === 'TEXTAREA' || active.getAttribute('contenteditable') === 'true') && active.closest('form')) {
      // Don't blur if clicking on the active element itself
      if (active === clickTarget || active.contains(clickTarget)) {
        return;
      }
      // If directive is on a button, intercept blur events to prevent validation during click
      // This allows the click to complete before validation fires and causes layout shifts
      if (isDirectiveOnButton) {
        // Store reference to active element
        this.pendingBlurElement = active;
        // Add a blur event listener that stops immediate propagation
        // This prevents Angular's blur handlers from running, which trigger validation
        this.blurPreventionListener = e => {
          e.stopImmediatePropagation();
        };
        // Add listener in capture phase (true) to catch before Angular's handlers
        // Capture phase runs before target phase, so we catch it first
        active.addEventListener('blur', this.blurPreventionListener, true);
        // Remove the listener after a short delay (after click completes)
        // This allows the click event to fire normally
        setTimeout(() => {
          if (this.blurPreventionListener && active.isConnected) {
            active.removeEventListener('blur', this.blurPreventionListener, true);
            this.blurPreventionListener = null;
          }
        }, 50); // Short delay to ensure click completes
        return;
      }
      // For non-button clicks, blur immediately
      active.blur();
    }
  }
  onMouseUp(event) {
    // Clear pending blur reference on mouseup
    // The blur interception listener will be cleaned up by the setTimeout in onMouseDown
    if (this.pendingBlurElement) {
      this.pendingBlurElement = null;
    }
  }
  static {
    this.ɵfac = function CatchClickDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CatchClickDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: CatchClickDirective,
      selectors: [["", "catch-click", ""]],
      hostBindings: function CatchClickDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mousedown", function CatchClickDirective_mousedown_HostBindingHandler($event) {
            return ctx.onMouseDown($event);
          })("mouseup", function CatchClickDirective_mouseup_HostBindingHandler($event) {
            return ctx.onMouseUp($event);
          });
        }
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CatchClickDirective, [{
    type: Directive,
    args: [{
      selector: '[catch-click]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    onMouseDown: [{
      type: HostListener,
      args: ['mousedown', ['$event']]
    }],
    onMouseUp: [{
      type: HostListener,
      args: ['mouseup', ['$event']]
    }]
  });
})();

/**
 * Based on `tap` operator from RXJS
 * See: https://github.com/ReactiveX/rxjs/blob/6.x/src/internal/operators/tap.ts
 */
function tapOnce(nextOrObserver, error, complete) {
  return function tapOnceOperatorFunction(source) {
    return source.lift(new DoOperator(nextOrObserver, error, complete));
  };
}
class DoOperator {
  constructor(nextOrObserver, error, complete) {
    this.nextOrObserver = nextOrObserver;
    this.error = error;
    this.complete = complete;
  }
  call(subscriber, source) {
    return source.subscribe(new TapOnceSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
  }
}
class TapOnceSubscriber extends Subscriber {
  constructor(destination, observerOrNext, error, complete) {
    super(destination);
    this.isFirst = true;
    this.tapNext = noop;
    this.tapError = noop;
    this.tapComplete = noop;
    this.tapError = error || noop;
    this.tapComplete = complete || noop;
    if (typeof observerOrNext === 'function') {
      this.context = this;
      this.tapNext = observerOrNext;
    } else if (observerOrNext) {
      this.context = observerOrNext;
      this.tapNext = observerOrNext.next || noop;
      this.tapError = observerOrNext.error || noop;
      this.tapComplete = observerOrNext.complete || noop;
    }
  }
  _next(value) {
    if (this.isFirst) {
      this.isFirst = false;
      try {
        this.tapNext.call(this.context, value);
      } catch (err) {
        this.destination.error?.(err);
        return;
      }
    }
    this.destination.next?.(value);
  }
  _error(err) {
    if (this.isFirst) {
      this.isFirst = false;
      try {
        this.tapError.call(this.context, err);
      } catch (err) {
        this.destination.error?.(err);
        return;
      }
    }
    this.destination.error?.(err);
  }
  _complete() {
    if (this.isFirst) {
      this.isFirst = false;
      try {
        this.tapComplete.call(this.context);
      } catch (err) {
        this.destination.error?.(err);
        return;
      }
    }
    return this.destination.complete?.();
  }
}
class SyngCommonModule {
  static forRoot() {
    return {
      ngModule: SyngCommonModule,
      providers: [HelpService, HighlightSearchPipe, SearchTextPipe$1, CallbackPipe, FilterPipe, KeysPipe, MonogramPipe, OrderByPipe, SanitizeHtmlPipe, FileSizePipe, FileExtensionPipe, StripUnderscorePipe]
    };
  }
  static {
    this.ɵfac = function SyngCommonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SyngCommonModule)();
    };
  }
  static {
    this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
      type: SyngCommonModule
    });
  }
  static {
    this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
      providers: [TranslateService, provideHttpClient(withInterceptorsFromDi())],
      imports: [CommonModule, NgbModule, RouterModule, TranslateModule, ImageCropperModule, hierarchicalListWidgetComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SyngCommonModule, [{
    type: NgModule,
    args: [{
      declarations: [PaginationComponent, ModalComponent, TabsComponent, ProgressBarComponent, WarningModalComponent, CollapsableWellComponent, SearchTextPipe$1, CallbackPipe, FilterPipe, KeysPipe, MonogramPipe, OrderByPipe, SanitizeHtmlPipe, FileSizePipe, FileExtensionPipe, StripUnderscorePipe, ReadMoreDirective, DisableRightClickDirective, KeyboardTrapDirective, DragTableDirective, TrueFalseValueDirective, CatchClickDirective, TruncateTextPipe, ToastAlertComponent, ProgressSpinnerComponent, SafeHtmlPipe, HelpComponent, ImageCropComponent],
      exports: [PaginationComponent, ModalComponent, TabsComponent, ProgressBarComponent, WarningModalComponent, CollapsableWellComponent, HighlightSearchPipe, SearchTextPipe$1, CallbackPipe, FilterPipe, KeysPipe, MonogramPipe, OrderByPipe, SanitizeHtmlPipe, FileSizePipe, FileExtensionPipe, StripUnderscorePipe, ReadMoreDirective, DisableRightClickDirective, KeyboardTrapDirective, DragTableDirective, TrueFalseValueDirective, CatchClickDirective, TruncateTextPipe, ToastAlertComponent, ProgressSpinnerComponent, SafeHtmlPipe, HelpComponent, ImageCropComponent, hierarchicalListWidgetComponent],
      imports: [CommonModule, NgbModule, RouterModule, TranslateModule, ImageCropperModule, HighlightSearchPipe, hierarchicalListWidgetComponent],
      providers: [TranslateService, provideHttpClient(withInterceptorsFromDi())]
    }]
  }], null, null);
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SyngCommonModule, {
    declarations: [PaginationComponent, ModalComponent, TabsComponent, ProgressBarComponent, WarningModalComponent, CollapsableWellComponent, SearchTextPipe$1, CallbackPipe, FilterPipe, KeysPipe, MonogramPipe, OrderByPipe, SanitizeHtmlPipe, FileSizePipe, FileExtensionPipe, StripUnderscorePipe, ReadMoreDirective, DisableRightClickDirective, KeyboardTrapDirective, DragTableDirective, TrueFalseValueDirective, CatchClickDirective, TruncateTextPipe, ToastAlertComponent, ProgressSpinnerComponent, SafeHtmlPipe, HelpComponent, ImageCropComponent],
    imports: [CommonModule, NgbModule, RouterModule, TranslateModule, ImageCropperModule, HighlightSearchPipe, hierarchicalListWidgetComponent],
    exports: [PaginationComponent, ModalComponent, TabsComponent, ProgressBarComponent, WarningModalComponent, CollapsableWellComponent, HighlightSearchPipe, SearchTextPipe$1, CallbackPipe, FilterPipe, KeysPipe, MonogramPipe, OrderByPipe, SanitizeHtmlPipe, FileSizePipe, FileExtensionPipe, StripUnderscorePipe, ReadMoreDirective, DisableRightClickDirective, KeyboardTrapDirective, DragTableDirective, TrueFalseValueDirective, CatchClickDirective, TruncateTextPipe, ToastAlertComponent, ProgressSpinnerComponent, SafeHtmlPipe, HelpComponent, ImageCropComponent, hierarchicalListWidgetComponent]
  });
})();
class DataTableResource {
  constructor(items) {
    this.items = items;
  }
  query(params, filter) {
    let result = [];
    if (filter) {
      result = this.items.filter(filter);
    } else {
      result = this.items.slice(); // shallow copy to use for sorting instead of changing the original
    }
    if (params.sortBy) {
      result.sort((a, b) => {
        if (typeof a[params.sortBy] === 'string') {
          return a[params.sortBy].localeCompare(b[params.sortBy]);
        } else {
          return a[params.sortBy] - b[params.sortBy];
        }
      });
      if (params.sortAsc === false) {
        result.reverse();
      }
    }
    if (params.offset !== undefined) {
      if (params.limit === undefined) {
        result = result.slice(params.offset, result.length);
      } else {
        result = result.slice(params.offset, params.offset + params.limit);
      }
    }
    return new Promise((resolve, reject) => {
      setTimeout(() => resolve(result));
    });
  }
  count() {
    return new Promise((resolve, reject) => {
      setTimeout(() => resolve(this.items.length));
    });
  }
}
class DataTableModule {
  static {
    this.ɵfac = function DataTableModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DataTableModule)();
    };
  }
  static {
    this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
      type: DataTableModule
    });
  }
  static {
    this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
      providers: [provideHttpClient(withInterceptorsFromDi())],
      imports: [CommonModule, FormsModule, TranslationsModule, SyngCommonModule.forRoot(), ContextMenuModule, ContextMenuModule, TranslationsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableModule, [{
    type: NgModule,
    args: [{
      declarations: [DataTable, DataTableColumn, DataTableRow, DataTableHeader, PixelConverter, Hide, MinPipe$1],
      exports: [DataTable, DataTableColumn, ContextMenuModule, TranslationsModule, PixelConverter, Hide, MinPipe$1],
      imports: [CommonModule, FormsModule, TranslationsModule, SyngCommonModule.forRoot(), ContextMenuModule],
      providers: [provideHttpClient(withInterceptorsFromDi())]
    }]
  }], null, null);
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DataTableModule, {
    declarations: [DataTable, DataTableColumn, DataTableRow, DataTableHeader, PixelConverter, Hide, MinPipe$1],
    imports: [CommonModule, FormsModule, TranslationsModule, SyngCommonModule, ContextMenuModule],
    exports: [DataTable, DataTableColumn, ContextMenuModule, TranslationsModule, PixelConverter, Hide, MinPipe$1]
  });
})();
i0.ɵɵsetComponentScope(DataTable, [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, i1$1.TranslateDirective, DataTableRow, DataTableHeader, Hide], [i1$1.TranslatePipe, PixelConverter]);
const _c0$1x = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c1$1f = a0 => ({
  field_name: a0
});
const _c2$W = (a0, a1) => ({
  field_name: a0,
  max: a1
});
const _c3$E = (a0, a1) => ({
  field_name: a0,
  min: a1
});
const _c4$v = a0 => ({
  patternLength: a0
});
function FormInputComponent_div_0_div_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 14);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormInputComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "label", 12);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, FormInputComponent_div_0_div_1_i_4_Template, 2, 0, "i", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, ctx_r1.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired);
  }
}
function FormInputComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormInputComponent_div_0_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$1f, ctx_r1.translatedLabel)), " ");
  }
}
function FormInputComponent_div_0_div_4_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Max length error", i0.ɵɵpureFunction2(4, _c2$W, ctx_r1.translatedLabel, ctx_r1.control.errors.maxlength.requiredLength)), " ");
  }
}
function FormInputComponent_div_0_div_4_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Min length error", i0.ɵɵpureFunction2(4, _c3$E, ctx_r1.translatedLabel, ctx_r1.control.errors.minlength.requiredLength)), " ");
  }
}
function FormInputComponent_div_0_div_4_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "misc.invalid email error"), " ");
  }
}
function FormInputComponent_div_0_div_4_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Must be exact numeric digits", i0.ɵɵpureFunction1(4, _c4$v, ctx_r1.zipPatternCharacterLength)), " ");
  }
}
function FormInputComponent_div_0_div_4_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "misc.invalid url error"), " ");
  }
}
function FormInputComponent_div_0_div_4_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, ctx_r1.patternError), " ");
  }
}
function FormInputComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, FormInputComponent_div_0_div_4_div_1_Template, 4, 6, "div", 9)(2, FormInputComponent_div_0_div_4_div_2_Template, 4, 7, "div", 9)(3, FormInputComponent_div_0_div_4_div_3_Template, 4, 7, "div", 9)(4, FormInputComponent_div_0_div_4_div_4_Template, 4, 3, "div", 9)(5, FormInputComponent_div_0_div_4_div_5_Template, 4, 6, "div", 9)(6, FormInputComponent_div_0_div_4_div_6_Template, 4, 3, "div", 9)(7, FormInputComponent_div_0_div_4_div_7_Template, 4, 3, "div", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.maxlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.minlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.email);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.zipPattern);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.pattern);
  }
}
function FormInputComponent_div_0_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 18);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function FormInputComponent_div_0_ng_container_9_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearValue($event));
    });
    i0.ɵɵelement(3, "i", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.control.value);
    i0.ɵɵattribute("aria-hidden", !ctx_r1.control.value)("aria-label", i0.ɵɵpipeBind1(2, 3, "misc.Clear"));
  }
}
function FormInputComponent_div_0_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (ctx_r1.control.value.length < ctx_r1.config.maxLength ? ctx_r1.control.value.length : ctx_r1.config.maxLength) + "/" + ctx_r1.config.maxLength, " ");
  }
}
function FormInputComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, FormInputComponent_div_0_div_1_Template, 5, 7, "div", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtemplate(3, FormInputComponent_div_0_div_3_Template, 3, 6, "div", 5)(4, FormInputComponent_div_0_div_4_Template, 8, 7, "div", 6);
    i0.ɵɵelementStart(5, "div", 7)(6, "input", 8, 0);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵlistener("blur", function FormInputComponent_div_0_Template_input_blur_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("blur", $event));
    })("keypress", function FormInputComponent_div_0_Template_input_keypress_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.triggerEvent("keypress", $event);
      return i0.ɵɵresetView(ctx_r1.control.markAsTouched());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, FormInputComponent_div_0_ng_container_9_Template, 4, 5, "ng-container", 9)(10, FormInputComponent_div_0_div_10_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(21, _c0$1x, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild))("formGroup", ctx_r1.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("input-text ", ctx_r1.config.className, "");
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵproperty("type", ctx_r1.inputType)("formControlName", ctx_r1.config.name)("maxlength", ctx_r1.config.maxLength ? ctx_r1.config.maxLength : null);
    i0.ɵɵattribute("placeholder", i0.ɵɵpipeBind1(8, 19, ctx_r1.config.placeholder))("aria-describedby", ctx_r1.describedByValue)("aria-required", ctx_r1.isRequired);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.config.clearButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.maxLength && ctx_r1.control.value);
  }
}
class FormInputComponent {
  constructor(translate) {
    this.translate = translate;
    this.inputType = 'text';
    this.zipPatternCharacterLength = 5;
    this.translatedLabel = '';
    this.inputFocusStates = {};
  }
  get control() {
    return this.group.controls[this.config.name];
  }
  get controlName() {
    return this.config.name;
  }
  get isRequired() {
    return hasRequiredField(this.control);
  }
  get required() {
    let _validator = this.control.validator && this.control.validator(this.control);
    return _validator && _validator.required;
  }
  get patternError() {
    return 'misc.invalid ' + this.controlName + ' error';
  }
  get elementId() {
    return this.config.elementId + (this.modal ? 'modal' : '');
  }
  ngOnInit() {
    this.defaultInit();
    this.configuration();
    this.initSetValue();
  }
  initSetValue() {
    if (this.config.value) {
      setTimeout(() => {
        this.control.setValue(this.config.value, {
          'emitEvent': false,
          'emitModelToViewChange': true
        });
      });
    }
  }
  defaultInit() {
    this.inputFocusStates[this.config.name] = true;
    this.translatedLabel = this.config.label ? this.translate.instant(this.config.label) : '';
    this.inputType = typeof this.config.inputType !== 'undefined' ? this.config.inputType : this.inputType;
    this.zipPatternCharacterLength = typeof this.config.zipPatternCharacterLength !== 'undefined' ? this.config.zipPatternCharacterLength : this.zipPatternCharacterLength;
    if (this.inputType === 'email') {
      this.setEmailValidator();
    }
    if (this.inputType === 'url') {
      this.setUrlValidator();
    }
    if (this.inputType === 'zip') {
      this.setZipValidator();
    }
    this.setDescribedBy();
    if (this.config.readOnlyForm && !this.config.displayBlurbOnRO) {
      this.config.blurb = null;
    }
  }
  setDescribedBy() {
    let modal = this.modal ? 'modal' : '';
    this.describedByValue = this.config.blurb ? this.config.elementId + modal + '-blurb' : null;
  }
  setEmailValidator() {
    let validators = [customEmailValidator];
    if (this.config.validators) {
      validators = validators.concat(this.config.validators);
    }
    this.control.setValidators(validators);
  }
  setUrlValidator() {
    let validators = [customURLValidator];
    if (this.config.validators) {
      validators = validators.concat(this.config.validators);
    }
    this.control.setValidators(validators);
  }
  setZipValidator() {
    let validators = [control => zipPatternValidator(control, this.zipPatternCharacterLength)];
    if (this.config.validators) {
      validators = validators.concat(this.config.validators);
    }
    this.control.setValidators(validators);
  }
  triggerEvent(action, event) {
    if (this.config.triggerEvent && this.config.triggerEvent instanceof Function) {
      this.config.triggerEvent(action, event);
    }
  }
  clearValue(event) {
    this.group.get(this.config.name)?.setValue(undefined);
    this.triggerEvent('clear', event);
    setTimeout(d => {
      document.getElementById(this.config.elementId + (this.modal ? 'modal' : ''))?.focus();
    }, 100);
  }
  configuration() {}
  static {
    this.ɵfac = function FormInputComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormInputComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormInputComponent,
      selectors: [["form-input"]],
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["inputField", ""], ["class", "field form-input form-custom", 3, "ngClass", "formGroup", 4, "ngIf"], [1, "field", "form-input", "form-custom", 3, "ngClass", "formGroup"], ["class", "field-label", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], [1, "btn-in-select"], [3, "blur", "keypress", "type", "formControlName", "id", "maxlength"], [4, "ngIf"], ["class", "character-count", 4, "ngIf"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [1, "icn-error_filled"], [1, "clearBtn", 3, "click", "hidden"], [1, "icn-close"], [1, "character-count"]],
      template: function FormInputComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormInputComponent_div_0_Template, 11, 24, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.MaxLengthValidator, i1.NgClass, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormInputComponent, [{
    type: Component,
    args: [{
      selector: 'form-input',
      template: `
            <div class="field form-input form-custom" *ngIf="!config.hideField" [ngClass]="{'field-error': !control.valid && (control.dirty || control.touched), 'last': config.lastChild}" [formGroup]="group">
                <div *ngIf="!config.hideLabel" class="field-label">
                  <label for="{{config.elementId}}{{modal?'modal':''}}">
                    {{config.label | translate}}
                    <i *ngIf="isRequired" class="req-indicator">*</i>
                  </label>
                </div>
                <div class="field-widget">
                    <div *ngIf="config.blurb" id="{{describedByValue}}" class="blurb field-blurb" [innerHTML]="config.blurb | translate | safeHtml"></div>
                    <div role="alert" *ngIf="(!control.valid && (control.dirty || control.touched))">
                        <div *ngIf="control.errors.required">
                            <i class="icn-error_filled"></i>
                            {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}
                        </div>
                        <div *ngIf="control.errors.maxlength">
                            <i class="icn-error_filled"></i>
                            {{ 'misc.Max length error' | translate: {field_name: translatedLabel, max: control.errors.maxlength.requiredLength} }}
                        </div>
                        <div *ngIf="control.errors.minlength">
                            <i class="icn-error_filled"></i>
                            {{ 'misc.Min length error' | translate: {field_name: translatedLabel, min: control.errors.minlength.requiredLength} }}
                        </div>
                        <div *ngIf="control.errors.email">
                            <i class="icn-error_filled"></i>
                            {{'misc.invalid email error' | translate}}
                        </div>
                        <div *ngIf="control.errors.zipPattern">
                            <i class="icn-error_filled"></i>
                            {{'misc.Must be exact numeric digits' | translate: {patternLength: zipPatternCharacterLength} }}
                        </div>
                        <div *ngIf="control.errors.url">
                            <i class="icn-error_filled"></i>
                            {{'misc.invalid url error' | translate}}
                        </div>
                        <div *ngIf="control.errors.pattern">
                            <i class="icn-error_filled"></i>
                            {{patternError | translate}}
                        </div>
                    </div>
                    <div class="btn-in-select">
                        <input
                            #inputField
                            [type]="inputType"
                            [attr.placeholder]="config.placeholder | translate"
                            [formControlName]="config.name"
                            id="{{config.elementId}}{{modal?'modal':''}}"
                            [attr.aria-describedby]="describedByValue"
                            [attr.aria-required]="isRequired"
                            (blur)="triggerEvent('blur', $event);"
                            (keypress)="triggerEvent('keypress', $event); control.markAsTouched();"
                            [maxlength]="config.maxLength ? config.maxLength : null"
                            class="input-text {{config.className}}" />
                        <ng-container *ngIf="config.clearButton">
                            <button class="clearBtn" (click)="clearValue($event)" [hidden]="!this.control.value" [attr.aria-hidden]="!this.control.value" [attr.aria-label]="'misc.Clear' | translate">
                                <i class="icn-close"></i>
                            </button>
                        </ng-container>
                        <div class="character-count" *ngIf="config.maxLength && control.value">
                            {{ (control.value.length < config.maxLength ? control.value.length : config.maxLength) + '/' + config.maxLength }}
                        </div>
                    </div>
                </div>
            </div>
    `,
      standalone: false
    }]
  }], () => [{
    type: i1$1.TranslateService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormInputComponent, {
    className: "FormInputComponent",
    filePath: "dynamic-form/components/form-input/form-input.component.ts",
    lineNumber: 75
  });
})();
function customURLValidator(control) {
  const URL_REGEXP = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.%]+$/;
  let controlValue = control.value;
  if (!controlValue) {
    return null;
  }
  if (URL_REGEXP.test(controlValue)) {
    return null;
  } else {
    return {
      'url': true
    };
  }
}
function zipPatternValidator(control, patternValidation) {
  const ZIP_REGEXP = new RegExp(`^\\d{${patternValidation}}$`);
  let controlValue = control.value;
  if (!controlValue) {
    return null; // don't validate empty values to allow optional controls
  }
  if (ZIP_REGEXP.test(controlValue)) {
    return null;
  } else {
    return {
      'zipPattern': true
    };
  }
}
function customEmailValidator(control) {
  const EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  const MERGE_CODE_REGEXP = /^\[\w+\]$/;
  let controlValue = control.value;
  if (!controlValue) {
    return null; // don't validate empty values to allow optional controls
  }
  if (controlValue.split(',').every(email => EMAIL_REGEXP.test(email.trim()) || MERGE_CODE_REGEXP.test(email.trim()))) {
    return null;
  } else {
    return {
      'email': true
    };
  }
}
const _c0$1w = (a0, a1) => ({
  "last": a0,
  "inline": a1
});
function FormButtonComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "button", 2);
    i0.ɵɵlistener("click", function FormButtonComponent_div_0_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.config.onClick($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.group)("ngClass", i0.ɵɵpureFunction2(8, _c0$1w, ctx_r1.config.lastChild, ctx_r1.config.displayInline));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("type", ctx_r1.config.name);
    i0.ɵɵproperty("ngClass", ctx_r1.config.styleClass)("disabled", ctx_r1.config.name === "submit" && !ctx_r1.group.valid);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, ctx_r1.config.label), " ");
  }
}
class FormButtonComponent {
  static {
    this.ɵfac = function FormButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormButtonComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormButtonComponent,
      selectors: [["form-button"]],
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["class", "field form-button", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "field", "form-button", 3, "formGroup", "ngClass"], [1, "input-button", 3, "click", "type", "ngClass", "disabled"]],
      template: function FormButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormButtonComponent_div_0_Template, 4, 11, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.NgControlStatusGroup, i1.NgClass, i1.NgIf, i2$1.FormGroupDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormButtonComponent, [{
    type: Component,
    args: [{
      selector: 'form-button',
      template: `
			<div *ngIf="!config.hideField"
				class="field form-button"
				[formGroup]="group" 
				[ngClass]="{'last':config.lastChild, 'inline': config.displayInline}">
				<button type="{{ config.name }}" 
					class="input-button" 
					(click)="config.onClick($event)"
					[ngClass]="config.styleClass"
					[disabled]="config.name === 'submit' && !group.valid">
					{{config.label | translate}}
				</button>
			</div>
            `,
      standalone: false
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormButtonComponent, {
    className: "FormButtonComponent",
    filePath: "dynamic-form/components/form-button/form-button.component.ts",
    lineNumber: 22
  });
})();
const _c0$1v = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c1$1e = a0 => ({
  field_name: a0
});
const _c2$V = a0 => ({
  "flex-row": a0
});
const _c3$D = a0 => ({
  "flex-grow-1": a0
});
function FormSelectComponent_div_0_div_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 9);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormSelectComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "label", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, FormSelectComponent_div_0_div_1_i_4_Template, 2, 0, "i", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
  }
}
function FormSelectComponent_div_0_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormSelectComponent_div_0_div_2_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "i", 19);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$1e, ctx_r0.translatedLabel)), " ");
  }
}
function FormSelectComponent_div_0_div_2_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, FormSelectComponent_div_0_div_2_div_2_div_1_Template, 4, 6, "div", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function FormSelectComponent_div_0_div_2_select_3_ng_container_1_option_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r2 = ctx.$implicit;
    i0.ɵɵproperty("disabled", option_r2.disabled)("ngValue", option_r2.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r2.display ? option_r2.display : option_r2, " ");
  }
}
function FormSelectComponent_div_0_div_2_select_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormSelectComponent_div_0_div_2_select_3_ng_container_1_option_1_Template, 2, 3, "option", 21);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r0.config.options));
  }
}
function FormSelectComponent_div_0_div_2_select_3_ng_container_2_ng_container_3_option_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const opt_r3 = ctx.$implicit;
    const option_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("disabled", opt_r3.disabled)("ngValue", opt_r3.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", opt_r3.display ? opt_r3.display : option_r4, " ");
  }
}
function FormSelectComponent_div_0_div_2_select_3_ng_container_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "optgroup");
    i0.ɵɵtemplate(2, FormSelectComponent_div_0_div_2_select_3_ng_container_2_ng_container_3_option_2_Template, 2, 3, "option", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const option_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵattribute("label", option_r4.key);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", option_r4.value);
  }
}
function FormSelectComponent_div_0_div_2_select_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "option", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, FormSelectComponent_div_0_div_2_select_3_ng_container_2_ng_container_3_Template, 3, 2, "ng-container", 24);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "keyvalue");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngValue", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate((tmp_5_0 = ctx_r0.config.placeholder) !== null && tmp_5_0 !== undefined ? tmp_5_0 : " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(5, 5, i0.ɵɵpipeBind1(4, 3, ctx_r0.config.options), ctx_r0.originalOrder));
  }
}
function FormSelectComponent_div_0_div_2_select_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "select", 20);
    i0.ɵɵtemplate(1, FormSelectComponent_div_0_div_2_select_3_ng_container_1_Template, 3, 3, "ng-container", 1)(2, FormSelectComponent_div_0_div_2_select_3_ng_container_2_Template, 6, 8, "ng-container", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵproperty("formControlName", ctx_r0.config.name);
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.useGrouping);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.useGrouping);
  }
}
function FormSelectComponent_div_0_div_2_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25)(1, "button", 26);
    i0.ɵɵlistener("click", function FormSelectComponent_div_0_div_2_div_4_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.config.addNewItem.addFunction(ctx_r0.config));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.config.addNewItem.blurb);
  }
}
function FormSelectComponent_div_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, FormSelectComponent_div_0_div_2_div_1_Template, 3, 6, "div", 11)(2, FormSelectComponent_div_0_div_2_div_2_Template, 2, 1, "div", 12)(3, FormSelectComponent_div_0_div_2_select_3_Template, 3, 7, "select", 13)(4, FormSelectComponent_div_0_div_2_div_4_Template, 3, 4, "div", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb && !ctx_r0.config.hideBlurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.addNewItem || ctx_r0.config.addNewItem && !ctx_r0.config.emptyPicklist);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.addNewItem && ctx_r0.config.emptyPicklist);
  }
}
function FormSelectComponent_div_0_div_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx_r0.config.blurb));
  }
}
function FormSelectComponent_div_0_div_3_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r6 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", option_r6.id)("disabled", option_r6.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r6.display ? option_r6.display : option_r6, " ");
  }
}
function FormSelectComponent_div_0_div_3_div_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "i", 19);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$1e, ctx_r0.config.label)), " ");
  }
}
function FormSelectComponent_div_0_div_3_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, FormSelectComponent_div_0_div_3_div_7_div_1_Template, 4, 6, "div", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function FormSelectComponent_div_0_div_3_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "form-actions", 32);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("actions", ctx_r0.config.customActions.actions);
  }
}
function FormSelectComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, FormSelectComponent_div_0_div_3_div_1_Template, 3, 4, "div", 27);
    i0.ɵɵelementStart(2, "div", 28)(3, "div", 28)(4, "select", 20);
    i0.ɵɵtemplate(5, FormSelectComponent_div_0_div_3_option_5_Template, 2, 3, "option", 29);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, FormSelectComponent_div_0_div_3_div_7_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, FormSelectComponent_div_0_div_3_ng_container_8_Template, 2, 1, "ng-container", 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c2$V, ctx_r0.config.customActions.displayInline));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c3$D, ctx_r0.config.customActions.displayInline));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵproperty("formControlName", ctx_r0.config.name);
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(6, 11, ctx_r0.config.options));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.customActions && !ctx_r0.config.customActions.hideAction);
  }
}
function FormSelectComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "button", 34);
    i0.ɵɵlistener("click", function FormSelectComponent_div_0_div_4_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.config.addNewItem.addFunction(ctx_r0.config));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "misc.or"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.config.addNewItem.blurb);
  }
}
function FormSelectComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, FormSelectComponent_div_0_div_1_Template, 5, 7, "div", 3)(2, FormSelectComponent_div_0_div_2_Template, 5, 4, "div", 4)(3, FormSelectComponent_div_0_div_3_Template, 9, 17, "div", 4)(4, FormSelectComponent_div_0_div_4_Template, 5, 4, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.group)("ngClass", i0.ɵɵpureFunction2(6, _c0$1v, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.hideLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.customActions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.customActions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.addNewItem && !ctx_r0.config.emptyPicklist);
  }
}
function FormSelectComponent_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 36);
  }
  if (rf & 2) {
    const field_r8 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r8)("group", ctx_r0.group);
  }
}
function FormSelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormSelectComponent_div_1_ng_container_1_Template, 1, 2, "ng-container", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.dependents);
  }
}
class FormSelectComponent extends FormInputComponent {
  constructor(fb, translate) {
    super(translate);
    this.fb = fb;
    this.translate = translate;
    this.useGrouping = false;
    this.originalOrder = (a, b) => 0;
  }
  ngOnInit() {
    this.translatedLabel = this.translate.instant(this.config.label);
    if (this.config.options instanceof Observable) {
      this.config.options = this.config.options.pipe(map(opts => {
        if (opts.some(o => !!o.groupBy)) {
          this.useGrouping = true;
          return _.groupBy(opts, 'groupBy');
        }
        if (opts.every(o => !!o.id)) {
          opts.unshift({
            'id': undefined,
            'display': this.config.placeholder || ' '
          });
        }
        return opts;
      }));
    }
    if (this.config.dependents) {
      this.control.valueChanges.subscribe(newVal => {
        this.setBlurbState(newVal);
        this.setupDependentsState(newVal);
      });
      this.registerDependentControls();
    }
    if (this.config.onChangeFn) {
      this.control.valueChanges.subscribe(newVal => {
        this.config.onChangeFn(newVal);
      });
    }
    setTimeout(() => {
      this.control.setValue(this.config.value);
    });
    if (this.config.defaultValue || this.config.defaultValue == '') {
      setTimeout(() => {
        this.control.setValue(this.config.defaultValue);
      });
    }
    this.setDescribedBy();
  }
  setupDependentsState(newVal) {
    this.config.dependents.forEach(depConfig => {
      let depControl = this.group.controls[depConfig.name];
      let key = depConfig.aggregateKey;
      if (depConfig.hasOwnProperty('displayOn')) {
        depConfig.hideField = depConfig.displayOn.indexOf(newVal) < 0;
        setTimeout(() => {
          depConfig.hideField ||= this.config.hideField;
        });
      }
      if (!depConfig.hideField) {
        setTimeout(() => depControl.setValidators(depConfig.dynamicValidators));
        if (depConfig.optionsAPICallback) {
          depConfig.options = depConfig.optionsAPICallback(newVal);
        }
      } else if (key) {
        this.config.options.subscribe(opts => {
          let newDepOptions = opts[key];
          // Setting Options as Observable for Async pipe to work
          depConfig.options = of(newDepOptions);
          if (!newDepOptions.includes(depControl.value)) {
            depControl.setValue('');
          }
        });
      } else if (!depConfig.keepValue) {
        // New value is null when parent option is changed
        // Reset downstream options
        depConfig.value = null;
        depControl?.setValue(null);
        depConfig.options = [];
        depControl?.clearValidators();
        depControl?.updateValueAndValidity();
      }
    });
  }
  setBlurbState(newVal) {
    if (this.config.hasOwnProperty('displayBlurbOn')) {
      this.config.hideBlurb = this.config.displayBlurbOn.indexOf(newVal) < 0;
    }
  }
  registerDependentControls() {
    this.config.dependents.forEach(control => this.group.addControl(control.name, this.fb.control(null, control.validators)));
  }
  static {
    this.ɵfac = function FormSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormSelectComponent)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormSelectComponent,
      selectors: [["form-select"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 2,
      consts: [["class", "field form-select form-custom", 3, "formGroup", "ngClass", 4, "ngIf"], [4, "ngIf"], [1, "field", "form-select", "form-custom", 3, "formGroup", "ngClass"], ["class", "field-label", 4, "ngIf"], ["class", "field-widget", 4, "ngIf"], ["class", "space-top-xs", 4, "ngIf"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], [3, "formControlName", "id", 4, "ngIf"], ["class", "field-add-new", 4, "ngIf"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], ["class", "field-error", 4, "ngIf"], [1, "field-error"], [1, "icn-error_filled"], [3, "formControlName", "id"], [3, "disabled", "ngValue", 4, "ngFor", "ngForOf"], [3, "disabled", "ngValue"], [3, "ngValue"], [4, "ngFor", "ngForOf"], [1, "field-add-new"], ["type", "button", 1, "btn_text-link", 3, "click", "id"], ["class", "blurb field-blurb", 3, "id", 4, "ngIf"], [3, "ngClass"], [3, "ngValue", "disabled", 4, "ngFor", "ngForOf"], [1, "blurb", "field-blurb", 3, "id"], [3, "ngValue", "disabled"], [3, "actions"], [1, "space-top-xs"], ["type", "button", 1, "btn_text-link", 3, "click"], ["dynamicField", "", 3, "config", "group", 4, "ngFor", "ngForOf"], ["dynamicField", "", 3, "config", "group"]],
      template: function FormSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormSelectComponent_div_0_Template, 5, 9, "div", 0)(1, FormSelectComponent_div_1_Template, 2, 1, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.control.value);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormSelectComponent, [{
    type: Component,
    args: [{
      selector: 'form-select',
      template: `
            <div
              class="field form-select form-custom" *ngIf="!config.hideField"
              [formGroup]="group" [ngClass]="{'field-error': !control.valid && (control.dirty || control.touched), 'last': config.lastChild}">
                <div *ngIf="!config.hideLabel" class="field-label">
                    <label for="{{config.elementId}}{{modal?'modal':''}}">
                      {{config.label | translate}}
                      <i *ngIf="isRequired" class="req-indicator">*</i>
                    </label>
                </div>
                <div *ngIf="!config.customActions" class="field-widget">
                    <div *ngIf="config.blurb && !config.hideBlurb" class="blurb field-blurb" id="{{describedByValue}}" [innerHTML]="config.blurb | translate | safeHtml"></div>
                    <div role="alert" *ngIf="!control.valid && (control.dirty || control.touched)">
                        <div class="field-error" *ngIf="control.errors.required">
                            <i class="icn-error_filled"></i>
                            {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}
                        </div>
                    </div>
                    <select
                        *ngIf="!config.addNewItem || (config.addNewItem && !config.emptyPicklist)"
                        [formControlName]="config.name"
                        [attr.aria-describedby]="describedByValue"
                        id="{{config.elementId}}{{modal?'modal':''}}"
                    >
                        <ng-container *ngIf=!useGrouping>
                        <option *ngFor="let option of config.options | async" [disabled]="option.disabled" [ngValue]="option.id">
                            {{ option.display ? option.display : option }}
                        </option>
                        </ng-container>
                        <ng-container *ngIf=useGrouping>
                            <option [ngValue]="undefined">{{config.placeholder ?? ' '}}</option>
                            <ng-container *ngFor="let option of config.options | async | keyvalue: originalOrder">
                                <optgroup [attr.label]="option.key">
                                    <option *ngFor="let opt of option.value" [disabled]="opt.disabled" [ngValue]="opt.id">
                                        {{ opt.display ? opt.display : option }}
                                    </option>
                                </optgroup>
                            </ng-container>
                        </ng-container>
                    </select>
                    <div class="field-add-new" *ngIf="config.addNewItem && config.emptyPicklist"><button id="{{config.elementId}}{{modal?'modal':''}}" type="button" class="btn_text-link" (click)="config.addNewItem.addFunction(config)">{{ config.addNewItem.blurb }}</button></div>
                </div>
                <div *ngIf="config.customActions" class="field-widget">
                    <div *ngIf="config.blurb" class="blurb field-blurb" id="{{describedByValue}}">{{config.blurb | translate}}</div>
                    <div [ngClass]="{'flex-row' : config.customActions.displayInline}">
                        <div [ngClass]="{'flex-grow-1': config.customActions.displayInline}">
                            <select
                                [formControlName]="config.name"
                                [attr.aria-describedby]="describedByValue"
                                id="{{config.elementId}}{{modal?'modal':''}}">
                                <option *ngFor="let option of config.options | async"
                                    [ngValue]="option.id" [disabled]="option.disabled">
                                    {{ option.display ? option.display : option }}
                                </option>
                            </select>
                            <div role="alert" *ngIf="!control.valid && (control.dirty || control.touched)">
                                <div class="field-error" *ngIf="control.errors.required">
                                    <i class="icn-error_filled"></i>
                                    {{ 'misc.Field is required' | translate: {field_name: config.label} }}
                                </div>
                            </div>
                        </div>
                        <ng-container *ngIf="config.customActions && !config.customActions.hideAction">
                            <form-actions [actions]="config.customActions.actions"></form-actions>
                        </ng-container>
                    </div>
                </div>
                <div *ngIf="config.addNewItem && !config.emptyPicklist" class="space-top-xs">
                    {{ 'misc.or' | translate }} <button type="button" class="btn_text-link" (click)="config.addNewItem.addFunction(config)">{{ config.addNewItem.blurb }}</button>
                </div>
            </div>
            <div *ngIf='control.value'>
                <ng-container *ngFor="let field of config.dependents" dynamicField [config]="field" [group]="group"></ng-container>
            </div>

    `,
      standalone: false
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }, {
    type: i1$1.TranslateService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormSelectComponent, {
    className: "FormSelectComponent",
    filePath: "dynamic-form/components/form-select/form-select.component.ts",
    lineNumber: 89
  });
})();
const _c0$1u = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c1$1d = a0 => ({
  field_name: a0
});
const _c2$U = (a0, a1) => ({
  field_name: a0,
  max: a1
});
function FormTextareaComponent_div_0_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 10);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormTextareaComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormTextareaComponent_div_0_div_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$1d, ctx_r1.translatedLabel)), " ");
  }
}
function FormTextareaComponent_div_0_div_8_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Max length error", i0.ɵɵpureFunction2(4, _c2$U, ctx_r1.translatedLabel, ctx_r1.control.errors.maxlength.requiredLength)), " ");
  }
}
function FormTextareaComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, FormTextareaComponent_div_0_div_8_div_1_Template, 4, 6, "div", 13)(2, FormTextareaComponent_div_0_div_8_div_2_Template, 4, 7, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.maxlength);
  }
}
function FormTextareaComponent_div_0_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (ctx_r1.control.value.length < ctx_r1.config.maxLength ? ctx_r1.control.value.length : ctx_r1.config.maxLength) + "/" + ctx_r1.config.maxLength, " ");
  }
}
function FormTextareaComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "label", 3);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, FormTextareaComponent_div_0_i_5_Template, 2, 0, "i", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵtemplate(7, FormTextareaComponent_div_0_div_7_Template, 3, 6, "div", 6)(8, FormTextareaComponent_div_0_div_8_Template, 3, 2, "div", 7);
    i0.ɵɵelementStart(9, "textarea", 8);
    i0.ɵɵlistener("keypress", function FormTextareaComponent_div_0_Template_textarea_keypress_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.control.markAsTouched());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, FormTextareaComponent_div_0_div_10_Template, 2, 1, "div", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(18, _c0$1u, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild))("formGroup", ctx_r1.group);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 16, ctx_r1.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵproperty("formControlName", ctx_r1.config.name)("maxlength", ctx_r1.config.maxLength ? ctx_r1.config.maxLength : null);
    i0.ɵɵattribute("aria-describedby", ctx_r1.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.maxLength && ctx_r1.control.value);
  }
}
class FormTextareaComponent extends FormInputComponent {
  constructor(translate) {
    super(translate);
    this.translate = translate;
    this.translatedLabel = '';
  }
  ngOnInit() {
    this.translatedLabel = this.translate.instant(this.config.label);
    if (this.config.value) {
      setTimeout(() => {
        this.control.setValue(this.config.value, {
          'emitEvent': false,
          'emitModelToViewChange': true
        });
      });
    }
  }
  static {
    this.ɵfac = function FormTextareaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormTextareaComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormTextareaComponent,
      selectors: [["form-textarea"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "field form-textarea form-custom", 3, "ngClass", "formGroup", 4, "ngIf"], [1, "field", "form-textarea", "form-custom", 3, "ngClass", "formGroup"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], ["rows", "5", 1, "form-control", 3, "keypress", "formControlName", "id", "maxlength"], ["class", "character-count", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [4, "ngIf"], [1, "icn-error_filled"], [1, "character-count"]],
      template: function FormTextareaComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormTextareaComponent_div_0_Template, 11, 21, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.MaxLengthValidator, i1.NgClass, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormTextareaComponent, [{
    type: Component,
    args: [{
      selector: 'form-textarea',
      template: `
        <div *ngIf="!config.hideField" class="field form-textarea form-custom"
             [ngClass]="{'field-error': !control.valid && (control.dirty || control.touched), 'last':config.lastChild}" [formGroup]="group">
            <div class="field-label">
                <label for="{{config.elementId}}{{modal?'modal':''}}">
                    {{config.label | translate}}
                    <i *ngIf="isRequired" class="req-indicator">*</i>
                </label>
            </div>
            <div class="field-widget">
                <div *ngIf="config.blurb" class="blurb field-blurb" id="{{describedByValue}}" [innerHTML]="config.blurb | translate | safeHtml"></div>
                <div role="alert" *ngIf="!control.valid && (control.dirty || control.touched)">
                    <div *ngIf="control.errors.required">
                        <i class="icn-error_filled"></i>
                        {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}
                    </div>
                    <div *ngIf="control.errors.maxlength">
                        <i class="icn-error_filled"></i>
                        {{ 'misc.Max length error' | translate: {field_name: translatedLabel, max: control.errors.maxlength!.requiredLength} }}
                    </div>
                </div>
                <textarea
                        class="form-control"
                        rows="5"
                        (keypress)="control.markAsTouched()"
                        [formControlName]="config.name"
                        id="{{config.elementId}}{{modal?'modal':''}}"
                        [attr.aria-describedby]="describedByValue"
                        [maxlength]="config.maxLength ? config.maxLength : null"
                ></textarea>
                <div class="character-count" *ngIf="config.maxLength && control.value">
                    {{ (control.value.length < config.maxLength ? control.value.length : config.maxLength) + '/' + config.maxLength }}
                </div>
            </div>
        </div>
    `,
      standalone: false
    }]
  }], () => [{
    type: i1$1.TranslateService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormTextareaComponent, {
    className: "FormTextareaComponent",
    filePath: "dynamic-form/components/form-textarea/form-textarea.component.ts",
    lineNumber: 45
  });
})();
const _c0$1t = a0 => ({
  "last": a0
});
const _c1$1c = a0 => ({
  field_name: a0
});
const _c2$T = (a0, a1, a2) => ({
  field_name: a0,
  min: a1,
  max: a2
});
function FormRangeComponent_div_0_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 11);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormRangeComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(1, 1, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormRangeComponent_div_0_div_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$1c, ctx_r0.translatedLabel)), " ");
  }
}
function FormRangeComponent_div_0_div_8_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field range should be", i0.ɵɵpureFunction3(4, _c2$T, ctx_r0.translatedLabel, ctx_r0.minValue, ctx_r0.maxValue)), " ");
  }
}
function FormRangeComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, FormRangeComponent_div_0_div_8_div_1_Template, 4, 6, "div", 14)(2, FormRangeComponent_div_0_div_8_div_2_Template, 4, 8, "div", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.incorrectValue);
  }
}
function FormRangeComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "span", 3);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, FormRangeComponent_div_0_i_5_Template, 2, 0, "i", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵtemplate(7, FormRangeComponent_div_0_div_7_Template, 3, 5, "div", 6)(8, FormRangeComponent_div_0_div_8_Template, 3, 2, "div", 7);
    i0.ɵɵelement(9, "input", 8);
    i0.ɵɵelementStart(10, "span", 9);
    i0.ɵɵtext(11, "misc.to");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "input", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.group)("ngClass", i0.ɵɵpureFunction1(17, _c0$1t, ctx_r0.config.lastChild));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "lbl_", ctx_r0.config.elementId, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 15, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-labelledby", "lbl_" + ctx_r0.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r0.inputType)("formControl", ctx_r0.fromInputControl);
    i0.ɵɵattribute("placeholder", ctx_r0.config.placeholder[0]);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r0.inputType)("formControl", ctx_r0.toInputControl);
    i0.ɵɵattribute("placeholder", ctx_r0.config.placeholder[1]);
  }
}
class FormRangeComponent extends FormInputComponent {
  constructor(translate) {
    super(translate);
    this.translate = translate;
    this.inputType = 'text';
    this.translatedLabel = '';
  }
  ngOnInit() {
    this.translatedLabel = this.translate.instant(this.config.label);
    if (typeof this.config.inputType !== 'undefined') {
      this.inputType = this.config.inputType;
    }
    if (typeof this.config.value !== 'undefined') {
      if (typeof this.config.value.from == 'undefined') {
        this.config.value.from = this.config.value[0] ?? '';
      }
      if (typeof this.config.value.to == 'undefined') {
        this.config.value.to = this.config.value[1] ?? '';
      }
    } else {
      this.config.value = {
        from: '',
        to: ''
      };
    }
    if (typeof this.config.minValue !== 'undefined') {
      this.minValue = this.config.minValue;
    }
    if (typeof this.config.maxValue !== 'undefined') {
      this.maxValue = this.config.maxValue;
    }
    this.rangeFG = new UntypedFormGroup({
      from: new UntypedFormControl(this.config.value.from),
      to: new UntypedFormControl(this.config.value.to)
    });
    this.rangeFG.valueChanges.subscribe(selectedValue => {
      if (typeof this.config.onChangeCallback !== 'undefined') {
        this.config.onChangeCallback(this.config.name, selectedValue);
      }
      if (isNaN(selectedValue.from) || isNaN(selectedValue.to)) {
        this.control.setErrors({
          'incorrectValue': true
        });
      } else if (typeof this.minValue !== 'undefined' && typeof this.maxValue !== 'undefined') {
        if ((Number(selectedValue.from) < this.minValue || Number(selectedValue.to) > this.maxValue || Number(selectedValue.from) > Number(selectedValue.to) || selectedValue.from === "" && selectedValue.to !== "" || selectedValue.from !== "" && selectedValue.to === "") && (selectedValue.from !== "" || selectedValue.to !== "")) {
          this.control.setErrors({
            'incorrectValue': true
          });
        } else {
          this.control.setErrors(null);
        }
      }
    });
    this.group.setControl(this.config.name, this.rangeFG); // replaces current control with new formgroup
  }
  get fromInputControl() {
    return this.group.get(this.config.name + '.from');
  }
  get toInputControl() {
    return this.group.get(this.config.name + '.to');
  }
  static {
    this.ɵfac = function FormRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormRangeComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormRangeComponent,
      selectors: [["form-range"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "field form-range field-custom", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "field", "form-range", "field-custom", 3, "formGroup", "ngClass"], [1, "field-label"], [3, "id"], ["class", "req-indicator", 4, "ngIf"], ["role", "group", 1, "field-widget"], ["class", "blurb field-blurb", 3, "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], ["aria-label", "From", 1, "input-text", "input-range-sm", 3, "type", "formControl"], ["translate", "", 1, "range-separator"], ["aria-label", "To", 1, "input-text", "input-range-sm", 3, "type", "formControl"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "innerHTML"], ["role", "alert"], ["class", "field-error", 4, "ngIf"], [1, "field-error"], [1, "icn-error_filled"]],
      template: function FormRangeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormRangeComponent_div_0_Template, 13, 19, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgIf, i2$1.FormControlDirective, i2$1.FormGroupDirective, i1$1.TranslateDirective, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: [".input-range-sm{width:44%!important;display:inline-block}.form-range input:first-child{margin-right:5px}.form-range input:nth-of-type(2){margin-left:5px}.form-range .range-separator{margin:0 1px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormRangeComponent, [{
    type: Component,
    args: [{
      selector: 'form-range',
      template: `
        <div
                class="field form-range field-custom"
                *ngIf="!config.hideField" [formGroup]="group" [ngClass]="{'last':config.lastChild}">
            <div class="field-label">
                <span id="lbl_{{config.elementId}}">
                    {{config.label | translate}}
                    <i *ngIf="isRequired" class="req-indicator">*</i>
                </span>
            </div>
            <div class="field-widget" role="group" [attr.aria-labelledby]="'lbl_' + config.elementId">
                <div *ngIf="config.blurb" class="blurb field-blurb" [innerHTML]="config.blurb | translate | safeHtml"></div>
                <div role="alert" *ngIf="!control.valid && (control.dirty || control.touched)">
                    <div class="field-error" *ngIf="control.errors.required">
                        <i class="icn-error_filled"></i>
                        {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}
                    </div>
                    <div class="field-error" *ngIf="control.errors.incorrectValue">
                        <i class="icn-error_filled"></i>
                        {{ 'misc.Field range should be' | translate: {field_name: translatedLabel, min: minValue, max: maxValue} }}
                    </div>
                </div>
                <input
                        [type]="inputType"
                        [attr.placeholder]="config.placeholder[0]"
                        aria-label="From"
                        [formControl]="fromInputControl" class="input-text input-range-sm"/>
                <span class="range-separator" translate>misc.to</span>
                <input
                        [type]="inputType"
                        [attr.placeholder]="config.placeholder[1]"
                        aria-label="To"
                        [formControl]="toInputControl"
                        class="input-text input-range-sm"
                        />
            </div>
        </div>
    `,
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      styles: [".input-range-sm{width:44%!important;display:inline-block}.form-range input:first-child{margin-right:5px}.form-range input:nth-of-type(2){margin-left:5px}.form-range .range-separator{margin:0 1px}\n"]
    }]
  }], () => [{
    type: i1$1.TranslateService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormRangeComponent, {
    className: "FormRangeComponent",
    filePath: "dynamic-form/components/form-range/form-range.component.ts",
    lineNumber: 50
  });
})();
class CheckboxItem {
  constructor(id, display, isChecked = false, disabled = false, extraLabels = []) {
    this.id = id;
    this.display = display;
    this.isChecked = isChecked;
    this.disabled = disabled;
    this.extraLabels = extraLabels;
  }
}
const _c0$1s = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c1$1b = a0 => ({
  field_name: a0
});
const _c2$S = () => ({
  standalone: true
});
function FormCheckboxComponent_div_0_div_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 12);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormCheckboxComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "label", 10);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, FormCheckboxComponent_div_0_div_1_i_4_Template, 2, 0, "i", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵattribute("aria-required", ctx_r0.isRequired);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
  }
}
function FormCheckboxComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 13);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r0.describedByValue)("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormCheckboxComponent_div_0_div_4_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$1b, ctx_r0.translatedLabel)), " ");
  }
}
function FormCheckboxComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵtemplate(2, FormCheckboxComponent_div_0_div_4_span_2_Template, 3, 6, "span", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function FormCheckboxComponent_div_0_div_7_Conditional_5_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "br");
    i0.ɵɵelementStart(1, "span", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const extraLabel_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(extraLabel_r4);
  }
}
function FormCheckboxComponent_div_0_div_7_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, FormCheckboxComponent_div_0_div_7_Conditional_5_For_1_Template, 3, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵrepeater(item_r3.extraLabels);
  }
}
function FormCheckboxComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "input", 18);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function FormCheckboxComponent_div_0_div_7_Template_input_ngModelChange_1_listener($event) {
      const item_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      i0.ɵɵtwoWayBindingSet(item_r3.isChecked, $event) || (item_r3.isChecked = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormCheckboxComponent_div_0_div_7_Template_input_ngModelChange_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onCheckboxValueChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 19);
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, FormCheckboxComponent_div_0_div_7_Conditional_5_Template, 2, 0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "-", item_r3.id, "");
    i0.ɵɵtwoWayProperty("ngModel", item_r3.isChecked);
    i0.ɵɵproperty("disabled", item_r3.disabled)("ngModelOptions", i0.ɵɵpureFunction0(17, _c2$S));
    i0.ɵɵattribute("name", ctx_r0.config.name)("aria-checked", item_r3.isChecked)("aria-required", ctx_r0.isRequired)("aria-label", i0.ɵɵpipeBind1(2, 15, ctx_r0.config.label) + " " + item_r3.display);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "-", item_r3.id, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.display, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional((item_r3.extraLabels == null ? null : item_r3.extraLabels.length) ? 5 : -1);
  }
}
function FormCheckboxComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "button", 22);
    i0.ɵɵlistener("click", function FormCheckboxComponent_div_0_div_8_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.config.addNewItem.addFunction(ctx_r0.config));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.config.addNewItem.blurb);
  }
}
function FormCheckboxComponent_div_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "button", 23);
    i0.ɵɵlistener("click", function FormCheckboxComponent_div_0_div_9_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.config.addNewItem.addFunction(ctx_r0.config));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "misc.or"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.config.addNewItem.blurb);
  }
}
function FormCheckboxComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, FormCheckboxComponent_div_0_div_1_Template, 5, 8, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, FormCheckboxComponent_div_0_div_3_Template, 3, 6, "div", 4)(4, FormCheckboxComponent_div_0_div_4_Template, 3, 1, "div", 5);
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtemplate(7, FormCheckboxComponent_div_0_div_7_Template, 6, 18, "div", 6)(8, FormCheckboxComponent_div_0_div_8_Template, 3, 4, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, FormCheckboxComponent_div_0_div_9_Template, 5, 4, "div", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c0$1s, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild))("formGroup", ctx_r0.group);
    i0.ɵɵattribute("aria-labelledby", ctx_r0.config.elementId + (ctx_r0.modal ? "modal" : ""))("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", !!ctx_r0.config.legendText ? "group" : null)("aria-label", !!ctx_r0.config.legendText ? i0.ɵɵpipeBind1(6, 12, ctx_r0.config.legendText) : null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.addNewItem && ctx_r0.config.emptyPicklist);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.addNewItem && !ctx_r0.config.emptyPicklist);
  }
}
class FormCheckboxComponent extends FormInputComponent {
  constructor() {
    super(...arguments);
    this.useFilter = false;
    this.useSelectAll = false;
    this.useScrollableList = false;
    this.scrollableListThreshold = 5;
    this.items = [];
    this.items$ = new BehaviorSubject([]);
    this.filterKey = '';
    this.allItemsSelected = false;
    this.itemsSelectedCount = 0;
    this.checkboxConfigKeys = ['useFilter', 'useSelectAll', 'useScrollableList', 'scrollableListThreshold'];
    this.destroyed$ = new Subject();
  }
  ngOnInit() {
    this.defaultInit();
    this.applyCheckboxConfigs(this.checkboxConfigKeys);
    this.setItems();
    this.watchControlValue();
    if (this.useFilter) {
      this.watchFilterControlValue();
    }
    if (this.config.value) {
      this.control.setValue(this.config.value, {
        'emitEvent': false,
        'emitModelToViewChange': true
      });
      setTimeout(() => {
        this.setCheckboxesValues(true);
      });
    }
  }
  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  toggleAllSelected(deselectAll = false) {
    const filteredItemsIds = this.getFilteredItems().map(item => item.id);
    this.items = this.items.map(item => {
      if (!item.disabled) {
        item.isChecked = deselectAll ? false : filteredItemsIds.includes(item.id) ? !this.allItemsSelected : item.isChecked;
      }
      return item;
    });
    this.onValueChanges();
    this.updateAvailableItems();
  }
  onCheckboxValueChange() {
    this.onValueChanges();
    this.updateAvailableItems();
  }
  updateAvailableItems() {
    const filteredItems = this.getFilteredItems();
    const checkedItems = this.getCheckedItems(filteredItems);
    this.itemsSelectedCount = checkedItems.length;
    this.allItemsSelected = this.itemsSelectedCount === filteredItems.filter(item => !item.disabled).length;
    this.items$.next(filteredItems);
  }
  getFilteredItems() {
    return this.items.filter(item => item.display.toLowerCase().includes(this.filterKey.toLowerCase()));
  }
  getCheckedItems(items) {
    return items.filter(item => item.isChecked);
  }
  applyCheckboxConfigs(checkboxConfigKeys) {
    checkboxConfigKeys.filter(key => typeof this.config[key] !== 'undefined' && this.hasOwnProperty(key)).forEach(key => this[key] = this.config[key]);
  }
  setItems() {
    if (this.config.options instanceof Observable) {
      this.config.options.pipe(takeUntil(this.destroyed$)).subscribe(options => {
        if (this.items.length === 0) {
          this.items = options.map(option => new CheckboxItem(option.id, option.display, false, option.disabled, option.extraLabels));
        }
        this.setCheckboxesValues();
      });
    } else {
      return;
    }
  }
  watchControlValue() {
    this.control.valueChanges.pipe(filter(value => !Array.isArray(value)), takeUntil(this.destroyed$)).subscribe(value => {
      if (this.config.soWidget !== 'monocheck') {
        this.control.setValue(_.isNil(value) ? [] : [value], {
          emitEvent: false
        });
      }
      this.setCheckboxesValues();
    });
  }
  watchFilterControlValue() {
    this.filterControl = new UntypedFormControl({
      value: '',
      disabled: this.control.disabled
    });
    this.filterControl.valueChanges.pipe(debounceTime(150), map((value = '') => value.trim()), takeUntil(this.destroyed$)).subscribe(value => {
      this.filterKey = value;
      this.updateAvailableItems();
    });
  }
  setCheckboxesValues(onInit = false) {
    if (this.control.value) {
      const values = !Array.isArray(this.control.value) ? [this.control.value] : this.control.value;
      let newValues = values.map(value => _.isObject(value) && value.hasOwnProperty('_id') ? value['_id'] : value);
      this.items.forEach(item => {
        item.isChecked = newValues.includes(item.id);
      });
      if (!onInit && values.length) {
        this.onValueChanges();
      }
    }
    this.updateAvailableItems();
  }
  onValueChanges() {
    if (this.control.untouched) {
      setTimeout(() => {
        this.control.markAsTouched();
        this.control.updateValueAndValidity();
      });
    }
    const value = this.config.soWidget === 'monocheck' ? this.items[0].isChecked ? this.items[0].id : null : this.items.filter(item => item.isChecked).map(item => item.id);
    if (!_.isEqual(value, this.control.value)) {
      this.control.setValue(value);
    }
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵFormCheckboxComponent_BaseFactory;
      return function FormCheckboxComponent_Factory(__ngFactoryType__) {
        return (ɵFormCheckboxComponent_BaseFactory || (ɵFormCheckboxComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormCheckboxComponent)))(__ngFactoryType__ || FormCheckboxComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormCheckboxComponent,
      selectors: [["form-checkbox"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "field form-checkbox", "role", "group", 3, "ngClass", "formGroup", 4, "ngIf"], ["role", "group", 1, "field", "form-checkbox", 3, "ngClass", "formGroup"], ["class", "field-label", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["class", "field-add-new", 4, "ngIf"], [4, "ngIf"], [1, "field-label"], [3, "id"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [1, "icn-error_filled"], ["class", "field-error", 4, "ngIf"], [1, "field-error"], ["type", "checkbox", 1, "input-checkbox", 3, "ngModelChange", "id", "ngModel", "disabled", "ngModelOptions"], [1, "vertical-radio-group", 3, "for"], [1, "text-muted", "fs-6"], [1, "field-add-new"], ["type", "button", 1, "btn_text-link", 3, "click", "id"], ["type", "button", 1, "btn_text-link", 3, "click"]],
      template: function FormCheckboxComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormCheckboxComponent_div_0_Template, 10, 17, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.CheckboxControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.NgModel, i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormCheckboxComponent, [{
    type: Component,
    args: [{
      selector: 'form-checkbox',
      standalone: false,
      template: "<div\n    *ngIf=\"!config.hideField\"\n    class=\"field form-checkbox\"\n    role=\"group\"\n    [ngClass]=\"{\n        'field-error': !control.valid && (control.dirty || control.touched),\n        'last': config.lastChild\n    }\"\n    [attr.aria-labelledby]=\"config.elementId + (modal?'modal':'')\"\n    [attr.aria-describedby]=\"describedByValue\"\n    [formGroup]=\"group\"\n>\n    <div *ngIf=\"!config.hideLabel\" class=\"field-label\">\n        <label id=\"{{ config.elementId }}{{ modal ? 'modal' : '' }}\" [attr.aria-required]=\"isRequired\">\n            {{ config.label | translate }}\n            <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n        </label>\n    </div>\n    \n    <div class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" class=\"blurb field-blurb\" [id]=\"describedByValue\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n\n        <div *ngIf=\"!control.valid && (control.dirty || control.touched)\" role=\"alert\">\n            <i class=\"icn-error_filled\"></i>\n            \n            <span *ngIf=\"control.errors.required\" class=\"field-error\">\n                {{ 'misc.Field is required' | translate: { field_name: translatedLabel } }}\n            </span>\n        </div>\n        \n        <div [attr.role]=\"!!config.legendText ? 'group' : null\" [attr.aria-label]=\"!!config.legendText ? (config.legendText | translate) : null\">\n            <div *ngFor=\"let item of items\">\n                <input\n                    type=\"checkbox\"\n                    class=\"input-checkbox\"\n                    id=\"{{ config.elementId }}-{{ item.id }}\"\n                    [attr.name]=\"config.name\"\n                    [attr.aria-checked]=\"item.isChecked\"\n                    [attr.aria-required]=\"isRequired\"\n                    [attr.aria-label]=\"(config.label | translate) + ' ' + item.display\"\n                    [(ngModel)]=\"item.isChecked\"\n                    [disabled]=\"item.disabled\"\n                    [ngModelOptions]=\"{ standalone: true }\"\n                    (ngModelChange)=\"onCheckboxValueChange()\"\n                />\n\n                <label class=\"vertical-radio-group\" for=\"{{ config.elementId }}-{{ item.id }}\">\n                    {{ item.display }}\n                    @if (item.extraLabels?.length) {\n                    @for (extraLabel of item.extraLabels; track extraLabel) {\n                    <br>\n                    <span class=\"text-muted fs-6\">{{ extraLabel }}</span>\n                    }\n                    }\n                </label>\n            </div>\n            <div class=\"field-add-new\" *ngIf=\"config.addNewItem && config.emptyPicklist\"><button id=\"{{config.elementId}}{{modal?'modal':''}}\" type=\"button\" class=\"btn_text-link\" (click)=\"config.addNewItem.addFunction(config)\">{{ config.addNewItem.blurb }}</button></div>\n        </div>\n        <div *ngIf=\"config.addNewItem && !config.emptyPicklist\">\n            {{ 'misc.or' | translate }} <button type=\"button\" class=\"btn_text-link\" (click)=\"config.addNewItem.addFunction(config)\">{{ config.addNewItem.blurb }}</button>\n        </div>\n    </div>\n</div>\n"
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormCheckboxComponent, {
    className: "FormCheckboxComponent",
    filePath: "dynamic-form/components/form-checkbox/form-checkbox.component.ts",
    lineNumber: 14
  });
})();
const _c0$1r = a0 => ({
  "last": a0
});
const _c1$1a = a0 => ({
  field_name: a0
});
function FormRadioComponent_div_0_div_1_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 10);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormRadioComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, FormRadioComponent_div_0_div_1_i_3_Template, 2, 0, "i", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.config.elementId);
    i0.ɵɵattribute("aria-required", ctx_r0.isRequired);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
  }
}
function FormRadioComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormRadioComponent_div_0_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$1a, ctx_r0.translatedLabel)), " ");
  }
}
function FormRadioComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, FormRadioComponent_div_0_div_4_div_1_Template, 4, 6, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors == null ? null : ctx_r0.control.errors.required);
  }
}
function FormRadioComponent_div_0_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 16);
    i0.ɵɵlistener("click", function FormRadioComponent_div_0_ng_container_5_Template_input_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.control.markAsTouched());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "-", option_r3.id, "");
    i0.ɵɵproperty("formControlName", ctx_r0.config.name)("value", option_r3.id);
    i0.ɵɵattribute("disabled", option_r3.disabled || null)("name", ctx_r0.config.name);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "-", option_r3.id, "");
    i0.ɵɵproperty("ngClass", ctx_r0.ngClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r3.display);
  }
}
function FormRadioComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, FormRadioComponent_div_0_div_1_Template, 4, 6, "div", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtemplate(3, FormRadioComponent_div_0_div_3_Template, 3, 6, "div", 5)(4, FormRadioComponent_div_0_div_4_Template, 2, 1, "div", 6)(5, FormRadioComponent_div_0_ng_container_5_Template, 4, 12, "ng-container", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.group)("ngClass", i0.ɵɵpureFunction1(8, _c0$1r, ctx_r0.config.lastChild));
    i0.ɵɵattribute("aria-labelledby", ctx_r0.config.elementId)("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.options);
  }
}
function FormRadioComponent_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 19);
  }
  if (rf & 2) {
    const field_r4 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r4)("group", ctx_r0.group);
  }
}
function FormRadioComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormRadioComponent_div_1_ng_container_1_Template, 1, 2, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.dependents);
  }
}
class FormRadioComponent extends FormInputComponent {
  constructor(fb, translate) {
    super(translate);
    this.fb = fb;
    this.translate = translate;
    this.ngClass = 'vertical-radio-group';
  }
  ngOnInit() {
    this.defaultInit();
    if (['onoff', 'yesno'].indexOf(this.config.soWidget) > -1) {
      this.ngClass = 'horizontal-radio-group';
    }
    if (this.config.dependents) {
      this.control.valueChanges.subscribe(newVal => this.setupDependentsState(newVal));
      this.registerDependentControls();
    }
    this.setDescribedBy();
    setTimeout(() => {
      let value = this.config.value;
      if (value || value === 0) {
        value = value.toString();
      }
      this.control.setValue(value, {
        'emitEvent': true,
        'emitModelToViewChange': true
      });
    });
  }
  setupDependentsState(newVal) {
    this.config.dependents.forEach(depConfig => {
      let depControl = this.group.controls[depConfig.name];
      if (depConfig.hasOwnProperty('displayOn')) {
        depConfig.hideField = depConfig.displayOn.indexOf(newVal) < 0;
      }
      if (!depConfig.hideField) {
        if (depConfig.optionsAPICallback) {
          depConfig.options = depConfig.optionsAPICallback(newVal);
        }
        if (depConfig.onDisplayCallback) {
          depConfig.onDisplayCallback(depControl, newVal);
        }
        depControl.setValidators(depConfig.dynamicValidators);
      } else {
        // New value is null when parent option is changed
        // Reset downstream options
        depConfig.value = null;
        depControl.setValue(null);
        depConfig.options = [];
        depControl.clearValidators();
      }
      depControl.updateValueAndValidity();
    });
  }
  registerDependentControls() {
    this.config.dependents.forEach(control => this.group.addControl(control.name, this.fb.control(null, control.validators)));
  }
  static {
    this.ɵfac = function FormRadioComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormRadioComponent)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormRadioComponent,
      selectors: [["form-radio"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 2,
      consts: [["role", "radiogroup", "class", "field form-radio field-custom", 3, "formGroup", "ngClass", 4, "ngIf"], [4, "ngIf"], ["role", "radiogroup", 1, "field", "form-radio", "field-custom", 3, "formGroup", "ngClass"], ["class", "field-label", 3, "id", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "field-label", 3, "id"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], ["class", "field-error", 4, "ngIf"], [1, "field-error"], [1, "icn-error_filled"], ["type", "radio", 1, "input-radio", 3, "click", "formControlName", "value", "id"], [3, "ngClass", "for"], ["dynamicField", "", 3, "config", "group", 4, "ngFor", "ngForOf"], ["dynamicField", "", 3, "config", "group"]],
      template: function FormRadioComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormRadioComponent_div_0_Template, 6, 10, "div", 0)(1, FormRadioComponent_div_1_Template, 2, 1, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.control.value);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormRadioComponent, [{
    type: Component,
    args: [{
      selector: 'form-radio',
      template: `
            <div *ngIf="!config.hideField" role="radiogroup" class="field form-radio field-custom" [formGroup]="group" [ngClass]="{'last':config.lastChild}" [attr.aria-labelledby]="config.elementId" [attr.aria-describedby]="describedByValue">
                <div *ngIf="!config.hideLabel" class="field-label" id="{{config.elementId}}" [attr.aria-required]="isRequired">
                        {{config.label | translate}}
                        <i *ngIf="isRequired" class="req-indicator">*</i>
                </div>
                <div class="field-widget">
                    <div *ngIf="config.blurb" id="{{describedByValue}}" class="blurb field-blurb" [innerHTML]="config.blurb | translate | safeHtml"></div>
                    <div role="alert" *ngIf="!control.valid && (control.dirty || control.touched)">
                        <div class="field-error" *ngIf="control.errors?.required">
                            <i class="icn-error_filled"></i>
                            {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}
                        </div>
                    </div>
                    <ng-container *ngFor="let option of config.options; let i = index">
                        <input
                            type="radio"
                            class="input-radio"
                            [attr.disabled]="option.disabled || null"
                            [formControlName]="config.name"
                            [attr.name]="config.name"
                            [value]="option.id"
                            id="{{config.elementId}}-{{option.id}}"
                            (click)="control.markAsTouched()"
                        >
                        <label [ngClass]="ngClass" for="{{config.elementId}}-{{option.id}}">{{option.display}}</label>
                    </ng-container>
                </div>
            </div>
            <div *ngIf='control.value'>
                <ng-container *ngFor="let field of config.dependents" dynamicField [config]="field" [group]="group"></ng-container>
            </div>

    `,
      standalone: false
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }, {
    type: i1$1.TranslateService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormRadioComponent, {
    className: "FormRadioComponent",
    filePath: "dynamic-form/components/form-radio/form-radio.component.ts",
    lineNumber: 44
  });
})();
class RelationField {
  constructor(fieldValue) {
    this.id = fieldValue._id;
    this.label = fieldValue._label;
  }
}
function FormActionButtonComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 1);
    i0.ɵɵlistener("click", function FormActionButtonComponent_ng_container_0_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      $event.preventDefault();
      return i0.ɵɵresetView(ctx_r1.action.onClick($event));
    })("keyup.enter", function FormActionButtonComponent_ng_container_0_Template_button_keyup_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      $event.preventDefault();
      return i0.ɵɵresetView(ctx_r1.action.onClick($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("btn ", ctx_r1.action.class, "");
    i0.ɵɵpropertyInterpolate("type", ctx_r1.action.buttonType);
    i0.ɵɵproperty("ngClass", ctx_r1.action.styleClass)("disabled", ctx_r1.action.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.action.label, " ");
  }
}
class FormActionButtonComponent {
  static {
    this.ɵfac = function FormActionButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormActionButtonComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormActionButtonComponent,
      selectors: [["form-action-button"]],
      inputs: {
        action: "action"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [[4, "ngIf"], [3, "click", "keyup.enter", "type", "ngClass", "disabled"]],
      template: function FormActionButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormActionButtonComponent_ng_container_0_Template, 3, 7, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.action);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormActionButtonComponent, [{
    type: Component,
    args: [{
      selector: 'form-action-button',
      template: `<ng-container *ngIf="action">
                    <button class="btn {{action.class}}" 
                        type="{{action.buttonType}}" 
                        [ngClass]="action.styleClass" 
                        (click)="$event.preventDefault(); action.onClick($event)" 
                        (keyup.enter)="$event.preventDefault(); action.onClick($event)" 
                        [disabled]="action.disabled">
                            {{action.label}}
                    </button>
                </ng-container>`,
      standalone: false
    }]
  }], null, {
    action: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormActionButtonComponent, {
    className: "FormActionButtonComponent",
    filePath: "common/form-action-button.component.ts",
    lineNumber: 17
  });
})();
function FormActionAnchorComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 1);
    i0.ɵɵlistener("click", function FormActionAnchorComponent_ng_container_0_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      return i0.ɵɵresetView($event.stopPropagation());
    })("keydown.enter", function FormActionAnchorComponent_ng_container_0_Template_a_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.action.class);
    i0.ɵɵproperty("ngClass", ctx_r1.action.styleClass);
    i0.ɵɵattribute("href", ctx_r1.action.href, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.action.label, " ");
  }
}
class FormActionAnchorComponent {
  static {
    this.ɵfac = function FormActionAnchorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormActionAnchorComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormActionAnchorComponent,
      selectors: [["form-action-anchor"]],
      inputs: {
        action: "action"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [[4, "ngIf"], [3, "click", "keydown.enter", "ngClass"]],
      template: function FormActionAnchorComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormActionAnchorComponent_ng_container_0_Template, 3, 6, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.action);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormActionAnchorComponent, [{
    type: Component,
    args: [{
      selector: 'form-action-anchor',
      template: `<ng-container *ngIf="action">
                    <a [attr.href]="action.href" 
                        class="{{action.class}}" 
                        [ngClass]="action.styleClass" 
                        (click)="$event.stopPropagation()" 
                        (keydown.enter)="$event.stopPropagation()">
                      {{action.label}}
                    </a>
               </ng-container>`,
      standalone: false
    }]
  }], null, {
    action: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormActionAnchorComponent, {
    className: "FormActionAnchorComponent",
    filePath: "common/form-action-anchor.component.ts",
    lineNumber: 16
  });
})();
function FormActionsComponent_ng_container_0_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "form-action-anchor", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const action_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("action", action_r1);
  }
}
function FormActionsComponent_ng_container_0_ng_container_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "form-action-button", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const action_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("action", action_r1);
  }
}
function FormActionsComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 2);
    i0.ɵɵtemplate(2, FormActionsComponent_ng_container_0_ng_container_1_ng_container_2_Template, 2, 1, "ng-container", 3)(3, FormActionsComponent_ng_container_0_ng_container_1_ng_container_3_Template, 2, 1, "ng-container", 3);
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const action_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", action_r1.element);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "anchor");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "button");
  }
}
function FormActionsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormActionsComponent_ng_container_0_ng_container_1_Template, 4, 3, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.actions);
  }
}
class FormActionsComponent {
  constructor() {
    this.actions = [];
  }
  static {
    this.ɵfac = function FormActionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormActionsComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormActionsComponent,
      selectors: [["form-actions"]],
      inputs: {
        actions: "actions"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "inline", 3, "ngSwitch"], [4, "ngSwitchCase"], [3, "action"]],
      template: function FormActionsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormActionsComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.actions);
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i1.NgSwitch, i1.NgSwitchCase, FormActionButtonComponent, FormActionAnchorComponent],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormActionsComponent, [{
    type: Component,
    args: [{
      selector: 'form-actions',
      template: `<ng-container *ngIf="actions">
                    <ng-container *ngFor="let action of actions">
                        <ng-container [ngSwitch]="action.element" class="inline">
                            <ng-container *ngSwitchCase="'anchor'">
                                <form-action-anchor [action]="action"></form-action-anchor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'button'">
                                <form-action-button [action]="action"></form-action-button>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>`,
      standalone: false
    }]
  }], null, {
    actions: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormActionsComponent, {
    className: "FormActionsComponent",
    filePath: "common/form-actions.component.ts",
    lineNumber: 18
  });
})();
const _c0$1q = (a0, a1) => ({
  "last": a0,
  "space-bottom-xs": a1
});
const _c1$19 = (a0, a1) => ({
  "field-widget-tinymce": a0,
  "field-widget-text": a1
});
const _c2$R = a0 => ({
  "field-label-has-blurb": a0
});
const _c3$C = () => ["pills", "file"];
const _c4$u = () => [];
const _c5$l = a0 => ({
  "chip-success": a0
});
function FormStaticComponent_div_0_div_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 9);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormStaticComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FormStaticComponent_div_0_div_1_i_4_Template, 2, 0, "i", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c2$R, ctx_r0.config.blurb));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
  }
}
function FormStaticComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(1, 1, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormStaticComponent_div_0_ng_container_5_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 13);
    i0.ɵɵpipe(1, "sanitizeInputHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.config.elementId);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 4, ctx_r0.fieldDisplayValue), i0.ɵɵsanitizeHtml)("ngStyle", ctx_r0.config.style)("ngClass", ctx_r0.config.class);
  }
}
function FormStaticComponent_div_0_ng_container_5_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.config.elementId);
    i0.ɵɵproperty("innerHTML", ctx_r0.config.translate, i0.ɵɵsanitizeHtml)("ngStyle", ctx_r0.config.style)("ngClass", ctx_r0.config.class);
  }
}
function FormStaticComponent_div_0_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormStaticComponent_div_0_ng_container_5_p_1_Template, 2, 6, "p", 11)(2, FormStaticComponent_div_0_ng_container_5_p_2_Template, 1, 4, "p", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fieldDisplayValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.translate);
  }
}
function FormStaticComponent_div_0_ng_container_6_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 17);
    i0.ɵɵpipe(1, "sanitizeInputHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.config.elementId);
    i0.ɵɵproperty("ngStyle", ctx_r0.config.style)("ngClass", ctx_r0.config.class)("innerHTML", i0.ɵɵpipeBind1(1, 4, ctx_r0.fieldDisplayValue), i0.ɵɵsanitizeHtml);
  }
}
function FormStaticComponent_div_0_ng_container_6_ng_container_2_ng_container_2_li_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const value_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("href", value_r2.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(value_r2.url);
  }
}
function FormStaticComponent_div_0_ng_container_6_ng_container_2_ng_container_2_li_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    let tmp_7_0;
    const value_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" ", (tmp_7_0 = value_r2 == null ? null : value_r2._label) !== null && tmp_7_0 !== undefined ? tmp_7_0 : value_r2, " ");
  }
}
function FormStaticComponent_div_0_ng_container_6_ng_container_2_ng_container_2_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, FormStaticComponent_div_0_ng_container_6_ng_container_2_ng_container_2_li_1_Conditional_1_Template, 2, 2, "a", 21)(2, FormStaticComponent_div_0_ng_container_6_ng_container_2_ng_container_2_li_1_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const value_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional((value_r2 == null ? null : value_r2.url) ? 1 : 2);
  }
}
function FormStaticComponent_div_0_ng_container_6_ng_container_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormStaticComponent_div_0_ng_container_6_ng_container_2_ng_container_2_li_1_Template, 3, 1, "li", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const value_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isValidString(value_r2) || (value_r2 == null ? null : value_r2.url) || (value_r2 == null ? null : value_r2._label));
  }
}
function FormStaticComponent_div_0_ng_container_6_ng_container_2_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function FormStaticComponent_div_0_ng_container_6_ng_container_2_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.showAll(ctx_r0.config));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "misc.See all"));
  }
}
function FormStaticComponent_div_0_ng_container_6_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 18);
    i0.ɵɵtemplate(2, FormStaticComponent_div_0_ng_container_6_ng_container_2_ng_container_2_Template, 2, 1, "ng-container", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, FormStaticComponent_div_0_ng_container_6_ng_container_2_button_3_Template, 3, 3, "button", 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ((tmp_3_0 = ctx_r0.config == null ? null : ctx_r0.config.value) !== null && tmp_3_0 !== undefined ? tmp_3_0 : i0.ɵɵpureFunction0(2, _c4$u)).slice(0, ctx_r0.listLimit == 0 || ctx_r0.config.showAll ? undefined : ctx_r0.listLimit));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.listLimit > 0 && ctx_r0.config.value && ctx_r0.config.value.length > 1 && ctx_r0.config.value.length > ctx_r0.listLimit && (!ctx_r0.config.showAll || ctx_r0.config.showAll == undefined));
  }
}
function FormStaticComponent_div_0_ng_container_6_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 23)(2, "div", 24)(3, "div", 25);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 26);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 24)(9, "div", 25);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 26)(13, "a", 21);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(15, "div", 24)(16, "div", 25);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 26);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const value_r4 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 8, "misc.Title"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(value_r4.title);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 10, "misc.File Name"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("href", "/utils/view.php?id=", value_r4.file_id, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(value_r4.user_file_name);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 12, "misc.Size"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(value_r4.size);
  }
}
function FormStaticComponent_div_0_ng_container_6_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormStaticComponent_div_0_ng_container_6_ng_container_3_ng_container_1_Template, 21, 14, "ng-container", 19);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.value);
  }
}
function FormStaticComponent_div_0_ng_container_6_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 27)(2, "span", 28);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const value_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c5$l, value_r5.success));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(value_r5._label ? value_r5._label : value_r5);
  }
}
function FormStaticComponent_div_0_ng_container_6_ng_container_4_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function FormStaticComponent_div_0_ng_container_6_ng_container_4_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.showAll(ctx_r0.config));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "misc.See all"));
  }
}
function FormStaticComponent_div_0_ng_container_6_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormStaticComponent_div_0_ng_container_6_ng_container_4_ng_container_1_Template, 4, 4, "ng-container", 19)(2, FormStaticComponent_div_0_ng_container_6_ng_container_4_button_2_Template, 3, 3, "button", 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.listLimit > 0 && ctx_r0.config.value && ctx_r0.config.value.length > 1 && ctx_r0.config.value.length > ctx_r0.listLimit && (!ctx_r0.config.showAll || ctx_r0.config.showAll == undefined));
  }
}
function FormStaticComponent_div_0_ng_container_6_p_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.config.elementId);
    i0.ɵɵproperty("ngStyle", ctx_r0.config.style)("ngClass", ctx_r0.config.class);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.config.translate);
  }
}
function FormStaticComponent_div_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormStaticComponent_div_0_ng_container_6_p_1_Template, 2, 6, "p", 15)(2, FormStaticComponent_div_0_ng_container_6_ng_container_2_Template, 4, 3, "ng-container", 6)(3, FormStaticComponent_div_0_ng_container_6_ng_container_3_Template, 2, 1, "ng-container", 6)(4, FormStaticComponent_div_0_ng_container_6_ng_container_4_Template, 3, 2, "ng-container", 6)(5, FormStaticComponent_div_0_ng_container_6_p_5_Template, 2, 4, "p", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fieldDisplayValue !== undefined && !ctx_r0.config.isList && !i0.ɵɵpureFunction0(5, _c3$C).includes(ctx_r0.config.soWidget));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fieldDisplayValue && ctx_r0.config.isList && !i0.ɵɵpureFunction0(6, _c3$C).includes(ctx_r0.config.soWidget));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fieldDisplayValue && ctx_r0.config.soWidget === "file");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fieldDisplayValue && ctx_r0.config.soWidget === "pills");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.translate);
  }
}
function FormStaticComponent_div_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "form-actions", 30);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("actions", ctx_r0.config.customActions.actions);
  }
}
function FormStaticComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, FormStaticComponent_div_0_div_1_Template, 5, 7, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, FormStaticComponent_div_0_div_3_Template, 3, 5, "div", 4);
    i0.ɵɵelement(4, "input", 5);
    i0.ɵɵtemplate(5, FormStaticComponent_div_0_ng_container_5_Template, 3, 2, "ng-container", 6)(6, FormStaticComponent_div_0_ng_container_6_Template, 6, 7, "ng-container", 6)(7, FormStaticComponent_div_0_ng_container_7_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.group)("ngClass", i0.ɵɵpureFunction2(10, _c0$1q, ctx_r0.config.lastChild, ctx_r0.config.soWidget === "pills"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.hideLabels);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c1$19, ctx_r0.config.soWidget === "tinymce", ctx_r0.config.soWidget !== "tinymce"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r0.fieldValue)("formControlName", ctx_r0.config.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.soWidget === "tinymce");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.soWidget !== "tinymce");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.customActions && !ctx_r0.config.customActions.hideAction);
  }
}
class FormStaticComponent extends FormInputComponent {
  constructor(htmlFormatterService, translate, sanitizer) {
    super(translate);
    this.htmlFormatterService = htmlFormatterService;
    this.translate = translate;
    this.sanitizer = sanitizer;
    this.inputType = 'hidden';
    this.listLimit = 0;
  }
  ngOnInit() {
    if (this.config.options instanceof Observable) {
      this.config.options.subscribe(options => this.configOptions = options);
    } else {
      this.configOptions = this.config.options;
    }
    if (this.config.type !== 'blurb') {
      if (this.config.soWidget === 'textarea') {
        this.config.style = {
          "white-space": "pre-wrap"
        };
      }
      if (this.config.readOnlyForm && !this.config.displayBlurbOnRO) {
        this.config.blurb = null;
      }
      if (this.config.listLimit) {
        this.listLimit = this.config.listLimit;
      }
      setTimeout(() => {
        if (_.isPlainObject(this.config.value)) {
          let relationFieldValue = new RelationField(this.config.value);
          this.config.value = relationFieldValue.id;
          this.fieldValue = this.config.value;
          this.fieldDisplayValue = relationFieldValue.label;
          if ((this.fieldDisplayValue === undefined || this.fieldDisplayValue === null) && ['radio', 'picklist', 'hierpicklist', 'yesno'].includes(this.config.soWidget)) {
            this.fieldDisplayValue = this.translate.instant('misc.Not selected');
          }
        } else {
          this.fieldDisplayValue = this.fieldValue = this.setValueFromInitialType();
        }
        this.control.setValue(this.config.value, {
          'emitModelToViewChange': true
        });
      });
    }
  }
  containsStyleAttribute(htmlString) {
    const styleAttributeRegex = /<[^>]*\sstyle\s*=\s*["'][^"']*["'][^>]*>/i;
    return styleAttributeRegex.test(htmlString);
  }
  showAll(config) {
    config.showAll = true;
  }
  isValidString(value) {
    return _.isString(value) && !_.isEmpty(value);
  }
  setValueFromInitialType() {
    let value = this.config.value;
    if (this.config.printAsList && Array.isArray(value)) {
      this.config.isList = true;
    }
    if (this.config.hideEmpty && !this.config.hideField) {
      this.config.hideField = this.config.soWidget == 'hidden' || !value || Array.isArray(value) && !value.length;
    }
    let readEmptyVal = this.config.readOnlyFormShowEmptyVal ? '' : this.translate.instant('misc.Not selected');
    switch (this.config.soWidget) {
      case 'date':
      case 'datedynamicwidget':
        if (!value && this.config.readOnlyForm) {
          value = readEmptyVal;
        } else {
          let format = window.DATETIME_FORMAT?.DATE.MEDIUM || 'mediumDate';
          value = this.htmlFormatterService.formatDate(value, format);
        }
        break;
      case 'datetime':
        if (!value && this.config.readOnlyForm) {
          value = readEmptyVal;
        } else {
          let format = 'short';
          if (window.DATETIME_FORMAT?.DATE.SHORT && window.DATETIME_FORMAT?.TIME.SHORT) {
            format = window.DATETIME_FORMAT.DATE.SHORT + ', ' + window.DATETIME_FORMAT.TIME.SHORT;
          }
          value = this.htmlFormatterService.formatDate(value, format);
        }
        break;
      case 'yesno':
      case 'onoff':
      case 'monocheck':
        if (!value && this.config.readOnlyForm) {
          value = readEmptyVal;
        } else {
          value = this.resolveYesNo(value);
        }
        break;
      case 'picklist':
      case 'hierpicklist':
      case 'checkbox':
        if (this.config.readOnlyForm && (!value || Array.isArray(value) && !value.length)) {
          value = readEmptyVal;
        } else {
          if (Array.isArray(value) && value.length) {
            if (value[0].hasOwnProperty('_label')) {
              value = value.map(v => v._label).join(', ');
              break;
            }
            value = value.join(', ');
          }
        }
        break;
      case 'time':
        if (!value && this.config.readOnlyForm) {
          value = readEmptyVal;
        } else {
          value = this.htmlFormatterService.formatTime(value, this.config.timeFormat, this.config.inputFormat, this.config.skipTzConvert);
        }
        break;
      default:
        if (!value) {
          if (this.config.readOnlyForm) {
            value = this.config.readOnlyFormShowEmptyVal ? '' : this.translate.instant('misc.Not entered');
          } else {
            value = '';
          }
        }
    }
    return value;
  }
  resolveYesNo(val) {
    let selectedPick = _.find(this.configOptions, ['id', val]);
    return selectedPick ? selectedPick['value'] : val;
  }
  static {
    this.ɵfac = function FormStaticComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormStaticComponent)(i0.ɵɵdirectiveInject(HtmlFormatterService), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i1$5.DomSanitizer));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormStaticComponent,
      selectors: [["form-static"]],
      standalone: false,
      features: [i0.ɵɵProvidersFeature([HtmlFormatterService]), i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "field form-static-list", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "field", "form-static-list", 3, "formGroup", "ngClass"], ["class", "field-label field-label-readonly", 3, "ngClass", 4, "ngIf"], [1, "field-widget", "widget-readonly", 3, "ngClass"], ["class", "blurb field-blurb", 3, "innerHTML", 4, "ngIf"], ["type", "hidden", 3, "value", "formControlName"], [4, "ngIf"], [1, "field-label", "field-label-readonly", 3, "ngClass"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "innerHTML"], [3, "id", "innerHTML", "ngStyle", "ngClass", 4, "ngIf"], ["translate", "", 3, "id", "innerHTML", "ngStyle", "ngClass", 4, "ngIf"], [3, "id", "innerHTML", "ngStyle", "ngClass"], ["translate", "", 3, "id", "innerHTML", "ngStyle", "ngClass"], [3, "id", "ngStyle", "ngClass", "innerHTML", 4, "ngIf"], ["translate", "", 3, "id", "ngStyle", "ngClass", 4, "ngIf"], [3, "id", "ngStyle", "ngClass", "innerHTML"], [1, "list-bulleted"], [4, "ngFor", "ngForOf"], ["class", "btn_text-link", 3, "click", 4, "ngIf"], ["target", "_blank", 3, "href"], [1, "btn_text-link", 3, "click"], [1, "subform"], [1, "field"], [1, "field-label", "field-label-readonly"], [1, "field-widget", "widget-readonly"], [1, "chip", "chip-disabled", "chip-sm", 3, "ngClass"], [1, "chip-value", "text-base"], ["translate", "", 3, "id", "ngStyle", "ngClass"], [3, "actions"]],
      template: function FormStaticComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormStaticComponent_div_0_Template, 8, 16, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgStyle, i2$1.FormGroupDirective, i2$1.FormControlName, i1$1.TranslateDirective, FormActionsComponent, i1$1.TranslatePipe, SanitizeHtmlPipe, SafeHtmlPipe],
      styles: [".on-completion-text{color:#6c6c6c;font-size:16px;margin-top:20px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormStaticComponent, [{
    type: Component,
    args: [{
      selector: 'form-static',
      template: `
        <div *ngIf="!config.hideField" class="field form-static-list" [formGroup]="group" [ngClass]="{'last': config.lastChild, 'space-bottom-xs': config.soWidget === 'pills'}">
            <div *ngIf="!config.hideLabels" class="field-label field-label-readonly" [ngClass]="{'field-label-has-blurb': config.blurb}">
                <span>
                    {{config.label | translate}}
                </span>
                <i *ngIf="isRequired" class="req-indicator">*</i>
            </div>
            <div class="field-widget widget-readonly" [ngClass]="{'field-widget-tinymce' : config.soWidget === 'tinymce', 'field-widget-text': config.soWidget !== 'tinymce'}">
                <div *ngIf="config.blurb" class="blurb field-blurb" [innerHTML]="config.blurb | translate | safeHtml"></div>
                <input type="hidden" [value]="fieldValue" [formControlName]="config.name">
                <ng-container *ngIf="config.soWidget === 'tinymce'">
                    <p *ngIf="fieldDisplayValue" id="{{config.elementId}}" [innerHTML]="fieldDisplayValue | sanitizeInputHtml" [ngStyle]="config.style" [ngClass]="config.class"></p>
                    <p *ngIf="config.translate" id="{{config.elementId}}" [innerHTML]="config.translate" [ngStyle]="config.style" [ngClass]="config.class" translate></p>
                </ng-container>
                <ng-container *ngIf="config.soWidget !=='tinymce'">
                    <p *ngIf="fieldDisplayValue !== undefined && !config.isList && !['pills', 'file'].includes(config.soWidget)" id="{{config.elementId}}" [ngStyle]="config.style" [ngClass]="config.class" [innerHTML]="fieldDisplayValue | sanitizeInputHtml"></p>
                    <ng-container *ngIf="fieldDisplayValue && config.isList && !['pills', 'file'].includes(config.soWidget)">
                        <ul class="list-bulleted">
                            <ng-container *ngFor="let value of (config?.value ?? []).slice(0, (listLimit == 0 || config.showAll) ? undefined : listLimit)">
                                <li *ngIf="isValidString(value) || value?.url || value?._label">
                                    @if (value?.url) {
                                        <a [href]="value.url" target="_blank">{{ value.url }}</a>
                                    } @else {
                                        {{ value?._label ?? value }}
                                    }
                                </li>
                            </ng-container>
                        </ul>
                        <button class="btn_text-link" *ngIf="(config.listLimit > 0) && (config.value && config.value.length > 1 && config.value.length > listLimit) && (!config.showAll || config.showAll == undefined)" (click)="showAll(config)">{{ 'misc.See all' | translate }}</button>
                    </ng-container>
                    <ng-container *ngIf="fieldDisplayValue && config.soWidget === 'file'">
                        <ng-container *ngFor="let value of config.value; let i = index">
                            <div class="subform">
                                <div class="field">
                                    <div class="field-label field-label-readonly">{{ 'misc.Title' | translate }}</div>
                                    <div class="field-widget widget-readonly">{{value.title}}</div>
                                </div>
                                <div class="field">
                                    <div class="field-label field-label-readonly">{{ 'misc.File Name' | translate }}</div>
                                    <div class="field-widget widget-readonly"><a href="/utils/view.php?id={{value.file_id}}" target="_blank">{{value.user_file_name}}</a></div>
                                </div>
                                <div class="field">
                                    <div class="field-label field-label-readonly">{{ 'misc.Size' | translate }}</div>
                                    <div class="field-widget widget-readonly">{{value.size}}</div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="fieldDisplayValue && config.soWidget === 'pills'">
                        <ng-container *ngFor="let value of config.value; let i = index">
                            <span class="chip chip-disabled chip-sm" [ngClass]="{'chip-success': value.success}">
                                <span class="chip-value text-base">{{value._label ? value._label : value}}</span>
                            </span>
                        </ng-container>
                        <button class="btn_text-link" *ngIf="(config.listLimit > 0) && (config.value && config.value.length > 1 && config.value.length > listLimit) && (!config.showAll || config.showAll == undefined)" (click)="showAll(config)">{{ 'misc.See all' | translate }}</button>
                    </ng-container>
                    <p *ngIf="config.translate" id="{{config.elementId}}" [ngStyle]="config.style" [ngClass]="config.class" translate>{{config.translate}}</p>
                </ng-container>
                <ng-container *ngIf="config.customActions && !config.customActions.hideAction">
                    <form-actions [actions]="config.customActions.actions"></form-actions>
                </ng-container>
            </div>
        </div>
    `,
      encapsulation: ViewEncapsulation.None,
      providers: [HtmlFormatterService],
      standalone: false,
      styles: [".on-completion-text{color:#6c6c6c;font-size:16px;margin-top:20px}\n"]
    }]
  }], () => [{
    type: HtmlFormatterService
  }, {
    type: i1$1.TranslateService
  }, {
    type: i1$5.DomSanitizer
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormStaticComponent, {
    className: "FormStaticComponent",
    filePath: "dynamic-form/components/form-static/form-static.component.ts",
    lineNumber: 86
  });
})();
function FormStaticListComponent_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 6);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormStaticListComponent_li_7_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const fieldConfig_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 1, fieldConfig_r1 == null ? null : fieldConfig_r1.label), ": ");
  }
}
function FormStaticListComponent_li_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 7);
    i0.ɵɵtemplate(1, FormStaticListComponent_li_7_span_1_Template, 4, 3, "span", 8);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const fieldConfig_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", fieldConfig_r1.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(fieldConfig_r1 == null ? null : fieldConfig_r1.value);
  }
}
class FormStaticListComponent {
  ngOnInit() {}
  static {
    this.ɵfac = function FormStaticListComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormStaticListComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormStaticListComponent,
      selectors: [["form-static-list"]],
      standalone: false,
      decls: 8,
      vars: 5,
      consts: [[1, "form-static-list", "field"], [1, "field-label"], ["class", "req-indicator", 4, "ngIf"], [1, "field-widget"], [1, "list-group"], ["class", "waitlist-modal-table-list", 4, "ngFor", "ngForOf"], [1, "req-indicator"], [1, "waitlist-modal-table-list"], [4, "ngIf"]],
      template: function FormStaticListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵtemplate(4, FormStaticListComponent_i_4_Template, 2, 0, "i", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 3)(6, "ul", 4);
          i0.ɵɵtemplate(7, FormStaticListComponent_li_7_Template, 4, 2, "li", 5);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, ctx.config == null ? null : ctx.config.label), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.isRequired);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngForOf", ctx.config.staticFieldsConfig);
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormStaticListComponent, [{
    type: Component,
    args: [{
      selector: 'form-static-list',
      standalone: false,
      template: "<div class=\"form-static-list field\">\n    <div class=\"field-label\">\n        {{config?.label | translate}}\n        <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n    </div>\n    <div class=\"field-widget\">\n        <ul class=\"list-group\">\n            <li *ngFor=\"let fieldConfig of config.staticFieldsConfig\" class=\"waitlist-modal-table-list\">\n                <span *ngIf=\"fieldConfig.value\"><b>{{fieldConfig?.label | translate}}: </b></span>\n                <span>{{fieldConfig?.value}}</span>\n            </li>\n        </ul>\n    </div>\n</div>\n"
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormStaticListComponent, {
    className: "FormStaticListComponent",
    filePath: "dynamic-form/components/form-static/form-static-list.component.ts",
    lineNumber: 8
  });
})();
const _c0$1p = a0 => ({
  "last": a0
});
const _c1$18 = a0 => ({
  field_name: a0
});
function FormMultiSelectComponent_div_0_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 13);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormMultiSelectComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormMultiSelectComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, "When autocomplete results are available use up and down arrows to review and enter to select. Start typing to filter the options.");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
  }
}
function FormMultiSelectComponent_div_0_ng_template_12_b_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(#", item_r3.orderBy, ")");
  }
}
function FormMultiSelectComponent_div_0_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, FormMultiSelectComponent_div_0_ng_template_12_b_0_Template, 2, 1, "b", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵlistener("click", function FormMultiSelectComponent_div_0_ng_template_12_Template_span_click_2_listener($event) {
      const ctx_r3 = i0.ɵɵrestoreView(_r2);
      const item_r3 = ctx_r3.item;
      const clear_r5 = ctx_r3.clear;
      clear_r5(item_r3);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtext(3, "\u00D7");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.item;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.ordered);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.display, " ");
  }
}
function FormMultiSelectComponent_div_0_div_13_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$18, ctx_r0.translatedLabel)), " ");
  }
}
function FormMultiSelectComponent_div_0_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, FormMultiSelectComponent_div_0_div_13_div_1_Template, 4, 6, "div", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function FormMultiSelectComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "label", 5);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, FormMultiSelectComponent_div_0_i_5_Template, 2, 0, "i", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtemplate(7, FormMultiSelectComponent_div_0_div_7_Template, 3, 6, "div", 8)(8, FormMultiSelectComponent_div_0_div_8_Template, 2, 1, "div", 9);
    i0.ɵɵelementStart(9, "ng-select", 10);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵpipe(11, "async");
    i0.ɵɵtemplate(12, FormMultiSelectComponent_div_0_ng_template_12_Template, 4, 2, "ng-template", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, FormMultiSelectComponent_div_0_div_13_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.group)("ngClass", i0.ɵɵpureFunction1(26, _c0$1p, ctx_r0.config.lastChild));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 20, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 22, ctx_r0.config.placeholder));
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r0.controlName);
    i0.ɵɵproperty("items", i0.ɵɵpipeBind1(11, 24, ctx_r0.config.options))("loading", ctx_r0.loading)("multiple", true)("maxSelectedItems", ctx_r0.config.maxSelectedItems);
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
  }
}
function FormMultiSelectComponent_div_1_i_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 13);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormMultiSelectComponent_div_1_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx_r0.config.blurb));
  }
}
function FormMultiSelectComponent_div_1_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, "When autocomplete results are available use up and down arrows to review and enter to select. Start typing to filter the options.");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
  }
}
function FormMultiSelectComponent_div_1_ng_template_16_b_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r8 = i0.ɵɵnextContext().item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(#", item_r8.orderBy, ")");
  }
}
function FormMultiSelectComponent_div_1_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, FormMultiSelectComponent_div_1_ng_template_16_b_0_Template, 2, 1, "b", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵlistener("click", function FormMultiSelectComponent_div_1_ng_template_16_Template_span_click_2_listener($event) {
      const ctx_r8 = i0.ɵɵrestoreView(_r7);
      const item_r8 = ctx_r8.item;
      const clear_r10 = ctx_r8.clear;
      clear_r10(item_r8);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtext(3, "\u00D7");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r8 = ctx.item;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.ordered);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r8.display, " ");
  }
}
function FormMultiSelectComponent_div_1_div_17_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$18, ctx_r0.translatedLabel)), " ");
  }
}
function FormMultiSelectComponent_div_1_div_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, FormMultiSelectComponent_div_1_div_17_div_1_Template, 3, 6, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function FormMultiSelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "table", 22)(2, "tr")(3, "td", 23)(4, "div", 24)(5, "label", 5);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵtemplate(8, FormMultiSelectComponent_div_1_i_8_Template, 2, 0, "i", 6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "td", 23)(10, "div", 25);
    i0.ɵɵtemplate(11, FormMultiSelectComponent_div_1_div_11_Template, 3, 4, "div", 26)(12, FormMultiSelectComponent_div_1_div_12_Template, 2, 1, "div", 9);
    i0.ɵɵelementStart(13, "ng-select", 27);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵpipe(15, "async");
    i0.ɵɵlistener("change", function FormMultiSelectComponent_div_1_Template_ng_select_change_13_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onValChange($event));
    });
    i0.ɵɵtemplate(16, FormMultiSelectComponent_div_1_ng_template_16_Template, 4, 2, "ng-template", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, FormMultiSelectComponent_div_1_div_17_Template, 2, 1, "div", 28);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.group);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 19, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(14, 21, ctx_r0.config.placeholder));
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r0.controlName);
    i0.ɵɵproperty("items", i0.ɵɵpipeBind1(15, 23, ctx_r0.config.options))("loading", ctx_r0.loading)("multiple", true)("maxSelectedItems", ctx_r0.config.maxSelectedItems);
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
  }
}
function FormMultiSelectComponent_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 32);
  }
  if (rf & 2) {
    const field_r11 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r11)("group", ctx_r0.group);
  }
}
function FormMultiSelectComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormMultiSelectComponent_div_2_ng_container_1_Template, 1, 2, "ng-container", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.dependents);
  }
}
class FormMultiSelectComponent extends FormInputComponent {
  constructor(fb, backendService, translate) {
    super(translate);
    this.fb = fb;
    this.backendService = backendService;
    this.translate = translate;
    this.loading = false;
    this.showDependentControl = false;
  }
  get optionSelected() {
    return !_.isEmpty(this.control.value);
  }
  ngOnInit() {
    if (this.config.dependents) {
      this.registerDependentControls();
      this.control.valueChanges.subscribe(newVal => this.onValChange(newVal));
    }
    if (this.config.value) {
      this.loading = true;
      // Initializing after subscribing to value changes so subscription gets called on initialization
      this.initializeControl(this.config.value);
    }
    this.setDescribedBy();
  }
  onValChange(newVal) {
    if (this.config.ordered) {
      this.setOrderBy(newVal);
    }
    ;
    if (this.config.dependents) {
      if (this.config.multiple && newVal) {
        newVal = newVal.length === 1 ? newVal[0] : null;
      }
      this.setupDependentsState(newVal);
    }
  }
  setOrderBy(items) {
    let orderBy = 1;
    items.forEach(item => item['orderBy'] = orderBy++);
    return items;
  }
  initializeControl(initialIDs) {
    let initialOptions = this.getOptionsByID(initialIDs, this.config.options);
    initialOptions.subscribe(options => {
      if (this.config.ordered) {
        this.setOrderBy(options);
      }
      this.control.setValue(this.config.multiple ? options : options[0]);
      this.loading = false;
    });
  }
  setupDependentsState(newVal) {
    this.showDependentControl = true;
    this.config.dependents.forEach(depConfig => {
      let depControl = this.group.controls[depConfig.name];
      let key = depConfig.aggregateKey;
      if (newVal) {
        if (depConfig.optionsAPICallback) {
          depConfig.options = this.backendService.getDynamicPicks(depConfig.optionsAPICallback, newVal.id);
        } else if (key) {
          // Parent Value Object contains child Picklist Options
          let newDepOptions = newVal[key];
          // Setting Options as Observable for Async pipe to work
          depConfig.options = of(newDepOptions);
          if (!newDepOptions.includes(depControl.value)) {
            depControl.setValue('');
          }
        }
      } else {
        // New value is null when parent option is changed
        // Reset downstream values
        let val = depConfig.multiple ? [] : '';
        depControl.setValue(val);
        this.showDependentControl = false;
      }
    });
  }
  registerDependentControls() {
    this.config.dependents.forEach(control => this.group.addControl(control.name, this.fb.control(null, control.validators)));
  }
  getOptionsByID(ids, optionsObs) {
    // Filtering so that it does not emit empty values
    return optionsObs.pipe(map(options => options.filter(option => ids.includes(option.id))));
  }
  static {
    this.ɵfac = function FormMultiSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormMultiSelectComponent)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(BackendService), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormMultiSelectComponent,
      selectors: [["form-select"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 3,
      consts: [["class", "field form-select", 3, "formGroup", "ngClass", 4, "ngIf"], ["class", "row form-select form-group", 3, "formGroup", 4, "ngIf"], [4, "ngIf"], [1, "field", "form-select", 3, "formGroup", "ngClass"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "field-widget", "search_filter_multiselect"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["class", "blurb hide", 3, "id", 4, "ngIf"], ["bindLabel", "display", "clearAllText", "Clear", 1, "form-select-multiselect", 3, "items", "loading", "multiple", "maxSelectedItems", "placeholder", "formControlName"], ["ng-label-tmp", ""], ["role", "alert", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], [1, "blurb", "hide", 3, "id"], ["aria-hidden", "true", "role", "button", "title", "delete", 1, "ng-value-icon", "right", 3, "click"], ["role", "alert"], ["class", "field-error", 4, "ngIf"], [1, "field-error"], [1, "icn-error_filled"], [1, "row", "form-select", "form-group", 3, "formGroup"], ["role", "layout", 1, "waitlist-modal-table"], [1, "waitlist-modal-table-column"], [1, "label"], [1, "widget", "waitlist-modal-table-multiselect"], ["class", "blurb field-blurb", 3, "id", 4, "ngIf"], ["bindLabel", "display", "clearAllText", "Clear", 3, "change", "items", "loading", "multiple", "maxSelectedItems", "placeholder", "formControlName"], ["role", "alert", "class", "alert alert-danger", 4, "ngIf"], [1, "blurb", "field-blurb", 3, "id"], ["role", "alert", 1, "alert", "alert-danger"], ["dynamicField", "", 3, "config", "group", 4, "ngFor", "ngForOf"], ["dynamicField", "", 3, "config", "group"]],
      template: function FormMultiSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormMultiSelectComponent_div_0_Template, 14, 28, "div", 0)(1, FormMultiSelectComponent_div_1_Template, 18, 25, "div", 1)(2, FormMultiSelectComponent_div_2_Template, 2, 1, "div", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField && !ctx.modal);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.config.hideField && ctx.modal);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showDependentControl);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormMultiSelectComponent, [{
    type: Component,
    args: [{
      selector: 'form-select',
      standalone: false,
      template: "<div class=\"field form-select\" *ngIf=\"!config.hideField && !modal\" [formGroup]=\"group\" [ngClass]=\"{'last': config.lastChild}\">\n\t<div class=\"field-label\">\n\t\t<label for=\"{{config.elementId}}{{modal?'modal':''}}\">{{config.label | translate}}\n\t\t\t<i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n\t\t</label>\n\t</div>\n\t<div class=\"field-widget search_filter_multiselect\">\n\t\t<div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb field-blurb\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n\t\t<div *ngIf=\"!config.blurb\" id=\"{{describedByValue}}\" class=\"blurb hide\">When autocomplete results are available use up and down arrows to review and enter to select. Start typing to filter the options.</div>\n\t\t<ng-select\n\t\t\t[items]=\"config.options | async\"\n\t\t\tclass=\"form-select-multiselect\"\n\t\t\tbindLabel=\"display\"\n\t\t\t[loading]=\"loading\"\n\t\t\t[multiple]=\"true\"\n\t\t\t[maxSelectedItems]=\"config.maxSelectedItems\"\n\t\t\tplaceholder=\"{{config.placeholder | translate}}\"\n\t\t\t[attr.aria-describedby]=\"describedByValue\"\n\t\t\tattr.id=\"{{config.elementId}}{{modal?'modal':''}}\"\n\t\t\tclearAllText=\"Clear\"\n\t\t\tformControlName=\"{{controlName}}\">\n\t\t\t<ng-template  ng-label-tmp let-item=\"item\" let-clear=\"clear\">\n\t\t\t\t<b *ngIf=\"config.ordered\">(#{{item.orderBy}})</b> {{item.display}}\n\t\t\t\t<span class=\"ng-value-icon right\" (click)=\"clear(item); $event.stopPropagation()\" aria-hidden=\"true\" role=\"button\" title=\"delete\">\u00D7</span>\n\t\t\t</ng-template>\n\t\t</ng-select>\n\t\t<div role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n\t\t\t<div class=\"field-error\" *ngIf=\"control.errors.required\">\n\t\t\t\t<i class=\"icn-error_filled\"></i>\n\t\t\t\t{{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<div class=\"row form-select form-group\" *ngIf=\"!config.hideField && modal\" [formGroup]=\"group\">\n\t<table class=\"waitlist-modal-table\" role=\"layout\">\n\t\t<tr>\n\t\t\t<td class=\"waitlist-modal-table-column\">\n\t\t\t\t<div class=\"label\">\n\t\t\t\t\t<label for=\"{{config.elementId}}{{modal?'modal':''}}\">{{config.label | translate}}\n\t\t\t\t\t\t<i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</td>\n\t\t\t<td class=\"waitlist-modal-table-column\">\n\t\t\t\t<div class=\"widget waitlist-modal-table-multiselect\">\n\t\t\t\t\t<div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb field-blurb\">{{config.blurb | translate}}</div>\n\t\t\t\t\t<div *ngIf=\"!config.blurb\" id=\"{{describedByValue}}\" class=\"blurb hide\">When autocomplete results are available use up and down arrows to review and enter to select. Start typing to filter the options.</div>\n\t\t\t\t\t<ng-select\n\t\t\t\t\t\t[items]=\"config.options | async\"\n\t\t\t\t\t\tbindLabel=\"display\"\n\t\t\t\t\t\t[loading]=\"loading\"\n\t\t\t\t\t\t[multiple]=\"true\"\n\t\t\t\t\t\t[maxSelectedItems]=\"config.maxSelectedItems\"\n\t\t\t\t\t\tplaceholder=\"{{config.placeholder | translate}}\"\n\t\t\t\t\t\t[attr.aria-describedby]=\"describedByValue\"\n\t\t\t\t\t\tattr.id=\"{{config.elementId}}{{modal?'modal':''}}\"\n\t\t\t\t\t\tclearAllText=\"Clear\"\n\t\t\t\t\t\t(change)=\"onValChange($event)\"\n\t\t\t\t\t\tformControlName=\"{{controlName}}\">\n\t\t\t\t\t\t<ng-template  ng-label-tmp let-item=\"item\" let-clear=\"clear\">\n\t\t\t\t\t\t\t<b *ngIf=\"config.ordered\">(#{{item.orderBy}})</b> {{item.display}}\n\t\t\t\t\t\t\t<span class=\"ng-value-icon right\" (click)=\"clear(item); $event.stopPropagation()\" aria-hidden=\"true\" role=\"button\" title=\"delete\">\u00D7</span>\n\t\t\t\t\t\t</ng-template>\n\t\t\t\t\t</ng-select>\n\t\t\t\t\t<div role=\"alert\" class=\"alert alert-danger\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n\t\t\t\t\t\t<div *ngIf=\"control.errors.required\">\n\t\t\t\t\t\t\t{{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</td>\n\t\t</tr>\n\t</table>\n</div>\n<div *ngIf='showDependentControl'>\n    <ng-container *ngFor=\"let field of config.dependents\" dynamicField [config]=\"field\" [group]=\"group\"></ng-container>\n</div>\n"
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }, {
    type: BackendService
  }, {
    type: i1$1.TranslateService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormMultiSelectComponent, {
    className: "FormMultiSelectComponent",
    filePath: "dynamic-form/components/form-multiselect/form-multiselect.component.ts",
    lineNumber: 15
  });
})();
const _c0$1o = (a0, a1, a2) => ({
  "field-error": a0,
  "group-options": a1,
  "last": a2
});
const _c1$17 = a0 => ({
  field_name: a0
});
function FormNGSelectComponent_div_0_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 10);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormNGSelectComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormNGSelectComponent_div_0_div_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$17, ctx_r0.translatedLabel)), " ");
  }
}
function FormNGSelectComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, FormNGSelectComponent_div_0_div_8_div_1_Template, 4, 6, "div", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function FormNGSelectComponent_div_0_ng_template_12_b_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(#", item_r3.orderBy, ")");
  }
}
function FormNGSelectComponent_div_0_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, FormNGSelectComponent_div_0_ng_template_12_b_0_Template, 2, 1, "b", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 14);
    i0.ɵɵlistener("click", function FormNGSelectComponent_div_0_ng_template_12_Template_span_click_2_listener($event) {
      const ctx_r3 = i0.ɵɵrestoreView(_r2);
      const item_r3 = ctx_r3.item;
      const clear_r5 = ctx_r3.clear;
      clear_r5(item_r3);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtext(3, "\u00D7");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.item;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.ordered);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.display, " ");
  }
}
function FormNGSelectComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "label");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, FormNGSelectComponent_div_0_i_5_Template, 2, 0, "i", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵtemplate(7, FormNGSelectComponent_div_0_div_7_Template, 3, 6, "div", 6)(8, FormNGSelectComponent_div_0_div_8_Template, 2, 1, "div", 7);
    i0.ɵɵelementStart(9, "ng-select", 8);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵtemplate(12, FormNGSelectComponent_div_0_ng_template_12_Template, 4, 2, "ng-template", 9);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(26, _c0$1o, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.groupOptions, ctx_r0.config.lastChild))("formGroup", ctx_r0.group);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 20, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("labelForId", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r0.controlName);
    i0.ɵɵproperty("items", i0.ɵɵpipeBind1(10, 22, ctx_r0.config.options))("loading", ctx_r0.loading)("multiple", ctx_r0.config.multiple)("maxSelectedItems", ctx_r0.config.maxSelectedItems)("placeholder", i0.ɵɵpipeBind1(11, 24, ctx_r0.config.placeholder))("searchable", ctx_r0.searchable);
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue);
  }
}
function FormNGSelectComponent_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 16);
  }
  if (rf & 2) {
    const field_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r6)("group", ctx_r0.group)("modal", ctx_r0.modal);
  }
}
function FormNGSelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormNGSelectComponent_div_1_ng_container_1_Template, 1, 3, "ng-container", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.dependents);
  }
}
class FormNGSelectComponent extends FormInputComponent {
  constructor(fb, backendService, translate) {
    super(translate);
    this.fb = fb;
    this.backendService = backendService;
    this.translate = translate;
    this.loading = false;
    this.showDependentControl = false;
    this.searchable = false;
    this.translatedLabel = '';
  }
  get optionSelected() {
    return !_.isEmpty(this.control.value);
  }
  ngOnInit() {
    this.translatedLabel = this.translate.instant(this.config.label);
    if (this.config.yesNo) {
      this.config['options'] = new BehaviorSubject([{
        'id': '1',
        'display': this.translate.instant('misc.Yes')
      }, {
        'id': '0',
        'display': this.translate.instant('misc.No')
      }]);
    }
    if (this.config.dependents) {
      this.registerDependentControls();
    }
    if (typeof this.config.searchable !== 'undefined') {
      this.searchable = this.config.searchable;
    }
    this.control.valueChanges.subscribe(newVal => this.onValChange(newVal));
    if (this.config.value) {
      this.loading = true;
      setTimeout(() => {
        // Initializing after subscribing to value changes so subscription gets called on initialization
        this.initializeControl(this.config.value);
      });
    }
    this.setDescribedBy();
  }
  onValChange(newVal) {
    if (this.config.ordered) {
      this.setOrderBy(newVal);
    }
    if (this.config.dependents) {
      if (this.config.multiple && newVal) {
        newVal = newVal.length === 1 ? newVal[0] : null;
      }
      this.setupDependentsState(newVal);
    }
  }
  setOrderBy(items) {
    if (items) {
      let orderBy = 1;
      items.forEach(item => item['orderBy'] = orderBy++);
      return items;
    }
  }
  initializeControl(initialIDs) {
    let initialOptions = this.getOptionsByID(initialIDs, this.config.options);
    initialOptions.subscribe(options => {
      if (this.config.ordered) {
        this.setOrderBy(options);
      }
      this.control.setValue(this.config.multiple ? options : options[0]);
      this.loading = false;
    });
  }
  setupDependentsState(newVal) {
    this.showDependentControl = true;
    this.config.dependents.forEach(depConfig => {
      let depControl = this.group.controls[depConfig.name];
      let key = depConfig.aggregateKey;
      if (newVal) {
        if (depConfig.optionsAPICallback) {
          depConfig.options = this.backendService.getDynamicPicks(depConfig.optionsAPICallback, newVal.id);
        } else if (key) {
          // Parent Value Object contains child Picklist Options
          let newDepOptions = newVal[key];
          // Setting Options as Observable for Async pipe to work
          depConfig.options = of(newDepOptions);
          if (!newDepOptions.includes(depControl.value)) {
            depControl.setValue('');
          }
        }
      } else {
        // New value is null when parent option is changed
        // Reset downstream values
        let val = depConfig.multiple ? [] : null;
        depControl.setValue(val);
        this.showDependentControl = false;
      }
    });
  }
  registerDependentControls() {
    this.config.dependents.forEach(control => this.group.addControl(control.name, this.fb.control(null, control.validators)));
  }
  getOptionsByID(ids, optionsObs) {
    // Filtering so that it does not emit empty values
    return optionsObs.pipe(map(options => options.filter(option => ids.includes(option.id))));
  }
  static {
    this.ɵfac = function FormNGSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormNGSelectComponent)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(BackendService), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormNGSelectComponent,
      selectors: [["form-ngselect"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 2,
      consts: [["class", "field form-select", 3, "ngClass", "formGroup", 4, "ngIf"], [4, "ngIf"], [1, "field", "form-select", 3, "ngClass", "formGroup"], [1, "field-label"], ["class", "req-indicator", 4, "ngIf"], [1, "field-widget", "search_filter_multiselect"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], ["bindLabel", "display", "groupBy", "groupBy", "clearAllText", "Clear", 1, "form-select-multiselect", 3, "items", "labelForId", "loading", "multiple", "maxSelectedItems", "placeholder", "searchable", "formControlName"], ["ng-label-tmp", ""], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [1, "icn-error_filled"], ["aria-hidden", "true", "role", "button", "title", "delete", 1, "ng-value-icon", "right", 3, "click"], ["dynamicField", "", 3, "config", "group", "modal", 4, "ngFor", "ngForOf"], ["dynamicField", "", 3, "config", "group", "modal"]],
      template: function FormNGSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormNGSelectComponent_div_0_Template, 13, 30, "div", 0)(1, FormNGSelectComponent_div_1_Template, 2, 1, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showDependentControl);
        }
      },
      styles: [".ng-select .ng-control,.ng-select.ng-single .ng-control{min-height:40px;height:40px}.ng-select.ng-select-opened>.ng-select-container{background:#fff;border-color:#949494}.ng-select.ng-select-opened>.ng-select-container:hover{box-shadow:none}.ng-select.ng-select-opened.ng-select-bottom>.ng-select-container{border-bottom-right-radius:0;border-bottom-left-radius:0}.ng-select.ng-select-opened.ng-select-top>.ng-select-container{border-top-right-radius:0;border-top-left-radius:0}.ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border-color:#007eff;box-shadow:inset 0 1px 1px #00000013,0 0 0 3px #007eff1a}.ng-select.ng-select-disabled>.ng-select-container{background-color:#f9f9f9}.ng-select .ng-has-value .ng-placeholder{display:none}.ng-select .ng-select-container{background-color:#fff;border-radius:3px;border:1px solid #949494;min-height:30px;align-items:center}.ng-select .ng-select-container:hover{box-shadow:0 1px #0000000f}.ng-select .ng-select-container .ng-value-container{align-items:center;padding-left:10px}.ng-select .ng-select-container .ng-value-container .ng-placeholder{color:#aaa}.ng-select.ng-select-single .ng-select-container{height:30px}.ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{left:0;padding-left:10px;padding-right:50px;top:5px}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value{background-color:#f9f9f9;border:1px solid #e3e3e3}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value .ng-value-label{padding:0 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-left:7px;padding-top:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{font-size:.9em;margin-right:5px;margin-bottom:5px;background-color:#f5faff;border-radius:2px;border:1px solid #c2e0ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled{background-color:#f9f9f9;border:1px solid #e3e3e3}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled .ng-value-label{padding-left:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-label,.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon{display:inline-block;padding:0 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon:hover{background-color:#d8eafd}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-right:1px solid #c2e0ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:1px solid #c2e0ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding-bottom:3px;padding-left:3px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{top:5px;padding-bottom:5px;padding-left:3px}.ng-select .ng-clear-wrapper{color:#6c6c6c;top:1px}.ng-select .ng-select-container .ng-clear-wrapper .ng-clear{display:block}.ng-select .ng-clear-wrapper .ng-clear:hover{color:#d0021b}.ng-select .ng-spinner-zone{padding-right:5px;padding-top:5px}.ng-select .ng-arrow-wrapper{padding-right:5px;width:25px}.ng-select .ng-arrow-wrapper .ng-arrow{width:30px!important;margin-left:2px;vertical-align:middle;background:url(/components/unicon/assets/svg-output/chevron_down_light.svg) no-repeat center right 15px;background-size:17px;height:20px!important}[dir=rtl] .ng-select .ng-arrow-wrapper .ng-arrow{background:url(/components/unicon/assets/svg-output/chevron_down_light.svg) no-repeat center left 15px/17px}.ng-dropdown-panel{background-color:#fff;border:1px solid #ccc;box-shadow:0 1px #0000000f;left:0}[dir=rtl] .ng-dropdown-panel{text-align:right}.ng-dropdown-panel.ng-select-bottom{top:100%;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-top-color:#e6e6e6;margin-top:-1px}.ng-dropdown-panel.ng-select-bottom .ng-dropdown-panel-items .ng-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.ng-dropdown-panel.ng-select-top{bottom:100%;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-color:#e6e6e6;margin-bottom:-1px}.ng-dropdown-panel.ng-select-top .ng-dropdown-panel-items .ng-option:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.ng-dropdown-panel .ng-dropdown-header{border-bottom:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-footer{border-top:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-panel-items{margin-bottom:1px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{-webkit-user-select:none;user-select:none;cursor:default;padding:8px 10px;font-weight:500;color:#0000008a;cursor:pointer}.group-options .ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{font-weight:700;color:#444}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-disabled{cursor:default}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-marked{background-color:#ebf5ff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected{background-color:#f5faff;font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option{background-color:#fff;color:#3e3e3ede;padding:8px 10px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected{color:#333;background-color:#f5faff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label{font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked{background-color:#428bca;color:#fff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled{color:#ccc}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-left:22px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{padding-right:5px;font-size:80%;font-weight:400}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormNGSelectComponent, [{
    type: Component,
    args: [{
      selector: 'form-ngselect',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div *ngIf=\"!config.hideField\" class=\"field form-select\" [ngClass]=\"{'field-error': !control.valid && (control.dirty || control.touched), 'group-options' : config.groupOptions, 'last':config.lastChild}\" [formGroup]=\"group\">\n    <div class=\"field-label\">\n        <label attr.for=\"{{config.elementId}}{{modal?'modal':''}}\">{{config.label | translate}}\n            <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n        </label>\n    </div>\n    <div class=\"field-widget search_filter_multiselect\">\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb field-blurb\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n            <div *ngIf=\"control.errors.required\">\n                <i class=\"icn-error_filled\"></i>\n                {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n            </div>\n        </div>\n        <ng-select\n                [items]=\"config.options | async\"\n                class=\"form-select-multiselect\"\n                bindLabel=\"display\"\n                groupBy=\"groupBy\"\n                labelForId=\"{{config.elementId}}{{modal?'modal':''}}\"\n                [loading]=\"loading\"\n                [multiple]=\"config.multiple\"\n                [maxSelectedItems]=\"config.maxSelectedItems\"\n                [placeholder]=\"config.placeholder | translate\"\n                [attr.aria-describedby]=\"describedByValue\"\n                [searchable]=\"searchable\"\n                clearAllText=\"Clear\"\n                formControlName=\"{{controlName}}\">\n            <ng-template  ng-label-tmp let-item=\"item\" let-clear=\"clear\">\n                <b *ngIf=\"config.ordered\">(#{{item.orderBy}})</b> {{item.display}}\n                <span class=\"ng-value-icon right\" (click)=\"clear(item); $event.stopPropagation()\" aria-hidden=\"true\" role=\"button\" title=\"delete\">\u00D7</span>\n            </ng-template>\n        </ng-select>\n    </div>\n</div>\n<div *ngIf='showDependentControl'>\n    <ng-container *ngFor=\"let field of config.dependents\" dynamicField [config]=\"field\" [group]=\"group\" [modal]=\"modal\"></ng-container>\n</div>\n",
      styles: [".ng-select .ng-control,.ng-select.ng-single .ng-control{min-height:40px;height:40px}.ng-select.ng-select-opened>.ng-select-container{background:#fff;border-color:#949494}.ng-select.ng-select-opened>.ng-select-container:hover{box-shadow:none}.ng-select.ng-select-opened.ng-select-bottom>.ng-select-container{border-bottom-right-radius:0;border-bottom-left-radius:0}.ng-select.ng-select-opened.ng-select-top>.ng-select-container{border-top-right-radius:0;border-top-left-radius:0}.ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border-color:#007eff;box-shadow:inset 0 1px 1px #00000013,0 0 0 3px #007eff1a}.ng-select.ng-select-disabled>.ng-select-container{background-color:#f9f9f9}.ng-select .ng-has-value .ng-placeholder{display:none}.ng-select .ng-select-container{background-color:#fff;border-radius:3px;border:1px solid #949494;min-height:30px;align-items:center}.ng-select .ng-select-container:hover{box-shadow:0 1px #0000000f}.ng-select .ng-select-container .ng-value-container{align-items:center;padding-left:10px}.ng-select .ng-select-container .ng-value-container .ng-placeholder{color:#aaa}.ng-select.ng-select-single .ng-select-container{height:30px}.ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{left:0;padding-left:10px;padding-right:50px;top:5px}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value{background-color:#f9f9f9;border:1px solid #e3e3e3}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value .ng-value-label{padding:0 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-left:7px;padding-top:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{font-size:.9em;margin-right:5px;margin-bottom:5px;background-color:#f5faff;border-radius:2px;border:1px solid #c2e0ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled{background-color:#f9f9f9;border:1px solid #e3e3e3}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled .ng-value-label{padding-left:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-label,.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon{display:inline-block;padding:0 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon:hover{background-color:#d8eafd}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-right:1px solid #c2e0ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:1px solid #c2e0ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding-bottom:3px;padding-left:3px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{top:5px;padding-bottom:5px;padding-left:3px}.ng-select .ng-clear-wrapper{color:#6c6c6c;top:1px}.ng-select .ng-select-container .ng-clear-wrapper .ng-clear{display:block}.ng-select .ng-clear-wrapper .ng-clear:hover{color:#d0021b}.ng-select .ng-spinner-zone{padding-right:5px;padding-top:5px}.ng-select .ng-arrow-wrapper{padding-right:5px;width:25px}.ng-select .ng-arrow-wrapper .ng-arrow{width:30px!important;margin-left:2px;vertical-align:middle;background:url(/components/unicon/assets/svg-output/chevron_down_light.svg) no-repeat center right 15px;background-size:17px;height:20px!important}[dir=rtl] .ng-select .ng-arrow-wrapper .ng-arrow{background:url(/components/unicon/assets/svg-output/chevron_down_light.svg) no-repeat center left 15px/17px}.ng-dropdown-panel{background-color:#fff;border:1px solid #ccc;box-shadow:0 1px #0000000f;left:0}[dir=rtl] .ng-dropdown-panel{text-align:right}.ng-dropdown-panel.ng-select-bottom{top:100%;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-top-color:#e6e6e6;margin-top:-1px}.ng-dropdown-panel.ng-select-bottom .ng-dropdown-panel-items .ng-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.ng-dropdown-panel.ng-select-top{bottom:100%;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-color:#e6e6e6;margin-bottom:-1px}.ng-dropdown-panel.ng-select-top .ng-dropdown-panel-items .ng-option:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.ng-dropdown-panel .ng-dropdown-header{border-bottom:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-footer{border-top:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-panel-items{margin-bottom:1px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{-webkit-user-select:none;user-select:none;cursor:default;padding:8px 10px;font-weight:500;color:#0000008a;cursor:pointer}.group-options .ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{font-weight:700;color:#444}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-disabled{cursor:default}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-marked{background-color:#ebf5ff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected{background-color:#f5faff;font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option{background-color:#fff;color:#3e3e3ede;padding:8px 10px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected{color:#333;background-color:#f5faff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label{font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked{background-color:#428bca;color:#fff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled{color:#ccc}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-left:22px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{padding-right:5px;font-size:80%;font-weight:400}\n"]
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }, {
    type: BackendService
  }, {
    type: i1$1.TranslateService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormNGSelectComponent, {
    className: "FormNGSelectComponent",
    filePath: "dynamic-form/components/form-ngselect/form-ngselect.component.ts",
    lineNumber: 17
  });
})();
const _c0$1n = ["dpFrom"];
const _c1$16 = ["dpTo"];
const _c2$Q = a0 => ({
  "last": a0
});
const _c3$B = a0 => ({
  "bg-primary text-white": a0
});
function FormRangeDatePickerComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.config.elementId, "-blurb", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 6, i0.ɵɵpipeBind1(1, 4, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormRangeDatePickerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "span", 6);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵtemplate(6, FormRangeDatePickerComponent_div_0_div_6_Template, 3, 8, "div", 8);
    i0.ɵɵelementStart(7, "div", 9)(8, "div", 10)(9, "input", 11);
    i0.ɵɵlistener("blur", function FormRangeDatePickerComponent_div_0_Template_input_blur_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 12)(11, "ngb-datepicker", 13, 1);
    i0.ɵɵlistener("dateSelect", function FormRangeDatePickerComponent_div_0_Template_ngb_datepicker_dateSelect_11_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDateSelectionFrom($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 14);
    i0.ɵɵlistener("click", function FormRangeDatePickerComponent_div_0_Template_div_click_13_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showFromCal ? ctx_r1.showFromCal = false : ctx_r1.openFromCal());
    })("keyup.enter", function FormRangeDatePickerComponent_div_0_Template_div_keyup_enter_13_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showFromCal ? ctx_r1.showFromCal = false : ctx_r1.openFromCal());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "span", 15);
    i0.ɵɵtext(15, "misc.to");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 10)(17, "input", 16);
    i0.ɵɵlistener("blur", function FormRangeDatePickerComponent_div_0_Template_input_blur_17_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 12)(19, "ngb-datepicker", 17, 2);
    i0.ɵɵlistener("dateSelect", function FormRangeDatePickerComponent_div_0_Template_ngb_datepicker_dateSelect_19_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDateSelectionTo($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "div", 14);
    i0.ɵɵlistener("click", function FormRangeDatePickerComponent_div_0_Template_div_click_21_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showToCal ? ctx_r1.showToCal = false : ctx_r1.openToCal());
    })("keyup.enter", function FormRangeDatePickerComponent_div_0_Template_div_keyup_enter_21_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showToCal ? ctx_r1.showToCal = false : ctx_r1.openToCal());
    });
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const calendarTemplate_r3 = i0.ɵɵreference(2);
    i0.ɵɵproperty("formGroup", ctx_r1.group)("ngClass", i0.ɵɵpureFunction1(30, _c2$Q, ctx_r1.config.lastChild));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 28, ctx_r1.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-labelledby", ctx_r1.config.elementId)("aria-describedby", ctx_r1.config.blurb ? ctx_r1.config.elementId + "-blurb" + (ctx_r1.modal ? "modal" : "") : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.dateRangeFG);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.config.elementId, "-from", ctx_r1.modal ? "-modal" : "", "");
    i0.ɵɵproperty("formControl", ctx_r1.fromDateControl);
    i0.ɵɵattribute("placeholder", ctx_r1.config.placeholder[0]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.showFromCal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("displayMonths", 1)("startDate", ctx_r1.fromDate)("maxDate", ctx_r1.toDate)("dayTemplate", calendarTemplate_r3);
    i0.ɵɵadvance(6);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.config.elementId, "-to", ctx_r1.modal ? "-modal" : "", "");
    i0.ɵɵproperty("formControl", ctx_r1.toDateControl);
    i0.ɵɵattribute("placeholder", ctx_r1.config.placeholder[1]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.showToCal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("displayMonths", 1)("startDate", ctx_r1.toDate || ctx_r1.fromDate)("minDate", ctx_r1.fromDate)("dayTemplate", calendarTemplate_r3);
  }
}
function FormRangeDatePickerComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const date_r4 = ctx.date;
    const selected_r5 = ctx.selected;
    const focused_r6 = ctx.focused;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("focused", focused_r6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3$B, selected_r5 || ctx_r1.selectDay(date_r4)));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", date_r4.day, " ");
  }
}
const equals = (one, two) => one && two && two.year === one.year && two.month === one.month && two.day === one.day;
const before = (one, two) => !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day ? false : one.day < two.day : one.month < two.month : one.year < two.year;
const after = (one, two) => !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day ? false : one.day > two.day : one.month > two.month : one.year > two.year;
class NgbDateNativeAdapter extends NgbDateAdapter {
  fromModel(date) {
    if (!date) return null;
    if (typeof date === 'string') {
      const splitDate = date.substr(0, 10).split('-');
      if (splitDate.length !== 3) return null;
      const [yearStr, monthStr, dayStr] = splitDate;
      const year = Number(yearStr);
      const month = Number(monthStr);
      const day = Number(dayStr);
      if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day)) {
        return null;
      }
      return NgbDate.from({
        year,
        month,
        day
      });
    }
    if (typeof date.year === 'number' && typeof date.month === 'number' && typeof date.day === 'number') {
      return date;
    }
    return null;
  }
  toModel(date) {
    let output = '';
    if (date) {
      let year = `${date.year}`;
      let month = date.month > 9 ? `${date.month}` : `0${date.month}`;
      let day = date.day > 9 ? `${date.day}` : `0${date.day}`;
      output = `${year}-${month}-${day}`;
    }
    return output;
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵNgbDateNativeAdapter_BaseFactory;
      return function NgbDateNativeAdapter_Factory(__ngFactoryType__) {
        return (ɵNgbDateNativeAdapter_BaseFactory || (ɵNgbDateNativeAdapter_BaseFactory = i0.ɵɵgetInheritedFactory(NgbDateNativeAdapter)))(__ngFactoryType__ || NgbDateNativeAdapter);
      };
    })();
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: NgbDateNativeAdapter,
      factory: NgbDateNativeAdapter.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgbDateNativeAdapter, [{
    type: Injectable
  }], null, null);
})();
class FormRangeDatePickerComponent extends FormInputComponent {
  constructor(calendar, adapter, translate) {
    super(translate);
    this.translate = translate;
    this.showFromCal = false;
    this.showToCal = false;
    this.themePath = '/themes/dawn/dawn/';
    this.isHovered = date => this.fromDate && !this.toDate && this.hoveredDate && after(date, this.fromDate) && before(date, this.hoveredDate);
    this.isInside = date => after(date, this.fromDate) && before(date, this.toDate);
    this.isFrom = date => equals(date, this.fromDate);
    this.isTo = date => equals(date, this.toDate);
    this.calendar = calendar;
    this.adapter = adapter;
  }
  outsideClick(e) {
    let target = e.target;
    if (this.showFromCal) {
      if (!target.closest('.date-picker-container')) {
        this.showFromCal = false;
      }
    }
    if (this.showToCal) {
      if (!target.closest('.date-picker-container')) {
        this.showToCal = false;
      }
    }
  }
  ngOnInit() {
    if (typeof this.config.value[0] === 'undefined') {
      this.config.value[0] = '';
    }
    if (typeof this.config.value[1] === 'undefined') {
      this.config.value[1] = '';
    }
    if (!Array.isArray(this.config.placeholder)) {
      this.config.placeholder = ['', ''];
    }
    this.fromDate = this.config.value[0];
    this.toDate = this.config.value[1];
    this.dateRangeFG = new UntypedFormGroup({
      from: new UntypedFormControl(this.fromDate),
      to: new UntypedFormControl(this.toDate)
    }, {
      updateOn: 'blur'
    });
    this.dateRangeFG.valueChanges.subscribe(selectedValue => {
      if (typeof this.config.onChangeCallback !== 'undefined') {
        this.config.onChangeCallback(this.config.name, selectedValue);
      }
    });
    // replaces current control with new formgroup
    this.group.setControl(this.config.name, this.dateRangeFG);
  }
  get fromDateControl() {
    return this.group.get(this.config.name + '.from');
  }
  get toDateControl() {
    return this.group.get(this.config.name + '.to');
  }
  openFromCal() {
    const parsed = this.adapter.fromModel(this.fromDateControl.value);
    if (this.isValidCalendarDate(parsed)) {
      this.fromDate = parsed;
    }
    this.datePickerFrom.navigateTo(this.fromDate);
    this.showAndFocusFromCal();
  }
  openToCal() {
    const parsed = this.adapter.fromModel(this.toDateControl.value);
    if (this.isValidCalendarDate(parsed)) {
      this.toDate = parsed;
    }
    this.datePickerTo.navigateTo(this.toDate);
    this.showAndFocusToCal();
  }
  showAndFocusFromCal() {
    setTimeout(() => {
      this.showFromCal = true;
      this.datePickerFrom.focus();
    }, 10);
  }
  showAndFocusToCal() {
    setTimeout(() => {
      this.showToCal = true;
      this.datePickerTo.focus();
    }, 10);
  }
  onDateSelectionFrom(date) {
    this.handleDateSelection(this.fromDateControl, 'fromDate', date);
    this.showFromCal = false;
  }
  onDateSelectionTo(date) {
    this.handleDateSelection(this.toDateControl, 'toDate', date);
    this.showToCal = false;
  }
  handleDateSelection(control, assignTo, rawValue) {
    const parsed = this.adapter.fromModel(rawValue);
    if (this.isValidCalendarDate(parsed)) {
      this[assignTo] = parsed;
      control.setValue(this.adapter.toModel(parsed));
    } else {
      this[assignTo] = null;
      control.setValue('');
    }
  }
  onBlur() {
    this.handleDateSelection(this.fromDateControl, 'fromDate', this.fromDateControl.value);
    this.handleDateSelection(this.toDateControl, 'toDate', this.toDateControl.value);
    this.showFromCal = false;
    this.showToCal = false;
  }
  selectDay(date) {
    const target = this.isFrom(date) ? this.fromDate : this.toDate;
    return target && target.month && target.day && target.month === date.month && target.day === date.day;
  }
  isValidCalendarDate(date) {
    return date && typeof date.year === 'number' && typeof date.month === 'number' && typeof date.day === 'number' && this.calendar.isValid(NgbDate.from(date));
  }
  static {
    this.ɵfac = function FormRangeDatePickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormRangeDatePickerComponent)(i0.ɵɵdirectiveInject(i1$4.NgbCalendar), i0.ɵɵdirectiveInject(NgbDateNativeAdapter), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormRangeDatePickerComponent,
      selectors: [["form-range-datepicker"]],
      viewQuery: function FormRangeDatePickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$1n, 5);
          i0.ɵɵviewQuery(_c1$16, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datePickerFrom = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datePickerTo = _t.first);
        }
      },
      hostBindings: function FormRangeDatePickerComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function FormRangeDatePickerComponent_click_HostBindingHandler($event) {
            return ctx.outsideClick($event);
          }, false, i0.ɵɵresolveWindow);
        }
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 1,
      consts: [["calendarTemplate", ""], ["dpFrom", ""], ["dpTo", ""], ["class", "field form-input form-custom date-range-form-custom", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "field", "form-input", "form-custom", "date-range-form-custom", 3, "formGroup", "ngClass"], [1, "field-label", "date-range-custom-label"], [3, "id"], ["role", "group", 1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], [1, "input-group", "rm-padding", 3, "formGroup"], [1, "input-date-picker-wrapper"], ["type", "text", "aria-label", "From", 1, "input-text", "input-date-picker", 3, "blur", "formControl", "id"], [1, "date-picker-container", 3, "hidden"], [3, "dateSelect", "displayMonths", "startDate", "maxDate", "dayTemplate"], ["tabindex", "0", 1, "calendar-icon-container", "icn-calendar", "icon-base", 3, "click", "keyup.enter"], ["translate", "", 1, "range-separator"], ["type", "text", "aria-label", "To", 1, "input-text", "input-date-picker", 3, "blur", "formControl", "id"], [3, "dateSelect", "displayMonths", "startDate", "minDate", "dayTemplate"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], [1, "custom-day", 3, "ngClass"]],
      template: function FormRangeDatePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormRangeDatePickerComponent_div_0_Template, 22, 32, "div", 3)(1, FormRangeDatePickerComponent_ng_template_1_Template, 2, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgIf, i2$1.FormControlDirective, i2$1.FormGroupDirective, i1$4.NgbDatepicker, i1$1.TranslateDirective, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: [".input-group{max-width:500px;gap:5px}.input-date-picker-wrapper{position:relative;display:flex;gap:10px;flex-basis:85%}.field.date-range-form-custom .input-date-picker{display:inline-block}.input-date-picker::-webkit-calendar-picker-indicator{display:none}.input-date-picker::-webkit-input-placeholder{visibility:hidden!important}.date-range-form-custom .custom-day{text-align:center;padding:.185rem .25rem;display:inline-block;height:2rem;width:2rem}.date-range-form-custom .custom-day.focused{background-color:#e6e6e6}.date-range-form-custom .custom-day.range,.custom-day:hover{background-color:#0275d8;color:#fff}.date-range-form-custom .custom-day.faded{background-color:#0275d880}.date-range-form-custom .date-picker-container{background:#fff;z-index:999;position:absolute}.date-range-form-custom .date-range-custom-label{margin-top:auto;margin-bottom:auto}.date-range-form-custom input:last-child{margin-left:0}.date-range-form-custom .range-separator{display:flex;align-items:center}.date-picker-container .ngb-dp-arrow .btn{min-width:0}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormRangeDatePickerComponent, [{
    type: Component,
    args: [{
      selector: 'form-range-datepicker',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"field form-input form-custom date-range-form-custom\" *ngIf=\"!config.hideField\" [formGroup]=\"group\" [ngClass]=\"{'last':config.lastChild}\">\n    <div class=\"field-label date-range-custom-label\">\n        <span id=\"{{config.elementId}}\">\n            {{config.label | translate}}\n        </span>\n    </div>\n    <div class=\"field-widget\" role=\"group\" [attr.aria-labelledby]=\"config.elementId\" [attr.aria-describedby]=\"config.blurb ? (config.elementId + '-blurb' + (modal ? 'modal':'')) : null\">\n        <div *ngIf=\"config.blurb\" id=\"{{config.elementId}}-blurb{{modal?'modal':''}}\" class=\"blurb field-blurb\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div class=\"input-group rm-padding\" [formGroup]=\"dateRangeFG\">\n            <div class=\"input-date-picker-wrapper\">\n                <input type=\"text\"\n                       aria-label=\"From\"\n                       class=\"input-text input-date-picker\"\n                       [formControl]=\"fromDateControl\"\n                       [attr.placeholder]=\"config.placeholder[0]\"\n                       (blur)=\"onBlur()\"\n                        id=\"{{config.elementId}}-from{{modal?'-modal':''}}\"\n                >\n                <div [hidden]=\"!showFromCal\" class=\"date-picker-container\">\n                    <ngb-datepicker #dpFrom\n                                    (dateSelect)=\"onDateSelectionFrom($event)\"\n                                    [displayMonths]=\"1\"\n                                    [startDate]=\"fromDate\"\n                                    [maxDate]=\"toDate\"\n                                    [dayTemplate]=\"calendarTemplate\"\n                    >\n                    </ngb-datepicker>\n                </div>\n                <div\n                        (click)=\"showFromCal ? showFromCal = false : openFromCal()\"\n                        (keyup.enter)=\"showFromCal ? showFromCal = false : openFromCal()\"\n                        class=\"calendar-icon-container icn-calendar icon-base\"\n                        tabindex=\"0\"\n                >\n                </div>\n            </div>\n            \n            <span class=\"range-separator\" translate>misc.to</span>\n            \n            <div class=\"input-date-picker-wrapper\">\n                <input type=\"text\"\n                       aria-label=\"To\"\n                       class=\"input-text input-date-picker\"\n                       [formControl]=\"toDateControl\"\n                       [attr.placeholder]=\"config.placeholder[1]\"\n                       (blur)=\"onBlur()\"\n                        id=\"{{config.elementId}}-to{{modal?'-modal':''}}\"\n                >\n                <div [hidden]=\"!showToCal\" class=\"date-picker-container\">\n                    <ngb-datepicker #dpTo\n                                    (dateSelect)=\"onDateSelectionTo($event)\"\n                                    [displayMonths]=\"1\"\n                                    [startDate]=\"(toDate || fromDate)\"\n                                    [minDate]=\"fromDate\"\n                                    [dayTemplate]=\"calendarTemplate\"\n                    >\n                    </ngb-datepicker>\n                </div>\n                <div\n                        (click)=\"showToCal ? showToCal = false : openToCal()\"\n                        (keyup.enter)=\"showToCal ? showToCal = false : openToCal()\"\n                        class=\"calendar-icon-container icn-calendar icon-base\"\n                        tabindex=\"0\"\n                >\n                </div>\n            </div>\n        </div>\n\n    </div>\n</div>\n\n<ng-template #calendarTemplate\n             let-date=\"date\"\n             let-currentMonth=\"currentMonth\"\n             let-selected=\"selected\"\n             let-focused=\"focused\">\n                        <span class=\"custom-day\"\n                              [ngClass]=\"{'bg-primary text-white' : selected || selectDay(date)}\"\n                              [class.focused]=\"focused\">\n                            {{date.day}}\n                        </span>\n</ng-template>\n",
      styles: [".input-group{max-width:500px;gap:5px}.input-date-picker-wrapper{position:relative;display:flex;gap:10px;flex-basis:85%}.field.date-range-form-custom .input-date-picker{display:inline-block}.input-date-picker::-webkit-calendar-picker-indicator{display:none}.input-date-picker::-webkit-input-placeholder{visibility:hidden!important}.date-range-form-custom .custom-day{text-align:center;padding:.185rem .25rem;display:inline-block;height:2rem;width:2rem}.date-range-form-custom .custom-day.focused{background-color:#e6e6e6}.date-range-form-custom .custom-day.range,.custom-day:hover{background-color:#0275d8;color:#fff}.date-range-form-custom .custom-day.faded{background-color:#0275d880}.date-range-form-custom .date-picker-container{background:#fff;z-index:999;position:absolute}.date-range-form-custom .date-range-custom-label{margin-top:auto;margin-bottom:auto}.date-range-form-custom input:last-child{margin-left:0}.date-range-form-custom .range-separator{display:flex;align-items:center}.date-picker-container .ngb-dp-arrow .btn{min-width:0}\n"]
    }]
  }], () => [{
    type: i1$4.NgbCalendar
  }, {
    type: NgbDateNativeAdapter
  }, {
    type: i1$1.TranslateService
  }], {
    datePickerFrom: [{
      type: ViewChild,
      args: ['dpFrom']
    }],
    datePickerTo: [{
      type: ViewChild,
      args: ['dpTo']
    }],
    outsideClick: [{
      type: HostListener,
      args: ['window:click', ['$event']]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormRangeDatePickerComponent, {
    className: "FormRangeDatePickerComponent",
    filePath: "dynamic-form/components/form-datepicker/form-range-datepicker.component.ts",
    lineNumber: 71
  });
})();
const _c0$1m = ["dp"];
const _c1$15 = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c2$P = a0 => ({
  field_name: a0
});
const _c3$A = a0 => ({
  "bg-primary text-white": a0
});
function FormDatePickerComponent_div_0_div_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 16);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormDatePickerComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, FormDatePickerComponent_div_0_div_1_i_4_Template, 2, 0, "i", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, ctx_r1.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired);
  }
}
function FormDatePickerComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 17);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormDatePickerComponent_div_0_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c2$P, ctx_r1.translatedLabel)), " ");
  }
}
function FormDatePickerComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, FormDatePickerComponent_div_0_div_4_div_1_Template, 4, 6, "div", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors == null ? null : ctx_r1.control.errors.required);
  }
}
function FormDatePickerComponent_div_0_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const date_r3 = ctx.date;
    const selected_r4 = ctx.selected;
    const focused_r5 = ctx.focused;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("focused", focused_r5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3$A, selected_r4 || ctx_r1.selectDay(date_r3)));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", date_r3.day, " ");
  }
}
function FormDatePickerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, FormDatePickerComponent_div_0_div_1_Template, 5, 7, "div", 4);
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵtemplate(3, FormDatePickerComponent_div_0_div_3_Template, 3, 6, "div", 6)(4, FormDatePickerComponent_div_0_div_4_Template, 2, 1, "div", 7);
    i0.ɵɵelementStart(5, "div", 8)(6, "input", 9);
    i0.ɵɵlistener("focus", function FormDatePickerComponent_div_0_Template_input_focus_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showCal = false);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 10);
    i0.ɵɵlistener("click", function FormDatePickerComponent_div_0_Template_div_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showCal ? ctx_r1.showCal = false : ctx_r1.openCal());
    })("keyup.enter", function FormDatePickerComponent_div_0_Template_div_keyup_enter_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showCal ? ctx_r1.showCal = false : ctx_r1.openCal());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 11)(9, "ngb-datepicker", 12, 0);
    i0.ɵɵlistener("dateSelect", function FormDatePickerComponent_div_0_Template_ngb_datepicker_dateSelect_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.onDateSelection($event);
      return i0.ɵɵresetView(ctx_r1.control.markAsTouched());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, FormDatePickerComponent_div_0_ng_template_11_Template, 2, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const customDay_r6 = i0.ɵɵreference(12);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.group)("ngClass", i0.ɵɵpureFunction2(13, _c1$15, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵproperty("formControlName", ctx_r1.config.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", !ctx_r1.showCal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("displayMonths", 1)("startDate", ctx_r1.fromDate)("dayTemplate", customDay_r6);
  }
}
class FormDatePickerComponent extends FormInputComponent {
  constructor(translate, adapter) {
    super(translate);
    this.translate = translate;
    this.showCal = false;
    this.adapter = adapter;
  }
  outsideClick(e) {
    if (!this.showCal) {
      return;
    }
    let target = e.target;
    if (!target.closest('.date-picker-container')) {
      this.showCal = false;
    }
  }
  ngOnInit() {
    this.defaultInit();
    let initValue = this.config.value || this.config.defaultValue;
    if (initValue) {
      this.fromDate = this.adapter.fromModel(initValue);
      setTimeout(() => {
        this.onDateSelection(this.fromDate);
      });
    }
    setTimeout(() => {
      this.control.valueChanges.subscribe(val => {
        this.control.markAsTouched();
        if (val == '') {
          this.control.setValue(null, {
            'emitEvent': false
          });
        }
      });
    });
  }
  openCal() {
    setTimeout(() => this.showCal = true);
  }
  onDateSelection(date) {
    this.showCal = false;
    this.fromDate = date;
    this.control.setValue(this.adapter.toModel(this.fromDate), {
      'emitEvent': true,
      'emitModelToViewChange': true
    });
  }
  selectDay(date) {
    return this.fromDate && this.fromDate.month && this.fromDate.day && this.fromDate.month === date.month && this.fromDate.day === date.day;
  }
  static {
    this.ɵfac = function FormDatePickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormDatePickerComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(NgbDateNativeAdapter));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormDatePickerComponent,
      selectors: [["form-datepicker"]],
      viewQuery: function FormDatePickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$1m, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datePicker = _t.first);
        }
      },
      hostBindings: function FormDatePickerComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function FormDatePickerComponent_click_HostBindingHandler($event) {
            return ctx.outsideClick($event);
          }, false, i0.ɵɵresolveWindow);
        }
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["dp", ""], ["customDay", ""], ["class", "field form-input form-custom date-range-form-custom", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "field", "form-input", "form-custom", "date-range-form-custom", 3, "formGroup", "ngClass"], ["class", "field-label", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], [1, "input-group"], ["type", "text", 1, "input-text", "input-date-picker", 3, "focus", "id", "formControlName"], ["tabindex", "0", 1, "calendar-icon-container", "icn-calendar", "icon-base", "single-date", 3, "click", "keyup.enter"], [1, "date-picker-container", 3, "hidden"], [3, "dateSelect", "displayMonths", "startDate", "dayTemplate"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [4, "ngIf"], [1, "icn-error_filled"], [1, "custom-day", 3, "ngClass"]],
      template: function FormDatePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormDatePickerComponent_div_0_Template, 13, 16, "div", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, i1$4.NgbDatepicker, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: [".input-group[_ngcontent-%COMP%]{max-width:500px;gap:5px}.input-date-picker-wrapper[_ngcontent-%COMP%]{position:relative;display:flex;gap:10px;flex-basis:85%}.field.date-range-form-custom[_ngcontent-%COMP%]   .input-date-picker[_ngcontent-%COMP%]{display:inline-block}.input-date-picker[_ngcontent-%COMP%]::-webkit-calendar-picker-indicator{display:none}.input-date-picker[_ngcontent-%COMP%]::-webkit-input-placeholder{visibility:hidden!important}.date-range-form-custom[_ngcontent-%COMP%]   .custom-day[_ngcontent-%COMP%]{text-align:center;padding:.185rem .25rem;display:inline-block;height:2rem;width:2rem}.date-range-form-custom[_ngcontent-%COMP%]   .custom-day.focused[_ngcontent-%COMP%]{background-color:#e6e6e6}.date-range-form-custom[_ngcontent-%COMP%]   .custom-day.range[_ngcontent-%COMP%], .custom-day[_ngcontent-%COMP%]:hover{background-color:#0275d8;color:#fff}.date-range-form-custom[_ngcontent-%COMP%]   .custom-day.faded[_ngcontent-%COMP%]{background-color:#0275d880}.date-range-form-custom[_ngcontent-%COMP%]   .date-picker-container[_ngcontent-%COMP%]{background:#fff;z-index:999;position:absolute}.date-range-form-custom[_ngcontent-%COMP%]   .date-range-custom-label[_ngcontent-%COMP%]{margin-top:auto;margin-bottom:auto}.date-range-form-custom[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:last-child{margin-left:0}.date-range-form-custom[_ngcontent-%COMP%]   .range-separator[_ngcontent-%COMP%]{display:flex;align-items:center}.date-picker-container[_ngcontent-%COMP%]   .ngb-dp-arrow[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{min-width:0}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormDatePickerComponent, [{
    type: Component,
    args: [{
      selector: 'form-datepicker',
      standalone: false,
      template: "<div class=\"field form-input form-custom date-range-form-custom\" *ngIf=\"!config.hideField\" [formGroup]=\"group\" [ngClass]=\"{'field-error': !control.valid && (control.dirty || control.touched), 'last': config.lastChild}\">\n    <div *ngIf=\"!config.hideLabel\" class=\"field-label\">\n        <label for=\"{{config.elementId}}{{modal ? 'modal' : ''}}\">\n            {{config.label | translate}}\n            <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n        </label>\n    </div>\n    <div class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb field-blurb\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n            <div *ngIf=\"control.errors?.required\">\n                <i class=\"icn-error_filled\"></i>\n                {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n            </div>\n        </div>\n        <div class=\"input-group\">\n            <input id=\"{{config.elementId}}{{modal ? 'modal' : ''}}\"\n                   type=\"text\"\n                   (focus)=\"showCal = false\"\n                   class=\"input-text input-date-picker\"\n                   [formControlName]=\"config.name\">\n            <div (click)=\"showCal ? showCal = false : openCal()\"\n                 (keyup.enter)=\"showCal ? showCal = false : openCal()\"\n                 class=\"calendar-icon-container icn-calendar icon-base single-date\"\n                 tabindex=\"0\">\n            </div>\n        </div>\n        <div [hidden]=\"!showCal\" class=\"date-picker-container\">\n            <ngb-datepicker #dp\n                            (dateSelect)=\"onDateSelection($event); control.markAsTouched();\"\n                            [displayMonths]=\"1\"\n                            [startDate]=\"fromDate\"\n                            [dayTemplate]=\"customDay\">\n            </ngb-datepicker>\n            <ng-template #customDay\n                         let-date=\"date\"\n                         let-currentMonth=\"currentMonth\"\n                         let-selected=\"selected\"\n                         let-focused=\"focused\">\n                        <span class=\"custom-day\"\n                              [ngClass]=\"{'bg-primary text-white' : selected || selectDay(date)}\"\n                              [class.focused]=\"focused\">\n                            {{date.day}}\n                        </span>\n            </ng-template>\n        </div>\n    </div>\n</div>\n",
      styles: [".input-group{max-width:500px;gap:5px}.input-date-picker-wrapper{position:relative;display:flex;gap:10px;flex-basis:85%}.field.date-range-form-custom .input-date-picker{display:inline-block}.input-date-picker::-webkit-calendar-picker-indicator{display:none}.input-date-picker::-webkit-input-placeholder{visibility:hidden!important}.date-range-form-custom .custom-day{text-align:center;padding:.185rem .25rem;display:inline-block;height:2rem;width:2rem}.date-range-form-custom .custom-day.focused{background-color:#e6e6e6}.date-range-form-custom .custom-day.range,.custom-day:hover{background-color:#0275d8;color:#fff}.date-range-form-custom .custom-day.faded{background-color:#0275d880}.date-range-form-custom .date-picker-container{background:#fff;z-index:999;position:absolute}.date-range-form-custom .date-range-custom-label{margin-top:auto;margin-bottom:auto}.date-range-form-custom input:last-child{margin-left:0}.date-range-form-custom .range-separator{display:flex;align-items:center}.date-picker-container .ngb-dp-arrow .btn{min-width:0}\n"]
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: NgbDateNativeAdapter
  }], {
    datePicker: [{
      type: ViewChild,
      args: ['dp', {
        static: true
      }]
    }],
    outsideClick: [{
      type: HostListener,
      args: ['window:click', ['$event']]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormDatePickerComponent, {
    className: "FormDatePickerComponent",
    filePath: "dynamic-form/components/form-datepicker/form-datepicker.component.ts",
    lineNumber: 13
  });
})();
const _c0$1l = ["hpWidget"];
const _c1$14 = ["widget"];
const _c2$O = ["inputField"];
const _c3$z = ["dropdown"];
const _c4$t = ["chipList"];
const _c5$k = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c6$f = a0 => ({
  field_name: a0
});
const _c7$a = () => ({
  standalone: true
});
const _c8$9 = a0 => ({
  "filtering": a0
});
const _c9$7 = a0 => ({
  item: a0
});
const _c10$5 = a0 => ({
  "active": a0
});
function FormHierpicklistComponent_div_0_label_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("id", ctx_r0.id + "-label")("aria-required", ctx_r0.isRequired);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, ctx_r0.label));
  }
}
function FormHierpicklistComponent_div_0_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 18);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormHierpicklistComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 19);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormHierpicklistComponent_div_0_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 21);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c6$f, ctx_r0.translatedLabel)), " ");
  }
}
function FormHierpicklistComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, FormHierpicklistComponent_div_0_div_6_div_1_Template, 4, 6, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function FormHierpicklistComponent_div_0_7_ng_template_0_Template(rf, ctx) {}
function FormHierpicklistComponent_div_0_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormHierpicklistComponent_div_0_7_ng_template_0_Template, 0, 0, "ng-template", 22);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const chipListTemplate_r2 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", chipListTemplate_r2);
  }
}
function FormHierpicklistComponent_div_0_ng_container_9_div_1_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("mousedown", function FormHierpicklistComponent_div_0_ng_container_9_div_1_button_4_Template_button_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(4);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    })("keydown.enter", function FormHierpicklistComponent_div_0_ng_container_9_div_1_button_4_Template_button_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    })("keydown.space", function FormHierpicklistComponent_div_0_ng_container_9_div_1_button_4_Template_button_keydown_space_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    });
    i0.ɵɵelement(2, "i", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("tabindex", ctx_r0.selects.length ? "0" : "-1")("aria-label", i0.ɵɵpipeBind1(1, 2, "misc.Deselect"));
  }
}
function FormHierpicklistComponent_div_0_ng_container_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24, 1);
    i0.ɵɵlistener("mousedown", function FormHierpicklistComponent_div_0_ng_container_9_div_1_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.openPicklist($event));
    })("keydown.enter", function FormHierpicklistComponent_div_0_ng_container_9_div_1_Template_div_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.openPicklist($event));
    })("keydown.space", function FormHierpicklistComponent_div_0_ng_container_9_div_1_Template_div_keydown_space_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.openPicklist($event));
    });
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FormHierpicklistComponent_div_0_ng_container_9_div_1_button_4_Template, 3, 4, "button", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-labelledby", ctx_r0.id + "-label " + ctx_r0.id + "-selected")("role", "combobox")("tabindex", ctx_r0.activeInputField ? -1 : 0)("aria-expanded", ctx_r0.showDropdownList)("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("id", ctx_r0.id + "-selected");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.getSelectedFirstItemName());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.multiple && ctx_r0.selects.length);
  }
}
function FormHierpicklistComponent_div_0_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormHierpicklistComponent_div_0_ng_container_9_div_1_Template, 5, 8, "div", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.activeInputField);
  }
}
function FormHierpicklistComponent_div_0_ng_container_10_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("mousedown", function FormHierpicklistComponent_div_0_ng_container_10_button_4_Template_button_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(3);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    })("keydown.enter", function FormHierpicklistComponent_div_0_ng_container_10_button_4_Template_button_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    })("keydown.space", function FormHierpicklistComponent_div_0_ng_container_10_button_4_Template_button_keydown_space_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    });
    i0.ɵɵelement(2, "i", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "misc.Clear"));
  }
}
function FormHierpicklistComponent_div_0_ng_container_10_ng_container_5_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hierarchical-list-widget", 33, 4);
    i0.ɵɵlistener("selection", function FormHierpicklistComponent_div_0_ng_container_10_ng_container_5_Conditional_4_Template_hierarchical_list_widget_selection_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.hpWidgetSelectionUpdates($event));
    })("searchChanged", function FormHierpicklistComponent_div_0_ng_container_10_ng_container_5_Conditional_4_Template_hierarchical_list_widget_searchChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.hpWidgetSearchUpdates($event));
    })("navigationChanged", function FormHierpicklistComponent_div_0_ng_container_10_ng_container_5_Conditional_4_Template_hierarchical_list_widget_navigationChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.hpWidgetNavigationUpdates($event));
    })("keydown.escape", function FormHierpicklistComponent_div_0_ng_container_10_ng_container_5_Conditional_4_Template_hierarchical_list_widget_keydown_escape_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.escapeDropdownList($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("config", ctx_r0.widgetConfig)("list", ctx_r0.widgetList)("values", ctx_r0.widgetSelects)("search", ctx_r0.widgetSearch);
  }
}
function FormHierpicklistComponent_div_0_ng_container_10_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 30)(2, "div", 31, 3);
    i0.ɵɵtemplate(4, FormHierpicklistComponent_div_0_ng_container_10_ng_container_5_Conditional_4_Template, 2, 4, "hierarchical-list-widget", 32);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c8$9, ctx_r0.isSearching()));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.widgetConfig && ctx_r0.widgetList ? 4 : -1);
  }
}
function FormHierpicklistComponent_div_0_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 29, 2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function FormHierpicklistComponent_div_0_ng_container_10_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.search, $event) || (ctx_r0.search = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormHierpicklistComponent_div_0_ng_container_10_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.searchChange($event));
    })("keydown", function FormHierpicklistComponent_div_0_ng_container_10_Template_input_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.formKeyNav($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FormHierpicklistComponent_div_0_ng_container_10_button_4_Template, 3, 3, "button", 26)(5, FormHierpicklistComponent_div_0_ng_container_10_ng_container_5_Template, 5, 4, "ng-container", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.search);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(14, _c7$a))("placeholder", i0.ɵɵpipeBind1(3, 12, ctx_r0.placeholder));
    i0.ɵɵattribute("id", ctx_r0.id + "-search")("aria-autocomplete", "list")("aria-expanded", ctx_r0.showDropdownList || ctx_r0.alwaysShowDropdownList)("aria-labelledby", ctx_r0.hideLabel ? null : ctx_r0.id + "-label")("aria-describedby", ctx_r0.describedByValue)("aria-owns", ctx_r0.id + "-list")("role", "combobox");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.search);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showDropdownList || ctx_r0.alwaysShowDropdownList);
  }
}
function FormHierpicklistComponent_div_0_13_ng_template_0_Template(rf, ctx) {}
function FormHierpicklistComponent_div_0_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormHierpicklistComponent_div_0_13_ng_template_0_Template, 0, 0, "ng-template", 22);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const chipListTemplate_r2 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", chipListTemplate_r2);
  }
}
function FormHierpicklistComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
    i0.ɵɵtemplate(2, FormHierpicklistComponent_div_0_label_2_Template, 3, 5, "label", 10)(3, FormHierpicklistComponent_div_0_i_3_Template, 2, 0, "i", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵtemplate(5, FormHierpicklistComponent_div_0_div_5_Template, 3, 6, "div", 13)(6, FormHierpicklistComponent_div_0_div_6_Template, 2, 1, "div", 14)(7, FormHierpicklistComponent_div_0_7_Template, 1, 1, null, 10);
    i0.ɵɵelementStart(8, "div", 15);
    i0.ɵɵtemplate(9, FormHierpicklistComponent_div_0_ng_container_9_Template, 2, 1, "ng-container", 10)(10, FormHierpicklistComponent_div_0_ng_container_10_Template, 6, 15, "ng-container", 10);
    i0.ɵɵelementStart(11, "div", 16);
    i0.ɵɵelement(12, "i", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, FormHierpicklistComponent_div_0_13_Template, 1, 1, null, 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c5$k, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild));
    i0.ɵɵattribute("id", ctx_r0.id);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.hideLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.hideChipList && ctx_r0.chipListPosition === "top");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.activeInputField && !ctx_r0.alwaysShowDropdownList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.activeInputField || ctx_r0.alwaysShowDropdownList);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.hideChipList && ctx_r0.chipListPosition === "bottom");
  }
}
function FormHierpicklistComponent_ng_template_1_div_0_div_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39, 6);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function FormHierpicklistComponent_ng_template_1_div_0_div_1_div_3_Template_div_click_0_listener() {
      const select_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.removeSelect(select_r10));
    });
    i0.ɵɵelementStart(3, "div", 40)(4, "div", 25);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 41);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵlistener("click", function FormHierpicklistComponent_ng_template_1_div_0_div_1_div_3_Template_button_click_6_listener() {
      const select_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.removeSelect(select_r10));
    });
    i0.ɵɵelement(8, "i", 28);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const select_r10 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("cdkOption", select_r10);
    i0.ɵɵattribute("role", "option")("aria-label", i0.ɵɵpipeBind2(2, 8, "misc.Item - Remove", i0.ɵɵpureFunction1(14, _c9$7, ctx_r0.getItemLabel(select_r10))));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c10$5, ctx_r0.showDropdownList));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.getItemLabel(select_r10));
    i0.ɵɵadvance();
    i0.ɵɵattribute("tabindex", "-1")("aria-hidden", true)("aria-label", i0.ɵɵpipeBind2(7, 11, "misc.Item - Remove", i0.ɵɵpureFunction1(18, _c9$7, ctx_r0.getItemLabel(select_r10))));
  }
}
function FormHierpicklistComponent_ng_template_1_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37, 5);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("keydown", function FormHierpicklistComponent_ng_template_1_div_0_div_1_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.chipNav($event));
    });
    i0.ɵɵtemplate(3, FormHierpicklistComponent_ng_template_1_div_0_div_1_div_3_Template, 9, 20, "div", 38);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("cdkListboxOrientation", "horizontal");
    i0.ɵɵattribute("role", "listbox")("aria-label", i0.ɵɵpipeBind1(2, 5, "misc.Selected options:"))("aria-live", ctx_r0.showDropdownList ? "polite" : "off");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.selects);
  }
}
function FormHierpicklistComponent_ng_template_1_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, FormHierpicklistComponent_ng_template_1_div_0_div_1_Template, 4, 7, "div", 36);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.multiple);
  }
}
function FormHierpicklistComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormHierpicklistComponent_ng_template_1_div_0_Template, 2, 1, "div", 34);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.multiple && (ctx_r0.selects == null ? null : ctx_r0.selects.length));
  }
}
class FormHierpicklistComponent extends FormInputComponent {
  get cdkListKeyManager() {
    // @ts-ignore
    return this.cdkListbox?.listKeyManager;
  }
  constructor(searchTextPipe, elementRef, cdRef, translate, zone) {
    super(translate);
    this.searchTextPipe = searchTextPipe;
    this.elementRef = elementRef;
    this.cdRef = cdRef;
    this.translate = translate;
    this.zone = zone;
    // FormConfig Options
    this.multiple = true;
    this.parentSelectable = true;
    this.chipListPosition = 'top';
    this.placeholder = 'misc.Search';
    this.label = '';
    this.hideLabel = false;
    this.isInit = true;
    this.unsubscribe = new Subject();
    this.hideChipList = false;
    this.alwaysShowDropdownList = false;
    this._items = [];
    this.backup_items = [];
    this.selects = [];
    this.backup_treeSelection = [];
    this.treeSelection = [];
    this.backup_search = '';
    this.search = '';
    this.searchChange = this.debounce(e => {
      this.searchChangeHandler(e);
    });
    this.activeInputField = false;
    this.showDropdownList = false;
    this.chipFocusIndex = 0;
    this.isRTL = window.document.dir === 'rtl';
    this.clickEventDelay = 10; // Delay value used in setTimeout() to the click event to prevent forced close the NGX bootstrap's dropdown when click any toggle button of widget. This is because the widget's toggle update is faster than bootstrap's code to check the target of the click event, so it is checked after the event target has already disappeared.
    this.widgetSearch = '';
    this.widgetSelects = [];
    this.blur = this.blur.bind(this);
  }
  // Configuration
  ngOnInit() {
    this.defaultInit();
    this.fieldInit();
    this.setupHierpicklistWidget();
    if (this.config.value) {
      this.control.setValue(this.config.value, {
        'emitEvent': false,
        'emitModelToViewChange': true
      });
    }
  }
  ngOnDestroy() {
    this.removeEventListeners();
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  fieldInit() {
    this.id = this.config.elementId + (this.modal ? 'modal' : '');
    this.applyConfigs(['label', 'hideLabel', 'chipListPosition', 'multiple', 'parentSelectable', 'placeholder', 'hideChipList', 'alwaysShowDropdownList']);
    this.isMultiSelect = this.multiple && this.parentSelectable;
    this.control.valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(newVal => this.updateItemsSelect(newVal));
    this.dynamicFunctionCall(this.config.options, this.setOptionItems);
    this.addEventListeners();
  }
  dynamicFunctionCall(option, bindFn) {
    if (option instanceof Observable) {
      option.pipe(debounceTime(100), distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)), takeUntil(this.unsubscribe)).subscribe(res => {
        if (!_.isNull(res)) {
          bindFn.call(this, res);
        }
      });
    } else {
      bindFn.call(this, option);
    }
  }
  setOptionItems(options) {
    /**
     * Note:
     * In the existing hierpicklist data structure from backend, the list item for 'Select All' option is represented by an item with an ID of '0'. (Example: 'Major' field)
     *
     * In the `list.js` file of the Vanilla JS library for Janus Hierpicklist and hierarchical-list-widget.component.ts, the "Select All" uses a property called `isExclusiveSelect`.
     * When this item is selected, all other items should be deselected, ensuring that only this item remains selected.
     *
     * If the backend changes the condition/indicator for representing 'Select All' in the future, this implementation should be changed accordingly.
     */
    const selectAllItem = this.findItem(options, 'id', '0');
    if (selectAllItem?.length) {
      selectAllItem[0]['isExclusiveSelect'] = true;
    }
    /** End **/
    this._items = options;
    this.items = this._items;
    this.widgetList = this._items;
    this.valueChangesWithOptionUpdate(options);
  }
  valueChangesWithOptionUpdate(options) {
    if (!this.isInit) {
      this.control.setValue(this.convertValue([]));
    } else if (!_.isEmpty(options)) {
      this.control.setValue(this.config.value);
      this.isInit = false;
    }
  }
  updateItemsSelect(newVal = []) {
    const values = _.uniqWith(this.findItem(this._items, 'id', newVal), _.isEqual);
    if (!_.isEqual(this.selects, values)) {
      this.selects = values;
      this.widgetSelects = values.map(v => v.id);
      let itemName = this.getItemLabel(values[0]);
      if (!this.multiple && this.search !== itemName) {
        this.search = itemName;
        this.backup_search = this.search;
      }
    }
    this.cdRef.detectChanges();
  }
  searchChangeHandler(text) {
    if (this.isSearching() && _.isEqual(text, this.treeSelection[0].key)) {
      return;
    }
    if (!this.multiple && _.isEmpty(text)) {
      this.clearValue(true);
      this.save([]);
      this.resetSearchText();
    } else {
      this.widgetSearch = text;
    }
    this.cdRef.detectChanges();
  }
  applyConfigs(values = []) {
    values.forEach(key => {
      if (!_.isUndefined(this.config[key]) && this.hasOwnProperty(key)) {
        this[key] = this.config[key];
      }
    });
  }
  // Picklist
  setupHierpicklistWidget() {
    this.widgetConfig = {
      multiple: this.multiple,
      id: this.id,
      templateType: 'valkyrie',
      parentSelectable: this.parentSelectable,
      autoScrollWhenInit: !this.multiple
    };
  }
  hpWidgetSearchUpdates(searchText) {
    this.search = searchText;
  }
  getValuesId(values = this.selects) {
    return values.map(val => val.id);
  }
  hpWidgetSelectionUpdates(values) {
    const controlValue = _.isArray(this.control.value) ? this.control.value : _.isNil(this.control.value) ? [] : [this.control.value];
    const _values = this.getValuesId(values);
    if (_.isEqual(_.sortBy(controlValue), _.sortBy(_values))) {
      return;
    }
    this.save(values);
    if (!this.multiple) {
      this.saveLastSelection(values[0], this.items, this.treeSelection);
      this.closePicklist();
    }
    if (!this.group.touched) {
      this.group.markAsTouched();
    }
  }
  hpWidgetNavigationUpdates(states) {
    switch (states.type) {
      case 'close':
        this.showDropdownList = false;
        break;
      case 'escape':
        if (this.multiple) {
          this.resetSearchText();
        } else {
          this.closePicklist(states.event);
          this.restoreLastSelection();
        }
        this.escapeDropdownList(states.event);
        break;
      case 'tab':
        if (!this.multiple) {
          this.restoreLastSelection();
        }
        if (states.event.shiftKey) {
          if (this.selects.length) {
            this.closePicklist();
            this.focusChip();
          } else {
            this.closePicklist(states.event);
          }
        } else {
          this.closePicklist();
        }
        break;
      case 'backwardFromRoot':
        this.backwardFromRootAction(states);
        break;
      default:
        this.items = states.items;
        this.treeSelection = states.treeSelection;
    }
  }
  openPicklist(e) {
    if (!this.activeInputField && this.control.enabled) {
      this.activeInputField = true;
      this.showDropdownList = true;
      this.cdRef.detectChanges();
      setTimeout(() => {
        this.focusSearchField();
      }, 10);
    }
  }
  closePicklist(e = undefined) {
    this.activeInputField = false;
    this.showDropdownList = false;
    this.widgetSearch = '';
    setTimeout(() => {
      this.widgetElm.nativeElement.focus();
    }, 30);
  }
  openDropdown(e = undefined) {
    this.showDropdownList = true;
    if (e instanceof KeyboardEvent) {
      setTimeout(() => {
        this.focusSearchField();
      }, 10);
    }
  }
  escapeDropdownList(e = undefined) {
    this.focusSearchField();
  }
  focusDropdownList() {
    setTimeout(() => {
      this.hpWidget?.focusToFirstItem();
    }, 10);
  }
  focusSearchField() {
    this.inputFieldElm.nativeElement.focus();
  }
  findItem(items = [], key, value) {
    let currentLevel = items.filter(i => _.isArray(value) ? value.includes(i[key]) : _.isEqual(i[key], value));
    let childrenLevel = _.flatten(items.map(i => i.children ? this.findItem(i.children, key, value) : []).filter(i => !_.isEmpty(i)));
    return currentLevel.concat(childrenLevel);
  }
  save(val) {
    const save = val.map(v => v.id);
    this.setValue(this.convertValue(save));
  }
  setValue(value) {
    this.control.setValue(value);
    this.onChangeCallback(value);
  }
  convertValue(value) {
    let val = value;
    if (!this.multiple && _.isArray(val)) {
      val = val[0];
    }
    return val;
  }
  onChangeCallback(value) {
    if (_.isFunction(this.config.onChangeCallback)) {
      this.config.onChangeCallback(this.config.name, this.convertValue(value));
    }
  }
  removeSelect(item) {
    setTimeout(() => {
      let save = _.filter(this.selects, s => !_.isEqual(s, item));
      this.save(save);
      if (!this.group.touched) {
        this.group.markAsTouched();
      }
      this.triggerEvent('remove', item);
    }, this.clickEventDelay);
  }
  getTitle() {
    const last = _.last(this.treeSelection);
    return last && last.type === 'click' ? last.label : '';
  }
  getSelectedFirstItemName() {
    return !this.multiple && !_.isEmpty(this.selects) ? this.selects[0].value : '';
  }
  isSearching() {
    return this.treeSelection.length && this.treeSelection[this.treeSelection.length - 1].type === 'search';
  }
  isSingleSelectorSelected() {
    return !this.multiple && !_.isEmpty(this.selects);
  }
  saveLastSelection(item = undefined, itemsList = [], treeSelection = []) {
    this.backup_items = _.cloneDeep(itemsList);
    this.backup_treeSelection = _.cloneDeep(treeSelection);
    this.backup_search = item ? this.getItemLabel(item) : '';
  }
  restoreLastSelection() {
    this.search = _.isEmpty(this.backup_search) ? '' : this.backup_search;
    this.treeSelection = _.isEmpty(this.backup_treeSelection) ? [] : _.cloneDeep(this.backup_treeSelection);
    this.items = _.isEmpty(this.backup_items) ? _.cloneDeep(this._items) : _.cloneDeep(this.backup_items);
  }
  clearLastSelection() {
    this.saveLastSelection();
  }
  resetSearchText() {
    this.search = '';
    this.widgetSearch = '';
  }
  clearSearch() {
    setTimeout(() => {
      if (this.isSingleSelectorSelected()) {
        this.save([]);
      }
      this.clearValue(true);
      const field = this.activeInputField ? this.inputFieldElm : this.widgetElm;
      field.nativeElement.focus();
    }, this.clickEventDelay);
  }
  clearValue(clearBackup = false) {
    this.resetSearchText();
    this.selects = [];
    this.widgetSelects = [];
    if (clearBackup) {
      this.clearLastSelection();
    }
  }
  backwardFromRootAction(states) {
    this.resetSearchText();
    this.focusSearchField();
  }
  wrapAround(idx, maxNum, loop = true) {
    let newIdx = idx;
    const min = loop ? 0 : maxNum;
    const max = loop ? maxNum : 0;
    if (idx < 0) {
      newIdx = max;
    } else if (idx > maxNum) {
      newIdx = min;
    }
    return newIdx < 0 ? -1 : newIdx;
  }
  getItemLabel(item = {}) {
    return item[this.getKeyForLabel(item)];
  }
  getKeyForLabel(item) {
    return item.hasOwnProperty('display') ? 'display' : 'value';
  }
  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }
  // Picklist Keyboard Navigations
  formKeyNav(e) {
    if (!this.activeInputField) {
      this.activeInputField = true;
    }
    switch (e.code) {
      case 'ArrowDown':
        this.focusDropdownList();
        break;
      case 'Escape':
        this.closePicklist(e);
        break;
      case 'Enter':
        this.triggerEvent('search', e);
        break;
    }
  }
  // Auto-close Widget
  shouldSkipDropdownClose(e) {
    return !(e.target instanceof HTMLElement) || !this.activeInputField;
  }
  blur(e) {
    if (this.shouldSkipDropdownClose(e)) {
      return;
    }
    const contains = e.target.closest('#' + this.id + ' .picklist-container');
    setTimeout(d => {
      if (!this.config.hideField && !this.elementRef.nativeElement.querySelector('.picklist-container').contains(document.activeElement) && !contains) {
        this.activeInputField = false;
        this.showDropdownList = false;
        if (this.isSingleSelectorSelected()) {
          this.restoreLastSelection();
        } else {
          this.resetSearchText();
          this.clearLastSelection();
        }
        this.cdRef.detectChanges();
      }
    }, 50);
  }
  addEventListeners() {
    this.zone.runOutsideAngular(() => {
      document.addEventListener('focus', this.blur, true);
      document.addEventListener('click', this.blur, true);
      document.addEventListener('keypress', this.blur, true);
    });
  }
  removeEventListeners() {
    document.removeEventListener('focus', this.blur, true);
    document.removeEventListener('click', this.blur, true);
    document.removeEventListener('keypress', this.blur, true);
  }
  // Chip Selection List
  focusChip() {
    setTimeout(() => {
      const item = this.chipList.nativeElement.querySelectorAll('[tabindex]:not([tabindex="-1"])')[0];
      item?.focus();
    }, 0);
  }
  focusNextChip(idx, e) {
    setTimeout(() => {
      if (this.selects.length) {
        this.chipFocusIndex = this.wrapAround(idx - 1, this.selects.length - 1, false);
        this.cdkListKeyManager.setActiveItem(this.chipFocusIndex);
      } else {
        this.closePicklist(e);
      }
    }, this.clickEventDelay);
  }
  chipNav(e) {
    const activeItemIndex = this.cdkListKeyManager.activeItemIndex;
    switch (e.key) {
      case 'Space':
      case 'Enter':
        this.removeSelect(this.selects[activeItemIndex]);
        this.focusNextChip(activeItemIndex, e);
        break;
    }
  }
  static {
    this.ɵfac = function FormHierpicklistComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormHierpicklistComponent)(i0.ɵɵdirectiveInject(SearchTextPipe$1), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormHierpicklistComponent,
      selectors: [["form-hierpicklist"]],
      viewQuery: function FormHierpicklistComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$1l, 5);
          i0.ɵɵviewQuery(_c1$14, 5);
          i0.ɵɵviewQuery(_c2$O, 5);
          i0.ɵɵviewQuery(_c3$z, 5);
          i0.ɵɵviewQuery(_c4$t, 5);
          i0.ɵɵviewQuery(CdkListbox, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hpWidget = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.widgetElm = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputFieldElm = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chipList = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cdkListbox = _t.first);
        }
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 1,
      consts: [["chipListTemplate", ""], ["widget", ""], ["inputField", ""], ["dropdown", ""], ["hpWidget", ""], ["chipList", ""], ["chipListItem", ""], ["class", "picklist-widget field", 3, "ngClass", 4, "ngIf"], [1, "picklist-widget", "field", 3, "ngClass"], [1, "field-label"], [4, "ngIf"], ["class", "req-indicator", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], [1, "picklist-container", "input-text"], [1, "picklist-dropdown-icon"], [1, "icn-chevron_down"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [1, "icn-error_filled"], [3, "ngTemplateOutlet"], ["class", "picklist-field picklist-selected-text input-text", 3, "mousedown", "keydown.enter", "keydown.space", 4, "ngIf"], [1, "picklist-field", "picklist-selected-text", "input-text", 3, "mousedown", "keydown.enter", "keydown.space"], [1, "text-truncate"], ["type", "button", "class", "clearBtn", 3, "mousedown", "keydown.enter", "keydown.space", 4, "ngIf"], ["type", "button", 1, "clearBtn", 3, "mousedown", "keydown.enter", "keydown.space"], [1, "icn-close"], ["type", "search", 1, "picklist-field", "picklist-search-input", "input-text", 3, "ngModelChange", "keydown", "ngModel", "ngModelOptions", "placeholder"], [1, "picklist-dropdown-wrapper"], [1, "picklist-dropdown", 3, "ngClass"], [3, "config", "list", "values", "search"], [3, "selection", "searchChanged", "navigationChanged", "keydown.escape", "config", "list", "values", "search"], ["class", "badge-group", 4, "ngIf"], [1, "badge-group"], ["class", "badge-list", "cdkListbox", "", 3, "cdkListboxOrientation", "keydown", 4, "ngIf"], ["cdkListbox", "", 1, "badge-list", 3, "keydown", "cdkListboxOrientation"], ["class", "badge-wrapper", "aria-selected", "true", 3, "cdkOption", "click", 4, "ngFor", "ngForOf"], ["aria-selected", "true", 1, "badge-wrapper", 3, "click", "cdkOption"], [1, "badge", "badge-small", 3, "ngClass"], ["type", "button", 3, "click"]],
      template: function FormHierpicklistComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormHierpicklistComponent_div_0_Template, 14, 13, "div", 7)(1, FormHierpicklistComponent_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, hierarchicalListWidgetComponent, i6.CdkListbox, i6.CdkOption, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormHierpicklistComponent, [{
    type: Component,
    args: [{
      selector: 'form-hierpicklist',
      standalone: false,
      template: "<div class=\"picklist-widget field\" *ngIf=\"!config.hideField\" [attr.id]=\"id\" [ngClass]=\"{'field-error': !control.valid && (control.dirty || control.touched), 'last': config.lastChild}\">\n    <div class=\"field-label\">\n        <label *ngIf=\"!hideLabel\" [attr.id]=\"id + '-label'\" [attr.aria-required]=\"isRequired\">{{ label | translate }}</label>\n        <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n    </div>\n    <div class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb field-blurb\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n            <div *ngIf=\"control.errors.required\">\n                <i class=\"icn-error_filled\"></i>\n                {{ 'misc.Field is required' | translate: { field_name: translatedLabel } }}\n            </div>\n        </div>\n\n        <ng-template *ngIf=\"!hideChipList && chipListPosition === 'top'\" [ngTemplateOutlet]=\"chipListTemplate\"></ng-template>\n\n        <div class=\"picklist-container input-text\">\n\n            <ng-container *ngIf=\"!activeInputField && !alwaysShowDropdownList\">\n                <div class=\"picklist-field picklist-selected-text input-text\"\n                     #widget\n                     *ngIf=\"!activeInputField\"\n                     [attr.aria-labelledby]=\"id + '-label ' + id + '-selected'\"\n                     [attr.role]=\"'combobox'\"\n                     [attr.tabindex]=\"activeInputField ? -1 : 0\"\n                     [attr.aria-expanded]=\"showDropdownList\"\n                     [attr.aria-describedby]=\"describedByValue\"\n                     (mousedown)=\"openPicklist($event)\"\n                     (keydown.enter)=\"openPicklist($event)\"\n                     (keydown.space)=\"openPicklist($event)\"\n                >\n                    <div [attr.id]=\"id + '-selected'\" class=\"text-truncate\">{{ getSelectedFirstItemName() }}</div>\n\n                    <button \n                            *ngIf=\"!multiple && selects.length\" \n                            type=\"button\" \n                            class=\"clearBtn\" \n                            [attr.tabindex]=\"selects.length ? '0' : '-1'\" \n                            [attr.aria-label]=\"'misc.Deselect' | translate\" \n                            (mousedown)=\"$event.stopPropagation(); clearSearch();\" \n                            (keydown.enter)=\"clearSearch();\"\n                            (keydown.space)=\"clearSearch();\"\n                    >\n                        <i class=\"icn-close\"></i>\n                    </button>\n                </div>\n            </ng-container>\n\n            <ng-container *ngIf=\"activeInputField || alwaysShowDropdownList\">\n                <input type=\"search\"\n                       #inputField\n                       class=\"picklist-field picklist-search-input input-text\"\n                       [(ngModel)]=\"search\"\n                       (ngModelChange)=\"searchChange($event)\"\n                       [ngModelOptions]=\"{ standalone: true }\"\n                       [placeholder]=\"placeholder | translate\"\n                       [attr.id]=\"id + '-search'\"\n                       [attr.aria-autocomplete]=\"'list'\"\n                       [attr.aria-expanded]=\"showDropdownList || alwaysShowDropdownList\"\n                       [attr.aria-labelledby]=\"hideLabel ? null : id + '-label'\"\n                       [attr.aria-describedby]=\"describedByValue\"\n                       [attr.aria-owns]=\"id + '-list'\"\n                       [attr.role]=\"'combobox'\"\n                       (keydown)=\"formKeyNav($event)\"\n                >\n                <button \n                        *ngIf=\"search\" \n                        type=\"button\" \n                        class=\"clearBtn\" \n                        [attr.aria-label]=\"'misc.Clear' | translate\" \n                        (mousedown)=\"$event.stopPropagation(); clearSearch();\"\n                        (keydown.enter)=\"clearSearch();\"\n                        (keydown.space)=\"clearSearch();\"\n                >\n                    <i class=\"icn-close\"></i>\n                </button>\n\n                <ng-container *ngIf=\"showDropdownList || alwaysShowDropdownList\">\n                    <div class=\"picklist-dropdown-wrapper\">\n                        <div #dropdown class=\"picklist-dropdown\" [ngClass]=\"{ 'filtering': isSearching() }\">\n                            @if (widgetConfig && widgetList) {\n                                <hierarchical-list-widget #hpWidget\n                                                          [config]=\"widgetConfig\"\n                                                          [list]=\"widgetList\"\n                                                          [values]=\"widgetSelects\"\n                                                          [search]=\"widgetSearch\"\n                                                          (selection)=\"hpWidgetSelectionUpdates($event)\"\n                                                          (searchChanged)=\"hpWidgetSearchUpdates($event)\"\n                                                          (navigationChanged)=\"hpWidgetNavigationUpdates($event)\"\n                                                          (keydown.escape)=\"escapeDropdownList($event)\"\n                                ></hierarchical-list-widget>\n                            }\n                        </div>\n                    </div>\n                </ng-container>\n            </ng-container>\n\n            <div class=\"picklist-dropdown-icon\">\n                <i class=\"icn-chevron_down\"></i>\n            </div>\n        </div>\n\n        <ng-template *ngIf=\"!hideChipList && chipListPosition === 'bottom'\" [ngTemplateOutlet]=\"chipListTemplate\"></ng-template>\n    </div>\n</div>\n\n<ng-template #chipListTemplate>\n    <div *ngIf=\"multiple && selects?.length\" class=\"badge-group\">\n        <div class=\"badge-list\"\n             #chipList\n             *ngIf=\"multiple\"\n             [attr.role]=\"'listbox'\"\n             [attr.aria-label]=\"'misc.Selected options:' | translate\"\n             [attr.aria-live]=\"showDropdownList ? 'polite' : 'off'\"\n\n             cdkListbox\n             [cdkListboxOrientation]=\"'horizontal'\"\n             (keydown)=\"chipNav($event)\"\n        >\n            <div *ngFor=\"let select of selects; index as idx\"\n                 #chipListItem\n                 class=\"badge-wrapper\"\n                 aria-selected=\"true\"\n                 [cdkOption]=\"select\"\n                 [attr.role]=\"'option'\"\n                 [attr.aria-label]=\"'misc.Item - Remove' | translate : {item: getItemLabel(select)}\"\n                 (click)=\"removeSelect(select)\"\n            >\n                <div class=\"badge badge-small\" [ngClass]=\"{'active': showDropdownList}\">\n                    <div class=\"text-truncate\">{{ getItemLabel(select) }}</div>\n                    <button type=\"button\" (click)=\"removeSelect(select)\" [attr.tabindex]=\"'-1'\" [attr.aria-hidden]=\"true\" [attr.aria-label]=\"'misc.Item - Remove' | translate : { item: getItemLabel(select) }\">\n                        <i class=\"icn-close\"></i>\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</ng-template>\n\n"
    }]
  }], () => [{
    type: SearchTextPipe$1
  }, {
    type: i0.ElementRef
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i1$1.TranslateService
  }, {
    type: i0.NgZone
  }], {
    hpWidget: [{
      type: ViewChild,
      args: ["hpWidget", {
        static: false
      }]
    }],
    widgetElm: [{
      type: ViewChild,
      args: ["widget", {
        static: false
      }]
    }],
    inputFieldElm: [{
      type: ViewChild,
      args: ["inputField", {
        static: false
      }]
    }],
    dropdown: [{
      type: ViewChild,
      args: ["dropdown", {
        static: false
      }]
    }],
    chipList: [{
      type: ViewChild,
      args: ["chipList", {
        static: false
      }]
    }],
    cdkListbox: [{
      type: ViewChild,
      args: [CdkListbox]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormHierpicklistComponent, {
    className: "FormHierpicklistComponent",
    filePath: "dynamic-form/components/form-hierpicklist/form-hierpicklist.component.ts",
    lineNumber: 18
  });
})();
const _c0$1k = (a0, a1, a2) => ({
  "field-error": a0,
  "last": a1,
  "d-none": a2
});
const _c1$13 = a0 => ({
  field_name: a0
});
function FormRichtextComponent_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 8);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormRichtextComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormRichtextComponent_div_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 12);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$13, ctx_r0.translatedLabel)), " ");
  }
}
function FormRichtextComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, FormRichtextComponent_div_8_div_1_Template, 4, 6, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors == null ? null : ctx_r0.control.errors.required);
  }
}
class FormRichtextComponent extends FormInputComponent {
  constructor(translate, cd) {
    super(translate);
    this.translate = translate;
    this.cd = cd;
    this.translatedLabel = '';
    this.ignoreFirstValueChange = false;
    this.defaultOptions = {
      "elementpath": false,
      "relative_urls": false,
      "remove_script_host": false,
      "skin": "light",
      "browser_spellcheck": true,
      "menubar": false,
      "image_advtab": true,
      'urlconverter_callback': this.skipMergeFieldUrlConversion,
      "valid_elements": "strong,b,em,i,ul,li,ol,a,p,br",
      "plugins": "paste, link, lists, autoresize",
      "toolbar": "bold italic | bullist numlist | outdent indent | link unlink | removeformat",
      "theme_advanced_path": false,
      "paste_use_dialog": true,
      "link_assume_external_targets": true,
      "convert_urls": false,
      "target_list": false,
      "default_link_target": "_blank",
      "extended_valid_elements": "a[href|target=_blank|title],p[style]",
      "invalid_styles": "color font font-family font-size background background-color line-height margin padding display background-image",
      "paste_auto_cleanup_on_paste": true,
      "min_height": 182,
      "resize": true,
      "autoresize_bottom_margin": 20
    };
  }
  ngOnInit() {
    let modal = this.modal ? 'modal' : '';
    this.translatedLabel = this.translate.instant(this.config.label);
    if (this.config.options) {
      delete this.config.options.selector;
      delete this.config.options.urlconverter_callback;
      this.initOptions = {
        ...this.defaultOptions,
        ...this.config.options
      };
    } else {
      this.initOptions = this.defaultOptions;
    }
    if (this.config.value) {
      this.ignoreFirstValueChange = true;
      setTimeout(() => {
        this.control.setValue(this.config.value, {
          'emitEvent': false,
          'emitModelToViewChange': true
        });
      });
    }
    this.describedByValue = this.config.blurb ? this.config.id + modal + '-blurb' : '';
    this.control.valueChanges.subscribe(() => {
      if (!this.ignoreFirstValueChange) {
        this.control.markAsTouched();
      } else {
        this.ignoreFirstValueChange = false;
      }
    });
  }
  initEditor(event) {
    // Add defensive handling for setMode method that doesn't exist
    if (event && event.editor) {
      const originalSetMode = event.editor.setMode;
      if (!originalSetMode || typeof originalSetMode !== 'function') {
        event.editor.setMode = function (mode) {
          // Silently ignore setMode calls to prevent errors
        };
      }
    }
    // Call the original tinyMceInit logic
    this.tinyMceInit(event);
  }
  tinyMceInit(tinyMceInstance) {
    // Add defensive handling for different event structures
    if (!tinyMceInstance || !tinyMceInstance.formElement) {
      return; // Skip if formElement is not available
    }
    let tinyMceInstanceElem = tinyMceInstance.formElement;
    let tinyMceButtons = tinyMceInstanceElem.getElementsByClassName('mce-btn');
    let button;
    for (button of tinyMceButtons) {
      let buttonLabel = button.getAttribute('aria-label');
      let buttonTags = button.getElementsByTagName('button');
      let tag;
      for (tag of buttonTags) {
        tag.setAttribute('aria-label', buttonLabel);
      }
    }
    window.tinymce.PluginManager.add('columns', function (editor, url) {
      editor.addButton('twocolumns', {
        icon: false,
        title: 'Create a 2 column layout',
        image: '/tinymce4/skins/mce_twocolumns.gif',
        onclick: function (e) {
          editor.getWin().focus();
          var text = editor.selection.getContent();
          let text1 = 'Column 1';
          let text2 = 'Column 2';
          if (text) {
            let half = text.length / 2;
            text1 = text.substring(0, half);
            text2 = text.substring(half, text.length);
          }
          editor.selection.setContent('' + '<table style="width: 100%; text-align:top;border-spacing:0;border-collapse:collapse;border:none;">' + '   <tbody>' + '       <tr>' + '           <td style="width:50%;vertical-align:top;padding: 0">' + '               <div style="padding: 0 6px 0 0">' + text1 + '</div>' + '           </td>' + '           <td style="width:50%;vertical-align:top;">' + '               <div style="padding: 0 0 0 6px">' + text2 + '</div>' + '           </td>' + '       </tr>  ' + '   </tbody>' + '</table>');
          editor.selection.select(window.tinyMCE.activeEditor.dom.select('div')[0]);
          editor.selection.collapse(true);
        }
      });
    });
  }
  skipMergeFieldUrlConversion(url, node, on_save, name) {
    let regex = /\[[a-zA-Z_]+\]$/;
    if (!regex.test(url)) {
      delete window.tinyMCE.activeEditor.settings.urlconverter_callback;
      url = window.tinyMCE.activeEditor.convertURL(url, name, node);
      window.tinyMCE.activeEditor.settings.urlconverter_callback = this.skipMergeFieldUrlConversion;
    }
    return url;
  }
  static {
    this.ɵfac = function FormRichtextComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormRichtextComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormRichtextComponent,
      selectors: [["form-richtext"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 10,
      vars: 17,
      consts: [[1, "field", "form-range", "field-custom", 3, "ngClass", "formGroup"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], ["role", "application", 1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], ["tagName", "textarea", "ngDefaultControl", "", 3, "onInit", "id", "formControlName", "init"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [4, "ngIf"], [1, "icn-error_filled"]],
      template: function FormRichtextComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "translate");
          i0.ɵɵtemplate(5, FormRichtextComponent_i_5_Template, 2, 0, "i", 3);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(6, "div", 4);
          i0.ɵɵtemplate(7, FormRichtextComponent_div_7_Template, 3, 6, "div", 5)(8, FormRichtextComponent_div_8_Template, 2, 1, "div", 6);
          i0.ɵɵelementStart(9, "editor", 7);
          i0.ɵɵlistener("onInit", function FormRichtextComponent_Template_editor_onInit_9_listener($event) {
            return ctx.initEditor($event);
          });
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(13, _c0$1k, ctx.control && !ctx.control.valid && (ctx.control.dirty || ctx.control.touched), ctx.config.lastChild, ctx.config.hideField))("formGroup", ctx.group);
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("for", ctx.config.elementId);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 11, ctx.config.label), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.isRequired);
          i0.ɵɵadvance();
          i0.ɵɵattribute("aria-labelledby", ctx.config.elementId);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.blurb);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.control && !ctx.control.valid && (ctx.control.dirty || ctx.control.touched));
          i0.ɵɵadvance();
          i0.ɵɵproperty("id", ctx.config.elementId)("formControlName", ctx.config.name)("init", ctx.initOptions);
        }
      },
      dependencies: [i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, i4.EditorComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: [".field-error-richtext{border:#bf3e24 solid 1.2px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormRichtextComponent, [{
    type: Component,
    args: [{
      selector: 'form-richtext',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"field form-range field-custom\"\n    [ngClass]=\"{'field-error': control && !control.valid && (control.dirty || control.touched), 'last': config.lastChild, 'd-none': config.hideField}\"\n    [formGroup]=\"group\">\n    <div class=\"field-label\">\n        <label for=\"{{config.elementId}}\">\n            {{config.label | translate}}\n            <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n        </label>\n    </div>\n    <div class=\"field-widget\" role=\"application\" [attr.aria-labelledby]=\"config.elementId\">\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb field-blurb\"\n            [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div role=\"alert\" *ngIf=\"control && !control.valid && (control.dirty || control.touched)\">\n            <div *ngIf=\"control.errors?.required\">\n                <i class=\"icn-error_filled\"></i>\n                {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n            </div>\n        </div>\n\n        <editor tagName=\"textarea\"\n            [id]=\"config.elementId\"\n            [formControlName]=\"config.name\"\n            ngDefaultControl\n            [init]=\"initOptions\"\n            (onInit)=\"initEditor($event)\"></editor>\n    </div>\n</div>",
      styles: [".field-error-richtext{border:#bf3e24 solid 1.2px}\n"]
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: i0.ChangeDetectorRef
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormRichtextComponent, {
    className: "FormRichtextComponent",
    filePath: "dynamic-form/components/form-richtext/form-richtext.component.ts",
    lineNumber: 15
  });
})();
const _c0$1j = a0 => ({
  "has-subform": a0
});
const _c1$12 = a0 => ({
  "subform": a0
});
function FormRelationComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 3);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", "blurb_" + ctx_r0.config.elementId);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormRelationComponent_ng_container_0_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "h2");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const group_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("id", "lbl_" + ctx_r0.config.elementId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(group_r2.groupTitle);
  }
}
function FormRelationComponent_ng_container_0_div_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 9);
  }
  if (rf & 2) {
    const field_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", field_r3)("group", ctx_r0.formGroup)("value", ctx_r0.config.value[field_r3.name]);
  }
}
function FormRelationComponent_ng_container_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, FormRelationComponent_ng_container_0_div_2_div_1_Template, 3, 2, "div", 5);
    i0.ɵɵelementStart(2, "div", 6);
    i0.ɵɵtemplate(3, FormRelationComponent_ng_container_0_div_2_ng_container_3_Template, 1, 3, "ng-container", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const group_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.subFormConfig.groupId);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$1j, ctx_r0.subFormConfig.isSubform));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r2.groupTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$12, ctx_r0.subFormConfig.isSubform));
    i0.ɵɵattribute("aria-labelledby", "lbl_" + ctx_r0.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", group_r2.controls);
  }
}
function FormRelationComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormRelationComponent_ng_container_0_div_1_Template, 3, 6, "div", 1)(2, FormRelationComponent_ng_container_0_div_2_Template, 4, 10, "div", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.subFormConfig.controlGroups);
  }
}
function FormRelationComponent_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 9);
  }
  if (rf & 2) {
    const field_r4 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r4)("group", ctx_r0.formGroup)("value", ctx_r0.config.value[field_r4.name]);
  }
}
function FormRelationComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormRelationComponent_div_1_ng_container_1_Template, 1, 3, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.subFormConfig.controls);
  }
}
class FormRelationComponent {
  get control() {
    return this.group.controls[this.config.name];
  }
  constructor(fb) {
    this.fb = fb;
    this.inputType = null;
  }
  ngOnInit() {
    if (this.config.config instanceof Subject) {
      this.subformSubscription = this.config.config.subscribe(resp => {
        this.config.config = this.subFormConfig = resp;
        this.setup();
      });
    } else {
      this.subFormConfig = this.config.config;
      this.setup();
    }
  }
  setup() {
    if (!this.config.value) {
      this.config.value = {};
    }
    this.setControlValue(this.config.value);
    this.group.controls[this.config.name] = this.createGroup(this.config.config);
    this.formGroup = this.group.controls[this.config.name];
  }
  setControlValue(controlValue) {
    setTimeout(() => {
      const controlFields = _.keys(this.formGroup.controls);
      let values = {};
      _.forEach(controlFields, fid => {
        values[fid] = controlValue[fid] === undefined ? null : controlValue[fid];
      });
      this.group.controls[this.config.name].patchValue(values, {
        'emitModelToViewChange': true
      });
      setTimeout(() => {
        this.valueSubscription = this.formGroup.valueChanges.subscribe(val => {
          this.formGroup.markAsTouched();
          this.group.markAsTouched();
          if (this.formGroup.invalid) {
            this.group.setErrors({});
          } else {
            this.group.setErrors(null);
          }
        });
      });
    });
  }
  createGroup(config) {
    let group = this.group.controls[this.config.name];
    if (group.addControl === undefined) {
      group = new UntypedFormGroup({});
    }
    let controls = [];
    if (config.useGroupedForm) {
      this.subFormConfig.controlGroups.forEach(g => {
        controls = controls.concat(g.controls);
      });
    } else {
      controls = config.controls;
    }
    let lastIndex = controls.reduce((acc, current, index) => {
      if (!current.hideField || current.hideField !== true) {
        return index;
      }
      return acc;
    }, -1);
    controls.forEach((control, idx) => {
      if (this.config.readOnly) {
        switch (control.type) {
          case 'rating':
          case 'relation':
            control.readOnly = true;
            break;
          default:
            control.type = 'static';
        }
      }
      if (this.config.readOnlyForm) {
        control.readOnlyForm = true;
      }
      if (idx === lastIndex) {
        control.lastChild = true;
      }
      return group.addControl(control.name, this.fb.control(null, control.validators));
    });
    return group;
  }
  ngOnDestroy() {
    if (this.subformSubscription) {
      this.subformSubscription.unsubscribe();
    }
    if (this.valueSubscription) {
      this.valueSubscription.unsubscribe();
    }
  }
  static {
    this.ɵfac = function FormRelationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormRelationComponent)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormRelationComponent,
      selectors: [["form-relation"]],
      inputs: {
        config: "config"
      },
      standalone: false,
      decls: 2,
      vars: 2,
      consts: [[4, "ngIf"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], [3, "id", "ngClass", 4, "ngFor", "ngForOf"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], [3, "id", "ngClass"], ["class", "fg-title", 4, "ngIf"], ["role", "group", 3, "ngClass"], ["dynamicField", "", 3, "config", "group", "value", 4, "ngFor", "ngForOf"], [1, "fg-title"], ["dynamicField", "", 3, "config", "group", "value"]],
      template: function FormRelationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormRelationComponent_ng_container_0_Template, 3, 2, "ng-container", 0)(1, FormRelationComponent_div_1_Template, 2, 1, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.subFormConfig && ctx.subFormConfig.useGroupedForm && !ctx.config.hideField);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.subFormConfig && !ctx.subFormConfig.useGroupedForm && !ctx.config.hideField);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormRelationComponent, [{
    type: Component,
    args: [{
      selector: 'form-relation',
      template: `
        <ng-container *ngIf="subFormConfig && subFormConfig.useGroupedForm && !config.hideField">
            <div *ngIf="config.blurb" id="{{'blurb_' + config.elementId}}" class="blurb field-blurb" [innerHTML]="config.blurb | translate | safeHtml"></div>
            <div *ngFor="let group of subFormConfig.controlGroups" id="{{subFormConfig.groupId}}" [ngClass]="{'has-subform': subFormConfig.isSubform}">
                <div [attr.id]="'lbl_' + config.elementId" class="fg-title" *ngIf="group.groupTitle">
                    <h2>{{group.groupTitle}}</h2>
                </div>
               <div [ngClass]="{'subform': subFormConfig.isSubform}" role="group" [attr.aria-labelledby]="'lbl_' + config.elementId">
                   <ng-container *ngFor="let field of group.controls" dynamicField [config]="field" [group]="formGroup" [value]="config.value[field.name]"></ng-container>
                </div>
            </div>
        </ng-container>
        <div *ngIf="subFormConfig && !subFormConfig.useGroupedForm && !config.hideField">
            <ng-container *ngFor="let field of subFormConfig.controls" dynamicField [config]="field" [group]="formGroup" [value]="config.value[field.name]"></ng-container>
        </div>
    `,
      standalone: false
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }], {
    config: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormRelationComponent, {
    className: "FormRelationComponent",
    filePath: "dynamic-form/components/form-relation/form-relation.component.ts",
    lineNumber: 28
  });
})();
const _c0$1i = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c1$11 = a0 => ({
  field_name: a0
});
const _c2$N = a0 => ({
  value: a0
});
const _c3$y = (a0, a1) => ({
  "selected": a0,
  "unselected": a1
});
function FormRatingComponent_div_0_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 11);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormRatingComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormRatingComponent_div_0_div_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$11, ctx_r0.translatedLabel)), " ");
  }
}
function FormRatingComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, FormRatingComponent_div_0_div_7_div_1_Template, 4, 6, "div", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function FormRatingComponent_div_0_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, "misc.Current rating x star", i0.ɵɵpureFunction1(4, _c2$N, ctx_r0.config.value)));
  }
}
function FormRatingComponent_div_0_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 17);
    i0.ɵɵlistener("focus", function FormRatingComponent_div_0_ng_template_10_Template_input_focus_0_listener($event) {
      const rating_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(!ctx_r0.config.readOnly && ctx_r0.setHighlight($event, rating_r3.id));
    })("focusout", function FormRatingComponent_div_0_ng_template_10_Template_input_focusout_0_listener($event) {
      const rating_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(!ctx_r0.config.readOnly && ctx_r0.setHighlight($event, rating_r3.id));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "label", 18);
    i0.ɵɵlistener("mouseenter", function FormRatingComponent_div_0_ng_template_10_Template_label_mouseenter_1_listener($event) {
      const rating_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(!ctx_r0.config.readOnly && ctx_r0.setHighlight($event, rating_r3.id));
    })("mouseleave", function FormRatingComponent_div_0_ng_template_10_Template_label_mouseleave_1_listener($event) {
      const rating_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(!ctx_r0.config.readOnly && ctx_r0.setHighlight($event, rating_r3.id));
    });
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const rating_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formControlName", ctx_r0.config.name)("value", rating_r3.id)("disabled", !!ctx_r0.config.readOnly);
    i0.ɵɵattribute("id", ctx_r0.config.elementId + "-star" + rating_r3.id)("name", ctx_r0.config.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c3$y, ctx_r0.currentHighlight >= rating_r3.id, ctx_r0.currentHighlight < rating_r3.id));
    i0.ɵɵattribute("for", ctx_r0.config.elementId + "-star" + rating_r3.id);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(rating_r3.value);
  }
}
function FormRatingComponent_div_0_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function FormRatingComponent_div_0_button_11_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.clearRating());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "misc.Clear Rating"));
  }
}
function FormRatingComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, FormRatingComponent_div_0_i_4_Template, 2, 0, "i", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵtemplate(6, FormRatingComponent_div_0_div_6_Template, 3, 6, "div", 5)(7, FormRatingComponent_div_0_div_7_Template, 2, 1, "div", 6)(8, FormRatingComponent_div_0_span_8_Template, 3, 6, "span", 7);
    i0.ɵɵelementStart(9, "div", 8);
    i0.ɵɵtemplate(10, FormRatingComponent_div_0_ng_template_10_Template, 4, 11, "ng-template", 9)(11, FormRatingComponent_div_0_button_11_Template, 2, 3, "button", 10);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(16, _c0$1i, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild))("formGroup", ctx_r0.group);
    i0.ɵɵadvance();
    i0.ɵɵattribute("id", "lbl_" + ctx_r0.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 14, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.readOnly);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r0.group);
    i0.ɵɵattribute("id", ctx_r0.config.elementId)("aria-labelledby", "lbl_" + ctx_r0.config.elementId)("aria-hidden", !!ctx_r0.config.readOnly ? "true" : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.options);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.readOnly);
  }
}
class FormRatingComponent extends FormInputComponent {
  constructor() {
    super(...arguments);
    this.options = [];
  }
  ngOnInit() {
    for (let i = 1; i <= 5; i++) {
      this.options.push({
        id: i,
        value: this.translate.instant('misc.x star', {
          value: i
        })
      });
    }
    this.config.value = !isNaN(+this.config.value) ? +this.config.value : 0;
    super.ngOnInit();
    this.setCurrentHighlight(this.config.value);
  }
  clearRating() {
    this.control.setValue(null, {
      'emitEvent': true,
      'emitModelToViewChange': true
    });
    this.control.markAsDirty();
    this.setCurrentHighlight(0);
  }
  setCurrentHighlight(value = 0) {
    this.currentHighlight = value;
  }
  setHighlight(e, ratingId) {
    let eventType = e.type || null;
    if (eventType == "mouseenter" || eventType == "focus") {
      this.setCurrentHighlight(ratingId);
    }
    if (eventType == "mouseleave" || eventType == "focusout") {
      // mouse/focus has left, set highlight based on currently selected value
      this.resetHighlight();
    }
  }
  resetHighlight() {
    if (this.control.value == null) {
      // No value set. Return all to unselected
      this.setCurrentHighlight(0);
    } else {
      this.setCurrentHighlight(this.control.value);
    }
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵFormRatingComponent_BaseFactory;
      return function FormRatingComponent_Factory(__ngFactoryType__) {
        return (ɵFormRatingComponent_BaseFactory || (ɵFormRatingComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FormRatingComponent)))(__ngFactoryType__ || FormRatingComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormRatingComponent,
      selectors: [["form-rating"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "field form-radio field-custom", "role", "group", 3, "ngClass", "formGroup", 4, "ngIf"], ["role", "group", 1, "field", "form-radio", "field-custom", 3, "ngClass", "formGroup"], [1, "field-label"], ["class", "req-indicator", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], ["class", "sr-only", 4, "ngIf"], ["role", "radiogroup", 1, "rating", 3, "formGroup"], ["ngFor", "", 3, "ngForOf"], ["type", "button", "class", "clear-rating", 3, "click", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [4, "ngIf"], [1, "icn-error_filled"], [1, "sr-only"], ["type", "radio", 1, "sr-only", 3, "focus", "focusout", "formControlName", "value", "disabled"], [3, "mouseenter", "mouseleave", "ngClass"], ["type", "button", 1, "clear-rating", 3, "click"]],
      template: function FormRatingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormRatingComponent_div_0_Template, 12, 19, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.DefaultValueAccessor, i2$1.RadioControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: [".rating input[type=radio],.rating input+label,.rating .clear-rating{height:28px;width:28px;margin:0 5px 5px}.rating input+label{color:#ccc}.rating .clear-rating{color:#949494;border:0;background:none;box-shadow:none;padding:0;vertical-align:top}.rating .clear-rating:before{content:\"\\21bb\"}.rating .clear-rating:disabled{display:none}.rating input:focus+label{outline-width:2px;outline-style:solid;outline-color:Highlight}@media (-webkit-min-device-pixel-ratio:0){.rating input:focus+label{outline-color:-webkit-focus-ring-color;outline-style:auto}}.rating input+label,.rating .clear-rating{position:relative}[dir=rtl] .rating input+label,[dir=rtl] .rating .clear-rating{margin-left:5px}.rating input+label:before{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);content:\"\\2605\"}.rating input+label:before,.rating .clear-rating:before{font-size:25px;line-height:32px}.rating input:not(:disabled)~label{cursor:pointer}.rating .selected{color:#ffc107}.rating .unselected{color:#ccc}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormRatingComponent, [{
    type: Component,
    args: [{
      selector: 'form-rating',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"field form-radio field-custom\" *ngIf=\"!config.hideField\" [ngClass]=\"{'field-error': !control.valid && (control.dirty || control.touched), 'last':config.lastChild}\" [formGroup]=\"group\" role=\"group\">\n    <div class=\"field-label\" [attr.id]=\"'lbl_' + config.elementId\">\n        {{config.label | translate}}\n        <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n    </div>\n\n    <div class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb field-blurb\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n\n        <div role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n            <div *ngIf=\"control.errors.required\">\n                <i class=\"icn-error_filled\"></i>\n                {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n            </div>\n        </div>\n\n        <span *ngIf=\"config.readOnly\" class=\"sr-only\">{{ 'misc.Current rating x star' | translate: {value: config.value} }}</span>\n\n        <div\n            [attr.id]=\"config.elementId\"\n            class=\"rating\"\n            [formGroup]=\"group\"\n            role=\"radiogroup\"\n            [attr.aria-labelledby]=\"'lbl_' + config.elementId\"\n            [attr.aria-hidden]=\"!!config.readOnly ? 'true' : null\">\n\n            <ng-template ngFor let-rating [ngForOf]=\"options\">\n                <input\n                    type=\"radio\"\n                    [attr.id]=\"config.elementId + '-star' + rating.id\"\n                    [attr.name]=\"config.name\"\n                    [formControlName]=\"config.name\"\n                    [value]=\"rating.id\"\n                    [disabled]=\"!!config.readOnly\"\n                    class=\"sr-only\"\n                    (focus)=\"!config.readOnly && setHighlight($event, rating.id)\"\n                    (focusout)=\"!config.readOnly && setHighlight($event, rating.id)\">\n                <label\n                    [attr.for]=\"config.elementId + '-star' + rating.id\"\n                    [ngClass]=\"{\n                            'selected': currentHighlight >= rating.id,\n                            'unselected': currentHighlight < rating.id\n                        }\"\n                    (mouseenter)=\"!config.readOnly && setHighlight($event, rating.id)\"\n                    (mouseleave)=\"!config.readOnly && setHighlight($event, rating.id)\">\n                        <span class=\"sr-only\">{{rating.value}}</span>\n                </label>\n            </ng-template>\n\n            <button\n                (click)=\"clearRating()\"\n                *ngIf=\"!config.readOnly\"\n                type=\"button\"\n                class=\"clear-rating\"\n                [attr.aria-label]=\"'misc.Clear Rating' | translate\">\n            </button>\n\n        </div>\n    </div>\n</div>\n",
      styles: [".rating input[type=radio],.rating input+label,.rating .clear-rating{height:28px;width:28px;margin:0 5px 5px}.rating input+label{color:#ccc}.rating .clear-rating{color:#949494;border:0;background:none;box-shadow:none;padding:0;vertical-align:top}.rating .clear-rating:before{content:\"\\21bb\"}.rating .clear-rating:disabled{display:none}.rating input:focus+label{outline-width:2px;outline-style:solid;outline-color:Highlight}@media (-webkit-min-device-pixel-ratio:0){.rating input:focus+label{outline-color:-webkit-focus-ring-color;outline-style:auto}}.rating input+label,.rating .clear-rating{position:relative}[dir=rtl] .rating input+label,[dir=rtl] .rating .clear-rating{margin-left:5px}.rating input+label:before{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);content:\"\\2605\"}.rating input+label:before,.rating .clear-rating:before{font-size:25px;line-height:32px}.rating input:not(:disabled)~label{cursor:pointer}.rating .selected{color:#ffc107}.rating .unselected{color:#ccc}\n"]
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormRatingComponent, {
    className: "FormRatingComponent",
    filePath: "dynamic-form/components/form-rating/form-rating.component.ts",
    lineNumber: 11
  });
})();
const _c0$1h = ["customItemTemplate"];
const _c1$10 = ["chipListElm"];
const _c2$M = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c3$x = a0 => ({
  "haveClearBtn": a0
});
const _c4$s = a0 => ({
  "sr-only": a0
});
const _c5$j = a0 => ({
  field_name: a0
});
const _c6$e = a0 => ({
  widget: a0
});
const _c7$9 = a0 => ({
  "chip-highlight": a0
});
const _c8$8 = a0 => ({
  item: a0
});
function FormLocationComponent_div_0_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 19);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormLocationComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "i", 21);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.config.locationNotFoundError);
  }
}
function FormLocationComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 22);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c4$s, ctx_r1.config.blurbSrOnly))("innerHTML", i0.ɵɵpipeBind1(2, 5, i0.ɵɵpipeBind1(1, 3, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormLocationComponent_div_0_div_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 24);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c5$j, ctx_r1.config.label)), " ");
  }
}
function FormLocationComponent_div_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtemplate(1, FormLocationComponent_div_0_div_9_div_1_Template, 4, 6, "div", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.required);
  }
}
function FormLocationComponent_div_0_ng_container_11_ng_container_4_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("keydown", function FormLocationComponent_div_0_ng_container_11_ng_container_4_span_1_Template_span_keydown_0_listener($event) {
      const ctx_r3 = i0.ɵɵrestoreView(_r3);
      const selection_r5 = ctx_r3.$implicit;
      const i_r6 = ctx_r3.index;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.chipNav($event, selection_r5, i_r6));
    });
    i0.ɵɵelementStart(2, "span", 28);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 29);
    i0.ɵɵlistener("click", function FormLocationComponent_div_0_ng_container_11_ng_container_4_span_1_Template_span_click_4_listener() {
      const selection_r5 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.removeChip(selection_r5));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selection_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    const isLast_r7 = ctx.last;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c7$9, isLast_r7));
    i0.ɵɵattribute("role", "option")("aria-label", i0.ɵɵpipeBind2(1, 8, "misc.Remove Item", i0.ɵɵpureFunction1(13, _c8$8, selection_r5.value)))("aria-setsize", ctx_r1.control.value.length)("aria-posinset", i_r6 + 1)("tabindex", ctx_r1.getChipTabIndex(i_r6));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(selection_r5.value);
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", "button");
  }
}
function FormLocationComponent_div_0_ng_container_11_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormLocationComponent_div_0_ng_container_11_ng_container_4_span_1_Template, 5, 15, "span", 26);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.control.value);
  }
}
function FormLocationComponent_div_0_ng_container_11_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 30);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("keydown", function FormLocationComponent_div_0_ng_container_11_ng_container_5_Template_span_keydown_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.removeChip(ctx_r1.control.value));
    });
    i0.ɵɵelementStart(3, "span", 28);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 29);
    i0.ɵɵlistener("click", function FormLocationComponent_div_0_ng_container_11_ng_container_5_Template_span_click_5_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.removeChip(ctx_r1.control.value));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", "option")("aria-label", i0.ɵɵpipeBind2(2, 5, "misc.Remove Item", i0.ɵɵpureFunction1(8, _c8$8, ctx_r1.control.value.value)))("tabindex", "1");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.control.value.value);
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", "button");
  }
}
function FormLocationComponent_div_0_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 25, 1);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, FormLocationComponent_div_0_ng_container_11_ng_container_4_Template, 2, 1, "ng-container", 12)(5, FormLocationComponent_div_0_ng_container_11_ng_container_5_Template, 6, 10, "ng-container", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", "listbox")("aria-live", "polite")("aria-atomic", true)("aria-orientation", "horizontal")("aria-label", i0.ɵɵpipeBind2(3, 7, "misc.widget selection", i0.ɵɵpureFunction1(10, _c6$e, ctx_r1.config.label)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.multiple);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.multiple);
  }
}
function FormLocationComponent_div_0_span_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 31);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", ctx_r1.query);
  }
}
function FormLocationComponent_div_0_ng_container_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 32);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function FormLocationComponent_div_0_ng_container_18_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearValue($event));
    });
    i0.ɵɵelement(3, "i", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.query);
    i0.ɵɵattribute("aria-hidden", !ctx_r1.query)("aria-label", i0.ɵɵpipeBind1(2, 3, "misc.Clear"));
  }
}
function FormLocationComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "label", 5);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, FormLocationComponent_div_0_i_5_Template, 2, 0, "i", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtemplate(7, FormLocationComponent_div_0_div_7_Template, 4, 1, "div", 8)(8, FormLocationComponent_div_0_div_8_Template, 3, 9, "div", 9)(9, FormLocationComponent_div_0_div_9_Template, 2, 1, "div", 10);
    i0.ɵɵelementStart(10, "div", 11);
    i0.ɵɵtemplate(11, FormLocationComponent_div_0_ng_container_11_Template, 6, 12, "ng-container", 12);
    i0.ɵɵelementStart(12, "div", 13)(13, "input", 14);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function FormLocationComponent_div_0_Template_input_ngModelChange_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.query, $event) || (ctx_r1.query = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormLocationComponent_div_0_Template_input_ngModelChange_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.updateQuery($event));
    })("typeaheadOnSelect", function FormLocationComponent_div_0_Template_input_typeaheadOnSelect_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelect($event));
    })("typeaheadOnPreview", function FormLocationComponent_div_0_Template_input_typeaheadOnPreview_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOptionHighlighted($event));
    })("typeaheadOnBlur", function FormLocationComponent_div_0_Template_input_typeaheadOnBlur_13_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearSrLabel());
    })("keypress", function FormLocationComponent_div_0_Template_input_keypress_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.keypress($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "span", 15);
    i0.ɵɵtemplate(17, FormLocationComponent_div_0_span_17_Template, 1, 1, "span", 16)(18, FormLocationComponent_div_0_ng_container_18_Template, 4, 5, "ng-container", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "div", 17);
    i0.ɵɵelement(20, "input", 18);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(30, _c2$M, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("for", ctx_r1.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 24, ctx_r1.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.locationNotFoundError && ctx_r1.showLocationNotFoundError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.chipList);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.config.elementId);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.query);
    i0.ɵɵproperty("typeahead", ctx_r1.searchSubscription)("typeaheadAsync", true)("typeaheadMinLength", 0)("typeaheadItemTemplate", ctx_r1.itemTemplate)("ngClass", i0.ɵɵpureFunction1(33, _c3$x, ctx_r1.config.clearButton && ctx_r1.control.value));
    i0.ɵɵattribute("placeholder", i0.ɵɵpipeBind1(14, 26, ctx_r1.config.placeholder))("aria-describedby", ctx_r1.describedByValue)("aria-label", i0.ɵɵpipeBind1(15, 28, ctx_r1.config.ariaLabel));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "sr-", ctx_r1.config.elementId, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.showSearchIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.clearButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.config.name);
  }
}
function FormLocationComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const model_r10 = ctx.item;
    i0.ɵɵpropertyInterpolate1("id", "option-", model_r10.id, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(model_r10.value);
  }
}
class FormLocationComponent {
  constructor(elRef) {
    this.elRef = elRef;
    this.translate = inject(TranslateService);
    this.http = inject(HttpClient);
    this.cdr = inject(ChangeDetectorRef);
    this.API = '/api/v2/location/search';
    this.AddCustomAPI = '/api/v2/location/validate';
    this.options = {
      'layers': 'region,locality,neighbourhood,borough,county,localadmin,country',
      'return-raw-data': '0',
      'relabel-results': '1'
    };
    this.isRTL = window.document.dir === 'rtl';
    this.destroy$ = new Subject();
    this.queryChange = new Subject();
    this.query = '';
    this.describedByValue = '';
    this.placeholder = 'misc.Search Locations';
    this.errorMessage = "misc.We can't find the location you've entered. Please search and select the nearest location from the suggestions.";
    this.chipFocusIndex = 0;
    this.showLocationNotFoundError = false;
    this.newSearchDone$ = new Subject();
  }
  get control() {
    return this.group.controls[this.config.name];
  }
  get controlName() {
    return this.config.name;
  }
  get isRequired() {
    return hasRequiredField(this.control);
  }
  get multiple() {
    return this.config.multiple || false;
  }
  get chipList() {
    return _.isUndefined(this.config.chipList) || this.config.chipList;
  }
  ngOnInit() {
    if (this.config.api) {
      this.API = this.config.api;
    }
    this.setup();
    if (this.config.options) {
      this.options = _.extend(this.options, this.config.options);
    }
    this.describedByValue = this.config.blurb ? this.config.id + '-blurb' : null;
    this.placeholder = this.translate.instant(this.config.placeholder || this.placeholder);
    this.errorMessage = this.translate.instant(this.errorMessage);
  }
  ngAfterViewInit() {
    this.itemTemplate = this.config.dropdownItemTemplate ? this.config.dropdownItemTemplate : this.defaultItemTemplate;
    this.cdr.detectChanges();
  }
  addCustom(query = this.query) {
    if (query) {
      this.http.get(this.AddCustomAPI, {
        params: {
          'location': query,
          'addNationWide': true,
          'layers': window.ngData?.peliasSearchLayers ? window.ngData.peliasSearchLayers : ''
        }
      }).subscribe(res => {
        let item = {
          id: res.id,
          value: res.location.address_text,
          data: res.value,
          valid: res.valid
        };
        if (!res.valid) {
          this.showLocationNotFoundError = true;
          item.id = Math.random().toString(32);
          item['notFound'] = true;
          item.value = query;
          item.data = item.id + ':notFound' + query;
        }
        if (this.checkUniqueLocation(item)) {
          this.setValue(item);
          if (this.multiple) {
            this.query = '';
          }
        }
      });
    }
  }
  checkUniqueLocation(item) {
    var uniqueLocation = true;
    if (_.isArray(this.control.value)) {
      _.each(this.control.value, function (selection) {
        if (item.value === selection.value) {
          uniqueLocation = false;
          return false;
        }
      });
    }
    return uniqueLocation;
  }
  setup() {
    if (this.config.value) {
      if (!this.config.multiple) {
        this.setValue(this.config.value);
        this.query = this.config.value.value ? this.config.value.value : '';
      } else {
        if (Array.isArray(this.config.value)) {
          this.config.value.forEach(item => {
            if (item.valid === false) {
              this.showLocationNotFoundError = true;
            }
          });
          this.pills = _.map(this.config.value, 'value');
        }
      }
    }
    if (!this.multiple) {
      this.control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(val => {
        if (val === null) {
          this.query = val;
        }
      });
    }
    this.searchSubscription = new Observable(observer => {
      observer.next(this.query);
    }).pipe(debounceTime(600), switchMap(query => {
      if (query) {
        return this.http.get(this.API, {
          params: _.extend(this.options, {
            keyword: query
          })
        }).pipe(map(data => {
          this.newSearchDone$.next();
          data = data.filter(item => item.value !== query);
          return !_.isEmpty(data) ? data : [];
        }), tap(() => noop, err => {
          this.errorMessage = err;
        }));
      }
      return of([]);
    }));
  }
  updateQuery(newQuery) {
    this.query = newQuery;
    this.queryChange.next(newQuery);
  }
  onSelect(event) {
    this.markGroupTouched();
    if (this.chipList || this.multiple) {
      this.query = '';
    }
    this.setValue(event.item);
    this.triggerEvent('select', event);
    this.clearSrLabel();
  }
  clearSrLabel() {
    let sr = document.getElementById('sr-' + this.config.elementId);
    if (sr) {
      sr.innerHTML = '';
    }
  }
  onOptionHighlighted($event) {
    if ($event) {
      let sr = document.getElementById('sr-' + this.config.elementId);
      if (sr) {
        sr.innerHTML = $event.item.value;
      }
    }
    const container = this.elRef.nativeElement.querySelector('typeahead-container');
    if (container) {
      setTimeout(() => {
        container.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }, 100);
    }
  }
  keypress(event) {
    if (this.config.allowCustomLocations && event.key == 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.addCustom();
    } else {
      this.triggerEvent('keypress', event);
    }
  }
  isTriggerEventAvailable() {
    return this.config.triggerEvent && this.config.triggerEvent instanceof Function;
  }
  setValue(item) {
    let value = this.control.value;
    this.markGroupTouched();
    if (this.multiple) {
      if (!_.isArray(value)) {
        value = [];
      }
      if (value.find(val => _.isMatch(val, item))) {
        return;
      }
      value.push(item);
    } else if (!this.multiple) {
      value = item;
    }
    this.control.setValue(value);
  }
  clearValue(event) {
    this.query = '';
    this.group.get(this.config.name).setValue(undefined);
    this.triggerEvent('clear', event);
    this.clearSrLabel();
  }
  getChipTabIndex(idx) {
    return +(idx === this.chipFocusIndex) - 1;
  }
  chipNav(e, item, idx) {
    switch (e.code) {
      case 'ArrowUp':
      case 'ArrowLeft':
        this.isRTL ? this.chipMove(this.chipFocusIndex + 1) : this.chipMove(this.chipFocusIndex - 1);
        break;
      case 'ArrowDown':
      case 'ArrowRight':
        this.isRTL ? this.chipMove(this.chipFocusIndex - 1) : this.chipMove(this.chipFocusIndex + 1);
        break;
      case 'Home':
        this.chipMove(0);
        break;
      case 'End':
        this.chipMove(this.control.value.length - 1);
        break;
      case 'Space':
      case 'Enter':
        this.removeChip(item);
        this.focusNextChip(idx);
        break;
    }
  }
  chipMove(idx) {
    this.chipFocusIndex = this.wrapAround(idx, this.control.value.length - 1);
    this.focusChip();
  }
  focusChip() {
    setTimeout(() => {
      const item = this.chipListElm.nativeElement.querySelectorAll('[tabindex]:not([tabindex="-1"])')[0];
      item.focus();
    }, 0);
  }
  focusNextChip(idx) {
    setTimeout(() => {
      if (this.control.value.length) {
        this.chipFocusIndex = this.wrapAround(idx - 1, this.control.value.length - 1, false);
        this.focusChip();
      } else {
        document.getElementById(this.config.elementId).focus();
      }
    }, 100);
  }
  wrapAround(idx, maxNum, loop = true) {
    let newIdx = idx;
    const min = loop ? 0 : maxNum;
    const max = loop ? maxNum : 0;
    if (idx < 0) {
      newIdx = max;
    } else if (idx > maxNum) {
      newIdx = min;
    }
    return newIdx < 0 ? -1 : newIdx;
  }
  removeChip(item = undefined) {
    this.markGroupTouched();
    if (item && this.multiple) {
      const newValue = this.group.get(this.config.name).value.filter(val => !_.isMatch(val, item));
      this.control.setValue(newValue);
      if (!this.group.get(this.config.name).value.find(item => item.hasOwnProperty('valid') && !item.valid)) {
        this.showLocationNotFoundError = false;
      }
    } else {
      this.group.get(this.config.name).setValue(undefined);
    }
    this.triggerEvent('remove', item);
  }
  triggerEvent(action, event) {
    if (this.isTriggerEventAvailable()) {
      this.config.triggerEvent(action, event);
    }
  }
  markGroupTouched() {
    if (!this.group.touched) {
      this.group.markAsTouched();
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  static {
    this.ɵfac = function FormLocationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormLocationComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormLocationComponent,
      selectors: [["form-location"]],
      viewQuery: function FormLocationComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$1h, 5);
          i0.ɵɵviewQuery(_c1$10, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultItemTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chipListElm = _t.first);
        }
      },
      inputs: {
        config: "config",
        group: "group"
      },
      standalone: false,
      decls: 3,
      vars: 1,
      consts: [["customItemTemplate", ""], ["chipListElm", ""], ["class", "field location-widget form-input form-custom", 3, "ngClass", 4, "ngIf"], [1, "field", "location-widget", "form-input", "form-custom", 3, "ngClass"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "field-widget"], ["class", "field-blurb field-warning", "role", "alert", 4, "ngIf"], ["class", "blurb field-blurb", 3, "id", "ngClass", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], [1, "input-selections-group"], [4, "ngIf"], [1, "input-clear-group"], ["typeaheadOptionField", "value", "role", "combobox", 1, "input-text", 3, "ngModelChange", "typeaheadOnSelect", "typeaheadOnPreview", "typeaheadOnBlur", "keypress", "ngModel", "typeahead", "typeaheadAsync", "typeaheadMinLength", "typeaheadItemTemplate", "ngClass", "id"], ["role", "alert", 1, "sr-only", 3, "id"], ["class", "icn-search", 3, "hidden", 4, "ngIf"], [3, "formGroup"], ["type", "hidden", 3, "formControlName"], [1, "req-indicator"], ["role", "alert", 1, "field-blurb", "field-warning"], [1, "icn-warning_filled"], [1, "blurb", "field-blurb", 3, "id", "ngClass", "innerHTML"], ["role", "alert"], [1, "icn-error_filled"], [1, "selections"], ["class", "chip", 3, "ngClass", "keydown", 4, "ngFor", "ngForOf"], [1, "chip", 3, "keydown", "ngClass"], [1, "chip-value"], [1, "chip-close", 3, "click"], [1, "chip", "chip-highlight", 3, "keydown"], [1, "icn-search", 3, "hidden"], ["type", "button", 1, "clearBtn", 3, "click", "hidden"], [1, "icn-close"], [3, "id"]],
      template: function FormLocationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormLocationComponent_div_0_Template, 21, 35, "div", 2)(1, FormLocationComponent_ng_template_1_Template, 2, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.NgModel, i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, i3$1.TypeaheadDirective, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormLocationComponent, [{
    type: Component,
    args: [{
      selector: 'form-location',
      standalone: false,
      template: "<div class=\"field location-widget form-input form-custom\" *ngIf=\"!config.hideField\" [ngClass]=\"{'field-error': !control.valid && (control.dirty || control.touched), 'last': config.lastChild }\" >\n    <div class=\"field-label\">\n        <label for=\"{{config.elementId}}\">\n            {{config.label | translate}}\n            <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n        </label>\n    </div>\n    <div class=\"field-widget\">\n        <div *ngIf=\"config.locationNotFoundError && showLocationNotFoundError\" class=\"field-blurb field-warning\" role=\"alert\">\n            <i class=\"icn-warning_filled\"></i>\n            <span>{{ config.locationNotFoundError }}</span>\n        </div>\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb field-blurb\" [ngClass]=\"{ 'sr-only': config.blurbSrOnly }\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n            <div *ngIf=\"control.errors.required\">\n                <i class=\"icn-error_filled\"></i>\n                {{ 'misc.Field is required' | translate: {field_name: config.label} }}\n            </div>\n        </div>\n        \n        <div class=\"input-selections-group\">\n            <ng-container *ngIf=\"chipList\">\n                <div class=\"selections\"\n                    #chipListElm\n                    [attr.role]=\"'listbox'\" \n                    [attr.aria-live]=\"'polite'\"\n                    [attr.aria-atomic]=\"true\"\n                    [attr.aria-orientation]=\"'horizontal'\"\n                    [attr.aria-label]=\"'misc.widget selection' | translate : { widget: config.label }\"\n                >\n                    <ng-container *ngIf=\"multiple\">\n                        <span\n                            *ngFor=\"let selection of control.value; index as i, last as isLast\"\n                            [attr.role]=\"'option'\"\n                            [attr.aria-label]=\"'misc.Remove Item' | translate : {item: selection.value}\"\n                            [attr.aria-setsize]=\"control.value.length\"\n                            [attr.aria-posinset]=\"i + 1\"\n                            [attr.tabindex]=\"getChipTabIndex(i)\"\n                            [ngClass]=\"{'chip-highlight': isLast}\"\n                            (keydown)=\"chipNav($event, selection, i)\"\n                            class=\"chip\"\n                        >\n                            <span class=\"chip-value\">{{selection.value}}</span>\n                            <span class=\"chip-close\"\n                                [attr.role]=\"'button'\"\n                                (click)=\"removeChip(selection)\"\n                            ></span>\n                        </span>\n                    </ng-container>\n                    \n                    <ng-container *ngIf=\"!multiple\">\n                        <span\n                            [attr.role]=\"'option'\"\n                            [attr.aria-label]=\"'misc.Remove Item' | translate : {item: control.value.value}\"\n                            [attr.tabindex]=\"'1'\"\n                            (keydown)=\"removeChip(control.value)\"\n                            class=\"chip chip-highlight\"\n                        >\n                            <span class=\"chip-value\">{{control.value.value}}</span>\n                            <span class=\"chip-close\"\n                                  [attr.role]=\"'button'\"\n                                  (click)=\"removeChip(control.value)\"\n                            ></span>\n                        </span>\n                    </ng-container>\n                    \n                </div>\n            </ng-container>\n            \n            <div class=\"input-clear-group\">\n                <input\n                    [(ngModel)]=\"query\"\n                    (ngModelChange)=\"updateQuery($event)\"\n                    [typeahead]=\"searchSubscription\"\n                    [typeaheadAsync]=\"true\"\n                    typeaheadOptionField=\"value\"\n                    [typeaheadMinLength]=\"0\"\n                    [typeaheadItemTemplate]=\"itemTemplate\"\n                    (typeaheadOnSelect)=\"onSelect($event)\"\n                    (typeaheadOnPreview)=\"onOptionHighlighted($event)\"\n                    (typeaheadOnBlur)=\"clearSrLabel()\"\n                    (keypress)=\"keypress($event)\"\n                    [attr.placeholder]=\"config.placeholder | translate\"\n                    [attr.aria-describedby]=\"describedByValue\"\n                    [attr.aria-label]=\"config.ariaLabel | translate\"\n                    [ngClass]=\"{'haveClearBtn': config.clearButton && control.value}\"\n                    id=\"{{config.elementId}}\"\n                    role=\"combobox\"\n                    class=\"input-text\"\n                />\n                <span class='sr-only' role='alert' id='sr-{{config.elementId}}'></span>\n                <span *ngIf=\"config.showSearchIcon\" [hidden]=\"query\" class=\"icn-search\"></span>\n                <ng-container *ngIf=\"config.clearButton\">\n                    <button type=\"button\" class=\"clearBtn\" (click)=\"clearValue($event)\" [hidden]=\"!query\" [attr.aria-hidden]=\"!query\" [attr.aria-label]=\"'misc.Clear' | translate\">\n                        <i class=\"icn-close\"></i>\n                    </button>\n                </ng-container>\n            </div>\n            \n        </div>\n        \n        <div [formGroup]=\"group\">\n            <input type=\"hidden\" [formControlName]=\"config.name\"/>\n        </div>\n    </div>\n</div>\n<ng-template #customItemTemplate let-model=\"item\" let-index=\"index\">\n    <span id=\"option-{{model.id}}\">{{model.value}}</span>\n</ng-template>\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    config: [{
      type: Input
    }],
    group: [{
      type: Input
    }],
    defaultItemTemplate: [{
      type: ViewChild,
      args: ['customItemTemplate', {
        static: false
      }]
    }],
    chipListElm: [{
      type: ViewChild,
      args: ['chipListElm', {
        static: false
      }]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormLocationComponent, {
    className: "FormLocationComponent",
    filePath: "dynamic-form/components/form-location/form-location.ts",
    lineNumber: 17
  });
})();
function FormMoxieManagerComponent_div_0_img_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r1.group.controls.background_image_thumb.value, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.thumbId);
    i0.ɵɵpropertyInterpolate("alt", ctx_r1.group.controls.background_image_thumb.value);
  }
}
function FormMoxieManagerComponent_div_0_button_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function FormMoxieManagerComponent_div_0_button_16_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearSelectedFile($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.clearBtnId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "misc.Clear"), " ");
  }
}
function FormMoxieManagerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "span", 3);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 4)(6, "div", 5);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div")(10, "div", 6);
    i0.ɵɵtemplate(11, FormMoxieManagerComponent_div_0_img_11_Template, 1, 3, "img", 7);
    i0.ɵɵelementStart(12, "div")(13, "button", 8);
    i0.ɵɵlistener("click", function FormMoxieManagerComponent_div_0_Template_button_click_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.chooseImage($event));
    });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, FormMoxieManagerComponent_div_0_button_16_Template, 3, 4, "button", 9);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.group);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 10, ctx_r1.config.label), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("id", ctx_r1.config.elementId + "-desc");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 12, "misc.Recommended image size is 1500 pixels wide. The maximum file size is 3 MB."));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-labelledby", ctx_r1.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.group.controls.background_image_thumb.value);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-describedby", ctx_r1.config.elementId + "-desc");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 14, "misc.Choose Image"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.group.controls.background_image_thumb.value);
  }
}
class FormMoxieManagerComponent {
  constructor(translate) {
    this.translate = translate;
    this.moxmanBrowserOptions = {
      fullscreen: false,
      view: 'thumbs',
      extensions: 'jpg,jpeg,png,gif',
      filelist_main_toolbar: 'upload',
      filelist_insert_toolbar: 'insert close',
      rootpath: window.rootpath,
      close: true,
      oninsert: this.onMoxieFileInsert.bind(this),
      onclose: this.onMoxieDialogClose.bind(this),
      width: 750,
      height: 500,
      title: this.translate.instant('misc.Image Manager')
    };
  }
  ngOnInit() {
    this.thumbId = this.config.elementId + '-thumb';
    this.clearBtnId = this.config.elementId + '-clear-button';
    if (this.config.value) {
      let backgroundImagePath = window.image_base_url + window.rootpath + '/' + this.config.value.substr(this.config.value.lastIndexOf('/') + 1);
      this.setImageControls(backgroundImagePath, this.config.value);
    }
  }
  onMoxieFileInsert(args) {
    this.setImageControls(window.image_base_url + args.focusedFile.path, args.focusedFile.thumbnailUrl);
    setTimeout(() => {
      document.getElementById(this.clearBtnId).style.display = 'block';
    });
  }
  clearSelectedFile(e) {
    let img = document.getElementById(this.thumbId);
    if (!img) {
      return;
    }
    img.remove();
    this.group.controls.background_image.setValue(null);
    this.group.controls.background_image_thumb.setValue(null);
    document.getElementById(this.clearBtnId).style.display = 'none';
  }
  onMoxieDialogOpen() {
    let moxie_dialog = document.querySelector('.moxman-window');
    if (moxie_dialog) {
      // Set focus to first focusable element in dialog
      // moxie_dialog.firstElementChild.focus();
      this.resizeMoxieManager(moxie_dialog);
      this.resizeSubscription = fromEvent(window, 'resize').pipe(debounceTime(300)).subscribe(() => {
        this.resizeMoxieManager(moxie_dialog);
      });
    } else {
      setTimeout(() => this.onMoxieDialogOpen(), 500);
    }
  }
  resizeMoxieManager(moxie_dialog) {
    let moxie_dialog_header = moxie_dialog.querySelector('.moxman-window-head'),
      moxie_dialog_body = moxie_dialog.querySelector('.moxman-container-body'),
      moxie_dialog_footer = moxie_dialog.querySelector('.moxman-foot'),
      bodyHeight = 0,
      dialogPos = {
        width: moxie_dialog_body.offsetWidth,
        height: moxie_dialog_body.querySelector('.moxman-container-body').offsetHeight + moxie_dialog_footer.offsetHeight + moxie_dialog_header.offsetHeight,
        left: (window.innerWidth - moxie_dialog.offsetWidth) / 2 + 'px',
        top: (window.innerHeight - moxie_dialog.offsetHeight) / 2 + 'px'
      };
    if (window.innerWidth < dialogPos.width) {
      dialogPos.left = '0';
    }
    if (window.innerHeight < dialogPos.height) {
      dialogPos.top = '0';
      bodyHeight = window.innerHeight - moxie_dialog_header.offsetHeight - moxie_dialog_footer.offsetHeight;
    } else {
      let heightCalc = document.querySelector('.moxman-container').offsetHeight;
      bodyHeight = heightCalc - moxie_dialog_header.offsetHeight - moxie_dialog_footer.offsetHeight;
    }
    moxie_dialog_body.style.height = `${bodyHeight}px`;
    moxie_dialog.style.top = dialogPos.top;
    moxie_dialog.style.left = dialogPos.left;
  }
  onMoxieDialogClose() {
    this.lastFocusedElement.focus();
    this.resizeSubscription?.unsubscribe();
  }
  chooseImage(e) {
    this.lastFocusedElement = e.target;
    window.moxman.browse(this.moxmanBrowserOptions);
    this.onMoxieDialogOpen();
    return false;
  }
  setImageControls(image, thumb) {
    this.group.controls.background_image.setValue(image);
    this.group.controls.background_image_thumb.setValue(thumb);
  }
  static {
    this.ɵfac = function FormMoxieManagerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormMoxieManagerComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormMoxieManagerComponent,
      selectors: [["moxiemanager"]],
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["class", "field form-upload form-custom", 3, "formGroup", 4, "ngIf"], [1, "field", "form-upload", "form-custom", 3, "formGroup"], [1, "field-label"], [3, "id"], [1, "field-widget"], [1, "blurb", "field-blurb"], [1, "moxie_manager_image_widget"], [3, "src", "id", "alt", 4, "ngIf"], ["type", "button", 1, "choose_img_btn", 3, "click"], ["type", "button", 3, "id", "click", 4, "ngIf"], [3, "src", "id", "alt"], ["type", "button", 3, "click", "id"]],
      template: function FormMoxieManagerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormMoxieManagerComponent_div_0_Template, 17, 16, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.NgControlStatusGroup, i1.NgIf, i2$1.FormGroupDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormMoxieManagerComponent, [{
    type: Component,
    args: [{
      selector: 'moxiemanager',
      template: `
            <div class="field form-upload form-custom" *ngIf="!config.hideField" [formGroup]="group">
                <div class="field-label">
                    <span id="{{config.elementId}}">
                        {{config.label | translate}}
                    </span>
                </div>
                <div class="field-widget">
                    <div class="blurb field-blurb" [attr.id]="config.elementId + '-desc'">{{'misc.Recommended image size is 1500 pixels wide. The maximum file size is 3 MB.'| translate}}</div>
                    <div>
                        <div
                            [attr.aria-labelledby]="config.elementId"
                            class="moxie_manager_image_widget"
                        >
                            <img
                                *ngIf="group.controls.background_image_thumb.value"
                                src="{{group.controls.background_image_thumb.value}}"
                                id="{{thumbId}}"
                                alt="{{group.controls.background_image_thumb.value}}">
                            <div>
                                <button
                                    type="button"
                                    class="choose_img_btn"
                                    [attr.aria-describedby]="config.elementId + '-desc'"
                                    (click)="chooseImage($event)"
                                >
                                    {{'misc.Choose Image' | translate}}
                                </button>
                                <button *ngIf="group.controls.background_image_thumb.value"
                                    type="button"
                                    id="{{clearBtnId}}"
                                    (click)="clearSelectedFile($event)"
                                >
                                    {{'misc.Clear' | translate}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    `,
      standalone: false
    }]
  }], () => [{
    type: i1$1.TranslateService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormMoxieManagerComponent, {
    className: "FormMoxieManagerComponent",
    filePath: "dynamic-form/components/form-moxiemanager/form-moxiemanager.component.ts",
    lineNumber: 54
  });
})();
function FormMoxieManagerStaticComponent_div_0_img_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r0.config.value, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r0.config.elementId, "-thumb");
    i0.ɵɵpropertyInterpolate1("alt", "Slide background image filename: ", ctx_r0.config.value, "");
  }
}
function FormMoxieManagerStaticComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "label");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 3)(6, "div", 4)(7, "div")(8, "div", 5);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 6);
    i0.ɵɵtemplate(11, FormMoxieManagerStaticComponent_div_0_img_11_Template, 1, 5, "img", 7);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.group);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, ctx_r0.config.label), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.config.title);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.value);
  }
}
class FormMoxieManagerStaticComponent {
  static {
    this.ɵfac = function FormMoxieManagerStaticComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormMoxieManagerStaticComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormMoxieManagerStaticComponent,
      selectors: [["imgstatic"]],
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["class", "field form-upload form-custom", 3, "formGroup", 4, "ngIf"], [1, "field", "form-upload", "form-custom", 3, "formGroup"], [1, "field-label"], [1, "field-widget"], [1, "subform"], [1, "label"], [1, "moxie_manager_image_widget"], [3, "src", "id", "alt", 4, "ngIf"], [3, "src", "id", "alt"]],
      template: function FormMoxieManagerStaticComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormMoxieManagerStaticComponent_div_0_Template, 12, 6, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.config.value && !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.NgControlStatusGroup, i1.NgIf, i2$1.FormGroupDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormMoxieManagerStaticComponent, [{
    type: Component,
    args: [{
      selector: 'imgstatic',
      template: `
            <div *ngIf="config.value && !config.hideField" class="field form-upload form-custom" [formGroup]="group">
                <div class="field-label">
                  <label>
                    {{config.label | translate}}
                  </label>
                </div>
                <div class="field-widget">
                    <div class="subform">
                        <div>
                        <div class="label">{{config.title}}</div>
                            <div class="moxie_manager_image_widget">
                                <img 
                                    *ngIf="config.value" 
                                    src="{{config.value}}" 
                                    id="{{config.elementId}}-thumb" 
                                    alt="Slide background image filename: {{config.value}}">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    `,
      standalone: false
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormMoxieManagerStaticComponent, {
    className: "FormMoxieManagerStaticComponent",
    filePath: "dynamic-form/components/form-static/form-moxiemanager-static.component.ts",
    lineNumber: 33
  });
})();
const _c0$1g = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c1$$ = a0 => ({
  field_name: a0
});
function FormMinMaxComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 9);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "misc.invalid minmax error"), " ");
  }
}
function FormMinMaxComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 9);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$$, ctx_r1.translatedLabel)), " ");
  }
}
function FormMinMaxComponent_div_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 9);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, ctx_r1.patternError), " ");
  }
}
function FormMinMaxComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "label", 4);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
    i0.ɵɵtemplate(7, FormMinMaxComponent_div_0_div_7_Template, 4, 3, "div", 7)(8, FormMinMaxComponent_div_0_div_8_Template, 4, 6, "div", 7)(9, FormMinMaxComponent_div_0_div_9_Template, 4, 3, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "input", 8, 0);
    i0.ɵɵlistener("keypress", function FormMinMaxComponent_div_0_Template_input_keypress_10_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("keypress", $event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c0$1g, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched) || ctx_r1.minmax, ctx_r1.config.lastChild))("formGroup", ctx_r1.group);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 12, ctx_r1.config.label), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r1.config.hideMinMaxError && ctx_r1.minmax);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched) && ctx_r1.control.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched) && ctx_r1.control.errors.pattern);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r1.config.elementId);
    i0.ɵɵproperty("formControlName", ctx_r1.config.name);
    i0.ɵɵattribute("aria-describedby", ctx_r1.describedByValue);
  }
}
class FormMinMaxComponent extends FormInputComponent {
  constructor(fb, translate) {
    super(translate);
    this.fb = fb;
    this.translate = translate;
  }
  get patternError() {
    return 'misc.invalid number error';
  }
  get minmax() {
    return this.validateMinMax(this.group);
  }
  ngOnInit() {
    this.translatedLabel = this.translate.instant(this.config.label);
    if (this.config.value || this.config.value === 0) {
      setTimeout(() => {
        this.control.setValue(this.config.value, {
          'emitEvent': true,
          'emitModelToViewChange': true
        });
      });
      this.defaultInit();
    }
  }
  validateMinMax(abstractControl) {
    if (abstractControl.value) {
      let values = Object.values(abstractControl.value);
      let minValue = window.parseInt(values[0]);
      let maxValue = window.parseInt(values[1]);
      if (minValue !== null && minValue > maxValue) {
        return true;
      }
    }
  }
  static {
    this.ɵfac = function FormMinMaxComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormMinMaxComponent)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormMinMaxComponent,
      selectors: [["form-minmax"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["inputField", ""], ["class", "field form-minmax form-custom", 3, "ngClass", "formGroup", 4, "ngIf"], [1, "field", "form-minmax", "form-custom", 3, "ngClass", "formGroup"], [1, "field-label"], [3, "for"], [1, "field-widget"], ["role", "alert"], [4, "ngIf"], ["type", "number", 1, "input-text", 3, "keypress", "formControlName", "id"], [1, "icn-error_filled"]],
      template: function FormMinMaxComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormMinMaxComponent_div_0_Template, 12, 17, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.DefaultValueAccessor, i2$1.NumberValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormMinMaxComponent, [{
    type: Component,
    args: [{
      selector: 'form-minmax',
      standalone: false,
      template: "<div class=\"field form-minmax form-custom\"\n     *ngIf=\"!config.hideField\"\n     [ngClass]=\"{'field-error': !control.valid && (control.dirty || control.touched) || minmax, 'last': config.lastChild}\"\n     [formGroup]=\"group\">\n    <div class=\"field-label\">\n        <label for=\"{{config.elementId}}{{modal?'modal':''}}\">\n            {{config.label | translate}}\n        </label>\n    </div>\n    <div class=\"field-widget\">\n        <div role=\"alert\">\n            <div *ngIf=\"!config.hideMinMaxError && minmax\">\n                <i class=\"icn-error_filled\"></i>\n                {{'misc.invalid minmax error' | translate}}\n            </div>\n            <div *ngIf=\"(!control.valid && (control.dirty || control.touched)) && control.errors.required\">\n                <i class=\"icn-error_filled\"></i>\n                {{ 'misc.Field is required' | translate: { field_name: translatedLabel } }}\n            </div>\n            <div *ngIf=\"(!control.valid && (control.dirty || control.touched)) && control.errors.pattern\">\n                <i class=\"icn-error_filled\"></i>\n                {{patternError | translate}}\n            </div>\n        </div>\n        <input\n                #inputField\n                type=\"number\"\n                [attr.aria-describedby]=\"describedByValue\"\n                [formControlName]=\"config.name\"\n                id=\"{{config.elementId}}\"\n                (keypress)=\"triggerEvent('keypress', $event);\"\n                class=\"input-text\"/>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }, {
    type: i1$1.TranslateService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormMinMaxComponent, {
    className: "FormMinMaxComponent",
    filePath: "dynamic-form/components/form-minmax/form-minmax.component.ts",
    lineNumber: 15
  });
})();
const _c0$1f = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c1$_ = a0 => ({
  field_name: a0
});
function FormNumberComparisonComponent_div_0_div_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 13);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormNumberComparisonComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "label", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, FormNumberComparisonComponent_div_0_div_1_i_4_Template, 2, 0, "i", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, ctx_r1.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired);
  }
}
function FormNumberComparisonComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormNumberComparisonComponent_div_0_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$_, ctx_r1.translatedLabel)), " ");
  }
}
function FormNumberComparisonComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, FormNumberComparisonComponent_div_0_div_4_div_1_Template, 4, 6, "div", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.required);
  }
}
function FormNumberComparisonComponent_div_0_option_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const comparison_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", comparison_r3.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(comparison_r3.value);
  }
}
function FormNumberComparisonComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, FormNumberComparisonComponent_div_0_div_1_Template, 5, 7, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, FormNumberComparisonComponent_div_0_div_3_Template, 3, 6, "div", 4)(4, FormNumberComparisonComponent_div_0_div_4_Template, 2, 1, "div", 5);
    i0.ɵɵelementStart(5, "div", 6)(6, "select", 7);
    i0.ɵɵtemplate(7, FormNumberComparisonComponent_div_0_option_7_Template, 2, 2, "option", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "input", 9);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵlistener("blur", function FormNumberComparisonComponent_div_0_Template_input_blur_8_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("blur", $event));
    })("keypress", function FormNumberComparisonComponent_div_0_Template_input_keypress_8_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("keypress", $event));
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.group)("ngClass", i0.ɵɵpureFunction2(18, _c0$1f, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.comparisonGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.comparisons);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("input-text ", ctx_r1.config.className, "");
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵattribute("placeholder", i0.ɵɵpipeBind1(9, 16, ctx_r1.config.placeholder))("aria-describedby", ctx_r1.describedByValue)("aria-required", ctx_r1.isRequired);
  }
}
class FormNumberComparisonComponent extends FormInputComponent {
  constructor(translate, fb) {
    super(translate);
    this.translate = translate;
    this.fb = fb;
    this.comparisons = [{
      id: 'lt',
      value: '<'
    }, {
      id: 'lteq',
      value: '<='
    }, {
      id: 'eq',
      value: '='
    }, {
      id: 'neq',
      value: '<>'
    }, {
      id: 'gteq',
      value: '>='
    }, {
      id: 'gt',
      value: '>'
    }];
    this.currentComparison = this.comparisons[0];
  }
  ngOnInit() {
    if (this.config?.value?.compare) {
      let newCurrent = this.comparisons.find(c => c.id === this.config.value.compare);
      this.currentComparison = newCurrent || this.currentComparison;
    }
    this.comparisonGroup = this.fb.group({
      compare: this.fb.control(this.currentComparison.id),
      number: this.fb.control(this.config?.value?.number || null)
    });
    this.group.setControl(this.config.name, this.comparisonGroup);
  }
  static {
    this.ɵfac = function FormNumberComparisonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormNumberComparisonComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormNumberComparisonComponent,
      selectors: [["form-number-comparison"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "field numbercomparison-widget form-custom", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "field", "numbercomparison-widget", "form-custom", 3, "formGroup", "ngClass"], ["class", "field-label", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], [1, "btn-in-select", 3, "formGroup"], ["formControlName", "compare"], [3, "value", 4, "ngFor", "ngForOf"], ["formControlName", "number", "type", "number", 3, "blur", "keypress", "id"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [4, "ngIf"], [1, "icn-error_filled"], [3, "value"]],
      template: function FormNumberComparisonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormNumberComparisonComponent_div_0_Template, 10, 21, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.DefaultValueAccessor, i2$1.NumberValueAccessor, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormNumberComparisonComponent, [{
    type: Component,
    args: [{
      selector: 'form-number-comparison',
      template: `
        <div
            [formGroup]="group"
            *ngIf="!config.hideField"
            class="field numbercomparison-widget form-custom"
            [ngClass]="{'field-error': !control.valid && (control.dirty || control.touched), 'last': config.lastChild}"
        >
            <div *ngIf="!config.hideLabel" class="field-label">
                <label for="{{config.elementId}}{{modal?'modal':''}}">
                {{config.label | translate}}
                <i *ngIf="isRequired" class="req-indicator">*</i>
                </label>
            </div>
            <div class="field-widget">
                <div *ngIf="config.blurb" id="{{describedByValue}}" class="blurb field-blurb" [innerHTML]="config.blurb | translate | safeHtml"></div>
                <div role="alert" *ngIf="(!control.valid && (control.dirty || control.touched))">
                    <div *ngIf="control.errors.required">
                        <i class="icn-error_filled"></i>
                        {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}
                    </div>
                </div>
                <div class="btn-in-select" [formGroup]="comparisonGroup">
                    <select formControlName="compare">
                        <option *ngFor="let comparison of comparisons" [value]="comparison.id" >{{comparison.value}}</option>
                    </select>
                    <input
                        formControlName="number"
                        type="number"
                        id="{{config.elementId}}{{modal?'modal':''}}"
                        class="input-text {{config.className}}"
                        [attr.placeholder]="config.placeholder | translate"
                        [attr.aria-describedby]="describedByValue"
                        [attr.aria-required]="isRequired"
                        (blur)="triggerEvent('blur', $event);"
                        (keypress)="triggerEvent('keypress', $event);"
                    />
                </div>
            </div>
        </div>
    `,
      standalone: false
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: i2$1.UntypedFormBuilder
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormNumberComparisonComponent, {
    className: "FormNumberComparisonComponent",
    filePath: "dynamic-form/components/form-number-compare/form-number-compare.component.ts",
    lineNumber: 51
  });
})();
class FileSelected {
  constructor(init) {
    this.file_id = '';
    this.name = '';
    this.size = 0;
    Object.assign(this, init);
  }
}
class UploadFile {
  constructor(init) {
    this.uploadProgress = 0;
    Object.assign(this, init);
  }
}
class FormFileUploadValidators {
  static maxFileSize(size) {
    return control => {
      const value = control.value;
      return value?.size > size ? {
        maxFileSize: true
      } : null;
    };
  }
}
const _c0$1e = ["flow"];
const _c1$Z = ["fileUploadWrapper"];
const _c2$L = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c3$w = a0 => ({
  field_name: a0
});
const _c4$r = a0 => ({
  "file-upload-multiple": a0
});
const _c5$i = a0 => ({
  "drag-active": a0
});
const _c6$d = a0 => ({
  "item": a0,
  "isItem": false
});
const _c7$8 = (a0, a1) => ({
  "uploading": a0,
  "error-state": a1
});
const _c8$7 = a0 => ({
  item: a0,
  isItem: true
});
function FormFileUploadComponent_div_2_div_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 19);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormFileUploadComponent_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "label", 17);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, FormFileUploadComponent_div_2_div_1_i_4_Template, 2, 0, "i", 18);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "_modal-container" : "_container", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
  }
}
function FormFileUploadComponent_div_2_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 20);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r0.describedByValue)("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormFileUploadComponent_div_2_div_4_ng_container_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c3$w, ctx_r0.translatedLabel)), " ");
  }
}
function FormFileUploadComponent_div_2_div_4_ng_container_1_ng_container_3_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "misc.Upload Failed - Too big"), " ");
  }
}
function FormFileUploadComponent_div_2_div_4_ng_container_1_ng_container_3_span_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "button", 23);
    i0.ɵɵlistener("click", function FormFileUploadComponent_div_2_div_4_ng_container_1_ng_container_3_span_2_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r0.retryUpload());
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "misc.Upload Failed"), " - ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 4, "misc.Try again"));
  }
}
function FormFileUploadComponent_div_2_div_4_ng_container_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormFileUploadComponent_div_2_div_4_ng_container_1_ng_container_3_span_1_Template, 3, 3, "span", 14)(2, FormFileUploadComponent_div_2_div_4_ng_container_1_ng_container_3_span_2_Template, 6, 6, "span", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.maxFileSize);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.api);
  }
}
function FormFileUploadComponent_div_2_div_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 22);
    i0.ɵɵtemplate(2, FormFileUploadComponent_div_2_div_4_ng_container_1_span_2_Template, 3, 6, "span", 14)(3, FormFileUploadComponent_div_2_div_4_ng_container_1_ng_container_3_Template, 3, 2, "ng-container", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isMultiUploadMode);
  }
}
function FormFileUploadComponent_div_2_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, FormFileUploadComponent_div_2_div_4_ng_container_1_Template, 4, 2, "ng-container", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.uploadFiles.length && !ctx_r0.isProgressItem(ctx_r0.firstItem) && !ctx_r0.isSuccessItem(ctx_r0.firstItem));
  }
}
function FormFileUploadComponent_div_2_ng_container_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelement(1, "i", 22);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const errorMsg_r3 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", errorMsg_r3, " ");
  }
}
function FormFileUploadComponent_div_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormFileUploadComponent_div_2_ng_container_5_div_1_Template, 4, 1, "div", 24);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.fileUploadConfig.customErrors);
  }
}
function FormFileUploadComponent_div_2_ng_template_6_Template(rf, ctx) {}
function FormFileUploadComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, FormFileUploadComponent_div_2_div_1_Template, 5, 7, "div", 10);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵtemplate(3, FormFileUploadComponent_div_2_div_3_Template, 3, 6, "div", 12)(4, FormFileUploadComponent_div_2_div_4_Template, 2, 1, "div", 13)(5, FormFileUploadComponent_div_2_ng_container_5_Template, 2, 1, "ng-container", 14)(6, FormFileUploadComponent_div_2_ng_template_6_Template, 0, 0, "ng-template", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const field_r4 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c2$L, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched) && !ctx_r0.uploadFiles.length && !ctx_r0.isProgressItem(ctx_r0.firstItem) && !ctx_r0.isSuccessItem(ctx_r0.firstItem), ctx_r0.config.lastChild))("formGroup", ctx_r0.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched) && !ctx_r0.fileUploadConfig.customErrors);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fileUploadConfig.customErrors == null ? null : ctx_r0.fileUploadConfig.customErrors.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", field_r4);
  }
}
function FormFileUploadComponent_ng_template_3_ng_container_1_1_ng_template_0_Template(rf, ctx) {}
function FormFileUploadComponent_ng_template_3_ng_container_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormFileUploadComponent_ng_template_3_ng_container_1_1_ng_template_0_Template, 0, 0, "ng-template", 15);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const uploadField_r5 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutlet", uploadField_r5);
  }
}
function FormFileUploadComponent_ng_template_3_ng_container_1_2_ng_template_0_Template(rf, ctx) {}
function FormFileUploadComponent_ng_template_3_ng_container_1_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormFileUploadComponent_ng_template_3_ng_container_1_2_ng_template_0_Template, 0, 0, "ng-template", 15);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const uploadProcess_r6 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", uploadProcess_r6);
  }
}
function FormFileUploadComponent_ng_template_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormFileUploadComponent_ng_template_3_ng_container_1_1_Template, 1, 1, null, 14)(2, FormFileUploadComponent_ng_template_3_ng_container_1_2_Template, 1, 1, null, 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.uploadFiles == null ? null : ctx_r0.uploadFiles.length) || ctx_r0.isErrorItem(ctx_r0.firstItem));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.uploadFiles.length && ctx_r0.isProgressItem(ctx_r0.firstItem));
  }
}
function FormFileUploadComponent_ng_template_3_ng_container_2_ng_template_1_Template(rf, ctx) {}
function FormFileUploadComponent_ng_template_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormFileUploadComponent_ng_template_3_ng_container_2_ng_template_1_Template, 0, 0, "ng-template", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const uploadField_r5 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", uploadField_r5);
  }
}
function FormFileUploadComponent_ng_template_3_3_ng_template_0_Template(rf, ctx) {}
function FormFileUploadComponent_ng_template_3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormFileUploadComponent_ng_template_3_3_ng_template_0_Template, 0, 0, "ng-template", 15);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const uploadFile_r7 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", uploadFile_r7);
  }
}
function FormFileUploadComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, FormFileUploadComponent_ng_template_3_ng_container_1_Template, 3, 2, "ng-container", 14)(2, FormFileUploadComponent_ng_template_3_ng_container_2_Template, 2, 1, "ng-container", 14)(3, FormFileUploadComponent_ng_template_3_3_Template, 1, 1, null, 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.config.elementId)("ngClass", i0.ɵɵpureFunction1(6, _c4$r, ctx_r0.isMultiUploadMode));
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isMultiUploadMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isMultiUploadMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isMultiUploadMode || ctx_r0.isSuccessItem(ctx_r0.firstItem));
  }
}
function FormFileUploadComponent_ng_template_5_button_0_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "fileSize");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "misc.Max file size:"), "\u00A0", i0.ɵɵpipeBind1(3, 4, ctx_r0.fileUploadConfig.maxFileSize), " ");
  }
}
function FormFileUploadComponent_ng_template_5_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28, 6)(2, "span", 29);
    i0.ɵɵlistener("dragenter", function FormFileUploadComponent_ng_template_5_button_0_Template_span_dragenter_2_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragEnter());
    })("dragover", function FormFileUploadComponent_ng_template_5_button_0_Template_span_dragover_2_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragOver());
    })("dragleave", function FormFileUploadComponent_ng_template_5_button_0_Template_span_dragleave_2_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragLeave());
    })("drop", function FormFileUploadComponent_ng_template_5_button_0_Template_span_drop_2_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDrop());
    });
    i0.ɵɵelement(3, "i", 30)(4, "span", 31);
    i0.ɵɵtemplate(5, FormFileUploadComponent_ng_template_5_button_0_span_5_Template, 4, 6, "span", 32);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const flow_r9 = i0.ɵɵreference(1);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "_modal-container" : "_container", "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c5$i, ctx_r0.dragActive))("flowAttributes", ctx_r0.flowAttributes)("flow", flow_r9.flowJs);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("flow", flow_r9.flowJs);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.fileUploadText, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fileUploadConfig.maxFileSize);
  }
}
function FormFileUploadComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormFileUploadComponent_ng_template_5_button_0_Template, 6, 11, "button", 27);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.readOnly);
  }
}
function FormFileUploadComponent_ng_template_7_ng_template_1_Template(rf, ctx) {}
function FormFileUploadComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtemplate(1, FormFileUploadComponent_ng_template_7_ng_template_1_Template, 0, 0, "ng-template", 35);
    i0.ɵɵelementStart(2, "p", 36);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 37);
    i0.ɵɵlistener("click", function FormFileUploadComponent_ng_template_7_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.cancelUpload(ctx_r0.firstItem));
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const spinner_r11 = i0.ɵɵreference(12);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", spinner_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c6$d, ctx_r0.firstItem));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(4, 5, "misc.Uploading"), " ", ctx_r0.firstItem == null ? null : ctx_r0.firstItem.fileSelected.name, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 7, "misc.Cancel"), " ");
  }
}
function FormFileUploadComponent_ng_template_9_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r0.elementId + "_list_label");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "misc.Files"), " ");
  }
}
function FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 46);
    i0.ɵɵelement(2, "i", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 48);
    i0.ɵɵelement(2, "i", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 50);
    i0.ɵɵelement(2, "i", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_6_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r13 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" - ", item_r13.statusMessage, " ");
  }
}
function FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 52);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_6_ng_container_4_Template, 2, 1, "ng-container", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "misc.Upload Failed"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r13.statusMessage);
  }
}
function FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 53);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "fileExtension");
    i0.ɵɵelement(4, "i", 54);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "fileSize");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, item_r13 == null ? null : item_r13.fileSelected.name), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, item_r13 == null ? null : item_r13.fileSelected.size), " ");
  }
}
function FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_10_ng_container_1_ng_template_2_Template(rf, ctx) {}
function FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_10_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 55);
    i0.ɵɵtemplate(2, FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_10_ng_container_1_ng_template_2_Template, 0, 0, "ng-template", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r13 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(3);
    const spinner_r11 = i0.ɵɵreference(12);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", spinner_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c8$7, item_r13));
  }
}
function FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_10_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 56);
    i0.ɵɵlistener("click", function FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_10_ng_container_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r14);
      const item_r13 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.deleteFile(item_r13));
    });
    i0.ɵɵelementStart(2, "span", 57);
    i0.ɵɵelement(3, "i", 58);
    i0.ɵɵelementStart(4, "span", 59);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 1, "misc.delete file"));
  }
}
function FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_10_ng_container_1_Template, 3, 4, "ng-container", 14)(2, FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_10_ng_container_2_Template, 7, 3, "ng-container", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r13 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isMultiUploadMode && ctx_r0.isProgressItem(item_r13));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.hideDeleteButton && (!ctx_r0.isMultiUploadMode || ctx_r0.isMultiUploadMode && ctx_r0.isSuccessItem(item_r13)));
  }
}
function FormFileUploadComponent_ng_template_9_ul_1_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 42)(1, "button", 43);
    i0.ɵɵlistener("click", function FormFileUploadComponent_ng_template_9_ul_1_li_1_Template_button_click_1_listener() {
      const item_r13 = i0.ɵɵrestoreView(_r12).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.downloadFile(item_r13));
    });
    i0.ɵɵtemplate(2, FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_2_Template, 3, 0, "ng-container", 14)(3, FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_3_Template, 3, 0, "ng-container", 14)(4, FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_4_Template, 3, 0, "ng-container", 14);
    i0.ɵɵelementStart(5, "span", 44);
    i0.ɵɵtemplate(6, FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_6_Template, 5, 4, "ng-container", 14);
    i0.ɵɵelementStart(7, "span", 45);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_9_Template, 7, 6, "ng-container", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, FormFileUploadComponent_ng_template_9_ul_1_li_1_ng_container_10_Template, 3, 2, "ng-container", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r13 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c7$8, ctx_r0.isProgressItem(item_r13), ctx_r0.isErrorItem(item_r13)));
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-disabled", !ctx_r0.isSuccessItem(item_r13));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isErrorItem(item_r13));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isSuccessItem(item_r13));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isErrorItem(item_r13));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isErrorItem(item_r13));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r13 == null ? null : item_r13.fileSelected.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isErrorItem(item_r13));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.readOnly && !ctx_r0.isErrorItem(item_r13));
  }
}
function FormFileUploadComponent_ng_template_9_ul_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtemplate(1, FormFileUploadComponent_ng_template_9_ul_1_li_1_Template, 11, 12, "li", 41);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-labelledby", ctx_r0.isMultiUploadMode && !ctx_r0.config.readOnly ? ctx_r0.elementId + "_list_label" : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.uploadFiles);
  }
}
function FormFileUploadComponent_ng_template_9_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 60);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.fileUploadConfig.emptyFileListMessage), " ");
  }
}
function FormFileUploadComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormFileUploadComponent_ng_template_9_div_0_Template, 3, 4, "div", 38)(1, FormFileUploadComponent_ng_template_9_ul_1_Template, 2, 2, "ul", 14)(2, FormFileUploadComponent_ng_template_9_p_2_Template, 3, 3, "p", 39);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.uploadFiles.length && ctx_r0.isMultiUploadMode && !ctx_r0.config.readOnly);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.uploadFiles.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.uploadFiles.length && ctx_r0.config.readOnly && ctx_r0.fileUploadConfig.emptyFileListMessage);
  }
}
function FormFileUploadComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 61);
    i0.ɵɵelement(1, "progress-spinner", 62);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r15 = ctx.item;
    const isItem_r16 = ctx.isItem;
    i0.ɵɵproperty("ngClass", isItem_r16 ? "icon-wrapper" : "space-bottom-sm");
    i0.ɵɵadvance();
    i0.ɵɵproperty("strokeWidth", 2)("radius", 7)("progress", item_r15.uploadProgress);
  }
}
class FormFileUploadComponent extends FormInputComponent {
  get isMultiUploadMode() {
    return !!!this.flowConfig.singleFile;
  }
  get firstItem() {
    return this.uploadFiles[0];
  }
  constructor(translate, changeDetectorRef) {
    super(translate);
    this.translate = translate;
    this.changeDetectorRef = changeDetectorRef;
    this.fileUploadConfig = {
      accept: '*',
      ariaHidden: 'true',
      uploadAPI: '',
      query: null,
      maxFileSize: null,
      onUploaded: null,
      onUploadError: null,
      onUploadCancelled: null,
      onDownload: null,
      onCompleted: null,
      onDelete: null,
      testChunks: false,
      customErrors: null,
      emptyFileListMessage: 'misc.No files added',
      hideDeleteButton: false
    };
    this.uploadFiles = [];
    this.dragActive = false;
    this.fileUploadText = '';
    this.uploadProgress = 0;
    this.errors = {};
    this.fileUploadConfigKeys = ['accept', 'ariaHidden', 'uploadAPI', 'query', 'maxFileSize', 'onUploaded', 'onUploadError', 'onUploadCancelled', 'onDownload', 'onCompleted', 'onDelete', 'testChunks', 'customErrors', 'emptyFileListMessage', 'hideDeleteButton'];
    this.uploadState = {
      initial: 'initial',
      progress: 'progress',
      success: 'success',
      error: 'error'
    };
    this.fileUploadHTML = browseString => `<span class="button-like">${browseString}</span>`;
    this.transfers = [];
    this.destroyed$ = new Subject();
  }
  ngOnInit() {
    this.defaultInit();
    this.applyFileUploadConfigs(this.fileUploadConfigKeys);
    this.setFlowJSConfigs();
    this.translate.get('misc.Close').pipe(take(1)).subscribe(res => {
      this.fileUploadText = this.translate.instant('misc.Drop or {browseLink} files to upload', {
        browseLink: this.fileUploadHTML(this.translate.instant('misc.browse'))
      });
    });
  }
  ngAfterViewInit() {
    this.updateValidators();
    if (!this.config.readOnly) {
      this.watchControlTouched();
      this.watchFlowEmitters();
    }
    this.setInitialValue();
  }
  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  /** UI events */
  onDragEnter() {
    if (this.dragActive) {
      return;
    }
    this.dragActive = true;
  }
  onDragOver() {
    if (this.dragActive) {
      return;
    }
    this.dragActive = true;
  }
  onDragLeave() {
    if (!this.dragActive) {
      return;
    }
    this.dragActive = false;
  }
  onDrop() {
    if (!this.dragActive) {
      return;
    }
    if (this.control.untouched) {
      this.control.markAsTouched();
    }
    this.dragActive = false;
  }
  /** FlowJS Actions */
  retryUpload(item = undefined) {
    if (!this.uploadFiles.length) {
      return;
    }
    this.control.updateValueAndValidity();
    const retryItem = item ? this.findUploadFile(item) : this.firstItem;
    retryItem.flowFile.retry();
  }
  cancelUpload(item) {
    this.cancelTransfer(item.flowFile);
    this.removeUploadFile(item);
    this.execCallback(this.fileUploadConfig.onUploadCancelled, item.fileSelected);
  }
  downloadFile(item = this.firstItem) {
    if (!this.isSuccessItem(item)) {
      return;
    }
    this.execCallback(this.fileUploadConfig.onDownload, item.fileSelected);
  }
  deleteFile(item) {
    this.removeUploadFile(item);
    this.execCallback(this.fileUploadConfig.onDelete, item.fileSelected);
  }
  applyFileUploadConfigs(fileUploadConfigKeys) {
    fileUploadConfigKeys.filter(key => typeof this.config[key] !== 'undefined' && this.fileUploadConfig.hasOwnProperty(key)).forEach(key => this.fileUploadConfig[key] = this.config[key]);
  }
  setFlowJSConfigs() {
    this.flowConfig = {
      singleFile: !this.config.multiple,
      target: this.fileUploadConfig.uploadAPI,
      query: this.fileUploadConfig.query || {},
      testChunks: this.fileUploadConfig.testChunks,
      allowDuplicateUploads: true
    };
    if (window.SUB_SYSTEM) {
      this.flowConfig.headers = {
        'x-requested-system-user': window.SUB_SYSTEM
      };
    }
    this.flowAttributes = {
      id: `${this.config.elementId}${this.modal ? 'modal' : ''}`,
      accept: this.fileUploadConfig.accept,
      'aria-hidden': this.fileUploadConfig.ariaHidden
    };
  }
  updateValidators() {
    const validators = [];
    if (this.isRequired) {
      validators.push(Validators.required);
    }
    if (this.fileUploadConfig.maxFileSize && typeof this.fileUploadConfig.maxFileSize === 'number') {
      validators.push(FormFileUploadValidators.maxFileSize(this.fileUploadConfig.maxFileSize));
    }
    this.control.setValidators(validators);
    this.control.updateValueAndValidity();
  }
  watchControlTouched() {
    fromEvent(this.fileUploadWrapper.nativeElement, 'click').pipe(filter(event => event.isTrusted && !!this.fileUploadWrapper), take(1), switchMap(() => fromEvent(this.fileUploadWrapper.nativeElement, 'focus')), take(1), delay(300), takeUntil(this.destroyed$)).subscribe(() => {
      this.control.markAsTouched();
    });
  }
  watchFlowEmitters() {
    this.flow.events$.pipe(takeUntil(this.destroyed$)).subscribe(event => {
      switch (event.type) {
        case 'fileAdded':
          this.onFileAdded(event);
          break;
        case 'filesSubmitted':
          this.onFileSubmitted(event);
          break;
        case 'fileProgress':
          this.onFileProgress(event);
          break;
        case 'fileSuccess':
          this.onFileSuccess(event);
          break;
        case 'fileError':
          this.onFileError(event);
          break;
        case 'complete':
          this.onComplete(event);
          break;
        default:
          break;
      }
    });
    this.flow.transfers$.pipe(map(uploadState => uploadState.transfers), takeUntil(this.destroyed$)).subscribe(transfers => this.transfers = this.transfers.concat(transfers));
  }
  setInitialValue() {
    let formValues = [];
    if (Array.isArray(this.config.value) && this.config.value.length) {
      this.config.value.forEach(val => {
        let file = this.convertFileAsSelected(_.cloneDeep(val));
        this.setInitDownloadableFiles(file);
      });
      formValues = this.getAllFileSelected();
    } else if (_.isObject(this.config.value) && !_.isEmpty(this.config.value)) {
      let file = this.convertFileAsSelected(_.cloneDeep(this.config.value));
      this.setInitDownloadableFiles(file);
      formValues = [file];
    }
    this.setFormValue(formValues, false);
    this.changeDetectorRef.detectChanges();
  }
  onFileAdded(event) {
    const flowFile = event.event[0];
    const uploadedFile = this.findUploadFile(flowFile);
    if (uploadedFile && !this.control.errors?.api) {
      return;
    }
    if (this.fileUploadConfig.maxFileSize && typeof this.fileUploadConfig.maxFileSize === 'number') {
      if (flowFile.size > this.fileUploadConfig?.maxFileSize) {
        this.fileUploadConfig.customErrors = null;
        this.control.setErrors({
          maxFileSize: true
        });
        return;
      }
    }
    this.errors = {};
    this.fileUploadConfig.customErrors = null;
    this.control.updateValueAndValidity();
    if (!this.isMultiUploadMode) {
      this.reset();
    }
    this.addUploadFile(flowFile);
  }
  onFileSubmitted(event) {
    const processingFlowFiles = event.event[0];
    if (this.isUploadingFileInvalid() || !processingFlowFiles.length) {
      return;
    }
    processingFlowFiles.forEach(file => {
      this.updateUploadFileState(this.uploadState.progress, file);
    });
    this.flow.upload();
  }
  onFileProgress(event) {
    const flowFile = event.event[0];
    const total = flowFile.chunks.length;
    const uploaded = flowFile.chunks.filter(chunk => chunk.xhr?.readyState === 4).length;
    const matchItem = this.findUploadFile(flowFile);
    matchItem['uploadProgress'] = uploaded / total * 100;
  }
  onFileSuccess(event) {
    const flowFile = event.event[0];
    const apiEvent = event?.event[2]?.xhr;
    const apiResponse = this.getAPIResponse(apiEvent.response);
    const file_id = apiResponse?.file_id || Object.values(apiResponse)[0]?.['file_id'];
    const hasErrorState = apiResponse.error;
    if (!_.isEmpty(hasErrorState) || !this.isUploadDataReady(flowFile, file_id)) {
      this.setFileErrorState(flowFile, apiEvent);
    } else {
      const matchItem = this.findUploadFile(flowFile);
      matchItem['uploadProgress'] = 100;
      matchItem.fileSelected.file_id = file_id;
      this.updateUploadFileState(this.uploadState.success, flowFile);
      this.execCallback(this.fileUploadConfig.onUploaded, apiResponse);
    }
  }
  onComplete(event) {
    const successItems = this.uploadFiles.filter(item => this.isSuccessItem(item));
    const newFormValues = this.getAllFileSelected(successItems);
    setTimeout(() => {
      if (JSON.stringify(newFormValues) !== JSON.stringify(this.control.value)) {
        this.setFormValue(newFormValues);
        this.control.updateValueAndValidity();
        this.setErrorState();
        this.execCallback(this.fileUploadConfig.onCompleted, successItems);
      }
      return;
    }, 50);
  }
  onFileError(event) {
    const flowFile = event.event[0];
    const errorEvent = event?.event[2]?.xhr;
    this.setFileErrorState(flowFile, errorEvent);
  }
  isUploadingFileInvalid() {
    let isInvalid = this.control.invalid;
    if (this.control.errors?.required && Object.keys(this.control.errors).length === 1) {
      isInvalid = false;
    }
    return isInvalid;
  }
  setFileErrorState(flowFile, event) {
    const {
      status,
      statusText,
      response
    } = event;
    const matchItem = this.findUploadFile(flowFile);
    matchItem.status = this.uploadState.error;
    matchItem.uploadProgress = 0;
    let parsedResponse = JSON.parse(response);
    let message = parsedResponse?.error?.message;
    if (!message) {
      message = parsedResponse?.messages[0]?.text;
    }
    if (message) {
      matchItem['statusMessage'] = message;
    }
    if (!this.isMultiUploadMode) {
      this.errors = {
        api: true
      };
      if (!!this.getAPIResponse(event.response)?.error?.maxSizeFile) {
        this.errors = {
          maxSizeFile: true
        };
      }
    }
    this.execCallback(this.fileUploadConfig.onUploadError, status, statusText, this.getAPIResponse(response), matchItem.fileSelected);
  }
  setErrorState() {
    if (!this.isMultiUploadMode && Object.keys(this.errors).length) {
      let error = this.control.errors || {};
      error = _.merge(error, this.errors);
      this.control.setErrors(error);
    }
  }
  reset() {
    this.uploadFiles = [];
    this.control.setValue(null);
  }
  execCallback(callback, ...data) {
    if (typeof callback === 'function') {
      return callback(...data);
    }
  }
  getAPIResponse(data) {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.warn(`FormFileUploadComponent::getAPIResponse Can't parse API response`, error);
      return {};
    }
  }
  convertFileAsSelected(value) {
    const {
      file_id,
      name,
      size
    } = value;
    return {
      file_id: file_id,
      name: name,
      size: size
    };
  }
  setInitDownloadableFiles(value) {
    const {
      name,
      size
    } = value;
    if (typeof name === 'string' && typeof size === 'number') {
      const initValueFile = this.createUploadFile(this.uploadState.success, undefined, value, 100);
      this.uploadFiles.push(initValueFile);
    }
  }
  setFormValue(values, emitEvent = true) {
    this.control.setValue(values, {
      emitEvent: emitEvent
    });
  }
  isUploadDataReady(file, fileId) {
    const {
      name,
      size
    } = file;
    return typeof name === 'string' && typeof size === 'number' && fileId;
  }
  updateUploadFileState(status, flowFile) {
    let existingFlowFile = this.findUploadFile(flowFile);
    if (existingFlowFile) {
      existingFlowFile.status = status;
    }
  }
  createUploadFile(status, flowFile = undefined, fileSelected = undefined, progress = 0) {
    return new UploadFile({
      status: status,
      flowFile: flowFile,
      fileSelected: fileSelected,
      uploadProgress: progress
    });
  }
  addUploadFile(flowFile) {
    let data = this.createUploadFile(this.uploadState.initial, flowFile, this.convertFileAsSelected(flowFile));
    this.uploadFiles.push(data);
  }
  removeUploadFile(item) {
    const isInitItem = this.isInitValueItem(item);
    this.uploadFiles = this.uploadFiles.filter(file => {
      if (isInitItem || this.isInitValueItem(file)) {
        return !_.isEqual(file.fileSelected, item.fileSelected);
      } else {
        return file.flowFile.uniqueIdentifier !== item.flowFile.uniqueIdentifier;
      }
    });
    const newValues = this.getAllFileSelected();
    this.setFormValue(newValues);
  }
  findUploadFile(flowFile) {
    return this.uploadFiles.find(file => this.hasUniqueIdentifier(file) && file.flowFile.uniqueIdentifier === flowFile.uniqueIdentifier);
  }
  getAllFileSelected(items = this.uploadFiles) {
    return items.map(file => file.fileSelected);
  }
  cancelTransfer(item) {
    let transfer = this.transfers.find(t => this.hasUniqueIdentifier(t) && t.flowFile.uniqueIdentifier === item.uniqueIdentifier);
    if (transfer) {
      this.flow.cancelFile(transfer);
    }
  }
  hasUniqueIdentifier(file) {
    return file.flowFile?.uniqueIdentifier;
  }
  isInitValueItem(item) {
    return _.isNil(item.flowFile) || _.isEmpty(item.flowFile);
  }
  isMatchStatus(item, status) {
    return item ? [].concat(status).includes(item.status) : false;
  }
  isProgressItem(item) {
    return this.isMatchStatus(item, [this.uploadState.initial, this.uploadState.progress]);
  }
  isSuccessItem(item) {
    return this.isMatchStatus(item, this.uploadState.success);
  }
  isErrorItem(item) {
    return this.isMatchStatus(item, this.uploadState.error);
  }
  static {
    this.ɵfac = function FormFileUploadComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormFileUploadComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormFileUploadComponent,
      selectors: [["form-file-upload"]],
      viewQuery: function FormFileUploadComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$1e, 5);
          i0.ɵɵviewQuery(_c1$Z, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.flow = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileUploadWrapper = _t.first);
        }
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 13,
      vars: 2,
      consts: [["flow", "flow"], ["field", ""], ["uploadField", ""], ["uploadProcess", ""], ["uploadFile", ""], ["spinner", ""], ["fileUploadWrapper", ""], [3, "flowConfig"], ["class", "field form-file-upload", 3, "ngClass", "formGroup", 4, "ngIf"], [1, "field", "form-file-upload", 3, "ngClass", "formGroup"], ["class", "field-label", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], [4, "ngIf"], [3, "ngTemplateOutlet"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [1, "icn-error_filled"], ["type", "button", 1, "button-like", 3, "click"], ["role", "alert", "class", "form-file-custom-errors", 4, "ngFor", "ngForOf"], ["role", "alert", 1, "form-file-custom-errors"], ["aria-live", "polite", 3, "id", "ngClass"], ["type", "button", "flowButton", "", "class", "file-upload-wrapper full_width no-padding", 3, "id", "ngClass", "flowAttributes", "flow", 4, "ngIf"], ["type", "button", "flowButton", "", 1, "file-upload-wrapper", "full_width", "no-padding", 3, "id", "ngClass", "flowAttributes", "flow"], ["flowDrop", "", 1, "padding-md", "flexbox", "flex-column", "align-items-center", "text-center", 3, "dragenter", "dragover", "dragleave", "drop", "flow"], [1, "icn-cloud_upload", "file-upload-icon", "icon-md", "flexbox", "align-items-center", "justified-content-center", "space-bottom-sm"], [1, "file-upload-text", "space-bottom-xs", 3, "innerHTML"], ["class", "file-upload-blurb body-small font_weight_light secondary-text", 4, "ngIf"], [1, "file-upload-blurb", "body-small", "font_weight_light", "secondary-text"], [1, "file-uploading-wrapper", "padding-md", "flexbox", "flex-column", "align-items-center", "text-center"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "file-upload-text", "space-bottom-xs", "text-truncate", "full_width"], ["type", "button", 1, "button-like", "body-small", "font_weight_light", 3, "click"], ["class", "file-list-label", 3, "id", 4, "ngIf"], ["class", "m-0", 4, "ngIf"], [1, "file-list-label", 3, "id"], ["class", "file-selected-wrapper flexbox", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "file-selected-wrapper", "flexbox", 3, "ngClass"], ["type", "button", 1, "right-action", "flexbox", "flex-grow-1", 3, "click"], [1, "file-information", "padding-sm"], [1, "file-name", "block", "text-truncate", "text-left", "font_weight_light"], [1, "icon-wrapper", "flexbox", "justified-content-center", "align-items-center", "file"], [1, "icn-file", "icon-md", "text-gray"], [1, "icon-wrapper", "flexbox", "justified-content-center", "align-items-center", "download"], [1, "icn-file_download", "icon-md"], [1, "icon-wrapper", "flexbox", "justified-content-center", "align-items-center", "error"], [1, "icn-error", "icon-md"], [1, "text-error", "text-truncate", "text-left", "font_weight_light"], [1, "file-description", "text-uppercase", "flexbox", "align-items-center", "xs-text"], [1, "dot-separator", "space-right-sm", "space-left-sm"], [1, "left-action"], ["type", "button", 1, "left-action", 3, "click"], [1, "icon-wrapper", "flexbox", "justified-content-center", "align-items-center"], [1, "icn-delete", "icon-md", "text-gray"], [1, "sr-only"], [1, "m-0"], [1, "file-upload-icon", "flexbox", "align-items-center", "justified-content-center", 3, "ngClass"], ["mode", "determinate", 3, "strokeWidth", "radius", "progress"]],
      template: function FormFileUploadComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementContainer(0, 7, 0);
          i0.ɵɵtemplate(2, FormFileUploadComponent_div_2_Template, 7, 10, "div", 8)(3, FormFileUploadComponent_ng_template_3_Template, 4, 8, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, FormFileUploadComponent_ng_template_5_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(7, FormFileUploadComponent_ng_template_7_Template, 8, 11, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(9, FormFileUploadComponent_ng_template_9_Template, 3, 3, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(11, FormFileUploadComponent_ng_template_11_Template, 2, 4, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("flowConfig", ctx.flowConfig);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.FormGroupDirective, ProgressSpinnerComponent, i5.ButtonDirective, i5.DropDirective, i5.FlowDirective, i1$1.TranslatePipe, FileSizePipe, FileExtensionPipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFileUploadComponent, [{
    type: Component,
    args: [{
      selector: 'form-file-upload',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<ng-container #flow=\"flow\" [flowConfig]=\"flowConfig\"></ng-container>\n\n<div \n    *ngIf=\"!config.hideField\" \n    class=\"field form-file-upload\" \n    [ngClass]=\"{\n        'field-error': !control.valid && (control.dirty || control.touched) && !this.uploadFiles.length && !isProgressItem(this.firstItem) && !isSuccessItem(this.firstItem),\n        'last': config.lastChild\n    }\"\n    [formGroup]=\"group\"\n>\n\n    <div *ngIf=\"!config.hideLabel\" class=\"field-label\">\n        <label for=\"{{ config.elementId }}{{ modal ? '_modal-container' : '_container' }}\">\n            {{ config.label | translate }}\n            <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n        </label>\n    </div>\n\n    <div class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" class=\"blurb field-blurb\" [id]=\"describedByValue\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div *ngIf=\"(!control.valid && (control.dirty || control.touched) && !fileUploadConfig.customErrors)\" role=\"alert\">\n            <ng-container *ngIf=\"!this.uploadFiles.length && !isProgressItem(this.firstItem) && !isSuccessItem(this.firstItem)\">\n                <i class=\"icn-error_filled\"></i>\n\n                <span *ngIf=\"control.errors.required\">\n                    {{ 'misc.Field is required' | translate: { field_name: translatedLabel } }}\n                </span>\n\n                <ng-container *ngIf=\"!isMultiUploadMode\">\n                    <span *ngIf=\"control.errors.maxFileSize\">\n                        {{ 'misc.Upload Failed - Too big' | translate }}\n                    </span>\n\n                    <span *ngIf=\"control.errors.api\">\n                    {{ 'misc.Upload Failed' | translate }} -\n                        <button type=\"button\" class=\"button-like\" (click)=\"retryUpload()\">{{ 'misc.Try again' | translate }}</button>\n                    </span>\n                </ng-container>\n            </ng-container>\n        </div>\n        <ng-container *ngIf=\"fileUploadConfig.customErrors?.length\">\n            <div *ngFor=\"let errorMsg of fileUploadConfig.customErrors\" role=\"alert\" class=\"form-file-custom-errors\">\n                <i class=\"icn-error_filled\"></i>\n                <span>\n                    {{errorMsg}}\n                </span>\n            </div>\n        </ng-container>\n\n        <ng-template [ngTemplateOutlet]=\"field\"></ng-template>\n    </div>\n</div>\n\n<ng-template #field>\n    <div [id]=\"config.elementId\" [attr.aria-describedby]=\"describedByValue\" aria-live=\"polite\" [ngClass]=\"{ 'file-upload-multiple': isMultiUploadMode }\">\n        <ng-container *ngIf=\"!isMultiUploadMode\">\n            <ng-template *ngIf=\"!this.uploadFiles?.length || isErrorItem(this.firstItem)\" [ngTemplateOutlet]=\"uploadField\"></ng-template>\n            <ng-template *ngIf=\"this.uploadFiles.length && isProgressItem(this.firstItem)\" [ngTemplateOutlet]=\"uploadProcess\"></ng-template>\n        </ng-container>\n\n        <ng-container *ngIf=\"isMultiUploadMode\">\n            <ng-template [ngTemplateOutlet]=\"uploadField\"></ng-template>\n        </ng-container>\n\n        <ng-template\n                *ngIf=\"isMultiUploadMode || isSuccessItem(this.firstItem)\"\n                [ngTemplateOutlet]=\"uploadFile\">\n        </ng-template>\n        \n    </div>\n</ng-template>\n\n<ng-template #uploadField>\n    <button\n            type=\"button\"\n            id=\"{{ config.elementId }}{{ modal ? '_modal-container' : '_container' }}\"\n            *ngIf=\"!config.readOnly\"\n            #fileUploadWrapper\n            flowButton\n            class=\"file-upload-wrapper full_width no-padding\"\n            [ngClass]=\"{ 'drag-active': dragActive }\"\n            [flowAttributes]=\"flowAttributes\"\n            [flow]=\"flow.flowJs\"\n    >\n            <span\n                    flowDrop\n                    class=\"padding-md flexbox flex-column align-items-center text-center\"\n                    [flow]=\"flow.flowJs\"\n                    (dragenter)=\"onDragEnter()\"\n                    (dragover)=\"onDragOver()\"\n                    (dragleave)=\"onDragLeave()\"\n                    (drop)=\"onDrop()\"\n            >\n                <i class=\"icn-cloud_upload file-upload-icon icon-md flexbox align-items-center justified-content-center space-bottom-sm\"></i>\n                \n                <span class=\"file-upload-text space-bottom-xs\" [innerHTML]=\"fileUploadText\"></span>\n    \n                <span *ngIf=\"fileUploadConfig.maxFileSize\" class=\"file-upload-blurb body-small font_weight_light secondary-text\">\n                    {{ 'misc.Max file size:' | translate }}&nbsp;{{ fileUploadConfig.maxFileSize | fileSize }}\n                </span>\n            </span>\n    </button>\n</ng-template>\n\n<ng-template #uploadProcess>\n    <div class=\"file-uploading-wrapper padding-md flexbox flex-column align-items-center text-center\">\n        \n        <ng-template [ngTemplateOutlet]=\"spinner\" [ngTemplateOutletContext]=\"{'item': this.firstItem, 'isItem': false}\"></ng-template>\n\n        <p class=\"file-upload-text space-bottom-xs text-truncate full_width\">\n            {{ 'misc.Uploading' | translate }} {{ this.firstItem?.fileSelected.name }}\n        </p>\n\n        <button type=\"button\" class=\"button-like body-small font_weight_light\" (click)=\"cancelUpload(this.firstItem)\">\n            {{ 'misc.Cancel' | translate }}\n        </button>\n    </div>\n</ng-template>\n\n<ng-template #uploadFile>\n    <div \n        *ngIf=\"uploadFiles.length && isMultiUploadMode && !config.readOnly\"\n        class=\"file-list-label\"\n        [id]=\"elementId + '_list_label'\"\n    >\n        {{ 'misc.Files' | translate }}\n    </div>\n\n    <ul *ngIf=\"uploadFiles.length\" [attr.aria-labelledby]=\"isMultiUploadMode && !config.readOnly ? elementId + '_list_label' : null\">\n        <li\n            *ngFor=\"let item of uploadFiles; index as idx\"\n            class=\"file-selected-wrapper flexbox\"\n            [ngClass]=\"{\n                'uploading': isProgressItem(item),\n                'error-state': isErrorItem(item)\n            }\"\n        >\n            <button type=\"button\"\n                    class=\"right-action flexbox flex-grow-1\"\n                    (click)=\"downloadFile(item)\"\n                    [attr.aria-disabled]=\"!isSuccessItem(item)\"\n            >\n\n                <ng-container *ngIf=\"!isErrorItem(item)\">\n                    <span class=\"icon-wrapper flexbox justified-content-center align-items-center file\">\n                        <i class=\"icn-file icon-md text-gray\"></i>\n                    </span>\n                </ng-container>\n\n                <ng-container *ngIf=\"isSuccessItem(item)\">\n                    <span class=\"icon-wrapper flexbox justified-content-center align-items-center download\">\n                        <i class=\"icn-file_download icon-md\"></i>\n                    </span>\n                </ng-container>\n\n                <ng-container *ngIf=\"isErrorItem(item)\">\n                    <span class=\"icon-wrapper flexbox justified-content-center align-items-center error\">\n                        <i class=\"icn-error icon-md\"></i>\n                    </span>\n                </ng-container>\n\n                <span class=\"file-information padding-sm\">\n            \n                    <ng-container *ngIf=\"isErrorItem(item)\">\n                        <div class=\"text-error text-truncate text-left font_weight_light\">\n                            {{ 'misc.Upload Failed' | translate }}\n                            <ng-container *ngIf=\"item.statusMessage\">\n                                - {{ item.statusMessage }}\n                            </ng-container>\n                        </div>\n                    </ng-container>\n                    \n                    <span class=\"file-name block text-truncate text-left font_weight_light\">\n                        {{ item?.fileSelected.name }}\n                    </span>\n                    \n                    <ng-container *ngIf=\"!isErrorItem(item)\">\n                        <span class=\"file-description text-uppercase flexbox align-items-center xs-text\">\n                            {{ item?.fileSelected.name | fileExtension }}\n                            <i class=\"dot-separator space-right-sm space-left-sm\"></i>\n                            {{ item?.fileSelected.size | fileSize }}\n                        </span>\n                    </ng-container>\n                    \n                </span>\n            </button>\n\n            <ng-container *ngIf=\"!config.readOnly && !isErrorItem(item)\">\n                <ng-container *ngIf=\"isMultiUploadMode && isProgressItem(item)\">\n                    <div class=\"left-action\">\n                        <ng-template [ngTemplateOutlet]=\"spinner\" [ngTemplateOutletContext]=\"{item: item, isItem: true}\"></ng-template>\n                    </div>\n                </ng-container>\n\n                <ng-container *ngIf=\"!config.hideDeleteButton && (!isMultiUploadMode || (isMultiUploadMode && isSuccessItem(item)))\">\n                    <button type=\"button\" class=\"left-action\" (click)=\"deleteFile(item)\">\n                        <span class=\"icon-wrapper flexbox justified-content-center align-items-center\">\n                            <i class=\"icn-delete icon-md text-gray\"></i>\n                            <span class=\"sr-only\">{{ 'misc.delete file' | translate }}</span>\n                        </span>\n                    </button>\n                </ng-container>\n            </ng-container>\n            \n        </li>\n    </ul>\n\n    <p *ngIf=\"!uploadFiles.length && config.readOnly && fileUploadConfig.emptyFileListMessage\" class=\"m-0\">\n        {{ fileUploadConfig.emptyFileListMessage | translate }}\n    </p>\n</ng-template>\n\n<ng-template #spinner let-item=\"item\" let-isItem=\"isItem\">\n    <span class=\"file-upload-icon flexbox align-items-center justified-content-center\" [ngClass]=\"isItem ? 'icon-wrapper' : 'space-bottom-sm'\">\n        <progress-spinner mode=\"determinate\" [strokeWidth]=\"2\" [radius]=\"7\" [progress]=\"item.uploadProgress\"></progress-spinner>\n    </span>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: i0.ChangeDetectorRef
  }], {
    flow: [{
      type: ViewChild,
      args: ['flow', {
        static: false
      }]
    }],
    fileUploadWrapper: [{
      type: ViewChild,
      args: ['fileUploadWrapper', {
        static: false
      }]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormFileUploadComponent, {
    className: "FormFileUploadComponent",
    filePath: "dynamic-form/components/form-file-upload/form-file-upload.component.ts",
    lineNumber: 21
  });
})();
const _c0$1d = (a0, a1) => ({
  "field-error": a0,
  "space-bottom-sm": a1
});
const _c1$Y = a0 => ({
  "field-error": a0
});
const _c2$K = a0 => ({
  field_name: a0
});
const _c3$v = (a0, a1) => ({
  width: a0,
  height: a1
});
const _c4$q = a0 => ({
  "drag-active": a0
});
const _c5$h = a0 => ({
  "item": a0,
  "isItem": false
});
function FormImageUploadComponent_div_3_div_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 20);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormImageUploadComponent_div_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "label", 18);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, FormImageUploadComponent_div_3_div_1_i_4_Template, 2, 0, "i", 19);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
  }
}
function FormImageUploadComponent_div_3_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 21);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$Y, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched)))("id", ctx_r0.describedByValue)("innerHTML", i0.ɵɵpipeBind1(2, 5, i0.ɵɵpipeBind1(1, 3, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormImageUploadComponent_div_3_div_4_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c2$K, ctx_r0.translatedLabel)), " ");
  }
}
function FormImageUploadComponent_div_3_div_4_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "misc.Upload Failed - Too big"), " ");
  }
}
function FormImageUploadComponent_div_3_div_4_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "misc.Upload Failed"), " - ", i0.ɵɵpipeBind1(3, 4, "misc.Try again"), " ");
  }
}
function FormImageUploadComponent_div_3_div_4_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Minimum size for upload is {width} x {height}. Please use a larger image.", i0.ɵɵpureFunction2(4, _c3$v, ctx_r0.minWidth + "px", ctx_r0.minHeight + "px")), " ");
  }
}
function FormImageUploadComponent_div_3_div_4_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "misc.This file is corrupt, try again"), " ");
  }
}
function FormImageUploadComponent_div_3_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelement(1, "i", 23);
    i0.ɵɵtemplate(2, FormImageUploadComponent_div_3_div_4_span_2_Template, 3, 6, "span", 9);
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵtemplate(4, FormImageUploadComponent_div_3_div_4_span_4_Template, 3, 3, "span", 9)(5, FormImageUploadComponent_div_3_div_4_span_5_Template, 4, 6, "span", 9)(6, FormImageUploadComponent_div_3_div_4_span_6_Template, 3, 7, "span", 9)(7, FormImageUploadComponent_div_3_div_4_span_7_Template, 3, 3, "span", 9);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.maxSizeFile);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.api);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.minimumDimensionRequired);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.readError);
  }
}
function FormImageUploadComponent_div_3_div_5_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const errorMsg_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", errorMsg_r2, " ");
  }
}
function FormImageUploadComponent_div_3_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, FormImageUploadComponent_div_3_div_5_span_1_Template, 2, 1, "span", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.fileUploadConfig.customErrors);
  }
}
function FormImageUploadComponent_div_3_ng_template_7_Template(rf, ctx) {}
function FormImageUploadComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, FormImageUploadComponent_div_3_div_1_Template, 5, 7, "div", 11);
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵtemplate(3, FormImageUploadComponent_div_3_div_3_Template, 3, 9, "div", 13)(4, FormImageUploadComponent_div_3_div_4_Template, 8, 5, "div", 14)(5, FormImageUploadComponent_div_3_div_5_Template, 2, 1, "div", 15);
    i0.ɵɵelementContainerStart(6);
    i0.ɵɵtemplate(7, FormImageUploadComponent_div_3_ng_template_7_Template, 0, 0, "ng-template", 16);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const field_r3 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$1d, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.imageLoaded))("formGroup", ctx_r0.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched) && !ctx_r0.fileUploadConfig.customErrors);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fileUploadConfig.customErrors == null ? null : ctx_r0.fileUploadConfig.customErrors.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", field_r3);
  }
}
function FormImageUploadComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "image-crop", 26);
    i0.ɵɵlistener("onCropped", function FormImageUploadComponent_ng_container_4_Template_image_crop_onCropped_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.setCroppedImage($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("url", ctx_r0.currentImage)("roundCorners", ctx_r0.config.rounded);
  }
}
function FormImageUploadComponent_ng_template_5_ng_container_1_1_ng_template_0_Template(rf, ctx) {}
function FormImageUploadComponent_ng_template_5_ng_container_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormImageUploadComponent_ng_template_5_ng_container_1_1_ng_template_0_Template, 0, 0, "ng-template", 16);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const uploadField_r5 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", uploadField_r5);
  }
}
function FormImageUploadComponent_ng_template_5_ng_container_1_2_ng_template_0_Template(rf, ctx) {}
function FormImageUploadComponent_ng_template_5_ng_container_1_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormImageUploadComponent_ng_template_5_ng_container_1_2_ng_template_0_Template, 0, 0, "ng-template", 16);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const uploadProcess_r6 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", uploadProcess_r6);
  }
}
function FormImageUploadComponent_ng_template_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormImageUploadComponent_ng_template_5_ng_container_1_1_Template, 1, 1, null, 9)(2, FormImageUploadComponent_ng_template_5_ng_container_1_2_Template, 1, 1, null, 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.uploadFiles == null ? null : ctx_r0.uploadFiles.length) || ctx_r0.isErrorItem(ctx_r0.firstItem));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.uploadFiles.length && ctx_r0.isProgressItem(ctx_r0.firstItem));
  }
}
function FormImageUploadComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, FormImageUploadComponent_ng_template_5_ng_container_1_Template, 3, 2, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.imageLoaded);
  }
}
function FormImageUploadComponent_ng_template_7_button_0_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "fileSize");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "misc.Max file size:"), "\u00A0", i0.ɵɵpipeBind1(3, 4, ctx_r0.fileUploadConfig.maxFileSize), " ");
  }
}
function FormImageUploadComponent_ng_template_7_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29, 5)(2, "span", 30);
    i0.ɵɵlistener("dragenter", function FormImageUploadComponent_ng_template_7_button_0_Template_span_dragenter_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragEnter());
    })("dragover", function FormImageUploadComponent_ng_template_7_button_0_Template_span_dragover_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragOver());
    })("dragleave", function FormImageUploadComponent_ng_template_7_button_0_Template_span_dragleave_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragLeave());
    })("drop", function FormImageUploadComponent_ng_template_7_button_0_Template_span_drop_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDrop());
    });
    i0.ɵɵelement(3, "i", 31)(4, "span", 32);
    i0.ɵɵtemplate(5, FormImageUploadComponent_ng_template_7_button_0_span_5_Template, 4, 6, "span", 33);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const flow_r8 = i0.ɵɵreference(2);
    i0.ɵɵproperty("flowAttributes", ctx_r0.flowAttributes)("flow", flow_r8.flowJs)("ngClass", i0.ɵɵpureFunction1(6, _c4$q, ctx_r0.dragActive));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("flow", flow_r8.flowJs);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.fileUploadText, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fileUploadConfig.maxFileSize);
  }
}
function FormImageUploadComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormImageUploadComponent_ng_template_7_button_0_Template, 6, 8, "button", 28);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.readOnly);
  }
}
function FormImageUploadComponent_ng_template_9_ng_template_1_Template(rf, ctx) {}
function FormImageUploadComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, FormImageUploadComponent_ng_template_9_ng_template_1_Template, 0, 0, "ng-template", 36);
    i0.ɵɵelementStart(2, "p", 37);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 38);
    i0.ɵɵlistener("click", function FormImageUploadComponent_ng_template_9_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.cancelUpload(ctx_r0.firstItem));
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const spinner_r10 = i0.ɵɵreference(12);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", spinner_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c5$h, ctx_r0.firstItem));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(4, 5, "misc.Uploading"), " ", ctx_r0.firstItem == null ? null : ctx_r0.firstItem.fileSelected.name, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 7, "misc.Cancel"), " ");
  }
}
function FormImageUploadComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 39);
    i0.ɵɵelement(1, "progress-spinner", 40);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r11 = ctx.item;
    const isItem_r12 = ctx.isItem;
    i0.ɵɵproperty("ngClass", isItem_r12 ? "icon-wrapper" : "space-bottom-sm");
    i0.ɵɵadvance();
    i0.ɵɵproperty("strokeWidth", 2)("radius", 7)("progress", item_r11.uploadProgress);
  }
}
class FormImageUploadComponent extends FormFileUploadComponent {
  constructor(translate, changeDetectorRef, http) {
    super(translate, changeDetectorRef);
    this.translate = translate;
    this.changeDetectorRef = changeDetectorRef;
    this.http = http;
    this.imageLoaded = false;
    this.coverImage = {};
    this.coverImageSmall = {};
  }
  ngAfterViewInit() {
    this.minHeight = this.config.minHeight || 256;
    this.minWidth = this.config.minWidth || 256;
    super.ngAfterViewInit();
    this.setInitialValue();
  }
  setInitialValue() {
    setTimeout(() => {
      if (this.config.value) {
        this.control.setValue([this.config.value]);
        this.control.updateValueAndValidity();
        this.createDataUrl(this.config.value);
        this.imageLoaded = true;
      }
    });
  }
  onFileAdded(event) {
    super.onFileAdded(event);
    this.imageEvent = event;
  }
  onFileError(event) {
    this.imageLoaded = false;
    super.onFileError(event);
  }
  onFileSubmitted(event) {
    if (this.group.valid) {
      this.readImageFile(event, this.imageEvent);
    } else {
      this.cropper.loadImageFailed();
    }
  }
  onComplete(event) {
    super.onComplete(event);
    setTimeout(() => {
      this.control.setValue([{
        ...this.control.value[0],
        originalImage: this.imageData
      }]);
      this.imageLoaded = true;
    }, 50);
  }
  readImageFile(orignalEvent, event) {
    const flowFile = event.event[0];
    let reader = new FileReader();
    reader.onload = ev => {
      if (flowFile.file.type.includes('image/') && ev.target?.result instanceof ArrayBuffer) {
        let binary = '',
          bytes = new Uint8Array(ev.target?.result),
          len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        let data = btoa(binary);
        this.fileType = flowFile.file.type;
        this.fileName = flowFile.file.name;
        let image = new Image();
        image.src = this.temp_current_image = 'data:' + flowFile.file.type + ';base64,' + data;
        this.currentImage = this.temp_current_image;
        let control = this.control;
        image.onload = () => {
          if (image.height < this.minHeight || image.width < this.minWidth) {
            flowFile.cancel();
            this.reset();
            this.imageLoaded = false;
            control.markAsTouched();
            control.setErrors({
              minimumDimensionRequired: true
            });
            return;
          } else {
            super.onFileSubmitted(orignalEvent);
            this.currentImage = image.src;
            this.imageData = {
              data: data,
              user_file_name: flowFile.file.name,
              filetype: flowFile.file.type
            };
          }
        };
      } else {
        this.control.setErrors({
          readError: true
        });
        this.control.updateValueAndValidity();
      }
    };
    reader.onerror = type => {
      flowFile.cancel();
    };
    reader.readAsArrayBuffer(flowFile.file);
  }
  setCroppedImage(dataUrl) {
    let imageObject = this.control.value[0];
    let cropped = dataUrl.replace(/^data\:([^\;]+)\;base64,/gmi, '');
    let data = {
      data: cropped,
      filetype: 'image/png',
      objURL: 'data:' + this.getFileType(dataUrl) + ';base64,' + cropped,
      user_file_name: imageObject.name || imageObject.user_file_name
    };
    imageObject.croppedImage = data;
    this.control.setValue([imageObject]);
    this.control.updateValueAndValidity();
  }
  createDataUrl(data) {
    const url = `/utils/view.php?id=${data.file_id}&inline=true`;
    this.http.get(url, {
      responseType: 'arraybuffer'
    }).pipe(map(resp => {
      if (!resp) {
        return;
      }
      let binary = '';
      let bytes = new Uint8Array(resp);
      let len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return 'data:image/jpeg;base64,' + btoa(binary);
    })).subscribe(value => {
      this.currentImage = value;
    });
  }
  getFileType(url) {
    const parts = url.split(':');
    const format = parts[1].split(';')[0];
    return format;
  }
  static {
    this.ɵfac = function FormImageUploadComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormImageUploadComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.HttpClient));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormImageUploadComponent,
      selectors: [["form-image-upload"]],
      viewQuery: function FormImageUploadComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(ImageCropComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cropper = _t.first);
        }
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 13,
      vars: 4,
      consts: [["flow", "flow"], ["field", ""], ["uploadField", ""], ["uploadProcess", ""], ["spinner", ""], ["fileUploadWrapper", ""], [1, "flexbox", "flex-column", 3, "ngClass"], [3, "flowConfig"], ["class", "field form-file-upload no-margin", 3, "ngClass", "formGroup", 4, "ngIf"], [4, "ngIf"], [1, "field", "form-file-upload", "no-margin", 3, "ngClass", "formGroup"], ["class", "field-label", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "ngClass", "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], ["role", "alert", "class", "form-file-custom-errors", 4, "ngIf"], [3, "ngTemplateOutlet"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "ngClass", "id", "innerHTML"], ["role", "alert"], [1, "icn-error_filled"], ["role", "alert", 1, "form-file-custom-errors"], [4, "ngFor", "ngForOf"], [3, "onCropped", "url", "roundCorners"], ["aria-live", "polite"], ["type", "button", "flowButton", "", "class", "file-upload-wrapper full_width no-padding", "style", "height: 250px", 3, "flowAttributes", "flow", "ngClass", 4, "ngIf"], ["type", "button", "flowButton", "", 1, "file-upload-wrapper", "full_width", "no-padding", 2, "height", "250px", 3, "flowAttributes", "flow", "ngClass"], ["flowDrop", "", 1, "padding-md", "flexbox", "flex-column", "align-items-center", "text-center", 3, "dragenter", "dragover", "dragleave", "drop", "flow"], [1, "icn-cloud_upload", "file-upload-icon", "icon-md", "flexbox", "align-items-center", "justified-content-center", "space-bottom-sm"], [1, "file-upload-text", "space-bottom-xs", 3, "innerHTML"], ["class", "file-upload-blurb body-small font_weight_light secondary-text", 4, "ngIf"], [1, "file-upload-blurb", "body-small", "font_weight_light", "secondary-text"], [1, "file-uploading-wrapper", "padding-md", "flexbox", "flex-column", "align-items-center", "text-center"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "file-upload-text", "space-bottom-xs", "text-truncate", "full_width"], ["type", "button", 1, "button-like", "body-small", "font_weight_light", 3, "click"], [1, "file-upload-icon", "flexbox", "align-items-center", "justified-content-center", 3, "ngClass"], ["mode", "determinate", 3, "strokeWidth", "radius", "progress"]],
      template: function FormImageUploadComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 6);
          i0.ɵɵelementContainer(1, 7, 0);
          i0.ɵɵtemplate(3, FormImageUploadComponent_div_3_Template, 8, 10, "div", 8)(4, FormImageUploadComponent_ng_container_4_Template, 2, 2, "ng-container", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, FormImageUploadComponent_ng_template_5_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(7, FormImageUploadComponent_ng_template_7_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(9, FormImageUploadComponent_ng_template_9_Template, 8, 11, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(11, FormImageUploadComponent_ng_template_11_Template, 2, 4, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.config.styleClasses);
          i0.ɵɵadvance();
          i0.ɵɵproperty("flowConfig", ctx.flowConfig);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.imageLoaded);
        }
      },
      dependencies: [i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.FormGroupDirective, ProgressSpinnerComponent, ImageCropComponent, i5.ButtonDirective, i5.DropDirective, i5.FlowDirective, i1$1.TranslatePipe, FileSizePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormImageUploadComponent, [{
    type: Component,
    args: [{
      selector: 'form-image-upload',
      standalone: false,
      template: "<div class=\"flexbox flex-column\" [ngClass]=\"config.styleClasses\">\n  <ng-container #flow=\"flow\" [flowConfig]=\"flowConfig\"></ng-container>\n  <div\n          *ngIf=\"!config.hideField\"\n          class=\"field form-file-upload no-margin\"\n          [ngClass]=\"{\n            'field-error': !control.valid && (control.dirty || control.touched),\n            'space-bottom-sm': imageLoaded}\"\n          [formGroup]=\"group\">\n    <div *ngIf=\"!config.hideLabel\" class=\"field-label\">\n      <label for=\"{{ config.elementId }}{{ modal ? 'modal' : '' }}\">\n        {{ config.label | translate }}\n        <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n      </label>\n    </div>\n    <div class=\"field-widget\">\n      <div\n              *ngIf=\"config.blurb\"\n              class=\"blurb field-blurb\"\n              [ngClass]=\"{\n        'field-error': !control.valid && (control.dirty || control.touched)}\"\n              [id]=\"describedByValue\"\n              [innerHTML]=\"config.blurb | translate | safeHtml\">\n      </div>\n      <div\n        *ngIf=\"(!control.valid && (control.dirty || control.touched) && !fileUploadConfig.customErrors)\"\n        role=\"alert\">\n        <i class=\"icn-error_filled\"></i>\n        <span *ngIf=\"control.errors.required\">\n          {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n        </span>\n        <ng-container>\n          <span *ngIf=\"control.errors.maxSizeFile\">\n            {{ 'misc.Upload Failed - Too big' | translate }}\n          </span>\n          <span *ngIf=\"control.errors.api\">\n            {{ 'misc.Upload Failed' | translate }} -\n            {{ 'misc.Try again' | translate }}\n          </span>\n          <span *ngIf=\"control.errors.minimumDimensionRequired\">\n            {{'misc.Minimum size for upload is {width} x {height}. Please use a larger image.' | translate: {width: (minWidth + 'px'), height: (minHeight + 'px')} }}\n          </span>\n          <span *ngIf=\"control.errors.readError\">\n            {{'misc.This file is corrupt, try again' | translate }}\n          </span>\n        </ng-container>\n      </div>\n      <div\n        *ngIf=\"fileUploadConfig.customErrors?.length\"\n        role=\"alert\"\n        class=\"form-file-custom-errors\">\n        <span *ngFor=\"let errorMsg of fileUploadConfig.customErrors\">\n          {{errorMsg}}\n        </span>\n      </div>\n      <ng-container>\n        <ng-template [ngTemplateOutlet]=\"field\"></ng-template>\n      </ng-container>\n    </div>\n  </div>\n  <ng-container *ngIf=\"imageLoaded\">\n    <image-crop [url]=\"currentImage\" (onCropped)=\"setCroppedImage($event)\" [roundCorners]=\"config.rounded\"></image-crop>\n  </ng-container>\n</div>\n<ng-template #field>\n  <div\n    [attr.aria-describedby]=\"describedByValue\"\n    aria-live=\"polite\">\n    <ng-container *ngIf=\"!imageLoaded\">\n      <ng-template *ngIf=\"!this.uploadFiles?.length || isErrorItem(this.firstItem)\" [ngTemplateOutlet]=\"uploadField\"></ng-template>\n      <ng-template *ngIf=\"this.uploadFiles.length && isProgressItem(this.firstItem)\" [ngTemplateOutlet]=\"uploadProcess\"></ng-template>\n    </ng-container>\n  </div>\n</ng-template>\n<ng-template #uploadField>\n  <button\n          type=\"button\"\n          *ngIf=\"!config.readOnly\"\n          #fileUploadWrapper\n          flowButton\n          [flowAttributes]=\"flowAttributes\"\n          [flow]=\"flow.flowJs\"\n          class=\"file-upload-wrapper full_width no-padding\"\n          style=\"height: 250px\"\n          [ngClass]=\"{ 'drag-active': dragActive }\">\n    <span\n            flowDrop\n            class=\"padding-md flexbox flex-column align-items-center text-center\"\n            [flow]=\"flow.flowJs\"\n            (dragenter)=\"onDragEnter()\"\n            (dragover)=\"onDragOver()\"\n            (dragleave)=\"onDragLeave()\"\n            (drop)=\"onDrop()\"\n    >\n      <i\n              class=\"icn-cloud_upload file-upload-icon icon-md flexbox align-items-center justified-content-center space-bottom-sm\"\n      ></i>\n\n      <span\n              class=\"file-upload-text space-bottom-xs\"\n              [innerHTML]=\"fileUploadText\"\n      ></span>\n\n      <span *ngIf=\"fileUploadConfig.maxFileSize\" class=\"file-upload-blurb body-small font_weight_light secondary-text\">\n        {{ 'misc.Max file size:' | translate}}&nbsp;{{ fileUploadConfig.maxFileSize | fileSize }}\n      </span>\n    </span>\n  </button>\n</ng-template>\n\n<ng-template #uploadProcess>\n  <div class=\"file-uploading-wrapper padding-md flexbox flex-column align-items-center text-center\">\n    <ng-template [ngTemplateOutlet]=\"spinner\" [ngTemplateOutletContext]=\"{'item': this.firstItem, 'isItem': false}\"></ng-template>\n    <p class=\"file-upload-text space-bottom-xs text-truncate full_width\">\n      {{ 'misc.Uploading' | translate }} {{ this.firstItem?.fileSelected.name }}\n    </p>\n    <button\n            type=\"button\"\n            class=\"button-like body-small font_weight_light\"\n            (click)=\"cancelUpload(this.firstItem)\">\n      {{ 'misc.Cancel' | translate }}\n    </button>\n  </div>\n</ng-template>\n\n<ng-template #spinner let-item=\"item\" let-isItem=\"isItem\">\n  <span\n    class=\"file-upload-icon flexbox align-items-center justified-content-center\"\n    [ngClass]=\"isItem ? 'icon-wrapper' : 'space-bottom-sm'\"\n  >\n    <progress-spinner\n            mode=\"determinate\"\n            [strokeWidth]=\"2\"\n            [radius]=\"7\"\n            [progress]=\"item.uploadProgress\"\n    ></progress-spinner>\n  </span>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i2.HttpClient
  }], {
    cropper: [{
      type: ViewChild,
      args: [ImageCropComponent]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormImageUploadComponent, {
    className: "FormImageUploadComponent",
    filePath: "dynamic-form/components/form-image-upload/form-image-upload.component.ts",
    lineNumber: 21
  });
})();
class PicklistValue {
  constructor(id = '', value = '', disabled = false, children = []) {
    this.id = id;
    this.value = value;
    this.disabled = disabled;
    this.children = children;
    this.id = id.toString();
  }
  get display() {
    return this.value;
  }
}
const _c0$1c = ["customItemTemplate"];
const _c1$X = ["chipListElm"];
const _c2$J = (a0, a1, a2) => ({
  "is-invalid field-error": a0,
  "last": a1,
  "mb-4": a2
});
const _c3$u = a0 => ({
  "visually-hidden": a0
});
const _c4$p = a0 => ({
  field_name: a0
});
const _c5$g = a0 => ({
  "chip-highlight": a0
});
const _c6$c = a0 => ({
  item: a0
});
function FormACLookupComponent_div_0_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 20);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormACLookupComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelement(1, "span", 22);
    i0.ɵɵelementStart(2, "span", 23);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.config.warningMessage);
  }
}
function FormACLookupComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "span", 25);
    i0.ɵɵelementStart(2, "span", 23);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.config.ai_flag_text);
  }
}
function FormACLookupComponent_div_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormACLookupComponent_div_0_div_10_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c4$p, ctx_r1.translatedLabel)), " ");
  }
}
function FormACLookupComponent_div_0_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, FormACLookupComponent_div_0_div_10_div_1_Template, 4, 6, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.config.showFieldError ? "field-error" : "invalid-feedback");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.required);
  }
}
function FormACLookupComponent_div_0_ng_container_12_ng_container_4_li_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 32);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("keydown", function FormACLookupComponent_div_0_ng_container_12_ng_container_4_li_2_Template_li_keydown_0_listener($event) {
      const ctx_r3 = i0.ɵɵrestoreView(_r3);
      const selection_r5 = ctx_r3.$implicit;
      const i_r6 = ctx_r3.index;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.chipNav($event, selection_r5, i_r6));
    });
    i0.ɵɵelementStart(2, "span", 33);
    i0.ɵɵtext(3);
    i0.ɵɵelementStart(4, "button", 34);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵlistener("click", function FormACLookupComponent_div_0_ng_container_12_ng_container_4_li_2_Template_button_click_4_listener() {
      const selection_r5 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.removeChip(selection_r5));
    });
    i0.ɵɵelement(6, "i", 35);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const selection_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    const isLast_r7 = ctx.last;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c5$g, isLast_r7));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 7, "misc.Item - Remove", i0.ɵɵpureFunction1(15, _c6$c, selection_r5[ctx_r1.optionField])))("aria-setsize", ctx_r1.control.value.length)("aria-posinset", i_r6 + 1)("tabindex", ctx_r1.getChipTabIndex(i_r6));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", selection_r5[ctx_r1.optionField], " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(5, 10, "misc.Item - Remove", i0.ɵɵpureFunction1(17, _c6$c, selection_r5[ctx_r1.optionField])));
  }
}
function FormACLookupComponent_div_0_ng_container_12_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 30);
    i0.ɵɵtemplate(2, FormACLookupComponent_div_0_ng_container_12_ng_container_4_li_2_Template, 7, 19, "li", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.control.value);
  }
}
function FormACLookupComponent_div_0_ng_container_12_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 36);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("keydown", function FormACLookupComponent_div_0_ng_container_12_ng_container_5_Template_span_keydown_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.removeChip(ctx_r1.control.value));
    });
    i0.ɵɵelementStart(3, "span", 37);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 38);
    i0.ɵɵlistener("click", function FormACLookupComponent_div_0_ng_container_12_ng_container_5_Template_span_click_5_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.removeChip(ctx_r1.control.value));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", "option")("aria-label", i0.ɵɵpipeBind2(2, 5, "misc.Item - Remove", i0.ɵɵpureFunction1(8, _c6$c, ctx_r1.control.value.value)))("tabindex", "1");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.control.value.value);
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", "button");
  }
}
function FormACLookupComponent_div_0_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 29, 1);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, FormACLookupComponent_div_0_ng_container_12_ng_container_4_Template, 3, 1, "ng-container", 13)(5, FormACLookupComponent_div_0_ng_container_12_ng_container_5_Template, 6, 10, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", "listbox")("aria-live", "polite")("aria-atomic", true)("aria-orientation", "horizontal")("aria-label", i0.ɵɵpipeBind1(3, 7, "misc.Selected options:"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.multiple);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.multiple && ctx_r1.control.value);
  }
}
function FormACLookupComponent_div_0_span_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 39);
  }
}
function FormACLookupComponent_div_0_ng_container_19_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 40);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function FormACLookupComponent_div_0_ng_container_19_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearValue($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 1, "misc.Clear"));
  }
}
function FormACLookupComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "label", 5);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, FormACLookupComponent_div_0_i_5_Template, 2, 0, "i", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtemplate(7, FormACLookupComponent_div_0_div_7_Template, 4, 1, "div", 8)(8, FormACLookupComponent_div_0_div_8_Template, 4, 1, "div", 9)(9, FormACLookupComponent_div_0_div_9_Template, 3, 6, "div", 10)(10, FormACLookupComponent_div_0_div_10_Template, 2, 2, "div", 11);
    i0.ɵɵelementStart(11, "div", 12);
    i0.ɵɵtemplate(12, FormACLookupComponent_div_0_ng_container_12_Template, 6, 9, "ng-container", 13);
    i0.ɵɵelementStart(13, "div", 14)(14, "input", 15);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function FormACLookupComponent_div_0_Template_input_ngModelChange_14_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.query, $event) || (ctx_r1.query = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("typeaheadOnSelect", function FormACLookupComponent_div_0_Template_input_typeaheadOnSelect_14_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelect($event));
    })("typeaheadOnPreview", function FormACLookupComponent_div_0_Template_input_typeaheadOnPreview_14_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOptionHighlighted($event));
    })("typeaheadOnBlur", function FormACLookupComponent_div_0_Template_input_typeaheadOnBlur_14_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearSrLabel());
    })("keypress", function FormACLookupComponent_div_0_Template_input_keypress_14_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.keypress($event));
    })("blur", function FormACLookupComponent_div_0_Template_input_blur_14_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.blur($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(17, "span", 16);
    i0.ɵɵtemplate(18, FormACLookupComponent_div_0_span_18_Template, 1, 0, "span", 17)(19, FormACLookupComponent_div_0_ng_container_19_Template, 3, 3, "ng-container", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(20, "div", 18);
    i0.ɵɵelement(21, "input", 19);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(38, _c2$J, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild, !ctx_r1.config.lastChild));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("for", ctx_r1.config.elementId);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(42, _c3$u, ctx_r1.config.hideLabel));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 32, ctx_r1.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.warningMessage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.ai_flag_text);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.chipList);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.config.elementId);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.query);
    i0.ɵɵproperty("typeahead", ctx_r1.searchSubscription)("typeaheadAsync", true)("typeaheadOptionField", ctx_r1.optionField)("typeaheadGroupField", ctx_r1.acLookupGroupBy)("typeaheadMinLength", 0)("typeaheadOptionsLimit", ctx_r1.resultLimit)("typeaheadItemTemplate", ctx_r1.itemTemplate)("typeaheadScrollable", true)("typeaheadSelectFirstItem", !ctx_r1.config.allowNonListedValues)("typeaheadOptionsInScrollableView", ctx_r1.scrollViewSize)("ngClass", ctx_r1.setClasses());
    i0.ɵɵattribute("placeholder", i0.ɵɵpipeBind1(15, 34, ctx_r1.config.placeholder))("aria-label", i0.ɵɵpipeBind1(16, 36, ctx_r1.config.ariaLabel))("aria-describedby", ctx_r1.describedByValue);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "sr-", ctx_r1.config.elementId, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.clearButton && !ctx_r1.query || !ctx_r1.config.clearButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.clearButton && (ctx_r1.query == null ? null : ctx_r1.query.length));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.config.name);
  }
}
function FormACLookupComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 41);
    i0.ɵɵpipe(1, "highlight");
  }
  if (rf & 2) {
    const model_r10 = ctx.item;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, model_r10[ctx_r1.optionField], ctx_r1.query), i0.ɵɵsanitizeHtml);
  }
}
function getTypeaheadConfig() {
  return Object.assign(new TypeaheadConfig(), {
    cancelRequestOnFocusLost: true
  });
}
class FormACLookupComponent {
  constructor(translate, http, cdr, elRef) {
    this.translate = translate;
    this.http = http;
    this.cdr = cdr;
    this.elRef = elRef;
    this.isRTL = window.document.dir === 'rtl';
    this.query = '';
    this.placeholder = 'misc.Search Keywords';
    this.errorMessage = "misc.We can't find the keywords you've entered.";
    this.chipFocusIndex = 0;
  }
  get control() {
    return this.group.controls[this.config.name];
  }
  get controlName() {
    return this.config.name;
  }
  get isRequired() {
    return hasRequiredField(this.control);
  }
  get multiple() {
    return this.config.multiple || false;
  }
  get chipList() {
    return _.isUndefined(this.config.chipList) || this.config.chipList;
  }
  get optionField() {
    return this.config.optionField || 'display';
  }
  get resultLimit() {
    return this.config.resultLimit || 0;
  }
  get acLookupGroupBy() {
    return this.config.acLookupGroupBy || null;
  }
  get scrollViewSize() {
    return this.config.scrollViewSize || 5;
  }
  ngOnInit() {
    this.setup();
    this.describedByValue = this.config.blurb ? this.config.id + '-blurb' : null;
    this.placeholder = this.translate.instant(this.config.placeholder || this.placeholder);
    this.translatedLabel = this.config.label ? this.translate.instant(this.config.label) : '';
    this.errorMessage = this.translate.instant(this.errorMessage);
    if (this.config.value) {
      setTimeout(() => {
        this.control.setValue(this.config.value, {
          'emitEvent': false,
          'emitModelToViewChange': true
        });
        this.query = this.config.value.value || this.config.value.inputValue;
      });
    }
  }
  ngAfterViewInit() {
    this.itemTemplate = this.config.dropdownItemTemplate ? this.config.dropdownItemTemplate : this.defaultItemTemplate;
    this.cdr.detectChanges();
  }
  setup() {
    this.keywordKey = this.config.keywordKey || 'keyword';
    this.searchSubscription = new Observable(observer => {
      observer.next(this.query);
    }).pipe(debounceTime(600), distinctUntilChanged(), switchMap(query => {
      if (query) {
        return this.http.get(this.config.apiUrl || this.config.api, {
          params: _.extend(this.config.options, {
            [this.keywordKey]: query,
            mode: 'json'
          })
        }).pipe(map(data => {
          let convertedData = [];
          if (data) {
            convertedData = data.map(pick => {
              if (pick['skill_id']) {
                pick['id'] = pick['skill_id'];
                pick['value'] = pick['skill_name'];
              }
              return new PicklistValue(pick['id'], pick['value']);
            });
          }
          if (typeof this.config.listUpdateCallBack === 'function') {
            convertedData = this.config.listUpdateCallBack(convertedData, query, data);
          }
          return convertedData;
        }), tap(() => noop, err => {
          this.errorMessage = err;
        }));
      }
      return of([]);
    }));
  }
  updateNonListedValue() {
    if (!this.config.allowNonListedValues || this.control.value?.value == this.query) {
      return;
    }
    if (this.multiple) {
      this.setValue(new PicklistValue(undefined, this.query));
      this.query = '';
    } else {
      this.setValue({
        inputValue: this.query
      });
    }
  }
  onSelect(event) {
    if (this.chipList || this.multiple) {
      this.query = '';
    }
    this.setValue(event.item);
    this.triggerEvent('select', event);
    this.clearSrLabel();
  }
  onOptionHighlighted($event) {
    const container = this.elRef.nativeElement.querySelector('typeahead-container');
    if (container) {
      setTimeout(() => {
        container.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }, 100);
      const buttons = container.querySelectorAll('button[id^="ngb-typeahead"]');
      buttons.forEach(button => {
        const text = button.textContent?.trim();
        if (text) {
          button.setAttribute('aria-label', this.formatLetterRepetitions(text));
        }
      });
    }
  }
  formatLetterRepetitions(value) {
    if (typeof value === "string") {
      value = value.replace(/(\w)\1{2,}/g, match => match.split("").join(" "));
    }
    return value;
  }
  blur(event) {
    if (this.multiple || this.chipList) {
      return;
    }
    var val = event.target['value'];
    if (!val) {
      this.control.setValue(null);
    } else {
      this.control.setValue({
        inputValue: val
      });
    }
    this.control.markAsTouched();
    this.control.updateValueAndValidity();
  }
  keypress(event) {
    if (!this.group.touched) {
      this.group.markAsTouched();
    }
    if (this.multiple) {
      if (event.code == 'Enter' && this.query) {
        this.updateNonListedValue();
        event.preventDefault();
        event.stopPropagation();
      }
    } else {
      setTimeout(() => {
        this.updateNonListedValue();
      });
    }
    this.triggerEvent('keypress', event);
  }
  setValue(item) {
    let value = this.control.value;
    if (this.multiple) {
      if (!_.isArray(value)) {
        value = [];
      }
      if (value.find(val => _.isMatch(val, item))) {
        return;
      }
      value.push(item);
    } else if (!this.multiple) {
      value = item;
    }
    this.control.setValue(value);
  }
  clearValue(event) {
    this.query = '';
    this.group.get(this.config.name).setValue(null);
    this.triggerEvent('clear', event);
    this.clearSrLabel();
  }
  getChipTabIndex(idx) {
    return +(idx === this.chipFocusIndex) - 1;
  }
  chipNav(e, item, idx) {
    switch (e.code) {
      case 'ArrowUp':
      case 'ArrowLeft':
        e.preventDefault();
        this.isRTL ? this.chipMove(this.chipFocusIndex + 1) : this.chipMove(this.chipFocusIndex - 1);
        break;
      case 'ArrowDown':
      case 'ArrowRight':
        e.preventDefault();
        this.isRTL ? this.chipMove(this.chipFocusIndex - 1) : this.chipMove(this.chipFocusIndex + 1);
        break;
      case 'Home':
        e.preventDefault();
        this.chipMove(0);
        break;
      case 'End':
        e.preventDefault();
        this.chipMove(this.control.value.length - 1);
        break;
      case 'Space':
      case 'Enter':
        e.preventDefault();
        this.removeChip(item);
        this.focusNextChip(idx);
        break;
    }
  }
  chipMove(idx) {
    this.chipFocusIndex = this.wrapAround(idx, this.control.value.length - 1);
    this.focusChip();
  }
  focusChip() {
    setTimeout(() => {
      const item = this.chipListElm.nativeElement.querySelectorAll('[tabindex]:not([tabindex="-1"])')[0];
      item?.focus();
    }, 0);
  }
  focusNextChip(idx) {
    setTimeout(() => {
      if (this.control.value.length) {
        this.chipFocusIndex = this.wrapAround(idx - 1, this.control.value.length - 1, false);
        this.focusChip();
      } else {
        document.getElementById(this.config.elementId).focus();
      }
    }, 100);
  }
  wrapAround(idx, maxNum, loop = true) {
    let newIdx = idx;
    const min = loop ? 0 : maxNum;
    const max = loop ? maxNum : 0;
    if (idx < 0) {
      newIdx = max;
    } else if (idx > maxNum) {
      newIdx = min;
    }
    return newIdx < 0 ? -1 : newIdx;
  }
  removeChip(item = undefined) {
    if (!this.group.touched) {
      this.group.markAsTouched();
    }
    if (item && this.multiple) {
      const newValue = this.group.get(this.config.name).value.filter(val => !_.isMatch(val, item));
      this.control.setValue(newValue);
    } else {
      this.group.get(this.config.name).setValue(undefined);
    }
    this.triggerEvent('remove', item);
  }
  setClasses() {
    let classObject = {
      haveClearBtn: this.config.clearButton && this.control.value
    };
    classObject[this.config.className] = true;
    return classObject;
  }
  isTriggerEventAvailable() {
    return this.config.triggerEvent instanceof Function;
  }
  triggerEvent(action, event) {
    if (this.isTriggerEventAvailable()) {
      this.config.triggerEvent(action, event);
    }
  }
  clearSrLabel() {
    let sr = document.getElementById('sr-' + this.config.elementId);
    if (sr) {
      sr.innerHTML = '';
    }
  }
  static {
    this.ɵfac = function FormACLookupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormACLookupComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i2.HttpClient), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormACLookupComponent,
      selectors: [["form-aclookup"]],
      viewQuery: function FormACLookupComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$1c, 5);
          i0.ɵɵviewQuery(_c1$X, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultItemTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chipListElm = _t.first);
        }
      },
      inputs: {
        config: "config",
        group: "group"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: TypeaheadConfig,
        useFactory: getTypeaheadConfig
      }])],
      decls: 3,
      vars: 1,
      consts: [["customItemTemplate", ""], ["chipListElm", ""], ["class", "field aclookup-widget form-input form-custom", 3, "ngClass", 4, "ngIf"], [1, "field", "aclookup-widget", "form-input", "form-custom", 3, "ngClass"], [1, "field-label"], [1, "form-label", 3, "for", "ngClass"], ["class", "req-indicator", 4, "ngIf"], [1, "field-widget"], ["class", "text-warning margin-bottom-xs", 4, "ngIf"], ["class", "field-blurb field-info margin-bottom-xs", 4, "ngIf"], ["class", "form-text", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 3, "ngClass", 4, "ngIf"], [1, "input-selections-group"], [4, "ngIf"], [1, "input-wrapper", "d-inline-flex", "align-items-center", "w-100", "position-relative"], ["role", "combobox", "type", "text", 1, "input-text", "padding-right-xl", 3, "ngModelChange", "typeaheadOnSelect", "typeaheadOnPreview", "typeaheadOnBlur", "keypress", "blur", "ngModel", "typeahead", "typeaheadAsync", "typeaheadOptionField", "typeaheadGroupField", "typeaheadMinLength", "typeaheadOptionsLimit", "typeaheadItemTemplate", "typeaheadScrollable", "typeaheadSelectFirstItem", "typeaheadOptionsInScrollableView", "ngClass", "id"], ["role", "alert", 1, "sr-only", 3, "id"], ["class", "icn-search", 4, "ngIf"], [3, "formGroup"], ["type", "hidden", 3, "formControlName"], [1, "req-indicator"], [1, "text-warning", "margin-bottom-xs"], [1, "align-middle", "icn-warning_filled", "icon-md", "margin-right-xs"], [1, "align-text-top"], [1, "field-blurb", "field-info", "margin-bottom-xs"], [1, "align-middle", "icn-noun_ai_star", "icon-md", "margin-right-xs"], [1, "form-text", 3, "id", "innerHTML"], ["role", "alert", 3, "ngClass"], [1, "icn-error_filled"], [1, "selections"], [1, "list-unstyled", "list-inline", "my-0"], ["role", "presentation", "class", "list-inline-item me-1 mb-2", 3, "ngClass", "keydown", 4, "ngFor", "ngForOf"], ["role", "presentation", 1, "list-inline-item", "me-1", "mb-2", 3, "keydown", "ngClass"], [1, "btn", "text-white", "bg-primary", "d-inline-flex", "badge", "minw-0"], ["type", "button", "tabindex", "-1", "role", "option", 1, "d-flex", "align-items-center", "btn-close", "btn-close-white", "ms-2", "me-0", "p-0", 3, "click"], [1, "icn-close"], [1, "chip", "chip-highlight", 3, "keydown"], [1, "chip-value"], [1, "chip-close", 3, "click"], [1, "icn-search"], [1, "border-0", "clearBtn", "bg-transparent", "icn-close", 3, "click"], [1, "query-result-item", "fw-bold", 3, "innerHTML"]],
      template: function FormACLookupComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormACLookupComponent_div_0_Template, 22, 44, "div", 2)(1, FormACLookupComponent_ng_template_1_Template, 2, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.NgModel, i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, i3$1.TypeaheadDirective, i1$1.TranslatePipe, HighlightSearchPipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormACLookupComponent, [{
    type: Component,
    args: [{
      selector: 'form-aclookup',
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: TypeaheadConfig,
        useFactory: getTypeaheadConfig
      }],
      standalone: false,
      template: "<div class=\"field aclookup-widget form-input form-custom\" *ngIf=\"!config.hideField\" [ngClass]=\"{'is-invalid field-error': !control.valid && (control.dirty || control.touched), 'last': config.lastChild, 'mb-4': !config.lastChild }\">\n    <div class=\"field-label\">\n        <label for=\"{{config.elementId}}\" class=\"form-label\" [ngClass]=\"{'visually-hidden': config.hideLabel}\">\n            {{config.label | translate}}\n            <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n        </label>\n    </div>\n    <div class=\"field-widget\">\n        <div *ngIf=\"config.warningMessage\" class=\"text-warning margin-bottom-xs\">\n            <span class=\"align-middle icn-warning_filled icon-md margin-right-xs\"></span>\n            <span class=\"align-text-top\">{{config.warningMessage}}</span>\n        </div>\n        <div *ngIf=\"config.ai_flag_text\" class=\"field-blurb field-info margin-bottom-xs\">\n            <span class=\"align-middle icn-noun_ai_star icon-md margin-right-xs\"></span>\n            <span class=\"align-text-top\">{{config.ai_flag_text}}</span>\n        </div>\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\" [ngClass]=\"config.showFieldError ? 'field-error' : 'invalid-feedback'\">\n            <div *ngIf=\"control.errors.required\">\n                <i class=\"icn-error_filled\"></i>\n                {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n            </div>\n        </div>\n        \n        <div class=\"input-selections-group\">\n            <ng-container *ngIf=\"chipList\">\n                <div class=\"selections\"\n                    #chipListElm\n                    [attr.role]=\"'listbox'\" \n                    [attr.aria-live]=\"'polite'\"\n                    [attr.aria-atomic]=\"true\"\n                    [attr.aria-orientation]=\"'horizontal'\"\n                    [attr.aria-label]=\"'misc.Selected options:' | translate\"\n                >\n                    <ng-container *ngIf=\"multiple\">\n                        <ul class=\"list-unstyled list-inline my-0\">\n                            <li\n                                *ngFor=\"let selection of control.value; index as i, last as isLast\"\n                                role=\"presentation\"\n                                [attr.aria-label]=\"'misc.Item - Remove' | translate : {item: selection[optionField]}\"\n                                [attr.aria-setsize]=\"control.value.length\"\n                                [attr.aria-posinset]=\"i + 1\"\n                                [attr.tabindex]=\"getChipTabIndex(i)\"\n                                [ngClass]=\"{'chip-highlight': isLast}\"\n                                (keydown)=\"chipNav($event, selection, i)\"\n                                class=\"list-inline-item me-1 mb-2\"\n                            >\n                                <span class=\"btn text-white bg-primary d-inline-flex badge minw-0\">\n                                    {{selection[optionField]}}\n                                    <button \n                                        type=\"button\" \n                                        class=\"d-flex align-items-center btn-close btn-close-white ms-2 me-0 p-0\" \n                                        [attr.aria-label]=\"'misc.Item - Remove' | translate : {item: selection[optionField]}\" \n                                        (click)=\"removeChip(selection)\" \n                                        tabindex=\"-1\"\n                                        role=\"option\"\n                                    >\n                                        <i class=\"icn-close\"></i>\n                                    </button>\n                                </span>\n                            </li>\n                        </ul>\n                    </ng-container>\n                    \n                    <ng-container *ngIf=\"!multiple && control.value\">\n                        <span\n                            [attr.role]=\"'option'\"\n                            [attr.aria-label]=\"'misc.Item - Remove' | translate : {item: control.value.value}\"\n                            [attr.tabindex]=\"'1'\"\n                            (keydown)=\"removeChip(control.value)\"\n                            class=\"chip chip-highlight\"\n                        >\n                            <span class=\"chip-value\">{{control.value.value}}</span>\n                            <span class=\"chip-close\"\n                                    [attr.role]=\"'button'\"\n                                    (click)=\"removeChip(control.value)\"\n                            ></span>\n                        </span>\n                    </ng-container>\n                </div>\n            </ng-container>\n\n            <div class=\"input-wrapper d-inline-flex align-items-center w-100 position-relative\">\n                <input\n                        [(ngModel)]=\"query\"\n                        [typeahead]=\"searchSubscription\"\n                        [typeaheadAsync]=\"true\"\n                        [typeaheadOptionField]=\"optionField\"\n                        [typeaheadGroupField]=\"acLookupGroupBy\"\n                        [typeaheadMinLength]=\"0\"\n                        [typeaheadOptionsLimit]=\"resultLimit\"\n                        [typeaheadItemTemplate]=\"itemTemplate\"\n                        [typeaheadScrollable]=\"true\"\n                        [typeaheadSelectFirstItem]=\"!config.allowNonListedValues\"\n                        [typeaheadOptionsInScrollableView]=\"scrollViewSize\"\n                        (typeaheadOnSelect)=\"onSelect($event)\"\n                        (typeaheadOnPreview)=\"onOptionHighlighted($event)\"\n                        (typeaheadOnBlur)=\"clearSrLabel()\"\n                        (keypress)=\"keypress($event)\"\n                        (blur)=\"blur($event)\"\n                        [attr.placeholder]=\"config.placeholder | translate\"\n                        [attr.aria-label]=\"config.ariaLabel | translate\"\n                        [attr.aria-describedby]=\"describedByValue\"\n                        [ngClass]=\"setClasses()\"\n                        role=\"combobox\"\n                        id=\"{{config.elementId}}\"\n                        type=\"text\"\n                        class=\"input-text padding-right-xl\"\n                />\n                <span class='sr-only' role='alert' id='sr-{{config.elementId}}'></span>\n                <span *ngIf=\"(config.clearButton && !query) || (!config.clearButton)\"\n                    class=\"icn-search\"\n                ></span>\n                <ng-container *ngIf=\"config.clearButton && query?.length\">\n                    <button (click)=\"clearValue($event)\" [attr.aria-label]=\"'misc.Clear' | translate\"\n                        class=\"border-0 clearBtn bg-transparent icn-close\"\n                    ></button>\n                </ng-container>\n            </div>\n        </div>\n        <div [formGroup]=\"group\">\n            <input type=\"hidden\" [formControlName]=\"config.name\"/>\n        </div>\n    </div>\n</div>\n<ng-template #customItemTemplate let-model=\"item\" let-index=\"index\">\n    <span class=\"query-result-item fw-bold\" [innerHTML]=\"model[optionField] | highlight: query\"></span>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: i2.HttpClient
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.ElementRef
  }], {
    config: [{
      type: Input
    }],
    group: [{
      type: Input
    }],
    defaultItemTemplate: [{
      type: ViewChild,
      args: ['customItemTemplate', {
        static: false
      }]
    }],
    chipListElm: [{
      type: ViewChild,
      args: ['chipListElm', {
        static: false
      }]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormACLookupComponent, {
    className: "FormACLookupComponent",
    filePath: "dynamic-form/components/form-aclookup/form-aclookup.component.ts",
    lineNumber: 24
  });
})();
const _c0$1b = (a0, a1) => ({
  label: a0,
  index: a1
});
const _c1$W = a0 => ({
  label: a0
});
function N1Component_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.config.label), " ");
  }
}
function N1Component_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(1, 1, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function N1Component_div_5_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function N1Component_div_5_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      const control_r4 = ctx_r2.$implicit;
      const idx_r5 = ctx_r2.index;
      const ctx_r0 = i0.ɵɵnextContext();
      ctx_r0.removeField(idx_r5);
      return i0.ɵɵresetView(control_r4.markAsTouched());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const idx_r5 = i0.ɵɵnextContext().index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 2, "misc.Delete {label}: item {index}", i0.ɵɵpureFunction2(7, _c0$1b, ctx_r0.config.label, idx_r5 + 1)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, ctx_r0.config.n1_deletebutton_label || "misc.Delete"), " ");
  }
}
function N1Component_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵelementContainer(3, 11);
    i0.ɵɵtemplate(4, N1Component_div_5_button_4_Template, 4, 10, "button", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const idx_r5 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r0.config.relation_subform_max_count === null || ctx_r0.config.relation_subform_max_count !== 1 ? i0.ɵɵpipeBind2(1, 5, "misc.{label}: item {index}", i0.ɵɵpureFunction2(8, _c0$1b, ctx_r0.config.label, idx_r5 + 1)) : ctx_r0.config.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroupName", idx_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", ctx_r0.groupedControls[idx_r5])("config", ctx_r0.clonedConfig(ctx_r0.subFormConfig, idx_r5));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.n1_no_delete);
  }
}
function N1Component_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function N1Component_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      ctx_r0.addItem();
      return i0.ɵɵresetView(ctx_r0.control.markAsTouched());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r0.formGroupArray.invalid);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 3, "misc.Add new item to {label}", i0.ɵɵpureFunction1(8, _c1$W, ctx_r0.config.label)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, ctx_r0.config.n1_addbutton_label || "misc.Add Item"), " ");
  }
}
class N1Component extends FormRelationComponent {
  constructor(fb, translate, cdRef) {
    super(fb);
    this.fb = fb;
    this.translate = translate;
    this.cdRef = cdRef;
    this.defaultConfig = {
      relation_subform_max_count: null,
      n1_addbutton_label: 'misc.Add Item',
      n1_deletebutton_label: 'misc.Delete',
      n1_render_empty: true,
      n1_no_delete: false
    };
  }
  get formGroupArray() {
    return this.group.get(this.config.name);
  }
  get groupedControls() {
    return this.formGroupArray.controls;
  }
  setup() {
    Object.keys(this.defaultConfig).forEach(key => {
      if (!this.config.hasOwnProperty(key)) {
        this.config[key] = this.defaultConfig[key];
      }
    });
    this.group.setControl(this.config.name, this.fb.array([]));
    this.setValidation();
    if (!this.config.n1_render_empty) {
      this.addItem();
    }
    if (this.config.value) {
      this.config.value.forEach(item => {
        this.addItem();
      });
      this.formGroupArray.setValue(this.config.value);
    }
    if (this.config.label) {
      this.config.label = this.translate.instant(this.config.label);
    }
  }
  setValidation() {
    if (!this.subFormConfig.validators) {
      return;
    }
    this.groupedControls.forEach(cGroup => {
      let control = cGroup.get(this.subFormConfig.name);
      if (control) {
        control.setValidators(this.subFormConfig.validators);
        control.updateValueAndValidity();
      }
    });
  }
  addItem() {
    this.formGroupArray.push(this.fb.group({
      [this.subFormConfig.name]: ''
    }));
    if (this.config.hasOwnProperty('onAdd')) {
      this.config.onAdd(this.config.name, this.group.controls[this.config.name].getRawValue());
    }
    this.setValidation();
    this.cdRef.detectChanges();
  }
  removeField(idx) {
    if (this.config.hasOwnProperty('onDelete')) {
      this.config.onDelete(this.config.name, this.group.controls[this.config.name].getRawValue()[idx]);
    }
    this.config.value = this.config.value.filter((v, i) => i !== idx);
    this.formGroupArray.removeAt(idx);
  }
  clonedConfig(cfg, index) {
    let config = cloneDeep(cfg);
    if (this.config.value?.[index] && this.config.value?.[index][this.config.name]) {
      config.value = this.config.value[index][this.config.name];
    }
    return config;
  }
  checkMaxCount() {
    return this.config.relation_subform_max_count !== null ? this.groupedControls.length < this.config.relation_subform_max_count : true;
  }
  static {
    this.ɵfac = function N1Component_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || N1Component)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: N1Component,
      selectors: [["form-n1"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 7,
      vars: 6,
      consts: [[1, "field", "n1-widget"], ["class", "field-label", 4, "ngIf"], [1, "field-widget", 3, "formGroup"], ["class", "blurb field-blurb", 3, "innerHTML", 4, "ngIf"], [3, "formArrayName"], ["class", "subform", "role", "group", 4, "ngFor", "ngForOf"], ["class", "btn btn_add margin-top-sm", "type", "button", 3, "disabled", "click", 4, "ngIf"], [1, "field-label"], [1, "blurb", "field-blurb", 3, "innerHTML"], ["role", "group", 1, "subform"], [3, "formGroupName"], ["dynamicField", "", 3, "group", "config"], ["class", "btn btn_delete", "type", "button", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "btn_delete", 3, "click"], ["type", "button", 1, "btn", "btn_add", "margin-top-sm", 3, "click", "disabled"]],
      template: function N1Component_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, N1Component_div_1_Template, 3, 3, "div", 1);
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵtemplate(3, N1Component_div_3_Template, 3, 5, "div", 3);
          i0.ɵɵelementStart(4, "div", 4);
          i0.ɵɵtemplate(5, N1Component_div_5_Template, 5, 11, "div", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, N1Component_button_6_Template, 4, 10, "button", 6);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.config.hideLabel);
          i0.ɵɵadvance();
          i0.ɵɵproperty("formGroup", ctx.group);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.blurb);
          i0.ɵɵadvance();
          i0.ɵɵproperty("formArrayName", ctx.config.name);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.groupedControls);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.checkMaxCount());
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(N1Component, [{
    type: Component,
    args: [{
      selector: 'form-n1',
      standalone: false,
      template: "<div class=\"field n1-widget\">\n\n    <div *ngIf=\"!config.hideLabel\" class=\"field-label\">\n        {{config.label | translate}}\n    </div>\n    <div [formGroup]=\"group\" class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" class=\"blurb field-blurb\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div [formArrayName]=\"config.name\">\n            <div *ngFor=\"let control of groupedControls; index as idx;\"\n                class=\"subform\"\n                role=\"group\"\n                [attr.aria-label]=\"config.relation_subform_max_count === null || config.relation_subform_max_count !== 1 ? ('misc.{label}: item {index}' | translate : { label: config.label, index: idx + 1 }) : config.label\">\n                <div [formGroupName]=\"idx\">\n                    <ng-container dynamicField [group]=\"groupedControls[idx]\" [config]=\"clonedConfig(subFormConfig, idx)\"></ng-container>\n                    <button\n                        *ngIf=\"!config.n1_no_delete\"\n                        (click)=\"removeField(idx); control.markAsTouched();\"\n                        class=\"btn btn_delete\"\n                        type=\"button\"\n                        [attr.aria-label]=\"'misc.Delete {label}: item {index}' | translate : { label: config.label, index: idx + 1 }\"\n                    >\n                        {{(config.n1_deletebutton_label || 'misc.Delete') | translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n        <button\n            *ngIf=\"checkMaxCount()\"\n            [disabled]=\"formGroupArray.invalid\"\n            class=\"btn btn_add margin-top-sm\"\n            type=\"button\"\n            (click)=\"addItem(); control.markAsTouched();\"\n            [attr.aria-label]=\"'misc.Add new item to {label}' | translate : { label: config.label }\"\n        >\n            {{(config.n1_addbutton_label || 'misc.Add Item') | translate}}\n        </button>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }, {
    type: i1$1.TranslateService
  }, {
    type: i0.ChangeDetectorRef
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(N1Component, {
    className: "N1Component",
    filePath: "dynamic-form/components/form-n1/form-n1.component.ts",
    lineNumber: 12
  });
})();
const _c0$1a = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c1$V = a0 => ({
  "user-select-none": a0
});
const _c2$I = a0 => ({
  field_name: a0
});
function FormTimepickerComponent_div_0_div_1_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 12);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormTimepickerComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "label", 10);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, FormTimepickerComponent_div_0_div_1_i_3_Template, 2, 0, "i", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.translatedLabel, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired);
  }
}
function FormTimepickerComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 13);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormTimepickerComponent_div_0_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c2$I, ctx_r1.translatedLabel)), " ");
  }
}
function FormTimepickerComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, FormTimepickerComponent_div_0_div_4_div_1_Template, 4, 6, "div", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.required);
  }
}
function FormTimepickerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, FormTimepickerComponent_div_0_div_1_Template, 4, 5, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, FormTimepickerComponent_div_0_div_3_Template, 3, 6, "div", 4)(4, FormTimepickerComponent_div_0_div_4_Template, 2, 1, "div", 5);
    i0.ɵɵelementStart(5, "div", 6)(6, "timepicker", 7);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵlistener("keypress", function FormTimepickerComponent_div_0_Template_timepicker_keypress_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onValueChanges(ctx_r1.today));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 8);
    i0.ɵɵlistener("click", function FormTimepickerComponent_div_0_Template_div_click_10_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClockClick());
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.timeGroup)("ngClass", i0.ɵɵpureFunction2(29, _c0$1a, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(32, _c1$V, ctx_r1.control.disabled));
    i0.ɵɵattribute("readonly", ctx_r1.control.disabled || null);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵproperty("showSpinners", false)("hoursPlaceholder", i0.ɵɵpipeBind1(7, 23, ctx_r1.timepickerConfig.hoursPlaceholder))("hourStep", ctx_r1.timepickerConfig.hourStep)("meridians", ctx_r1.timepickerConfig.meridians)("minutesPlaceholder", i0.ɵɵpipeBind1(8, 25, ctx_r1.timepickerConfig.minutesPlaceholder))("minuteStep", ctx_r1.timepickerConfig.minuteStep)("mousewheel", !ctx_r1.control.disabled)("secondsPlaceholder", i0.ɵɵpipeBind1(9, 27, ctx_r1.timepickerConfig.secondsPlaceholder))("secondsStep", ctx_r1.timepickerConfig.secondsStep)("showMeridian", ctx_r1.timepickerConfig.showMeridian)("showMinutes", ctx_r1.timepickerConfig.showMinutes)("showSeconds", ctx_r1.timepickerConfig.showSeconds);
    i0.ɵɵattribute("aria-labelledby", ctx_r1.config.elementId + (ctx_r1.modal ? "modal" : ""));
  }
}
class FormTimepickerComponent extends FormInputComponent {
  constructor(translate, destroy$) {
    super(translate);
    this.translate = translate;
    this.destroy$ = destroy$;
    this.timezone = '';
    this.timeGroup = new UntypedFormGroup({
      time: new UntypedFormControl()
    });
    this.defaultTimeConfig = {
      minuteStep: 15,
      ariaLabelHours: 'misc.hours',
      ariaLabelMinutes: 'misc.minutes',
      ariaLabelSeconds: 'misc.seconds',
      hoursPlaceholder: 'misc.HH',
      minutesPlaceholder: 'misc.MM',
      secondsPlaceholder: 'misc.SS'
    };
    this.timepickerConfig = {
      ...new TimepickerConfig(),
      ...this.defaultTimeConfig
    };
    this.keyCodesWhitelist = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'End', 'Home', 'Tab'];
    this.numbersRegExp = new RegExp(/^(^[0-9])+$/);
    this.today = new Date();
    this.timepickerConfigKeys = ['ariaLabelHours', 'ariaLabelMinutes', 'ariaLabelSeconds', 'disabled', 'hoursPlaceholder', 'hourStep', 'meridians', 'minutesPlaceholder', 'minuteStep', 'secondsPlaceholder', 'secondsStep', 'showMeridian', 'showMinutes', 'showSeconds'];
    this.configKeys = ['timezone'];
    this.DOMInputs = [{
      selector: '[aria-label="hours"]',
      replacement: {
        attribute: 'aria-label',
        replacementKey: 'ariaLabelHours'
      }
    }, {
      selector: '[aria-label="minutes"]',
      replacement: {
        attribute: 'aria-label',
        replacementKey: 'ariaLabelMinutes'
      }
    }, {
      selector: '[aria-label="seconds"]',
      replacement: {
        attribute: 'aria-label',
        replacementKey: 'ariaLabelSeconds'
      }
    }];
    this.offsets = {
      value: 0,
      timezone: 0
    };
  }
  ngOnInit() {
    this.defaultInit();
    this.applyTimepickerConfig(this.timepickerConfigKeys, this.configKeys);
    if (this.config.disabled) {
      this.timeGroup.get('time')?.disable({
        emitEvent: false
      });
    }
    if (this.isRequired) {
      this.timeGroup.get('time')?.setValidators(Validators.required);
    }
    this.setTimepickerDate();
    this.timeGroup.get('time')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => this.onValueChanges(value));
  }
  ngAfterViewInit() {
    this.updateDOMInputs();
  }
  applyTimepickerConfig(timepickerConfigsKeys, configsKeys) {
    timepickerConfigsKeys.filter(key => typeof this.config[key] !== 'undefined' && this.timepickerConfig.hasOwnProperty(key)).forEach(key => this.timepickerConfig[key] = this.config[key]);
    configsKeys.filter(key => typeof this.config[key] !== 'undefined' && this.hasOwnProperty(key)).forEach(key => this[key] = this.config[key]);
  }
  updateDOMInputs() {
    if (!this.timepickerComponent?.nativeElement) {
      return;
    }
    this.DOMInputs.forEach(domInput => {
      const element = this.timepickerComponent.nativeElement.querySelector(domInput.selector);
      if (element) {
        const {
          attribute,
          replacementKey
        } = domInput.replacement;
        this.addInputGuards(element, domInput.selector);
        element.setAttribute(attribute, this.translate.instant(this.timepickerConfig[replacementKey]));
      }
    });
  }
  setTimepickerDate() {
    if (this.timezone) {
      this.offsets.timezone = moment$1.parseZone(moment$1(new Date()).tz(this.timezone)).utcOffset();
    }
    if (this.config.value) {
      const year = this.today.getFullYear().toString();
      const month = (this.today.getMonth() + 1).toString().padStart(2, '0');
      const date = this.today.getDate().toString().padStart(2, '0');
      let momentDate = moment$1.parseZone(`${year}-${month}-${date}T${this.config.value}`);
      //const value = moment.parseZone(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offset}`).utcOffset(this.offsets.value).format('HH:mm:ssZ');
      this.offsets.value = momentDate.utcOffset();
      if (this.offsets.timezone) {
        momentDate = momentDate.utcOffset(this.offsets.timezone);
      }
      const [hours, minutes, seconds] = momentDate.format('HH:mm:ss').split(':').map(number => parseInt(number, 10));
      this.today.setHours(hours);
      this.today.setMinutes(minutes);
      this.today.setSeconds(seconds);
      this.timeGroup.get('time')?.setValue(this.today, {
        emitEvent: false
      });
      this.onValueChanges(this.today, false);
    }
    if (!this.config.value && this.timezone) {
      this.offsets.value = this.offsets.timezone;
    }
  }
  onValueChanges(date, emitEvent = true) {
    if (date && date instanceof Date) {
      const year = this.today.getFullYear().toString();
      const month = (this.today.getMonth() + 1).toString().padStart(2, '0');
      const day = this.today.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      const offset = this.numberToISOOffset();
      const value = moment$1.parseZone(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offset}`).utcOffset(this.offsets.value).format('HH:mm:ssZ');
      this.control.setValue({
        time: value
      }, {
        emitEvent: emitEvent
      });
    } else if (date === null) {
      this.control.setValue(null, {
        emitEvent: emitEvent
      });
    }
  }
  numberToISOOffset() {
    const offset = this.timezone ? this.offsets.timezone : this.offsets.value;
    let retval = '';
    retval += offset < 0 ? '-' : '+';
    retval += Math.floor(Math.abs(offset / 60)).toString().padStart(2, '0');
    retval += ':';
    retval += Math.abs(offset % 60).toString().padStart(2, '0');
    return retval;
  }
  addInputGuards(element, selector) {
    const type = selector.replace('[aria-label="', '').replace('"]', '');
    fromEvent(element, 'keydown').pipe(takeUntil(this.destroy$)).subscribe(event => {
      if (!(this.keyCodesWhitelist.includes(event.code) || this.numbersRegExp.test(event.key))) {
        event.preventDefault();
        return;
      }
      if (this.numbersRegExp.test(event.key)) {
        const {
          selectionEnd,
          selectionStart = 0,
          value
        } = event.target || {};
        /**
         * Time inputs have a `maxlength` attribute set to `2`, so when the value is something between 0 and 9
         * `selectionStart` is going to be 0 or 1 and `selectionEnd` is going to be between 0 and 2.
         *
         * In that way, it's easy to predict the future value based on which number key was pressed:
         *   - if `selectionStart` is `0`, then `event.key` should be added before `value`
         *   - if `selectionStart` is `1`, then `event.key` should be added after `value`
         *
         * If `selectionEnd` is not equal to `selectionStart`, means that there is a selection performed over `value`.
         * In that way,  it's easy to know which portion of the value is candidate to replace the `value` portion.
         */
        const predictedValue = selectionEnd === selectionStart ? parseInt(selectionStart === 0 ? `${event.key}${value}` : `${value}${event.key}`, 10) : parseInt(value.replace(value.substring(selectionStart, selectionEnd), event.key), 10);
        if ((type === 'minutes' || type === 'seconds') && predictedValue > 59 || type === 'hours' && this.timepickerConfig.showMeridian && predictedValue > 12 || type === 'hours' && !this.timepickerConfig.showMeridian && predictedValue > 23) {
          event.preventDefault();
        }
      }
    });
  }
  onClockClick() {
    this.timepickerComponent.nativeElement?.querySelector('input')?.focus();
  }
  static {
    this.ɵfac = function FormTimepickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormTimepickerComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(DestroyEmitter));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormTimepickerComponent,
      selectors: [["form-timepicker"]],
      viewQuery: function FormTimepickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TimepickerComponent, 5, ElementRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timepickerComponent = _t.first);
        }
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([DestroyEmitter]), i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "field timepicker-widget align-items-start", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "field", "timepicker-widget", "align-items-start", 3, "formGroup", "ngClass"], ["class", "field-label", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], [1, "timepicker-wrapper", "form-control", "d-inline-flex", "align-items-center", "w-auto", "p-0", 3, "ngClass"], ["role", "group", "formControlName", "time", 3, "keypress", "id", "showSpinners", "hoursPlaceholder", "hourStep", "meridians", "minutesPlaceholder", "minuteStep", "mousewheel", "secondsPlaceholder", "secondsStep", "showMeridian", "showMinutes", "showSeconds"], [1, "icn-clock", "icon-lg", "text-gray", 3, "click"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [4, "ngIf"], [1, "icn-error_filled"]],
      template: function FormTimepickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormTimepickerComponent_div_0_Template, 11, 34, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, i4$1.TimepickerComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormTimepickerComponent, [{
    type: Component,
    args: [{
      selector: 'form-timepicker',
      encapsulation: ViewEncapsulation.None,
      providers: [DestroyEmitter],
      standalone: false,
      template: "<div\n    [formGroup]=\"timeGroup\"\n    *ngIf=\"!config.hideField\"\n    class=\"field timepicker-widget align-items-start\"\n    [ngClass]=\"{'field-error': !control.valid && (control.dirty || control.touched), 'last': config.lastChild}\"\n>\n    <div *ngIf=\"!config.hideLabel\" class=\"field-label\">\n        <label for=\"{{config.elementId}}{{modal?'modal':''}}\">\n            {{translatedLabel}}\n            <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n        </label>\n    </div>\n    <div class=\"field-widget\" >\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb field-blurb\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n            <div *ngIf=\"control.errors.required\">\n                <i class=\"icn-error_filled\"></i>\n                {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n            </div>\n        </div>\n        <div \n            class=\"timepicker-wrapper form-control d-inline-flex align-items-center w-auto p-0\" \n            [ngClass]=\"{ 'user-select-none': control.disabled }\"\n            [attr.readonly]=\"control.disabled || null\"\n        >\n            <timepicker\n                id=\"{{config.elementId}}{{modal?'modal':''}}\" \n                role=\"group\"\n                formControlName=\"time\"\n                (keypress)=\"onValueChanges(today)\"\n                [showSpinners]=\"false\"\n                [attr.aria-labelledby]=\"config.elementId + (modal ? 'modal':'')\"\n                [hoursPlaceholder]=\"timepickerConfig.hoursPlaceholder | translate\"\n                [hourStep]=\"timepickerConfig.hourStep\"\n                [meridians]=\"timepickerConfig.meridians\"\n                [minutesPlaceholder]=\"timepickerConfig.minutesPlaceholder | translate\"\n                [minuteStep]=\"timepickerConfig.minuteStep\"\n                [mousewheel]=\"!control.disabled\"\n                [secondsPlaceholder]=\"timepickerConfig.secondsPlaceholder | translate\"\n                [secondsStep]=\"timepickerConfig.secondsStep\"\n                [showMeridian]=\"timepickerConfig.showMeridian\"\n                [showMinutes]=\"timepickerConfig.showMinutes\"\n                [showSeconds]=\"timepickerConfig.showSeconds\"\n            ></timepicker>\n            <div (click)=\"onClockClick()\" class=\"icn-clock icon-lg text-gray\"></div>\n        </div>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: DestroyEmitter
  }], {
    timepickerComponent: [{
      type: ViewChild,
      args: [TimepickerComponent, {
        read: ElementRef
      }]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormTimepickerComponent, {
    className: "FormTimepickerComponent",
    filePath: "dynamic-form/components/form-timepicker/form-timepicker.component.ts",
    lineNumber: 19
  });
})();
const _c0$19 = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
function FormDatetimepickerComponent_div_0_div_1_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 11);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormDatetimepickerComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "label", 9);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, FormDatetimepickerComponent_div_0_div_1_i_3_Template, 2, 0, "i", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.translatedLabel, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
  }
}
function FormDatetimepickerComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormDatetimepickerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, FormDatetimepickerComponent_div_0_div_1_Template, 4, 5, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, FormDatetimepickerComponent_div_0_div_3_Template, 3, 6, "div", 4);
    i0.ɵɵelementStart(4, "div", 5)(5, "div", 6);
    i0.ɵɵelementContainer(6, 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 6);
    i0.ɵɵelementContainer(8, 7);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c0$19, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵattribute("readonly", ctx_r0.control.disabled || null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("config", ctx_r0.dateConfig)("group", ctx_r0.dateTimeGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("config", ctx_r0.timeConfig)("group", ctx_r0.dateTimeGroup);
  }
}
class FormDatetimepickerComponent extends FormInputComponent {
  constructor(translate, cd) {
    super(translate);
    this.translate = translate;
    this.cd = cd;
    this.groupReady = true;
    this.timeConfig = {
      type: 'timepicker',
      label: 'time',
      name: 'innerTime',
      hideLabel: true,
      value: undefined,
      showMeridian: window.DATETIME_FORMAT?.TIME?.SHORT === 'HH:mm' ? false : true
    };
    this.dateConfig = {
      type: 'datepicker',
      label: 'date',
      name: 'innerDate',
      hideLabel: true,
      value: undefined
    };
    this.dateTimeGroup = new UntypedFormGroup({
      innerTime: new UntypedFormControl(),
      innerDate: new UntypedFormControl()
    });
  }
  ngOnInit() {
    this.defaultInit();
    if (this.config.value) {
      const [initDate, initTime] = this.config.value.split('T');
      this.dateConfig.value = initDate;
      this.timeConfig.value = initTime;
      this.cd.detectChanges();
      if (initDate && initTime) {
        this.control.setValue(this.config.value, {
          emitEvent: false
        });
      }
    }
    setTimeout(() => {
      this.dateTimeGroup.valueChanges.subscribe(value => {
        this.control.markAsTouched();
        if (!value.innerDate || !value.innerTime) {
          this.control.setValue(null);
        } else {
          this.control.setValue(`${value.innerDate}T${value.innerTime.time}`);
        }
      });
    });
  }
  static {
    this.ɵfac = function FormDatetimepickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormDatetimepickerComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormDatetimepickerComponent,
      selectors: [["form-datetimepicker"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "field", 3, "ngClass", 4, "ngIf"], [1, "field", 3, "ngClass"], ["class", "field-label", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], [1, "dateTimerWrapper", "flex-row", "gap-lg"], [1, "w-50"], ["dynamicField", "", 3, "config", "group"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"]],
      template: function FormDatetimepickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormDatetimepickerComponent_div_0_Template, 9, 11, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField && ctx.groupReady);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormDatetimepickerComponent, [{
    type: Component,
    args: [{
      selector: 'form-datetimepicker',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div\n    *ngIf=\"!config.hideField && groupReady\"\n    class=\"field\"\n    [ngClass]=\"{'field-error': !control.valid && (control.dirty || control.touched), 'last': config.lastChild}\"\n>\n    <div *ngIf=\"!config.hideLabel\" class=\"field-label\">\n        <label for=\"{{config.elementId}}{{modal?'modal':''}}\">\n            {{translatedLabel}}\n            <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n        </label>\n    </div>\n    <div class=\"field-widget\" >\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb field-blurb\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div \n            class=\"dateTimerWrapper flex-row gap-lg\"\n            [attr.readonly]=\"control.disabled || null\"\n        >\n            <div class=\"w-50\">\n                <ng-container dynamicField [config]=\"dateConfig\" [group]=\"dateTimeGroup\"></ng-container>\n            </div>\n            <div class=\"w-50\">\n                <ng-container dynamicField [config]=\"timeConfig\" [group]=\"dateTimeGroup\"></ng-container>\n            </div>\n        </div>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: i0.ChangeDetectorRef
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormDatetimepickerComponent, {
    className: "FormDatetimepickerComponent",
    filePath: "dynamic-form/components/form-datetimepicker/form-datetimepicker.component.ts",
    lineNumber: 14
  });
})();
const _c0$18 = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c1$U = a0 => ({
  field_name: a0
});
function MonthYearPicker_div_0_div_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 13);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function MonthYearPicker_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "label", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, MonthYearPicker_div_0_div_1_i_4_Template, 2, 0, "i", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 5, ctx_r1.config.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired);
  }
}
function MonthYearPicker_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.blurb));
  }
}
function MonthYearPicker_div_0_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$U, ctx_r1.translatedLabel)), " ");
  }
}
function MonthYearPicker_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, MonthYearPicker_div_0_div_4_div_1_Template, 4, 6, "div", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.required);
  }
}
function MonthYearPicker_div_0_option_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const month_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", month_r3.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(month_r3.value);
  }
}
function MonthYearPicker_div_0_option_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const year_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", year_r4.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(year_r4.value);
  }
}
function MonthYearPicker_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, MonthYearPicker_div_0_div_1_Template, 5, 7, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, MonthYearPicker_div_0_div_3_Template, 3, 3, "div", 4)(4, MonthYearPicker_div_0_div_4_Template, 2, 1, "div", 5);
    i0.ɵɵelementStart(5, "div", 6)(6, "select", 7);
    i0.ɵɵlistener("change", function MonthYearPicker_div_0_Template_select_change_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.checkTouched());
    });
    i0.ɵɵtemplate(7, MonthYearPicker_div_0_option_7_Template, 2, 2, "option", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "select", 9);
    i0.ɵɵlistener("change", function MonthYearPicker_div_0_Template_select_change_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.checkTouched());
    });
    i0.ɵɵtemplate(9, MonthYearPicker_div_0_option_9_Template, 2, 2, "option", 8);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$18, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.dateGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.monthOptions);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.yearOptions);
  }
}
class MonthYearPicker {
  constructor(translate) {
    this.translate = translate;
    this.dateGroup = new UntypedFormGroup({
      month: new UntypedFormControl(),
      year: new UntypedFormControl()
    });
    this.monthOptions = [];
    this.yearOptions = [];
  }
  ngOnInit() {
    this.translatedLabel = this.translate.instant(this.config.label);
    this.monthOptions = [{
      id: '',
      value: ''
    }].concat(this.config.options.month_options.map(opt => ({
      id: opt.id.padStart(2, '0'),
      value: opt.value
    })));
    const years_back = +this.config.options.years_back;
    const years_forward = +this.config.options.years_forward;
    const currentYear = new Date().getFullYear();
    this.yearOptions.push({
      id: '',
      value: ''
    });
    for (let i = currentYear - years_back; i <= currentYear + years_forward; i++) {
      this.yearOptions.push({
        id: i,
        value: i
      });
    }
    this.dateGroup.valueChanges.subscribe(value => this.setControlValue(value));
    let initValue = this.config.value;
    if (initValue && typeof initValue == 'string') {
      const [year, month, day] = initValue.split('-');
      this.dateGroup.setValue({
        month,
        year
      });
    }
  }
  setControlValue({
    month,
    year
  }) {
    if (month && year) {
      let value = `${year}-${month}-01`;
      this.control.setValue(value);
    } else {
      this.control.setValue(null);
    }
  }
  checkTouched() {
    if (!this.group.touched) {
      this.group.markAsTouched();
    }
  }
  get control() {
    return this.group.controls[this.config.name];
  }
  get isRequired() {
    if (this.control.validator) {
      const validator = this.control.validator({});
      if (validator && validator.required) {
        return true;
      }
    }
    return false;
  }
  static {
    this.ɵfac = function MonthYearPicker_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MonthYearPicker)(i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: MonthYearPicker,
      selectors: [["month-year-picker"]],
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["class", "field form-custom", 3, "ngClass", 4, "ngIf"], [1, "field", "form-custom", 3, "ngClass"], ["class", "field-label", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 4, "ngIf"], ["role", "alert", 4, "ngIf"], [1, "flex-row", "gap-lg", 3, "formGroup"], ["formControlName", "month", 1, "w-auto", 3, "change"], [3, "value", 4, "ngFor", "ngForOf"], ["formControlName", "year", 1, "w-auto", 3, "change"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb"], ["role", "alert"], [4, "ngIf"], [1, "icn-error_filled"], [3, "value"]],
      template: function MonthYearPicker_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MonthYearPicker_div_0_Template, 10, 10, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonthYearPicker, [{
    type: Component,
    args: [{
      selector: 'month-year-picker',
      standalone: false,
      template: "\n<div\n    *ngIf=\"!config.hideField\"\n    class=\"field form-custom\"\n    [ngClass]=\"{'field-error': !control.valid && (control.dirty || control.touched), 'last': config.lastChild}\"\n>\n    <div *ngIf=\"!config.hideLabel\" class=\"field-label\">\n        <label for=\"{{config.elementId}}{{modal?'modal':''}}\">{{config.label | translate}}<i *ngIf=\"isRequired\" class=\"req-indicator\">*</i></label>\n    </div>\n    <div class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" class=\"blurb field-blurb\">{{config.blurb | translate}}</div>\n        <div role=\"alert\" *ngIf=\"(!control.valid && (control.dirty || control.touched))\">\n            <div *ngIf=\"control.errors.required\">\n                <i class=\"icn-error_filled\"></i>\n                {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n            </div>\n        </div>\n        <div class=\"flex-row gap-lg\" [formGroup]=\"dateGroup\">\n            <select formControlName=\"month\" class=\"w-auto\" (change)=\"checkTouched()\">\n                <option *ngFor=\"let month of monthOptions\" [value]=\"month.id\" >{{month.value}}</option>\n            </select>\n            <select formControlName=\"year\" class=\"w-auto\" (change)=\"checkTouched()\">\n                <option *ngFor=\"let year of yearOptions\" [value]=\"year.id\" >{{year.value}}</option>\n            </select>\n        </div>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: i1$1.TranslateService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MonthYearPicker, {
    className: "MonthYearPicker",
    filePath: "dynamic-form/components/form-month-year/month-year-picker.component.ts",
    lineNumber: 11
  });
})();
const _c0$17 = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c1$T = a0 => ({
  "input-group": a0
});
const _c2$H = () => ({
  standalone: true
});
const _c3$t = a0 => ({
  field_name: a0
});
function FormNumberComponent_div_0_div_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 14);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormNumberComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "label", 12);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, FormNumberComponent_div_0_div_1_i_4_Template, 2, 0, "i", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, ctx_r1.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired);
  }
}
function FormNumberComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormNumberComponent_div_0_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c3$t, ctx_r1.translatedLabel)), " ");
  }
}
function FormNumberComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, FormNumberComponent_div_0_div_4_div_1_Template, 4, 6, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.required);
  }
}
function FormNumberComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
    i0.ɵɵpipe(1, "sanitizeInputHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.config.prefixClass)("innerHTML", i0.ɵɵpipeBind1(1, 2, ctx_r1.config.prefixText), i0.ɵɵsanitizeHtml);
  }
}
function FormNumberComponent_div_0_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 19);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function FormNumberComponent_div_0_ng_container_10_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearValue($event));
    });
    i0.ɵɵelement(3, "i", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.control.value);
    i0.ɵɵattribute("aria-hidden", !ctx_r1.control.value)("aria-label", i0.ɵɵpipeBind1(2, 3, "misc.Clear"));
  }
}
function FormNumberComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, FormNumberComponent_div_0_div_1_Template, 5, 7, "div", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtemplate(3, FormNumberComponent_div_0_div_3_Template, 3, 6, "div", 5)(4, FormNumberComponent_div_0_div_4_Template, 2, 1, "div", 6);
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵtemplate(6, FormNumberComponent_div_0_div_6_Template, 2, 4, "div", 8);
    i0.ɵɵelementStart(7, "input", 9, 0);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function FormNumberComponent_div_0_Template_input_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.inputValue, $event) || (ctx_r1.inputValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormNumberComponent_div_0_Template_input_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.submit($event));
    })("blur", function FormNumberComponent_div_0_Template_input_blur_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.markAsTouched();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("blur", $event));
    })("keypress", function FormNumberComponent_div_0_Template_input_keypress_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.checkKeyValid($event);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("keypress", $event));
    })("paste", function FormNumberComponent_div_0_Template_input_paste_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.checkPasteValid($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, FormNumberComponent_div_0_ng_container_10_Template, 4, 5, "ng-container", 10);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.group)("ngClass", i0.ɵɵpureFunction2(22, _c0$17, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c1$T, ctx_r1.config.prefixText));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.prefixText);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("form-control ", ctx_r1.config.className, "");
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.inputValue);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(27, _c2$H))("disabled", ctx_r1.control.disabled);
    i0.ɵɵattribute("placeholder", i0.ɵɵpipeBind1(9, 20, ctx_r1.config.placeholder))("aria-describedby", ctx_r1.describedByValue)("aria-required", ctx_r1.isRequired);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.config.clearButton);
  }
}
class FormNumberComponent extends FormInputComponent {
  constructor(translate) {
    super(translate);
    this.translate = translate;
    this.minus = '-';
    this.decimal = '.';
    this.specialKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete', this.minus, this.decimal];
    this.allowNegative = true;
    this.allowFloat = true;
    this.allowEmpty = false;
  }
  configuration() {
    this.allowEmpty = this.config.allowEmpty;
    this.allowNegative = !!this.config.allowNegative;
    this.allowFloat = !!this.config.allowFloat;
    if (this.config.value) {
      this.inputValue = this.config.value;
    }
  }
  isNumericString(val) {
    return !isNaN$1(Number(val));
  }
  checkPasteValid(event) {
    this.markAsTouched();
    let value = event.clipboardData.getData('text/plain');
    if (!value || !this.isNumericString(value)) {
      event.preventDefault();
    }
  }
  checkKeyValid(event) {
    if (!this.isValidCharacter(event)) {
      event.preventDefault();
    }
  }
  isValidCharacter(evt) {
    const isSpecialKey = this.specialKeys.indexOf(evt.key) !== -1;
    const isNumber = /^[0-9]*$/.test(evt.key);
    let valid = true;
    let invalidKey = false;
    if (evt.key === this.minus) {
      if (this.allowNegative) {
        invalidKey = evt.target.selectionStart > 0;
      } else {
        invalidKey = true;
      }
    }
    if (evt.key === this.decimal) {
      if (this.allowFloat) {
        invalidKey = evt.target.value.indexOf('.') > -1;
      } else {
        invalidKey = true;
      }
    }
    if (!(isSpecialKey || isNumber) || invalidKey) {
      valid = false;
    }
    return valid;
  }
  submit(value) {
    this.markAsTouched();
    let reg = new RegExp("[^0-9" + this.decimal + this.minus + "]", 'g');
    if (isEmpty(value)) {
      this.updateValue(value);
    } else if (value && !value.match(reg)) {
      this.updateValue(value.replace(reg, ''));
    }
    if (value === this.decimal) {
      this.updateValue('0' + this.decimal);
    }
  }
  updateValue(value) {
    setTimeout(() => {
      this.inputValue = value;
      const numValue = value === '-' || value.lastIndexOf('-') > 0 ? undefined : +value;
      if (this.allowEmpty && value === "") {
        this.control.setValue(null);
      } else {
        this.control.setValue(numValue);
      }
    });
  }
  markAsTouched() {
    if (this.control.untouched) {
      this.control.markAsTouched();
    }
  }
  static {
    this.ɵfac = function FormNumberComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormNumberComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormNumberComponent,
      selectors: [["form-number"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["inputField", ""], ["class", "field numbercomparison-widget form-custom", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "field", "numbercomparison-widget", "form-custom", 3, "formGroup", "ngClass"], ["class", "field-label", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], [3, "ngClass"], [3, "ngClass", "innerHTML", 4, "ngIf"], ["type", "text", "inputmode", "numeric", 3, "ngModelChange", "blur", "keypress", "paste", "ngModel", "ngModelOptions", "disabled", "id"], [4, "ngIf"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [1, "icn-error_filled"], [3, "ngClass", "innerHTML"], [1, "clearBtn", 3, "click", "hidden"], [1, "icn-close"]],
      template: function FormNumberComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormNumberComponent_div_0_Template, 11, 28, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.NgModel, i1.NgClass, i1.NgIf, i2$1.FormGroupDirective, i1$1.TranslatePipe, SanitizeHtmlPipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormNumberComponent, [{
    type: Component,
    args: [{
      selector: 'form-number',
      template: `
        <div
            [formGroup]="group"
            *ngIf="!config.hideField"
            class="field numbercomparison-widget form-custom"
            [ngClass]="{'field-error': !control.valid && (control.dirty || control.touched), 'last': config.lastChild}"
        >
            <div *ngIf="!config.hideLabel" class="field-label">
                <label for="{{config.elementId}}{{modal?'modal':''}}">
                {{config.label | translate}}
                <i *ngIf="isRequired" class="req-indicator">*</i>
                </label>
            </div>
            <div class="field-widget">
                <div *ngIf="config.blurb" id="{{describedByValue}}" class="blurb field-blurb" [innerHTML]="config.blurb | translate | safeHtml"></div>
                <div role="alert" *ngIf="(!control.valid && (control.dirty || control.touched))">
                    <div *ngIf="control.errors.required">
                        <i class="icn-error_filled"></i>
                        {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}
                    </div>
                </div>
                <div [ngClass]="{ 'input-group': config.prefixText }">
                    <div *ngIf="config.prefixText" [ngClass]="config.prefixClass" [innerHTML]="config.prefixText | sanitizeInputHtml"></div>
                    <input
                            #inputField
                            type="text"
                            inputmode="numeric"
                            [(ngModel)]="inputValue"
                            (ngModelChange)="submit($event)"
                            [ngModelOptions]="{standalone: true}"
                            [disabled]="control.disabled"
                            [attr.placeholder]="config.placeholder | translate"
                            id="{{config.elementId}}{{modal?'modal':''}}"
                            [attr.aria-describedby]="describedByValue"
                            [attr.aria-required]="isRequired"
                            (blur)="markAsTouched(); triggerEvent('blur', $event);"
                            (keypress)="checkKeyValid($event); triggerEvent('keypress', $event);"
                            (paste)="checkPasteValid($event)"
                            class="form-control {{config.className}}" />
                    <ng-container *ngIf="config.clearButton">
                        <button class="clearBtn" (click)="clearValue($event)" [hidden]="!this.control.value" [attr.aria-hidden]="!this.control.value" [attr.aria-label]="'misc.Clear' | translate">
                            <i class="icn-close"></i>
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>
    `,
      standalone: false
    }]
  }], () => [{
    type: i1$1.TranslateService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormNumberComponent, {
    className: "FormNumberComponent",
    filePath: "dynamic-form/components/form-number/form-number.component.ts",
    lineNumber: 58
  });
})();
const components = {
  input: FormInputComponent,
  select: FormSelectComponent,
  button: FormButtonComponent,
  textarea: FormTextareaComponent,
  range: FormRangeComponent,
  checkbox: FormCheckboxComponent,
  radio: FormRadioComponent,
  static: FormStaticComponent,
  staticList: FormStaticListComponent,
  multiselect: FormMultiSelectComponent,
  datepicker: FormDatePickerComponent,
  ngselect: FormNGSelectComponent,
  rangeDatePicker: FormRangeDatePickerComponent,
  richtext: FormRichtextComponent,
  relation: FormRelationComponent,
  rating: FormRatingComponent,
  location: FormLocationComponent,
  moxiemanager: FormMoxieManagerComponent,
  imgstatic: FormMoxieManagerStaticComponent,
  minmax: FormMinMaxComponent,
  hierpicklist: FormHierpicklistComponent,
  numberComparison: FormNumberComparisonComponent,
  number: FormNumberComponent,
  fileUpload: FormFileUploadComponent,
  imageUpload: FormImageUploadComponent,
  aclookup: FormACLookupComponent,
  n1: N1Component,
  timepicker: FormTimepickerComponent,
  datetimepicker: FormDatetimepickerComponent,
  monthYearPicker: MonthYearPicker
};
class DynamicFieldDirective {
  constructor(containerRef) {
    this.containerRef = containerRef;
    this.unsubscribe = new Subject();
  }
  ngOnInit() {
    if (this.value || this.value === 0) {
      this.config.value = this.value;
    }
    const component = this.getComponent(this.config);
    this.component = this.containerRef.createComponent(component);
    this.config['elementId'] = this.setElementId(this.config.id);
    this.component.instance.config = this.config;
    this.component.instance.group = this.group;
    this.component.instance.modal = this.modal;
    this.setDependencies();
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  getComponent(config) {
    if (components.hasOwnProperty(config.type)) {
      return components[config.type];
    } else if (config.type === 'custom' && config.hasOwnProperty('customWidget')) {
      return config.customWidget;
    }
  }
  setElementId(configId = '') {
    let id = this.config.elementId ? this.config.elementId : uniqueElementId(configId);
    return `sy_formfield_${id}`;
  }
  setDependencies() {
    if (_.isObject(this.config.dependencies) && _.size(this.config.dependencies)) {
      this.group.valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(changes => {
        let formValueFields = Object.keys(changes);
        let dependenciesValueMatched = !!_.find(this.config.dependencies, (depValue, depField) => {
          let formValueAsArray = [];
          if (!_.isUndefined(changes[depField])) {
            if (Array.isArray(changes[depField]) && changes[depField].length) {
              if (changes[depField][0].hasOwnProperty('_id')) {
                formValueAsArray = formValueAsArray.concat(changes[depField].map(v => v._id));
              } else if (changes[depField][0].hasOwnProperty('id')) {
                formValueAsArray = formValueAsArray.concat(changes[depField].map(v => v.id));
              } else {
                formValueAsArray = formValueAsArray.concat(changes[depField]);
              }
            } else if (changes[depField] && changes[depField].hasOwnProperty('id')) {
              formValueAsArray = formValueAsArray.concat(changes[depField].id);
            } else {
              formValueAsArray = formValueAsArray.concat(changes[depField]);
            }
          }
          return _.includes(formValueFields, depField) && this.depValueMatch(formValueAsArray, depValue);
        });
        if (dependenciesValueMatched !== this.group.get(this.config.name).enabled) {
          if (dependenciesValueMatched) {
            this.group.get(this.config.name).enable();
          } else {
            this.group.get(this.config.name).disable();
          }
        }
        this.component.instance.config.hideField = !dependenciesValueMatched;
      });
    }
  }
  depValueMatch(formValue, depValue) {
    let match;
    const hasValue = formValue.some(v => _.isNumber(v) || !_.isEmpty(v));
    if (['', '*'].includes(depValue[0])) {
      match = depValue[0] === '' && !hasValue || depValue[0] === '*' && hasValue;
    } else {
      const comparisonFn = (a, b) => ['string', 'number'].includes(typeof a) ? a == b : _.isEqual(a, b);
      match = !!_.intersectionWith(formValue, depValue, comparisonFn).length;
      const reverseDependency = _.get(this.config, 'reverseDependency');
      if (hasValue && !_.isUndefined(reverseDependency)) {
        match = reverseDependency ? !match : match;
      }
    }
    return match;
  }
  static {
    this.ɵfac = function DynamicFieldDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DynamicFieldDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: DynamicFieldDirective,
      selectors: [["", "dynamicField", ""]],
      inputs: {
        config: "config",
        group: "group",
        modal: "modal",
        value: "value"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFieldDirective, [{
    type: Directive,
    args: [{
      selector: '[dynamicField]',
      standalone: false
    }]
  }], () => [{
    type: i0.ViewContainerRef
  }], {
    config: [{
      type: Input
    }],
    group: [{
      type: Input
    }],
    modal: [{
      type: Input
    }],
    value: [{
      type: Input
    }]
  });
})();
const _c0$16 = a0 => ({
  "form-readonly": a0
});
const _c1$S = a0 => ({
  object_type: a0
});
const _c2$G = a0 => ({
  field_name: a0
});
const _c3$s = (a0, a1) => ({
  field_name: a0,
  max: a1
});
const _c4$o = (a0, a1) => ({
  field_name: a0,
  min: a1
});
function FormComponent_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "span", 10);
    i0.ɵɵlistener("click", function FormComponent_div_1_div_1_Template_span_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hideMessage());
    });
    i0.ɵɵtext(2, "X");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 1, "misc.Record saved successfully", i0.ɵɵpureFunction1(4, _c1$S, ctx_r1.objectType)), " ");
  }
}
function FormComponent_div_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "span", 10);
    i0.ɵɵlistener("click", function FormComponent_div_1_div_3_Template_span_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hideMessage());
    });
    i0.ɵɵtext(2, "X");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "misc.Object Update Error"), " ");
  }
}
function FormComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormComponent_div_1_div_1_Template, 5, 6, "div", 7);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, FormComponent_div_1_div_3_Template, 5, 3, "div", 8);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r1.config.successStatus));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(4, 4, ctx_r1.config.successStatus));
  }
}
function FormComponent_div_2_ng_container_4_li_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c2$G, field_r4.label)), " ");
  }
}
function FormComponent_div_2_ng_container_4_li_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "misc.invalid email error"), " ");
  }
}
function FormComponent_div_2_ng_container_4_li_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "misc.invalid url error"), " ");
  }
}
function FormComponent_div_2_ng_container_4_li_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Max length error", i0.ɵɵpureFunction2(4, _c3$s, field_r4.label, field_r4.errors.maxlength.requiredLength)), " ");
  }
}
function FormComponent_div_2_ng_container_4_li_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Min length error", i0.ɵɵpureFunction2(4, _c4$o, field_r4.label, field_r4.errors.maxlength.requiredLength)), " ");
  }
}
function FormComponent_div_2_ng_container_4_li_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", field_r4.errorMessage, " ");
  }
}
function FormComponent_div_2_ng_container_4_li_1_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", field_r4.errors == null ? null : field_r4.errors.errorMessage, i0.ɵɵsanitizeHtml);
  }
}
function FormComponent_div_2_ng_container_4_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, FormComponent_div_2_ng_container_4_li_1_ng_container_1_Template, 3, 6, "ng-container", 1)(2, FormComponent_div_2_ng_container_4_li_1_ng_container_2_Template, 3, 3, "ng-container", 1)(3, FormComponent_div_2_ng_container_4_li_1_ng_container_3_Template, 3, 3, "ng-container", 1)(4, FormComponent_div_2_ng_container_4_li_1_ng_container_4_Template, 3, 7, "ng-container", 1)(5, FormComponent_div_2_ng_container_4_li_1_ng_container_5_Template, 3, 7, "ng-container", 1)(6, FormComponent_div_2_ng_container_4_li_1_ng_container_6_Template, 2, 1, "ng-container", 1)(7, FormComponent_div_2_ng_container_4_li_1_ng_container_7_Template, 2, 1, "ng-container", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.email);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.maxlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.minlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.responseError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.customError);
  }
}
function FormComponent_div_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormComponent_div_2_ng_container_4_li_1_Template, 8, 7, "li", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors);
  }
}
function FormComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "ul");
    i0.ɵɵtemplate(4, FormComponent_div_2_ng_container_4_Template, 2, 1, "ng-container", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "misc.Errors detected:"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.validationBox);
  }
}
function FormComponent_div_4_ng_container_1_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function FormComponent_div_4_ng_container_1_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.publishForm(ctx_r1.form));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.publishLabel));
  }
}
function FormComponent_div_4_ng_container_1_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function FormComponent_div_4_ng_container_1_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.unpublishForm(ctx_r1.form));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.unpublishLabel));
  }
}
function FormComponent_div_4_ng_container_1_button_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.submitLabel));
  }
}
function FormComponent_div_4_ng_container_1_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function FormComponent_div_4_ng_container_1_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.openEditForm());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.editLabel));
  }
}
function FormComponent_div_4_ng_container_1_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function FormComponent_div_4_ng_container_1_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleCallback(ctx_r1.config.unarchiveFn, "unarchiveWarning"));
    });
    i0.ɵɵtext(1, "misc.Unarchive");
    i0.ɵɵelementEnd();
  }
}
function FormComponent_div_4_ng_container_1_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵlistener("click", function FormComponent_div_4_ng_container_1_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleCallback(ctx_r1.config.deleteFn, "deleteWarning"));
    });
    i0.ɵɵtext(1, "Delete");
    i0.ɵɵelementEnd();
  }
}
function FormComponent_div_4_ng_container_1_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function FormComponent_div_4_ng_container_1_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleCallback(ctx_r1.config.archiveFn, "archiveWarning"));
    });
    i0.ɵɵtext(1, "misc.Archive");
    i0.ɵɵelementEnd();
  }
}
function FormComponent_div_4_ng_container_1_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function FormComponent_div_4_ng_container_1_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.cancel());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.cancelLabel));
  }
}
function FormComponent_div_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormComponent_div_4_ng_container_1_button_1_Template, 3, 3, "button", 16)(2, FormComponent_div_4_ng_container_1_button_2_Template, 3, 3, "button", 17)(3, FormComponent_div_4_ng_container_1_button_3_Template, 3, 3, "button", 18)(4, FormComponent_div_4_ng_container_1_button_4_Template, 3, 3, "button", 17)(5, FormComponent_div_4_ng_container_1_button_5_Template, 2, 0, "button", 19)(6, FormComponent_div_4_ng_container_1_button_6_Template, 2, 0, "button", 20)(7, FormComponent_div_4_ng_container_1_button_7_Template, 2, 0, "button", 19)(8, FormComponent_div_4_ng_container_1_button_8_Template, 3, 3, "button", 21);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.publishFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.unpublishFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.submitFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.editFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.unarchiveFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.deleteFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.archiveFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.submitFn);
  }
}
function FormComponent_div_4_ng_container_2_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function FormComponent_div_4_ng_container_2_button_1_Template_button_click_0_listener() {
      const button_r13 = i0.ɵɵrestoreView(_r12).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.setupValidationBox();
      return i0.ɵɵresetView(button_r13.onClick(ctx_r1.form, button_r13.action));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r13 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", button_r13.class);
    i0.ɵɵattribute("type", button_r13.type);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(button_r13.label);
  }
}
function FormComponent_div_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormComponent_div_4_ng_container_2_button_1_Template, 2, 3, "button", 28);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.customButtons);
  }
}
function FormComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, FormComponent_div_4_ng_container_1_Template, 9, 8, "ng-container", 1)(2, FormComponent_div_4_ng_container_2_Template, 2, 1, "ng-container", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.useCustomButtons);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.useCustomButtons);
  }
}
function FormComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30)(1, "span", 31);
    i0.ɵɵtext(2, "* ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 32);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 1, "misc.indicates a required field"));
  }
}
function FormComponent_div_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 34);
  }
  if (rf & 2) {
    const field_r14 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r14)("group", ctx_r1.form)("value", ctx_r1.resource[field_r14.name]);
  }
}
function FormComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormComponent_div_6_ng_container_1_Template, 1, 3, "ng-container", 33);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.controls);
  }
}
function FormComponent_div_7_div_1_div_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 40);
    i0.ɵɵpipe(1, "safeHtml");
  }
  if (rf & 2) {
    const group_r15 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, group_r15.groupBlurb), i0.ɵɵsanitizeHtml);
  }
}
function FormComponent_div_7_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38)(1, "h2");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, FormComponent_div_7_div_1_div_1_div_3_Template, 2, 3, "div", 39);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r15 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(group_r15.groupTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r15.groupBlurb);
  }
}
function FormComponent_div_7_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 34);
  }
  if (rf & 2) {
    const field_r16 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", field_r16)("group", ctx_r1.form)("value", ctx_r1.resource[field_r16.name]);
  }
}
function FormComponent_div_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtemplate(1, FormComponent_div_7_div_1_div_1_Template, 4, 2, "div", 37)(2, FormComponent_div_7_div_1_ng_container_2_Template, 1, 3, "ng-container", 33);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r15 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("id", group_r15.groupId);
    i0.ɵɵproperty("ngClass", group_r15.styleClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r15.groupTitle || group_r15.groupBlurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", group_r15.controls);
  }
}
function FormComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormComponent_div_7_div_1_Template, 3, 4, "div", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.controlGroups);
  }
}
function FormComponent_div_8_ng_container_1_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function FormComponent_div_8_ng_container_1_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r17);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.publishForm(ctx_r1.form));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.publishLabel));
  }
}
function FormComponent_div_8_ng_container_1_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function FormComponent_div_8_ng_container_1_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.unpublishForm(ctx_r1.form));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.unpublishLabel));
  }
}
function FormComponent_div_8_ng_container_1_button_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.submitLabel));
  }
}
function FormComponent_div_8_ng_container_1_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function FormComponent_div_8_ng_container_1_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r19);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.openEditForm());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.editLabel));
  }
}
function FormComponent_div_8_ng_container_1_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function FormComponent_div_8_ng_container_1_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r20);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleCallback(ctx_r1.config.unarchiveFn, "unarchiveWarning"));
    });
    i0.ɵɵtext(1, "Unarchive");
    i0.ɵɵelementEnd();
  }
}
function FormComponent_div_8_ng_container_1_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function FormComponent_div_8_ng_container_1_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleCallback(ctx_r1.config.deleteFn, "deleteWarning"));
    });
    i0.ɵɵtext(1, "Delete");
    i0.ɵɵelementEnd();
  }
}
function FormComponent_div_8_ng_container_1_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function FormComponent_div_8_ng_container_1_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r22);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleCallback(ctx_r1.config.archiveFn, "archiveWarning", ctx_r1.config.archiveValidationFn));
    });
    i0.ɵɵtext(1, "misc.Archive");
    i0.ɵɵelementEnd();
  }
}
function FormComponent_div_8_ng_container_1_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function FormComponent_div_8_ng_container_1_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r23);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.cancel());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.cancelLabel));
  }
}
function FormComponent_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormComponent_div_8_ng_container_1_button_1_Template, 3, 3, "button", 16)(2, FormComponent_div_8_ng_container_1_button_2_Template, 3, 3, "button", 17)(3, FormComponent_div_8_ng_container_1_button_3_Template, 3, 3, "button", 42)(4, FormComponent_div_8_ng_container_1_button_4_Template, 3, 3, "button", 17)(5, FormComponent_div_8_ng_container_1_button_5_Template, 2, 0, "button", 17)(6, FormComponent_div_8_ng_container_1_button_6_Template, 2, 0, "button", 17)(7, FormComponent_div_8_ng_container_1_button_7_Template, 2, 0, "button", 19)(8, FormComponent_div_8_ng_container_1_button_8_Template, 3, 3, "button", 19);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.publishFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.unpublishFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.submitFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.editFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.unarchiveFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.deleteFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.archiveFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.submitFn);
  }
}
function FormComponent_div_8_ng_container_2_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function FormComponent_div_8_ng_container_2_button_1_Template_button_click_0_listener() {
      const button_r25 = i0.ɵɵrestoreView(_r24).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.setupValidationBox();
      return i0.ɵɵresetView(button_r25.onClick(ctx_r1.form, button_r25.action));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r25 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", button_r25.class);
    i0.ɵɵattribute("type", button_r25.type);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(button_r25.label);
  }
}
function FormComponent_div_8_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormComponent_div_8_ng_container_2_button_1_Template, 2, 3, "button", 28);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.customButtons);
  }
}
function FormComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtemplate(1, FormComponent_div_8_ng_container_1_Template, 9, 8, "ng-container", 1)(2, FormComponent_div_8_ng_container_2_Template, 2, 1, "ng-container", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.useCustomButtons);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.useCustomButtons);
  }
}
class FormComponent {
  constructor(fb, globalService, formErrorService, zone, _viewContainerRef, _route, translate) {
    this.fb = fb;
    this.globalService = globalService;
    this.formErrorService = formErrorService;
    this.zone = zone;
    this._viewContainerRef = _viewContainerRef;
    this._route = _route;
    this.translate = translate;
    this.callbacks = null;
    this.config = undefined;
    this.destroyed = new EventEmitter();
    this.rendered = new EventEmitter();
    this.showReqFieldMsg = true;
    this.success = false;
    this.error = false;
    this.objectType = 'Record';
    this.errorMsg = 'Object Update Error';
    this.enableErrorMsg = false;
    this.validationBox = [];
  }
  ngOnInit() {
    if (!this.config.resourceID && this.config.pKey && this.resource[this.config.pKey]) {
      this.config.resourceID = this.config.resourceID ?? this.resource[this.config.pKey];
    }
    this.success = this.config.success ?? this.success;
    this.error = this.config.error ?? this.error;
    this.errorMsg = this.config.errorMsg ?? this.errorMsg;
    this.objectType = this.config.objectType ?? this.objectType;
    this.objectType = this.translate.instant(this.objectType);
    this.form = this.createGroup();
    this.backendErrorSubscribe();
  }
  ngAfterViewInit() {
    this.rendered.emit();
  }
  backendErrorSubscribe() {
    if (this.config.readOnly === false && this.config.enableValidationBox !== false) {
      this.backendErrorSubscription = this.formErrorService.getFormErrors().subscribe(errorResponse => {
        if (errorResponse) {
          this.validationBox = [];
          const messages = errorResponse.error?.messages;
          const errorList = errorResponse.error?.errors;
          if (messages) {
            messages.forEach(message => {
              this.validationBox.push({
                label: '',
                errors: {
                  responseError: true
                },
                errorMessage: message.text
              });
            });
          }
          if (errorList) {
            if (Array.isArray(errorList) && errorList.every(el => typeof el === 'string')) {
              this.validationBox = errorList.map(error => ({
                label: '',
                errors: {
                  responseError: true
                },
                errorMessage: error
              }));
            }
            if (errorList.error_message) {
              this.validationBox.push({
                label: '',
                errors: {
                  responseError: true
                },
                errorMessage: errorList.error_message
              });
            }
            if (errorList.field_errors) {
              this.addBackendError(errorList.field_errors);
            }
          }
          setTimeout(() => {
            this.formErrorService.setFormErrors(null);
            if (this.validationBox && this.validationBox.length) {
              this.scrollToValidationBox();
            }
          });
        }
      });
    }
  }
  addBackendError(fieldErrors) {
    for (const [key, value] of Object.entries(fieldErrors)) {
      const field = value;
      if (!Array.isArray(value) && !field._error_message) {
        this.addBackendError(value);
      } else {
        if (Array.isArray(value)) {
          for (let error of field) {
            this.validationBox.push({
              label: this.getFieldLabel(key, this.config),
              errors: {
                responseError: true
              },
              errorMessage: error
            });
          }
        } else if (field._error_message) {
          this.validationBox.push({
            label: this.getFieldLabel(key, this.config),
            errors: {
              responseError: true
            },
            errorMessage: field._error_message
          });
        }
      }
    }
  }
  ngOnDestroy() {
    this.id = null;
    this.resource = null;
    this.callbacks = null;
    this.callback = null;
    this.showReqFieldMsg = null;
    this.form = null;
    this.success = null;
    this.error = null;
    this.objectType = null;
    this.errorMsg = null;
    this.enableErrorMsg = null;
    this.validationBox = null;
    if (this.backendErrorSubscription) {
      this.backendErrorSubscription.unsubscribe();
    }
    this.destroyed.emit();
  }
  createGroup(config = this.config) {
    let groups = {};
    let controls = [];
    if (config.useGroupedForm) {
      for (const group of config.controlGroups) {
        if (group.controls.length > 0) {
          group.controls[group.controls.length - 1].lastChild = true;
        }
        controls.push(...group.controls);
      }
    } else {
      controls = config.controls;
    }
    controls.forEach((control, idx) => {
      if (control.type === 'relation') {
        groups[control.name] = new UntypedFormGroup({}, control.validators);
      } else {
        groups[control.name] = new UntypedFormControl(null, control.validators);
      }
    });
    if (controls.length) {
      controls[controls.length - 1].lastChild = true;
    }
    const formGroup = new UntypedFormGroup(groups);
    if (config.disabled) {
      formGroup.disable();
    }
    return formGroup;
  }
  submitForm(f) {
    if (this.config.submitFn instanceof Function) {
      let output = this.getOutput(f);
      this.config.submitFn(output);
      let errorMsg = typeof this.config.enableErrorMsg !== 'undefined' ? this.config.enableErrorMsg : this.enableErrorMsg;
      if (this.config.successStatus) {
        this.enableErrorMsg = false;
        setTimeout(() => {
          this.enableErrorMsg = errorMsg;
        }, 500);
      } else {
        this.enableErrorMsg = errorMsg;
      }
    }
  }
  isFormControlEmptyOrUntouched(control) {
    const formControl = control;
    return formControl.pristine || !formControl.value;
  }
  setupValidationBox(janus = false) {
    if (this.config.readOnly === false && this.config.enableValidationBox !== false) {
      this.validationBox = [];
      this.getFormGroup(this.form);
      if (this.validationBox.length) {
        setTimeout(() => {
          this.scrollToValidationBox(janus);
        });
      }
    }
  }
  scrollToValidationBox(skipFadeAnimation = false) {
    this.zone.runOutsideAngular(() => {
      let validationBoxElem = document.getElementById('validation-box');
      if (!validationBoxElem) {
        return;
      }
      if (skipFadeAnimation) {
        validationBoxElem.scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        });
        validationBoxElem.tabIndex = 0;
        validationBoxElem.focus({
          preventScroll: true
        });
        return;
      }
      validationBoxElem.style.position = 'relative';
      validationBoxElem.style.zIndex = '1051';
      let backdrop = document.createElement('div');
      document.body.appendChild(backdrop);
      backdrop.style.transition = 'background 1s';
      setTimeout(() => {
        backdrop.classList.add('modal-backdrop', 'fade', 'show', 'scrolling-to-error');
        validationBoxElem.tabIndex = -1;
        if (this.config.customValidationScroll !== null) {
          let customElementScroll = document.querySelector(this.config.customValidationScroll.element);
          customElementScroll.scrollTo({
            top: this.config.customValidationScroll.top,
            left: this.config.customValidationScroll.left,
            behavior: 'smooth'
          });
        } else {
          validationBoxElem.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          });
        }
      });
      setTimeout(() => {
        backdrop.style.background = 'transparent';
        validationBoxElem.focus();
      }, 1400);
      setTimeout(() => {
        backdrop.remove();
        validationBoxElem.style.position = '';
        validationBoxElem.style.zIndex = '';
      }, 2500);
    });
  }
  getFormGroup(form) {
    for (const [key, value] of Object.entries(form.controls)) {
      let control = value;
      if (control.status === 'INVALID' && control.errors) {
        this.validationBox.push({
          label: this.getFieldLabel(key, this.config),
          errors: control?.errors
        });
      }
      if (control.controls) {
        this.getFormGroup(control);
      }
    }
  }
  getFieldLabel(key, config) {
    if (config.controlGroups) {
      let label = key;
      for (const groupValue of Object.values(config.controlGroups)) {
        const formGroup = groupValue;
        label = this.labelHandleControls(formGroup, key);
        if (label !== key) {
          return label;
        }
      }
    } else if (config.controls) {
      return this.labelHandleControls(config, key);
    }
    return key;
  }
  labelHandleControls(formGroup, key) {
    if (formGroup?.controls) {
      for (const controlValue of Object.values(formGroup.controls)) {
        const control = controlValue;
        if (control) {
          if (control.id === key) {
            return control.label;
          }
          if (control.config) {
            let label = this.getFieldLabel(key, control.config);
            if (label !== key) {
              return label;
            }
          }
        }
      }
    }
    return key;
  }
  publishForm(f) {
    this.enableErrorMsg = false;
    let output = this.getOutput(f);
    this.config.publishFn(output);
  }
  unpublishForm(f) {
    this.enableErrorMsg = false;
    let output = this.getOutput(f);
    this.config.unpublishFn(output);
  }
  getOutput(f) {
    let output = f.value;
    output.id = this.config.resourceID || null;
    return output;
  }
  cancel() {
    this.form.reset();
    this.closeForm();
  }
  openEditForm() {
    this.config.editFn(this.resource);
  }
  closeForm() {
    this.config.cancelFn ? this.config.cancelFn(this.resource) : this._route.navigate(['/']);
  }
  hideMessage() {
    this.enableErrorMsg = false;
  }
  handleCallback(callbackFn, warningType = '', validationFn = null) {
    if (validationFn) {
      this.handleValidation(callbackFn, warningType, validationFn);
    } else if (warningType) {
      let proceed = this.displayWarning(warningType);
      if (proceed) {
        this.callback(callbackFn);
      }
    } else {
      this.callback(callbackFn);
    }
  }
  handleValidation(callbackFn, warningType = '', validationFn = null) {
    validationFn(this.config.resourceID).subscribe(response => {
      if (response.passed) {
        this.handleCallback(callbackFn, warningType);
      } else {
        this.displayWarning(null, false, response.errorMsg);
      }
    });
  }
  displayWarning(warningType, confirmState = true, msg) {
    let message = msg ? msg : this.globalService.getWarningMsg(warningType);
    if (confirm(message)) {
      return true;
    }
  }
  callback(callbackFn) {
    callbackFn(this.config.resourceID);
    this.cancel();
  }
  markFormGroupTouched(formGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      this.enableErrorMsg = false;
      if (control instanceof UntypedFormGroup) {
        this.markFormGroupTouched(control);
      } else {
        if (Array.isArray(control.controls)) {
          Array.prototype.forEach.call(control.controls, child => {
            this.markFormGroupTouched(child);
          });
        }
      }
    });
  }
  static {
    this.ɵfac = function FormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormComponent)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(GlobalService), i0.ɵɵdirectiveInject(FormErrorService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1$7.Router), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormComponent,
      selectors: [["app-form"]],
      viewQuery: function FormComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(FormGroupDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formGroupDirective = _t.first);
        }
      },
      inputs: {
        id: "id",
        resource: "resource",
        callbacks: "callbacks",
        config: "config"
      },
      outputs: {
        destroyed: "destroyed",
        rendered: "rendered"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([GlobalService])],
      decls: 9,
      vars: 12,
      consts: [[1, "form", 3, "ngClass"], [4, "ngIf"], ["id", "validation-box", "class", "alert error fade show", 4, "ngIf"], [1, "dynamic-form", 3, "ngSubmit", "id", "formGroup"], ["class", "buttonbar buttonbar-top", 4, "ngIf"], ["class", "reqd_msg margin-bottom-xl", 4, "ngIf"], ["class", "buttonbar buttonbar-bottom", 4, "ngIf"], ["class", "alert alert-success alert-dismissible fade show", 4, "ngIf"], ["class", "alert alert-danger alert-dismissible fade show", 4, "ngIf"], [1, "alert", "alert-success", "alert-dismissible", "fade", "show"], ["href", "#", "aria-label", "close", 1, "close", 3, "click"], [1, "alert", "alert-danger", "alert-dismissible", "fade", "show"], ["id", "validation-box", 1, "alert", "error", "fade", "show"], [4, "ngFor", "ngForOf"], [3, "innerHTML"], [1, "buttonbar", "buttonbar-top"], ["type", "button", "class", "input-submit btn_primary primary_btn_text", 3, "click", 4, "ngIf"], ["type", "button", "class", "input-submit", 3, "click", 4, "ngIf"], ["type", "submit", "class", "input-submit btn_primary primary_btn_text btn_submit", 4, "ngIf"], ["type", "button", "class", "input-submit", "translate", "", 3, "click", 4, "ngIf"], ["type", "button", "class", "input-submit btn_delete", 3, "click", 4, "ngIf"], ["type", "button", "class", "input-submit btn_close", "translate", "", 3, "click", 4, "ngIf"], ["type", "button", 1, "input-submit", "btn_primary", "primary_btn_text", 3, "click"], ["type", "button", 1, "input-submit", 3, "click"], ["type", "submit", 1, "input-submit", "btn_primary", "primary_btn_text", "btn_submit"], ["type", "button", "translate", "", 1, "input-submit", 3, "click"], ["type", "button", 1, "input-submit", "btn_delete", 3, "click"], ["type", "button", "translate", "", 1, "input-submit", "btn_close", 3, "click"], ["class", "input-submit", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "input-submit", 3, "click", "ngClass"], [1, "reqd_msg", "margin-bottom-xl"], [1, "req-indicator"], [1, "body-sm"], ["dynamicField", "", 3, "config", "group", "value", 4, "ngFor", "ngForOf"], ["dynamicField", "", 3, "config", "group", "value"], ["class", "fieldgroup", 3, "id", "ngClass", 4, "ngFor", "ngForOf"], [1, "fieldgroup", 3, "id", "ngClass"], ["class", "fg-title", 4, "ngIf"], [1, "fg-title"], ["class", "fg-blurb", 3, "innerHTML", 4, "ngIf"], [1, "fg-blurb", 3, "innerHTML"], [1, "buttonbar", "buttonbar-bottom"], ["type", "submit", "class", "input-submit btn_primary primary_btn_text", 4, "ngIf"], ["type", "submit", 1, "input-submit", "btn_primary", "primary_btn_text"]],
      template: function FormComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, FormComponent_div_1_Template, 5, 6, "div", 1)(2, FormComponent_div_2_Template, 5, 4, "div", 2);
          i0.ɵɵelementStart(3, "form", 3);
          i0.ɵɵlistener("ngSubmit", function FormComponent_Template_form_ngSubmit_3_listener() {
            ctx.form.valid ? ctx.submitForm(ctx.form) : ctx.markFormGroupTouched(ctx.form);
            return ctx.setupValidationBox();
          });
          i0.ɵɵtemplate(4, FormComponent_div_4_Template, 3, 2, "div", 4)(5, FormComponent_div_5_Template, 6, 3, "div", 5)(6, FormComponent_div_6_Template, 2, 1, "div", 1)(7, FormComponent_div_7_Template, 2, 1, "div", 1)(8, FormComponent_div_8_Template, 3, 2, "div", 6);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0$16, ctx.config.readOnly));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.enableErrorMsg);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.validationBox.length);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("id", ctx.config.id);
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.hideButtonbar !== "top" && !ctx.config.modal);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.showReqFieldMsg);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.config.useGroupedForm);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.useGroupedForm);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.hideButtonbar !== "bottom" && !ctx.config.modal);
        }
      },
      dependencies: [i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i1$1.TranslateDirective, DynamicFieldDirective, i1.AsyncPipe, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormComponent, [{
    type: Component,
    args: [{
      selector: 'app-form',
      providers: [GlobalService],
      standalone: false,
      template: "<div class=\"form\" [ngClass]=\"{'form-readonly': config.readOnly}\">\n\t<div *ngIf=\"enableErrorMsg\">\n\t\t<div class=\"alert alert-success alert-dismissible fade show\" *ngIf=\"config.successStatus | async\">\n\t\t\t<span href=\"#\" class=\"close\" aria-label=\"close\" (click)=\"hideMessage()\">X</span>\n\t\t\t{{ 'misc.Record saved successfully' | translate: {object_type: objectType} }}\n\t\t</div>\n\t\t<div class=\"alert alert-danger alert-dismissible fade show\"\n\t\t\t *ngIf=\"!(config.successStatus | async)\">\n\t\t\t<span href=\"#\" class=\"close\" aria-label=\"close\" (click)=\"hideMessage()\">X</span>\n\t\t\t{{ 'misc.Object Update Error' | translate}}\n\t\t</div>\n\t</div>\n\n\t<div id=\"validation-box\" class=\"alert error fade show\" *ngIf=\"validationBox.length\">\n\t\t{{ 'misc.Errors detected:' | translate}}\n\t\t<ul>\n\t\t\t<ng-container *ngFor=\"let field of validationBox\">\n\t\t\t\t<li *ngIf=\"field.errors\">\n\t\t\t\t\t<ng-container *ngIf=\"field.errors?.required\">\n\t\t\t\t\t\t{{ 'misc.Field is required' | translate: {field_name: field.label} }}\n\t\t\t\t\t</ng-container>\n\t\t\t\t\t<ng-container *ngIf=\"field.errors?.email\">\n\t\t\t\t\t\t{{ 'misc.invalid email error' | translate }}\n\t\t\t\t\t</ng-container>\n\t\t\t\t\t<ng-container *ngIf=\"field.errors?.url\">\n\t\t\t\t\t\t{{ 'misc.invalid url error' | translate }}\n\t\t\t\t\t</ng-container>\n\t\t\t\t\t<ng-container *ngIf=\"field.errors?.maxlength\">\n\t\t\t\t\t\t{{ 'misc.Max length error' | translate: {field_name: field.label, max: field.errors.maxlength.requiredLength} }}\n\t\t\t\t\t</ng-container>\n\t\t\t\t\t<ng-container *ngIf=\"field.errors?.minlength\">\n\t\t\t\t\t\t{{ 'misc.Min length error' | translate: {field_name: field.label, min: field.errors.maxlength.requiredLength} }}\n\t\t\t\t\t</ng-container>\n\t\t\t\t\t<ng-container *ngIf=\"field.errors?.responseError\">\n\t\t\t\t\t\t{{ field.errorMessage }}\n\t\t\t\t\t</ng-container>\n\t\t\t\t\t<ng-container *ngIf=\"field.errors?.customError\">\n\t\t\t\t\t\t\t<div [innerHTML]=\"field.errors?.errorMessage\"></div>\n\t\t\t\t\t</ng-container>\n\t\t\t\t</li>\n\t\t\t</ng-container>\n\t\t</ul>\n\t</div>\n\t<form\n\t\tid=\"{{config.id}}\"\n\t\tclass=\"dynamic-form\"\n\t\t[formGroup]=\"form\"\n\t\t(ngSubmit)=\"form.valid ? submitForm(form) : markFormGroupTouched(form); setupValidationBox();\">\n\t\t<div *ngIf=\"config.hideButtonbar !== 'top' && !config.modal\" class=\"buttonbar buttonbar-top\">\n\t\t\t<ng-container *ngIf=\"!config.useCustomButtons\">\n\t\t\t\t<button *ngIf=\"config.publishFn\" type=\"button\" class=\"input-submit btn_primary primary_btn_text\" (click)=\"publishForm(form);\">{{config.publishLabel | translate}}</button>\n\t\t\t\t<button *ngIf=\"config.unpublishFn\" type=\"button\" class=\"input-submit\" (click)=\"unpublishForm(form);\">{{config.unpublishLabel | translate}}</button>\n\t\t\t\t<button *ngIf=\"config.submitFn\" type=\"submit\" class=\"input-submit btn_primary primary_btn_text btn_submit\">{{config.submitLabel | translate}}</button>\n\t\t\t\t<button *ngIf=\"config.editFn\" type=\"button\" class=\"input-submit\" (click)=\"openEditForm()\">{{config.editLabel | translate}}</button>\n\t\t\t\t<button *ngIf=\"config.unarchiveFn\" type=\"button\" class=\"input-submit\" (click)=\"handleCallback(config.unarchiveFn, 'unarchiveWarning')\" translate>misc.Unarchive</button>\n\t\t\t\t<button *ngIf=\"config.deleteFn\" type=\"button\" class=\"input-submit btn_delete\" (click)=\"handleCallback(config.deleteFn, 'deleteWarning')\">Delete</button>\n\t\t\t\t<button *ngIf=\"config.archiveFn\" type=\"button\" class=\"input-submit\" (click)=\"handleCallback(config.archiveFn, 'archiveWarning')\" translate>misc.Archive</button>\n\t\t\t\t<button *ngIf=\"config.submitFn\" type=\"button\" class=\"input-submit btn_close\" (click)=\"cancel()\" translate>{{config.cancelLabel | translate}}</button>\n\t\t\t</ng-container>\n\t\t\t<ng-container *ngIf=\"config.useCustomButtons\">\n\t\t\t\t<button *ngFor=\"let button of config.customButtons\" [attr.type]=\"button.type\" class=\"input-submit\" [ngClass]=\"button.class\" (click)=\"setupValidationBox(); button.onClick(form, button.action);\">{{button.label}}</button>\n\t\t\t</ng-container>\n\t\t</div>\n        <div class=\"reqd_msg margin-bottom-xl\" *ngIf=\"config.showReqFieldMsg\"><span class=\"req-indicator\">* </span><span class=\"body-sm\">{{'misc.indicates a required field' | translate}}</span></div>\n\t\t<div *ngIf=\"!config.useGroupedForm\">\n\t\t\t<ng-container *ngFor=\"let field of config.controls\" dynamicField [config]=\"field\" [group]=\"form\" [value]=\"resource[field.name]\"></ng-container>\n\t\t</div>\n\t\t<div *ngIf=\"config.useGroupedForm\">\n\t\t\t<div *ngFor=\"let group of config.controlGroups\" id=\"{{group.groupId}}\" class=\"fieldgroup\" [ngClass]=\"group.styleClass\">\n\t\t\t\t<div *ngIf=\"group.groupTitle || group.groupBlurb\" class=\"fg-title\">\n                                        <h2>{{group.groupTitle}}</h2>\n                                        <div *ngIf=\"group.groupBlurb\" [innerHTML]=\"group.groupBlurb | safeHtml\" class=\"fg-blurb\"></div>\n                                </div>\n\t\t\t\t<ng-container *ngFor=\"let field of group.controls\" dynamicField [config]=\"field\" [group]=\"form\" [value]=\"resource[field.name]\"></ng-container>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div *ngIf=\"config.hideButtonbar !== 'bottom' && !config.modal\" class=\"buttonbar buttonbar-bottom\">\n\t\t\t<ng-container *ngIf=\"!config.useCustomButtons\">\n\t\t\t\t<button *ngIf=\"config.publishFn\" type=\"button\" class=\"input-submit btn_primary primary_btn_text\" (click)=\"publishForm(form);\">{{config.publishLabel | translate}}</button>\n\t\t\t\t<button *ngIf=\"config.unpublishFn\" type=\"button\" class=\"input-submit\" (click)=\"unpublishForm(form);\">{{config.unpublishLabel | translate}}</button>\n\t\t\t\t<button *ngIf=\"config.submitFn\" type=\"submit\" class=\"input-submit btn_primary primary_btn_text\">{{config.submitLabel | translate}}</button>\n\t\t\t\t<button *ngIf=\"config.editFn\" type=\"button\" class=\"input-submit\" (click)=\"openEditForm()\">{{config.editLabel | translate}}</button>\n\t\t\t\t<button *ngIf=\"config.unarchiveFn\" type=\"button\" class=\"input-submit\" (click)=\"handleCallback(config.unarchiveFn, 'unarchiveWarning')\">Unarchive</button>\n\t\t\t\t<button *ngIf=\"config.deleteFn\" type=\"button\" class=\"input-submit\" (click)=\"handleCallback(config.deleteFn, 'deleteWarning')\">Delete</button>\n\t\t\t\t<button *ngIf=\"config.archiveFn\" type=\"button\" class=\"input-submit\" (click)=\"handleCallback(config.archiveFn, 'archiveWarning', config.archiveValidationFn)\" translate>misc.Archive</button>\n\t\t\t\t<button *ngIf=\"config.submitFn\" type=\"button\" class=\"input-submit\" (click)=\"cancel()\" translate>{{config.cancelLabel | translate}}</button>\n\t\t\t</ng-container>\n\t\t\t<ng-container *ngIf=\"config.useCustomButtons\">\n\t\t\t\t<button *ngFor=\"let button of config.customButtons\" [attr.type]=\"button.type\" class=\"input-submit\" [ngClass]=\"button.class\" (click)=\"setupValidationBox(); button.onClick(form, button.action)\">{{button.label}}</button>\n\t\t\t</ng-container>\n\t\t</div>\n\t</form>\n</div>\n"
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }, {
    type: GlobalService
  }, {
    type: FormErrorService
  }, {
    type: i0.NgZone
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i1$7.Router
  }, {
    type: i1$1.TranslateService
  }], {
    id: [{
      type: Input
    }],
    resource: [{
      type: Input
    }],
    callbacks: [{
      type: Input
    }],
    config: [{
      type: Input
    }],
    destroyed: [{
      type: Output
    }],
    rendered: [{
      type: Output
    }],
    formGroupDirective: [{
      type: ViewChild,
      args: [FormGroupDirective]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormComponent, {
    className: "FormComponent",
    filePath: "common/form.component.ts",
    lineNumber: 16
  });
})();
function FormModalComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "p", 13);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "safeHtml");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(3, 3, i0.ɵɵpipeBind1(2, 1, ctx_r0.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function FormModalComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("* ", i0.ɵɵpipeBind1(2, 1, "misc.indicates a required field"), "");
  }
}
function FormModalComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 15);
  }
  if (rf & 2) {
    const field_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("config", field_r2)("group", ctx_r0.form)("modal", true);
  }
}
function FormModalComponent_ng_container_13_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function FormModalComponent_ng_container_13_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.cancel());
    });
    i0.ɵɵtext(1, "misc.Cancel");
    i0.ɵɵelementEnd();
  }
}
function FormModalComponent_ng_container_13_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function FormModalComponent_ng_container_13_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.cancel());
    });
    i0.ɵɵtext(1, "misc.Close");
    i0.ɵɵelementEnd();
  }
}
function FormModalComponent_ng_container_13_button_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.config.submitLabel));
  }
}
function FormModalComponent_ng_container_13_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function FormModalComponent_ng_container_13_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.openEditForm());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.config.editLabel));
  }
}
function FormModalComponent_ng_container_13_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function FormModalComponent_ng_container_13_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleCallback(ctx_r0.config.unarchiveFn, "unarchiveWarning"));
    });
    i0.ɵɵtext(1, "misc.Unarchive");
    i0.ɵɵelementEnd();
  }
}
function FormModalComponent_ng_container_13_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function FormModalComponent_ng_container_13_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleCallback(ctx_r0.config.deleteFn, "deleteWarning"));
    });
    i0.ɵɵtext(1, "misc.Delete");
    i0.ɵɵelementEnd();
  }
}
function FormModalComponent_ng_container_13_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function FormModalComponent_ng_container_13_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleCallback(ctx_r0.config.archiveFn, "archiveWarning", ctx_r0.config.archiveValidationFn));
    });
    i0.ɵɵtext(1, "misc.Archive");
    i0.ɵɵelementEnd();
  }
}
function FormModalComponent_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormModalComponent_ng_container_13_button_1_Template, 2, 0, "button", 16)(2, FormModalComponent_ng_container_13_button_2_Template, 2, 0, "button", 16)(3, FormModalComponent_ng_container_13_button_3_Template, 3, 3, "button", 17)(4, FormModalComponent_ng_container_13_button_4_Template, 3, 3, "button", 18)(5, FormModalComponent_ng_container_13_button_5_Template, 2, 0, "button", 16)(6, FormModalComponent_ng_container_13_button_6_Template, 2, 0, "button", 16)(7, FormModalComponent_ng_container_13_button_7_Template, 2, 0, "button", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.submitFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.submitFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.submitFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.editFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.unarchiveFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.deleteFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.archiveFn);
  }
}
function FormModalComponent_ng_container_14_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function FormModalComponent_ng_container_14_button_1_Template_button_click_0_listener() {
      const button_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(button_r10.onClick(ctx_r0.form, button_r10.action));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r10 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", button_r10.class);
    i0.ɵɵattribute("type", button_r10.type);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(button_r10.label);
  }
}
function FormModalComponent_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormModalComponent_ng_container_14_button_1_Template, 2, 3, "button", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.customButtons);
  }
}
class FormModalComponent {
  constructor(activeModal, _modalService, fb, globalService, elementRef) {
    this.activeModal = activeModal;
    this._modalService = _modalService;
    this.fb = fb;
    this.globalService = globalService;
    this.elementRef = elementRef;
    this.callbacks = null;
    this.config = null;
    this.blurb = '';
    this.showReqFieldMsg = true;
  }
  ngOnInit() {
    if (this.callbacks) {
      this.config.setCallbacks(this.callbacks);
    }
    switch (this.modalId) {
      case 'createCareerPlanTask':
      case 'editCareerPlanTask':
        this.config.resourceID = this.resource && this.resource.career_plan_task_id;
        break;
      case 'chatInstructions':
        this.config.resourceID = this.resource && this.config.id;
        break;
      default:
        this.config.resourceID = this.resource && this.resource.career_plan_step_id;
    }
    this.form = this.createGroup();
  }
  ngAfterViewInit() {
    if (this.config.controls && this.config.controls.length) {
      let target = this.config.controls[0].elementId;
      let element = this.elementRef.nativeElement.querySelector('#' + target + 'modal');
      if (element) {
        element.focus();
      }
    }
  }
  createGroup(config = this.config) {
    const group = this.fb.group({});
    config.controls.forEach(control => group.addControl(control.name, this.fb.control(null, control.validators)));
    return group;
  }
  submitForm(f) {
    if (this.config.submitFn instanceof Function) {
      let output = f.value;
      output.id = this.config.resourceID;
      this.config.submitFn(output);
      this.activeModal.close(f);
    }
  }
  cancel() {
    this.form.reset();
    this.activeModal.dismiss();
  }
  openEditForm() {
    this.config.editFn(this.resource);
    this.cancel();
  }
  handleCallback(callbackFn, warningType = '', validationFn = null) {
    if (validationFn) {
      this.handleValidation(callbackFn, warningType, validationFn);
    } else if (warningType) {
      this.displayWarning(warningType).then(proceed => {
        if (proceed) {
          this.callback(callbackFn);
        }
      });
    } else {
      this.callback(callbackFn);
    }
  }
  handleValidation(callbackFn, warningType = '', validationFn = null) {
    validationFn(this.config.resourceID).subscribe(response => {
      if (response.passed) {
        this.handleCallback(callbackFn, warningType);
      } else {
        this.displayWarning(null, false, response.errorMsg);
      }
    });
  }
  displayWarning(warningType, confirm = true, msg) {
    const modalRef = this._modalService.open(WarningModalComponent);
    modalRef.componentInstance.msg = msg ? msg : this.globalService.getWarningMsg(warningType);
    modalRef.componentInstance.confirm = confirm;
    return modalRef.result;
  }
  callback(callbackFn) {
    callbackFn(this.config.resourceID);
    this.cancel();
  }
  markFormGroupTouched(formGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }
  static {
    this.ɵfac = function FormModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormModalComponent)(i0.ɵɵdirectiveInject(i1$4.NgbActiveModal), i0.ɵɵdirectiveInject(i1$4.NgbModal), i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(GlobalService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormModalComponent,
      selectors: [["app-form-modal"]],
      inputs: {
        modalId: "modalId",
        resource: "resource",
        callbacks: "callbacks",
        config: "config",
        blurb: "blurb",
        styleClasses: "styleClasses"
      },
      standalone: false,
      decls: 15,
      vars: 14,
      consts: [[1, "dynamic-form", 3, "ngSubmit", "id", "formGroup"], [1, "modal-header", 3, "ngClass"], ["id", "myModalLabel", 1, "modal-title"], ["type", "button", "aria-label", "Close", 1, "modal-close", 3, "click"], [1, "modal-body", 3, "ngClass"], ["class", "blurb field-blurb", 4, "ngIf"], ["class", "reqd_msg req-indicator", 4, "ngIf"], ["dynamicField", "", 3, "config", "group", "modal", 4, "ngFor", "ngForOf"], ["type", "hidden", "name", "formName", 3, "value"], [1, "modal-footer", 3, "ngClass"], [1, "margin-auto"], [4, "ngIf"], [1, "blurb", "field-blurb"], [3, "innerHTML"], [1, "reqd_msg", "req-indicator"], ["dynamicField", "", 3, "config", "group", "modal"], ["type", "button", "class", "input-submit", "flow-btn", "", "translate", "", 3, "click", 4, "ngIf"], ["type", "submit", "class", "input-submit btn_primary primary_btn_text", "flow-btn", "", 4, "ngIf"], ["type", "button", "class", "input-submit", "flow-btn", "", 3, "click", 4, "ngIf"], ["type", "button", "flow-btn", "", "translate", "", 1, "input-submit", 3, "click"], ["type", "submit", "flow-btn", "", 1, "input-submit", "btn_primary", "primary_btn_text"], ["type", "button", "flow-btn", "", 1, "input-submit", 3, "click"], ["flow-btn", "", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["flow-btn", "", 3, "click", "ngClass"]],
      template: function FormModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "form", 0);
          i0.ɵɵlistener("ngSubmit", function FormModalComponent_Template_form_ngSubmit_0_listener() {
            return ctx.form.valid ? ctx.submitForm(ctx.form) : ctx.markFormGroupTouched(ctx.form);
          });
          i0.ɵɵelementStart(1, "div", 1)(2, "h3", 2);
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "button", 3);
          i0.ɵɵlistener("click", function FormModalComponent_Template_button_click_5_listener() {
            return ctx.cancel();
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(6, "div", 4);
          i0.ɵɵtemplate(7, FormModalComponent_div_7_Template, 4, 5, "div", 5)(8, FormModalComponent_div_8_Template, 3, 3, "div", 6)(9, FormModalComponent_ng_container_9_Template, 1, 3, "ng-container", 7);
          i0.ɵɵelement(10, "input", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(11, "div", 9)(12, "div", 10);
          i0.ɵɵtemplate(13, FormModalComponent_ng_container_13_Template, 8, 7, "ng-container", 11)(14, FormModalComponent_ng_container_14_Template, 2, 1, "ng-container", 11);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵpropertyInterpolate("id", ctx.config.id);
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.styleClasses == null ? null : ctx.styleClasses.header);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 12, ctx.config.title));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngClass", ctx.styleClasses == null ? null : ctx.styleClasses.body);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.blurb);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.showReqFieldMsg);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.config.controls);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("value", ctx.modalId);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.styleClasses == null ? null : ctx.styleClasses.footer);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.config.useCustomButtons);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.useCustomButtons);
        }
      },
      dependencies: [i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i1$1.TranslateDirective, DynamicFieldDirective, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: [".dynamic-form .close[type=button]{box-shadow:none;background:none;opacity:100}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormModalComponent, [{
    type: Component,
    args: [{
      selector: 'app-form-modal',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<form id=\"{{config.id}}\" class=\"dynamic-form\" [formGroup]=\"form\" (ngSubmit)=\"form.valid ? submitForm(form) : markFormGroupTouched(form);\">\n\t<div class=\"modal-header\" [ngClass]=\"styleClasses?.header\">\n\t\t<h3 class=\"modal-title\" id=\"myModalLabel\">{{config.title | translate}}</h3>\n\t\t<button type=\"button\" class=\"modal-close\" (click)=\"cancel()\" aria-label=\"Close\"></button>\n\t</div>\n\t<div class=\"modal-body\" [ngClass]=\"styleClasses?.body\">\n\t\t<div *ngIf=\"blurb\" class=\"blurb field-blurb\">\n\t\t\t<p [innerHTML]=\"blurb | translate | safeHtml\"></p>\n\t\t</div>\n\t\t<div class=\"reqd_msg req-indicator\" *ngIf=\"!showReqFieldMsg\">* {{'misc.indicates a required field' | translate}}</div>\n\t\t<ng-container *ngFor=\"let field of config.controls\" dynamicField [config]=\"field\" [group]=\"form\" [modal]=\"true\"></ng-container>\n\t\t<input type=\"hidden\" name=\"formName\" value={{modalId}}>\n\t</div>\n\t<div class=\"modal-footer\" [ngClass]=\"styleClasses?.footer\">\n\t\t<div class=\"margin-auto\">\n\t\t\t<ng-container *ngIf=\"!config.useCustomButtons\">\n\t\t\t\t<button *ngIf=\"config.submitFn\" type=\"button\" class=\"input-submit\" (click)=\"cancel()\" flow-btn translate>misc.Cancel</button>\n\t\t\t\t<button *ngIf=\"!config.submitFn\" type=\"button\" class=\"input-submit\" (click)=\"cancel()\" flow-btn translate>misc.Close</button>\n\t\t\t\t<button *ngIf=\"config.submitFn\" type=\"submit\" class=\"input-submit btn_primary primary_btn_text\" flow-btn>{{config.submitLabel | translate}}</button>\n\t\t\t\t<button *ngIf=\"config.editFn\" type=\"button\" class=\"input-submit\" (click)=\"openEditForm()\" flow-btn>{{config.editLabel\n\t\t\t\t\t| translate}}</button>\n\t\t\t\t<button *ngIf=\"config.unarchiveFn\" type=\"button\" class=\"input-submit\" (click)=\"handleCallback(config.unarchiveFn, 'unarchiveWarning')\" flow-btn translate>misc.Unarchive</button>\n\t\t\t\t<button *ngIf=\"config.deleteFn\" type=\"button\" class=\"input-submit\" (click)=\"handleCallback(config.deleteFn, 'deleteWarning')\" flow-btn translate>misc.Delete</button>\n\t\t\t\t<button *ngIf=\"config.archiveFn\" type=\"button\" class=\"input-submit\" (click)=\"handleCallback(config.archiveFn, 'archiveWarning', config.archiveValidationFn)\" flow-btn translate>misc.Archive</button>\n\t\t\t</ng-container>\n\t\t\t<ng-container *ngIf=\"config.useCustomButtons\">\n\t\t\t\t<button *ngFor=\"let button of config.customButtons\" [attr.type]=\"button.type\" [ngClass]=\"button.class\" (click)=\"button.onClick(form, button.action)\" flow-btn>{{button.label}}</button>\n\t\t\t</ng-container>\n\t\t</div>\n\t</div>\n</form>\n",
      styles: [".dynamic-form .close[type=button]{box-shadow:none;background:none;opacity:100}\n"]
    }]
  }], () => [{
    type: i1$4.NgbActiveModal
  }, {
    type: i1$4.NgbModal
  }, {
    type: i2$1.UntypedFormBuilder
  }, {
    type: GlobalService
  }, {
    type: i0.ElementRef
  }], {
    modalId: [{
      type: Input
    }],
    resource: [{
      type: Input
    }],
    callbacks: [{
      type: Input
    }],
    config: [{
      type: Input
    }],
    blurb: [{
      type: Input
    }],
    styleClasses: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormModalComponent, {
    className: "FormModalComponent",
    filePath: "common/form-modal.component.ts",
    lineNumber: 15
  });
})();
function FormModalExtendedComponent_div_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 10);
  }
  if (rf & 2) {
    const field_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r1)("group", ctx_r1.form)("value", ctx_r1.resource[field_r1.name]);
  }
}
function FormModalExtendedComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormModalExtendedComponent_div_9_ng_container_1_Template, 1, 3, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.controls);
  }
}
function FormModalExtendedComponent_div_10_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "h2");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const group_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(group_r3.groupTitle);
  }
}
function FormModalExtendedComponent_div_10_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 10);
  }
  if (rf & 2) {
    const field_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", field_r4)("group", ctx_r1.form)("value", ctx_r1.resource[field_r4.name]);
  }
}
function FormModalExtendedComponent_div_10_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, FormModalExtendedComponent_div_10_div_1_div_1_Template, 3, 1, "div", 13)(2, FormModalExtendedComponent_div_10_div_1_ng_container_2_Template, 1, 3, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r3 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("id", group_r3.groupId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r3.groupTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", group_r3.controls);
  }
}
function FormModalExtendedComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormModalExtendedComponent_div_10_div_1_Template, 3, 3, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.controlGroups);
  }
}
function FormModalExtendedComponent_ng_container_13_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function FormModalExtendedComponent_ng_container_13_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.cancel());
    });
    i0.ɵɵtext(1, "misc.Cancel");
    i0.ɵɵelementEnd();
  }
}
function FormModalExtendedComponent_ng_container_13_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function FormModalExtendedComponent_ng_container_13_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.cancel());
    });
    i0.ɵɵtext(1, "misc.Close");
    i0.ɵɵelementEnd();
  }
}
function FormModalExtendedComponent_ng_container_13_button_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.submitLabel));
  }
}
function FormModalExtendedComponent_ng_container_13_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function FormModalExtendedComponent_ng_container_13_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.openEditForm());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.editLabel));
  }
}
function FormModalExtendedComponent_ng_container_13_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function FormModalExtendedComponent_ng_container_13_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleCallback(ctx_r1.config.unarchiveFn, "unarchiveWarning"));
    });
    i0.ɵɵtext(1, "misc.Unarchive");
    i0.ɵɵelementEnd();
  }
}
function FormModalExtendedComponent_ng_container_13_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function FormModalExtendedComponent_ng_container_13_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleCallback(ctx_r1.config.deleteFn, "deleteWarning"));
    });
    i0.ɵɵtext(1, "misc.Delete");
    i0.ɵɵelementEnd();
  }
}
function FormModalExtendedComponent_ng_container_13_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function FormModalExtendedComponent_ng_container_13_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleCallback(ctx_r1.config.archiveFn, "archiveWarning", ctx_r1.config.archiveValidationFn));
    });
    i0.ɵɵtext(1, "misc.Archive");
    i0.ɵɵelementEnd();
  }
}
function FormModalExtendedComponent_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormModalExtendedComponent_ng_container_13_button_1_Template, 2, 0, "button", 15)(2, FormModalExtendedComponent_ng_container_13_button_2_Template, 2, 0, "button", 15)(3, FormModalExtendedComponent_ng_container_13_button_3_Template, 3, 3, "button", 16)(4, FormModalExtendedComponent_ng_container_13_button_4_Template, 3, 3, "button", 17)(5, FormModalExtendedComponent_ng_container_13_button_5_Template, 2, 0, "button", 15)(6, FormModalExtendedComponent_ng_container_13_button_6_Template, 2, 0, "button", 15)(7, FormModalExtendedComponent_ng_container_13_button_7_Template, 2, 0, "button", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.submitFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.submitFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.submitFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.editFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.unarchiveFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.deleteFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.archiveFn);
  }
}
function FormModalExtendedComponent_ng_container_14_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function FormModalExtendedComponent_ng_container_14_button_1_Template_button_click_0_listener() {
      const button_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(button_r12.onClick(ctx_r1.form, button_r12.action));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r12 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", button_r12.class);
    i0.ɵɵattribute("disabled", button_r12.disabled ? true : null)("type", button_r12.type);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 4, button_r12.label));
  }
}
function FormModalExtendedComponent_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormModalExtendedComponent_ng_container_14_button_1_Template, 3, 6, "button", 21);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.customButtons);
  }
}
class FormModalExtendedComponent extends FormComponent {
  constructor(activeModal, _modalService, _viewContainerRef, fb, _route, translate, globalService, formErrorService, zone) {
    super(fb, globalService, formErrorService, zone, _viewContainerRef, _route, translate);
    this.activeModal = activeModal;
    this._modalService = _modalService;
    this._viewContainerRef = _viewContainerRef;
    this.fb = fb;
    this._route = _route;
    this.translate = translate;
    this.globalService = globalService;
    this.formErrorService = formErrorService;
    this.zone = zone;
    this.callbacks = null;
    this.config = null;
  }
  ngOnInit() {
    this.form = this.createGroup();
  }
  static {
    this.ɵfac = function FormModalExtendedComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormModalExtendedComponent)(i0.ɵɵdirectiveInject(i1$4.NgbActiveModal), i0.ɵɵdirectiveInject(i1$4.NgbModal), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(i1$7.Router), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(GlobalService), i0.ɵɵdirectiveInject(FormErrorService), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormModalExtendedComponent,
      selectors: [["app-form-modal-extended"]],
      inputs: {
        modalId: "modalId",
        resource: "resource",
        callbacks: "callbacks",
        config: "config"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 15,
      vars: 12,
      consts: [[1, "modal-header"], ["id", "myModalLabel", 1, "modal-title"], ["type", "button", 1, "close", "btn", "btn_link", 3, "click"], [1, "list-action-icn", "icn-close"], [1, "modal-body"], [1, "dynamic-form", 3, "ngSubmit", "id", "formGroup"], [4, "ngIf"], [1, "modal-footer"], [1, "margin-auto"], ["dynamicField", "", 3, "config", "group", "value", 4, "ngFor", "ngForOf"], ["dynamicField", "", 3, "config", "group", "value"], ["class", "fieldgroup", 3, "id", 4, "ngFor", "ngForOf"], [1, "fieldgroup", 3, "id"], ["class", "fg-title", 4, "ngIf"], [1, "fg-title"], ["type", "button", "class", "input-submit", "flow-btn", "", "translate", "", 3, "click", 4, "ngIf"], ["type", "submit", "class", "input-submit btn_primary primary_btn_text", "flow-btn", "", 4, "ngIf"], ["type", "button", "class", "input-submit", "flow-btn", "", 3, "click", 4, "ngIf"], ["type", "button", "flow-btn", "", "translate", "", 1, "input-submit", 3, "click"], ["type", "submit", "flow-btn", "", 1, "input-submit", "btn_primary", "primary_btn_text"], ["type", "button", "flow-btn", "", 1, "input-submit", 3, "click"], ["flow-btn", "", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["flow-btn", "", 3, "click", "ngClass"]],
      template: function FormModalExtendedComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "h3", 1);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "button", 2);
          i0.ɵɵpipe(5, "translate");
          i0.ɵɵlistener("click", function FormModalExtendedComponent_Template_button_click_4_listener() {
            return ctx.activeModal.close();
          });
          i0.ɵɵelement(6, "i", 3);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(7, "div", 4)(8, "form", 5);
          i0.ɵɵlistener("ngSubmit", function FormModalExtendedComponent_Template_form_ngSubmit_8_listener() {
            return ctx.form.valid ? ctx.submitForm(ctx.form) : ctx.markFormGroupTouched(ctx.form);
          });
          i0.ɵɵtemplate(9, FormModalExtendedComponent_div_9_Template, 2, 1, "div", 6)(10, FormModalExtendedComponent_div_10_Template, 2, 1, "div", 6);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(11, "div", 7)(12, "div", 8);
          i0.ɵɵtemplate(13, FormModalExtendedComponent_ng_container_13_Template, 8, 7, "ng-container", 6)(14, FormModalExtendedComponent_ng_container_14_Template, 2, 1, "ng-container", 6);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 8, ctx.config.title));
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 10, "misc.Close"));
          i0.ɵɵadvance(4);
          i0.ɵɵpropertyInterpolate("id", ctx.config.id);
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.config.useGroupedForm);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.useGroupedForm);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", !ctx.config.useCustomButtons);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.useCustomButtons);
        }
      },
      dependencies: [i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i1$1.TranslateDirective, DynamicFieldDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormModalExtendedComponent, [{
    type: Component,
    args: [{
      selector: 'app-form-modal-extended',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"myModalLabel\">{{config.title | translate}}</h3>\n    <button type=\"button\" class=\"close btn btn_link\" (click)=\"activeModal.close()\" [attr.aria-label]=\"'misc.Close' | translate\">\n        <i class=\"list-action-icn icn-close\"></i>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <form\n            id=\"{{config.id}}\"\n            class=\"dynamic-form\"\n            [formGroup]=\"form\"\n            (ngSubmit)=\"form.valid ? submitForm(form) : markFormGroupTouched(form);\">\n        <div *ngIf=\"!config.useGroupedForm\">\n            <ng-container *ngFor=\"let field of config.controls\" dynamicField [config]=\"field\" [group]=\"form\" [value]=\"resource[field.name]\"></ng-container>\n        </div>\n        <div *ngIf=\"config.useGroupedForm\">\n            <div *ngFor=\"let group of config.controlGroups\" id=\"{{group.groupId}}\" class=\"fieldgroup\">\n                <div *ngIf=\"group.groupTitle\" class=\"fg-title\">\n                    <h2>{{group.groupTitle}}</h2>\n                </div>\n                <ng-container *ngFor=\"let field of group.controls\" dynamicField [config]=\"field\" [group]=\"form\" [value]=\"resource[field.name]\"></ng-container>\n            </div>\n        </div>\n    </form>\n</div>\n\n<div class=\"modal-footer\">\n    <div class=\"margin-auto\">\n        <ng-container *ngIf=\"!config.useCustomButtons\">\n            <button *ngIf=\"config.submitFn\" type=\"button\" class=\"input-submit\" (click)=\"cancel()\" flow-btn translate>misc.Cancel</button>\n            <button *ngIf=\"!config.submitFn\" type=\"button\" class=\"input-submit\" (click)=\"cancel()\" flow-btn translate>misc.Close</button>\n            <button *ngIf=\"config.submitFn\" type=\"submit\" class=\"input-submit btn_primary primary_btn_text\" flow-btn>{{config.submitLabel | translate}}</button>\n            <button *ngIf=\"config.editFn\" type=\"button\" class=\"input-submit\" (click)=\"openEditForm()\" flow-btn>{{config.editLabel\n                | translate}}</button>\n            <button *ngIf=\"config.unarchiveFn\" type=\"button\" class=\"input-submit\" (click)=\"handleCallback(config.unarchiveFn, 'unarchiveWarning')\" flow-btn translate>misc.Unarchive</button>\n            <button *ngIf=\"config.deleteFn\" type=\"button\" class=\"input-submit\" (click)=\"handleCallback(config.deleteFn, 'deleteWarning')\" flow-btn translate>misc.Delete</button>\n            <button *ngIf=\"config.archiveFn\" type=\"button\" class=\"input-submit\" (click)=\"handleCallback(config.archiveFn, 'archiveWarning', config.archiveValidationFn)\" flow-btn translate>misc.Archive</button>\n        </ng-container>\n        <ng-container *ngIf=\"config.useCustomButtons\">\n            <button *ngFor=\"let button of config.customButtons\" [attr.disabled]=\"button.disabled ? true : null\" [attr.type]=\"button.type\" [ngClass]=\"button.class\" (click)=\"button.onClick(form, button.action)\" flow-btn>{{button.label | translate}}</button>\n        </ng-container>\n    </div>\n</div>"
    }]
  }], () => [{
    type: i1$4.NgbActiveModal
  }, {
    type: i1$4.NgbModal
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i2$1.UntypedFormBuilder
  }, {
    type: i1$7.Router
  }, {
    type: i1$1.TranslateService
  }, {
    type: GlobalService
  }, {
    type: FormErrorService
  }, {
    type: i0.NgZone
  }], {
    modalId: [{
      type: Input
    }],
    resource: [{
      type: Input
    }],
    callbacks: [{
      type: Input
    }],
    config: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormModalExtendedComponent, {
    className: "FormModalExtendedComponent",
    filePath: "common/form-modal-extended.component.ts",
    lineNumber: 18
  });
})();
function FormSidebarComponent_ng_container_0_ng_container_1_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 8);
  }
  if (rf & 2) {
    const field_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", field_r3)("group", ctx_r1.form);
  }
}
function FormSidebarComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "div", 3)(3, "div", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 5)(6, "form", 6);
    i0.ɵɵlistener("ngSubmit", function FormSidebarComponent_ng_container_0_ng_container_1_Template_form_ngSubmit_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.form.valid ? ctx_r1.submitForm(ctx_r1.form) : ctx_r1.markFormGroupTouched(ctx_r1.form));
    });
    i0.ɵɵtemplate(7, FormSidebarComponent_ng_container_0_ng_container_1_ng_container_7_Template, 1, 2, "ng-container", 7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const controlGroup_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(controlGroup_r4.title);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.config.id);
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", controlGroup_r4.controls);
  }
}
function FormSidebarComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormSidebarComponent_ng_container_0_ng_container_1_Template, 8, 4, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.controlGroups);
  }
}
function FormSidebarComponent_ng_container_1_ng_container_1_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 8);
  }
  if (rf & 2) {
    const field_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", field_r6)("group", ctx_r1.form);
  }
}
function FormSidebarComponent_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "div", 9)(3, "div", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 10)(6, "form", 6);
    i0.ɵɵlistener("ngSubmit", function FormSidebarComponent_ng_container_1_ng_container_1_Template_form_ngSubmit_6_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.form.valid ? ctx_r1.submitForm(ctx_r1.form) : ctx_r1.markFormGroupTouched(ctx_r1.form));
    });
    i0.ɵɵtemplate(7, FormSidebarComponent_ng_container_1_ng_container_1_ng_container_7_Template, 1, 2, "ng-container", 7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const controlGroup_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(controlGroup_r7.title);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.config.id);
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", controlGroup_r7.controls);
  }
}
function FormSidebarComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormSidebarComponent_ng_container_1_ng_container_1_Template, 8, 4, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.controlGroups);
  }
}
class FormSidebarComponent {
  constructor(fb, janus) {
    this.fb = fb;
    this.janus = janus;
  }
  ngOnInit() {
    this.form = this.createGroup();
  }
  createGroup(config = this.config) {
    const group = this.fb.group({});
    config.controlGroups.map(controlGroup => controlGroup.controls.map(control => {
      return group.addControl(control.name, this.fb.control(null, control.validators));
    }));
    return group;
  }
  submitForm(f) {
    let output = this.getOutput(f);
    this.config.submitFn(output);
    this.enableErrorMsg = typeof this.config.enableErrorMsg !== 'undefined' ? this.config.enableErrorMsg : this.enableErrorMsg;
  }
  getOutput(f) {
    let output = f.value;
    output.id = this.config.resourceID || null;
    return output;
  }
  markFormGroupTouched(formGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      this.enableErrorMsg = false;
      if (control.controls) {
        Array.prototype.forEach.call(control.controls, child => {
          this.markFormGroupTouched(child);
        });
      }
    });
  }
  static {
    this.ɵfac = function FormSidebarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormSidebarComponent)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject('ENABLE_JANUS', 8));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FormSidebarComponent,
      selectors: [["app-form-sidebar"]],
      inputs: {
        id: "id",
        resource: "resource",
        config: "config"
      },
      standalone: false,
      decls: 2,
      vars: 2,
      consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "sidebar-inner", "sb"], [1, "sidebar-header", "border-bottom", "border-gray-200", "bg-gray-100", "p-2"], ["translate", "", 1, "sidebar-title"], [1, "sidebar-body", "p-3"], [1, "dynamic-form", 3, "ngSubmit", "id", "formGroup"], ["dynamicField", "", 3, "config", "group", 4, "ngFor", "ngForOf"], ["dynamicField", "", 3, "config", "group"], [1, "sidebar-header"], [1, "sidebar-body"]],
      template: function FormSidebarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormSidebarComponent_ng_container_0_Template, 2, 1, "ng-container", 0)(1, FormSidebarComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.janus);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.janus);
        }
      },
      dependencies: [i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i1$1.TranslateDirective, DynamicFieldDirective],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormSidebarComponent, [{
    type: Component,
    args: [{
      selector: 'app-form-sidebar',
      standalone: false,
      template: "<ng-container *ngIf=\"janus\">\n    <ng-container *ngFor=\"let controlGroup of config.controlGroups\">\n        <div class=\"sidebar-inner sb\">\n            <div class=\"sidebar-header border-bottom border-gray-200 bg-gray-100 p-2\">\n                <div class=\"sidebar-title\" translate>{{controlGroup.title}}</div>\n            </div>\n            <div class=\"sidebar-body p-3\">\n                <form\n                    id=\"{{config.id}}\"\n                    class=\"dynamic-form\"\n                    [formGroup]=\"form\"\n                    (ngSubmit)=\"form.valid ? submitForm(form) : markFormGroupTouched(form);\"\n                >\n                    <ng-container dynamicField\n                        *ngFor=\"let field of controlGroup.controls\"\n                        [config]=\"field\"\n                        [group]=\"form\"\n                    ></ng-container>\n                </form>\n            </div>\n        </div>\n    </ng-container>\n</ng-container>\n\n<ng-container *ngIf=\"!janus\">\n    <ng-container *ngFor=\"let controlGroup of config.controlGroups\">\n        <div class=\"sidebar-inner sb\">\n            <div class=\"sidebar-header\">\n                <div class=\"sidebar-title\" translate>{{controlGroup.title}}</div>\n            </div>\n            <div class=\"sidebar-body\">\n                <form\n                id=\"{{config.id}}\"\n                class=\"dynamic-form\"\n                [formGroup]=\"form\"\n                (ngSubmit)=\"form.valid ? submitForm(form) : markFormGroupTouched(form);\">\n                <ng-container *ngFor=\"let field of controlGroup.controls\" dynamicField [config]=\"field\"\n                                  [group]=\"form\"></ng-container>\n                </form>\n            </div>\n    \n        </div>\n    </ng-container>\n</ng-container>\n"
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['ENABLE_JANUS']
    }]
  }], {
    id: [{
      type: Input
    }],
    resource: [{
      type: Input
    }],
    config: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormSidebarComponent, {
    className: "FormSidebarComponent",
    filePath: "common/form-sidebar.component.ts",
    lineNumber: 9
  });
})();
const _c0$15 = (a0, a1) => ({
  "btn_subtract": a0,
  "btn_add": a1
});
function FiltersComponent_div_1_ng_container_4_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 15);
  }
  if (rf & 2) {
    const controlConfig_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", controlConfig_r3)("group", ctx_r1.form);
  }
}
function FiltersComponent_div_1_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FiltersComponent_div_1_ng_container_4_ng_container_1_ng_container_1_Template, 1, 2, "ng-container", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const controlConfig_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", controlConfig_r3.className === "keyword_search" || controlConfig_r3.className === "initial_filter");
  }
}
function FiltersComponent_div_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FiltersComponent_div_1_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const controlGroup_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", controlGroup_r4.controls);
  }
}
function FiltersComponent_div_1_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "misc.Showing more filters, press tab to interact"));
  }
}
function FiltersComponent_div_1_ng_container_8_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 15);
  }
  if (rf & 2) {
    const controlConfig_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", controlConfig_r5)("group", ctx_r1.form);
  }
}
function FiltersComponent_div_1_ng_container_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FiltersComponent_div_1_ng_container_8_ng_container_1_ng_container_1_Template, 1, 2, "ng-container", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const controlConfig_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", controlConfig_r5.className !== "keyword_search" && controlConfig_r5.className !== "initial_filter");
  }
}
function FiltersComponent_div_1_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FiltersComponent_div_1_ng_container_8_ng_container_1_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const controlGroup_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", controlGroup_r6.controls);
  }
}
function FiltersComponent_div_1_input_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 17);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function FiltersComponent_div_1_input_14_Template_input_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.submitAndSaveFilters(ctx_r1.form));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("value", i0.ɵɵpipeBind1(1, 1, "misc.Save Defaults"));
  }
}
function FiltersComponent_div_1_input_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 18);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function FiltersComponent_div_1_input_15_Template_input_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleFilters());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("value", ctx_r1.isFiltersVisible ? i0.ɵɵpipeBind1(1, 2, "misc.Fewer Filters") : i0.ɵɵpipeBind1(2, 4, "misc.More Filters"));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c0$15, ctx_r1.isFiltersVisible, !ctx_r1.isFiltersVisible));
  }
}
function FiltersComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "form", 3);
    i0.ɵɵlistener("ngSubmit", function FiltersComponent_div_1_Template_form_ngSubmit_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.submitForm(ctx_r1.form));
    });
    i0.ɵɵelementStart(2, "div", 4)(3, "div", 5);
    i0.ɵɵtemplate(4, FiltersComponent_div_1_ng_container_4_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵtemplate(6, FiltersComponent_div_1_span_6_Template, 3, 3, "span", 8);
    i0.ɵɵelementStart(7, "div", 5);
    i0.ɵɵtemplate(8, FiltersComponent_div_1_ng_container_8_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 9);
    i0.ɵɵelement(10, "input", 10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementStart(12, "input", 11);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵlistener("click", function FiltersComponent_div_1_Template_input_click_12_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearFilters());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, FiltersComponent_div_1_input_14_Template, 2, 3, "input", 12)(15, FiltersComponent_div_1_input_15_Template, 3, 9, "input", 13);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("filters-shown", ctx_r1.isFiltersVisible);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.config.controlGroups);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showMoreFilters);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.config.controlGroups);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", i0.ɵɵpipeBind1(11, 10, "misc.apply search"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", i0.ɵɵpipeBind1(13, 12, "misc.clear"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.hasSaveDefault);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showMoreFilters);
  }
}
class FiltersComponent {
  constructor(fb, backendService) {
    this.fb = fb;
    this.backendService = backendService;
    this.showMoreFilters = true;
    this.submitted = new EventEmitter();
    this.filters = [];
    this.storeFilters = false;
    this.isFiltersVisible = false;
    this.hasSaveDefault = false;
    this.joinIds = (accumulator, valueObj) => accumulator ? accumulator + ',' + (valueObj.id || valueObj.value) : valueObj.id || valueObj.value;
    this.isFilterActive = val => !_.isNull(val) && !_.isUndefined(val) && (!_.isObject(val) || this.isGoodObjVal(val));
    this.isGoodObjVal = val => this.isRangeVal(val) || this.isPickVal(val) || this.isMultiPickVal(val) || this.isNumberCompareVal(val);
    this.isRangeVal = val => val.from || val.to;
    this.isPickVal = val => val.id || val.value;
    this.isMultiPickVal = val => val.length;
    this.isNumberCompareVal = val => val.compare && val.number;
  }
  ngOnInit() {
    this.hasSaveDefault = !!(this.saveDefault?.hasOwnProperty('class') && this.saveDefault?.hasOwnProperty('sectionkey'));
    this.form = this.createGroup();
  }
  createGroup(config = this.config) {
    const group = this.fb.group({});
    config.controlGroups.map(controlGroup => {
      controlGroup.controls.map(control => {
        if (control.multiple && typeof control.value === 'string') {
          control.value = control.value.split(',').filter(Boolean);
        }
        this.addFilter(control);
        return group.addControl(control.name, this.fb.control(control.value ?? null, control.validators));
      });
    });
    return group;
  }
  addFilter(control) {
    this.filters.push({
      name: control.name,
      paramName: control.paramName || control.name,
      type: this.getFilterType(control),
      value: control.value ?? null,
      multiple: control.multiple
    });
    if (control.dependents) {
      control.dependents.forEach(depControl => this.addFilter(depControl));
    }
  }
  getFilterType(control) {
    switch (control.type) {
      case 'select':
        return 'single-select';
      case 'ngselect':
        return 'hierpicklist';
      case 'range':
        return 'range';
      case 'rangeDatePicker':
        return 'range';
      case 'numberComparison':
        return 'numberComparison';
      case 'location':
        return 'location';
      default:
        return 'other';
    }
  }
  getFilterParams(filters) {
    return filters.map(filter => {
      if (this.isFilterActive(filter.value)) {
        switch (filter.type) {
          case 'hierpicklist':
            let params = `${filter.paramName}=${filter.value.id || filter.value.value}`;
            if (filter.multiple) {
              params = `${filter.paramName}=${filter.value.reduce(this.joinIds, '')}`;
            }
            return params;
          case 'range':
            let rangeValue = [filter.value['from'] || '', filter.value['to'] || ''];
            return `${filter.paramName}=` + rangeValue;
          case 'numberComparison':
            return `${filter.paramName}=${JSON.stringify(filter.value)}`;
          case 'location':
            let result = '';
            if (filter.value.value) {
              result += filter.value.value;
            }
            if (filter.value.data.indexOf('notFound') === -1) {
              result += "|" + filter.value.data;
            }
            if (filter.value.layer) {
              result += "|" + filter.value.layer;
            }
            return `${filter.paramName}=${result}`;
          default:
            return `${filter.paramName}=${filter.value}`;
        }
      } else {
        return null;
      }
    }).filter(nonNullVal => nonNullVal);
  }
  submitForm(f) {
    this.setFilterValues(f.value);
    let params = this.getFilterParams(this.filters);
    if (this.storeFilters) {
      this.saveDefaultFilters(params);
    }
    if (!this.config.hasOwnProperty('returnParams')) {
      this.config.returnParams = true;
    }
    if (this.config.returnParams) {
      this.submitted.emit(params);
    } else {
      this.submitted.emit(f.value);
    }
  }
  clearFilters() {
    this.filters.forEach(filter => filter.value = null);
    this.form.reset();
    this.submitted.emit([]);
  }
  submitAndSaveFilters(f) {
    this.storeFilters = true;
    this.submitForm(f);
  }
  saveDefaultFilters(paramsArray) {
    let params = {};
    paramsArray.reduce((acc, filter) => {
      let [filterKey, filterValue] = filter.split('=');
      acc[filterKey] = filterValue;
      return acc;
    }, params);
    if (this.saveDefault.id) {
      this.backendService.update(this.saveDefault.id, 'saved-filters', {
        class: this.saveDefault.class,
        sectionkey: this.saveDefault.sectionkey,
        data: params
      }, 'v3').subscribe();
    } else {
      this.backendService.create('saved-filters', {
        class: this.saveDefault.class,
        sectionkey: this.saveDefault.sectionkey,
        data: params
      }, 'v3').subscribe(res => {
        this.saveDefault.id = res.store_id;
      });
    }
  }
  setFilterValues(vals) {
    this.filters.forEach(filter => {
      let value = vals[filter.name];
      if (filter.multiple && typeof value === 'string') {
        value = value.split(',');
      }
      filter.value = value;
    });
    // Needs to be completed to handle the different types of form values
  }
  toggleFilters() {
    this.isFiltersVisible = !this.isFiltersVisible;
    if (this.isFiltersVisible) {
      let srOnlyTextElement = document.getElementById('hidden-filters-sronly');
      setTimeout(() => {
        srOnlyTextElement.focus();
      }, 0);
    }
  }
  static {
    this.ɵfac = function FiltersComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FiltersComponent)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(BackendService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FiltersComponent,
      selectors: [["app-filters"]],
      inputs: {
        config: "config",
        app_name: "app_name",
        showMoreFilters: "showMoreFilters",
        saveDefault: "saveDefault"
      },
      outputs: {
        submitted: "submitted"
      },
      standalone: false,
      decls: 2,
      vars: 2,
      consts: [[3, "ngSwitch"], ["class", "search-filters form form-editmode", 3, "filters-shown", 4, "ngSwitchCase"], [1, "search-filters", "form", "form-editmode"], ["name", "search_filters", "method", "post", 1, "dynamic-form", 3, "ngSubmit", "formGroup"], [1, "shown-filters"], [1, "column-wrapper"], [4, "ngFor", "ngForOf"], [1, "hidden-filters"], ["id", "hidden-filters-sronly", "class", "sr-only", "tabindex", "-1", 4, "ngIf"], [1, "buttonbar", "clearfix", "search-button-panel"], ["type", "submit", 1, "input-submit", "btn_search", 3, "value"], ["type", "button", 1, "input-submit", "btn_reset", 3, "click", "value"], ["type", "button", "name", "store_filters", "class", "input-submit btn_save btn_check", 3, "value", "click", 4, "ngIf"], ["type", "button", "class", "input-button closed", 3, "value", "ngClass", "click", 4, "ngIf"], ["dynamicField", "", 3, "config", "group", 4, "ngIf"], ["dynamicField", "", 3, "config", "group"], ["id", "hidden-filters-sronly", "tabindex", "-1", 1, "sr-only"], ["type", "button", "name", "store_filters", 1, "input-submit", "btn_save", "btn_check", 3, "click", "value"], ["type", "button", 1, "input-button", "closed", 3, "click", "value", "ngClass"]],
      template: function FiltersComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, FiltersComponent_div_1_Template, 16, 14, "div", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngSwitch", ctx.app_name);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "csm");
        }
      },
      dependencies: [i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgSwitch, i1.NgSwitchCase, i2$1.FormGroupDirective, DynamicFieldDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FiltersComponent, [{
    type: Component,
    args: [{
      selector: 'app-filters',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div [ngSwitch]=\"app_name\">\n    <div class=\"search-filters form form-editmode\" *ngSwitchCase=\"'csm'\" [class.filters-shown]=\"isFiltersVisible\">\n        <form name=\"search_filters\" method=\"post\" class=\"dynamic-form\" [formGroup]=\"form\"\n              (ngSubmit)=\"submitForm(form);\">\n            <div class=\"shown-filters\">\n                <div class=\"column-wrapper\">\n                    <ng-container *ngFor=\"let controlGroup of config.controlGroups\">\n                        <ng-container *ngFor=\"let controlConfig of controlGroup.controls\">\n                            <ng-container\n                                *ngIf=\"controlConfig.className === 'keyword_search' || controlConfig.className === 'initial_filter'\"\n                                dynamicField\n                                [config]=\"controlConfig\"\n                                [group]=\"form\"\n                            ></ng-container>\n                        </ng-container>\n                    </ng-container>\n                </div>\n            </div>\n            <div class=\"hidden-filters\">\n                <span *ngIf=\"showMoreFilters\" id=\"hidden-filters-sronly\" class=\"sr-only\" tabindex=\"-1\">{{'misc.Showing more filters, press tab to interact' | translate}}</span>\n                <div class=\"column-wrapper\">\n                    <ng-container *ngFor=\"let controlGroup of config.controlGroups\">\n                        <ng-container *ngFor=\"let controlConfig of controlGroup.controls\">\n                            <ng-container\n                                *ngIf=\"controlConfig.className !== 'keyword_search' && controlConfig.className !== 'initial_filter'\"\n                                dynamicField\n                                [config]=\"controlConfig\"\n                                [group]=\"form\"\n                            ></ng-container>\n                        </ng-container>\n                    </ng-container>\n                </div>\n            </div>\n\n            <div class=\"buttonbar clearfix search-button-panel\">\n                <input type=\"submit\" value=\"{{'misc.apply search' | translate}}\" class=\"input-submit btn_search\">\n                <input type=\"button\" value=\"{{'misc.clear' | translate}}\" class=\"input-submit btn_reset\" (click)=\"clearFilters()\">\n                <input *ngIf=\"hasSaveDefault\" type=\"button\" value=\"{{'misc.Save Defaults' | translate}}\" name=\"store_filters\" class=\"input-submit btn_save btn_check\" (click)=\"submitAndSaveFilters(form)\">\n                <input type=\"button\"\n                    *ngIf=\"showMoreFilters\"\n                    (click)=\"toggleFilters()\"\n                    value=\"{{isFiltersVisible ? ('misc.Fewer Filters' | translate) : ('misc.More Filters' | translate)}}\"\n                    class=\"input-button closed\"\n                    [ngClass]=\"{'btn_subtract' : isFiltersVisible , 'btn_add' : !isFiltersVisible}\">\n            </div>\n        </form>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }, {
    type: BackendService
  }], {
    config: [{
      type: Input
    }],
    app_name: [{
      type: Input
    }],
    showMoreFilters: [{
      type: Input
    }],
    saveDefault: [{
      type: Input
    }],
    submitted: [{
      type: Output
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FiltersComponent, {
    className: "FiltersComponent",
    filePath: "common/filters.component.ts",
    lineNumber: 13
  });
})();
class DynamicFormModule {
  static {
    this.ɵfac = function DynamicFormModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DynamicFormModule)();
    };
  }
  static {
    this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
      type: DynamicFormModule
    });
  }
  static {
    this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
      providers: [{
        provide: FlowInjectionToken,
        useValue: Flow
      }, NgbDateNativeAdapter, HtmlFormatterService, TranslateService],
      imports: [FormsModule, CommonModule, ReactiveFormsModule, NgbModule, TranslateModule, NgSelectModule, TypeaheadModule.forRoot(), SyngCommonModule.forRoot(), NgxFlowModule, EditorModule, TimepickerModule.forRoot(), CdkListboxModule, TranslateModule, NgxFlowModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormModule, [{
    type: NgModule,
    args: [{
      imports: [FormsModule, CommonModule, ReactiveFormsModule, NgbModule, TranslateModule, NgSelectModule, TypeaheadModule.forRoot(), SyngCommonModule.forRoot(), NgxFlowModule, EditorModule, TimepickerModule.forRoot(), CdkListboxModule],
      declarations: [DynamicFieldDirective, FormComponent, FormModalComponent, FormModalExtendedComponent, FiltersComponent, FormInputComponent, FormSelectComponent, FormButtonComponent, FormTextareaComponent, FormRangeComponent, FormCheckboxComponent, FormRadioComponent, FormNGSelectComponent, FormStaticComponent, FormStaticListComponent, FormMultiSelectComponent, FormDatePickerComponent, FormRangeDatePickerComponent, FormHierpicklistComponent, FormSidebarComponent, FormRichtextComponent, FormActionsComponent, FormActionButtonComponent, FormActionAnchorComponent, FormRelationComponent, FormRatingComponent, FormLocationComponent, FormMoxieManagerComponent, FormMoxieManagerStaticComponent, FormMinMaxComponent, FormNumberComparisonComponent, FormNumberComponent, FormFileUploadComponent, FormImageUploadComponent, FormACLookupComponent, N1Component, FormTimepickerComponent, FormDatetimepickerComponent, MonthYearPicker],
      exports: [FormComponent, FormModalComponent, FormModalExtendedComponent, FormSidebarComponent, FiltersComponent, TranslateModule, DynamicFieldDirective, FormActionsComponent, NgxFlowModule],
      providers: [{
        provide: FlowInjectionToken,
        useValue: Flow
      }, NgbDateNativeAdapter, HtmlFormatterService, TranslateService]
    }]
  }], null, null);
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DynamicFormModule, {
    declarations: [DynamicFieldDirective, FormComponent, FormModalComponent, FormModalExtendedComponent, FiltersComponent, FormInputComponent, FormSelectComponent, FormButtonComponent, FormTextareaComponent, FormRangeComponent, FormCheckboxComponent, FormRadioComponent, FormNGSelectComponent, FormStaticComponent, FormStaticListComponent, FormMultiSelectComponent, FormDatePickerComponent, FormRangeDatePickerComponent, FormHierpicklistComponent, FormSidebarComponent, FormRichtextComponent, FormActionsComponent, FormActionButtonComponent, FormActionAnchorComponent, FormRelationComponent, FormRatingComponent, FormLocationComponent, FormMoxieManagerComponent, FormMoxieManagerStaticComponent, FormMinMaxComponent, FormNumberComparisonComponent, FormNumberComponent, FormFileUploadComponent, FormImageUploadComponent, FormACLookupComponent, N1Component, FormTimepickerComponent, FormDatetimepickerComponent, MonthYearPicker],
    imports: [FormsModule, CommonModule, ReactiveFormsModule, NgbModule, TranslateModule, NgSelectModule, i3$1.TypeaheadModule, SyngCommonModule, NgxFlowModule, EditorModule, i4$1.TimepickerModule, CdkListboxModule],
    exports: [FormComponent, FormModalComponent, FormModalExtendedComponent, FormSidebarComponent, FiltersComponent, TranslateModule, DynamicFieldDirective, FormActionsComponent, NgxFlowModule]
  });
})();
i0.ɵɵsetComponentScope(FormSelectComponent, function () {
  return [i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, DynamicFieldDirective, FormActionsComponent];
}, function () {
  return [i1.AsyncPipe, i1.KeyValuePipe, i1$1.TranslatePipe, SafeHtmlPipe];
});
i0.ɵɵsetComponentScope(FormRadioComponent, function () {
  return [i2$1.DefaultValueAccessor, i2$1.RadioControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, DynamicFieldDirective];
}, function () {
  return [i1$1.TranslatePipe, SafeHtmlPipe];
});
i0.ɵɵsetComponentScope(FormNGSelectComponent, function () {
  return [i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, i8.NgSelectComponent, i8.NgLabelTemplateDirective, DynamicFieldDirective];
}, function () {
  return [i1.AsyncPipe, i1$1.TranslatePipe, SafeHtmlPipe];
});
i0.ɵɵsetComponentScope(FormMultiSelectComponent, function () {
  return [i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormControlName, i8.NgSelectComponent, i8.NgLabelTemplateDirective, DynamicFieldDirective];
}, function () {
  return [i1.AsyncPipe, i1$1.TranslatePipe, SafeHtmlPipe];
});
i0.ɵɵsetComponentScope(FormRelationComponent, function () {
  return [i1.NgClass, i1.NgForOf, i1.NgIf, DynamicFieldDirective];
}, function () {
  return [i1$1.TranslatePipe, SafeHtmlPipe];
});
i0.ɵɵsetComponentScope(N1Component, function () {
  return [i2$1.NgControlStatusGroup, i1.NgForOf, i1.NgIf, i2$1.FormGroupDirective, i2$1.FormGroupName, i2$1.FormArrayName, DynamicFieldDirective];
}, function () {
  return [i1$1.TranslatePipe, SafeHtmlPipe];
});
i0.ɵɵsetComponentScope(FormDatetimepickerComponent, function () {
  return [i1.NgClass, i1.NgIf, DynamicFieldDirective];
}, function () {
  return [i1$1.TranslatePipe, SafeHtmlPipe];
});
class AutoColorDirective {
  constructor(el) {
    this.el = el;
    this.colorMap = {
      "0": "pale-blue",
      "1": "pale-blue",
      "2": "pale-indigo",
      "3": "pale-indigo",
      "4": "pale-purple",
      "5": "pale-purple",
      "6": "pale-pink",
      "7": "pale-pink",
      "8": "pale-red",
      "9": "pale-red",
      "a": "pale-green",
      "b": "pale-green",
      "c": "pale-teal",
      "d": "pale-teal",
      "e": "pale-cyan",
      "f": "pale-cyan"
    };
  }
  ngAfterViewInit() {
    if (this.id) {
      const idx = this.id.slice(-1);
      let color = this.colorMap[idx];
      if (!color) {
        color = this.colorMap["0"];
      }
      this.el.nativeElement.classList.add('bg-' + color);
    }
  }
  static {
    this.ɵfac = function AutoColorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AutoColorDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: AutoColorDirective,
      selectors: [["", "autocolor", ""]],
      inputs: {
        id: [0, "autocolor", "id"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutoColorDirective, [{
    type: Directive,
    args: [{
      selector: '[autocolor]',
      standalone: true
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    id: [{
      type: Input,
      args: ['autocolor']
    }]
  });
})();
function ValkyrieSessionTimeoutModalComponent_i_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 7);
  }
}
class ValkyrieSessionTimeoutModalComponent {
  constructor(activeModal, http) {
    this.activeModal = activeModal;
    this.http = http;
    this.disableButtons = false;
  }
  keepSigned() {
    this.disableButtons = true;
    const payload = {
      ltarget: window.SUB_SYSTEM,
      ctracker: true
    };
    this.http.post('/utils/updateSessionTimeout.php', payload, {
      params: {
        mode: 'json'
      }
    }).subscribe(res => {
      this.activeModal.close(true);
      this.disableButtons = false;
      if (!res.success) {
        this.signOut(true);
      }
    });
  }
  signOut(timeout = false) {
    let logoutHref = `/logout.php${timeout ? '?_to=1' : ''}`;
    window.location.href = logoutHref;
  }
  static {
    this.ɵfac = function ValkyrieSessionTimeoutModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ValkyrieSessionTimeoutModalComponent)(i0.ɵɵdirectiveInject(i1$4.NgbActiveModal), i0.ɵɵdirectiveInject(i2.HttpClient));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ValkyrieSessionTimeoutModalComponent,
      selectors: [["session-timeout-modal"]],
      standalone: false,
      decls: 16,
      vars: 15,
      consts: [[1, "modal-header"], ["tabindex", "-1", "ngbAutofocus", "", 1, "modal-title"], [1, "modal-body"], [1, "modal-footer"], ["flow-btn", "", 1, "btn", "btn_default", 3, "click", "disabled"], ["flow-btn", "", 1, "btn", "btn_primary", 3, "click", "disabled"], ["class", "icn-interface-loading spin-animation", 4, "ngIf"], [1, "icn-interface-loading", "spin-animation"]],
      template: function ValkyrieSessionTimeoutModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "h3", 1);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "div", 2)(5, "span");
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(8, "div", 3)(9, "button", 4);
          i0.ɵɵlistener("click", function ValkyrieSessionTimeoutModalComponent_Template_button_click_9_listener() {
            return ctx.signOut();
          });
          i0.ɵɵtext(10);
          i0.ɵɵpipe(11, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "button", 5);
          i0.ɵɵlistener("click", function ValkyrieSessionTimeoutModalComponent_Template_button_click_12_listener() {
            return ctx.keepSigned();
          });
          i0.ɵɵtext(13);
          i0.ɵɵpipe(14, "translate");
          i0.ɵɵtemplate(15, ValkyrieSessionTimeoutModalComponent_i_15_Template, 1, 0, "i", 6);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 7, "misc.Still there?"));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 9, "misc.Your session is about to expire due to inactivity. Do you want to stay signed in?"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("disabled", ctx.disableButtons);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 11, "misc.Sign out"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("disabled", ctx.disableButtons);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 13, "misc.Keep me signed in"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.disableButtons);
        }
      },
      dependencies: [i1.NgIf, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValkyrieSessionTimeoutModalComponent, [{
    type: Component,
    args: [{
      selector: 'session-timeout-modal',
      standalone: false,
      template: "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" tabindex=\"-1\" ngbAutofocus>{{ 'misc.Still there?' | translate }}</h3>\n</div>\n<div class=\"modal-body\">\n    <span>{{ 'misc.Your session is about to expire due to inactivity. Do you want to stay signed in?' | translate}}</span>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn_default\" (click)=\"signOut()\" [disabled]=\"disableButtons\" flow-btn>\n        {{ 'misc.Sign out' | translate}}\n    </button>\n    <button class=\"btn btn_primary\" (click)=\"keepSigned()\" [disabled]=\"disableButtons\" flow-btn>\n        {{ 'misc.Keep me signed in' | translate}}\n        <i *ngIf=\"disableButtons\" class=\"icn-interface-loading spin-animation\"></i>\n    </button>\n</div>"
    }]
  }], () => [{
    type: i1$4.NgbActiveModal
  }, {
    type: i2.HttpClient
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ValkyrieSessionTimeoutModalComponent, {
    className: "ValkyrieSessionTimeoutModalComponent",
    filePath: "valkyrie/common/session-timeout-modal.component.ts",
    lineNumber: 13
  });
})();
class SessionTimeoutInterceptor {
  constructor() {
    this.timeToShowModal = 50; // In minutes
    this.timeToAutoSignOut = 10; // In minutes
  }
  intercept(request, next) {
    this.unsubscribeTimeouts();
    this.notifySessionExpiring();
    return next.handle(request).pipe(catchError(error => {
      if (error.error?.['skipInterceptor'] !== true) {
        if (error.status === 401) {
          window.location.href = window.location.href;
        }
      }
      return throwError(error);
    }));
  }
  sessionExpiringModal() {
    this.openExpiringModal();
    this.startSignoutTimeout();
  }
  openExpiringModal() {}
  notifySessionExpiring() {
    let lastTimestamp = Date.now();
    this.sessionExpiringSubscription = interval(60_000).pipe(filter(() => Date.now() - lastTimestamp >= this.timeToShowModal * 60 * 1000), take(1)).subscribe(() => {
      this.sessionExpiringModal();
    });
  }
  startSignoutTimeout() {
    let lastTimestamp = Date.now();
    this.signoutTimeoutSubscription = interval(60_000).pipe(filter(() => Date.now() - lastTimestamp >= this.timeToAutoSignOut * 60 * 1000), take(1)).subscribe(() => {
      window.location.href = "/logout.php?_to=1";
    });
  }
  unsubscribeTimeouts() {
    this.sessionExpiringSubscription?.unsubscribe();
    this.signoutTimeoutSubscription?.unsubscribe();
  }
  ngOnDestroy() {
    this.unsubscribeTimeouts();
  }
  static {
    this.ɵfac = function SessionTimeoutInterceptor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SessionTimeoutInterceptor)();
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: SessionTimeoutInterceptor,
      factory: SessionTimeoutInterceptor.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SessionTimeoutInterceptor, [{
    type: Injectable
  }], null, null);
})();
class ValkyrieSessionTimeoutInterceptor extends SessionTimeoutInterceptor {
  constructor(modalService) {
    super();
    this.modalService = modalService;
  }
  openExpiringModal() {
    const myApp = document.querySelector('my-app');
    myApp?.toggleAttribute('inert', true);
    this.modalService.open(ValkyrieSessionTimeoutModalComponent, {
      windowClass: 'ngb-modal modal-scroll',
      size: 'sm',
      backdrop: 'static',
      keyboard: false
    }).closed.subscribe(() => {
      myApp?.toggleAttribute('inert', false);
    });
  }
  static {
    this.ɵfac = function ValkyrieSessionTimeoutInterceptor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ValkyrieSessionTimeoutInterceptor)(i0.ɵɵinject(i1$4.NgbModal));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: ValkyrieSessionTimeoutInterceptor,
      factory: ValkyrieSessionTimeoutInterceptor.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValkyrieSessionTimeoutInterceptor, [{
    type: Injectable
  }], () => [{
    type: i1$4.NgbModal
  }], null);
})();
class SearchTextPipe {
  transform(value, keys, term) {
    if (!term) return value;
    let filter = (item, keys, idx = 0) => {
      let result = false;
      if (keys) {
        let key = keys.split('.')[idx];
        if (item.hasOwnProperty(key)) {
          if (keys.split('.')[idx + 1]) {
            result = filter(item[key], keys, idx + 1);
          } else {
            result = item.hasOwnProperty(key) && item[key].toLowerCase().indexOf(term.toLowerCase()) !== -1;
          }
        }
      } else {
        result = item.toLowerCase().indexOf(term.toLowerCase()) !== -1;
      }
      return result;
    };
    return (value || []).filter(item => filter(item, keys));
  }
  static {
    this.ɵfac = function SearchTextPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SearchTextPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "searchText",
      type: SearchTextPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchTextPipe, [{
    type: Pipe,
    args: [{
      name: 'searchText',
      standalone: false
    }]
  }], null, null);
})();
class MinPipe {
  transform(value, args) {
    return Math.min.apply(null, value);
  }
  static {
    this.ɵfac = function MinPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MinPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "min",
      type: MinPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MinPipe, [{
    type: Pipe,
    args: [{
      name: 'min',
      standalone: false
    }]
  }], null, null);
})();
class Initials {
  constructor() {}
  transform(fullname, fname = '', lname = '') {
    let initials = '';
    if (fname && lname) {
      initials = fname.substring(0, 1) + lname.substring(0, 1);
    } else if (fullname) {
      let name = fullname.split(' ');
      let num_of_initials = name.length;
      let lastInitial = '';
      if (num_of_initials > 1) {
        lastInitial = name[num_of_initials - 1].substring(0, 1);
      }
      initials = name[0].substring(0, 1) + lastInitial;
    }
    return initials;
  }
  static {
    this.ɵfac = function Initials_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Initials)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "initials",
      type: Initials,
      pure: false,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Initials, [{
    type: Pipe,
    args: [{
      name: 'initials',
      pure: false,
      standalone: false
    }]
  }], () => [], null);
})();
class ValkyrieAuthService {
  constructor(http, backendService) {
    this.http = http;
    this.backendService = backendService;
    this.currentUser = new BehaviorSubject(null);
    this.socketSignature = new BehaviorSubject(null);
  }
  fetchCurrentUser() {
    this.http.get('/api/v2/auth/current-user', {
      observe: 'response',
      headers: {
        'x-requested-system-user': window.SUB_SYSTEM
      }
    }).subscribe(res => {
      this.currentUser.next(res.body['user']);
      this.socketSignature.next(res.headers.get('socket-signature'));
    });
  }
  getUserRights() {
    if (!this._userRights$) {
      this._userRights$ = this.backendService.getAll('auth/rights').pipe(shareReplay(1));
    }
    return this._userRights$;
  }
  getCurrentUser() {
    return this.currentUser.asObservable();
  }
  getsocketSignature() {
    return this.socketSignature;
  }
  static {
    this.ɵfac = function ValkyrieAuthService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ValkyrieAuthService)(i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(ValkyrieBackendService));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: ValkyrieAuthService,
      factory: ValkyrieAuthService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValkyrieAuthService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i2.HttpClient
  }, {
    type: ValkyrieBackendService
  }], null);
})();
const ScriptStore = [{
  name: 'loginas',
  src: ['/js/loginas.js']
}, {
  name: 'flickity',
  src: ['/components/flickity/dist/flickity.pkgd.js', '/components/flickity/css/flickity.css']
}, {
  name: 'scrolltabs',
  src: ['/components/valkyrie/js/jquery.scrolltabs.js'],
  req: ['flickity']
}];
class ValkyrieUtilsService {
  constructor(router, location) {
    this.router = router;
    this.location = location;
    this.scripts = [];
    this.isPopState = false;
    ScriptStore.forEach(script => {
      let data = {
        name: script.name,
        src: script.src,
        req: script.req
      };
      this.scripts.push(data);
    });
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.currentPath = this.location.pathname;
      this.checkPopState();
    });
  }
  loadJS(...scripts) {
    const promises = [];
    scripts.forEach(script => {
      let js = this.scripts.find(f => f.name == script);
      let getSourceFiles = js => {
        let val = js.src;
        if (js.req && js.req.length) {
          js.req.forEach(req => {
            val = val.concat(getSourceFiles(this.scripts.find(f => f.name == req)));
          });
        }
        return val;
      };
      js.src = getSourceFiles(js);
      promises.push(this.loadScript(js));
    });
    return Promise.all(promises);
  }
  loadScript(js) {
    return new Promise((resolve, reject) => {
      let loaded = [];
      let fileExtExpression = /(?:\.([^.]+))?$/;
      let srcTypeGroup = {
        js: {
          elm: 'script',
          attrSrc: 'src',
          attrType: 'type',
          type: 'text/javascript'
        },
        css: {
          elm: 'link',
          attrSrc: 'href',
          attrType: 'rel',
          type: 'stylesheet'
        }
      };
      js.src.forEach(item => {
        let fileExt = fileExtExpression.exec(item)[1];
        let srcInfo = srcTypeGroup[fileExt];
        //check it is already loaded.
        let srcInHTML = Array.prototype.slice.call(document.querySelectorAll(srcInfo.elm));
        let srcFound = srcInHTML.filter(val => {
          return val.getAttribute(srcInfo.attrSrc) != null && val.getAttribute(srcInfo.attrSrc).includes(item);
        });
        if (!srcFound.length) {
          //load script
          let src = document.createElement(srcInfo.elm);
          src[srcInfo.attrType] = srcInfo.type;
          src[srcInfo.attrSrc] = item;
          if (item == '/js/loginas.js') {
            src[srcInfo.attrSrc] += `?t=02-21-2023`; // Avoid cache issues
          }
          if (src.readyState) {
            //IE
            src.onreadystatechange = () => {
              if (src.readyState === "loaded" || src.readyState === "complete") {
                src.onreadystatechange = null;
                loaded.push(item);
                if (loaded.length == js.src.length) {
                  resolve({
                    script: js.name,
                    loaded: true,
                    status: 'Loaded'
                  });
                }
              }
            };
          } else {
            //Others
            src.onload = () => {
              loaded.push(item);
              if (loaded.length == js.src.length) {
                resolve({
                  script: js.name,
                  loaded: true,
                  status: 'Loaded'
                });
              }
            };
          }
          src.onerror = error => resolve({
            script: name,
            loaded: false,
            status: 'Loaded'
          });
          document.getElementsByTagName('head')[0].appendChild(src);
        } else {
          loaded.push(item);
          if (loaded.length == js.src.length) {
            resolve({
              script: name,
              loaded: true,
              status: 'Already Loaded'
            });
          }
        }
      });
    });
  }
  setPopState() {
    this.isPopState = true;
    setTimeout(d => {
      this.isPopState = false;
    }, 500);
  }
  saveSession(key, value, group = 'ng-valkyrie') {
    let sessionGroup = sessionStorage[group] ? JSON.parse(sessionStorage[group]) : [];
    let sameItemIndex = sessionGroup.findIndex(data => data.id == key);
    let savingData = {
      id: key,
      value: value
    };
    if (sameItemIndex > -1) {
      sessionGroup[sameItemIndex] = savingData;
    } else {
      sessionGroup.push(savingData);
    }
    sessionStorage.setItem(group, JSON.stringify(sessionGroup));
  }
  loadSession(key, group = 'ng-valkyrie', getMultipleItems = false) {
    let dataGroup = sessionStorage[group] ? JSON.parse(sessionStorage[group]) : [];
    let data = getMultipleItems ? dataGroup.filter(item => item.id == key) : dataGroup.find(item => item.id == key);
    return data && data.value ? data.value : null;
  }
  getDeepestTarget(data, childrenKey, target) {
    let val;
    let _data = data || [];
    if (_data[childrenKey] && _data[childrenKey].length) {
      val = this.getDeepestTarget(_data[childrenKey][0], childrenKey, target);
    } else {
      val = _data[target];
    }
    return val;
  }
  static findTargetKeyInDeepTreeObj(parentObj, childrenArrayKey, target, matchValue = undefined, returnValuesOnly = false, results = []) {
    if (!_.isEmpty(parentObj[childrenArrayKey])) {
      for (let obj of parentObj[childrenArrayKey]) {
        const foundTargetValue = _.get(obj, target);
        if (foundTargetValue && (_.isUndefined(matchValue) ? true : foundTargetValue === matchValue)) {
          results.push(_.cloneDeep(returnValuesOnly ? foundTargetValue : obj));
        }
        results = ValkyrieUtilsService.findTargetKeyInDeepTreeObj(obj, childrenArrayKey, target, matchValue, returnValuesOnly, results);
      }
    } else if (_.isEmpty(results)) {
      const foundTargetValue = _.get(parentObj, target);
      if (foundTargetValue && (_.isUndefined(matchValue) ? true : foundTargetValue === matchValue)) {
        results.push(_.cloneDeep(returnValuesOnly ? foundTargetValue : parentObj));
      }
    }
    return results;
  }
  checkPopState() {
    if (window.performance) {
      let navEntries = window.performance.getEntriesByType('navigation');
      if (navEntries.length > 0 && navEntries[0].type === 'back_forward' || window.performance.navigation && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD || performance.navigation.type === 1) {
        this.setPopState();
      }
    }
    this.location.onPopState(() => {
      this.setPopState();
    });
  }
  static {
    this.ɵfac = function ValkyrieUtilsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ValkyrieUtilsService)(i0.ɵɵinject(i1$7.Router), i0.ɵɵinject(i1.PlatformLocation));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: ValkyrieUtilsService,
      factory: ValkyrieUtilsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValkyrieUtilsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$7.Router
  }, {
    type: i1.PlatformLocation
  }], null);
})();
class ValkyrieCommonService {
  constructor(backendService, router, route, utilsService, title, enableNotification) {
    this.backendService = backendService;
    this.router = router;
    this.route = route;
    this.utilsService = utilsService;
    this.title = title;
    this.siteStructure = new ReplaySubject(1);
    this.pageTitleConfig = new BehaviorSubject({});
    this.breadcrumbs = new BehaviorSubject([]);
    this.customBreadcrumbLabel = new Subject();
    this.enableNotification = false;
    this.enableBreadcrumbs = new Subject();
    this.showTranslationMenu = new Subject();
    this.translationMenu = new Subject();
    this.translationButton = new Subject();
    this.enableHints = new Subject();
    this.floatingLayout = new BehaviorSubject(false);
    this.navbarReadySubject = new BehaviorSubject(undefined);
    this.blockMessageReady$ = new BehaviorSubject(undefined);
    this.enableNotification = enableNotification;
  }
  convertSiteStructure(siteStructureData) {
    let activeMenuTargets = this.utilsService.getDeepestTarget(this.route.snapshot, 'children', 'data').navTarget;
    activeMenuTargets = _.isArray(activeMenuTargets) ? activeMenuTargets : [activeMenuTargets];
    let siteStructure = this.convertSiteStructureMenus(siteStructureData, activeMenuTargets);
    return siteStructure;
  }
  convertSiteStructureMenus(items, activeNavMenu, rootLevel = true) {
    items = _.isArray(items) ? items : _.values(items);
    items.forEach(item => {
      let activeMenuTargets = rootLevel ? [...activeNavMenu] : activeNavMenu;
      const isFindingActiveMenu = !_.isEmpty(activeMenuTargets);
      item.icon = this.iconMap[item.shortname] || 'icn-chevron_right';
      if (item.shortname === activeMenuTargets[0]) {
        activeMenuTargets.shift();
      }
      if (!_.isEmpty(item.children)) {
        item.children = this.convertSiteStructureMenus(item.children, activeMenuTargets, false);
      }
      item['active'] = isFindingActiveMenu && _.isEmpty(activeMenuTargets);
    });
    return items;
  }
  convertObjToArray(obj) {
    return Object.keys(obj).map(function (key) {
      return obj[key];
    });
  }
  setSiteStructure(navData) {
    if (!this.iconMap) {
      this.backendService.setCheck('', 'students/app/assets/icon_map.json').pipe(tap(icons => this.iconMap = icons), switchMap(() => {
        if (navData) {
          return of(navData);
        } else {
          return this.backendService.fetchSiteStructure();
        }
      })).subscribe(navNext => {
        this._navData = navNext;
        let siteStructure = this.convertSiteStructure(navNext);
        this.siteStructure.next(siteStructure);
      });
    } else {
      let siteStructure = this.convertSiteStructure(this._navData);
      this.siteStructure.next(siteStructure);
    }
  }
  getSiteStructure() {
    return this.siteStructure.asObservable();
  }
  setPageTitle(title) {
    this.pageTitleConfig.next({
      text: title
    });
  }
  getPageTitle() {
    return this.pageTitleConfig.asObservable().pipe(map(config => config.text || ''));
  }
  setPageTitleConfig(value) {
    this.pageTitleConfig.next(value);
  }
  getPageTitleConfig() {
    return this.pageTitleConfig.asObservable();
  }
  setPageTitleConfigFromTabTitle(hide = false) {
    this.pageTitleConfig.next({
      text: this.title.getTitle(),
      hide
    });
  }
  getBreadcrumbs() {
    return this.breadcrumbs.asObservable();
  }
  replaceBreadcrumbLabel(label, id, translate = true) {
    this.getBreadcrumbs().pipe(filter(breadcrumbs => !!(breadcrumbs && breadcrumbs.length)), take(1)).subscribe(breadcrumbs => {
      const idx = breadcrumbs.findIndex(f => f.id === id);
      if (idx !== -1 && breadcrumbs[idx].label !== label) {
        breadcrumbs[idx].label = label;
        breadcrumbs[idx].translateLabel = translate;
        this.breadcrumbs.next(breadcrumbs);
      }
    });
  }
  setFloatingLayout(floating) {
    this.floatingLayout.next(floating);
  }
  getFloatingLayout() {
    return this.floatingLayout.asObservable();
  }
  setEnableBreadcrumbs(enable) {
    this.enableBreadcrumbs.next(enable);
  }
  getEnableBreadcrumbs() {
    return this.enableBreadcrumbs.asObservable();
  }
  setShowTranslationMenu(enable) {
    this.showTranslationMenu.next(enable);
  }
  getShowTranslationMenu() {
    return this.showTranslationMenu.asObservable();
  }
  setTranslationMenu(translationMenu) {
    this.translationMenu.next(translationMenu);
    this.translationButton.next(null);
  }
  getTranslationMenu() {
    return this.translationMenu.asObservable();
  }
  setTranslationButton(translationButton) {
    this.translationButton.next(translationButton);
    this.translationMenu.next(null);
  }
  getTranslationButton() {
    return this.translationButton.asObservable();
  }
  setEnableHints(enable) {
    this.enableHints.next(enable);
  }
  getEnableHints() {
    return this.enableHints.asObservable();
  }
  getCurrentRoutePath(activatedRoute) {
    return activatedRoute.pathFromRoot.map(path => path.routeConfig && path.routeConfig.path).join('/');
  }
  getTabListFromRoutes(activatedRoute, replaceParam = undefined) {
    let tabList = [];
    let thisRoute = activatedRoute.routeConfig;
    if (thisRoute.children && thisRoute.children.length) {
      //Get all direct children routes with 'isTabMenu: true' in current route.
      let tabRoutes = thisRoute.children.filter(child => child.data ? child.data.isTabMenu : false);
      const childRoutePath = activatedRoute.children[0].routeConfig.path;
      for (let tabRoute of tabRoutes) {
        let tab = this.genTabItem(tabRoute.data.label, tabRoute.path, tabRoute.data.externalUrl, tabRoute.path == childRoutePath, activatedRoute, replaceParam);
        tabList.push(tab);
      }
    }
    return tabList;
  }
  genTabItem(label, path, url_external = '', active = false, activatedRoute = undefined, replaceParam = undefined) {
    let isExternalUrl = url_external ? true : false;
    let childRoute = {
      title: label,
      url: isExternalUrl ? url_external : this.getCurrentRoutePath(activatedRoute) + '/' + path,
      externalUrl: isExternalUrl,
      path: path,
      active: active
    };
    if (replaceParam && !isExternalUrl) {
      childRoute.url = childRoute.url.replace(replaceParam.key, replaceParam.value);
      childRoute.url = childRoute.url.replace("//", "/");
    }
    return childRoute;
  }
  getTabListFromSiteStructure(res, targetPath, parentPath = '') {
    let childMenu = [];
    let navList = res;
    let getChildMenu = (data, target) => {
      let val = data.find(item => {
        return item.shortname == target && item.children && item.children.length;
      });
      if (val) {
        val = val.children;
      } else {
        let itemChildren = data.filter(item => item.children && item.children.length > 0);
        if (itemChildren.length) {
          val = getChildMenu(itemChildren, target);
        }
      }
      return val;
    };
    for (let item of getChildMenu(navList, targetPath)) {
      childMenu.push(this.genTabItem(item.title, item.shortname, item.link, item.active));
    }
    return childMenu;
  }
  getTabsBySection(section) {
    return this.backendService.getAll(section, 'v2/my/tabs');
  }
  checkImageBySize(id, size) {
    return this.backendService.getAll(`student/${id}/image/${size}?return_url=true`);
  }
  encodeStringToHTML(string) {
    return string.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
  }
  convertObjToTabList(tabs, params) {
    let tabList = [];
    for (let key of Object.keys(tabs)) {
      if (params.id) {
        tabs[key].link = tabs[key].link.replace("{id}", params.id);
      }
      tabList.push({
        title: tabs[key].text,
        url: tabs[key].link,
        path: key,
        externalUrl: tabs[key].externalUrl
      });
    }
    return tabList;
  }
  convertObjToApiParam(params) {
    let query = Object.assign({}, params);
    Object.keys(query).forEach(key => {
      let paramKey = key;
      let paramValue;
      if (Array.isArray(query[paramKey])) {
        paramValue = query[paramKey].length ? query[paramKey].join(',') : '';
      } else {
        paramValue = typeof query[paramKey] == 'string' ? this.encodeStringToHTML(query[paramKey]) : query[paramKey];
      }
      if (paramKey == 'sortBy' || paramKey == 'sortAsc') {
        if (paramKey == 'sortAsc') {
          paramValue = paramValue ? params.sortBy : '!' + params.sortBy;
        }
        delete query[paramKey];
        paramKey = 'sort';
      }
      if (paramValue === '' || paramValue === undefined) {
        delete query[paramKey];
      } else {
        query[paramKey] = paramValue;
      }
    });
    return query;
  }
  titleRouteData$() {
    const lastRoute = this.getLastNonTabRoute(this.route);
    return lastRoute.data;
  }
  getLastNonTabRoute(activatedRoute) {
    if (activatedRoute.firstChild && !activatedRoute.firstChild.snapshot.data.isTabMenu) {
      return this.getLastNonTabRoute(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
  setNavbarReady(ref) {
    this.navbarReadySubject.next(ref);
    this.navbarReadySubject.complete();
  }
  navbarReady() {
    return this.navbarReadySubject.asObservable();
  }
  setBlockMessageReady() {
    this.blockMessageReady$.next("Acount blocked message ready");
    this.blockMessageReady$.complete();
  }
  blockMessageReady() {
    return this.blockMessageReady$.asObservable();
  }
  scrollTo(name, e) {
    e.preventDefault();
    let target = $$1('[name="' + name + '"]');
    if (target.length) {
      $$1('html, body').animate({
        scrollTop: target.offset().top
      }, 1000);
      target.attr('tabIndex', -1).focus();
    }
  }
  static {
    this.ɵfac = function ValkyrieCommonService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ValkyrieCommonService)(i0.ɵɵinject(ValkyrieBackendService), i0.ɵɵinject(i1$7.Router), i0.ɵɵinject(i1$7.ActivatedRoute), i0.ɵɵinject(ValkyrieUtilsService), i0.ɵɵinject(i1$5.Title), i0.ɵɵinject('enableNotification', 8));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: ValkyrieCommonService,
      factory: ValkyrieCommonService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValkyrieCommonService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: ValkyrieBackendService
  }, {
    type: i1$7.Router
  }, {
    type: i1$7.ActivatedRoute
  }, {
    type: ValkyrieUtilsService
  }, {
    type: i1$5.Title
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['enableNotification']
    }]
  }], null);
})();
class SizeDetectorService {
  get onResize$() {
    return this.resizeSubject.asObservable().pipe(distinctUntilChanged());
  }
  constructor() {
    this.resizeSubject = new BehaviorSubject({});
  }
  onResize(id, size, width) {
    let val = {
      id: id,
      size: size,
      width: width
    };
    this.resizeSubject.next(val);
  }
  static {
    this.ɵfac = function SizeDetectorService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SizeDetectorService)();
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: SizeDetectorService,
      factory: SizeDetectorService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SizeDetectorService, [{
    type: Injectable
  }], () => [], null);
})();
class HttpFormErrorInterceptor {
  constructor(formErrorService) {
    this.formErrorService = formErrorService;
  }
  intercept(request, next) {
    return next.handle(request).pipe(catchError(err => {
      if (err.status == 422) {
        this.formErrorService.setFormErrors(err);
        return throwError(err);
      } else if (err.status == 401) {
        if (window.SUB_SYSTEM) {
          window.location.href = '/' + window.SUB_SYSTEM;
        } else {
          window.location.reload();
        }
      } else {
        return throwError(err);
      }
    }));
  }
  static {
    this.ɵfac = function HttpFormErrorInterceptor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HttpFormErrorInterceptor)(i0.ɵɵinject(FormErrorService));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: HttpFormErrorInterceptor,
      factory: HttpFormErrorInterceptor.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HttpFormErrorInterceptor, [{
    type: Injectable
  }], () => [{
    type: FormErrorService
  }], null);
})();
const _c0$14 = ["notifications", ""];
const _c1$R = (a0, a1, a2) => ({
  "black-icon": a0,
  "notification-icn": a1,
  "icn-alarm": a2
});
const _c2$F = (a0, a1) => ({
  read: a0,
  read2: a1
});
function NotificationsComponent_button_0_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.notifications.totalUnread);
  }
}
function NotificationsComponent_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function NotificationsComponent_button_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.showHide = ctx_r1.showHide === false ? true : false;
      return i0.ɵɵresetView(ctx_r1.toggle = !ctx_r1.toggle);
    })("keydown", function NotificationsComponent_button_0_Template_button_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeOnEsc($event, 1));
    });
    i0.ɵɵelementStart(2, "span", 3);
    i0.ɵɵtemplate(3, NotificationsComponent_button_0_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 4, "misc.Notifications"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(6, _c1$R, ctx_r1.showHide, ctx_r1.notifications.totalUnread < 1, ctx_r1.notifications.totalUnread < 1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.totalUnread == null && ctx_r1.notifications.totalUnread > 0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.notifications.totalUnread ? ctx_r1.totalUnread : "", " ");
  }
}
function NotificationsComponent_div_1_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "img", 17);
    i0.ɵɵelementStart(2, "p", 8);
    i0.ɵɵtext(3, "misc.All caught up!");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("src", "/students/psx/assets/images/icons/svg/illustration-empty-notifications.svg", i0.ɵɵsanitizeUrl);
  }
}
function NotificationsComponent_div_1_button_11_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "img", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notifications_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵattribute("src", notifications_r6.company_logo, i0.ɵɵsanitizeUrl);
  }
}
function NotificationsComponent_div_1_button_11_i_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const notifications_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMapInterpolate1("notifications-icon icn-", notifications_r6.icon, "");
  }
}
function NotificationsComponent_div_1_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function NotificationsComponent_div_1_button_11_Template_button_click_0_listener() {
      const ctx_r4 = i0.ɵɵrestoreView(_r4);
      const notifications_r6 = ctx_r4.$implicit;
      const i_r7 = ctx_r4.index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      ctx_r1.markRead(notifications_r6.notification_id, notifications_r6.url, notifications_r6.read_flag, notifications_r6.employer_activity_id);
      return i0.ɵɵresetView(ctx_r1.itemClicked(i_r7));
    });
    i0.ɵɵtemplate(1, NotificationsComponent_div_1_button_11_span_1_Template, 2, 1, "span", 4)(2, NotificationsComponent_div_1_button_11_i_2_Template, 1, 3, "i", 19);
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵelement(4, "p", 21);
    i0.ɵɵelementStart(5, "p", 22);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const notifications_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c2$F, notifications_r6.read_flag == "1", ctx_r1.checkArray(i_r7)));
    i0.ɵɵattribute("aria-label", notifications_r6.template);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", notifications_r6.company_logo);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !notifications_r6.company_logo);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", notifications_r6.template, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(notifications_r6.count_down);
  }
}
function NotificationsComponent_div_1_div_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "a", 24);
    i0.ɵɵtext(2, "misc.View all");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "a", 25);
    i0.ɵɵlistener("keydown", function NotificationsComponent_div_1_div_12_Template_a_keydown_3_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.focusTrap($event));
    })("click", function NotificationsComponent_div_1_div_12_Template_a_click_3_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      ctx_r1.markAllRead();
      return i0.ɵɵresetView(ctx_r1.fillArray(25));
    });
    i0.ɵɵtext(4, "misc.Mark all as read");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", "/students/?s=notifications", i0.ɵɵsanitizeUrl);
  }
}
function NotificationsComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("keydown", function NotificationsComponent_div_1_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeOnEsc($event, 0));
    });
    i0.ɵɵelementStart(1, "div", 6)(2, "div", 7)(3, "h2", 8);
    i0.ɵɵtext(4, "misc.Notifications");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 9);
    i0.ɵɵelementStart(6, "a", 10);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵlistener("keydown", function NotificationsComponent_div_1_Template_a_keydown_6_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.focusTrap($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "div", 11)(9, "div", 12);
    i0.ɵɵtemplate(10, NotificationsComponent_div_1_div_10_Template, 4, 1, "div", 13)(11, NotificationsComponent_div_1_button_11_Template, 7, 9, "button", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(12, NotificationsComponent_div_1_div_12_Template, 5, 1, "div", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵattribute("href", "/students/app/profile/email-notification/in-app-notification", i0.ɵɵsanitizeUrl)("aria-label", i0.ɵɵpipeBind1(7, 5, "misc.Notification Settings"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.notifications.total === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.notifications.model);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.notifications.total != 0);
  }
}
class NotificationsComponent {
  constructor(backendService, sanitized, toastAlertService, translate) {
    this.backendService = backendService;
    this.sanitized = sanitized;
    this.toastAlertService = toastAlertService;
    this.translate = translate;
    this.showHide = false;
    this.toggle = false;
    this.selectedArray = [];
    this.isLoaded = false;
  }
  ngOnInit() {
    this.dataSetup();
  }
  ngAfterViewInit() {
    $$1('body').click(this, e => {
      if (!$$1(event.target).closest('#page-notifications').length) {
        this.showHide = false;
        this.toggle = false;
      }
    });
  }
  dataSetup() {
    this.backendService.getAll('my/notifications', 'v2', {
      includeAggregator: 1
    }).subscribe(res => {
      this.notifications = res;
      this.notifications.model.forEach(model => {
        if (!model.company_logo && !model.icon) {
          model.icon = 'alarm';
        }
        model.template = this.sanitized.bypassSecurityTrustHtml(model.template);
      });
    });
  }
  itemClicked(idx) {
    this.selectedArray.push(idx);
  }
  checkArray(idx) {
    if (this.selectedArray.indexOf(idx) > -1) {
      return true;
    } else {
      return false;
    }
  }
  fillArray(limit) {
    for (let i = 0; i <= limit; i++) {
      this.selectedArray.push(i + '');
    }
    this.totalUnread = 0;
  }
  markRead(notification_id, url, read_flag, employer_activity_id) {
    let empFlag = 0;
    let id = '';
    if (notification_id) {
      id = notification_id;
    } else {
      id = employer_activity_id;
      empFlag = 1;
    }
    if (id) {
      if (read_flag == '0') {
        if (!this.totalUnread) {
          this.totalUnread = this.notifications.totalUnread;
          this.totalUnread--;
        } else {
          this.totalUnread--;
        }
        this.backendService.update(`mark-read?employer_flag=${empFlag}`, 'my/notifications/' + id, null).subscribe(res => {
          this.markReadRedirect(url);
        });
      } else {
        this.markReadRedirect(url);
      }
    }
  }
  markAllRead() {
    this.backendService.updateWithoutID('/my/notifications/mark-read', '').subscribe(res => {
      this.toastAlertService.success(this.translate.instant('misc.Successfully Marked All Notifications as Read'));
      this.notifications.model.forEach(notification => {
        notification.read_flag = 1;
      });
    });
  }
  markReadRedirect(url) {
    if (url !== null) {
      if (url.indexOf('/students/app/') < 0) {
        url = '/students/index.php?' + url;
      }
      let new_location = url;
      window.location.replace(new_location);
    }
  }
  focusTrap(e) {
    if (e.which == 9) {
      var focusableElements = Array.from($$1('.toolbar-notifications').find(':focusable'));
      var nextElementIndex = focusableElements.findIndex(elm => elm === e.target);
      e.shiftKey ? nextElementIndex-- : nextElementIndex++;
      if (nextElementIndex < 0) {
        e.preventDefault();
        var total_focusable = $$1('.toolbar-notifications').find(':focusable').length;
        $$1('.toolbar-notifications').find(':focusable').eq(total_focusable - 1).focus();
      } else if (nextElementIndex >= focusableElements.length) {
        e.preventDefault();
        $$1('.toolbar-notifications').find(':focusable').eq(0).focus();
      }
    }
  }
  closeOnEsc(e, closeOnNavOut) {
    if (e.keyCode === 27) {
      this.showHide = false;
      this.toggle = false;
      $$1('#page-notifications button').eq(0).focus();
    }
    if (closeOnNavOut) {
      if (e.which == 9 && e.shiftKey) {
        this.showHide = false;
        this.toggle = false;
      }
    }
  }
  static {
    this.ɵfac = function NotificationsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NotificationsComponent)(i0.ɵɵdirectiveInject(ValkyrieBackendService), i0.ɵɵdirectiveInject(i1$5.DomSanitizer), i0.ɵɵdirectiveInject(ToastAlertService), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: NotificationsComponent,
      selectors: [["", "notifications", ""]],
      standalone: false,
      attrs: _c0$14,
      decls: 2,
      vars: 2,
      consts: [["class", "avatar monogram toolbar-BTN", 3, "click", "keydown", 4, "ngIf"], ["class", "toolbar-notifications", 3, "keydown", 4, "ngIf"], [1, "avatar", "monogram", "toolbar-BTN", 3, "click", "keydown"], [3, "ngClass"], [4, "ngIf"], [1, "toolbar-notifications", 3, "keydown"], [1, "notifications-toolbar"], [1, "md-toolbar-tools", "md-toolbar-tools-top"], ["translate", ""], [1, "flex"], [1, "settings", "icn-gear", 3, "keydown"], [1, "notifications-content"], ["md-no-ink", "", 1, "notifications-list"], ["class", "empty-notification text-center", 4, "ngIf"], ["class", "notifications-list-item md-no-style", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["class", "bottom", "layout", "row", "layout-align", "center center", 4, "ngIf"], [1, "empty-notification", "text-center"], ["role", "presentation", "alt", ""], [1, "notifications-list-item", "md-no-style", 3, "click", "ngClass"], [3, "class", 4, "ngIf"], [1, "list-item-content"], [3, "innerHTML"], [1, "notification-time"], ["layout", "row", "layout-align", "center center", 1, "bottom"], ["translate", "", 1, "primary_link"], ["tabindex", "0", "translate", "", 1, "secondary_link", 3, "keydown", "click"]],
      template: function NotificationsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, NotificationsComponent_button_0_Template, 5, 10, "button", 0)(1, NotificationsComponent_div_1_Template, 13, 7, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.notifications);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showHide);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1$1.TranslateDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationsComponent, [{
    type: Component,
    args: [{
      selector: '[notifications]',
      standalone: false,
      template: "<button *ngIf=\"notifications\" (click)=\"showHide = showHide === false ? true: false; toggle = !toggle;\" (keydown)=\"closeOnEsc($event, 1)\" class=\"avatar monogram toolbar-BTN\" [attr.aria-label]=\"'misc.Notifications' | translate\">\n    <span [ngClass]=\"{'black-icon': showHide, 'notification-icn': notifications.totalUnread < 1, 'icn-alarm': notifications.totalUnread < 1 }\">\n        <span *ngIf=\"totalUnread == null && notifications.totalUnread > 0\">{{notifications.totalUnread}}</span>\n        {{notifications.totalUnread ? totalUnread : ''}}\n    </span>\n</button>\n<div *ngIf=\"showHide\" class=\"toolbar-notifications\" (keydown)=\"closeOnEsc($event, 0)\">\n    <div class=\"notifications-toolbar\">\n        <div class=\"md-toolbar-tools md-toolbar-tools-top\">\n            <h2 translate>misc.Notifications</h2>\n            <span class=\"flex\"></span>\n            <a class=\"settings icn-gear\" (keydown)=\"focusTrap($event)\" [attr.href]=\"'/students/app/profile/email-notification/in-app-notification'\" [attr.aria-label]=\"'misc.Notification Settings' | translate\"></a>\n        </div>\n    </div>\n    <div class=\"notifications-content\">\n        <div class=\"notifications-list\" md-no-ink>\n            <div class=\"notifications-list-item\" class=\"empty-notification text-center\" *ngIf=\"notifications.total === 0\">\n                <img [attr.src]=\"'/students/psx/assets/images/icons/svg/illustration-empty-notifications.svg'\" role=\"presentation\" alt=\"\">\n                <p translate>misc.All caught up!</p>\n            </div>\n            <button class=\"notifications-list-item md-no-style\" *ngFor=\"let notifications of notifications.model; let i = index;\" (click)=\"markRead(notifications.notification_id, notifications.url, notifications.read_flag, notifications.employer_activity_id); itemClicked(i);\" [ngClass]=\"{read: notifications.read_flag == '1', read2: checkArray(i)}\" [attr.aria-label]=\"notifications.template\">\n                <span *ngIf=\"notifications.company_logo\">\n                    <img [attr.src]=\"notifications.company_logo\" role=\"presentation\" alt=\"\"/>\n                </span>\n                <i class=\"notifications-icon icn-{{notifications.icon}}\" *ngIf=\"!notifications.company_logo\"></i>\n                <div class=\"list-item-content\">\n                    <p [innerHTML]=\"notifications.template\"></p>\n                    <p class=\"notification-time\" >{{notifications.count_down}}</p>\n                </div>\n            </button>\n        </div>\n    </div>\n    <div *ngIf=\"notifications.total != 0\" class=\"bottom\" layout=\"row\" layout-align=\"center center\">\n        <a class=\"primary_link\" [attr.href]=\"'/students/?s=notifications'\" translate>misc.View all</a>\n        <a class=\"secondary_link\" (keydown)=\"focusTrap($event)\" (click)=\"markAllRead(); fillArray(25);\" tabindex=\"0\" translate>misc.Mark all as read</a>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: ValkyrieBackendService
  }, {
    type: i1$5.DomSanitizer
  }, {
    type: ToastAlertService
  }, {
    type: i1$1.TranslateService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(NotificationsComponent, {
    className: "NotificationsComponent",
    filePath: "valkyrie/layout/notifications.component.ts",
    lineNumber: 15
  });
})();
const _c0$13 = ["contact-chip", ""];
function ContactChipComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 3);
  }
}
function ContactChipComponent_div_2_img_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("src", ctx_r1.profile_pic_url, i0.ɵɵsanitizeUrl);
  }
}
function ContactChipComponent_div_2_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getNameInitials(ctx_r1.user.name));
  }
}
function ContactChipComponent_div_2_div_7_li_4_a_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵlistener("keydown", function ContactChipComponent_div_2_div_7_li_4_a_1_Template_a_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusTrap($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tool_item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMapInterpolate1("", tool_item_r4.class, " branding-text1");
    i0.ɵɵpropertyInterpolate("target", tool_item_r4.target);
    i0.ɵɵattribute("href", tool_item_r4.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(tool_item_r4.label);
  }
}
function ContactChipComponent_div_2_div_7_li_4_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵpipe(1, "safeHtml");
    i0.ɵɵlistener("keydown", function ContactChipComponent_div_2_div_7_li_4_div_2_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusTrap($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tool_item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, tool_item_r4.html), i0.ɵɵsanitizeHtml);
  }
}
function ContactChipComponent_div_2_div_7_li_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 17);
    i0.ɵɵtemplate(1, ContactChipComponent_div_2_div_7_li_4_a_1_Template, 2, 6, "a", 18)(2, ContactChipComponent_div_2_div_7_li_4_div_2_Template, 2, 3, "div", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tool_item_r4 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", tool_item_r4.first ? "first-focusable" : tool_item_r4.last ? "last-focusable" : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !tool_item_r4.html);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tool_item_r4.html);
  }
}
function ContactChipComponent_div_2_div_7_ng_container_5_nav_1_li_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 24);
    i0.ɵɵlistener("keydown", function ContactChipComponent_div_2_div_7_ng_container_5_nav_1_li_4_Template_a_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.focusTrap($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const child_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", child_r7.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("target", child_r7.target);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(child_r7.text);
  }
}
function ContactChipComponent_div_2_div_7_ng_container_5_nav_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "nav")(1, "div", 23);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ContactChipComponent_div_2_div_7_ng_container_5_nav_1_li_4_Template, 3, 3, "li", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const childItem_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("tool-", childItem_r8.label, "");
    i0.ɵɵattribute("aria-labelledby", "user-menu-header-" + ctx_r1.tools.length);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "user-menu-header-", ctx_r1.tools.length, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 8, childItem_r8.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", childItem_r8.menu);
  }
}
function ContactChipComponent_div_2_div_7_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ContactChipComponent_div_2_div_7_ng_container_5_nav_1_Template, 5, 10, "nav", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const childItem_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", childItem_r8.menu == null ? null : childItem_r8.menu.length);
  }
}
function ContactChipComponent_div_2_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul", 14);
    i0.ɵɵtemplate(4, ContactChipComponent_div_2_div_7_li_4_Template, 3, 3, "li", 15)(5, ContactChipComponent_div_2_div_7_ng_container_5_Template, 2, 1, "ng-container", 16);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tool_r9 = ctx.$implicit;
    const idx_r10 = ctx.index;
    i0.ɵɵclassMapInterpolate1("tool-", tool_r9.label, "");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "user-menu-header-", idx_r10, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(tool_r9.label);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-labelledby", "user-menu-header-" + idx_r10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", tool_r9.items);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", tool_r9.child);
  }
}
function ContactChipComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "button", 5);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("keydown", function ContactChipComponent_div_2_Template_button_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeOnEsc($event, 1));
    })("click", function ContactChipComponent_div_2_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleMenu($event));
    });
    i0.ɵɵtemplate(3, ContactChipComponent_div_2_img_3_Template, 1, 1, "img", 6)(4, ContactChipComponent_div_2_div_4_Template, 2, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 8);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵlistener("keydown", function ContactChipComponent_div_2_Template_div_keydown_5_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeOnEsc($event, 0));
    });
    i0.ɵɵtemplate(7, ContactChipComponent_div_2_div_7_Template, 6, 9, "div", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 5, "misc.User Menu"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.profile_pic_url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.profile_pic_url);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 7, "misc.User Account and Tools links"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.tools);
  }
}
class ContactChipComponent {
  constructor(router, activatedRoute, backendService, commonService, authSerivce, translate) {
    this.router = router;
    this.activatedRoute = activatedRoute;
    this.backendService = backendService;
    this.commonService = commonService;
    this.authSerivce = authSerivce;
    this.translate = translate;
    this.profile_pic_url = false;
    this.account_blocked = false;
    this.enableNotifications = false;
  }
  ngOnInit() {
    this.enableNotifications = this.commonService.enableNotification;
  }
  ngAfterViewInit() {
    this.setupContactChip();
  }
  setupToolItem(data, index) {
    data[index]["target"] = "_self";
    switch (index) {
      case 'logout':
        data[index]['class'] = 'font-weight-bold';
        break;
      case 'timezone':
        data[index]["html"] = "<a href=\"javascript:void(0)\" title=\"" + this.i18('misc.Select your timezone') + "\" onclick=\"newpopframe(this, 'select_tz', '" + this.i18('misc.Select your timezone') + "', '/utils/tzSelector.php', \'sm\', 300, 'center')\">" + data[index]["label"] + "</a>";
        break;
      case 'xlate-switcher':
        if (!data[index]["langs_supported"] || !data[index]["current_lang"]) {
          break;
        }
        let xli_selected = "";
        data[index]["html"] = "<form id=\"xlate-lang-form\"><select onchange=\"self.location.href='?_lang_switch=' + this.options[selectedIndex].value\" id=\"" + data[index]["id"] + "\" name=\"which_lang\" aria-label=\"" + this.i18('misc.Language') + "\">";
        for (let xli in data[index]["langs_supported"]) {
          if (xli === data[index]["current_lang"]) {
            xli_selected = " selected=\"selected\" ";
          } else {
            xli_selected = "";
          }
          data[index]["html"] += "<option value=\"" + xli + "\"" + xli_selected + ">" + data[index]["langs_supported"][xli] + "</option>";
        }
        data[index]["html"] += "</select><input type=\"submit\" value=\"Go\" class=\"acc_hide\" tabindex=\"-1\"></form>";
        break;
      case 'help':
        data[index]["target"] = "csm-help";
        if (!data[index]["label"]) {
          data[index]["label"] = this.translate.instant('misc.Help');
        }
        if (!data[index]["link"]) {
          const userType = this.user.class == 'contact' ? 'employer' : this.user.class;
          data[index]["link"] = '/utils/help.php?sy=' + userType + '&se=home';
        }
        if (!data[index]["onclick"]) {
          data[index]["onclick"] = 'return getHelpWindow();';
        }
    }
  }
  generateUserMenu(data, account_array, tool_array) {
    let tools_array = [{
      label: "misc.Tools",
      items: []
    }, {
      label: "misc.Account",
      items: []
    }];
    const jumpto = data['jumpto'];
    if (jumpto) {
      tools_array[0]['child'] = [jumpto];
    }
    for (let item of tool_array) {
      if (!data[item]) {
        continue;
      }
      this.setupToolItem(data, item);
      tools_array[0].items.push(data[item]);
    }
    for (let item of account_array) {
      if (!data[item]) {
        continue;
      }
      this.setupToolItem(data, item);
      tools_array[1].items.push(data[item]);
    }
    return tools_array;
  }
  focusTrap(e) {
    if (e.which == 9) {
      var focusableElements = Array.from($$1('#user-tools').find(':focusable'));
      var nextElementIndex = focusableElements.findIndex(elm => elm === e.target);
      e.shiftKey ? nextElementIndex-- : nextElementIndex++;
      if (nextElementIndex < 0) {
        e.preventDefault();
        var total_focusable = $$1('#user-tools').find(':focusable').length;
        $$1('#user-tools').find(':focusable').eq(total_focusable - 1).focus();
      } else if (nextElementIndex >= focusableElements.length) {
        e.preventDefault();
        $$1('#user-tools').find(':focusable').eq(0).focus();
      }
    }
    if (e.which == 27) {
      this.closeTools(e);
      $$1('.user-tools-container button').eq(0).focus();
    }
  }
  setupStudentMenu(id, section = 'home', subsection = undefined, mode = undefined, subtab = undefined, helpparam = undefined) {
    let account_array = ["personal_info", "academic_info", "privacy", "learn_more_gts", "notification_settings", "timezone", "password", "logout"];
    let tool_array = ["xlate-switcher", "help", "acc"];
    let param = {
      section: section,
      subsection: subsection,
      mode: mode,
      subtab: subtab,
      helpparam: helpparam
    };
    this.backendService.getAll(`student/${id}/navigation-tools`, 'v2', param).subscribe(response => {
      this.tools = this.generateUserMenu(response, account_array, tool_array);
    });
  }
  setupEmployerMenu(section, subsection) {
    let data = window.ngData.userMenu;
    let account_array = ["profile", "privacy", "password", "logout"];
    let tool_array = ["xlate-switcher", "help", "acc", 'hat_switcher'];
    if (data.my_account) {
      data = Object.assign(data, data.my_account.menu);
      delete data.my_account;
    }
    data.help.link = this.updateHelpLink('employers', section, subsection);
    this.tools = this.generateUserMenu(data, account_array, tool_array);
  }
  setupFacultyMenu(section, subsection) {
    let data = window.ngData.userMenu;
    let account_array = ["profile", "password", "logout"];
    let tool_array = ["xlate-switcher", "linkedin", "help", "acc"];
    if (data.my_account && Object.keys(data.my_account.menu).length) {
      data = Object.assign(data, data.my_account.menu);
      delete data.my_account;
    }
    data.help.link = this.updateHelpLink('faculty', section, subsection);
    this.tools = this.generateUserMenu(data, account_array, tool_array);
  }
  updateHelpLink(type, section, subsection) {
    return '/utils/help.php?' + $$1.param({
      sy: type,
      se: section,
      ta: subsection
    });
  }
  i18(value) {
    return this.translate.instant(value);
  }
  setupContactChip() {
    this.authSerivce.getCurrentUser().subscribe(response => {
      if (!_.isEmpty(response)) {
        this.user = response;
        if (this.user.account_blocked && this.user.account_blocked == '1') {
          this.account_blocked = true;
        }
        this.updateAvatarAsImage();
        this.setupHelpHint();
        this.subscription = this.router.events.subscribe(e => {
          if (e instanceof NavigationEnd) {
            this.setupHelpHint();
          }
        });
        $$1('body').click(this, e => {
          if (!$$1(e.target).closest('.user-tools-container').length) {
            this.closeTools(e);
          }
        });
      }
    });
  }
  updateAvatarAsImage() {
    switch (this.user.class) {
      case 'student':
        this.commonService.checkImageBySize(this.user.id, 40).pipe(filter(response => (response.messages === undefined || response.messages[0].type !== 'error') && response.url)).subscribe(response => {
          this.profile_pic_url = response.url;
        });
        break;
    }
  }
  setupHelpHint() {
    const sectionData = ValkyrieUtilsService.findTargetKeyInDeepTreeObj(this.activatedRoute.snapshot, 'children', ['routeConfig', 'data', 'phpSectionParams'], undefined, true);
    const isSamePage = _.isEqual(this.lastSectionParam, sectionData[sectionData.length - 1]);
    if (isSamePage && !_.isEmpty(this.tools)) {
      return;
    }
    this.lastSectionParam = sectionData[sectionData.length - 1];
    let section = this.lastSectionParam ? this.lastSectionParam.section : undefined;
    let subsection = this.lastSectionParam ? this.lastSectionParam.subsection : undefined;
    switch (this.user.class) {
      case 'student':
        this.setupStudentMenu(this.user.id, section, subsection);
        break;
      case 'contact':
        this.setupEmployerMenu(section, subsection);
        break;
      case 'faculty':
        this.setupFacultyMenu(section, subsection);
        break;
    }
  }
  toggleMenu(e) {
    if ($$1(e.currentTarget).hasClass('badge-toggle-closed')) {
      this.openTools(e);
    } else {
      this.closeTools(e);
    }
  }
  openTools(e) {
    $$1('.ng-contact-chip').addClass('user-tools-open');
    var contact_toggle_icon = $$1('.ng-contact-chip .toggle-icon');
    var openClass = contact_toggle_icon.attr('data-openclass');
    var closedClass = contact_toggle_icon.attr('data-closedclass');
    contact_toggle_icon.addClass(openClass).removeClass(closedClass);
    $$1('.badge-toggle').removeClass('badge-toggle-closed').addClass('badge-toggle-open').attr('aria-expanded', 'true');
  }
  closeTools(e) {
    $$1('.ng-contact-chip').removeClass('user-tools-open');
    var contact_toggle_icon = $$1('.ng-contact-chip .toggle-icon');
    var openClass = contact_toggle_icon.attr('data-openclass');
    var closedClass = contact_toggle_icon.attr('data-closedclass');
    contact_toggle_icon.addClass(closedClass).removeClass(openClass);
    $$1('.badge-toggle').removeClass('badge-toggle-open').addClass('badge-toggle-closed').attr('aria-expanded', 'false');
  }
  getNameInitials(name) {
    return name.split(' ').map(n => n[0]).join('').toUpperCase().replace(/^(.).*(.)$/, '$1$2');
  }
  closeOnEsc(e, closeOnNavOut) {
    if (e.keyCode === 27) {
      this.closeTools(e);
      $$1('.user-tools-container button').eq(0).focus();
    }
    if (closeOnNavOut) {
      if (e.which == 9 && e.shiftKey) {
        this.closeTools(e);
      }
    }
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  static {
    this.ɵfac = function ContactChipComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ContactChipComponent)(i0.ɵɵdirectiveInject(i1$7.Router), i0.ɵɵdirectiveInject(i1$7.ActivatedRoute), i0.ɵɵdirectiveInject(ValkyrieBackendService), i0.ɵɵdirectiveInject(ValkyrieCommonService), i0.ɵɵdirectiveInject(ValkyrieAuthService), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ContactChipComponent,
      selectors: [["", "contact-chip", ""]],
      standalone: false,
      attrs: _c0$13,
      decls: 3,
      vars: 2,
      consts: [[1, "ng-contact-chip"], ["notifications", "", "id", "page-notifications", 4, "ngIf"], ["class", "user-tools-container", 4, "ngIf"], ["notifications", "", "id", "page-notifications"], [1, "user-tools-container"], ["aria-haspopup", "true", "aria-controls", "user-tools", "tabindex", "0", 1, "contact-summary", "avatar", "avatar-img-cover", "monogram", "badge-toggle", "badge-toggle-closed", 3, "keydown", "click"], ["alt", "Profile Picture", "role", "presentation", "class", "avatar profile-picture", 4, "ngIf"], ["class", "avatar monogram", 4, "ngIf"], ["id", "user-tools", "role", "navigation", 3, "keydown"], ["role", "menubar", 3, "class", 4, "ngFor", "ngForOf"], ["alt", "Profile Picture", "role", "presentation", 1, "avatar", "profile-picture"], [1, "avatar", "monogram"], ["role", "menubar"], ["translate", "", 1, "section-title", 3, "id"], ["role", "menu"], [3, "ngClass", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], [3, "ngClass"], ["role", "menuitem", 3, "target", "class", "keydown", 4, "ngIf"], ["class", "branding-text1", 3, "innerHTML", "keydown", 4, "ngIf"], ["role", "menuitem", 3, "keydown", "target"], [1, "branding-text1", 3, "keydown", "innerHTML"], [3, "class", 4, "ngIf"], [1, "section-title", 3, "id"], ["role", "menuitem", 1, "branding-text1", 3, "keydown", "href", "target"]],
      template: function ContactChipComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, ContactChipComponent_div_1_Template, 1, 0, "div", 1)(2, ContactChipComponent_div_2_Template, 8, 9, "div", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.enableNotifications);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.user);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1$1.TranslateDirective, NotificationsComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContactChipComponent, [{
    type: Component,
    args: [{
      selector: '[contact-chip]',
      standalone: false,
      template: "<div class=\"ng-contact-chip\">\n    <div notifications *ngIf=\"enableNotifications\" id=\"page-notifications\"></div>\n    <div class=\"user-tools-container\" *ngIf=\"user\">\n        <button [attr.aria-label]=\"'misc.User Menu' | translate\" aria-haspopup=\"true\" aria-controls=\"user-tools\" class=\"contact-summary avatar avatar-img-cover monogram badge-toggle badge-toggle-closed\" tabindex=\"0\" (keydown)=\"closeOnEsc($event, 1)\" (click)=\"toggleMenu($event)\">\n            <img alt=\"Profile Picture\" role=\"presentation\" class=\"avatar profile-picture\" *ngIf=\"profile_pic_url\" [attr.src]=\"profile_pic_url\"/>\n            <div class=\"avatar monogram\" *ngIf=\"!profile_pic_url\">{{getNameInitials(user.name)}}</div>\n        </button>\n        <div id=\"user-tools\" role=\"navigation\" [attr.aria-label]=\"'misc.User Account and Tools links' | translate\" (keydown)=\"closeOnEsc($event, 0)\">\n            <div *ngFor=\"let tool of tools; index as idx\" class=\"tool-{{ tool.label }}\" role=\"menubar\">\n                <div id=\"user-menu-header-{{idx}}\" class=\"section-title\" translate>{{tool.label}}</div>\n                <ul role=\"menu\" [attr.aria-labelledby]=\"'user-menu-header-' + idx\">\n                    <li *ngFor=\"let tool_item of tool.items;\" [ngClass]=\"tool_item.first ? 'first-focusable' : tool_item.last ? 'last-focusable' : null\">\n                        <a (keydown)=\"focusTrap($event)\" [attr.href]=\"tool_item.link\" *ngIf=\"!tool_item.html\" target=\"{{ tool_item.target }}\" class=\"{{ tool_item.class }} branding-text1\" role=\"menuitem\">{{ tool_item.label }}</a>\n                        <div (keydown)=\"focusTrap($event)\" *ngIf=\"tool_item.html\" [innerHTML]=\"tool_item.html | safeHtml\" class=\"branding-text1\"></div>\n                    </li>\n                    <ng-container *ngFor=\"let childItem of tool.child\">\n                        <nav *ngIf=\"childItem.menu?.length\" class=\"tool-{{ childItem.label }}\" [attr.aria-labelledby]=\"'user-menu-header-' + tools.length\">\n                            <div id=\"user-menu-header-{{tools.length}}\" class=\"section-title\">{{childItem.label | translate}}</div>\n                            <li *ngFor=\"let child of childItem.menu\">\n                                <a (keydown)=\"focusTrap($event)\" href=\"{{ child.link }}\" target=\"{{ child.target }}\" class=\"branding-text1\" role=\"menuitem\">{{ child.text }}</a>\n                            </li>\n                        </nav>\n                    </ng-container>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>"
    }]
  }], () => [{
    type: i1$7.Router
  }, {
    type: i1$7.ActivatedRoute
  }, {
    type: ValkyrieBackendService
  }, {
    type: ValkyrieCommonService
  }, {
    type: ValkyrieAuthService
  }, {
    type: i1$1.TranslateService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ContactChipComponent, {
    className: "ContactChipComponent",
    filePath: "valkyrie/layout/contact-chip.component.ts",
    lineNumber: 21
  });
})();
const _c0$12 = ["page-header", ""];
const _c1$Q = a0 => ({
  "background-image": a0
});
function PageHeaderComponent_button_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "i", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "misc.Navigation"));
  }
}
function PageHeaderComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c1$Q, "url(" + ctx_r0.branding_image + ")"));
  }
}
function PageHeaderComponent_a_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 11);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "div", 10);
    i0.ɵɵelementStart(3, "span", 12);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 5, "misc.Visit Site"));
    i0.ɵɵattribute("href", ctx_r0.branding_link, i0.ɵɵsanitizeUrl)("target", "_blank");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c1$Q, "url(" + ctx_r0.branding_image + ")"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 7, "misc.Visit Site"));
  }
}
function PageHeaderComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 13);
    i0.ɵɵelementStart(2, "div", 14);
    i0.ɵɵelement(3, "span", 15)(4, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
class PageHeaderComponent {
  constructor() {
    this.branding_image = '';
    this.branding_link = '';
    this.tools = true;
  }
  ngOnInit() {
    this.branding_image = window.BRANDING_IMAGE ? window.BRANDING_IMAGE : window.DEFAULT_BRANDING_IMAGE;
    this.branding_link = window.BRANDING_LINK;
  }
  static {
    this.ɵfac = function PageHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageHeaderComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: PageHeaderComponent,
      selectors: [["", "page-header", ""]],
      inputs: {
        tools: "tools"
      },
      standalone: false,
      attrs: _c0$12,
      decls: 7,
      vars: 4,
      consts: [[1, "container"], [1, "header-menu"], ["id", "page-menu", "class", "nav-toggle branding-bg nav-toggle btn btn_icn no-margin", 4, "ngIf"], ["id", "page-brand", 1, "branding-bg"], ["class", "nav-brand", 4, "ngIf"], ["class", "nav-brand branding-bg", 3, "title", 4, "ngIf"], [4, "ngIf"], ["id", "page-menu", 1, "nav-toggle", "branding-bg", "nav-toggle", "btn", "btn_icn", "no-margin"], [1, "icn-menu"], [1, "nav-brand"], [3, "ngStyle"], [1, "nav-brand", "branding-bg", 3, "title"], [1, "sr-only"], ["id", "page-flex-fill"], ["id", "page-user"], ["id", "loginas-placeholder"], ["contact-chip", "", 1, "ng-contact-chip", "layout-row"]],
      template: function PageHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtemplate(2, PageHeaderComponent_button_2_Template, 3, 3, "button", 2);
          i0.ɵɵelementStart(3, "div", 3);
          i0.ɵɵtemplate(4, PageHeaderComponent_div_4_Template, 2, 3, "div", 4)(5, PageHeaderComponent_a_5_Template, 6, 11, "a", 5);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(6, PageHeaderComponent_ng_container_6_Template, 5, 0, "ng-container", 6);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.tools);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.branding_link);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.branding_link);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.tools);
        }
      },
      dependencies: [i1.NgIf, i1.NgStyle, ContactChipComponent, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageHeaderComponent, [{
    type: Component,
    args: [{
      selector: '[page-header]',
      standalone: false,
      template: "<div class=\"container\">\n    <div class=\"header-menu\">\n        <button *ngIf=\"tools\" id=\"page-menu\" class=\"nav-toggle branding-bg nav-toggle btn btn_icn no-margin\" [attr.aria-label]=\"'misc.Navigation' | translate \">\n            <i class=\"icn-menu\"></i>\n        </button>\n        <div id=\"page-brand\" class=\"branding-bg\">\n            <div *ngIf=\"!branding_link\" class=\"nav-brand\">\n                <div [ngStyle]=\"{'background-image': 'url(' + branding_image + ')'}\" ></div>\n            </div>\n            <a *ngIf=\"branding_link\" [attr.href]=\"branding_link\" [attr.target]=\"'_blank'\" class=\"nav-brand branding-bg\" title=\"{{'misc.Visit Site' | translate}}\">\n                <div [ngStyle]=\"{'background-image': 'url(' + branding_image + ')'}\" ></div>\n                <span class=\"sr-only\">{{'misc.Visit Site' | translate}}</span>\n            </a>\n        </div>\n    </div>\n    <ng-container *ngIf=\"tools\">\n        <div id=\"page-flex-fill\"></div>\n        <div id=\"page-user\">\n            <span id=\"loginas-placeholder\"></span>\n            <div contact-chip class=\"ng-contact-chip layout-row\"></div>\n        </div>\n    </ng-container>\n</div>\n"
    }]
  }], () => [], {
    tools: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PageHeaderComponent, {
    className: "PageHeaderComponent",
    filePath: "valkyrie/layout/page-header.component.ts",
    lineNumber: 12
  });
})();
const _c0$11 = ["page-footer", ""];
function PageFooterComponent_div_2_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "a", 9);
    i0.ɵɵtext(2, "misc.Privacy Policy");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " | ");
    i0.ɵɵelementStart(4, "a", 10);
    i0.ɵɵtext(5, "misc.Terms of Use");
    i0.ɵɵelementEnd()();
  }
}
function PageFooterComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "a", 5);
    i0.ɵɵelement(3, "img", 6);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtemplate(6, PageFooterComponent_div_2_div_6_Template, 6, 0, "div", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("alt", i0.ɵɵpipeBind1(4, 2, "Powered by Symplicity"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.language_pack);
  }
}
class PageFooterComponent {
  constructor() {
    this.text_footer = '';
    this.language_pack = false;
    this.show_symp_branding = true;
  }
  ngOnInit() {
    this.text_footer = window.ngData.textfooter ? window.ngData.textfooter : '';
    this.language_pack = window.ngData.language_pack ? window.ngData.language_pack : false;
    if (window.ngData.hasOwnProperty('show_symp_branding')) {
      this.show_symp_branding = window.ngData.show_symp_branding;
    }
  }
  static {
    this.ɵfac = function PageFooterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageFooterComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: PageFooterComponent,
      selectors: [["", "page-footer", ""]],
      standalone: false,
      attrs: _c0$11,
      decls: 3,
      vars: 2,
      consts: [[1, "page-footer", "space-bottom-md"], [1, "footer-text", 3, "innerHTML"], ["class", "page-footer", 4, "ngIf"], [1, "page-footer"], [1, "footer-image"], ["href", "http://symplicity.com/career_services_manager_csm", "target", "_blank"], ["src", "/si_ei/images/csm_footer_branding.svg", 3, "alt"], ["class", "footer-links", 4, "ngIf"], [1, "footer-links"], ["href", "http://www.symplicity.com/privacy_policy", "target", "_blank", "translate", ""], ["href", "http://www.symplicity.com/terms_of_use", "target", "_blank", "translate", ""]],
      template: function PageFooterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "div", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(2, PageFooterComponent_div_2_Template, 7, 4, "div", 2);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("innerHTML", ctx.text_footer, i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.show_symp_branding);
        }
      },
      dependencies: [i1.NgIf, i1$1.TranslateDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageFooterComponent, [{
    type: Component,
    args: [{
      selector: '[page-footer]',
      standalone: false,
      template: "<div class=\"page-footer space-bottom-md\">\n    <div class=\"footer-text\" [innerHTML]=\"text_footer\"></div>\n</div>\n<div *ngIf=\"show_symp_branding\" class=\"page-footer\">\n    <div class=\"footer-image\">\n        <a href=\"http://symplicity.com/career_services_manager_csm\" target=\"_blank\">\n            <img src=\"/si_ei/images/csm_footer_branding.svg\" alt=\"{{'Powered by Symplicity' | translate}}\" />\n        </a>\n    </div>\n    <div>\n        <div *ngIf=\"!language_pack\" class=\"footer-links\">\n            <a href=\"http://www.symplicity.com/privacy_policy\" target=\"_blank\" translate>misc.Privacy Policy</a> | <a href=\"http://www.symplicity.com/terms_of_use\" target=\"_blank\" translate>misc.Terms of Use</a>\n        </div>\n    </div>\n</div>\n"
    }]
  }], () => [], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PageFooterComponent, {
    className: "PageFooterComponent",
    filePath: "valkyrie/layout/page-footer.component.ts",
    lineNumber: 11
  });
})();
const _c0$10 = ["breadcrumbs", ""];
function BreadcrumbsComponent_ng_container_2_li_1_span_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const breadcrumb_r1 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, breadcrumb_r1.label), " ");
  }
}
function BreadcrumbsComponent_ng_container_2_li_1_span_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const breadcrumb_r1 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", breadcrumb_r1.label, " ");
  }
}
function BreadcrumbsComponent_ng_container_2_li_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "a");
    i0.ɵɵtemplate(2, BreadcrumbsComponent_ng_container_2_li_1_span_1_ng_container_2_Template, 3, 3, "ng-container", 2)(3, BreadcrumbsComponent_ng_container_2_li_1_span_1_ng_container_3_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 4);
    i0.ɵɵtext(5, "/");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const breadcrumb_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", breadcrumb_r1.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", breadcrumb_r1.translateLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !breadcrumb_r1.translateLabel);
  }
}
function BreadcrumbsComponent_ng_container_2_li_1_span_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const breadcrumb_r1 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, breadcrumb_r1.label), " ");
  }
}
function BreadcrumbsComponent_ng_container_2_li_1_span_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const breadcrumb_r1 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", breadcrumb_r1.label, " ");
  }
}
function BreadcrumbsComponent_ng_container_2_li_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtemplate(1, BreadcrumbsComponent_ng_container_2_li_1_span_2_ng_container_1_Template, 3, 3, "ng-container", 2)(2, BreadcrumbsComponent_ng_container_2_li_1_span_2_ng_container_2_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const breadcrumb_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵattribute("aria-current", "page");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", breadcrumb_r1.translateLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !breadcrumb_r1.translateLabel);
  }
}
function BreadcrumbsComponent_ng_container_2_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, BreadcrumbsComponent_ng_container_2_li_1_span_1_Template, 6, 3, "span", 2)(2, BreadcrumbsComponent_ng_container_2_li_1_span_2_Template, 3, 3, "span", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const last_r2 = i0.ɵɵnextContext().last;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !last_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", last_r2);
  }
}
function BreadcrumbsComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BreadcrumbsComponent_ng_container_2_li_1_Template, 3, 2, "li", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const breadcrumb_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", breadcrumb_r1.show);
  }
}
class BreadcrumbsComponent {
  constructor(router, activatedRoute, commonService, utilService, destroy$) {
    this.router = router;
    this.activatedRoute = activatedRoute;
    this.commonService = commonService;
    this.utilService = utilService;
    this.destroy$ = destroy$;
  }
  ngOnInit() {
    this.breadcrumbs$ = this.commonService.getBreadcrumbs().pipe(filter(breadcrumbs => !!breadcrumbs.length), map(breadcrumbs => breadcrumbs.filter(breadcrumb => breadcrumb.label)));
    this.setupBreadcrumbs();
    this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.destroy$)).subscribe(() => this.setupBreadcrumbs());
  }
  setupBreadcrumbs() {
    const breadcrumbStartRoute = ValkyrieUtilsService.findTargetKeyInDeepTreeObj(this.activatedRoute.snapshot, 'children', ['routeConfig', 'data', 'breadcrumbStartRoute']);
    const root = breadcrumbStartRoute.length ? breadcrumbStartRoute[breadcrumbStartRoute.length - 1] : this.activatedRoute.snapshot.firstChild;
    const currentRouteData = this.utilService.getDeepestTarget(this.activatedRoute.snapshot, 'children', 'data');
    if (!root || currentRouteData && currentRouteData.ignoreBreadcrumbUpdate) {
      return;
    }
    let routeBreadcrumbs = this.getRouteBreadcrumbs(root);
    let breadcrumbs;
    if (this.siteStructureSubs) {
      this.siteStructureSubs.unsubscribe();
    }
    this.siteStructureSubs = this.commonService.getSiteStructure().pipe(takeUntil(this.destroy$)).subscribe(res => {
      breadcrumbs = this.generateBreadcrumbsFromSiteStucture(res);
      if (this.activatedRoute.snapshot.firstChild && breadcrumbStartRoute.length) {
        breadcrumbs.splice(1);
      }
      breadcrumbs = breadcrumbs.concat(routeBreadcrumbs);
      let state = window.history.state;
      if (routeBreadcrumbs && routeBreadcrumbs.length && state.breadcrumbLabel) {
        routeBreadcrumbs[routeBreadcrumbs.length - 1].label = state.breadcrumbLabel;
        routeBreadcrumbs[routeBreadcrumbs.length - 1].translateLabel = state.translateLabel !== undefined ? state.translateLabel : true;
      }
      this.commonService.breadcrumbs.next(breadcrumbs);
    });
  }
  generateBreadcrumbsFromSiteStucture(menu) {
    let activeItem = [];
    for (let item of menu.filter(d => d.active || d.shortname == 'home')) {
      let breadcrumb = {
        label: item.title,
        translateLabel: true,
        url: item.link,
        shortname: item.shortname,
        show: true
      };
      activeItem.push(breadcrumb);
      if (item.children && item.children.length) {
        activeItem = activeItem.concat(this.generateBreadcrumbsFromSiteStucture(item.children));
      }
    }
    return activeItem;
  }
  getRouteBreadcrumbs(root) {
    let newRoutes = [];
    let routes = BreadcrumbsComponent.generateBreadcrumbsFromRoute(root);
    const firstRouteIndex = routes.findIndex(d => d.chainBreadcrumb);
    if (firstRouteIndex > -1) {
      routes.splice(0, firstRouteIndex);
    }
    newRoutes = routes.filter(route => !route.hideThisRoute);
    return newRoutes;
  }
  static generateBreadcrumbsFromRoute(route, breadcrumbs = []) {
    if (route.outlet === PRIMARY_OUTLET) {
      let routeURL = route.pathFromRoot.map(path => path.url.map(u => u.path).join('/')).filter(path => path).join('/');
      if (!route.routeConfig.hasOwnProperty('loadChildren')) {
        let breadcrumb;
        if (!Object.keys(route.data).length) {
          breadcrumb = {
            id: '',
            label: route.routeConfig.path,
            translateLabel: false,
            shortname: route.routeConfig.path,
            chainBreadcrumb: false,
            url: routeURL,
            show: true,
            hideThisRoute: false
          };
        } else {
          let routeData = route.routeConfig.data;
          breadcrumb = {
            id: routeData.id || '',
            label: routeData.customBreadcrumbLabel || routeData.label,
            translateLabel: true,
            shortname: route.data.navTarget,
            chainBreadcrumb: route.data.chainBreadcrumb,
            //Add a path that ends the breadcrumb in Site Structure to which this breadcrumb will continue.
            url: route.routeConfig.data.externalUrl ? route.routeConfig.data.externalUrl : routeURL,
            show: true,
            hideThisRoute: routeData.hideThisRoute || false
          };
        }
        breadcrumbs.push(breadcrumb);
      }
    }
    let children = route.children;
    if (children.length) {
      for (let child of children) {
        breadcrumbs.concat(BreadcrumbsComponent.generateBreadcrumbsFromRoute(child, breadcrumbs));
      }
    }
    return breadcrumbs;
  }
  static {
    this.ɵfac = function BreadcrumbsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BreadcrumbsComponent)(i0.ɵɵdirectiveInject(i1$7.Router), i0.ɵɵdirectiveInject(i1$7.ActivatedRoute), i0.ɵɵdirectiveInject(ValkyrieCommonService), i0.ɵɵdirectiveInject(ValkyrieUtilsService), i0.ɵɵdirectiveInject(DestroyEmitter));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: BreadcrumbsComponent,
      selectors: [["", "breadcrumbs", ""]],
      standalone: false,
      features: [i0.ɵɵProvidersFeature([DestroyEmitter])],
      attrs: _c0$10,
      decls: 4,
      vars: 6,
      consts: [["id", "csm-bc", 1, "breadcrumbs"], [4, "ngFor", "ngForOf"], [4, "ngIf"], ["class", "current_path", 4, "ngIf"], [1, "bc-sep", "space-right-xs", "space-left-xs"], [1, "current_path"]],
      template: function BreadcrumbsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "ul", 0);
          i0.ɵɵpipe(1, "translate");
          i0.ɵɵtemplate(2, BreadcrumbsComponent_ng_container_2_Template, 2, 1, "ng-container", 1);
          i0.ɵɵpipe(3, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "misc.breadcrumb"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 4, ctx.breadcrumbs$));
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i1.AsyncPipe, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbsComponent, [{
    type: Component,
    args: [{
      selector: '[breadcrumbs]',
      providers: [DestroyEmitter],
      standalone: false,
      template: "<ul id=\"csm-bc\" class=\"breadcrumbs\" [attr.aria-label]=\"'misc.breadcrumb' | translate\">\n    <ng-container *ngFor=\"let breadcrumb of breadcrumbs$ | async; last as last;\">\n        <li *ngIf=\"breadcrumb.show\">\n            <span *ngIf=\"!last\">\n                <a [attr.href]=\"breadcrumb.url\">\n                    <ng-container *ngIf=\"breadcrumb.translateLabel\">\n                        {{breadcrumb.label | translate}}\n                    </ng-container>\n                    <ng-container *ngIf=\"!breadcrumb.translateLabel\">\n                        {{breadcrumb.label}}\n                    </ng-container>\n                </a>\n                <span class=\"bc-sep space-right-xs space-left-xs\">/</span>\n            </span>\n            <span *ngIf=\"last\" [attr.aria-current]=\"'page'\" class=\"current_path\">\n                <ng-container *ngIf=\"breadcrumb.translateLabel\">\n                    {{breadcrumb.label | translate}}\n                </ng-container>\n                <ng-container *ngIf=\"!breadcrumb.translateLabel\">\n                    {{breadcrumb.label}}\n                </ng-container>\n            </span>\n        </li>\n    </ng-container>\n</ul>\n"
    }]
  }], () => [{
    type: i1$7.Router
  }, {
    type: i1$7.ActivatedRoute
  }, {
    type: ValkyrieCommonService
  }, {
    type: ValkyrieUtilsService
  }, {
    type: DestroyEmitter
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(BreadcrumbsComponent, {
    className: "BreadcrumbsComponent",
    filePath: "valkyrie/layout/breadcrumbs.component.ts",
    lineNumber: 16
  });
})();
const _c0$$ = ["sidebar-nav", ""];
const _c1$P = a0 => ({
  "active": a0
});
const _c2$E = a0 => ({
  "parent-active subnav-open": a0
});
const _c3$r = a0 => ({
  "nav-level-open": a0
});
function SidebarNavComponent_li_2_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("href", item_r1.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("target", item_r1.target);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$P, item_r1.active));
    i0.ɵɵadvance();
    i0.ɵɵclassMap(item_r1.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r1.title, " ");
  }
}
function SidebarNavComponent_li_2_a_2_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 10);
  }
}
function SidebarNavComponent_li_2_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SidebarNavComponent_li_2_a_2_i_4_Template, 1, 0, "i", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c2$E, item_r1.active));
    i0.ɵɵattribute("aria-expanded", item_r1.active);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(item_r1.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r1.title, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.children.length !== 0);
  }
}
function SidebarNavComponent_li_2_div_3_li_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 2)(1, "a", 12);
    i0.ɵɵelement(2, "i", 13);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const child_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", child_r2.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("target", child_r2.target);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1$P, child_r2.active));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", child_r2.title, " ");
  }
}
function SidebarNavComponent_li_2_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "ul");
    i0.ɵɵtemplate(2, SidebarNavComponent_li_2_div_3_li_2_Template, 5, 6, "li", 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3$r, item_r1.active));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", item_r1.children);
  }
}
function SidebarNavComponent_li_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵtemplate(1, SidebarNavComponent_li_2_a_1_Template, 4, 9, "a", 3)(2, SidebarNavComponent_li_2_a_2_Template, 5, 9, "a", 4)(3, SidebarNavComponent_li_2_div_3_Template, 3, 4, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.children.length == 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.children.length !== 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.children.length !== 0);
  }
}
class SidebarNavComponent {
  constructor(backendService, route, router, translate, utilsService, commonService, elementRef) {
    this.backendService = backendService;
    this.route = route;
    this.router = router;
    this.translate = translate;
    this.utilsService = utilsService;
    this.commonService = commonService;
    this.elementRef = elementRef;
    this.nav = [];
    this.navbarReady = new EventEmitter();
  }
  initValkyrieMenu() {
    this.navElm = this.elementRef.nativeElement;
    const debounce = (func, wait, immediate) => {
      let timeout;
      return e => {
        let context = this.navElm,
          args = e;
        let later = () => {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    };
    jQuery.fn.ValkyrieMenu = options => {
      let mask_tid,
        closed = true;
      let open = e => {
        e.stopPropagation();
        if (closed) {
          jQuery('#nav-container').addClass('nav-container-open');
          clearTimeout(mask_tid);
          jQuery('.nav-mask').css('display', 'block');
          mask_tid = setTimeout(function () {
            jQuery('.nav-mask').addClass('active');
          }, 0);
          jQuery(e.currentTarget).attr('aria-expanded', true);
          closed = false;
        }
        jQuery('body').addClass('nav-open');
      };
      let close = e => {
        e.stopPropagation();
        if (!closed) {
          jQuery('#nav-container').removeClass('nav-container-open');
          clearTimeout(mask_tid);
          mask_tid = setTimeout(function () {
            jQuery('.nav-mask').removeClass('active');
            setTimeout(function () {
              jQuery('.nav-mask').css('display', 'none');
            }, 330);
          }, 25);
          jQuery(e.currentTarget).attr('aria-expanded', false);
          closed = true;
        }
        jQuery('body').removeClass('nav-open');
      };
      let getSubMenu = element => {
        return jQuery('.nav-level', element.parentNode).first();
      };
      let toggleChild = e => {
        let contactChip = jQuery('.contact-chip');
        contactChip.removeClass('user-tools-open');
        let contact_toggle_icon = jQuery('.contact-chip .toggle-icon');
        let openClass = contact_toggle_icon.attr('data-openclass');
        let closedClass = contact_toggle_icon.attr('data-closedclass');
        contact_toggle_icon.addClass(closedClass).removeClass(openClass);
        jQuery('.badge-toggle').removeClass('badge-toggle-open').addClass('badge-toggle-closed').attr('aria-expanded', 'false');
        let _target = jQuery(e.currentTarget);
        let sub = getSubMenu(e.currentTarget);
        if (sub.length) {
          if (!sub.hasClass('nav-level-open')) {
            openChild(sub, _target);
          } else {
            closeChild(sub, _target);
          }
          return false;
        }
      };
      let openChild = (sub, _target) => {
        sub.addClass('nav-level-open');
        _target.attr('aria-expanded', true).addClass('subnav-open');
      };
      let closeChild = (sub, _target) => {
        sub.removeClass('nav-level-open');
        _target.attr('aria-expanded', false).removeClass('subnav-open');
      };
      let toggle = e => {
        let args = e;
        if (e) {
          e.stopPropagation();
        }
        if (closed) {
          open.apply(this.navElm, [args]);
        } else {
          close.apply(this.navElm, [args]);
        }
      };
      let onKeyUp = e => {
        // if tab key was pressed
        if (e.which == 9) {
          // determine which, if any, navigation element has focus
          let _focused = jQuery('a:focus', this.navElm);
          if (_focused.length) {
            // ensure the menu is open
            open.apply(this.navElm, [e]);
            // open any child menu that might exist
            let _target = jQuery(e.target);
            let _sub = getSubMenu(e.target);
            // if a submenu was found, open it.
            if (_sub.length) {
              openChild.apply(this.navElm, [_sub, _target]);
              // otherwise, check if the focused element is the child of a submenu and open that.
            } else {
              let _parentsub = _target.closest('.nav-level').not('.nav-level-open');
              if (_parentsub.length) {
                let _parentanchor = _parentsub.siblings('a');
                openChild.apply(this.navElm, [_parentsub, _parentanchor]);
              }
            }
          }
        }
      };
      let bindEvents = () => {
        jQuery(this.navElm).on('keyup', jQuery.proxy(onKeyUp, this.navElm));
        jQuery('.nav-item a').on('click', jQuery.proxy(toggleChild, this.navElm));
        jQuery('.nav-mask').on('click', jQuery.proxy(close, this.navElm));
        jQuery('.nav-toggle').attr('aria-expanded', false);
        jQuery('.nav-toggle').attr('aria-haspopup', true);
        jQuery('.nav-toggle').attr('aria-controls', jQuery(this.navElm).attr('id'));
        jQuery('.nav-toggle').on('click', jQuery.proxy(toggle, this.navElm));
      };
      let setup = () => {
        bindEvents.apply(this.navElm);
      };
      jQuery(jQuery.proxy(setup, this.navElm));
    };
    jQuery.fn.ValkyrieFixedHeader = () => {
      let _wrapper = jQuery('body');
      let check = debounce(function () {
        let scrollTop = jQuery(window).scrollTop();
        if (scrollTop > 88) {
          _wrapper.addClass('scrolled');
        } else {
          _wrapper.removeClass('scrolled');
        }
      }, 250);
      jQuery(window).on('scroll', check);
      check(undefined);
    };
    setTimeout(() => {
      jQuery(this.navElm).ValkyrieMenu();
      jQuery('body').ValkyrieFixedHeader();
    });
  }
  ngOnInit() {
    this.commonService.getSiteStructure().subscribe(res => {
      this.nav = res;
      this.navbarReady.emit(this.elementRef);
      this.initValkyrieMenu();
    });
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  static {
    this.ɵfac = function SidebarNavComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SidebarNavComponent)(i0.ɵɵdirectiveInject(ValkyrieBackendService), i0.ɵɵdirectiveInject(i1$7.ActivatedRoute), i0.ɵɵdirectiveInject(i1$7.Router), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(ValkyrieUtilsService), i0.ɵɵdirectiveInject(ValkyrieCommonService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SidebarNavComponent,
      selectors: [["", "sidebar-nav", ""]],
      outputs: {
        navbarReady: "navbarReady"
      },
      standalone: false,
      attrs: _c0$$,
      decls: 3,
      vars: 1,
      consts: [["name", "menu"], ["class", "nav-item", 4, "ngFor", "ngForOf"], [1, "nav-item"], ["event-focus", "keypress click", "event-focus-id", "skip-links", 3, "href", "target", "ngClass", 4, "ngIf"], ["href", "javascript:;", 3, "ngClass", 4, "ngIf"], ["class", "nav-level", 3, "ngClass", 4, "ngIf"], ["event-focus", "keypress click", "event-focus-id", "skip-links", 3, "href", "target", "ngClass"], ["aria-hidden", "true"], ["href", "javascript:;", 3, "ngClass"], ["class", "icn-chevron_down", 4, "ngIf"], [1, "icn-chevron_down"], [1, "nav-level", 3, "ngClass"], [3, "href", "target", "ngClass"], ["aria-hidden", "true", 1, "icn-chevron_right"]],
      template: function SidebarNavComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "a", 0);
          i0.ɵɵelementStart(1, "ul");
          i0.ɵɵtemplate(2, SidebarNavComponent_li_2_Template, 4, 3, "li", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.nav);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavComponent, [{
    type: Component,
    args: [{
      selector: '[sidebar-nav]',
      standalone: false,
      template: "<a name=\"menu\"></a>\n<ul>\n    <li *ngFor=\"let item of nav\" class=\"nav-item\">\n        <a *ngIf=\"item.children.length == 0\" href=\"{{item.link}}\" target=\"{{item.target}}\" [ngClass]=\"{'active' : item.active}\"  event-focus=\"keypress click\" event-focus-id=\"skip-links\">\n            <i class=\"{{item.icon}}\" aria-hidden=\"true\"></i>\n            <span>\n                {{item.title}}\n            </span>\n        </a>\n        <a href=\"javascript:;\" *ngIf=\"item.children.length !== 0\" [ngClass]=\"{'parent-active subnav-open' : item.active}\" [attr.aria-expanded]=\"item.active\">\n            <i class=\"{{item.icon}}\"></i>\n            <span>\n                {{item.title}}\n            </span>\n            <i class=\"icn-chevron_down\" *ngIf=\"item.children.length !== 0\"></i>\n        </a>\n        <div class=\"nav-level\" *ngIf=\"item.children.length !== 0\" [ngClass]=\"{'nav-level-open' : item.active}\">\n            <ul>\n                <li class=\"nav-item\" *ngFor=\"let child of item.children\">\n                    <a href=\"{{child.link}}\" target=\"{{child.target}}\" [ngClass]=\"{'active' : child.active}\">\n                        <i class=\"icn-chevron_right\" aria-hidden=\"true\"></i>\n                        <span>\n                            {{child.title}}\n                        </span>\n                    </a>\n                </li>\n            </ul>\n        </div>\n    </li>\n</ul>\n"
    }]
  }], () => [{
    type: ValkyrieBackendService
  }, {
    type: i1$7.ActivatedRoute
  }, {
    type: i1$7.Router
  }, {
    type: i1$1.TranslateService
  }, {
    type: ValkyrieUtilsService
  }, {
    type: ValkyrieCommonService
  }, {
    type: i0.ElementRef
  }], {
    navbarReady: [{
      type: Output
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SidebarNavComponent, {
    className: "SidebarNavComponent",
    filePath: "valkyrie/layout/sidebar-nav.component.ts",
    lineNumber: 19
  });
})();
const _c0$_ = ["account-blocked-message", ""];
class AccountBlockedMessageComponent {
  set interfaceType(type) {
    this.accountBlockedMessage = type === "student" ? "misc.Your account is blocked. Please contact your school to get your account unblocked." : "misc.Account Blocked";
  }
  static {
    this.ɵfac = function AccountBlockedMessageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AccountBlockedMessageComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: AccountBlockedMessageComponent,
      selectors: [["", "account-blocked-message", ""]],
      inputs: {
        interfaceType: "interfaceType"
      },
      standalone: false,
      attrs: _c0$_,
      decls: 3,
      vars: 4,
      template: function AccountBlockedMessageComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div");
          i0.ɵɵtext(1);
          i0.ɵɵpipe(2, "translate");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵattribute("class", "msg-content container");
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx.accountBlockedMessage));
        }
      },
      dependencies: [i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccountBlockedMessageComponent, [{
    type: Component,
    args: [{
      selector: '[account-blocked-message]',
      standalone: false,
      template: "<div [attr.class]=\"'msg-content container'\">{{ accountBlockedMessage | translate }}</div>"
    }]
  }], null, {
    interfaceType: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(AccountBlockedMessageComponent, {
    className: "AccountBlockedMessageComponent",
    filePath: "valkyrie/layout/account-blocked-message.component.ts",
    lineNumber: 9
  });
})();
const _c0$Z = ["*"];
const _c1$O = a0 => ({
  "sr-only": a0
});
function MainLayoutComponent_ul_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul", 20)(1, "li")(2, "a", 21);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("click", function MainLayoutComponent_ul_0_Template_a_click_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.skipLink("content", $event));
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "li")(7, "a", 22);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵlistener("click", function MainLayoutComponent_ul_0_Template_a_click_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.skipLink("menu", $event));
    });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 4, "misc.Skip to content"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 6, "misc.Skip to content"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(8, 8, "misc.Skip to main menu"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 10, "misc.Skip to main menu"));
  }
}
function MainLayoutComponent_header_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "header", 23);
  }
}
function MainLayoutComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 24);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("interfaceType", ctx_r1.accountBlockedUserType);
  }
}
function MainLayoutComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 25);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r1.weakPassword, i0.ɵɵsanitizeHtml);
  }
}
function MainLayoutComponent_nav_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nav", 26);
    i0.ɵɵlistener("navbarReady", function MainLayoutComponent_nav_8_Template_nav_navbarReady_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navbarReady($event));
    });
    i0.ɵɵelementEnd();
  }
}
function MainLayoutComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27)(1, "div", 28);
    i0.ɵɵelement(2, "nav", 29);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 1, "misc.breadcrumb"));
  }
}
function MainLayoutComponent_div_15_ng_container_3_ul_7_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 39)(1, "button", 40);
    i0.ɵɵlistener("click", function MainLayoutComponent_div_15_ng_container_3_ul_7_li_1_Template_button_click_1_listener() {
      const menuItem_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.openTranslationLink(menuItem_r5.link, menuItem_r5.target));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const menuItem_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, menuItem_r5.label));
  }
}
function MainLayoutComponent_div_15_ng_container_3_ul_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 37);
    i0.ɵɵtemplate(1, MainLayoutComponent_div_15_ng_container_3_ul_7_li_1_Template, 4, 3, "li", 38);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.translationMenu.menuItems);
  }
}
function MainLayoutComponent_div_15_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 32)(2, "button", 33);
    i0.ɵɵelement(3, "i", 34);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "i", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, MainLayoutComponent_div_15_ng_container_3_ul_7_Template, 2, 1, "ul", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("autoClose", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 2, ctx_r1.translationMenu.label), " ");
  }
}
function MainLayoutComponent_div_15_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 41);
    i0.ɵɵelement(2, "i", 34);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", ctx_r1.translationButton.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("target", ctx_r1.translationButton.target);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, ctx_r1.translationButton.label));
  }
}
function MainLayoutComponent_div_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27)(1, "div", 30)(2, "div", 31);
    i0.ɵɵtemplate(3, MainLayoutComponent_div_15_ng_container_3_Template, 8, 4, "ng-container", 3)(4, MainLayoutComponent_div_15_ng_container_4_Template, 5, 5, "ng-container", 3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.translationMenu);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.translationButton);
  }
}
function MainLayoutComponent_h1_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 42);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1$O, ctx_r1.pageTitleConfig.hide));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx_r1.pageTitleConfig.text));
  }
}
function MainLayoutComponent_help_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "help", 43);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("helpHints", ctx_r1.helpHints);
  }
}
function MainLayoutComponent_footer_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "footer", 44);
  }
}
class MainLayoutComponent {
  constructor(route, router, commonService, authService, helpService, utilsService, translate, sanitizer, cd, destroy$) {
    this.route = route;
    this.router = router;
    this.commonService = commonService;
    this.authService = authService;
    this.helpService = helpService;
    this.utilsService = utilsService;
    this.translate = translate;
    this.sanitizer = sanitizer;
    this.cd = cd;
    this.destroy$ = destroy$;
    this.currentUrl = '';
    this.enableBreadcrumbs = true;
    this.showTranslationMenu = false;
    this.enableHints = true;
    this.floatingLayout = false;
    this.layoutSet = false;
    this.helpHints = [];
    this.siteStructureData = window.ngData && window.ngData.siteStructure ? window.ngData.siteStructure : undefined;
    this.enablePageHeader = true;
    this.enableSidebarNav = true;
    this.enableSkipLinks = true;
    this.checkLoginAs();
    this.currentUrl = window.location.href;
    this.routeEvent(this.router);
    this.setSiteStructure();
    this.weakPassword = this.sanitizer.bypassSecurityTrustHtml(window.ngData.weakPwdNotice || '');
  }
  ngOnInit() {
    this.authService.fetchCurrentUser();
    this.setPageTitle();
    this.getLayout();
    this.getEnableBreadcrumbs();
    this.getShowTranslationMenu();
    this.getEnableHints();
  }
  routeEvent(router) {
    if (this.enableHints) {
      router.events.subscribe(e => {
        if (e instanceof NavigationEnd) {
          this.authService.getCurrentUser().subscribe(response => {
            if (response) {
              this.getHelpHints();
              if (!!+response.account_blocked) {
                this.accountBlockedUserType = response.type;
              }
              this.cd.detectChanges();
              this.commonService.setBlockMessageReady();
            }
          });
        }
      });
    }
  }
  setPageTitle() {
    this.subscription_title = this.commonService.getPageTitleConfig().subscribe(res => {
      this.pageTitleConfig = res;
    });
  }
  getEnableBreadcrumbs() {
    this.subscription_breadcrumb = this.commonService.getEnableBreadcrumbs().subscribe(res => {
      this.enableBreadcrumbs = res;
    });
  }
  getShowTranslationMenu() {
    this.translationMenu$ = this.commonService.getTranslationMenu().subscribe(res => {
      this.translationMenu = res;
    });
    this.translationButton$ = this.commonService.getTranslationButton().subscribe(res => {
      this.translationButton = res;
    });
    this.showTranslationMenu$ = this.commonService.getShowTranslationMenu().subscribe(res => {
      this.showTranslationMenu = res;
    });
  }
  getEnableHints() {
    this.subscription_hints = this.commonService.getEnableHints().subscribe(res => {
      this.enableHints = res;
    });
  }
  getLayout() {
    this.subscription_layout = this.commonService.getFloatingLayout().subscribe(res => {
      this.floatingLayout = res;
      this.layoutSet = true;
    });
  }
  setSiteStructure() {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd), takeUntil(this.destroy$)).subscribe(e => {
      this.commonService.setSiteStructure(this.siteStructureData);
    });
  }
  skipLink(name, e) {
    this.commonService.scrollTo(name, e);
  }
  openTranslationLink(link, target) {
    window.open(link, target);
  }
  getHelpHints() {
    const sectionData = ValkyrieUtilsService.findTargetKeyInDeepTreeObj(this.route.snapshot, 'children', ['routeConfig', 'data', 'phpSectionParams'], undefined, true);
    if (_.isEqual(this.lastSectionParam, sectionData[sectionData.length - 1])) {
      return;
    }
    this.lastSectionParam = sectionData[sectionData.length - 1];
    const {
      section,
      subsection
    } = this.lastSectionParam ?? {};
    this.helpService.getHelpHints(section, subsection).subscribe(hints => {
      if (hints) {
        this.helpHints = hints.models;
      }
    });
  }
  navbarReady(ref) {
    this.commonService.setNavbarReady(ref);
  }
  checkLoginAs() {
    if (window.ngData.manager_loginas) {
      this.utilsService.loadJS('loginas').then(data => {
        if (data.find(res => res.status == 'Loaded')) {
          let loginAs;
          switch (window.SUB_SYSTEM) {
            case 'students':
              loginAs = {
                window: 'student',
                msg: 'student'
              };
              break;
            case 'employers':
              loginAs = {
                window: 'contact',
                msg: 'employer'
              };
              break;
            case 'faculty':
              loginAs = {
                window: 'faculty',
                msg: 'faculty'
              };
              break;
          }
          forkJoin([this.translate.get('misc.You have opened a separate window for ' + loginAs.msg + ' login-as'), this.translate.get('misc.Close other window'), this.translate.get('misc.Open in a separate window'), this.translate.get('misc.Close Window')]).subscribe(([otherWindowMsg, closeOtherWindowMsg, showInSepWindowMessage, closeWindowMessage]) => {
            window.CSM.loginAs.init({
              placeholder: '#loginas-placeholder',
              windowname: '_' + loginAs.window + '_loginas_win',
              responsive: 'true',
              otherWindowMsg: otherWindowMsg,
              closeOtherWindowMsg: closeOtherWindowMsg,
              showInSepWindowMessage: showInSepWindowMessage,
              closeWindowMessage: closeWindowMessage
            });
          });
        }
      }).catch(error => console.log(error));
    }
  }
  ngOnDestroy() {
    this.subscription_title.unsubscribe();
    this.subscription_layout.unsubscribe();
    this.subscription_breadcrumb.unsubscribe();
    this.showTranslationMenu$.unsubscribe();
    if (this.translationMenu$) {
      this.translationMenu$.unsubscribe();
    }
    if (this.translationButton$) {
      this.translationButton$.unsubscribe();
    }
    this.subscription_hints.unsubscribe();
  }
  static {
    this.ɵfac = function MainLayoutComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MainLayoutComponent)(i0.ɵɵdirectiveInject(i1$7.ActivatedRoute), i0.ɵɵdirectiveInject(i1$7.Router), i0.ɵɵdirectiveInject(ValkyrieCommonService), i0.ɵɵdirectiveInject(ValkyrieAuthService), i0.ɵɵdirectiveInject(HelpService), i0.ɵɵdirectiveInject(ValkyrieUtilsService), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i1$5.DomSanitizer), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(DestroyEmitter));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: MainLayoutComponent,
      selectors: [["main-layout"]],
      inputs: {
        enablePageHeader: "enablePageHeader",
        enableSidebarNav: "enableSidebarNav",
        enableSkipLinks: "enableSkipLinks"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([DestroyEmitter])],
      ngContentSelectors: _c0$Z,
      decls: 24,
      vars: 13,
      consts: [["class", "skip-links", 4, "ngIf"], ["page-header", "", "class", "page-top", "role", "banner", 4, "ngIf"], [1, "banner-msg-list", "webview-no-top"], [4, "ngIf"], [1, "container"], [1, "row", "block"], ["id", "helpdiv"], ["sidebar-nav", "", "id", "nav-container", "class", "nav-showicons col md-col-2", 3, "navbarReady", 4, "ngIf"], [1, "nav-mask"], ["id", "frame"], ["id", "content-view"], [1, "page-utils", "webview-hide"], ["class", "row", 4, "ngIf"], [1, "page-title-wrapper"], ["class", "page-title", 3, "ngClass", 4, "ngIf"], [1, "page-main"], [3, "helpHints", 4, "ngIf"], ["name", "content", 3, "ngClass"], [1, "content-container-inner"], ["page-footer", "", "role", "contentinfo", 4, "ngIf"], [1, "skip-links"], ["href", "javascript:void(0)", "id", "skip-links", "event-focus", "keypress click", "event-focus-id", "content-view", "accesskey", "c", 1, "sr-only", "sr-only-focusable", 3, "click", "title"], ["href", "javascript:void(0)", "event-focus", "keypress click", "event-focus-id", "nav-container", "accesskey", "m", 1, "sr-only", "sr-only-focusable", 3, "click", "title"], ["page-header", "", "role", "banner", 1, "page-top"], ["account-blocked-message", "", "role", "alert", 1, "banner-msg", "error", 3, "interfaceType"], [3, "innerHTML"], ["sidebar-nav", "", "id", "nav-container", 1, "nav-showicons", "col", "md-col-2", 3, "navbarReady"], [1, "row"], [1, "col", "col-12", "sm-col-8", "back-links"], ["breadcrumbs", "", "role", "navigation"], [1, "col", "col-12", "sm-col-4", "text-right", "pull-right"], [1, "actions-menu-wrapper", "inline-block"], ["dropdown", "", 1, "actions-toggle-wrapper", 3, "autoClose"], ["id", "translationMenuButton", "dropdownToggle", "", "aria-controls", "translationMenu", 1, "btn", "btn_minimal"], [1, "icn-translate"], [1, "icn-chevron_down"], ["id", "translationMenu", "class", "actions-menu dropdown-menu-right body-small", "aria-labelledby", "translationMenuButton", "role", "menu", 4, "dropdownMenu"], ["id", "translationMenu", "aria-labelledby", "translationMenuButton", "role", "menu", 1, "actions-menu", "dropdown-menu-right", "body-small"], ["role", "menuitem", 4, "ngFor", "ngForOf"], ["role", "menuitem"], [3, "click"], [1, "btn", "btn_minimal", 3, "href", "target"], [1, "page-title", 3, "ngClass"], [3, "helpHints"], ["page-footer", "", "role", "contentinfo"]],
      template: function MainLayoutComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, MainLayoutComponent_ul_0_Template, 11, 12, "ul", 0)(1, MainLayoutComponent_header_1_Template, 1, 0, "header", 1);
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵtemplate(3, MainLayoutComponent_ng_container_3_Template, 2, 1, "ng-container", 3)(4, MainLayoutComponent_ng_container_4_Template, 2, 1, "ng-container", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 4)(6, "div", 5);
          i0.ɵɵelement(7, "div", 6);
          i0.ɵɵtemplate(8, MainLayoutComponent_nav_8_Template, 1, 0, "nav", 7);
          i0.ɵɵelement(9, "div", 8);
          i0.ɵɵelementStart(10, "div", 9)(11, "main", 10);
          i0.ɵɵelement(12, "toast-alert");
          i0.ɵɵelementStart(13, "div", 11);
          i0.ɵɵtemplate(14, MainLayoutComponent_div_14_Template, 4, 3, "div", 12)(15, MainLayoutComponent_div_15_Template, 5, 2, "div", 12);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(16, "div", 13);
          i0.ɵɵtemplate(17, MainLayoutComponent_h1_17_Template, 3, 6, "h1", 14);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(18, "div", 15);
          i0.ɵɵtemplate(19, MainLayoutComponent_help_19_Template, 1, 1, "help", 16);
          i0.ɵɵelementStart(20, "div", 17)(21, "div", 18);
          i0.ɵɵprojection(22);
          i0.ɵɵelementEnd()()()();
          i0.ɵɵtemplate(23, MainLayoutComponent_footer_23_Template, 1, 0, "footer", 19);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.enableSkipLinks);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.enablePageHeader);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.accountBlockedUserType);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.weakPassword);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.enableSidebarNav);
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("no-nav", !ctx.enableSidebarNav);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.enableBreadcrumbs);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showTranslationMenu && (ctx.translationMenu || ctx.translationButton));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.pageTitleConfig.text);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.enableHints);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.floatingLayout == true ? "floating_content" : ctx.layoutSet ? "content-container" : "");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.layoutSet);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i10.BsDropdownMenuDirective, i10.BsDropdownToggleDirective, i10.BsDropdownDirective, ToastAlertComponent, HelpComponent, PageHeaderComponent, PageFooterComponent, BreadcrumbsComponent, SidebarNavComponent, AccountBlockedMessageComponent, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MainLayoutComponent, [{
    type: Component,
    args: [{
      selector: 'main-layout',
      encapsulation: ViewEncapsulation.None,
      providers: [DestroyEmitter],
      standalone: false,
      template: "<ul *ngIf=\"enableSkipLinks\" class=\"skip-links\">\n    <li><a href=\"javascript:void(0)\" (click)=\"skipLink('content', $event)\" id=\"skip-links\" event-focus=\"keypress click\" event-focus-id=\"content-view\" title=\"{{'misc.Skip to content' | translate}}\" accesskey=\"c\" class=\"sr-only sr-only-focusable\">{{'misc.Skip to content' | translate}}</a></li>\n    <li><a href=\"javascript:void(0)\" (click)=\"skipLink('menu', $event)\" event-focus=\"keypress click\" event-focus-id=\"nav-container\" title=\"{{'misc.Skip to main menu' | translate}}\" accesskey=\"m\" class=\"sr-only sr-only-focusable\">{{'misc.Skip to main menu' | translate }}</a></li>\n</ul>\n<header *ngIf=\"enablePageHeader\" page-header class=\"page-top\" role=\"banner\"></header>\n\n<div class=\"banner-msg-list webview-no-top\">\n    <ng-container *ngIf=\"accountBlockedUserType\">\n        <div account-blocked-message [interfaceType]=\"accountBlockedUserType\" class=\"banner-msg error\" role=\"alert\"></div>\n    </ng-container>\n    <ng-container *ngIf=\"weakPassword\">\n        <div [innerHTML]=\"weakPassword\"></div>\n    </ng-container>\n</div>\n\n<div class=\"container\">\n    <div class=\"row block\">\n        <div id=\"helpdiv\"></div>\n        <nav *ngIf=\"enableSidebarNav\" sidebar-nav (navbarReady)=\"navbarReady($event)\" id=\"nav-container\" class=\"nav-showicons col md-col-2\"></nav>\n        <div class=\"nav-mask\"></div>\n        <div id=\"frame\" [class.no-nav]=\"!enableSidebarNav\">\n            <main id=\"content-view\">\n                <toast-alert></toast-alert>\n                <div class=\"page-utils webview-hide\">\n                    <div class=\"row\" *ngIf=\"enableBreadcrumbs\">\n                        <div class=\"col col-12 sm-col-8 back-links\">\n                            <nav breadcrumbs role=\"navigation\" [attr.aria-label]=\"'misc.breadcrumb' | translate\"></nav>\n                        </div>\n                    </div>\n                    <div class=\"row\" *ngIf=\"showTranslationMenu && (translationMenu || translationButton)\">\n                        <div class=\"col col-12 sm-col-4 text-right pull-right\">\n                            <div class=\"actions-menu-wrapper inline-block\">\n                                <ng-container *ngIf=\"translationMenu\">\n                                    <div class=\"actions-toggle-wrapper\" dropdown [autoClose]=\"true\">\n                                        <button id=\"translationMenuButton\" class=\"btn btn_minimal\" dropdownToggle aria-controls=\"translationMenu\">\n                                            <i class=\"icn-translate\"></i>\n                                            {{translationMenu.label | translate}}\n                                            <i class=\"icn-chevron_down\"></i>\n                                        </button>\n                                        <ul id=\"translationMenu\" class=\"actions-menu dropdown-menu-right body-small\" aria-labelledby=\"translationMenuButton\" role=\"menu\" *dropdownMenu>\n                                            <li *ngFor=\"let menuItem of translationMenu.menuItems\" role=\"menuitem\">\n                                                <button (click)=\"openTranslationLink(menuItem.link, menuItem.target)\">{{menuItem.label | translate}}</button>\n                                            </li>\n                                        </ul>\n                                    </div>\n                                </ng-container>\n                                <ng-container *ngIf=\"translationButton\">\n                                    <a class=\"btn btn_minimal\" href=\"{{translationButton.link}}\" target=\"{{translationButton.target}}\"><i class=\"icn-translate\"></i>{{translationButton.label | translate}}</a>\n                                </ng-container>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"page-title-wrapper\">\n                    <h1 *ngIf=\"pageTitleConfig.text\" class=\"page-title\" [ngClass]=\"{'sr-only': pageTitleConfig.hide}\">{{pageTitleConfig.text | translate}}</h1>\n                </div>\n                <div class=\"page-main\">\n                    <help *ngIf=\"enableHints\" [helpHints]=\"helpHints\"></help>\n                    <div [ngClass]=\"(floatingLayout == true)? 'floating_content' : layoutSet ? 'content-container' : ''\" name=\"content\">\n                        <div class=\"content-container-inner\">\n                            <ng-content></ng-content>\n                        </div>\n                    </div>\n                </div>\n            </main>\n            <footer *ngIf=\"layoutSet\" page-footer role=\"contentinfo\"></footer>\n        </div>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: i1$7.ActivatedRoute
  }, {
    type: i1$7.Router
  }, {
    type: ValkyrieCommonService
  }, {
    type: ValkyrieAuthService
  }, {
    type: HelpService
  }, {
    type: ValkyrieUtilsService
  }, {
    type: i1$1.TranslateService
  }, {
    type: i1$5.DomSanitizer
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: DestroyEmitter
  }], {
    enablePageHeader: [{
      type: Input
    }],
    enableSidebarNav: [{
      type: Input
    }],
    enableSkipLinks: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MainLayoutComponent, {
    className: "MainLayoutComponent",
    filePath: "valkyrie/layout/main-layout.component.ts",
    lineNumber: 26
  });
})();
const _c0$Y = ["tab"];
const _c1$N = (a0, a1, a2) => ({
  "active": a0,
  "first": a1,
  "last": a2
});
function TabComponent_div_0_span_3_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵattribute("href", tab_r1.url, i0.ɵɵsanitizeUrl)("aria-selected", false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, tab_r1.title), " ");
  }
}
function TabComponent_div_0_span_3_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", tab_r1.url);
    i0.ɵɵattribute("ng-anchor", "")("aria-selected", tab_r1.active ? true : false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, tab_r1.title), " ");
  }
}
function TabComponent_div_0_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtemplate(1, TabComponent_div_0_span_3_a_1_Template, 3, 5, "a", 6)(2, TabComponent_div_0_span_3_a_2_Template, 3, 6, "a", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    const idx_r2 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c1$N, tab_r1.active, idx_r2 === 0, idx_r2 === ctx_r2.tabs.tabList.length - 1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r1.externalUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !tab_r1.externalUrl);
  }
}
function TabComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2, 0)(2, "div", 3);
    i0.ɵɵtemplate(3, TabComponent_div_0_span_3_Template, 3, 7, "span", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r2.tabDefaultId, "", ctx_r2.tabs.tabId, "");
    i0.ɵɵproperty("ngClass", ctx_r2.tabs.styleClass);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.tabs.tabList);
  }
}
class TabComponent {
  constructor(baseHref, utilsService, translate, router) {
    this.baseHref = baseHref;
    this.utilsService = utilsService;
    this.translate = translate;
    this.router = router;
    this.currentPath = '';
    this.tabDefaultId = 'scrollTab_';
    this.initTab = false;
    this.buttons = [];
    this.attrRoutePath = 'href';
    this.baseHref = this.baseHref.slice(0, -1);
    this.utilsService.loadJS('scrolltabs').then(data => {
      if (data.find(res => res.loaded)) {
        let initScrollTabs = setInterval(e => {
          if (e.initTab && e.tabData.tabList && e.tabData.tabList.length && jQuery().scrollTabs && jQuery().flickity) {
            clearInterval(initScrollTabs);
            jQuery('#' + e.tabDefaultId + e.tabData.tabId).scrollTabs();
            e.initTab = false;
            if (this.tab && this.tab.nativeElement.querySelector('.flickity-viewport')) {
              this.buttons = this.tab.nativeElement.querySelectorAll('[ng-anchor]');
              if (this.buttons.length && ![...this.buttons].find(button => button.parentNode.classList.contains('active'))) {
                this.selectTab(this.router.url);
                this.buttons.forEach(button => {
                  let url = button.getAttribute(this.attrRoutePath);
                  button.addEventListener('click', this.redirect.bind(this, url));
                });
              }
            }
          }
        }, 300, this);
      }
    });
    this.routeSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.selectTab(this.router.url);
    });
  }
  ngOnInit() {
    this.lang = this.translate.currentLang;
    this.tabs = this.tabData;
    this.initTab = true;
    this.currentPath = this.router.url;
  }
  selectTab(target) {
    let selected = 'active';
    target = this.baseHref + target;
    this.buttons.forEach(button => {
      button.parentNode.classList.remove(selected);
      if (target.includes(button.getAttribute(this.attrRoutePath).replace(/\/\//g, '/'))) {
        button.parentNode.classList.add(selected);
      }
    });
  }
  redirect(url, event) {
    event.preventDefault();
    this.selectTab(url);
    this.router.navigate([url.replace(this.baseHref, "")]);
  }
  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }
  static {
    this.ɵfac = function TabComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabComponent)(i0.ɵɵdirectiveInject(APP_BASE_HREF), i0.ɵɵdirectiveInject(ValkyrieUtilsService), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i1$7.Router));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: TabComponent,
      selectors: [["tab"]],
      viewQuery: function TabComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$Y, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tab = _t.first);
        }
      },
      inputs: {
        tabData: "tabData"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["tab", ""], ["role", "tablist", "class", "scroll_tabs_container", 3, "id", "ngClass", 4, "ngIf"], ["role", "tablist", 1, "scroll_tabs_container", 3, "id", "ngClass"], [1, "scroll_tab_inner"], [3, "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"], ["role", "tab", 4, "ngIf"], ["tabindex", "0", "role", "tab", 3, "routerLink", 4, "ngIf"], ["role", "tab"], ["tabindex", "0", "role", "tab", 3, "routerLink"]],
      template: function TabComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, TabComponent_div_0_Template, 4, 5, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.tabs);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1$7.RouterLink, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabComponent, [{
    type: Component,
    args: [{
      selector: 'tab',
      standalone: false,
      template: "<div *ngIf=\"tabs\" #tab role=\"tablist\" class=\"scroll_tabs_container\" id=\"{{tabDefaultId}}{{tabs.tabId}}\" [ngClass]=\"tabs.styleClass\">\n    <div class=\"scroll_tab_inner\">\n        <span *ngFor=\"let tab of tabs.tabList; index as idx\" [ngClass]=\"{'active': tab.active, 'first': idx === 0, 'last': idx === (tabs.tabList.length - 1)}\">\n            <a *ngIf=\"tab.externalUrl\" [attr.href]=\"tab.url\" role=\"tab\" [attr.aria-selected]=\"false\">\n                {{tab.title | translate}}\n            </a>\n            <a *ngIf=\"!tab.externalUrl\" [attr.ng-anchor]=\"''\" [routerLink]=\"tab.url\" tabindex=\"0\" role=\"tab\" [attr.aria-selected]=\"tab.active ? true : false\">\n                {{tab.title | translate}}\n            </a>\n        </span>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [APP_BASE_HREF]
    }]
  }, {
    type: ValkyrieUtilsService
  }, {
    type: i1$1.TranslateService
  }, {
    type: i1$7.Router
  }], {
    tabData: [{
      type: Input
    }],
    tab: [{
      type: ViewChild,
      args: ['tab']
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TabComponent, {
    className: "TabComponent",
    filePath: "valkyrie/common/tab.component.ts",
    lineNumber: 17
  });
})();
const _c0$X = ["theCheckbox"];
function TriStateCheckboxComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.checkboxData == null ? null : ctx_r1.checkboxData.blurb);
  }
}
function TriStateCheckboxComponent_li_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "input", 3);
    i0.ɵɵtwoWayListener("ngModelChange", function TriStateCheckboxComponent_li_9_Template_input_ngModelChange_1_listener($event) {
      const option_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      i0.ɵɵtwoWayBindingSet(option_r4.value, $event) || (option_r4.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function TriStateCheckboxComponent_li_9_Template_input_change_1_listener() {
      const i_r5 = i0.ɵɵrestoreView(_r3).index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.valueChanged(i_r5));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const option_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "ts-checkbox-", ctx_r1.uniqId, "-", i_r5, "");
    i0.ɵɵtwoWayProperty("ngModel", option_r4.value);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "ts-checkbox-", ctx_r1.uniqId, "-", i_r5, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r4.label);
  }
}
class TriStateCheckboxComponent {
  constructor(_changeDetectorRef) {
    this._changeDetectorRef = _changeDetectorRef;
    this.masterCheckbox = false;
    this.ariaChecked = 'false';
    this.ariaControls = '';
    this.checkboxData = {};
    this.data = {};
    this.change = new EventEmitter();
  }
  ngOnInit() {
    this.generateUniqId();
  }
  generateUniqId() {
    const randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    this.uniqId = randLetter + Date.now();
  }
  ngOnChanges(changes) {
    this.setState();
  }
  ngAfterViewInit() {
    this.checkboxData = this.data;
    this.setAriaControls(this.checkboxData.options);
    this.setState();
    this._changeDetectorRef.detectChanges();
  }
  valueChanged(index) {
    this.setState();
    let changedData = JSON.parse(JSON.stringify(this.checkboxData));
    changedData.options = this.checkboxData.options.filter((item, i) => {
      return i === index;
    });
    this.change.emit(changedData);
  }
  setState() {
    if (!this.checkboxData.options) return;
    let count = 0;
    for (var i = 0; i < this.checkboxData.options.length; i++) {
      count += this.checkboxData.options[i].value ? 1 : 0;
    }
    this.masterCheckbox = count !== 0;
    if (count > 0 && count < i) {
      this.checkbox.nativeElement.indeterminate = true;
      this.ariaChecked = 'mixed';
    } else {
      this.checkbox.nativeElement.indeterminate = false;
      this.ariaChecked = String(this.masterCheckbox);
    }
  }
  setAriaControls(data = []) {
    for (let i = 0; i < data.length; i++) {
      this.ariaControls += 'ts-checkbox-' + this.uniqId + '-' + i + ' ';
    }
  }
  masterChange() {
    for (var i = 0; i < this.checkboxData.options.length; i++) {
      this.checkboxData.options[i].value = this.masterCheckbox;
    }
    let changedData = JSON.parse(JSON.stringify(this.checkboxData));
    this.change.emit(changedData);
  }
  static {
    this.ɵfac = function TriStateCheckboxComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TriStateCheckboxComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: TriStateCheckboxComponent,
      selectors: [["tri-state-checkbox"]],
      viewQuery: function TriStateCheckboxComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$X, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkbox = _t.first);
        }
      },
      inputs: {
        data: "data"
      },
      outputs: {
        change: "change"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 10,
      vars: 10,
      consts: [["theCheckbox", ""], [1, "flexbox", "flex-row"], [1, "multi-level-input-wrapper"], ["type", "checkbox", 3, "ngModelChange", "change", "id", "ngModel"], [1, "multi-level-input-label-wrapper", "flexbox", "flex-column"], [1, "space-bottom-xs", 3, "for"], ["class", "body-small font_weight_light space-bottom-xs", 4, "ngIf"], [1, "space-top-xs"], [4, "ngFor", "ngForOf"], [1, "body-small", "font_weight_light", "space-bottom-xs"], [3, "for"]],
      template: function TriStateCheckboxComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "input", 3, 0);
          i0.ɵɵtwoWayListener("ngModelChange", function TriStateCheckboxComponent_Template_input_ngModelChange_2_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.masterCheckbox, $event) || (ctx.masterCheckbox = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵlistener("change", function TriStateCheckboxComponent_Template_input_change_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.masterChange());
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "div", 4)(5, "label", 5);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, TriStateCheckboxComponent_div_7_Template, 2, 1, "div", 6);
          i0.ɵɵelementStart(8, "ul", 7);
          i0.ɵɵtemplate(9, TriStateCheckboxComponent_li_9_Template, 4, 8, "li", 8);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate1("id", "ts-checkbox-", ctx.uniqId, "");
          i0.ɵɵtwoWayProperty("ngModel", ctx.masterCheckbox);
          i0.ɵɵattribute("aria-checked", ctx.ariaChecked)("aria-controls", ctx.ariaControls);
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate1("for", "ts-checkbox-", ctx.uniqId, "");
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.checkboxData == null ? null : ctx.checkboxData.label);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.checkboxData.blurb);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.checkboxData.options);
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i2$1.CheckboxControlValueAccessor, i2$1.NgControlStatus, i2$1.NgModel],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TriStateCheckboxComponent, [{
    type: Component,
    args: [{
      selector: 'tri-state-checkbox',
      standalone: false,
      template: "<div class=\"flexbox flex-row\">\n    <div class=\"multi-level-input-wrapper\">\n        <input #theCheckbox type=\"checkbox\" id=\"ts-checkbox-{{uniqId}}\" [(ngModel)]=\"masterCheckbox\" (change)=\"masterChange()\" [attr.aria-checked]=\"ariaChecked\" [attr.aria-controls]=\"ariaControls\">\n    </div>\n    <div class=\"multi-level-input-label-wrapper flexbox flex-column\">\n        <label for=\"ts-checkbox-{{uniqId}}\" class=\"space-bottom-xs\">{{checkboxData?.label}}</label>\n        <div *ngIf=\"checkboxData.blurb\" class=\"body-small font_weight_light space-bottom-xs\">{{checkboxData?.blurb}}</div>\n        <ul class=\"space-top-xs\">\n            <li *ngFor=\"let option of checkboxData.options; index as i\">\n                <input type=\"checkbox\" id=\"ts-checkbox-{{uniqId}}-{{i}}\" [(ngModel)]=\"option.value\" (change)=\"valueChanged(i)\">\n                <label for=\"ts-checkbox-{{uniqId}}-{{i}}\">{{option.label}}</label>\n            </li>\n        </ul>\n    </div>\n</div>"
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    data: [{
      type: Input
    }],
    checkbox: [{
      type: ViewChild,
      args: ["theCheckbox", {
        static: true
      }]
    }],
    change: [{
      type: Output
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TriStateCheckboxComponent, {
    className: "TriStateCheckboxComponent",
    filePath: "valkyrie/common/tri-state-checkbox.component.ts",
    lineNumber: 9
  });
})();
class ExternalUrlComponent {
  constructor() {}
  ngOnInit() {}
  static {
    this.ɵfac = function ExternalUrlComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ExternalUrlComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ExternalUrlComponent,
      selectors: [["external-url"]],
      standalone: false,
      decls: 1,
      vars: 0,
      template: function ExternalUrlComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div");
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExternalUrlComponent, [{
    type: Component,
    args: [{
      selector: 'external-url',
      standalone: false,
      template: "<div></div>"
    }]
  }], () => [], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ExternalUrlComponent, {
    className: "ExternalUrlComponent",
    filePath: "valkyrie/common/external-url.component.ts",
    lineNumber: 9
  });
})();
function SizeDetectorComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const s_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("hide ", s_r1.css + " " + (ctx_r1.prefix + s_r1.id), "");
  }
}
class SizeDetectorComponent {
  constructor(elementRef, resizeSvc) {
    this.elementRef = elementRef;
    this.resizeSvc = resizeSvc;
    this.prefix = 'is-';
    this.sizes = [{
      id: SCREEN_SIZE.MOBILE,
      name: SCREEN_SIZE[SCREEN_SIZE.MOBILE],
      css: `display-mobile-block`
    }, {
      id: SCREEN_SIZE.SM,
      name: SCREEN_SIZE[SCREEN_SIZE.SM],
      css: `display-sm-block`
    }, {
      id: SCREEN_SIZE.MD,
      name: SCREEN_SIZE[SCREEN_SIZE.MD],
      css: `display-md-block`
    }, {
      id: SCREEN_SIZE.LG,
      name: SCREEN_SIZE[SCREEN_SIZE.LG],
      css: `display-lg-block`
    }, {
      id: SCREEN_SIZE.XL,
      name: SCREEN_SIZE[SCREEN_SIZE.XL],
      css: `display-desktop-block`
    }];
  }
  onResize() {
    this.detectScreenSize();
  }
  ngAfterViewInit() {
    this.detectScreenSize();
  }
  detectScreenSize() {
    let el;
    const currentSize = this.sizes.find(x => {
      el = this.elementRef.nativeElement.querySelector(`.${this.prefix}${x.id}`);
      const isVisible = window.getComputedStyle(el).display != 'none';
      return isVisible;
    });
    this.resizeSvc.onResize(this.id, currentSize.name, el.offsetWidth);
  }
  static {
    this.ɵfac = function SizeDetectorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SizeDetectorComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(SizeDetectorService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SizeDetectorComponent,
      selectors: [["size-detector"]],
      hostBindings: function SizeDetectorComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("resize", function SizeDetectorComponent_resize_HostBindingHandler() {
            return ctx.onResize();
          }, false, i0.ɵɵresolveWindow);
        }
      },
      inputs: {
        id: "id"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [[3, "class", 4, "ngFor", "ngForOf"]],
      template: function SizeDetectorComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SizeDetectorComponent_div_0_Template, 1, 3, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngForOf", ctx.sizes);
        }
      },
      dependencies: [i1.NgForOf],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SizeDetectorComponent, [{
    type: Component,
    args: [{
      selector: 'size-detector',
      template: '<div *ngFor="let s of sizes" class="hide {{s.css + \' \' + (prefix + s.id) }}"></div>',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: SizeDetectorService
  }], {
    id: [{
      type: Input
    }],
    onResize: [{
      type: HostListener,
      args: ["window:resize", []]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SizeDetectorComponent, {
    className: "SizeDetectorComponent",
    filePath: "valkyrie/common/size-detector.component.ts",
    lineNumber: 10
  });
})();
var SCREEN_SIZE;
(function (SCREEN_SIZE) {
  SCREEN_SIZE[SCREEN_SIZE["MOBILE"] = 0] = "MOBILE";
  SCREEN_SIZE[SCREEN_SIZE["SM"] = 1] = "SM";
  SCREEN_SIZE[SCREEN_SIZE["MD"] = 2] = "MD";
  SCREEN_SIZE[SCREEN_SIZE["LG"] = 3] = "LG";
  SCREEN_SIZE[SCREEN_SIZE["XL"] = 4] = "XL";
})(SCREEN_SIZE || (SCREEN_SIZE = {}));
const _c0$W = ["editor"];
const _c1$M = ["flow"];
const _c2$D = ["requiredInput"];
const _c3$q = () => ({
  standalone: true
});
const _c4$n = a0 => ({
  "sidebar-hidden": a0
});
const _c5$f = a0 => ({
  "active": a0
});
const _c6$b = a0 => ({
  count: a0
});
function MailwizComponent_div_83_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 59);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r4.selectedTemplate.attachment.length, " ");
  }
}
function MailwizComponent_div_83_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54)(1, "div", 55)(2, "button", 56);
    i0.ɵɵlistener("click", function MailwizComponent_div_83_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.toggleAttachments());
    });
    i0.ɵɵelement(3, "i", 57);
    i0.ɵɵtemplate(4, MailwizComponent_div_83_span_4_Template, 2, 1, "span", 58);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c5$f, ctx_r4.showAttachments));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.selectedTemplate == null ? null : ctx_r4.selectedTemplate.attachment == null ? null : ctx_r4.selectedTemplate.attachment.length);
  }
}
function MailwizComponent_div_87_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "a", 67);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "fileSize");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "a", 18);
    i0.ɵɵlistener("click", function MailwizComponent_div_87_div_1_div_1_Template_a_click_6_listener() {
      const ctx_r6 = i0.ɵɵrestoreView(_r6);
      const attachment_r8 = ctx_r6.$implicit;
      const index_r9 = ctx_r6.index;
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.deleteFile(index_r9, attachment_r8));
    });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const attachment_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", attachment_r8.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(attachment_r8.user_file_name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" - ", attachment_r8.filetype, " (", i0.ɵɵpipeBind1(5, 5, attachment_r8.size), ") ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 7, "misc.Delete"));
  }
}
function MailwizComponent_div_87_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵtemplate(1, MailwizComponent_div_87_div_1_div_1_Template, 9, 9, "div", 66);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.selectedTemplate.attachment);
  }
}
function MailwizComponent_div_87_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 69);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 70);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    const flow_r10 = i0.ɵɵreference(1);
    i0.ɵɵproperty("flow", flow_r10.flowJs);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, "misc.Drag and Drop files here or"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("flowAttributes", ctx_r4.flowAttributes)("flow", flow_r10.flowJs);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 8, "misc.browse files to upload"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 10, "misc.Drop the Files!"), " ");
  }
}
function MailwizComponent_div_87_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 71);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Uploading files", i0.ɵɵpureFunction1(4, _c6$b, ctx_r4.filesToUpload.length)), " ");
  }
}
function MailwizComponent_div_87_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵtemplate(1, MailwizComponent_div_87_div_1_Template, 2, 1, "div", 61);
    i0.ɵɵelementStart(2, "div", 62);
    i0.ɵɵtemplate(3, MailwizComponent_div_87_div_3_Template, 10, 12, "div", 63)(4, MailwizComponent_div_87_div_4_Template, 3, 6, "div", 64);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", !ctx_r4.showAttachments);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.selectedTemplate.attachment.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.filesToUploadStatus === "initial");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.filesToUploadStatus === "progress");
  }
}
function MailwizComponent_div_111_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 74);
    i0.ɵɵlistener("click", function MailwizComponent_div_111_ng_container_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r11 = i0.ɵɵnextContext();
      const recipient_r13 = ctx_r11.$implicit;
      const i_r14 = ctx_r11.index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.removeRecipient(i_r14, recipient_r13.id));
    });
    i0.ɵɵtext(2, "\u00D7");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const recipient_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", recipient_r13.email, " ");
  }
}
function MailwizComponent_div_111_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 72);
    i0.ɵɵtemplate(1, MailwizComponent_div_111_ng_container_1_Template, 4, 1, "ng-container", 73);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const recipient_r13 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", recipient_r13.email.includes(ctx_r4.keyword));
  }
}
function MailwizComponent_div_119_div_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 77);
    i0.ɵɵlistener("click", function MailwizComponent_div_119_div_3_div_1_Template_div_click_0_listener() {
      const field_r16 = i0.ɵɵrestoreView(_r15).$implicit;
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.addMailmergeVarToCaret(field_r16.key));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r16 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(field_r16.key);
  }
}
function MailwizComponent_div_119_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MailwizComponent_div_119_div_3_div_1_Template, 3, 1, "div", 76);
    i0.ɵɵpipe(2, "keyvalue");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const fields_r17 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, fields_r17.value));
  }
}
function MailwizComponent_div_119_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 75)(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MailwizComponent_div_119_div_3_Template, 3, 3, "div", 66);
    i0.ɵɵpipe(4, "keyvalue");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const mailmergeVars_r18 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(mailmergeVars_r18.key);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(4, 2, mailmergeVars_r18.value));
  }
}
class MailwizComponent {
  constructor(activeModal, backendService, translateService) {
    this.activeModal = activeModal;
    this.backendService = backendService;
    this.translateService = translateService;
    this.message = '';
    this.selectedRecipients = [];
    this.templateApi = {
      resource: '',
      version: 'v2'
    };
    this.attachmentsApi = {
      uploadAPI: '',
      deleteResource: '',
      deleteVersion: '',
      downloadAPI: ''
    };
    this.initOptions = {
      "elementpath": false,
      "relative_urls": false,
      "remove_script_host": false,
      "skin": "light",
      "browser_spellcheck": true,
      "menubar": false,
      "image_advtab": true,
      'urlconverter_callback': this.skipMergeFieldUrlConversion,
      'init_instance_callback': this.tinyMceInit,
      "valid_elements": "strong,b,em,i,ul,li,ol,a,p,br",
      "plugins": "paste, link, lists",
      "toolbar": "bold italic | bullist numlist | outdent indent | link unlink | removeformat",
      "theme_advanced_path": false,
      "paste_use_dialog": true,
      "link_assume_external_targets": true,
      "convert_urls": false,
      "target_list": false,
      "default_link_target": "_blank",
      "extended_valid_elements": "a[href|target=_blank|title],p[style]",
      "invalid_styles": "color font font-family font-size background background-color line-height text-align margin padding display background-image",
      "paste_auto_cleanup_on_paste": true
    };
    this.showCc = false;
    this.showBcc = false;
    this.sidebar = '';
    this.showToolbar = false;
    this.showAttachments = false;
    this.keyword = '';
    this.selectedTemplate = {
      attachment: [],
      bcc_address: null,
      body: '',
      cc_address: null,
      from_address: null,
      html_body: '',
      html_format: false,
      label: null,
      mailmerge_vars: [],
      send_copy_to: null,
      subject: null
    };
    this.totalRecipients = 0;
    this.excludeTheseEmailIds = [];
    this.destroyed$ = new Subject();
    this.filesToUpload = [];
    this.filesToUploadStatus = 'initial';
  }
  ngOnInit() {
    const queryParams = {
      interface: 'contact',
      message: this.message
    };
    this.totalRecipients = this.selectedRecipients.length;
    this.backendService.getAll(this.templateApi.resource, this.templateApi.version, queryParams).pipe(catchError(error => {
      throw new Error(error);
    })).subscribe(response => {
      this.messageTemplate = response;
      if (this.messageTemplate.selectedTemplate) {
        this.selectedTemplate = this.messageTemplate.selectedTemplate;
        if (!this.selectedTemplate.attachment) {
          this.selectedTemplate.attachment = [];
        }
      }
      if (this.selectedTemplate) {
        this.selectedTemplate.mailmerge_vars = this.messageTemplate.default_mailmerge_vars;
      } else {
        this.selectedTemplate = {
          message_id: '__new',
          html_format: true,
          mailmerge_vars: this.messageTemplate.default_mailmerge_vars
        };
      }
      if (this.messageTemplate?.settings?.allow_attachments === '1') {
        this.setFlowJSConfigs();
        this.watchFlowEmitters();
      }
    });
  }
  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  hideModal() {
    this.activeModal.dismiss();
  }
  toggleToolbar() {
    this.showToolbar = !this.showToolbar;
  }
  toggleAttachments() {
    this.showAttachments = !this.showAttachments;
  }
  focusOnEditor() {
    this.editor.editor.focus();
  }
  removeRecipient(recipientArrayIndex, recipientId) {
    this.excludeTheseEmailIds.push(recipientId);
    this.selectedRecipients.splice(recipientArrayIndex, 1);
    this.totalRecipients = this.selectedRecipients.length;
  }
  addMailmergeVarToCaret(field) {
    this.editor.editor.execCommand('mceInsertContent', false, `[${field}]`);
  }
  send() {
    const fieldWithErrors = this.requiredInputs.filter(input => {
      if (!input.nativeElement.validity.valid) {
        input.nativeElement.reportValidity();
        return true;
      }
    });
    if (fieldWithErrors.length) {
      return;
    }
    if (this.totalRecipients <= 0) {
      throw new Error(this.translateService.instant('misc.No recipients selected'));
    }
    if (!this.selectedTemplate.html_body || Array.isArray(this.selectedTemplate.html_body) && this.selectedTemplate.html_body.length <= 0) {
      throw new Error(this.translateService.instant('misc.Please fill in email message content.'));
    }
    this.selectedTemplate.body = this.selectedTemplate.html_body;
    this.activeModal.close({
      selectedTemplate: this.selectedTemplate,
      mopts: 'nosave',
      excludeTheseEmailIds: this.excludeTheseEmailIds
    });
  }
  /** Attachments related */
  deleteFile(index, file) {
    this.selectedTemplate.attachment.splice(index, 1);
    this.backendService.delete(file.file_id, this.attachmentsApi.deleteResource, this.attachmentsApi.deleteVersion).subscribe(() => {});
  }
  setFlowJSConfigs() {
    this.flowConfig = {
      singleFile: false,
      target: this.attachmentsApi.uploadAPI,
      query: {},
      testChunks: false,
      allowDuplicateUploads: true
    };
    this.flowAttributes = {
      id: 'mailwiz-modal',
      accept: '*'
    };
  }
  watchFlowEmitters() {
    this.flow.events$.pipe(takeUntil(this.destroyed$)).subscribe(event => {
      switch (event.type) {
        case 'filesSubmitted':
          this.onFileSubmitted(event);
          break;
        case 'fileSuccess':
          this.onFileSuccess(event);
          break;
        case 'complete':
          this.onComplete();
          break;
        default:
          break;
      }
    });
  }
  onFileSubmitted(event) {
    this.filesToUpload = event.event[0];
    this.filesToUploadStatus = 'progress';
    this.flow.upload();
  }
  onFileSuccess(event) {
    const flowFile = event.event[0];
    const apiResponse = this.getAPIResponse(event?.event[2]?.xhr?.response);
    const file_id = apiResponse?.file_id || Object.values(apiResponse)[0]?.['file_id'];
    this.selectedTemplate.attachment.push({
      file_id: file_id,
      filetype: flowFile.file.type,
      size: flowFile.file.size.toString(),
      url: `${this.attachmentsApi.downloadAPI}/${file_id}`,
      user_file_name: flowFile.file.name
    });
  }
  onComplete() {
    this.filesToUpload = [];
    this.filesToUploadStatus = 'initial';
  }
  getAPIResponse(data) {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.warn(`FormFileUploadComponent::getAPIResponse Can't parse API response`, error);
      return {};
    }
  }
  tinyMceInit(tinyMceInstance) {
    let tinyMceInstanceElem = tinyMceInstance.formElement;
    let tinyMceButtons = tinyMceInstanceElem.getElementsByClassName('mce-btn');
    let button;
    for (button of tinyMceButtons) {
      let buttonLabel = button.getAttribute('aria-label');
      let buttonTags = button.getElementsByTagName('button');
      let tag;
      for (tag of buttonTags) {
        tag.setAttribute('aria-label', buttonLabel);
      }
    }
    window.tinymce.PluginManager.add('columns', function (editor, url) {
      editor.addButton('twocolumns', {
        icon: false,
        title: 'Create a 2 column layout',
        image: '/tinymce4/skins/mce_twocolumns.gif',
        onclick: function (e) {
          editor.getWin().focus();
          var text = editor.selection.getContent();
          let text1 = 'Column 1';
          let text2 = 'Column 2';
          if (text) {
            let half = text.length / 2;
            text1 = text.substring(0, half);
            text2 = text.substring(half, text.length);
          }
          editor.selection.setContent('' + '<table style="width: 100%; text-align:top;border-spacing:0;border-collapse:collapse;border:none;">' + '   <tbody>' + '       <tr>' + '           <td style="width:50%;vertical-align:top;padding: 0">' + '               <div style="padding: 0 6px 0 0">' + text1 + '</div>' + '           </td>' + '           <td style="width:50%;vertical-align:top;">' + '               <div style="padding: 0 0 0 6px">' + text2 + '</div>' + '           </td>' + '       </tr>  ' + '   </tbody>' + '</table>');
          editor.selection.select(window.tinyMCE.activeEditor.dom.select('div')[0]);
          editor.selection.collapse(true);
        }
      });
    });
  }
  skipMergeFieldUrlConversion(url, node, on_save, name) {
    let regex = /\[[a-zA-Z_]+\]$/;
    if (!regex.test(url)) {
      delete window.tinyMCE.activeEditor.settings.urlconverter_callback;
      url = window.tinyMCE.activeEditor.convertURL(url, name, node);
      window.tinyMCE.activeEditor.settings.urlconverter_callback = this.skipMergeFieldUrlConversion;
    }
    return url;
  }
  static {
    this.ɵfac = function MailwizComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MailwizComponent)(i0.ɵɵdirectiveInject(i1$4.NgbActiveModal), i0.ɵɵdirectiveInject(ValkyrieBackendService), i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: MailwizComponent,
      selectors: [["mailwiz"]],
      viewQuery: function MailwizComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$W, 7);
          i0.ɵɵviewQuery(_c1$M, 5);
          i0.ɵɵviewQuery(_c2$D, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editor = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.flow = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.requiredInputs = _t);
        }
      },
      inputs: {
        message: "message",
        selectedRecipients: "selectedRecipients",
        templateApi: "templateApi",
        attachmentsApi: "attachmentsApi"
      },
      standalone: false,
      decls: 128,
      vars: 91,
      consts: [["flow", "flow"], ["collapseCc", "ngbCollapse"], ["collapseBcc", "ngbCollapse"], ["requiredInput", ""], ["editor", ""], [3, "flowConfig"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], [1, "modal-close", 3, "click"], [1, "icn-close"], ["name", "mailwiz"], [1, "modal-body"], [1, "content-container"], [1, "main-content"], [1, "email-fields"], [1, "section-divider"], [1, "section-content"], [3, "click"], [1, "email-field-label", "pull-right", 3, "click", "hidden"], [1, "section-divider", 3, "ngbCollapseChange", "ngbCollapse"], [1, "section-label"], ["for", "cc"], [1, "section-input"], ["type", "text", "id", "cc", 1, "form-control", 3, "ngModelChange", "ngModel", "ngModelOptions"], ["for", "bcc"], ["type", "text", "id", "bcc", 1, "form-control", 3, "ngModelChange", "ngModel", "ngModelOptions"], ["for", "subject"], [1, "control-label"], ["name", "subject", "type", "text", "id", "subject", "required", "", 1, "form-control", 3, "ngModelChange", "ngModel", "ngModelOptions"], ["for", "from_address"], ["name", "from_address", "type", "text", "id", "from_address", "required", "", 1, "form-control", 3, "ngModelChange", "ngModel", "ngModelOptions"], ["for", "send_copy_to"], ["name", "send_copy_to", "type", "text", "id", "send_copy_to", 1, "form-control", 3, "ngModelChange", "ngModel", "ngModelOptions"], ["class", "section-divider action-buttons flexbox align-items-center", 4, "ngIf"], [1, "email-body"], ["tagName", "textarea", 3, "ngModelChange", "ngModel", "ngModelOptions", "init"], ["class", "file-upload", 3, "hidden", 4, "ngIf"], [1, "sidebar-container", "sidebar-options"], [1, "sidebar-option", "section-divider", 3, "click"], [1, "arrow", "icn-chevron_right"], [1, "sidebar-container", "sidebar-recipients", 3, "ngClass"], [1, "arrow", "icn-chevron_left"], [1, "sidebar-list-container"], [1, "input-append", "btn-block"], ["type", "search", "placeholder", "Search Recipients", 1, "input-search", "btn-block", 3, "ngModelChange", "ngModel", "ngModelOptions"], ["type", "button", 1, "btn", "btn_search"], [1, "icn-search"], ["class", "mailwiz-list-item recipient", 4, "ngFor", "ngForOf"], [1, "sidebar-container", "sidebar-fields", 3, "ngClass"], ["class", "mailwiz-list-item mailwiz-list-item-selectable", 4, "ngFor", "ngForOf"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn_secondary", 3, "click"], ["type", "button", 1, "btn", "btn_primary", 3, "click"], [1, "section-divider", "action-buttons", "flexbox", "align-items-center"], [1, "section-content", "flexbox"], ["type", "button", 1, "btn", "btn-small", "btn-mailwiz-action", 3, "click", "ngClass"], [1, "icn-paperclip"], ["class", "label label-primary label-top-right", 4, "ngIf"], [1, "label", "label-primary", "label-top-right"], [1, "file-upload", 3, "hidden"], ["class", "files-list", 4, "ngIf"], [1, "flow-dragdrop"], ["flowDrop", "", 3, "flow", 4, "ngIf"], ["class", "uploading-files", 4, "ngIf"], [1, "files-list"], [4, "ngFor", "ngForOf"], ["target", "_blank", 3, "href"], ["flowDrop", "", 3, "flow"], ["flowButton", "", 3, "flowAttributes", "flow"], [1, "flow-drop-instructions"], [1, "uploading-files"], [1, "mailwiz-list-item", "recipient"], [4, "ngIf"], ["type", "button", 1, "btn", "btn_icn", "space-left-sm", 3, "click"], [1, "mailwiz-list-item", "mailwiz-list-item-selectable"], ["class", "mailmerge", 3, "click", 4, "ngFor", "ngForOf"], [1, "mailmerge", 3, "click"]],
      template: function MailwizComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementContainer(0, 5, 0);
          i0.ɵɵelementStart(2, "div", 6)(3, "div", 7)(4, "h3", 8);
          i0.ɵɵtext(5);
          i0.ɵɵpipe(6, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "button", 9);
          i0.ɵɵpipe(8, "translate");
          i0.ɵɵlistener("click", function MailwizComponent_Template_button_click_7_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.hideModal());
          });
          i0.ɵɵelement(9, "span", 10);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(10, "form", 11)(11, "div", 12)(12, "div", 13)(13, "div", 14)(14, "div", 15)(15, "div", 16)(16, "div", 17)(17, "span");
          i0.ɵɵtext(18);
          i0.ɵɵpipe(19, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtext(20, ": ");
          i0.ɵɵelementStart(21, "a", 18);
          i0.ɵɵlistener("click", function MailwizComponent_Template_a_click_21_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.sidebar = "recipients");
          });
          i0.ɵɵtext(22);
          i0.ɵɵelementStart(23, "span");
          i0.ɵɵtext(24);
          i0.ɵɵpipe(25, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(26, "span", 19);
          i0.ɵɵlistener("click", function MailwizComponent_Template_span_click_26_listener() {
            i0.ɵɵrestoreView(_r1);
            const collapseCc_r2 = i0.ɵɵreference(35);
            collapseCc_r2.toggle();
            return i0.ɵɵresetView(ctx.showCc = !ctx.showCc);
          });
          i0.ɵɵelementStart(27, "span");
          i0.ɵɵtext(28);
          i0.ɵɵpipe(29, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(30, "span", 19);
          i0.ɵɵlistener("click", function MailwizComponent_Template_span_click_30_listener() {
            i0.ɵɵrestoreView(_r1);
            const collapseBcc_r3 = i0.ɵɵreference(44);
            collapseBcc_r3.toggle();
            return i0.ɵɵresetView(ctx.showBcc = !ctx.showBcc);
          });
          i0.ɵɵelementStart(31, "span");
          i0.ɵɵtext(32);
          i0.ɵɵpipe(33, "translate");
          i0.ɵɵelementEnd()()()();
          i0.ɵɵelementStart(34, "div", 20, 1);
          i0.ɵɵlistener("ngbCollapseChange", function MailwizComponent_Template_div_ngbCollapseChange_34_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.showCc = $event);
          });
          i0.ɵɵelementStart(36, "div", 21)(37, "label", 22);
          i0.ɵɵelement(38, "span");
          i0.ɵɵtext(39);
          i0.ɵɵpipe(40, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(41, "div", 23)(42, "input", 24);
          i0.ɵɵtwoWayListener("ngModelChange", function MailwizComponent_Template_input_ngModelChange_42_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.selectedTemplate.cc_address, $event) || (ctx.selectedTemplate.cc_address = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(43, "div", 20, 2);
          i0.ɵɵlistener("ngbCollapseChange", function MailwizComponent_Template_div_ngbCollapseChange_43_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.showBcc = $event);
          });
          i0.ɵɵelementStart(45, "div", 21)(46, "label", 25);
          i0.ɵɵelement(47, "span");
          i0.ɵɵtext(48);
          i0.ɵɵpipe(49, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(50, "div", 23)(51, "input", 26);
          i0.ɵɵtwoWayListener("ngModelChange", function MailwizComponent_Template_input_ngModelChange_51_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.selectedTemplate.bcc_address, $event) || (ctx.selectedTemplate.bcc_address = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(52, "div", 16)(53, "div", 21)(54, "label", 27)(55, "span", 28);
          i0.ɵɵelement(56, "span");
          i0.ɵɵtext(57);
          i0.ɵɵpipe(58, "translate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(59, "div", 23)(60, "input", 29, 3);
          i0.ɵɵtwoWayListener("ngModelChange", function MailwizComponent_Template_input_ngModelChange_60_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.selectedTemplate.subject, $event) || (ctx.selectedTemplate.subject = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(62, "div", 16)(63, "div", 21)(64, "label", 30)(65, "span", 28)(66, "span");
          i0.ɵɵtext(67);
          i0.ɵɵpipe(68, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtext(69, ":");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(70, "div", 23)(71, "input", 31, 3);
          i0.ɵɵtwoWayListener("ngModelChange", function MailwizComponent_Template_input_ngModelChange_71_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.selectedTemplate.from_address, $event) || (ctx.selectedTemplate.from_address = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(73, "div", 16)(74, "div", 21)(75, "label", 32)(76, "span", 28)(77, "span");
          i0.ɵɵtext(78);
          i0.ɵɵpipe(79, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtext(80, ":");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(81, "div", 23)(82, "input", 33);
          i0.ɵɵtwoWayListener("ngModelChange", function MailwizComponent_Template_input_ngModelChange_82_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.selectedTemplate.send_copy_to, $event) || (ctx.selectedTemplate.send_copy_to = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(83, MailwizComponent_div_83_Template, 5, 4, "div", 34);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(84, "div", 35)(85, "editor", 36, 4);
          i0.ɵɵtwoWayListener("ngModelChange", function MailwizComponent_Template_editor_ngModelChange_85_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.selectedTemplate.html_body, $event) || (ctx.selectedTemplate.html_body = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(87, MailwizComponent_div_87_Template, 5, 4, "div", 37);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(88, "div", 38)(89, "div", 39);
          i0.ɵɵlistener("click", function MailwizComponent_Template_div_click_89_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.sidebar = "recipients");
          });
          i0.ɵɵelementStart(90, "span");
          i0.ɵɵtext(91);
          i0.ɵɵpipe(92, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(93, "i", 40);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(94, "div", 39);
          i0.ɵɵlistener("click", function MailwizComponent_Template_div_click_94_listener() {
            i0.ɵɵrestoreView(_r1);
            ctx.sidebar = "fields";
            return i0.ɵɵresetView(ctx.focusOnEditor());
          });
          i0.ɵɵelementStart(95, "span");
          i0.ɵɵtext(96);
          i0.ɵɵpipe(97, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(98, "i", 40);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(99, "div", 41)(100, "div", 39);
          i0.ɵɵlistener("click", function MailwizComponent_Template_div_click_100_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.sidebar = "");
          });
          i0.ɵɵelement(101, "i", 42);
          i0.ɵɵelementStart(102, "span");
          i0.ɵɵtext(103);
          i0.ɵɵpipe(104, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(105, "div", 43)(106, "div", 44)(107, "input", 45);
          i0.ɵɵtwoWayListener("ngModelChange", function MailwizComponent_Template_input_ngModelChange_107_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.keyword, $event) || (ctx.keyword = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(108, "button", 46);
          i0.ɵɵelement(109, "i", 47);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(110, "div");
          i0.ɵɵtemplate(111, MailwizComponent_div_111_Template, 2, 1, "div", 48);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(112, "div", 49)(113, "div", 39);
          i0.ɵɵlistener("click", function MailwizComponent_Template_div_click_113_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.sidebar = "");
          });
          i0.ɵɵelement(114, "i", 42);
          i0.ɵɵelementStart(115, "span");
          i0.ɵɵtext(116);
          i0.ɵɵpipe(117, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(118, "div", 43);
          i0.ɵɵtemplate(119, MailwizComponent_div_119_Template, 5, 4, "div", 50);
          i0.ɵɵpipe(120, "keyvalue");
          i0.ɵɵelementEnd()()()()();
          i0.ɵɵelementStart(121, "div", 51)(122, "button", 52);
          i0.ɵɵlistener("click", function MailwizComponent_Template_button_click_122_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.hideModal());
          });
          i0.ɵɵtext(123);
          i0.ɵɵpipe(124, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(125, "button", 53);
          i0.ɵɵlistener("click", function MailwizComponent_Template_button_click_125_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.send());
          });
          i0.ɵɵtext(126);
          i0.ɵɵpipe(127, "translate");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("flowConfig", ctx.flowConfig);
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 44, "misc.New Message"));
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(8, 46, "misc.Close"));
          i0.ɵɵadvance(11);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 48, "misc.To"), "");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1("", ctx.totalRecipients, " ");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(25, 50, "misc.Recipients"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("hidden", ctx.showCc);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(29, 52, "misc.Cc"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("hidden", ctx.showBcc);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(33, 54, "misc.Bcc"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngbCollapse", !ctx.showCc);
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(40, 56, "misc.Cc"), ":");
          i0.ɵɵadvance(3);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedTemplate.cc_address);
          i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(80, _c3$q));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngbCollapse", !ctx.showBcc);
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(49, 58, "misc.Bcc"), ":");
          i0.ɵɵadvance(3);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedTemplate.bcc_address);
          i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(81, _c3$q));
          i0.ɵɵadvance(6);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(58, 60, "misc.Subject"), ":");
          i0.ɵɵadvance(3);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedTemplate.subject);
          i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(82, _c3$q));
          i0.ɵɵadvance(7);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(68, 62, "misc.From"));
          i0.ɵɵadvance(4);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedTemplate.from_address);
          i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(83, _c3$q));
          i0.ɵɵadvance(7);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(79, 64, "misc.Send Copy To"));
          i0.ɵɵadvance(4);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedTemplate.send_copy_to);
          i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(84, _c3$q));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", (ctx.messageTemplate == null ? null : ctx.messageTemplate.settings == null ? null : ctx.messageTemplate.settings.allow_attachments) === "1");
          i0.ɵɵadvance(2);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedTemplate.html_body);
          i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(85, _c3$q))("init", ctx.initOptions);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", (ctx.messageTemplate == null ? null : ctx.messageTemplate.settings == null ? null : ctx.messageTemplate.settings.allow_attachments) === "1");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(92, 66, "misc.Recipients"));
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(97, 68, "misc.Fields"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(86, _c4$n, ctx.sidebar !== "recipients"));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(104, 70, "misc.Recipients"));
          i0.ɵɵadvance(4);
          i0.ɵɵtwoWayProperty("ngModel", ctx.keyword);
          i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(88, _c3$q));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngForOf", ctx.selectedRecipients);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(89, _c4$n, ctx.sidebar !== "fields"));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(117, 72, "misc.Fields"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(120, 74, ctx.selectedTemplate.mailmerge_vars));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(124, 76, "misc.Close"));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(127, 78, "misc.Send"));
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.ɵNgNoValidate, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.RequiredValidator, i2$1.NgModel, i2$1.NgForm, i1$4.NgbCollapse, i5.ButtonDirective, i5.DropDirective, i5.FlowDirective, i4.EditorComponent, i1.KeyValuePipe, i1$1.TranslatePipe, FileSizePipe],
      styles: ["mailwiz .field-error-richtext{border:#bf3e24 solid 1.2px}mailwiz .modal-backdrop{z-index:3;position:fixed;height:auto;bottom:0}mailwiz .modal-open .modal{overflow-x:hidden;overflow-y:auto}mailwiz .modal{display:none;inset:0;overflow:hidden;position:fixed;z-index:9998}mailwiz .modal-dialog{max-width:1024px;width:100%}mailwiz form{display:grid;grid-template-rows:1fr auto;height:calc(100% - 60px);overflow:auto}mailwiz .modal-header{padding:5px 15px;background-color:#f6f6f6}mailwiz .modal-body{padding:0!important;height:620px;overflow:hidden}mailwiz .main-content{display:grid;grid-template-rows:auto 1fr auto;height:100%;width:70%;grid-template-areas:\"email-field\" \"email-content\" \"email-attach\"}mailwiz .modal-body .content-container,mailwiz .modal-body .sidebar-container{height:100%;min-width:unset}mailwiz .modal-body .content-container .email-fields{grid-area:email-field}mailwiz .modal-body .content-container .email-body{position:relative;display:grid;width:100%;grid-area:email-content;overflow:auto}mailwiz .modal-body .content-container .email-body .mailwiz-body{grid-area:email-body-form;overflow:auto}mailwiz .modal-body .content-container .email-body .mailwiz-toolbar{grid-area:email-body-toolbar;padding:10px 5px 0 10px}mailwiz .modal-body .content-container .email-body .email-body-input{height:100%;width:100%;padding:10px;overflow-y:auto;border:none}mailwiz .modal-body .content-container .email-body .ta-bind{min-height:100%}mailwiz .modal-body .content-container .file-upload{background-color:#ececec;padding:10px;box-sizing:border-box;grid-area:email-attach}mailwiz .modal-body .content-container .file-upload .files-list a{color:#042;text-decoration:none;font-size:13px;line-height:20px}mailwiz .modal-body .content-container .file-upload .files-list a:hover{text-decoration:underline}mailwiz .modal-body .content-container .file-upload .files-list>div:last-child{margin-bottom:10px}mailwiz .modal-body .content-container .file-upload .flow-dragdrop{padding:10px;border:2px dashed #949494;border-radius:5px;text-align:center}mailwiz .modal-body .content-container .file-upload .flow-dragdrop a{font-size:14px;text-decoration:underline}mailwiz .modal-body .content-container .email-field-label{margin-right:5px;cursor:pointer}mailwiz .sidebar-container{width:30%;position:absolute;top:0;right:0;bottom:0;border-left:1px solid #CCC;-webkit-transition:right .3s ease-out;-o-transition:right .3s ease-out;transition:right .3s ease-out}mailwiz .modal-body .sidebar-options{background-color:#333;color:#fff;z-index:1}mailwiz .modal-body .sidebar-recipients,mailwiz .modal-body .sidebar-templates,mailwiz .modal-body .sidebar-fields{z-index:10;background-color:#fff}mailwiz .sidebar-hidden{right:-400px}mailwiz .modal-body .section-divider{width:100%;padding:0 10px;border-bottom:1px solid #CCC;height:40px;grid-area:email-field}mailwiz .modal-body .section-divider.action-buttons{height:44px}mailwiz .modal-body .section-divider .section-label,mailwiz .modal-body .section-divider .section-input{display:inline-block;line-height:40px}mailwiz .modal-body .section-divider .section-label input[type=text],mailwiz .modal-body .section-divider .section-input input[type=text]{border:0;background-color:transparent;-webkit-box-shadow:none;box-shadow:none;width:100%;height:40px}mailwiz .modal-body .section-divider .section-label{width:100px}mailwiz .modal-body .section-divider .section-input{width:calc(100% - 120px);border-left:1px solid #CCC}mailwiz .modal-body .section-divider .section-content{line-height:40px;padding-right:10px}mailwiz .modal-body .section-divider .section-content input[type=radio]{margin-top:12px}mailwiz .modal-body .sidebar-option{text-align:center;font-size:1.2em;cursor:pointer;position:relative;line-height:40px}mailwiz .modal-body .sidebar-option .arrow{position:absolute}mailwiz .modal-body .sidebar-option .icn-chevron_left{left:3px;top:12px}mailwiz .modal-body .sidebar-option .icn-chevron_right{right:5px;top:11px}mailwiz .modal-body .sidebar-list-container{overflow-y:auto;height:inherit}mailwiz .mailwiz-list-item{padding:5px 10px;border-bottom:1px solid #EEE;cursor:pointer}mailwiz .mailwiz-list-item.recipient{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}mailwiz .mailwiz-list-item:first-child{border-top:0}mailwiz .mailwiz-list-item.mailwiz-list-item-selectable:hover{background-color:#eee}mailwiz .modal-footer{background-color:#ececec;padding:13px;margin-top:0;vertical-align:middle}mailwiz .modal-footer .popover .popover-content{border:1px solid #EEE;padding:0}mailwiz .modal-footer .popover .content-container{min-width:auto;margin:0;border-top:0}mailwiz .modal-footer .footer-actions{float:left;display:none}@media (max-width: 991px){mailwiz .modal-body{height:auto}mailwiz .modal-body .content-container{width:100%;margin:0;border:0}mailwiz .modal-body .content-container .email-body{height:420px;overflow:inherit}mailwiz .modal-body .content-container .action-buttons{display:none}mailwiz .modal-body .content-container .main-content{width:100%}mailwiz .modal-body .sidebar-container{display:none}mailwiz .modal-footer .footer-actions{display:block}}@media (max-width: 767px){mailwiz .modal-body{overflow-y:auto}mailwiz .modal-body .content-container .email-body{height:auto}}mailwiz .btn.btn-mailwiz-action{display:inline-block;border:1px solid #CCC;background-color:transparent;padding:8px 16px;line-height:normal}mailwiz .btn.btn-mailwiz-action.active{background-color:silver}mailwiz #typeaheadContainer .typeahead.dropdown-menu{width:90%}mailwiz #typeaheadContainer .dropdown-menu>li>a{overflow:hidden;text-overflow:ellipsis}mailwiz .popover.popover-pretty .popover-title{background-color:#0fa6ec;color:#fff}mailwiz .popover.job-descriptions{width:500px;max-width:none}mailwiz .popover.job-descriptions .job-description{height:300px;overflow-y:auto;-webkit-user-select:none;user-select:none}mailwiz .popover .popover-footer{margin:10px 0}mailwiz .popover .popover-footer button{margin-left:10px}mailwiz .popover.popover-pricing-chart{max-width:800px;font-size:13px}mailwiz .popover.popover-pricing-chart .title{margin-top:0}mailwiz .popover.popover-pricing-chart .popover-content{width:400px}mailwiz .popover.mailwiz-popover{width:300px}mailwiz .popover.mailwiz-popover .popover-content .content-container{height:150px;overflow-y:auto}mailwiz .popover.mailwiz-popover .popover-content .popover-footer{margin:0;padding:10px}mailwiz .btn.disabled,mailwiz .btn.btn[disabled]{opacity:.35}mailwiz btn.disabled,mailwiz .btn[disabled],mailwiz fieldset[disabled] .btn{box-shadow:none;cursor:not-allowed;opacity:.65;pointer-events:none}mailwiz .btn:active,mailwiz .btn.active{background-image:none;box-shadow:0 3px 5px #00000020 inset}mailwiz .float-right{float:right}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MailwizComponent, [{
    type: Component,
    args: [{
      selector: 'mailwiz',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<ng-container #flow=\"flow\" [flowConfig]=\"flowConfig\"></ng-container>\n\n<div class=\"modal-content\">\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\">{{ 'misc.New Message' | translate }}</h3>\n        <button class=\"modal-close\" [attr.aria-label]=\"'misc.Close' | translate\" (click)=\"hideModal()\">\n            <span class=\"icn-close\"></span>\n        </button>\n    </div>\n    <form name=\"mailwiz\">\n        <div class=\"modal-body\">\n            <div class=\"content-container\">\n                <div class=\"main-content\">\n                    <div class=\"email-fields\">\n                        <div class=\"section-divider\">\n                            <div class=\"section-content\">\n                                <span> {{'misc.To' | translate }}</span>: <a (click)=\"sidebar = 'recipients';\">{{ totalRecipients }} <span>{{ 'misc.Recipients' | translate }}</span></a>\n                                <span class=\"email-field-label pull-right\" (click)=\"collapseCc.toggle();showCc=!showCc;\" [hidden]=\"showCc\"><span>{{ 'misc.Cc' | translate}}</span></span>\n                                <span class=\"email-field-label pull-right\" (click)=\"collapseBcc.toggle();showBcc=!showBcc;\" [hidden]=\"showBcc\"><span>{{ 'misc.Bcc' | translate }}</span></span>\n                            </div>\n                        </div>\n                        \n                        <div class=\"section-divider\" #collapseCc=\"ngbCollapse\" [ngbCollapse]=\"!showCc\" (ngbCollapseChange)=\"showCc = $event\">\n                            <div class=\"section-label\"><label for=\"cc\"><span></span>{{ 'misc.Cc' | translate }}:</label></div>\n                            <div class=\"section-input\"><input type=\"text\" id=\"cc\" class=\"form-control\" [(ngModel)]=\"selectedTemplate.cc_address\" [ngModelOptions]=\"{standalone: true}\"/></div>\n                        </div>\n\n                        <div class=\"section-divider\"  #collapseBcc=\"ngbCollapse\" [ngbCollapse]=\"!showBcc\" (ngbCollapseChange)=\"showBcc = $event\">\n                            <div class=\"section-label\"><label for=\"bcc\"><span></span>{{ 'misc.Bcc' | translate }}:</label></div>\n                            <div class=\"section-input\"><input type=\"text\" id=\"bcc\" class=\"form-control\" [(ngModel)]=\"selectedTemplate.bcc_address\" [ngModelOptions]=\"{standalone: true}\"/></div>\n                        </div>\n\n                        <div class=\"section-divider\">\n                            <div class=\"section-label\">\n                                <label for=\"subject\">\n                                    <span class=\"control-label\"><span></span>{{ 'misc.Subject' | translate }}:</span>\n                                </label>\n                            </div>\n                            <div class=\"section-input\">\n                                <input #requiredInput name=\"subject\" type=\"text\" id=\"subject\" class=\"form-control\" [(ngModel)]=\"selectedTemplate.subject\" [ngModelOptions]=\"{standalone: true}\" required>\n                            </div>\n                        </div>\n\n                        <div class=\"section-divider\">\n                            <div class=\"section-label\">\n                                <label for=\"from_address\">\n                                    <span class=\"control-label\"><span>{{ 'misc.From' | translate }}</span>:</span>\n                                </label>\n                            </div>\n                            <div class=\"section-input\">\n                                <input #requiredInput name=\"from_address\" type=\"text\" id=\"from_address\" class=\"form-control\" [(ngModel)]=\"selectedTemplate.from_address\" [ngModelOptions]=\"{standalone: true}\" required>\n                            </div>\n                        </div>\n\n                        <div class=\"section-divider\">\n                            <div class=\"section-label\">\n                                <label for=\"send_copy_to\">\n                                    <span class=\"control-label\"><span>{{ 'misc.Send Copy To' | translate }}</span>:</span>\n                                </label>\n                            </div>\n                            <div class=\"section-input\">\n                                <input name=\"send_copy_to\" type=\"text\" id=\"send_copy_to\" class=\"form-control\" [(ngModel)]=\"selectedTemplate.send_copy_to\" [ngModelOptions]=\"{standalone: true}\"/>\n                            </div>\n                        </div>\n\n                        <div *ngIf=\"messageTemplate?.settings?.allow_attachments === '1'\" class=\"section-divider action-buttons flexbox align-items-center\">\n                            <div class=\"section-content flexbox\">\n                                <button type=\"button\" class=\"btn btn-small btn-mailwiz-action\" [ngClass]=\"{ 'active': showAttachments }\" (click)=\"toggleAttachments()\">\n                                    <i class=\"icn-paperclip\"></i>\n                                    <span *ngIf=\"selectedTemplate?.attachment?.length\" class=\"label label-primary label-top-right\">\n                                        {{ selectedTemplate.attachment.length }}\n                                    </span>\n                                </button>\n                            </div>\n                        </div>\n\n                        \n                    </div>\n\n                    <div class=\"email-body\">\n                        <editor tagName=\"textarea\"\n                                [(ngModel)]=\"selectedTemplate.html_body\"\n                                [ngModelOptions]=\"{standalone: true}\"\n                                [init]=\"initOptions\"\n                                #editor\n                        ></editor>\n                    </div>\n\n                    <div *ngIf=\"messageTemplate?.settings?.allow_attachments === '1'\" class=\"file-upload\" [hidden]=\"!showAttachments\">\n                        <div *ngIf=\"selectedTemplate.attachment.length\" class=\"files-list\">\n                            <div *ngFor=\"let attachment of selectedTemplate.attachment; let index = index;\">\n                                <a [href]=\"attachment.url\" target=\"_blank\">{{ attachment.user_file_name }}</a>\n                                <span> - {{ attachment.filetype }} ({{ attachment.size | fileSize }}) </span>\n                                <a (click)=\"deleteFile(index, attachment)\">{{ 'misc.Delete' | translate }}</a>\n                            </div>\n                        </div>\n\n                        <div class=\"flow-dragdrop\">\n                            <div *ngIf=\"filesToUploadStatus === 'initial'\" flowDrop [flow]=\"flow.flowJs\">\n                                <span>\n                                    {{ 'misc.Drag and Drop files here or' | translate }}\n                                </span>\n                                \n                                <a flowButton [flowAttributes]=\"flowAttributes\" [flow]=\"flow.flowJs\">\n                                    {{ 'misc.browse files to upload' | translate }}\n                                </a>\n                                \n                                <div class=\"flow-drop-instructions\">\n                                    {{ 'misc.Drop the Files!' | translate }}\n                                </div>\n                            </div>\n\n                            <div *ngIf=\"filesToUploadStatus === 'progress'\" class=\"uploading-files\">\n                                {{ 'misc.Uploading files' | translate: { count: filesToUpload.length } }}\n                                <!-- {{ 'career_fair employers.Students Waiting' | translate: { count: studentsWaiting } }} -->\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"sidebar-container sidebar-options\">\n                    <div class=\"sidebar-option section-divider\" (click)=\"sidebar = 'recipients';\">\n                        <span>{{ 'misc.Recipients' | translate}}</span><i class=\"arrow icn-chevron_right\"></i>\n                    </div>\n                    <div class=\"sidebar-option section-divider\" (click)=\"sidebar = 'fields'; focusOnEditor()\">\n                        <span>{{ 'misc.Fields' | translate }}</span><i class=\"arrow icn-chevron_right\"></i>\n                    </div>\n                </div>\n\n                <!-- Recipients -->\n                <div class=\"sidebar-container sidebar-recipients\" [ngClass]=\"{'sidebar-hidden': sidebar !== 'recipients'}\">\n                    <div class=\"sidebar-option section-divider\" (click)=\"sidebar = ''\">\n                        <i class=\"arrow icn-chevron_left\"></i><span>{{ 'misc.Recipients' | translate }}</span>\n                    </div>\n                    <div class=\"sidebar-list-container\">\n                        <div class=\"input-append btn-block\">\n                            <input class=\"input-search btn-block\" type=\"search\" placeholder=\"Search Recipients\" [(ngModel)]=\"keyword\" [ngModelOptions]=\"{standalone: true}\">\n                            <button class=\"btn btn_search\" type=\"button\">\n                                <i class=\"icn-search\"></i>\n                            </button>\n                        </div>\n                        <div>\n                            \n                                <div class=\"mailwiz-list-item recipient\" *ngFor=\"let recipient of selectedRecipients; let i = index\">\n                                    <ng-container *ngIf=\"recipient.email.includes(keyword)\">\n                                        <button type=\"button\" class=\"btn btn_icn space-left-sm\" (click)=\"removeRecipient(i, recipient.id)\">&times;</button>\n                                        {{ recipient.email }}\n                                    </ng-container>\n                                </div>\n                            \n                        </div>\n                    </div>\n                </div>\n\n                <!-- Fields -->\n                <div class=\"sidebar-container sidebar-fields\" [ngClass]=\"{'sidebar-hidden': sidebar !== 'fields'}\">\n                    <div class=\"sidebar-option section-divider\" (click)=\"sidebar = ''\">\n                        <i class=\"arrow icn-chevron_left\"></i><span>{{ 'misc.Fields' | translate}}</span>\n                    </div>\n                    <div class=\"sidebar-list-container\">\n                        <div class=\"mailwiz-list-item mailwiz-list-item-selectable\" *ngFor=\"let mailmergeVars of selectedTemplate.mailmerge_vars | keyvalue\">\n                            <b>{{ mailmergeVars.key }}</b>\n                            <div *ngFor=\"let fields of mailmergeVars.value | keyvalue\">\n                                <div class=\"mailmerge\" *ngFor=\"let field of fields.value | keyvalue\" (click)=\"addMailmergeVarToCaret(field.key)\">\n                                    <span>{{ field.key }}</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn_secondary\" data-dismiss=\"modal\" (click)=\"hideModal()\">{{ 'misc.Close' | translate}}</button>\n        <button type=\"button\" class=\"btn btn_primary\" (click)=\"send()\">{{ 'misc.Send' | translate }}</button>\n      </div>\n</div>\n",
      styles: ["mailwiz .field-error-richtext{border:#bf3e24 solid 1.2px}mailwiz .modal-backdrop{z-index:3;position:fixed;height:auto;bottom:0}mailwiz .modal-open .modal{overflow-x:hidden;overflow-y:auto}mailwiz .modal{display:none;inset:0;overflow:hidden;position:fixed;z-index:9998}mailwiz .modal-dialog{max-width:1024px;width:100%}mailwiz form{display:grid;grid-template-rows:1fr auto;height:calc(100% - 60px);overflow:auto}mailwiz .modal-header{padding:5px 15px;background-color:#f6f6f6}mailwiz .modal-body{padding:0!important;height:620px;overflow:hidden}mailwiz .main-content{display:grid;grid-template-rows:auto 1fr auto;height:100%;width:70%;grid-template-areas:\"email-field\" \"email-content\" \"email-attach\"}mailwiz .modal-body .content-container,mailwiz .modal-body .sidebar-container{height:100%;min-width:unset}mailwiz .modal-body .content-container .email-fields{grid-area:email-field}mailwiz .modal-body .content-container .email-body{position:relative;display:grid;width:100%;grid-area:email-content;overflow:auto}mailwiz .modal-body .content-container .email-body .mailwiz-body{grid-area:email-body-form;overflow:auto}mailwiz .modal-body .content-container .email-body .mailwiz-toolbar{grid-area:email-body-toolbar;padding:10px 5px 0 10px}mailwiz .modal-body .content-container .email-body .email-body-input{height:100%;width:100%;padding:10px;overflow-y:auto;border:none}mailwiz .modal-body .content-container .email-body .ta-bind{min-height:100%}mailwiz .modal-body .content-container .file-upload{background-color:#ececec;padding:10px;box-sizing:border-box;grid-area:email-attach}mailwiz .modal-body .content-container .file-upload .files-list a{color:#042;text-decoration:none;font-size:13px;line-height:20px}mailwiz .modal-body .content-container .file-upload .files-list a:hover{text-decoration:underline}mailwiz .modal-body .content-container .file-upload .files-list>div:last-child{margin-bottom:10px}mailwiz .modal-body .content-container .file-upload .flow-dragdrop{padding:10px;border:2px dashed #949494;border-radius:5px;text-align:center}mailwiz .modal-body .content-container .file-upload .flow-dragdrop a{font-size:14px;text-decoration:underline}mailwiz .modal-body .content-container .email-field-label{margin-right:5px;cursor:pointer}mailwiz .sidebar-container{width:30%;position:absolute;top:0;right:0;bottom:0;border-left:1px solid #CCC;-webkit-transition:right .3s ease-out;-o-transition:right .3s ease-out;transition:right .3s ease-out}mailwiz .modal-body .sidebar-options{background-color:#333;color:#fff;z-index:1}mailwiz .modal-body .sidebar-recipients,mailwiz .modal-body .sidebar-templates,mailwiz .modal-body .sidebar-fields{z-index:10;background-color:#fff}mailwiz .sidebar-hidden{right:-400px}mailwiz .modal-body .section-divider{width:100%;padding:0 10px;border-bottom:1px solid #CCC;height:40px;grid-area:email-field}mailwiz .modal-body .section-divider.action-buttons{height:44px}mailwiz .modal-body .section-divider .section-label,mailwiz .modal-body .section-divider .section-input{display:inline-block;line-height:40px}mailwiz .modal-body .section-divider .section-label input[type=text],mailwiz .modal-body .section-divider .section-input input[type=text]{border:0;background-color:transparent;-webkit-box-shadow:none;box-shadow:none;width:100%;height:40px}mailwiz .modal-body .section-divider .section-label{width:100px}mailwiz .modal-body .section-divider .section-input{width:calc(100% - 120px);border-left:1px solid #CCC}mailwiz .modal-body .section-divider .section-content{line-height:40px;padding-right:10px}mailwiz .modal-body .section-divider .section-content input[type=radio]{margin-top:12px}mailwiz .modal-body .sidebar-option{text-align:center;font-size:1.2em;cursor:pointer;position:relative;line-height:40px}mailwiz .modal-body .sidebar-option .arrow{position:absolute}mailwiz .modal-body .sidebar-option .icn-chevron_left{left:3px;top:12px}mailwiz .modal-body .sidebar-option .icn-chevron_right{right:5px;top:11px}mailwiz .modal-body .sidebar-list-container{overflow-y:auto;height:inherit}mailwiz .mailwiz-list-item{padding:5px 10px;border-bottom:1px solid #EEE;cursor:pointer}mailwiz .mailwiz-list-item.recipient{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}mailwiz .mailwiz-list-item:first-child{border-top:0}mailwiz .mailwiz-list-item.mailwiz-list-item-selectable:hover{background-color:#eee}mailwiz .modal-footer{background-color:#ececec;padding:13px;margin-top:0;vertical-align:middle}mailwiz .modal-footer .popover .popover-content{border:1px solid #EEE;padding:0}mailwiz .modal-footer .popover .content-container{min-width:auto;margin:0;border-top:0}mailwiz .modal-footer .footer-actions{float:left;display:none}@media (max-width: 991px){mailwiz .modal-body{height:auto}mailwiz .modal-body .content-container{width:100%;margin:0;border:0}mailwiz .modal-body .content-container .email-body{height:420px;overflow:inherit}mailwiz .modal-body .content-container .action-buttons{display:none}mailwiz .modal-body .content-container .main-content{width:100%}mailwiz .modal-body .sidebar-container{display:none}mailwiz .modal-footer .footer-actions{display:block}}@media (max-width: 767px){mailwiz .modal-body{overflow-y:auto}mailwiz .modal-body .content-container .email-body{height:auto}}mailwiz .btn.btn-mailwiz-action{display:inline-block;border:1px solid #CCC;background-color:transparent;padding:8px 16px;line-height:normal}mailwiz .btn.btn-mailwiz-action.active{background-color:silver}mailwiz #typeaheadContainer .typeahead.dropdown-menu{width:90%}mailwiz #typeaheadContainer .dropdown-menu>li>a{overflow:hidden;text-overflow:ellipsis}mailwiz .popover.popover-pretty .popover-title{background-color:#0fa6ec;color:#fff}mailwiz .popover.job-descriptions{width:500px;max-width:none}mailwiz .popover.job-descriptions .job-description{height:300px;overflow-y:auto;-webkit-user-select:none;user-select:none}mailwiz .popover .popover-footer{margin:10px 0}mailwiz .popover .popover-footer button{margin-left:10px}mailwiz .popover.popover-pricing-chart{max-width:800px;font-size:13px}mailwiz .popover.popover-pricing-chart .title{margin-top:0}mailwiz .popover.popover-pricing-chart .popover-content{width:400px}mailwiz .popover.mailwiz-popover{width:300px}mailwiz .popover.mailwiz-popover .popover-content .content-container{height:150px;overflow-y:auto}mailwiz .popover.mailwiz-popover .popover-content .popover-footer{margin:0;padding:10px}mailwiz .btn.disabled,mailwiz .btn.btn[disabled]{opacity:.35}mailwiz btn.disabled,mailwiz .btn[disabled],mailwiz fieldset[disabled] .btn{box-shadow:none;cursor:not-allowed;opacity:.65;pointer-events:none}mailwiz .btn:active,mailwiz .btn.active{background-image:none;box-shadow:0 3px 5px #00000020 inset}mailwiz .float-right{float:right}\n"]
    }]
  }], () => [{
    type: i1$4.NgbActiveModal
  }, {
    type: ValkyrieBackendService
  }, {
    type: i1$1.TranslateService
  }], {
    message: [{
      type: Input
    }],
    selectedRecipients: [{
      type: Input
    }],
    templateApi: [{
      type: Input
    }],
    attachmentsApi: [{
      type: Input
    }],
    editor: [{
      type: ViewChild,
      args: ['editor', {
        static: true
      }]
    }],
    requiredInputs: [{
      type: ViewChildren,
      args: ['requiredInput']
    }],
    flow: [{
      type: ViewChild,
      args: ['flow', {
        static: false
      }]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MailwizComponent, {
    className: "MailwizComponent",
    filePath: "valkyrie/mailwiz/mailwiz.component.ts",
    lineNumber: 19
  });
})();
const _c0$V = ["modal"];
const _c1$L = [[["", "content", ""]], [["", "footer", ""]]];
const _c2$C = ["[content]", "[footer]"];
function ModalWindowLayoutComponent_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function ModalWindowLayoutComponent_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeModal());
    });
    i0.ɵɵelement(2, "i", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "misc.Close"));
  }
}
class ModalWindowLayoutComponent {
  constructor() {
    this.closeBtn = true;
    this.dismiss = new EventEmitter();
  }
  get closeButton() {
    return this.closeBtn;
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $(this.modalContent.nativeElement).closest('ngb-modal-window').focus();
    }, 400);
  }
  closeModal() {
    this.dismiss.emit(true);
  }
  static {
    this.ɵfac = function ModalWindowLayoutComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalWindowLayoutComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ModalWindowLayoutComponent,
      selectors: [["modal-window-layout"]],
      viewQuery: function ModalWindowLayoutComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$V, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modalContent = _t.first);
        }
      },
      inputs: {
        title: "title",
        class: "class",
        closeBtn: "closeBtn"
      },
      outputs: {
        dismiss: "dismiss"
      },
      standalone: false,
      ngContentSelectors: _c2$C,
      decls: 11,
      vars: 5,
      consts: [["modal", ""], [1, "modal-header"], [1, "modal-title"], ["type", "button", "class", "modal-close", 3, "title", "click", 4, "ngIf"], [1, "modal-scroll", 3, "ngClass"], [1, "modal-body"], [1, "modal-footer"], ["type", "button", 1, "modal-close", 3, "click", "title"], [1, "icn-close"]],
      template: function ModalWindowLayoutComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c1$L);
          i0.ɵɵelementStart(0, "div", 1)(1, "span", 2);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, ModalWindowLayoutComponent_button_4_Template, 3, 3, "button", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 4, 0)(7, "div", 5);
          i0.ɵɵprojection(8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "div", 6);
          i0.ɵɵprojection(10, 1, ["flow-btn", ""]);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, ctx.title));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.closeButton);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.class);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalWindowLayoutComponent, [{
    type: Component,
    args: [{
      selector: 'modal-window-layout',
      standalone: false,
      template: "<div class=\"modal-header\">\n    <span class=\"modal-title\">{{title | translate}}</span>\n    <button *ngIf=\"closeButton\" type=\"button\" class=\"modal-close\" title=\"{{'misc.Close' | translate}}\" (click)=\"closeModal()\">\n        <i class=\"icn-close\"></i>\n    </button>\n</div>\n<div class=\"modal-scroll\" #modal [ngClass]=\"class\">\n    <div class=\"modal-body\">\n        <ng-content select=\"[content]\"></ng-content>\n    </div>\n    <div class=\"modal-footer\">\n        <ng-content select=\"[footer]\" flow-btn></ng-content>\n    </div>\n</div>"
    }]
  }], null, {
    title: [{
      type: Input
    }],
    class: [{
      type: Input
    }],
    closeBtn: [{
      type: Input
    }],
    dismiss: [{
      type: Output
    }],
    modalContent: [{
      type: ViewChild,
      args: ['modal', {
        static: false
      }]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ModalWindowLayoutComponent, {
    className: "ModalWindowLayoutComponent",
    filePath: "valkyrie/layout/modal-window-layout.component.ts",
    lineNumber: 9
  });
})();
const _c0$U = a0 => ({
  "more-options-container filter-sub-menu": a0
});
function ListFilterModalComponent_div_2_ng_container_2_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r4 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", option_r4.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r4.label);
  }
}
function ListFilterModalComponent_div_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div")(4, "select", 10);
    i0.ɵɵlistener("change", function ListFilterModalComponent_div_2_ng_container_2_Template_select_change_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const filter_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.singleSelecltorChange($event, filter_r2));
    });
    i0.ɵɵtemplate(5, ListFilterModalComponent_div_2_ng_container_2_option_5_Template, 2, 2, "option", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const filter_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(filter_r2.title);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("id", filter_r2.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", filter_r2.options);
  }
}
function ListFilterModalComponent_div_2_ng_container_3_li_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 15)(1, "input", 16);
    i0.ɵɵtwoWayListener("ngModelChange", function ListFilterModalComponent_div_2_ng_container_3_li_5_Template_input_ngModelChange_1_listener($event) {
      const field_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      i0.ɵɵtwoWayBindingSet(field_r6.value, $event) || (field_r6.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r6 = ctx.$implicit;
    const idx_r7 = ctx.index;
    const filter_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", filter_r2.id, "-m-checkbox-", idx_r7, "");
    i0.ɵɵtwoWayProperty("ngModel", field_r6.value);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", filter_r2.id, "-m-checkbox-", idx_r7, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(field_r6.label);
  }
}
function ListFilterModalComponent_div_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "fieldset")(2, "legend", 9);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ul", 13);
    i0.ɵɵtemplate(5, ListFilterModalComponent_div_2_ng_container_3_li_5_Template, 4, 8, "li", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const filter_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(filter_r2.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$U, filter_r2.fields.length > 5));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", filter_r2.fields);
  }
}
function ListFilterModalComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵtemplate(2, ListFilterModalComponent_div_2_ng_container_2_Template, 6, 3, "ng-container", 8)(3, ListFilterModalComponent_div_2_ng_container_3_Template, 6, 5, "ng-container", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const filter_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", filter_r2.type == "singleSelect");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", filter_r2.type == "multipleSelect");
  }
}
class ListFilterModalComponent {
  get filters() {
    return this.filterDataImported;
  }
  constructor(activeModal) {
    this.activeModal = activeModal;
    this.filterDataImported = [];
  }
  ngOnInit() {
    this.filterDataImported = JSON.parse(JSON.stringify(this.filterData));
  }
  singleSelecltorChange(e, filter) {
    filter.value = e.target.value;
  }
  filterSubmit() {
    this.activeModal.close(this.filters);
  }
  static {
    this.ɵfac = function ListFilterModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListFilterModalComponent)(i0.ɵɵdirectiveInject(i1$4.NgbActiveModal));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ListFilterModalComponent,
      selectors: [["list-filter-modal"]],
      inputs: {
        filterData: "filterData"
      },
      standalone: false,
      decls: 8,
      vars: 4,
      consts: [[3, "dismiss", "title"], ["content", ""], ["class", "field", 4, "ngFor", "ngForOf"], ["footer", ""], ["type", "button", "translate", "", 1, "btn", "btn_primary", 3, "click"], ["type", "button", "translate", "", 1, "btn", "btn_default", 3, "click"], [1, "field"], [1, "field-widget"], [4, "ngIf"], [1, "font_weight_normal", "space-bottom-sm"], [3, "change"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], [1, "list-unstyled", "multi-select-list", 3, "ngClass"], ["class", "space-bottom-sm", 4, "ngFor", "ngForOf"], [1, "space-bottom-sm"], ["type", "checkbox", 3, "ngModelChange", "id", "ngModel"], [1, "font_weight_normal", 3, "for"]],
      template: function ListFilterModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "modal-window-layout", 0);
          i0.ɵɵlistener("dismiss", function ListFilterModalComponent_Template_modal_window_layout_dismiss_0_listener() {
            return ctx.activeModal.close();
          });
          i0.ɵɵelementContainerStart(1, 1);
          i0.ɵɵtemplate(2, ListFilterModalComponent_div_2_Template, 4, 2, "div", 2);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementContainerStart(3, 3);
          i0.ɵɵelementStart(4, "button", 4);
          i0.ɵɵlistener("click", function ListFilterModalComponent_Template_button_click_4_listener() {
            return ctx.filterSubmit();
          });
          i0.ɵɵtext(5, "misc.Apply");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "button", 5);
          i0.ɵɵlistener("click", function ListFilterModalComponent_Template_button_click_6_listener() {
            return ctx.activeModal.close();
          });
          i0.ɵɵtext(7, "misc.Close");
          i0.ɵɵelementEnd();
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap("more-filter-dropdown");
          i0.ɵɵproperty("title", "misc.Filters");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.filters);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.CheckboxControlValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$1.TranslateDirective, ModalWindowLayoutComponent],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListFilterModalComponent, [{
    type: Component,
    args: [{
      selector: 'list-filter-modal',
      standalone: false,
      template: "<modal-window-layout [title]=\"'misc.Filters'\" [class]=\"'more-filter-dropdown'\" (dismiss)=\"activeModal.close()\">\n    <ng-container content>\n        <div class=\"field\" *ngFor=\"let filter of filters\">\n            <div class=\"field-widget\">\n            \n                <ng-container *ngIf=\"filter.type == 'singleSelect'\">\n                    <label class=\"font_weight_normal space-bottom-sm\">{{filter.title}}</label>\n                    <div>\n                        <select [attr.id]=\"filter.id\" (change)=\"singleSelecltorChange($event, filter)\">\n                            <option *ngFor=\"let option of filter.options\" [ngValue]=\"option.id\">{{option.label}}</option>\n                        </select>\n                    </div>\n                </ng-container>\n            \n                <ng-container *ngIf=\"filter.type == 'multipleSelect'\">\n                    <fieldset>\n                        <legend class=\"font_weight_normal space-bottom-sm\">{{filter.title}}</legend>\n                        <ul class=\"list-unstyled multi-select-list\" [ngClass]=\"{'more-options-container filter-sub-menu': filter.fields.length > 5}\">\n                            <li class=\"space-bottom-sm\" *ngFor=\"let field of filter.fields; index as idx\">\n                                <input type=\"checkbox\" id=\"{{filter.id}}-m-checkbox-{{idx}}\" [(ngModel)]=\"field.value\">\n                                <label for=\"{{filter.id}}-m-checkbox-{{idx}}\" class=\"font_weight_normal\">{{field.label}}</label>\n                            </li>\n                        </ul>\n                    </fieldset>\n                </ng-container>\n        \n            </div>\n        </div>\n    </ng-container>\n    <ng-container footer>\n        <button type=\"button\" class=\"btn btn_primary\" (click)=\"filterSubmit()\" translate>misc.Apply</button>\n        <button type=\"button\" class=\"btn btn_default\" (click)=\"activeModal.close()\" translate>misc.Close</button>\n    </ng-container>\n</modal-window-layout>"
    }]
  }], () => [{
    type: i1$4.NgbActiveModal
  }], {
    filterData: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ListFilterModalComponent, {
    className: "ListFilterModalComponent",
    filePath: "valkyrie/list-filters/list-filter-modal.component.ts",
    lineNumber: 9
  });
})();
class StandardListPageModel {
  constructor(init) {
    Object.assign(this, init);
  }
}
class ListItemLabel {
  constructor(init) {
    this.label = '';
    this.styleClass = '';
    Object.assign(this, init);
  }
}
class SimpleFilterModel {
  constructor(init) {
    this.filters = [];
    Object.assign(this, init);
  }
}
class ListFilterSingleSelect {
  constructor(init) {
    this.id = '';
    this.title = '';
    this.value = undefined;
    this.type = 'singleSelect';
    Object.assign(this, init);
  }
}
class ListFilterSingleSelectOption {
  constructor(init) {
    Object.assign(this, init);
  }
}
class ListFilterMultipleSelect {
  constructor(init) {
    this.id = '';
    this.title = '';
    this.searchField = true;
    this.type = 'multipleSelect';
    Object.assign(this, init);
  }
}
class ListFilterMultipleSelectField {
  constructor(init) {
    Object.assign(this, init);
  }
}
class SelectedFilter {
  constructor(init) {
    Object.assign(this, init);
  }
}
class ListSorts {
  constructor(init) {
    this.title = '';
    this.id = '';
    Object.assign(this, init);
  }
}
class ListItemFilterMatch {
  constructor(init) {
    Object.assign(this, init);
  }
}
class defaultStyleTypes {
  constructor() {
    this.title = 'list-item-title';
    this.subtitle = 'list-item-subtitle';
    this.description = 'list-data-columns list-data-description font-weight-normal';
    this.status = 'list-data-columns flex align-items-center item-status';
    this.tag = 'badge badge-small';
    this.text = '';
    this.button = 'btn';
    this.anchor = '';
  }
}
class SkeletonLoaderModel {
  constructor(init) {
    this.rows = 10;
    this.checkbox = false;
    this.thumbnails = false;
    this.thumbnailsStyle = '';
    this.texts = 0;
    this.actionButtons = 0;
    this.sidebar = 0;
    this.iconBtn = 0;
    Object.assign(this, init);
  }
}
class IconButton extends ListItemLabel {
  constructor(param) {
    super();
    this.id = '';
    this.icon = '';
    this.value = false;
    this.useTooltip = false;
    Object.assign(this, param);
  }
}
class Thumbnail {
  constructor(init) {
    this.type = 'image'; // 'image' or 'icon'
    this.src = ''; // If type is 'image', add a file location. If type is 'icon', add a icon class name.
    this.autoColor = '';
    this.styleClass = '';
    this.imagePosition = 'center center'; // Set background position (CSS) for image type.
    Object.assign(this, init);
  }
}
/**
 * Adds a monogram to a List Item.
 * @param type Accepts label, image or icon.
 * @param src The image source. If type is icon, add a icon class name.
 * @param isSquare Set FALSE if want to display it with circle background.
 *
 * @export
 * @class Monogram
 * @extends {ListItemLabel}
 */
class Monogram extends ListItemLabel {
  constructor(init) {
    super();
    this.type = 'label';
    this.src = '';
    this.autoColor = '';
    this.isSquare = true;
    this.statusIcon = '';
    this.statusClass = '';
    Object.assign(this, init);
  }
}
class ListItemElement extends ListItemLabel {
  constructor(param) {
    super();
    this.type = 'text'; //'text' or 'button' or 'anchor'
    this.icon = '';
    this.defaultStyleType = '';
    this.autoColor = '';
    this.ariaLabel = '';
    Object.assign(this, param);
    let selectStyle = new defaultStyleTypes()[this.defaultStyleType];
    if (selectStyle) {
      this.styleClass = selectStyle + ' ' + this.styleClass;
    }
  }
}
class EmptyState {
  constructor(init) {
    this.src = '/components/valkyrie/images/empty-magnifying-glass-gray.svg';
    this.alt = '';
    this.title = 'misc.No results found';
    this.message = '';
    this.messageTranslationParams = {};
    Object.assign(this, init);
  }
}
class EmptyStateActionButton {
  constructor(init) {
    Object.assign(this, init);
  }
}
class RowAnchorModel {
  constructor(init) {
    this.enable = false;
    Object.assign(this, init);
  }
}
class AnchorUrlModel {
  constructor(init) {
    Object.assign(this, init);
  }
}
const _c0$T = ["selector"];
const _c1$K = ["list-simple-filter-single-select", ""];
const _c2$B = a0 => ({
  "width": a0
});
function ListSimpleFilterSingleSelectComponent_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngValue", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.filter.title);
  }
}
function ListSimpleFilterSingleSelectComponent_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r3 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", option_r3.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r3.label);
  }
}
class ListSimpleFilterSingleSelectComponent {
  constructor() {
    this.changes = new EventEmitter();
    this.width = 'auto';
  }
  get filterData() {
    return this.filter;
  }
  set filterData(data) {
    if (!_.isEqual(this.filter, data)) {
      this.filter = data;
      setTimeout(() => this.resizeWidth());
    }
  }
  ngAfterViewInit() {
    setTimeout(d => {
      this.resizeWidth();
    }, 0);
  }
  resizeWidth() {
    let $this = $$1(this.selector.nativeElement);
    let text = $this.find("option:selected").text();
    let $test = $$1("<span>").html(text).css({
      "font-size": $this.css("font-size"),
      "visibility": "hidden"
    });
    $test.appendTo($this.parent());
    let textWidth = $test.width();
    $test.remove();
    const direction = window.document.dir === 'rtl' ? 'left' : 'right';
    this.width = textWidth ? textWidth + 3 + parseInt($this.css('padding-' + direction)) + 'px' : 'auto';
  }
  filterSubmit(event) {
    this.resizeWidth();
    this.changes.emit(this.filterData);
  }
  static {
    this.ɵfac = function ListSimpleFilterSingleSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListSimpleFilterSingleSelectComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ListSimpleFilterSingleSelectComponent,
      selectors: [["", "list-simple-filter-single-select", ""]],
      viewQuery: function ListSimpleFilterSingleSelectComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$T, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selector = _t.first);
        }
      },
      inputs: {
        filterData: "filterData"
      },
      outputs: {
        changes: "changes"
      },
      standalone: false,
      attrs: _c1$K,
      decls: 6,
      vars: 8,
      consts: [["selector", ""], [1, "btn-group"], [1, "btn", "btn_minimal", "filter-dropdown-btn"], [1, "filter-btn-single-select", 3, "ngModelChange", "change", "ngModel", "ngStyle"], ["selected", "", "disabled", "", 3, "ngValue", 4, "ngIf"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["selected", "", "disabled", "", 3, "ngValue"], [3, "ngValue"]],
      template: function ListSimpleFilterSingleSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1)(1, "span", 2)(2, "select", 3, 0);
          i0.ɵɵtwoWayListener("ngModelChange", function ListSimpleFilterSingleSelectComponent_Template_select_ngModelChange_2_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.filter.value, $event) || (ctx.filter.value = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵlistener("change", function ListSimpleFilterSingleSelectComponent_Template_select_change_2_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.filterSubmit($event));
          });
          i0.ɵɵtemplate(4, ListSimpleFilterSingleSelectComponent_option_4_Template, 2, 2, "option", 4)(5, ListSimpleFilterSingleSelectComponent_option_5_Template, 2, 2, "option", 5);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtwoWayProperty("ngModel", ctx.filter.value);
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(6, _c2$B, ctx.width));
          i0.ɵɵattribute("id", "single-select-filter-" + ctx.filter.id)("aria-label", ctx.filter.title);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.filter.title);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.filter.options);
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i1.NgStyle, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgModel],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListSimpleFilterSingleSelectComponent, [{
    type: Component,
    args: [{
      selector: '[list-simple-filter-single-select]',
      standalone: false,
      template: "<div class=\"btn-group\">\n    <span class=\"btn btn_minimal filter-dropdown-btn\">\n        <select #selector [attr.id]=\"'single-select-filter-' + filter.id\" [(ngModel)]=\"filter.value\" (change)=\"filterSubmit($event)\" class=\"filter-btn-single-select\" [ngStyle]=\"{'width': width}\" [attr.aria-label]=\"filter.title\">\n            <option *ngIf=\"filter.title\" [ngValue]=\"undefined\" selected disabled>{{filter.title}}</option>\n            <option *ngFor=\"let option of filter.options\" [ngValue]=\"option.value\">{{option.label}}</option>\n        </select>\n    </span>\n</div>"
    }]
  }], null, {
    filterData: [{
      type: Input
    }],
    changes: [{
      type: Output
    }],
    selector: [{
      type: ViewChild,
      args: ['selector']
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ListSimpleFilterSingleSelectComponent, {
    className: "ListSimpleFilterSingleSelectComponent",
    filePath: "valkyrie/list-filters/list-simple-filter-single-select.component.ts",
    lineNumber: 12
  });
})();
const _c0$S = ["list-simple-filter-multiple-select", ""];
const _c1$J = () => ({
  standalone: true
});
function ListSimpleFilterMultipleSelectComponent_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(", ctx_r1.filterData.activeFilters, ")");
  }
}
function ListSimpleFilterMultipleSelectComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "input", 18);
    i0.ɵɵtwoWayListener("ngModelChange", function ListSimpleFilterMultipleSelectComponent_div_10_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.searchQuery, $event) || (ctx_r1.searchQuery = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.searchQuery);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(3, _c1$J));
    i0.ɵɵattribute("role", "search");
  }
}
function ListSimpleFilterMultipleSelectComponent_li_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 19)(1, "input", 20);
    i0.ɵɵtwoWayListener("ngModelChange", function ListSimpleFilterMultipleSelectComponent_li_13_Template_input_ngModelChange_1_listener($event) {
      const field_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      i0.ɵɵtwoWayBindingSet(field_r5.value, $event) || (field_r5.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 21, 1);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r5 = ctx.$implicit;
    const idx_r6 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.filter.id, "-checkbox-", idx_r6, "");
    i0.ɵɵtwoWayProperty("ngModel", field_r5.value);
    i0.ɵɵattribute("aria-label", ctx_r1.setAriaLabel(field_r5.label, idx_r6 + 1));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.filter.id, "-checkbox-", idx_r6, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(field_r5.label);
  }
}
function ListSimpleFilterMultipleSelectComponent_button_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function ListSimpleFilterMultipleSelectComponent_button_16_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clear());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "misc.Clear"));
  }
}
class ListSimpleFilterMultipleSelectComponent {
  get filter() {
    return this.filterDataImported;
  }
  constructor(translate, searchTextPipe) {
    this.translate = translate;
    this.searchTextPipe = searchTextPipe;
    this.changes = new EventEmitter();
    this.searchQuery = '';
  }
  ngOnInit() {
    this.setFilterData();
  }
  toggled(isOpen) {
    if (isOpen) {
      this.setFilterData();
    } else {
      this.filterSubmit();
    }
  }
  setFilterData() {
    this.filterDataImported = JSON.parse(JSON.stringify(this.filterData));
  }
  clear() {
    this.filter.fields.forEach(filter => {
      filter.value = false;
    });
  }
  displayClearBtn() {
    return !!this.filter.fields.find(field => field.value);
  }
  setAriaLabel(label, index) {
    let ariaLabel = label + ', ' + this.translate.instant('misc.index of total', {
      index: index,
      total: this.searchTextPipe.transform(this.filterDataImported.fields, 'label', this.searchQuery).length
    });
    return ariaLabel;
  }
  filterSubmit(dropdown = false) {
    if (JSON.stringify(this.filterData.fields) !== JSON.stringify(this.filter.fields)) {
      this.changes.emit(this.filter);
    }
    if (dropdown) {
      dropdown.close();
    }
  }
  static {
    this.ɵfac = function ListSimpleFilterMultipleSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListSimpleFilterMultipleSelectComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(SearchTextPipe$1));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ListSimpleFilterMultipleSelectComponent,
      selectors: [["", "list-simple-filter-multiple-select", ""]],
      inputs: {
        filterData: "filterData"
      },
      outputs: {
        changes: "changes"
      },
      standalone: false,
      attrs: _c0$S,
      decls: 20,
      vars: 15,
      consts: [["dropdown", "ngbDropdown"], ["fieldLabel", ""], ["ngbDropdown", "", 1, "btn-group", "customSelect", 3, "openChange"], ["ngbDropdownToggle", "", 1, "btn", "btn_minimal", "filter-dropdown-btn", "more-filter-dropdown-btn", 3, "id"], [1, "filter-text"], [4, "ngIf"], [1, "icn-chevron_down"], ["ngbDropdownMenu", ""], [1, "field", "last"], [1, "field-widget"], ["class", "search-block border-bottom ng-scope", 4, "ngIf"], ["tabindex", "-1", 1, "filter-sub-menu"], [1, "list-unstyled", "multi-select-list"], ["class", "filter-sub-option", 4, "ngFor", "ngForOf"], [1, "filter-btns", "border-top"], ["class", "btn_text-link secondary-text", 3, "click", 4, "ngIf"], ["type", "submit", 1, "btn", "btn_primary", "no-margin", "pull-right", 3, "click"], [1, "search-block", "border-bottom", "ng-scope"], ["type", "search", "aria-label", "Filter list search", "aria-invalid", "false", 1, "input-text", "input-search", "btn-block", "ng-pristine", "ng-valid", "ng-empty", "ng-touched", 3, "ngModelChange", "ngModel", "ngModelOptions"], [1, "filter-sub-option"], ["type", "checkbox", 3, "ngModelChange", "id", "ngModel"], [3, "for"], [1, "btn_text-link", "secondary-text", 3, "click"]],
      template: function ListSimpleFilterMultipleSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 2, 0);
          i0.ɵɵlistener("openChange", function ListSimpleFilterMultipleSelectComponent_Template_div_openChange_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggled($event));
          });
          i0.ɵɵelementStart(2, "button", 3)(3, "span", 4);
          i0.ɵɵtext(4);
          i0.ɵɵtemplate(5, ListSimpleFilterMultipleSelectComponent_span_5_Template, 2, 1, "span", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(6, "i", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "div", 7)(8, "div", 8)(9, "div", 9);
          i0.ɵɵtemplate(10, ListSimpleFilterMultipleSelectComponent_div_10_Template, 2, 4, "div", 10);
          i0.ɵɵelementStart(11, "div", 11)(12, "ul", 12);
          i0.ɵɵtemplate(13, ListSimpleFilterMultipleSelectComponent_li_13_Template, 5, 9, "li", 13);
          i0.ɵɵpipe(14, "searchText");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(15, "div", 14);
          i0.ɵɵtemplate(16, ListSimpleFilterMultipleSelectComponent_button_16_Template, 3, 3, "button", 15);
          i0.ɵɵelementStart(17, "button", 16);
          i0.ɵɵlistener("click", function ListSimpleFilterMultipleSelectComponent_Template_button_click_17_listener() {
            i0.ɵɵrestoreView(_r1);
            const dropdown_r8 = i0.ɵɵreference(1);
            return i0.ɵɵresetView(ctx.filterSubmit(dropdown_r8));
          });
          i0.ɵɵtext(18);
          i0.ɵɵpipe(19, "translate");
          i0.ɵɵelementEnd()()()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("id", "listFilter-category-" + ctx.filter.id);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1("", ctx.filter.title, " ");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterData.activeFilters);
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-labelledby", "listFilter-category-" + ctx.filter.id);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.filter.searchField);
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-live", "polite");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(14, 9, ctx.filter.fields, "label", ctx.searchQuery));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.displayClearBtn());
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 13, "misc.Apply"));
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i2$1.DefaultValueAccessor, i2$1.CheckboxControlValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$4.NgbDropdown, i1$4.NgbDropdownToggle, i1$4.NgbDropdownMenu, i1$1.TranslatePipe, SearchTextPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListSimpleFilterMultipleSelectComponent, [{
    type: Component,
    args: [{
      selector: '[list-simple-filter-multiple-select]',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div ngbDropdown class=\"btn-group customSelect\" #dropdown=\"ngbDropdown\" (openChange)=\"toggled($event)\">\n    <button class=\"btn btn_minimal filter-dropdown-btn more-filter-dropdown-btn\" [id]=\"'listFilter-category-' + filter.id\" ngbDropdownToggle>\n        <span class=\"filter-text\">{{filter.title}}\n            <span *ngIf=\"filterData.activeFilters\">({{filterData.activeFilters}})</span>\n        </span>\n        <i class=\"icn-chevron_down\"></i>\n    </button>\n    <div ngbDropdownMenu [attr.aria-labelledby]=\"'listFilter-category-' + filter.id\">\n        <div class=\"field last\">\n            <div class=\"field-widget\">\n                <div *ngIf=\"filter.searchField\" class=\"search-block border-bottom ng-scope\">\n                    <input [(ngModel)]=\"searchQuery\" [ngModelOptions]=\"{standalone: true}\" class=\"input-text input-search btn-block ng-pristine ng-valid ng-empty ng-touched\" type=\"search\" aria-label=\"Filter list search\" aria-invalid=\"false\" [attr.role]=\"'search'\" >\n                </div>\n                <div class=\"filter-sub-menu\" tabindex=\"-1\">\n                    <ul class=\"list-unstyled multi-select-list\" [attr.aria-live]=\"'polite'\">\n                        <li\n                            *ngFor=\"let field of filter.fields | searchText:'label': searchQuery; index as idx\"\n                            class=\"filter-sub-option\"\n                        >\n                            <input\n                                id=\"{{filter.id}}-checkbox-{{idx}}\"\n                                type=\"checkbox\"\n                                [attr.aria-label]=\"setAriaLabel(field.label, idx + 1)\"\n                                [(ngModel)]=\"field.value\"\n                            >\n                            <label #fieldLabel for=\"{{filter.id}}-checkbox-{{idx}}\">{{field.label}}</label>\n                        </li>\n                    </ul>\n                </div>\n                <div class=\"filter-btns border-top\">\n                    <button *ngIf=\"displayClearBtn()\" class=\"btn_text-link secondary-text\" (click)=\"clear()\">{{'misc.Clear' | translate}}</button>\n                    <button type=\"submit\" class=\"btn btn_primary no-margin pull-right\" (click)=\"filterSubmit(dropdown)\">{{'misc.Apply' | translate}}</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: SearchTextPipe$1
  }], {
    filterData: [{
      type: Input
    }],
    changes: [{
      type: Output
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ListSimpleFilterMultipleSelectComponent, {
    className: "ListSimpleFilterMultipleSelectComponent",
    filePath: "valkyrie/list-filters/list-simple-filter-multiple-select.component.ts",
    lineNumber: 12
  });
})();
const _c0$R = a0 => ({
  "active": a0
});
const _c1$I = a0 => ({
  chipText: a0
});
function ListFilterChipsComponent_div_0_span_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 5)(1, "span", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 7);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("click", function ListFilterChipsComponent_div_0_span_2_Template_button_click_3_listener() {
      const selectedFilter_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.clearSelectedFilter(selectedFilter_r3));
    })("mouseover", function ListFilterChipsComponent_div_0_span_2_Template_button_mouseover_3_listener() {
      const idx_r5 = i0.ɵɵrestoreView(_r2).index;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.hoverBtnIdx = idx_r5);
    })("mouseout", function ListFilterChipsComponent_div_0_span_2_Template_button_mouseout_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.hoverBtnIdx = undefined);
    });
    i0.ɵɵelement(5, "i", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedFilter_r3 = ctx.$implicit;
    const idx_r5 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("chip search-form-filters-chip ", ctx_r3.chipClass, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$R, ctx_r3.hoverBtnIdx === idx_r5));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(selectedFilter_r3.label);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(4, 6, ctx_r3.removeChipLabel, i0.ɵɵpureFunction1(11, _c1$I, selectedFilter_r3.label)));
  }
}
function ListFilterChipsComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "span", 2);
    i0.ɵɵtemplate(2, ListFilterChipsComponent_div_0_span_2_Template, 6, 13, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 4);
    i0.ɵɵlistener("click", function ListFilterChipsComponent_div_0_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.clearAllSelectedFilters());
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.selectedFilters);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 2, "misc.Clear All"));
  }
}
class ListFilterChipsComponent {
  constructor() {
    this.selectedFilters = [];
    this.chipClass = '';
    this.removeChipLabel = 'misc.Remove Filter Chip';
    this.clear = new EventEmitter();
  }
  get selectedFilterList() {
    return this.selectedFilters;
  }
  clearSelectedFilter(selectedFilter) {
    this.clear.emit(selectedFilter);
    this.hoverBtnIdx = undefined;
  }
  clearAllSelectedFilters() {
    this.clear.emit();
  }
  static {
    this.ɵfac = function ListFilterChipsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListFilterChipsComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ListFilterChipsComponent,
      selectors: [["list-filter-chips"]],
      inputs: {
        selectedFilters: "selectedFilters",
        chipClass: "chipClass",
        removeChipLabel: "removeChipLabel"
      },
      outputs: {
        clear: "clear"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["class", "filter-applied-container body-small space-top-lg space-left-lg space-right-lg", 4, "ngIf"], [1, "filter-applied-container", "body-small", "space-top-lg", "space-left-lg", "space-right-lg"], ["role", "list", 1, "inline-block"], ["role", "listitem", 3, "class", "ngClass", 4, "ngFor", "ngForOf"], [1, "btn", "btn_text-link", "font_weight_normal", "secondary-text", "space-bottom-md", 3, "click"], ["role", "listitem", 3, "ngClass"], [1, "chip-value"], [1, "chip-btn", 3, "click", "mouseover", "mouseout"], [1, "icn-close"]],
      template: function ListFilterChipsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ListFilterChipsComponent_div_0_Template, 6, 4, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.selectedFilters.length);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListFilterChipsComponent, [{
    type: Component,
    args: [{
      selector: 'list-filter-chips',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div *ngIf=\"selectedFilters.length\" class=\"filter-applied-container body-small space-top-lg space-left-lg space-right-lg\">\n    <span role=\"list\" class=\"inline-block\">\n        <span *ngFor=\"let selectedFilter of selectedFilters; index as idx\"\n            class=\"chip search-form-filters-chip {{chipClass}}\"\n            [ngClass]=\"{'active': hoverBtnIdx === idx }\"\n            role=\"listitem\"\n        >\n            <span class=\"chip-value\">{{selectedFilter.label}}</span>\n            <button\n                class=\"chip-btn\"\n                (click)=\"clearSelectedFilter(selectedFilter)\"\n                (mouseover)=\"hoverBtnIdx = idx\"\n                (mouseout)=\"hoverBtnIdx = undefined\"\n                [attr.aria-label]=\"removeChipLabel | translate : { chipText: selectedFilter.label }\"\n            >\n                <i class=\"icn-close\"></i>\n            </button>\n        </span>\n    </span>\n    <button\n        class=\"btn btn_text-link font_weight_normal secondary-text space-bottom-md\"\n        (click)=\"clearAllSelectedFilters()\"\n    >{{'misc.Clear All' | translate}}</button>\n</div>\n"
    }]
  }], null, {
    selectedFilters: [{
      type: Input
    }],
    chipClass: [{
      type: Input
    }],
    removeChipLabel: [{
      type: Input
    }],
    clear: [{
      type: Output
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ListFilterChipsComponent, {
    className: "ListFilterChipsComponent",
    filePath: "valkyrie/list-filters/list-filter-chips.component.ts",
    lineNumber: 10
  });
})();
const _c0$Q = ["searchField"];
const _c1$H = [[["", "custom", ""]]];
const _c2$A = ["[custom]"];
const _c3$p = () => ({
  standalone: true
});
function ListSimpleFilterComponent_ng_container_18_ng_container_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵlistener("changes", function ListSimpleFilterComponent_ng_container_18_ng_container_3_div_1_Template_div_changes_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.singleSelectFilterChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filter_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("filterData", filter_r4);
  }
}
function ListSimpleFilterComponent_ng_container_18_ng_container_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("changes", function ListSimpleFilterComponent_ng_container_18_ng_container_3_div_2_Template_div_changes_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.multipleSelectFilterChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filter_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("filterData", filter_r4);
  }
}
function ListSimpleFilterComponent_ng_container_18_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListSimpleFilterComponent_ng_container_18_ng_container_3_div_1_Template, 1, 1, "div", 16)(2, ListSimpleFilterComponent_ng_container_18_ng_container_3_div_2_Template, 1, 1, "div", 17);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const filter_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", filter_r4.type == "singleSelect");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", filter_r4.type == "multipleSelect");
  }
}
function ListSimpleFilterComponent_ng_container_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 13)(2, "div", 14);
    i0.ɵɵtemplate(3, ListSimpleFilterComponent_ng_container_18_ng_container_3_Template, 3, 2, "ng-container", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2._filterGroup.filters);
  }
}
function ListSimpleFilterComponent_ng_container_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵprojection(1);
    i0.ɵɵelementContainerEnd();
  }
}
function ListSimpleFilterComponent_ng_container_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "list-filter-chips", 20);
    i0.ɵɵlistener("clear", function ListSimpleFilterComponent_ng_container_20_Template_list_filter_chips_clear_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clearFilter($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("selectedFilters", ctx_r2.selectedFilters);
  }
}
class ListSimpleFilterComponent {
  constructor(modalService) {
    this.modalService = modalService;
    this._filterGroup = new SimpleFilterModel();
    this.lastSearchedQuery = '';
    this.searchQuery = '';
    this.placeholder = '';
    this.customFilter = false;
    this.mobileFilter = new EventEmitter();
  }
  get searchText() {
    return this.lastSearchedQuery;
  }
  set searchText(value) {
    this.searchQuery = value;
    this.lastSearchedQuery = value;
    this.updateSelectedFilters();
  }
  get filters() {
    return this._filterGroup;
  }
  set filters(value) {
    if (value !== undefined) {
      this._filterGroup = value;
      this.bindFilterChange();
    }
    if (this._filterGroup && this._filterGroup.filters) {
      this.updateSearchedText();
      this.PreventFilterIdMissing();
      this.updateSelectedFilters();
    }
  }
  get isFilterExist() {
    return this._filterGroup && this._filterGroup.filters ? this._filterGroup.filters.length > 1 : false;
  }
  get selectedFilters() {
    return this.selectedFilterList;
  }
  updateSearchedText() {
    let idx = this._filterGroup.filters.findIndex(d => d.id == 'text-search');
    let item = this.generateFilterItem('text-search', this.lastSearchedQuery, this.lastSearchedQuery, 'text-search');
    if (idx > -1) {
      this._filterGroup.filters[idx] = item;
    } else {
      this._filterGroup.filters.unshift(item);
    }
  }
  PreventFilterIdMissing() {
    this._filterGroup.filters.filter(f => !f.id).forEach((filter, idx) => {
      for (let i = idx; i < 100; i++) {
        let id = 'list-filter-' + i;
        if (!this._filterGroup.filters.filter(f => f.id == id).length) {
          filter['id'] = id;
          break;
        }
      }
    });
  }
  enterKeySubmit(e) {
    if (e.key === "Enter") {
      this.submitSearch(e.currentTarget.value);
    }
  }
  submitSearch(value) {
    this.searchText = value;
    this._filterGroup.submitFn();
  }
  clearSearch() {
    this.searchQuery = '';
    this.submitSearch(this.searchQuery);
    this.searchField.nativeElement.focus();
  }
  bindFilterChange() {
    this._filterGroup.filters.forEach(filter => {
      switch (filter.type) {
        case 'singleSelect':
          filter.onChange = this.singleSelectFilterChange.bind(this);
          break;
        case 'multipleSelect':
          filter.onChange = this.multipleSelectFilterChange.bind(this);
          break;
      }
    });
  }
  singleSelectFilterChange(e) {
    this.updateSelectedFilters(true);
  }
  multipleSelectFilterChange(changes) {
    let matchFilterIndex = this._filterGroup.filters.map(filter => filter.id == changes.id).indexOf(true);
    this.filters.filters.splice(matchFilterIndex, 1, changes);
    this.updateSelectedFilters(true);
  }
  allFilterChange(data) {
    this._filterGroup.filters = data;
    this.updateSelectedFilters(true);
  }
  openFilterModalWindow() {
    if (this.customFilter) {
      this.mobileFilter.emit();
    } else {
      const modal = this.modalService.open(ListFilterModalComponent, {
        windowClass: 'ngb-modal',
        size: 'lg',
        backdrop: 'static'
      });
      modal.componentInstance.filterData = this._filterGroup.filters.filter(f => f.type !== 'text-search');
      $('body').addClass('ngb-modal-stack-open');
      modal.result.then(res => {
        $('body').removeClass('ngb-modal-stack-open');
        if (res) {
          this.allFilterChange(res);
        }
      });
    }
  }
  generateFilterItem(id, label, value, type, optionIdx = undefined) {
    let val = new SelectedFilter({
      id: id,
      label: label,
      value: value,
      type: type
    });
    if (optionIdx !== undefined || optionIdx !== null || optionIdx > -1) {
      val['optionIndex'] = optionIdx;
    }
    return val;
  }
  updateSelectedFilters(submit = false) {
    let selectedFilterSet = [];
    this.updateSearchedText();
    this._filterGroup.filters.forEach(filter => {
      let value;
      switch (filter.type) {
        case 'text-search':
          if (filter.value) {
            selectedFilterSet.push(filter);
          }
          break;
        case 'singleSelect':
          if (filter.value) {
            value = this.generateFilterItem(filter.id, filter.options.find(opt => opt.value === filter.value).label, filter.value, filter.type);
            selectedFilterSet.push(value);
          }
          break;
        case 'multipleSelect':
          let fields = filter.fields.filter(d => d.value);
          fields.forEach(field => {
            let idx = filter.fields.indexOf(field);
            value = this.generateFilterItem(filter.id, field.label, field.value, filter.type, idx);
            selectedFilterSet.push(value);
          });
          break;
      }
    });
    this.selectedFilterList = selectedFilterSet;
    if (submit) {
      this.filters.submitFn();
    }
  }
  clearSelectedFilter(selectedFilter, clearAll = false) {
    let item = this._filterGroup.filters.find(f => f.id === selectedFilter.id);
    switch (selectedFilter.type) {
      case 'text-search':
        this.searchText = '';
        break;
      case 'singleSelect':
        item.value = undefined;
        break;
      case 'multipleSelect':
        item.fields[selectedFilter.optionIndex].value = false;
        break;
    }
    if (!clearAll) {
      this.updateSelectedFilters(true);
    }
  }
  clearFilter(selectedFilter) {
    if (!selectedFilter) {
      this.selectedFilters.forEach(filter => {
        this.clearSelectedFilter(filter, true);
      });
      this.updateSelectedFilters(true);
    } else {
      this.clearSelectedFilter(selectedFilter);
    }
  }
  static {
    this.ɵfac = function ListSimpleFilterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListSimpleFilterComponent)(i0.ɵɵdirectiveInject(i1$4.NgbModal));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ListSimpleFilterComponent,
      selectors: [["list-simple-filter"]],
      viewQuery: function ListSimpleFilterComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$Q, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchField = _t.first);
        }
      },
      inputs: {
        placeholder: "placeholder",
        customFilter: "customFilter",
        searchText: "searchText",
        filters: "filters"
      },
      outputs: {
        mobileFilter: "mobileFilter"
      },
      standalone: false,
      ngContentSelectors: _c2$A,
      decls: 21,
      vars: 23,
      consts: [["searchField", ""], ["role", "search", 1, "search-form-filters", "form", "form-editmode", "flexbox", "flex-column"], [1, "filter-fields"], [1, "field", "last"], [1, "field-widget", "search-filter"], [1, "input-wrapper", "input-wrapper-sticky"], ["type", "search", 1, "input-text", 3, "ngModelChange", "keydown", "ngModel", "ngModelOptions"], [1, "clearBtn", 3, "click", "hidden"], [1, "icn-close", "ui-select-clear-btn"], ["type", "submit", 1, "btn", "btn_default", "btn-sticky", 3, "click"], [1, "btn", "btn_default", "hide", "display-mobile-inline-block", "display-sm-inline-block", 3, "click"], [1, "icn-custom_setting", "no-margin", "lg-text"], [4, "ngIf"], [1, "filter-list", "display-mobile-none", "display-sm-none"], [1, "flexbox"], [4, "ngFor", "ngForOf"], ["list-simple-filter-single-select", "", "class", "inline-block", 3, "filterData", "changes", 4, "ngIf"], ["list-simple-filter-multiple-select", "", "class", "inline-block", 3, "filterData", "changes", 4, "ngIf"], ["list-simple-filter-single-select", "", 1, "inline-block", 3, "changes", "filterData"], ["list-simple-filter-multiple-select", "", 1, "inline-block", 3, "changes", "filterData"], [1, "border-top", 3, "clear", "selectedFilters"]],
      template: function ListSimpleFilterComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef(_c1$H);
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "div", 4)(4, "span", 5)(5, "input", 6, 0);
          i0.ɵɵpipe(7, "translate");
          i0.ɵɵpipe(8, "translate");
          i0.ɵɵtwoWayListener("ngModelChange", function ListSimpleFilterComponent_Template_input_ngModelChange_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.searchQuery, $event) || (ctx.searchQuery = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵlistener("keydown", function ListSimpleFilterComponent_Template_input_keydown_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.enterKeySubmit($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "button", 7);
          i0.ɵɵpipe(10, "translate");
          i0.ɵɵlistener("click", function ListSimpleFilterComponent_Template_button_click_9_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.clearSearch());
          });
          i0.ɵɵelement(11, "i", 8);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(12, "button", 9);
          i0.ɵɵlistener("click", function ListSimpleFilterComponent_Template_button_click_12_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.submitSearch(ctx.searchQuery));
          });
          i0.ɵɵtext(13);
          i0.ɵɵpipe(14, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(15, "button", 10);
          i0.ɵɵpipe(16, "translate");
          i0.ɵɵlistener("click", function ListSimpleFilterComponent_Template_button_click_15_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.openFilterModalWindow());
          });
          i0.ɵɵelement(17, "i", 11);
          i0.ɵɵelementEnd()()()()();
          i0.ɵɵtemplate(18, ListSimpleFilterComponent_ng_container_18_Template, 4, 1, "ng-container", 12)(19, ListSimpleFilterComponent_ng_container_19_Template, 2, 0, "ng-container", 12)(20, ListSimpleFilterComponent_ng_container_20_Template, 2, 1, "ng-container", 12);
        }
        if (rf & 2) {
          i0.ɵɵadvance(5);
          i0.ɵɵtwoWayProperty("ngModel", ctx.searchQuery);
          i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(22, _c3$p));
          i0.ɵɵattribute("placeholder", i0.ɵɵpipeBind1(7, 12, ctx.placeholder))("aria-label", i0.ɵɵpipeBind1(8, 14, ctx.placeholder));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("hidden", !ctx.searchQuery || !ctx.searchQuery.length);
          i0.ɵɵattribute("aria-hidden", !ctx.searchQuery || !ctx.searchQuery.length)("aria-label", i0.ɵɵpipeBind1(10, 16, "misc.Clear"));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 18, "misc.Search"));
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(16, 20, "misc.More Filters"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", !ctx.customFilter && ctx.isFilterExist);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.customFilter);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.customFilter);
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, ListSimpleFilterSingleSelectComponent, ListSimpleFilterMultipleSelectComponent, ListFilterChipsComponent, i1$1.TranslatePipe],
      styles: [".dropdown-toggle:after{display:none}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListSimpleFilterComponent, [{
    type: Component,
    args: [{
      selector: 'list-simple-filter',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"search-form-filters form form-editmode flexbox flex-column\" role=\"search\">\n    <div class=\"filter-fields\">\n        <div class=\"field last\">\n            <div class=\"field-widget search-filter\">\n                <span class=\"input-wrapper input-wrapper-sticky\">\n                    <input #searchField type=\"search\" [(ngModel)]=\"searchQuery\" [ngModelOptions]=\"{standalone: true}\" class=\"input-text\" (keydown)=\"enterKeySubmit($event)\" [attr.placeholder]=\"placeholder | translate\" [attr.aria-label]=\"placeholder | translate\">\n                    <button class=\"clearBtn\" [hidden]=\"!searchQuery || !searchQuery.length\" (click)=\"clearSearch()\" [attr.aria-hidden]=\"!searchQuery || !searchQuery.length\" [attr.aria-label]=\"'misc.Clear' | translate\">\n                        <i class=\"icn-close ui-select-clear-btn\"></i>\n                    </button>\n                </span>\n                <button type=\"submit\" class=\"btn btn_default btn-sticky\" (click)=\"submitSearch(searchQuery)\">{{'misc.Search' | translate}}</button>\n                <button class=\"btn btn_default hide display-mobile-inline-block display-sm-inline-block\" (click)=\"openFilterModalWindow()\" [attr.aria-label]=\"'misc.More Filters' | translate\">\n                    <i class=\"icn-custom_setting no-margin lg-text\"></i>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<ng-container *ngIf=\"!customFilter && isFilterExist\">\n    <div class=\"filter-list display-mobile-none display-sm-none\">\n        <div class=\"flexbox\">\n            <ng-container *ngFor=\"let filter of _filterGroup.filters\">\n                <div list-simple-filter-single-select *ngIf=\"filter.type == 'singleSelect'\" [filterData]=\"filter\" (changes)=\"singleSelectFilterChange($event)\" class=\"inline-block\"></div>\n                <div list-simple-filter-multiple-select *ngIf=\"filter.type == 'multipleSelect'\" [filterData]=\"filter\" (changes)=\"multipleSelectFilterChange($event)\" class=\"inline-block\"></div>\n            </ng-container>\n        </div>\n    </div>\n</ng-container>\n\n<ng-container *ngIf=\"customFilter\">\n    <ng-content select=\"[custom]\"></ng-content>\n</ng-container>\n\n<ng-container *ngIf=\"!customFilter\">\n    <list-filter-chips class=\"border-top\" [selectedFilters]=\"selectedFilters\" (clear)=\"clearFilter($event)\"></list-filter-chips>\n</ng-container>",
      styles: [".dropdown-toggle:after{display:none}\n"]
    }]
  }], () => [{
    type: i1$4.NgbModal
  }], {
    placeholder: [{
      type: Input
    }],
    customFilter: [{
      type: Input
    }],
    mobileFilter: [{
      type: Output
    }],
    searchField: [{
      type: ViewChild,
      args: ['searchField', {
        static: true
      }]
    }],
    searchText: [{
      type: Input
    }],
    filters: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ListSimpleFilterComponent, {
    className: "ListSimpleFilterComponent",
    filePath: "valkyrie/list-filters/list-simple-filter.component.ts",
    lineNumber: 14
  });
})();
const _c0$P = a0 => ({
  controls: a0
});
const _c1$G = a0 => ({
  control: a0
});
function DynamicFormMobileFilterComponent_ng_container_2_ng_container_1_ng_template_1_Template(rf, ctx) {}
function DynamicFormMobileFilterComponent_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormMobileFilterComponent_ng_container_2_ng_container_1_ng_template_1_Template, 0, 0, "ng-template", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const filterGroup_r3 = i0.ɵɵreference(14);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", filterGroup_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$P, ctx_r1.controls));
  }
}
function DynamicFormMobileFilterComponent_ng_container_2_ng_container_2_ng_container_1_ng_template_1_Template(rf, ctx) {}
function DynamicFormMobileFilterComponent_ng_container_2_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormMobileFilterComponent_ng_container_2_ng_container_2_ng_container_1_ng_template_1_Template, 0, 0, "ng-template", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const section_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext(2);
    const filterItem_r5 = i0.ɵɵreference(16);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", filterItem_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1$G, section_r4.control));
  }
}
function DynamicFormMobileFilterComponent_ng_container_2_ng_container_2_ng_container_2_ng_template_5_Template(rf, ctx) {}
function DynamicFormMobileFilterComponent_ng_container_2_ng_container_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 12)(2, "h3");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 13);
    i0.ɵɵtemplate(5, DynamicFormMobileFilterComponent_ng_container_2_ng_container_2_ng_container_2_ng_template_5_Template, 0, 0, "ng-template", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const section_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext(2);
    const filterGroup_r3 = i0.ɵɵreference(14);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", section_r4.styleClass);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(section_r4.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", filterGroup_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c0$P, section_r4.control));
  }
}
function DynamicFormMobileFilterComponent_ng_container_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormMobileFilterComponent_ng_container_2_ng_container_2_ng_container_1_Template, 2, 4, "ng-container", 5)(2, DynamicFormMobileFilterComponent_ng_container_2_ng_container_2_ng_container_2_Template, 6, 6, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const section_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !section_r4.isGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", section_r4.isGroup);
  }
}
function DynamicFormMobileFilterComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormMobileFilterComponent_ng_container_2_ng_container_1_Template, 2, 4, "ng-container", 5)(2, DynamicFormMobileFilterComponent_ng_container_2_ng_container_2_Template, 3, 2, "ng-container", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.controls && ctx_r1.controls.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.groupFilters);
  }
}
function DynamicFormMobileFilterComponent_ng_template_13_ng_container_0_ng_template_1_Template(rf, ctx) {}
function DynamicFormMobileFilterComponent_ng_template_13_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormMobileFilterComponent_ng_template_13_ng_container_0_ng_template_1_Template, 0, 0, "ng-template", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const control_r6 = ctx.$implicit;
    i0.ɵɵnextContext(2);
    const filterItem_r5 = i0.ɵɵreference(16);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", filterItem_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1$G, control_r6));
  }
}
function DynamicFormMobileFilterComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicFormMobileFilterComponent_ng_template_13_ng_container_0_Template, 2, 4, "ng-container", 10);
  }
  if (rf & 2) {
    const controls_r7 = ctx.controls;
    i0.ɵɵproperty("ngForOf", controls_r7);
  }
}
function DynamicFormMobileFilterComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14, 2);
    i0.ɵɵelement(2, "div", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const control_r8 = ctx.control;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.getStyleClass(control_r8));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("group", ctx_r1.formGroup)("config", control_r8)("value", control_r8.value);
  }
}
class DynamicFormMobileFilterComponent {
  constructor(activeModal, modalService, elementRef) {
    this.activeModal = activeModal;
    this.modalService = modalService;
    this.elementRef = elementRef;
    this.title = '';
    this.groupFilters = [];
    this.styleClass = '';
  }
  isFormConfigLoaded() {
    return this.controls && this.controls.length > 0 || this.groupFilters && this.groupFilters.length;
  }
  clearFilters() {
    const resetValuesObj = {};
    if (this.controls && this.controls.length) {
      this.controls.map(control => {
        resetValuesObj[control.name] = this.getClearValue(control);
      });
    }
    if (this.groupFilters && this.groupFilters.length) {
      this.groupFilters.forEach(group => {
        if (_.isArray(group.control)) {
          group.control.forEach(control => {
            resetValuesObj[control.name] = this.getClearValue(control);
          });
        } else {
          resetValuesObj[group.control.name] = this.getClearValue(group.control);
        }
      });
    }
    this.formGroup.reset(resetValuesObj);
    this.elementRef.nativeElement.querySelectorAll('input[type=checkbox]:checked').forEach(e => {
      e.checked = false;
    });
  }
  getClearValue(control) {
    if (control.defaultValue) {
      return control.defaultValue;
    }
    if (control.type == 'rangeDatePicker') {
      return ['', ''];
    }
    if (control.type == 'numberComparison') {
      return {
        "operator": "",
        "number": ""
      };
    }
    if (control.multiple) {
      return [];
    }
    return null;
  }
  cancelFilterChanges() {
    this.activeModal.close();
  }
  applyFilters() {
    this.activeModal.close(this.formGroup.value);
  }
  getStyleClass(control) {
    let style = '';
    if (control.type === 'checkbox' && control.options.length > 5) {
      style += ' overflow-widget';
    }
    return style;
  }
  static {
    this.ɵfac = function DynamicFormMobileFilterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DynamicFormMobileFilterComponent)(i0.ɵɵdirectiveInject(i1$4.NgbActiveModal), i0.ɵɵdirectiveInject(i1$4.NgbModal), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: DynamicFormMobileFilterComponent,
      selectors: [["dynamic-form-mobile-filter"]],
      inputs: {
        title: "title",
        controls: "controls",
        groupFilters: "groupFilters",
        formGroup: "formGroup",
        styleClass: "styleClass"
      },
      standalone: false,
      decls: 17,
      vars: 13,
      consts: [["filterGroup", ""], ["filterItem", ""], ["filterGrid", ""], [3, "dismiss", "title"], ["content", ""], [4, "ngIf"], ["footer", ""], ["type", "button", 1, "btn", "btn-default", 3, "click"], ["type", "button", 1, "btn", "btn-default", "ml-2", 3, "click"], ["type", "button", 1, "btn", "btn_primary", "ml-2", 3, "click"], [4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "section", "group-fields", "list-border", 3, "ngClass"], [1, "fields-wrapper"], [1, "filter-grid", 3, "ngClass"], ["dynamicField", "", 3, "group", "config", "value"]],
      template: function DynamicFormMobileFilterComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "modal-window-layout", 3);
          i0.ɵɵlistener("dismiss", function DynamicFormMobileFilterComponent_Template_modal_window_layout_dismiss_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.cancelFilterChanges());
          });
          i0.ɵɵelementContainerStart(1, 4);
          i0.ɵɵtemplate(2, DynamicFormMobileFilterComponent_ng_container_2_Template, 3, 2, "ng-container", 5);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementContainerStart(3, 6);
          i0.ɵɵelementStart(4, "button", 7);
          i0.ɵɵlistener("click", function DynamicFormMobileFilterComponent_Template_button_click_4_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.clearFilters());
          });
          i0.ɵɵtext(5);
          i0.ɵɵpipe(6, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "button", 8);
          i0.ɵɵlistener("click", function DynamicFormMobileFilterComponent_Template_button_click_7_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.cancelFilterChanges());
          });
          i0.ɵɵtext(8);
          i0.ɵɵpipe(9, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "button", 9);
          i0.ɵɵlistener("click", function DynamicFormMobileFilterComponent_Template_button_click_10_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.applyFilters());
          });
          i0.ɵɵtext(11);
          i0.ɵɵpipe(12, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(13, DynamicFormMobileFilterComponent_ng_template_13_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(15, DynamicFormMobileFilterComponent_ng_template_15_Template, 3, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styleClass);
          i0.ɵɵproperty("title", ctx.title);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.isFormConfigLoaded());
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 7, "misc.Clear"));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 9, "misc.Cancel"));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 11, "misc.Apply"));
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, DynamicFieldDirective, ModalWindowLayoutComponent, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormMobileFilterComponent, [{
    type: Component,
    args: [{
      selector: 'dynamic-form-mobile-filter',
      standalone: false,
      template: "<modal-window-layout [title]=\"title\" [class]=\"styleClass\" (dismiss)=\"cancelFilterChanges()\">\n    <ng-container content>\n        <ng-container *ngIf=\"isFormConfigLoaded()\">\n\n            <ng-container *ngIf=\"controls && controls.length\">\n                <ng-template [ngTemplateOutlet]=\"filterGroup\" [ngTemplateOutletContext]=\"{ controls: controls }\"></ng-template>\n            </ng-container>\n\n            <ng-container *ngFor=\"let section of groupFilters\">\n                <ng-container *ngIf=\"!section.isGroup\">\n                    <ng-template [ngTemplateOutlet]=\"filterItem\" [ngTemplateOutletContext]=\"{ control: section.control }\"></ng-template>\n                </ng-container>\n                <ng-container *ngIf=\"section.isGroup\">\n                    <div class=\"section group-fields list-border\" [ngClass]=\"section.styleClass\">\n                        <h3>{{section.label}}</h3>\n                        <div class=\"fields-wrapper\">\n                            <ng-template [ngTemplateOutlet]=\"filterGroup\" [ngTemplateOutletContext]=\"{ controls: section.control }\"></ng-template>\n                        </div>\n                    </div>\n                </ng-container>\n            </ng-container>\n\n        </ng-container>\n    </ng-container>\n    <ng-container footer>\n        <button class=\"btn btn-default\" type=\"button\" (click)=\"clearFilters()\">{{ 'misc.Clear' | translate }}</button>\n        <button class=\"btn btn-default ml-2\" type=\"button\" (click)=\"cancelFilterChanges()\">{{ 'misc.Cancel' | translate }}</button>\n        <button class=\"btn btn_primary ml-2\" type=\"button\" (click)=\"applyFilters()\">{{ 'misc.Apply' | translate }}</button>\n    </ng-container>\n</modal-window-layout>\n\n<ng-template #filterGroup let-controls=\"controls\">\n    <ng-container *ngFor=\"let control of controls; odd as isOdd\">\n        <ng-template [ngTemplateOutlet]=\"filterItem\" [ngTemplateOutletContext]=\"{ control: control }\"></ng-template>\n    </ng-container>\n</ng-template>\n\n<ng-template #filterItem let-control=\"control\">\n    <div #filterGrid class=\"filter-grid\" [ngClass]=\"getStyleClass(control)\">\n        <div\n            dynamicField\n            [group]=\"formGroup\"\n            [config]=\"control\"\n            [value]=\"control.value\"\n        ></div>\n    </div>\n</ng-template>"
    }]
  }], () => [{
    type: i1$4.NgbActiveModal
  }, {
    type: i1$4.NgbModal
  }, {
    type: i0.ElementRef
  }], {
    title: [{
      type: Input
    }],
    controls: [{
      type: Input
    }],
    groupFilters: [{
      type: Input
    }],
    formGroup: [{
      type: Input
    }],
    styleClass: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicFormMobileFilterComponent, {
    className: "DynamicFormMobileFilterComponent",
    filePath: "valkyrie/list-filters/dynamic-form-mobile-filter.component.ts",
    lineNumber: 12
  });
})();
const _c0$O = ["*"];
const _c1$F = a0 => ({
  "list-reloading": a0
});
const _c2$z = (a0, a1) => ({
  item: a0,
  idx: a1
});
const _c3$o = (a0, a1, a2) => ({
  item: a0,
  idx: a1,
  rowAnchor: a2
});
const _c4$m = a0 => ({
  "cursor-pointer": a0
});
function ListPageComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1, "misc.Loading");
    i0.ɵɵelementEnd();
  }
}
function ListPageComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isReload", ctx_r0.reloading);
  }
}
function ListPageComponent_div_3_ng_container_1_2_ng_template_0_Template(rf, ctx) {}
function ListPageComponent_div_3_ng_container_1_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageComponent_div_3_ng_container_1_2_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const item_r3 = ctx_r1.$implicit;
    const idx_r4 = ctx_r1.index;
    i0.ɵɵnextContext(2);
    const hrefItem_r5 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", hrefItem_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c2$z, item_r3, idx_r4));
  }
}
function ListPageComponent_div_3_ng_container_1_3_ng_template_0_Template(rf, ctx) {}
function ListPageComponent_div_3_ng_container_1_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageComponent_div_3_ng_container_1_3_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const item_r3 = ctx_r1.$implicit;
    const idx_r4 = ctx_r1.index;
    i0.ɵɵnextContext(2);
    const routerLinkItem_r6 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngTemplateOutlet", routerLinkItem_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c2$z, item_r3, idx_r4));
  }
}
function ListPageComponent_div_3_ng_container_1_4_ng_template_0_Template(rf, ctx) {}
function ListPageComponent_div_3_ng_container_1_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageComponent_div_3_ng_container_1_4_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const item_r3 = ctx_r1.$implicit;
    const idx_r4 = ctx_r1.index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const onClickItem_r7 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngTemplateOutlet", onClickItem_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c3$o, item_r3, idx_r4, ctx_r0.rowAnchor));
  }
}
function ListPageComponent_div_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 15);
    i0.ɵɵtemplate(2, ListPageComponent_div_3_ng_container_1_2_Template, 1, 5, null, 16)(3, ListPageComponent_div_3_ng_container_1_3_Template, 1, 5, null, 16)(4, ListPageComponent_div_3_ng_container_1_4_Template, 1, 6, null, 16);
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", ctx_r0.getAnchorType(item_r3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "href");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "routerLink");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "onClick");
  }
}
function ListPageComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, ListPageComponent_div_3_ng_container_1_Template, 5, 4, "ng-container", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("role", "list");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
  }
}
function ListPageComponent_div_4_ng_container_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(group_r8.label);
  }
}
function ListPageComponent_div_4_ng_container_1_ng_container_3_2_ng_template_0_Template(rf, ctx) {}
function ListPageComponent_div_4_ng_container_1_ng_container_3_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageComponent_div_4_ng_container_1_ng_container_3_2_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    const item_r10 = ctx_r8.$implicit;
    const idxItem_r11 = ctx_r8.index;
    const idxGroup_r12 = i0.ɵɵnextContext().index;
    i0.ɵɵnextContext(2);
    const hrefItem_r5 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", hrefItem_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c2$z, item_r10, idxGroup_r12 + "-" + idxItem_r11));
  }
}
function ListPageComponent_div_4_ng_container_1_ng_container_3_3_ng_template_0_Template(rf, ctx) {}
function ListPageComponent_div_4_ng_container_1_ng_container_3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageComponent_div_4_ng_container_1_ng_container_3_3_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    const item_r10 = ctx_r8.$implicit;
    const idxItem_r11 = ctx_r8.index;
    const idxGroup_r12 = i0.ɵɵnextContext().index;
    i0.ɵɵnextContext(2);
    const routerLinkItem_r6 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngTemplateOutlet", routerLinkItem_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c2$z, item_r10, idxGroup_r12 + "-" + idxItem_r11));
  }
}
function ListPageComponent_div_4_ng_container_1_ng_container_3_4_ng_template_0_Template(rf, ctx) {}
function ListPageComponent_div_4_ng_container_1_ng_container_3_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageComponent_div_4_ng_container_1_ng_container_3_4_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    const item_r10 = ctx_r8.$implicit;
    const idxItem_r11 = ctx_r8.index;
    const idxGroup_r12 = i0.ɵɵnextContext().index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const onClickItem_r7 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngTemplateOutlet", onClickItem_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c3$o, item_r10, idxGroup_r12 + "-" + idxItem_r11, ctx_r0.rowAnchor));
  }
}
function ListPageComponent_div_4_ng_container_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 15);
    i0.ɵɵtemplate(2, ListPageComponent_div_4_ng_container_1_ng_container_3_2_Template, 1, 5, null, 16)(3, ListPageComponent_div_4_ng_container_1_ng_container_3_3_Template, 1, 5, null, 16)(4, ListPageComponent_div_4_ng_container_1_ng_container_3_4_Template, 1, 6, null, 16);
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const item_r10 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", ctx_r0.getAnchorType(item_r10));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "href");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "routerLink");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "onClick");
  }
}
function ListPageComponent_div_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵtemplate(2, ListPageComponent_div_4_ng_container_1_div_2_Template, 2, 1, "div", 20)(3, ListPageComponent_div_4_ng_container_1_ng_container_3_Template, 5, 4, "ng-container", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const group_r8 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", group_r8.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.reloading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.filterGroup(group_r8.id));
  }
}
function ListPageComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, ListPageComponent_div_4_ng_container_1_Template, 4, 3, "ng-container", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.groupsLabel);
  }
}
function ListPageComponent_div_5_img_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 26);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("alt", ctx_r0.emptyState.alt ? ctx_r0.emptyState.alt : "");
    i0.ɵɵattribute("src", ctx_r0.emptyState.src, i0.ɵɵsanitizeUrl);
  }
}
function ListPageComponent_div_5_h2_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.emptyState.title));
  }
}
function ListPageComponent_div_5_p_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 27);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, ctx_r0.emptyState.message, ctx_r0.emptyState.messageTranslationParams));
  }
}
function ListPageComponent_div_5_a_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("routerLink", ctx_r0.emptyState.actionButton.routerLink)("ngClass", ctx_r0.emptyState.actionButton.styleClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, ctx_r0.emptyState.actionButton.label));
  }
}
function ListPageComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, ListPageComponent_div_5_img_1_Template, 1, 2, "img", 23)(2, ListPageComponent_div_5_h2_2_Template, 3, 3, "h2", 10)(3, ListPageComponent_div_5_p_3_Template, 3, 4, "p", 24)(4, ListPageComponent_div_5_a_4_Template, 3, 5, "a", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!ctx_r0.emptyState.src);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!ctx_r0.emptyState.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!ctx_r0.emptyState.message);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.emptyState.actionButton);
  }
}
function ListPageComponent_ng_content_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngIf", "custom"]);
  }
}
function ListPageComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 29);
    i0.ɵɵelementContainerEnd();
  }
}
function ListPageComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "a", 30, 3);
  }
  if (rf & 2) {
    const item_r13 = ctx.item;
    const idx_r14 = ctx.idx;
    i0.ɵɵclassMapInterpolate1("list-item list_rows ", item_r13.styleClass, " ");
    i0.ɵɵpropertyInterpolate1("id", "list-item-", idx_r14, "");
    i0.ɵɵproperty("item", item_r13)("itemIndex", idx_r14);
    i0.ɵɵattribute("href", item_r13.anchorUrl["href"], i0.ɵɵsanitizeUrl)("aria-label", item_r13.ariaLabel || (item_r13.title == null ? null : item_r13.title.label) || null);
  }
}
function ListPageComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "a", 31, 3);
  }
  if (rf & 2) {
    const item_r15 = ctx.item;
    const idx_r16 = ctx.idx;
    i0.ɵɵclassMapInterpolate1("list-item list_rows ", item_r15.styleClass, " ");
    i0.ɵɵpropertyInterpolate1("id", "list-item-", idx_r16, "");
    i0.ɵɵproperty("item", item_r15)("itemIndex", idx_r16)("routerLink", item_r15.anchorUrl["routerLink"]);
    i0.ɵɵattribute("aria-label", item_r15.ariaLabel || (item_r15.title == null ? null : item_r15.title.label) || null);
  }
}
function ListPageComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32)(1, "div", 33, 3);
    i0.ɵɵlistener("keyup.enter", function ListPageComponent_ng_template_12_Template_div_keyup_enter_1_listener($event) {
      const ctx_r17 = i0.ɵɵrestoreView(_r17);
      const item_r19 = ctx_r17.item;
      const idx_r20 = ctx_r17.idx;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.clickRow(item_r19, idx_r20, $event));
    })("click", function ListPageComponent_ng_template_12_Template_div_click_1_listener($event) {
      const ctx_r20 = i0.ɵɵrestoreView(_r17);
      const item_r19 = ctx_r20.item;
      const idx_r20 = ctx_r20.idx;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.clickRow(item_r19, idx_r20, $event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r19 = ctx.item;
    const idx_r20 = ctx.idx;
    const rowAnchor_r22 = ctx.rowAnchor;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("list-item list_rows ", item_r19.styleClass, " ");
    i0.ɵɵpropertyInterpolate1("id", "list-item-", idx_r20, "");
    i0.ɵɵproperty("item", item_r19)("itemIndex", idx_r20)("ngClass", i0.ɵɵpureFunction1(11, _c4$m, rowAnchor_r22.enable && !ctx_r0.reloading))("checkbox", ctx_r0.useBatchOptions);
    i0.ɵɵattribute("tabindex", rowAnchor_r22.enable ? 0 : null)("role", "link");
  }
}
class ListPageComponent {
  constructor(sizeDetector) {
    this.sizeDetector = sizeDetector;
    this.header = true;
    this.pagination = true;
    this.custom = false;
    this.emptyState = new EmptyState();
    this.resultString = 'misc.results plural';
    this.rowAnchor = new RowAnchorModel();
    this.textTitle = false;
    this.displaySort = true;
    this.displayPerPage = true;
    this.autoScrollTop = true;
    this.groupsLabel = [];
    this.useListButton = false;
    this.listButtons = [];
    this.batchOptions = [];
    this.useBatchOptions = false;
    this.hideEmptyState = false;
    this.view = new EventEmitter();
    this.reload = new EventEmitter();
    this.action = new EventEmitter();
    this._items = [];
    this._sortAsc = false;
    this._page = 1;
    this._reloading = false;
    this._initiated = false;
    this.batchOptionsVisible = false;
    this.batchOptionsDisabled = true;
    this.isMobileScreen = false;
    this.showSubmenusMobile = false;
    this.currentMenu = 'misc.Batch Options';
    this.rowsSelections = {
      checkedAll: false,
      idsAmount: 0,
      ids: {}
    };
    this._displayParams = {};
    this._scheduledReload = null;
  }
  get reloading() {
    return this._reloading;
  }
  get execReloading() {
    return this.reloading;
  }
  set execReloading(value) {
    if (this._initiated) {
      this.loadingScreen();
    }
  }
  get items() {
    return this._items;
  }
  set items(items) {
    this._items = items;
    this.itemsSet = true;
    if (items) {
      // Should only be null on initial null value passed by Data Storage Service
      this._onReloadFinished();
    }
  }
  get sortBy() {
    return this._sortBy;
  }
  set sortBy(value) {
    if (this._initiated && this._sortBy !== value) {
      this._triggerReload();
    }
    this._sortBy = value;
  }
  get sortAsc() {
    return this._sortAsc;
  }
  set sortAsc(value) {
    if (this._initiated && this._sortAsc !== value) {
      this._triggerReload();
    }
    this._sortAsc = value;
  }
  get offset() {
    return (this.page - 1) * this.perPage;
  }
  get page() {
    return this._page;
  }
  set page(value) {
    if (this._initiated && this._page !== Number(value)) {
      this._triggerReload();
    }
    this._page = Number(value);
  }
  get perPage() {
    return this._perPage;
  }
  set perPage(value) {
    if (this._initiated && this._perPage !== value) {
      this._triggerReload();
    }
    this._perPage = value;
  }
  // calculated property:
  get lastPage() {
    return Math.ceil(this.totalCount / this.perPage);
  }
  ngOnInit() {
    this._initiated = true;
    this._updateDisplayParams();
    this.loadingScreen();
    this.sizeDetectorSubscription = this.sizeDetector.onResize$.pipe(delay(200)).subscribe(screen => {
      this.isMobileScreen = screen.size === 'MOBILE' || screen.size === 'SM';
    });
    this.closeAllSubmenus();
  }
  _getRemoteParameters() {
    let params = {};
    if (this.sortBy) {
      params.sortBy = this.sortBy;
      params.sortAsc = this.sortAsc;
    }
    if (this.pagination) {
      params.perPage = this.perPage;
      params.page = this.page;
    }
    return params;
  }
  loadingScreen() {
    if (!this.custom && (!this.itemsSet || !this._items)) {
      this._items = Array(this.skeleton.rows).fill(0).map((x, i) => i);
      this._reloading = true;
    }
  }
  filterGroup(id) {
    return this._reloading ? this.items : this.items.filter(item => item.groupId === id);
  }
  reloadItems() {
    this.loadingScreen();
    this._reloading = true;
    this.reload.emit(this._getRemoteParameters());
  }
  _onReloadFinished() {
    this._updateDisplayParams();
    setTimeout(d => {
      this._reloading = false;
      if (this.autoScrollTop) {
        window.scrollTo(0, 0);
      }
    }, 300);
  }
  _updateDisplayParams() {
    this._displayParams = {
      sortBy: this.sortBy,
      sortAsc: this.sortAsc,
      perPage: this.perPage
    };
  }
  _triggerReload() {
    if (this._scheduledReload) {
      clearTimeout(this._scheduledReload);
    }
    if (!this.reloading) {
      this._scheduledReload = setTimeout(() => {
        this.reloadItems();
      });
    }
  }
  viewItem(item) {
    this.view.emit(item);
  }
  sort(sortBy) {
    this.sortBy = sortBy;
  }
  clickRow(item, itemIdx, event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.rowAnchor.enable || this.reloading) {
      return false;
    }
    let val = {
      item: item,
      itemIndex: itemIdx,
      event: event,
      rowClick: true
    };
    this.rowAnchor.onClick(val);
  }
  getAnchorType(item) {
    let type = 'onClick';
    if (_.has(item.anchorUrl, 'href') && !_.isEmpty(item.anchorUrl.href)) {
      type = 'href';
    } else if (_.has(item.anchorUrl, 'routerLink') && !_.isEmpty(item.anchorUrl.routerLink)) {
      type = 'routerLink';
    }
    return type;
  }
  asNumber(value) {
    return parseInt(value, 10);
  }
  toggleCheckAll() {
    if (this.rowsSelections.checkedAll) {
      this.rowsSelections = {
        checkedAll: false,
        idsAmount: 0,
        ids: {}
      };
    } else {
      this.rowsSelections = {
        checkedAll: true,
        uncheckedIdsAmount: 0,
        uncheckedIds: {}
      };
    }
    this.checkBatchOptionsAvailability();
  }
  toggleCheck(itemId) {
    const itemChecked = this.rowsSelections.checkedAll ? !Object.keys(this.rowsSelections.uncheckedIds).includes(itemId) : Object.keys(this.rowsSelections.ids).includes(itemId);
    if (this.rowsSelections.checkedAll) {
      if (itemChecked) {
        this.rowsSelections.uncheckedIds[itemId] = 1;
      } else {
        delete this.rowsSelections.uncheckedIds[itemId];
      }
      this.rowsSelections.uncheckedIdsAmount = Object.keys(this.rowsSelections.uncheckedIds).length;
    } else {
      if (itemChecked) {
        delete this.rowsSelections.ids[itemId];
      } else {
        this.rowsSelections.ids[itemId] = 1;
      }
      this.rowsSelections.idsAmount = Object.keys(this.rowsSelections.ids).length;
    }
    if (this.rowsSelections.checkedAll && this.rowsSelections.uncheckedIdsAmount === this.totalCount || !this.rowsSelections.checkedAll && this.rowsSelections.idsAmount === this.totalCount) {
      this.toggleCheckAll();
    } else {
      this.checkBatchOptionsAvailability();
    }
  }
  checkBatchOptionsAvailability() {
    this.batchOptionsDisabled = !this.rowsSelections.checkedAll && this.rowsSelections.idsAmount === 0;
  }
  showSubmenu(show, option) {
    this.closeAllSubmenus();
    if (option.submenus !== undefined) {
      option.submenus.show = show;
    }
  }
  optionClicked(option) {
    this.showSubmenusMobile = false;
    if (this.isMobileScreen && option.submenus !== undefined) {
      this.currentMenu = option.label;
      this.showSubmenusMobile = true;
      option.submenus.show = true;
    } else if (this.isMobileScreen && option.submenus === undefined || !this.isMobileScreen) {
      option.onClick(this.rowsSelections);
      this.closeMenu(true);
    }
  }
  closeMenu(close) {
    this.showSubmenusMobile = false;
    this.closeAllSubmenus();
    this.currentMenu = 'misc.Batch Options';
    if (close) {
      this.batchOptionsVisible = false;
    }
  }
  closeAllSubmenus() {
    this.batchOptions.forEach(option => {
      if (option.submenus !== undefined) {
        option.submenus.show = false;
      }
    });
  }
  static {
    this.ɵfac = function ListPageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListPageComponent)(i0.ɵɵdirectiveInject(SizeDetectorService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ListPageComponent,
      selectors: [["list-page"]],
      inputs: {
        header: "header",
        pagination: "pagination",
        sorts: "sorts",
        totalCount: "totalCount",
        styleClass: "styleClass",
        custom: "custom",
        emptyState: "emptyState",
        resultString: "resultString",
        rowAnchor: "rowAnchor",
        textTitle: "textTitle",
        skeleton: "skeleton",
        displaySort: "displaySort",
        displayPerPage: "displayPerPage",
        autoScrollTop: "autoScrollTop",
        groupsLabel: "groupsLabel",
        useListButton: "useListButton",
        listButtons: "listButtons",
        batchOptions: "batchOptions",
        useBatchOptions: "useBatchOptions",
        hideEmptyState: "hideEmptyState",
        execReloading: "execReloading",
        items: "items",
        sortBy: "sortBy",
        sortAsc: "sortAsc",
        page: "page",
        perPage: "perPage"
      },
      outputs: {
        view: "view",
        reload: "reload",
        action: "action"
      },
      standalone: false,
      ngContentSelectors: _c0$O,
      decls: 14,
      vars: 13,
      consts: [["hrefItem", ""], ["routerLinkItem", ""], ["onClickItem", ""], ["listItem", ""], [3, "ngClass"], ["class", "sr-only", "role", "alert", "aria-atomic", "true", "translate", "", 4, "ngIf"], ["list-page-header", "", "class", "lst-head", 3, "isReload", 4, "ngIf"], ["id", "list", "name", "list", 4, "ngIf"], ["id", "list", 4, "ngIf"], ["class", "empty-state", 4, "ngIf"], [4, "ngIf"], ["role", "alert", "aria-atomic", "true", "translate", "", 1, "sr-only"], ["list-page-header", "", 1, "lst-head", 3, "isReload"], ["id", "list", "name", "list"], [4, "ngFor", "ngForOf"], [3, "ngSwitch"], [4, "ngSwitchCase"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["id", "list"], ["role", "list"], ["id", "event-cf-list-title", "class", "engraved-block-title no-borders", 4, "ngIf"], ["id", "event-cf-list-title", 1, "engraved-block-title", "no-borders"], [1, "empty-state"], ["role", "presentation", 3, "alt", 4, "ngIf"], ["class", "body-small", 4, "ngIf"], [3, "routerLink", "ngClass", 4, "ngIf"], ["role", "presentation", 3, "alt"], [1, "body-small"], [3, "routerLink", "ngClass"], ["list-page-pagination", "", 1, "lst-foot"], ["list-page-row-standard", "", 3, "id", "item", "itemIndex"], ["list-page-row-standard", "", 3, "id", "item", "itemIndex", "routerLink"], ["role", "listitem", 1, "border-bottom"], ["list-page-row-standard", "", 3, "keyup.enter", "click", "id", "item", "itemIndex", "ngClass", "checkbox"]],
      template: function ListPageComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 4);
          i0.ɵɵtemplate(1, ListPageComponent_div_1_Template, 2, 0, "div", 5)(2, ListPageComponent_div_2_Template, 1, 1, "div", 6)(3, ListPageComponent_div_3_Template, 2, 2, "div", 7)(4, ListPageComponent_div_4_Template, 2, 1, "div", 8)(5, ListPageComponent_div_5_Template, 5, 4, "div", 9)(6, ListPageComponent_ng_content_6_Template, 1, 0, "ng-content", 10)(7, ListPageComponent_ng_container_7_Template, 2, 0, "ng-container", 10);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, ListPageComponent_ng_template_8_Template, 2, 9, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(10, ListPageComponent_ng_template_10_Template, 2, 9, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(12, ListPageComponent_ng_template_12_Template, 3, 13, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styleClass);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1$F, ctx.reloading));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.reloading);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.header);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.custom && ctx.items && ctx.items.length && ctx.groupsLabel && !ctx.groupsLabel.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.custom && ctx.items && ctx.items.length && ctx.groupsLabel && ctx.groupsLabel.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.custom && !ctx.items.length && !ctx.hideEmptyState);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.custom);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.pagination && ctx.items.length && (ctx.totalCount !== undefined ? ctx.totalCount > ctx.perPage : true));
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListPageComponent, [{
    type: Component,
    args: [{
      selector: 'list-page',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"{{styleClass}}\" [ngClass]=\"{'list-reloading': this.reloading}\">\n    <div *ngIf=\"this.reloading\" class=\"sr-only\" role=\"alert\" aria-atomic=\"true\" translate>misc.Loading</div>\n    <div list-page-header *ngIf=\"header\" [isReload]=\"this.reloading\" class=\"lst-head\"></div>\n    <div *ngIf=\"!custom && items && items.length && groupsLabel && !groupsLabel.length\" id=\"list\" name=\"list\" [attr.role]=\"'list'\">\n        <ng-container *ngFor=\"let item of items; index as idx\">\n            <ng-container [ngSwitch]=\"getAnchorType(item)\">\n                <ng-template *ngSwitchCase=\"'href'\" [ngTemplateOutlet]=\"hrefItem\" [ngTemplateOutletContext]=\"{ item: item, idx: idx }\"></ng-template>\n                <ng-template *ngSwitchCase=\"'routerLink'\" [ngTemplateOutlet]=\"routerLinkItem\" [ngTemplateOutletContext]=\"{ item: item, idx: idx }\"></ng-template>\n                <ng-template  *ngSwitchCase=\"'onClick'\" [ngTemplateOutlet]=\"onClickItem\" [ngTemplateOutletContext]=\"{ item: item, idx: idx, rowAnchor: rowAnchor }\"></ng-template>\n            </ng-container>\n\n        </ng-container>\n    </div>\n\n    <div *ngIf=\"!custom && items && items.length && groupsLabel && groupsLabel.length \" id=\"list\">\n        <ng-container *ngFor=\"let group of groupsLabel; index as idxGroup\">\n            <div role=\"list\" [attr.aria-label]=\"group.label\">\n                <div id=\"event-cf-list-title\" class=\"engraved-block-title no-borders\" *ngIf=\"!reloading\">{{ group.label }}</div>\n                <ng-container *ngFor=\"let item of filterGroup(group.id); index as idxItem\">\n                    <ng-container [ngSwitch]=\"getAnchorType(item)\">\n                        <ng-template *ngSwitchCase=\"'href'\" [ngTemplateOutlet]=\"hrefItem\" [ngTemplateOutletContext]=\"{ item: item, idx: idxGroup+'-'+idxItem }\"></ng-template>\n                        <ng-template *ngSwitchCase=\"'routerLink'\" [ngTemplateOutlet]=\"routerLinkItem\" [ngTemplateOutletContext]=\"{ item: item, idx: idxGroup+'-'+idxItem }\"></ng-template>\n                        <ng-template  *ngSwitchCase=\"'onClick'\" [ngTemplateOutlet]=\"onClickItem\" [ngTemplateOutletContext]=\"{ item: item, idx: idxGroup+'-'+idxItem, rowAnchor: rowAnchor }\"></ng-template>\n                    </ng-container>\n                </ng-container>\n            </div>\n        </ng-container>\n    </div>\n\n    <div *ngIf=\"!custom && !items.length && !hideEmptyState\" class=\"empty-state\">\n        <img *ngIf=\"!!emptyState.src\" [attr.src]=\"emptyState.src\" alt=\"{{ emptyState.alt ? emptyState.alt : '' }}\" role=\"presentation\">\n        <h2 *ngIf=\"!!emptyState.title\">{{emptyState.title | translate}}</h2>\n        <p *ngIf=\"!!emptyState.message\" class=\"body-small\">{{emptyState.message | translate:emptyState.messageTranslationParams}}</p>\n        <a *ngIf=\"emptyState.actionButton\" [routerLink]=\"emptyState.actionButton.routerLink\" [ngClass]=\"emptyState.actionButton.styleClass\">{{ emptyState.actionButton.label | translate }}</a>\n    </div>\n    <ng-content *ngIf=\"custom\"></ng-content>\n    <ng-container *ngIf=\"pagination && items.length && (totalCount !== undefined ? totalCount > perPage : true)\">\n        <div list-page-pagination class=\"lst-foot\"></div>\n    </ng-container>\n</div>\n\n<ng-template #hrefItem let-item=\"item\" let-idx=\"idx\">\n    <a list-page-row-standard\n        #listItem\n        id=\"list-item-{{idx}}\"\n        class=\"list-item list_rows {{item.styleClass}} \"\n        [item]=\"item\"\n        [itemIndex]=\"idx\"\n        [attr.href]=\"item.anchorUrl['href']\"\n        [attr.aria-label]=\"item.ariaLabel || item.title?.label || null\"\n    ></a>\n</ng-template>\n\n<ng-template #routerLinkItem let-item=\"item\" let-idx=\"idx\">\n    <a list-page-row-standard\n        #listItem\n        id=\"list-item-{{idx}}\"\n        class=\"list-item list_rows {{item.styleClass}} \"\n        [item]=\"item\"\n        [itemIndex]=\"idx\"\n        [attr.aria-label]=\"item.ariaLabel || item.title?.label || null\"\n        [routerLink]=\"item.anchorUrl['routerLink']\"\n    ></a>\n</ng-template>\n\n<ng-template #onClickItem let-item=\"item\" let-idx=\"idx\" let-rowAnchor=\"rowAnchor\">\n    <div class=\"border-bottom\" role=\"listitem\">\n        <div list-page-row-standard\n             #listItem\n             id=\"list-item-{{idx}}\"\n             class=\"list-item list_rows {{item.styleClass}} \"\n             [item]=\"item\"\n             [itemIndex]=\"idx\"\n             [ngClass]=\"{ 'cursor-pointer': rowAnchor.enable && !this.reloading }\"\n             [attr.tabindex]=\"rowAnchor.enable ? 0 : null\"\n             [attr.role]=\"'link'\"\n             (keyup.enter)=\"clickRow(item, idx, $event)\"\n             (click)=\"clickRow(item, idx, $event)\"\n             [checkbox]=\"useBatchOptions\"\n        ></div>\n    </div>\n</ng-template>"
    }]
  }], () => [{
    type: SizeDetectorService
  }], {
    header: [{
      type: Input
    }],
    pagination: [{
      type: Input
    }],
    sorts: [{
      type: Input
    }],
    totalCount: [{
      type: Input
    }],
    styleClass: [{
      type: Input
    }],
    custom: [{
      type: Input
    }],
    emptyState: [{
      type: Input
    }],
    resultString: [{
      type: Input
    }],
    rowAnchor: [{
      type: Input
    }],
    textTitle: [{
      type: Input
    }],
    skeleton: [{
      type: Input
    }],
    displaySort: [{
      type: Input
    }],
    displayPerPage: [{
      type: Input
    }],
    autoScrollTop: [{
      type: Input
    }],
    groupsLabel: [{
      type: Input
    }],
    useListButton: [{
      type: Input
    }],
    listButtons: [{
      type: Input
    }],
    batchOptions: [{
      type: Input
    }],
    useBatchOptions: [{
      type: Input
    }],
    hideEmptyState: [{
      type: Input
    }],
    view: [{
      type: Output
    }],
    reload: [{
      type: Output
    }],
    action: [{
      type: Output
    }],
    execReloading: [{
      type: Input
    }],
    items: [{
      type: Input
    }],
    sortBy: [{
      type: Input
    }],
    sortAsc: [{
      type: Input
    }],
    page: [{
      type: Input
    }],
    perPage: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ListPageComponent, {
    className: "ListPageComponent",
    filePath: "valkyrie/list-page/list-page.component.ts",
    lineNumber: 14
  });
})();
const _c0$N = ["list-page-pagination", ""];
function ListPagePaginationComponent_ng_container_1_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function ListPagePaginationComponent_ng_container_1_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.pageBack());
    });
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "misc.Previous"));
  }
}
function ListPagePaginationComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListPagePaginationComponent_ng_container_1_button_1_Template, 5, 3, "button", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.page > 1);
  }
}
function ListPagePaginationComponent_option_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const page_r5 = ctx.$implicit;
    i0.ɵɵproperty("value", page_r5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 3, "misc.Page"), " ", page_r5, "");
  }
}
function ListPagePaginationComponent_ng_container_7_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function ListPagePaginationComponent_ng_container_7_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.pageForward());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "misc.Next"));
  }
}
function ListPagePaginationComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListPagePaginationComponent_ng_container_7_button_1_Template, 5, 3, "button", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.page != ctx_r2.maxPage);
  }
}
class ListPagePaginationComponent {
  constructor(listPage) {
    this.listPage = listPage;
  }
  get page() {
    return this.listPage.page || 1;
  }
  set page(value) {
    this.listPage.page = Number(value);
  }
  get maxPage() {
    return this.pages[this.pages.length - 1];
  }
  get perPage() {
    let perPage = [10, 20, 50, 100, 250];
    return perPage;
  }
  get pages() {
    let pages = [];
    if (this.listPage.totalCount && this.listPage.perPage) {
      let num = Math.ceil(this.listPage.totalCount / this.listPage.perPage);
      while (num > 0) {
        pages.push(num);
        num--;
      }
      pages = pages.sort(function (a, b) {
        return a - b;
      });
    }
    return pages;
  }
  get isReloadingSkeleton() {
    return !this.listPage.skeleton || this.listPage.skeleton && !this.listPage.reloading;
  }
  pageBack() {
    if (this.listPage.offset > 1) {
      // this.listPage.offset -= Math.min(this.listPage.limit, (this.listPage.offset - 1));
      this.listPage.page -= 1;
    }
  }
  pageForward() {
    if (this.page < this.maxPage) {
      this.listPage.page += 1;
    }
  }
  static {
    this.ɵfac = function ListPagePaginationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListPagePaginationComponent)(i0.ɵɵdirectiveInject(forwardRef(() => ListPageComponent)));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ListPagePaginationComponent,
      selectors: [["", "list-page-pagination", ""]],
      standalone: false,
      attrs: _c0$N,
      decls: 8,
      vars: 7,
      consts: [["pageInput", ""], [1, "lst-paging"], [4, "ngIf"], [1, "btn", "btn_minimal", "lst-jumper"], ["size", "1", 3, "change", "ngModel"], [3, "value", 4, "ngFor", "ngForOf"], ["href", "#", "onclick", "return false;", "class", "btn btn_default", 3, "click", 4, "ngIf"], ["href", "#", "onclick", "return false;", 1, "btn", "btn_default", 3, "click"], [1, "icn-chevron_left"], [3, "value"], ["href", "#", "onclick", "return false;", "class", "btn btn_alt-default text-primary", 3, "click", 4, "ngIf"], ["href", "#", "onclick", "return false;", 1, "btn", "btn_alt-default", "text-primary", 3, "click"], [1, "icn-chevron_right"]],
      template: function ListPagePaginationComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵtemplate(1, ListPagePaginationComponent_ng_container_1_Template, 2, 1, "ng-container", 2);
          i0.ɵɵelementStart(2, "div", 3)(3, "select", 4, 0);
          i0.ɵɵpipe(5, "translate");
          i0.ɵɵlistener("change", function ListPagePaginationComponent_Template_select_change_3_listener() {
            i0.ɵɵrestoreView(_r1);
            const pageInput_r4 = i0.ɵɵreference(4);
            return i0.ɵɵresetView(ctx.page = ctx.listPage.asNumber(pageInput_r4.value));
          });
          i0.ɵɵtemplate(6, ListPagePaginationComponent_option_6_Template, 3, 5, "option", 5);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(7, ListPagePaginationComponent_ng_container_7_Template, 2, 1, "ng-container", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isReloadingSkeleton);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngModel", ctx.page);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 5, "misc.Jump to page"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngForOf", ctx.pages);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isReloadingSkeleton);
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListPagePaginationComponent, [{
    type: Component,
    args: [{
      selector: '[list-page-pagination]',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"lst-paging\">\n    <ng-container *ngIf=\"isReloadingSkeleton\">\n        <button *ngIf=\"page > 1\" href=\"#\" onclick=\"return false;\" (click)=\"pageBack()\" class=\"btn btn_default\">\n            <span class=\"icn-chevron_left\"></span>\n            <span>{{'misc.Previous' | translate}}</span>\n        </button>\n    </ng-container>\n    <div class=\"btn btn_minimal lst-jumper\">\n        <select size=\"1\" #pageInput (change)=\"page = listPage.asNumber(pageInput.value)\" [ngModel]=\"page\" [attr.aria-label]=\"'misc.Jump to page' | translate\">\n            <option *ngFor=\"let page of pages\" [value]=\"page\">{{'misc.Page' | translate}} {{page}}</option>\n        </select>\n    </div>\n    <ng-container *ngIf=\"isReloadingSkeleton\">\n        <button *ngIf=\"page != maxPage\" href=\"#\" onclick=\"return false;\" (click)=\"pageForward()\" class=\"btn btn_alt-default text-primary\">\n            <span>{{'misc.Next' | translate}}</span>\n            <span class=\"icn-chevron_right\"></span>\n        </button>\n    </ng-container>\n</div>"
    }]
  }], () => [{
    type: ListPageComponent,
    decorators: [{
      type: Inject,
      args: [forwardRef(() => ListPageComponent)]
    }]
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ListPagePaginationComponent, {
    className: "ListPagePaginationComponent",
    filePath: "valkyrie/list-page/list-page-pagination.component.ts",
    lineNumber: 10
  });
})();
const _c0$M = ["sortInput"];
const _c1$E = ["limitInput"];
const _c2$y = ["list-page-header", ""];
const _c3$n = a0 => ({
  "btn_disabled": a0
});
const _c4$l = a0 => ({
  "menu-show": a0
});
const _c5$e = a0 => ({
  "hide": a0
});
const _c6$a = (a0, a1) => ({
  selectedRows: a0,
  totalCount: a1
});
const _c7$7 = a0 => ({
  numrows: a0
});
const _c8$6 = (a0, a1) => [a0, a1];
const _c9$6 = (a0, a1, a2) => ({
  start: a0,
  end: a1,
  total: a2
});
function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 28);
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_div_5_a_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵlistener("click", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_div_5_a_1_Template_a_click_0_listener() {
      const menu_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      menu_r7.onClick(ctx_r1.listPage.rowsSelections);
      return i0.ɵɵresetView(ctx_r1.listPage.closeMenu(true));
    })("focus", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_div_5_a_1_Template_a_focus_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const option_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.listPage.showSubmenu(true, option_r4));
    })("focusout", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_div_5_a_1_Template_a_focusout_0_listener() {
      const lastSubmenu_r8 = i0.ɵɵrestoreView(_r6).last;
      const lastMenu_r9 = i0.ɵɵnextContext(2).last;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(lastSubmenu_r8 && lastMenu_r9 ? ctx_r1.listPage.closeMenu(true) : null);
    })("keyup.enter", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_div_5_a_1_Template_a_keyup_enter_0_listener() {
      const menu_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      menu_r7.onClick(ctx_r1.listPage.rowsSelections);
      return i0.ɵɵresetView(ctx_r1.listPage.closeMenu(true));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const menu_r7 = ctx.$implicit;
    const option_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵattribute("tabindex", option_r4.submenus.show ? "0" : "-1");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", menu_r7.label, " ");
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵlistener("mouseover", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_div_5_Template_div_mouseover_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const option_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.listPage.showSubmenu(true, option_r4));
    })("mouseout", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_div_5_Template_div_mouseout_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const option_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.listPage.showSubmenu(false, option_r4));
    });
    i0.ɵɵtemplate(1, ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_div_5_a_1_Template, 2, 2, "a", 30);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    const option_r4 = ctx_r9.$implicit;
    const i_r11 = ctx_r9.index;
    i0.ɵɵproperty("id", "submenu_container_" + i_r11)("ngClass", i0.ɵɵpureFunction1(3, _c5$e, option_r4.submenus.show === undefined || !option_r4.submenus.show));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", option_r4.submenus);
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "a", 25);
    i0.ɵɵlistener("click", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_Template_a_click_1_listener() {
      const option_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.listPage.optionClicked(option_r4));
    })("mouseover", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_Template_a_mouseover_1_listener() {
      const option_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.listPage.showSubmenu(true, option_r4));
    })("keyup.enter", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_Template_a_keyup_enter_1_listener() {
      const option_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.listPage.showSubmenu(true, option_r4));
    })("focus", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_Template_a_focus_1_listener() {
      const option_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.listPage.showSubmenu(true, option_r4));
    })("mouseout", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_Template_a_mouseout_1_listener() {
      const option_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.listPage.showSubmenu(false, option_r4));
    })("keyup.enter", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_Template_a_keyup_enter_1_listener() {
      const option_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(option_r4.submenus === undefined ? ctx_r1.listPage.optionClicked(option_r4) : null);
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_span_4_Template, 1, 0, "span", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_div_5_Template, 2, 5, "div", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r4 = ctx.$implicit;
    const i_r11 = ctx.index;
    i0.ɵɵattribute("aria-expanded", option_r4.submenus !== undefined ? option_r4.submenus.show : "")("aria-controls", "submenu_container_" + i_r11);
    i0.ɵɵadvance();
    i0.ɵɵattribute("tabindex", 0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, option_r4.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", option_r4.submenus !== undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r4.submenus !== undefined);
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_2_div_19_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_19_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.listPage.closeMenu(false));
    })("keyup.enter", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_19_button_1_Template_button_keyup_enter_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.listPage.closeMenu(false));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "misc.Go Back to"));
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_2_div_19_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtemplate(1, ListPageHeaderComponent_ng_container_0_ng_container_2_div_19_button_1_Template, 2, 3, "button", 33);
    i0.ɵɵelementStart(2, "span", 34);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 35);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵlistener("click", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_19_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.listPage.closeMenu(true));
    })("keyup.enter", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_19_Template_button_keyup_enter_5_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.listPage.closeMenu(true));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.showSubmenusMobile);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, ctx_r1.listPage.currentMenu));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 5, "misc.Close Actions Menu"));
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_2_ng_container_21_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 40);
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_2_ng_container_21_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 37)(2, "a", 38);
    i0.ɵɵlistener("click", function ListPageHeaderComponent_ng_container_0_ng_container_2_ng_container_21_Template_a_click_2_listener() {
      const option_r15 = i0.ɵɵrestoreView(_r14).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.listPage.optionClicked(option_r15));
    })("keyup.enter", function ListPageHeaderComponent_ng_container_0_ng_container_2_ng_container_21_Template_a_keyup_enter_2_listener() {
      const option_r15 = i0.ɵɵrestoreView(_r14).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.listPage.optionClicked(option_r15));
    })("keydown.tab", function ListPageHeaderComponent_ng_container_0_ng_container_2_ng_container_21_Template_a_keydown_tab_2_listener() {
      const lastMobileMenu_r16 = i0.ɵɵrestoreView(_r14).last;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(lastMobileMenu_r16 ? ctx_r1.listPage.closeMenu(true) : null);
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, ListPageHeaderComponent_ng_container_0_ng_container_2_ng_container_21_span_5_Template, 1, 0, "span", 39);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const option_r15 = ctx.$implicit;
    const i_r17 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-controls", "submenu_mobile_container_" + i_r17)("aria-expanded", option_r15.submenus !== undefined && ctx_r1.listPage.showSubmenusMobile && option_r15.submenus.show);
    i0.ɵɵadvance();
    i0.ɵɵattribute("tabindex", 0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, option_r15.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", option_r15.submenus !== undefined);
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_2_div_22_ng_container_1_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 44);
    i0.ɵɵlistener("click", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_22_ng_container_1_a_2_Template_a_click_0_listener() {
      const menu_r19 = i0.ɵɵrestoreView(_r18).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.listPage.optionClicked(menu_r19));
    })("keyup.enter", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_22_ng_container_1_a_2_Template_a_keyup_enter_0_listener() {
      const menu_r19 = i0.ɵɵrestoreView(_r18).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.listPage.optionClicked(menu_r19));
    })("keydown.tab", function ListPageHeaderComponent_ng_container_0_ng_container_2_div_22_ng_container_1_a_2_Template_a_keydown_tab_0_listener() {
      const lastMobileSubmenu_r20 = i0.ɵɵrestoreView(_r18).last;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(lastMobileSubmenu_r20 ? ctx_r1.listPage.closeMenu(true) : null);
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const menu_r19 = ctx.$implicit;
    const option_r21 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵattribute("tabindex", option_r21.submenus.show ? "0" : "-1");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", menu_r19.label, " ");
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_2_div_22_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 42);
    i0.ɵɵtemplate(2, ListPageHeaderComponent_ng_container_0_ng_container_2_div_22_ng_container_1_a_2_Template, 2, 2, "a", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const option_r21 = ctx.$implicit;
    const i_r22 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", option_r21.submenus !== undefined && ctx_r1.listPage.isMobileScreen && option_r21.submenus.show !== undefined && option_r21.submenus.show ? "show" : "hide")("id", "submenu_mobile_container_" + i_r22);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", option_r21.submenus);
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_2_div_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtemplate(1, ListPageHeaderComponent_ng_container_0_ng_container_2_div_22_ng_container_1_Template, 3, 3, "ng-container", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.listPage.batchOptions);
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 8)(2, "input", 9);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("click", function ListPageHeaderComponent_ng_container_0_ng_container_2_Template_input_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.listPage.toggleCheckAll());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 10)(5, "div", 11)(6, "div", 12)(7, "button", 13);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵlistener("click", function ListPageHeaderComponent_ng_container_0_ng_container_2_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.listPage.batchOptionsVisible = !ctx_r1.listPage.batchOptionsVisible);
    })("focus", function ListPageHeaderComponent_ng_container_0_ng_container_2_Template_button_focus_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.listPage.batchOptionsVisible = false);
    });
    i0.ɵɵelementStart(9, "span", 14);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelement(12, "i", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "i", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 17);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵtemplate(16, ListPageHeaderComponent_ng_container_0_ng_container_2_div_16_Template, 6, 8, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 19);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵtemplate(19, ListPageHeaderComponent_ng_container_0_ng_container_2_div_19_Template, 7, 7, "div", 20);
    i0.ɵɵelementStart(20, "div", 21);
    i0.ɵɵtemplate(21, ListPageHeaderComponent_ng_container_0_ng_container_2_ng_container_21_Template, 6, 7, "ng-container", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, ListPageHeaderComponent_ng_container_0_ng_container_2_div_22_Template, 2, 1, "div", 23);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r1.listPage.rowsSelections.checkedAll)("indeterminate", ctx_r1.listPage.rowsSelections.checkedAll && !!ctx_r1.listPage.rowsSelections.uncheckedIdsAmount || !ctx_r1.listPage.rowsSelections.checkedAll && !!ctx_r1.listPage.rowsSelections.idsAmount);
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(3, 18, ctx_r1.listPage.rowsSelections.checkedAll ? "misc.Clear All" : "misc.Select All"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(28, _c3$n, ctx_r1.listPage.batchOptionsDisabled))("disabled", ctx_r1.listPage.batchOptionsDisabled);
    i0.ɵɵattribute("aria-expanded", ctx_r1.listPage.batchOptionsVisible)("aria-label", i0.ɵɵpipeBind1(8, 20, ctx_r1.listPage.batchOptionsVisible ? "misc.Close Actions Menu" : "misc.Open Actions Menu"))("aria-disabled", ctx_r1.listPage.batchOptionsDisabled);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 22, ctx_r1.listPage.currentMenu), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(30, _c4$l, ctx_r1.listPage.batchOptionsVisible && !ctx_r1.listPage.isMobileScreen));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(15, 24, "misc.Actions Menu"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.listPage.batchOptions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.listPage.batchOptionsVisible && ctx_r1.listPage.isMobileScreen ? "show" : "hide");
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(18, 26, "misc.Actions Menu"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.isMobileScreen);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.listPage.showSubmenusMobile ? "hide" : "show");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.listPage.batchOptions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.showSubmenusMobile);
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_3_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 47);
    i0.ɵɵlistener("click", function ListPageHeaderComponent_ng_container_0_ng_container_3_button_2_Template_button_click_0_listener() {
      const button_r24 = i0.ɵɵrestoreView(_r23).$implicit;
      return i0.ɵɵresetView(button_r24.onClick(button_r24.action));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r24 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", button_r24.class);
    i0.ɵɵattribute("type", button_r24.type);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(button_r24.label);
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 45);
    i0.ɵɵtemplate(2, ListPageHeaderComponent_ng_container_0_ng_container_3_button_2_Template, 2, 3, "button", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.listButtons);
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Number of results selected", i0.ɵɵpureFunction2(4, _c6$a, ctx_r1.listPage.rowsSelections.checkedAll ? ctx_r1.listPage.totalCount - ctx_r1.listPage.rowsSelections.uncheckedIdsAmount : ctx_r1.listPage.rowsSelections.idsAmount, ctx_r1.listPage.totalCount)), " ");
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.listPage.totalCount, " ");
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_6_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "min");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 3, "misc.List items range", i0.ɵɵpureFunction3(9, _c9$6, ctx_r1.listPage.offset + 1, i0.ɵɵpipeBind1(2, 1, i0.ɵɵpureFunction2(6, _c8$6, ctx_r1.listPage.offset + +ctx_r1.listPage.perPage, ctx_r1.listPage.totalCount)), ctx_r1.listPage.totalCount)), " ");
  }
}
function ListPageHeaderComponent_ng_container_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListPageHeaderComponent_ng_container_0_ng_container_6_ng_container_1_Template, 2, 1, "ng-container", 2)(2, ListPageHeaderComponent_ng_container_0_ng_container_6_ng_container_2_Template, 4, 13, "ng-container", 2);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.totalCount <= ctx_r1.limit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.totalCount > ctx_r1.limit);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 3, ctx_r1.listPage.resultString, i0.ɵɵpureFunction1(6, _c7$7, ctx_r1.listPage.totalCount)), " ");
  }
}
function ListPageHeaderComponent_ng_container_0_span_8_option_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 53);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r27 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", option_r27.id)("selected", option_r27.id == ctx_r1.sortBy);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, option_r27.title));
  }
}
function ListPageHeaderComponent_ng_container_0_span_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 48)(1, "div", 49);
    i0.ɵɵelement(2, "span", 50);
    i0.ɵɵelementStart(3, "select", 51, 0);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵlistener("change", function ListPageHeaderComponent_ng_container_0_span_8_Template_select_change_3_listener() {
      i0.ɵɵrestoreView(_r25);
      const sortInput_r26 = i0.ɵɵreference(4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.sortBy = sortInput_r26.value);
    });
    i0.ɵɵtemplate(6, ListPageHeaderComponent_ng_container_0_span_8_option_6_Template, 3, 5, "option", 52);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r1.sortBy);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 3, "misc.Sort by"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.sorts);
  }
}
function ListPageHeaderComponent_ng_container_0_span_9_option_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 58);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pp_r30 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", pp_r30);
    i0.ɵɵattribute("selected", ctx_r1.limitSelect(pp_r30, ctx_r1.limit));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(pp_r30);
  }
}
function ListPageHeaderComponent_ng_container_0_span_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 54)(1, "div", 49)(2, "label", 55);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "select", 56, 1);
    i0.ɵɵlistener("change", function ListPageHeaderComponent_ng_container_0_span_9_Template_select_change_6_listener() {
      i0.ɵɵrestoreView(_r28);
      const limitInput_r29 = i0.ɵɵreference(7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.limit = ctx_r1.listPage.asNumber(limitInput_r29.value));
    });
    i0.ɵɵtemplate(8, ListPageHeaderComponent_ng_container_0_span_9_option_8_Template, 2, 3, "option", 57);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 4, "misc.Number of Items Showing"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(5, 6, "misc.Show"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r1.limit);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.perPage);
  }
}
function ListPageHeaderComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtemplate(2, ListPageHeaderComponent_ng_container_0_ng_container_2_Template, 23, 32, "ng-container", 2)(3, ListPageHeaderComponent_ng_container_0_ng_container_3_Template, 3, 1, "ng-container", 2);
    i0.ɵɵelementStart(4, "span", 4);
    i0.ɵɵtemplate(5, ListPageHeaderComponent_ng_container_0_ng_container_5_Template, 3, 7, "ng-container", 2)(6, ListPageHeaderComponent_ng_container_0_ng_container_6_Template, 5, 8, "ng-container", 2);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 5);
    i0.ɵɵtemplate(8, ListPageHeaderComponent_ng_container_0_span_8_Template, 7, 5, "span", 6)(9, ListPageHeaderComponent_ng_container_0_span_9_Template, 9, 8, "span", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.useBatchOptions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.useListButton);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.rowsSelections.checkedAll || !ctx_r1.listPage.rowsSelections.checkedAll && ctx_r1.listPage.rowsSelections.idsAmount);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.listPage.rowsSelections.checkedAll && ctx_r1.listPage.rowsSelections.idsAmount === 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.displaySort);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.displayPerPage);
  }
}
function ListPageHeaderComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 59)(2, "div", 60);
    i0.ɵɵelement(3, "span", 61);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 62)(5, "div", 63)(6, "div", 64);
    i0.ɵɵelement(7, "span", 61);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 65);
    i0.ɵɵelement(9, "span", 61);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
}
class ListPageHeaderComponent {
  closeBatchOptions(target) {
    if (this.listPage.useBatchOptions && this.listPage.batchOptionsVisible && !target.closest('.lst-batch') && !this.listPage.isMobileScreen) {
      this.listPage.closeMenu(true);
    }
  }
  constructor(listPage) {
    this.listPage = listPage;
    this._items = [];
    this.readyToResize = false;
  }
  get limit() {
    return this.listPage.perPage;
  }
  set limit(value) {
    if (this.listPage.totalCount && this.listPage.page) {
      let page = this.listPage.page;
      while (value * page > this.listPage.totalCount && page > 1) {
        page--;
      }
      this.listPage.page = page;
    }
    this.listPage.perPage = Number(value);
  }
  get sortBy() {
    return this.listPage.sortBy;
  }
  set sortBy(value) {
    this.listPage.sortBy = value;
  }
  get sorts() {
    return this.listPage.sorts || [];
  }
  get perPage() {
    let perPage = [10, 20, 50, 100, 250];
    return perPage;
  }
  limitSelect(a, b) {
    return parseInt(a) == parseInt(b);
  }
  get useListButton() {
    return this.listPage.useListButton;
  }
  get listButtons() {
    return this.listPage.listButtons;
  }
  set isReload(value) {
    if (this.listPage.displayPerPage || this.listPage.displaySort) {
      if (!value && this.readyToResize) {
        setTimeout(() => {
          this.resizeSelector(this.sortInput);
          this.resizeSelector(this.limitInput);
        }, 300);
        this.readyToResize = false;
      } else if (value && !this.readyToResize) {
        this.readyToResize = true;
      }
    }
  }
  resizeSelector(elm = undefined) {
    if (elm) {
      const text = $$1(elm.nativeElement).find('option:selected').text();
      const $aux = $$1('<select/>').append($$1('<option/>').text(text));
      $$1(elm.nativeElement).after($aux);
      $$1(elm.nativeElement).width($aux.width());
      $aux.remove();
    }
  }
  static {
    this.ɵfac = function ListPageHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListPageHeaderComponent)(i0.ɵɵdirectiveInject(forwardRef(() => ListPageComponent)));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ListPageHeaderComponent,
      selectors: [["", "list-page-header", ""]],
      viewQuery: function ListPageHeaderComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$M, 7);
          i0.ɵɵviewQuery(_c1$E, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortInput = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.limitInput = _t.first);
        }
      },
      hostBindings: function ListPageHeaderComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function ListPageHeaderComponent_click_HostBindingHandler($event) {
            return ctx.closeBatchOptions($event.target);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        isReload: "isReload"
      },
      standalone: false,
      attrs: _c2$y,
      decls: 2,
      vars: 2,
      consts: [["sortInput", ""], ["limitInput", ""], [4, "ngIf"], [1, "lst-head-l"], [1, "lst-cnt"], [1, "lst-head-r"], ["class", "lst-sortby", 4, "ngIf"], ["class", "lst-rpp display-mobile-none display-sm-none", 4, "ngIf"], [1, "lst-selectall"], ["type", "checkbox", 3, "click", "checked", "indeterminate"], [1, "lst-batch"], [1, "actions-menu-wrapper", "actions-menu-left", "batch-button"], [1, "actions-toggle-wrapper"], ["type", "button", "aria-haspopup", "true", 1, "actions-toggle", "cb-actions", "btn", "btn_primary", 3, "click", "focus", "ngClass", "disabled"], [1, "toggle-text"], [1, "icn-chevron_down"], [1, "icn-custom_setting"], ["role", "menu", 1, "actions-menu", 3, "ngClass"], ["class", "main-action split_btns", "role", "menuitem", 4, "ngFor", "ngForOf"], ["id", "menu-mobile", "role", "menu", 1, "actions-menu", "menu-mobile", 3, "ngClass"], ["class", "flexbox align-items-center justify-content-between", 4, "ngIf"], ["role", "menu", 3, "ngClass"], [4, "ngFor", "ngForOf"], ["id", "submenu-options", "role", "menu", 4, "ngIf"], ["role", "menuitem", 1, "main-action", "split_btns"], [1, "ListToolMenuLink", "space-between", 3, "click", "mouseover", "keyup.enter", "focus", "mouseout"], ["class", "icn-chevron_right no-margin-right", 4, "ngIf"], ["role", "menu", "class", "submenu", 3, "id", "ngClass", "mouseover", "mouseout", 4, "ngIf"], [1, "icn-chevron_right", "no-margin-right"], ["role", "menu", 1, "submenu", 3, "mouseover", "mouseout", "id", "ngClass"], ["class", "ListToolMenuLink", "role", "menuitem", 3, "click", "focus", "focusout", "keyup.enter", 4, "ngFor", "ngForOf"], ["role", "menuitem", 1, "ListToolMenuLink", 3, "click", "focus", "focusout", "keyup.enter"], [1, "flexbox", "align-items-center", "justify-content-between"], ["id", "btn_back", "class", "btn-reset padding-lg icn-chevron_left", 3, "click", "keyup.enter", 4, "ngIf"], ["role", "heading", "aria-live", "polite", 1, "text-bold"], ["id", "btn_close", 1, "btn-reset", "padding-lg", "icn-close", 3, "click", "keyup.enter"], ["id", "btn_back", 1, "btn-reset", "padding-lg", "icn-chevron_left", 3, "click", "keyup.enter"], ["role", "menuitem", "aria-owns", "submenu-options", 1, "main-action", "split_btns"], [1, "ListToolMenuLink", "flexbox", "align-items-center", "margin-left-auto", 3, "click", "keyup.enter", "keydown.tab"], ["class", "icn-chevron_right margin-left-auto", 4, "ngIf"], [1, "icn-chevron_right", "margin-left-auto"], ["id", "submenu-options", "role", "menu"], ["role", "menuitem", 1, "main-action", "split_btns", 3, "ngClass", "id"], ["class", "ListToolMenuLink", 3, "click", "keyup.enter", "keydown.tab", 4, "ngFor", "ngForOf"], [1, "ListToolMenuLink", 3, "click", "keyup.enter", "keydown.tab"], [1, "lst-btn"], ["class", "input-submit", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "input-submit", 3, "click", "ngClass"], [1, "lst-sortby"], [1, "btn", "btn_minimal"], ["role", "presentation", 1, "icn-sort_descend"], ["size", "1", 3, "change", "ngModel"], [3, "value", "selected", 4, "ngFor", "ngForOf"], [3, "value", "selected"], [1, "lst-rpp", "display-mobile-none", "display-sm-none"], [1, "font_weight_normal", "flexbox", "align-items-center"], ["size", "1", 1, "space-left-xs", 3, "change", "ngModel"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [1, "lst-head-l", "full_width"], [1, "skeleton-bar", "col-3", "no-margin"], [1, "skeleton-animation"], [1, "lst-head-r", "full_width"], [1, "inline-block", "space-right-lg"], [1, "skeleton-bar", "col-4", "no-margin"], [1, "skeleton-bar", "col-2", "no-margin", "display-mobile-none", "display-sm-none"]],
      template: function ListPageHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ListPageHeaderComponent_ng_container_0_Template, 10, 6, "ng-container", 2)(1, ListPageHeaderComponent_ng_container_1_Template, 10, 0, "ng-container", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.listPage.reloading);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.listPage.reloading);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$1.TranslatePipe, MinPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListPageHeaderComponent, [{
    type: Component,
    args: [{
      selector: '[list-page-header]',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<ng-container *ngIf=\"!listPage.reloading\">\n    <div class=\"lst-head-l\">\n        <ng-container *ngIf=\"listPage.useBatchOptions\">\n            <div class=\"lst-selectall\">\n                <input \n                    type=\"checkbox\"\n                    [attr.title]=\"(listPage.rowsSelections.checkedAll ? 'misc.Clear All' : 'misc.Select All') | translate\"\n                    [checked]=\"listPage.rowsSelections.checkedAll\"\n                    [indeterminate]=\"(listPage.rowsSelections.checkedAll && !!listPage.rowsSelections.uncheckedIdsAmount) || (!listPage.rowsSelections.checkedAll && !!listPage.rowsSelections.idsAmount)\"\n                    (click)=\"listPage.toggleCheckAll()\"\n                />\n            </div>\n            <div class=\"lst-batch\">\n                <div class=\"actions-menu-wrapper actions-menu-left batch-button\">\n                    <div class=\"actions-toggle-wrapper\">\n                        <button \n                            type=\"button\"\n                            class=\"actions-toggle cb-actions btn btn_primary\"\n                            aria-haspopup=\"true\" \n                            [attr.aria-expanded]=\"listPage.batchOptionsVisible\" \n                            [attr.aria-label]=\"(listPage.batchOptionsVisible ? 'misc.Close Actions Menu' : 'misc.Open Actions Menu') | translate\"\n                            [attr.aria-disabled]=\"listPage.batchOptionsDisabled\"\n                            [ngClass]=\"{ 'btn_disabled': listPage.batchOptionsDisabled }\"\n                            [disabled]=\"listPage.batchOptionsDisabled\"\n                            (click)=\"listPage.batchOptionsVisible = !listPage.batchOptionsVisible\"\n                            (focus)=\"listPage.batchOptionsVisible = false\"\n                        >\n                            <span class=\"toggle-text\">\n                                {{ listPage.currentMenu | translate }}\n                                <i class=\"icn-chevron_down\"></i>\n                            </span>\n                            <i class=\"icn-custom_setting\"></i>\n                        </button>\n                        <div class=\"actions-menu\" role=\"menu\" [attr.aria-label]=\"'misc.Actions Menu' | translate\" [ngClass]=\"{'menu-show': listPage.batchOptionsVisible && !listPage.isMobileScreen}\">\n                            <div *ngFor=\"let option of listPage.batchOptions; let lastMenu = last; let i = index;\" class=\"main-action split_btns\" role=\"menuitem\" [attr.aria-expanded]=\"option.submenus !== undefined ? option.submenus.show : ''\" [attr.aria-controls]=\"'submenu_container_' + i\">\n                                <a \n                                    class=\"ListToolMenuLink space-between\" \n                                    (click)=\"listPage.optionClicked(option);\" \n                                    (mouseover)=\"listPage.showSubmenu(true, option)\" \n                                    (keyup.enter)=\"listPage.showSubmenu(true, option)\" \n                                    (focus)=\"listPage.showSubmenu(true, option)\" \n                                    (mouseout)=\"listPage.showSubmenu(false, option)\" \n                                    [attr.tabindex]=\"0\"\n                                    (keyup.enter)=\"option.submenus === undefined ? listPage.optionClicked(option) : null\"\n                                >\n                                    {{ option.label | translate }}\n                                    <span *ngIf=\"option.submenus !== undefined\" class=\"icn-chevron_right no-margin-right\"></span>\n                                </a>\n                                <div [id]=\"'submenu_container_' + i\" role=\"menu\" *ngIf=\"option.submenus !== undefined\" class=\"submenu\" [ngClass]=\"{'hide': option.submenus.show === undefined || !option.submenus.show}\" (mouseover)=\"listPage.showSubmenu(true, option)\" (mouseout)=\"listPage.showSubmenu(false, option)\">\n                                    <a\n                                        *ngFor=\"let menu of option.submenus;let lastSubmenu = last;\" \n                                        class=\"ListToolMenuLink\" \n                                        (click)=\"menu.onClick(listPage.rowsSelections); listPage.closeMenu(true);\" \n                                        (focus)=\"listPage.showSubmenu(true, option)\" \n                                        [attr.tabindex]=\"option.submenus.show ? '0' : '-1'\" \n                                        (focusout)=\"lastSubmenu && lastMenu ? listPage.closeMenu(true) : null\"\n                                        (keyup.enter)=\"menu.onClick(listPage.rowsSelections); listPage.closeMenu(true);\"\n                                        role=\"menuitem\"\n                                    >\n                                        {{ menu.label }}\n                                    </a>\n                                </div>\n                            </div>\n                        </div>\n                        <div id=\"menu-mobile\" class=\"actions-menu menu-mobile\" role=\"menu\" [attr.aria-label]=\"'misc.Actions Menu' | translate\" [ngClass]=\"listPage.batchOptionsVisible && listPage.isMobileScreen ? 'show' : 'hide'\">\n                            <div class=\"flexbox align-items-center justify-content-between\" *ngIf=\"listPage.isMobileScreen\">\n                                <button *ngIf=\"listPage.showSubmenusMobile\" id=\"btn_back\" class=\"btn-reset padding-lg icn-chevron_left\" (click)=\"listPage.closeMenu(false)\" (keyup.enter)=\"listPage.closeMenu(false)\" [attr.aria-label]=\"'misc.Go Back to' | translate\"></button>\n                                <span class=\"text-bold\" role=\"heading\" aria-live=\"polite\">{{ listPage.currentMenu | translate }}</span>\n                                <button id=\"btn_close\" class=\"btn-reset padding-lg icn-close\" (click)=\"listPage.closeMenu(true);\" (keyup.enter)=\"listPage.closeMenu(true)\" [attr.aria-label]=\"'misc.Close Actions Menu' | translate\"></button>\n                            </div>\n                            <div [ngClass]=\"listPage.showSubmenusMobile ? 'hide' : 'show'\" role=\"menu\">\n                                <ng-container *ngFor=\"let option of listPage.batchOptions; let i = index;let lastMobileMenu = last;\">\n                                    <div class=\"main-action split_btns\" role=\"menuitem\" aria-owns=\"submenu-options\" [attr.aria-controls]=\"'submenu_mobile_container_' + i\" [attr.aria-expanded]=\"option.submenus !== undefined && listPage.showSubmenusMobile && option.submenus.show\">\n                                        <a \n                                            class=\"ListToolMenuLink flexbox align-items-center margin-left-auto\" \n                                            (click)=\"listPage.optionClicked(option);\"\n                                            [attr.tabindex]=\"0\"\n                                            (keyup.enter)=\"listPage.optionClicked(option)\"\n                                            (keydown.tab)=\"lastMobileMenu ? listPage.closeMenu(true) : null\"\n                                        >\n                                            {{ option.label | translate }}\n                                            <span *ngIf=\"option.submenus !== undefined\" class=\"icn-chevron_right margin-left-auto\"></span>\n                                        </a>\n                                    </div>\n                                </ng-container>\n                            </div>\n                            <div *ngIf=\"listPage.showSubmenusMobile\" id=\"submenu-options\" role=\"menu\">\n                                <ng-container *ngFor=\"let option of listPage.batchOptions; let i = index;\">\n                                    <div [ngClass]=\"option.submenus !== undefined && listPage.isMobileScreen && option.submenus.show !== undefined && option.submenus.show ? 'show' : 'hide'\" class=\"main-action split_btns\" role=\"menuitem\" [id]=\"'submenu_mobile_container_' + i\">\n                                        <a \n                                            *ngFor=\"let menu of option.submenus;let lastMobileSubmenu = last\"\n                                            class=\"ListToolMenuLink\" \n                                            (click)=\"listPage.optionClicked(menu)\"\n                                            (keyup.enter)=\"listPage.optionClicked(menu)\"\n                                            [attr.tabindex]=\"option.submenus.show ? '0' : '-1'\"\n                                            (keydown.tab)=\"lastMobileSubmenu ? listPage.closeMenu(true) : null\"\n                                        >\n                                            {{ menu.label }}\n                                        </a>\n                                    </div>\n                                </ng-container>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </ng-container>\n        <ng-container *ngIf=\"useListButton\">\n            <span class=\"lst-btn\">\n                <button *ngFor=\"let button of listButtons\" [attr.type]=\"button.type\" class=\"input-submit\" [ngClass]=\"button.class\" (click)=\"button.onClick(button.action)\">{{button.label}}</button>\n            </span>\n        </ng-container>\n        <span class=\"lst-cnt\">\n            <ng-container *ngIf=\"listPage.rowsSelections.checkedAll || (!listPage.rowsSelections.checkedAll && listPage.rowsSelections.idsAmount)\">\n                {{\n                    'misc.Number of results selected' | translate: {\n                        selectedRows: listPage.rowsSelections.checkedAll ? (listPage.totalCount - listPage.rowsSelections.uncheckedIdsAmount) : listPage.rowsSelections.idsAmount,\n                        totalCount: listPage.totalCount\n                    }\n                }}\n            </ng-container>\n\n            <ng-container *ngIf=\"!listPage.rowsSelections.checkedAll && listPage.rowsSelections.idsAmount === 0\">\n\n                <ng-container *ngIf=\"listPage.totalCount <= limit\">\n                    {{ listPage.totalCount }}\n                </ng-container>\n    \n                <ng-container *ngIf=\"listPage.totalCount > limit\">\n                    {{\n                        'misc.List items range' | translate: {\n                            start: (listPage.offset + 1),\n                            end: [listPage.offset + (+listPage.perPage) , listPage.totalCount] | min,\n                            total: listPage.totalCount\n                        }\n                    }}\n                </ng-container>\n                \n                {{ listPage.resultString | translate : { numrows: listPage.totalCount }  }}\n\n            </ng-container>\n        </span>\n    </div>\n    <div class=\"lst-head-r\">\n        <span class=\"lst-sortby\" *ngIf=\"listPage.displaySort\">\n            <div class=\"btn btn_minimal\">\n                <span class=\"icn-sort_descend\" role=\"presentation\"></span>\n                <select #sortInput\n                        [ngModel]=\"sortBy\"\n                        [attr.aria-label]=\"'misc.Sort by' | translate\"\n                        (change)=\"sortBy = sortInput.value\"\n                        size=\"1\">\n                    <option *ngFor=\"let option of sorts\" [value]=\"option.id\" [selected]=\"option.id == sortBy\">{{option.title | translate}}</option>\n                </select>\n            </div>\n        </span>\n        <span *ngIf=\"listPage.displayPerPage\" class=\"lst-rpp display-mobile-none display-sm-none\">\n            <div class=\"btn btn_minimal\">\n                <label class=\"font_weight_normal flexbox align-items-center\" [attr.aria-label]=\"'misc.Number of Items Showing' | translate\">{{'misc.Show' | translate}}\n                    <select #limitInput\n                            [ngModel]=\"limit\"\n                            (change)=\"limit = listPage.asNumber(limitInput.value)\"\n                            class=\"space-left-xs\"\n                            size=\"1\">\n                        <option *ngFor=\"let pp of perPage\" [value]=\"pp\" [attr.selected]=\"limitSelect(pp, limit)\">{{pp}}</option>\n                    </select>\n                </label>\n            </div>\n        </span>\n    </div>\n</ng-container>\n\n<ng-container *ngIf=\"listPage.reloading\">\n    <div class=\"lst-head-l full_width\">\n        <div class=\"skeleton-bar col-3 no-margin\">\n            <span class=\"skeleton-animation\"></span>\n        </div>\n    </div>\n    <div class=\"lst-head-r full_width\">\n        <div class=\"inline-block space-right-lg\">\n            <div class=\"skeleton-bar col-4 no-margin\">\n                <span class=\"skeleton-animation\"></span>\n            </div>\n        </div>\n        <div class=\"skeleton-bar col-2 no-margin display-mobile-none display-sm-none\">\n            <span class=\"skeleton-animation\"></span>\n        </div>\n    </div>\n</ng-container>"
    }]
  }], () => [{
    type: ListPageComponent,
    decorators: [{
      type: Inject,
      args: [forwardRef(() => ListPageComponent)]
    }]
  }], {
    sortInput: [{
      type: ViewChild,
      args: ['sortInput', {
        static: true
      }]
    }],
    limitInput: [{
      type: ViewChild,
      args: ['limitInput', {
        static: true
      }]
    }],
    closeBatchOptions: [{
      type: HostListener,
      args: ['document:click', ['$event.target']]
    }],
    isReload: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ListPageHeaderComponent, {
    className: "ListPageHeaderComponent",
    filePath: "valkyrie/list-page/list-page-header.component.ts",
    lineNumber: 11
  });
})();
const _c0$L = ["list-page-row-standard", ""];
const _c1$D = (a0, a1) => ({
  "avatar-square": a0,
  "monogram": a1
});
const _c2$x = (a0, a1) => ({
  "background-image": a0,
  "background-position": a1
});
const _c3$m = (a0, a1) => ({
  item: a0,
  idx: a1,
  fieldKey: "title",
  class: "inline-block space-right-xs"
});
const _c4$k = (a0, a1, a2) => ({
  item: a0,
  class: "badge badge-small no-margin",
  idx: a1,
  fidx: a2
});
const _c5$d = (a0, a1, a2) => ({
  item: a0,
  idx: a1,
  fidx: a2
});
const _c6$9 = (a0, a1, a2) => ({
  item: a0,
  idx: a1,
  fidx: a2,
  fieldKey: "actionButtons"
});
const _c7$6 = (a0, a1, a2) => ({
  item: a0,
  class: "space-bottom-sm",
  idx: a1,
  fidx: a2
});
const _c8$5 = (a0, a1, a2) => ({
  item: a0,
  class: "block",
  idx: a1,
  fidx: a2
});
const _c9$5 = (a0, a1, a2, a3, a4, a5) => ({
  item: a0,
  idx: a1,
  fidx: a2,
  fieldKey: a3,
  value: a4,
  class: a5
});
const _c10$4 = () => ({
  class: ""
});
const _c11$3 = a0 => ({
  class: a0
});
const _c12$2 = a0 => ({
  length: a0
});
const _c13$2 = () => ({
  length: 2,
  class: "inline-block  space-right-md margin-bottom-auto"
});
const _c14$2 = () => ({
  length: 5,
  class: ""
});
const _c15$1 = () => ({
  class: "skeleton-circle inline-block"
});
const _c16$1 = a0 => ({
  item: a0
});
function ListPageRowStandardComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 20)(2, "label", 21);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "input", 22);
    i0.ɵɵlistener("click", function ListPageRowStandardComponent_ng_container_0_ng_container_1_Template_input_click_5_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setCheckbox($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("for", "list-checkbox-", ctx_r1.itemIndex, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, "misc.Select this item"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "list-checkbox-", ctx_r1.itemIndex, "");
    i0.ɵɵproperty("checked", ctx_r1.isPresentSelectedRows());
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_2_div_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1._item.monogram.label);
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_2_div_2_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r1._item.monogram.src);
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_2_div_2_img_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 28);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("src", ctx_r1._item.monogram.src, i0.ɵɵsanitizeUrl);
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_2_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵelement(2, "i");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 26);
    i0.ɵɵtemplate(4, ListPageRowStandardComponent_ng_container_0_ng_container_2_div_2_ng_container_4_Template, 2, 1, "ng-container", 13)(5, ListPageRowStandardComponent_ng_container_0_ng_container_2_div_2_span_5_Template, 1, 3, "span", 24)(6, ListPageRowStandardComponent_ng_container_0_ng_container_2_div_2_img_6_Template, 1, 1, "img", 27);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r1._item.monogram.styleClass, " avatar-group");
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("avatar-status ", ctx_r1._item.monogram.statusClass, "");
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1._item.monogram.statusIcon);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("avatar ", ctx_r1._item.monogram.styleClass, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(17, _c1$D, ctx_r1._item.monogram.isSquare, ctx_r1._item.monogram.type !== "image"))("autocolor", ctx_r1._item.monogram.autoColor && ctx_r1._item.monogram.type === "icon" ? ctx_r1._item.monogram.autoColor : "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._item.monogram.type === "label" && ctx_r1._item.monogram.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._item.monogram.type === "icon" && ctx_r1._item.monogram.src);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._item.monogram.type === "image" && ctx_r1._item.monogram.src);
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_2_div_3_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1._item.monogram.label);
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_2_div_3_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r1._item.monogram.src);
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_2_div_3_img_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 28);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("src", ctx_r1._item.monogram.src, i0.ɵɵsanitizeUrl);
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_2_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_ng_container_2_div_3_span_1_Template, 2, 1, "span", 29)(2, ListPageRowStandardComponent_ng_container_0_ng_container_2_div_3_span_2_Template, 1, 3, "span", 24)(3, ListPageRowStandardComponent_ng_container_0_ng_container_2_div_3_img_3_Template, 1, 1, "img", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("avatar ", ctx_r1._item.monogram.styleClass, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c1$D, ctx_r1._item.monogram.isSquare, ctx_r1._item.monogram.type !== "image"))("autocolor", ctx_r1._item.monogram.autoColor && ctx_r1._item.monogram.type !== "image" ? ctx_r1._item.monogram.autoColor : "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._item.monogram.type === "label" && ctx_r1._item.monogram.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._item.monogram.type === "icon" && ctx_r1._item.monogram.src);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._item.monogram.type === "image" && ctx_r1._item.monogram.src);
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵtemplate(2, ListPageRowStandardComponent_ng_container_0_ng_container_2_div_2_Template, 7, 20, "div", 24)(3, ListPageRowStandardComponent_ng_container_0_ng_container_2_div_3_Template, 4, 11, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1._item.monogram.statusIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1._item.monogram.statusIcon);
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", null, 11);
    i0.ɵɵelement(3, "div", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("thumbnailbox thumbnailbox-image space-right-lg ", ctx_r1._item.thumbnails.styleClass, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(4, _c2$x, "url(" + ctx_r1._item.thumbnails.src + ")", ctx_r1._item.thumbnails.imagePosition));
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_3_ng_container_2_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 34);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", ctx_r1._item.thumbnails.src);
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 32, 11);
    i0.ɵɵtemplate(3, ListPageRowStandardComponent_ng_container_0_ng_container_3_ng_container_2_i_3_Template, 1, 1, "i", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("thumbnailbox thumbnailbox-icon space-right-lg flexbox justified-content-center align-items-center ", ctx_r1._item.thumbnails.styleClass, "");
    i0.ɵɵproperty("autocolor", ctx_r1._item.thumbnails.autoColor ? ctx_r1._item.thumbnails.autoColor : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1._item.thumbnails.type == "icon");
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_ng_container_3_ng_container_1_Template, 4, 7, "ng-container", 13)(2, ListPageRowStandardComponent_ng_container_0_ng_container_3_ng_container_2_Template, 4, 5, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._item.thumbnails.type == "image");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._item.thumbnails.type == "icon");
  }
}
function ListPageRowStandardComponent_ng_container_0_div_5_ng_container_1_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_div_5_ng_container_1_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    const text_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", text_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c3$m, ctx_r1._item.title, ctx_r1.itemIndex));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_5_ng_container_2_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_div_5_ng_container_2_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    const info_r4 = i0.ɵɵreference(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", info_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c3$m, ctx_r1._item.title, ctx_r1.itemIndex));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_5_ng_container_3_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_5_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_div_5_ng_container_3_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    const anchor_r5 = i0.ɵɵreference(17);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", anchor_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c3$m, ctx_r1._item.title, ctx_r1.itemIndex));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_5_ng_template_4_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_5_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_div_5_ng_template_4_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const fidx_r7 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const info_r4 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", info_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c4$k, item_r6, ctx_r1.itemIndex, fidx_r7));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_div_5_ng_container_1_Template, 2, 5, "ng-container", 13)(2, ListPageRowStandardComponent_ng_container_0_div_5_ng_container_2_Template, 2, 5, "ng-container", 13)(3, ListPageRowStandardComponent_ng_container_0_div_5_ng_container_3_Template, 2, 5, "ng-container", 13)(4, ListPageRowStandardComponent_ng_container_0_div_5_ng_template_4_Template, 1, 6, "ng-template", 36);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.textTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.rowAnchor.enable && !ctx_r1.listPage.textTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.listPage.rowAnchor.enable && !ctx_r1.listPage.textTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1._item.titleTags);
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_6_2_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_ng_container_6_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_ng_container_6_2_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const item_r9 = ctx_r7.$implicit;
    const fidx_r10 = ctx_r7.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    const info_r4 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", info_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c5$d, item_r9, ctx_r1.itemIndex, fidx_r10));
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_6_3_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_ng_container_6_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_ng_container_6_3_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const item_r9 = ctx_r7.$implicit;
    const fidx_r10 = ctx_r7.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    const infoSafe_r11 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", infoSafe_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c5$d, item_r9, ctx_r1.itemIndex, fidx_r10));
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_6_4_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_ng_container_6_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_ng_container_6_4_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const item_r9 = ctx_r7.$implicit;
    const fidx_r10 = ctx_r7.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    const icon_r12 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngTemplateOutlet", icon_r12)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c5$d, item_r9, ctx_r1.itemIndex, fidx_r10));
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_6_5_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_ng_container_6_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_ng_container_6_5_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const item_r9 = ctx_r7.$implicit;
    const fidx_r10 = ctx_r7.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    const anchor_r5 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", anchor_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c5$d, item_r9, ctx_r1.itemIndex, fidx_r10));
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_6_6_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_ng_container_6_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_ng_container_6_6_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const item_r9 = ctx_r7.$implicit;
    const fidx_r10 = ctx_r7.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    const button_r13 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngTemplateOutlet", button_r13)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c5$d, item_r9, ctx_r1.itemIndex, fidx_r10));
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_6_7_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_ng_container_6_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_ng_container_6_7_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const item_r9 = ctx_r7.$implicit;
    const fidx_r10 = ctx_r7.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    const buttonLink_r14 = i0.ɵɵreference(15);
    i0.ɵɵproperty("ngTemplateOutlet", buttonLink_r14)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c5$d, item_r9, ctx_r1.itemIndex, fidx_r10));
  }
}
function ListPageRowStandardComponent_ng_container_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 38);
    i0.ɵɵtemplate(2, ListPageRowStandardComponent_ng_container_0_ng_container_6_2_Template, 1, 6, null, 39)(3, ListPageRowStandardComponent_ng_container_0_ng_container_6_3_Template, 1, 6, null, 39)(4, ListPageRowStandardComponent_ng_container_0_ng_container_6_4_Template, 1, 6, null, 39)(5, ListPageRowStandardComponent_ng_container_0_ng_container_6_5_Template, 1, 6, null, 39)(6, ListPageRowStandardComponent_ng_container_0_ng_container_6_6_Template, 1, 6, null, 39)(7, ListPageRowStandardComponent_ng_container_0_ng_container_6_7_Template, 1, 6, null, 39);
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const item_r9 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", item_r9.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "text");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "textSafe");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "icon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "anchor");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "buttonLink");
  }
}
function ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_2_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_2_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    const item_r16 = ctx_r14.$implicit;
    const fidx_r17 = ctx_r14.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const anchor_r5 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", anchor_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6$9, item_r16, ctx_r1.itemIndex, fidx_r17));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_3_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_3_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    const item_r16 = ctx_r14.$implicit;
    const fidx_r17 = ctx_r14.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const button_r13 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngTemplateOutlet", button_r13)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6$9, item_r16, ctx_r1.itemIndex, fidx_r17));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_4_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_4_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    const item_r16 = ctx_r14.$implicit;
    const fidx_r17 = ctx_r14.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const buttonLink_r14 = i0.ɵɵreference(15);
    i0.ɵɵproperty("ngTemplateOutlet", buttonLink_r14)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6$9, item_r16, ctx_r1.itemIndex, fidx_r17));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 38);
    i0.ɵɵtemplate(2, ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_2_Template, 1, 6, null, 39)(3, ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_3_Template, 1, 6, null, 39)(4, ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_4_Template, 1, 6, null, 39);
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const item_r16 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", item_r16.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "anchor");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "buttonLink");
  }
}
function ListPageRowStandardComponent_ng_container_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_div_7_ng_container_1_Template, 5, 4, "ng-container", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1._item.actionButtons);
  }
}
function ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_2_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_2_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    const item_r19 = ctx_r17.$implicit;
    const fidx_r20 = ctx_r17.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const anchor_r5 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", anchor_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6$9, item_r19, ctx_r1.itemIndex, fidx_r20));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_3_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_3_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    const item_r19 = ctx_r17.$implicit;
    const fidx_r20 = ctx_r17.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const button_r13 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngTemplateOutlet", button_r13)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6$9, item_r19, ctx_r1.itemIndex, fidx_r20));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_4_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_4_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    const item_r19 = ctx_r17.$implicit;
    const fidx_r20 = ctx_r17.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    const buttonLink_r14 = i0.ɵɵreference(15);
    i0.ɵɵproperty("ngTemplateOutlet", buttonLink_r14)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6$9, item_r19, ctx_r1.itemIndex, fidx_r20));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 38);
    i0.ɵɵtemplate(2, ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_2_Template, 1, 6, null, 39)(3, ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_3_Template, 1, 6, null, 39)(4, ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_4_Template, 1, 6, null, 39);
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const item_r19 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", item_r19.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "anchor");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "buttonLink");
  }
}
function ListPageRowStandardComponent_ng_container_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_div_8_ng_container_1_Template, 5, 4, "ng-container", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1._item.absoluteButtons);
  }
}
function ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_1_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_1_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext();
    const item_r22 = ctx_r20.$implicit;
    const fidx_r23 = ctx_r20.index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    const info_r4 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", info_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c7$6, item_r22, ctx_r1.itemIndex, fidx_r23));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_2_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_2_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext();
    const item_r22 = ctx_r20.$implicit;
    const fidx_r23 = ctx_r20.index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    const anchor_r5 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", anchor_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c7$6, item_r22, ctx_r1.itemIndex, fidx_r23));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_3_ng_template_0_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_3_ng_template_0_Template, 0, 0, "ng-template", 37);
  }
  if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext();
    const item_r22 = ctx_r20.$implicit;
    const fidx_r23 = ctx_r20.index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    const button_r13 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngTemplateOutlet", button_r13)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c8$5, item_r22, ctx_r1.itemIndex, fidx_r23));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 38);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_1_Template, 1, 6, null, 39)(2, ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_2_Template, 1, 6, null, 39)(3, ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_3_Template, 1, 6, null, 39);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r22 = ctx.$implicit;
    i0.ɵɵproperty("ngSwitch", item_r22.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "text");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "anchor");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "button");
  }
}
function ListPageRowStandardComponent_ng_container_0_div_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_div_9_div_1_ng_template_1_Template, 4, 4, "ng-template", 36);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1._item.sidebar);
  }
}
function ListPageRowStandardComponent_ng_container_0_div_9_div_2_ng_container_1_ng_template_2_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_9_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 47);
    i0.ɵɵtemplate(2, ListPageRowStandardComponent_ng_container_0_div_9_div_2_ng_container_1_ng_template_2_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const iconbtn_r24 = ctx.$implicit;
    const i_r25 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    const iconButton_r26 = i0.ɵɵreference(19);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "iconbutton-", i_r25, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", iconButton_r26)("ngTemplateOutletContext", i0.ɵɵpureFunction6(4, _c9$5, iconbtn_r24, ctx_r1.itemIndex, i_r25, iconbtn_r24.id, iconbtn_r24.value, "auto_width " + iconbtn_r24.icon));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_9_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_div_9_div_2_ng_container_1_Template, 3, 11, "ng-container", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1._item.iconButtons);
  }
}
function ListPageRowStandardComponent_ng_container_0_div_9_ng_container_3_li_10_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_0_div_9_ng_container_3_li_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_div_9_ng_container_3_li_10_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r27 = ctx.$implicit;
    const fidx_r28 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    const anchor_r5 = i0.ɵɵreference(17);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", anchor_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6$9, item_r27, ctx_r1.itemIndex, fidx_r28));
  }
}
function ListPageRowStandardComponent_ng_container_0_div_9_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 48)(2, "div", 49);
    i0.ɵɵelement(3, "button", 50);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementStart(7, "div", 51);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementStart(9, "ul", 52);
    i0.ɵɵtemplate(10, ListPageRowStandardComponent_ng_container_0_div_9_ng_container_3_li_10_Template, 2, 6, "li", 16);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 5, "misc.Open Actions Menu"))("label-closed", i0.ɵɵpipeBind1(5, 7, "misc.Open Actions Menu"))("label-opened", i0.ɵɵpipeBind1(6, 9, "misc.Close Actions Menu"));
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(8, 11, "misc.Actions Menu"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1._item.actionButtons);
  }
}
function ListPageRowStandardComponent_ng_container_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_div_9_div_1_Template, 2, 1, "div", 43)(2, ListPageRowStandardComponent_ng_container_0_div_9_div_2_Template, 2, 1, "div", 44)(3, ListPageRowStandardComponent_ng_container_0_div_9_ng_container_3_Template, 11, 13, "ng-container", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.item.sidebar);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._item.iconButtons && ctx_r1._item.iconButtons.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._item.actionButtons);
  }
}
function ListPageRowStandardComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_0_ng_container_1_Template, 6, 8, "ng-container", 13)(2, ListPageRowStandardComponent_ng_container_0_ng_container_2_Template, 4, 2, "ng-container", 13)(3, ListPageRowStandardComponent_ng_container_0_ng_container_3_Template, 3, 2, "ng-container", 13);
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵtemplate(5, ListPageRowStandardComponent_ng_container_0_div_5_Template, 5, 4, "div", 15)(6, ListPageRowStandardComponent_ng_container_0_ng_container_6_Template, 8, 7, "ng-container", 16)(7, ListPageRowStandardComponent_ng_container_0_div_7_Template, 2, 1, "div", 17)(8, ListPageRowStandardComponent_ng_container_0_div_8_Template, 2, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ListPageRowStandardComponent_ng_container_0_div_9_Template, 4, 3, "div", 19);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.checkbox);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._item.monogram);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._item.thumbnails);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1._item.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1._item.texts);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.item.actionButtons);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.item.absoluteButtons);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.item.sidebar || ctx_r1._item.iconButtons && ctx_r1._item.iconButtons.length);
  }
}
function ListPageRowStandardComponent_ng_container_1_ng_container_1_ng_template_2_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵtemplate(2, ListPageRowStandardComponent_ng_container_1_ng_container_1_ng_template_2_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const skeletonFill_r29 = i0.ɵɵreference(23);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", skeletonFill_r29)("ngTemplateOutletContext", i0.ɵɵpureFunction0(2, _c10$4));
  }
}
function ListPageRowStandardComponent_ng_container_1_ng_container_2_ng_template_2_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵtemplate(2, ListPageRowStandardComponent_ng_container_1_ng_container_2_ng_template_2_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const skeletonFill_r29 = i0.ɵɵreference(23);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", skeletonFill_r29)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c11$3, "avatar " + ctx_r1.listPage.skeleton.thumbnailsStyle));
  }
}
function ListPageRowStandardComponent_ng_container_1_ng_container_4_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_1_ng_container_4_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const i_r30 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    const skeletonBar_r31 = i0.ɵɵreference(21);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", skeletonBar_r31)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c12$2, ctx_r1.getSkeletonWidth(i_r30)));
  }
}
function ListPageRowStandardComponent_ng_container_1_div_5_ng_container_1_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_1_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_1_div_5_ng_container_1_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const skeletonBar_r31 = i0.ɵɵreference(21);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", skeletonBar_r31)("ngTemplateOutletContext", i0.ɵɵpureFunction0(2, _c13$2));
  }
}
function ListPageRowStandardComponent_ng_container_1_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_1_div_5_ng_container_1_Template, 2, 3, "ng-container", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.skeletonNumber(ctx_r1.listPage.skeleton.actionButtons));
  }
}
function ListPageRowStandardComponent_ng_container_1_div_6_ng_container_2_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_1_div_6_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_1_div_6_ng_container_2_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const skeletonBar_r31 = i0.ɵɵreference(21);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", skeletonBar_r31)("ngTemplateOutletContext", i0.ɵɵpureFunction0(2, _c14$2));
  }
}
function ListPageRowStandardComponent_ng_container_1_div_6_ng_container_3_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_container_1_div_6_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_1_div_6_ng_container_3_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const skeletonFill_r29 = i0.ɵɵreference(23);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", skeletonFill_r29)("ngTemplateOutletContext", i0.ɵɵpureFunction0(2, _c15$1));
  }
}
function ListPageRowStandardComponent_ng_container_1_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54)(1, "div", 55);
    i0.ɵɵtemplate(2, ListPageRowStandardComponent_ng_container_1_div_6_ng_container_2_Template, 2, 3, "ng-container", 16)(3, ListPageRowStandardComponent_ng_container_1_div_6_ng_container_3_Template, 2, 3, "ng-container", 16);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.skeletonNumber(ctx_r1.listPage.skeleton.sidebar));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.skeletonNumber(ctx_r1.listPage.skeleton.iconBtn));
  }
}
function ListPageRowStandardComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_container_1_ng_container_1_Template, 3, 3, "ng-container", 13)(2, ListPageRowStandardComponent_ng_container_1_ng_container_2_Template, 3, 4, "ng-container", 13);
    i0.ɵɵelementStart(3, "div", 14);
    i0.ɵɵtemplate(4, ListPageRowStandardComponent_ng_container_1_ng_container_4_Template, 2, 4, "ng-container", 16)(5, ListPageRowStandardComponent_ng_container_1_div_5_Template, 2, 1, "div", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ListPageRowStandardComponent_ng_container_1_div_6_Template, 4, 2, "div", 53);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.skeleton.checkbox);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.skeleton.thumbnails);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.skeletonNumber(ctx_r1.listPage.skeleton.texts));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.skeleton.actionButtons);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.skeleton.sidebar);
  }
}
function ListPageRowStandardComponent_ng_template_2_i_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const item_r32 = i0.ɵɵnextContext().item;
    i0.ɵɵclassMap(item_r32.icon);
  }
}
function ListPageRowStandardComponent_ng_template_2_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 57);
  }
  if (rf & 2) {
    const item_r32 = i0.ɵɵnextContext().item;
    i0.ɵɵproperty("innerHTML", item_r32.label, i0.ɵɵsanitizeHtml);
  }
}
function ListPageRowStandardComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_template_2_i_0_Template, 1, 3, "i", 24)(1, ListPageRowStandardComponent_ng_template_2_span_1_Template, 1, 1, "span", 56);
  }
  if (rf & 2) {
    const item_r32 = ctx.item;
    i0.ɵɵproperty("ngIf", item_r32.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r32.label);
  }
}
function ListPageRowStandardComponent_ng_template_4_i_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const item_r33 = i0.ɵɵnextContext().item;
    i0.ɵɵclassMap(item_r33.icon);
  }
}
function ListPageRowStandardComponent_ng_template_4_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 57);
    i0.ɵɵpipe(1, "safeHtml");
  }
  if (rf & 2) {
    const item_r33 = i0.ɵɵnextContext().item;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, item_r33.label), i0.ɵɵsanitizeHtml);
  }
}
function ListPageRowStandardComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_template_4_i_0_Template, 1, 3, "i", 24)(1, ListPageRowStandardComponent_ng_template_4_span_1_Template, 2, 3, "span", 56);
  }
  if (rf & 2) {
    const item_r33 = ctx.item;
    i0.ɵɵproperty("ngIf", item_r33.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r33.label);
  }
}
function ListPageRowStandardComponent_ng_template_6_div_0_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_template_6_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_template_6_div_0_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext();
    const item_r35 = ctx_r33.item;
    const class_r36 = ctx_r33.class;
    const idx_r37 = ctx_r33.idx;
    const fidx_r38 = ctx_r33.fidx;
    i0.ɵɵnextContext();
    const text_r3 = i0.ɵɵreference(3);
    i0.ɵɵclassMapInterpolate2("", class_r36, " ", item_r35.styleClass, "");
    i0.ɵɵattribute("list-item-index", idx_r37)("field-item-index", fidx_r38);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", text_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c16$1, item_r35));
  }
}
function ListPageRowStandardComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_template_6_div_0_Template, 2, 10, "div", 24);
  }
  if (rf & 2) {
    const item_r35 = ctx.item;
    i0.ɵɵproperty("ngIf", item_r35.label);
  }
}
function ListPageRowStandardComponent_ng_template_8_div_0_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_template_8_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_template_8_div_0_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext();
    const item_r40 = ctx_r38.item;
    const class_r41 = ctx_r38.class;
    const idx_r42 = ctx_r38.idx;
    const fidx_r43 = ctx_r38.fidx;
    i0.ɵɵnextContext();
    const textSafe_r44 = i0.ɵɵreference(5);
    i0.ɵɵclassMapInterpolate2("", class_r41, " ", item_r40.styleClass, "");
    i0.ɵɵattribute("list-item-index", idx_r42)("field-item-index", fidx_r43);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", textSafe_r44)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c16$1, item_r40));
  }
}
function ListPageRowStandardComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_template_8_div_0_Template, 2, 10, "div", 24);
  }
  if (rf & 2) {
    const item_r40 = ctx.item;
    i0.ɵɵproperty("ngIf", item_r40.label);
  }
}
function ListPageRowStandardComponent_ng_template_10_div_0_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_template_10_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_template_10_div_0_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext();
    const item_r46 = ctx_r44.item;
    const class_r47 = ctx_r44.class;
    const idx_r48 = ctx_r44.idx;
    const fidx_r49 = ctx_r44.fidx;
    i0.ɵɵnextContext();
    const text_r3 = i0.ɵɵreference(3);
    i0.ɵɵclassMapInterpolate2("", class_r47, " ", item_r46.styleClass, "");
    i0.ɵɵattribute("list-item-index", idx_r48)("field-item-index", fidx_r49);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", text_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c16$1, item_r46));
  }
}
function ListPageRowStandardComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_template_10_div_0_Template, 2, 10, "div", 24);
  }
  if (rf & 2) {
    const item_r46 = ctx.item;
    i0.ɵɵproperty("ngIf", item_r46.icon);
  }
}
function ListPageRowStandardComponent_ng_template_12_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 58);
    i0.ɵɵlistener("click", function ListPageRowStandardComponent_ng_template_12_Template_button_click_0_listener($event) {
      const ctx_r50 = i0.ɵɵrestoreView(_r50);
      const item_r52 = ctx_r50.item;
      const idx_r53 = ctx_r50.idx;
      $event.preventDefault();
      return i0.ɵɵresetView(item_r52.onClick(item_r52, idx_r53, $event));
    })("keyup.enter", function ListPageRowStandardComponent_ng_template_12_Template_button_keyup_enter_0_listener($event) {
      const ctx_r53 = i0.ɵɵrestoreView(_r50);
      const item_r52 = ctx_r53.item;
      const idx_r53 = ctx_r53.idx;
      $event.preventDefault();
      return i0.ɵɵresetView(item_r52.onClick(item_r52, idx_r53, $event));
    });
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_template_12_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r52 = ctx.item;
    const idx_r53 = ctx.idx;
    const fidx_r55 = ctx.fidx;
    const class_r56 = ctx.class;
    i0.ɵɵnextContext();
    const text_r3 = i0.ɵɵreference(3);
    i0.ɵɵclassMapInterpolate1("btn ", class_r56, "");
    i0.ɵɵproperty("ngClass", item_r52.styleClass)("disabled", item_r52.disabled);
    i0.ɵɵattribute("aria-label", item_r52.ariaLabel ? item_r52.ariaLabel : null)("list-item-index", idx_r53)("field-item-index", fidx_r55);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", text_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(10, _c16$1, item_r52));
  }
}
function ListPageRowStandardComponent_ng_template_14_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 58);
    i0.ɵɵlistener("click", function ListPageRowStandardComponent_ng_template_14_Template_button_click_0_listener($event) {
      const item_r58 = i0.ɵɵrestoreView(_r57).item;
      $event.preventDefault();
      return i0.ɵɵresetView(item_r58.onClick(item_r58, $event));
    })("keyup.enter", function ListPageRowStandardComponent_ng_template_14_Template_button_keyup_enter_0_listener($event) {
      const ctx_r58 = i0.ɵɵrestoreView(_r57);
      const item_r58 = ctx_r58.item;
      const idx_r60 = ctx_r58.idx;
      $event.preventDefault();
      return i0.ɵɵresetView(item_r58.onClick(item_r58, idx_r60, $event));
    });
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_template_14_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r58 = ctx.item;
    const idx_r60 = ctx.idx;
    const fidx_r61 = ctx.fidx;
    const class_r62 = ctx.class;
    i0.ɵɵnextContext();
    const text_r3 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(class_r62);
    i0.ɵɵproperty("ngClass", item_r58.styleClass)("disabled", item_r58.disabled);
    i0.ɵɵattribute("list-item-index", idx_r60)("field-item-index", fidx_r61);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", text_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c16$1, item_r58));
  }
}
function ListPageRowStandardComponent_ng_template_16_ng_template_1_Template(rf, ctx) {}
function ListPageRowStandardComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 59);
    i0.ɵɵlistener("click", function ListPageRowStandardComponent_ng_template_16_Template_a_click_0_listener($event) {
      const item_r64 = i0.ɵɵrestoreView(_r63).item;
      $event.stopPropagation();
      return i0.ɵɵresetView(item_r64.onClick(item_r64, $event));
    })("keydown.enter", function ListPageRowStandardComponent_ng_template_16_Template_a_keydown_enter_0_listener($event) {
      const item_r64 = i0.ɵɵrestoreView(_r63).item;
      $event.stopPropagation();
      return i0.ɵɵresetView(item_r64.onClick(item_r64, $event));
    });
    i0.ɵɵtemplate(1, ListPageRowStandardComponent_ng_template_16_ng_template_1_Template, 0, 0, "ng-template", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r64 = ctx.item;
    const idx_r65 = ctx.idx;
    const fidx_r66 = ctx.fidx;
    const class_r67 = ctx.class;
    i0.ɵɵnextContext();
    const text_r3 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(class_r67);
    i0.ɵɵproperty("ngClass", item_r64.styleClass);
    i0.ɵɵattribute("href", item_r64.href ? item_r64.href : "", i0.ɵɵsanitizeUrl)("list-item-index", idx_r65)("field-item-index", fidx_r66);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", text_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c16$1, item_r64));
  }
}
function ListPageRowStandardComponent_ng_template_18_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const item_r70 = i0.ɵɵnextContext().item;
    i0.ɵɵtextInterpolate(item_r70.label);
  }
}
function ListPageRowStandardComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r68 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 60);
    i0.ɵɵlistener("click", function ListPageRowStandardComponent_ng_template_18_Template_a_click_0_listener($event) {
      const ctx_r68 = i0.ɵɵrestoreView(_r68);
      const item_r70 = ctx_r68.item;
      const idx_r71 = ctx_r68.idx;
      const fidx_r72 = ctx_r68.fidx;
      const fieldKey_r73 = ctx_r68.fieldKey;
      const value_r74 = ctx_r68.value;
      $event.preventDefault();
      return i0.ɵɵresetView(item_r70.onClick(item_r70, idx_r71, fidx_r72, fieldKey_r73, value_r74, $event));
    })("keydown.enter", function ListPageRowStandardComponent_ng_template_18_Template_a_keydown_enter_0_listener($event) {
      const ctx_r74 = i0.ɵɵrestoreView(_r68);
      const item_r70 = ctx_r74.item;
      const idx_r71 = ctx_r74.idx;
      const fidx_r72 = ctx_r74.fidx;
      const fieldKey_r73 = ctx_r74.fieldKey;
      const value_r74 = ctx_r74.value;
      $event.preventDefault();
      return i0.ɵɵresetView(item_r70.onClick(item_r70, idx_r71, fidx_r72, fieldKey_r73, value_r74, $event));
    });
    i0.ɵɵelementStart(1, "span", 61);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(3, ListPageRowStandardComponent_ng_template_18_ng_template_3_Template, 1, 1, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const item_r70 = ctx.item;
    const class_r76 = ctx.class;
    const idx_r71 = ctx.idx;
    const fidx_r72 = ctx.fidx;
    const value_r74 = ctx.value;
    const tooltipTemplate_r77 = i0.ɵɵreference(4);
    i0.ɵɵclassMapInterpolate2("", class_r76, " ", item_r70.styleClass, "");
    i0.ɵɵproperty("tooltipAnimation", item_r70.useTooltip ? false : null)("tooltipAppendToBody", item_r70.useTooltip ? true : null)("tooltip", item_r70.useTooltip ? tooltipTemplate_r77 : null)("ngClass", value_r74 ? "active" : null);
    i0.ɵɵattribute("list-item-index", idx_r71)("field-item-index", fidx_r72);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r70.label);
  }
}
function ListPageRowStandardComponent_ng_template_20_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "span", 63);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r77 = i0.ɵɵnextContext();
    const length_r79 = ctx_r77.length;
    const class_r80 = ctx_r77.class;
    i0.ɵɵclassMapInterpolate1("skeleton-bar col-", length_r79, "");
    i0.ɵɵproperty("ngClass", class_r80);
  }
}
function ListPageRowStandardComponent_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_template_20_div_0_Template, 2, 4, "div", 62);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.reloading && ctx_r1.listPage.skeleton);
  }
}
function ListPageRowStandardComponent_ng_template_22_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelement(1, "span", 63);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const class_r81 = i0.ɵɵnextContext().class;
    i0.ɵɵproperty("ngClass", class_r81);
  }
}
function ListPageRowStandardComponent_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_template_22_div_0_Template, 2, 1, "div", 64);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.listPage.reloading && ctx_r1.listPage.skeleton);
  }
}
class ListPageRowStandardComponent {
  constructor(listPage) {
    this.listPage = listPage;
    this.actionBtnOpened = false;
  }
  ngOnInit() {
    this._item = this.item;
  }
  clickActionBtn(item, itemIdx, fieldIdx, fieldKey, value) {
    let res = {};
    res.item = item;
    res.itemIndex = itemIdx;
    res.fieldIndex = fieldIdx;
    res.fieldKey = fieldKey;
    res.value = value;
    this.listPage.action.emit(res);
  }
  getSkeletonWidth(idx) {
    let sizeset = [8, 6, 4, 2, 1, 1, 1, 1, 1, 1];
    return sizeset[idx];
  }
  skeletonNumber(num) {
    return Array(num).fill(0).map((x, i) => i);
  }
  setCheckbox(event) {
    event.stopPropagation();
    this.listPage.toggleCheck(this.item.id);
  }
  isPresentSelectedRows() {
    const {
      id
    } = this.item;
    const {
      checkedAll,
      uncheckedIds = {},
      ids = {}
    } = this.listPage.rowsSelections;
    return checkedAll && !Object.keys(uncheckedIds).includes(id) || !checkedAll && Object.keys(ids).includes(id);
  }
  static {
    this.ɵfac = function ListPageRowStandardComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListPageRowStandardComponent)(i0.ɵɵdirectiveInject(forwardRef(() => ListPageComponent)));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ListPageRowStandardComponent,
      selectors: [["", "list-page-row-standard", ""]],
      inputs: {
        item: "item",
        itemIndex: "itemIndex",
        checkbox: "checkbox"
      },
      standalone: false,
      attrs: _c0$L,
      decls: 24,
      vars: 2,
      consts: [["text", ""], ["textSafe", ""], ["info", ""], ["infoSafe", ""], ["icon", ""], ["button", ""], ["buttonLink", ""], ["anchor", ""], ["iconButton", ""], ["skeletonBar", ""], ["skeletonFill", ""], ["ListThumbnail", ""], ["tooltipTemplate", ""], [4, "ngIf"], [1, "list-item-body"], ["class", "list-item-title no-padding", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["class", "list-item-actions-bar", 4, "ngIf"], ["class", "list-item-actions-bar floating-actions-bar", 4, "ngIf"], ["class", "list-item-actions auto_width", 4, "ngIf"], [1, "list-item-checkbox"], [1, "acc_hide2", 3, "for"], ["type", "checkbox", 3, "click", "id", "checked"], [1, "list-item-logo"], [3, "class", 4, "ngIf"], [3, "class", "ngClass", "autocolor", 4, "ngIf"], [3, "ngClass", "autocolor"], ["alt", "", 3, "src", 4, "ngIf"], ["alt", "", 3, "src"], ["class", "monogram-label", 4, "ngIf"], [1, "monogram-label"], [1, "thumbnailbox-img-wrapper", "background-img-fit-width", 3, "ngStyle"], [3, "autocolor"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], [1, "list-item-title", "no-padding"], ["ngFor", "", 3, "ngForOf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ngSwitch"], [4, "ngSwitchCase"], [1, "list-item-actions-bar"], [1, "list-item-actions-bar", "floating-actions-bar"], [1, "list-item-actions", "auto_width"], ["class", "list-secondary-action margin-bottom-auto", 4, "ngIf"], ["class", "actions-toggle-wrap inline-flexbox", 4, "ngIf"], [1, "list-secondary-action", "margin-bottom-auto"], [1, "actions-toggle-wrap", "inline-flexbox"], [3, "id"], [1, "actions-menu-wrapper", "actions-menu-right", "space-top-sm"], ["ngbDropdown", "", "placement", "bottom-right", 1, "actions-toggle-wrapper"], ["type", "button", "ngbDropdownToggle", "", "tabindex", "0", 1, "actions-toggle"], ["ngbDropdownMenu", "", "role", "menu", 1, "actions-menu"], [1, "actions-list"], ["class", "list-item-actions auto_width display-mobile-none display-sm-none", 4, "ngIf"], [1, "list-item-actions", "auto_width", "display-mobile-none", "display-sm-none"], [1, "list-secondary-action"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], [3, "click", "keyup.enter", "ngClass", "disabled"], [3, "click", "keydown.enter", "ngClass"], ["href", "", "role", "button", 3, "click", "keydown.enter", "tooltipAnimation", "tooltipAppendToBody", "tooltip", "ngClass"], [1, "sr-only"], [3, "class", "ngClass", 4, "ngIf"], [1, "skeleton-animation"], ["class", "skeleton-fill", 3, "ngClass", 4, "ngIf"], [1, "skeleton-fill", 3, "ngClass"]],
      template: function ListPageRowStandardComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ListPageRowStandardComponent_ng_container_0_Template, 10, 8, "ng-container", 13)(1, ListPageRowStandardComponent_ng_container_1_Template, 7, 5, "ng-container", 13)(2, ListPageRowStandardComponent_ng_template_2_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, ListPageRowStandardComponent_ng_template_4_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, ListPageRowStandardComponent_ng_template_6_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(8, ListPageRowStandardComponent_ng_template_8_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(10, ListPageRowStandardComponent_ng_template_10_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(12, ListPageRowStandardComponent_ng_template_12_Template, 2, 12, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(14, ListPageRowStandardComponent_ng_template_14_Template, 2, 11, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(16, ListPageRowStandardComponent_ng_template_16_Template, 2, 11, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor)(18, ListPageRowStandardComponent_ng_template_18_Template, 5, 11, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor)(20, ListPageRowStandardComponent_ng_template_20_Template, 1, 1, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor)(22, ListPageRowStandardComponent_ng_template_22_Template, 1, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.listPage.reloading || !ctx.listPage.skeleton);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.listPage.reloading && ctx.listPage.skeleton);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, i1.NgSwitch, i1.NgSwitchCase, i1$4.NgbDropdown, i1$4.NgbDropdownToggle, i1$4.NgbDropdownMenu, i3$2.TooltipDirective, AutoColorDirective, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListPageRowStandardComponent, [{
    type: Component,
    args: [{
      selector: '[list-page-row-standard]',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<!--List-->\n<ng-container *ngIf=\"!listPage.reloading || !listPage.skeleton\">\n    \n    <ng-container *ngIf=\"checkbox\">\n        <div class=\"list-item-checkbox\">\n            <label for=\"list-checkbox-{{itemIndex}}\" class=\"acc_hide2\">{{'misc.Select this item' | translate}}</label>\n            <input type=\"checkbox\" id=\"list-checkbox-{{itemIndex}}\" (click)=\"setCheckbox($event)\" [checked]=\"isPresentSelectedRows()\">\n        </div>\n    </ng-container>\n    \n    <ng-container *ngIf=\"_item.monogram\">\n        <div class=\"list-item-logo\">\n            <div *ngIf=\"_item.monogram.statusIcon\" class=\"{{_item.monogram.styleClass}} avatar-group\">\n                <div class=\"avatar-status {{_item.monogram.statusClass}}\">\n                    <i class=\"{{_item.monogram.statusIcon}}\"></i>\n                </div>\n                <div class=\"avatar {{_item.monogram.styleClass}}\"\n                     [ngClass]=\"{'avatar-square': _item.monogram.isSquare, 'monogram': _item.monogram.type !== 'image'}\"\n                     [autocolor]=\"_item.monogram.autoColor && _item.monogram.type === 'icon' ? _item.monogram.autoColor : ''\">\n                    <ng-container *ngIf=\"_item.monogram.type === 'label' && _item.monogram.label\">{{_item.monogram.label}}</ng-container>\n                    <span *ngIf=\"_item.monogram.type === 'icon' && _item.monogram.src\"\n                          class=\"{{_item.monogram.src}}\"></span>\n                    <img *ngIf=\"_item.monogram.type === 'image' && _item.monogram.src\"\n                         [src]=\"_item.monogram.src\"\n                         alt=\"\">\n                </div>\n            </div>\n            <div *ngIf=\"!_item.monogram.statusIcon\" class=\"avatar {{_item.monogram.styleClass}}\"\n                 [ngClass]=\"{'avatar-square': _item.monogram.isSquare, 'monogram': _item.monogram.type !== 'image'}\"\n                 [autocolor]=\"_item.monogram.autoColor && _item.monogram.type !== 'image' ? _item.monogram.autoColor : ''\">\n                <span *ngIf=\"_item.monogram.type === 'label' && _item.monogram.label\" class=\"monogram-label\">{{_item.monogram.label}}</span>\n                <span *ngIf=\"_item.monogram.type === 'icon' && _item.monogram.src\"\n                      class=\"{{_item.monogram.src}}\"></span>\n                <img *ngIf=\"_item.monogram.type === 'image' && _item.monogram.src\"\n                     [src]=\"_item.monogram.src\"\n                     alt=\"\">\n            </div>\n        </div>\n    </ng-container>\n    \n    <ng-container *ngIf=\"_item.thumbnails\">\n        <ng-container *ngIf=\"_item.thumbnails.type == 'image'\">\n            <div #ListThumbnail class=\"thumbnailbox thumbnailbox-image space-right-lg {{_item.thumbnails.styleClass}}\">\n                <div class=\"thumbnailbox-img-wrapper background-img-fit-width\" [ngStyle]=\"{ 'background-image': 'url(' + _item.thumbnails.src + ')', 'background-position': _item.thumbnails.imagePosition } \">\n                </div>\n            </div>\n        </ng-container>\n        \n        <ng-container *ngIf=\"_item.thumbnails.type == 'icon'\">\n            <div #ListThumbnail [autocolor]=\"_item.thumbnails.autoColor ? _item.thumbnails.autoColor : ''\" class=\"thumbnailbox thumbnailbox-icon space-right-lg flexbox justified-content-center align-items-center {{_item.thumbnails.styleClass}}\">\n                <i *ngIf=\"_item.thumbnails.type == 'icon'\" [ngClass]=\"_item.thumbnails.src\"></i>\n            </div>\n        </ng-container>\n    </ng-container>\n    \n    <div class=\"list-item-body\">\n        \n        <div class=\"list-item-title no-padding\" *ngIf=\"_item.title\">\n            <ng-container *ngIf=\"listPage.textTitle\">\n                <ng-template [ngTemplateOutlet]=\"text\" [ngTemplateOutletContext]=\"{ item: _item.title, idx: itemIndex, fieldKey: 'title', class: 'inline-block space-right-xs' }\"></ng-template>\n            </ng-container>\n            <ng-container *ngIf=\"listPage.rowAnchor.enable && !listPage.textTitle\">\n                <ng-template [ngTemplateOutlet]=\"info\" [ngTemplateOutletContext]=\"{ item: _item.title, idx: itemIndex, fieldKey: 'title', class: 'inline-block space-right-xs' }\"></ng-template>\n            </ng-container>\n            \n            <ng-container *ngIf=\"!listPage.rowAnchor.enable && !listPage.textTitle\">\n                <ng-template [ngTemplateOutlet]=\"anchor\" [ngTemplateOutletContext]=\"{ item: _item.title, idx: itemIndex, fieldKey: 'title', class: 'inline-block space-right-xs' }\"></ng-template>\n            </ng-container>\n            \n            <ng-template ngFor let-item let-fidx=\"index\" [ngForOf]=\"_item.titleTags\">\n                <ng-template [ngTemplateOutlet]=\"info\" [ngTemplateOutletContext]=\"{ item: item, class: 'badge badge-small no-margin', idx: itemIndex, fidx: fidx }\"></ng-template>\n            </ng-template>\n        </div>\n    \n        <ng-container *ngFor=\"let item of _item.texts; index as fidx\">\n            <ng-container [ngSwitch]=\"item.type\">\n                <ng-template *ngSwitchCase=\"'text'\" [ngTemplateOutlet]=\"info\" [ngTemplateOutletContext]=\"{ item: item, idx: itemIndex, fidx: fidx }\"></ng-template>\n                <ng-template *ngSwitchCase=\"'textSafe'\" [ngTemplateOutlet]=\"infoSafe\" [ngTemplateOutletContext]=\"{ item: item, idx: itemIndex, fidx: fidx }\"></ng-template>\n                <ng-template *ngSwitchCase=\"'icon'\" [ngTemplateOutlet]=\"icon\" [ngTemplateOutletContext]=\"{ item: item, idx: itemIndex, fidx: fidx }\"></ng-template>\n                <ng-template *ngSwitchCase=\"'anchor'\" [ngTemplateOutlet]=\"anchor\" [ngTemplateOutletContext]=\"{ item: item, idx: itemIndex, fidx: fidx }\"></ng-template>\n                <ng-template *ngSwitchCase=\"'button'\" [ngTemplateOutlet]=\"button\" [ngTemplateOutletContext]=\"{ item: item, idx: itemIndex, fidx: fidx }\"></ng-template>\n                <ng-template *ngSwitchCase=\"'buttonLink'\" [ngTemplateOutlet]=\"buttonLink\" [ngTemplateOutletContext]=\"{ item: item, idx: itemIndex, fidx: fidx }\"></ng-template>\n            </ng-container>\n        </ng-container>\n        \n        <div class=\"list-item-actions-bar\" *ngIf=\"item.actionButtons\">\n            <ng-container *ngFor=\"let item of _item.actionButtons; index as fidx\">\n                <ng-container [ngSwitch]=\"item.type\">\n                    <ng-template *ngSwitchCase=\"'anchor'\" [ngTemplateOutlet]=\"anchor\" [ngTemplateOutletContext]=\"{ item: item, idx: itemIndex, fidx: fidx, fieldKey: 'actionButtons' }\"></ng-template>\n                    <ng-template *ngSwitchCase=\"'button'\" [ngTemplateOutlet]=\"button\" [ngTemplateOutletContext]=\"{ item: item, idx: itemIndex, fidx: fidx, fieldKey: 'actionButtons' }\"></ng-template>\n                    <ng-template *ngSwitchCase=\"'buttonLink'\" [ngTemplateOutlet]=\"buttonLink\" [ngTemplateOutletContext]=\"{ item: item, idx: itemIndex, fidx: fidx, fieldKey: 'actionButtons' }\"></ng-template>\n                </ng-container>\n            </ng-container>\n        </div>\n        <div class=\"list-item-actions-bar floating-actions-bar\" *ngIf=\"item.absoluteButtons\">\n            <ng-container *ngFor=\"let item of _item.absoluteButtons; index as fidx\">\n                <ng-container [ngSwitch]=\"item.type\">\n                    <ng-template *ngSwitchCase=\"'anchor'\" [ngTemplateOutlet]=\"anchor\" [ngTemplateOutletContext]=\"{ item: item, idx: itemIndex, fidx: fidx, fieldKey: 'actionButtons' }\"></ng-template>\n                    <ng-template *ngSwitchCase=\"'button'\" [ngTemplateOutlet]=\"button\" [ngTemplateOutletContext]=\"{ item: item, idx: itemIndex, fidx: fidx, fieldKey: 'actionButtons' }\"></ng-template>\n                    <ng-template *ngSwitchCase=\"'buttonLink'\" [ngTemplateOutlet]=\"buttonLink\" [ngTemplateOutletContext]=\"{ item: item, idx: itemIndex, fidx: fidx, fieldKey: 'actionButtons' }\"></ng-template>\n                </ng-container>\n            </ng-container>\n        </div>\n    </div>\n    \n    <div class=\"list-item-actions auto_width\" *ngIf=\"item.sidebar || (_item.iconButtons && _item.iconButtons.length)\">\n        <div class=\"list-secondary-action margin-bottom-auto\" *ngIf=\"item.sidebar\">\n            <ng-template ngFor let-item let-fidx=\"index\" [ngForOf]=\"_item.sidebar\">\n                <ng-container [ngSwitch]=\"item.type\">\n                    <ng-template\n                        *ngSwitchCase=\"'text'\"\n                        [ngTemplateOutlet]=\"info\"\n                        [ngTemplateOutletContext]=\"{\n                            item: item,\n                            class: 'space-bottom-sm',\n                            idx: itemIndex,\n                            fidx: fidx\n                        }\">\n                    </ng-template>\n                    <ng-template\n                        *ngSwitchCase=\"'anchor'\"\n                        [ngTemplateOutlet]=\"anchor\"\n                        [ngTemplateOutletContext]=\"{\n                            item: item,\n                            class: 'space-bottom-sm',\n                            idx: itemIndex,\n                            fidx: fidx\n                        }\">\n                    </ng-template>\n                    <ng-template\n                        *ngSwitchCase=\"'button'\"\n                        [ngTemplateOutlet]=\"button\"\n                        [ngTemplateOutletContext]=\"{\n                            item: item,\n                            class: 'block',\n                            idx: itemIndex,\n                            fidx: fidx\n                        }\">\n                    </ng-template>\n                </ng-container>\n            </ng-template>\n        </div>\n        \n        <div *ngIf=\"_item.iconButtons && _item.iconButtons.length\" class=\"actions-toggle-wrap inline-flexbox\">\n            <ng-container *ngFor=\"let iconbtn of _item.iconButtons; index as i\">\n                <div id=\"iconbutton-{{i}}\">\n                    <ng-template\n                        [ngTemplateOutlet]=\"iconButton\"\n                        [ngTemplateOutletContext]=\"{\n                            item: iconbtn,\n                            idx: itemIndex,\n                            fidx: i,\n                            fieldKey: iconbtn.id,\n                            value: iconbtn.value,\n                            class: 'auto_width ' + iconbtn.icon\n                        }\">\n                    </ng-template>\n                </div>\n            </ng-container>\n        </div>\n        \n        <ng-container *ngIf=\"_item.actionButtons\">\n            <div class=\"actions-menu-wrapper actions-menu-right space-top-sm\">\n                <div ngbDropdown class=\"actions-toggle-wrapper\" placement=\"bottom-right\">\n                    <button type=\"button\" class=\"actions-toggle\" [attr.aria-label]=\"'misc.Open Actions Menu' | translate\" [attr.label-closed]=\"'misc.Open Actions Menu' | translate\" [attr.label-opened]=\"'misc.Close Actions Menu' | translate\" ngbDropdownToggle tabindex=\"0\"></button>\n                    <div ngbDropdownMenu class=\"actions-menu\" role=\"menu\" [attr.aria-label]=\"'misc.Actions Menu' | translate\">\n                        <ul class=\"actions-list\">\n                            <li *ngFor=\"let item of _item.actionButtons; index as fidx\">\n                                <ng-template [ngTemplateOutlet]=\"anchor\" [ngTemplateOutletContext]=\"{ item: item, idx: itemIndex, fidx: fidx, fieldKey: 'actionButtons' }\"></ng-template>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </ng-container>\n    </div>\n</ng-container>\n\n<!--Skeleton Loader-->\n<ng-container *ngIf=\"listPage.reloading && listPage.skeleton\">\n    <ng-container *ngIf=\"listPage.skeleton.checkbox\">\n        <div class=\"list-item-checkbox\">\n            <ng-template [ngTemplateOutlet]=\"skeletonFill\" [ngTemplateOutletContext]=\"{ class: '' }\"></ng-template>\n        </div>\n    </ng-container>\n    \n    <ng-container *ngIf=\"listPage.skeleton.thumbnails\">\n        <div class=\"list-item-logo\">\n            <ng-template [ngTemplateOutlet]=\"skeletonFill\" [ngTemplateOutletContext]=\"{ class: 'avatar ' + listPage.skeleton.thumbnailsStyle }\"></ng-template>\n        </div>\n    </ng-container>\n    \n    <div class=\"list-item-body\">\n\n        <ng-container *ngFor=\"let skeleton of skeletonNumber(listPage.skeleton.texts); index as i\">\n            <ng-template [ngTemplateOutlet]=\"skeletonBar\" [ngTemplateOutletContext]=\"{ length: getSkeletonWidth(i) }\"></ng-template>\n        </ng-container>\n        \n        <div class=\"list-item-actions-bar\" *ngIf=\"listPage.skeleton.actionButtons\">\n            <ng-container *ngFor=\"let skeleton of skeletonNumber(listPage.skeleton.actionButtons); index as i\">\n                <ng-template [ngTemplateOutlet]=\"skeletonBar\" [ngTemplateOutletContext]=\"{ length: 2, class: 'inline-block  space-right-md margin-bottom-auto' }\"></ng-template>\n            </ng-container>\n        </div>\n    </div>\n    \n    <div class=\"list-item-actions auto_width display-mobile-none display-sm-none\" *ngIf=\"listPage.skeleton.sidebar\">\n        \n        <div class=\"list-secondary-action\">\n            <ng-container *ngFor=\"let skeleton of skeletonNumber(listPage.skeleton.sidebar)\">\n                <ng-template [ngTemplateOutlet]=\"skeletonBar\" [ngTemplateOutletContext]=\"{ length: 5, class: '' }\"></ng-template>\n            </ng-container>\n\n            <ng-container *ngFor=\"let skeleton of skeletonNumber(listPage.skeleton.iconBtn)\">\n                <ng-template [ngTemplateOutlet]=\"skeletonFill\" [ngTemplateOutletContext]=\"{ class: 'skeleton-circle inline-block' }\"></ng-template>\n            </ng-container>\n        </div>\n    \n    </div>\n</ng-container>\n\n<!--Templates-->\n<ng-template #text let-item=\"item\">\n    <i *ngIf=\"item.icon\" class=\"{{item.icon}}\"></i>\n    <span *ngIf=\"item.label\" [innerHTML]=\"item.label\"></span>\n</ng-template>\n\n<ng-template #textSafe let-item=\"item\">\n    <i *ngIf=\"item.icon\" class=\"{{item.icon}}\"></i>\n    <span *ngIf=\"item.label\" [innerHTML]=\"item.label | safeHtml\"></span>\n</ng-template>\n\n<ng-template #info let-item=\"item\" let-class=\"class\" let-idx=\"idx\" let-fidx=\"fidx\">\n    <div *ngIf=\"item.label\" class=\"{{class}} {{item.styleClass}}\" [attr.list-item-index]=\"idx\" [attr.field-item-index]=\"fidx\">\n        <ng-template [ngTemplateOutlet]=\"text\" [ngTemplateOutletContext]=\"{ item: item }\"></ng-template>\n    </div>\n</ng-template>\n\n<ng-template #infoSafe let-item=\"item\" let-class=\"class\" let-idx=\"idx\" let-fidx=\"fidx\">\n    <div *ngIf=\"item.label\" class=\"{{class}} {{item.styleClass}}\" [attr.list-item-index]=\"idx\" [attr.field-item-index]=\"fidx\">\n        <ng-template [ngTemplateOutlet]=\"textSafe\" [ngTemplateOutletContext]=\"{ item: item }\"></ng-template>\n    </div>\n</ng-template>\n\n<ng-template #icon let-item=\"item\" let-class=\"class\" let-idx=\"idx\" let-fidx=\"fidx\">\n    <div *ngIf=\"item.icon\" class=\"{{class}} {{item.styleClass}}\" [attr.list-item-index]=\"idx\" [attr.field-item-index]=\"fidx\">\n        <ng-template [ngTemplateOutlet]=\"text\" [ngTemplateOutletContext]=\"{ item: item }\"></ng-template>\n    </div>\n</ng-template>\n\n<ng-template #button let-item=\"item\" let-idx=\"idx\" let-fidx=\"fidx\" let-fieldKey=\"fieldKey\" let-class=\"class\">\n    <button class=\"btn {{class}}\" [ngClass]=\"item.styleClass\" [attr.aria-label]=\"item.ariaLabel ? item.ariaLabel : null\" [attr.list-item-index]=\"idx\" [attr.field-item-index]=\"fidx\" (click)=\"$event.preventDefault(); item.onClick(item, idx, $event)\" (keyup.enter)=\"$event.preventDefault(); item.onClick(item, idx, $event)\" [disabled]=\"item.disabled\">\n        <ng-template [ngTemplateOutlet]=\"text\" [ngTemplateOutletContext]=\"{ item: item }\"></ng-template>\n    </button>\n</ng-template>\n\n<ng-template #buttonLink let-item=\"item\" let-idx=\"idx\" let-fidx=\"fidx\" let-fieldKey=\"fieldKey\" let-class=\"class\">\n    <button class=\"{{class}}\" [ngClass]=\"item.styleClass\" [attr.list-item-index]=\"idx\" [attr.field-item-index]=\"fidx\" (click)=\"$event.preventDefault(); item.onClick(item, $event)\" (keyup.enter)=\"$event.preventDefault(); item.onClick(item, idx, $event)\" [disabled]=\"item.disabled\">\n        <ng-template [ngTemplateOutlet]=\"text\" [ngTemplateOutletContext]=\"{ item: item }\"></ng-template>\n    </button>\n</ng-template>\n\n<ng-template #anchor let-item=\"item\" let-idx=\"idx\" let-fidx=\"fidx\" let-fieldKey=\"fieldKey\" let-class=\"class\">\n    <a [attr.href]=\"item.href ? item.href : ''\" class=\"{{class}}\" [ngClass]=\"item.styleClass\" [attr.list-item-index]=\"idx\" [attr.field-item-index]=\"fidx\" (click)=\"$event.stopPropagation(); item.onClick(item, $event)\" (keydown.enter)=\"$event.stopPropagation(); item.onClick(item, $event)\">\n        <ng-template [ngTemplateOutlet]=\"text\" [ngTemplateOutletContext]=\"{ item: item }\"></ng-template>\n    </a>\n</ng-template>\n\n<ng-template #iconButton let-item=\"item\" let-class=\"class\" let-activeClass='activeClass' let-idx=\"idx\" let-fidx=\"fidx\" let-fieldKey=\"fieldKey\" let-value=\"value\">\n    <a href=\"\" role=\"button\" class=\"{{class}} {{item.styleClass}}\" [tooltipAnimation]=\"item.useTooltip ? false : null\" [tooltipAppendToBody]=\"item.useTooltip ? true : null\" [tooltip]=\"item.useTooltip ? tooltipTemplate : null\" [ngClass]=\"value ? 'active' : null\" (click)=\"$event.preventDefault(); item.onClick(item, idx, fidx, fieldKey, value, $event)\" (keydown.enter)=\"$event.preventDefault(); item.onClick(item, idx, fidx, fieldKey, value, $event)\" [attr.list-item-index]=\"idx\" [attr.field-item-index]=\"fidx\">\n        <span class=\"sr-only\">{{item.label}}</span>\n    </a>\n    <ng-template #tooltipTemplate>{{item.label}}</ng-template>\n</ng-template>\n\n<ng-template #skeletonBar let-length=\"length\" let-class=\"class\">\n    <div *ngIf=\"listPage.reloading && listPage.skeleton\" class=\"skeleton-bar col-{{length}}\" [ngClass]=\"class\">\n        <span class=\"skeleton-animation\"></span>\n    </div>\n</ng-template>\n\n<ng-template #skeletonFill let-class=\"class\">\n    <div *ngIf=\"listPage.reloading && listPage.skeleton\" class=\"skeleton-fill\" [ngClass]=\"class\">\n        <span class=\"skeleton-animation\"></span>\n    </div>\n</ng-template>\n"
    }]
  }], () => [{
    type: ListPageComponent,
    decorators: [{
      type: Inject,
      args: [forwardRef(() => ListPageComponent)]
    }]
  }], {
    item: [{
      type: Input
    }],
    itemIndex: [{
      type: Input
    }],
    checkbox: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ListPageRowStandardComponent, {
    className: "ListPageRowStandardComponent",
    filePath: "valkyrie/list-page/list-page-row-standard.component.ts",
    lineNumber: 12
  });
})();
const _c0$K = ["WrapperElement"];
const _c1$C = ["ContentElement"];
const _c2$w = a0 => ({
  "max-height": a0
});
function ExpandableContentComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "button", 6);
    i0.ɵɵlistener("click", function ExpandableContentComponent_div_6_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.expandContent());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, ctx_r1.seeMoreString), " ");
  }
}
class ExpandableContentComponent {
  set wrapperHeight(wrapperHeight) {
    this.wrapperHeight$.next(`${wrapperHeight}px`);
  }
  set content(content) {
    this.sanitizedContent$.next(this.domSanitizer.bypassSecurityTrustHtml(content));
  }
  constructor(changeDetectorRef, domSanitizer) {
    this.changeDetectorRef = changeDetectorRef;
    this.domSanitizer = domSanitizer;
    this.seeMoreString = 'misc.See more';
    this.isExpanded$ = new BehaviorSubject(false);
    this.wrapperHeight$ = new BehaviorSubject('200px');
    this.sanitizedContent$ = new BehaviorSubject('');
    this.canBeExpanded$ = new BehaviorSubject(false);
  }
  ngAfterViewInit() {
    const wrapperHeight = this.wrapperElement.nativeElement.clientHeight;
    const contentHeight = this.contentElement.nativeElement.scrollHeight;
    if (contentHeight > wrapperHeight) {
      this.canBeExpanded$.next(true);
      this.changeDetectorRef.detectChanges();
    }
  }
  expandContent() {
    this.wrapperHeight$.next('none');
    this.isExpanded$.next(true);
  }
  static {
    this.ɵfac = function ExpandableContentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ExpandableContentComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$5.DomSanitizer));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ExpandableContentComponent,
      selectors: [["expandable-content"]],
      viewQuery: function ExpandableContentComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$K, 5);
          i0.ɵɵviewQuery(_c1$C, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.wrapperElement = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentElement = _t.first);
        }
      },
      inputs: {
        wrapperHeight: "wrapperHeight",
        content: "content",
        seeMoreString: "seeMoreString"
      },
      standalone: false,
      decls: 9,
      vars: 13,
      consts: [["WrapperElement", ""], ["ContentElement", ""], [1, "article-trim", "secondary-text", 3, "ngStyle"], [1, "field-widget-tinymce", 3, "innerHTML"], ["class", "article-trim-bg", 4, "ngIf"], [1, "article-trim-bg"], [1, "btn", "btn_link", "btn_primary", "article-trim-btn", 3, "click"]],
      template: function ExpandableContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2, 0);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelement(3, "div", 3, 1);
          i0.ɵɵpipe(5, "async");
          i0.ɵɵtemplate(6, ExpandableContentComponent_div_6_Template, 4, 3, "div", 4);
          i0.ɵɵpipe(7, "async");
          i0.ɵɵpipe(8, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(11, _c2$w, i0.ɵɵpipeBind1(2, 3, ctx.wrapperHeight$)));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(5, 5, ctx.sanitizedContent$), i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 7, ctx.canBeExpanded$) && !i0.ɵɵpipeBind1(8, 9, ctx.isExpanded$));
        }
      },
      dependencies: [i1.NgIf, i1.NgStyle, i1.AsyncPipe, i1$1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExpandableContentComponent, [{
    type: Component,
    args: [{
      selector: 'expandable-content',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n    #WrapperElement\n    class=\"article-trim secondary-text\"\n    [ngStyle]=\"{ 'max-height': wrapperHeight$ | async }\"\n>\n    <div\n        #ContentElement\n        class=\"field-widget-tinymce\"\n        [innerHTML]=\"sanitizedContent$ | async\"\n    >\n    </div>\n\n    <div\n        *ngIf=\"(canBeExpanded$ | async) && !(isExpanded$ | async)\"\n        class=\"article-trim-bg\"\n    >\n        <button\n            class=\"btn btn_link btn_primary article-trim-btn\"\n            (click)=\"expandContent()\"\n        >\n            {{ seeMoreString | translate }}\n        </button>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i1$5.DomSanitizer
  }], {
    wrapperHeight: [{
      type: Input
    }],
    content: [{
      type: Input
    }],
    seeMoreString: [{
      type: Input
    }],
    wrapperElement: [{
      type: ViewChild,
      args: ['WrapperElement', {
        static: false
      }]
    }],
    contentElement: [{
      type: ViewChild,
      args: ['ContentElement', {
        static: false
      }]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ExpandableContentComponent, {
    className: "ExpandableContentComponent",
    filePath: "valkyrie/common/expandable-content.component.ts",
    lineNumber: 11
  });
})();

/* Components */
class ValkyrieUiModule {
  static forRoot() {
    return {
      ngModule: ValkyrieUiModule,
      providers: [ValkyrieCommonService, ValkyrieBackendService, ValkyrieUtilsService, TranslateService, SizeDetectorService, {
        provide: HTTP_INTERCEPTORS,
        useClass: ValkyrieSessionTimeoutInterceptor,
        multi: true
      }, {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpFormErrorInterceptor,
        multi: true
      }, {
        provide: APP_BASE_HREF,
        useFactory: s => s.getBaseHrefFromDOM(),
        deps: [PlatformLocation]
      }]
    };
  }
  static {
    this.ɵfac = function ValkyrieUiModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ValkyrieUiModule)();
    };
  }
  static {
    this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
      type: ValkyrieUiModule
    });
  }
  static {
    this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
      providers: [provideHttpClient(withInterceptorsFromDi())],
      imports: [CommonModule, FormsModule, TranslationsModule.forChild(), NgbModule, RouterModule, TooltipModule.forRoot(), BsDropdownModule.forRoot(), DynamicFormModule, SyngCommonModule, EditorModule, TranslationsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValkyrieUiModule, [{
    type: NgModule,
    args: [{
      declarations: [ValkyrieSessionTimeoutModalComponent, MainLayoutComponent, PageHeaderComponent, PageFooterComponent, BreadcrumbsComponent, SidebarNavComponent, NotificationsComponent, TabComponent, SizeDetectorComponent, TriStateCheckboxComponent, ContactChipComponent, ExternalUrlComponent, SearchTextPipe, MinPipe, Initials, ListPageComponent, ListPageHeaderComponent, ListSimpleFilterComponent, ListSimpleFilterSingleSelectComponent, ListSimpleFilterMultipleSelectComponent, ListFilterChipsComponent, ListPagePaginationComponent, ListFilterModalComponent, DynamicFormMobileFilterComponent, ModalWindowLayoutComponent, ListPageRowStandardComponent, AccountBlockedMessageComponent, ExpandableContentComponent, MailwizComponent],
      exports: [MainLayoutComponent, PageHeaderComponent, PageFooterComponent, BreadcrumbsComponent, SidebarNavComponent, NotificationsComponent, TabComponent, TriStateCheckboxComponent, ContactChipComponent, TranslationsModule, ExternalUrlComponent, ListPageComponent, ListSimpleFilterComponent, SizeDetectorComponent, ModalWindowLayoutComponent, ListFilterChipsComponent, ListSimpleFilterMultipleSelectComponent, DynamicFormMobileFilterComponent, Initials, ListSimpleFilterSingleSelectComponent, ExpandableContentComponent, MailwizComponent],
      imports: [CommonModule, FormsModule, TranslationsModule.forChild(), NgbModule, RouterModule, TooltipModule.forRoot(), BsDropdownModule.forRoot(), DynamicFormModule, AutoColorDirective, SyngCommonModule, EditorModule],
      providers: [provideHttpClient(withInterceptorsFromDi())]
    }]
  }], null, null);
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ValkyrieUiModule, {
    declarations: [ValkyrieSessionTimeoutModalComponent, MainLayoutComponent, PageHeaderComponent, PageFooterComponent, BreadcrumbsComponent, SidebarNavComponent, NotificationsComponent, TabComponent, SizeDetectorComponent, TriStateCheckboxComponent, ContactChipComponent, ExternalUrlComponent, SearchTextPipe, MinPipe, Initials, ListPageComponent, ListPageHeaderComponent, ListSimpleFilterComponent, ListSimpleFilterSingleSelectComponent, ListSimpleFilterMultipleSelectComponent, ListFilterChipsComponent, ListPagePaginationComponent, ListFilterModalComponent, DynamicFormMobileFilterComponent, ModalWindowLayoutComponent, ListPageRowStandardComponent, AccountBlockedMessageComponent, ExpandableContentComponent, MailwizComponent],
    imports: [CommonModule, FormsModule, TranslationsModule, NgbModule, RouterModule, i3$2.TooltipModule, i10.BsDropdownModule, DynamicFormModule, AutoColorDirective, SyngCommonModule, EditorModule],
    exports: [MainLayoutComponent, PageHeaderComponent, PageFooterComponent, BreadcrumbsComponent, SidebarNavComponent, NotificationsComponent, TabComponent, TriStateCheckboxComponent, ContactChipComponent, TranslationsModule, ExternalUrlComponent, ListPageComponent, ListSimpleFilterComponent, SizeDetectorComponent, ModalWindowLayoutComponent, ListFilterChipsComponent, ListSimpleFilterMultipleSelectComponent, DynamicFormMobileFilterComponent, Initials, ListSimpleFilterSingleSelectComponent, ExpandableContentComponent, MailwizComponent]
  });
})();
i0.ɵɵsetComponentScope(ListPageComponent, function () {
  return [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgSwitch, i1.NgSwitchCase, i1$1.TranslateDirective, i1$7.RouterLink, ListPageHeaderComponent, ListPagePaginationComponent, ListPageRowStandardComponent];
}, function () {
  return [i1$1.TranslatePipe];
});
function ModernTabComponent_td_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 4)(1, "a", 5)(2, "div", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    i0.ɵɵattribute("class", tab_r1.active ? "hi" : "lo");
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", tab_r1.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(tab_r1.title);
  }
}
class ModernTabComponent {
  constructor() {}
  static {
    this.ɵfac = function ModernTabComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModernTabComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ModernTabComponent,
      selectors: [["tab"]],
      inputs: {
        tabData: "tabData"
      },
      decls: 5,
      vars: 1,
      consts: [["role", "menubar", "id", "page_tabs", 1, "tabs"], ["id", "ui_module_tabs", "cellspacing", "0", "cellpadding", "0", "role", "presentation", 1, "tabs"], ["role", "presentation"], ["valign", "middle", "role", "presentation", "class", "first", "nowrap", "", 4, "ngFor", "ngForOf"], ["valign", "middle", "role", "presentation", "nowrap", "", 1, "first"], ["role", "menuitem", 3, "href"], [1, "tab_text"]],
      template: function ModernTabComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "nav", 0)(1, "table", 1)(2, "tbody")(3, "tr", 2);
          i0.ɵɵtemplate(4, ModernTabComponent_td_4_Template, 4, 3, "td", 3);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngForOf", ctx.tabData);
        }
      },
      dependencies: [CommonModule, i1.NgForOf],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModernTabComponent, [{
    type: Component,
    args: [{
      selector: 'tab',
      imports: [CommonModule],
      template: "<nav class=\"tabs\" role=\"menubar\" id=\"page_tabs\">\n    <table class=\"tabs\" id=\"ui_module_tabs\" cellspacing=\"0\" cellpadding=\"0\" role=\"presentation\">\n        <tbody>\n        <tr role=\"presentation\">\n            <td *ngFor=\"let tab of tabData\" valign=\"middle\" role=\"presentation\" class=\"first\"\n                [attr.class]=\"tab.active ? 'hi' : 'lo'\" nowrap=\"\">\n                <a role=\"menuitem\" [href]=\"tab.link\">\n                    <div class=\"tab_text\">{{tab.title}}</div>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</nav>\n"
    }]
  }], () => [], {
    tabData: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ModernTabComponent, {
    className: "ModernTabComponent",
    filePath: "modern/common/tab.component.ts",
    lineNumber: 10
  });
})();
class FormConfig {
  constructor(config) {
    this.submitAriaControls = '';
    this.submitLabel = 'misc.Submit';
    this.cancelAriaControls = '';
    this.editAriaControls = '';
    this.editLabel = 'misc.Edit';
    this.cancelLabel = 'misc.Cancel';
    this.deleteAriaControls = '';
    this.enableValidationBox = true;
    this.publishLabel = 'misc.Publish';
    this.unpublishLabel = 'misc.Unpublish';
    this.useCustomButtons = false;
    this.hideButtonbar = 'none';
    this.modal = false;
    this.customButtons = [];
    this.readOnly = false;
    this.disabled = false;
    this.isProcessing = false;
    this.customValidationScroll = null;
    this.returnParams = true;
    this.removeNoResultFound = false;
    Object.assign(this, config);
  }
  setCallbacks(callbacks = null) {
    if (callbacks) {
      Object.assign(this, callbacks);
    }
  }
}
class ListState {
  constructor() {
    this.items = null;
    this.count = 0;
    this.totalCheckedRows = 0;
    this.paginationState = Object.assign({}, defaultPaginationState);
  }
  setAll(items, count, paginationState, totalCheckedRows = 0) {
    this.items = items;
    this.count = count;
    this.totalCheckedRows = totalCheckedRows;
    this.paginationState = paginationState;
  }
}
class State {
  constructor(activeListState = new ListState(), archivedListState = new ListState(), eligibleStudentListState = new ListState(), participantListState = new ListState()) {
    this.activeListState = activeListState;
    this.archivedListState = archivedListState;
    this.eligibleStudentListState = eligibleStudentListState;
    this.participantListState = participantListState;
  }
}
class AddNewItem {
  constructor(blurb, addFunction) {
    this.blurb = blurb;
    this.addFunction = addFunction;
  }
}
class SocketService {
  constructor(valkyrieAuthService) {
    this.valkyrieAuthService = valkyrieAuthService;
    this.socketReady = new BehaviorSubject(false);
    this.socketSignature$ = new BehaviorSubject(false);
    this.valkyrieAuthService.getCurrentUser().subscribe(resp => {
      if (!_.isEmpty(resp)) {
        this.userId = resp.id;
      }
    });
    this.valkyrieAuthService.getsocketSignature().subscribe(sign => {
      if (sign) {
        this.socketSignature$.next(sign);
      }
    });
  }
  initSocketClient(channelPrefix = '', callbackForTokenRenewal) {
    window.localStorage.removeItem('socketcluster.authToken');
    this.socketClient = socketClusterClient.create({
      hostname: window.SOCKETCLUSTER_SERVER,
      autoConnect: false,
      disconnectOnUnload: true,
      connectTimeout: 3000,
      channelPrefix: channelPrefix
    });
    this.socketSignature$.subscribe(sign => {
      if (sign) {
        this.socketClient.invoke('login', {
          token: sign
        }).then(resp => {
          if (callbackForTokenRenewal) {
            this.listenToReAuthorize(callbackForTokenRenewal);
          }
          this.socketReady.next(true);
        }, rejected => {
          this.socketClient.disconnect();
          alert('something went wrong, please refresh the page');
          console.error(rejected, 'rejected');
        }).catch(err => {
          console.error(err, 'catch');
        });
      }
    });
  }
  subscribeChannel(channelId, callback, channelType = 'private') {
    if (this.socketClient) {
      const channel = this.socketClient.subscribe(channelId, {
        data: {
          channelType: channelType,
          userId: this.userId,
          host: window.location.hostname
        }
      });
      SocketService.awaitForData(channel, callback, this.socketClient, this.userId);
    }
  }
  async listenToReAuthorize(callbackForTokenRenewal) {
    for await (const data of this.socketClient.listener('deauthenticate')) {
      const expiry = callbackForTokenRenewal();
      if (expiry > 0) {
        this.valkyrieAuthService.getsocketSignature().subscribe(sign => {
          if (sign) {
            this.socketClient.invoke('renew', {
              token: 'Bearer ' + data.oldSignedAuthToken,
              eventExpiresAt: expiry,
              socketSignature: sign
            });
          }
        });
      } else {
        this.disconnect();
      }
    }
  }
  static async awaitForData(channel, callback, socketClient, userId) {
    for await (const data of channel) {
      switch (data.channelType) {
        case 'private':
          if (socketClient.authToken.subject === userId) {
            callback.apply(null, [data]);
          }
          break;
        case 'global':
          callback.apply(null, [data]);
      }
    }
  }
  async unsubscribePrivateChannel(channelName) {
    if (this.socketClient) {
      return this.socketClient.invoke('unsubscribe', {
        'channelId': channelName,
        'userId': this.userId,
        'host': window.location.hostname
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.socketClient.unsubscribe(channelName);
      });
    }
  }
  async unsubscribeGlobalChannel(channelName) {
    if (this.socketClient) {
      await this.socketClient.unsubscribe(channelName);
    }
  }
  disconnect() {
    if (this.socketClient) {
      this.socketClient.disconnect(4004);
    }
  }
  isSubscribed(channelName) {
    if (this.socketClient) {
      return this.socketClient.isSubscribed(channelName, true);
    }
    return false;
  }
  static {
    this.ɵfac = function SocketService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SocketService)(i0.ɵɵinject(ValkyrieAuthService));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: SocketService,
      factory: SocketService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SocketService, [{
    type: Injectable
  }], () => [{
    type: ValkyrieAuthService
  }], null);
})();
const _c0$J = ["janusDataTableRow", ""];
const _c1$B = a0 => ({
  "me-2": a0
});
const _c2$v = (a0, a1, a2, a3, a4) => ({
  column: a0,
  row: a1,
  item: a2,
  parentItem: a3,
  parentIndex: a4
});
function JanusDataTableRow_td_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.displayIndex);
  }
}
function JanusDataTableRow_td_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 8);
    i0.ɵɵlistener("change", function JanusDataTableRow_td_1_Conditional_2_Template_input_change_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      ctx_r0.dataTable.onCheckboxSelect(ctx_r0, ctx_r0.selected);
      return i0.ɵɵresetView(ctx_r0.setIndeterminate(ctx_r0.selected));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "checkbox_", ctx_r0.index, "");
    i0.ɵɵproperty("checked", ctx_r0.selected);
  }
}
function JanusDataTableRow_td_1_ng_container_3_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function JanusDataTableRow_td_1_ng_container_3_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.dataTable.viewItem(ctx_r0.item));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.dataTable.assetsPath + "tabler-sprite-nostroke.svg#tabler-file-search", null, "xlink");
  }
}
function JanusDataTableRow_td_1_ng_container_3_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function JanusDataTableRow_td_1_ng_container_3_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.dataTable.editItem(ctx_r0.item));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.dataTable.assetsPath + "tabler-sprite-nostroke.svg#tabler-edit", null, "xlink");
  }
}
function JanusDataTableRow_td_1_ng_container_3_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function JanusDataTableRow_td_1_ng_container_3_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.dataTable.deleteItem(ctx_r0.item));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1$B, ctx_r0.dataTable.customRowActions.length));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.dataTable.assetsPath + "tabler-sprite-nostroke.svg#tabler-trash", null, "xlink");
  }
}
function JanusDataTableRow_td_1_ng_container_3_ng_container_4_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function JanusDataTableRow_td_1_ng_container_3_ng_container_4_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const customAction_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(customAction_r7.fn(ctx_r0.item));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const customAction_r7 = ctx_r7.$implicit;
    const last_r9 = ctx_r7.last;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$B, !last_r9));
    i0.ɵɵattribute("aria-label", customAction_r7.label);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", "{{dataTable.assetsPath}}tabler-sprite-nostroke.svg#tabler-" + customAction_r7.icon, null, "xlink");
  }
}
function JanusDataTableRow_td_1_ng_container_3_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusDataTableRow_td_1_ng_container_3_ng_container_4_button_1_Template, 3, 5, "button", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const customAction_r7 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !customAction_r7.canUse || customAction_r7.canUse(ctx_r0.item));
  }
}
function JanusDataTableRow_td_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusDataTableRow_td_1_ng_container_3_button_1_Template, 3, 1, "button", 9)(2, JanusDataTableRow_td_1_ng_container_3_button_2_Template, 3, 1, "button", 10)(3, JanusDataTableRow_td_1_ng_container_3_button_3_Template, 3, 4, "button", 11)(4, JanusDataTableRow_td_1_ng_container_3_ng_container_4_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dataTable.canView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dataTable.canEdit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dataTable.canDelete);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.dataTable.customRowActions);
  }
}
function JanusDataTableRow_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 4)(1, "div", 5);
    i0.ɵɵtemplate(2, JanusDataTableRow_td_1_Conditional_2_Template, 1, 3, "input", 6)(3, JanusDataTableRow_td_1_ng_container_3_Template, 5, 4, "ng-container", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.dataTable.selectColumnVisible ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dataTable.hasListItemActions);
  }
}
function JanusDataTableRow_ng_container_2_td_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 22);
  }
  if (rf & 2) {
    const column_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.item[column_r10.property]);
  }
}
function JanusDataTableRow_ng_container_2_td_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
  }
  if (rf & 2) {
    const column_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", column_r10.cellTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c2$v, column_r10, ctx_r0._this, ctx_r0.item, ctx_r0.parentItem, ctx_r0.parentIndex));
  }
}
function JanusDataTableRow_ng_container_2_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 19);
    i0.ɵɵtemplate(1, JanusDataTableRow_ng_container_2_td_1_div_1_Template, 1, 1, "div", 20)(2, JanusDataTableRow_ng_container_2_td_1_div_2_Template, 1, 8, "div", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    const column_r10 = ctx_r10.$implicit;
    const childIndex_r12 = ctx_r10.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background-color", column_r10.getCellColor(ctx_r0, ctx_r0.index));
    i0.ɵɵproperty("hide", !column_r10.visible)("ngClass", ctx_r0.getCombinedClasses(column_r10));
    i0.ɵɵattribute("headers", "column-" + (childIndex_r12 + 1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !column_r10.cellTemplate && column_r10.property !== "display" && ctx_r0.item[column_r10.property]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r10.cellTemplate);
  }
}
function JanusDataTableRow_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusDataTableRow_ng_container_2_td_1_Template, 3, 7, "td", 18);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const column_r10 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r10.property !== "Actions");
  }
}
class JanusDataTableRow extends DataTableRow {
  ngOnInit() {
    super.ngOnInit();
    this.firstContentColumn = this.dataTable.columns.find(column => column.property !== 'Actions');
  }
  setIndeterminate(selected) {
    const batchSelect = document.querySelector(".list-maincol #batch-select");
    if (batchSelect) {
      if (!selected) {
        this.dataTable.totalCheckedRows--;
      } else {
        this.dataTable.totalCheckedRows++;
      }
      if (this.dataTable.totalCheckedRows === this.dataTable.itemCount) {
        this.dataTable.selectedAll = true;
        batchSelect.indeterminate = false;
      } else if (this.dataTable.totalCheckedRows === 0) {
        this.dataTable.selectedAll = false;
        batchSelect.indeterminate = false;
      } else {
        this.dataTable.selectedAll = true;
        batchSelect.indeterminate = true;
      }
    }
  }
  getCombinedClasses(column) {
    return {
      ...column.styleClassObject,
      'fw-semibold': column === this.firstContentColumn,
      'text-gray-900': column === this.firstContentColumn,
      'first-content-column': column === this.firstContentColumn,
      'fw-normal': column !== this.firstContentColumn,
      'text-gray-700': column !== this.firstContentColumn,
      'text-nowrap': true,
      'position-relative': true
    };
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusDataTableRow_BaseFactory;
      return function JanusDataTableRow_Factory(__ngFactoryType__) {
        return (ɵJanusDataTableRow_BaseFactory || (ɵJanusDataTableRow_BaseFactory = i0.ɵɵgetInheritedFactory(JanusDataTableRow)))(__ngFactoryType__ || JanusDataTableRow);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusDataTableRow,
      selectors: [["", "janusDataTableRow", ""]],
      inputs: {
        dataTable: "dataTable",
        parentItem: "parentItem",
        parentIndex: "parentIndex",
        janusVersion: "janusVersion"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      attrs: _c0$J,
      decls: 3,
      vars: 3,
      consts: [["class", "index-column table-column-padding", 3, "textContent", 4, "ngIf"], ["class", "actions", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "index-column", "table-column-padding", 3, "textContent"], [1, "actions"], [1, "d-flex", "align-items-center"], ["data-aria-label", "list action.Select item", "type", "checkbox", 1, "form-check-input", "border-gray-600", 3, "id", "checked"], [4, "ngIf"], ["data-aria-label", "list action.Select item", "type", "checkbox", 1, "form-check-input", "border-gray-600", 3, "change", "id", "checked"], ["type", "button", "class", "btn text-gray-600 p-0 border-0", "data-aria-label", "list action.View item", 3, "click", 4, "ngIf"], ["type", "button", "class", "btn text-gray-600 p-0 border-0", "data-aria-label", "list action.Edit item", 3, "click", 4, "ngIf"], ["type", "button", "class", "btn text-gray-600 p-0 border-0", "data-aria-label", "list action.Delete item", 3, "ngClass", "click", 4, "ngIf"], ["type", "button", "data-aria-label", "list action.View item", 1, "btn", "text-gray-600", "p-0", "border-0", 3, "click"], [1, "icon-xl-font-size", "d-flex"], ["type", "button", "data-aria-label", "list action.Edit item", 1, "btn", "text-gray-600", "p-0", "border-0", 3, "click"], ["type", "button", "data-aria-label", "list action.Delete item", 1, "btn", "text-gray-600", "p-0", "border-0", 3, "click", "ngClass"], ["type", "button", "class", "btn text-gray-600 p-0 border-0", 3, "ngClass", "click", 4, "ngIf"], ["type", "button", 1, "btn", "text-gray-600", "p-0", "border-0", 3, "click", "ngClass"], ["role", "cell", 3, "hide", "ngClass", "background-color", 4, "ngIf"], ["role", "cell", 3, "hide", "ngClass"], [3, "textContent", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [3, "textContent"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function JanusDataTableRow_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusDataTableRow_td_0_Template, 1, 1, "td", 0)(1, JanusDataTableRow_td_1_Template, 4, 2, "td", 1)(2, JanusDataTableRow_ng_container_2_Template, 2, 1, "ng-container", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.dataTable.indexColumnVisible);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.dataTable.selectColumnVisible || ctx.dataTable.hasListItemActions);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.dataTable.columns);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, Hide],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusDataTableRow, [{
    type: Component,
    args: [{
      selector: '[janusDataTableRow]',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<td *ngIf=\"dataTable.indexColumnVisible\" class=\"index-column table-column-padding\" [textContent]=\"displayIndex\"></td>\r\n<td *ngIf=\"dataTable.selectColumnVisible || dataTable.hasListItemActions\" class=\"actions\">\r\n    <div class=\"d-flex align-items-center\">\r\n        @if (dataTable.selectColumnVisible) {\r\n        <input data-aria-label=\"list action.Select item\" class=\"form-check-input border-gray-600\"\r\n            id=\"checkbox_{{index}}\" type=\"checkbox\" [checked]=\"selected\"\r\n            (change)=\"dataTable.onCheckboxSelect(this, selected); setIndeterminate(selected);\" />\r\n        }\r\n        <ng-container *ngIf=\"dataTable.hasListItemActions\">\r\n            <button *ngIf=\"dataTable.canView\" type=\"button\" class=\"btn text-gray-600 p-0 border-0\"\r\n                (click)=\"dataTable.viewItem(item)\" data-aria-label=\"list action.View item\">\r\n                <svg class=\"icon-xl-font-size d-flex\">\r\n                    <use [attr.xlink:href]=\"dataTable.assetsPath + 'tabler-sprite-nostroke.svg#tabler-file-search'\">\r\n                    </use>\r\n                </svg>\r\n            </button>\r\n            <button *ngIf=\"dataTable.canEdit\" type=\"button\" class=\"btn text-gray-600 p-0 border-0\"\r\n                (click)=\"dataTable.editItem(item)\" data-aria-label=\"list action.Edit item\">\r\n                <svg class=\"icon-xl-font-size d-flex\">\r\n                    <use [attr.xlink:href]=\"dataTable.assetsPath + 'tabler-sprite-nostroke.svg#tabler-edit'\"></use>\r\n                </svg>\r\n            </button>\r\n            <button *ngIf=\"dataTable.canDelete\" type=\"button\" class=\"btn text-gray-600 p-0 border-0\"\r\n                [ngClass]=\"{'me-2' : dataTable.customRowActions.length}\" (click)=\"dataTable.deleteItem(item)\"\r\n                data-aria-label=\"list action.Delete item\">\r\n                <svg class=\"icon-xl-font-size d-flex\">\r\n                    <use [attr.xlink:href]=\"dataTable.assetsPath + 'tabler-sprite-nostroke.svg#tabler-trash'\"></use>\r\n                </svg>\r\n            </button>\r\n            <ng-container *ngFor='let customAction of dataTable.customRowActions; let last = last'>\r\n                <button *ngIf=\"!customAction.canUse || customAction.canUse(item)\" type=\"button\"\r\n                    class=\"btn text-gray-600 p-0 border-0\" [ngClass]=\"{'me-2' : !last}\"\r\n                    [attr.aria-label]=\"customAction.label\" (click)=\"customAction.fn(item)\">\r\n                    <svg class=\"icon-xl-font-size d-flex\">\r\n                        <use\r\n                            [attr.xlink:href]=\"'{{dataTable.assetsPath}}tabler-sprite-nostroke.svg#tabler-' + customAction.icon\">\r\n                        </use>\r\n                    </svg>\r\n                </button>\r\n            </ng-container>\r\n        </ng-container>\r\n    </div>\r\n</td>\r\n<ng-container *ngFor=\"let column of dataTable.columns; let childIndex = index\">\r\n    <td *ngIf=\"column.property !== 'Actions'\" [hide]=\"!column.visible\" [ngClass]=\"getCombinedClasses(column)\"\r\n        [style.background-color]=\"column.getCellColor(this, index)\" role=\"cell\"\r\n        [attr.headers]=\"'column-' + (childIndex + 1)\">\r\n        <div *ngIf=\"!column.cellTemplate && column.property!=='display' && item[column.property]\"\r\n            [textContent]=\"item[column.property]\"></div>\r\n        <div *ngIf=\"column.cellTemplate\" [ngTemplateOutlet]=\"column.cellTemplate\" [ngTemplateOutletContext]=\"{\r\n            column: column,\r\n            row: _this,\r\n            item: item,\r\n            parentItem: parentItem,\r\n            parentIndex: parentIndex\r\n        }\">\r\n        </div>\r\n    </td>\r\n</ng-container>"
    }]
  }], null, {
    dataTable: [{
      type: Input
    }],
    parentItem: [{
      type: Input
    }],
    parentIndex: [{
      type: Input
    }],
    janusVersion: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusDataTableRow, {
    className: "JanusDataTableRow",
    filePath: "janus/components/data-table/janus-row.ts",
    lineNumber: 12
  });
})();
class JanusDataTableColumn extends DataTableColumn {
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusDataTableColumn_BaseFactory;
      return function JanusDataTableColumn_Factory(__ngFactoryType__) {
        return (ɵJanusDataTableColumn_BaseFactory || (ɵJanusDataTableColumn_BaseFactory = i0.ɵɵgetInheritedFactory(JanusDataTableColumn)))(__ngFactoryType__ || JanusDataTableColumn);
      };
    })();
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: JanusDataTableColumn,
      selectors: [["janus-data-table-column"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusDataTableColumn, [{
    type: Directive,
    args: [{
      selector: 'janus-data-table-column',
      standalone: false
    }]
  }], null, null);
})();
const _c0$I = ["dataTableExpand"];
const _c1$A = ["dataTableGroupedRowsHeader"];
const _c2$u = ["noSelection"];
const _c3$l = ["hpWidget"];
const _c4$j = (a0, a1, a2, a3) => ({
  "overflow-auto h-100": a0,
  "bg-white content-columns mt-2 mt-xl-3 border border-gray-200": a1,
  "d-block": a2,
  "d-flex align-items-center justify-content-center": a3
});
const _c5$c = a0 => ({
  "d-none": a0
});
const _c6$8 = (a0, a1) => [a0, a1];
const _c7$5 = (a0, a1, a2) => ({
  start: a0,
  end: a1,
  total: a2
});
const _c8$4 = a0 => ({
  "visually-hidden": a0
});
const _c9$4 = (a0, a1) => ({
  x: a0,
  total: a1
});
const _c10$3 = a0 => ({
  "list-addnew-btn": a0
});
const _c11$2 = () => ({
  "margin": 0,
  "height": "36px"
});
const _c12$1 = () => ({
  "display": "flex",
  "margin": 0,
  "height": "25px",
  "margin-top": "1.25rem"
});
const _c13$1 = () => ({
  "display": "flex",
  "margin": 0
});
const _c14$1 = () => ({
  "display": "flex",
  "margin": 0,
  "height": "10px"
});
const _c15 = () => ({
  "display": "flex",
  "margin": 0,
  "height": "20px"
});
const _c16 = a0 => ({
  "bg-white mx-3": a0
});
const _c17 = (a0, a1) => ({
  "list-min-h w-100": a0,
  "mx-3 bg-white border border-ultra-light border-top-0 border-bottom-0": a1
});
const _c18 = (a0, a1, a2) => ({
  "expandable-table": a0,
  "table-responsive": a1,
  "table-borderless fs-5": a2
});
const _c19 = a0 => ({
  object_name: a0
});
const _c20 = (a0, a1) => ({
  "position-sticky top-0 z-1": a0,
  "border-top": a1
});
const _c21 = a0 => ({
  "py-md-2": a0
});
const _c22 = (a0, a1) => ({
  "ps-3": a0,
  "py-md-2": a1
});
const _c23 = (a0, a1) => ({
  "ps-3": a0,
  "d-flex align-items-center p-2 py-2 h-100 border-bottom border-gray-200 py-md-6": a1
});
const _c24 = a0 => ({
  "h6 mb-0 text-wrap": a0
});
const _c25 = a0 => ({
  field_name: a0
});
const _c26 = a0 => ({
  "text-gray-400": a0
});
const _c27 = a0 => ({
  column: a0
});
const _c28 = a0 => ({
  "lh-1": a0
});
const _c29 = (a0, a1, a2) => ({
  id: a0,
  item: a1,
  states: a2
});
const _c30 = () => ({});
const _c31 = (a0, a1) => ({
  "modal-close": a0,
  "btn-close": a1
});
function JanusDataTable_section_0_button_3__svg_svg_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 25);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r2.assetsPath + "tabler-sprite.svg#tabler-plus", null, "xlink");
  }
}
function JanusDataTable_section_0_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function JanusDataTable_section_0_button_3_Template_button_click_0_listener() {
      const button_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.customButtonEvent(button_r2.id));
    });
    i0.ɵɵtemplate(3, JanusDataTable_section_0_button_3__svg_svg_3_Template, 2, 1, "svg", 23);
    i0.ɵɵelementStart(4, "span", 24);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const button_r2 = ctx.$implicit;
    i0.ɵɵclassMapInterpolate1("btn me-2 ", button_r2.styleClass, " text-nowrap");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c10$3, button_r2.id === "addNew"));
    i0.ɵɵattribute("aria-label", button_r2.ariaLabel ? i0.ɵɵpipeBind1(1, 8, button_r2.ariaLabel) : null)("title", button_r2.ariaLabel ? i0.ɵɵpipeBind1(2, 10, button_r2.ariaLabel) : null);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", button_r2.id === "addNew");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 12, button_r2.display));
  }
}
function JanusDataTable_section_0_div_4_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function JanusDataTable_section_0_div_4_button_1_Template_button_click_0_listener() {
      const btn_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      return i0.ɵɵresetView(btn_r5.onclick ? btn_r5.onclick : null);
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const btn_r5 = ctx.$implicit;
    i0.ɵɵclassMap(btn_r5.class ? btn_r5.class : "btn btn-outline-primary text-nowrap me-2");
    i0.ɵɵattribute("disabled", btn_r5.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(btn_r5.label);
  }
}
function JanusDataTable_section_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, JanusDataTable_section_0_div_4_button_1_Template, 2, 4, "button", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.additionalListButtons);
  }
}
function JanusDataTable_section_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29)(1, "button", 30);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 31);
    i0.ɵɵelement(4, "use", 32);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(5, "ul", 33);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 1, "misc.More actions"));
  }
}
function JanusDataTable_section_0_ng_container_6_hierarchical_list_widget_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hierarchical-list-widget", 43, 2);
    i0.ɵɵlistener("selection", function JanusDataTable_section_0_ng_container_6_hierarchical_list_widget_12_Template_hierarchical_list_widget_selection_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      i0.ɵɵnextContext();
      const batchOption_r7 = i0.ɵɵreference(2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.batchOptionsSelection($event, batchOption_r7));
    })("navigationChanged", function JanusDataTable_section_0_ng_container_6_hierarchical_list_widget_12_Template_hierarchical_list_widget_navigationChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      i0.ɵɵnextContext();
      const batchOption_r7 = i0.ɵɵreference(2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.batchOptionsNav($event, batchOption_r7));
    })("statesChanged", function JanusDataTable_section_0_ng_container_6_hierarchical_list_widget_12_Template_hierarchical_list_widget_statesChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      i0.ɵɵnextContext();
      const batchOption_r7 = i0.ɵɵreference(2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.batchOptionsStates($event, batchOption_r7));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", ctx_r2.batchOptionsConfig)("list", ctx_r2.batchOptions);
  }
}
function JanusDataTable_section_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 34, 1);
    i0.ɵɵlistener("openChange", function JanusDataTable_section_0_ng_container_6_Template_div_openChange_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const batchOption_r7 = i0.ɵɵreference(2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.openBatchAction($event, batchOption_r7));
    });
    i0.ɵɵelementStart(3, "button", 35);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 36);
    i0.ɵɵelement(5, "use", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "span", 38);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(9, "svg", 39);
    i0.ɵɵelement(10, "use", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(11, "div", 41);
    i0.ɵɵtemplate(12, JanusDataTable_section_0_ng_container_6_hierarchical_list_widget_12_Template, 2, 2, "hierarchical-list-widget", 42);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("autoClose", "outside");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 7, "misc.Actions"));
    i0.ɵɵadvance(4);
    i0.ɵɵstyleProp("scroll-padding", ctx_r2.hpScrollPadding, "px");
    i0.ɵɵclassProp("d-block", ctx_r2.showBatchActionMenu);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showBatchActionMenu);
  }
}
function JanusDataTable_section_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵtemplate(3, JanusDataTable_section_0_button_3_Template, 7, 16, "button", 16)(4, JanusDataTable_section_0_div_4_Template, 2, 1, "div", 17)(5, JanusDataTable_section_0_div_5_Template, 6, 3, "div", 18)(6, JanusDataTable_section_0_ng_container_6_Template, 13, 9, "ng-container", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 19)(8, "span", 20);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "min");
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "span", 21);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "janus-pagination");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 10, "misc.List Actions and Pagination"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.customButtons)("ngForTrackBy", ctx_r2.trackByIndex);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.additionalListButtons && ctx_r2.additionalListButtons.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.additionalListButtons && ctx_r2.additionalListButtons.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.batchOptions);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c5$c, ctx_r2.totalCheckedRows));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(11, 14, "misc.List items range", i0.ɵɵpureFunction3(25, _c7$5, ctx_r2.offset + 1, i0.ɵɵpipeBind1(10, 12, i0.ɵɵpureFunction2(22, _c6$8, ctx_r2.offset + ctx_r2.limit, ctx_r2.itemCount)), ctx_r2.itemCount)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(29, _c8$4, !ctx_r2.totalCheckedRows))("innerHTML", i0.ɵɵpipeBind2(13, 17, "misc.List items x selected", i0.ɵɵpureFunction2(31, _c9$4, ctx_r2.totalCheckedRows, ctx_r2.itemCount)), i0.ɵɵsanitizeHtml);
  }
}
function JanusDataTable_section_1_ng_container_8_hierarchical_list_widget_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hierarchical-list-widget", 55, 2);
    i0.ɵɵlistener("selection", function JanusDataTable_section_1_ng_container_8_hierarchical_list_widget_11_Template_hierarchical_list_widget_selection_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      i0.ɵɵnextContext();
      const mobileBatchOption_r11 = i0.ɵɵreference(2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.batchOptionsSelection($event, mobileBatchOption_r11));
    })("navigationChanged", function JanusDataTable_section_1_ng_container_8_hierarchical_list_widget_11_Template_hierarchical_list_widget_navigationChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      i0.ɵɵnextContext();
      const mobileBatchOption_r11 = i0.ɵɵreference(2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.batchOptionsNav($event, mobileBatchOption_r11));
    })("statesChanged", function JanusDataTable_section_1_ng_container_8_hierarchical_list_widget_11_Template_hierarchical_list_widget_statesChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      i0.ɵɵnextContext();
      const mobileBatchOption_r11 = i0.ɵɵreference(2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.batchOptionsStates($event, mobileBatchOption_r11));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", ctx_r2.batchOptionsConfig)("list", ctx_r2.batchOptions);
  }
}
function JanusDataTable_section_1_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 51, 3);
    i0.ɵɵlistener("openChange", function JanusDataTable_section_1_ng_container_8_Template_div_openChange_1_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const mobileBatchOption_r11 = i0.ɵɵreference(2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.openBatchAction($event, mobileBatchOption_r11, true));
    });
    i0.ɵɵelementStart(3, "button", 52)(4, "span", 49);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 50);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(8, "svg");
    i0.ɵɵelement(9, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(10, "div", 53);
    i0.ɵɵtemplate(11, JanusDataTable_section_1_ng_container_8_hierarchical_list_widget_11_Template, 2, 2, "hierarchical-list-widget", 54);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("autoClose", "outside");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 8, "misc.Actions"));
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("href", ctx_r2.assetsPath + "tabler-sprite.svg#tabler-settings", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("scroll-padding", ctx_r2.hpScrollPadding, "px");
    i0.ɵɵclassProp("d-block", ctx_r2.showMobileBatchActionMenu);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showMobileBatchActionMenu);
  }
}
function JanusDataTable_section_1_ng_container_9_button_1__svg_svg_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg");
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", "/images/tabler-icons/tabler-sprite.svg#" + (button_r14.id === "addNew" ? "tabler-plus" : button_r14.icon), null, "xlink");
  }
}
function JanusDataTable_section_1_ng_container_9_button_1__svg_svg_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg");
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r2.assetsPath + "tabler-sprite.svg#tabler-dots-circle-horizontal", null, "xlink");
  }
}
function JanusDataTable_section_1_ng_container_9_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 57);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function JanusDataTable_section_1_ng_container_9_button_1_Template_button_click_0_listener() {
      const button_r14 = i0.ɵɵrestoreView(_r13).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.customButtonEvent(button_r14.id));
    });
    i0.ɵɵelementStart(3, "span", 49);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 50);
    i0.ɵɵtemplate(7, JanusDataTable_section_1_ng_container_9_button_1__svg_svg_7_Template, 2, 1, "svg", 9)(8, JanusDataTable_section_1_ng_container_9_button_1__svg_svg_8_Template, 2, 1, "svg", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const button_r14 = ctx.$implicit;
    i0.ɵɵproperty("disabled", !!button_r14.disabled);
    i0.ɵɵattribute("aria-label", button_r14.ariaLabel ? i0.ɵɵpipeBind1(1, 6, button_r14.ariaLabel) : null)("title", button_r14.ariaLabel ? i0.ɵɵpipeBind1(2, 8, button_r14.ariaLabel) : null);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 10, button_r14.display));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", button_r14.icon || button_r14.id === "addNew");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !button_r14.icon && button_r14.id !== "addNew");
  }
}
function JanusDataTable_section_1_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusDataTable_section_1_ng_container_9_button_1_Template, 9, 12, "button", 56);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.customButtons)("ngForTrackBy", ctx_r2.trackByIndex);
  }
}
function JanusDataTable_section_1_ng_container_10_button_1__svg_svg_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg");
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const btn_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", "/images/tabler-icons/tabler-sprite.svg#" + btn_r16.icon, null, "xlink");
  }
}
function JanusDataTable_section_1_ng_container_10_button_1__svg_svg_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg");
    i0.ɵɵelement(1, "use", 60);
    i0.ɵɵelementEnd();
  }
}
function JanusDataTable_section_1_ng_container_10_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 59);
    i0.ɵɵlistener("click", function JanusDataTable_section_1_ng_container_10_button_1_Template_button_click_0_listener() {
      const btn_r16 = i0.ɵɵrestoreView(_r15).$implicit;
      return i0.ɵɵresetView(btn_r16.onclick ? btn_r16.onclick : null);
    });
    i0.ɵɵelementStart(1, "span", 49);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 50);
    i0.ɵɵtemplate(4, JanusDataTable_section_1_ng_container_10_button_1__svg_svg_4_Template, 2, 1, "svg", 9)(5, JanusDataTable_section_1_ng_container_10_button_1__svg_svg_5_Template, 2, 0, "svg", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const btn_r16 = ctx.$implicit;
    i0.ɵɵproperty("disabled", !!btn_r16.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(btn_r16.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", btn_r16.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !btn_r16.icon);
  }
}
function JanusDataTable_section_1_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusDataTable_section_1_ng_container_10_button_1_Template, 6, 4, "button", 58);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.additionalListButtons);
  }
}
function JanusDataTable_section_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 44);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "button", 45);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("click", function JanusDataTable_section_1_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.triggerListOpen());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg");
    i0.ɵɵelement(5, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "div", 46);
    i0.ɵɵlistener("keydown.esc", function JanusDataTable_section_1_Template_div_keydown_esc_6_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.triggerListClose());
    })("click", function JanusDataTable_section_1_Template_div_click_6_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.triggerListClickHandler($event));
    });
    i0.ɵɵelementStart(7, "div", 47);
    i0.ɵɵtemplate(8, JanusDataTable_section_1_ng_container_8_Template, 12, 10, "ng-container", 9)(9, JanusDataTable_section_1_ng_container_9_Template, 2, 2, "ng-container", 9)(10, JanusDataTable_section_1_ng_container_10_Template, 2, 1, "ng-container", 9);
    i0.ɵɵelementStart(11, "button", 48);
    i0.ɵɵlistener("click", function JanusDataTable_section_1_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.triggerListClose());
    });
    i0.ɵɵelementStart(12, "span", 49);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 50);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(16, "svg");
    i0.ɵɵelement(17, "use");
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 8, "misc.List Controls"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 10, "misc.List Actions"));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r2.assetsPath + "tabler-sprite.svg#tabler-bolt", null, "xlink");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.batchOptions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.customButtons == null ? null : ctx_r2.customButtons.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.additionalListButtons == null ? null : ctx_r2.additionalListButtons.length);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 12, "misc.Close"));
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("href", ctx_r2.assetsPath + "tabler-sprite.svg#tabler-x", null, "xlink");
  }
}
function JanusDataTable_div_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 61);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 62)(2, "ngx-skeleton-loader", 63);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 64);
    i0.ɵɵelementStart(4, "div", 65)(5, "span", 66);
    i0.ɵɵelement(6, "ngx-skeleton-loader", 67);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(3, _c11$2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(4, _c11$2));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(5, _c12$1));
  }
}
function JanusDataTable_div_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68)(1, "div", 69)(2, "span", 66);
    i0.ɵɵelement(3, "ngx-skeleton-loader", 70);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(4, "div", 71)(5, "div", 72)(6, "span", 66);
    i0.ɵɵelement(7, "ngx-skeleton-loader", 70);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 73)(9, "span", 74);
    i0.ɵɵelement(10, "ngx-skeleton-loader", 70);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(11, "div", 75)(12, "div", 69)(13, "span", 66);
    i0.ɵɵelement(14, "ngx-skeleton-loader", 70);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(4, _c13$1));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(5, _c14$1));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(6, _c15));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(7, _c13$1));
  }
}
function JanusDataTable_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusDataTable_div_3_Conditional_1_Template, 7, 6)(2, JanusDataTable_div_3_Conditional_2_Template, 15, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.janusVersion === 2 ? 1 : 2);
  }
}
function JanusDataTable_janus_data_table_header_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-data-table-header", 76);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c16, ctx_r2.janusVersion === 1))("header", ctx_r2.header)("assetsPath", ctx_r2.assetsPath);
  }
}
function JanusDataTable_div_5_caption_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "caption", 85);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.a11yDesc);
  }
}
function JanusDataTable_div_5_th_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 86)(1, "div", 87);
    i0.ɵɵelement(2, "span", 88);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c21, ctx_r2.janusVersion === 2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r2.indexColumnHeader);
  }
}
function JanusDataTable_div_5_th_11_input_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 91);
    i0.ɵɵpipe(1, "titlecase");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "lowercase");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "lowercase");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵlistener("click", function JanusDataTable_div_5_th_11_input_2_Template_input_click_0_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.batchSelect($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("checked", ctx_r2.selectedAll);
    i0.ɵɵattribute("aria-label", !ctx_r2.headerTitle ? i0.ɵɵpipeBind1(2, 4, "misc." + i0.ɵɵpipeBind1(1, 2, "select all")) : ctx_r2.totalCheckedRows === 0 ? i0.ɵɵpipeBind2(4, 8, "misc.Select all {object_name} records", i0.ɵɵpureFunction1(16, _c19, i0.ɵɵpipeBind1(3, 6, ctx_r2.headerTitle))) : i0.ɵɵpipeBind2(6, 13, "misc.Deselect all {object_name} records", i0.ɵɵpureFunction1(18, _c19, i0.ɵɵpipeBind1(5, 11, ctx_r2.headerTitle))));
  }
}
function JanusDataTable_div_5_th_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 86)(1, "div", 89);
    i0.ɵɵtemplate(2, JanusDataTable_div_5_th_11_input_2_Template, 7, 20, "input", 90);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c22, !ctx_r2.indexColumnVisible && ctx_r2.janusVersion === 2, ctx_r2.janusVersion === 2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.selectColumnVisible);
  }
}
function JanusDataTable_div_5_ng_container_12_th_1_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 98);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const column_r19 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c24, ctx_r2.useStickyHeader))("innerHTML", i0.ɵɵpipeBind1(1, 2, column_r19.header), i0.ɵɵsanitizeHtml);
  }
}
function JanusDataTable_div_5_ng_container_12_th_1_button_5_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 102);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const column_r19 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, column_r19.header), i0.ɵɵsanitizeHtml);
  }
}
function JanusDataTable_div_5_ng_container_12_th_1_button_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 99);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, JanusDataTable_div_5_ng_container_12_th_1_button_5_span_5_Template, 2, 3, "span", 100);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(6, "svg", 101);
    i0.ɵɵelement(7, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const column_r19 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c24, ctx_r2.useStickyHeader));
    i0.ɵɵattribute("aria-label", !ctx_r2.sortAsc ? i0.ɵɵpipeBind2(2, 7, "misc.Sort by {field_name}, ascending", i0.ɵɵpureFunction1(17, _c25, i0.ɵɵpipeBind1(1, 5, column_r19.header))) : i0.ɵɵpipeBind2(4, 12, "misc.Sort by {field_name}, descending", i0.ɵɵpureFunction1(19, _c25, i0.ɵɵpipeBind1(3, 10, column_r19.header))));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", column_r19.header);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c26, !column_r19.active || column_r19.property !== ctx_r2.sortBy));
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r2.assetsPath + "tabler-sprite-nostroke.svg#tabler-" + (column_r19.sortable && column_r19.property !== ctx_r2.sortBy || column_r19.sortable && column_r19.property === ctx_r2.sortBy && ctx_r2.sortAsc ? "chevron-up" : column_r19.sortable && column_r19.property === ctx_r2.sortBy && !ctx_r2.sortAsc ? "chevron-down" : ""), null, "xlink");
  }
}
function JanusDataTable_div_5_ng_container_12_th_1_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 85);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r19 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, column_r19.emptyHeader));
  }
}
function JanusDataTable_div_5_ng_container_12_th_1_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 103);
  }
  if (rf & 2) {
    const column_r19 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", column_r19.headerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c27, column_r19));
  }
}
function JanusDataTable_div_5_ng_container_12_th_1_span_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 104);
    i0.ɵɵlistener("mousedown", function JanusDataTable_div_5_ng_container_12_th_1_span_8_Template_span_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r20);
      i0.ɵɵnextContext();
      const th_r21 = i0.ɵɵreference(1);
      const column_r19 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.resizeColumnStart($event, column_r19, th_r21));
    });
    i0.ɵɵelementEnd();
  }
}
function JanusDataTable_div_5_ng_container_12_th_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 93, 4);
    i0.ɵɵpipe(2, "px");
    i0.ɵɵlistener("keyup.enter", function JanusDataTable_div_5_ng_container_12_th_1_Template_th_keyup_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const column_r19 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.headerClicked(column_r19, $event));
    })("click", function JanusDataTable_div_5_ng_container_12_th_1_Template_th_click_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const column_r19 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.headerClicked(column_r19, $event));
    });
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtemplate(4, JanusDataTable_div_5_ng_container_12_th_1_span_4_Template, 2, 6, "span", 94)(5, JanusDataTable_div_5_ng_container_12_th_1_button_5_Template, 8, 23, "button", 95)(6, JanusDataTable_div_5_ng_container_12_th_1_span_6_Template, 3, 3, "span", 80)(7, JanusDataTable_div_5_ng_container_12_th_1_span_7_Template, 1, 4, "span", 96)(8, JanusDataTable_div_5_ng_container_12_th_1_span_8_Template, 1, 0, "span", 97);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext();
    const column_r19 = ctx_r21.$implicit;
    const headerIndex_r23 = ctx_r21.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("width", i0.ɵɵpipeBind1(2, 18, column_r19.width));
    i0.ɵɵclassProp("actions", !column_r19.cellTemplate && column_r19.property === "Actions")("sortable", column_r19.sortable)("resizable", column_r19.resizable);
    i0.ɵɵproperty("hide", !column_r19.visible)("ngClass", ctx_r2.getCombinedClasses(column_r19));
    i0.ɵɵattribute("id", "column-" + column_r19.property)("aria-sort", column_r19.sortable && column_r19.property === ctx_r2.sortBy ? ctx_r2.sortAsc ? "ascending" : "descending" : null);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(20, _c23, !ctx_r2.indexColumnVisible && !ctx_r2.selectColumnVisible && headerIndex_r23 === 0 && ctx_r2.janusVersion === 2, ctx_r2.janusVersion === 2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !column_r19.sortable && column_r19.property !== "Actions");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !column_r19.headerTemplate && column_r19.sortable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !column_r19.header);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r19.headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r19.resizable);
  }
}
function JanusDataTable_div_5_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusDataTable_div_5_ng_container_12_th_1_Template, 9, 23, "th", 92);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const column_r19 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r19.property !== "Actions");
  }
}
function JanusDataTable_div_5_ng_container_13_tr_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 107, 5);
    i0.ɵɵlistener("dblclick", function JanusDataTable_div_5_ng_container_13_tr_2_Template_tr_dblclick_0_listener($event) {
      i0.ɵɵrestoreView(_r24);
      const row_r25 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.rowDoubleClicked(row_r25, $event));
    })("click", function JanusDataTable_div_5_ng_container_13_tr_2_Template_tr_click_0_listener($event) {
      i0.ɵɵrestoreView(_r24);
      const row_r25 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.rowClicked(row_r25, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r26 = ctx.$implicit;
    const idx_r27 = ctx.index;
    const row_r25 = i0.ɵɵreference(1);
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("background-color", ctx_r2.getRowColor(item_r26, idx_r27, row_r25));
    i0.ɵɵclassProp("row-odd", idx_r27 % 2 === 0)("row-even", idx_r27 % 2 === 1)("row_content_style", true)("selected-row", row_r25.selected)("clickable", ctx_r2.selectOnRowClick);
    i0.ɵɵproperty("dataTable", ctx_r2)("item", item_r26)("index", idx_r27)("title", ctx_r2.getTooltip(item_r26, row_r25, idx_r27));
  }
}
function JanusDataTable_div_5_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tbody", 105);
    i0.ɵɵtemplate(2, JanusDataTable_div_5_ng_container_13_tr_2_Template, 2, 16, "tr", 106);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.items);
  }
}
function JanusDataTable_div_5_ng_container_14_ng_container_1_tbody_5_tr_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 114, 5);
    i0.ɵɵlistener("dblclick", function JanusDataTable_div_5_ng_container_14_ng_container_1_tbody_5_tr_1_Template_tr_dblclick_0_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const row_r29 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r2.rowDoubleClicked(row_r29, $event));
    })("click", function JanusDataTable_div_5_ng_container_14_ng_container_1_tbody_5_tr_1_Template_tr_click_0_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const row_r29 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r2.rowClicked(row_r29, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r30 = ctx.$implicit;
    const idx_r31 = ctx.index;
    const row_r29 = i0.ɵɵreference(1);
    const ctx_r31 = i0.ɵɵnextContext(2);
    const parentItem_r33 = ctx_r31.$implicit;
    const parentIdx_r34 = ctx_r31.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("group-" + (parentIdx_r34 + 1) + "-collapse");
    i0.ɵɵstyleProp("background-color", ctx_r2.getRowColor(item_r30, idx_r31, row_r29));
    i0.ɵɵclassProp("row-odd", idx_r31 % 2 === 0)("row-even", idx_r31 % 2 === 1)("selected-row", row_r29.selected)("clickable", ctx_r2.selectOnRowClick);
    i0.ɵɵproperty("dataTable", ctx_r2)("item", item_r30)("index", idx_r31)("parentItem", parentItem_r33)("parentIndex", parentIdx_r34)("id", "content-" + (parentIdx_r34 + 1) + "-" + (idx_r31 + 1))("title", ctx_r2.getTooltip(item_r30, row_r29, idx_r31))("janusVersion", ctx_r2.janusVersion);
  }
}
function JanusDataTable_div_5_ng_container_14_ng_container_1_tbody_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 112);
    i0.ɵɵtemplate(1, JanusDataTable_div_5_ng_container_14_ng_container_1_tbody_5_tr_1_Template, 2, 20, "tr", 113);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const parentItem_r33 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", parentItem_r33[ctx_r2.groupedRowsField]);
  }
}
function JanusDataTable_div_5_ng_container_14_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tbody", 108)(2, "tr", 109)(3, "th", 110);
    i0.ɵɵelement(4, "div", 103);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(5, JanusDataTable_div_5_ng_container_14_ng_container_1_tbody_5_Template, 2, 1, "tbody", 111);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const parentItem_r33 = ctx.$implicit;
    const parentIdx_r34 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("id", "row-" + (parentIdx_r34 + 1))("ngClass", i0.ɵɵpureFunction1(6, _c28, ctx_r2.janusVersion === 1));
    i0.ɵɵattribute("colspan", ctx_r2.columnCount);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.groupedRowsHeaderTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(8, _c29, parentIdx_r34, parentItem_r33, ctx_r2.collapsedRows));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", parentItem_r33[ctx_r2.groupedRowsField].length && !ctx_r2.collapsedRows[parentIdx_r34]);
  }
}
function JanusDataTable_div_5_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusDataTable_div_5_ng_container_14_ng_container_1_Template, 6, 12, "ng-container", 84);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.items);
  }
}
function JanusDataTable_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 77)(1, "div")(2, "table", 78);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "min");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "tbody", 79);
    i0.ɵɵtemplate(7, JanusDataTable_div_5_caption_7_Template, 2, 1, "caption", 80);
    i0.ɵɵelementStart(8, "thead", 81)(9, "tr", 82);
    i0.ɵɵtemplate(10, JanusDataTable_div_5_th_10_Template, 3, 4, "th", 83)(11, JanusDataTable_div_5_th_11_Template, 3, 5, "th", 83)(12, JanusDataTable_div_5_ng_container_12_Template, 2, 1, "ng-container", 84);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, JanusDataTable_div_5_ng_container_13_Template, 3, 1, "ng-container", 9)(14, JanusDataTable_div_5_ng_container_14_Template, 2, 1, "ng-container", 9);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(18, _c17, ctx_r2.janusVersion === 2, ctx_r2.janusVersion === 1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(21, _c18, ctx_r2.groupedRows, !ctx_r2.useStickyFooterControls, ctx_r2.janusVersion === 1));
    i0.ɵɵattribute("aria-label", (ctx_r2.headerTitle ? i0.ɵɵpipeBind2(3, 10, "misc.List of {object_name} records", i0.ɵɵpureFunction1(25, _c19, ctx_r2.headerTitle)) + ", " : "") + i0.ɵɵpipeBind2(5, 15, "misc.List range", i0.ɵɵpureFunction3(30, _c7$5, ctx_r2.offset + 1, i0.ɵɵpipeBind1(4, 13, i0.ɵɵpureFunction2(27, _c6$8, ctx_r2.offset + ctx_r2.limit, ctx_r2.itemCount)), ctx_r2.itemCount)));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r2.a11yDesc);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(34, _c20, ctx_r2.useStickyHeader, ctx_r2.janusVersion === 1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.indexColumnVisible);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.selectColumnVisible || ctx_r2.hasListItemActions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.columns);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.groupedRows);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.groupedRows);
  }
}
function JanusDataTable_janus_data_table_header_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-data-table-header", 115);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c16, ctx_r2.janusVersion === 1))("header", ctx_r2.header)("assetsPath", ctx_r2.assetsPath);
  }
}
function JanusDataTable_div_7_ng_container_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 121);
    i0.ɵɵtext(1, "misc.Once you create records, they will appear here");
    i0.ɵɵelementEnd();
  }
}
function JanusDataTable_div_7_ng_container_1_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 122)(1, "button", 28);
    i0.ɵɵlistener("click", function JanusDataTable_div_7_ng_container_1_div_5_Template_button_click_1_listener() {
      const button_r36 = i0.ɵɵrestoreView(_r35).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.customButtonEvent(button_r36.id));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const button_r36 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("btn ", button_r36.styleClass, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, button_r36.display), " ");
  }
}
function JanusDataTable_div_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "janus-svg-icon", 117);
    i0.ɵɵelementStart(2, "h3", 118);
    i0.ɵɵtext(3, "misc.No records yet");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, JanusDataTable_div_7_ng_container_1_div_4_Template, 2, 0, "div", 119)(5, JanusDataTable_div_7_ng_container_1_div_5_Template, 4, 6, "div", 120);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", "search")("rem", 3.75)("size", "none")("cssClasses", "text-primary");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.customButtons || ctx_r2.showAddNewMsg);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.customButtons)("ngForTrackBy", ctx_r2.trackByIndex);
  }
}
function JanusDataTable_div_7_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 127);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 128);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "span", 129);
    i0.ɵɵtext(4, "misc.Empty List");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("class", ctx_r2.emptyStateImg.cssClasses)("width", ctx_r2.emptyStateImg.width)("height", ctx_r2.emptyStateImg.height)("viewBox", ctx_r2.emptyStateImg.viewBox);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r2.emptyStateImg.route, null, "xlink");
  }
}
function JanusDataTable_div_7_ng_container_2_i_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 130);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r2.emptyState.icon);
  }
}
function JanusDataTable_div_7_ng_container_2_h3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 131);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r2.emptyState.titleStyleClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, ctx_r2.emptyState.title), " ");
  }
}
function JanusDataTable_div_7_ng_container_2_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 98);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r2.emptyState.messageStyleClass)("innerHTML", ctx_r2.emptyState.message, i0.ɵɵsanitizeHtml);
  }
}
function JanusDataTable_div_7_ng_container_2_div_5_button_1__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 137);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const actionButton_r38 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", actionButton_r38.icon.styleClass);
    i0.ɵɵattribute("alt", i0.ɵɵpipeBind2(1, 3, actionButton_r38.label, actionButton_r38.translationParams || i0.ɵɵpureFunction0(6, _c30)));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r2.assetsPath + "tabler-sprite-nostroke.svg#tabler-" + actionButton_r38.icon.name, null, "xlink");
  }
}
function JanusDataTable_div_7_ng_container_2_div_5_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 135);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function JanusDataTable_div_7_ng_container_2_div_5_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r37);
      const actionButton_r38 = i0.ɵɵnextContext().ngIf;
      return i0.ɵɵresetView(actionButton_r38.onClick());
    });
    i0.ɵɵtemplate(2, JanusDataTable_div_7_ng_container_2_div_5_button_1__svg_svg_2_Template, 3, 7, "svg", 136);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const actionButton_r38 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("ngClass", actionButton_r38.styleClass);
    i0.ɵɵattribute("aria-label", actionButton_r38.ariaLabel ? i0.ɵɵpipeBind1(1, 4, actionButton_r38.ariaLabel) : null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", actionButton_r38.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(5, 6, actionButton_r38.label, actionButton_r38.translationParams || i0.ɵɵpureFunction0(9, _c30)), " ");
  }
}
function JanusDataTable_div_7_ng_container_2_div_5_a_2__svg_svg_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 137);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const actionButton_r38 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", actionButton_r38.icon.styleClass);
    i0.ɵɵattribute("alt", i0.ɵɵpipeBind2(1, 3, actionButton_r38.label, actionButton_r38.translationParams || i0.ɵɵpureFunction0(6, _c30)));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r2.assetsPath + "tabler-sprite-nostroke.svg#tabler-" + actionButton_r38.icon.name, null, "xlink");
  }
}
function JanusDataTable_div_7_ng_container_2_div_5_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 138);
    i0.ɵɵtemplate(1, JanusDataTable_div_7_ng_container_2_div_5_a_2__svg_svg_1_Template, 3, 7, "svg", 136);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const actionButton_r38 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("ngClass", actionButton_r38.styleClass)("routerLink", actionButton_r38.routerLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", actionButton_r38.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 4, actionButton_r38.label, actionButton_r38.translationParams || i0.ɵɵpureFunction0(7, _c30)), " ");
  }
}
function JanusDataTable_div_7_ng_container_2_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 132);
    i0.ɵɵtemplate(1, JanusDataTable_div_7_ng_container_2_div_5_button_1_Template, 6, 10, "button", 133)(2, JanusDataTable_div_7_ng_container_2_div_5_a_2_Template, 5, 8, "a", 134);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const actionButton_r38 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", actionButton_r38 && actionButton_r38.type === "button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", actionButton_r38 && actionButton_r38.type === "anchor");
  }
}
function JanusDataTable_div_7_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusDataTable_div_7_ng_container_2_div_1_Template, 5, 5, "div", 123)(2, JanusDataTable_div_7_ng_container_2_i_2_Template, 1, 1, "i", 124)(3, JanusDataTable_div_7_ng_container_2_h3_3_Template, 3, 4, "h3", 125)(4, JanusDataTable_div_7_ng_container_2_div_4_Template, 1, 2, "div", 94)(5, JanusDataTable_div_7_ng_container_2_div_5_Template, 3, 2, "div", 126);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.emptyStateImg.route);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.emptyState.icon && !ctx_r2.emptyState.src);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.emptyState.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.emptyState.message);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.emptyState.actionButton);
  }
}
function JanusDataTable_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 116);
    i0.ɵɵtemplate(1, JanusDataTable_div_7_ng_container_1_Template, 6, 7, "ng-container", 9)(2, JanusDataTable_div_7_ng_container_2_Template, 6, 5, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.useCustomEmptyState);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.useCustomEmptyState && ctx_r2.emptyState);
  }
}
function JanusDataTable_ng_container_8_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 142);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, "misc.List items x selected", i0.ɵɵpureFunction2(4, _c9$4, ctx_r2.totalCheckedRows, ctx_r2.itemCount)), i0.ɵɵsanitizeHtml);
  }
}
function JanusDataTable_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "section", 139);
    i0.ɵɵelement(2, "janus-pagination", 140);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, JanusDataTable_ng_container_8_div_3_Template, 2, 7, "div", 141);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("openUpwards", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.totalCheckedRows);
  }
}
function JanusDataTable_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 143)(1, "h3", 144);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 145);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵlistener("click", function JanusDataTable_ng_template_9_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r39);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.noSelectionModalRef.hide());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 146)(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 147)(11, "button", 148);
    i0.ɵɵlistener("click", function JanusDataTable_ng_template_9_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r39);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.noSelectionModalRef.hide());
    });
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 5, "misc.No selection"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c31, ctx_r2.janusVersion === 1, ctx_r2.janusVersion !== 1));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 7, "misc.Close"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 9, "misc.To perform this action, you must select at least one record."));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 11, "misc.OK"));
  }
}
class JanusDataTable extends DataTable {
  get execReloading() {
    return this.reloading;
  }
  set execReloading(value) {
    if (this._initiated) {
      this._reloading = true;
    }
  }
  constructor(backendService, translate, modalService, janusVersion) {
    super(backendService, translate);
    this.backendService = backendService;
    this.translate = translate;
    this.modalService = modalService;
    this.janusVersion = janusVersion;
    this.assetsPath = '/app/assets/';
    this.emptyStateImg = {
      route: '',
      width: '',
      height: '',
      viewBox: ''
    };
    this.groupedRows = false;
    this.groupedRowsField = '';
    this.a11yDesc = '';
    this.noBorder = false;
    this.useStickyHeader = false;
    this.useStickyFooterControls = false;
    this.additionalListButtons = [];
    this.selectedAll = false;
    this.collapsedRows = [];
    this.hasListItemActions = false;
    this.batchOptionsConfig = {
      templateType: 'janus',
      defaultLabel: this.translate.instant('misc.Actions'),
      forceMobileUI: true,
      addFullParentData: true,
      showSearchFieldOnDesktop: true
    };
    this.showBatchActionMenu = false;
    this.showMobileBatchActionMenu = false;
    this.hpScrollPadding = 0;
    this.janusVersion ??= 2;
  }
  ngAfterViewInit() {
    this.hasListItemActions = this.columns.find(column => column.property === 'Actions') ? true : false;
    setTimeout(() => {
      janusSecondaryActionsDropdownHandler();
    }, 100);
    this.itemsLoaded.subscribe(() => {
      setTimeout(() => {
        janusTableActionsAriaLabelHandler(this.translate);
        const batchSelect = document.querySelector(".list-maincol #batch-select");
        if (batchSelect) {
          if (!this.totalCheckedRows) {
            this.selectedAll = false;
            batchSelect.indeterminate = false;
          } else {
            if (this.totalCheckedRows === this.itemCount) {
              this.selectedAll = true;
              batchSelect.indeterminate = false;
            } else {
              this.selectedAll = true;
              batchSelect.indeterminate = true;
            }
          }
        }
      });
    });
  }
  batchSelect($event) {
    if (this.totalCheckedRows > 0) {
      this._onSelectAllChanged($event, false);
      this.selectedAll = false;
      this.totalCheckedRows = 0;
    } else {
      this._onSelectAllChanged($event, true);
      this.selectedAll = true;
      this.totalCheckedRows = this.itemCount;
    }
  }
  triggerListOpen() {
    const listOverlayEl = document.querySelector('.overlay-list-section .list-overlay');
    listOverlayEl.classList.remove('d-none');
    setTimeout(() => {
      listOverlayEl.classList.add('opacity-100');
    });
    document.querySelector('.list-overlay-trigger-close')?.focus();
  }
  triggerListClose() {
    const listOverlayEl = document.querySelector('.overlay-list-section .list-overlay');
    listOverlayEl.classList.remove('opacity-100');
    setTimeout(() => {
      listOverlayEl.classList.add('d-none');
      document.querySelector('.list-overlay-trigger')?.focus();
    }, 500);
  }
  triggerListClickHandler(e) {
    const overlay = e.target.closest('.overlay-list-section');
    const isClickedBackground = e.target.classList.contains('.list-overlay');
    const closestButton = overlay?.querySelector('button');
    if (isClickedBackground || closestButton?.classList.contains('list-overlay-close')) {
      this.triggerListClose();
      return;
    }
    if (closestButton?.classList.contains('list-overlay-trigger')) {
      this.triggerListOpen();
    }
  }
  onKeyUpCheckbox($event, check) {
    this._onSelectAllChanged($event, check);
    let checkboxStatus = "checkbox-selected";
    if (!check) {
      checkboxStatus = "checkbox-empty";
    }
    setTimeout(() => {
      document.getElementById(checkboxStatus)?.focus();
    });
  }
  openBatchAction(event, dropdown, isMobile = false) {
    if (isMobile) {
      this.showMobileBatchActionMenu = event;
    } else {
      this.showBatchActionMenu = event;
    }
    if (event) {
      dropdown._menu.nativeElement.classList.remove('dropdown-menu');
    } else {
      return;
    }
    setTimeout(() => {
      const focusables = getKeyboardFocusableElements(dropdown._menu.nativeElement);
      if (focusables.length) {
        focusables[0].focus();
      }
    });
  }
  batchOptionsSelection(select, dropdown) {
    if (!select?.length) {
      return;
    }
    const batchOption = select[0];
    if (!this.totalCheckedRows && !this.skipSelectedRowsCheck.includes(batchOption.id)) {
      this.noSelectionModal();
      return;
    }
    if (batchOption.parents[0]?.id === 'mail') {
      this.redirect(batchOption);
    } else {
      this.batchAction.emit({
        keySuffix: this.keySuffix,
        menu: batchOption
      });
    }
    dropdown.close();
  }
  batchOptionsStates(states, dropdown) {
    const mobileView = states.mobileView;
    const element = dropdown._elementRef.nativeElement;
    if (mobileView && !element.classList.contains('mobile-view-fullsize')) {
      element.classList.add('mobile-view-fullsize');
    }
    if (!mobileView && element.classList.contains('mobile-view-fullsize')) {
      element.classList.remove('mobile-view-fullsize');
    }
  }
  batchOptionsNav(event, dropdown) {
    if (event.type === 'close') {
      dropdown.close();
      this.triggerListClose();
    } else {
      setTimeout(() => {
        const hpWidgetElements = this.hpWidget.getElements();
        this.hpScrollPadding = hpWidgetElements.header?.clientHeight || 0;
      }, 10);
    }
  }
  noSelectionModal() {
    this.noSelectionModalRef = this.modalService.show(this.noSelectionTemplate, {
      class: this.janusVersion === 1 ? 'modal-sm' : 'modal-dialog-centered modal-fullscreen-sm-down',
      ariaLabelledBy: 'ax-title'
    });
  }
  redirect(batchOptions) {
    let messageId = batchOptions.id;
    let sesskey = batchOptions.sesskey;
    let urlSection = batchOptions.urlSection || 'students';
    window.location.href = `/manager/index.php?s=${urlSection}&curr_mode=list&mode=mailwiz&msg=${messageId}&sesskey=${sesskey}`;
  }
  getCombinedClasses(column) {
    return {
      ...column.styleClassObject,
      'fs-8 text-gray-800 fw-medium p-0 border-bottom-0': this.janusVersion === 2,
      'py-2 px-3 text-nowrap': this.janusVersion === 1,
      'active_col': column.active
    };
  }
  static {
    this.ɵfac = function JanusDataTable_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusDataTable)(i0.ɵɵdirectiveInject(BackendService), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i1$3.BsModalService), i0.ɵɵdirectiveInject('JANUS_VERSION', 8));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusDataTable,
      selectors: [["janus-data-table"]],
      contentQueries: function JanusDataTable_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c0$I, 7);
          i0.ɵɵcontentQuery(dirIndex, _c1$A, 7);
          i0.ɵɵcontentQuery(dirIndex, JanusDataTableColumn, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expandTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groupedRowsHeaderTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columns = _t);
        }
      },
      viewQuery: function JanusDataTable_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2$u, 5);
          i0.ɵɵviewQuery(_c3$l, 5);
          i0.ɵɵviewQuery(JanusDataTableRow, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noSelectionTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hpWidget = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rows = _t);
        }
      },
      hostVars: 2,
      hostBindings: function JanusDataTable_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.useStickyFooterControls ? "d-flex flex-column minh-0 h-100" : null);
        }
      },
      inputs: {
        assetsPath: "assetsPath",
        emptyStateImg: "emptyStateImg",
        groupedRows: "groupedRows",
        groupedRowsField: "groupedRowsField",
        a11yDesc: "a11yDesc",
        noBorder: "noBorder",
        useStickyHeader: "useStickyHeader",
        useStickyFooterControls: "useStickyFooterControls",
        additionalListButtons: "additionalListButtons",
        execReloading: "execReloading"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 11,
      vars: 14,
      consts: [["noSelection", ""], ["batchOption", "ngbDropdown"], ["hpWidget", ""], ["mobileBatchOption", "ngbDropdown"], ["th", ""], ["row", ""], ["class", "table-list-bottom-controls table-list-bottom-controls-sticky h-auto order flex-shrink-0 mx-3 mx-xl-4 pt-2 pt-xl-3 d-none d-sm-flex justify-content-between align-items-center border-gray-300 border-end-0 border-start-0 border-bottom-0", 4, "ngIf"], ["class", "overlay-list-section", 4, "ngIf"], [3, "ngClass"], [4, "ngIf"], ["class", "d-block rounded-top mt-3 py-2 border border-ultra-light border-bottom-0", 3, "ngClass", "header", "assetsPath", 4, "ngIf"], ["class", "list-wrap", 3, "ngClass", 4, "ngIf"], ["class", "d-block rounded-bottom mb-3 py-2 border border-ultra-light border-top-0", 3, "ngClass", "header", "assetsPath", 4, "ngIf"], ["class", "loading-table list-no-records d-flex flex-column align-items-center mt-5 mx-3 py5 text-center", 4, "ngIf"], [1, "table-list-bottom-controls", "table-list-bottom-controls-sticky", "h-auto", "order", "flex-shrink-0", "mx-3", "mx-xl-4", "pt-2", "pt-xl-3", "d-none", "d-sm-flex", "justify-content-between", "align-items-center", "border-gray-300", "border-end-0", "border-start-0", "border-bottom-0"], [1, "list_results", "d-flex", "align-items-center"], ["type", "button", 3, "class", "ngClass", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "d-none d-lg-inline-flex secondary-actions", 4, "ngIf"], ["class", "d-none dropup", "moredropdown", "", 4, "ngIf"], [1, "d-flex", "justify-content-end", "flex-fill", "mx-2", "text-nowrap"], ["id", "list_items_count_string", 1, "fs-5", "text-gray-600", 3, "ngClass"], ["id", "list_items_selected_counter", "aria-live", "polite", 1, "fs-5", "text-gray-600", 3, "ngClass", "innerHTML"], ["type", "button", 3, "click", "ngClass"], ["width", "1.5rem", "height", "1.5rem", "class", "d-lg-none", 4, "ngIf"], [1, "d-lg-block", "d-sm-none"], ["width", "1.5rem", "height", "1.5rem", 1, "d-lg-none"], [1, "d-none", "d-lg-inline-flex", "secondary-actions"], ["type", "button", 3, "class", "click", 4, "ngFor", "ngForOf"], ["type", "button", 3, "click"], ["moredropdown", "", 1, "d-none", "dropup"], ["type", "button", "data-bs-toggle", "dropdown", "aria-expanded", "false", 1, "btn", "btn-outline-gray-400", "text-dark", "me-2", "d-inline-flex"], ["width", "1.25rem", "height", "1.25rem"], [0, "xlink", "href", "/images/tabler-icons/tabler-sprite.svg#tabler-dots"], [1, "dropdown-menu"], ["ngbDropdown", "", 1, "d-none", "d-sm-inline-block", "hierpicklist-widget", 3, "openChange", "autoClose"], ["type", "button", "ngbDropdownToggle", "", "aria-controls", "batchActionMenu", 1, "btn", "btn-outline-gray-400", "text-dark", "d-inline-flex", "flex-nowrap", "list-actions-btn", "after-off"], ["width", "20px", "height", "20px", 1, "align-self-center", "me-1"], [0, "xlink", "href", "/images/tabler-icons/tabler-sprite.svg#tabler-settings"], [1, "d-none", "d-lg-block"], ["width", "20px", "height", "20px", 1, "align-self-center"], [0, "xlink", "href", "/images/tabler-icons/tabler-sprite.svg#tabler-chevron-down"], ["ngbDropdownMenu", "", "placement", "top-end", 1, "dropdown-menu-avoid-bs-js", "overflow-auto", "dropdown-menu-size", "py-0"], ["id", "batchActionMenu", "keyboardTrap", "", 3, "config", "list", "selection", "navigationChanged", "statesChanged", 4, "ngIf"], ["id", "batchActionMenu", "keyboardTrap", "", 3, "selection", "navigationChanged", "statesChanged", "config", "list"], [1, "overlay-list-section"], ["type", "button", 1, "list-overlay-trigger", "d-sm-none", "avatar", "avatar-icon", "rounded", "position-fixed", "bg-primary", "text-white", "p-1", "z-1", 3, "click"], ["keyboardTrap", "", "role", "dialog", "aria-modal", "true", 1, "list-overlay", "opacity-0", "fixed-bottom", "top-0", "bg-white", "d-none", "d-sm-none", "d-flex", "flex-column", "align-items-end", "overflow-auto", "p-3", 3, "keydown.esc", "click"], [1, "mt-auto"], ["type", "button", 1, "list-overlay-trigger-close", "d-flex", "align-items-center", "bg-transparent", "p-0", "ps-2", "mt-3", "text-gray-800", "rounded", "border-0", "ms-auto", "text-capitalize", 3, "click"], [1, "me-2"], [1, "avatar", "avatar-icon", "avatar-md", "p-1", "bg-white", "border", "border-gray-400", "rounded"], ["ngbDropdown", "", 1, "hierpicklist-widget", 3, "openChange", "autoClose"], ["type", "button", "ngbDropdownToggle", "", "aria-controls", "mobileBatchActionMenu", 1, "d-flex", "align-items-center", "bg-transparent", "p-0", "ps-2", "mt-3", "text-gray-800", "rounded", "border-0", "ms-auto", "text-capitalize", "after-off"], ["ngbDropdownMenu", "", 1, "hp-dropdown", "dropdown-menu-avoid-bs-js", "d-block", "overflow-auto", "dropdown-menu-size", "py-0"], ["id", "mobileBatchActionMenu", "keyboardTrap", "", 3, "config", "list", "selection", "navigationChanged", "statesChanged", 4, "ngIf"], ["id", "mobileBatchActionMenu", "keyboardTrap", "", 3, "selection", "navigationChanged", "statesChanged", "config", "list"], ["type", "button", "class", "d-flex align-items-center bg-transparent p-0 ps-2 mt-3 text-gray-800 rounded border-0 ms-auto text-capitalize", 3, "disabled", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["type", "button", 1, "d-flex", "align-items-center", "bg-transparent", "p-0", "ps-2", "mt-3", "text-gray-800", "rounded", "border-0", "ms-auto", "text-capitalize", 3, "click", "disabled"], ["type", "button", "class", "d-flex align-items-center bg-transparent p-0 ps-2 mt-3 text-gray-800 rounded border-0 ms-auto", 3, "disabled", "click", 4, "ngFor", "ngForOf"], ["type", "button", 1, "d-flex", "align-items-center", "bg-transparent", "p-0", "ps-2", "mt-3", "text-gray-800", "rounded", "border-0", "ms-auto", 3, "click", "disabled"], [0, "xlink", "href", "/images/tabler-icons/tabler-sprite.svg#tabler-dots-circle-horizontal"], [1, "d-flex", "justify-content-between", "mx-3", "mt-2"], ["animation", "false", 2, "width", "6.5rem", 3, "theme"], ["animation", "false", 2, "width", "8rem", 3, "theme"], [1, "janus-radial-accent-bg", 2, "height", "1rem"], [1, "d-flex", "align-items-center", "py-4", "mx-4"], [1, "w-100"], ["count", "15", "animation", "false", 3, "theme"], [1, "d-block", "rounded-top", "mx-3", "py-2", "mt-3", "border", "border-ultra-light"], [1, "d-flex", "align-items-center", "mx-3"], ["animation", "progress-dark", 3, "theme"], [1, "d-block", "bg-white", "mx-3", "border", "border-ultra-light", "border-top-0"], [1, "d-flex", "align-items-center", "py-4", "mx-3"], [1, "bg-light", "d-flex", "align-items-center", "py-4"], [1, "w-100", "mx-3"], [1, "d-block", "bg-white", "rounded-bottom", "mx-3", "py-2", "border", "border-ultra-light", "border-top-0"], [1, "d-block", "rounded-top", "mt-3", "py-2", "border", "border-ultra-light", "border-bottom-0", 3, "ngClass", "header", "assetsPath"], [1, "list-wrap", 3, "ngClass"], ["dragTable", "", "role", "grid", 1, "list-maincol", "d-block", "table", "position-relative", "align-middle", "mb-0", "w-100", 3, "ngClass"], [1, "d-table", "w-100"], ["class", "visually-hidden", 4, "ngIf"], ["role", "rowgroup", 1, "text-nowrap", 3, "ngClass"], ["role", "row", 1, "shadow-none"], ["role", "columnheader", "scope", "col", "class", "lh-1 p-0 border-bottom-0", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "visually-hidden"], ["role", "columnheader", "scope", "col", 1, "lh-1", "p-0", "border-bottom-0"], [1, "d-flex", "align-items-center", "h-100", "p-2", "py-1", "ps-3", "border-bottom", "border-gray-200", 3, "ngClass"], [3, "textContent"], [1, "d-flex", "align-items-center", "h-100", "p-2", "py-1", "border-bottom", "border-gray-200", 3, "ngClass"], ["id", "batch-select", "type", "checkbox", "class", "form-check-input border-gray-600", 3, "checked", "click", 4, "ngIf"], ["id", "batch-select", "type", "checkbox", 1, "form-check-input", "border-gray-600", 3, "click", "checked"], ["role", "columnheader", "scope", "col", 3, "hide", "ngClass", "actions", "sortable", "resizable", "width", "keyup.enter", "click", 4, "ngIf"], ["role", "columnheader", "scope", "col", 3, "keyup.enter", "click", "hide", "ngClass"], [3, "ngClass", "innerHTML", 4, "ngIf"], ["class", "d-flex align-items-center border-0 bg-transparent p-0 w-100 h-100", "translate", "", 3, "ngClass", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [3, "mousedown", 4, "ngIf"], [3, "ngClass", "innerHTML"], ["translate", "", 1, "d-flex", "align-items-center", "border-0", "bg-transparent", "p-0", "w-100", "h-100", 3, "ngClass"], [3, "innerHTML", 4, "ngIf"], ["width", "0.75rem", "height", "0.75rem", 1, "mx-1", "icon-base-font-size", "flex-shrink-0", 3, "ngClass"], [3, "innerHTML"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "mousedown"], ["role", "rowgroup"], ["class", "border-bottom border-light", "janusDataTableRow", "", "role", "row", 3, "dataTable", "item", "index", "title", "background-color", "row-odd", "row-even", "row_content_style", "selected-row", "clickable", "dblclick", "click", 4, "ngFor", "ngForOf"], ["janusDataTableRow", "", "role", "row", 1, "border-bottom", "border-light", 3, "dblclick", "click", "dataTable", "item", "index", "title"], ["role", "rowgroup", 1, "expandable-row-parent"], ["role", "row", 1, "bg-light", "shadow-none"], ["scope", "colgroup", 1, "px-3", "py-2", 3, "id", "ngClass"], ["role", "rowgroup", "class", "expandable-row-child", 4, "ngIf"], ["role", "rowgroup", 1, "expandable-row-child"], ["janusDataTableRow", "", "role", "row", 3, "dataTable", "item", "index", "parentItem", "parentIndex", "class", "id", "title", "background-color", "row-odd", "row-even", "selected-row", "clickable", "janusVersion", "dblclick", "click", 4, "ngFor", "ngForOf"], ["janusDataTableRow", "", "role", "row", 3, "dblclick", "click", "dataTable", "item", "index", "parentItem", "parentIndex", "id", "title", "janusVersion"], [1, "d-block", "rounded-bottom", "mb-3", "py-2", "border", "border-ultra-light", "border-top-0", 3, "ngClass", "header", "assetsPath"], [1, "loading-table", "list-no-records", "d-flex", "flex-column", "align-items-center", "mt-5", "mx-3", "py5", "text-center"], [3, "icon", "rem", "size", "cssClasses"], ["translate", "", 1, "mt-3", "mb-1"], ["class", "text-muted", "translate", "", 4, "ngIf"], ["class", "list-buttonbar mt-3 gap-2 d-none d-sm-flex justify-content-center", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["translate", "", 1, "text-muted"], [1, "list-buttonbar", "mt-3", "gap-2", "d-none", "d-sm-flex", "justify-content-center"], ["class", "emptystate-img-container", 4, "ngIf"], ["class", "icn", 3, "ngClass", 4, "ngIf"], ["class", "mt-3 mb-1", 3, "ngClass", 4, "ngIf"], ["class", "mt-3 gap-2 d-none d-sm-flex justify-content-center", 4, "ngIf"], [1, "emptystate-img-container"], ["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink"], ["translate", "", 1, "visually-hidden"], [1, "icn", 3, "ngClass"], [1, "mt-3", "mb-1", 3, "ngClass"], [1, "mt-3", "gap-2", "d-none", "d-sm-flex", "justify-content-center"], ["class", "d-flex align-items-center", 3, "ngClass", "click", 4, "ngIf"], ["class", "d-flex align-items-center", 3, "ngClass", "routerLink", 4, "ngIf"], [1, "d-flex", "align-items-center", 3, "click", "ngClass"], ["width", "1.25rem", "height", "1.25rem", 3, "ngClass", 4, "ngIf"], ["width", "1.25rem", "height", "1.25rem", 3, "ngClass"], [1, "d-flex", "align-items-center", 3, "ngClass", "routerLink"], [1, "table-list-bottom-controls", "start-0", "position-sticky", "bg-white", "border", "flex-shrink-0", "py-3", "px-3", "d-flex", "d-sm-none", "justify-content-between", "align-items-center", "border-gray-300", "border-end-0", "border-start-0", "border-bottom-0"], [3, "openUpwards"], ["id", "list_items_selected_counter_xs", "aria-live", "polite", "class", "position-sticky bg-white py-1 d-block d-sm-none text-gray-600 border-top border-gray-200 fs-6 text-center bottom-0 start-0", 3, "innerHTML", 4, "ngIf"], ["id", "list_items_selected_counter_xs", "aria-live", "polite", 1, "position-sticky", "bg-white", "py-1", "d-block", "d-sm-none", "text-gray-600", "border-top", "border-gray-200", "fs-6", "text-center", "bottom-0", "start-0", 3, "innerHTML"], [1, "modal-header"], ["id", "ax-title", "tabindex", "-1", 1, "modal-title"], [3, "click", "ngClass"], [1, "modal-body"], [1, "modal-footer"], [1, "btn", "btn_primary", 3, "click"]],
      template: function JanusDataTable_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusDataTable_section_0_Template, 15, 34, "section", 6)(1, JanusDataTable_section_1_Template, 18, 14, "section", 7);
          i0.ɵɵelementStart(2, "main", 8);
          i0.ɵɵtemplate(3, JanusDataTable_div_3_Template, 3, 1, "div", 9)(4, JanusDataTable_janus_data_table_header_4_Template, 1, 5, "janus-data-table-header", 10)(5, JanusDataTable_div_5_Template, 15, 37, "div", 11)(6, JanusDataTable_janus_data_table_header_6_Template, 1, 5, "janus-data-table-header", 12)(7, JanusDataTable_div_7_Template, 3, 2, "div", 13)(8, JanusDataTable_ng_container_8_Template, 4, 2, "ng-container", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(9, JanusDataTable_ng_template_9_Template, 14, 16, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.useStickyFooterControls && (ctx.items == null ? null : ctx.items.length) && (!ctx.showReloading || !ctx.reloading));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.useStickyFooterControls && (ctx.items == null ? null : ctx.items.length) && (!ctx.showReloading || !ctx.reloading));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(9, _c4$j, ctx.useStickyFooterControls, ctx.janusVersion === 2, ctx.janusVersion === 2, (ctx.items == null ? null : ctx.items.length) === 0 && ctx.janusVersion === 2));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showReloading && ctx.reloading);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.useStickyFooterControls && ctx.header && !ctx.reloading && ctx.items && ctx.items.length > 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.reloading && ctx.items && ctx.items.length > 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.useStickyFooterControls && ctx.header && !ctx.reloading && (ctx.items == null ? null : ctx.items.length));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.reloading && (ctx.items == null ? null : ctx.items.length) === 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.useStickyFooterControls && (ctx.items == null ? null : ctx.items.length) && (!ctx.showReloading || !ctx.reloading));
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusDataTable, [{
    type: Component,
    args: [{
      selector: 'janus-data-table',
      host: {
        '[class]': 'useStickyFooterControls ? "d-flex flex-column minh-0 h-100" : null'
      },
      standalone: false,
      template: "<section *ngIf=\"useStickyFooterControls && items?.length && (!showReloading || !reloading)\"\n    class=\"table-list-bottom-controls table-list-bottom-controls-sticky h-auto order flex-shrink-0 mx-3 mx-xl-4 pt-2 pt-xl-3 d-none d-sm-flex justify-content-between align-items-center border-gray-300 border-end-0 border-start-0 border-bottom-0\"\n    [attr.aria-label]=\"'misc.List Actions and Pagination' | translate\">\n    <div class=\"list_results d-flex align-items-center\">\n        <button *ngFor=\"let button of customButtons; trackBy: trackByIndex\" type=\"button\"\n            class=\"btn me-2 {{button.styleClass}} text-nowrap\" [ngClass]=\"{ 'list-addnew-btn': button.id === 'addNew' }\"\n            [attr.aria-label]=\"button.ariaLabel ? (button.ariaLabel | translate ) : null\"\n            [attr.title]=\"button.ariaLabel ? (button.ariaLabel | translate) : null\"\n            (click)=\"customButtonEvent(button.id)\">\n            <svg *ngIf=\"button.id === 'addNew'\" width=\"1.5rem\" height=\"1.5rem\" class=\"d-lg-none\">\n                <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite.svg#tabler-plus'\"></use>\n            </svg>\n            <span class=\"d-lg-block d-sm-none\">{{button.display | translate}}</span>\n        </button>\n\n        <div *ngIf=\"additionalListButtons && additionalListButtons.length > 0\"\n            class=\"d-none d-lg-inline-flex secondary-actions\">\n            <button *ngFor=\"let btn of additionalListButtons\" type=\"button\"\n                [class]=\"btn.class ? btn.class : 'btn btn-outline-primary text-nowrap me-2'\"\n                (click)=\"btn.onclick ? btn.onclick : null\" [attr.disabled]=\"btn.disabled\">{{btn.label}}</button>\n        </div>\n        <div *ngIf=\"additionalListButtons && additionalListButtons.length > 0\" class=\"d-none dropup\" moredropdown>\n            <button type=\"button\" class=\"btn btn-outline-gray-400 text-dark me-2 d-inline-flex\"\n                [attr.aria-label]=\"'misc.More actions' | translate\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n                <svg width=\"1.25rem\" height=\"1.25rem\">\n                    <use xlink:href=\"/images/tabler-icons/tabler-sprite.svg#tabler-dots\" />\n                </svg>\n            </button>\n\n            <ul class=\"dropdown-menu\"></ul>\n        </div>\n\n        <ng-container *ngIf=\"batchOptions\">\n            <div class=\"d-none d-sm-inline-block hierpicklist-widget\" ngbDropdown #batchOption=\"ngbDropdown\"\n                [autoClose]=\"'outside'\" (openChange)=\"openBatchAction($event, batchOption)\">\n                <button type=\"button\"\n                    class=\"btn btn-outline-gray-400 text-dark d-inline-flex flex-nowrap list-actions-btn after-off\"\n                    ngbDropdownToggle aria-controls=\"batchActionMenu\">\n                    <svg width=\"20px\" height=\"20px\" class=\"align-self-center me-1\">\n                        <use xlink:href=\"/images/tabler-icons/tabler-sprite.svg#tabler-settings\" />\n                    </svg>\n                    <span class=\"d-none d-lg-block\">{{'misc.Actions' | translate }}</span>\n                    <svg width=\"20px\" height=\"20px\" class=\"align-self-center\">\n                        <use xlink:href=\"/images/tabler-icons/tabler-sprite.svg#tabler-chevron-down\" />\n                    </svg>\n\n                    <div ngbDropdownMenu placement=\"top-end\"\n                        class=\"dropdown-menu-avoid-bs-js overflow-auto dropdown-menu-size py-0\"\n                        [class.d-block]=\"showBatchActionMenu\" [style.scroll-padding.px]=\"hpScrollPadding\">\n                        <hierarchical-list-widget *ngIf=\"showBatchActionMenu\" #hpWidget id=\"batchActionMenu\"\n                            keyboardTrap [config]=\"batchOptionsConfig\" [list]=\"batchOptions\"\n                            (selection)=\"batchOptionsSelection($event, batchOption)\"\n                            (navigationChanged)=\"batchOptionsNav($event, batchOption)\"\n                            (statesChanged)=\"batchOptionsStates($event, batchOption)\"></hierarchical-list-widget>\n                    </div>\n                </button>\n            </div>\n        </ng-container>\n    </div>\n    <div class=\"d-flex justify-content-end flex-fill mx-2 text-nowrap\">\n        <span id=\"list_items_count_string\" class=\"fs-5 text-gray-600\"\n            [ngClass]=\"{ 'd-none': totalCheckedRows }\">{{'misc.List items range' | translate: { start: (offset + 1),\n            end: [offset + limit , itemCount] | min, total: itemCount } }}</span>\n        <span id=\"list_items_selected_counter\" class=\"fs-5 text-gray-600\" aria-live=\"polite\"\n            [ngClass]=\"{ 'visually-hidden': !totalCheckedRows }\"\n            [innerHTML]=\"'misc.List items x selected' | translate: { x: totalCheckedRows, total: itemCount }\"></span>\n    </div>\n    <janus-pagination></janus-pagination>\n</section>\n<section *ngIf=\"useStickyFooterControls && items?.length && (!showReloading || !reloading)\" class=\"overlay-list-section\"\n    [attr.aria-label]=\"'misc.List Controls' | translate\">\n    <button type=\"button\" [attr.aria-label]=\"'misc.List Actions' | translate\"\n        class=\"list-overlay-trigger d-sm-none avatar avatar-icon rounded position-fixed bg-primary text-white p-1 z-1\"\n        (click)=\"triggerListOpen()\">\n        <svg>\n            <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite.svg#tabler-bolt'\" />\n        </svg>\n    </button>\n    <div class=\"list-overlay opacity-0 fixed-bottom top-0 bg-white d-none d-sm-none d-flex flex-column align-items-end overflow-auto p-3\"\n        keyboardTrap role=\"dialog\" aria-modal=\"true\" (keydown.esc)=\"triggerListClose()\"\n        (click)=\"triggerListClickHandler($event)\">\n        <div class=\"mt-auto\">\n            <ng-container *ngIf=\"batchOptions\">\n                <div ngbDropdown class=\"hierpicklist-widget\" #mobileBatchOption=\"ngbDropdown\" [autoClose]=\"'outside'\"\n                    (openChange)=\"openBatchAction($event, mobileBatchOption, true)\">\n\n                    <button type=\"button\"\n                        class=\"d-flex align-items-center bg-transparent p-0 ps-2 mt-3 text-gray-800 rounded border-0 ms-auto text-capitalize after-off\"\n                        ngbDropdownToggle aria-controls=\"mobileBatchActionMenu\">\n                        <span class=\"me-2\">{{'misc.Actions' | translate}}</span>\n                        <div class=\"avatar avatar-icon avatar-md p-1 bg-white border border-gray-400 rounded\">\n                            <svg>\n                                <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite.svg#tabler-settings'\" />\n                            </svg>\n                        </div>\n                        <div ngbDropdownMenu\n                            class=\"hp-dropdown dropdown-menu-avoid-bs-js d-block overflow-auto dropdown-menu-size py-0\"\n                            [class.d-block]=\"showMobileBatchActionMenu\" [style.scroll-padding.px]=\"hpScrollPadding\">\n                            <hierarchical-list-widget *ngIf=\"showMobileBatchActionMenu\" #hpWidget\n                                id=\"mobileBatchActionMenu\" keyboardTrap [config]=\"batchOptionsConfig\"\n                                [list]=\"batchOptions\" (selection)=\"batchOptionsSelection($event, mobileBatchOption)\"\n                                (navigationChanged)=\"batchOptionsNav($event, mobileBatchOption)\"\n                                (statesChanged)=\"batchOptionsStates($event, mobileBatchOption)\"></hierarchical-list-widget>\n                        </div>\n                    </button>\n                </div>\n            </ng-container>\n\n            <ng-container *ngIf=\"customButtons?.length\">\n                <button *ngFor=\"let button of customButtons; trackBy: trackByIndex\" type=\"button\"\n                    class=\"d-flex align-items-center bg-transparent p-0 ps-2 mt-3 text-gray-800 rounded border-0 ms-auto text-capitalize\"\n                    [disabled]=\"!!button.disabled\"\n                    [attr.aria-label]=\"button.ariaLabel ? (button.ariaLabel | translate ) : null\"\n                    [attr.title]=\"button.ariaLabel ? (button.ariaLabel | translate) : null\"\n                    (click)=\"customButtonEvent(button.id)\">\n                    <span class=\"me-2\">{{button.display | translate}}</span>\n                    <div class=\"avatar avatar-icon avatar-md p-1 bg-white border border-gray-400 rounded\">\n                        <svg *ngIf=\"button.icon || button.id === 'addNew'\">\n                            <use\n                                [attr.xlink:href]=\"'/images/tabler-icons/tabler-sprite.svg#' + (button.id === 'addNew' ? 'tabler-plus' : button.icon)\" />\n                        </svg>\n                        <svg *ngIf=\"!button.icon && button.id !== 'addNew'\">\n                            <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite.svg#tabler-dots-circle-horizontal'\" />\n                        </svg>\n                    </div>\n                </button>\n            </ng-container>\n\n            <ng-container *ngIf=\"additionalListButtons?.length\">\n                <button *ngFor=\"let btn of additionalListButtons\" type=\"button\"\n                    class=\"d-flex align-items-center bg-transparent p-0 ps-2 mt-3 text-gray-800 rounded border-0 ms-auto\"\n                    (click)=\"btn.onclick ? btn.onclick : null\" [disabled]=\"!!btn.disabled\">\n                    <span class=\"me-2\">{{btn.label}}</span>\n                    <div class=\"avatar avatar-icon avatar-md p-1 bg-white border border-gray-400 rounded\">\n                        <svg *ngIf=\"btn.icon\">\n                            <use [attr.xlink:href]=\"'/images/tabler-icons/tabler-sprite.svg#' + btn.icon\" />\n                        </svg>\n                        <svg *ngIf=\"!btn.icon\">\n                            <use xlink:href=\"/images/tabler-icons/tabler-sprite.svg#tabler-dots-circle-horizontal\" />\n                        </svg>\n                    </div>\n                </button>\n            </ng-container>\n\n            <button type=\"button\" (click)=\"triggerListClose()\"\n                class=\"list-overlay-trigger-close d-flex align-items-center bg-transparent p-0 ps-2 mt-3 text-gray-800 rounded border-0 ms-auto text-capitalize\">\n                <span class=\"me-2\">{{'misc.Close' | translate}}</span>\n                <div class=\"avatar avatar-icon avatar-md p-1 bg-white border border-gray-400 rounded\">\n                    <svg>\n                        <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite.svg#tabler-x'\" />\n                    </svg>\n                </div>\n            </button>\n        </div>\n    </div>\n</section>\n\n<main\n    [ngClass]=\"{\n        'overflow-auto h-100': useStickyFooterControls,\n        'bg-white content-columns mt-2 mt-xl-3 border border-gray-200': janusVersion === 2,\n        'd-block': janusVersion === 2,\n        'd-flex align-items-center justify-content-center': items?.length === 0 && janusVersion === 2\n    }\">\n    <div *ngIf=\"showReloading && reloading\">\n        @if (janusVersion === 2) {\n            <div class=\"d-flex justify-content-between mx-3 mt-2\">\n                <ngx-skeleton-loader style=\"width: 6.5rem;\" animation=\"false\" [theme]=\"{'margin': 0, 'height': '36px'}\" />\n                <ngx-skeleton-loader style=\"width: 8rem;\" animation=\"false\" [theme]=\"{'margin': 0, 'height': '36px'}\" />\n            </div>\n            <div style=\"height: 1rem;\" class=\"janus-radial-accent-bg\"></div>\n            <div class=\"d-flex align-items-center py-4 mx-4\">\n                <span class=\"w-100\">\n                    <ngx-skeleton-loader count=\"15\" animation=\"false\" [theme]=\"{'display': 'flex', 'margin': 0, 'height': '25px', 'margin-top': '1.25rem'}\" />\n                </span>\n            </div>\n        } @else {\n            <div class=\"d-block rounded-top mx-3 py-2 mt-3 border border-ultra-light\">\n                <div class=\"d-flex align-items-center mx-3\">\n                    <span class=\"w-100\">\n                        <ngx-skeleton-loader animation=\"progress-dark\" [theme]=\"{'display': 'flex', 'margin': 0}\" />\n                    </span>\n                </div>\n            </div>\n            <div class=\"d-block bg-white mx-3 border border-ultra-light border-top-0\">\n                <div class=\"d-flex align-items-center py-4 mx-3\">\n                    <span class=\"w-100\">\n                        <ngx-skeleton-loader animation=\"progress-dark\" [theme]=\"{'display': 'flex', 'margin': 0, 'height': '10px'}\" />\n                    </span>\n                </div>\n                <div class=\"bg-light d-flex align-items-center py-4\">\n                    <span class=\"w-100 mx-3\">\n                        <ngx-skeleton-loader animation=\"progress-dark\" [theme]=\"{'display': 'flex', 'margin': 0, 'height': '20px'}\" />\n                    </span>\n                </div>\n            </div>\n            <div class=\"d-block bg-white rounded-bottom mx-3 py-2 border border-ultra-light border-top-0\">\n                <div class=\"d-flex align-items-center mx-3\">\n                    <span class=\"w-100\">\n                        <ngx-skeleton-loader animation=\"progress-dark\" [theme]=\"{'display': 'flex', 'margin': 0}\" />\n                    </span>\n                </div>\n            </div>\n        }\n    </div>\n\n    <janus-data-table-header class=\"d-block rounded-top mt-3 py-2 border border-ultra-light border-bottom-0\"\n        [ngClass]=\"{'bg-white mx-3' : janusVersion === 1}\" [header]=\"header\" [assetsPath]=\"assetsPath\"\n        *ngIf=\"!useStickyFooterControls && header && !reloading && items && items.length>0\"></janus-data-table-header>\n    <div class=\"list-wrap\"\n        [ngClass]=\"{'list-min-h w-100' : janusVersion === 2, 'mx-3 bg-white border border-ultra-light border-top-0 border-bottom-0' : janusVersion === 1}\"\n        *ngIf=\"!reloading && items && items.length>0\">\n        <div>\n            <table\n                [attr.aria-label]=\"(headerTitle ? ('misc.List of {object_name} records' | translate: { object_name: headerTitle }) + ', ' : '') + ('misc.List range' | translate: { start: (offset + 1), end: [offset + limit , itemCount] | min, total: itemCount })\"\n                dragTable role=\"grid\" class=\"list-maincol d-block table position-relative align-middle mb-0 w-100\"\n                [ngClass]=\"{'expandable-table' : groupedRows, 'table-responsive': !useStickyFooterControls, 'table-borderless fs-5': janusVersion === 1}\">\n                <tbody class=\"d-table w-100\">\n                    <caption class=\"visually-hidden\" *ngIf=\"a11yDesc\">{{a11yDesc}}</caption>\n                    <thead class=\"text-nowrap\"\n                        [ngClass]=\"{'position-sticky top-0 z-1': useStickyHeader, 'border-top': janusVersion === 1}\"\n                        role=\"rowgroup\">\n                        <tr role=\"row\" class=\"shadow-none\">\n                            <th *ngIf=\"indexColumnVisible\" role=\"columnheader\" scope=\"col\" class=\"lh-1 p-0 border-bottom-0\">\n                                <div class=\"d-flex align-items-center h-100 p-2 py-1 ps-3 border-bottom border-gray-200\"\n                                    [ngClass]=\"{'py-md-2': janusVersion === 2}\">\n                                    <span [textContent]=\"indexColumnHeader\"></span>\n                                </div>\n                            </th>\n                            <th *ngIf=\"selectColumnVisible || hasListItemActions\" role=\"columnheader\" scope=\"col\"\n                                class=\"lh-1 p-0 border-bottom-0\">\n                                <div class=\"d-flex align-items-center h-100 p-2 py-1 border-bottom border-gray-200\"\n                                    [ngClass]=\"{'ps-3': !indexColumnVisible && janusVersion === 2, 'py-md-2': janusVersion === 2}\">\n                                    <input *ngIf=\"selectColumnVisible\" id=\"batch-select\" type=\"checkbox\"\n                                        class=\"form-check-input border-gray-600\" (click)=\"batchSelect($event)\"\n                                        [checked]=\"selectedAll\"\n                                        [attr.aria-label]=\"!headerTitle ? ('misc.' + ('select all' | titlecase) | translate) : (totalCheckedRows === 0 ? ('misc.Select all {object_name} records' | translate: { object_name: (headerTitle | lowercase) }) : ('misc.Deselect all {object_name} records' | translate: { object_name: (headerTitle | lowercase) }))\" />\n                                </div>\n                            </th>\n                            <ng-container *ngFor=\"let column of columns; let headerIndex=index\">\n                                <th *ngIf=\"column.property !== 'Actions'\" #th [hide]=\"!column.visible\"\n                                    (keyup.enter)=\"headerClicked(column, $event)\" (click)=\"headerClicked(column, $event)\"\n                                    [attr.id]=\"'column-' + column.property\" [ngClass]=\"getCombinedClasses(column)\"\n                                    [class.actions]=\"!column.cellTemplate && column.property==='Actions'\"\n                                    [class.sortable]=\"column.sortable\" [class.resizable]=\"column.resizable\"\n                                    [style.width]=\"column.width | px\"\n                                    [attr.aria-sort]=\"(column.sortable && column.property === sortBy) ? (sortAsc ? 'ascending' : 'descending') : null\"\n                                    role=\"columnheader\" scope=\"col\">\n                                    <div\n                                        [ngClass]=\"{'ps-3': !indexColumnVisible && !selectColumnVisible && headerIndex === 0 && janusVersion === 2, 'd-flex align-items-center p-2 py-2 h-100 border-bottom border-gray-200 py-md-6': janusVersion === 2}\">\n                                        <span *ngIf=\"!column.sortable && column.property!=='Actions'\"\n                                            [ngClass]=\"{'h6 mb-0 text-wrap': useStickyHeader}\"\n                                            [innerHTML]=\"column.header | translate\"></span>\n                                        <button\n                                            [attr.aria-label]=\"!sortAsc ? ('misc.Sort by {field_name}, ascending' | translate: { field_name: column.header | translate }) : ('misc.Sort by {field_name}, descending' | translate: { field_name: column.header | translate })\"\n                                            *ngIf=\"!column.headerTemplate && column.sortable\"\n                                            class=\"d-flex align-items-center border-0 bg-transparent p-0 w-100 h-100\"\n                                            [ngClass]=\"{'h6 mb-0 text-wrap': useStickyHeader }\" translate>\n                                            <span *ngIf=\"column.header\" [innerHTML]=\"column.header | translate\"></span>\n                                            <svg class=\"mx-1 icon-base-font-size flex-shrink-0\"\n                                                [ngClass]=\"{ 'text-gray-400': !column.active || column.property !== sortBy }\"\n                                                width=\"0.75rem\" height=\"0.75rem\">\n                                                <use\n                                                    [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-' + (((column.sortable && column.property!==sortBy)||(column.sortable && column.property===sortBy && sortAsc )) ? 'chevron-up' : (column.sortable && column.property===sortBy && !sortAsc ? 'chevron-down' : ''))\">\n                                                </use>\n                                            </svg>\n                                        </button>\n                                        <span *ngIf=\"!column.header\" class=\"visually-hidden\">{{column.emptyHeader |\n                                            translate}}</span>\n                                        <span *ngIf=\"column.headerTemplate\" [ngTemplateOutlet]=\"column.headerTemplate\"\n                                            [ngTemplateOutletContext]=\"{column: column}\"></span>\n                                        <span *ngIf=\"column.resizable\"\n                                            (mousedown)=\"resizeColumnStart($event, column, th)\"></span>\n                                    </div>\n                                </th>\n                            </ng-container>\n                        </tr>\n                    </thead>\n                    <ng-container *ngIf=\"!groupedRows\">\n                        <tbody role=\"rowgroup\">\n                            <tr class=\"border-bottom border-light\" *ngFor=\"let item of items; let idx=index\" janusDataTableRow\n                                #row [dataTable]=\"this\" [item]=\"item\" [index]=\"idx\" role=\"row\"\n                                [title]=\"getTooltip(item, row, idx)\" [style.background-color]=\"getRowColor(item, idx, row)\"\n                                [class.row-odd]=\"idx % 2 === 0\" [class.row-even]=\"idx % 2 === 1\"\n                                [class.row_content_style]=\"true\" [class.selected-row]=\"row.selected\"\n                                [class.clickable]=\"selectOnRowClick\" (dblclick)=\"rowDoubleClicked(row, $event)\"\n                                (click)=\"rowClicked(row, $event)\"></tr>\n                        </tbody>\n                    </ng-container>\n                    <ng-container *ngIf=\"groupedRows\">\n                        <ng-container *ngFor=\"let parentItem of items; let parentIdx=index\">\n                            <tbody class=\"expandable-row-parent\" role=\"rowgroup\">\n                                <tr role=\"row\" class=\"bg-light shadow-none\">\n                                    <th class=\"px-3 py-2\" scope=\"colgroup\" [id]=\"'row-' + (parentIdx + 1)\"\n                                        [attr.colspan]=\"columnCount\" [ngClass]=\"{'lh-1': janusVersion === 1}\">\n                                        <div [ngTemplateOutlet]=\"groupedRowsHeaderTemplate\"\n                                            [ngTemplateOutletContext]=\"{id: parentIdx, item: parentItem, states: collapsedRows}\">\n                                        </div>\n                                    </th>\n                                </tr>\n                            </tbody>\n                            <tbody *ngIf=\"parentItem[groupedRowsField].length && !collapsedRows[parentIdx]\" role=\"rowgroup\"\n                                class=\"expandable-row-child\">\n                                <tr *ngFor=\"let item of parentItem[groupedRowsField]; let idx=index\" janusDataTableRow #row\n                                    [dataTable]=\"this\" [item]=\"item\" [index]=\"idx\" [parentItem]=\"parentItem\"\n                                    [parentIndex]=\"parentIdx\" [class]=\"'group-' + (parentIdx + 1) + '-collapse'\"\n                                    [id]=\"'content-' + (parentIdx + 1) + '-' + (idx + 1)\" role=\"row\"\n                                    [title]=\"getTooltip(item, row, idx)\" [style.background-color]=\"getRowColor(item, idx, row)\"\n                                    [class.row-odd]=\"idx % 2 === 0\" [class.row-even]=\"idx % 2 === 1\"\n                                    [class.selected-row]=\"row.selected\" [class.clickable]=\"selectOnRowClick\"\n                                    [janusVersion]=\"janusVersion\" (dblclick)=\"rowDoubleClicked(row, $event)\"\n                                    (click)=\"rowClicked(row, $event)\"></tr>\n                            </tbody>\n                        </ng-container>\n                    </ng-container>\n                </tbody>\n            </table>\n        </div>\n        <!-- <div [loadingSpinner]=\"{loading: (showReloading && reloading), css: 'mt-4'}\"></div> -->\n    </div>\n    <janus-data-table-header class=\"d-block rounded-bottom mb-3 py-2 border border-ultra-light border-top-0\"\n        [ngClass]=\"{'bg-white mx-3': janusVersion === 1}\" [header]=\"header\" [assetsPath]=\"assetsPath\"\n        *ngIf=\"!useStickyFooterControls && header && !reloading && items?.length\"></janus-data-table-header>\n    <!-- <div [loadingSpinner]=\"{loading: (showReloading && reloading), css: 'mt-4'}\"></div> -->\n    <div *ngIf=\"!reloading && items?.length === 0\"\n        class=\"loading-table list-no-records d-flex flex-column align-items-center mt-5 mx-3 py5 text-center\">\n        <ng-container *ngIf=\"!useCustomEmptyState\">\n            <janus-svg-icon [icon]=\"'search'\" [rem]=\"3.75\" [size]=\"'none'\" [cssClasses]=\"'text-primary'\"></janus-svg-icon>\n            <h3 class=\"mt-3 mb-1\" translate>misc.No records yet</h3>\n            <div *ngIf=\"customButtons || showAddNewMsg\" class=\"text-muted\"\n                    translate>misc.Once you create records, they will appear here</div>\n            <div class=\"list-buttonbar mt-3 gap-2 d-none d-sm-flex justify-content-center\" *ngFor='let button of customButtons; trackBy: trackByIndex'>\n                <button type=\"button\" class=\"btn {{button.styleClass}}\" (click)=\"customButtonEvent(button.id)\">\n                    {{button.display | translate}}\n                </button>\n            </div>\n        </ng-container>\n\n        <ng-container *ngIf=\"useCustomEmptyState && emptyState\">\n            <div *ngIf=\"emptyStateImg.route\" class=\"emptystate-img-container\">\n                <svg [attr.class]=\"emptyStateImg.cssClasses\" [attr.width]=\"emptyStateImg.width\" [attr.height]=\"emptyStateImg.height\"\n                    [attr.viewBox]=\"emptyStateImg.viewBox\" xmlns=\"http://www.w3.org/2000/svg\"\n                    xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n                    <use [attr.xlink:href]=\"emptyStateImg.route\" />\n                </svg>\n\n                <span class=\"visually-hidden\" translate>misc.Empty List</span>\n            </div>\n\n            <i *ngIf=\"emptyState.icon && !emptyState.src\" class=\"icn\" [ngClass]=\"emptyState.icon\"></i>\n\n            <h3 *ngIf=\"emptyState.title\" class=\"mt-3 mb-1\" [ngClass]=\"emptyState.titleStyleClass\">\n                {{ emptyState.title | translate }}\n            </h3>\n\n            <div *ngIf=\"emptyState.message\" [ngClass]=\"emptyState.messageStyleClass\"\n                [innerHTML]=\"emptyState.message\">\n            </div>\n\n            <div *ngIf=\"emptyState.actionButton as actionButton\" class=\"mt-3 gap-2 d-none d-sm-flex justify-content-center\">\n                <button\n                    *ngIf=\"actionButton && actionButton.type === 'button'\"\n                    class=\"d-flex align-items-center\"\n                    [ngClass]=\"actionButton.styleClass\"\n                    [attr.aria-label]=\"actionButton.ariaLabel ? (actionButton.ariaLabel | translate ) : null\"\n                    (click)=\"actionButton.onClick()\"\n                >\n                    <svg *ngIf=\"actionButton.icon\" width=\"1.25rem\" height=\"1.25rem\"\n                        [ngClass]=\"actionButton.icon.styleClass\"\n                        [attr.alt]=\"actionButton.label | translate: (actionButton.translationParams || {})\">\n                        <use\n                            [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-' + actionButton.icon.name\">\n                        </use>\n                    </svg>\n                    <span>\n                        {{ actionButton.label | translate: (actionButton.translationParams || {}) }}\n                    </span>\n                </button>\n\n                <a *ngIf=\"actionButton && actionButton.type === 'anchor'\"\n                    class=\"d-flex align-items-center\" [ngClass]=\"actionButton.styleClass\"\n                    [routerLink]=\"actionButton.routerLink\">\n                    <svg *ngIf=\"actionButton.icon\" width=\"1.25rem\" height=\"1.25rem\"\n                        [ngClass]=\"actionButton.icon.styleClass\"\n                        [attr.alt]=\"actionButton.label | translate: (actionButton.translationParams || {})\">\n                        <use\n                            [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-' + actionButton.icon.name\">\n                        </use>\n                    </svg>\n                    <span>\n                        {{ actionButton.label | translate: (actionButton.translationParams || {}) }}\n                    </span>\n                </a>\n            </div>\n        </ng-container>\n    </div>\n\n    <ng-container *ngIf=\"useStickyFooterControls && items?.length && (!showReloading || !reloading)\">\n        <section\n            class=\"table-list-bottom-controls start-0 position-sticky bg-white border flex-shrink-0 py-3 px-3 d-flex d-sm-none justify-content-between align-items-center border-gray-300 border-end-0 border-start-0 border-bottom-0\">\n            <janus-pagination [openUpwards]=\"true\"></janus-pagination>\n        </section>\n        <div *ngIf=\"totalCheckedRows\" id=\"list_items_selected_counter_xs\" aria-live=\"polite\"\n            [innerHTML]=\"'misc.List items x selected' | translate: { x: totalCheckedRows, total: itemCount }\"\n            class=\"position-sticky bg-white py-1 d-block d-sm-none text-gray-600 border-top border-gray-200 fs-6 text-center bottom-0 start-0\">\n        </div>\n    </ng-container>\n</main>\n\n<ng-template #noSelection>\n    <div class=\"modal-header\">\n        <h3 id=\"ax-title\" class=\"modal-title\" tabindex=\"-1\">{{ 'misc.No selection' | translate }}</h3>\n        <button [ngClass]=\"{'modal-close': janusVersion === 1, 'btn-close': janusVersion !== 1}\" [attr.aria-label]=\"'misc.Close' | translate\"\n            (click)=\"noSelectionModalRef.hide()\"></button>\n    </div>\n    <div class=\"modal-body\">\n        <span>{{ 'misc.To perform this action, you must select at least one record.' | translate}}</span>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn_primary\" (click)=\"noSelectionModalRef.hide()\">{{ 'misc.OK' | translate}}</button>\n    </div>\n</ng-template>"
    }]
  }], () => [{
    type: BackendService
  }, {
    type: i1$1.TranslateService
  }, {
    type: i1$3.BsModalService
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['JANUS_VERSION']
    }]
  }], {
    assetsPath: [{
      type: Input
    }],
    emptyStateImg: [{
      type: Input
    }],
    groupedRows: [{
      type: Input
    }],
    groupedRowsField: [{
      type: Input
    }],
    a11yDesc: [{
      type: Input
    }],
    noBorder: [{
      type: Input
    }],
    useStickyHeader: [{
      type: Input
    }],
    useStickyFooterControls: [{
      type: Input
    }],
    additionalListButtons: [{
      type: Input
    }],
    execReloading: [{
      type: Input
    }],
    columns: [{
      type: ContentChildren,
      args: [JanusDataTableColumn]
    }],
    rows: [{
      type: ViewChildren,
      args: [JanusDataTableRow]
    }],
    expandTemplate: [{
      type: ContentChild,
      args: ['dataTableExpand', {
        static: true
      }]
    }],
    groupedRowsHeaderTemplate: [{
      type: ContentChild,
      args: ['dataTableGroupedRowsHeader', {
        static: true
      }]
    }],
    noSelectionTemplate: [{
      type: ViewChild,
      args: ['noSelection']
    }],
    hpWidget: [{
      type: ViewChild,
      args: ['hpWidget']
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusDataTable, {
    className: "JanusDataTable",
    filePath: "janus/components/data-table/janus-data-table.ts",
    lineNumber: 20
  });
})();
class JanusSecondaryAction {
  constructor(obj) {
    this.label = obj.label;
    this.class = obj.class;
    this.onclick = obj.onclick;
    this.disabled = obj.disabled;
    this.icon = obj.icon;
  }
}
function janusTableActionsAriaLabelHandler(translate) {
  const lnameTh = document.querySelector('table.list-maincol thead th#column-lname');
  const fnameTh = document.querySelector('table.list-maincol thead th#column-fname');
  let lnameIndex = -1;
  let fnameIndex = -1;
  if (lnameTh && fnameTh) {
    const row = lnameTh.parentElement;
    if (row) {
      Array.from(row.children).forEach((child, index) => {
        if (child === lnameTh) lnameIndex = index;
        if (child === fnameTh) fnameIndex = index;
      });
    }
  }
  const rows = document.querySelectorAll('table.list-maincol tbody tr');
  rows.forEach(row => {
    let actionCells = row.querySelectorAll('td');
    let ariaLabel = '';
    actionCells.forEach(actionCell => {
      let nextCell = actionCell.nextElementSibling;
      if (nextCell && (nextCell?.classList.contains('actions') || nextCell?.classList.contains('options'))) {
        nextCell = nextCell?.nextElementSibling;
      }
      let nextButtonOrLink = nextCell?.querySelector('a, button');
      if (!ariaLabel && nextCell) {
        ariaLabel = nextButtonOrLink ? nextButtonOrLink.textContent?.trim() || '' : nextCell?.textContent?.trim();
        if (lnameIndex !== -1 && fnameIndex !== -1) {
          const lnameContent = actionCell.parentElement?.children[lnameIndex].textContent?.trim() || '';
          const fnameContent = actionCell.parentElement?.children[fnameIndex].textContent?.trim() || '';
          ariaLabel = `${lnameContent} ${fnameContent}`.trim();
        }
      }
      const buttonsAndLinks = actionCell.querySelectorAll('[data-aria-label]');
      buttonsAndLinks.forEach(buttonOrLink => {
        let label = buttonOrLink.getAttribute('data-aria-label');
        let actionLabel = '';
        if (label) {
          actionLabel = translate.instant(label, {
            'item': ariaLabel
          });
          buttonOrLink.setAttribute('aria-label', actionLabel);
          buttonOrLink.setAttribute('title', actionLabel);
          buttonOrLink.removeAttribute('data-aria-label');
          const visuallyHiddenChild = buttonOrLink.parentElement?.querySelector('.visually-hidden');
          if (visuallyHiddenChild) {
            visuallyHiddenChild.textContent = actionLabel;
          }
        }
      });
    });
  });
}
/* Hide buttons in dropdown based on available width */
function janusSecondaryActionsDropdownHandler() {
  const breakpointLg = getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-lg');
  const belowBreakpointLg = window.matchMedia(`( max-width: ${breakpointLg} )`).matches;
  const listResults = document.querySelectorAll('.list_results');
  if (listResults.length === 0) {
    return;
  } // Container everything is based on does not exist
  const listFooter = listResults[0].parentNode;
  const listSecondaryActionsContainer = listFooter.querySelectorAll('.secondary-actions');
  const listItems = [...listFooter.querySelectorAll('.secondary-actions button')];
  if (listItems.length === 0) {
    return;
  } // Secondary actions do not exist
  const listCount = document.getElementById('list_items_count_string');
  const listPagination = listFooter.querySelectorAll('.list-pagination-control');
  const listAddNewBtn = listFooter.querySelectorAll('.list-addnew-btn');
  const listActionsBtn = listFooter.querySelectorAll('.list-actions-btn');
  let moreDropdown = listFooter.querySelector('[moredropdown]');
  let moreDropdownList = moreDropdown.querySelector('ul.dropdown-menu');
  moreDropdown.classList.add('d-none');
  moreDropdownList.innerHTML = '';
  let availableWidth = 0;
  let maxReached = false;
  if (!belowBreakpointLg) {
    // Show all secondary actions and measure
    listItems.forEach(item => item.classList.remove('d-none'));
    const minWidthToFit = listSecondaryActionsContainer[0].offsetWidth;
    // Re-hide all secondary actions
    listItems.forEach(item => item.classList.add('d-none'));
    // Measure container and all other parts
    let fullWidth = listFooter.offsetWidth - parseInt(window.getComputedStyle(listFooter).getPropertyValue('padding-right')) - parseInt(window.getComputedStyle(listFooter).getPropertyValue('padding-left'));
    let countWidth = listCount.offsetWidth + parseInt(window.getComputedStyle(listCount).getPropertyValue('margin-right')) + parseInt(window.getComputedStyle(listCount).getPropertyValue('margin-left'));
    let paginationWidth = listPagination.length > 0 ? listPagination[0].offsetWidth : 0;
    let addNewBtnWidth = listAddNewBtn.length > 0 ? listAddNewBtn[0].offsetWidth + parseInt(window.getComputedStyle(listAddNewBtn[0]).getPropertyValue('margin-right')) : 0;
    let actionsBtnWidth = listActionsBtn.length > 0 ? listActionsBtn[0].offsetWidth : 0;
    availableWidth = fullWidth - countWidth - paginationWidth - addNewBtnWidth - actionsBtnWidth;
    if (availableWidth >= minWidthToFit) {
      // All tabs fit without the need for dropdown
      listItems.forEach(item => item.classList.remove('d-none'));
      return;
    }
  }
  // Show moredropdown
  moreDropdown.classList.remove('d-none');
  availableWidth -= moreDropdown.offsetWidth;
  // Loop to measure each button and display it until no more can fit
  listItems.forEach(item => {
    item.classList.remove('d-none');
    let itemWidthMargin = item.offsetWidth + parseInt(window.getComputedStyle(item).getPropertyValue('margin-right'));
    if (availableWidth >= itemWidthMargin && !maxReached) {
      // button fits in available space
      availableWidth -= itemWidthMargin;
    } else {
      maxReached = true;
      item.classList.add('d-none');
      // Move remaining buttons into moredropdown
      const cloned = item.cloneNode(true);
      cloned.className = 'dropdown-item';
      cloned.classList.add('text-truncate');
      moreDropdownList.append(cloned);
    }
  });
}
;
const _c0$H = (a0, a1) => [a0, a1];
const _c1$z = (a0, a1, a2) => ({
  start: a0,
  end: a1,
  total: a2
});
const _c2$t = () => ({});
function JanusDataTableHeader_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function JanusDataTableHeader_button_2_Template_button_click_0_listener($event) {
      const button_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      return i0.ɵɵresetView(button_r2.onClick($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", button_r2.styleClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 2, button_r2.display, button_r2.displayParams || i0.ɵɵpureFunction0(5, _c2$t)), " ");
  }
}
function JanusDataTableHeader_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "select", 10)(2, "option", 11);
    i0.ɵɵtext(3, "Batch Options");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "option", 12);
    i0.ɵɵtext(5, "One");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "option", 13);
    i0.ɵɵtext(7, "Two");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "option", 14);
    i0.ɵɵtext(9, "Three");
    i0.ɵɵelementEnd()()();
  }
}
function JanusDataTableHeader_div_8_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 26);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pp_r6 = ctx.$implicit;
    i0.ɵɵproperty("value", pp_r6);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 3, "misc.Show"), " ", pp_r6, "");
  }
}
function JanusDataTableHeader_div_8_option_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const page_r8 = ctx.$implicit;
    i0.ɵɵproperty("value", page_r8);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(page_r8);
  }
}
function JanusDataTableHeader_div_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16)(2, "select", 17, 0);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("change", function JanusDataTableHeader_div_8_Template_select_change_2_listener() {
      i0.ɵɵrestoreView(_r3);
      const limitInput_r4 = i0.ɵɵreference(3);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.limit = +limitInput_r4.value);
    });
    i0.ɵɵtemplate(5, JanusDataTableHeader_div_8_option_5_Template, 3, 5, "option", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "nav", 19)(7, "ul", 20)(8, "li", 21)(9, "button", 22);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵlistener("click", function JanusDataTableHeader_div_8_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.pageBack());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(11, "svg", 23);
    i0.ɵɵelement(12, "use");
    i0.ɵɵelementEnd()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(13, "li", 21)(14, "select", 24, 1);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵlistener("change", function JanusDataTableHeader_div_8_Template_select_change_14_listener() {
      i0.ɵɵrestoreView(_r3);
      const pageInput_r7 = i0.ɵɵreference(15);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.page = +pageInput_r7.value);
    });
    i0.ɵɵtemplate(17, JanusDataTableHeader_div_8_option_17_Template, 2, 2, "option", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "li", 21)(19, "button", 25);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵlistener("click", function JanusDataTableHeader_div_8_Template_button_click_19_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.pageForward());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(21, "svg", 23);
    i0.ɵɵelement(22, "use");
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r4.limit);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 12, "misc.Number of Items Showing"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r4.perPage);
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(10, 14, "misc.Previous Page"))("aria-label", "Previous page");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r4.assetsPath + "tabler-sprite-nostroke.svg#tabler-chevron-left", null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r4.page);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(16, 16, "misc.Jump to page"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r4.pages);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(20, 18, "misc.Next Page"))("aria-label", "Next page");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r4.assetsPath + "tabler-sprite-nostroke.svg#tabler-chevron-right", null, "xlink");
  }
}
class JanusDataTableHeader extends DataTableHeader {
  constructor(dataTable, contextMenuService, modalService) {
    super(dataTable, contextMenuService, modalService);
    this.dataTable = dataTable;
    this.contextMenuService = contextMenuService;
    this.modalService = modalService;
    this.assetsPath = '/app/assets/';
  }
  static {
    this.ɵfac = function JanusDataTableHeader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusDataTableHeader)(i0.ɵɵdirectiveInject(forwardRef(() => JanusDataTable)), i0.ɵɵdirectiveInject(i1$2.ContextMenuService), i0.ɵɵdirectiveInject(i1$3.BsModalService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusDataTableHeader,
      selectors: [["janus-data-table-header"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 9,
      vars: 17,
      consts: [["limitInput", ""], ["pageInput", ""], [1, "d-flex", "align-items-center", "justify-content-between", "flex-wrap", "flex-sm-row", "flex-column", "align-content-start", "mx-3"], [1, "button-panel", "align-self-start", "mb-sm-0", "mb-2"], ["type", "button", "class", "input-button fs-5 me-3", 3, "ngClass", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "fs-6", "lh-sm", "mt-sm-0", "mt-2"], ["class", "d-flex align-items-center justify-content-center", 4, "ngIf"], ["class", "d-flex align-items-center flex-wrap", 4, "ngIf"], ["type", "button", 1, "input-button", "fs-5", "me-3", 3, "click", "ngClass"], [1, "d-flex", "align-items-center", "justify-content-center"], ["aria-label", "Batch Options", 1, "form-select", "fs-6", "w-auto"], ["selected", ""], ["value", "1"], ["value", "2"], ["value", "3"], [1, "d-flex", "align-items-center", "flex-wrap"], [1, "w-auto", "me-3"], [1, "form-select", "lh-sm", "fs-6", "bg-transparent", "border-0", "ps-0", 3, "change", "ngModel"], [3, "value", 4, "ngFor", "ngForOf"], ["aria-label", "Navigation"], [1, "pagination", "pagination-sm", "m-0"], [1, "page-item"], ["tabindex", "0", 1, "page-link", "border-end-0", "m-0", "rounded-start", 3, "click"], [1, "icon-lg-font-size", "mt-n1"], [1, "form-select", "fs-6", "ps-3", "pe-9", "h-100", "lh-sm", "rounded-0", "page-link", "text-secondary", "m-0", "border-gray", 3, "change", "ngModel"], ["tabindex", "0", 1, "page-link", "border-start-0", "m-0", "rounded-end", 3, "click"], [3, "value"]],
      template: function JanusDataTableHeader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
          i0.ɵɵtemplate(2, JanusDataTableHeader_button_2_Template, 3, 6, "button", 4);
          i0.ɵɵelementStart(3, "span", 5);
          i0.ɵɵtext(4);
          i0.ɵɵpipe(5, "min");
          i0.ɵɵpipe(6, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(7, JanusDataTableHeader_div_7_Template, 10, 0, "div", 6)(8, JanusDataTableHeader_div_8_Template, 23, 20, "div", 7);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.dataTable.customButtons)("ngForTrackBy", ctx.dataTable.trackByIndex);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(6, 7, "misc.List items range", i0.ɵɵpureFunction3(13, _c1$z, ctx.dataTable.offset + 1, i0.ɵɵpipeBind1(5, 5, i0.ɵɵpureFunction2(10, _c0$H, ctx.dataTable.offset + ctx.dataTable.limit, ctx.dataTable.itemCount)), ctx.dataTable.itemCount)), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.dataTable.batchOptions);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.dataTable.pagination);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$1.TranslatePipe, MinPipe$1],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusDataTableHeader, [{
    type: Component,
    args: [{
      selector: 'janus-data-table-header',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"d-flex align-items-center justify-content-between flex-wrap flex-sm-row flex-column align-content-start mx-3\">\n    <div class=\"button-panel align-self-start mb-sm-0 mb-2\">\n        <button \n            *ngFor=\"let button of dataTable.customButtons; trackBy: dataTable.trackByIndex\"\n            type=\"button\"\n            class=\"input-button fs-5 me-3\"\n            [ngClass]=\"button.styleClass\"\n            (click)=\"button.onClick($event)\"\n        >\n            {{ button.display | translate: (button.displayParams || {}) }}\n        </button>\n        \n        <span class=\"fs-6 lh-sm mt-sm-0 mt-2\">\n            {{ \n                'misc.List items range' | translate: {\n                    start: (dataTable.offset + 1),\n                    end: [dataTable.offset + dataTable.limit , dataTable.itemCount] | min,\n                    total: dataTable.itemCount\n                }\n            }}\n        </span>\n    </div>\n    <div *ngIf=\"dataTable.batchOptions\" class=\"d-flex align-items-center justify-content-center\">\n        <select class=\"form-select fs-6 w-auto\" aria-label=\"Batch Options\">\n            <option selected=\"\">Batch Options</option>\n            <option value=\"1\">One</option>\n            <option value=\"2\">Two</option>\n            <option value=\"3\">Three</option>\n        </select>\n        <!-- <button class=\"input-button btn btn_primary hp_selection\"\n                (click)=\"onContextMenu($event, item)\"\n                disable-right-click\n                [contextMenu]=\"basicMenu\"\n                [contextMenuSubject]=\"item\" translate>misc.Batch Options\n        </button> -->\n    </div>\n    <!-- <context-menu #basicMenu>\n        <ng-container *ngIf=\"dataTable.batchOptions\">\n            <ng-container *ngFor=\"let batchOption of dataTable.batchOptions\">\n                <ng-container *ngIf=\"batchOption.mail\">\n                    <ng-template contextMenuItem [subMenu]=\"saySubMenu\">\n                        {{'misc.Mail' | translate}}\n                    </ng-template>\n                    <context-menu #saySubMenu>\n                        <ng-container *ngIf=\"batchOption.newMail\">\n                            <ng-template contextMenuItem *ngFor=\"let message of batchOption.newMail\" (execute)='redirect(message.message_id, message.sesskey)'>\n                                {{message.label}}\n                            </ng-template>\n                        </ng-container>\n                        <ng-container *ngIf=\"batchOption.categories\">\n                            <ng-container *ngFor=\"let category of batchOption.categories\">\n                                <ng-template contextMenuItem [subMenu]=\"saySubMenu1\">\n                                    {{category | translate}}\n                                </ng-template>\n                                <context-menu #saySubMenu1>\n                                    <ng-container *ngFor=\"let categoryMessage of batchOption.categoryMessages\">\n                                        <ng-container *ngIf=\"categoryMessage.category == category\">\n                                            <ng-template contextMenuItem (execute)='redirect(categoryMessage.message_id, categoryMessage.sesskey)'>\n                                                {{categoryMessage.label}}\n                                             </ng-template>\n                                        </ng-container>\n                                    </ng-container>\n                                </context-menu>\n                            </ng-container>\n                       </ng-container>\n                       <ng-template contextMenuItem *ngFor=\"let batchOptionMail of batchOption.mail\" (execute)='redirect(batchOptionMail.message_id, batchOptionMail.sesskey)'>\n                          {{batchOptionMail.label}}\n                       </ng-template>\n                   </context-menu>\n                </ng-container>\n                <ng-container *ngIf=\"batchOption.mainmenu\">\n                    <ng-template contextMenuItem (execute)='batchAction(dataTable.keySuffix, batchOption.mainmenu)'>\n                        {{batchOption.mainmenu.label | translate}}\n                    </ng-template>\n                </ng-container>\n                <ng-container *ngIf=\"batchOption.submenu\">\n                    <ng-template contextMenuItem [subMenu]=\"saySubMenu1\">\n                        {{batchOption.submenu.parentLabel | translate}}\n                    </ng-template>\n                    <context-menu #saySubMenu1>\n                        <ng-template contextMenuItem (execute)='batchAction(dataTable.keySuffix, batchOption.submenu)'>\n                            {{batchOption.submenu.childLabel | translate}}\n                        </ng-template>\n                    </context-menu>\n                </ng-container>\n                <ng-container *ngIf=\"batchOption.hierarchalMenu\">\n                    <ng-container>\n                        <ng-template contextMenuItem [subMenu]=\"saySubMenu1\">\n                            {{ batchOption.hierarchalMenu.label }}\n                        </ng-template>\n                        <context-menu #saySubMenu1>\n                            <ng-container *ngFor=\"let category of batchOption.hierarchalMenu.categories\">\n                                <ng-template contextMenuItem\n                                             [subMenu]=\"saySubMenu2\">\n                                    {{ category.label }}\n                                </ng-template>\n                                <context-menu #saySubMenu2>\n                                    <ng-template contextMenuItem *ngFor=\"let subcategory of category.subcategories\"\n                                                 (execute)='batchAction(dataTable.keySuffix, subcategory)'>\n                                        {{ subcategory.label }}\n                                    </ng-template>\n                                </context-menu>\n                            </ng-container>\n                        </context-menu>\n                    </ng-container>\n                </ng-container>\n            </ng-container>\n        </ng-container>\n    </context-menu> -->\n    <!-- <div class=\"ListHeadResultInfo display-inline\">\n        <span *ngIf=\"dataTable.totalCheckedRows\"> ({{'misc.List items selected' | translate: {\n                total: dataTable.totalCheckedRows}\n            }})</span>\n    </div> -->\n    <div class=\"d-flex align-items-center flex-wrap\" *ngIf=\"dataTable.pagination\">\n        <div class=\"w-auto me-3\">\n            <select #limitInput (change)=\"limit = +limitInput.value\"\n                    [ngModel]=\"limit\"\n                    [attr.aria-label]=\"'misc.Number of Items Showing' | translate\"\n                    class=\"form-select lh-sm fs-6 bg-transparent border-0 ps-0\">\n                <option *ngFor=\"let pp of perPage\" [value]=\"pp\">{{'misc.Show' | translate}} {{pp}}</option>\n            </select>\n        </div>\n        <nav aria-label=\"Navigation\">\n            <ul class=\"pagination pagination-sm m-0\">\n                <li class=\"page-item\">\n                    <button class=\"page-link border-end-0 m-0 rounded-start\" [attr.title]=\"'misc.Previous Page' | translate\" [attr.aria-label]=\"'Previous page'\" (click)=\"pageBack()\" tabindex=\"0\">\n                        <svg class=\"icon-lg-font-size mt-n1\">\n                            <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-chevron-left'\"></use>\n                        </svg>\n                    </button>\n                </li>\n                <li class=\"page-item\">\n                    <select #pageInput (change)=\"page = +pageInput.value\"\n                            [ngModel]=\"page\"\n                            [attr.aria-label]=\"'misc.Jump to page' | translate\"\n                            class=\"form-select fs-6 ps-3 pe-9 h-100 lh-sm rounded-0 page-link text-secondary m-0 border-gray\">\n                        <option *ngFor=\"let page of pages\" [value]=\"page\">{{page}}</option>\n                    </select>\n                </li>\n                <li class=\"page-item\">\n                    <button class=\"page-link border-start-0 m-0 rounded-end\" [attr.title]=\"'misc.Next Page' | translate\" [attr.aria-label]=\"'Next page'\" (click)=\"pageForward()\" tabindex=\"0\">\n                        <svg class=\"icon-lg-font-size mt-n1\">\n                            <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-chevron-right'\"></use>\n                        </svg>\n                    </button>\n                </li>\n            </ul>\n        </nav>\n    </div>\n    <!-- <div class=\"select-panel float-right\" *ngIf=\"header\">\n        <button class=\"btn btn_generic column-selector-button\" [class.active]=\"columnSelectorOpen\"\n                (click)=\"columnSelectorOpen = !columnSelectorOpen; $event.stopPropagation()\">{{ 'misc.Show Columns' | translate }}</button>\n        <div class=\"column-selector-wrapper\" (click)=\"$event.stopPropagation()\">\n            <div *ngIf=\"columnSelectorOpen\" class=\"column-selector-box panel panel-default\">\n                <div *ngIf=\"dataTable.expandableRows\" class=\"column-selector-fixed-column checkbox\">\n                    <label class=\"column-selector-label\">\n                        <input type=\"checkbox\" [(ngModel)]=\"dataTable.expandColumnVisible\"/>\n                        <span class=\"column-label-span\">{{dataTable.translations.expandColumn}}</span>\n                    </label>\n                </div>\n                <div *ngIf=\"dataTable.indexColumn\" class=\"column-selector-fixed-column checkbox\">\n                    <label class=\"column-selector-label\">\n                        <input type=\"checkbox\" [(ngModel)]=\"dataTable.indexColumnVisible\"/>\n                        <span class=\"column-label-span\">{{dataTable.translations.indexColumn}}</span>\n                    </label>\n                </div>\n                <div *ngIf=\"dataTable.selectColumn\" class=\"column-selector-fixed-column checkbox\">\n                    <label class=\"column-selector-label\">\n                        <input type=\"checkbox\" [(ngModel)]=\"dataTable.selectColumnVisible\"/>\n                        <span class=\"column-label-span\">{{dataTable.translations.selectColumn}}</span>\n                    </label>\n                </div>\n                <div *ngFor=\"let column of dataTable.columns\" class=\"column-selector-column checkbox\">\n                    <label class=\"column-selector-label\">\n                        <input type=\"checkbox\" [(ngModel)]=\"column.visible\"/>\n                        <span class=\"column-label-span\" [textContent]=\"column.header\" translate></span>\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div> -->\n</div>\n"
    }]
  }], () => [{
    type: JanusDataTable,
    decorators: [{
      type: Inject,
      args: [forwardRef(() => JanusDataTable)]
    }]
  }, {
    type: i1$2.ContextMenuService
  }, {
    type: i1$3.BsModalService
  }], {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusDataTableHeader, {
    className: "JanusDataTableHeader",
    filePath: "janus/components/data-table/janus-header.ts",
    lineNumber: 13
  });
})();
const _c0$G = a0 => ({
  "opacity-25": a0
});
const _c1$y = (a0, a1) => ({
  page: a0,
  total_pages: a1
});
function JanusDataTablePagination_li_20__svg_svg_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 1);
  }
}
function JanusDataTablePagination_li_20__svg_svg_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 1);
    i0.ɵɵelement(1, "use", 22);
    i0.ɵɵelementEnd();
  }
}
function JanusDataTablePagination_li_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "button", 19);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function JanusDataTablePagination_li_20_Template_button_click_1_listener() {
      const pg_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.page = pg_r2);
    });
    i0.ɵɵtemplate(3, JanusDataTablePagination_li_20__svg_svg_3_Template, 1, 0, "svg", 20)(4, JanusDataTablePagination_li_20__svg_svg_4_Template, 2, 0, "svg", 20);
    i0.ɵɵelementStart(5, "span", 21);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const pg_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-current", ctx_r2.page === pg_r2)("title", i0.ɵɵpipeBind1(2, 5, "misc.Jump to page"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.page !== pg_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.page === pg_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(pg_r2);
  }
}
function JanusDataTablePagination_li_26__svg_svg_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 1);
  }
}
function JanusDataTablePagination_li_26__svg_svg_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 1);
    i0.ɵɵelement(1, "use", 22);
    i0.ɵɵelementEnd();
  }
}
function JanusDataTablePagination_li_26_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "button", 19);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function JanusDataTablePagination_li_26_Template_button_click_1_listener() {
      const pp_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.limit = pp_r5;
      return i0.ɵɵresetView(ctx_r2.page = 1);
    });
    i0.ɵɵtemplate(3, JanusDataTablePagination_li_26__svg_svg_3_Template, 1, 0, "svg", 20)(4, JanusDataTablePagination_li_26__svg_svg_4_Template, 2, 0, "svg", 20);
    i0.ɵɵelementStart(5, "span", 21);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const pp_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-current", ctx_r2.limit === pp_r5)("title", i0.ɵɵpipeBind1(2, 5, "misc.Jump to page"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.limit !== pp_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.limit === pp_r5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(pp_r5);
  }
}
class JanusDataTablePagination extends DataTableHeader {
  constructor(dataTable, contextMenuService, modalService) {
    super(dataTable, contextMenuService, modalService);
    this.dataTable = dataTable;
    this.contextMenuService = contextMenuService;
    this.modalService = modalService;
    this.assetsPath = '/app/assets/';
    this.openUpwards = false;
  }
  pageBack() {
    if (this.dataTable.offset > 1) {
      this.dataTable.offset -= Math.min(this.dataTable.limit, this.dataTable.offset);
      this.dataTable.page -= 1;
    }
  }
  pageForward() {
    if (this.dataTable.offset + this.dataTable.limit <= this.dataTable.itemCount) {
      this.dataTable.offset += this.dataTable.limit;
      this.dataTable.page += 1;
    }
  }
  static {
    this.ɵfac = function JanusDataTablePagination_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusDataTablePagination)(i0.ɵɵdirectiveInject(forwardRef(() => JanusDataTable)), i0.ɵɵdirectiveInject(i1$2.ContextMenuService), i0.ɵɵdirectiveInject(i1$3.BsModalService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusDataTablePagination,
      selectors: [["janus-pagination"]],
      hostAttrs: [1, "bg-white", "d-flex", "h-100", "align-items-stretch", "justify-content-center", "list-pagination-control", "ms-sm-1"],
      hostVars: 4,
      hostBindings: function JanusDataTablePagination_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("dropdown", !ctx.openUpwards)("dropup", ctx.openUpwards);
        }
      },
      inputs: {
        assetsPath: "assetsPath",
        openUpwards: "openUpwards"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 31,
      vars: 31,
      consts: [["type", "button", 1, "d-flex", "bg-white", "p-2", "border", "border-end-0", "border-gray-400", "text-gray-700", "h-100", "align-items-center", "rounded-start", 3, "click", "ariaLabel", "ngClass"], ["width", "1.2rem", "height", "1.2rem"], [0, "xlink", "href", "/images/tabler-icons/tabler-sprite.svg#tabler-chevron-left"], [1, "d-flex"], ["role", "button", "data-bs-display", "static", "data-bs-toggle", "dropdown", "aria-expanded", "false", 1, "bg-white", "text-nowrap", "border", "border-gray-400", "text-gray-800", "rounded-0", "gap-1", "px-2", "d-flex", "align-items-center", 3, "ariaLabel"], [1, "d-none", "d-xl-block"], ["width", "1.2rem", "height", "1.2rem", 1, "text-gray-700"], [0, "xlink", "href", "/images/tabler-icons/tabler-sprite.svg#tabler-chevron-down"], [1, "dropdown-menu", "m-0", "p-0"], [1, "d-flex", "bg-white", "border", "border-gray-200"], [1, "pagination-select-column", "overflow-y-auto", "overflow-x-hidden", "col-6", "border-end", "border-gray-200"], ["id", "list-select-page", 1, "sticky-top", "fs-6", "p-2", "text-nowrap", "bg-white", "text-gray-600"], ["role", "navigation", "aria-labelledby", "list-select-page", 1, "p-0", "m-0"], [4, "ngFor", "ngForOf"], [1, "pagination-select-column", "overflow-y-auto", "overflow-x-hidden", "col-6"], ["id", "list-select-perpage", 1, "sticky-top", "fs-6", "p-2", "text-nowrap", "bg-white", "text-gray-600"], ["role", "navigation", "aria-labelledby", "list-select-perpage", 1, "p-0", "m-0"], ["type", "button", 1, "d-flex", "bg-white", "p-2", "border", "border-start-0", "border-gray-400", "text-gray-700", "h-100", "align-items-center", "rounded-end", 3, "click", "ariaLabel", "ngClass"], [0, "xlink", "href", "/images/tabler-icons/tabler-sprite.svg#tabler-chevron-right"], [1, "dropdown-item", "d-flex", "align-items-center", "px-2", 3, "click"], ["width", "1.2rem", "height", "1.2rem", 4, "ngIf"], [1, "ms-2"], [0, "xlink", "href", "/images/tabler-icons/tabler-sprite.svg#tabler-check"]],
      template: function JanusDataTablePagination_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵpipe(1, "translate");
          i0.ɵɵlistener("click", function JanusDataTablePagination_Template_button_click_0_listener() {
            return ctx.pageBack();
          });
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(2, "svg", 1);
          i0.ɵɵelement(3, "use", 2);
          i0.ɵɵelementEnd()();
          i0.ɵɵnamespaceHTML();
          i0.ɵɵelementStart(4, "div", 3)(5, "button", 4);
          i0.ɵɵpipe(6, "translate");
          i0.ɵɵelementStart(7, "span", 5);
          i0.ɵɵtext(8);
          i0.ɵɵpipe(9, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtext(10);
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(11, "svg", 6);
          i0.ɵɵelement(12, "use", 7);
          i0.ɵɵelementEnd()();
          i0.ɵɵnamespaceHTML();
          i0.ɵɵelementStart(13, "div", 8)(14, "div", 9)(15, "div", 10)(16, "div", 11);
          i0.ɵɵtext(17);
          i0.ɵɵpipe(18, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(19, "ul", 12);
          i0.ɵɵtemplate(20, JanusDataTablePagination_li_20_Template, 7, 7, "li", 13);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(21, "div", 14)(22, "div", 15);
          i0.ɵɵtext(23);
          i0.ɵɵpipe(24, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(25, "ul", 16);
          i0.ɵɵtemplate(26, JanusDataTablePagination_li_26_Template, 7, 7, "li", 13);
          i0.ɵɵelementEnd()()()()();
          i0.ɵɵelementStart(27, "button", 17);
          i0.ɵɵpipe(28, "translate");
          i0.ɵɵlistener("click", function JanusDataTablePagination_Template_button_click_27_listener() {
            return ctx.pageForward();
          });
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(29, "svg", 1);
          i0.ɵɵelement(30, "use", 18);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ariaLabel", i0.ɵɵpipeBind1(1, 11, "misc.Previous Page"))("ngClass", i0.ɵɵpureFunction1(24, _c0$G, ctx.page === 1));
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("ariaLabel", i0.ɵɵpipeBind2(6, 13, "misc.Page {page} of {total_pages}. Select a page or change records per page.", i0.ɵɵpureFunction2(26, _c1$y, ctx.page, ctx.pages.length)));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 16, "misc.Page"));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.page, " ");
          i0.ɵɵadvance(7);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 18, "misc.Page"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngForOf", ctx.pages);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 20, "misc.Items per page"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngForOf", ctx.perPage);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ariaLabel", i0.ɵɵpipeBind1(28, 22, "misc.Next Page"))("ngClass", i0.ɵɵpureFunction1(29, _c0$G, ctx.page === ctx.pages.length));
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusDataTablePagination, [{
    type: Component,
    args: [{
      selector: 'janus-pagination',
      host: {
        '[class.dropdown]': '!openUpwards',
        '[class.dropup]': 'openUpwards',
        'class': 'bg-white d-flex h-100 align-items-stretch justify-content-center list-pagination-control ms-sm-1'
      },
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<button (click)=\"pageBack()\" [ariaLabel]=\"'misc.Previous Page' | translate\" type=\"button\" [ngClass]=\"{'opacity-25': page === 1}\" class=\"d-flex bg-white p-2 border border-end-0 border-gray-400 text-gray-700 h-100 align-items-center rounded-start\">\n    <svg width=\"1.2rem\" height=\"1.2rem\">\n        <use xlink:href=\"/images/tabler-icons/tabler-sprite.svg#tabler-chevron-left\" />\n    </svg>\n</button>\n<div class=\"d-flex\">\n    <button [ariaLabel]=\"'misc.Page {page} of {total_pages}. Select a page or change records per page.' | translate: { page: page, total_pages: pages.length }\" class=\"bg-white text-nowrap border border-gray-400 text-gray-800 rounded-0 gap-1 px-2 d-flex align-items-center\" role=\"button\" data-bs-display=\"static\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\n        <span class=\"d-none d-xl-block\">{{ 'misc.Page' | translate }}</span> {{page}}\n        <svg width=\"1.2rem\" height=\"1.2rem\" class=\"text-gray-700\">\n            <use xlink:href=\"/images/tabler-icons/tabler-sprite.svg#tabler-chevron-down\" />\n        </svg>\n    </button>\n    <div class=\"dropdown-menu m-0 p-0\">\n        <div class=\"d-flex bg-white border border-gray-200\">\n            <div class=\"pagination-select-column overflow-y-auto overflow-x-hidden col-6 border-end border-gray-200 \">\n                <div id=\"list-select-page\" class=\"sticky-top fs-6 p-2 text-nowrap bg-white text-gray-600\">{{ 'misc.Page' | translate }}</div>\n                <ul role=\"navigation\" aria-labelledby=\"list-select-page\" class=\"p-0 m-0\">\n                    <li *ngFor=\"let pg of pages\">\n                        <button (click)=\"page = pg\" [attr.aria-current]=\"page === pg\" [attr.title]=\"'misc.Jump to page' | translate\" class=\"dropdown-item d-flex align-items-center px-2\">\n                            <svg *ngIf=\"page !== pg\" width=\"1.2rem\" height=\"1.2rem\"></svg>\n                            <svg *ngIf=\"page === pg\" width=\"1.2rem\" height=\"1.2rem\">\n                                <use xlink:href=\"/images/tabler-icons/tabler-sprite.svg#tabler-check\" />\n                            </svg>\n                            <span class=\"ms-2\">{{pg}}</span>\n                        </button>\n                    </li>\n                </ul>\n            </div>\n            <div class=\"pagination-select-column overflow-y-auto overflow-x-hidden col-6\">\n                <div id=\"list-select-perpage\" class=\"sticky-top fs-6 p-2 text-nowrap bg-white text-gray-600\">{{ 'misc.Items per page' | translate }}</div>\n                <ul role=\"navigation\" aria-labelledby=\"list-select-perpage\" class=\"p-0 m-0\">\n                    <li *ngFor=\"let pp of perPage\">\n                        <button (click)=\"limit = pp; page = 1\" [attr.aria-current]=\"limit === pp\" [attr.title]=\"'misc.Jump to page' | translate\" class=\"dropdown-item d-flex align-items-center px-2\">\n                            <svg *ngIf=\"limit !== pp\" width=\"1.2rem\" height=\"1.2rem\"></svg>\n                            <svg *ngIf=\"limit === pp\" width=\"1.2rem\" height=\"1.2rem\">\n                                <use xlink:href=\"/images/tabler-icons/tabler-sprite.svg#tabler-check\" />\n                            </svg>\n                            <span class=\"ms-2\">{{pp}}</span>\n                        </button>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n<button (click)=\"pageForward()\" [ariaLabel]=\"'misc.Next Page' | translate\" type=\"button\" [ngClass]=\"{'opacity-25': page === pages.length}\" class=\"d-flex bg-white p-2 border border-start-0 border-gray-400 text-gray-700 h-100 align-items-center rounded-end\">\n    <svg width=\"1.2rem\" height=\"1.2rem\">\n        <use xlink:href=\"/images/tabler-icons/tabler-sprite.svg#tabler-chevron-right\" />\n    </svg>\n</button>"
    }]
  }], () => [{
    type: JanusDataTable,
    decorators: [{
      type: Inject,
      args: [forwardRef(() => JanusDataTable)]
    }]
  }, {
    type: i1$2.ContextMenuService
  }, {
    type: i1$3.BsModalService
  }], {
    assetsPath: [{
      type: Input
    }],
    openUpwards: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusDataTablePagination, {
    className: "JanusDataTablePagination",
    filePath: "janus/components/data-table/janus-pagination.ts",
    lineNumber: 18
  });
})();
class JanusWindowSizeService {
  constructor() {
    this.zone = inject(NgZone);
    this._breakpoints = {
      xs: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-xs')),
      // 0
      sm: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-sm')),
      // 576
      md: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-md')),
      // 768
      lg: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-lg')),
      // 992
      xl: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-xl')),
      // 1200
      xxl: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-xxl')),
      // 1400
      super: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-super')) // 1675
    };
    this._sizes$ = new BehaviorSubject(this.calcSize());
    this.breakpointBaseSignal = signal(this.calcBreakpoint());
    this.breakpointSignal = computed(this.breakpointBaseSignal);
    this.zone.runOutsideAngular(() => {
      fromEvent(window, 'resize').pipe(throttleTime(400, asyncScheduler, {
        trailing: true
      })).subscribe(() => {
        this._sizes$.next(this.calcSize());
        this.breakpointBaseSignal.set(this.calcBreakpoint());
      });
    });
  }
  sizes$() {
    return this._sizes$.asObservable();
  }
  breakpoints$() {
    return this._sizes$.asObservable().pipe(map(v => v.breakpoint), distinctUntilChanged());
  }
  currentSize() {
    return this._sizes$.getValue();
  }
  xsMax() {
    return window.matchMedia(`( max-width: ${this._breakpoints.sm - 1}px)`).matches;
  }
  smMax() {
    return window.matchMedia(`( max-width: ${this._breakpoints.md - 1}px)`).matches;
  }
  mdMax() {
    return window.matchMedia(`( max-width: ${this._breakpoints.lg - 1}px)`).matches;
  }
  lgMax() {
    return window.matchMedia(`( max-width: ${this._breakpoints.xl - 1}px)`).matches;
  }
  xlMax() {
    return window.matchMedia(`( max-width: ${this._breakpoints.xxl - 1}px)`).matches;
  }
  superMax() {
    return window.matchMedia(`( max-width: ${this._breakpoints.super - 1}px)`).matches;
  }
  smMin() {
    return window.matchMedia(`( min-width: ${this._breakpoints.sm}px)`).matches;
  }
  mdMin() {
    return window.matchMedia(`( min-width: ${this._breakpoints.md}px)`).matches;
  }
  lgMin() {
    return window.matchMedia(`( min-width: ${this._breakpoints.lg}px)`).matches;
  }
  xlMin() {
    return window.matchMedia(`( min-width: ${this._breakpoints.xl}px)`).matches;
  }
  xxlMin() {
    return window.matchMedia(`( min-width: ${this._breakpoints.xxl}px)`).matches;
  }
  superMin() {
    return window.matchMedia(`( min-width: ${this._breakpoints.super}px)`).matches;
  }
  calcSize() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      breakpoint: this.calcBreakpoint()
    };
  }
  calcBreakpoint(width = window.innerWidth) {
    if (width >= this._breakpoints.super) {
      return 'super';
    }
    if (width >= this._breakpoints.xxl) {
      return 'xxl';
    }
    if (width >= this._breakpoints.xl) {
      return 'xl';
    }
    if (width >= this._breakpoints.lg) {
      return 'lg';
    }
    if (width >= this._breakpoints.md) {
      return 'md';
    }
    if (width >= this._breakpoints.sm) {
      return 'sm';
    }
    return 'xs';
  }
  static {
    this.ɵfac = function JanusWindowSizeService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusWindowSizeService)();
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: JanusWindowSizeService,
      factory: JanusWindowSizeService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusWindowSizeService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
const moment = moment_;
class JanusFormConfigService {
  constructor(fileSizePipe) {
    this.fileSizePipe = fileSizePipe;
    this.asyncOptionsWidgets = ['ngselect', 'multiselect', 'treeselect', 'select', 'checkbox', 'picklist'];
  }
  preparePicklistValuesForSave(formData, formConfig) {
    _.each(formConfig.controlGroups, group => {
      this.picklistValuesForSave(formData, group, true);
    });
  }
  picklistValuesForSave(formData, controlGroup, isControlGroup = false) {
    _.each(controlGroup.controls, field => {
      if (this.asyncOptionsWidgets.indexOf(field.type) > -1) {
        if (Array.isArray(formData[field.name])) {
          if (field.multiple) {
            formData[field.name] = _.map(formData[field.name], 'id');
          } else if (Array.isArray(formData[field.name]) && formData[field.name][0].hasOwnProperty('id')) {
            formData[field.name] = formData[field.name][0].id;
          }
        } else if (formData[field.name] && typeof formData[field.name] === 'object') {
          formData[field.name] = formData[field.name].id;
        }
      }
      if (field.type === 'relation') {
        if (isControlGroup) {
          this.preparePicklistValuesForSave(formData[field.name], field.config);
        } else {
          this.picklistValuesForSave(formData[field.name], field.config);
        }
      }
      if (field.type === 'richtext' && formData[field.name] && formData[field.name].hasOwnProperty('html')) {
        formData[field.name] = formData[field.name].html;
      }
    });
  }
  getFormErrors(formConfig, formGroup) {
    const errorMessages = [];
    const controlsConfigs = formConfig.controlGroups.reduce((prev, curr) => [...prev, ...curr.controls], []);
    controlsConfigs.forEach(config => {
      const control = formGroup.get(config.id);
      const errors = control.errors || {};
      if (!control.valid && control.enabled) {
        errorMessages.push({
          text: `${config.label}${this.getFormValidationAlertMessage(errors, config)}`,
          elementId: config.elementId
        });
      }
    });
    return errorMessages;
  }
  getFormValidationAlertMessage(formGroupError, fieldConfig) {
    const key = Object.keys(formGroupError)?.[0];
    const map = {
      email: ' should be a valid email address',
      required: ' is required',
      maxlength: ` is limited to ${formGroupError?.[key]?.requiredLength} characters.`,
      maxFileSize: `'s file size must be less than ${this.fileSizePipe.transform(fieldConfig?.maxFileSize)}`,
      dateFormat: ` must be formatted as ${moment.localeData(window.LOCALE).longDateFormat('L')}`
    };
    return map[key] ?? map.required;
  }
  buttonsOutsideFormStyles(hasSidebar) {
    return 'd-flex col-12' + (hasSidebar ? ' col-xl-7 col-xxl-8 pe-xl-1' : '') + ' flex-shrink-0 form_actions h-auto py-2 pb-sm-0 pt-xl-3 px-3 px-xl-4 align-items-center';
  }
  static {
    this.ɵfac = function JanusFormConfigService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusFormConfigService)(i0.ɵɵinject(FileSizePipe));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: JanusFormConfigService,
      factory: JanusFormConfigService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormConfigService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: FileSizePipe
  }], null);
})();
function JanusSVGIconComponent__svg_title_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "title");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function JanusSVGIconComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", "description-" + ctx_r0.UID);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.description);
  }
}
class JanusSVGIconComponent {
  constructor() {
    this.icon = '';
    this.title = '';
    this.description = '';
    this.size = 'lg';
    this.rem = null;
    this.cssClasses = '';
    this.svgRole = 'presentation';
    this.label = null;
    // TODO: Implement Translate Directive once it is ready
    //@Input() translate?: any = null;
    this.module = '/images/tabler-icons/';
    this.svgSizes = {
      base: 'icon-base-font-size',
      lg: 'icon-lg-font-size',
      xl: 'icon-xl-font-size',
      xxl: 'icon-xxl-font-size',
      none: ''
    };
    this.link = '';
    this.UID = '';
  }
  ngOnInit() {
    this.UID = (new Date().getTime() * Math.random()).toString(36).replace('.', '');
    this.link = `${this.module}tabler-sprite-nostroke.svg#tabler-${this.icon}`;
  }
  static {
    this.ɵfac = function JanusSVGIconComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusSVGIconComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusSVGIconComponent,
      selectors: [["janus-svg-icon"]],
      inputs: {
        icon: "icon",
        title: "title",
        description: "description",
        size: "size",
        rem: "rem",
        cssClasses: "cssClasses",
        svgRole: "svgRole",
        label: "label",
        module: "module"
      },
      decls: 4,
      vars: 9,
      consts: [[4, "ngIf"], ["class", "visually-hidden", 4, "ngIf"], [1, "visually-hidden"]],
      template: function JanusSVGIconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg");
          i0.ɵɵtemplate(1, JanusSVGIconComponent__svg_title_1_Template, 2, 1, "title", 0);
          i0.ɵɵelement(2, "use");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(3, JanusSVGIconComponent_span_3_Template, 2, 2, "span", 1);
        }
        if (rf & 2) {
          let tmp_5_0;
          i0.ɵɵattribute("class", (ctx.size ? ctx.svgSizes[ctx.size] : "") + " " + ctx.cssClasses)("width", ctx.rem ? ctx.rem + "rem" : null)("height", ctx.rem ? ctx.rem + "rem" : null)("role", ctx.svgRole)("aria-describedby", ctx.description ? "description-" + ctx.UID : null)("aria-label", (tmp_5_0 = ctx.label) !== null && tmp_5_0 !== undefined ? tmp_5_0 : null);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.title);
          i0.ɵɵadvance();
          i0.ɵɵattribute("href", ctx.link);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.description);
        }
      },
      dependencies: [CommonModule, i1.NgIf],
      styles: ["[_nghost-%COMP%]{display:flex}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusSVGIconComponent, [{
    type: Component,
    args: [{
      selector: 'janus-svg-icon',
      imports: [CommonModule],
      template: "<svg [attr.class]=\"(size ? svgSizes[size] : '') + ' ' + cssClasses\" [attr.width]=\"rem ? rem + 'rem' : null\" [attr.height]=\"rem ? rem + 'rem' : null\" [attr.role]=\"svgRole\" \n     [attr.aria-describedby]=\"description ? ('description-' + UID) : null\"\n     [attr.aria-label]=\"label ?? null\"\n>\n    <title *ngIf=\"title\">{{title}}</title>\n    <use [attr.href]=\"link\"></use>\n</svg>\n<span *ngIf=\"description\" class=\"visually-hidden\" [attr.id]=\"'description-' + UID\">{{description}}</span>",
      styles: [":host{display:flex}\n"]
    }]
  }], null, {
    icon: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    description: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rem: [{
      type: Input
    }],
    cssClasses: [{
      type: Input
    }],
    svgRole: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    module: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusSVGIconComponent, {
    className: "JanusSVGIconComponent",
    filePath: "janus/components/svg-icon/janus-svg-icon.component.ts",
    lineNumber: 10
  });
})();
const _c0$F = a0 => ({
  "text-muted": a0
});
function JanusRequiredComponent_Conditional_0_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$F, !ctx_r0.hasError));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, "misc.required_indicator"));
  }
}
function JanusRequiredComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusRequiredComponent_Conditional_0_span_0_Template, 3, 6, "span", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
  }
}
function JanusRequiredComponent_Conditional_1_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "misc.required_indicator"));
  }
}
function JanusRequiredComponent_Conditional_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(", i0.ɵɵpipeBind1(2, 1, "misc.Required"), ")");
  }
}
function JanusRequiredComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusRequiredComponent_Conditional_1_span_0_Template, 3, 3, "span", 2)(1, JanusRequiredComponent_Conditional_1_span_1_Template, 3, 3, "span", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
  }
}
class JanusRequiredComponent {
  constructor(translate, janusVersion) {
    this.translate = translate;
    this.janusVersion = janusVersion;
  }
  static {
    this.ɵfac = function JanusRequiredComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusRequiredComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject('JANUS_VERSION', 8));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusRequiredComponent,
      selectors: [["janus-required"]],
      inputs: {
        isRequired: "isRequired",
        hasError: "hasError"
      },
      standalone: false,
      decls: 2,
      vars: 1,
      consts: [[1, "ms-1", "fw-normal", 3, "ngClass"], ["class", "ms-1 fw-normal", 3, "ngClass", 4, "ngIf"], ["class", "req-indicator ms-1 d-none d-sm-inline-block text-danger", 4, "ngIf"], ["class", "req-indicator ms-1 d-inline-block d-sm-none text-gray-500 fw-normal text-lowercase", 4, "ngIf"], [1, "req-indicator", "ms-1", "d-none", "d-sm-inline-block", "text-danger"], [1, "req-indicator", "ms-1", "d-inline-block", "d-sm-none", "text-gray-500", "fw-normal", "text-lowercase"]],
      template: function JanusRequiredComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusRequiredComponent_Conditional_0_Template, 1, 1, "span", 0)(1, JanusRequiredComponent_Conditional_1_Template, 2, 2);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.janusVersion === 1 ? 0 : 1);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusRequiredComponent, [{
    type: Component,
    args: [{
      selector: 'janus-required',
      standalone: false,
      template: "@if (janusVersion === 1) {\n    <span class=\"ms-1 fw-normal\" [ngClass]=\"{'text-muted': !hasError}\" *ngIf=\"isRequired\">{{ 'misc.required_indicator' | translate }}</span>\n} @else {\n    <span class=\"req-indicator ms-1 d-none d-sm-inline-block text-danger\" *ngIf=\"isRequired\">{{ 'misc.required_indicator' | translate }}</span>\n    <span class=\"req-indicator ms-1 d-inline-block d-sm-none text-gray-500 fw-normal text-lowercase\" *ngIf=\"isRequired\">({{ 'misc.Required' | translate }})</span>\n}"
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['JANUS_VERSION']
    }]
  }], {
    isRequired: [{
      type: Input
    }],
    hasError: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusRequiredComponent, {
    className: "JanusRequiredComponent",
    filePath: "janus/components/required/janus-required.component.ts",
    lineNumber: 9
  });
})();
const _c0$E = (a0, a1, a2) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2
});
const _c1$x = a0 => ({
  "visually-hidden": a0
});
const _c2$s = a0 => ({
  "input-group": a0
});
const _c3$k = a0 => ({
  field_name: a0
});
const _c4$i = (a0, a1) => ({
  field_name: a0,
  max: a1
});
const _c5$b = (a0, a1) => ({
  field_name: a0,
  min: a1
});
function JanusFormInputComponent_div_0_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 15);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Field is required", i0.ɵɵpureFunction1(5, _c3$k, ctx_r1.translatedLabel)), " ");
  }
}
function JanusFormInputComponent_div_0_div_6_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 15);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Max length error", i0.ɵɵpureFunction2(5, _c4$i, ctx_r1.translatedLabel, ctx_r1.control.errors.maxlength.requiredLength)), " ");
  }
}
function JanusFormInputComponent_div_0_div_6_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 15);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Min length error", i0.ɵɵpureFunction2(5, _c5$b, ctx_r1.translatedLabel, ctx_r1.control.errors.minlength.requiredLength)), " ");
  }
}
function JanusFormInputComponent_div_0_div_6_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 15);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, "misc.invalid email error"), " ");
  }
}
function JanusFormInputComponent_div_0_div_6_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 15);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, ctx_r1.patternError), " ");
  }
}
function JanusFormInputComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, JanusFormInputComponent_div_0_div_6_div_1_Template, 5, 7, "div", 13)(2, JanusFormInputComponent_div_0_div_6_div_2_Template, 5, 8, "div", 13)(3, JanusFormInputComponent_div_0_div_6_div_3_Template, 5, 8, "div", 13)(4, JanusFormInputComponent_div_0_div_6_div_4_Template, 5, 4, "div", 13)(5, JanusFormInputComponent_div_0_div_6_div_5_Template, 5, 4, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.maxlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.minlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.email);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.pattern);
  }
}
function JanusFormInputComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormInputComponent_div_0_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormInputComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, JanusFormInputComponent_div_0_div_8_ng_container_1_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.config.blurbTemplate);
  }
}
function JanusFormInputComponent_div_0_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 19);
    i0.ɵɵpipe(1, "sanitizeInputHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.config.prefixClass)("innerHTML", i0.ɵɵpipeBind1(1, 2, ctx_r1.config.prefixText), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormInputComponent_div_0__svg_svg_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 20);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.setIconClass());
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-" + ctx_r1.config.icon, null, "xlink");
  }
}
function JanusFormInputComponent_div_0_ng_container_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 21);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function JanusFormInputComponent_div_0_ng_container_15_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearValue($event));
    });
    i0.ɵɵelement(3, "i", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.control.value);
    i0.ɵɵattribute("aria-hidden", !ctx_r1.control.value)("aria-label", i0.ɵɵpipeBind1(2, 3, "misc.Clear"));
  }
}
function JanusFormInputComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "label", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 5);
    i0.ɵɵtemplate(6, JanusFormInputComponent_div_0_div_6_Template, 6, 5, "div", 6)(7, JanusFormInputComponent_div_0_div_7_Template, 3, 6, "div", 7)(8, JanusFormInputComponent_div_0_div_8_Template, 2, 2, "div", 8);
    i0.ɵɵelementStart(9, "div", 9);
    i0.ɵɵtemplate(10, JanusFormInputComponent_div_0_div_10_Template, 2, 4, "div", 10)(11, JanusFormInputComponent_div_0__svg_svg_11_Template, 2, 2, "svg", 11);
    i0.ɵɵelementStart(12, "input", 12, 0);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵlistener("blur", function JanusFormInputComponent_div_0_Template_input_blur_12_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("blur", $event));
    })("focus", function JanusFormInputComponent_div_0_Template_input_focus_12_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("focus", $event));
    })("keypress", function JanusFormInputComponent_div_0_Template_input_keypress_12_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("keypress", $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, JanusFormInputComponent_div_0_ng_container_15_Template, 4, 5, "ng-container", 13);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(31, _c0$E, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild, !ctx_r1.config.lastChild))("formGroup", ctx_r1.group);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(35, _c1$x, ctx_r1.config.hideLabel));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 27, ctx_r1.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched))("isRequired", ctx_r1.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurbTemplate && !ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(37, _c2$s, ctx_r1.config.prefixText));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.prefixText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.icon);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("form-control ", ctx_r1.config.className, "");
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵproperty("type", ctx_r1.inputType)("formControlName", ctx_r1.config.name);
    i0.ɵɵattribute("placeholder", i0.ɵɵpipeBind1(14, 29, ctx_r1.config.placeholder))("aria-describedby", ctx_r1.describedByValue)("aria-required", ctx_r1.isRequired);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.config.clearButton);
  }
}
class JanusFormInputComponent extends FormInputComponent {
  constructor() {
    super(...arguments);
    this.assetsPath = '/app/assets/';
  }
  setEmailInputValue(control, value) {
    control.setValue(value);
  }
  isEmailInput(controlName) {
    const emailInputs = ['recipients', 'cc_address', 'bcc_address'];
    return emailInputs.includes(controlName);
  }
  setDescribedBy() {
    let modal = this.modal ? 'modal' : '';
    this.describedByValue = this.config.blurb || this.config.blurbTemplate ? this.config.elementId + modal + '-blurb' : null;
  }
  formatEmailInput(inputValue) {
    const formatValue = inputValue.replace(/^\s*,+|,+\s*$|,\s*,|(\s+)|(\.\s+)/g, '').trim();
    return formatValue.replace(/,/g, ', ');
  }
  formatEmails(controlName, control) {
    if (this.isEmailInput(controlName) && control.value) {
      const inputValue = control.value;
      const formattedEmails = this.formatEmailInput(inputValue);
      this.setEmailInputValue(control, formattedEmails);
    }
  }
  setIconClass() {
    let classObject = {
      "position-absolute": true
    };
    classObject[this.config.iconClass] = true;
    return classObject;
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormInputComponent_BaseFactory;
      return function JanusFormInputComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormInputComponent_BaseFactory || (ɵJanusFormInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormInputComponent)))(__ngFactoryType__ || JanusFormInputComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormInputComponent,
      selectors: [["janus-form-input"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["inputField", ""], ["class", "janus-field", 3, "ngClass", "formGroup", 4, "ngIf"], [1, "janus-field", 3, "ngClass", "formGroup"], [1, "form-label", 3, "for", "ngClass"], [3, "hasError", "isRequired"], [1, "field-widget"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], ["class", "form-text", 3, "id", "innerHTML", 4, "ngIf"], [3, "id", 4, "ngIf"], [1, "position-relative", 3, "ngClass"], [3, "ngClass", "innerHTML", 4, "ngIf"], ["width", "1.25rem", "height", "1.25rem", 3, "ngClass", 4, "ngIf"], [3, "blur", "focus", "keypress", "type", "formControlName", "id"], [4, "ngIf"], ["role", "alert", 1, "invalid-feedback"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [1, "form-text", 3, "id", "innerHTML"], [3, "id"], [4, "ngTemplateOutlet"], [3, "ngClass", "innerHTML"], ["width", "1.25rem", "height", "1.25rem", 3, "ngClass"], [1, "clearBtn", 3, "click", "hidden"], [1, "icn-close"]],
      template: function JanusFormInputComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormInputComponent_div_0_Template, 16, 39, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, JanusRequiredComponent, i1$1.TranslatePipe, SanitizeHtmlPipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormInputComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-input',
      template: `
            <div class="janus-field" *ngIf="!config.hideField" [ngClass]="{'is-invalid': !control.valid && (control.dirty || control.touched), 'last': config.lastChild, 'mb-4': !config.lastChild}" [formGroup]="group">
                <label 
                    for="{{config.elementId}}{{modal?'modal':''}}" 
                    class="form-label"
                    [ngClass]="{'visually-hidden': config.hideLabel}"
                    >
                        {{config.label | translate}}<janus-required [hasError]="(!control.valid && (control.dirty || control.touched))" [isRequired]="isRequired"></janus-required>
                </label>
                <div class="field-widget">
                    <div class="invalid-feedback" role="alert" *ngIf="(!control.valid && (control.dirty || control.touched))">
                        <div *ngIf="control.errors.required">
                            <svg width="1.25rem" height="1.25rem" class="mt-n1 me-1">
                                <use [attr.xlink:href]="assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'"></use>
                            </svg>
                            {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}
                        </div>
                        <div *ngIf="control.errors.maxlength">
                            <svg width="1.25rem" height="1.25rem" class="mt-n1 me-1">
                                <use [attr.xlink:href]="assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'"></use>
                            </svg>
                            {{ 'misc.Max length error' | translate: {field_name: translatedLabel, max: control.errors.maxlength.requiredLength} }}
                        </div>
                        <div *ngIf="control.errors.minlength">
                            <svg width="1.25rem" height="1.25rem" class="mt-n1 me-1">
                                <use [attr.xlink:href]="assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'"></use>
                            </svg>
                            {{ 'misc.Min length error' | translate: {field_name: translatedLabel, min: control.errors.minlength.requiredLength} }}
                        </div>
                        <div *ngIf="control.errors.email">
                            <svg width="1.25rem" height="1.25rem" class="mt-n1 me-1">
                                <use [attr.xlink:href]="assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'"></use>
                            </svg>
                            {{'misc.invalid email error' | translate}}
                        </div>   
                        <div *ngIf="control.errors.pattern">
                            <svg width="1.25rem" height="1.25rem" class="mt-n1 me-1">
                                <use [attr.xlink:href]="assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'"></use>
                            </svg>
                            {{patternError | translate}}
                        </div>                                     
                    </div>
                    <div *ngIf="config.blurb" id="{{describedByValue}}" class="form-text" [innerHTML]="config.blurb | translate | safeHtml"></div>
                    <div *ngIf="config.blurbTemplate && !config.blurb" id="{{describedByValue}}">
                        <ng-container *ngTemplateOutlet="config.blurbTemplate"></ng-container>
                    </div>
                    <div [ngClass]="{ 'input-group': config.prefixText }" class="position-relative">
                        <div *ngIf="config.prefixText" [ngClass]="config.prefixClass" [innerHTML]="config.prefixText | sanitizeInputHtml"></div>
                        <svg *ngIf="config.icon" width="1.25rem" height="1.25rem" [ngClass]="setIconClass()">
                            <use [attr.xlink:href]="assetsPath + 'tabler-sprite-nostroke.svg#tabler-' + config.icon"></use>
                        </svg>
                        <input
                            #inputField
                            [type]="inputType"
                            [attr.placeholder]="config.placeholder | translate"
                            [formControlName]="config.name"
                            id="{{config.elementId}}{{modal?'modal':''}}"
                            [attr.aria-describedby]="describedByValue"
                            [attr.aria-required]="isRequired"
                            (blur)="triggerEvent('blur', $event);"
                            (focus)="triggerEvent('focus', $event);"
                            (keypress)="triggerEvent('keypress', $event);"
                            class="form-control {{config.className}}"
                        />
                        <ng-container *ngIf="config.clearButton">
                            <button class="clearBtn" (click)="clearValue($event)" [hidden]="!this.control.value" [attr.aria-hidden]="!this.control.value" [attr.aria-label]="'misc.Clear' | translate">
                                <i class="icn-close"></i>
                            </button>
                        </ng-container>
                    </div>
                </div>
            </div>
    `,
      standalone: false
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormInputComponent, {
    className: "JanusFormInputComponent",
    filePath: "janus/components/form-input/janus-form-input.component.ts",
    lineNumber: 83
  });
})();
const _c0$D = (a0, a1, a2) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2
});
const _c1$w = a0 => ({
  "visually-hidden": a0
});
const _c2$r = a0 => ({
  field_name: a0
});
function JanusFormRadioComponent_fieldset_0_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Field is required", i0.ɵɵpureFunction1(5, _c2$r, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormRadioComponent_fieldset_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, JanusFormRadioComponent_fieldset_0_div_6_div_1_Template, 5, 7, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors == null ? null : ctx_r0.control.errors.required);
  }
}
function JanusFormRadioComponent_fieldset_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormRadioComponent_fieldset_0_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormRadioComponent_fieldset_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, JanusFormRadioComponent_fieldset_0_div_8_ng_container_1_Template, 1, 0, "ng-container", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.config.blurbTemplate);
  }
}
function JanusFormRadioComponent_fieldset_0_ng_container_9_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 19);
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const option_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "-", option_r2.id, "");
    i0.ɵɵproperty("ngClass", ctx_r0.ngClass)("innerHTML", i0.ɵɵpipeBind1(2, 6, option_r2.display), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(option_r2.display);
  }
}
function JanusFormRadioComponent_fieldset_0_ng_container_9_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const option_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "-", option_r2.id, "");
    i0.ɵɵproperty("ngClass", ctx_r0.ngClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r2.display);
  }
}
function JanusFormRadioComponent_fieldset_0_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelement(2, "input", 18);
    i0.ɵɵtemplate(3, JanusFormRadioComponent_fieldset_0_ng_container_9_ng_container_3_Template, 4, 8, "ng-container", 1)(4, JanusFormRadioComponent_fieldset_0_ng_container_9_ng_container_4_Template, 3, 5, "ng-container", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "-", option_r2.id, "");
    i0.ɵɵproperty("formControlName", ctx_r0.config.name)("value", option_r2.id);
    i0.ɵɵattribute("name", ctx_r0.config.name)("aria-required", ctx_r0.isRequired)("aria-describedby", ctx_r0.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.optionLabelAsHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.optionLabelAsHtml);
  }
}
function JanusFormRadioComponent_fieldset_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "fieldset", 2)(1, "legend", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 5);
    i0.ɵɵtemplate(6, JanusFormRadioComponent_fieldset_0_div_6_Template, 2, 1, "div", 6)(7, JanusFormRadioComponent_fieldset_0_div_7_Template, 3, 6, "div", 7)(8, JanusFormRadioComponent_fieldset_0_div_8_Template, 2, 2, "div", 8)(9, JanusFormRadioComponent_fieldset_0_ng_container_9_Template, 5, 10, "ng-container", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.group)("ngClass", i0.ɵɵpureFunction3(15, _c0$D, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild, !ctx_r0.config.lastChild));
    i0.ɵɵattribute("aria-labelledby", ctx_r0.config.elementId)("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r0.config.elementId);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c1$w, ctx_r0.config.hideLabel));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 13, ctx_r0.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched))("isRequired", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurbTemplate && !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.options);
  }
}
function JanusFormRadioComponent_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 22);
  }
  if (rf & 2) {
    const field_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r3)("group", ctx_r0.group);
  }
}
function JanusFormRadioComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormRadioComponent_div_1_ng_container_1_Template, 1, 2, "ng-container", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.dependents);
  }
}
class JanusFormRadioComponent extends FormRadioComponent {
  constructor() {
    super(...arguments);
    this.assetsPath = '/app/assets/';
  }
  setDescribedBy() {
    let modal = this.modal ? 'modal' : '';
    this.describedByValue = this.config.blurb || this.config.blurbTemplate ? this.config.elementId + modal + '-blurb' : null;
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormRadioComponent_BaseFactory;
      return function JanusFormRadioComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormRadioComponent_BaseFactory || (ɵJanusFormRadioComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormRadioComponent)))(__ngFactoryType__ || JanusFormRadioComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormRadioComponent,
      selectors: [["janus-form-radio"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 2,
      consts: [["class", "janus-field", "role", "group", 3, "formGroup", "ngClass", 4, "ngIf"], [4, "ngIf"], ["role", "group", 1, "janus-field", 3, "formGroup", "ngClass"], [1, "form-label", 3, "ngClass", "id"], [3, "hasError", "isRequired"], [1, "field-widget"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], ["class", "form-text", 3, "id", "innerHTML", 4, "ngIf"], [3, "id", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["role", "alert", 1, "invalid-feedback"], ["class", "field-error", 4, "ngIf"], [1, "field-error"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [1, "form-text", 3, "id", "innerHTML"], [3, "id"], [4, "ngTemplateOutlet"], [1, "form-check", "w-100"], ["type", "radio", 1, "form-check-input", 3, "formControlName", "value", "id"], [1, "form-check-label", 3, "ngClass", "for", "innerHTML"], [1, "form-check-label", 3, "ngClass", "for"], ["dynamicField", "", 3, "config", "group", 4, "ngFor", "ngForOf"], ["dynamicField", "", 3, "config", "group"]],
      template: function JanusFormRadioComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormRadioComponent_fieldset_0_Template, 10, 21, "fieldset", 0)(1, JanusFormRadioComponent_div_1_Template, 2, 1, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.control.value);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.DefaultValueAccessor, i2$1.RadioControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, DynamicFieldDirective, JanusRequiredComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormRadioComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-radio',
      template: `
            <fieldset class="janus-field" *ngIf="!config.hideField" role="group" [formGroup]="group" [ngClass]="{'is-invalid': !control.valid && (control.dirty || control.touched), 'last':config.lastChild, 'mb-4': !config.lastChild}" [attr.aria-labelledby]="config.elementId" [attr.aria-describedby]="describedByValue">
                <legend [ngClass]="{'visually-hidden': config.hideLabel}" class="form-label" id="{{config.elementId}}">
                        {{config.label | translate}}<janus-required [hasError]="(!control.valid && (control.dirty || control.touched))" [isRequired]="isRequired"></janus-required>
                </legend>
                <div class="field-widget">
                    <div class="invalid-feedback" role="alert" *ngIf="!control.valid && (control.dirty || control.touched)">
                        <div class="field-error" *ngIf="control.errors?.required">
                            <svg width="1.25rem" height="1.25rem" class="mt-n1 me-1">
                                <use [attr.xlink:href]="assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'"></use>
                            </svg>
                            {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}
                        </div>
                    </div>
                    <div *ngIf="config.blurb" id="{{describedByValue}}" class="form-text" [innerHTML]="config.blurb | translate | safeHtml"></div>
                    <div *ngIf="config.blurbTemplate && !config.blurb" id="{{describedByValue}}">
                        <ng-container *ngTemplateOutlet="config.blurbTemplate"></ng-container>
                    </div>
                    <ng-container *ngFor="let option of config.options; let i = index">
                        <div class="form-check w-100">
                            <input
                                type="radio"
                                class="form-check-input"
                                [formControlName]="config.name"
                                [attr.name]="config.name"
                                [value]="option.id"
                                [attr.aria-required]="isRequired"
                                id="{{config.elementId}}-{{option.id}}"
                                [attr.aria-describedby]="config.elementId"
                            >
                            <ng-container *ngIf="config.optionLabelAsHtml">
                                <label class="form-check-label" [ngClass]="ngClass" for="{{config.elementId}}-{{option.id}}" [innerHTML]="option.display | safeHtml">{{option.display}}</label>
                            </ng-container>
                            <ng-container *ngIf="!config.optionLabelAsHtml">
                                <label class="form-check-label" [ngClass]="ngClass" for="{{config.elementId}}-{{option.id}}">{{option.display}}</label>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </fieldset>
            <div *ngIf='control.value'>
                <ng-container *ngFor="let field of config.dependents" dynamicField [config]="field" [group]="group"></ng-container>
            </div>
    `,
      standalone: false
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormRadioComponent, {
    className: "JanusFormRadioComponent",
    filePath: "janus/components/form-radio/janus-form-radio.component.ts",
    lineNumber: 52
  });
})();
const _c0$C = ["textareaField"];
const _c1$v = (a0, a1, a2) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2
});
const _c2$q = a0 => ({
  "visually-hidden": a0
});
const _c3$j = a0 => ({
  "no-resizable": a0
});
const _c4$h = a0 => ({
  field_name: a0
});
function JanusFormTextareaComponent_div_0_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 12);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(5, 4, "misc.Field is required", i0.ɵɵpureFunction1(7, _c4$h, i0.ɵɵpipeBind1(4, 2, ctx_r0.config.label))), " ");
  }
}
function JanusFormTextareaComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, JanusFormTextareaComponent_div_0_div_6_div_1_Template, 6, 9, "div", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors == null ? null : ctx_r0.control.errors.required);
  }
}
function JanusFormTextareaComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 13);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(1, 1, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormTextareaComponent_div_0_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormTextareaComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormTextareaComponent_div_0_div_8_ng_container_1_Template, 1, 0, "ng-container", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.config.blurbTemplate);
  }
}
function JanusFormTextareaComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "label", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 5);
    i0.ɵɵtemplate(6, JanusFormTextareaComponent_div_0_div_6_Template, 2, 1, "div", 6)(7, JanusFormTextareaComponent_div_0_div_7_Template, 3, 5, "div", 7)(8, JanusFormTextareaComponent_div_0_div_8_Template, 2, 1, "div", 8);
    i0.ɵɵelement(9, "textarea", 9, 0);
    i0.ɵɵelementStart(11, "label", 10);
    i0.ɵɵtext(12, "Hidden textarea");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(24, _c1$v, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild, !ctx_r0.config.lastChild))("formGroup", ctx_r0.group);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(28, _c2$q, ctx_r0.config.hideLabel));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 22, ctx_r0.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched))("isRequired", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurbTemplate && !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("max-height", ctx_r0.maxRows ? ctx_r0.lineHeight * ctx_r0.maxRows : null, "px");
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵproperty("formControlName", ctx_r0.config.name)("disabled", !!ctx_r0.control.disabled)("ngClass", i0.ɵɵpureFunction1(30, _c3$j, !ctx_r0.resizable));
    i0.ɵɵattribute("rows", ctx_r0.rows)("aria-describedby", ctx_r0.describedByValue);
  }
}
class JanusFormTextareaComponent extends FormTextareaComponent {
  set textareaField(el) {
    this._textareaField = el;
    if (el) {
      this.resizeTextArea();
    }
  }
  get textareaField() {
    return this._textareaField;
  }
  constructor(translate, elementRef, cdRef) {
    super(translate);
    this.translate = translate;
    this.elementRef = elementRef;
    this.cdRef = cdRef;
    this.unsubscribe = new Subject();
    this.extraRows = 2;
    this.minRows = 3;
    this.lineHeight = 20;
    this.rows = this.minRows;
    this.resizable = false;
    this.assetsPath = '/app/assets/';
  }
  ngOnInit() {
    this.configSetup();
    this.createBuffer();
    this.control.valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.resizeTextArea());
    if (this.config.value) {
      setTimeout(() => {
        this.control.setValue(this.config.value);
      });
    }
  }
  setDescribedBy() {
    let modal = this.modal ? 'modal' : '';
    this.describedByValue = this.config.blurb || this.config.blurbTemplate ? this.config.elementId + modal + '-blurb' : null;
  }
  configSetup() {
    if (this.config.minRows) {
      this.minRows = this.config.minRows;
      this.rows = this.minRows;
    }
    if (this.config.maxRows || this.config.maxRows > 0) {
      this.maxRows = this.config.maxRows;
    }
    if (this.config.extraRows) {
      this.extraRows = this.config.extraRows;
    }
    this.resizable = !!this.config.resizable;
  }
  createBuffer() {
    if (this._buffer === undefined) {
      this._buffer = document.createElement('textarea');
      this._buffer.style.border = 'none';
      this._buffer.style.height = '0';
      this._buffer.style.overflow = 'hidden';
      this._buffer.style.padding = '0';
      this._buffer.style.position = 'absolute';
      this._buffer.style.left = '0';
      this._buffer.style.top = '0';
      this._buffer.style.zIndex = '-1';
      this._buffer.setAttribute('aria-hidden', 'true');
      this._buffer.setAttribute('tabindex', '-1');
      this._buffer.setAttribute('id', 'hiddentextarea');
      this.elementRef.nativeElement.append(this._buffer);
    }
  }
  resizeTextArea() {
    if (!this.textareaField) return;
    const input = this.getTextAreaInfo();
    const totalRows = input.rows + this.extraRows;
    this.lineHeightUpdate(input.lineHeight);
    if (totalRows <= this.minRows) {
      this.rows = this.minRows;
    } else if (isUndefined(this.maxRows) || this.maxRows === 0 || totalRows <= this.maxRows) {
      this.rows = input.rows + this.extraRows;
    } else {
      this.rows = this.maxRows;
    }
  }
  getTextAreaInfo(textarea = this.textareaField.nativeElement) {
    const styles = window.getComputedStyle(textarea);
    const pl = parseInt(styles.paddingLeft);
    const pr = parseInt(styles.paddingRight);
    let lh = parseInt(styles.lineHeight);
    // for when [lineHeight] returns 'normal'.
    if (isNaN(lh)) {
      lh = parseInt(styles.fontSize) * 1.2;
    }
    this._buffer.style.width = textarea.clientWidth - pl - pr + 'px';
    this._buffer.style.font = styles.font;
    this._buffer.style.letterSpacing = styles.letterSpacing;
    this._buffer.style.whiteSpace = styles.whiteSpace;
    this._buffer.style.wordBreak = styles.wordBreak;
    this._buffer.style.wordSpacing = styles.wordSpacing;
    this._buffer.style.wordWrap = styles.wordWrap;
    this._buffer.value = textarea.value;
    let rows = Math.floor(this._buffer.scrollHeight / lh);
    if (rows === 0) {
      rows = 1;
    }
    return {
      lineHeight: lh,
      rows: rows
    };
  }
  lineHeightUpdate(lineHeight) {
    if (this.lineHeight !== lineHeight) {
      this.lineHeight = lineHeight;
      this.cdRef.detectChanges();
    }
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  static {
    this.ɵfac = function JanusFormTextareaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusFormTextareaComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormTextareaComponent,
      selectors: [["janus-form-textarea"]],
      viewQuery: function JanusFormTextareaComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$C, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textareaField = _t.first);
        }
      },
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["textareaField", ""], ["class", "janus-field", 3, "ngClass", "formGroup", 4, "ngIf"], [1, "janus-field", 3, "ngClass", "formGroup"], [1, "form-label", 3, "ngClass", "for"], [3, "hasError", "isRequired"], [1, "field-widget"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], ["class", "form-text", 3, "innerHTML", 4, "ngIf"], [4, "ngIf"], [1, "form-control", 3, "id", "formControlName", "disabled", "ngClass"], ["for", "hiddentextarea", "aria-hidden", "true", "hidden", ""], ["role", "alert", 1, "invalid-feedback"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [1, "form-text", 3, "innerHTML"], [4, "ngTemplateOutlet"]],
      template: function JanusFormTextareaComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormTextareaComponent_div_0_Template, 13, 32, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, JanusRequiredComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: ["textarea[_ngcontent-%COMP%]{overflow:auto}.no-resizable[_ngcontent-%COMP%]{resize:none}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormTextareaComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-textarea',
      template: `
        <div class="janus-field" *ngIf="!config.hideField"
             [ngClass]="{'is-invalid': !control.valid && (control.dirty || control.touched), 'last':config.lastChild, 'mb-4': !config.lastChild}" [formGroup]="group">
            <label [ngClass]="{'visually-hidden': config.hideLabel}" class="form-label" for="{{config.elementId}}{{modal?'modal':''}}">
                {{config.label | translate}}<janus-required [hasError]="(!control.valid && (control.dirty || control.touched))" [isRequired]="isRequired"></janus-required>
            </label>
            <div class="field-widget">
                <div class="invalid-feedback" role="alert" *ngIf="!control.valid && (control.dirty || control.touched)">
                    <div *ngIf="control.errors?.required">
                        <svg width="1.25rem" height="1.25rem" class="mt-n1 me-1">
                            <use [attr.xlink:href]="assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'"></use>
                        </svg>
                        {{ 'misc.Field is required' | translate: {field_name: (config.label | translate)} }}
                    </div>
                </div>
                <div *ngIf="config.blurb" class="form-text" [innerHTML]="config.blurb | translate | safeHtml"></div>
                <div *ngIf="config.blurbTemplate && !config.blurb">
                    <ng-container *ngTemplateOutlet="config.blurbTemplate"></ng-container>
                </div>
                <textarea
                        #textareaField
                        id="{{config.elementId}}{{modal?'modal':''}}"
                        class="form-control"
                        [formControlName]="config.name"
                        [attr.rows]="rows"
                        [attr.aria-describedby]="describedByValue"
                        [disabled]="!!control.disabled"
                        [ngClass]="{'no-resizable': !resizable}"
                        [style.maxHeight.px]="maxRows ? (lineHeight * maxRows) : null"
                ></textarea>
                <label for="hiddentextarea" aria-hidden="true" hidden>Hidden textarea</label>
            </div>
        </div>
    `,
      standalone: false,
      styles: ["textarea{overflow:auto}.no-resizable{resize:none}\n"]
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.ChangeDetectorRef
  }], {
    assetsPath: [{
      type: Input
    }],
    textareaField: [{
      type: ViewChild,
      args: ['textareaField', {
        static: false
      }]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormTextareaComponent, {
    className: "JanusFormTextareaComponent",
    filePath: "janus/components/form-textarea/janus-form-textarea.component.ts",
    lineNumber: 47
  });
})();
const _c0$B = (a0, a1, a2) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2
});
const _c1$u = a0 => ({
  "visually-hidden": a0
});
const _c2$p = a0 => ({
  field_name: a0
});
const _c3$i = a0 => ({
  "chip-highlight": a0
});
const _c4$g = a0 => ({
  item: a0
});
function JanusFormACLookupComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(1, 1, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormACLookupComponent_div_0_div_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormACLookupComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormACLookupComponent_div_0_div_7_ng_container_1_Template, 1, 0, "ng-container", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.config.blurbTemplate);
  }
}
function JanusFormACLookupComponent_div_0_div_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 21);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Field is required", i0.ɵɵpureFunction1(5, _c2$p, ctx_r1.config.label)), " ");
  }
}
function JanusFormACLookupComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, JanusFormACLookupComponent_div_0_div_8_div_1_Template, 5, 7, "div", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.required);
  }
}
function JanusFormACLookupComponent_div_0_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 21);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-triangle");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.config.warningMessage, " ");
  }
}
function JanusFormACLookupComponent_div_0_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 21);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-sparkles");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.config.ai_flag_text, " ");
  }
}
function JanusFormACLookupComponent_div_0_ng_container_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 24);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function JanusFormACLookupComponent_div_0_ng_container_17_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearValue($event));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 25);
    i0.ɵɵelement(4, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 2, "misc.Clear"));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-x", null, "xlink");
  }
}
function JanusFormACLookupComponent_div_0_ng_container_18_ng_container_3_li_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 29);
    i0.ɵɵlistener("keydown", function JanusFormACLookupComponent_div_0_ng_container_18_ng_container_3_li_3_Template_li_keydown_0_listener($event) {
      const ctx_r4 = i0.ɵɵrestoreView(_r4);
      const selection_r6 = ctx_r4.$implicit;
      const i_r7 = ctx_r4.index;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.chipNav($event, selection_r6, i_r7));
    });
    i0.ɵɵelementStart(1, "span", 30);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "button", 31);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("click", function JanusFormACLookupComponent_div_0_ng_container_18_ng_container_3_li_3_Template_button_click_3_listener() {
      const selection_r6 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.removeChip(selection_r6));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const selection_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const isLast_r8 = ctx.last;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c3$i, isLast_r8));
    i0.ɵɵattribute("tabindex", "0")("aria-label", selection_r6[ctx_r1.optionField])("aria-setsize", ctx_r1.control.value.length)("aria-posinset", i_r7 + 1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", selection_r6[ctx_r1.optionField], " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(4, 7, "misc.Remove - Item", i0.ɵɵpureFunction1(12, _c4$g, selection_r6[ctx_r1.optionField])));
  }
}
function JanusFormACLookupComponent_div_0_ng_container_18_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 27);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, JanusFormACLookupComponent_div_0_ng_container_18_ng_container_3_li_3_Template, 5, 14, "li", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 2, "misc.Selected options:"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.control.value);
  }
}
function JanusFormACLookupComponent_div_0_ng_container_18_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 32);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("keydown", function JanusFormACLookupComponent_div_0_ng_container_18_ng_container_4_Template_span_keydown_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.removeChip(ctx_r1.control.value));
    });
    i0.ɵɵelementStart(3, "span", 33);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 34);
    i0.ɵɵlistener("click", function JanusFormACLookupComponent_div_0_ng_container_18_ng_container_4_Template_span_click_5_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.removeChip(ctx_r1.control.value));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", "option")("aria-label", i0.ɵɵpipeBind2(2, 4, "misc.Item - Remove", i0.ɵɵpureFunction1(7, _c4$g, ctx_r1.control.value.value)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.control.value.value);
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", "button");
  }
}
function JanusFormACLookupComponent_div_0_ng_container_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 26, 1);
    i0.ɵɵtemplate(3, JanusFormACLookupComponent_div_0_ng_container_18_ng_container_3_Template, 4, 4, "ng-container", 8)(4, JanusFormACLookupComponent_div_0_ng_container_18_ng_container_4_Template, 6, 9, "ng-container", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-atomic", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.multiple);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.multiple && ctx_r1.control.value);
  }
}
function JanusFormACLookupComponent_div_0_ng_container_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 35);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.config.noResultFoundMsg, " ");
  }
}
function JanusFormACLookupComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "label", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵtemplate(6, JanusFormACLookupComponent_div_0_div_6_Template, 3, 5, "div", 7)(7, JanusFormACLookupComponent_div_0_div_7_Template, 2, 1, "div", 8)(8, JanusFormACLookupComponent_div_0_div_8_Template, 2, 1, "div", 9);
    i0.ɵɵelementStart(9, "div", 10);
    i0.ɵɵtemplate(10, JanusFormACLookupComponent_div_0_div_10_Template, 4, 2, "div", 11)(11, JanusFormACLookupComponent_div_0_div_11_Template, 4, 2, "div", 12);
    i0.ɵɵelementStart(12, "div", 13)(13, "input", 14);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function JanusFormACLookupComponent_div_0_Template_input_ngModelChange_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.query, $event) || (ctx_r1.query = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("typeaheadNoResults", function JanusFormACLookupComponent_div_0_Template_input_typeaheadNoResults_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.typeaheadNoResults($event));
    })("typeaheadOnSelect", function JanusFormACLookupComponent_div_0_Template_input_typeaheadOnSelect_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelect($event));
    })("typeaheadOnPreview", function JanusFormACLookupComponent_div_0_Template_input_typeaheadOnPreview_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOptionHighlighted($event));
    })("typeaheadOnBlur", function JanusFormACLookupComponent_div_0_Template_input_typeaheadOnBlur_13_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearSrLabel());
    })("keypress", function JanusFormACLookupComponent_div_0_Template_input_keypress_13_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.keypress($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "span", 15);
    i0.ɵɵtemplate(17, JanusFormACLookupComponent_div_0_ng_container_17_Template, 5, 4, "ng-container", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, JanusFormACLookupComponent_div_0_ng_container_18_Template, 5, 3, "ng-container", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, JanusFormACLookupComponent_div_0_ng_container_19_Template, 3, 1, "ng-container", 8);
    i0.ɵɵelementStart(20, "div", 16);
    i0.ɵɵelement(21, "input", 17);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(38, _c0$B, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild, !ctx_r1.config.lastChild));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("for", ctx_r1.config.elementId);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(42, _c1$u, ctx_r1.config.hideLabel));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 32, ctx_r1.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched))("isRequired", ctx_r1.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurbTemplate && !ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.warningMessage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.ai_flag_text);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.config.elementId);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.query);
    i0.ɵɵproperty("typeahead", ctx_r1.searchSubscription)("typeaheadAsync", true)("typeaheadOptionField", ctx_r1.optionField)("typeaheadGroupField", ctx_r1.acLookupGroupBy)("typeaheadMinLength", 0)("typeaheadOptionsLimit", ctx_r1.resultLimit)("typeaheadItemTemplate", ctx_r1.itemTemplate)("typeaheadScrollable", true)("typeaheadOptionsInScrollableView", ctx_r1.scrollViewSize)("ngClass", ctx_r1.setClasses());
    i0.ɵɵattribute("placeholder", i0.ɵɵpipeBind1(14, 34, ctx_r1.config.placeholder))("aria-label", i0.ɵɵpipeBind1(15, 36, ctx_r1.config.ariaLabel));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "sr-", ctx_r1.config.elementId, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.clearButton && (ctx_r1.query == null ? null : ctx_r1.query.length));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.chipList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.noResult && ctx_r1.query && !ctx_r1.config.removeNoResultFound);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.config.name);
  }
}
function JanusFormACLookupComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "strong", 36);
    i0.ɵɵpipe(1, "highlight");
  }
  if (rf & 2) {
    const model_r10 = ctx.item;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "option-", model_r10.id, "");
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 3, model_r10[ctx_r1.optionField], ctx_r1.query), i0.ɵɵsanitizeHtml);
  }
}
class JanusFormACLookupComponent extends FormACLookupComponent {
  constructor() {
    super(...arguments);
    this.noResult = false;
    this.assetsPath = '/app/assets/';
  }
  ngOnInit() {
    super.ngOnInit();
    this.config.noResultFoundMsg ||= this.translate.instant('misc.No results found');
  }
  typeaheadNoResults(event) {
    this.noResult = event;
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormACLookupComponent_BaseFactory;
      return function JanusFormACLookupComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormACLookupComponent_BaseFactory || (ɵJanusFormACLookupComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormACLookupComponent)))(__ngFactoryType__ || JanusFormACLookupComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormACLookupComponent,
      selectors: [["janus-form-aclookup"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 1,
      consts: [["customItemTemplate", ""], ["chipListElm", ""], ["class", "janus-field aclookup-widget form-input form-custom", 3, "ngClass", 4, "ngIf"], [1, "janus-field", "aclookup-widget", "form-input", "form-custom", 3, "ngClass"], [1, "form-label", 3, "for", "ngClass"], [3, "hasError", "isRequired"], [1, "field-widget"], ["class", "form-text", 3, "innerHTML", 4, "ngIf"], [4, "ngIf"], ["role", "alert", "class", "invalid-feedback", 4, "ngIf"], [1, "input-selections-group", "d-flex", "flex-column-reverse"], ["class", "mt-1 text-warning", 4, "ngIf"], ["class", "mt-1 fs-5 text-info", 4, "ngIf"], [1, "input-wrapper", "d-inline-flex", "align-items-center", "w-100", "position-relative"], ["type", "text", "role", "combobox", "autocomplete", "off", 1, "form-control", 3, "ngModelChange", "typeaheadNoResults", "typeaheadOnSelect", "typeaheadOnPreview", "typeaheadOnBlur", "keypress", "ngModel", "typeahead", "typeaheadAsync", "typeaheadOptionField", "typeaheadGroupField", "typeaheadMinLength", "typeaheadOptionsLimit", "typeaheadItemTemplate", "typeaheadScrollable", "typeaheadOptionsInScrollableView", "ngClass", "id"], ["role", "alert", 1, "visually-hidden", 3, "id"], [3, "formGroup"], ["type", "hidden", 3, "formControlName"], [1, "form-text", 3, "innerHTML"], [4, "ngTemplateOutlet"], ["role", "alert", 1, "invalid-feedback"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [1, "mt-1", "text-warning"], [1, "mt-1", "fs-5", "text-info"], [1, "border-0", "position-absolute", "bg-transparent", "end-0", "py-0", "px-3", "d-flex", "align-items-center", "h-100", 3, "click"], ["width", "1rem", "height", "1rem"], [1, "selections"], ["role", "listbox", "aria-orientation", "horizontal", 1, "list-unstyled", "list-inline", "my-0"], ["role", "option", "aria-selected", "true", "class", "list-inline-item me-1 mb-2", 3, "ngClass", "keydown", 4, "ngFor", "ngForOf"], ["role", "option", "aria-selected", "true", 1, "list-inline-item", "me-1", "mb-2", 3, "keydown", "ngClass"], [1, "btn", "text-white", "bg-primary", "d-inline-flex", "badge", "minw-0"], ["type", "button", "role", "option", 1, "d-flex", "align-items-center", "btn-close", "btn-close-white", "ms-2", "me-0", "p-0", 3, "click"], [1, "chip", "chip-highlight", 3, "keydown"], [1, "chip-value"], [1, "chip-close", 3, "click"], [1, "dropdown", "open", "bottom", "dropdown-menu", "d-block", "query-result-item", "ps-3"], [1, "query-result-item", 3, "id", "innerHTML"]],
      template: function JanusFormACLookupComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormACLookupComponent_div_0_Template, 22, 44, "div", 2)(1, JanusFormACLookupComponent_ng_template_1_Template, 2, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.NgModel, i2$1.FormGroupDirective, i2$1.FormControlName, i3$1.TypeaheadDirective, JanusRequiredComponent, i1$1.TranslatePipe, HighlightSearchPipe, SafeHtmlPipe],
      styles: ["janus-form-aclookup .query-result-item mark{font-weight:400;background-color:transparent;padding:0}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormACLookupComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-aclookup',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"janus-field aclookup-widget form-input form-custom\" *ngIf=\"!config.hideField\" [ngClass]=\"{'is-invalid': !control.valid && (control.dirty || control.touched), 'last': config.lastChild, 'mb-4': !config.lastChild }\">\n    <label \n        for=\"{{config.elementId}}\" \n        class=\"form-label\"\n        [ngClass]=\"{'visually-hidden': config.hideLabel}\"\n        >\n            {{config.label | translate }}<janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\"></janus-required>\n    </label>\n    <div class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" class=\"form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div *ngIf=\"config.blurbTemplate && !config.blurb\">\n            <ng-container *ngTemplateOutlet=\"config.blurbTemplate\"></ng-container>\n        </div>\n        <div role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\" class=\"invalid-feedback\"> \n            <div *ngIf=\"control.errors.required\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                </svg>\n                {{ 'misc.Field is required' | translate: {field_name: config.label} }}\n            </div>\n        </div>\n        \n        <div class=\"input-selections-group d-flex flex-column-reverse\">\n\n            <div *ngIf=\"config.warningMessage\" class=\"mt-1 text-warning\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-triangle'\"></use>\n                </svg>\n                {{ config.warningMessage }}\n            </div>\n            <div *ngIf=\"config.ai_flag_text\" class=\"mt-1 fs-5 text-info\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-sparkles'\"></use>\n                </svg>\n                {{ config.ai_flag_text }}\n            </div>\n            <div class=\"input-wrapper d-inline-flex align-items-center w-100 position-relative\">\n                <input\n                        [(ngModel)]=\"query\"\n                        (typeaheadNoResults)=\"typeaheadNoResults($event)\"\n                        [typeahead]=\"searchSubscription\"\n                        [typeaheadAsync]=\"true\"\n                        [typeaheadOptionField]=\"optionField\"\n                        [typeaheadGroupField]=\"acLookupGroupBy\"\n                        [typeaheadMinLength]=\"0\"\n                        [typeaheadOptionsLimit]=\"resultLimit\"\n                        [typeaheadItemTemplate]=\"itemTemplate\"\n                        [typeaheadScrollable]=\"true\"\n                        [typeaheadOptionsInScrollableView]=\"scrollViewSize\"\n                        (typeaheadOnSelect)=\"onSelect($event)\"\n                        (typeaheadOnPreview)=\"onOptionHighlighted($event)\"\n                        (typeaheadOnBlur)=\"clearSrLabel()\"\n                        (keypress)=\"keypress($event)\"\n                        [attr.placeholder]=\"config.placeholder | translate\"\n                        [attr.aria-label]=\"config.ariaLabel | translate\"\n                        [ngClass]=\"setClasses()\"\n                        id=\"{{config.elementId}}\"\n                        type=\"text\"\n                        role=\"combobox\"\n                        class=\"form-control\"\n                        autocomplete=\"off\"\n                />\n                <span class='visually-hidden' role='alert' id='sr-{{config.elementId}}'></span>\n                <ng-container *ngIf=\"config.clearButton && query?.length\">\n                    <button class=\"border-0 position-absolute bg-transparent end-0 py-0 px-3 d-flex align-items-center h-100\" (click)=\"clearValue($event)\" [attr.aria-label]=\"'misc.Clear' | translate\">\n                        <svg width=\"1rem\" height=\"1rem\">\n                            <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-x'\"></use>\n                        </svg>\n                    </button>\n                </ng-container>\n            </div>\n            <ng-container *ngIf=\"chipList\">\n                <div class=\"selections\"\n                    #chipListElm\n                    [attr.aria-atomic]=\"true\"\n                >\n                    <ng-container *ngIf=\"multiple\">\n                        <ul class=\"list-unstyled list-inline my-0\" \n                            role=\"listbox\"\n                            aria-orientation=\"horizontal\"\n                            [attr.aria-label]=\"'misc.Selected options:' | translate\"\n                        >\n                            <li\n                                *ngFor=\"let selection of control.value; index as i, last as isLast\"\n                                role=\"option\"\n                                aria-selected=\"true\"\n                                [attr.tabindex]=\"'0'\"\n                                [attr.aria-label]=\"selection[optionField]\"\n                                [attr.aria-setsize]=\"control.value.length\"\n                                [attr.aria-posinset]=\"i + 1\"\n                                (keydown)=\"chipNav($event, selection, i)\"\n                                [ngClass]=\"{'chip-highlight': isLast}\"\n                                class=\"list-inline-item me-1 mb-2\"\n                            >\n                                <span class=\"btn text-white bg-primary d-inline-flex badge minw-0\">\n                                    {{selection[optionField]}}\n                                    <button \n                                            type=\"button\" \n                                            class=\"d-flex align-items-center btn-close btn-close-white ms-2 me-0 p-0\" \n                                            [attr.aria-label]=\"'misc.Remove - Item' | translate : {item: selection[optionField]}\"\n                                            (click)=\"removeChip(selection)\"\n                                            role=\"option\"\n                                    ></button>\n                                </span>\n                            </li>\n                        </ul>\n                    </ng-container>\n                    \n                    <ng-container *ngIf=\"!multiple && control.value\">\n                        <span\n                            [attr.role]=\"'option'\"\n                            [attr.aria-label]=\"'misc.Item - Remove' | translate : {item: control.value.value}\"\n                            (keydown)=\"removeChip(control.value)\"\n                            class=\"chip chip-highlight\"\n                        >\n                            <span class=\"chip-value\">{{control.value.value}}</span>\n                            <span class=\"chip-close\"\n                                    [attr.role]=\"'button'\"\n                                    (click)=\"removeChip(control.value)\"\n                            ></span>\n                        </span>\n                    </ng-container>\n                    \n                </div>\n            </ng-container>\n        </div>\n        <ng-container *ngIf=\"noResult && query && !config.removeNoResultFound\">\n            <span class=\"dropdown open bottom dropdown-menu d-block query-result-item ps-3\">\n                {{config.noResultFoundMsg}}\n            </span>\n        </ng-container>\n        \n        <div [formGroup]=\"group\">\n            <input type=\"hidden\" [formControlName]=\"config.name\"/>\n        </div>\n    </div>\n</div>\n<ng-template #customItemTemplate let-model=\"item\" let-index=\"index\">\n    <strong id=\"option-{{model.id}}\" class=\"query-result-item\" [innerHTML]=\"model[optionField] | highlight: query\"></strong>\n</ng-template>\n",
      styles: ["janus-form-aclookup .query-result-item mark{font-weight:400;background-color:transparent;padding:0}\n"]
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormACLookupComponent, {
    className: "JanusFormACLookupComponent",
    filePath: "janus/components/form-aclookup/janus-form-aclookup.component.ts",
    lineNumber: 13
  });
})();
const _c0$A = (a0, a1) => ({
  "last mb-0": a0,
  "mb-4": a1
});
const _c1$t = (a0, a1, a2) => ({
  "field-widget-tinymce": a0,
  "field-widget-text": a1,
  "col-8 col-sm-9": a2
});
const _c2$o = (a0, a1) => ({
  "form-label-has-blurb": a0,
  "col-4 col-sm-3": a1
});
const _c3$h = a0 => ({
  config: a0
});
function JanusFormStaticComponent_div_0_dt_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dt", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "janus-required", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c2$o, ctx_r0.config.blurb, !ctx_r0.config.stacked));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, ctx_r0.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched))("isRequired", ctx_r0.isRequired);
  }
}
function JanusFormStaticComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(1, 1, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormStaticComponent_div_0_div_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormStaticComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormStaticComponent_div_0_div_4_ng_container_1_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.config.blurbTemplate);
  }
}
function JanusFormStaticComponent_div_0_ng_container_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 13);
    i0.ɵɵpipe(1, "sanitizeInputHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.config.elementId);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 4, ctx_r0.fieldDisplayValue), i0.ɵɵsanitizeHtml)("ngStyle", ctx_r0.config.style)("ngClass", ctx_r0.config.class);
  }
}
function JanusFormStaticComponent_div_0_ng_container_6_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.config.elementId);
    i0.ɵɵproperty("innerHTML", ctx_r0.config.translate, i0.ɵɵsanitizeHtml)("ngStyle", ctx_r0.config.style)("ngClass", ctx_r0.config.class);
  }
}
function JanusFormStaticComponent_div_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormStaticComponent_div_0_ng_container_6_div_1_Template, 2, 6, "div", 11)(2, JanusFormStaticComponent_div_0_ng_container_6_div_2_Template, 1, 4, "div", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fieldDisplayValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.translate);
  }
}
function JanusFormStaticComponent_div_0_ng_container_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 17);
    i0.ɵɵpipe(1, "sanitizeInputHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.config.elementId);
    i0.ɵɵproperty("ngStyle", ctx_r0.config.style)("ngClass", ctx_r0.config.class)("innerHTML", i0.ɵɵpipeBind1(1, 4, ctx_r0.fieldDisplayValue), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormStaticComponent_div_0_ng_container_7_ng_container_2_ng_container_2_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const value_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(value_r2);
  }
}
function JanusFormStaticComponent_div_0_ng_container_7_ng_container_2_ng_container_2_li_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const value_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(value_r2);
  }
}
function JanusFormStaticComponent_div_0_ng_container_7_ng_container_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormStaticComponent_div_0_ng_container_7_ng_container_2_ng_container_2_li_1_Template, 2, 1, "li", 5)(2, JanusFormStaticComponent_div_0_ng_container_7_ng_container_2_ng_container_2_li_2_Template, 2, 1, "li", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const i_r3 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.listLimit > 0 && i_r3 <= ctx_r0.listLimit - 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.listLimit == 0 || i_r3 > ctx_r0.listLimit - 1 && ctx_r0.config.showAll);
  }
}
function JanusFormStaticComponent_div_0_ng_container_7_ng_container_2_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function JanusFormStaticComponent_div_0_ng_container_7_ng_container_2_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.showAll(ctx_r0.config));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "misc.See all"));
  }
}
function JanusFormStaticComponent_div_0_ng_container_7_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 18);
    i0.ɵɵtemplate(2, JanusFormStaticComponent_div_0_ng_container_7_ng_container_2_ng_container_2_Template, 3, 2, "ng-container", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, JanusFormStaticComponent_div_0_ng_container_7_ng_container_2_button_3_Template, 3, 3, "button", 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.config.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.listLimit > 0 && ctx_r0.config.value && ctx_r0.config.value.length > 1 && ctx_r0.config.value.length > ctx_r0.listLimit && (!ctx_r0.config.showAll || ctx_r0.config.showAll == undefined));
  }
}
function JanusFormStaticComponent_div_0_ng_container_7_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.config.elementId);
    i0.ɵɵproperty("ngStyle", ctx_r0.config.style)("ngClass", ctx_r0.config.class);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.config.translate);
  }
}
function JanusFormStaticComponent_div_0_ng_container_7_4_ng_template_0_Template(rf, ctx) {}
function JanusFormStaticComponent_div_0_ng_container_7_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormStaticComponent_div_0_ng_container_7_4_ng_template_0_Template, 0, 0, "ng-template", 23);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.config.suffixTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c3$h, ctx_r0.config));
  }
}
function JanusFormStaticComponent_div_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormStaticComponent_div_0_ng_container_7_div_1_Template, 2, 6, "div", 15)(2, JanusFormStaticComponent_div_0_ng_container_7_ng_container_2_Template, 4, 2, "ng-container", 5)(3, JanusFormStaticComponent_div_0_ng_container_7_div_3_Template, 2, 4, "div", 16)(4, JanusFormStaticComponent_div_0_ng_container_7_4_Template, 1, 4, null, 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fieldDisplayValue !== undefined && !ctx_r0.config.isList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fieldDisplayValue && ctx_r0.config.isList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.translate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.suffixTemplate);
  }
}
function JanusFormStaticComponent_div_0_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "form-actions", 24);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("actions", ctx_r0.config.customActions.actions);
  }
}
function JanusFormStaticComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, JanusFormStaticComponent_div_0_dt_1_Template, 4, 9, "dt", 2);
    i0.ɵɵelementStart(2, "dd", 3);
    i0.ɵɵtemplate(3, JanusFormStaticComponent_div_0_div_3_Template, 3, 5, "div", 4)(4, JanusFormStaticComponent_div_0_div_4_Template, 2, 1, "div", 5);
    i0.ɵɵelement(5, "input", 6);
    i0.ɵɵtemplate(6, JanusFormStaticComponent_div_0_ng_container_6_Template, 3, 2, "ng-container", 5)(7, JanusFormStaticComponent_div_0_ng_container_7_Template, 5, 4, "ng-container", 5)(8, JanusFormStaticComponent_div_0_ng_container_8_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.group)("ngClass", i0.ɵɵpureFunction2(11, _c0$A, ctx_r0.config.lastChild, !ctx_r0.config.lastChild));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.hideLabels);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(14, _c1$t, ctx_r0.config.soWidget === "tinymce", ctx_r0.config.soWidget !== "tinymce", !ctx_r0.config.stacked));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurbTemplate && !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r0.fieldValue)("formControlName", ctx_r0.config.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.soWidget === "tinymce");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.soWidget !== "tinymce");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.customActions && !ctx_r0.config.customActions.hideAction);
  }
}
class JanusFormStaticComponent extends FormStaticComponent {
  constructor() {
    super(...arguments);
    this.assetsPath = '/app/assets/';
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormStaticComponent_BaseFactory;
      return function JanusFormStaticComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormStaticComponent_BaseFactory || (ɵJanusFormStaticComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormStaticComponent)))(__ngFactoryType__ || JanusFormStaticComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormStaticComponent,
      selectors: [["janus-form-static"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([HtmlFormatterService]), i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "janus-field p-0", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "janus-field", "p-0", 3, "formGroup", "ngClass"], ["class", "label form-label", 3, "ngClass", 4, "ngIf"], [1, "field-widget", "widget-readonly", 3, "ngClass"], ["class", "form-text mb-0", 3, "innerHTML", 4, "ngIf"], [4, "ngIf"], ["type", "hidden", 3, "value", "formControlName"], [1, "label", "form-label", 3, "ngClass"], [3, "hasError", "isRequired"], [1, "form-text", "mb-0", 3, "innerHTML"], [4, "ngTemplateOutlet"], [3, "id", "innerHTML", "ngStyle", "ngClass", 4, "ngIf"], ["translate", "", 3, "id", "innerHTML", "ngStyle", "ngClass", 4, "ngIf"], [3, "id", "innerHTML", "ngStyle", "ngClass"], ["translate", "", 3, "id", "innerHTML", "ngStyle", "ngClass"], ["class", "m-0", 3, "id", "ngStyle", "ngClass", "innerHTML", 4, "ngIf"], ["translate", "", 3, "id", "ngStyle", "ngClass", 4, "ngIf"], [1, "m-0", 3, "id", "ngStyle", "ngClass", "innerHTML"], [1, "list-bulleted"], [4, "ngFor", "ngForOf"], ["class", "btn_text-link", 3, "click", 4, "ngIf"], [1, "btn_text-link", 3, "click"], ["translate", "", 3, "id", "ngStyle", "ngClass"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "actions"]],
      template: function JanusFormStaticComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormStaticComponent_div_0_Template, 9, 18, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, i1$1.TranslateDirective, FormActionsComponent, JanusRequiredComponent, i1$1.TranslatePipe, SanitizeHtmlPipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormStaticComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-static',
      template: `
        <div *ngIf="!config.hideField" class="janus-field p-0" [formGroup]="group" [ngClass]="{'last mb-0': config.lastChild, 'mb-4' : !config.lastChild}">
            <dt class="label form-label" *ngIf="!config.hideLabels" [ngClass]="{'form-label-has-blurb': config.blurb, 'col-4 col-sm-3': !config.stacked}">
                {{config.label | translate}}<janus-required [hasError]="(!control.valid && (control.dirty || control.touched))" [isRequired]="isRequired"></janus-required>
            </dt>
            <dd class="field-widget widget-readonly" [ngClass]="{'field-widget-tinymce' : config.soWidget === 'tinymce', 'field-widget-text': config.soWidget !== 'tinymce', 'col-8 col-sm-9': !config.stacked}">
                <div *ngIf="config.blurb" class="form-text mb-0" [innerHTML]="config.blurb | translate | safeHtml"></div>
                <div *ngIf="config.blurbTemplate && !config.blurb">
                    <ng-container *ngTemplateOutlet="config.blurbTemplate"></ng-container>
                </div>
                <input type="hidden" [value]="fieldValue" [formControlName]="config.name">
                <ng-container *ngIf="config.soWidget === 'tinymce'">
                    <div *ngIf="fieldDisplayValue" id="{{config.elementId}}" [innerHTML]="fieldDisplayValue | sanitizeInputHtml" [ngStyle]="config.style" [ngClass]="config.class"></div>
                    <div *ngIf="config.translate" id="{{config.elementId}}" [innerHTML]="config.translate" [ngStyle]="config.style" [ngClass]="config.class" translate></div>
                </ng-container>
                <ng-container *ngIf="config.soWidget !=='tinymce'">
                    <div *ngIf="fieldDisplayValue !== undefined && !config.isList" class="m-0" id="{{config.elementId}}" [ngStyle]="config.style" [ngClass]="config.class" [innerHTML]="fieldDisplayValue | sanitizeInputHtml"></div>
                    <ng-container *ngIf="fieldDisplayValue && config.isList">
                        <ul class="list-bulleted">
                            <ng-container *ngFor="let value of config.value; let i = index">
                                <li *ngIf="(listLimit > 0 && i <= (listLimit - 1))">{{value}}</li>
                                <li *ngIf="(listLimit == 0) || (i > listLimit - 1 && config.showAll)">{{value}}</li>
                            </ng-container>
                        </ul>
                        <button class="btn_text-link" *ngIf="(config.listLimit > 0) && (config.value && config.value.length > 1 && config.value.length > listLimit) && (!config.showAll || config.showAll == undefined)" (click)="showAll(config)">{{ 'misc.See all' | translate }}</button>
                    </ng-container>
                    <div *ngIf="config.translate" id="{{config.elementId}}" [ngStyle]="config.style" [ngClass]="config.class" translate>{{config.translate}}</div>
                    <ng-template
                        *ngIf="config.suffixTemplate" 
                        [ngTemplateOutlet]="config.suffixTemplate"
                        [ngTemplateOutletContext]="{ config: config }"
                    ></ng-template>
                </ng-container>
                <ng-container *ngIf="config.customActions && !config.customActions.hideAction">
                    <form-actions [actions]="config.customActions.actions"></form-actions>
                </ng-container>
            </dd>
        </div>
    `,
      providers: [HtmlFormatterService],
      standalone: false
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormStaticComponent, {
    className: "JanusFormStaticComponent",
    filePath: "janus/components/form-static/janus-form-static.component.ts",
    lineNumber: 49
  });
})();
const _c0$z = (a0, a1, a2) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2
});
const _c1$s = a0 => ({
  "visually-hidden": a0
});
const _c2$n = a0 => ({
  field_name: a0
});
const _c3$g = () => ({
  standalone: true
});
const _c4$f = a0 => ({
  "text-nowrap": a0
});
function JanusFormSwitchComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(1, 1, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormSwitchComponent_div_0_div_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormSwitchComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormSwitchComponent_div_0_div_7_ng_container_1_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.config.blurbTemplate);
  }
}
function JanusFormSwitchComponent_div_0_div_8_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c2$n, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormSwitchComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 12);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, JanusFormSwitchComponent_div_0_div_8_span_3_Template, 3, 6, "span", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function JanusFormSwitchComponent_div_0_div_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "input", 16);
    i0.ɵɵtwoWayListener("ngModelChange", function JanusFormSwitchComponent_div_0_div_11_Template_input_ngModelChange_1_listener($event) {
      const item_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      i0.ɵɵtwoWayBindingSet(item_r3.isChecked, $event) || (item_r3.isChecked = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function JanusFormSwitchComponent_div_0_div_11_Template_input_ngModelChange_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onCheckboxValueChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "-", item_r3.id, "");
    i0.ɵɵtwoWayProperty("ngModel", item_r3.isChecked);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(13, _c3$g));
    i0.ɵɵattribute("name", ctx_r0.config.name)("aria-checked", item_r3.isChecked)("checked", item_r3.isChecked || null);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "-", item_r3.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c4$f, ctx_r0.config.unwrapOptionstext))("innerHTML", item_r3.display, i0.ɵɵsanitizeHtml);
  }
}
function JanusFormSwitchComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "label", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵtemplate(6, JanusFormSwitchComponent_div_0_div_6_Template, 3, 5, "div", 5)(7, JanusFormSwitchComponent_div_0_div_7_Template, 2, 1, "div", 6)(8, JanusFormSwitchComponent_div_0_div_8_Template, 4, 2, "div", 7);
    i0.ɵɵelementStart(9, "div");
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵtemplate(11, JanusFormSwitchComponent_div_0_div_11_Template, 3, 16, "div", 8);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(22, _c0$z, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild, !ctx_r0.config.lastChild))("formGroup", ctx_r0.group);
    i0.ɵɵattribute("aria-labelledby", ctx_r0.config.elementId + (ctx_r0.modal ? "modal" : ""))("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(26, _c1$s, ctx_r0.config.hideLabel));
    i0.ɵɵattribute("aria-required", ctx_r0.isRequired);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 18, ctx_r0.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched))("isRequired", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurbTemplate && !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", !!ctx_r0.config.legendText ? "group" : null)("aria-label", !!ctx_r0.config.legendText ? i0.ɵɵpipeBind1(10, 20, ctx_r0.config.legendText) : null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
  }
}
class JanusFormSwitchComponent extends FormCheckboxComponent {
  constructor() {
    super(...arguments);
    this.assetsPath = '/app/assets/';
  }
  setDescribedBy() {
    let modal = this.modal ? 'modal' : '';
    this.describedByValue = this.config.blurb || this.config.blurbTemplate ? this.config.elementId + modal + '-blurb' : null;
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormSwitchComponent_BaseFactory;
      return function JanusFormSwitchComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormSwitchComponent_BaseFactory || (ɵJanusFormSwitchComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormSwitchComponent)))(__ngFactoryType__ || JanusFormSwitchComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormSwitchComponent,
      selectors: [["janus-form-switch"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "janus-field form-checkbox", "role", "group", 3, "ngClass", "formGroup", 4, "ngIf"], ["role", "group", 1, "janus-field", "form-checkbox", 3, "ngClass", "formGroup"], [1, "form-label", 3, "ngClass", "id"], [3, "hasError", "isRequired"], [1, "field-widget"], ["class", "blurb field-blurb form-text", 3, "innerHTML", 4, "ngIf"], [4, "ngIf"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], ["class", "form-check form-switch", 4, "ngFor", "ngForOf"], [1, "blurb", "field-blurb", "form-text", 3, "innerHTML"], [4, "ngTemplateOutlet"], ["role", "alert", 1, "invalid-feedback"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], ["class", "field-error", 4, "ngIf"], [1, "field-error"], [1, "form-check", "form-switch"], ["type", "checkbox", "role", "switch", 1, "form-check-input", 3, "ngModelChange", "id", "ngModel", "ngModelOptions"], [1, "form-check-label", 3, "ngClass", "for", "innerHTML"]],
      template: function JanusFormSwitchComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormSwitchComponent_div_0_Template, 12, 28, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.CheckboxControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.NgModel, i2$1.FormGroupDirective, JanusRequiredComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormSwitchComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-switch',
      standalone: false,
      template: "<div\n    *ngIf=\"!config.hideField\"\n    class=\"janus-field form-checkbox\"\n    [ngClass]=\"{\n        'is-invalid': !control.valid && (control.dirty || control.touched),\n        'last': config.lastChild,\n        'mb-4': !config.lastChild\n    }\"\n    role=\"group\"\n    [attr.aria-labelledby]=\"config.elementId + (modal ? 'modal' : '')\"\n    [attr.aria-describedby]=\"describedByValue\"\n    [formGroup]=\"group\"\n>\n    <label [ngClass]=\"{'visually-hidden': config.hideLabel}\" class=\"form-label\" id=\"{{ config.elementId }}{{ modal ? 'modal' : '' }}\" [attr.aria-required]=\"isRequired\">\n        {{ config.label | translate }}<janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\"></janus-required>\n    </label>\n\n    <div class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" class=\"blurb field-blurb form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div *ngIf=\"config.blurbTemplate && !config.blurb\">\n            <ng-container *ngTemplateOutlet=\"config.blurbTemplate\"></ng-container>\n        </div>\n\n        <div *ngIf=\"!control.valid && (control.dirty || control.touched)\" class=\"invalid-feedback\" role=\"alert\">\n            <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n            </svg>\n\n            <span *ngIf=\"control.errors.required\" class=\"field-error\">\n                {{ 'misc.Field is required' | translate: { field_name: translatedLabel } }}\n            </span>\n        </div>\n\n        <div [attr.role]=\"!!config.legendText ? 'group' : null\" [attr.aria-label]=\"!!config.legendText ? (config.legendText | translate) : null\">\n            <div *ngFor=\"let item of items\" class=\"form-check form-switch\">\n                <input\n                    type=\"checkbox\"\n                    role=\"switch\"\n                    id=\"{{ config.elementId }}-{{ item.id }}\"\n                    class=\"form-check-input\"\n                    [attr.name]=\"config.name\"\n                    [attr.aria-checked]=\"item.isChecked\"\n                    [attr.checked]=\"item.isChecked || null\"\n                    [(ngModel)]=\"item.isChecked\"\n                    [ngModelOptions]=\"{ standalone: true }\"\n                    (ngModelChange)=\"onCheckboxValueChange()\"\n                />\n\n                <label class=\"form-check-label\" [ngClass]=\"{'text-nowrap': config.unwrapOptionstext}\" for=\"{{ config.elementId }}-{{ item.id }}\" [innerHTML]=\"item.display\">\n                </label>\n            </div>\n        </div>\n    </div>\n</div>"
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormSwitchComponent, {
    className: "JanusFormSwitchComponent",
    filePath: "janus/components/form-switch/janus-form-switch.component.ts",
    lineNumber: 9
  });
})();
const _c0$y = (a0, a1, a2, a3) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2,
  "visually-hidden": a3
});
const _c1$r = a0 => ({
  "visually-hidden": a0
});
const _c2$m = a0 => ({
  field_name: a0
});
const _c3$f = a0 => ({
  "scrollable-list": a0
});
const _c4$e = () => ({
  standalone: true
});
const _c5$a = a0 => ({
  "text-muted": a0
});
function JanusFormCheckboxComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormCheckboxComponent_div_0_div_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormCheckboxComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, JanusFormCheckboxComponent_div_0_div_7_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.config.blurbTemplate);
  }
}
function JanusFormCheckboxComponent_div_0_div_8_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c2$m, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormCheckboxComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, JanusFormCheckboxComponent_div_0_div_8_span_3_Template, 3, 6, "span", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors == null ? null : ctx_r0.control.errors.required);
  }
}
function JanusFormCheckboxComponent_div_0_ng_container_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "input", 21);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 22);
    i0.ɵɵelement(4, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind2(2, 4, "misc.Search field options", i0.ɵɵpureFunction1(7, _c2$m, ctx_r0.translatedLabel)))("formControl", ctx_r0.filterControl);
    i0.ɵɵattribute("aria-controls", ctx_r0.config.elementId + "-list");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-search", null, "xlink");
  }
}
function JanusFormCheckboxComponent_div_0_ng_container_9_div_3_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵlistener("click", function JanusFormCheckboxComponent_div_0_ng_container_9_div_3_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.toggleAllSelected(ctx_r0.showOnlySelected));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span", 27);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r0.control.disabled);
    i0.ɵɵattribute("aria-controls", ctx_r0.getCheckboxListVariant(ctx_r0.config, ctx_r0.items));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, ctx_r0.allItemsSelected || ctx_r0.showOnlySelected ? "misc.Clear All" : "misc.Select All"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("\"", ctx_r0.config.label, "\" options");
  }
}
function JanusFormCheckboxComponent_div_0_ng_container_9_div_3_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", ctx_r0.itemsSelectedCount, "/", ctx_r0.listCount, " ");
  }
}
function JanusFormCheckboxComponent_div_0_ng_container_9_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtemplate(1, JanusFormCheckboxComponent_div_0_ng_container_9_div_3_button_1_Template, 5, 6, "button", 24)(2, JanusFormCheckboxComponent_div_0_ng_container_9_div_3_span_2_Template, 2, 2, "span", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.useSelectAll);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.useScrollableList && ctx_r0.items.length > ctx_r0.scrollableListThreshold);
  }
}
function JanusFormCheckboxComponent_div_0_ng_container_9_ul_4_li_2_Conditional_7_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "br");
    i0.ɵɵelementStart(1, "span", 38);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const extraLabel_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(extraLabel_r5);
  }
}
function JanusFormCheckboxComponent_div_0_ng_container_9_ul_4_li_2_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, JanusFormCheckboxComponent_div_0_ng_container_9_ul_4_li_2_Conditional_7_For_1_Template, 3, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵrepeater(item_r4.extraLabels);
  }
}
function JanusFormCheckboxComponent_div_0_ng_container_9_ul_4_li_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 32)(1, "span", 33)(2, "span", 34)(3, "input", 35);
    i0.ɵɵtwoWayListener("ngModelChange", function JanusFormCheckboxComponent_div_0_ng_container_9_ul_4_li_2_Template_input_ngModelChange_3_listener($event) {
      const item_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      i0.ɵɵtwoWayBindingSet(item_r4.isChecked, $event) || (item_r4.isChecked = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function JanusFormCheckboxComponent_div_0_ng_container_9_ul_4_li_2_Template_input_ngModelChange_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.onCheckboxValueChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 36)(5, "label", 37);
    i0.ɵɵtext(6);
    i0.ɵɵtemplate(7, JanusFormCheckboxComponent_div_0_ng_container_9_ul_4_li_2_Conditional_7_Template, 2, 0);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "-", item_r4.id, "");
    i0.ɵɵproperty("disabled", item_r4.disabled || ctx_r0.control.disabled);
    i0.ɵɵtwoWayProperty("ngModel", item_r4.isChecked);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(15, _c4$e));
    i0.ɵɵattribute("name", ctx_r0.config.name)("aria-checked", item_r4.isChecked)("aria-required", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "-", item_r4.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c5$a, item_r4.disabled));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r4.display, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional((item_r4.extraLabels == null ? null : item_r4.extraLabels.length) ? 7 : -1);
  }
}
function JanusFormCheckboxComponent_div_0_ng_container_9_ul_4_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "misc.No results found"), " ");
  }
}
function JanusFormCheckboxComponent_div_0_ng_container_9_ul_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 29);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, JanusFormCheckboxComponent_div_0_ng_container_9_ul_4_li_2_Template, 8, 18, "li", 30)(3, JanusFormCheckboxComponent_div_0_ng_container_9_ul_4_div_3_Template, 3, 3, "div", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const items_r6 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("role", !!ctx_r0.config.legendText ? "group" : "list")("aria-label", !!ctx_r0.config.legendText ? i0.ɵɵpipeBind1(1, 5, ctx_r0.config.legendText) : null)("id", ctx_r0.config.elementId + "-list");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", items_r6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !items_r6.length && ctx_r0.filterKey);
  }
}
function JanusFormCheckboxComponent_div_0_ng_container_9_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "button", 26);
    i0.ɵɵlistener("click", function JanusFormCheckboxComponent_div_0_ng_container_9_div_6_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.toggleShowOnlySelected());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "span", 27);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !ctx_r0.itemsSelectedCount || ctx_r0.allItemsSelected || ctx_r0.control.disabled);
    i0.ɵɵattribute("aria-controls", ctx_r0.showOnlySelected && !ctx_r0.allItemsSelected ? "show-all" : "show-selected");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, ctx_r0.showOnlySelected && !ctx_r0.allItemsSelected ? "misc.Show All" : "misc.Show Selected"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("\"", ctx_r0.config.label, "\" options");
  }
}
function JanusFormCheckboxComponent_div_0_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormCheckboxComponent_div_0_ng_container_9_div_1_Template, 5, 9, "div", 16);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵtemplate(3, JanusFormCheckboxComponent_div_0_ng_container_9_div_3_Template, 3, 2, "div", 18)(4, JanusFormCheckboxComponent_div_0_ng_container_9_ul_4_Template, 4, 7, "ul", 19);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵtemplate(6, JanusFormCheckboxComponent_div_0_ng_container_9_div_6_Template, 6, 6, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.useFilter && ctx_r0.items.length > ctx_r0.scrollableListThreshold);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$f, ctx_r0.useScrollableList && ctx_r0.items.length > ctx_r0.scrollableListThreshold));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.useSelectAll || ctx_r0.useScrollableList) && ctx_r0.items.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 5, ctx_r0.items$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.useScrollableList && ctx_r0.items.length > ctx_r0.scrollableListThreshold);
  }
}
function JanusFormCheckboxComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "label", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵtemplate(6, JanusFormCheckboxComponent_div_0_div_6_Template, 3, 6, "div", 5)(7, JanusFormCheckboxComponent_div_0_div_7_Template, 2, 2, "div", 6)(8, JanusFormCheckboxComponent_div_0_div_8_Template, 4, 2, "div", 7)(9, JanusFormCheckboxComponent_div_0_ng_container_9_Template, 7, 9, "ng-container", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", ctx_r0.config.elementId + (ctx_r0.modal ? "modal" : ""));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(19, _c0$y, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild, !ctx_r0.config.lastChild, ctx_r0.config.snareField))("formGroup", ctx_r0.group);
    i0.ɵɵattribute("aria-labelledby", ctx_r0.config.elementId + (ctx_r0.modal ? "modal" : "") + "-label")("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "-label");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c1$r, ctx_r0.config.hideLabel));
    i0.ɵɵattribute("aria-required", ctx_r0.isRequired);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 17, ctx_r0.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched))("isRequired", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurbTemplate && !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.items.length);
  }
}
class JanusFormCheckboxComponent extends FormCheckboxComponent {
  constructor() {
    super(...arguments);
    this.assetsPath = '/app/assets/';
    this.showOnlySelected = false;
    this.listCount = 0;
  }
  toggleShowOnlySelected() {
    this.showOnlySelected = !this.showOnlySelected;
    this.updateAvailableItems();
  }
  updateAvailableItems() {
    const filteredItems = this.getFilteredItems();
    const checkedItems = this.getCheckedItems(filteredItems);
    this.listCount = filteredItems.length;
    this.itemsSelectedCount = checkedItems.length;
    this.allItemsSelected = this.itemsSelectedCount === filteredItems.filter(item => !item.disabled).length;
    if (checkedItems.length === 0) {
      this.showOnlySelected = false;
    }
    this.items$.next(this.showOnlySelected ? checkedItems : filteredItems);
  }
  getCheckboxListVariant(config, items) {
    let ariaControlsValue;
    if (items.length <= 5) {
      ariaControlsValue = items.map(item => config.elementId + '-' + item.id).join(' ');
    } else {
      ariaControlsValue = config.elementId + '-list';
    }
    return ariaControlsValue;
  }
  setDescribedBy() {
    let modal = this.modal ? 'modal' : '';
    this.describedByValue = this.config.blurb || this.config.blurbTemplate ? this.config.elementId + modal + '-blurb' : null;
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormCheckboxComponent_BaseFactory;
      return function JanusFormCheckboxComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormCheckboxComponent_BaseFactory || (ɵJanusFormCheckboxComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormCheckboxComponent)))(__ngFactoryType__ || JanusFormCheckboxComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormCheckboxComponent,
      selectors: [["janus-form-checkbox"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["role", "group", "class", "janus-field", 3, "id", "ngClass", "formGroup", 4, "ngIf"], ["role", "group", 1, "janus-field", 3, "id", "ngClass", "formGroup"], [1, "form-label", 3, "ngClass", "id"], [3, "hasError", "isRequired"], [1, "field-widget"], ["class", "form-text", 3, "id", "innerHTML", 4, "ngIf"], [3, "id", 4, "ngIf"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], [4, "ngIf"], [1, "form-text", 3, "id", "innerHTML"], [3, "id"], [4, "ngTemplateOutlet"], ["role", "alert", 1, "invalid-feedback"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], ["class", "field-error", 4, "ngIf"], [1, "field-error"], ["class", "checkbox-items-filter mb-2 position-relative", 4, "ngIf"], [1, "checkbox-items-wrapper", 3, "ngClass"], ["class", "checkbox-items-header d-flex align-items-center justify-content-between", 4, "ngIf"], ["class", "checkbox-items-body list-unstyled mb-0 py-2 overflow-auto", "aria-live", "polite", 4, "ngIf"], [1, "checkbox-items-filter", "mb-2", "position-relative"], ["type", "search", 1, "form-control", "bg-transparent", "pe-5", 3, "placeholder", "formControl"], ["width", "1.25rem", "height", "1.25rem", 1, "d-flex", "align-items-center", "h-100", "me-3", "position-absolute", "top-0", "end-0", "bottom-0"], [1, "checkbox-items-header", "d-flex", "align-items-center", "justify-content-between"], ["type", "button", "class", "btn btn-link btn-sm p-0 text-decoration-none", "role", "button", "aria-live", "polite", 3, "disabled", "click", 4, "ngIf"], ["class", "small text-muted flex-grow-1 text-end", "role", "status", "aria-live", "polite", 4, "ngIf"], ["type", "button", "role", "button", "aria-live", "polite", 1, "btn", "btn-link", "btn-sm", "p-0", "text-decoration-none", 3, "click", "disabled"], [1, "visually-hidden"], ["role", "status", "aria-live", "polite", 1, "small", "text-muted", "flex-grow-1", "text-end"], ["aria-live", "polite", 1, "checkbox-items-body", "list-unstyled", "mb-0", "py-2", "overflow-auto"], ["class", "checkbox-item", 4, "ngFor", "ngForOf"], ["class", "checkbox-item", 4, "ngIf"], [1, "checkbox-item"], [1, "d-flex", "px-2"], [1, "d-flex", "w-100"], ["type", "checkbox", "role", "checkbox", "aria-live", "polite", 1, "form-check-input", "me-2", "flex-shrink-0", 3, "ngModelChange", "id", "disabled", "ngModel", "ngModelOptions"], [1, "w-100"], [1, "form-check-label", "list-group-item", "border-0", "p-0", "bg-transparent", 3, "ngClass", "for"], [1, "text-muted", "fs-6"]],
      template: function JanusFormCheckboxComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormCheckboxComponent_div_0_Template, 10, 26, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.DefaultValueAccessor, i2$1.CheckboxControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.NgModel, i2$1.FormControlDirective, i2$1.FormGroupDirective, JanusRequiredComponent, i1.AsyncPipe, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: ["janus-form-checkbox .checkbox-items-filter svg{z-index:-1}janus-form-checkbox .checkbox-items-wrapper .checkbox-items-header button{min-width:fit-content}janus-form-checkbox .checkbox-items-wrapper.scrollable-list{border:1px solid var(--bs-gray-300);border-radius:.25rem;overflow:hidden}janus-form-checkbox .checkbox-items-wrapper.scrollable-list .checkbox-items-header,janus-form-checkbox .checkbox-items-wrapper.scrollable-list .checkbox-items-footer{padding:.25rem .5rem;background-color:var(--bs-gray-200)}janus-form-checkbox .checkbox-items-wrapper.scrollable-list .checkbox-items-body{max-height:16em}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormCheckboxComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-checkbox',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div\n    *ngIf=\"!config.hideField\"\n    role=\"group\"\n    class=\"janus-field\"\n    id=\"{{ config.elementId + (modal ? 'modal' : '')}}\"\n    [ngClass]=\"{\n        'is-invalid': !control.valid && (control.dirty || control.touched),\n        'last': config.lastChild,\n        'mb-4': !config.lastChild,\n        'visually-hidden': config.snareField\n    }\"\n    [attr.aria-labelledby]=\"config.elementId + (modal ? 'modal' : '') + '-label'\"\n    [attr.aria-describedby]=\"describedByValue\"\n    [formGroup]=\"group\"\n>\n    <label [ngClass]=\"{'visually-hidden': config.hideLabel}\" class=\"form-label\" id=\"{{ config.elementId }}{{ modal ? 'modal' : '' }}-label\" [attr.aria-required]=\"isRequired\">\n        {{ config.label | translate }}<janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\"></janus-required>\n    </label>\n\n    <div class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div *ngIf=\"config.blurbTemplate && !config.blurb\" id=\"{{describedByValue}}\">\n            <ng-container *ngTemplateOutlet=\"config.blurbTemplate\"></ng-container>\n        </div>\n\n        <div *ngIf=\"!control.valid && (control.dirty || control.touched)\" class=\"invalid-feedback\" role=\"alert\">\n            <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n            </svg>\n\n            <span *ngIf=\"control.errors?.required\" class=\"field-error\">\n                {{ 'misc.Field is required' | translate: { field_name: translatedLabel } }}\n            </span>\n        </div>\n\n        <ng-container *ngIf=\"items.length\">\n            <div *ngIf=\"useFilter && items.length > scrollableListThreshold\" class=\"checkbox-items-filter mb-2 position-relative\">\n                <input \n                    type=\"search\" \n                    class=\"form-control bg-transparent pe-5\" \n                    [placeholder]=\"'misc.Search field options' | translate: { field_name: translatedLabel }\"\n                    [formControl]=\"filterControl\"\n                    [attr.aria-controls]=\"config.elementId + '-list'\"\n                />\n\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"d-flex align-items-center h-100 me-3 position-absolute top-0 end-0 bottom-0\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-search'\"></use>\n                </svg>\n            </div>\n\n            <div class=\"checkbox-items-wrapper\" [ngClass]=\"{ 'scrollable-list': useScrollableList && items.length > scrollableListThreshold }\">\n                <div *ngIf=\"(useSelectAll || useScrollableList) && items.length\" class=\"checkbox-items-header d-flex align-items-center justify-content-between\">\n                    <button \n                        *ngIf=\"useSelectAll\"\n                        type=\"button\"\n                        class=\"btn btn-link btn-sm p-0 text-decoration-none\"\n                        [disabled]=\"control.disabled\"\n                        (click)=\"toggleAllSelected(showOnlySelected)\"\n                        role=\"button\"\n                        aria-live=\"polite\"\n                        [attr.aria-controls]=\"getCheckboxListVariant(config,items)\"\n                    >\n                        {{ ((allItemsSelected || showOnlySelected) ? 'misc.Clear All' : 'misc.Select All') | translate }}\n                        <span class=\"visually-hidden\">\"{{config.label}}\" options</span>\n                    </button>\n\n                    <span *ngIf=\"useScrollableList && items.length > scrollableListThreshold\" class=\"small text-muted flex-grow-1 text-end\" role=\"status\" aria-live=\"polite\">\n                        {{ itemsSelectedCount }}/{{ listCount }}\n                    </span>\n                </div>\n\n                <ul \n                    *ngIf=\"items$ | async as items\"\n                    class=\"checkbox-items-body list-unstyled mb-0 py-2 overflow-auto\"\n                    [attr.role]=\"!!config.legendText ? 'group' : 'list'\"\n                    [attr.aria-label]=\"!!config.legendText ? (config.legendText | translate) : null\"\n                    [attr.id]=\"config.elementId + '-list'\"\n                    aria-live=\"polite\"\n                >\n                    <li *ngFor=\"let item of items\" class=\"checkbox-item\">\n                        <span class=\"d-flex px-2\">\n                            <span class=\"d-flex w-100\">\n                                <input\n                                    type=\"checkbox\"\n                                    class=\"form-check-input me-2 flex-shrink-0\"\n                                    id=\"{{ config.elementId }}-{{ item.id }}\"\n                                    [disabled]=\"item.disabled || control.disabled\"\n                                    [attr.name]=\"config.name\"\n                                    [attr.aria-checked]=\"item.isChecked\"\n                                    [attr.aria-required]=\"isRequired\"\n                                    [(ngModel)]=\"item.isChecked\"\n                                    [ngModelOptions]=\"{ standalone: true }\"\n                                    (ngModelChange)=\"onCheckboxValueChange()\"\n                                    role=\"checkbox\"\n                                    aria-live=\"polite\"\n                                />\n                                <div class=\"w-100\">\n                                    <label class=\"form-check-label list-group-item border-0 p-0 bg-transparent\"\n                                        [ngClass]=\"{'text-muted': item.disabled}\"\n                                        for=\"{{ config.elementId }}-{{ item.id }}\">\n                                        {{ item.display }}\n                                        @if (item.extraLabels?.length) {\n                                            @for (extraLabel of item.extraLabels; track extraLabel) {\n                                                <br>\n                                                <span class=\"text-muted fs-6\">{{ extraLabel }}</span>\n                                            }\n                                        }\n                                    </label>\n                                </div>\n                            </span>\n                        </span>\n                    </li>\n\n                    <div *ngIf=\"!items.length && filterKey\" class=\"checkbox-item\">\n                        {{ 'misc.No results found' | translate }}\n                    </div>\n                </ul>\n\n                <div *ngIf=\"useScrollableList && items.length > scrollableListThreshold\" class=\"checkbox-items-header d-flex align-items-center justify-content-between\">\n                    <button \n                        type=\"button\"\n                        class=\"btn btn-link btn-sm p-0 text-decoration-none\"\n                        role=\"button\"\n                        aria-live=\"polite\"\n                        [disabled]=\"!itemsSelectedCount || allItemsSelected || control.disabled\"\n                        (click)=\"toggleShowOnlySelected()\"\n                        [attr.aria-controls]=\"(showOnlySelected && !allItemsSelected) ? 'show-all' : 'show-selected'\"\n                    >\n                        {{ (showOnlySelected && !allItemsSelected ? 'misc.Show All' : 'misc.Show Selected') | translate }}\n                        <span class=\"visually-hidden\">\"{{config.label}}\" options</span>\n                    </button>\n                </div>\n            </div>\n        </ng-container>\n    </div>\n</div>\n",
      styles: ["janus-form-checkbox .checkbox-items-filter svg{z-index:-1}janus-form-checkbox .checkbox-items-wrapper .checkbox-items-header button{min-width:fit-content}janus-form-checkbox .checkbox-items-wrapper.scrollable-list{border:1px solid var(--bs-gray-300);border-radius:.25rem;overflow:hidden}janus-form-checkbox .checkbox-items-wrapper.scrollable-list .checkbox-items-header,janus-form-checkbox .checkbox-items-wrapper.scrollable-list .checkbox-items-footer{padding:.25rem .5rem;background-color:var(--bs-gray-200)}janus-form-checkbox .checkbox-items-wrapper.scrollable-list .checkbox-items-body{max-height:16em}\n"]
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormCheckboxComponent, {
    className: "JanusFormCheckboxComponent",
    filePath: "janus/components/form-checkbox/janus-form-checkbox.component.ts",
    lineNumber: 11
  });
})();
const _c0$x = ["mobileButton"];
const _c1$q = ["hpWidget"];
const _c2$l = (a0, a1, a2, a3) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2,
  "pe-none": a3
});
const _c3$e = a0 => ({
  field_name: a0
});
const _c4$d = () => ({
  standalone: true
});
const _c5$9 = (a0, a1, a2) => ({
  "filtering": a0,
  "position-fixed top-0 start-0 min-vh-100 vw-100": a1,
  "mt-1": a2
});
const _c6$7 = a0 => ({
  "d-none": a0
});
const _c7$4 = a0 => ({
  item: a0
});
const _c8$3 = (a0, a1) => ({
  "text-white bg-primary": a0,
  "text-dark bg-light": a1
});
const _c9$3 = a0 => ({
  "btn-close-white": a0
});
function JanusFormHierpicklistComponent_div_0_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "janus-required", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("id", ctx_r0.id + "-label")("aria-required", ctx_r0.isRequired);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 5, ctx_r0.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched))("isRequired", ctx_r0.isRequired);
  }
}
function JanusFormHierpicklistComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 21);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormHierpicklistComponent_div_0_div_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormHierpicklistComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, JanusFormHierpicklistComponent_div_0_div_4_ng_container_1_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.config.blurbTemplate);
  }
}
function JanusFormHierpicklistComponent_div_0_div_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 25);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Field is required", i0.ɵɵpureFunction1(5, _c3$e, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormHierpicklistComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, JanusFormHierpicklistComponent_div_0_div_5_div_1_Template, 5, 7, "div", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function JanusFormHierpicklistComponent_div_0_6_ng_template_0_Template(rf, ctx) {}
function JanusFormHierpicklistComponent_div_0_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormHierpicklistComponent_div_0_6_ng_template_0_Template, 0, 0, "ng-template", 26);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const chipListTemplate_r2 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", chipListTemplate_r2);
  }
}
function JanusFormHierpicklistComponent_div_0_Conditional_9_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r0.config.customAddButtonLabel), " ");
  }
}
function JanusFormHierpicklistComponent_div_0_Conditional_9_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, "misc.Add"), " ");
  }
}
function JanusFormHierpicklistComponent_div_0_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27, 2);
    i0.ɵɵlistener("click", function JanusFormHierpicklistComponent_div_0_Conditional_9_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.openDropdown($event));
    });
    i0.ɵɵtemplate(2, JanusFormHierpicklistComponent_div_0_Conditional_9_Conditional_2_Template, 2, 3)(3, JanusFormHierpicklistComponent_div_0_Conditional_9_Conditional_3_Template, 2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-expanded", ctx_r0.showDropdownList || ctx_r0.alwaysShowDropdownList);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.config.customAddButtonLabel ? 2 : 3);
  }
}
function JanusFormHierpicklistComponent_div_0_Conditional_10_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 34);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function JanusFormHierpicklistComponent_div_0_Conditional_10_Conditional_4_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(3);
      $event.stopImmediatePropagation();
      $event.preventDefault();
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    })("keydown.enter", function JanusFormHierpicklistComponent_div_0_Conditional_10_Conditional_4_Template_button_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(3);
      $event.stopImmediatePropagation();
      $event.preventDefault();
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    })("keydown.space", function JanusFormHierpicklistComponent_div_0_Conditional_10_Conditional_4_Template_button_keydown_space_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(3);
      $event.stopImmediatePropagation();
      $event.preventDefault();
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    });
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 36);
    i0.ɵɵelement(4, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "misc.Deselect"));
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-x", null, "xlink");
  }
}
function JanusFormHierpicklistComponent_div_0_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28, 2);
    i0.ɵɵlistener("click", function JanusFormHierpicklistComponent_div_0_Conditional_10_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.openDropdown($event));
    })("keydown.enter", function JanusFormHierpicklistComponent_div_0_Conditional_10_Template_button_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.openDropdown($event));
    })("keydown.space", function JanusFormHierpicklistComponent_div_0_Conditional_10_Template_button_keydown_space_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.openDropdown($event));
    });
    i0.ɵɵelementStart(2, "span", 29);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, JanusFormHierpicklistComponent_div_0_Conditional_10_Conditional_4_Template, 5, 4, "button", 30);
    i0.ɵɵelement(5, "input", 31);
    i0.ɵɵelementStart(6, "div", 32);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(7, "svg", 33);
    i0.ɵɵelement(8, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("id", ctx_r0.id + "-selected");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getSelectedFirstItemName(), " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.selects == null ? null : ctx_r0.selects.length) ? 4 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-chevron-down", null, "xlink");
  }
}
function JanusFormHierpicklistComponent_div_0_ng_container_11_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 40);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function JanusFormHierpicklistComponent_div_0_ng_container_11_button_5_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(3);
      $event.stopImmediatePropagation();
      $event.preventDefault();
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    })("keydown.enter", function JanusFormHierpicklistComponent_div_0_ng_container_11_button_5_Template_button_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(3);
      $event.stopImmediatePropagation();
      $event.preventDefault();
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    })("keydown.space", function JanusFormHierpicklistComponent_div_0_ng_container_11_button_5_Template_button_keydown_space_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(3);
      $event.stopImmediatePropagation();
      $event.preventDefault();
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    });
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 36);
    i0.ɵɵelement(4, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("tabindex", ctx_r0.selects.length ? "0" : "-1")("aria-label", i0.ɵɵpipeBind1(1, 3, "misc.Deselect"));
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-x", null, "xlink");
  }
}
function JanusFormHierpicklistComponent_div_0_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 37, 3);
    i0.ɵɵlistener("click", function JanusFormHierpicklistComponent_div_0_ng_container_11_Template_div_click_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.openPicklist($event));
    })("keydown.enter", function JanusFormHierpicklistComponent_div_0_ng_container_11_Template_div_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.openPicklist($event));
    })("keydown.space", function JanusFormHierpicklistComponent_div_0_ng_container_11_Template_div_keydown_space_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.openPicklist($event));
    });
    i0.ɵɵelementStart(3, "span", 29);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, JanusFormHierpicklistComponent_div_0_ng_container_11_button_5_Template, 5, 5, "button", 38);
    i0.ɵɵelementStart(6, "div", 39);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(7, "svg", 33);
    i0.ɵɵelement(8, "use");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-labelledby", ctx_r0.id + "-label " + ctx_r0.id + "-selected")("role", "combobox")("tabindex", ctx_r0.activeInputField || ctx_r0.control.disabled ? -1 : 0)("aria-expanded", ctx_r0.activeInputField)("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("id", ctx_r0.id + "-selected");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getSelectedFirstItemName(), " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.multiple && ctx_r0.selects.length);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-chevron-down", null, "xlink");
  }
}
function JanusFormHierpicklistComponent_div_0_ng_container_12_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 45);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("mousedown", function JanusFormHierpicklistComponent_div_0_ng_container_12_button_5_Template_button_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r0 = i0.ɵɵnextContext(3);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    })("keydown.enter", function JanusFormHierpicklistComponent_div_0_ng_container_12_button_5_Template_button_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    })("keydown.space", function JanusFormHierpicklistComponent_div_0_ng_container_12_button_5_Template_button_keydown_space_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.clearSearch());
    });
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 36);
    i0.ɵɵelement(4, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "misc.Clear"));
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-x", null, "xlink");
  }
}
function JanusFormHierpicklistComponent_div_0_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 41)(2, "input", 42, 4);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function JanusFormHierpicklistComponent_div_0_ng_container_12_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.search, $event) || (ctx_r0.search = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function JanusFormHierpicklistComponent_div_0_ng_container_12_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.searchChange($event));
    })("keydown", function JanusFormHierpicklistComponent_div_0_ng_container_12_Template_input_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.formKeyNav($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, JanusFormHierpicklistComponent_div_0_ng_container_12_button_5_Template, 5, 4, "button", 43);
    i0.ɵɵelementStart(6, "div", 44);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(7, "svg", 33);
    i0.ɵɵelement(8, "use");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("padding-left", ctx_r0.isRTL ? "4rem" : null)("padding-right", ctx_r0.isRTL ? null : "4rem");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.search);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(18, _c4$d))("placeholder", i0.ɵɵpipeBind1(4, 16, ctx_r0.placeholder));
    i0.ɵɵattribute("id", ctx_r0.id + "-search")("aria-autocomplete", "list")("aria-expanded", ctx_r0.activeInputField)("aria-labelledby", ctx_r0.hideLabel ? null : ctx_r0.id + "-label")("aria-describedby", ctx_r0.describedByValue)("aria-owns", ctx_r0.id + "-list")("role", "combobox");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.search);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-chevron-down", null, "xlink");
  }
}
function JanusFormHierpicklistComponent_div_0_ng_container_13_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hierarchical-list-widget", 48, 6);
    i0.ɵɵlistener("selection", function JanusFormHierpicklistComponent_div_0_ng_container_13_Conditional_3_Template_hierarchical_list_widget_selection_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.hpWidgetSelectionUpdates($event));
    })("searchChanged", function JanusFormHierpicklistComponent_div_0_ng_container_13_Conditional_3_Template_hierarchical_list_widget_searchChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.hpWidgetSearchUpdates($event));
    })("navigationChanged", function JanusFormHierpicklistComponent_div_0_ng_container_13_Conditional_3_Template_hierarchical_list_widget_navigationChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.hpWidgetNavigationUpdates($event));
    })("statesChanged", function JanusFormHierpicklistComponent_div_0_ng_container_13_Conditional_3_Template_hierarchical_list_widget_statesChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.hpWidgetStatesUpdates($event));
    })("keydown.escape", function JanusFormHierpicklistComponent_div_0_ng_container_13_Conditional_3_Template_hierarchical_list_widget_keydown_escape_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.escapeDropdownList($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", ctx_r0.widgetConfig)("list", ctx_r0.widgetList)("values", ctx_r0.widgetSelects)("search", ctx_r0.widgetSearch);
  }
}
function JanusFormHierpicklistComponent_div_0_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 46, 5);
    i0.ɵɵtemplate(3, JanusFormHierpicklistComponent_div_0_ng_container_13_Conditional_3_Template, 2, 4, "hierarchical-list-widget", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("scroll-padding", ctx_r0.scrollPadding, "px");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(4, _c5$9, ctx_r0.isSearching(), ctx_r0.isMobileView, !ctx_r0.isMobileView));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.widgetConfig && ctx_r0.widgetList ? 3 : -1);
  }
}
function JanusFormHierpicklistComponent_div_0_14_ng_template_0_Template(rf, ctx) {}
function JanusFormHierpicklistComponent_div_0_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormHierpicklistComponent_div_0_14_ng_template_0_Template, 0, 0, "ng-template", 26);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const chipListTemplate_r2 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", chipListTemplate_r2);
  }
}
function JanusFormHierpicklistComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, JanusFormHierpicklistComponent_div_0_label_1_Template, 4, 7, "label", 10);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵtemplate(3, JanusFormHierpicklistComponent_div_0_div_3_Template, 3, 6, "div", 12)(4, JanusFormHierpicklistComponent_div_0_div_4_Template, 2, 2, "div", 13)(5, JanusFormHierpicklistComponent_div_0_div_5_Template, 2, 1, "div", 14)(6, JanusFormHierpicklistComponent_div_0_6_Template, 1, 1, null, 15);
    i0.ɵɵelementStart(7, "div", 16, 1);
    i0.ɵɵtemplate(9, JanusFormHierpicklistComponent_div_0_Conditional_9_Template, 4, 2, "button", 17)(10, JanusFormHierpicklistComponent_div_0_Conditional_10_Template, 9, 4, "button", 18)(11, JanusFormHierpicklistComponent_div_0_ng_container_11_Template, 9, 9, "ng-container", 15)(12, JanusFormHierpicklistComponent_div_0_ng_container_12_Template, 9, 19, "ng-container", 15)(13, JanusFormHierpicklistComponent_div_0_ng_container_13_Template, 4, 8, "ng-container", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, JanusFormHierpicklistComponent_div_0_14_Template, 1, 1, null, 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(14, _c2$l, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild, !ctx_r0.config.lastChild, ctx_r0.control.disabled));
    i0.ɵɵattribute("id", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurbTemplate && !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.hideChipList && ctx_r0.chipListPosition === "top");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("mobile-view-fullsize", ctx_r0.isMobileView);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.config.multiple ? 9 : 10);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.activeInputField && !ctx_r0.alwaysShowDropdownList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.activeInputField || ctx_r0.alwaysShowDropdownList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showDropdownList || ctx_r0.alwaysShowDropdownList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.hideChipList && ctx_r0.chipListPosition === "bottom");
  }
}
function JanusFormHierpicklistComponent_ng_template_1_div_0_li_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 53);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "button", 54);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("click", function JanusFormHierpicklistComponent_ng_template_1_div_0_li_4_Template_button_click_2_listener() {
      const select_r13 = i0.ɵɵrestoreView(_r12).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.removeSelect(select_r13));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelement(5, "span", 55);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const select_r13 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("cdkOption", select_r13);
    i0.ɵɵattribute("aria-selected", true)("aria-label", i0.ɵɵpipeBind2(1, 7, "misc.Item - Remove", i0.ɵɵpureFunction1(13, _c7$4, ctx_r0.getItemLabel(select_r13))));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(15, _c8$3, ctx_r0.activeInputField, !ctx_r0.activeInputField));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(3, 10, "misc.Item - Remove", i0.ɵɵpureFunction1(18, _c7$4, ctx_r0.getItemLabel(select_r13))));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getItemLabel(select_r13), " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c9$3, ctx_r0.activeInputField));
  }
}
function JanusFormHierpicklistComponent_ng_template_1_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 50)(1, "ul", 51, 7);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("keydown", function JanusFormHierpicklistComponent_ng_template_1_div_0_Template_ul_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.chipNav($event));
    });
    i0.ɵɵtemplate(4, JanusFormHierpicklistComponent_ng_template_1_div_0_li_4_Template, 6, 22, "li", 52);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c6$7, !ctx_r0.multiple));
    i0.ɵɵadvance();
    i0.ɵɵproperty("cdkListboxOrientation", "horizontal");
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 5, "misc.Selected options:"))("aria-live", ctx_r0.activeInputField ? "polite" : "off");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.selects);
  }
}
function JanusFormHierpicklistComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormHierpicklistComponent_ng_template_1_div_0_Template, 5, 9, "div", 49);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.selects == null ? null : ctx_r0.selects.length);
  }
}
class JanusFormHierpicklistComponent extends FormHierpicklistComponent {
  constructor() {
    super(...arguments);
    this.assetsPath = '/app/assets/';
    this.isMobileView = false;
    this.scrollPadding = 0;
  }
  setDescribedBy() {
    let modal = this.modal ? 'modal' : '';
    this.describedByValue = this.config.blurb || this.config.blurbTemplate ? this.config.elementId + modal + '-blurb' : null;
  }
  fieldInit() {
    this.placeholder = this.translate.instant(this.placeholder);
    super.fieldInit();
  }
  setupHierpicklistWidget() {
    this.widgetConfig = {
      multiple: this.multiple,
      id: this.id,
      templateType: 'janus',
      parentSelectable: this.parentSelectable,
      defaultLabel: this.config.label,
      autoScrollWhenInit: !this.multiple,
      showSearchFieldOnDesktop: false
    };
  }
  closePicklist(e = undefined) {
    this.activeInputField = false;
    this.showDropdownList = false;
    this.widgetSearch = '';
    setTimeout(() => {
      if (this.isMobileView) {
        this.mobileButton.nativeElement.focus();
      } else {
        this.widgetElm.nativeElement.focus();
      }
    }, 10);
  }
  openPicklist(e) {
    super.openPicklist(e);
    setTimeout(() => {
      const closestScrollEl = this.dropdown.nativeElement.closest('.approval-overlay-container') || this.dropdown.nativeElement.closest('.modal-body') || this.dropdown.nativeElement.closest('.maincol');
      if (closestScrollEl) {
        let listBottom = this.dropdown.nativeElement.getBoundingClientRect().bottom;
        let scrollElBottom = closestScrollEl.getBoundingClientRect().bottom;
        if (listBottom > scrollElBottom) {
          closestScrollEl.scrollBy({
            left: 0,
            top: listBottom - scrollElBottom + 5,
            behavior: 'smooth'
          });
        }
      }
    }, 100);
  }
  clearSearch() {
    setTimeout(() => {
      if (this.isSingleSelectorSelected()) {
        this.save([]);
      }
      this.clearValue(true);
      let field = this.widgetElm;
      if (this.activeInputField) {
        field = this.inputFieldElm;
      } else if (this.isMobileView) {
        field = this.mobileButton;
      }
      field?.nativeElement?.focus();
    }, this.clickEventDelay);
  }
  hpWidgetNavigationUpdates(e) {
    super.hpWidgetNavigationUpdates(e);
    if (this.showDropdownList) {
      this.setScrollAdjustment();
    }
  }
  hpWidgetStatesUpdates(states) {
    if (this.showDropdownList && this.isMobileView !== states.mobileView) {
      this.setScrollAdjustment();
    }
    this.isMobileView = states.mobileView;
    this.widgetConfig.hideSearchField = !states.mobileView;
    this.cdRef.detectChanges();
  }
  focusSearchField() {
    if (this.isMobileView) {
      this.hpWidget.searchField?.nativeElement?.focus();
    } else {
      super.focusSearchField();
    }
  }
  setScrollAdjustment() {
    setTimeout(() => {
      if (!this.showDropdownList) {
        return;
      }
      const hpWidgetElements = this.hpWidget.getElements();
      this.scrollPadding = hpWidgetElements.header?.clientHeight || 0;
    }, 10);
  }
  escapeDropdownList(event) {
    if (this.isMobileView) {
      this.closePicklist(event);
    } else {
      this.inputFieldElm.nativeElement.focus();
    }
  }
  shouldSkipDropdownClose(e) {
    return !(e.target instanceof HTMLElement) || !this.isMobileView && !this.activeInputField && !this.showDropdownList;
  }
  backwardFromRootAction(states) {
    if (!this.isMobileView) {
      super.backwardFromRootAction(states);
    }
  }
  getSelectedFirstItemName() {
    const selected = !this.multiple && !_.isEmpty(this.selects) ? this.selects[0].value : '';
    return selected ? selected : this.placeholder ? this.placeholder : '';
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormHierpicklistComponent_BaseFactory;
      return function JanusFormHierpicklistComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormHierpicklistComponent_BaseFactory || (ɵJanusFormHierpicklistComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormHierpicklistComponent)))(__ngFactoryType__ || JanusFormHierpicklistComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormHierpicklistComponent,
      selectors: [["janus-form-hierpicklist"]],
      viewQuery: function JanusFormHierpicklistComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$x, 5);
          i0.ɵɵviewQuery(_c1$q, 5, hierarchicalListWidgetComponent);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.mobileButton = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hpWidget = _t.first);
        }
      },
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 1,
      consts: [["chipListTemplate", ""], ["content", ""], ["mobileButton", ""], ["widget", ""], ["inputField", ""], ["dropdown", ""], ["hpWidget", ""], ["chipList", ""], ["class", "janus-field picklist-widget", 3, "ngClass", 4, "ngIf"], [1, "janus-field", "picklist-widget", 3, "ngClass"], ["class", "form-label", 4, "ngIf"], [1, "field-widget"], ["class", "form-text", 3, "id", "innerHTML", 4, "ngIf"], [3, "id", 4, "ngIf"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], [4, "ngIf"], [1, "picklist-container", "position-relative"], ["type", "button", 1, "d-sm-none", "d-block", "w-100", "btn", "btn-outline-secondary"], ["type", "button", 1, "form-control", "d-flex", "d-sm-none", "text-start", "align-items-center", "pe-12"], [1, "form-label"], [3, "hasError", "isRequired"], [1, "form-text", 3, "id", "innerHTML"], [3, "id"], [4, "ngTemplateOutlet"], ["role", "alert", 1, "invalid-feedback"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [3, "ngTemplateOutlet"], ["type", "button", 1, "d-sm-none", "d-block", "w-100", "btn", "btn-outline-secondary", 3, "click"], ["type", "button", 1, "form-control", "d-flex", "d-sm-none", "text-start", "align-items-center", "pe-12", 3, "click", "keydown.enter", "keydown.space"], [1, "text-start", "w-100", "picklist-selected-text", "text-truncate"], ["type", "button", 1, "bg-transparent", "border-0", "p-1"], ["type", "text", 1, "invisible", "border-0", "p-0", 2, "width", "1px"], [1, "d-flex", "align-items-center", "position-absolute", "bg-transparent", "end-0", "me-6"], ["width", "1.125rem", "height", "1.125rem"], ["type", "button", 1, "bg-transparent", "border-0", "p-1", 3, "click", "keydown.enter", "keydown.space"], [1, "d-flex", "align-items-center"], ["width", "1rem", "height", "1rem", 1, "filter-remove"], [1, "form-control", "d-none", "d-sm-inline-flex", "ps-6", "pe-3", "filter-toggle", "filter-drop", "d-inline-flex", "align-items-center", 3, "click", "keydown.enter", "keydown.space"], ["type", "button", "class", "bg-transparent border-0 p-1 flex-shrink-0", 3, "click", "keydown.enter", "keydown.space", 4, "ngIf"], [1, "me-n2", "px-1", "d-flex", "align-items-center", "flex-shrink-0"], ["type", "button", 1, "bg-transparent", "border-0", "p-1", "flex-shrink-0", 3, "click", "keydown.enter", "keydown.space"], [1, "btn", "border", "border-gray-400", "p-0", "filter-toggle", "filter-drop", "d-none", "d-sm-inline-flex", "align-items-center", "w-100", "position-relative"], ["type", "text", 1, "picklist-field", "picklist-search-input", "border-0", "w-100", "form-control", 3, "ngModelChange", "keydown", "ngModel", "ngModelOptions", "placeholder"], ["type", "button", "class", "position-absolute bg-transparent border-0 end-0 p-2 pe-10 me-12 flex-shrink-0", 3, "mousedown", "keydown.enter", "keydown.space", 4, "ngIf"], [1, "d-flex", "align-items-center", "position-absolute", "bg-transparent", "end-0", "me-6", "flex-shrink-0"], ["type", "button", 1, "position-absolute", "bg-transparent", "border-0", "end-0", "p-2", "pe-10", "me-12", "flex-shrink-0", 3, "mousedown", "keydown.enter", "keydown.space"], [1, "picklist-dropdown", "dropdown-menu-avoid-bs-js", "d-block", "filter-menu", "pb-0", "pt-0", "show", "overflow-auto", 3, "ngClass"], [3, "config", "list", "values", "search"], [3, "selection", "searchChanged", "navigationChanged", "statesChanged", "keydown.escape", "config", "list", "values", "search"], ["class", "badge-group", 3, "ngClass", 4, "ngIf"], [1, "badge-group", 3, "ngClass"], ["role", "listbox", "aria-atomic", "true", "cdkListbox", "", 1, "list-unstyled", "d-flex", "flex-wrap", "gap-1", "mb-2", "mt-2", 3, "keydown", "cdkListboxOrientation"], [3, "cdkOption", 4, "ngFor", "ngForOf"], [3, "cdkOption"], ["type", "button", "aria-selected", "true", "role", "option", "tabindex", "-1", "aria-hidden", "true", 1, "btn", "d-inline-flex", "badge", "minw-0", "text-wrap", "text-start", 3, "click", "ngClass"], [1, "d-flex", "align-items-center", "btn-close", "ms-2", "me-0", "p-0", "flex-shrink-0", 3, "ngClass"]],
      template: function JanusFormHierpicklistComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormHierpicklistComponent_div_0_Template, 15, 19, "div", 8)(1, JanusFormHierpicklistComponent_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, hierarchicalListWidgetComponent, i6.CdkListbox, i6.CdkOption, JanusRequiredComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: [".form-select.disabled{background-color:var(--bs-secondary-bg)}.mobile-visible-only{visibility:hidden}.mobile-view-fullsize .picklist-dropdown{position:fixed;top:0;left:0;width:100vw;height:100vh;max-height:100vh;margin:0!important;z-index:1040}.mobile-view-fullsize .mobile-visible-only{visibility:visible}.mobile-view-fullsize .dropdown-menu-avoid-bs-js{max-width:100vw}.hp-inner-header{position:sticky!important;top:0;background-color:#fff;z-index:1}.picklist-item-list li:not([aria-disabled=true]){cursor:pointer}.picklist-item-list li:not([aria-disabled=true]) label{cursor:pointer}.picklist-container .picklist-dropdown{min-width:20rem;max-width:31.25rem;max-height:31rem}@media screen and (max-width: 576px){.picklist-container .picklist-dropdown{min-width:100%;max-width:100%}}.picklist-container .picklist-selected-text{height:1.5em}.next-button{min-width:auto}.next-button:hover{background-color:var(--bs-gray-300)}.dropdown-menu-avoid-bs-js{--bs-dropdown-zindex: 1000;--bs-dropdown-min-width: 12.5rem;--bs-dropdown-padding-x: 0;--bs-dropdown-padding-y: .5rem;--bs-dropdown-spacer: .25rem;--bs-dropdown-font-size: 1rem;--bs-dropdown-color: var(--bs-body-color);--bs-dropdown-bg: var(--bs-body-bg);--bs-dropdown-border-color: rgb(236, 236, 236);--bs-dropdown-border-radius: .188rem;--bs-dropdown-border-width: var(--bs-border-width);--bs-dropdown-inner-border-radius: calc(.188rem - var(--bs-border-width));--bs-dropdown-divider-bg: rgb(236, 236, 236);--bs-dropdown-divider-margin-y: .5rem;--bs-dropdown-box-shadow: 0 .125rem .375rem rgba(0, 0, 0, .3);--bs-dropdown-link-color: var(--bs-body-color);--bs-dropdown-link-hover-color: var(--bs-body-color);--bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);--bs-dropdown-link-active-color: rgb(255, 255, 255);--bs-dropdown-link-active-bg: rgb(14, 98, 185);--bs-dropdown-link-disabled-color: var(--bs-tertiary-color);--bs-dropdown-item-padding-x: 1.25rem;--bs-dropdown-item-padding-y: .375rem;--bs-dropdown-header-color: rgb(69, 69, 69);--bs-dropdown-header-padding-x: 1.25rem;--bs-dropdown-header-padding-y: .5rem;position:absolute;z-index:var(--bs-dropdown-zindex);display:none;min-width:var(--bs-dropdown-min-width);padding:var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);margin:0;font-size:var(--bs-dropdown-font-size);color:var(--bs-dropdown-color);text-align:left;list-style:none;background-color:var(--bs-dropdown-bg);background-clip:padding-box;border:var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);border-radius:var(--bs-dropdown-border-radius);box-shadow:var(--bs-dropdown-box-shadow)}.dropdown-menu-avoid-bs-js.show{display:block!important}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormHierpicklistComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-hierpicklist',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"janus-field picklist-widget\" *ngIf=\"!config.hideField\" [attr.id]=\"id\" [ngClass]=\"{'is-invalid': !control.valid && (control.dirty || control.touched), 'last': config.lastChild, 'mb-4': !config.lastChild, 'pe-none': control.disabled}\">\n    <label class=\"form-label\" *ngIf=\"!hideLabel\" [attr.id]=\"id + '-label'\" [attr.aria-required]=\"isRequired\">\n        {{ config.label | translate }}<janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\"></janus-required>\n    </label>\n    <div class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div *ngIf=\"config.blurbTemplate && !config.blurb\" id=\"{{describedByValue}}\">\n            <ng-container *ngTemplateOutlet=\"config.blurbTemplate\"></ng-container>\n        </div>\n        <div class=\"invalid-feedback\" role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n            <div *ngIf=\"control.errors.required\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                </svg>\n                {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n            </div>\n        </div>\n\n        <ng-template *ngIf=\"!hideChipList && chipListPosition === 'top'\" [ngTemplateOutlet]=\"chipListTemplate\"></ng-template>\n        \n        <div #content class=\"picklist-container position-relative\" [class.mobile-view-fullsize]=\"isMobileView\">\n            @if (config.multiple) {\n                <button #mobileButton\n                        type=\"button\"\n                        class=\"d-sm-none d-block w-100 btn btn-outline-secondary\"\n                        (click)=\"openDropdown($event)\"\n                        [attr.aria-expanded]=\"showDropdownList || alwaysShowDropdownList\"\n                >\n                    @if (config.customAddButtonLabel) {\n                        {{ config.customAddButtonLabel | translate }}\n                    } @else {\n                        {{ 'misc.Add' | translate }}\n                    }\n                </button>\n            } @else {\n                <button #mobileButton\n                        type=\"button\"\n                        class=\"form-control d-flex d-sm-none text-start align-items-center pe-12\"\n                        (click)=\"openDropdown($event)\"\n                        (keydown.enter)=\"openDropdown($event);\"\n                        (keydown.space)=\"openDropdown($event);\"\n                >\n                    <span [attr.id]=\"id + '-selected'\" class=\"text-start w-100 picklist-selected-text text-truncate\">\n                        {{ getSelectedFirstItemName() }}\n                    </span>\n                    @if (selects?.length) {\n                        <button\n                                type=\"button\"\n                                class=\"bg-transparent border-0 p-1\"\n                                [attr.aria-label]=\"'misc.Deselect' | translate\"\n                                (click)=\"$event.stopImmediatePropagation(); $event.preventDefault(); clearSearch();\"\n                                (keydown.enter)=\"$event.stopImmediatePropagation(); $event.preventDefault(); clearSearch()\"\n                                (keydown.space)=\"$event.stopImmediatePropagation(); $event.preventDefault(); clearSearch()\"\n                        >\n                            <span class=\"d-flex align-items-center\">\n                                <svg width=\"1rem\" height=\"1rem\" class=\"filter-remove\">\n                                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-x'\"></use>\n                                </svg>\n                            </span>\n                        </button>\n                    }\n                    <input type=\"text\" class=\"invisible border-0 p-0\" style=\"width: 1px\"/>\n                    \n                    <div class=\"d-flex align-items-center position-absolute bg-transparent end-0 me-6\">\n                        <svg width=\"1.125rem\" height=\"1.125rem\">\n                            <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-chevron-down'\"></use>\n                        </svg>\n                    </div>\n                </button>\n            }\n\n            <ng-container *ngIf=\"!activeInputField && !alwaysShowDropdownList\">\n                <div class=\"form-control d-none d-sm-inline-flex ps-6 pe-3 filter-toggle filter-drop d-inline-flex align-items-center\" \n                     #widget\n                     [attr.aria-labelledby]=\"id + '-label ' + id + '-selected'\"\n                     [attr.role]=\"'combobox'\"\n                     [attr.tabindex]=\"activeInputField || control.disabled ? -1 : 0\"\n                     [attr.aria-expanded]=\"activeInputField\"\n                     [attr.aria-describedby]=\"describedByValue\"\n                     (click)=\"openPicklist($event)\"\n                     (keydown.enter)=\"openPicklist($event)\"\n                     (keydown.space)=\"openPicklist($event)\"\n                >\n                    <span [attr.id]=\"id + '-selected'\" class=\"text-start w-100 picklist-selected-text text-truncate\">\n                        {{ getSelectedFirstItemName() }}\n                    </span>\n                    \n                    <button \n                            type=\"button\" \n                            class=\"bg-transparent border-0 p-1 flex-shrink-0\" \n                            *ngIf=\"!multiple && selects.length\" \n                            [attr.tabindex]=\"selects.length ? '0' : '-1'\"\n                            [attr.aria-label]=\"'misc.Deselect' | translate\"\n                            (click)=\"$event.stopImmediatePropagation(); $event.preventDefault(); clearSearch();\"\n                            (keydown.enter)=\"$event.stopImmediatePropagation(); $event.preventDefault(); clearSearch()\"\n                            (keydown.space)=\"$event.stopImmediatePropagation(); $event.preventDefault(); clearSearch()\"\n                    >\n                        <span class=\"d-flex align-items-center\">\n                            <svg width=\"1rem\" height=\"1rem\" class=\"filter-remove\">\n                                <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-x'\"></use>\n                            </svg>\n                        </span>\n                    </button>\n                    \n                    <div class=\"me-n2 px-1 d-flex align-items-center flex-shrink-0\">\n                        <svg width=\"1.125rem\" height=\"1.125rem\">\n                            <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-chevron-down'\"></use>\n                        </svg>\n                    </div>\n                </div>\n            </ng-container>\n\n            <ng-container *ngIf=\"activeInputField || alwaysShowDropdownList\">\n                <div class=\"btn border border-gray-400 p-0 filter-toggle filter-drop d-none d-sm-inline-flex align-items-center w-100 position-relative\">\n                    <input type=\"text\"\n                        #inputField\n                        class=\"picklist-field picklist-search-input border-0 w-100 form-control\"\n                        [(ngModel)]=\"search\"\n                        (ngModelChange)=\"searchChange($event)\"\n                        [ngModelOptions]=\"{ standalone: true }\"\n                        [placeholder]=\"placeholder | translate\"\n                        [attr.id]=\"id + '-search'\"\n                        [attr.aria-autocomplete]=\"'list'\"\n                        [attr.aria-expanded]=\"activeInputField\"\n                        [attr.aria-labelledby]=\"hideLabel ? null : id + '-label'\"\n                        [attr.aria-describedby]=\"describedByValue\"\n                        [attr.aria-owns]=\"id + '-list'\"\n                        [attr.role]=\"'combobox'\"\n                        [style.padding-left]=\"isRTL ? '4rem' : null\"\n                        [style.padding-right]=\"isRTL ? null : '4rem'\"\n                        (keydown)=\"formKeyNav($event)\"\n                    >\n                    <button \n                            type=\"button\" \n                            class=\"position-absolute bg-transparent border-0 end-0 p-2 pe-10 me-12 flex-shrink-0\" \n                            *ngIf=\"search\" \n                            [attr.aria-label]=\"'misc.Clear' | translate\" \n                            (mousedown)=\"$event.stopPropagation(); clearSearch();\" \n                            (keydown.enter)=\"clearSearch();\"\n                            (keydown.space)=\"clearSearch();\"\n                    >\n                        <span class=\"d-flex align-items-center\">\n                            <svg width=\"1rem\" height=\"1rem\" class=\"filter-remove\">\n                            <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-x'\"></use>\n                            </svg>\n                        </span>\n                    </button>\n                    <div class=\"d-flex align-items-center position-absolute bg-transparent end-0 me-6 flex-shrink-0\">\n                        <svg width=\"1.125rem\" height=\"1.125rem\">\n                            <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-chevron-down'\"></use>\n                        </svg>\n                    </div>\n                </div>\n            </ng-container>\n            \n            <ng-container *ngIf=\"showDropdownList || alwaysShowDropdownList\">\n                <div #dropdown \n                     class=\"picklist-dropdown dropdown-menu-avoid-bs-js d-block filter-menu pb-0 pt-0 show overflow-auto\"\n                     [style.scroll-padding.px]=\"scrollPadding\"\n                     [ngClass]=\"{\n                        'filtering': isSearching(),\n                        'position-fixed top-0 start-0 min-vh-100 vw-100': isMobileView,\n                        'mt-1': !isMobileView,\n                     }\"\n                >\n                    @if (widgetConfig && widgetList) {\n                        <hierarchical-list-widget #hpWidget\n                                                  [config]=\"widgetConfig\"\n                                                  [list]=\"widgetList\"\n                                                  [values]=\"widgetSelects\"\n                                                  [search]=\"widgetSearch\"\n                                                  (selection)=\"hpWidgetSelectionUpdates($event)\"\n                                                  (searchChanged)=\"hpWidgetSearchUpdates($event)\"\n                                                  (navigationChanged)=\"hpWidgetNavigationUpdates($event)\"\n                                                  (statesChanged)=\"hpWidgetStatesUpdates($event)\"\n                                                  (keydown.escape)=\"escapeDropdownList($event)\"\n                        ></hierarchical-list-widget>\n                    }\n                </div>\n            </ng-container>\n        </div>\n\n        <ng-template *ngIf=\"!hideChipList && chipListPosition === 'bottom'\" [ngTemplateOutlet]=\"chipListTemplate\"></ng-template>\n    </div>\n</div>\n\n<ng-template #chipListTemplate>\n    <div *ngIf=\"selects?.length\" class=\"badge-group\" [ngClass]=\"{'d-none': !multiple}\">\n        <ul class=\"list-unstyled d-flex flex-wrap gap-1 mb-2 mt-2\"\n            #chipList\n            role=\"listbox\"\n            aria-atomic=\"true\"\n            [attr.aria-label]=\"'misc.Selected options:' | translate\"\n            [attr.aria-live]=\"activeInputField ? 'polite' : 'off'\"\n\n            cdkListbox\n            [cdkListboxOrientation]=\"'horizontal'\"\n            (keydown)=\"chipNav($event)\"\n        >\n            <li *ngFor=\"let select of selects; index as idx\"\n                [cdkOption]=\"select\"\n                [attr.aria-selected]=\"true\"\n                [attr.aria-label]=\"'misc.Item - Remove' | translate : {item: getItemLabel(select)}\"\n            >\n                <button\n                        type=\"button\"\n                        class=\"btn d-inline-flex badge minw-0 text-wrap text-start\"\n                        aria-selected=\"true\"\n                        role=\"option\"\n                        tabindex=\"-1\" \n                        aria-hidden=\"true\"\n                        [attr.aria-label]=\"'misc.Item - Remove' | translate : {item: getItemLabel(select) }\" \n                        [ngClass]=\"{'text-white bg-primary': activeInputField, 'text-dark bg-light': !activeInputField}\"\n                        (click)=\"removeSelect(select)\"\n                >\n                    {{ getItemLabel(select) }}\n                    <span class=\"d-flex align-items-center btn-close ms-2 me-0 p-0 flex-shrink-0\" [ngClass]=\"{'btn-close-white': activeInputField}\"></span>\n                </button>\n            </li>\n        </ul>\n    </div>\n</ng-template>",
      styles: [".form-select.disabled{background-color:var(--bs-secondary-bg)}.mobile-visible-only{visibility:hidden}.mobile-view-fullsize .picklist-dropdown{position:fixed;top:0;left:0;width:100vw;height:100vh;max-height:100vh;margin:0!important;z-index:1040}.mobile-view-fullsize .mobile-visible-only{visibility:visible}.mobile-view-fullsize .dropdown-menu-avoid-bs-js{max-width:100vw}.hp-inner-header{position:sticky!important;top:0;background-color:#fff;z-index:1}.picklist-item-list li:not([aria-disabled=true]){cursor:pointer}.picklist-item-list li:not([aria-disabled=true]) label{cursor:pointer}.picklist-container .picklist-dropdown{min-width:20rem;max-width:31.25rem;max-height:31rem}@media screen and (max-width: 576px){.picklist-container .picklist-dropdown{min-width:100%;max-width:100%}}.picklist-container .picklist-selected-text{height:1.5em}.next-button{min-width:auto}.next-button:hover{background-color:var(--bs-gray-300)}.dropdown-menu-avoid-bs-js{--bs-dropdown-zindex: 1000;--bs-dropdown-min-width: 12.5rem;--bs-dropdown-padding-x: 0;--bs-dropdown-padding-y: .5rem;--bs-dropdown-spacer: .25rem;--bs-dropdown-font-size: 1rem;--bs-dropdown-color: var(--bs-body-color);--bs-dropdown-bg: var(--bs-body-bg);--bs-dropdown-border-color: rgb(236, 236, 236);--bs-dropdown-border-radius: .188rem;--bs-dropdown-border-width: var(--bs-border-width);--bs-dropdown-inner-border-radius: calc(.188rem - var(--bs-border-width));--bs-dropdown-divider-bg: rgb(236, 236, 236);--bs-dropdown-divider-margin-y: .5rem;--bs-dropdown-box-shadow: 0 .125rem .375rem rgba(0, 0, 0, .3);--bs-dropdown-link-color: var(--bs-body-color);--bs-dropdown-link-hover-color: var(--bs-body-color);--bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);--bs-dropdown-link-active-color: rgb(255, 255, 255);--bs-dropdown-link-active-bg: rgb(14, 98, 185);--bs-dropdown-link-disabled-color: var(--bs-tertiary-color);--bs-dropdown-item-padding-x: 1.25rem;--bs-dropdown-item-padding-y: .375rem;--bs-dropdown-header-color: rgb(69, 69, 69);--bs-dropdown-header-padding-x: 1.25rem;--bs-dropdown-header-padding-y: .5rem;position:absolute;z-index:var(--bs-dropdown-zindex);display:none;min-width:var(--bs-dropdown-min-width);padding:var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);margin:0;font-size:var(--bs-dropdown-font-size);color:var(--bs-dropdown-color);text-align:left;list-style:none;background-color:var(--bs-dropdown-bg);background-clip:padding-box;border:var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);border-radius:var(--bs-dropdown-border-radius);box-shadow:var(--bs-dropdown-box-shadow)}.dropdown-menu-avoid-bs-js.show{display:block!important}\n"]
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }],
    mobileButton: [{
      type: ViewChild,
      args: ["mobileButton", {
        static: false
      }]
    }],
    hpWidget: [{
      type: ViewChild,
      args: ["hpWidget", {
        static: false,
        read: hierarchicalListWidgetComponent
      }]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormHierpicklistComponent, {
    className: "JanusFormHierpicklistComponent",
    filePath: "janus/components/form-hierpicklist/janus-form-hierpicklist.component.ts",
    lineNumber: 14
  });
})();
const _c0$w = (a0, a1, a2) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2
});
const _c1$p = a0 => ({
  "visually-hidden": a0
});
const _c2$k = a0 => ({
  field_name: a0
});
function JanusFormSelectComponent_div_0_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Field is required", i0.ɵɵpureFunction1(5, _c2$k, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormSelectComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, JanusFormSelectComponent_div_0_div_6_div_1_Template, 5, 7, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function JanusFormSelectComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormSelectComponent_div_0_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormSelectComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, JanusFormSelectComponent_div_0_div_8_ng_container_1_Template, 1, 0, "ng-container", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.config.blurbTemplate);
  }
}
function JanusFormSelectComponent_div_0_ng_container_10_option_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r2 = ctx.$implicit;
    i0.ɵɵproperty("disabled", option_r2.disabled)("ngValue", option_r2.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r2.display ? option_r2.display : option_r2, " ");
  }
}
function JanusFormSelectComponent_div_0_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormSelectComponent_div_0_ng_container_10_option_1_Template, 2, 3, "option", 17);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r0.config.options));
  }
}
function JanusFormSelectComponent_div_0_ng_container_11_ng_container_3_option_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const opt_r3 = ctx.$implicit;
    const option_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("disabled", opt_r3.disabled)("ngValue", opt_r3.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", opt_r3.display ? opt_r3.display : option_r4, " ");
  }
}
function JanusFormSelectComponent_div_0_ng_container_11_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "optgroup");
    i0.ɵɵtemplate(2, JanusFormSelectComponent_div_0_ng_container_11_ng_container_3_option_2_Template, 2, 3, "option", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const option_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵattribute("label", option_r4.key);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", option_r4.value);
  }
}
function JanusFormSelectComponent_div_0_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "option", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, JanusFormSelectComponent_div_0_ng_container_11_ng_container_3_Template, 3, 2, "ng-container", 20);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "keyvalue");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngValue", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate((tmp_3_0 = ctx_r0.config.placeholder) !== null && tmp_3_0 !== undefined ? tmp_3_0 : " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(5, 5, i0.ɵɵpipeBind1(4, 3, ctx_r0.config.options), ctx_r0.originalOrder));
  }
}
function JanusFormSelectComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "label", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 5);
    i0.ɵɵtemplate(6, JanusFormSelectComponent_div_0_div_6_Template, 2, 1, "div", 6)(7, JanusFormSelectComponent_div_0_div_7_Template, 3, 6, "div", 7)(8, JanusFormSelectComponent_div_0_div_8_Template, 2, 2, "div", 8);
    i0.ɵɵelementStart(9, "select", 9);
    i0.ɵɵtemplate(10, JanusFormSelectComponent_div_0_ng_container_10_Template, 3, 3, "ng-container", 1)(11, JanusFormSelectComponent_div_0_ng_container_11_Template, 6, 8, "ng-container", 1);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(25, _c0$w, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild, !ctx_r0.config.lastChild))("formGroup", ctx_r0.group);
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue)("aria-labelledby", ctx_r0.config.elementId + (ctx_r0.modal ? "modal" : ""));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(29, _c1$p, ctx_r0.config.hideLabel));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 23, ctx_r0.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched))("isRequired", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurbTemplate && !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵproperty("formControlName", ctx_r0.config.name)("ngClass", ctx_r0.config.className || "");
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue)("aria-controls", ctx_r0.config.ariaControls ? ctx_r0.config.ariaControls : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.useGrouping);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.useGrouping);
  }
}
function JanusFormSelectComponent_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 22);
  }
  if (rf & 2) {
    const field_r5 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r5)("group", ctx_r0.group);
  }
}
function JanusFormSelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormSelectComponent_div_1_ng_container_1_Template, 1, 2, "ng-container", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.dependents);
  }
}
class JanusFormSelectComponent extends FormSelectComponent {
  constructor() {
    super(...arguments);
    this.assetsPath = '/app/assets/';
  }
  setDescribedBy() {
    let modal = this.modal ? 'modal' : '';
    this.describedByValue = this.config.blurb || this.config.blurbTemplate ? this.config.elementId + modal + '-blurb' : null;
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormSelectComponent_BaseFactory;
      return function JanusFormSelectComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormSelectComponent_BaseFactory || (ɵJanusFormSelectComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormSelectComponent)))(__ngFactoryType__ || JanusFormSelectComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormSelectComponent,
      selectors: [["janus-form-select"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 2,
      consts: [["class", "janus-field", 3, "ngClass", "formGroup", 4, "ngIf"], [4, "ngIf"], [1, "janus-field", 3, "ngClass", "formGroup"], [1, "form-label", 3, "for", "ngClass"], [3, "hasError", "isRequired"], [1, "field-widget"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], ["class", "form-text", 3, "id", "innerHTML", 4, "ngIf"], [3, "id", 4, "ngIf"], [1, "form-select", 3, "id", "formControlName", "ngClass"], ["role", "alert", 1, "invalid-feedback"], ["class", "field-error", 4, "ngIf"], [1, "field-error"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [1, "form-text", 3, "id", "innerHTML"], [3, "id"], [4, "ngTemplateOutlet"], [3, "disabled", "ngValue", 4, "ngFor", "ngForOf"], [3, "disabled", "ngValue"], [3, "ngValue"], [4, "ngFor", "ngForOf"], ["janusDynamicField", "", 3, "config", "group", 4, "ngFor", "ngForOf"], ["janusDynamicField", "", 3, "config", "group"]],
      template: function JanusFormSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormSelectComponent_div_0_Template, 12, 31, "div", 0)(1, JanusFormSelectComponent_div_1_Template, 2, 1, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.control.value && ctx.config.dependents);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormSelectComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-select',
      template: `
        <div
            *ngIf="!config.hideField"
            class="janus-field"
            [attr.aria-describedby]="describedByValue"
            [attr.aria-labelledby]="config.elementId + (modal ? 'modal' : '')"
            [ngClass]="{
                'is-invalid': !control.valid && (control.dirty || control.touched),
                'last': config.lastChild,
                'mb-4': !config.lastChild
            }"
            [formGroup]="group"
        >
            <label 
                for="{{ config.elementId }}{{ modal ? 'modal' :'' }}" 
                class="form-label"
                [ngClass]="{'visually-hidden': config.hideLabel}"
            >
                {{ config.label | translate }}<janus-required [hasError]="(!control.valid && (control.dirty || control.touched))" [isRequired]="isRequired"></janus-required>
            </label>
            <div class="field-widget">
                <div 
                    *ngIf="!control.valid && (control.dirty || control.touched)"
                    class="invalid-feedback"
                    role="alert"
                >
                    <div *ngIf="control.errors.required" class="field-error">
                        <svg width="1.25rem" height="1.25rem" class="mt-n1 me-1">
                            <use [attr.xlink:href]="assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'"></use>
                        </svg>
                        {{ 'misc.Field is required' | translate: { field_name: translatedLabel } }}
                    </div>
                </div>
                
                <div *ngIf="config.blurb" id="{{describedByValue}}" class="form-text" [innerHTML]="config.blurb | translate | safeHtml"></div>
                <div *ngIf="config.blurbTemplate && !config.blurb" id="{{describedByValue}}">
                    <ng-container *ngTemplateOutlet="config.blurbTemplate"></ng-container>
                </div>

                <select 
                    class="form-select" 
                    id="{{ config.elementId }}{{ modal ? 'modal' :'' }}"
                    [attr.aria-describedby]="describedByValue"
                    [attr.aria-controls]="config.ariaControls ? config.ariaControls : null"
                    [formControlName]="config.name"
                    [ngClass]="config.className || ''"
                >
                    <ng-container *ngIf=!useGrouping>
                        <option *ngFor="let option of config.options | async" [disabled]="option.disabled" [ngValue]="option.id">
                            {{ option.display ? option.display : option }}
                        </option>
                    </ng-container>
                    <ng-container *ngIf=useGrouping>
                        <option [ngValue]="undefined">{{config.placeholder ?? ' '}}</option>
                        <ng-container *ngFor="let option of config.options | async | keyvalue: originalOrder">
                            <optgroup [attr.label]="option.key">
                                <option *ngFor="let opt of option.value" [disabled]="opt.disabled" [ngValue]="opt.id">
                                    {{ opt.display ? opt.display : option }}
                                </option>
                            </optgroup>
                        </ng-container>
                    </ng-container>
                </select>
            </div>
        </div>
        <div *ngIf='control.value && config.dependents'>
            <ng-container *ngFor="let field of config.dependents" janusDynamicField [config]="field" [group]="group"></ng-container>
        </div>
    `,
      standalone: false
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormSelectComponent, {
    className: "JanusFormSelectComponent",
    filePath: "janus/components/form-select/janus-form-select.component.ts",
    lineNumber: 77
  });
})();
const _c0$v = (a0, a1, a2) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2
});
const _c1$o = a0 => ({
  "visually-hidden": a0
});
const _c2$j = a0 => ({
  "input-group": a0
});
const _c3$d = () => ({
  standalone: true
});
const _c4$c = a0 => ({
  field_name: a0
});
function JanusFormNumberComponent_div_0_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Field is required", i0.ɵɵpureFunction1(5, _c4$c, ctx_r1.translatedLabel)), " ");
  }
}
function JanusFormNumberComponent_div_0_div_6_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, ctx_r1.patternError), " ");
  }
}
function JanusFormNumberComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, JanusFormNumberComponent_div_0_div_6_div_1_Template, 5, 7, "div", 11)(2, JanusFormNumberComponent_div_0_div_6_div_2_Template, 5, 4, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors == null ? null : ctx_r1.control.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors == null ? null : ctx_r1.control.errors.pattern);
  }
}
function JanusFormNumberComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormNumberComponent_div_0_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormNumberComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, JanusFormNumberComponent_div_0_div_8_ng_container_1_Template, 1, 0, "ng-container", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.config.blurbTemplate);
  }
}
function JanusFormNumberComponent_div_0_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 17);
    i0.ɵɵpipe(1, "sanitizeInputHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.config.prefixClass)("innerHTML", i0.ɵɵpipeBind1(1, 2, ctx_r1.config.prefixText), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormNumberComponent_div_0_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 18);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function JanusFormNumberComponent_div_0_ng_container_14_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearValue($event));
    });
    i0.ɵɵelement(3, "i", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.control.value);
    i0.ɵɵattribute("aria-hidden", !ctx_r1.control.value)("aria-label", i0.ɵɵpipeBind1(2, 3, "misc.Clear"));
  }
}
function JanusFormNumberComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "label", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(5);
    i0.ɵɵtemplate(6, JanusFormNumberComponent_div_0_div_6_Template, 3, 2, "div", 5)(7, JanusFormNumberComponent_div_0_div_7_Template, 3, 6, "div", 6)(8, JanusFormNumberComponent_div_0_div_8_Template, 2, 2, "div", 7);
    i0.ɵɵelementStart(9, "div", 8);
    i0.ɵɵtemplate(10, JanusFormNumberComponent_div_0_div_10_Template, 2, 4, "div", 9);
    i0.ɵɵelementStart(11, "input", 10, 0);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function JanusFormNumberComponent_div_0_Template_input_ngModelChange_11_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.inputValue, $event) || (ctx_r1.inputValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function JanusFormNumberComponent_div_0_Template_input_ngModelChange_11_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.submit($event));
    })("blur", function JanusFormNumberComponent_div_0_Template_input_blur_11_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.markAsTouched();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("blur", $event));
    })("keypress", function JanusFormNumberComponent_div_0_Template_input_keypress_11_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.checkKeyValid($event);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("keypress", $event));
    })("paste", function JanusFormNumberComponent_div_0_Template_input_paste_11_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.checkPasteValid($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, JanusFormNumberComponent_div_0_ng_container_14_Template, 4, 5, "ng-container", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(31, _c0$v, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild, !ctx_r1.config.lastChild))("formGroup", ctx_r1.group);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(35, _c1$o, ctx_r1.config.hideLabel));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 27, ctx_r1.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched))("isRequired", ctx_r1.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurbTemplate && !ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(37, _c2$j, ctx_r1.config.prefixText));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.prefixText);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("form-control ", ctx_r1.config.className, "");
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.inputValue);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(39, _c3$d))("disabled", ctx_r1.control.disabled);
    i0.ɵɵattribute("placeholder", i0.ɵɵpipeBind1(13, 29, ctx_r1.config.placeholder))("aria-describedby", ctx_r1.describedByValue)("aria-required", ctx_r1.isRequired);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.config.clearButton);
  }
}
class JanusFormNumberComponent extends JanusFormInputComponent {
  constructor() {
    super(...arguments);
    this.minus = '-';
    this.decimal = '.';
    this.specialKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete', this.minus, this.decimal];
    this.allowNegative = true;
    this.allowFloat = true;
    this.allowEmpty = false;
  }
  configuration() {
    this.allowEmpty = this.config.allowEmpty;
    this.allowNegative = !!this.config.allowNegative;
    this.allowFloat = !!this.config.allowFloat;
    if (this.config.value) {
      this.inputValue = this.config.value;
    }
  }
  isNumericString(val) {
    return !isNaN$1(Number(val));
  }
  checkPasteValid(event) {
    this.markAsTouched();
    let value = event.clipboardData.getData('text/plain');
    if (!value || !this.isNumericString(value)) {
      event.preventDefault();
    }
  }
  checkKeyValid(event) {
    if (!this.isValidCharacter(event)) {
      event.preventDefault();
    }
  }
  isValidCharacter(evt) {
    const isSpecialKey = this.specialKeys.indexOf(evt.key) !== -1;
    const isNumber = /^[0-9]*$/.test(evt.key);
    let valid = true;
    let invalidKey = false;
    if (evt.key === this.minus) {
      if (this.allowNegative) {
        invalidKey = evt.target.selectionStart > 0;
      } else {
        invalidKey = true;
      }
    }
    if (evt.key === this.decimal) {
      if (this.allowFloat) {
        invalidKey = evt.target.value.indexOf('.') > -1;
      } else {
        invalidKey = true;
      }
    }
    if (!(isSpecialKey || isNumber) || invalidKey) {
      valid = false;
    }
    return valid;
  }
  submit(value) {
    this.markAsTouched();
    let reg = new RegExp("[^0-9" + this.decimal + this.minus + "]", 'g');
    if (isEmpty(value)) {
      this.updateValue(value);
    } else if (value && !value.match(reg)) {
      this.updateValue(value.replace(reg, ''));
    }
    if (value === this.decimal) {
      this.updateValue('0' + this.decimal);
    }
  }
  updateValue(value) {
    setTimeout(() => {
      this.inputValue = value;
      const numValue = value === '-' || value.lastIndexOf('-') > 0 ? undefined : +value;
      if (this.allowEmpty && value === "") {
        this.control.setValue(null);
      } else {
        this.control.setValue(numValue);
      }
    });
  }
  markAsTouched() {
    if (this.control.untouched) {
      this.control.markAsTouched();
    }
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormNumberComponent_BaseFactory;
      return function JanusFormNumberComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormNumberComponent_BaseFactory || (ɵJanusFormNumberComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormNumberComponent)))(__ngFactoryType__ || JanusFormNumberComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormNumberComponent,
      selectors: [["janus-form-number"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["inputField", ""], ["class", "janus-field", 3, "ngClass", "formGroup", 4, "ngIf"], [1, "janus-field", 3, "ngClass", "formGroup"], [1, "form-label", 3, "ngClass", "for"], [3, "hasError", "isRequired"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], ["class", "form-text", 3, "id", "innerHTML", 4, "ngIf"], [3, "id", 4, "ngIf"], [3, "ngClass"], [3, "ngClass", "innerHTML", 4, "ngIf"], ["type", "text", "inputmode", "numeric", 3, "ngModelChange", "blur", "keypress", "paste", "ngModel", "ngModelOptions", "disabled", "id"], [4, "ngIf"], ["role", "alert", 1, "invalid-feedback"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [1, "form-text", 3, "id", "innerHTML"], [3, "id"], [4, "ngTemplateOutlet"], [3, "ngClass", "innerHTML"], [1, "clearBtn", 3, "click", "hidden"], [1, "icn-close"]],
      template: function JanusFormNumberComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormNumberComponent_div_0_Template, 15, 40, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.NgModel, i2$1.FormGroupDirective, JanusRequiredComponent, i1$1.TranslatePipe, SanitizeHtmlPipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormNumberComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-number',
      template: `
        <div class="janus-field" *ngIf="!config.hideField" [ngClass]="{'is-invalid': !control.valid && (control.dirty || control.touched), 'last': config.lastChild, 'mb-4': !config.lastChild}" [formGroup]="group">
            <label [ngClass]="{'visually-hidden': config.hideLabel}" for="{{config.elementId}}{{modal?'modal':''}}" class="form-label">
                {{config.label | translate}}<janus-required [hasError]="(!control.valid && (control.dirty || control.touched))" [isRequired]="isRequired"></janus-required>
            </label>
            <ng-container>
                <div class="invalid-feedback" role="alert" *ngIf="(!control.valid && (control.dirty || control.touched))">
                    <div *ngIf="control.errors?.required">
                        <svg width="1.25rem" height="1.25rem" class="mt-n1 me-1">
                            <use [attr.xlink:href]="assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'"></use>
                        </svg>
                        {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}
                    </div>
                    <div *ngIf="control.errors?.pattern">
                        <svg width="1.25rem" height="1.25rem" class="mt-n1 me-1">
                            <use [attr.xlink:href]="assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'"></use>
                        </svg>
                        {{patternError | translate}}
                    </div>
                </div>
                <div *ngIf="config.blurb" id="{{describedByValue}}" class="form-text" [innerHTML]="config.blurb | translate | safeHtml"></div>
                <div *ngIf="config.blurbTemplate && !config.blurb" id="{{describedByValue}}">
                    <ng-container *ngTemplateOutlet="config.blurbTemplate"></ng-container>
                </div>
                <div [ngClass]="{ 'input-group': config.prefixText }">
                    <div *ngIf="config.prefixText" [ngClass]="config.prefixClass" [innerHTML]="config.prefixText | sanitizeInputHtml"></div>
                    <input
                            #inputField
                            type="text"
                            inputmode="numeric"
                            [(ngModel)]="inputValue"
                            (ngModelChange)="submit($event)"
                            [ngModelOptions]="{standalone: true}"
                            [disabled]="control.disabled"
                            [attr.placeholder]="config.placeholder | translate"
                            id="{{config.elementId}}{{modal?'modal':''}}"
                            [attr.aria-describedby]="describedByValue"
                            [attr.aria-required]="isRequired"
                            (blur)="markAsTouched(); triggerEvent('blur', $event);"
                            (keypress)="checkKeyValid($event); triggerEvent('keypress', $event);"
                            (paste)="checkPasteValid($event)"
                            class="form-control {{config.className}}" />
                    <ng-container *ngIf="config.clearButton">
                        <button class="clearBtn" (click)="clearValue($event)" [hidden]="!this.control.value" [attr.aria-hidden]="!this.control.value" [attr.aria-label]="'misc.Clear' | translate">
                            <i class="icn-close"></i>
                        </button>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    `,
      standalone: false
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormNumberComponent, {
    className: "JanusFormNumberComponent",
    filePath: "janus/components/form-number/janus-form-number.component.ts",
    lineNumber: 60
  });
})();
const CLOSEST_SCROLL_CONTAINER_LIST = new InjectionToken('List of classes to find closest to some widgets to track it and scroll when needed');
const _c0$u = (a0, a1, a2, a3) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2,
  "pe-none": a3
});
const _c1$n = a0 => ({
  field_name: a0
});
const _c2$i = a0 => ({
  format: a0
});
function JanusFormDatePickerComponent_div_0_div_5_div_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$n, ctx_r1.translatedLabel)), " ");
  }
}
function JanusFormDatePickerComponent_div_0_div_5_div_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Date must be in {format} format.", i0.ɵɵpureFunction1(4, _c2$i, ctx_r1.config.format || ctx_r1.localeData._longDateFormat.L)), " ");
  }
}
function JanusFormDatePickerComponent_div_0_div_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 13);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, JanusFormDatePickerComponent_div_0_div_5_div_1_ng_container_4_Template, 3, 6, "ng-container", 1)(5, JanusFormDatePickerComponent_div_0_div_5_div_1_ng_container_5_Template, 3, 6, "ng-container", 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors == null ? null : ctx_r1.control.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors == null ? null : ctx_r1.control.errors.dateFormat);
  }
}
function JanusFormDatePickerComponent_div_0_div_5_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormDatePickerComponent_div_0_div_5_div_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormDatePickerComponent_div_0_div_5_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, JanusFormDatePickerComponent_div_0_div_5_div_3_ng_container_1_Template, 1, 0, "ng-container", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.config.blurbTemplate);
  }
}
function JanusFormDatePickerComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, JanusFormDatePickerComponent_div_0_div_5_div_1_Template, 6, 3, "div", 7)(2, JanusFormDatePickerComponent_div_0_div_5_div_2_Template, 3, 6, "div", 8)(3, JanusFormDatePickerComponent_div_0_div_5_div_3_Template, 2, 2, "div", 9);
    i0.ɵɵelementStart(4, "duet-date-picker", 10);
    i0.ɵɵlistener("duetBlur", function JanusFormDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetBlur_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      ctx_r1.checkFieldValueValid($event);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("blur", $event));
    })("duetChange", function JanusFormDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetChange_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectDate($event));
    })("duetFocus", function JanusFormDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetFocus_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("focus", $event));
    })("duetOpen", function JanusFormDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetOpen_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("open", $event));
    })("duetClose", function JanusFormDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetClose_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("close", $event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurbTemplate && !ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dateAdapter", ctx_r1.dateAdapter)("localization", ctx_r1.pickerLocalization)("value", ctx_r1.config.value)("identifier", ctx_r1.config.elementId)("disabled", ctx_r1.config.disabled)("firstDayOfWeek", ctx_r1.properties == null ? null : ctx_r1.properties.firstDayOfWeek)("max", ctx_r1.properties == null ? null : ctx_r1.properties.max)("min", ctx_r1.properties == null ? null : ctx_r1.properties.min)("name", ctx_r1.properties == null ? null : ctx_r1.properties.name)("role", (ctx_r1.properties == null ? null : ctx_r1.properties.role) || "datepicker")("dateFormat", ctx_r1.config.dateFormat)("disabled", ctx_r1.control.disabled);
  }
}
function JanusFormDatePickerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "label", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, JanusFormDatePickerComponent_div_0_div_5_Template, 5, 15, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.group)("ngClass", i0.ɵɵpureFunction4(13, _c0$u, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild, !ctx_r1.config.lastChild, ctx_r1.control.disabled));
    i0.ɵɵattribute("aria-labelledby", ctx_r1.config.elementId)("aria-describedby", ctx_r1.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("visually-hidden", ctx_r1.config.hideLabel);
    i0.ɵɵpropertyInterpolate("for", ctx_r1.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 11, ctx_r1.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched))("isRequired", ctx_r1.isRequired);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.readyToLoad);
  }
}
function JanusFormDatePickerComponent_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 18);
  }
  if (rf & 2) {
    const field_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r3)("group", ctx_r1.group);
  }
}
function JanusFormDatePickerComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormDatePickerComponent_div_1_ng_container_1_Template, 1, 2, "ng-container", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.dependents);
  }
}
class JanusFormDatePickerComponent extends JanusFormInputComponent {
  constructor(translate, elementRef, cdr, janusVersion, closestScrollContainerList) {
    super(translate);
    this.translate = translate;
    this.elementRef = elementRef;
    this.cdr = cdr;
    this.janusVersion = janusVersion;
    this.closestScrollContainerList = closestScrollContainerList;
    this.locale = this.getLocale();
    this.localeData = moment$1.localeData(this.locale);
    this.dateFormat = 'YYYY-MM-DD';
    this.userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.readyToLoad = false;
    this.properties = {};
    defineCustomElements(window);
  }
  ngOnInit() {
    super.ngOnInit();
    this.init();
  }
  init() {
    if (this.config.format) {
      this.dateFormat = this.config.format;
    } else if (this.config.useLocaleFormat || this.janusVersion === 1) {
      this.dateFormat = this.localeData._longDateFormat.L;
    }
    this.translate.get('misc.Close').pipe(take(1)).subscribe(res => {
      this.dateAdapter = this.getDateAdapter(this);
      this.pickerLocalization = this.getLocalization();
      this.readyToLoad = true;
      this.setup();
    });
  }
  setup() {
    if (!isEmpty(this.config.properties)) {
      for (let pkey in this.config.properties) {
        if (!['value', 'dateAdapter', 'required'].includes(pkey)) {
          this.properties[pkey] = this.config.properties[pkey];
        }
      }
    }
    this.properties.required = this.isRequired;
  }
  getDateAdapter(component) {
    const _this = component;
    return {
      parse(date, createDate) {
        if (!date) {
          return;
        }
        const dateData = moment$1(date, _this.dateFormat).tz(_this.userTimezone);
        if (_this.checkDateFormatValid(date)) {
          return createDate(dateData.format('YYYY'), dateData.format('MM'), dateData.format('DD'));
        }
      },
      format(date) {
        const dateData = moment$1(date, _this.dateFormat).tz(_this.userTimezone);
        return dateData.format(_this.dateFormat);
      }
    };
  }
  selectDate(e, control = this.control) {
    control.setValue(e.detail.value);
    this.triggerEvent('change', {
      ...e,
      control: control
    });
  }
  triggerEvent(action, event) {
    if (action === 'open' && this.closestScrollContainerList) {
      const duetEl = event.target;
      const duetDropdown = duetEl.querySelector('.duet-date__dialog-content');
      const closestScrollEl = this.closestScrollContainerList.map(selector => duetEl.closest(selector)).find(Boolean);
      if (closestScrollEl) {
        const duetBottom = duetDropdown.getBoundingClientRect().bottom;
        const scrollElBottom = closestScrollEl.getBoundingClientRect().bottom;
        if (duetBottom > scrollElBottom) {
          closestScrollEl.scrollBy({
            left: 0,
            top: duetBottom - scrollElBottom + 5,
            behavior: 'smooth'
          });
        }
      }
    }
    super.triggerEvent(action, event);
  }
  checkDateFormatValid(date) {
    let momentDate = moment$1(date, this.dateFormat, true);
    return momentDate.isValid();
  }
  checkFieldValueValid(e) {
    setTimeout(() => {
      const dialog = document.querySelector(".duet-date__dialog.is-active");
      if (!dialog) {
        let value = e.target.querySelector('input').value;
        if (value && !this.checkDateFormatValid(value)) {
          this.control.setErrors({
            dateFormat: true
          });
        }
        this.control.markAsTouched();
      }
    }, 100);
  }
  getLocale() {
    let locale = window.LOCALE || 'en-US';
    const data = {
      'en-US': ['en', 'en_us'],
      'pt-BR': ['pt', 'pt_br'],
      'ar-SA': ['ar', 'ar_sa'],
      'fr-FR': ['fr', 'fr_fr'],
      'he-IL': ['he', 'he_il'],
      'es-419': ['es', 'es_419']
    };
    for (let key in data) {
      if (data[key].includes(locale.toLowerCase())) {
        locale = key;
        break;
      }
    }
    return locale;
  }
  getPlaceholder(idx = undefined) {
    let placeholder = this.config.placeholder;
    if (placeholder) {
      if (isNumber(idx) && Array.isArray(this.config.placeholder)) {
        placeholder = this.config.placeholder[idx];
      }
      placeholder = placeholder.replace('#{locale-format}', this.dateFormat);
    }
    return placeholder;
  }
  getLocalization(idx = undefined) {
    let localization = {
      buttonLabel: 'misc.Choose date',
      placeholder: this.getPlaceholder(idx) || this.dateFormat,
      selectedDateMessage: 'misc.Selected date is',
      prevMonthLabel: 'misc.Previous month',
      nextMonthLabel: 'misc.Next month',
      monthSelectLabel: 'misc.Month',
      yearSelectLabel: 'misc.Year',
      closeLabel: 'misc.Close window',
      calendarHeading: 'misc.Choose a date',
      dayNames: this.localeData.weekdays(),
      monthNames: this.localeData.months(),
      monthNamesShort: this.localeData.monthsShort()
    };
    Object.keys(localization).forEach(key => {
      if (!['dayNames', 'monthNames', 'monthNamesShort', 'placeholder'].includes(key)) {
        localization[key] = this.translate.instant(localization[key]);
      }
    });
    localization['locale'] = this.locale;
    return localization;
  }
  static {
    this.ɵfac = function JanusFormDatePickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusFormDatePickerComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject('JANUS_VERSION', 8), i0.ɵɵdirectiveInject(CLOSEST_SCROLL_CONTAINER_LIST, 8));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormDatePickerComponent,
      selectors: [["janus-form-datepicker"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 2,
      consts: [["class", "janus-field", "role", "group", 3, "formGroup", "ngClass", 4, "ngIf"], [4, "ngIf"], ["role", "group", 1, "janus-field", 3, "formGroup", "ngClass"], [1, "form-label", 3, "for"], [3, "hasError", "isRequired"], ["class", "field-widget", 4, "ngIf"], [1, "field-widget"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], ["class", "form-text", 3, "id", "innerHTML", 4, "ngIf"], [3, "id", 4, "ngIf"], [3, "duetBlur", "duetChange", "duetFocus", "duetOpen", "duetClose", "dateAdapter", "localization", "value", "identifier", "disabled", "firstDayOfWeek", "max", "min", "name", "role", "dateFormat"], ["role", "alert", 1, "invalid-feedback"], [1, "field-error"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [1, "form-text", 3, "id", "innerHTML"], [3, "id"], [4, "ngTemplateOutlet"], ["dynamicField", "", 3, "config", "group", 4, "ngFor", "ngForOf"], ["dynamicField", "", 3, "config", "group"]],
      template: function JanusFormDatePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormDatePickerComponent_div_0_Template, 6, 18, "div", 0)(1, JanusFormDatePickerComponent_div_1_Template, 2, 1, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.control.value);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, DynamicFieldDirective, JanusRequiredComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: [":root{--duet-color-primary: #005fcc;--duet-color-text: #333;--duet-color-text-active: #fff;--duet-color-placeholder: #666;--duet-color-button: #f5f5f5;--duet-color-surface: #fff;--duet-color-overlay: rgba(0, 0, 0, .8);--duet-color-border: #333;--duet-font: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;--duet-font-normal: 400;--duet-font-bold: 600;--duet-radius: 4px;--duet-z-index: 600}duet-date-picker .duet-date__dialog{display:none}duet-date-picker .duet-date__dialog.is-active{display:flex}duet-date-picker .duet-date__input{font-size:1rem;padding:.3125rem .75rem;border:1px solid #aaa;line-height:1.5}duet-date-picker .duet-date__input:disabled{background-color:#e9ecef}duet-date-picker .duet-date__toggle{z-index:0}duet-date-picker .duet-date__toggle-icon svg{width:40%}duet-date-picker .duet-date,duet-date-picker .duet-date__input,duet-date-picker .duet-date__day{font-family:var(--bs-body-font-family)}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormDatePickerComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-datepicker',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div *ngIf=\"!config.hideField\" class=\"janus-field\" role=\"group\" [formGroup]=\"group\" [ngClass]=\"{'is-invalid': !control.valid && (control.dirty || control.touched), 'last':config.lastChild, 'mb-4': !config.lastChild, 'pe-none': control.disabled }\" [attr.aria-labelledby]=\"config.elementId\" [attr.aria-describedby]=\"describedByValue\">\n    <label class=\"form-label\"\n           [class.visually-hidden]=\"config.hideLabel\"\n           for=\"{{config.elementId}}\"\n    >\n        {{config.label | translate}}<janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\"></janus-required>\n    </label>\n    <div class=\"field-widget\" *ngIf=\"readyToLoad\">\n        <div class=\"invalid-feedback\" role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n            <div class=\"field-error\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                </svg>\n                <ng-container *ngIf=\"control.errors?.required\">\n                    {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n                </ng-container>\n                <ng-container *ngIf=\"control.errors?.dateFormat\">\n                    {{ 'misc.Date must be in {format} format.' | translate: { format: config.format || localeData._longDateFormat.L } }}\n                </ng-container>\n            </div>\n        </div>\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div *ngIf=\"config.blurbTemplate && !config.blurb\" id=\"{{describedByValue}}\">\n            <ng-container *ngTemplateOutlet=\"config.blurbTemplate\"></ng-container>\n        </div>\n        <duet-date-picker\n                [dateAdapter]=\"dateAdapter\"\n                [localization]=\"pickerLocalization\"\n                [value]=\"config.value\"\n                [identifier]=\"config.elementId\"\n                [disabled]=\"config.disabled\"\n                [firstDayOfWeek]=\"properties?.firstDayOfWeek\"\n                [max]=\"properties?.max\"\n                [min]=\"properties?.min\"\n                [name]=\"properties?.name\"\n                [role]=\"properties?.role || 'datepicker'\"\n                [dateFormat]=\"config.dateFormat\"\n                [disabled]=\"control.disabled\"\n                (duetBlur)=\"checkFieldValueValid($event); triggerEvent('blur', $event)\"\n                (duetChange)=\"selectDate($event)\"\n                (duetFocus)=\"triggerEvent('focus', $event)\"\n                (duetOpen)=\"triggerEvent('open', $event)\"\n                (duetClose)=\"triggerEvent('close', $event)\"\n        ></duet-date-picker>\n    </div>\n</div>\n<div *ngIf='control.value'>\n    <ng-container *ngFor=\"let field of config.dependents\" dynamicField [config]=\"field\" [group]=\"group\"></ng-container>\n</div>",
      styles: [":root{--duet-color-primary: #005fcc;--duet-color-text: #333;--duet-color-text-active: #fff;--duet-color-placeholder: #666;--duet-color-button: #f5f5f5;--duet-color-surface: #fff;--duet-color-overlay: rgba(0, 0, 0, .8);--duet-color-border: #333;--duet-font: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;--duet-font-normal: 400;--duet-font-bold: 600;--duet-radius: 4px;--duet-z-index: 600}duet-date-picker .duet-date__dialog{display:none}duet-date-picker .duet-date__dialog.is-active{display:flex}duet-date-picker .duet-date__input{font-size:1rem;padding:.3125rem .75rem;border:1px solid #aaa;line-height:1.5}duet-date-picker .duet-date__input:disabled{background-color:#e9ecef}duet-date-picker .duet-date__toggle{z-index:0}duet-date-picker .duet-date__toggle-icon svg{width:40%}duet-date-picker .duet-date,duet-date-picker .duet-date__input,duet-date-picker .duet-date__day{font-family:var(--bs-body-font-family)}\n"]
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['JANUS_VERSION']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [CLOSEST_SCROLL_CONTAINER_LIST]
    }]
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormDatePickerComponent, {
    className: "JanusFormDatePickerComponent",
    filePath: "janus/components/form-datepicker/janus-form-datepicker.component.ts",
    lineNumber: 19
  });
})();
const _c0$t = ["startDatePicker"];
const _c1$m = ["endDatePicker"];
const _c2$h = (a0, a1, a2, a3) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2,
  "pe-none": a3
});
const _c3$c = a0 => ({
  field_name: a0
});
const _c4$b = a0 => ({
  format: a0
});
function JanusFormRangeDatePickerComponent_div_0_div_5_div_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c3$c, ctx_r1.translatedLabel)), " ");
  }
}
function JanusFormRangeDatePickerComponent_div_0_div_5_div_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Date must be in {format} format.", i0.ɵɵpureFunction1(4, _c4$b, ctx_r1.localeData._longDateFormat.L)), " ");
  }
}
function JanusFormRangeDatePickerComponent_div_0_div_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 20);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, JanusFormRangeDatePickerComponent_div_0_div_5_div_1_ng_container_4_Template, 3, 6, "ng-container", 3)(5, JanusFormRangeDatePickerComponent_div_0_div_5_div_1_ng_container_5_Template, 3, 6, "ng-container", 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors == null ? null : ctx_r1.control.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors == null ? null : ctx_r1.control.errors.dateFormat);
  }
}
function JanusFormRangeDatePickerComponent_div_0_div_5_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 21);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormRangeDatePickerComponent_div_0_div_5_div_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormRangeDatePickerComponent_div_0_div_5_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, JanusFormRangeDatePickerComponent_div_0_div_5_div_3_ng_container_1_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.config.blurbTemplate);
  }
}
function JanusFormRangeDatePickerComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, JanusFormRangeDatePickerComponent_div_0_div_5_div_1_Template, 6, 3, "div", 9)(2, JanusFormRangeDatePickerComponent_div_0_div_5_div_2_Template, 3, 6, "div", 10)(3, JanusFormRangeDatePickerComponent_div_0_div_5_div_3_Template, 2, 2, "div", 11);
    i0.ɵɵelementStart(4, "div", 12)(5, "div", 13)(6, "label", 14);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "duet-date-picker", 15, 0);
    i0.ɵɵlistener("duetBlur", function JanusFormRangeDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetBlur_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      ctx_r1.checkFieldValueValid($event);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("blur", $event));
    })("duetChange", function JanusFormRangeDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetChange_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.startDateChange($event));
    })("duetFocus", function JanusFormRangeDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetFocus_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("focus", $event));
    })("duetOpen", function JanusFormRangeDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetOpen_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("open", $event));
    })("duetClose", function JanusFormRangeDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetClose_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("close", $event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 16);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 13)(14, "label", 17);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "duet-date-picker", 15, 1);
    i0.ɵɵlistener("duetBlur", function JanusFormRangeDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetBlur_17_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      ctx_r1.checkFieldValueValid($event);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("blur", $event));
    })("duetChange", function JanusFormRangeDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetChange_17_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.endDateChange($event));
    })("duetFocus", function JanusFormRangeDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetFocus_17_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("focus", $event));
    })("duetOpen", function JanusFormRangeDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetOpen_17_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("open", $event));
    })("duetClose", function JanusFormRangeDatePickerComponent_div_0_div_5_Template_duet_date_picker_duetClose_17_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.triggerEvent("close", $event));
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurbTemplate && !ctx_r1.config.blurb);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 32, "misc.Start date"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "startdate")("dateAdapter", ctx_r1.dateAdapter)("localization", ctx_r1.pickerLocalization)("value", ctx_r1.getRangeValue(ctx_r1.config.value, 0))("min", ctx_r1.properties.min)("max", ctx_r1.getEarliestDate(ctx_r1.getRangeValue(ctx_r1.config.value, 1), ctx_r1.properties.max))("identifier", "startdate")("direction", ctx_r1.isLTR ? "right" : "left")("disabled", ctx_r1.config.disabled)("firstDayOfWeek", ctx_r1.properties.firstDayOfWeek)("role", ctx_r1.properties.role)("disabled", ctx_r1.control.disabled);
    i0.ɵɵattribute("id", ctx_r1.config.elementId + "_duet-date-picker");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (ctx_r1.config.properties == null ? null : ctx_r1.config.properties.delimiter) || "to", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 34, "misc.End date"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "enddate")("dateAdapter", ctx_r1.dateAdapter)("localization", ctx_r1.endPickerLocalization)("value", ctx_r1.getRangeValue(ctx_r1.config.value, 1))("min", ctx_r1.getLatestDate(ctx_r1.getRangeValue(ctx_r1.config.value, 0), ctx_r1.properties == null ? null : ctx_r1.properties.min))("max", ctx_r1.properties == null ? null : ctx_r1.properties.max)("identifier", "enddate")("direction", ctx_r1.isLTR ? "left" : "right")("disabled", ctx_r1.config == null ? null : ctx_r1.config.disabled)("firstDayOfWeek", ctx_r1.properties.firstDayOfWeek)("role", ctx_r1.properties == null ? null : ctx_r1.properties.role)("disabled", ctx_r1.control.disabled);
    i0.ɵɵattribute("id", ctx_r1.config.elementId + "_duet-date-picker-to");
  }
}
function JanusFormRangeDatePickerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "label", 5);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, JanusFormRangeDatePickerComponent_div_0_div_5_Template, 19, 36, "div", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.group)("ngClass", i0.ɵɵpureFunction4(11, _c2$h, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild, !ctx_r1.config.lastChild, ctx_r1.control.disabled));
    i0.ɵɵattribute("aria-labelledby", ctx_r1.config.elementId)("aria-describedby", ctx_r1.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r1.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 9, ctx_r1.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched))("isRequired", ctx_r1.isRequired);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.readyToLoad);
  }
}
function JanusFormRangeDatePickerComponent_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 25);
  }
  if (rf & 2) {
    const field_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r3)("group", ctx_r1.group);
  }
}
function JanusFormRangeDatePickerComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormRangeDatePickerComponent_div_1_ng_container_1_Template, 1, 2, "ng-container", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.dependents);
  }
}
class JanusFormRangeDatePickerComponent extends JanusFormDatePickerComponent {
  constructor() {
    super(...arguments);
    this.isLTR = document.dir === 'ltr';
  }
  get fromDateControl() {
    return this.group.get(this.config.name + '.from');
  }
  get toDateControl() {
    return this.group.get(this.config.name + '.to');
  }
  init() {
    this.setDefaultRangeValues();
    if (this.config.format) {
      this.dateFormat = this.config.format;
    }
    this.translate.get('misc.Close').pipe(take(1)).subscribe(res => {
      this.dateAdapter = this.getDateAdapter(this);
      this.pickerLocalization = this.getLocalization(0);
      this.endPickerLocalization = this.getLocalization(1);
      this.readyToLoad = true;
      this.rangeFormSetup();
      this.setup();
    });
  }
  initSetValue() {
    if (!isEmpty(this.config.value)) {
      if (isArray(this.config.value)) {
        this.control.setValue({
          from: this.config.value[0],
          to: this.config.value[1]
        }, {
          'emitEvent': false
        });
      } else if (isObject(this.config.value)) {
        this.control.setValue(this.config.value, {
          'emitEvent': false
        });
      }
    }
  }
  setDefaultRangeValues(item = this.config.value, defaultValue = [undefined, undefined]) {
    if (item === undefined || item === null) {
      item = defaultValue;
    }
  }
  rangeFormSetup() {
    this.dateRangeFG = new UntypedFormGroup({
      from: new UntypedFormControl(this.config.value[0]),
      to: new UntypedFormControl(this.config.value[1])
    }, {
      updateOn: 'blur'
    });
    this.valueChangesSubscribe = this.dateRangeFG.valueChanges.subscribe(selectedValue => {
      if (typeof this.config.onChangeCallback !== 'undefined') {
        this.config.onChangeCallback(this.config.name, selectedValue);
      }
    });
    this.group.setControl(this.config.name, this.dateRangeFG);
  }
  startDateChange(e) {
    this.selectDate(e, this.fromDateControl);
  }
  endDateChange(e) {
    this.selectDate(e, this.toDateControl);
  }
  getRangeValue(item, idx) {
    return isArray(item) ? item[idx] : undefined;
  }
  getEarliestDate(a, b) {
    let item = a || b;
    if (a !== undefined && b !== undefined) {
      item = moment$1(a).isBefore(moment$1(b)) ? a : b;
    }
    return item;
  }
  getLatestDate(a, b) {
    let item = a || b;
    if (a !== undefined && b !== undefined) {
      item = moment$1(a).isAfter(moment$1(b)) ? a : b;
    }
    return item;
  }
  ngOnDestroy() {
    this.valueChangesSubscribe.unsubscribe();
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormRangeDatePickerComponent_BaseFactory;
      return function JanusFormRangeDatePickerComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormRangeDatePickerComponent_BaseFactory || (ɵJanusFormRangeDatePickerComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormRangeDatePickerComponent)))(__ngFactoryType__ || JanusFormRangeDatePickerComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormRangeDatePickerComponent,
      selectors: [["janus-form-range-datepicker"]],
      viewQuery: function JanusFormRangeDatePickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$t, 5);
          i0.ɵɵviewQuery(_c1$m, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.startDatePicker = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.endDatePicker = _t.first);
        }
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 2,
      consts: [["startDatePicker", ""], ["endDatePicker", ""], ["class", "janus-field", "role", "group", 3, "formGroup", "ngClass", 4, "ngIf"], [4, "ngIf"], ["role", "group", 1, "janus-field", 3, "formGroup", "ngClass"], ["for", "date", 1, "form-label", 3, "id"], [3, "hasError", "isRequired"], ["class", "field-widget", 4, "ngIf"], [1, "field-widget"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], ["class", "form-text", 3, "id", "innerHTML", 4, "ngIf"], [3, "id", 4, "ngIf"], [1, "gx-3", "gy-2", "row"], [1, "col-10", "col-md"], ["for", "startdate", 1, "visually-hidden"], [1, "input-group", 3, "duetBlur", "duetChange", "duetFocus", "duetOpen", "duetClose", "name", "dateAdapter", "localization", "value", "min", "max", "identifier", "direction", "disabled", "firstDayOfWeek", "role"], [1, "col-2", "col-md-auto"], ["for", "enddate", 1, "visually-hidden"], ["role", "alert", 1, "invalid-feedback"], [1, "field-error"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [1, "form-text", 3, "id", "innerHTML"], [3, "id"], [4, "ngTemplateOutlet"], ["dynamicField", "", 3, "config", "group", 4, "ngFor", "ngForOf"], ["dynamicField", "", 3, "config", "group"]],
      template: function JanusFormRangeDatePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormRangeDatePickerComponent_div_0_Template, 6, 16, "div", 2)(1, JanusFormRangeDatePickerComponent_div_1_Template, 2, 1, "div", 3);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.control.value);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, DynamicFieldDirective, JanusRequiredComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: [":root{--duet-color-primary: #005fcc;--duet-color-text: #333;--duet-color-text-active: #fff;--duet-color-placeholder: #666;--duet-color-button: #f5f5f5;--duet-color-surface: #fff;--duet-color-overlay: rgba(0, 0, 0, .8);--duet-color-border: #333;--duet-font: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;--duet-font-normal: 400;--duet-font-bold: 600;--duet-radius: 4px;--duet-z-index: 600}duet-date-picker .duet-date__dialog{display:none}duet-date-picker .duet-date__dialog.is-active{display:flex}duet-date-picker .duet-date__input{font-size:1rem;padding:.3125rem .75rem;border:1px solid #aaa;line-height:1.5}duet-date-picker .duet-date__input:disabled{background-color:#e9ecef}duet-date-picker .duet-date__toggle{z-index:0}duet-date-picker .duet-date__toggle-icon svg{width:40%}duet-date-picker .duet-date,duet-date-picker .duet-date__input,duet-date-picker .duet-date__day{font-family:var(--bs-body-font-family)}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormRangeDatePickerComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-range-datepicker',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"janus-field\" *ngIf=\"!config.hideField\" role=\"group\" [formGroup]=\"group\" [ngClass]=\"{'is-invalid': !control.valid && (control.dirty || control.touched), 'last':config.lastChild, 'mb-4': !config.lastChild, 'pe-none': control.disabled }\" [attr.aria-labelledby]=\"config.elementId\" [attr.aria-describedby]=\"describedByValue\">\n    <label class=\"form-label\" id=\"{{config.elementId}}\" for=\"date\">\n        {{config.label | translate}}<janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\"></janus-required>\n    </label>\n    <div class=\"field-widget\" *ngIf=\"readyToLoad\">\n        <div class=\"invalid-feedback\" role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n            <div class=\"field-error\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                </svg>\n                <ng-container *ngIf=\"control.errors?.required\">\n                    {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n                </ng-container>\n                <ng-container *ngIf=\"control.errors?.dateFormat\">\n                    {{ 'misc.Date must be in {format} format.' | translate: { format: localeData._longDateFormat.L } }}\n                </ng-container>\n            </div>\n        </div>\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div *ngIf=\"config.blurbTemplate && !config.blurb\" id=\"{{describedByValue}}\">\n            <ng-container *ngTemplateOutlet=\"config.blurbTemplate\"></ng-container>\n        </div>\n        <div class=\"gx-3 gy-2 row\">\n            <div class=\"col-10 col-md\">\n                <label for=\"startdate\" class=\"visually-hidden\">{{ 'misc.Start date' | translate }}</label>\n                <duet-date-picker\n                    #startDatePicker\n                    class=\"input-group\"\n                    [attr.id]=\"config.elementId + '_duet-date-picker'\"\n                    [name]=\"'startdate'\"\n                    [dateAdapter]=\"dateAdapter\"\n                    [localization]=\"pickerLocalization\"\n                    [value]=\"getRangeValue(config.value, 0)\"\n                    [min]=\"properties.min\"\n                    [max]=\"getEarliestDate(getRangeValue(config.value, 1), properties.max)\"\n                    [identifier]=\"'startdate'\"\n                    [direction]=\"isLTR ? 'right' : 'left'\"\n                    [disabled]=\"config.disabled\"\n                    [firstDayOfWeek]=\"properties.firstDayOfWeek\"\n                    [role]=\"properties.role\"\n                    [disabled]=\"control.disabled\"\n                    (duetBlur)=\"checkFieldValueValid($event); triggerEvent('blur', $event)\"\n                    (duetChange)=\"startDateChange($event)\"\n                    (duetFocus)=\"triggerEvent('focus', $event)\"\n                    (duetOpen)=\"triggerEvent('open', $event)\"\n                    (duetClose)=\"triggerEvent('close', $event)\"\n                ></duet-date-picker>\n            </div>\n            \n            <div class=\"col-2 col-md-auto\">\n                {{ config.properties?.delimiter || 'to' }}\n            </div>\n            \n            <div class=\"col-10 col-md\">\n                <label for=\"enddate\" class=\"visually-hidden\">{{ 'misc.End date' | translate }}</label>\n                <duet-date-picker\n                    #endDatePicker\n                    class=\"input-group\"\n                    [attr.id]=\"config.elementId + '_duet-date-picker-to'\"\n                    [name]=\"'enddate'\"\n                    [dateAdapter]=\"dateAdapter\"\n                    [localization]=\"endPickerLocalization\"\n                    [value]=\"getRangeValue(config.value, 1)\"\n                    [min]=\"getLatestDate(getRangeValue(config.value, 0), properties?.min)\"\n                    [max]=\"properties?.max\"\n                    [identifier]=\"'enddate'\"\n                    [direction]=\"isLTR ? 'left' : 'right'\"\n                    [disabled]=\"config?.disabled\"\n                    [firstDayOfWeek]=\"properties.firstDayOfWeek\"\n                    [role]=\"properties?.role\"\n                    [disabled]=\"control.disabled\"\n                    (duetBlur)=\"checkFieldValueValid($event); triggerEvent('blur', $event)\"\n                    (duetChange)=\"endDateChange($event)\"\n                    (duetFocus)=\"triggerEvent('focus', $event)\"\n                    (duetOpen)=\"triggerEvent('open', $event)\"\n                    (duetClose)=\"triggerEvent('close', $event)\"\n                ></duet-date-picker>\n            </div>\n        </div>\n    </div>\n</div>\n<div *ngIf='control.value'>\n    <ng-container *ngFor=\"let field of config.dependents\" dynamicField [config]=\"field\" [group]=\"group\"></ng-container>\n</div>",
      styles: [":root{--duet-color-primary: #005fcc;--duet-color-text: #333;--duet-color-text-active: #fff;--duet-color-placeholder: #666;--duet-color-button: #f5f5f5;--duet-color-surface: #fff;--duet-color-overlay: rgba(0, 0, 0, .8);--duet-color-border: #333;--duet-font: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;--duet-font-normal: 400;--duet-font-bold: 600;--duet-radius: 4px;--duet-z-index: 600}duet-date-picker .duet-date__dialog{display:none}duet-date-picker .duet-date__dialog.is-active{display:flex}duet-date-picker .duet-date__input{font-size:1rem;padding:.3125rem .75rem;border:1px solid #aaa;line-height:1.5}duet-date-picker .duet-date__input:disabled{background-color:#e9ecef}duet-date-picker .duet-date__toggle{z-index:0}duet-date-picker .duet-date__toggle-icon svg{width:40%}duet-date-picker .duet-date,duet-date-picker .duet-date__input,duet-date-picker .duet-date__day{font-family:var(--bs-body-font-family)}\n"]
    }]
  }], null, {
    startDatePicker: [{
      type: ViewChild,
      args: ['startDatePicker']
    }],
    endDatePicker: [{
      type: ViewChild,
      args: ['endDatePicker']
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormRangeDatePickerComponent, {
    className: "JanusFormRangeDatePickerComponent",
    filePath: "janus/components/form-datepicker/janus-form-range-datepicker.component.ts",
    lineNumber: 16
  });
})();
const _c0$s = (a0, a1, a2) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2
});
const _c1$l = a0 => ({
  "user-select-none": a0
});
const _c2$g = a0 => ({
  field_name: a0
});
function JanusFormTimepickerComponent_div_0_div_6_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c2$g, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormTimepickerComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, JanusFormTimepickerComponent_div_0_div_6_ng_container_3_Template, 3, 6, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function JanusFormTimepickerComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(1, 1, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormTimepickerComponent_div_0_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormTimepickerComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormTimepickerComponent_div_0_div_8_ng_container_1_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.config.blurbTemplate);
  }
}
function JanusFormTimepickerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "label", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵtemplate(6, JanusFormTimepickerComponent_div_0_div_6_Template, 4, 2, "div", 5)(7, JanusFormTimepickerComponent_div_0_div_7_Template, 3, 5, "div", 6)(8, JanusFormTimepickerComponent_div_0_div_8_Template, 2, 1, "div", 7);
    i0.ɵɵelementStart(9, "div", 8)(10, "span", 9);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(11, "svg", 10);
    i0.ɵɵelement(12, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(13, "timepicker", 11);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(39, _c0$s, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild, !ctx_r0.config.lastChild))("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("visually-hidden", ctx_r0.config.hideLabel);
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 31, ctx_r0.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched))("isRequired", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurbTemplate && !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(43, _c1$l, ctx_r0.control.disabled));
    i0.ɵɵattribute("readonly", ctx_r0.control.disabled || null);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-clock", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵproperty("hoursPlaceholder", i0.ɵɵpipeBind1(14, 33, ctx_r0.timepickerConfig.hoursPlaceholder))("hourStep", ctx_r0.timepickerConfig.hourStep)("meridians", ctx_r0.timepickerConfig.meridians)("minutesPlaceholder", i0.ɵɵpipeBind1(15, 35, ctx_r0.timepickerConfig.minutesPlaceholder))("minuteStep", ctx_r0.timepickerConfig.minuteStep)("mousewheel", !ctx_r0.control.disabled)("secondsPlaceholder", i0.ɵɵpipeBind1(16, 37, ctx_r0.timepickerConfig.secondsPlaceholder))("secondsStep", ctx_r0.timepickerConfig.secondsStep)("showMeridian", ctx_r0.timepickerConfig.showMeridian)("showMinutes", ctx_r0.timepickerConfig.showMinutes)("showSeconds", ctx_r0.timepickerConfig.showSeconds);
    i0.ɵɵattribute("aria-labelledby", ctx_r0.config.elementId + (ctx_r0.modal ? "modal" : ""));
  }
}
class JanusFormTimepickerComponent extends JanusFormInputComponent {
  constructor(translateService) {
    super(translateService);
    this.translateService = translateService;
    this.timepickerConfig = {
      ...new TimepickerConfig(),
      ariaLabelHours: 'misc.hours',
      ariaLabelMinutes: 'misc.minutes',
      ariaLabelSeconds: 'misc.seconds',
      hoursPlaceholder: 'misc.HH',
      minutesPlaceholder: 'misc.MM',
      secondsPlaceholder: 'misc.SS'
    };
    this.formGroup = new UntypedFormGroup({
      time: new UntypedFormControl()
    });
    this.timezone = '';
    this.timepickerConfigKeys = ['ariaLabelHours', 'ariaLabelMinutes', 'ariaLabelSeconds', 'disabled', 'hoursPlaceholder', 'hourStep', 'meridians', 'minutesPlaceholder', 'minuteStep', 'secondsPlaceholder', 'secondsStep', 'showMeridian', 'showMinutes', 'showSeconds'];
    this.configKeys = ['timezone'];
    this.DOMInputs = [{
      selector: '[aria-label="hours"]',
      replacement: {
        attribute: 'aria-label',
        replacementKey: 'ariaLabelHours'
      }
    }, {
      selector: '[aria-label="minutes"]',
      replacement: {
        attribute: 'aria-label',
        replacementKey: 'ariaLabelMinutes'
      }
    }, {
      selector: '[aria-label="seconds"]',
      replacement: {
        attribute: 'aria-label',
        replacementKey: 'ariaLabelSeconds'
      }
    }];
    this.keyCodesWhitelist = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'End', 'Home', 'Tab'];
    this.numbersRegExp = new RegExp(/^(^[0-9])+$/);
    this.offsets = {
      value: 0,
      timezone: 0
    };
    this.today = new Date();
    this.destroyed$ = new Subject();
  }
  ngOnInit() {
    this.defaultInit();
    this.applyTimepickerConfig(this.timepickerConfigKeys, this.configKeys);
    if (this.config.disabled) {
      this.formGroup.get('time')?.disable({
        emitEvent: false
      });
    }
    if (this.isRequired) {
      this.formGroup.get('time')?.setValidators(Validators.required);
    }
    this.setTimepickerDate();
    this.formGroup.get('time')?.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(value => this.onValueChanges(value));
  }
  ngAfterViewInit() {
    this.updateDOMInputs();
    this.updateTableA11y();
  }
  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  applyTimepickerConfig(timepickerConfigsKeys, configsKeys) {
    timepickerConfigsKeys.filter(key => typeof this.config[key] !== 'undefined' && this.timepickerConfig.hasOwnProperty(key)).forEach(key => this.timepickerConfig[key] = this.config[key]);
    configsKeys.filter(key => typeof this.config[key] !== 'undefined' && this.hasOwnProperty(key)).forEach(key => this[key] = this.config[key]);
  }
  updateTableA11y() {
    if (!this.timepickerComponent?.nativeElement) {
      return;
    }
    const table = this.timepickerComponent.nativeElement.querySelector('table');
    if (table) {
      table.setAttribute('role', 'none');
    }
  }
  updateDOMInputs() {
    if (!this.timepickerComponent?.nativeElement) {
      return;
    }
    this.DOMInputs.forEach(domInput => {
      const element = this.timepickerComponent.nativeElement.querySelector(domInput.selector);
      if (element) {
        const {
          attribute,
          replacementKey
        } = domInput.replacement;
        this.addInputGuards(element, domInput.selector);
        element.setAttribute(attribute, this.translateService.instant(this.timepickerConfig[replacementKey]));
      }
    });
  }
  setTimepickerDate() {
    if (this.timezone) {
      this.offsets.timezone = moment$1.parseZone(moment$1(new Date()).tz(this.timezone)).utcOffset();
    }
    if (this.config.value) {
      const year = this.today.getFullYear().toString();
      const month = (this.today.getMonth() + 1).toString().padStart(2, '0');
      const date = this.today.getDate().toString().padStart(2, '0');
      let momentDate = moment$1.parseZone(`${year}-${month}-${date}T${this.config.value}`);
      this.offsets.value = momentDate.utcOffset();
      if (this.offsets.timezone) {
        momentDate = momentDate.utcOffset(this.offsets.timezone);
      }
      const [hours, minutes, seconds] = momentDate.format('HH:mm:ss').split(':').map(number => parseInt(number, 10));
      this.today.setHours(hours);
      this.today.setMinutes(minutes);
      this.today.setSeconds(seconds);
      this.formGroup.get('time')?.setValue(this.today, {
        emitEvent: false
      });
      this.onValueChanges(this.today, false);
    }
    if (!this.config.value && this.timezone) {
      this.offsets.value = this.offsets.timezone;
    }
  }
  onValueChanges(date, emitEvent = true) {
    if (date && date instanceof Date) {
      const year = this.today.getFullYear().toString();
      const month = (this.today.getMonth() + 1).toString().padStart(2, '0');
      const day = this.today.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      const offset = this.numberToISOOffset();
      const value = moment$1.parseZone(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offset}`).utcOffset(this.offsets.value).format('HH:mm:ss');
      this.control.setValue(value, {
        emitEvent: emitEvent
      });
    }
  }
  numberToISOOffset() {
    const offset = this.timezone ? this.offsets.timezone : this.offsets.value;
    let retval = '';
    retval += offset < 0 ? '-' : '+';
    retval += Math.floor(Math.abs(offset / 60)).toString().padStart(2, '0');
    retval += ':';
    retval += Math.abs(offset % 60).toString().padStart(2, '0');
    return retval;
  }
  addInputGuards(element, selector) {
    const type = selector.replace('[aria-label="', '').replace('"]', '');
    fromEvent(element, 'keydown').pipe(takeUntil(this.destroyed$)).subscribe(event => {
      if (!(this.keyCodesWhitelist.includes(event.code) || this.numbersRegExp.test(event.key))) {
        event.preventDefault();
        return;
      }
      if (this.numbersRegExp.test(event.key)) {
        const {
          selectionEnd,
          selectionStart = 0,
          value
        } = event.target || {};
        /**
         * Time inputs have a `maxlength` attribute set to `2`, so when the value is something between 0 and 9
         * `selectionStart` is going to be 0 or 1 and `selectionEnd` is going to be between 0 and 2.
         *
         * In that way, it's easy to predict the future value based on which number key was pressed:
         *   - if `selectionStart` is `0`, then `event.key` should be added before `value`
         *   - if `selectionStart` is `1`, then `event.key` should be added after `value`
         *
         * If `selectionEnd` is not equal to `selectionStart`, means that there is a selection performed over `value`.
         * In that way,  it's easy to know which portion of the value is candidate to replace the `value` portion.
         */
        const predictedValue = selectionEnd === selectionStart ? parseInt(selectionStart === 0 ? `${event.key}${value}` : `${value}${event.key}`, 10) : parseInt(value.replace(value.substring(selectionStart, selectionEnd), event.key), 10);
        if ((type === 'minutes' || type === 'seconds') && predictedValue > 59 || type === 'hours' && this.timepickerConfig.showMeridian && predictedValue > 12 || type === 'hours' && !this.timepickerConfig.showMeridian && predictedValue > 23) {
          event.preventDefault();
        }
      }
    });
  }
  static {
    this.ɵfac = function JanusFormTimepickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusFormTimepickerComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormTimepickerComponent,
      selectors: [["janus-form-timepicker"]],
      viewQuery: function JanusFormTimepickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TimepickerComponent, 5, ElementRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timepickerComponent = _t.first);
        }
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "janus-field timepicker-widget d-flex flex-column align-items-start", 3, "ngClass", "formGroup", 4, "ngIf"], [1, "janus-field", "timepicker-widget", "d-flex", "flex-column", "align-items-start", 3, "ngClass", "formGroup"], [1, "form-label", 3, "for"], [3, "hasError", "isRequired"], [1, "field-widget"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], ["class", "form-text", 3, "innerHTML", 4, "ngIf"], [4, "ngIf"], [1, "timepicker-wrapper", "form-control", "d-inline-flex", "align-items-center", "w-auto", "p-0", 3, "ngClass"], [1, "ps-2"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1"], ["role", "group", "formControlName", "time", 3, "id", "hoursPlaceholder", "hourStep", "meridians", "minutesPlaceholder", "minuteStep", "mousewheel", "secondsPlaceholder", "secondsStep", "showMeridian", "showMinutes", "showSeconds"], ["role", "alert", 1, "invalid-feedback"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [1, "form-text", 3, "innerHTML"], [4, "ngTemplateOutlet"]],
      template: function JanusFormTimepickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormTimepickerComponent_div_0_Template, 17, 45, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, i4$1.TimepickerComponent, JanusRequiredComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: [".timepicker-widget .timepicker-wrapper timepicker table tbody tr:first-child,.timepicker-widget .timepicker-wrapper timepicker table tbody tr:last-child{display:none}.timepicker-widget .timepicker-wrapper timepicker table tbody td input{width:3.5rem;border:none}.timepicker-widget .timepicker-wrapper timepicker table tbody td button{min-width:initial;min-height:unset;padding:.25rem .75rem;border:0}.timepicker-widget .timepicker-wrapper timepicker table tbody .form-control{min-height:unset;padding-top:.25rem;padding-bottom:.25rem}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormTimepickerComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-timepicker',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div \n    *ngIf=\"!config.hideField\"\n    class=\"janus-field timepicker-widget d-flex flex-column align-items-start\"\n    [ngClass]=\"{\n        'is-invalid': !control.valid && (control.dirty || control.touched),\n        'last': config.lastChild,\n        'mb-4': !config.lastChild\n    }\"\n    [formGroup]=\"formGroup\"\n>\n    <label\n        for=\"{{config.elementId}}{{modal?'modal':''}}\" \n        class=\"form-label\"\n        [class.visually-hidden]=\"config.hideLabel\"\n    >\n            {{ config.label | translate }}<janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\"></janus-required>\n    </label>\n    <div class=\"field-widget\">\n        <div \n            *ngIf=\"!control.valid && (control.dirty || control.touched)\"\n            class=\"invalid-feedback\"\n            role=\"alert\"\n        >\n            <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n            </svg>\n\n            <ng-container *ngIf=\"control.errors.required\">\n                {{ 'misc.Field is required' | translate: { field_name: translatedLabel } }}\n            </ng-container>\n        </div>\n\n        <div *ngIf=\"config.blurb\" class=\"form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div *ngIf=\"config.blurbTemplate && !config.blurb\">\n            <ng-container *ngTemplateOutlet=\"config.blurbTemplate\"></ng-container>\n        </div>\n\n        <div \n            class=\"timepicker-wrapper form-control d-inline-flex align-items-center w-auto p-0\" \n            [ngClass]=\"{\n                'user-select-none': control.disabled\n            }\"\n            [attr.readonly]=\"control.disabled || null\"\n        >\n            <span class=\"ps-2\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-clock'\"></use>\n                </svg>\n            </span>\n            \n            <timepicker\n                id=\"{{config.elementId}}{{modal?'modal':''}}\" \n                role=\"group\"\n                formControlName=\"time\"\n                [attr.aria-labelledby]=\"config.elementId + (modal ? 'modal':'')\"\n                [hoursPlaceholder]=\"timepickerConfig.hoursPlaceholder | translate\"\n                [hourStep]=\"timepickerConfig.hourStep\"\n                [meridians]=\"timepickerConfig.meridians\"\n                [minutesPlaceholder]=\"timepickerConfig.minutesPlaceholder | translate\"\n                [minuteStep]=\"timepickerConfig.minuteStep\"\n                [mousewheel]=\"!control.disabled\"\n                [secondsPlaceholder]=\"timepickerConfig.secondsPlaceholder | translate\"\n                [secondsStep]=\"timepickerConfig.secondsStep\"\n                [showMeridian]=\"timepickerConfig.showMeridian\"\n                [showMinutes]=\"timepickerConfig.showMinutes\"\n                [showSeconds]=\"timepickerConfig.showSeconds\"\n            >\n            </timepicker>\n        </div>\n    </div>\n</div>\n",
      styles: [".timepicker-widget .timepicker-wrapper timepicker table tbody tr:first-child,.timepicker-widget .timepicker-wrapper timepicker table tbody tr:last-child{display:none}.timepicker-widget .timepicker-wrapper timepicker table tbody td input{width:3.5rem;border:none}.timepicker-widget .timepicker-wrapper timepicker table tbody td button{min-width:initial;min-height:unset;padding:.25rem .75rem;border:0}.timepicker-widget .timepicker-wrapper timepicker table tbody .form-control{min-height:unset;padding-top:.25rem;padding-bottom:.25rem}\n"]
    }]
  }], () => [{
    type: i1$1.TranslateService
  }], {
    timepickerComponent: [{
      type: ViewChild,
      args: [TimepickerComponent, {
        static: false,
        read: ElementRef
      }]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormTimepickerComponent, {
    className: "JanusFormTimepickerComponent",
    filePath: "janus/components/form-timepicker/janus-form-timepicker.component.ts",
    lineNumber: 17
  });
})();
const _c0$r = ["editor"];
const _c1$k = (a0, a1, a2, a3, a4) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2,
  "d-flex": a3,
  "d-none": a4
});
const _c2$f = a0 => ({
  "pe-3": a0
});
const _c3$b = a0 => ({
  field_name: a0
});
const _c4$a = a0 => ({
  "text-muted": a0
});
const _c5$8 = a0 => ({
  config: a0
});
function JanusFormRichtextComponent_ng_container_1_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormRichtextComponent_ng_container_1_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormRichtextComponent_ng_container_1_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, JanusFormRichtextComponent_ng_container_1_div_8_ng_container_1_Template, 1, 0, "ng-container", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.config.blurbTemplate);
  }
}
function JanusFormRichtextComponent_ng_container_1_div_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 16);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Field is required", i0.ɵɵpureFunction1(5, _c3$b, ctx_r1.translatedLabel)), " ");
  }
}
function JanusFormRichtextComponent_ng_container_1_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, JanusFormRichtextComponent_ng_container_1_div_9_div_1_Template, 5, 7, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors == null ? null : ctx_r1.control.errors.required);
  }
}
function JanusFormRichtextComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 6)(6, "div", 7);
    i0.ɵɵtemplate(7, JanusFormRichtextComponent_ng_container_1_div_7_Template, 3, 6, "div", 8)(8, JanusFormRichtextComponent_ng_container_1_div_8_Template, 2, 2, "div", 9)(9, JanusFormRichtextComponent_ng_container_1_div_9_Template, 2, 1, "div", 10);
    i0.ɵɵelementStart(10, "editor", 11, 0);
    i0.ɵɵlistener("onFocus", function JanusFormRichtextComponent_ng_container_1_Template_editor_onFocus_10_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("focus", $event));
    })("onInit", function JanusFormRichtextComponent_ng_container_1_Template_editor_onInit_10_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.initEditor($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("for", ctx_r1.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 11, ctx_r1.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", ctx_r1.control && !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched))("isRequired", ctx_r1.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c2$f, ctx_r1.mergeCodeTemplate));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurbTemplate && !ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control && !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.config.elementId)("formControlName", ctx_r1.config.name)("init", ctx_r1.initOptions);
  }
}
function JanusFormRichtextComponent_ng_container_2_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c4$a, ctx_r1.control && (ctx_r1.control.valid || !(ctx_r1.control.dirty || ctx_r1.control.touched))));
    i0.ɵɵattribute("aria-required", ctx_r1.isRequired);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "misc.required_indicator"), " ");
  }
}
function JanusFormRichtextComponent_ng_container_2_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormRichtextComponent_ng_container_2_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormRichtextComponent_ng_container_2_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, JanusFormRichtextComponent_ng_container_2_div_8_ng_container_1_Template, 1, 0, "ng-container", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.config.blurbTemplate);
  }
}
function JanusFormRichtextComponent_ng_container_2_div_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 16);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Field is required", i0.ɵɵpureFunction1(5, _c3$b, ctx_r1.translatedLabel)), " ");
  }
}
function JanusFormRichtextComponent_ng_container_2_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, JanusFormRichtextComponent_ng_container_2_div_9_div_1_Template, 5, 7, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors == null ? null : ctx_r1.control.errors.required);
  }
}
function JanusFormRichtextComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17)(2, "label", 4);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, JanusFormRichtextComponent_ng_container_2_span_5_Template, 3, 7, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 19);
    i0.ɵɵtemplate(7, JanusFormRichtextComponent_ng_container_2_div_7_Template, 3, 6, "div", 8)(8, JanusFormRichtextComponent_ng_container_2_div_8_Template, 2, 2, "div", 9)(9, JanusFormRichtextComponent_ng_container_2_div_9_Template, 2, 1, "div", 10);
    i0.ɵɵelementStart(10, "editor", 11, 0);
    i0.ɵɵlistener("onFocus", function JanusFormRichtextComponent_ng_container_2_Template_editor_onFocus_10_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("focus", $event));
    })("onInit", function JanusFormRichtextComponent_ng_container_2_Template_editor_onInit_10_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.initEditor($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c2$f, ctx_r1.mergeCodeTemplate));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("for", ctx_r1.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 10, ctx_r1.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurbTemplate && !ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control && !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.config.elementId)("formControlName", ctx_r1.config.name)("init", ctx_r1.initOptions);
  }
}
function JanusFormRichtextComponent_div_3_ng_template_1_Template(rf, ctx) {}
function JanusFormRichtextComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, JanusFormRichtextComponent_div_3_ng_template_1_Template, 0, 0, "ng-template", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.mergeCodeTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c5$8, ctx_r1.config));
  }
}
class JanusFormRichtextComponent extends FormRichtextComponent {
  constructor(janusVersion, translate, cd) {
    super(translate, cd);
    this.janusVersion = janusVersion;
    this.translate = translate;
    this.cd = cd;
    this.assetsPath = '/app/assets/';
  }
  ngOnInit() {
    this.mergeCodeTemplate = this.config.mergeCodeTemplate;
    super.ngOnInit();
    let modal = this.modal ? 'modal' : '';
    this.describedByValue = this.config.blurb || this.config.blurbTemplate ? this.config.id + modal + '-blurb' : '';
  }
  ngAfterViewInit() {
    try {
      this.editor._element.setAttribute('aria-hidden', true);
    } catch (error) {
      // Silently ignore initialization errors
    }
  }
  triggerEvent(action, event) {
    if (this.config.triggerEvent && this.config.triggerEvent instanceof Function) {
      this.config.triggerEvent(action, event);
    }
  }
  static {
    this.ɵfac = function JanusFormRichtextComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusFormRichtextComponent)(i0.ɵɵdirectiveInject('JANUS_VERSION', 8), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormRichtextComponent,
      selectors: [["janus-form-richtext"]],
      viewQuery: function JanusFormRichtextComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$r, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editor = _t.first);
        }
      },
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 12,
      consts: [["editor", ""], ["role", "group", 1, "janus-field", 3, "formGroup", "ngClass"], [4, "ngIf"], ["class", "merge-codes-container w-100 my-n3 me-n3 ms-0", 4, "ngIf"], [1, "form-label", 3, "for"], [3, "hasError", "isRequired"], [1, "field-widget"], ["role", "application", 3, "ngClass"], ["class", "form-text", 3, "id", "innerHTML", 4, "ngIf"], [3, "id", 4, "ngIf"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], ["tagName", "textarea", 3, "onFocus", "onInit", "id", "formControlName", "init"], [1, "form-text", 3, "id", "innerHTML"], [3, "id"], [4, "ngTemplateOutlet"], ["role", "alert", 1, "invalid-feedback"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [3, "ngClass"], ["class", "fw-normal ms-1", 3, "ngClass", 4, "ngIf"], ["role", "application"], [1, "fw-normal", "ms-1", 3, "ngClass"], [1, "merge-codes-container", "w-100", "my-n3", "me-n3", "ms-0"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function JanusFormRichtextComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵtemplate(1, JanusFormRichtextComponent_ng_container_1_Template, 12, 15, "ng-container", 2)(2, JanusFormRichtextComponent_ng_container_2_Template, 12, 14, "ng-container", 2)(3, JanusFormRichtextComponent_div_3_Template, 2, 4, "div", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.group)("ngClass", i0.ɵɵpureFunction5(6, _c1$k, ctx.control && !ctx.control.valid && (ctx.control.dirty || ctx.control.touched), ctx.config.lastChild, !ctx.config.lastChild, ctx.mergeCodeTemplate, ctx.config.hideField));
          i0.ɵɵattribute("aria-describedby", ctx.describedByValue);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.janusVersion === 2);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.janusVersion === 1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.mergeCodeTemplate);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, i4.EditorComponent, JanusRequiredComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: ["janus-form-richtext .merge-codes-container{max-width:220px}janus-form-richtext .field-error-richtext{border:#bf3e24 solid 1.2px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormRichtextComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-richtext',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"janus-field\" role=\"group\" [formGroup]=\"group\"\n    [ngClass]=\"{'is-invalid': control && !control.valid && (control.dirty || control.touched), 'last': config.lastChild, 'mb-4': !config.lastChild, 'd-flex': mergeCodeTemplate, 'd-none': config.hideField}\"\n    [attr.aria-describedby]=\"describedByValue\">\n    <ng-container *ngIf=\"janusVersion === 2\">\n        <label class=\"form-label\" for=\"{{config.elementId}}\">\n            {{config.label | translate}}<janus-required\n                [hasError]=\"(control && !control.valid && (control.dirty || control.touched))\"\n                [isRequired]=\"isRequired\"></janus-required>\n        </label>\n        <div class=\"field-widget\">\n            <div [ngClass]=\"{'pe-3' : mergeCodeTemplate}\" role=\"application\">\n                <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"form-text\"\n                    [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n                <div *ngIf=\"config.blurbTemplate && !config.blurb\" id=\"{{describedByValue}}\">\n                    <ng-container *ngTemplateOutlet=\"config.blurbTemplate\"></ng-container>\n                </div>\n                <div class=\"invalid-feedback\" role=\"alert\"\n                    *ngIf=\"control && !control.valid && (control.dirty || control.touched)\">\n                    <div *ngIf=\"control.errors?.required\">\n                        <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                            <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\">\n                            </use>\n                        </svg>\n                        {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n                    </div>\n                </div>\n\n\n                <editor #editor\n                    tagName=\"textarea\"\n                    [id]=\"config.elementId\"\n                    [formControlName]=\"config.name\"\n                    [init]=\"initOptions\"\n                    (onFocus)=\"triggerEvent('focus', $event);\"\n                    (onInit)=\"initEditor($event)\"></editor>\n            </div>\n        </div>\n    </ng-container>\n    <ng-container *ngIf=\"janusVersion === 1\">\n        <div [ngClass]=\"{'pe-3' : mergeCodeTemplate}\">\n            <label class=\"form-label\" for=\"{{config.elementId}}\">\n                {{config.label | translate}}\n                <span [attr.aria-required]=\"isRequired\" class=\"fw-normal ms-1\" *ngIf=\"isRequired\"\n                    [ngClass]=\"{'text-muted': (control && (control.valid || !(control.dirty || control.touched)))}\">\n                    {{ 'misc.required_indicator' | translate }}\n                </span>\n            </label>\n            <div role=\"application\">\n                <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"form-text\"\n                    [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n                <div *ngIf=\"config.blurbTemplate && !config.blurb\" id=\"{{describedByValue}}\">\n                    <ng-container *ngTemplateOutlet=\"config.blurbTemplate\"></ng-container>\n                </div>\n                <div class=\"invalid-feedback\" role=\"alert\"\n                    *ngIf=\"control && !control.valid && (control.dirty || control.touched)\">\n                    <div *ngIf=\"control.errors?.required\">\n                        <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                            <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\">\n                            </use>\n                        </svg>\n                        {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n                    </div>\n                </div>\n\n\n                <editor #editor\n                    tagName=\"textarea\"\n                    [id]=\"config.elementId\"\n                    [formControlName]=\"config.name\"\n                    [init]=\"initOptions\"\n                    (onFocus)=\"triggerEvent('focus', $event);\"\n                    (onInit)=\"initEditor($event)\"></editor>\n            </div>\n        </div>\n    </ng-container>\n    <div *ngIf=\"mergeCodeTemplate\" class=\"merge-codes-container w-100 my-n3 me-n3 ms-0\">\n        <ng-template [ngTemplateOutlet]=\"mergeCodeTemplate\"\n            [ngTemplateOutletContext]=\"{ config: config }\"></ng-template>\n    </div>\n</div>",
      styles: ["janus-form-richtext .merge-codes-container{max-width:220px}janus-form-richtext .field-error-richtext{border:#bf3e24 solid 1.2px}\n"]
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['JANUS_VERSION']
    }]
  }, {
    type: i1$1.TranslateService
  }, {
    type: i0.ChangeDetectorRef
  }], {
    assetsPath: [{
      type: Input
    }],
    editor: [{
      type: ViewChild,
      args: ['editor']
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormRichtextComponent, {
    className: "JanusFormRichtextComponent",
    filePath: "janus/components/form-richtext/janus-form-richtext.component.ts",
    lineNumber: 12
  });
})();
const _c0$q = (a0, a1, a2) => ({
  "mb-2": a0,
  "mb-0": a1,
  "px-4 pt-2": a2
});
function JanusSubheadingComponent_h1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c0$q, ctx_r0.hasMargin, !ctx_r0.hasMargin, ctx_r0.isActionBarList));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function JanusSubheadingComponent_h2_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c0$q, ctx_r0.hasMargin, !ctx_r0.hasMargin, ctx_r0.isActionBarList));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function JanusSubheadingComponent_h3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c0$q, ctx_r0.hasMargin, !ctx_r0.hasMargin, ctx_r0.isActionBarList));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function JanusSubheadingComponent_h4_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c0$q, ctx_r0.hasMargin, !ctx_r0.hasMargin, ctx_r0.isActionBarList));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function JanusSubheadingComponent_h5_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c0$q, ctx_r0.hasMargin, !ctx_r0.hasMargin, ctx_r0.isActionBarList));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function JanusSubheadingComponent_h6_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c0$q, ctx_r0.hasMargin, !ctx_r0.hasMargin, ctx_r0.isActionBarList));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function JanusSubheadingComponent_h2_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c0$q, ctx_r0.hasMargin, !ctx_r0.hasMargin, ctx_r0.isActionBarList));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
class JanusSubheadingComponent {
  constructor() {
    this.level = null;
    this.text = '';
    this.hasMargin = false;
    this.isActionBarList = false;
  }
  ngOnInit() {}
  static {
    this.ɵfac = function JanusSubheadingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusSubheadingComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusSubheadingComponent,
      selectors: [["janus-subheading"]],
      inputs: {
        level: "level",
        text: "text",
        hasMargin: "hasMargin",
        isActionBarList: "isActionBarList"
      },
      standalone: false,
      decls: 8,
      vars: 7,
      consts: [[3, "ngSwitch"], ["class", "text-muted fs-7 text-uppercase text-spaced", 3, "ngClass", 4, "ngSwitchCase"], ["class", "text-muted fs-7 text-uppercase text-spaced", 3, "ngClass", 4, "ngSwitchDefault"], [1, "text-muted", "fs-7", "text-uppercase", "text-spaced", 3, "ngClass"]],
      template: function JanusSubheadingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementContainerStart(0, 0);
          i0.ɵɵtemplate(1, JanusSubheadingComponent_h1_1_Template, 2, 6, "h1", 1)(2, JanusSubheadingComponent_h2_2_Template, 2, 6, "h2", 1)(3, JanusSubheadingComponent_h3_3_Template, 2, 6, "h3", 1)(4, JanusSubheadingComponent_h4_4_Template, 2, 6, "h4", 1)(5, JanusSubheadingComponent_h5_5_Template, 2, 6, "h5", 1)(6, JanusSubheadingComponent_h6_6_Template, 2, 6, "h6", 1)(7, JanusSubheadingComponent_h2_7_Template, 2, 6, "h2", 2);
          i0.ɵɵelementContainerEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngSwitch", ctx.level);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", 1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", 2);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", 3);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", 4);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", 5);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", 6);
        }
      },
      dependencies: [i1.NgClass, i1.NgSwitch, i1.NgSwitchCase, i1.NgSwitchDefault],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusSubheadingComponent, [{
    type: Component,
    args: [{
      selector: 'janus-subheading',
      template: `<ng-container [ngSwitch]="level">
  <h1 *ngSwitchCase="1" class="text-muted fs-7 text-uppercase text-spaced" [ngClass]="{ 'mb-2': hasMargin, 'mb-0': !hasMargin, 'px-4 pt-2': isActionBarList }">{{ text }}</h1>
  <h2 *ngSwitchCase="2" class="text-muted fs-7 text-uppercase text-spaced" [ngClass]="{ 'mb-2': hasMargin, 'mb-0': !hasMargin, 'px-4 pt-2': isActionBarList }">{{ text }}</h2>
  <h3 *ngSwitchCase="3" class="text-muted fs-7 text-uppercase text-spaced" [ngClass]="{ 'mb-2': hasMargin, 'mb-0': !hasMargin, 'px-4 pt-2': isActionBarList }">{{ text }}</h3>
  <h4 *ngSwitchCase="4" class="text-muted fs-7 text-uppercase text-spaced" [ngClass]="{ 'mb-2': hasMargin, 'mb-0': !hasMargin, 'px-4 pt-2': isActionBarList }">{{ text }}</h4>
  <h5 *ngSwitchCase="5" class="text-muted fs-7 text-uppercase text-spaced" [ngClass]="{ 'mb-2': hasMargin, 'mb-0': !hasMargin, 'px-4 pt-2': isActionBarList }">{{ text }}</h5>
  <h6 *ngSwitchCase="6" class="text-muted fs-7 text-uppercase text-spaced" [ngClass]="{ 'mb-2': hasMargin, 'mb-0': !hasMargin, 'px-4 pt-2': isActionBarList }">{{ text }}</h6>
  <h2 *ngSwitchDefault class="text-muted fs-7 text-uppercase text-spaced" [ngClass]="{ 'mb-2': hasMargin, 'mb-0': !hasMargin, 'px-4 pt-2': isActionBarList }">{{ text }}</h2>
</ng-container>`,
      standalone: false
    }]
  }], () => [], {
    level: [{
      type: Input
    }],
    text: [{
      type: Input
    }],
    hasMargin: [{
      type: Input
    }],
    isActionBarList: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusSubheadingComponent, {
    className: "JanusSubheadingComponent",
    filePath: "janus/components/subheading/janus-subheading.component.ts",
    lineNumber: 16
  });
})();
const _c0$p = a0 => ({
  "indeterminate": a0
});
class JanusProgressSpinnerComponent extends ProgressSpinnerComponent {
  constructor(elementRef) {
    super(elementRef);
    this.strokeColor = '--bs-primary';
  }
  static {
    this.ɵfac = function JanusProgressSpinnerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusProgressSpinnerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusProgressSpinnerComponent,
      selectors: [["janus-progress-spinner"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 5,
      vars: 11,
      consts: [[1, "spinner", 3, "ngClass"], ["fill", "none"], [1, "visually-hidden"]],
      template: function JanusProgressSpinnerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg", 0);
          i0.ɵɵelement(1, "circle", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵnamespaceHTML();
          i0.ɵɵelementStart(2, "span", 2);
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "translate");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$p, ctx.config.mode === "indeterminate"));
          i0.ɵɵattribute("viewBox", ctx.config.viewBox);
          i0.ɵɵadvance();
          i0.ɵɵattribute("cx", ctx.config.cx)("cy", ctx.config.cy)("r", ctx.config.r)("stroke-width", ctx.config.strokeWidth);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, "misc.Loading..."), "\n");
        }
      },
      dependencies: [i1.NgClass, i1$1.TranslatePipe],
      styles: ["janus-progress-spinner{display:block;margin:0 auto}janus-progress-spinner .spinner circle{transition:.5s;stroke:var(--stroke-color);stroke-linecap:round;stroke-dasharray:var(--stroke-dasharray)}janus-progress-spinner .spinner:not(.indeterminate){transform:rotate(-90deg)}janus-progress-spinner .spinner.indeterminate{animation:rotate 2s linear infinite}janus-progress-spinner .spinner.indeterminate circle{animation:dash 1.5s ease-in-out infinite}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:var(--stroke-dasharray-0);stroke-dashoffset:var(--stroke-dashoffset-0)}50%{stroke-dasharray:var(--stroke-dasharray-50);stroke-dashoffset:var(--stroke-dashoffset-50)}to{stroke-dasharray:var(--stroke-dasharray-100);stroke-dashoffset:var(--stroke-dashoffset-100)}}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusProgressSpinnerComponent, [{
    type: Component,
    args: [{
      selector: 'janus-progress-spinner',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<svg \n    class=\"spinner\" \n    [ngClass]=\"{ 'indeterminate': config.mode === 'indeterminate' }\" \n    [attr.viewBox]=\"config.viewBox\"\n>\n    <circle \n        fill=\"none\" \n        [attr.cx]=\"config.cx\" \n        [attr.cy]=\"config.cy\" \n        [attr.r]=\"config.r\" \n        [attr.stroke-width]=\"config.strokeWidth\"\n    >\n    </circle>\n</svg>\n\n<span class=\"visually-hidden\">\n    {{ 'misc.Loading...' | translate }}\n</span>\n",
      styles: ["janus-progress-spinner{display:block;margin:0 auto}janus-progress-spinner .spinner circle{transition:.5s;stroke:var(--stroke-color);stroke-linecap:round;stroke-dasharray:var(--stroke-dasharray)}janus-progress-spinner .spinner:not(.indeterminate){transform:rotate(-90deg)}janus-progress-spinner .spinner.indeterminate{animation:rotate 2s linear infinite}janus-progress-spinner .spinner.indeterminate circle{animation:dash 1.5s ease-in-out infinite}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:var(--stroke-dasharray-0);stroke-dashoffset:var(--stroke-dashoffset-0)}50%{stroke-dasharray:var(--stroke-dasharray-50);stroke-dashoffset:var(--stroke-dashoffset-50)}to{stroke-dasharray:var(--stroke-dasharray-100);stroke-dashoffset:var(--stroke-dashoffset-100)}}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusProgressSpinnerComponent, {
    className: "JanusProgressSpinnerComponent",
    filePath: "janus/components/progress-spinner/janus-progress-spinner.component.ts",
    lineNumber: 11
  });
})();
const _c0$o = (a0, a1, a2) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2
});
const _c1$j = a0 => ({
  "visually-hidden": a0
});
const _c2$e = a0 => ({
  field_name: a0
});
const _c3$a = (a0, a1) => ({
  "last mb-0": a0,
  "mb-3": a1
});
const _c4$9 = a0 => ({
  "row": a0
});
const _c5$7 = (a0, a1) => ({
  "field-label-has-blurb": a0,
  "visually-hidden": a1
});
const _c6$6 = a0 => ({
  "text-muted": a0
});
const _c7$3 = (a0, a1) => ({
  "drag-active": a0,
  "mb-4": a1
});
const _c8$2 = a0 => ({
  "item": a0,
  isItem: false
});
const _c9$2 = (a0, a1, a2) => ({
  "uploading": a0,
  "error-state": a1,
  "mb-3": a2
});
const _c10$2 = a0 => ({
  item: a0,
  isItem: true
});
function JanusFormFileUploadComponent_ng_container_3_div_1_div_6_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c2$e, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormFileUploadComponent_ng_container_3_div_1_div_6_ng_container_4_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "misc.Upload Failed - Too big"), " ");
  }
}
function JanusFormFileUploadComponent_ng_container_3_div_1_div_6_ng_container_4_span_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "button", 23);
    i0.ɵɵlistener("click", function JanusFormFileUploadComponent_ng_container_3_div_1_div_6_ng_container_4_span_2_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r0.retryUpload());
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "misc.Upload Failed"), " - ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 4, "misc.Try again"));
  }
}
function JanusFormFileUploadComponent_ng_container_3_div_1_div_6_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormFileUploadComponent_ng_container_3_div_1_div_6_ng_container_4_span_1_Template, 3, 3, "span", 20)(2, JanusFormFileUploadComponent_ng_container_3_div_1_div_6_ng_container_4_span_2_Template, 6, 6, "span", 21);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.maxFileSize);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.api);
  }
}
function JanusFormFileUploadComponent_ng_container_3_div_1_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 19);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, JanusFormFileUploadComponent_ng_container_3_div_1_div_6_span_3_Template, 3, 6, "span", 20)(4, JanusFormFileUploadComponent_ng_container_3_div_1_div_6_ng_container_4_Template, 3, 2, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isMultiUploadMode);
  }
}
function JanusFormFileUploadComponent_ng_container_3_div_1_ng_template_7_Template(rf, ctx) {}
function JanusFormFileUploadComponent_ng_container_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "label", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵtemplate(6, JanusFormFileUploadComponent_ng_container_3_div_1_div_6_Template, 5, 3, "div", 16)(7, JanusFormFileUploadComponent_ng_container_3_div_1_ng_template_7_Template, 0, 0, "ng-template", 17);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const field_r3 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(14, _c0$o, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild, !ctx_r0.config.lastChild))("formGroup", ctx_r0.group);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "-label");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c1$j, ctx_r0.config.hideLabel));
    i0.ɵɵattribute("aria-required", ctx_r0.isRequired);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 12, ctx_r0.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched))("isRequired", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", field_r3);
  }
}
function JanusFormFileUploadComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormFileUploadComponent_ng_container_3_div_1_Template, 8, 20, "div", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.hideField);
  }
}
function JanusFormFileUploadComponent_ng_template_4_dl_0_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c6$6, ctx_r0.control.valid || !(ctx_r0.control.dirty || ctx_r0.control.touched)));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, "misc.required_indicator"));
  }
}
function JanusFormFileUploadComponent_ng_template_4_dl_0_ng_template_7_Template(rf, ctx) {}
function JanusFormFileUploadComponent_ng_template_4_dl_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dl", 25)(1, "div", 26)(2, "dt", 27);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, JanusFormFileUploadComponent_ng_template_4_dl_0_span_5_Template, 3, 6, "span", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "dd", 29);
    i0.ɵɵtemplate(7, JanusFormFileUploadComponent_ng_template_4_dl_0_ng_template_7_Template, 0, 0, "ng-template", 17);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const field_r3 = i0.ɵɵreference(7);
    i0.ɵɵproperty("formGroup", ctx_r0.group)("ngClass", i0.ɵɵpureFunction2(9, _c3$a, ctx_r0.config.lastChild, !ctx_r0.config.lastChild));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c4$9, !ctx_r0.config.stacked));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c5$7, ctx_r0.config.blurb, ctx_r0.config.hideLabel));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, ctx_r0.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", field_r3);
  }
}
function JanusFormFileUploadComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormFileUploadComponent_ng_template_4_dl_0_Template, 8, 17, "dl", 24);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.hideField);
  }
}
function JanusFormFileUploadComponent_ng_template_6_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 34);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormFileUploadComponent_ng_template_6_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormFileUploadComponent_ng_template_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, JanusFormFileUploadComponent_ng_template_6_div_1_ng_container_1_Template, 1, 0, "ng-container", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.config.blurbTemplate);
  }
}
function JanusFormFileUploadComponent_ng_template_6_ng_container_3_1_ng_template_0_Template(rf, ctx) {}
function JanusFormFileUploadComponent_ng_template_6_ng_container_3_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormFileUploadComponent_ng_template_6_ng_container_3_1_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const uploadField_r4 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", uploadField_r4);
  }
}
function JanusFormFileUploadComponent_ng_template_6_ng_container_3_2_ng_template_0_Template(rf, ctx) {}
function JanusFormFileUploadComponent_ng_template_6_ng_container_3_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormFileUploadComponent_ng_template_6_ng_container_3_2_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const uploadProcess_r5 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngTemplateOutlet", uploadProcess_r5);
  }
}
function JanusFormFileUploadComponent_ng_template_6_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormFileUploadComponent_ng_template_6_ng_container_3_1_Template, 1, 1, null, 20)(2, JanusFormFileUploadComponent_ng_template_6_ng_container_3_2_Template, 1, 1, null, 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.uploadFiles == null ? null : ctx_r0.uploadFiles.length) || ctx_r0.isErrorItem(ctx_r0.firstItem));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.uploadFiles.length && ctx_r0.isProgressItem(ctx_r0.firstItem));
  }
}
function JanusFormFileUploadComponent_ng_template_6_ng_container_4_ng_template_1_Template(rf, ctx) {}
function JanusFormFileUploadComponent_ng_template_6_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormFileUploadComponent_ng_template_6_ng_container_4_ng_template_1_Template, 0, 0, "ng-template", 17);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const uploadField_r4 = i0.ɵɵreference(9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", uploadField_r4);
  }
}
function JanusFormFileUploadComponent_ng_template_6_5_ng_template_0_Template(rf, ctx) {}
function JanusFormFileUploadComponent_ng_template_6_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormFileUploadComponent_ng_template_6_5_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const uploadFile_r6 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngTemplateOutlet", uploadFile_r6);
  }
}
function JanusFormFileUploadComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormFileUploadComponent_ng_template_6_div_0_Template, 3, 6, "div", 31)(1, JanusFormFileUploadComponent_ng_template_6_div_1_Template, 2, 2, "div", 32);
    i0.ɵɵelementStart(2, "div", 33);
    i0.ɵɵtemplate(3, JanusFormFileUploadComponent_ng_template_6_ng_container_3_Template, 3, 2, "ng-container", 20)(4, JanusFormFileUploadComponent_ng_template_6_ng_container_4_Template, 2, 1, "ng-container", 20)(5, JanusFormFileUploadComponent_ng_template_6_5_Template, 1, 1, null, 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurbTemplate && !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "upload_field_" + ctx_r0.elementId);
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isMultiUploadMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isMultiUploadMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isMultiUploadMode || ctx_r0.isSuccessItem(ctx_r0.firstItem));
  }
}
function JanusFormFileUploadComponent_ng_template_8_button_0_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 43);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "fileSize");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "misc.Max file size:"), "\u00A0", i0.ɵɵpipeBind1(3, 4, ctx_r0.fileUploadConfig.maxFileSize), " ");
  }
}
function JanusFormFileUploadComponent_ng_template_8_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37, 7)(2, "span", 38);
    i0.ɵɵlistener("dragenter", function JanusFormFileUploadComponent_ng_template_8_button_0_Template_span_dragenter_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragEnter());
    })("dragover", function JanusFormFileUploadComponent_ng_template_8_button_0_Template_span_dragover_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragOver());
    })("dragleave", function JanusFormFileUploadComponent_ng_template_8_button_0_Template_span_dragleave_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragLeave());
    })("drop", function JanusFormFileUploadComponent_ng_template_8_button_0_Template_span_drop_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDrop());
    });
    i0.ɵɵelementStart(3, "span", 39);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 40);
    i0.ɵɵelement(5, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(6, "span", 41);
    i0.ɵɵtemplate(7, JanusFormFileUploadComponent_ng_template_8_button_0_span_7_Template, 4, 6, "span", 42);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const flow_r8 = i0.ɵɵreference(1);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "_modal-container" : "_container", "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c7$3, ctx_r0.dragActive, ctx_r0.uploadFiles.length && ctx_r0.isMultiUploadMode && !ctx_r0.config.readOnly))("flowAttributes", ctx_r0.flowAttributes)("flow", flow_r8.flowJs);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("flow", flow_r8.flowJs);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-cloud-upload", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.fileUploadText, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fileUploadConfig.maxFileSize);
  }
}
function JanusFormFileUploadComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormFileUploadComponent_ng_template_8_button_0_Template, 8, 13, "button", 36);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.readOnly);
  }
}
function JanusFormFileUploadComponent_ng_template_10_ng_template_1_Template(rf, ctx) {}
function JanusFormFileUploadComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵtemplate(1, JanusFormFileUploadComponent_ng_template_10_ng_template_1_Template, 0, 0, "ng-template", 45);
    i0.ɵɵelementStart(2, "p", 46);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 47);
    i0.ɵɵlistener("click", function JanusFormFileUploadComponent_ng_template_10_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.cancelUpload(ctx_r0.firstItem));
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const spinner_r10 = i0.ɵɵreference(15);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", spinner_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c8$2, ctx_r0.firstItem));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(4, 5, "misc.Uploading"), "\u00A0", ctx_r0.firstItem == null ? null : ctx_r0.firstItem.fileSelected.name, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 7, "misc.Cancel"), " ");
  }
}
function JanusFormFileUploadComponent_ng_template_12_janus_subheading_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-subheading", 51);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hasMargin", true)("id", ctx_r0.elementId + "_list_label")("text", i0.ɵɵpipeBind1(1, 3, "misc.Files"));
  }
}
function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 58);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 59);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-file", null, "xlink");
  }
}
function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 60);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 59);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-file-download", null, "xlink");
  }
}
function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 61);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 59);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-file-alert", null, "xlink");
  }
}
function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 62);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "misc.Uploading"));
  }
}
function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 62);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "misc.download file"));
  }
}
function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_8_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r12 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" - ", item_r12.statusMessage, " ");
  }
}
function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 63);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_8_ng_container_4_Template, 2, 1, "ng-container", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "misc.Upload Failed"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r12.statusMessage);
  }
}
function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 64);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "fileExtension");
    i0.ɵɵelement(4, "i", 65);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "fileSize");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, item_r12 == null ? null : item_r12.fileSelected.name), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, item_r12 == null ? null : item_r12.fileSelected.size), " ");
  }
}
function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_12_ng_container_1_ng_template_2_Template(rf, ctx) {}
function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_12_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 66);
    i0.ɵɵtemplate(2, JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_12_ng_container_1_ng_template_2_Template, 0, 0, "ng-template", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r12 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(3);
    const spinner_r10 = i0.ɵɵreference(15);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", spinner_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c10$2, item_r12));
  }
}
function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_12_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 67);
    i0.ɵɵlistener("click", function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_12_ng_container_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r13);
      const item_r12 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.deleteFile(item_r12));
    });
    i0.ɵɵelementStart(2, "span", 68);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 40);
    i0.ɵɵelement(4, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "span", 62);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-trash", null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 2, "misc.delete file"));
  }
}
function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_12_ng_container_1_Template, 3, 4, "ng-container", 20)(2, JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_12_ng_container_2_Template, 8, 4, "ng-container", 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isMultiUploadMode && ctx_r0.isProgressItem(item_r12));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isMultiUploadMode || ctx_r0.isMultiUploadMode && !ctx_r0.isProgressItem(item_r12));
  }
}
function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 54)(1, "button", 55);
    i0.ɵɵlistener("click", function JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_Template_button_click_1_listener() {
      const item_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.downloadFile(item_r12));
    });
    i0.ɵɵtemplate(2, JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_2_Template, 4, 1, "ng-container", 20)(3, JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_3_Template, 4, 1, "ng-container", 20)(4, JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_4_Template, 4, 1, "ng-container", 20);
    i0.ɵɵelementStart(5, "span", 56);
    i0.ɵɵtemplate(6, JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_6_Template, 4, 3, "ng-container", 20)(7, JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_7_Template, 4, 3, "ng-container", 20)(8, JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_8_Template, 5, 4, "ng-container", 20);
    i0.ɵɵelementStart(9, "div", 57);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_11_Template, 7, 6, "ng-container", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(12, JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_ng_container_12_Template, 3, 2, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r12 = ctx.$implicit;
    const last_r14 = ctx.last;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(11, _c9$2, ctx_r0.isProgressItem(item_r12), ctx_r0.isErrorItem(item_r12), ctx_r0.isMultiUploadMode && !last_r14));
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-disabled", !ctx_r0.isSuccessItem(item_r12));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isErrorItem(item_r12));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isSuccessItem(item_r12));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isErrorItem(item_r12));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isProgressItem(item_r12));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isSuccessItem(item_r12));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isErrorItem(item_r12));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r12 == null ? null : item_r12.fileSelected.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isErrorItem(item_r12));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.readOnly);
  }
}
function JanusFormFileUploadComponent_ng_template_12_ul_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 52);
    i0.ɵɵtemplate(1, JanusFormFileUploadComponent_ng_template_12_ul_1_li_1_Template, 13, 15, "li", 53);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-labelledby", ctx_r0.isMultiUploadMode && !ctx_r0.config.readOnly ? ctx_r0.elementId + "_list_label" : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.uploadFiles);
  }
}
function JanusFormFileUploadComponent_ng_template_12_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 69);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.fileUploadConfig.emptyFileListMessage), " ");
  }
}
function JanusFormFileUploadComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormFileUploadComponent_ng_template_12_janus_subheading_0_Template, 2, 5, "janus-subheading", 48)(1, JanusFormFileUploadComponent_ng_template_12_ul_1_Template, 2, 2, "ul", 49)(2, JanusFormFileUploadComponent_ng_template_12_p_2_Template, 3, 3, "p", 50);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.uploadFiles.length && ctx_r0.isMultiUploadMode && !ctx_r0.config.readOnly);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.uploadFiles.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.uploadFiles.length && ctx_r0.config.readOnly);
  }
}
function JanusFormFileUploadComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 70);
    i0.ɵɵelement(1, "janus-progress-spinner", 71);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r15 = ctx.item;
    const isItem_r16 = ctx.isItem;
    i0.ɵɵproperty("ngClass", isItem_r16 ? "icon-wrapper" : "mb-2");
    i0.ɵɵadvance();
    i0.ɵɵproperty("strokeWidth", 2)("radius", 7)("progress", item_r15.uploadProgress);
  }
}
class JanusFormFileUploadComponent extends FormFileUploadComponent {
  constructor() {
    super(...arguments);
    this.assetsPath = '/app/assets/';
    this.fileUploadHTML = browseString => `<span class="btn btn-link p-0 mx-1 border-0 text-decoration-none button-like bold">${browseString}</span>`;
  }
  setDescribedBy() {
    let modal = this.modal ? 'modal' : '';
    this.describedByValue = this.config.blurb || this.config.blurbTemplate ? this.config.elementId + modal + '-blurb' : null;
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormFileUploadComponent_BaseFactory;
      return function JanusFormFileUploadComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormFileUploadComponent_BaseFactory || (ɵJanusFormFileUploadComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormFileUploadComponent)))(__ngFactoryType__ || JanusFormFileUploadComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormFileUploadComponent,
      selectors: [["janus-form-file-upload"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 16,
      vars: 7,
      consts: [["flow", "flow"], ["readOnly", ""], ["field", ""], ["uploadField", ""], ["uploadProcess", ""], ["uploadFile", ""], ["spinner", ""], ["fileUploadWrapper", ""], [3, "flowConfig"], [3, "id"], [4, "ngIf", "ngIfElse"], ["class", "janus-field", 3, "ngClass", "formGroup", 4, "ngIf"], [1, "janus-field", 3, "ngClass", "formGroup"], [1, "d-flex", "form-label", 3, "ngClass", "id"], [3, "hasError", "isRequired"], [1, "field-widget"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], [3, "ngTemplateOutlet"], ["role", "alert", 1, "invalid-feedback"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [4, "ngIf"], ["class", "d-inline-flex", 4, "ngIf"], [1, "d-inline-flex"], ["type", "button", 1, "btn", "btn-link", "btn-sm", "p-0", "ms-1", "border-0", "button-like", "text-danger", 3, "click"], ["class", "container-fluid p-0", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "container-fluid", "p-0", 3, "formGroup", "ngClass"], [3, "ngClass"], [1, "col-3", "label", "form-label", 3, "ngClass"], ["class", "fw-normal ms-1", 3, "ngClass", 4, "ngIf"], [1, "col-9", "field-widget", "widget-readonly", "field-widget-text"], [1, "fw-normal", "ms-1", 3, "ngClass"], ["class", "form-text", 3, "id", "innerHTML", 4, "ngIf"], [3, "id", 4, "ngIf"], ["aria-live", "polite", 3, "id"], [1, "form-text", 3, "id", "innerHTML"], [4, "ngTemplateOutlet"], ["type", "button", "flowButton", "", "class", "file-upload-wrapper p-0 border-1 rounded w-100", 3, "ngClass", "flowAttributes", "flow", "id", 4, "ngIf"], ["type", "button", "flowButton", "", 1, "file-upload-wrapper", "p-0", "border-1", "rounded", "w-100", 3, "ngClass", "flowAttributes", "flow", "id"], ["flowDrop", "", 1, "p-3", "d-flex", "flex-column", "justify-content-center", "align-items-center", 3, "dragenter", "dragover", "dragleave", "drop", "flow"], [1, "file-upload-icon", "d-flex", "justify-content-center", "align-items-center", "rounded-circle", "mb-2"], ["width", "1.25rem", "height", "1.25rem"], [1, "file-upload-text", "d-flex", "mt-1", "mb-2", 3, "innerHTML"], ["class", "file-upload-blurb text-muted small", 4, "ngIf"], [1, "file-upload-blurb", "text-muted", "small"], [1, "file-uploading-wrapper", "p-3", "border-1", "rounded", "d-flex", "flex-column", "align-items-center"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "file-upload-text", "text-truncate", "w-100", "mt-1", "mb-2", "text-center"], ["type", "button", 1, "btn", "btn-link", "btn-sm", "p-0", "m-0", "border-0", "button-like", 3, "click"], [3, "hasMargin", "id", "text", 4, "ngIf"], ["class", "p-0 m-0", 4, "ngIf"], ["class", "m-0", 4, "ngIf"], [3, "hasMargin", "id", "text"], [1, "p-0", "m-0"], ["class", "file-selected-wrapper d-flex rounded overflow-hidden", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "file-selected-wrapper", "d-flex", "rounded", "overflow-hidden", 3, "ngClass"], ["type", "button", 1, "right-action", "border-0", "p-0", "bg-transparent", "d-flex", "align-items-center", "flex-grow-1", "overflow-hidden", 3, "click"], [1, "file-information", "px-3", "overflow-hidden", "text-start"], [1, "file-name", "d-block", "text-truncate", "small"], [1, "icon-wrapper", "file", "d-flex", "align-items-center", "justify-content-center", "flex-shrink-0"], [1, "icon-lg-font-size"], [1, "icon-wrapper", "download", "d-none", "align-items-center", "justify-content-center", "flex-shrink-0"], [1, "icon-wrapper", "error", "d-flex", "align-items-center", "justify-content-center", "flex-shrink-0"], [1, "visually-hidden"], [1, "text-danger", "fs-4"], [1, "file-description", "d-flex", "align-items-center", "small", "text-uppercase", "text-muted"], [1, "dot-separator", "mx-2", "rounded"], [1, "left-action", "border-0", "p-0", "bg-transparent", "flex-shrink-0"], ["type", "button", 1, "left-action", "border-0", "p-0", "bg-transparent", "flex-shrink-0", 3, "click"], [1, "icon-wrapper", "d-flex", "align-items-center", "justify-content-center", "flex-shrink-0"], [1, "m-0"], [1, "file-uploading-icon", "d-flex", "justify-content-center", "align-items-center", "rounded-circle", 3, "ngClass"], ["mode", "determinate", 1, "d-flex", 3, "strokeWidth", "radius", "progress"]],
      template: function JanusFormFileUploadComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementContainer(0, 8, 0);
          i0.ɵɵelementStart(2, "div", 9);
          i0.ɵɵtemplate(3, JanusFormFileUploadComponent_ng_container_3_Template, 2, 1, "ng-container", 10)(4, JanusFormFileUploadComponent_ng_template_4_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, JanusFormFileUploadComponent_ng_template_6_Template, 6, 7, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(8, JanusFormFileUploadComponent_ng_template_8_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(10, JanusFormFileUploadComponent_ng_template_10_Template, 8, 11, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(12, JanusFormFileUploadComponent_ng_template_12_Template, 3, 3, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(14, JanusFormFileUploadComponent_ng_template_14_Template, 2, 4, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const readOnly_r17 = i0.ɵɵreference(5);
          i0.ɵɵproperty("flowConfig", ctx.flowConfig);
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate2("id", "", ctx.config.elementId, "", ctx.modal ? "modal" : "", "");
          i0.ɵɵattribute("aria-labelledby", ctx.config.elementId + (ctx.modal ? "modal" : "") + "-label");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.config.readOnly)("ngIfElse", readOnly_r17);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i5.ButtonDirective, i5.DropDirective, i5.FlowDirective, JanusSubheadingComponent, JanusProgressSpinnerComponent, JanusRequiredComponent, i1$1.TranslatePipe, FileSizePipe, FileExtensionPipe, SafeHtmlPipe],
      styles: ["janus-form-file-upload .button-like{min-width:fit-content}janus-form-file-upload .button-like.bold{font-weight:600}janus-form-file-upload .file-list-label{letter-spacing:.2rem}janus-form-file-upload .file-upload-wrapper,janus-form-file-upload .file-uploading-wrapper{border-style:dashed;border-color:var(--bs-gray-400);background-color:var(--bs-gray-100)}janus-form-file-upload .file-upload-wrapper .file-upload-icon,janus-form-file-upload .file-upload-wrapper .file-uploading-icon,janus-form-file-upload .file-uploading-wrapper .file-upload-icon,janus-form-file-upload .file-uploading-wrapper .file-uploading-icon{height:2.75rem;width:2.75rem;background-color:var(--bs-gray-200);color:var(--bs-gray-600)}janus-form-file-upload .file-upload-wrapper .file-upload-text,janus-form-file-upload .file-uploading-wrapper .file-upload-text{font-weight:600}janus-form-file-upload .file-upload-wrapper .file-upload-text>span,janus-form-file-upload .file-uploading-wrapper .file-upload-text>span{min-height:0}janus-form-file-upload .file-upload-wrapper.drag-active,janus-form-file-upload .file-upload-wrapper:hover{background-color:#e7eff8}janus-form-file-upload .file-upload-wrapper.drag-active .file-upload-icon,janus-form-file-upload .file-upload-wrapper:hover .file-upload-icon{background-color:var(--bs-primary);color:#e7eff8}janus-form-file-upload .file-selected-wrapper{background-color:var(--bs-gray-200)}janus-form-file-upload .file-selected-wrapper.error-state{background-color:#f6e5e4;color:#a51c32}janus-form-file-upload .file-selected-wrapper.error-state .right-action .icon-wrapper{background-color:#a51c32;color:var(--bs-white)}janus-form-file-upload .file-selected-wrapper.error-state .right-action .file-name{color:#000}janus-form-file-upload .file-selected-wrapper .icon-wrapper{width:4.5rem;height:4.5rem;color:var(--bs-gray-600)}janus-form-file-upload .file-selected-wrapper .right-action .icon-wrapper{background-color:var(--bs-gray-300)}janus-form-file-upload .file-selected-wrapper .right-action .file-information .file-description .dot-separator{width:.25rem;height:.25rem;background-color:var(--bs-gray-500)}janus-form-file-upload .file-selected-wrapper .left-action:hover .icon-wrapper,janus-form-file-upload .file-selected-wrapper .left-action:focus .icon-wrapper{color:var(--bs-red)}janus-form-file-upload .file-selected-wrapper:hover:not(.uploading):not(.error-state),janus-form-file-upload .file-selected-wrapper:focus:not(.uploading):not(.error-state){background-color:#e7eff8}janus-form-file-upload .file-selected-wrapper:hover:not(.uploading):not(.error-state) .right-action .icon-wrapper,janus-form-file-upload .file-selected-wrapper:focus:not(.uploading):not(.error-state) .right-action .icon-wrapper{background-color:var(--bs-primary);color:var(--bs-white)}janus-form-file-upload .file-selected-wrapper:hover:not(.uploading):not(.error-state) .right-action .icon-wrapper.file,janus-form-file-upload .file-selected-wrapper:focus:not(.uploading):not(.error-state) .right-action .icon-wrapper.file{display:none!important}janus-form-file-upload .file-selected-wrapper:hover:not(.uploading):not(.error-state) .right-action .icon-wrapper.download,janus-form-file-upload .file-selected-wrapper:focus:not(.uploading):not(.error-state) .right-action .icon-wrapper.download{display:flex!important}janus-form-file-upload .file-selected-wrapper:hover:not(.uploading):not(.error-state) .right-action .file-information .file-name,janus-form-file-upload .file-selected-wrapper:focus:not(.uploading):not(.error-state) .right-action .file-information .file-name{color:var(--bs-primary)}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormFileUploadComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-file-upload',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<ng-container #flow=\"flow\" [flowConfig]=\"flowConfig\"></ng-container>\n\n<div id=\"{{ config.elementId }}{{ modal ? 'modal' : '' }}\"\n     [attr.aria-labelledby]=\"config.elementId + (modal ? 'modal' : '') + '-label'\"\n>\n    <ng-container *ngIf=\"!config.readOnly else readOnly\">\n        \n            <div class=\"janus-field\" *ngIf=\"!config.hideField\" [ngClass]=\"{ 'is-invalid': !control.valid && (control.dirty || control.touched), 'last': config.lastChild, 'mb-4': !config.lastChild }\" [formGroup]=\"group\">\n                <label [ngClass]=\"{'visually-hidden': config.hideLabel}\" class=\"d-flex form-label\" id=\"{{ config.elementId }}{{ modal ? 'modal' : '' }}-label\" [attr.aria-required]=\"isRequired\">\n                    {{ config.label | translate }}<janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\"></janus-required>\n                </label>\n\n                <div class=\"field-widget\">\n                    <div *ngIf=\"!control.valid && (control.dirty || control.touched)\" class=\"invalid-feedback\" role=\"alert\">\n                        <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                            <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                        </svg>\n\n                        <span *ngIf=\"control.errors.required\">\n                            {{ 'misc.Field is required' | translate: { field_name: translatedLabel } }}\n                        </span>\n\n                        <ng-container *ngIf=\"!isMultiUploadMode\">\n                            <span *ngIf=\"control.errors.maxFileSize\">\n                                {{ 'misc.Upload Failed - Too big' | translate }}\n                            </span>\n                            <span *ngIf=\"control.errors.api\" class=\"d-inline-flex\">\n                            {{ 'misc.Upload Failed' | translate }} -\n                                <button type=\"button\" class=\"btn btn-link btn-sm p-0 ms-1 border-0 button-like text-danger\" (click)=\"retryUpload()\">{{ 'misc.Try again' | translate }}</button>\n                            </span>\n                        </ng-container>  \n                    </div>\n                    <ng-template [ngTemplateOutlet]=\"field\"></ng-template>\n                </div>\n            </div>\n    </ng-container>\n\n    <ng-template #readOnly>\n        <dl *ngIf=\"!config.hideField\" class=\"container-fluid p-0\" [formGroup]=\"group\" [ngClass]=\"{'last mb-0': config.lastChild, 'mb-3' : !config.lastChild}\">\n            <div [ngClass]=\"{'row': !config.stacked}\">\n                <dt class=\"col-3 label form-label\" [ngClass]=\"{'field-label-has-blurb': config.blurb, 'visually-hidden': config.hideLabel}\">\n                    {{config.label | translate}}<span class=\"fw-normal ms-1\" [ngClass]=\"{'text-muted': (control.valid || !(control.dirty || control.touched))}\" *ngIf=\"isRequired\">{{ 'misc.required_indicator' | translate }}</span>\n                </dt>\n                <dd class=\"col-9 field-widget widget-readonly field-widget-text\">\n                    <ng-template [ngTemplateOutlet]=\"field\"></ng-template>\n                </dd>\n            </div>\n        </dl>\n    </ng-template>\n\n    <ng-template #field>\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div *ngIf=\"config.blurbTemplate && !config.blurb\" id=\"{{describedByValue}}\">\n            <ng-container *ngTemplateOutlet=\"config.blurbTemplate\"></ng-container>\n        </div>\n\n        <div [id]=\"'upload_field_'+elementId\" [attr.aria-describedby]=\"describedByValue\" aria-live=\"polite\">\n            \n            <ng-container *ngIf=\"!isMultiUploadMode\">\n                <ng-template *ngIf=\"!this.uploadFiles?.length || isErrorItem(this.firstItem)\" [ngTemplateOutlet]=\"uploadField\"></ng-template>\n                <ng-template *ngIf=\"this.uploadFiles.length && isProgressItem(this.firstItem)\" [ngTemplateOutlet]=\"uploadProcess\"></ng-template>\n            </ng-container>\n            \n            <ng-container *ngIf=\"isMultiUploadMode\">\n                <ng-template [ngTemplateOutlet]=\"uploadField\"></ng-template>\n            </ng-container>\n\n            <ng-template\n                    *ngIf=\"isMultiUploadMode || isSuccessItem(this.firstItem)\"\n                    [ngTemplateOutlet]=\"uploadFile\">\n            </ng-template>\n            \n        </div>\n    </ng-template>\n\n    <ng-template #uploadField>\n        <button type=\"button\" *ngIf=\"!config.readOnly\" #fileUploadWrapper flowButton class=\"file-upload-wrapper p-0 border-1 rounded w-100\" [ngClass]=\"{ 'drag-active': dragActive, 'mb-4': uploadFiles.length && isMultiUploadMode && !config.readOnly }\" [flowAttributes]=\"flowAttributes\" [flow]=\"flow.flowJs\" id=\"{{ config.elementId }}{{ modal ? '_modal-container' : '_container' }}\">\n                <span flowDrop class=\"p-3 d-flex flex-column justify-content-center align-items-center\" [flow]=\"flow.flowJs\" (dragenter)=\"onDragEnter()\" (dragover)=\"onDragOver()\" (dragleave)=\"onDragLeave()\" (drop)=\"onDrop()\">\n                    <span class=\"file-upload-icon d-flex justify-content-center align-items-center rounded-circle mb-2\">\n                        <svg width=\"1.25rem\" height=\"1.25rem\">\n                            <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-cloud-upload'\"></use>\n                        </svg>\n                    </span>\n                    \n                    <span class=\"file-upload-text d-flex mt-1 mb-2\" [innerHTML]=\"fileUploadText\"></span>\n        \n                    <span *ngIf=\"fileUploadConfig.maxFileSize\" class=\"file-upload-blurb text-muted small\">\n                        {{ 'misc.Max file size:' | translate }}&nbsp;{{ fileUploadConfig.maxFileSize | fileSize }}\n                    </span>\n                </span>\n        </button>\n    </ng-template>\n\n    <ng-template #uploadProcess>\n        <div class=\"file-uploading-wrapper p-3 border-1 rounded d-flex flex-column align-items-center\">\n            <ng-template [ngTemplateOutlet]=\"spinner\" [ngTemplateOutletContext]=\"{'item': firstItem, isItem: false}\"></ng-template>\n\n            <p class=\"file-upload-text text-truncate w-100 mt-1 mb-2 text-center\">\n                {{ 'misc.Uploading' | translate }}&nbsp;{{ this.firstItem?.fileSelected.name }}\n            </p>\n\n            <button type=\"button\" class=\"btn btn-link btn-sm p-0 m-0 border-0 button-like\" (click)=\"cancelUpload(this.firstItem)\">\n                {{ 'misc.Cancel' | translate }}\n            </button>\n        </div>\n    </ng-template>\n\n    <ng-template #uploadFile>\n        <janus-subheading\n            *ngIf=\"uploadFiles.length && isMultiUploadMode && !config.readOnly\"\n            [hasMargin]=\"true\"\n            [id]=\"elementId + '_list_label'\"\n            [text]=\"'misc.Files' | translate\"></janus-subheading>\n\n        <ul *ngIf=\"uploadFiles.length\" class=\"p-0 m-0\" [attr.aria-labelledby]=\"isMultiUploadMode && !config.readOnly ? elementId + '_list_label' : null\">\n            <li\n                *ngFor=\"let item of uploadFiles; let last = last;\"\n                class=\"file-selected-wrapper d-flex rounded overflow-hidden\"\n                [ngClass]=\"{\n                    'uploading': isProgressItem(item),\n                    'error-state': isErrorItem(item),\n                    'mb-3': isMultiUploadMode && !last\n                }\"\n            >\n                <button type=\"button\"\n                        class=\"right-action border-0 p-0 bg-transparent d-flex align-items-center flex-grow-1 overflow-hidden\"\n                        (click)=\"downloadFile(item)\"\n                        [attr.aria-disabled]=\"!isSuccessItem(item)\"\n                >\n                    \n                    <ng-container *ngIf=\"!isErrorItem(item)\">\n                        <span class=\"icon-wrapper file d-flex align-items-center justify-content-center flex-shrink-0\">\n                            <svg class=\"icon-lg-font-size\">\n                                <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-file'\"></use>\n                            </svg>\n                        </span>\n                    </ng-container>\n\n                    <ng-container *ngIf=\"isSuccessItem(item)\">\n                        <span class=\"icon-wrapper download d-none align-items-center justify-content-center flex-shrink-0\">\n                            <svg class=\"icon-lg-font-size\">\n                                <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-file-download'\"></use>\n                            </svg>\n                        </span>\n                    </ng-container>\n\n                    <ng-container *ngIf=\"isErrorItem(item)\">\n                        <span class=\"icon-wrapper error d-flex align-items-center justify-content-center flex-shrink-0\">\n                            <svg class=\"icon-lg-font-size\">\n                                <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-file-alert'\"></use>\n                            </svg>\n                        </span>\n                    </ng-container>\n\n                    <span class=\"file-information px-3 overflow-hidden text-start\">\n                \n                        <ng-container *ngIf=\"isProgressItem(item)\">\n                            <span class=\"visually-hidden\">{{ 'misc.Uploading' | translate }}</span>\n                        </ng-container>\n                        \n                        <ng-container *ngIf=\"isSuccessItem(item)\">\n                            <span class=\"visually-hidden\">{{ 'misc.download file' | translate }}</span>\n                        </ng-container>\n                        \n                        <ng-container *ngIf=\"isErrorItem(item)\">\n                            <div class=\"text-danger fs-4\">\n                                {{ 'misc.Upload Failed' | translate }}\n                                <ng-container *ngIf=\"item.statusMessage\">\n                                    - {{ item.statusMessage }}\n                                </ng-container>\n                            </div>\n                        </ng-container>\n                        \n                        <div class=\"file-name d-block text-truncate small\">\n                            {{ item?.fileSelected.name }}\n                        </div>\n                        \n                        <ng-container *ngIf=\"!isErrorItem(item)\">\n                            <span class=\"file-description d-flex align-items-center small text-uppercase text-muted\">\n                                {{ item?.fileSelected.name | fileExtension }}\n                                <i class=\"dot-separator mx-2 rounded\"></i>\n                                {{ item?.fileSelected.size | fileSize }}\n                            </span>\n                        </ng-container>\n                        \n                    </span>\n                </button>\n\n                <ng-container *ngIf=\"!config.readOnly\">\n\n                    <ng-container *ngIf=\"isMultiUploadMode && isProgressItem(item)\">\n                        <div class=\"left-action border-0 p-0 bg-transparent flex-shrink-0\">\n                            <ng-template [ngTemplateOutlet]=\"spinner\" [ngTemplateOutletContext]=\"{item: item, isItem: true}\"></ng-template>\n                        </div>\n                    </ng-container>\n\n                    <ng-container *ngIf=\"!isMultiUploadMode || (isMultiUploadMode && !isProgressItem(item))\">\n                        <button type=\"button\" class=\"left-action border-0 p-0 bg-transparent flex-shrink-0\" (click)=\"deleteFile(item)\">\n                            <span class=\"icon-wrapper d-flex align-items-center justify-content-center flex-shrink-0\">\n                                <svg width=\"1.25rem\" height=\"1.25rem\">\n                                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-trash'\"></use>\n                                </svg>\n                                <span class=\"visually-hidden\">{{ 'misc.delete file' | translate }}</span>\n                            </span>\n                        </button>\n                    </ng-container>\n\n                </ng-container>\n            </li>\n        </ul>\n\n        <p *ngIf=\"!uploadFiles.length && config.readOnly\" class=\"m-0\">\n            {{ fileUploadConfig.emptyFileListMessage | translate }}\n        </p>\n    </ng-template>\n</div> \n\n<ng-template #spinner let-item=\"item\" let-isItem=\"isItem\">\n    <span class=\"file-uploading-icon d-flex justify-content-center align-items-center rounded-circle\" [ngClass]=\"isItem ? 'icon-wrapper' : 'mb-2'\">\n        <janus-progress-spinner class=\"d-flex\" mode=\"determinate\" [strokeWidth]=\"2\" [radius]=\"7\" [progress]=\"item.uploadProgress\"></janus-progress-spinner>\n    </span>\n</ng-template>\n",
      styles: ["janus-form-file-upload .button-like{min-width:fit-content}janus-form-file-upload .button-like.bold{font-weight:600}janus-form-file-upload .file-list-label{letter-spacing:.2rem}janus-form-file-upload .file-upload-wrapper,janus-form-file-upload .file-uploading-wrapper{border-style:dashed;border-color:var(--bs-gray-400);background-color:var(--bs-gray-100)}janus-form-file-upload .file-upload-wrapper .file-upload-icon,janus-form-file-upload .file-upload-wrapper .file-uploading-icon,janus-form-file-upload .file-uploading-wrapper .file-upload-icon,janus-form-file-upload .file-uploading-wrapper .file-uploading-icon{height:2.75rem;width:2.75rem;background-color:var(--bs-gray-200);color:var(--bs-gray-600)}janus-form-file-upload .file-upload-wrapper .file-upload-text,janus-form-file-upload .file-uploading-wrapper .file-upload-text{font-weight:600}janus-form-file-upload .file-upload-wrapper .file-upload-text>span,janus-form-file-upload .file-uploading-wrapper .file-upload-text>span{min-height:0}janus-form-file-upload .file-upload-wrapper.drag-active,janus-form-file-upload .file-upload-wrapper:hover{background-color:#e7eff8}janus-form-file-upload .file-upload-wrapper.drag-active .file-upload-icon,janus-form-file-upload .file-upload-wrapper:hover .file-upload-icon{background-color:var(--bs-primary);color:#e7eff8}janus-form-file-upload .file-selected-wrapper{background-color:var(--bs-gray-200)}janus-form-file-upload .file-selected-wrapper.error-state{background-color:#f6e5e4;color:#a51c32}janus-form-file-upload .file-selected-wrapper.error-state .right-action .icon-wrapper{background-color:#a51c32;color:var(--bs-white)}janus-form-file-upload .file-selected-wrapper.error-state .right-action .file-name{color:#000}janus-form-file-upload .file-selected-wrapper .icon-wrapper{width:4.5rem;height:4.5rem;color:var(--bs-gray-600)}janus-form-file-upload .file-selected-wrapper .right-action .icon-wrapper{background-color:var(--bs-gray-300)}janus-form-file-upload .file-selected-wrapper .right-action .file-information .file-description .dot-separator{width:.25rem;height:.25rem;background-color:var(--bs-gray-500)}janus-form-file-upload .file-selected-wrapper .left-action:hover .icon-wrapper,janus-form-file-upload .file-selected-wrapper .left-action:focus .icon-wrapper{color:var(--bs-red)}janus-form-file-upload .file-selected-wrapper:hover:not(.uploading):not(.error-state),janus-form-file-upload .file-selected-wrapper:focus:not(.uploading):not(.error-state){background-color:#e7eff8}janus-form-file-upload .file-selected-wrapper:hover:not(.uploading):not(.error-state) .right-action .icon-wrapper,janus-form-file-upload .file-selected-wrapper:focus:not(.uploading):not(.error-state) .right-action .icon-wrapper{background-color:var(--bs-primary);color:var(--bs-white)}janus-form-file-upload .file-selected-wrapper:hover:not(.uploading):not(.error-state) .right-action .icon-wrapper.file,janus-form-file-upload .file-selected-wrapper:focus:not(.uploading):not(.error-state) .right-action .icon-wrapper.file{display:none!important}janus-form-file-upload .file-selected-wrapper:hover:not(.uploading):not(.error-state) .right-action .icon-wrapper.download,janus-form-file-upload .file-selected-wrapper:focus:not(.uploading):not(.error-state) .right-action .icon-wrapper.download{display:flex!important}janus-form-file-upload .file-selected-wrapper:hover:not(.uploading):not(.error-state) .right-action .file-information .file-name,janus-form-file-upload .file-selected-wrapper:focus:not(.uploading):not(.error-state) .right-action .file-information .file-name{color:var(--bs-primary)}\n"]
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormFileUploadComponent, {
    className: "JanusFormFileUploadComponent",
    filePath: "janus/components/form-file-upload/janus-form-file-upload.component.ts",
    lineNumber: 11
  });
})();
const _c0$n = a0 => ({
  "mb-4": a0
});
const _c1$i = (a0, a1) => ({
  "has-subform": a0,
  "last": a1
});
const _c2$d = (a0, a1) => ({
  "subform bg-gray-100": a0,
  "w-100": a1
});
function JanusFormRelationComponent_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", "blurb_" + ctx_r0.config.elementId);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormRelationComponent_ng_container_1_div_2_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const group_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", group_r2.groupTitle, " ");
  }
}
function JanusFormRelationComponent_ng_container_1_div_2_div_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.config.label, " ");
  }
}
function JanusFormRelationComponent_ng_container_1_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "label");
    i0.ɵɵtemplate(2, JanusFormRelationComponent_ng_container_1_div_2_div_1_ng_container_2_Template, 2, 1, "ng-container", 1)(3, JanusFormRelationComponent_ng_container_1_div_2_div_1_ng_container_3_Template, 2, 1, "ng-container", 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const group_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("id", "lbl_" + ctx_r0.config.id);
    i0.ɵɵadvance();
    i0.ɵɵattribute("for", "lbl_" + ctx_r0.config.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r2.groupTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !group_r2.groupTitle && ctx_r0.config.label);
  }
}
function JanusFormRelationComponent_ng_container_1_div_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 10);
  }
  if (rf & 2) {
    const field_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", field_r3)("group", ctx_r0.formGroup)("value", ctx_r0.config.value[field_r3.name]);
  }
}
function JanusFormRelationComponent_ng_container_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, JanusFormRelationComponent_ng_container_1_div_2_div_1_Template, 4, 4, "div", 6);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵtemplate(3, JanusFormRelationComponent_ng_container_1_div_2_ng_container_3_Template, 1, 3, "ng-container", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const group_r2 = ctx.$implicit;
    const last_r4 = ctx.last;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.subFormConfig.groupId);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c1$i, ctx_r0.subFormConfig.isSubform, last_r4));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.janusVersion !== 1 && (group_r2.groupTitle || ctx_r0.config.label) && !ctx_r0.config.hideLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c2$d, ctx_r0.subFormConfig.isSubform, !ctx_r0.config.label));
    i0.ɵɵattribute("aria-labelledby", "lbl_" + ctx_r0.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", group_r2.controls);
  }
}
function JanusFormRelationComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormRelationComponent_ng_container_1_div_1_Template, 3, 6, "div", 2)(2, JanusFormRelationComponent_ng_container_1_div_2_Template, 4, 12, "div", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.subFormConfig.controlGroups);
  }
}
function JanusFormRelationComponent_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 10);
  }
  if (rf & 2) {
    const field_r5 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r5)("group", ctx_r0.formGroup)("value", ctx_r0.config.value[field_r5.name]);
  }
}
function JanusFormRelationComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormRelationComponent_div_2_ng_container_1_Template, 1, 3, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.subFormConfig.controls);
  }
}
class JanusFormRelationComponent extends FormRelationComponent {
  constructor(fb, janusVersion) {
    super(fb);
    this.fb = fb;
    this.janusVersion = janusVersion;
  }
  static {
    this.ɵfac = function JanusFormRelationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusFormRelationComponent)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject('JANUS_VERSION', 8));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormRelationComponent,
      selectors: [["janus-form-relation"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 5,
      consts: [[1, "fg-fields", 3, "ngClass"], [4, "ngIf"], ["class", "blurb form-text", 3, "id", "innerHTML", 4, "ngIf"], ["class", "janus-field", 3, "id", "ngClass", 4, "ngFor", "ngForOf"], [1, "blurb", "form-text", 3, "id", "innerHTML"], [1, "janus-field", 3, "id", "ngClass"], ["class", "form-label", 4, "ngIf"], ["role", "group", 1, "field-widget", 3, "ngClass"], ["janusDynamicField", "", 3, "config", "group", "value", 4, "ngFor", "ngForOf"], [1, "form-label"], ["janusDynamicField", "", 3, "config", "group", "value"]],
      template: function JanusFormRelationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, JanusFormRelationComponent_ng_container_1_Template, 3, 2, "ng-container", 1)(2, JanusFormRelationComponent_div_2_Template, 2, 1, "div", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$n, !ctx.config.lastChild));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.subFormConfig && ctx.subFormConfig.useGroupedForm && !ctx.config.hideField);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.subFormConfig && !ctx.subFormConfig.useGroupedForm && !ctx.config.hideField);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormRelationComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-relation',
      template: `
        <div class="fg-fields" [ngClass]="{ 'mb-4': !config.lastChild }">
            <ng-container *ngIf="subFormConfig && subFormConfig.useGroupedForm && !config.hideField">
                <div *ngIf="config.blurb" id="{{'blurb_' + config.elementId}}" class="blurb form-text" [innerHTML]="config.blurb | translate | safeHtml"></div>
                <div class="janus-field" *ngFor="let group of subFormConfig.controlGroups; let last = last;" id="{{subFormConfig.groupId}}" [ngClass]="{'has-subform': subFormConfig.isSubform, 'last': last}">
                    <div *ngIf="janusVersion !== 1 && (group.groupTitle || config.label) && !config.hideLabel" class="form-label" [attr.id]="'lbl_' + config.id">
                        <label [attr.for]="'lbl_' + config.id">
                            <ng-container *ngIf="group.groupTitle">
                                {{group.groupTitle}}
                            </ng-container>
                            <ng-container *ngIf="!group.groupTitle && config.label">
                                {{config.label}}
                            </ng-container>
                        </label>
                    </div>
                    <div [ngClass]="{'subform bg-gray-100': subFormConfig.isSubform, 'w-100': !config.label}" class="field-widget" role="group" [attr.aria-labelledby]="'lbl_' + config.elementId">
                        <ng-container *ngFor="let field of group.controls" janusDynamicField [config]="field" [group]="formGroup" [value]="config.value[field.name]"></ng-container>
                    </div>
                </div>
            </ng-container>
            <div *ngIf="subFormConfig && !subFormConfig.useGroupedForm && !config.hideField">
                <ng-container *ngFor="let field of subFormConfig.controls" janusDynamicField [config]="field" [group]="formGroup" [value]="config.value[field.name]"></ng-container>
            </div>
        </div>
    `,
      standalone: false
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['JANUS_VERSION']
    }]
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormRelationComponent, {
    className: "JanusFormRelationComponent",
    filePath: "janus/components/form-relation/janus-form-relation.component.ts",
    lineNumber: 34
  });
})();
const _c0$m = (a0, a1) => ({
  "is-invalid": a0,
  "mb-4": a1
});
const _c1$h = a0 => ({
  field_name: a0
});
const _c2$c = a0 => ({
  value: a0
});
function JanusFormRatingComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormRatingComponent_div_0_div_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 17);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Field is required", i0.ɵɵpureFunction1(5, _c1$h, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormRatingComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, JanusFormRatingComponent_div_0_div_7_div_1_Template, 5, 7, "div", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function JanusFormRatingComponent_div_0_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, "misc.Current rating x star", i0.ɵɵpureFunction1(4, _c2$c, ctx_r0.config.value)));
  }
}
function JanusFormRatingComponent_div_0_ng_container_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "input", 9);
    i0.ɵɵelementStart(2, "label", 18);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 19);
    i0.ɵɵelement(4, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "svg", 20);
    i0.ɵɵelement(6, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(7, "span", 12);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const rating_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r0.config.name)("value", rating_r2.id)("disabled", !!ctx_r0.config.readOnly);
    i0.ɵɵattribute("id", ctx_r0.config.elementId + "-star" + rating_r2.id)("name", ctx_r0.config.name);
    i0.ɵɵadvance();
    i0.ɵɵattribute("for", ctx_r0.config.elementId + "-star" + rating_r2.id);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-star", null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-star-filled", null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(rating_r2.value);
  }
}
function JanusFormRatingComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵtemplate(6, JanusFormRatingComponent_div_0_div_6_Template, 3, 6, "div", 5)(7, JanusFormRatingComponent_div_0_div_7_Template, 2, 1, "div", 6)(8, JanusFormRatingComponent_div_0_span_8_Template, 3, 6, "span", 7);
    i0.ɵɵelementStart(9, "div", 8);
    i0.ɵɵelement(10, "input", 9);
    i0.ɵɵelementStart(11, "label", 10);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(12, "svg", 11);
    i0.ɵɵelement(13, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(14, "span", 12);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(17, JanusFormRatingComponent_div_0_ng_container_17_Template, 9, 9, "ng-container", 13);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(26, _c0$m, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), !ctx_r0.config.lastChild))("formGroup", ctx_r0.group);
    i0.ɵɵadvance();
    i0.ɵɵattribute("id", "lbl_" + ctx_r0.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 22, ctx_r0.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched))("isRequired", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.readOnly);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r0.group);
    i0.ɵɵattribute("id", ctx_r0.config.elementId)("aria-labelledby", "lbl_" + ctx_r0.config.elementId)("aria-hidden", !!ctx_r0.config.readOnly ? "true" : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r0.config.name)("value", null)("disabled", !!ctx_r0.config.readOnly);
    i0.ɵɵattribute("id", ctx_r0.config.elementId + "-star0")("name", ctx_r0.config.name);
    i0.ɵɵadvance();
    i0.ɵɵattribute("for", ctx_r0.config.elementId + "-star0");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-wash-dryclean-off", null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 24, "misc.No stars"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.options);
  }
}
class JanusFormRatingComponent extends FormRatingComponent {
  constructor() {
    super(...arguments);
    this.assetsPath = '/app/assets/';
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormRatingComponent_BaseFactory;
      return function JanusFormRatingComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormRatingComponent_BaseFactory || (ɵJanusFormRatingComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormRatingComponent)))(__ngFactoryType__ || JanusFormRatingComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormRatingComponent,
      selectors: [["janus-form-rating"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "janus-field form-radio field-custom", "role", "group", 3, "ngClass", "formGroup", 4, "ngIf"], ["role", "group", 1, "janus-field", "form-radio", "field-custom", 3, "ngClass", "formGroup"], [1, "form-label"], [3, "hasError", "isRequired"], [1, "field-widget"], ["class", "blurb form-text", 3, "id", "innerHTML", 4, "ngIf"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], ["class", "visually-hidden", 4, "ngIf"], ["role", "radiogroup", 1, "rating", "position-relative", "d-inline-flex", "align-items-center", 3, "formGroup"], ["type", "radio", 1, "visually-hidden", 3, "formControlName", "value", "disabled"], [1, "clear-rating", "px-1", "order-1"], ["width", "2rem", "height", "2rem", 1, "text-danger"], [1, "visually-hidden"], [4, "ngFor", "ngForOf"], [1, "blurb", "form-text", 3, "id", "innerHTML"], ["role", "alert", 1, "invalid-feedback"], [4, "ngIf"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [1, "px-1"], ["width", "2rem", "height", "2rem", 1, "star_unselected"], ["width", "2rem", "height", "2rem", 1, "star_selected"]],
      template: function JanusFormRatingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormRatingComponent_div_0_Template, 18, 29, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.DefaultValueAccessor, i2$1.RadioControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, JanusRequiredComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormRatingComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-rating',
      standalone: false,
      template: "<div *ngIf=\"!config.hideField\"\n    class=\"janus-field form-radio field-custom\"\n    role=\"group\"\n    [ngClass]=\"{ 'is-invalid': !control.valid && (control.dirty || control.touched), 'mb-4': !config.lastChild }\"\n    [formGroup]=\"group\"\n>\n    <div class=\"form-label\" [attr.id]=\"'lbl_' + config.elementId\">\n        {{config.label | translate}}<janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\"></janus-required>\n    </div>\n    <div class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div *ngIf=\"!control.valid && (control.dirty || control.touched)\" class=\"invalid-feedback\" role=\"alert\">\n            <div *ngIf=\"control.errors.required\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                </svg>\n                {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n            </div>\n        </div>\n        <span *ngIf=\"config.readOnly\" class=\"visually-hidden\">{{ 'misc.Current rating x star' | translate: { value: config.value } }}</span>\n        <div\n            class=\"rating position-relative d-inline-flex align-items-center\"\n            role=\"radiogroup\"\n            [attr.id]=\"config.elementId\"\n            [formGroup]=\"group\"\n            [attr.aria-labelledby]=\"'lbl_' + config.elementId\"\n            [attr.aria-hidden]=\"!!config.readOnly ? 'true' : null\"\n        >\n            <input\n                type=\"radio\"\n                class=\"visually-hidden\"\n                [attr.id]=\"config.elementId + '-star0'\"\n                [attr.name]=\"config.name\"\n                [formControlName]=\"config.name\"\n                [value]=\"null\"\n                [disabled]=\"!!config.readOnly\"\n            />\n            <label\n                class=\"clear-rating px-1 order-1\"\n                [attr.for]=\"config.elementId + '-star0'\"\n            >\n                <svg width=\"2rem\" height=\"2rem\" class=\"text-danger\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-wash-dryclean-off'\"></use>\n                </svg>\n                <span class=\"visually-hidden\">{{ 'misc.No stars' | translate }}</span>\n            </label>\n            <ng-container *ngFor=\"let rating of options\">\n                <input\n                    type=\"radio\"\n                    class=\"visually-hidden\"\n                    [attr.id]=\"config.elementId + '-star' + rating.id\"\n                    [attr.name]=\"config.name\"\n                    [formControlName]=\"config.name\"\n                    [value]=\"rating.id\"\n                    [disabled]=\"!!config.readOnly\"\n                />\n                <label\n                    class=\"px-1\"\n                    [attr.for]=\"config.elementId + '-star' + rating.id\"\n                >\n                    <svg width=\"2rem\" height=\"2rem\" class=\"star_unselected\">\n                        <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-star'\"></use>\n                    </svg>\n                    <svg width=\"2rem\" height=\"2rem\" class=\"star_selected\">\n                        <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-star-filled'\"></use>\n                    </svg>\n                    <span class=\"visually-hidden\">{{rating.value}}</span>\n                </label>\n            </ng-container>\n        </div>\n    </div>\n</div>\n"
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormRatingComponent, {
    className: "JanusFormRatingComponent",
    filePath: "janus/components/form-rating/janus-form-rating.component.ts",
    lineNumber: 9
  });
})();
const _c0$l = (a0, a1) => ({
  "last": a0,
  "inline": a1
});
function JanusFormButtonComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "button", 2);
    i0.ɵɵlistener("click", function JanusFormButtonComponent_div_0_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.config.onClick($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.group)("ngClass", i0.ɵɵpureFunction2(8, _c0$l, ctx_r1.config.lastChild, ctx_r1.config.displayInline));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("type", ctx_r1.config.name);
    i0.ɵɵproperty("ngClass", ctx_r1.config.styleClass)("disabled", ctx_r1.config.name === "submit" && !ctx_r1.group.valid);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, ctx_r1.config.label), " ");
  }
}
class JanusFormButtonComponent extends FormButtonComponent {
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormButtonComponent_BaseFactory;
      return function JanusFormButtonComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormButtonComponent_BaseFactory || (ɵJanusFormButtonComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormButtonComponent)))(__ngFactoryType__ || JanusFormButtonComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormButtonComponent,
      selectors: [["janus-form-button"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "janus-field form-button", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "janus-field", "form-button", 3, "formGroup", "ngClass"], [1, "input-button", 3, "click", "type", "ngClass", "disabled"]],
      template: function JanusFormButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormButtonComponent_div_0_Template, 4, 11, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormButtonComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-button',
      template: `
        <div *ngIf="!config.hideField"
            class="janus-field form-button"
            [formGroup]="group" 
            [ngClass]="{'last':config.lastChild, 'inline': config.displayInline}">
            <button type="{{ config.name }}" 
                class="input-button" 
                (click)="config.onClick($event)"
                [ngClass]="config.styleClass"
                [disabled]="config.name === 'submit' && !group.valid">
                {{config.label | translate}}
            </button>
        </div>
        `,
      standalone: false
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormButtonComponent, {
    className: "JanusFormButtonComponent",
    filePath: "janus/components/form-button/janus-form-button.component.ts",
    lineNumber: 22
  });
})();
const _c0$k = a0 => ({
  "last": a0
});
const _c1$g = a0 => ({
  "is-invalid": a0
});
const _c2$b = a0 => ({
  "align-items-center": a0
});
const _c3$9 = a0 => ({
  "w-sm-20pct": a0
});
const _c4$8 = (a0, a1) => ({
  "mx-2": a0,
  "m-1": a1
});
const _c5$6 = a0 => ({
  field_name: a0
});
const _c6$5 = (a0, a1, a2) => ({
  field_name: a0,
  min: a1,
  max: a2
});
function JanusFormRangeComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(1, 1, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormRangeComponent_div_0_div_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 15);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Field is required", i0.ɵɵpureFunction1(5, _c5$6, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormRangeComponent_div_0_div_9_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 15);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Field range should be", i0.ɵɵpureFunction3(5, _c6$5, ctx_r0.translatedLabel, ctx_r0.minValue, ctx_r0.maxValue)), " ");
  }
}
function JanusFormRangeComponent_div_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, JanusFormRangeComponent_div_0_div_9_div_1_Template, 5, 7, "div", 13)(2, JanusFormRangeComponent_div_0_div_9_div_2_Template, 5, 9, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.incorrectValue);
  }
}
function JanusFormRangeComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "fieldset")(2, "legend", 2)(3, "span", 3);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "janus-required", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 5);
    i0.ɵɵtemplate(8, JanusFormRangeComponent_div_0_div_8_Template, 3, 5, "div", 6)(9, JanusFormRangeComponent_div_0_div_9_Template, 3, 2, "div", 7);
    i0.ɵɵelementStart(10, "div", 8);
    i0.ɵɵelement(11, "input", 9);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementStart(13, "span", 10);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "input", 9);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.group)("ngClass", i0.ɵɵpureFunction1(32, _c0$k, ctx_r0.config.lastChild))("ngClass", i0.ɵɵpureFunction1(34, _c1$g, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched)));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "lbl_", ctx_r0.config.elementId, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 24, ctx_r0.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched))("isRequired", ctx_r0.isRequired);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-labelledby", "lbl_" + ctx_r0.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(36, _c2$b, ctx_r0.janusVersion === 1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r0.fromInputControl)("type", ctx_r0.inputType)("ngClass", i0.ɵɵpureFunction1(38, _c3$9, ctx_r0.janusVersion === 1));
    i0.ɵɵattribute("placeholder", ctx_r0.config.placeholder == null ? null : ctx_r0.config.placeholder[0])("aria-label", i0.ɵɵpipeBind1(12, 26, "misc.Minimum Score"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(40, _c4$8, ctx_r0.janusVersion === 1, ctx_r0.janusVersion !== 1));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 28, "misc.to"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r0.toInputControl)("type", ctx_r0.inputType)("ngClass", i0.ɵɵpureFunction1(43, _c3$9, ctx_r0.janusVersion === 1));
    i0.ɵɵattribute("placeholder", ctx_r0.config.placeholder == null ? null : ctx_r0.config.placeholder[1])("aria-label", i0.ɵɵpipeBind1(17, 30, "misc.Maximum Score"));
  }
}
class JanusFormRangeComponent extends FormRangeComponent {
  constructor(translate, janusVersion) {
    super(translate);
    this.translate = translate;
    this.janusVersion = janusVersion;
    this.assetsPath = '/app/assets/';
  }
  static {
    this.ɵfac = function JanusFormRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusFormRangeComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject('JANUS_VERSION', 8));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormRangeComponent,
      selectors: [["janus-form-range"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "janus-field janus-form-range field-custom", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "janus-field", "janus-form-range", "field-custom", 3, "formGroup", "ngClass"], [1, "form-label"], [3, "id"], [3, "hasError", "isRequired"], ["role", "group", 1, "field-widget"], ["class", "form-text", 3, "innerHTML", 4, "ngIf"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], [1, "d-flex", "flex-wrap", "flex-sm-nowrap", 3, "ngClass"], [1, "form-control", 3, "formControl", "type", "ngClass"], [3, "ngClass"], [1, "form-text", 3, "innerHTML"], ["role", "alert", 1, "invalid-feedback"], ["class", "field-error", 4, "ngIf"], [1, "field-error"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"]],
      template: function JanusFormRangeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormRangeComponent_div_0_Template, 18, 45, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormControlDirective, i2$1.FormGroupDirective, JanusRequiredComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormRangeComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-range',
      standalone: false,
      template: "<div\n    *ngIf=\"!config.hideField\" [formGroup]=\"group\" [ngClass]=\"{'last': config.lastChild}\"\n    class=\"janus-field janus-form-range field-custom\"\n    [ngClass]=\"{ 'is-invalid': !control.valid && (control.dirty || control.touched) }\"\n>\n    <fieldset>\n        <legend class=\"form-label\">\n            <span id=\"lbl_{{config.elementId}}\">\n                {{config.label | translate }}<janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\"></janus-required>\n            </span>\n        </legend>\n        <div class=\"field-widget\" role=\"group\" [attr.aria-labelledby]=\"'lbl_' + config.elementId\">\n            <div *ngIf=\"config.blurb\" class=\"form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n            <div *ngIf=\"!control.valid && (control.dirty || control.touched)\" class=\"invalid-feedback\" role=\"alert\">\n                <div class=\"field-error\" *ngIf=\"control.errors.required\">\n                    <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                        <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                    </svg>\n                    {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n                </div>\n                <div class=\"field-error\" *ngIf=\"control.errors.incorrectValue\">\n                    <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                        <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                    </svg>\n                    {{ 'misc.Field range should be' | translate: {field_name: translatedLabel, min: minValue, max: maxValue} }}\n                </div>\n            </div>\n            <div class=\"d-flex flex-wrap flex-sm-nowrap\" [ngClass]=\"{ 'align-items-center': janusVersion === 1 }\">\n                <input\n                    [formControl]=\"fromInputControl\"\n                    [type]=\"inputType\"\n                    [attr.placeholder]=\"config.placeholder?.[0]\"\n                    [attr.aria-label]=\"'misc.Minimum Score' | translate\"\n                    class=\"form-control\"\n                    [ngClass]=\"{ 'w-sm-20pct': janusVersion === 1 }\"\n                />\n                <span [ngClass]=\"{ 'mx-2': janusVersion === 1, 'm-1': janusVersion !== 1 }\">{{ 'misc.to' | translate }}</span>\n                <input\n                    [formControl]=\"toInputControl\"\n                    [type]=\"inputType\"\n                    [attr.placeholder]=\"config.placeholder?.[1]\"\n                    [attr.aria-label]=\"'misc.Maximum Score' | translate\"\n                    class=\"form-control\"\n                    [ngClass]=\"{ 'w-sm-20pct': janusVersion === 1 }\"\n                />\n            </div>\n        </div>\n    </fieldset>\n</div>\n"
    }]
  }], () => [{
    type: i1$1.TranslateService
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['JANUS_VERSION']
    }]
  }], {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormRangeComponent, {
    className: "JanusFormRangeComponent",
    filePath: "janus/components/form-range/janus-form-range.component.ts",
    lineNumber: 10
  });
})();
function JanusFormStaticListComponent_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 6);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function JanusFormStaticListComponent_li_7_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const fieldConfig_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 1, fieldConfig_r1 == null ? null : fieldConfig_r1.label), ": ");
  }
}
function JanusFormStaticListComponent_li_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 7);
    i0.ɵɵtemplate(1, JanusFormStaticListComponent_li_7_span_1_Template, 4, 3, "span", 8);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const fieldConfig_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", fieldConfig_r1.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(fieldConfig_r1 == null ? null : fieldConfig_r1.value);
  }
}
class JanusFormStaticListComponent extends FormStaticListComponent {
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormStaticListComponent_BaseFactory;
      return function JanusFormStaticListComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormStaticListComponent_BaseFactory || (ɵJanusFormStaticListComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormStaticListComponent)))(__ngFactoryType__ || JanusFormStaticListComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormStaticListComponent,
      selectors: [["janus-form-static-list"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 8,
      vars: 5,
      consts: [[1, "form-static-list", "field"], [1, "field-label"], ["class", "req-indicator", 4, "ngIf"], [1, "field-widget"], [1, "list-group"], ["class", "waitlist-modal-table-list", 4, "ngFor", "ngForOf"], [1, "req-indicator"], [1, "waitlist-modal-table-list"], [4, "ngIf"]],
      template: function JanusFormStaticListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵtemplate(4, JanusFormStaticListComponent_i_4_Template, 2, 0, "i", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 3)(6, "ul", 4);
          i0.ɵɵtemplate(7, JanusFormStaticListComponent_li_7_Template, 4, 2, "li", 5);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, ctx.config == null ? null : ctx.config.label), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.isRequired);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngForOf", ctx.config.staticFieldsConfig);
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormStaticListComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-static-list',
      standalone: false,
      template: "<div class=\"form-static-list field\">\n    <div class=\"field-label\">\n        {{config?.label | translate}}\n        <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n    </div>\n    <div class=\"field-widget\">\n        <ul class=\"list-group\">\n            <li *ngFor=\"let fieldConfig of config.staticFieldsConfig\" class=\"waitlist-modal-table-list\">\n                <span *ngIf=\"fieldConfig.value\"><b>{{fieldConfig?.label | translate}}: </b></span>\n                <span>{{fieldConfig?.value}}</span>\n            </li>\n        </ul>\n    </div>\n</div>\n"
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormStaticListComponent, {
    className: "JanusFormStaticListComponent",
    filePath: "janus/components/form-static/janus-form-static-list.component.ts",
    lineNumber: 9
  });
})();
const _c0$j = a0 => ({
  "last": a0
});
const _c1$f = a0 => ({
  field_name: a0
});
function JanusFormMultiSelectComponent_div_0_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 13);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function JanusFormMultiSelectComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormMultiSelectComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, "When autocomplete results are available use up and down arrows to review and enter to select. Start typing to filter the options.");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
  }
}
function JanusFormMultiSelectComponent_div_0_ng_template_12_b_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(#", item_r3.orderBy, ")");
  }
}
function JanusFormMultiSelectComponent_div_0_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, JanusFormMultiSelectComponent_div_0_ng_template_12_b_0_Template, 2, 1, "b", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵlistener("click", function JanusFormMultiSelectComponent_div_0_ng_template_12_Template_span_click_2_listener($event) {
      const ctx_r3 = i0.ɵɵrestoreView(_r2);
      const item_r3 = ctx_r3.item;
      const clear_r5 = ctx_r3.clear;
      clear_r5(item_r3);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtext(3, "\u00D7");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.item;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.ordered);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.display, " ");
  }
}
function JanusFormMultiSelectComponent_div_0_div_13_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$f, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormMultiSelectComponent_div_0_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, JanusFormMultiSelectComponent_div_0_div_13_div_1_Template, 4, 6, "div", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function JanusFormMultiSelectComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "label", 5);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, JanusFormMultiSelectComponent_div_0_i_5_Template, 2, 0, "i", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtemplate(7, JanusFormMultiSelectComponent_div_0_div_7_Template, 3, 6, "div", 8)(8, JanusFormMultiSelectComponent_div_0_div_8_Template, 2, 1, "div", 9);
    i0.ɵɵelementStart(9, "ng-select", 10);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵpipe(11, "async");
    i0.ɵɵtemplate(12, JanusFormMultiSelectComponent_div_0_ng_template_12_Template, 4, 2, "ng-template", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, JanusFormMultiSelectComponent_div_0_div_13_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.group)("ngClass", i0.ɵɵpureFunction1(26, _c0$j, ctx_r0.config.lastChild));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 20, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 22, ctx_r0.config.placeholder));
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r0.controlName);
    i0.ɵɵproperty("items", i0.ɵɵpipeBind1(11, 24, ctx_r0.config.options))("loading", ctx_r0.loading)("multiple", true)("maxSelectedItems", ctx_r0.config.maxSelectedItems);
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
  }
}
function JanusFormMultiSelectComponent_div_1_i_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 13);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function JanusFormMultiSelectComponent_div_1_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx_r0.config.blurb));
  }
}
function JanusFormMultiSelectComponent_div_1_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, "When autocomplete results are available use up and down arrows to review and enter to select. Start typing to filter the options.");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
  }
}
function JanusFormMultiSelectComponent_div_1_ng_template_16_b_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r8 = i0.ɵɵnextContext().item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(#", item_r8.orderBy, ")");
  }
}
function JanusFormMultiSelectComponent_div_1_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, JanusFormMultiSelectComponent_div_1_ng_template_16_b_0_Template, 2, 1, "b", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵlistener("click", function JanusFormMultiSelectComponent_div_1_ng_template_16_Template_span_click_2_listener($event) {
      const ctx_r8 = i0.ɵɵrestoreView(_r7);
      const item_r8 = ctx_r8.item;
      const clear_r10 = ctx_r8.clear;
      clear_r10(item_r8);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtext(3, "\u00D7");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r8 = ctx.item;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.ordered);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r8.display, " ");
  }
}
function JanusFormMultiSelectComponent_div_1_div_17_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$f, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormMultiSelectComponent_div_1_div_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, JanusFormMultiSelectComponent_div_1_div_17_div_1_Template, 3, 6, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function JanusFormMultiSelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "table", 22)(2, "tr")(3, "td", 23)(4, "div", 24)(5, "label", 5);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵtemplate(8, JanusFormMultiSelectComponent_div_1_i_8_Template, 2, 0, "i", 6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "td", 23)(10, "div", 25);
    i0.ɵɵtemplate(11, JanusFormMultiSelectComponent_div_1_div_11_Template, 3, 4, "div", 26)(12, JanusFormMultiSelectComponent_div_1_div_12_Template, 2, 1, "div", 9);
    i0.ɵɵelementStart(13, "ng-select", 27);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵpipe(15, "async");
    i0.ɵɵlistener("change", function JanusFormMultiSelectComponent_div_1_Template_ng_select_change_13_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onValChange($event));
    });
    i0.ɵɵtemplate(16, JanusFormMultiSelectComponent_div_1_ng_template_16_Template, 4, 2, "ng-template", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, JanusFormMultiSelectComponent_div_1_div_17_Template, 2, 1, "div", 28);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.group);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 19, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate2("id", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(14, 21, ctx_r0.config.placeholder));
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r0.controlName);
    i0.ɵɵproperty("items", i0.ɵɵpipeBind1(15, 23, ctx_r0.config.options))("loading", ctx_r0.loading)("multiple", true)("maxSelectedItems", ctx_r0.config.maxSelectedItems);
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
  }
}
function JanusFormMultiSelectComponent_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 32);
  }
  if (rf & 2) {
    const field_r11 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r11)("group", ctx_r0.group);
  }
}
function JanusFormMultiSelectComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormMultiSelectComponent_div_2_ng_container_1_Template, 1, 2, "ng-container", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.dependents);
  }
}
class JanusFormMultiSelectComponent extends FormMultiSelectComponent {
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormMultiSelectComponent_BaseFactory;
      return function JanusFormMultiSelectComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormMultiSelectComponent_BaseFactory || (ɵJanusFormMultiSelectComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormMultiSelectComponent)))(__ngFactoryType__ || JanusFormMultiSelectComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormMultiSelectComponent,
      selectors: [["janus-form-select"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 3,
      consts: [["class", "field form-select", 3, "formGroup", "ngClass", 4, "ngIf"], ["class", "row form-select form-group", 3, "formGroup", 4, "ngIf"], [4, "ngIf"], [1, "field", "form-select", 3, "formGroup", "ngClass"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "field-widget", "search_filter_multiselect"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["class", "blurb hide", 3, "id", 4, "ngIf"], ["bindLabel", "display", "clearAllText", "Clear", 1, "form-select-multiselect", 3, "items", "loading", "multiple", "maxSelectedItems", "placeholder", "formControlName"], ["ng-label-tmp", ""], ["role", "alert", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], [1, "blurb", "hide", 3, "id"], ["aria-hidden", "true", "role", "button", "title", "delete", 1, "ng-value-icon", "right", 3, "click"], ["role", "alert"], ["class", "field-error", 4, "ngIf"], [1, "field-error"], [1, "icn-error_filled"], [1, "row", "form-select", "form-group", 3, "formGroup"], ["role", "layout", 1, "waitlist-modal-table"], [1, "waitlist-modal-table-column"], [1, "label"], [1, "widget", "waitlist-modal-table-multiselect"], ["class", "blurb field-blurb", 3, "id", 4, "ngIf"], ["bindLabel", "display", "clearAllText", "Clear", 3, "change", "items", "loading", "multiple", "maxSelectedItems", "placeholder", "formControlName"], ["role", "alert", "class", "alert alert-danger", 4, "ngIf"], [1, "blurb", "field-blurb", 3, "id"], ["role", "alert", 1, "alert", "alert-danger"], ["dynamicField", "", 3, "config", "group", 4, "ngFor", "ngForOf"], ["dynamicField", "", 3, "config", "group"]],
      template: function JanusFormMultiSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormMultiSelectComponent_div_0_Template, 14, 28, "div", 0)(1, JanusFormMultiSelectComponent_div_1_Template, 18, 25, "div", 1)(2, JanusFormMultiSelectComponent_div_2_Template, 2, 1, "div", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField && !ctx.modal);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.config.hideField && ctx.modal);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showDependentControl);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, DynamicFieldDirective, i1.AsyncPipe, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormMultiSelectComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-select',
      standalone: false,
      template: "<div class=\"field form-select\" *ngIf=\"!config.hideField && !modal\" [formGroup]=\"group\" [ngClass]=\"{'last': config.lastChild}\">\n\t<div class=\"field-label\">\n\t\t<label for=\"{{config.elementId}}{{modal?'modal':''}}\">{{config.label | translate}}\n\t\t\t<i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n\t\t</label>\n\t</div>\n\t<div class=\"field-widget search_filter_multiselect\">\n\t\t<div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb field-blurb\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n\t\t<div *ngIf=\"!config.blurb\" id=\"{{describedByValue}}\" class=\"blurb hide\">When autocomplete results are available use up and down arrows to review and enter to select. Start typing to filter the options.</div>\n\t\t<ng-select\n\t\t\t[items]=\"config.options | async\"\n\t\t\tclass=\"form-select-multiselect\"\n\t\t\tbindLabel=\"display\"\n\t\t\t[loading]=\"loading\"\n\t\t\t[multiple]=\"true\"\n\t\t\t[maxSelectedItems]=\"config.maxSelectedItems\"\n\t\t\tplaceholder=\"{{config.placeholder | translate}}\"\n\t\t\t[attr.aria-describedby]=\"describedByValue\"\n\t\t\tattr.id=\"{{config.elementId}}{{modal?'modal':''}}\"\n\t\t\tclearAllText=\"Clear\"\n\t\t\tformControlName=\"{{controlName}}\">\n\t\t\t<ng-template  ng-label-tmp let-item=\"item\" let-clear=\"clear\">\n\t\t\t\t<b *ngIf=\"config.ordered\">(#{{item.orderBy}})</b> {{item.display}}\n\t\t\t\t<span class=\"ng-value-icon right\" (click)=\"clear(item); $event.stopPropagation()\" aria-hidden=\"true\" role=\"button\" title=\"delete\">\u00D7</span>\n\t\t\t</ng-template>\n\t\t</ng-select>\n\t\t<div role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n\t\t\t<div class=\"field-error\" *ngIf=\"control.errors.required\">\n\t\t\t\t<i class=\"icn-error_filled\"></i>\n\t\t\t\t{{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<div class=\"row form-select form-group\" *ngIf=\"!config.hideField && modal\" [formGroup]=\"group\">\n\t<table class=\"waitlist-modal-table\" role=\"layout\">\n\t\t<tr>\n\t\t\t<td class=\"waitlist-modal-table-column\">\n\t\t\t\t<div class=\"label\">\n\t\t\t\t\t<label for=\"{{config.elementId}}{{modal?'modal':''}}\">{{config.label | translate}}\n\t\t\t\t\t\t<i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</td>\n\t\t\t<td class=\"waitlist-modal-table-column\">\n\t\t\t\t<div class=\"widget waitlist-modal-table-multiselect\">\n\t\t\t\t\t<div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb field-blurb\">{{config.blurb | translate}}</div>\n\t\t\t\t\t<div *ngIf=\"!config.blurb\" id=\"{{describedByValue}}\" class=\"blurb hide\">When autocomplete results are available use up and down arrows to review and enter to select. Start typing to filter the options.</div>\n\t\t\t\t\t<ng-select\n\t\t\t\t\t\t[items]=\"config.options | async\"\n\t\t\t\t\t\tbindLabel=\"display\"\n\t\t\t\t\t\t[loading]=\"loading\"\n\t\t\t\t\t\t[multiple]=\"true\"\n\t\t\t\t\t\t[maxSelectedItems]=\"config.maxSelectedItems\"\n\t\t\t\t\t\tplaceholder=\"{{config.placeholder | translate}}\"\n\t\t\t\t\t\t[attr.aria-describedby]=\"describedByValue\"\n\t\t\t\t\t\tattr.id=\"{{config.elementId}}{{modal?'modal':''}}\"\n\t\t\t\t\t\tclearAllText=\"Clear\"\n\t\t\t\t\t\t(change)=\"onValChange($event)\"\n\t\t\t\t\t\tformControlName=\"{{controlName}}\">\n\t\t\t\t\t\t<ng-template  ng-label-tmp let-item=\"item\" let-clear=\"clear\">\n\t\t\t\t\t\t\t<b *ngIf=\"config.ordered\">(#{{item.orderBy}})</b> {{item.display}}\n\t\t\t\t\t\t\t<span class=\"ng-value-icon right\" (click)=\"clear(item); $event.stopPropagation()\" aria-hidden=\"true\" role=\"button\" title=\"delete\">\u00D7</span>\n\t\t\t\t\t\t</ng-template>\n\t\t\t\t\t</ng-select>\n\t\t\t\t\t<div role=\"alert\" class=\"alert alert-danger\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n\t\t\t\t\t\t<div *ngIf=\"control.errors.required\">\n\t\t\t\t\t\t\t{{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</td>\n\t\t</tr>\n\t</table>\n</div>\n<div *ngIf='showDependentControl'>\n    <ng-container *ngFor=\"let field of config.dependents\" dynamicField [config]=\"field\" [group]=\"group\"></ng-container>\n</div>\n"
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormMultiSelectComponent, {
    className: "JanusFormMultiSelectComponent",
    filePath: "janus/components/form-multiselect/janus-form-multiselect.component.ts",
    lineNumber: 9
  });
})();
const _c0$i = (a0, a1, a2) => ({
  "field-error": a0,
  "group-options": a1,
  "last": a2
});
const _c1$e = a0 => ({
  field_name: a0
});
function JanusFormNGSelectComponent_div_0_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 10);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function JanusFormNGSelectComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormNGSelectComponent_div_0_div_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$e, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormNGSelectComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, JanusFormNGSelectComponent_div_0_div_8_div_1_Template, 4, 6, "div", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
  }
}
function JanusFormNGSelectComponent_div_0_ng_template_12_b_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(#", item_r3.orderBy, ")");
  }
}
function JanusFormNGSelectComponent_div_0_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, JanusFormNGSelectComponent_div_0_ng_template_12_b_0_Template, 2, 1, "b", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 14);
    i0.ɵɵlistener("click", function JanusFormNGSelectComponent_div_0_ng_template_12_Template_span_click_2_listener($event) {
      const ctx_r3 = i0.ɵɵrestoreView(_r2);
      const item_r3 = ctx_r3.item;
      const clear_r5 = ctx_r3.clear;
      clear_r5(item_r3);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtext(3, "\u00D7");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.item;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.ordered);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.display, " ");
  }
}
function JanusFormNGSelectComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "label");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, JanusFormNGSelectComponent_div_0_i_5_Template, 2, 0, "i", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵtemplate(7, JanusFormNGSelectComponent_div_0_div_7_Template, 3, 6, "div", 6)(8, JanusFormNGSelectComponent_div_0_div_8_Template, 2, 1, "div", 7);
    i0.ɵɵelementStart(9, "ng-select", 8);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵtemplate(12, JanusFormNGSelectComponent_div_0_ng_template_12_Template, 4, 2, "ng-template", 9);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(26, _c0$i, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.groupOptions, ctx_r0.config.lastChild))("formGroup", ctx_r0.group);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 20, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("labelForId", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r0.controlName);
    i0.ɵɵproperty("items", i0.ɵɵpipeBind1(10, 22, ctx_r0.config.options))("loading", ctx_r0.loading)("multiple", ctx_r0.config.multiple)("maxSelectedItems", ctx_r0.config.maxSelectedItems)("placeholder", i0.ɵɵpipeBind1(11, 24, ctx_r0.config.placeholder))("searchable", ctx_r0.searchable);
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue);
  }
}
function JanusFormNGSelectComponent_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 16);
  }
  if (rf & 2) {
    const field_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r6)("group", ctx_r0.group)("modal", ctx_r0.modal);
  }
}
function JanusFormNGSelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormNGSelectComponent_div_1_ng_container_1_Template, 1, 3, "ng-container", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.dependents);
  }
}
class JanusFormNGSelectComponent extends FormNGSelectComponent {
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormNGSelectComponent_BaseFactory;
      return function JanusFormNGSelectComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormNGSelectComponent_BaseFactory || (ɵJanusFormNGSelectComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormNGSelectComponent)))(__ngFactoryType__ || JanusFormNGSelectComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormNGSelectComponent,
      selectors: [["form-ngselect"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 2,
      consts: [["class", "field form-select", 3, "ngClass", "formGroup", 4, "ngIf"], [4, "ngIf"], [1, "field", "form-select", 3, "ngClass", "formGroup"], [1, "field-label"], ["class", "req-indicator", 4, "ngIf"], [1, "field-widget", "search_filter_multiselect"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], ["bindLabel", "display", "groupBy", "groupBy", "clearAllText", "Clear", 1, "form-select-multiselect", 3, "items", "labelForId", "loading", "multiple", "maxSelectedItems", "placeholder", "searchable", "formControlName"], ["ng-label-tmp", ""], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [1, "icn-error_filled"], ["aria-hidden", "true", "role", "button", "title", "delete", 1, "ng-value-icon", "right", 3, "click"], ["dynamicField", "", 3, "config", "group", "modal", 4, "ngFor", "ngForOf"], ["dynamicField", "", 3, "config", "group", "modal"]],
      template: function JanusFormNGSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormNGSelectComponent_div_0_Template, 13, 30, "div", 0)(1, JanusFormNGSelectComponent_div_1_Template, 2, 1, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showDependentControl);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, DynamicFieldDirective, i1.AsyncPipe, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: [".ng-select .ng-control,.ng-select.ng-single .ng-control{min-height:40px;height:40px}.ng-select.ng-select-opened>.ng-select-container{background:#fff;border-color:#949494}.ng-select.ng-select-opened>.ng-select-container:hover{box-shadow:none}.ng-select.ng-select-opened.ng-select-bottom>.ng-select-container{border-bottom-right-radius:0;border-bottom-left-radius:0}.ng-select.ng-select-opened.ng-select-top>.ng-select-container{border-top-right-radius:0;border-top-left-radius:0}.ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border-color:#007eff;box-shadow:inset 0 1px 1px #00000013,0 0 0 3px #007eff1a}.ng-select.ng-select-disabled>.ng-select-container{background-color:#f9f9f9}.ng-select .ng-has-value .ng-placeholder{display:none}.ng-select .ng-select-container{background-color:#fff;border-radius:3px;border:1px solid #949494;min-height:30px;align-items:center}.ng-select .ng-select-container:hover{box-shadow:0 1px #0000000f}.ng-select .ng-select-container .ng-value-container{align-items:center;padding-left:10px}.ng-select .ng-select-container .ng-value-container .ng-placeholder{color:#aaa}.ng-select.ng-select-single .ng-select-container{height:30px}.ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{left:0;padding-left:10px;padding-right:50px;top:5px}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value{background-color:#f9f9f9;border:1px solid #e3e3e3}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value .ng-value-label{padding:0 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-left:7px;padding-top:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{font-size:.9em;margin-right:5px;margin-bottom:5px;background-color:#f5faff;border-radius:2px;border:1px solid #c2e0ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled{background-color:#f9f9f9;border:1px solid #e3e3e3}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled .ng-value-label{padding-left:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-label,.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon{display:inline-block;padding:0 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon:hover{background-color:#d8eafd}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-right:1px solid #c2e0ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:1px solid #c2e0ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding-bottom:3px;padding-left:3px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{top:5px;padding-bottom:5px;padding-left:3px}.ng-select .ng-clear-wrapper{color:#6c6c6c;top:1px}.ng-select .ng-select-container .ng-clear-wrapper .ng-clear{display:block}.ng-select .ng-clear-wrapper .ng-clear:hover{color:#d0021b}.ng-select .ng-spinner-zone{padding-right:5px;padding-top:5px}.ng-select .ng-arrow-wrapper{padding-right:5px;width:25px}.ng-select .ng-arrow-wrapper .ng-arrow{width:30px!important;margin-left:2px;vertical-align:middle;background:url(/components/unicon/assets/svg-output/chevron_down_light.svg) no-repeat center right 15px;background-size:17px;height:20px!important}[dir=rtl] .ng-select .ng-arrow-wrapper .ng-arrow{background:url(/components/unicon/assets/svg-output/chevron_down_light.svg) no-repeat center left 15px/17px}.ng-dropdown-panel{background-color:#fff;border:1px solid #ccc;box-shadow:0 1px #0000000f;left:0}[dir=rtl] .ng-dropdown-panel{text-align:right}.ng-dropdown-panel.ng-select-bottom{top:100%;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-top-color:#e6e6e6;margin-top:-1px}.ng-dropdown-panel.ng-select-bottom .ng-dropdown-panel-items .ng-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.ng-dropdown-panel.ng-select-top{bottom:100%;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-color:#e6e6e6;margin-bottom:-1px}.ng-dropdown-panel.ng-select-top .ng-dropdown-panel-items .ng-option:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.ng-dropdown-panel .ng-dropdown-header{border-bottom:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-footer{border-top:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-panel-items{margin-bottom:1px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{-webkit-user-select:none;user-select:none;cursor:default;padding:8px 10px;font-weight:500;color:#0000008a;cursor:pointer}.group-options .ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{font-weight:700;color:#444}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-disabled{cursor:default}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-marked{background-color:#ebf5ff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected{background-color:#f5faff;font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option{background-color:#fff;color:#3e3e3ede;padding:8px 10px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected{color:#333;background-color:#f5faff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label{font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked{background-color:#428bca;color:#fff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled{color:#ccc}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-left:22px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{padding-right:5px;font-size:80%;font-weight:400}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormNGSelectComponent, [{
    type: Component,
    args: [{
      selector: 'form-ngselect',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div *ngIf=\"!config.hideField\" class=\"field form-select\" [ngClass]=\"{'field-error': !control.valid && (control.dirty || control.touched), 'group-options' : config.groupOptions, 'last':config.lastChild}\" [formGroup]=\"group\">\n    <div class=\"field-label\">\n        <label attr.for=\"{{config.elementId}}{{modal?'modal':''}}\">{{config.label | translate}}\n            <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n        </label>\n    </div>\n    <div class=\"field-widget search_filter_multiselect\">\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"blurb field-blurb\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n            <div *ngIf=\"control.errors.required\">\n                <i class=\"icn-error_filled\"></i>\n                {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n            </div>\n        </div>\n        <ng-select\n                [items]=\"config.options | async\"\n                class=\"form-select-multiselect\"\n                bindLabel=\"display\"\n                groupBy=\"groupBy\"\n                labelForId=\"{{config.elementId}}{{modal?'modal':''}}\"\n                [loading]=\"loading\"\n                [multiple]=\"config.multiple\"\n                [maxSelectedItems]=\"config.maxSelectedItems\"\n                [placeholder]=\"config.placeholder | translate\"\n                [attr.aria-describedby]=\"describedByValue\"\n                [searchable]=\"searchable\"\n                clearAllText=\"Clear\"\n                formControlName=\"{{controlName}}\">\n            <ng-template  ng-label-tmp let-item=\"item\" let-clear=\"clear\">\n                <b *ngIf=\"config.ordered\">(#{{item.orderBy}})</b> {{item.display}}\n                <span class=\"ng-value-icon right\" (click)=\"clear(item); $event.stopPropagation()\" aria-hidden=\"true\" role=\"button\" title=\"delete\">\u00D7</span>\n            </ng-template>\n        </ng-select>\n    </div>\n</div>\n<div *ngIf='showDependentControl'>\n    <ng-container *ngFor=\"let field of config.dependents\" dynamicField [config]=\"field\" [group]=\"group\" [modal]=\"modal\"></ng-container>\n</div>\n",
      styles: [".ng-select .ng-control,.ng-select.ng-single .ng-control{min-height:40px;height:40px}.ng-select.ng-select-opened>.ng-select-container{background:#fff;border-color:#949494}.ng-select.ng-select-opened>.ng-select-container:hover{box-shadow:none}.ng-select.ng-select-opened.ng-select-bottom>.ng-select-container{border-bottom-right-radius:0;border-bottom-left-radius:0}.ng-select.ng-select-opened.ng-select-top>.ng-select-container{border-top-right-radius:0;border-top-left-radius:0}.ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border-color:#007eff;box-shadow:inset 0 1px 1px #00000013,0 0 0 3px #007eff1a}.ng-select.ng-select-disabled>.ng-select-container{background-color:#f9f9f9}.ng-select .ng-has-value .ng-placeholder{display:none}.ng-select .ng-select-container{background-color:#fff;border-radius:3px;border:1px solid #949494;min-height:30px;align-items:center}.ng-select .ng-select-container:hover{box-shadow:0 1px #0000000f}.ng-select .ng-select-container .ng-value-container{align-items:center;padding-left:10px}.ng-select .ng-select-container .ng-value-container .ng-placeholder{color:#aaa}.ng-select.ng-select-single .ng-select-container{height:30px}.ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{left:0;padding-left:10px;padding-right:50px;top:5px}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value{background-color:#f9f9f9;border:1px solid #e3e3e3}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value .ng-value-label{padding:0 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-left:7px;padding-top:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{font-size:.9em;margin-right:5px;margin-bottom:5px;background-color:#f5faff;border-radius:2px;border:1px solid #c2e0ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled{background-color:#f9f9f9;border:1px solid #e3e3e3}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled .ng-value-label{padding-left:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-label,.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon{display:inline-block;padding:0 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon:hover{background-color:#d8eafd}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-right:1px solid #c2e0ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:1px solid #c2e0ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding-bottom:3px;padding-left:3px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{top:5px;padding-bottom:5px;padding-left:3px}.ng-select .ng-clear-wrapper{color:#6c6c6c;top:1px}.ng-select .ng-select-container .ng-clear-wrapper .ng-clear{display:block}.ng-select .ng-clear-wrapper .ng-clear:hover{color:#d0021b}.ng-select .ng-spinner-zone{padding-right:5px;padding-top:5px}.ng-select .ng-arrow-wrapper{padding-right:5px;width:25px}.ng-select .ng-arrow-wrapper .ng-arrow{width:30px!important;margin-left:2px;vertical-align:middle;background:url(/components/unicon/assets/svg-output/chevron_down_light.svg) no-repeat center right 15px;background-size:17px;height:20px!important}[dir=rtl] .ng-select .ng-arrow-wrapper .ng-arrow{background:url(/components/unicon/assets/svg-output/chevron_down_light.svg) no-repeat center left 15px/17px}.ng-dropdown-panel{background-color:#fff;border:1px solid #ccc;box-shadow:0 1px #0000000f;left:0}[dir=rtl] .ng-dropdown-panel{text-align:right}.ng-dropdown-panel.ng-select-bottom{top:100%;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-top-color:#e6e6e6;margin-top:-1px}.ng-dropdown-panel.ng-select-bottom .ng-dropdown-panel-items .ng-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.ng-dropdown-panel.ng-select-top{bottom:100%;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-color:#e6e6e6;margin-bottom:-1px}.ng-dropdown-panel.ng-select-top .ng-dropdown-panel-items .ng-option:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.ng-dropdown-panel .ng-dropdown-header{border-bottom:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-footer{border-top:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-panel-items{margin-bottom:1px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{-webkit-user-select:none;user-select:none;cursor:default;padding:8px 10px;font-weight:500;color:#0000008a;cursor:pointer}.group-options .ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{font-weight:700;color:#444}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-disabled{cursor:default}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-marked{background-color:#ebf5ff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected{background-color:#f5faff;font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option{background-color:#fff;color:#3e3e3ede;padding:8px 10px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected{color:#333;background-color:#f5faff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label{font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked{background-color:#428bca;color:#fff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled{color:#ccc}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-left:22px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{padding-right:5px;font-size:80%;font-weight:400}\n"]
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormNGSelectComponent, {
    className: "JanusFormNGSelectComponent",
    filePath: "janus/components/form-ngselect/janus-form-ngselect.component.ts",
    lineNumber: 11
  });
})();
const _c0$h = (a0, a1, a2, a3) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2,
  "pe-none": a3
});
const _c1$d = a0 => ({
  field_name: a0
});
const _c2$a = a0 => ({
  widget: a0
});
const _c3$8 = a0 => ({
  item: a0
});
const _c4$7 = (a0, a1, a2, a3) => ({
  "text-white bg-primary": a0,
  "text-dark bg-light": a1,
  "text-white bg-warning": a2,
  "bg-warning-subtle text-warning": a3
});
const _c5$5 = (a0, a1, a2) => ({
  "text-white bg-primary": a0,
  "text-white bg-warning": a1,
  "text-dark bg-light": a2
});
const _c6$4 = a0 => ({
  "btn-close-white": a0
});
function JanusFormLocationComponent_div_0_div_6_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$d, ctx_r1.translatedLabel)), " ");
  }
}
function JanusFormLocationComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26)(1, "div", 27);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 28);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, JanusFormLocationComponent_div_0_div_6_ng_container_4_Template, 3, 6, "ng-container", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors == null ? null : ctx_r1.control.errors.required);
  }
}
function JanusFormLocationComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 29);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormLocationComponent_div_0_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormLocationComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, JanusFormLocationComponent_div_0_div_8_ng_container_1_Template, 1, 0, "ng-container", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.config.blurbTemplate);
  }
}
function JanusFormLocationComponent_div_0_ng_container_10_ng_container_4_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 34);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("keydown", function JanusFormLocationComponent_div_0_ng_container_10_ng_container_4_li_1_Template_li_keydown_0_listener($event) {
      const ctx_r3 = i0.ɵɵrestoreView(_r3);
      const selection_r5 = ctx_r3.$implicit;
      const i_r6 = ctx_r3.index;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.chipNav($event, selection_r5, i_r6));
    });
    i0.ɵɵelementStart(2, "button", 35);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("click", function JanusFormLocationComponent_div_0_ng_container_10_ng_container_4_li_1_Template_button_click_2_listener() {
      const selection_r5 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.removeChip(selection_r5));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelement(5, "span", 36);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selection_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    const isLast_r7 = ctx.last;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("chip-highlight", isLast_r7);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 11, "misc.Remove Item", i0.ɵɵpureFunction1(17, _c3$8, selection_r5.value)))("aria-setsize", ctx_r1.control.value.length)("aria-posinset", i_r6 + 1)("tabindex", ctx_r1.getChipTabIndex(i_r6));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(19, _c4$7, ctx_r1.focusin && !selection_r5["notFound"], !ctx_r1.focusin && !selection_r5["notFound"], ctx_r1.focusin && selection_r5["notFound"], !ctx_r1.focusin && selection_r5["notFound"]));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(3, 14, "misc.Item - Remove", i0.ɵɵpureFunction1(24, _c3$8, selection_r5.value)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", selection_r5.value, " ");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("btn-close-white", ctx_r1.focusin);
  }
}
function JanusFormLocationComponent_div_0_ng_container_10_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormLocationComponent_div_0_ng_container_10_ng_container_4_li_1_Template, 6, 26, "li", 33);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.control.value);
  }
}
function JanusFormLocationComponent_div_0_ng_container_10_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li", 37);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("keydown", function JanusFormLocationComponent_div_0_ng_container_10_ng_container_5_Template_li_keydown_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.removeChip(ctx_r1.control.value));
    });
    i0.ɵɵelementStart(3, "button", 38);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("click", function JanusFormLocationComponent_div_0_ng_container_10_ng_container_5_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.removeChip(ctx_r1.control.value));
    });
    i0.ɵɵtext(5);
    i0.ɵɵelement(6, "span", 39);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", "option")("aria-label", i0.ɵɵpipeBind2(2, 7, "misc.Remove Item", i0.ɵɵpureFunction1(13, _c3$8, ctx_r1.control.value.value)))("tabindex", "1");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(15, _c5$5, ctx_r1.focusin, ctx_r1.focusin && ctx_r1.showLocationNotFoundError, !ctx_r1.focusin));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(4, 10, "misc.Item - Remove", i0.ɵɵpureFunction1(19, _c3$8, ctx_r1.control.value.value)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.control.value.value, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c6$4, ctx_r1.focusin));
  }
}
function JanusFormLocationComponent_div_0_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 32, 3);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, JanusFormLocationComponent_div_0_ng_container_10_ng_container_4_Template, 2, 1, "ng-container", 14)(5, JanusFormLocationComponent_div_0_ng_container_10_ng_container_5_Template, 7, 23, "ng-container", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(3, 3, "misc.widget selection", i0.ɵɵpureFunction1(6, _c2$a, ctx_r1.config.label)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.multiple);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.multiple);
  }
}
function JanusFormLocationComponent_div_0_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 40);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function JanusFormLocationComponent_div_0_Conditional_18_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      i0.ɵɵnextContext();
      const searchInput_r10 = i0.ɵɵreference(13);
      const ctx_r1 = i0.ɵɵnextContext();
      $event.stopPropagation();
      ctx_r1.clearValue($event);
      return i0.ɵɵresetView(searchInput_r10.focus());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 41);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", !ctx_r1.query);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 3, "misc.Clear"));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-x");
  }
}
function JanusFormLocationComponent_div_0_Conditional_26_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hierarchical-list-widget", 42, 4);
    i0.ɵɵlistener("selection", function JanusFormLocationComponent_div_0_Conditional_26_Template_hierarchical_list_widget_selection_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      i0.ɵɵnextContext();
      const mobileButton_r12 = i0.ɵɵreference(23);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.hpWidgetOnSelect($event, mobileButton_r12));
    })("searchChanged", function JanusFormLocationComponent_div_0_Conditional_26_Template_hierarchical_list_widget_searchChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hpWidgetOnSearch($event));
    })("searchKeyEvent", function JanusFormLocationComponent_div_0_Conditional_26_Template_hierarchical_list_widget_searchKeyEvent_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      i0.ɵɵnextContext();
      const mobileButton_r12 = i0.ɵɵreference(23);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.hpWidgetOnSearchKeyEvent($event, mobileButton_r12));
    })("navigationChanged", function JanusFormLocationComponent_div_0_Conditional_26_Template_hierarchical_list_widget_navigationChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      i0.ɵɵnextContext();
      const mobileButton_r12 = i0.ɵɵreference(23);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.hpWidgetNavigationUpdates($event, mobileButton_r12));
    })("statesChanged", function JanusFormLocationComponent_div_0_Conditional_26_Template_hierarchical_list_widget_statesChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hpWidgetStatesUpdates($event));
    })("keydown.escape", function JanusFormLocationComponent_div_0_Conditional_26_Template_hierarchical_list_widget_keydown_escape_0_listener() {
      i0.ɵɵrestoreView(_r11);
      i0.ɵɵnextContext();
      const mobileButton_r12 = i0.ɵɵreference(23);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.hpWidgetModalClose(mobileButton_r12));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", ctx_r1.hpWidgetConfig)("list", ctx_r1.hpWidgetList)("values", ctx_r1.hpWidgetSelects);
  }
}
function JanusFormLocationComponent_div_0_ng_container_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 43);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 44);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-triangle");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.config.locationNotFoundError);
  }
}
function JanusFormLocationComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "label", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵtemplate(6, JanusFormLocationComponent_div_0_div_6_Template, 5, 2, "div", 10)(7, JanusFormLocationComponent_div_0_div_7_Template, 3, 6, "div", 11)(8, JanusFormLocationComponent_div_0_div_8_Template, 2, 2, "div", 12);
    i0.ɵɵelementStart(9, "div", 13);
    i0.ɵɵlistener("focusin", function JanusFormLocationComponent_div_0_Template_div_focusin_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.focusin = true);
    })("focusout", function JanusFormLocationComponent_div_0_Template_div_focusout_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.focusin = false);
    });
    i0.ɵɵtemplate(10, JanusFormLocationComponent_div_0_ng_container_10_Template, 6, 8, "ng-container", 14);
    i0.ɵɵelementStart(11, "div", 15)(12, "input", 16, 1);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function JanusFormLocationComponent_div_0_Template_input_ngModelChange_12_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.query, $event) || (ctx_r1.query = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("typeaheadOnSelect", function JanusFormLocationComponent_div_0_Template_input_typeaheadOnSelect_12_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelect($event));
    })("typeaheadOnPreview", function JanusFormLocationComponent_div_0_Template_input_typeaheadOnPreview_12_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOptionHighlighted($event));
    })("typeaheadOnBlur", function JanusFormLocationComponent_div_0_Template_input_typeaheadOnBlur_12_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearSrLabel());
    })("keypress", function JanusFormLocationComponent_div_0_Template_input_keypress_12_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.keypress($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "span", 17);
    i0.ɵɵelementStart(17, "div", 18);
    i0.ɵɵtemplate(18, JanusFormLocationComponent_div_0_Conditional_18_Template, 4, 5, "button", 19);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(19, "svg", 20);
    i0.ɵɵelement(20, "use");
    i0.ɵɵelementEnd()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(21, "div", 21)(22, "button", 22, 2);
    i0.ɵɵlistener("click", function JanusFormLocationComponent_div_0_Template_button_click_22_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.hpWidgetToggle());
    });
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(26, JanusFormLocationComponent_div_0_Conditional_26_Template, 2, 3, "hierarchical-list-widget", 23);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(27, "div", 24);
    i0.ɵɵelement(28, "input", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(29, JanusFormLocationComponent_div_0_ng_container_29_Template, 6, 2, "ng-container", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_20_0;
    const ctx_r1 = i0.ɵɵnextContext();
    const customItemTemplate_r13 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(39, _c0$h, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild, !ctx_r1.config.lastChild, ctx_r1.control.disabled));
    i0.ɵɵattribute("aria-labelledby", ctx_r1.config.elementId)("aria-describedby", ctx_r1.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("for", ctx_r1.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 31, ctx_r1.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched))("isRequired", ctx_r1.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurbTemplate && !ctx_r1.config.blurb);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.chipList);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("haveClearBtn", ctx_r1.config.clearButton && ctx_r1.control.value);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.config.elementId);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.query);
    i0.ɵɵproperty("typeahead", ctx_r1.searchSubscription)("typeaheadMinLength", 0)("typeaheadItemTemplate", (tmp_20_0 = ctx_r1.itemTemplate) !== null && tmp_20_0 !== undefined ? tmp_20_0 : customItemTemplate_r13);
    i0.ɵɵattribute("placeholder", i0.ɵɵpipeBind1(14, 33, ctx_r1.config.placeholder))("aria-describedby", ctx_r1.describedByValue)("aria-label", i0.ɵɵpipeBind1(15, 35, ctx_r1.config.ariaLabel));
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate1("id", "sr-", ctx_r1.config.elementId, "");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.config.clearButton ? 18 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-chevron-down");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-expanded", ctx_r1.showMobileUI);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(25, 37, "misc.Add"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.showMobileUI ? 26 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.config.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.locationNotFoundError && ctx_r1.showLocationNotFoundError);
  }
}
function JanusFormLocationComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 45);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const model_r14 = ctx.item;
    i0.ɵɵpropertyInterpolate1("id", "option-", model_r14.id, "");
    i0.ɵɵpropertyInterpolate("title", model_r14.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", model_r14.value, " ");
  }
}
class JanusFormLocationComponent extends FormLocationComponent {
  constructor() {
    super(...arguments);
    this.elementRef = inject(ElementRef);
    this.assetsPath = '/app/assets/';
    this.focusin = false;
    this.showMobileUI = false;
    this.hpWidgetList = [];
    this.hpWidgetSelects = [];
  }
  setup() {
    super.setup();
    this.translatedLabel = this.translate.instant(this.config.label);
    this.queryChange.pipe(takeUntil(this.destroy$), switchMap(() => this.searchSubscription)).subscribe(values => {
      this.hpWidgetList = values;
    });
    this.control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(val => {
      let values = _.isEmpty(val) ? [] : [{
        ...val
      }];
      if (!values?.[0]?.hasOwnProperty('id')) {
        values = values.map(v => ({
          ...v,
          id: v._id
        }));
      }
      this.hpWidgetSelects = values;
    });
    this.newSearchDone$.pipe(takeUntil(this.destroy$), debounceTime(100)).subscribe(() => {
      this.adjustWidgetScroll();
    });
    this.hpWidgetConfig = {
      multiple: false,
      parentSelectable: false,
      id: `${this.config.id}-mobile-ui`,
      templateType: 'janus',
      defaultLabel: this.config.label,
      placeholder: this.config.placeholder,
      externalSearch: true
    };
  }
  hpWidgetToggle() {
    if (this.showMobileUI) {
      this.hpWidgetModalClose();
    } else {
      this.showMobileUI = true;
    }
  }
  hpWidgetOnSelect(items, focusElement) {
    items.forEach(item => {
      this.onSelect({
        item: item,
        value: item.value
      });
    });
    this.hpWidgetModalClose(focusElement);
  }
  hpWidgetModalClose(focusElement) {
    this.showMobileUI = false;
    this.hpWidgetList = [];
    focusElement?.focus();
  }
  hpWidgetOnSearch(query) {
    this.updateQuery(query);
  }
  hpWidgetOnSearchKeyEvent(event, focusElement) {
    if (event.value && event.event.key === 'Enter') {
      this.addCustom(event.value);
      this.hpWidgetModalClose(focusElement);
    }
  }
  hpWidgetStatesUpdates(states) {
    if (this.showMobileUI && !states.mobileView) {
      this.hpWidgetModalClose();
    }
  }
  hpWidgetNavigationUpdates(event, focusElement) {
    switch (event.type) {
      case 'close':
      case 'escape':
      case 'tab':
        this.hpWidgetModalClose(focusElement);
        break;
    }
  }
  adjustWidgetScroll() {
    const closestScrollEl = this.elementRef.nativeElement.closest('.approval-overlay-container') || this.elementRef.nativeElement.closest('.modal-body') || this.elementRef.nativeElement.closest('.maincol');
    if (!closestScrollEl) return;
    const typeaheadContainer = this.elementRef.nativeElement.querySelector('typeahead-container');
    if (closestScrollEl && typeaheadContainer) {
      let listBottom = typeaheadContainer.getBoundingClientRect().bottom;
      let scrollElBottom = closestScrollEl.getBoundingClientRect().bottom;
      if (listBottom > scrollElBottom) {
        closestScrollEl.scrollBy({
          left: 0,
          top: listBottom - scrollElBottom + 5,
          behavior: 'smooth'
        });
      }
    }
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormLocationComponent_BaseFactory;
      return function JanusFormLocationComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormLocationComponent_BaseFactory || (ɵJanusFormLocationComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormLocationComponent)))(__ngFactoryType__ || JanusFormLocationComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormLocationComponent,
      selectors: [["janus-form-location"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 1,
      consts: [["customItemTemplate", ""], ["searchInput", ""], ["mobileButton", ""], ["chipListElm", ""], ["hpWidget", ""], ["class", "janus-field", "role", "group", 3, "ngClass", 4, "ngIf"], ["role", "group", 1, "janus-field", 3, "ngClass"], [1, "form-label", 3, "for"], [3, "hasError", "isRequired"], [1, "field-widget"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], ["class", "form-text", 3, "id", "innerHTML", 4, "ngIf"], [3, "id", 4, "ngIf"], [1, "input-selections-group", 3, "focusin", "focusout"], [4, "ngIf"], [1, "position-relative", "d-flex", "align-items-center", "d-none", "d-sm-flex"], ["typeaheadOptionField", "value", "role", "combobox", 1, "form-control", 3, "ngModelChange", "typeaheadOnSelect", "typeaheadOnPreview", "typeaheadOnBlur", "keypress", "ngModel", "typeahead", "typeaheadMinLength", "typeaheadItemTemplate", "id"], ["role", "alert", 1, "visually-hidden", 3, "id"], [1, "d-flex", "align-items-center", "position-absolute", "end-0", "pe-3"], ["type", "button", 1, "bg-transparent", "border-0", "px-1", 3, "hidden"], ["width", "1.125rem", "height", "1.125rem"], [1, "position-relative", "d-sm-none"], ["type", "button", 1, "btn", "btn-light", 3, "click"], [1, "mobile-view", "bg-white", 3, "config", "list", "values"], [3, "formGroup"], ["type", "hidden", 3, "formControlName"], ["role", "alert", 1, "invalid-feedback"], [1, "field-error"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [1, "form-text", 3, "id", "innerHTML"], [3, "id"], [4, "ngTemplateOutlet"], ["role", "listbox", "aria-live", "polite", "aria-atomic", "true", "aria-orientation", "horizontal", 1, "list-unstyled", "list-inline", "d-flex", "flex-wrap", "gap-2", "mb-2", "mt-n1"], ["role", "option", "class", "list-inline-item", 3, "chip-highlight", "keydown", 4, "ngFor", "ngForOf"], ["role", "option", 1, "list-inline-item", 3, "keydown"], ["type", "button", "role", "option", "aria-selected", "true", "aria-hidden", "true", "tabindex", "-1", 1, "btn", "d-inline-flex", "badge", "minw-0", 3, "click", "ngClass"], [1, "d-flex", "align-items-center", "btn-close", "ms-2", "me-0", "p-0"], [1, "chip", "chip-highlight", 3, "keydown"], ["type", "button", "aria-selected", "true", "role", "option", "tabindex", "-1", "aria-hidden", "true", 1, "btn", "d-inline-flex", "badge", "minw-0", 3, "click", "ngClass"], [1, "d-flex", "align-items-center", "btn-close", "ms-2", "me-0", "p-0", 3, "ngClass"], ["type", "button", 1, "bg-transparent", "border-0", "px-1", 3, "click", "hidden"], ["width", "1rem", "height", "1rem", 1, "filter-remove", "d-flex"], [1, "mobile-view", "bg-white", 3, "selection", "searchChanged", "searchKeyEvent", "navigationChanged", "statesChanged", "keydown.escape", "config", "list", "values"], ["role", "alert", 1, "text-warning", "form-text", "mt-2"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1", "d-inline"], [1, "p-0", "text-truncate-2", "text-break", "text-wrap", 3, "id", "title"]],
      template: function JanusFormLocationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormLocationComponent_div_0_Template, 30, 44, "div", 5)(1, JanusFormLocationComponent_ng_template_1_Template, 2, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.NgModel, i2$1.FormGroupDirective, i2$1.FormControlName, hierarchicalListWidgetComponent, i3$1.TypeaheadDirective, JanusRequiredComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: [".mobile-view[_ngcontent-%COMP%]{position:fixed!important;top:0!important;left:0!important;width:100vw;height:100vh;max-height:100vh;margin:0!important;z-index:1020;transform:none!important}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormLocationComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-location',
      standalone: false,
      template: "<div *ngIf=\"!config.hideField\"\n    class=\"janus-field\"\n    role=\"group\"\n    [attr.aria-labelledby]=\"config.elementId\"\n    [attr.aria-describedby]=\"describedByValue\"\n    [ngClass]=\"{\n        'is-invalid': !control.valid && (control.dirty || control.touched),\n        'last': config.lastChild,\n        'mb-4': !config.lastChild,\n        'pe-none': control.disabled\n    }\"\n>\n    <label class=\"form-label\" for=\"{{config.elementId}}\">\n        {{config.label | translate}}\n        <janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\" />\n    </label>\n    <div class=\"field-widget\">\n        <div class=\"invalid-feedback\" role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n            <div class=\"field-error\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                </svg>\n                <ng-container *ngIf=\"control.errors?.required\">\n                    {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n                </ng-container>\n            </div>\n        </div>\n\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div *ngIf=\"config.blurbTemplate && !config.blurb\" id=\"{{describedByValue}}\">\n            <ng-container *ngTemplateOutlet=\"config.blurbTemplate\"></ng-container>\n        </div>\n        \n        <div class=\"input-selections-group\" (focusin)=\"focusin = true\" (focusout)=\"focusin = false\">\n            <ng-container *ngIf=\"chipList\">\n                <ul #chipListElm\n                    class=\"list-unstyled list-inline d-flex flex-wrap gap-2 mb-2 mt-n1\"\n                    role=\"listbox\"\n                    aria-live=\"polite\"\n                    aria-atomic=\"true\"\n                    aria-orientation=\"horizontal\"\n                    [attr.aria-label]=\"'misc.widget selection' | translate : { widget: config.label }\"\n                >\n                    <ng-container *ngIf=\"multiple\">\n                        <li *ngFor=\"let selection of control.value; index as i, last as isLast\"\n                            role=\"option\"\n                            [attr.aria-label]=\"'misc.Remove Item' | translate : {item: selection.value}\"\n                            [attr.aria-setsize]=\"control.value.length\"\n                            [attr.aria-posinset]=\"i + 1\"\n                            [attr.tabindex]=\"getChipTabIndex(i)\"\n                            [class.chip-highlight]=\"isLast\"\n                            (keydown)=\"chipNav($event, selection, i)\"\n                            class=\"list-inline-item\"\n                        >\n                            <button\n                                type=\"button\"\n                                class=\"btn d-inline-flex badge minw-0\"\n                                role=\"option\"\n                                aria-selected=\"true\"\n                                aria-hidden=\"true\"\n                                tabindex=\"-1\"\n                                [attr.aria-label]=\"'misc.Item - Remove' | translate : {item: selection.value }\"\n                                [ngClass]=\"{\n                                    'text-white bg-primary': focusin && !selection['notFound'],\n                                    'text-dark bg-light': !focusin && !selection['notFound'],\n                                    'text-white bg-warning': focusin && selection['notFound'],\n                                    'bg-warning-subtle text-warning': !focusin && selection['notFound']\n                                }\"\n                                (click)=\"removeChip(selection)\"\n                            >\n                                {{selection.value}}\n                                <span class=\"d-flex align-items-center btn-close ms-2 me-0 p-0\" \n                                      [class.btn-close-white]=\"focusin\"\n                                ></span>\n                            </button>\n                        </li>\n                    </ng-container>\n\n                    <ng-container *ngIf=\"!multiple\">\n                        <li [attr.role]=\"'option'\"\n                            [attr.aria-label]=\"'misc.Remove Item' | translate : {item: control.value.value}\"\n                            [attr.tabindex]=\"'1'\"\n                            (keydown)=\"removeChip(control.value)\"\n                            class=\"chip chip-highlight\"\n                        >\n                            <button\n                                type=\"button\"\n                                class=\"btn d-inline-flex badge minw-0\"\n                                aria-selected=\"true\"\n                                role=\"option\"\n                                tabindex=\"-1\"\n                                aria-hidden=\"true\"\n                                [attr.aria-label]=\"'misc.Item - Remove' | translate : { item: control.value.value }\"\n                                [ngClass]=\"{\n                                    'text-white bg-primary': focusin,\n                                    'text-white bg-warning': focusin && showLocationNotFoundError,\n                                    'text-dark bg-light': !focusin\n                                }\"\n                                (click)=\"removeChip(control.value)\"\n                            >\n                                {{control.value.value}}\n                                <span\n                                    class=\"d-flex align-items-center btn-close ms-2 me-0 p-0\" \n                                    [ngClass]=\"{'btn-close-white': focusin}\"\n                                ></span>\n                            </button>\n                        </li>\n                    </ng-container>\n\n                </ul>\n            </ng-container>\n\n            <div class=\"position-relative d-flex align-items-center d-none d-sm-flex\">\n                <input\n                    #searchInput\n                    [(ngModel)]=\"query\"\n                    [typeahead]=\"searchSubscription\"\n                    typeaheadOptionField=\"value\"\n                    [typeaheadMinLength]=\"0\"\n                    [typeaheadItemTemplate]=\"itemTemplate ?? customItemTemplate\"\n                    (typeaheadOnSelect)=\"onSelect($event)\"\n                    (typeaheadOnPreview)=\"onOptionHighlighted($event)\"\n                    (typeaheadOnBlur)=\"clearSrLabel()\"\n                    (keypress)=\"keypress($event)\"\n                    [attr.placeholder]=\"config.placeholder | translate\"\n                    [attr.aria-describedby]=\"describedByValue\"\n                    [attr.aria-label]=\"config.ariaLabel | translate\"\n                    [class.haveClearBtn]=\"config.clearButton && control.value\"\n                    id=\"{{config.elementId}}\"\n                    role=\"combobox\"\n                    class=\"form-control\"\n                />\n                \n                <span class='visually-hidden' role='alert' id='sr-{{config.elementId}}'></span>\n                <div class=\"d-flex align-items-center position-absolute end-0 pe-3\">\n                    @if (config.clearButton) {\n                        <button\n                            type=\"button\"\n                            class=\"bg-transparent border-0 px-1\"\n                            [hidden]=\"!query\"\n                            [attr.aria-label]=\"'misc.Clear' | translate\"\n                            (click)=\"$event.stopPropagation(); clearValue($event); searchInput.focus()\"\n                        >\n                            <svg width=\"1rem\" height=\"1rem\" class=\"filter-remove d-flex\">\n                                <use [attr.href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-x'\"></use>\n                            </svg>\n                        </button>\n                    }\n                    <svg width=\"1.125rem\" height=\"1.125rem\">\n                        <use [attr.href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-chevron-down'\"></use>\n                    </svg>\n                </div>\n            </div>\n\n            <div class=\"position-relative d-sm-none\">\n                <button #mobileButton\n                    type=\"button\"\n                    class=\"btn btn-light\"\n                    (click)=\"hpWidgetToggle()\"\n                    [attr.aria-expanded]=\"showMobileUI\"\n                >{{'misc.Add' | translate}}</button>\n\n                @if (showMobileUI) {\n                    <hierarchical-list-widget #hpWidget\n                        class=\"mobile-view bg-white\"\n                        [config]=\"hpWidgetConfig\"\n                        [list]=\"hpWidgetList\"\n                        [values]=\"hpWidgetSelects\"\n                        (selection)=\"hpWidgetOnSelect($event, mobileButton)\"\n                        (searchChanged)=\"hpWidgetOnSearch($event)\"\n                        (searchKeyEvent)=\"hpWidgetOnSearchKeyEvent($event, mobileButton)\"\n                        (navigationChanged)=\"hpWidgetNavigationUpdates($event, mobileButton)\"\n                        (statesChanged)=\"hpWidgetStatesUpdates($event)\"\n                        (keydown.escape)=\"hpWidgetModalClose(mobileButton)\"\n                    />\n                }\n            </div>\n\n        </div>\n\n        <div [formGroup]=\"group\">\n            <input type=\"hidden\" [formControlName]=\"config.name\"/>\n        </div>\n\n        <ng-container *ngIf=\"config.locationNotFoundError && showLocationNotFoundError\">\n            <div class=\"text-warning form-text mt-2\" role=\"alert\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1 d-inline\">\n                    <use [attr.href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-triangle'\"></use>\n                </svg>\n                <span>{{ config.locationNotFoundError }}</span>\n            </div>\n        </ng-container>\n    </div>\n</div>\n\n<ng-template #customItemTemplate let-model=\"item\" let-index=\"index\">\n    <span id=\"option-{{model.id}}\"\n        class=\"p-0 text-truncate-2 text-break text-wrap\"\n        title=\"{{ model.value }}\"\n    >\n        {{model.value}}\n    </span>\n</ng-template>\n",
      styles: [".mobile-view{position:fixed!important;top:0!important;left:0!important;width:100vw;height:100vh;max-height:100vh;margin:0!important;z-index:1020;transform:none!important}\n"]
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormLocationComponent, {
    className: "JanusFormLocationComponent",
    filePath: "janus/components/form-location/janus-form-location.component.ts",
    lineNumber: 14
  });
})();
const _c0$g = a0 => ({
  "mb-4": a0
});
function JanusFormMoxieManagerComponent_div_0_img_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r1.group.controls.background_image_thumb.value, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.thumbId);
    i0.ɵɵpropertyInterpolate("alt", ctx_r1.group.controls.background_image_thumb.value);
  }
}
function JanusFormMoxieManagerComponent_div_0_button_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function JanusFormMoxieManagerComponent_div_0_button_15_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearSelectedFile($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.clearBtnId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "misc.Clear"), " ");
  }
}
function JanusFormMoxieManagerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "span", 3);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 4)(6, "div", 5);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 6);
    i0.ɵɵtemplate(10, JanusFormMoxieManagerComponent_div_0_img_10_Template, 1, 3, "img", 7);
    i0.ɵɵelementStart(11, "div", 8)(12, "button", 9);
    i0.ɵɵlistener("click", function JanusFormMoxieManagerComponent_div_0_Template_button_click_12_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.chooseImage($event));
    });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, JanusFormMoxieManagerComponent_div_0_button_15_Template, 3, 4, "button", 10);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c0$g, !ctx_r1.config.lastChild))("formGroup", ctx_r1.group);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 11, ctx_r1.config.label), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("id", ctx_r1.config.elementId + "-desc");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 13, "misc.Recommended image size is 1500 pixels wide. The maximum file size is 3 MB."), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-labelledby", ctx_r1.config.elementId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.group.controls.background_image_thumb.value);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-describedby", ctx_r1.config.elementId + "-desc");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 15, "misc.Choose Image"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.group.controls.background_image_thumb.value);
  }
}
class JanusFormMoxieManagerComponent extends FormMoxieManagerComponent {
  constructor() {
    super(...arguments);
    this.winSize = inject(JanusWindowSizeService);
  }
  chooseImage(e) {
    this.lastFocusedElement = e.target;
    const isXs = this.winSize.xsMax();
    window.moxman.browse({
      ...this.moxmanBrowserOptions,
      ...{
        fullscreen: isXs,
        leftpanel: !isXs
      }
    });
    if (!isXs) {
      this.onMoxieDialogOpen();
    }
    return false;
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormMoxieManagerComponent_BaseFactory;
      return function JanusFormMoxieManagerComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormMoxieManagerComponent_BaseFactory || (ɵJanusFormMoxieManagerComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormMoxieManagerComponent)))(__ngFactoryType__ || JanusFormMoxieManagerComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormMoxieManagerComponent,
      selectors: [["janus-moxiemanager"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "janus-field d-flex flex-column", 3, "ngClass", "formGroup", 4, "ngIf"], [1, "janus-field", "d-flex", "flex-column", 3, "ngClass", "formGroup"], [1, "form-label"], [3, "id"], [1, "field-widget"], [1, "blurb", "form-text", "mb-1"], [1, "moxie_manager_image_widget", "d-flex", "align-items-center"], ["class", "me-2 mw-100 h-auto border border-gray-500 rounded", 3, "src", "id", "alt", 4, "ngIf"], [1, "d-flex", "flex-column"], ["type", "button", 1, "btn", "btn-light", "fs-6", "fw-medium", "mb-1", 3, "click"], ["type", "button", "class", "btn btn-light fs-6 fw-medium", 3, "id", "click", 4, "ngIf"], [1, "me-2", "mw-100", "h-auto", "border", "border-gray-500", "rounded", 3, "src", "id", "alt"], ["type", "button", 1, "btn", "btn-light", "fs-6", "fw-medium", 3, "click", "id"]],
      template: function JanusFormMoxieManagerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormMoxieManagerComponent_div_0_Template, 16, 19, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormMoxieManagerComponent, [{
    type: Component,
    args: [{
      selector: 'janus-moxiemanager',
      template: `
        <div class="janus-field d-flex flex-column" *ngIf="!config.hideField" [ngClass]="{ 'mb-4': !config.lastChild }" [formGroup]="group">
            <div class="form-label">
                <span id="{{config.elementId}}">
                    {{config.label | translate}}
                </span>
            </div>
            <div class="field-widget">
                <div class="blurb form-text mb-1" [attr.id]="config.elementId + '-desc'">
                    {{'misc.Recommended image size is 1500 pixels wide. The maximum file size is 3 MB.'| translate}}
                </div>
                <div
                    class="moxie_manager_image_widget d-flex align-items-center"
                    [attr.aria-labelledby]="config.elementId"
                >
                    <img
                        *ngIf="group.controls.background_image_thumb.value"
                        src="{{group.controls.background_image_thumb.value}}"
                        id="{{thumbId}}"
                        class="me-2 mw-100 h-auto border border-gray-500 rounded"
                        alt="{{group.controls.background_image_thumb.value}}" 
                    />
                    <div class="d-flex flex-column">
                        <button
                            type="button"
                            class="btn btn-light fs-6 fw-medium mb-1"
                            (click)="chooseImage($event)"
                            [attr.aria-describedby]="config.elementId + '-desc'"
                        >
                            {{'misc.Choose Image' | translate}}
                        </button>
                        <button
                            *ngIf="group.controls.background_image_thumb.value"
                            id="{{clearBtnId}}"
                            type="button"
                            class="btn btn-light fs-6 fw-medium"
                            (click)="clearSelectedFile($event)"
                        >
                            {{'misc.Clear' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `,
      standalone: false
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormMoxieManagerComponent, {
    className: "JanusFormMoxieManagerComponent",
    filePath: "janus/components/form-moxiemanager/janus-form-moxiemanager.component.ts",
    lineNumber: 56
  });
})();
function JanusFormMoxieManagerStaticComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.config.title);
  }
}
function JanusFormMoxieManagerStaticComponent_div_0_img_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r0.config.value, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r0.config.elementId, "-thumb");
    i0.ɵɵpropertyInterpolate1("alt", "Slide background image filename: ", ctx_r0.config.value, "");
  }
}
function JanusFormMoxieManagerStaticComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "label", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 3);
    i0.ɵɵtemplate(5, JanusFormMoxieManagerStaticComponent_div_0_div_5_Template, 2, 1, "div", 4);
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵtemplate(7, JanusFormMoxieManagerStaticComponent_div_0_img_7_Template, 1, 5, "img", 6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.group);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, ctx_r0.config.label), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.config.title);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.value);
  }
}
class JanusFormMoxieManagerStaticComponent extends FormMoxieManagerStaticComponent {
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormMoxieManagerStaticComponent_BaseFactory;
      return function JanusFormMoxieManagerStaticComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormMoxieManagerStaticComponent_BaseFactory || (ɵJanusFormMoxieManagerStaticComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormMoxieManagerStaticComponent)))(__ngFactoryType__ || JanusFormMoxieManagerStaticComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormMoxieManagerStaticComponent,
      selectors: [["janus-imgstatic"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "janus-field form-upload form-custom", 3, "formGroup", 4, "ngIf"], [1, "janus-field", "form-upload", "form-custom", 3, "formGroup"], [1, "form-label"], [1, "field-widget"], ["class", "form-text", 4, "ngIf"], [1, "moxie_manager_image_widget"], ["class", "me-2 mw-100 h-auto border border-gray-500 rounded", 3, "src", "id", "alt", 4, "ngIf"], [1, "form-text"], [1, "me-2", "mw-100", "h-auto", "border", "border-gray-500", "rounded", 3, "src", "id", "alt"]],
      template: function JanusFormMoxieManagerStaticComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormMoxieManagerStaticComponent_div_0_Template, 8, 6, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.config.value && !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgIf, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormMoxieManagerStaticComponent, [{
    type: Component,
    args: [{
      selector: 'janus-imgstatic',
      template: `
        <div *ngIf="config.value && !config.hideField" class="janus-field form-upload form-custom" [formGroup]="group">
            <label class="form-label">
                {{config.label | translate}}
            </label>
            <div class="field-widget">
                <div *ngIf="config.title" class="form-text">{{config.title}}</div>
                <div class="moxie_manager_image_widget">
                    <img
                        *ngIf="config.value" 
                        src="{{config.value}}" 
                        id="{{config.elementId}}-thumb" 
                        class="me-2 mw-100 h-auto border border-gray-500 rounded"
                        alt="Slide background image filename: {{config.value}}">
                </div>
            </div>
        </div>
    `,
      standalone: false
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormMoxieManagerStaticComponent, {
    className: "JanusFormMoxieManagerStaticComponent",
    filePath: "janus/components/form-static/janus-form-moxiemanager-static.component.ts",
    lineNumber: 26
  });
})();
const _c0$f = (a0, a1) => ({
  "is-invalid": a0,
  "last": a1
});
const _c1$c = a0 => ({
  field_name: a0
});
function JanusFormMinMaxComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 9);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, "misc.invalid minmax error"), " ");
  }
}
function JanusFormMinMaxComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 9);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Field is required", i0.ɵɵpureFunction1(5, _c1$c, ctx_r1.translatedLabel)), " ");
  }
}
function JanusFormMinMaxComponent_div_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 9);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, ctx_r1.patternError), " ");
  }
}
function JanusFormMinMaxComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "label", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
    i0.ɵɵtemplate(7, JanusFormMinMaxComponent_div_0_div_7_Template, 5, 4, "div", 7)(8, JanusFormMinMaxComponent_div_0_div_8_Template, 5, 7, "div", 7)(9, JanusFormMinMaxComponent_div_0_div_9_Template, 5, 4, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "input", 8, 0);
    i0.ɵɵlistener("keypress", function JanusFormMinMaxComponent_div_0_Template_input_keypress_10_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("keypress", $event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(16, _c0$f, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched) || ctx_r1.minmax, ctx_r1.config.lastChild))("formGroup", ctx_r1.group);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 14, ctx_r1.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched))("isRequired", ctx_r1.isRequired);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.config.hideMinMaxError && ctx_r1.minmax);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched) && ctx_r1.control.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched) && ctx_r1.control.errors.pattern);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r1.config.elementId);
    i0.ɵɵproperty("formControlName", ctx_r1.config.name);
    i0.ɵɵattribute("aria-describedby", ctx_r1.describedByValue);
  }
}
class JanusFormMinMaxComponent extends FormMinMaxComponent {
  constructor() {
    super(...arguments);
    this.assetsPath = '/app/assets/';
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormMinMaxComponent_BaseFactory;
      return function JanusFormMinMaxComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormMinMaxComponent_BaseFactory || (ɵJanusFormMinMaxComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormMinMaxComponent)))(__ngFactoryType__ || JanusFormMinMaxComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormMinMaxComponent,
      selectors: [["janus-form-minmax"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["inputField", ""], ["class", "janus-field form-minmax mb-4", 3, "ngClass", "formGroup", 4, "ngIf"], [1, "janus-field", "form-minmax", "mb-4", 3, "ngClass", "formGroup"], [1, "form-label", 3, "for"], [3, "hasError", "isRequired"], [1, "field-widget"], ["role", "alert", 1, "invalid-feedback"], [4, "ngIf"], ["type", "number", 1, "form-control", 3, "keypress", "formControlName", "id"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"]],
      template: function JanusFormMinMaxComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormMinMaxComponent_div_0_Template, 12, 19, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i2$1.DefaultValueAccessor, i2$1.NumberValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, JanusRequiredComponent, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormMinMaxComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-minmax',
      standalone: false,
      template: "<div class=\"janus-field form-minmax mb-4\"\n    *ngIf=\"!config.hideField\"\n    [ngClass]=\"{'is-invalid': !control.valid && (control.dirty || control.touched) || minmax, 'last': config.lastChild}\"\n    [formGroup]=\"group\"\n>\n    <label class=\"form-label\" for=\"{{ config.elementId }}{{ modal ? 'modal' : '' }}\">\n        {{config.label | translate}}<janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\"></janus-required>\n    </label>\n    <div class=\"field-widget\">\n        <div role=\"alert\" class=\"invalid-feedback\">\n            <div *ngIf=\"!config.hideMinMaxError && minmax\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                </svg>\n                {{'misc.invalid minmax error' | translate}}\n            </div>\n            <div *ngIf=\"(!control.valid && (control.dirty || control.touched)) && control.errors.required\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                </svg>\n                {{ 'misc.Field is required' | translate: { field_name: translatedLabel } }}\n            </div>\n            <div *ngIf=\"(!control.valid && (control.dirty || control.touched)) && control.errors.pattern\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                </svg>\n                {{patternError | translate}}\n            </div>\n        </div>\n        <input\n            #inputField\n            type=\"number\"\n            [attr.aria-describedby]=\"describedByValue\"\n            [formControlName]=\"config.name\"\n            id=\"{{config.elementId}}\"\n            (keypress)=\"triggerEvent('keypress', $event);\"\n            class=\"form-control\"\n        />\n    </div>\n</div>\n"
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormMinMaxComponent, {
    className: "JanusFormMinMaxComponent",
    filePath: "janus/components/form-minmax/janus-form-minmax.component.ts",
    lineNumber: 10
  });
})();
const _c0$e = (a0, a1) => ({
  "field-error": a0,
  "last": a1
});
const _c1$b = a0 => ({
  field_name: a0
});
function JanusFormNumberComparisonComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "label", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, ctx_r1.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched))("isRequired", ctx_r1.isRequired);
  }
}
function JanusFormNumberComparisonComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 13);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r1.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormNumberComparisonComponent_div_0_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c1$b, ctx_r1.translatedLabel)), " ");
  }
}
function JanusFormNumberComparisonComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, JanusFormNumberComparisonComponent_div_0_div_4_div_1_Template, 4, 6, "div", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.required);
  }
}
function JanusFormNumberComparisonComponent_div_0_option_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const comparison_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", comparison_r3.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(comparison_r3.value);
  }
}
function JanusFormNumberComparisonComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, JanusFormNumberComparisonComponent_div_0_div_1_Template, 5, 8, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, JanusFormNumberComparisonComponent_div_0_div_3_Template, 3, 6, "div", 4)(4, JanusFormNumberComparisonComponent_div_0_div_4_Template, 2, 1, "div", 5);
    i0.ɵɵelementStart(5, "div", 6)(6, "select", 7);
    i0.ɵɵtemplate(7, JanusFormNumberComparisonComponent_div_0_option_7_Template, 2, 2, "option", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "input", 9);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵlistener("blur", function JanusFormNumberComparisonComponent_div_0_Template_input_blur_8_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("blur", $event));
    })("keypress", function JanusFormNumberComparisonComponent_div_0_Template_input_keypress_8_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEvent("keypress", $event));
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.group)("ngClass", i0.ɵɵpureFunction2(18, _c0$e, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.comparisonGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.comparisons);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("input-text ", ctx_r1.config.className, "");
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵattribute("placeholder", i0.ɵɵpipeBind1(9, 16, ctx_r1.config.placeholder))("aria-describedby", ctx_r1.describedByValue)("aria-required", ctx_r1.isRequired);
  }
}
class JanusFormNumberComparisonComponent extends FormNumberComparisonComponent {
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormNumberComparisonComponent_BaseFactory;
      return function JanusFormNumberComparisonComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormNumberComparisonComponent_BaseFactory || (ɵJanusFormNumberComparisonComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormNumberComparisonComponent)))(__ngFactoryType__ || JanusFormNumberComparisonComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormNumberComparisonComponent,
      selectors: [["janus-form-number-comparison"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "janus-field numbercomparison-widget form-custom", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "janus-field", "numbercomparison-widget", "form-custom", 3, "formGroup", "ngClass"], ["class", "form-label", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], [1, "btn-in-select", 3, "formGroup"], ["formControlName", "compare"], [3, "value", 4, "ngFor", "ngForOf"], ["formControlName", "number", "type", "number", 3, "blur", "keypress", "id"], [1, "form-label"], [3, "for"], [3, "hasError", "isRequired"], [1, "blurb", "field-blurb", 3, "id", "innerHTML"], ["role", "alert"], [4, "ngIf"], [1, "icn-error_filled"], [3, "value"]],
      template: function JanusFormNumberComparisonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusFormNumberComparisonComponent_div_0_Template, 10, 21, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.DefaultValueAccessor, i2$1.NumberValueAccessor, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, JanusRequiredComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormNumberComparisonComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-number-comparison',
      template: `
        <div
            [formGroup]="group"
            *ngIf="!config.hideField"
            class="janus-field numbercomparison-widget form-custom"
            [ngClass]="{'field-error': !control.valid && (control.dirty || control.touched), 'last': config.lastChild}"
        >
            <div *ngIf="!config.hideLabel" class="form-label">
                <label for="{{config.elementId}}{{modal?'modal':''}}">
                {{config.label | translate}}<janus-required [hasError]="(!control.valid && (control.dirty || control.touched))" [isRequired]="isRequired"></janus-required>
                </label>
            </div>
            <div class="field-widget">
                <div *ngIf="config.blurb" id="{{describedByValue}}" class="blurb field-blurb" [innerHTML]="config.blurb | translate | safeHtml"></div>
                <div role="alert" *ngIf="(!control.valid && (control.dirty || control.touched))">
                    <div *ngIf="control.errors.required">
                        <i class="icn-error_filled"></i>
                        {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}
                    </div>
                </div>
                <div class="btn-in-select" [formGroup]="comparisonGroup">
                    <select formControlName="compare">
                        <option *ngFor="let comparison of comparisons" [value]="comparison.id" >{{comparison.value}}</option>
                    </select>
                    <input
                        formControlName="number"
                        type="number"
                        id="{{config.elementId}}{{modal?'modal':''}}"
                        class="input-text {{config.className}}"
                        [attr.placeholder]="config.placeholder | translate"
                        [attr.aria-describedby]="describedByValue"
                        [attr.aria-required]="isRequired"
                        (blur)="triggerEvent('blur', $event);"
                        (keypress)="triggerEvent('keypress', $event);"
                    />
                </div>
            </div>
        </div>
    `,
      standalone: false
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormNumberComparisonComponent, {
    className: "JanusFormNumberComparisonComponent",
    filePath: "janus/components/form-number-compare/janus-form-number-compare.component.ts",
    lineNumber: 48
  });
})();
const _c0$d = (a0, a1) => ({
  "field-error": a0,
  "space-bottom-sm": a1
});
const _c1$a = a0 => ({
  "field-error": a0
});
const _c2$9 = a0 => ({
  field_name: a0
});
const _c3$7 = (a0, a1) => ({
  width: a0,
  height: a1
});
const _c4$6 = a0 => ({
  "drag-active": a0
});
const _c5$4 = a0 => ({
  "item": a0,
  "isItem": false
});
function JanusFormImageUploadComponent_div_3_div_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 20);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function JanusFormImageUploadComponent_div_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "label", 18);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, JanusFormImageUploadComponent_div_3_div_1_i_4_Template, 2, 0, "i", 19);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r0.config.elementId, "", ctx_r0.modal ? "modal" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
  }
}
function JanusFormImageUploadComponent_div_3_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 21);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$a, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched)))("id", ctx_r0.describedByValue)("innerHTML", i0.ɵɵpipeBind1(2, 5, i0.ɵɵpipeBind1(1, 3, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormImageUploadComponent_div_3_div_4_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c2$9, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormImageUploadComponent_div_3_div_4_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "misc.Upload Failed - Too big"), " ");
  }
}
function JanusFormImageUploadComponent_div_3_div_4_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "misc.Upload Failed"), " - ", i0.ɵɵpipeBind1(3, 4, "misc.Try again"), " ");
  }
}
function JanusFormImageUploadComponent_div_3_div_4_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Minimum size for upload is {width} x {height}. Please use a larger image.", i0.ɵɵpureFunction2(4, _c3$7, ctx_r0.minWidth + "px", ctx_r0.minHeight + "px")), " ");
  }
}
function JanusFormImageUploadComponent_div_3_div_4_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "misc.This file is corrupt, try again"), " ");
  }
}
function JanusFormImageUploadComponent_div_3_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelement(1, "i", 23);
    i0.ɵɵtemplate(2, JanusFormImageUploadComponent_div_3_div_4_span_2_Template, 3, 6, "span", 9);
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵtemplate(4, JanusFormImageUploadComponent_div_3_div_4_span_4_Template, 3, 3, "span", 9)(5, JanusFormImageUploadComponent_div_3_div_4_span_5_Template, 4, 6, "span", 9)(6, JanusFormImageUploadComponent_div_3_div_4_span_6_Template, 3, 7, "span", 9)(7, JanusFormImageUploadComponent_div_3_div_4_span_7_Template, 3, 3, "span", 9);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.maxSizeFile);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.api);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.minimumDimensionRequired);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors.readError);
  }
}
function JanusFormImageUploadComponent_div_3_div_5_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const errorMsg_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", errorMsg_r2, " ");
  }
}
function JanusFormImageUploadComponent_div_3_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, JanusFormImageUploadComponent_div_3_div_5_span_1_Template, 2, 1, "span", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.fileUploadConfig.customErrors);
  }
}
function JanusFormImageUploadComponent_div_3_ng_template_7_Template(rf, ctx) {}
function JanusFormImageUploadComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, JanusFormImageUploadComponent_div_3_div_1_Template, 5, 7, "div", 11);
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵtemplate(3, JanusFormImageUploadComponent_div_3_div_3_Template, 3, 9, "div", 13)(4, JanusFormImageUploadComponent_div_3_div_4_Template, 8, 5, "div", 14)(5, JanusFormImageUploadComponent_div_3_div_5_Template, 2, 1, "div", 15);
    i0.ɵɵelementContainerStart(6);
    i0.ɵɵtemplate(7, JanusFormImageUploadComponent_div_3_ng_template_7_Template, 0, 0, "ng-template", 16);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const field_r3 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$d, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.imageLoaded))("formGroup", ctx_r0.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.hideLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched) && !ctx_r0.fileUploadConfig.customErrors);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fileUploadConfig.customErrors == null ? null : ctx_r0.fileUploadConfig.customErrors.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", field_r3);
  }
}
function JanusFormImageUploadComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "image-crop", 26);
    i0.ɵɵlistener("onCropped", function JanusFormImageUploadComponent_ng_container_4_Template_image_crop_onCropped_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.setCroppedImage($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("url", ctx_r0.currentImage)("roundCorners", ctx_r0.config.rounded);
  }
}
function JanusFormImageUploadComponent_ng_template_5_ng_container_1_1_ng_template_0_Template(rf, ctx) {}
function JanusFormImageUploadComponent_ng_template_5_ng_container_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormImageUploadComponent_ng_template_5_ng_container_1_1_ng_template_0_Template, 0, 0, "ng-template", 16);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const uploadField_r5 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", uploadField_r5);
  }
}
function JanusFormImageUploadComponent_ng_template_5_ng_container_1_2_ng_template_0_Template(rf, ctx) {}
function JanusFormImageUploadComponent_ng_template_5_ng_container_1_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormImageUploadComponent_ng_template_5_ng_container_1_2_ng_template_0_Template, 0, 0, "ng-template", 16);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const uploadProcess_r6 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", uploadProcess_r6);
  }
}
function JanusFormImageUploadComponent_ng_template_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormImageUploadComponent_ng_template_5_ng_container_1_1_Template, 1, 1, null, 9)(2, JanusFormImageUploadComponent_ng_template_5_ng_container_1_2_Template, 1, 1, null, 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.uploadFiles == null ? null : ctx_r0.uploadFiles.length) || ctx_r0.isErrorItem(ctx_r0.firstItem));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.uploadFiles.length && ctx_r0.isProgressItem(ctx_r0.firstItem));
  }
}
function JanusFormImageUploadComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, JanusFormImageUploadComponent_ng_template_5_ng_container_1_Template, 3, 2, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-describedby", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.imageLoaded);
  }
}
function JanusFormImageUploadComponent_ng_template_7_button_0_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "fileSize");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "misc.Max file size:"), "\u00A0", i0.ɵɵpipeBind1(3, 4, ctx_r0.fileUploadConfig.maxFileSize), " ");
  }
}
function JanusFormImageUploadComponent_ng_template_7_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29, 5)(2, "span", 30);
    i0.ɵɵlistener("dragenter", function JanusFormImageUploadComponent_ng_template_7_button_0_Template_span_dragenter_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragEnter());
    })("dragover", function JanusFormImageUploadComponent_ng_template_7_button_0_Template_span_dragover_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragOver());
    })("dragleave", function JanusFormImageUploadComponent_ng_template_7_button_0_Template_span_dragleave_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragLeave());
    })("drop", function JanusFormImageUploadComponent_ng_template_7_button_0_Template_span_drop_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDrop());
    });
    i0.ɵɵelement(3, "i", 31)(4, "span", 32);
    i0.ɵɵtemplate(5, JanusFormImageUploadComponent_ng_template_7_button_0_span_5_Template, 4, 6, "span", 33);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const flow_r8 = i0.ɵɵreference(2);
    i0.ɵɵproperty("flowAttributes", ctx_r0.flowAttributes)("flow", flow_r8.flowJs)("ngClass", i0.ɵɵpureFunction1(6, _c4$6, ctx_r0.dragActive));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("flow", flow_r8.flowJs);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.fileUploadText, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.fileUploadConfig.maxFileSize);
  }
}
function JanusFormImageUploadComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormImageUploadComponent_ng_template_7_button_0_Template, 6, 8, "button", 28);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.readOnly);
  }
}
function JanusFormImageUploadComponent_ng_template_9_ng_template_1_Template(rf, ctx) {}
function JanusFormImageUploadComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, JanusFormImageUploadComponent_ng_template_9_ng_template_1_Template, 0, 0, "ng-template", 36);
    i0.ɵɵelementStart(2, "p", 37);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 38);
    i0.ɵɵlistener("click", function JanusFormImageUploadComponent_ng_template_9_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.cancelUpload(ctx_r0.firstItem));
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const spinner_r10 = i0.ɵɵreference(12);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", spinner_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c5$4, ctx_r0.firstItem));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(4, 5, "misc.Uploading"), " ", ctx_r0.firstItem == null ? null : ctx_r0.firstItem.fileSelected.name, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 7, "misc.Cancel"), " ");
  }
}
function JanusFormImageUploadComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 39);
    i0.ɵɵelement(1, "progress-spinner", 40);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r11 = ctx.item;
    const isItem_r12 = ctx.isItem;
    i0.ɵɵproperty("ngClass", isItem_r12 ? "icon-wrapper" : "space-bottom-sm");
    i0.ɵɵadvance();
    i0.ɵɵproperty("strokeWidth", 2)("radius", 7)("progress", item_r11.uploadProgress);
  }
}
class JanusFormImageUploadComponent extends FormImageUploadComponent {
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormImageUploadComponent_BaseFactory;
      return function JanusFormImageUploadComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormImageUploadComponent_BaseFactory || (ɵJanusFormImageUploadComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormImageUploadComponent)))(__ngFactoryType__ || JanusFormImageUploadComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormImageUploadComponent,
      selectors: [["form-image-upload"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 13,
      vars: 4,
      consts: [["flow", "flow"], ["field", ""], ["uploadField", ""], ["uploadProcess", ""], ["spinner", ""], ["fileUploadWrapper", ""], [1, "flexbox", "flex-column", 3, "ngClass"], [3, "flowConfig"], ["class", "field form-file-upload no-margin", 3, "ngClass", "formGroup", 4, "ngIf"], [4, "ngIf"], [1, "field", "form-file-upload", "no-margin", 3, "ngClass", "formGroup"], ["class", "field-label", 4, "ngIf"], [1, "field-widget"], ["class", "blurb field-blurb", 3, "ngClass", "id", "innerHTML", 4, "ngIf"], ["role", "alert", 4, "ngIf"], ["role", "alert", "class", "form-file-custom-errors", 4, "ngIf"], [3, "ngTemplateOutlet"], [1, "field-label"], [3, "for"], ["class", "req-indicator", 4, "ngIf"], [1, "req-indicator"], [1, "blurb", "field-blurb", 3, "ngClass", "id", "innerHTML"], ["role", "alert"], [1, "icn-error_filled"], ["role", "alert", 1, "form-file-custom-errors"], [4, "ngFor", "ngForOf"], [3, "onCropped", "url", "roundCorners"], ["aria-live", "polite"], ["type", "button", "flowButton", "", "class", "file-upload-wrapper full_width no-padding", "style", "height: 250px", 3, "flowAttributes", "flow", "ngClass", 4, "ngIf"], ["type", "button", "flowButton", "", 1, "file-upload-wrapper", "full_width", "no-padding", 2, "height", "250px", 3, "flowAttributes", "flow", "ngClass"], ["flowDrop", "", 1, "padding-md", "flexbox", "flex-column", "align-items-center", "text-center", 3, "dragenter", "dragover", "dragleave", "drop", "flow"], [1, "icn-cloud_upload", "file-upload-icon", "icon-md", "flexbox", "align-items-center", "justified-content-center", "space-bottom-sm"], [1, "file-upload-text", "space-bottom-xs", 3, "innerHTML"], ["class", "file-upload-blurb body-small font_weight_light secondary-text", 4, "ngIf"], [1, "file-upload-blurb", "body-small", "font_weight_light", "secondary-text"], [1, "file-uploading-wrapper", "padding-md", "flexbox", "flex-column", "align-items-center", "text-center"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "file-upload-text", "space-bottom-xs", "text-truncate", "full_width"], ["type", "button", 1, "button-like", "body-small", "font_weight_light", 3, "click"], [1, "file-upload-icon", "flexbox", "align-items-center", "justified-content-center", 3, "ngClass"], ["mode", "determinate", 3, "strokeWidth", "radius", "progress"]],
      template: function JanusFormImageUploadComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 6);
          i0.ɵɵelementContainer(1, 7, 0);
          i0.ɵɵtemplate(3, JanusFormImageUploadComponent_div_3_Template, 8, 10, "div", 8)(4, JanusFormImageUploadComponent_ng_container_4_Template, 2, 2, "ng-container", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, JanusFormImageUploadComponent_ng_template_5_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(7, JanusFormImageUploadComponent_ng_template_7_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(9, JanusFormImageUploadComponent_ng_template_9_Template, 8, 11, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(11, JanusFormImageUploadComponent_ng_template_11_Template, 2, 4, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.config.styleClasses);
          i0.ɵɵadvance();
          i0.ɵɵproperty("flowConfig", ctx.flowConfig);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.imageLoaded);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, ProgressSpinnerComponent, ImageCropComponent, i5.ButtonDirective, i5.DropDirective, i5.FlowDirective, i1$1.TranslatePipe, FileSizePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormImageUploadComponent, [{
    type: Component,
    args: [{
      selector: 'form-image-upload',
      standalone: false,
      template: "<div class=\"flexbox flex-column\" [ngClass]=\"config.styleClasses\">\n  <ng-container #flow=\"flow\" [flowConfig]=\"flowConfig\"></ng-container>\n  <div\n          *ngIf=\"!config.hideField\"\n          class=\"field form-file-upload no-margin\"\n          [ngClass]=\"{\n            'field-error': !control.valid && (control.dirty || control.touched),\n            'space-bottom-sm': imageLoaded}\"\n          [formGroup]=\"group\">\n    <div *ngIf=\"!config.hideLabel\" class=\"field-label\">\n      <label for=\"{{ config.elementId }}{{ modal ? 'modal' : '' }}\">\n        {{ config.label | translate }}\n        <i *ngIf=\"isRequired\" class=\"req-indicator\">*</i>\n      </label>\n    </div>\n    <div class=\"field-widget\">\n      <div\n              *ngIf=\"config.blurb\"\n              class=\"blurb field-blurb\"\n              [ngClass]=\"{\n        'field-error': !control.valid && (control.dirty || control.touched)}\"\n              [id]=\"describedByValue\"\n              [innerHTML]=\"config.blurb | translate | safeHtml\">\n      </div>\n      <div\n        *ngIf=\"(!control.valid && (control.dirty || control.touched) && !fileUploadConfig.customErrors)\"\n        role=\"alert\">\n        <i class=\"icn-error_filled\"></i>\n        <span *ngIf=\"control.errors.required\">\n          {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n        </span>\n        <ng-container>\n          <span *ngIf=\"control.errors.maxSizeFile\">\n            {{ 'misc.Upload Failed - Too big' | translate }}\n          </span>\n          <span *ngIf=\"control.errors.api\">\n            {{ 'misc.Upload Failed' | translate }} -\n            {{ 'misc.Try again' | translate }}\n          </span>\n          <span *ngIf=\"control.errors.minimumDimensionRequired\">\n            {{'misc.Minimum size for upload is {width} x {height}. Please use a larger image.' | translate: {width: (minWidth + 'px'), height: (minHeight + 'px')} }}\n          </span>\n          <span *ngIf=\"control.errors.readError\">\n            {{'misc.This file is corrupt, try again' | translate }}\n          </span>\n        </ng-container>\n      </div>\n      <div\n        *ngIf=\"fileUploadConfig.customErrors?.length\"\n        role=\"alert\"\n        class=\"form-file-custom-errors\">\n        <span *ngFor=\"let errorMsg of fileUploadConfig.customErrors\">\n          {{errorMsg}}\n        </span>\n      </div>\n      <ng-container>\n        <ng-template [ngTemplateOutlet]=\"field\"></ng-template>\n      </ng-container>\n    </div>\n  </div>\n  <ng-container *ngIf=\"imageLoaded\">\n    <image-crop [url]=\"currentImage\" (onCropped)=\"setCroppedImage($event)\" [roundCorners]=\"config.rounded\"></image-crop>\n  </ng-container>\n</div>\n<ng-template #field>\n  <div\n    [attr.aria-describedby]=\"describedByValue\"\n    aria-live=\"polite\">\n    <ng-container *ngIf=\"!imageLoaded\">\n      <ng-template *ngIf=\"!this.uploadFiles?.length || isErrorItem(this.firstItem)\" [ngTemplateOutlet]=\"uploadField\"></ng-template>\n      <ng-template *ngIf=\"this.uploadFiles.length && isProgressItem(this.firstItem)\" [ngTemplateOutlet]=\"uploadProcess\"></ng-template>\n    </ng-container>\n  </div>\n</ng-template>\n<ng-template #uploadField>\n  <button\n          type=\"button\"\n          *ngIf=\"!config.readOnly\"\n          #fileUploadWrapper\n          flowButton\n          [flowAttributes]=\"flowAttributes\"\n          [flow]=\"flow.flowJs\"\n          class=\"file-upload-wrapper full_width no-padding\"\n          style=\"height: 250px\"\n          [ngClass]=\"{ 'drag-active': dragActive }\">\n    <span\n            flowDrop\n            class=\"padding-md flexbox flex-column align-items-center text-center\"\n            [flow]=\"flow.flowJs\"\n            (dragenter)=\"onDragEnter()\"\n            (dragover)=\"onDragOver()\"\n            (dragleave)=\"onDragLeave()\"\n            (drop)=\"onDrop()\"\n    >\n      <i\n              class=\"icn-cloud_upload file-upload-icon icon-md flexbox align-items-center justified-content-center space-bottom-sm\"\n      ></i>\n\n      <span\n              class=\"file-upload-text space-bottom-xs\"\n              [innerHTML]=\"fileUploadText\"\n      ></span>\n\n      <span *ngIf=\"fileUploadConfig.maxFileSize\" class=\"file-upload-blurb body-small font_weight_light secondary-text\">\n        {{ 'misc.Max file size:' | translate}}&nbsp;{{ fileUploadConfig.maxFileSize | fileSize }}\n      </span>\n    </span>\n  </button>\n</ng-template>\n\n<ng-template #uploadProcess>\n  <div class=\"file-uploading-wrapper padding-md flexbox flex-column align-items-center text-center\">\n    <ng-template [ngTemplateOutlet]=\"spinner\" [ngTemplateOutletContext]=\"{'item': this.firstItem, 'isItem': false}\"></ng-template>\n    <p class=\"file-upload-text space-bottom-xs text-truncate full_width\">\n      {{ 'misc.Uploading' | translate }} {{ this.firstItem?.fileSelected.name }}\n    </p>\n    <button\n            type=\"button\"\n            class=\"button-like body-small font_weight_light\"\n            (click)=\"cancelUpload(this.firstItem)\">\n      {{ 'misc.Cancel' | translate }}\n    </button>\n  </div>\n</ng-template>\n\n<ng-template #spinner let-item=\"item\" let-isItem=\"isItem\">\n  <span\n    class=\"file-upload-icon flexbox align-items-center justified-content-center\"\n    [ngClass]=\"isItem ? 'icon-wrapper' : 'space-bottom-sm'\"\n  >\n    <progress-spinner\n            mode=\"determinate\"\n            [strokeWidth]=\"2\"\n            [radius]=\"7\"\n            [progress]=\"item.uploadProgress\"\n    ></progress-spinner>\n  </span>\n</ng-template>\n"
    }]
  }], null, null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormImageUploadComponent, {
    className: "JanusFormImageUploadComponent",
    filePath: "janus/components/form-image-upload/janus-form-image-upload.component.ts",
    lineNumber: 10
  });
})();
const _c0$c = (a0, a1, a2) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2
});
const _c1$9 = a0 => ({
  "visually-hidden": a0
});
const _c2$8 = a0 => ({
  "px-2": a0
});
const _c3$6 = (a0, a1) => ({
  "bg-light": a0,
  "bg-gray-100": a1
});
const _c4$5 = (a0, a1) => ({
  label: a0,
  index: a1
});
const _c5$3 = a0 => ({
  "px-3 pt-3": a0
});
const _c6$3 = a0 => ({
  x: a0
});
const _c7$2 = (a0, a1) => ({
  "my-2": a0,
  "m-2": a1
});
const _c8$1 = a0 => ({
  "d-flex justify-content-center": a0
});
const _c9$1 = (a0, a1) => ({
  "text-capitalize text-danger": a0,
  "btn-outline-secondary": a1
});
const _c10$1 = (a0, a1, a2) => ({
  "btn-outline-primary": a0,
  "btn-outline-secondary": a1,
  "btn-sm": a2
});
const _c11$1 = a0 => ({
  label: a0
});
function JanusN1Component_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(1, 1, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusN1Component_div_0_div_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusN1Component_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusN1Component_div_0_div_6_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.config.blurbTemplate);
  }
}
function JanusN1Component_div_0_div_8_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementContainer(1, 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const idx_r2 = i0.ɵɵnextContext().index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", ctx_r0.groupedControls[idx_r2])("config", ctx_r0.clonedConfig(ctx_r0.subFormConfig, idx_r2));
  }
}
function JanusN1Component_div_0_div_8_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 21);
  }
  if (rf & 2) {
    const idx_r2 = i0.ɵɵnextContext().index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("group", ctx_r0.groupedControls[idx_r2])("config", ctx_r0.clonedConfig(ctx_r0.subFormConfig, idx_r2));
  }
}
function JanusN1Component_div_0_div_8_button_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function JanusN1Component_div_0_div_8_button_12_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext();
      const control_r5 = ctx_r3.$implicit;
      const idx_r2 = ctx_r3.index;
      const ctx_r0 = i0.ɵɵnextContext(2);
      ctx_r0.removeField(idx_r2);
      return i0.ɵɵresetView(control_r5.markAsTouched());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 23);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const idx_r2 = i0.ɵɵnextContext().index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c9$1, ctx_r0.janusVersion === 1, ctx_r0.janusVersion !== 1));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 4, "misc.Delete label: item index", i0.ɵɵpureFunction2(12, _c4$5, ctx_r0.config.label, idx_r2 + 1)));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-trash", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, ctx_r0.config.n1_deletebutton_label || "misc.Delete Item"), " ");
  }
}
function JanusN1Component_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "div", 13)(3, "div", 14);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "hr", 15);
    i0.ɵɵtemplate(8, JanusN1Component_div_0_div_8_div_8_Template, 2, 2, "div", 16)(9, JanusN1Component_div_0_div_8_ng_container_9_Template, 1, 2, "ng-container", 17);
    i0.ɵɵelement(10, "hr");
    i0.ɵɵelementStart(11, "div", 18);
    i0.ɵɵtemplate(12, JanusN1Component_div_0_div_8_button_12_Template, 6, 15, "button", 19);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const idx_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(18, _c3$6, ctx_r0.janusVersion === 1, ctx_r0.janusVersion !== 1));
    i0.ɵɵattribute("aria-label", ctx_r0.config.relation_subform_max_count === null || ctx_r0.config.relation_subform_max_count !== 1 ? i0.ɵɵpipeBind2(1, 10, "misc.{label}: item {index}", i0.ɵɵpureFunction2(21, _c4$5, ctx_r0.config.label, idx_r2 + 1)) : ctx_r0.config.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroupName", idx_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c5$3, ctx_r0.janusVersion === 1));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.janusVersion === 1 ? i0.ɵɵpipeBind1(5, 13, ctx_r0.config.relation_subform_title) + ": " + (idx_r2 + 1) : i0.ɵɵpipeBind2(6, 15, "misc.Item x", i0.ɵɵpureFunction1(26, _c6$3, idx_r2 + 1)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(28, _c7$2, ctx_r0.janusVersion === 1, ctx_r0.janusVersion !== 1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.janusVersion === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.janusVersion == 2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(31, _c8$1, ctx_r0.janusVersion === 1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.n1_no_delete);
  }
}
function JanusN1Component_div_0_button_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function JanusN1Component_div_0_button_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      ctx_r0.addItem();
      return i0.ɵɵresetView(ctx_r0.control.markAsTouched());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 25);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r0.formGroupArray.invalid)("ngClass", i0.ɵɵpureFunction3(10, _c10$1, ctx_r0.janusVersion === 1, ctx_r0.janusVersion !== 1, ctx_r0.screenSize === "xs"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 5, "misc.Add new item to label", i0.ɵɵpureFunction1(14, _c11$1, ctx_r0.config.label)));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-plus", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 8, ctx_r0.config.n1_addbutton_label || "misc.Add Item"), " ");
  }
}
function JanusN1Component_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "label", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 3);
    i0.ɵɵtemplate(5, JanusN1Component_div_0_div_5_Template, 3, 5, "div", 4)(6, JanusN1Component_div_0_div_6_Template, 2, 1, "div", 5);
    i0.ɵɵelementStart(7, "div", 6);
    i0.ɵɵtemplate(8, JanusN1Component_div_0_div_8_Template, 13, 33, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 8);
    i0.ɵɵtemplate(10, JanusN1Component_div_0_button_10_Template, 6, 16, "button", 9);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(14, _c0$c, !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched), ctx_r0.config.lastChild, !ctx_r0.config.lastChild))("formGroup", ctx_r0.group);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("for", ctx_r0.config.elementId);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c1$9, ctx_r0.config.hideLabel));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 12, ctx_r0.config.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroup", ctx_r0.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurbTemplate && !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formArrayName", ctx_r0.config.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.groupedControls);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c2$8, ctx_r0.janusVersion !== 1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.checkMaxCount());
  }
}
class JanusN1Component extends JanusFormRelationComponent {
  constructor(fb, translate, cdRef, windowSize, destroyed$, janusVersion) {
    super(fb, janusVersion);
    this.fb = fb;
    this.translate = translate;
    this.cdRef = cdRef;
    this.windowSize = windowSize;
    this.destroyed$ = destroyed$;
    this.janusVersion = janusVersion;
    this.assetsPath = '/app/assets/';
    this.screenSize = '';
    this.defaultConfig = {
      relation_subform_max_count: null,
      n1_addbutton_label: 'misc.Add Item',
      n1_deletebutton_label: 'misc.Delete',
      n1_render_empty: true,
      n1_no_delete: false
    };
  }
  ngOnInit() {
    this.defaultConfig.n1_deletebutton_label = 'misc.Delete Item';
    this.windowSize.breakpoints$().pipe(takeUntil(this.destroyed$)).subscribe(size => {
      this.screenSize = size;
    });
    super.ngOnInit();
  }
  get formGroupArray() {
    return this.group.get(this.config.name);
  }
  get groupedControls() {
    return this.formGroupArray.controls;
  }
  setup() {
    Object.keys(this.defaultConfig).forEach(key => {
      if (!this.config.hasOwnProperty(key)) {
        this.config[key] = this.defaultConfig[key];
      }
    });
    this.group.setControl(this.config.name, this.fb.array([]));
    this.setValidation();
    if (!this.config.n1_render_empty) {
      this.addItem();
    }
    if (this.config.value) {
      this.config.value.forEach(item => {
        this.addItem();
      });
      this.formGroupArray.setValue(this.config.value);
    }
    if (this.config.label) {
      this.config.label = this.translate.instant(this.config.label);
    }
    const nested = this.config.config?.config;
    const title = nested?.relation_subform_title;
    if (title) {
      this.config.relation_subform_title = title;
    }
  }
  setValidation() {
    if (!this.subFormConfig.validators) {
      return;
    }
    this.groupedControls.forEach(cGroup => {
      let control = cGroup.get(this.subFormConfig.name);
      if (control) {
        control.setValidators(this.subFormConfig.validators);
        control.updateValueAndValidity();
      }
    });
  }
  addItem() {
    this.formGroupArray.push(this.fb.group({
      [this.subFormConfig.name]: ''
    }));
    if (this.config.hasOwnProperty('onAdd')) {
      this.config.onAdd(this.config.name, this.group.controls[this.config.name].getRawValue());
    }
    this.setValidation();
    this.cdRef.detectChanges();
  }
  removeField(idx) {
    if (this.config.hasOwnProperty('onDelete')) {
      this.config.onDelete(this.config.name, this.group.controls[this.config.name].getRawValue()[idx]);
    }
    this.config.value = this.config.value.filter((v, i) => i !== idx);
    this.formGroupArray.removeAt(idx);
  }
  clonedConfig(cfg, index) {
    let config = cloneDeep(cfg);
    if (this.config.value?.[index] && this.config.value?.[index][this.config.name]) {
      config.value = this.config.value[index][this.config.name];
    }
    return config;
  }
  checkMaxCount() {
    return this.config.relation_subform_max_count !== null ? this.groupedControls?.length < this.config.relation_subform_max_count : true;
  }
  static {
    this.ɵfac = function JanusN1Component_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusN1Component)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(JanusWindowSizeService), i0.ɵɵdirectiveInject(DestroyEmitter), i0.ɵɵdirectiveInject('JANUS_VERSION', 8));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusN1Component,
      selectors: [["janus-form-n1"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "janus-field", 3, "ngClass", "formGroup", 4, "ngIf"], [1, "janus-field", 3, "ngClass", "formGroup"], [1, "form-label", 3, "for", "ngClass"], [1, "field-widget", 3, "formGroup"], ["class", "form-text", 3, "innerHTML", 4, "ngIf"], [4, "ngIf"], [3, "formArrayName"], ["class", "mb-3 subform", "role", "group", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "d-xs-grid", "mb-2", 3, "ngClass"], ["class", "btn", "type", "button", 3, "disabled", "ngClass", "click", 4, "ngIf"], [1, "form-text", 3, "innerHTML"], [4, "ngTemplateOutlet"], ["role", "group", 1, "mb-3", "subform", 3, "ngClass"], [3, "formGroupName"], [1, "nplus1-title", 3, "ngClass"], [3, "ngClass"], ["class", "px-3 pt-3", 4, "ngIf"], ["janusDynamicField", "", 3, "group", "config", 4, "ngIf"], [1, "px-2", "pb-2", "janus-deletebutton", 3, "ngClass"], ["class", "btn btn-sm", "type", "button", 3, "ngClass", "click", 4, "ngIf"], [1, "px-3", "pt-3"], ["janusDynamicField", "", 3, "group", "config"], ["type", "button", 1, "btn", "btn-sm", 3, "click", "ngClass"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1", "text-danger"], ["type", "button", 1, "btn", 3, "click", "disabled", "ngClass"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"]],
      template: function JanusN1Component_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusN1Component_div_0_Template, 11, 22, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusN1Component, [{
    type: Component,
    args: [{
      selector: 'janus-form-n1',
      standalone: false,
      template: "<div\n    *ngIf=\"!config.hideField\"\n    class=\"janus-field\"\n    [ngClass]=\"{'is-invalid': !control.valid && (control.dirty || control.touched), 'last': config.lastChild, 'mb-4': !config.lastChild}\"\n    [formGroup]=\"group\">\n    <label\n        for=\"{{config.elementId}}\"\n        class=\"form-label\"\n        [ngClass]=\"{'visually-hidden': config.hideLabel}\"\n        >\n            {{config.label | translate}}\n    </label>\n    \n    <div [formGroup]=\"group\" class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" class=\"form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div *ngIf=\"config.blurbTemplate && !config.blurb\">\n            <ng-container *ngTemplateOutlet=\"config.blurbTemplate\"></ng-container>\n        </div>\n\n        <div [formArrayName]=\"config.name\">\n            <div *ngFor=\"let control of groupedControls; index as idx;\"\n                class=\"mb-3 subform\"\n                [ngClass]=\"{ 'bg-light': janusVersion === 1, 'bg-gray-100': janusVersion !== 1 }\"\n                role=\"group\"\n                [attr.aria-label]=\"\n                    config.relation_subform_max_count === null || config.relation_subform_max_count !== 1 \n                        ? ('misc.{label}: item {index}' | translate : { label: config.label, index: idx + 1 }) \n                        : config.label\n                \">\n                <div [formGroupName]=\"idx\">\n                    <div\n                        class=\"nplus1-title\"\n                        [ngClass]=\"{ 'px-3 pt-3': janusVersion === 1 }\">\n                        {{ janusVersion === 1\n                            ? (config.relation_subform_title | translate) + ': ' + (idx + 1)\n                            : ('misc.Item x' | translate:{ x: idx + 1 }) }}\n                    </div>\n                    <hr [ngClass]=\"{ 'my-2': janusVersion === 1, 'm-2': janusVersion !== 1 }\">\n                    <div *ngIf=\"janusVersion === 1\" class=\"px-3 pt-3\">\n                        <ng-container janusDynamicField [group]=\"groupedControls[idx]\" [config]=\"clonedConfig(subFormConfig, idx)\"></ng-container>\n                    </div>\n                    <ng-container *ngIf=\"janusVersion == 2\" janusDynamicField [group]=\"groupedControls[idx]\" [config]=\"clonedConfig(subFormConfig, idx)\"></ng-container>\n                    \n                    <hr>\n                    <div class=\"px-2 pb-2 janus-deletebutton\" [ngClass]=\"{ 'd-flex justify-content-center': janusVersion === 1 }\">\n                        <button\n                            *ngIf=\"!config.n1_no_delete\"\n                            (click)=\"removeField(idx); control.markAsTouched();\"\n                            class=\"btn btn-sm\"\n                            [ngClass]=\"{\n                                'text-capitalize text-danger': janusVersion === 1,\n                                'btn-outline-secondary': janusVersion !== 1\n                            }\"\n                            type=\"button\"\n                            [attr.aria-label]=\"'misc.Delete label: item index' | translate : { label: config.label, index: idx + 1 }\"\n                        >\n                            <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1 text-danger\">\n                                <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-trash'\"></use>\n                            </svg>\n                            {{(config.n1_deletebutton_label || 'misc.Delete Item') | translate}}\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"d-xs-grid mb-2\" [ngClass]=\"{'px-2': janusVersion !== 1}\">\n            <button\n                *ngIf=\"checkMaxCount()\"\n                [disabled]=\"formGroupArray.invalid\"\n                class=\"btn\"\n                [ngClass]=\"{\n                    'btn-outline-primary': janusVersion === 1,\n                    'btn-outline-secondary': janusVersion !== 1,\n                    'btn-sm': screenSize === 'xs'\n                }\"\n                type=\"button\"\n                (click)=\"addItem(); control.markAsTouched();\"\n                [attr.aria-label]=\"'misc.Add new item to label' | translate : { label: config.label }\"\n            >\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-plus'\"></use>\n                </svg>\n                {{ (config.n1_addbutton_label || 'misc.Add Item') | translate }}\n            </button>\n        </div>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }, {
    type: i1$1.TranslateService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: JanusWindowSizeService
  }, {
    type: DestroyEmitter
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['JANUS_VERSION']
    }]
  }], {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusN1Component, {
    className: "JanusN1Component",
    filePath: "janus/components/form-n1/janus-form-n1.component.ts",
    lineNumber: 15
  });
})();
const _c0$b = ["timeForm"];
const _c1$8 = ["timeModal"];
const _c2$7 = ["timeDropdown"];
const _c3$5 = ["duetDatePicker"];
const _c4$4 = (a0, a1, a2, a3) => ({
  "is-invalid": a0,
  "last": a1,
  "mb-4": a2,
  "pe-none": a3
});
const _c5$2 = a0 => ({
  field_name: a0
});
const _c6$2 = a0 => ({
  format: a0
});
function JanusFormDatetimepickerComponent_div_5_div_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Field is required", i0.ɵɵpureFunction1(4, _c5$2, ctx_r0.translatedLabel)), " ");
  }
}
function JanusFormDatetimepickerComponent_div_5_div_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Date must be in format.", i0.ɵɵpureFunction1(4, _c6$2, ctx_r0.getDateTimeFormatForGuide())), " ");
  }
}
function JanusFormDatetimepickerComponent_div_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 13);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, JanusFormDatetimepickerComponent_div_5_div_1_ng_container_4_Template, 3, 6, "ng-container", 14)(5, JanusFormDatetimepickerComponent_div_5_div_1_ng_container_5_Template, 3, 6, "ng-container", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r0.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors == null ? null : ctx_r0.control.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control.errors == null ? null : ctx_r0.control.errors.dateFormat);
  }
}
function JanusFormDatetimepickerComponent_div_5_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(1, 2, ctx_r0.config.blurb)), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormDatetimepickerComponent_div_5_div_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormDatetimepickerComponent_div_5_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, JanusFormDatetimepickerComponent_div_5_div_3_ng_container_1_Template, 1, 0, "ng-container", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.describedByValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.config.blurbTemplate);
  }
}
function JanusFormDatetimepickerComponent_div_5_Conditional_5_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 20);
  }
}
function JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "option", 35);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const num_r4 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", num_r4)("selected", ctx_r0.fieldValues.hours === num_r4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(num_r4);
  }
}
function JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Conditional_15_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "option", 35);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const num_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", num_r6)("selected", ctx_r0.fieldValues.minutes === num_r6);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(num_r6);
  }
}
function JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 36);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Conditional_15_Template_select_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r0.fieldValues.minutes, $event) || (ctx_r0.fieldValues.minutes = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(2, JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Conditional_15_ng_container_2_Template, 3, 3, "ng-container", 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.fieldValues.minutes);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 3, ctx_r0.timeConfig.ariaLabelMinutes));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.timeConfig.options.minutes);
  }
}
function JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Conditional_16_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "option", 35);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const num_r8 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", num_r8)("selected", ctx_r0.fieldValues.seconds === num_r8);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(num_r8);
  }
}
function JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 37);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Conditional_16_Template_select_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r0.fieldValues.seconds, $event) || (ctx_r0.fieldValues.seconds = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(2, JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Conditional_16_ng_container_2_Template, 3, 3, "ng-container", 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.fieldValues.seconds);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 3, ctx_r0.timeConfig.ariaLabelSeconds));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.timeConfig.options.seconds);
  }
}
function JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Conditional_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 38);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Conditional_17_Template_select_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r0 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r0.fieldValues.meridian, $event) || (ctx_r0.fieldValues.meridian = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(2, "option", 39);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "option", 40);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.fieldValues.meridian);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 6, ctx_r0.timeConfig.meridianPlaceholder));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("selected", ctx_r0.fieldValues.meridian === "am");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 8, "misc.AM"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("selected", ctx_r0.fieldValues.meridian === "pm");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 10, "misc.PM"));
  }
}
function JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23)(2, "h4", 24);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 25);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵlistener("click", function JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Template_button_click_6_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.closeTimeSelector($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 26)(9, "form", 16, 1)(11, "div", 27)(12, "select", 28);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Template_select_ngModelChange_12_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r0.fieldValues.hours, $event) || (ctx_r0.fieldValues.hours = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(14, JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_ng_container_14_Template, 3, 3, "ng-container", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Conditional_15_Template, 3, 5, "select", 30)(16, JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Conditional_16_Template, 3, 5, "select", 31)(17, JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Conditional_17_Template, 8, 12, "select", 32);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(18, "div", 33)(19, "button", 34);
    i0.ɵɵlistener("click", function JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Template_button_click_19_listener() {
      i0.ɵɵrestoreView(_r3);
      const timeForm_r10 = i0.ɵɵreference(10);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.submitTimeForm(timeForm_r10));
    });
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r0.elementId, "-timeSelector-label");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(4, 15, ctx_r0.config.label), " - ", i0.ɵɵpipeBind1(5, 17, "misc.Time"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(7, 19, "misc.Close"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r0.elementId, "-timeSelector");
    i0.ɵɵattribute("aria-labelledby", ctx_r0.elementId + "-timeSelector-label");
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.fieldValues.hours);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(13, 21, ctx_r0.timeConfig.ariaLabelHours));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.timeConfig.options.hours);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.timeConfig.showMinutes ? 15 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.timeConfig.showSeconds ? 16 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.timeConfig.showMeridian ? 17 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 23, "misc.Done"));
  }
}
function JanusFormDatetimepickerComponent_div_5_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "duet-date-picker", 18);
    i0.ɵɵlistener("duetBlur", function JanusFormDatetimepickerComponent_div_5_Conditional_5_Template_duet_date_picker_duetBlur_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      ctx_r0.checkFieldValueValid($event);
      return i0.ɵɵresetView(ctx_r0.triggerEvent("blur", $event));
    })("duetChange", function JanusFormDatetimepickerComponent_div_5_Conditional_5_Template_duet_date_picker_duetChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.selectDate($event));
    })("duetFocus", function JanusFormDatetimepickerComponent_div_5_Conditional_5_Template_duet_date_picker_duetFocus_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.triggerEvent("focus", $event));
    })("duetOpen", function JanusFormDatetimepickerComponent_div_5_Conditional_5_Template_duet_date_picker_duetOpen_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      ctx_r0.states.datePickerOpen = true;
      ctx_r0.backupValues();
      ctx_r0.resetTimeValues();
      return i0.ɵɵresetView(ctx_r0.triggerEvent("open", $event));
    })("duetClose", function JanusFormDatetimepickerComponent_div_5_Conditional_5_Template_duet_date_picker_duetClose_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      ctx_r0.states.datePickerOpen = false;
      ctx_r0.cancelPickerSelects(!ctx_r0.states.dateSelected);
      return i0.ɵɵresetView(ctx_r0.triggerEvent("close", $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "div", 19, 0);
    i0.ɵɵtemplate(4, JanusFormDatetimepickerComponent_div_5_Conditional_5_Conditional_4_Template, 1, 0, "div", 20)(5, JanusFormDatetimepickerComponent_div_5_Conditional_5_div_5_Template, 22, 25, "div", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("dateAdapter", ctx_r0.dateAdapter)("localization", ctx_r0.pickerLocalization)("value", ctx_r0.duetDatePickerValue)("identifier", ctx_r0.elementId)("disabled", ctx_r0.config.disabled)("direction", "left")("firstDayOfWeek", ctx_r0.properties == null ? null : ctx_r0.properties.firstDayOfWeek)("max", ctx_r0.properties == null ? null : ctx_r0.properties.max)("min", ctx_r0.properties == null ? null : ctx_r0.properties.min)("name", ctx_r0.properties == null ? null : ctx_r0.properties.name)("role", (ctx_r0.properties == null ? null : ctx_r0.properties.role) || "datepicker")("dateFormat", ctx_r0.dateConfig.format)("disabled", ctx_r0.control.disabled)("strictDateInput", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("autoClose", true);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.states.timePickerOpen ? 4 : -1);
  }
}
function JanusFormDatetimepickerComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, JanusFormDatetimepickerComponent_div_5_div_1_Template, 6, 3, "div", 7)(2, JanusFormDatetimepickerComponent_div_5_div_2_Template, 3, 6, "div", 8)(3, JanusFormDatetimepickerComponent_div_5_div_3_Template, 2, 2, "div", 9);
    i0.ɵɵelementStart(4, "div", 10);
    i0.ɵɵtemplate(5, JanusFormDatetimepickerComponent_div_5_Conditional_5_Template, 6, 16);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.control.valid && (ctx_r0.control.dirty || ctx_r0.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.blurbTemplate && !ctx_r0.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r0.elementId + "-field");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.readyToLoad ? 5 : -1);
  }
}
class JanusFormDatetimepickerComponent extends JanusFormDatePickerComponent {
  constructor() {
    super(...arguments);
    this.assetsPath = '/app/assets/';
    this.ngZone = inject(NgZone);
    this.readyToLoad = false;
    this.widgetConfig = {
      inputFormat: '',
      savingFormat: 'YYYY-MM-DD[T]HH:mm:ss'
    };
    this.timeConfig = {};
    this.dateConfig = {};
    this.fieldValues = {
      date: undefined,
      time: undefined,
      full: undefined,
      hours: null,
      minutes: null,
      seconds: null,
      meridian: null
    };
    this.tempFieldValues = {};
    this.states = {
      datePickerOpen: false,
      timePickerOpen: false,
      dateSelected: false,
      timeSelected: false
    };
  }
  /** Setup **/
  ngOnInit() {
    super.ngOnInit();
    this.defaultInit();
    this.readyToLoad = true;
  }
  ngAfterViewInit() {
    if (this.config.value) {
      this.onMutationUpdateDateInput(this.inputFieldElement, () => this.updateInputFieldText(this.getInputText()));
    }
  }
  defaultInit() {
    super.defaultInit();
    this.initializeConfigs();
    this.setupInitialValues();
  }
  initializeConfigs() {
    this.initializeDateConfig();
    this.initializeTimeConfig();
    this.setupWidgetConfig();
  }
  initializeDateConfig() {
    this.dateConfig = {
      format: this.dateFormat,
      ...this.config.dateConfig
    };
  }
  initializeTimeConfig() {
    const showMeridian = window.DATETIME_FORMAT?.TIME?.SHORT !== 'HH:mm';
    this.timeConfig = {
      ariaLabelHours: 'misc.hours',
      ariaLabelMinutes: 'misc.minutes',
      ariaLabelSeconds: 'misc.seconds',
      ariaLabelMeridian: 'misc.meridian',
      hoursPlaceholder: 'misc.HH',
      minutesPlaceholder: 'misc.MM',
      secondsPlaceholder: 'misc.SS',
      meridianPlaceholder: 'misc.AM/PM',
      hourStep: 1,
      minuteStep: 15,
      secondsStep: 15,
      showMinutes: true,
      showSeconds: false,
      showMeridian,
      options: this.generateTimeOptions(showMeridian),
      ...this.config.timeConfig
    };
    this.timeConfig['format'] = this.getTimeFormatString();
  }
  setupWidgetConfig() {
    this.widgetConfig.inputFormat = this.getConvertedInputFormat(this.dateConfig.format, this.timeConfig.format);
  }
  setupInitialValues() {
    if (this.config.value) {
      const momentValue = moment$1(this.config.value, this.widgetConfig.savingFormat).tz(this.userTimezone);
      this.fieldValues.full = momentValue;
      this.duetDatePickerValue = momentValue.format(this.dateConfig.format);
      this.control.setValue(this.config.value, {
        emitEvent: false
      });
      this.control.markAsTouched();
    }
  }
  onMutationUpdateDateInput(triggerFn, runFn) {
    let isTriggered = false;
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList' && !isTriggered) {
          if (triggerFn.call(this)) {
            isTriggered = true;
            observer.disconnect();
            this.ngZone.run(() => runFn.call(this));
          }
        }
      });
    });
    observer.observe(this.elementRef.nativeElement, {
      childList: true,
      subtree: true
    });
  }
  generateTimeOptions(showMeridian) {
    return {
      hours: showMeridian ? Array.from({
        length: 12
      }, (_, i) => (i + 1).toString().padStart(2, '0')) : Array.from({
        length: 24
      }, (_, i) => i.toString().padStart(2, '0')),
      minutes: this.createIntervalArray(60, this.timeConfig?.minuteStep || 15),
      seconds: this.createIntervalArray(60, this.timeConfig?.secondsStep || 15)
    };
  }
  createIntervalArray(max, interval) {
    return Array.from({
      length: Math.floor(max / interval) + 1
    }, (_, i) => (i * interval).toString().padStart(2, '0')).filter(num => parseInt(num) < max);
  }
  /** Date Picker Handler **/
  getDateAdapter(component) {
    const _this = component;
    return {
      parse(datetime, createDate) {
        if (!datetime) {
          _this.duetDatePickerValue = undefined;
          _this.fieldValues.full = undefined;
          _this.saveFormFieldValue();
        }
        if (!_this.checkDateTimeFormatValid(datetime)) {
          _this.resetFieldValues.call(_this);
          return;
        }
        const dateData = moment$1(datetime.replace(/\s/g, ''), _this.widgetConfig.inputFormat.replace(/\s/g, '')).tz(_this.userTimezone);
        _this.fieldValues.full = dateData;
        return createDate(dateData.format('YYYY'), dateData.format('MM'), dateData.format('DD'));
      },
      format(date) {
        return _this.getInputText(moment$1(date));
      }
    };
  }
  selectDate(e) {
    if (this.states.datePickerOpen) {
      this.states.dateSelected = true;
      this.fieldValues.full = moment$1(e.detail.valueAsDate).tz(this.userTimezone);
      this.updateInputFieldText(this.getInputText());
      this.openTimeSelectorModal();
      this.redirectFocusToTimeSelector();
    } else {
      this.saveFormFieldValue();
    }
  }
  /** Time Picker Handler **/
  openTimeSelectorModal() {
    // this.timeDropdown.dropup = true;
    this.timeDropdown.placement = 'top right';
    this.timeDropdown.show();
    this.states.timePickerOpen = true;
  }
  closeTimeSelector(event = undefined, isSubmit = false) {
    this.timeDropdown.hide();
    this.states.timePickerOpen = false;
    this.cancelPickerSelects(!isSubmit);
    if (event instanceof KeyboardEvent) {
      if (isSubmit) {
        this.elementRef.nativeElement.querySelector('.duet-date__toggle')?.focus();
      } else {
        this.elementRef.nativeElement.querySelector('.duet-date__input-wrapper')?.focus();
      }
    }
  }
  redirectFocusToTimeSelector() {
    /**
     * This method intercepts the focus that automatically moves to the button
     * after date is selected in duet date picker, and redirects it to first select
     * element of the time selector.
     *
     * It's run only once and automatically removes its event listener after execution.
     */
    const datePickerButton = this.elementRef.nativeElement?.querySelector('button.duet-date__toggle');
    const timeSelectorFocusAdjustmentFn = event => {
      const firstSelector = this.timeModalTemplate.nativeElement?.querySelector('select');
      if (firstSelector) {
        firstSelector.focus();
      }
      datePickerButton.removeEventListener('focus', boundTimeSelectorFocusAdjustmentFn, true);
    };
    const boundTimeSelectorFocusAdjustmentFn = timeSelectorFocusAdjustmentFn.bind(this);
    if (datePickerButton) {
      datePickerButton.addEventListener('focus', boundTimeSelectorFocusAdjustmentFn, true);
    }
  }
  submitTimeForm(timeForm) {
    if (!timeForm.valid) {
      return;
    }
    this.states.timeSelected = true;
    let hours = timeForm.form.get('hours')?.value ?? '00';
    const minutes = timeForm.form.get('minutes')?.value ?? '00';
    const seconds = timeForm.form.get('seconds')?.value ?? '00';
    const meridian = timeForm.form.get('meridian')?.value ?? 'am';
    const timeValues = this.getTimeFormatString(hours, minutes, seconds, meridian);
    this.fieldValues.full = this.combineDateTime(this.fieldValues.full, timeValues);
    this.updateInputFieldText(this.getInputText());
    this.saveFormFieldValue();
    this.closeTimeSelector(undefined, true);
    this.tempFieldValues = {};
  }
  /** Handler to Backup and Restore Previous Values When Date/Time Selection is Canceled **/
  backupValues() {
    for (let key in this.fieldValues) {
      this.tempFieldValues[key] = this.fieldValues[key];
    }
    this.tempFieldValues['lastEnteredText'] = this.inputFieldElement().value;
  }
  cancelPickerSelects(isCancel) {
    if (!isCancel) {
      return;
    }
    const text = this.inputFieldElement().value;
    const updateText = this.tempFieldValues.lastEnteredText;
    this.duetDatePickerValue = this.tempFieldValues.full?.format(this.dateConfig.format) || '';
    this.onMutationUpdateDateInput(() => {
      return this.inputFieldElement().value !== text;
    }, () => this.inputFieldElement().value = updateText);
    this.restoreBackupValues();
    this.resetSelectionStates();
  }
  restoreBackupValues() {
    for (let key in this.tempFieldValues) {
      if (!_.isNil(this.tempFieldValues[key]) && key !== 'lastEnteredText') {
        this.fieldValues[key] = this.tempFieldValues[key];
      }
    }
    this.tempFieldValues = {};
  }
  resetFieldValues() {
    for (let key in this.fieldValues) {
      this.fieldValues[key] = null;
    }
  }
  resetTimeValues() {
    this.fieldValues.hours = '12';
    if (this.timeConfig.showMinutes) {
      this.fieldValues.minutes = '00';
    }
    if (this.timeConfig.showSeconds) {
      this.fieldValues.seconds = '00';
    }
    if (this.timeConfig.showMeridian) {
      this.fieldValues.meridian = 'am';
    }
  }
  resetSelectionStates() {
    this.states.timeSelected = false;
    this.states.dateSelected = false;
  }
  /** Utilities **/
  getConvertedInputFormat(date, time = undefined) {
    if (!time) {
      time = this.getTimeFormatString('12', '00', '00', 'am');
    }
    return `${date}, ${time}`;
  }
  getInputText(dateTime = this.fieldValues.full) {
    if (typeof dateTime === 'string') {
      dateTime = moment$1(dateTime).tz(this.userTimezone);
    }
    return dateTime.format(this.widgetConfig.inputFormat);
  }
  getSavingValue(dateTime = this.fieldValues.full) {
    return dateTime.format(this.widgetConfig.savingFormat);
  }
  getDateTimeFormatForGuide() {
    let timeFormat = this.timeConfig.format.toUpperCase().replace('A', this.translate.instant('misc.AM/PM'));
    return this.getConvertedInputFormat(this.dateConfig.format, timeFormat).toUpperCase();
  }
  getPlaceholder() {
    return this.config.placeholder ?? this.getDateTimeFormatForGuide();
  }
  inputFieldElement() {
    return this.elementRef.nativeElement.querySelector('.duet-date__input');
  }
  updateInputFieldText(text) {
    this.inputFieldElement().value = text ?? '';
  }
  checkDateTimeFormatValid(datetime) {
    let outputFormat = this.widgetConfig.inputFormat;
    if (typeof datetime === 'string' && this.timeConfig.showMeridian) {
      const hasMatchMeridian = ['am', 'pm'].some(val => datetime.toLowerCase().includes(val));
      if (!hasMatchMeridian) {
        return false;
      }
      datetime = datetime.replace(/\s/g, '');
      outputFormat = outputFormat.replace(/\s/g, '');
    }
    const momentDate = moment$1(datetime, outputFormat, true);
    return momentDate.isValid();
  }
  checkDatePickerOpened() {
    return this.elementRef.nativeElement.querySelector(".duet-date__dialog.is-active");
  }
  checkFieldValueValid(e) {
    setTimeout(() => {
      const dialog = this.checkDatePickerOpened();
      if (!dialog) {
        let isValid = true;
        let value = e.target.querySelector('input').value;
        if (value) {
          isValid = this.checkDateTimeFormatValid(value);
        }
        if (isValid) {
          this.control.setErrors(null);
        } else {
          this.control.setErrors({
            dateFormat: true
          });
        }
        this.control.markAsTouched();
      }
    }, 100);
  }
  saveFormFieldValue() {
    let fullDateTime = '';
    let isValueValid = this.checkDateTimeFormatValid(this.fieldValues.full);
    if (isValueValid) {
      fullDateTime = this.getSavingValue();
    }
    this.control.setValue(fullDateTime);
    this.control.setErrors(null);
    this.control.markAsTouched();
    this.triggerEvent('change', this.control);
  }
  combineDateTime(date, time) {
    const dateMoment = moment$1(date, this.widgetConfig.inputFormat).tz(this.userTimezone);
    if (time === null) {
      time = this.getTimeFormatString('12', '00', '00', 'am');
    }
    const timeMoment = moment$1(time, this.timeConfig.format).tz(this.userTimezone);
    dateMoment.set({
      hour: timeMoment.hours(),
      minute: timeMoment.minute(),
      second: timeMoment.seconds()
    });
    return dateMoment;
  }
  getTimeFormatString(hours = 'hh', minutes = 'mm', seconds = 'ss', meridian = 'A') {
    let format = hours;
    if (this.timeConfig.showMinutes) format += `:${minutes}`;
    if (this.timeConfig.showSeconds) format += `:${seconds}`;
    if (this.timeConfig.showMeridian) format += ` ${meridian}`;
    return format;
  }
  clickOutside(event) {
    if (this.states.timePickerOpen) {
      const datePickerDialog = this.elementRef.nativeElement.querySelector(".duet-date__dialog-content");
      const timePickerDialog = this.elementRef.nativeElement.querySelector('.timeDropdown');
      if (!timePickerDialog || timePickerDialog.contains(event.target) || datePickerDialog.contains(event.target)) {
        return;
      }
      this.closeTimeSelector(event);
    }
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusFormDatetimepickerComponent_BaseFactory;
      return function JanusFormDatetimepickerComponent_Factory(__ngFactoryType__) {
        return (ɵJanusFormDatetimepickerComponent_BaseFactory || (ɵJanusFormDatetimepickerComponent_BaseFactory = i0.ɵɵgetInheritedFactory(JanusFormDatetimepickerComponent)))(__ngFactoryType__ || JanusFormDatetimepickerComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormDatetimepickerComponent,
      selectors: [["janus-form-datetimepicker"]],
      viewQuery: function JanusFormDatetimepickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$b, 5);
          i0.ɵɵviewQuery(_c1$8, 5);
          i0.ɵɵviewQuery(_c2$7, 5);
          i0.ɵɵviewQuery(_c3$5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timeForm = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timeModalTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timeDropdown = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.duetDatePicker = _t.first);
        }
      },
      hostBindings: function JanusFormDatetimepickerComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function JanusFormDatetimepickerComponent_click_HostBindingHandler($event) {
            return ctx.clickOutside($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 6,
      vars: 21,
      consts: [["timeModal", "", "timeDropdown", "bs-dropdown"], ["timeForm", "ngForm"], ["role", "group", 1, "janus-field", 3, "id", "formGroup", "ngClass"], [1, "form-label", 3, "id"], [3, "hasError", "isRequired"], ["class", "field-widget", 4, "ngIf"], [1, "field-widget"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], ["class", "form-text", 3, "id", "innerHTML", 4, "ngIf"], [3, "id", 4, "ngIf"], ["role", "group", 1, "row", "gap-2", "gap-md-0", "position-relative", 3, "id"], ["role", "alert", 1, "invalid-feedback"], [1, "field-error"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [4, "ngIf"], [1, "form-text", 3, "id", "innerHTML"], [3, "id"], [4, "ngTemplateOutlet"], [3, "duetBlur", "duetChange", "duetFocus", "duetOpen", "duetClose", "dateAdapter", "localization", "value", "identifier", "disabled", "direction", "firstDayOfWeek", "max", "min", "name", "role", "dateFormat", "strictDateInput"], ["dropdown", "", 1, "btn-group", 3, "autoClose"], [1, "modal-backdrop", "fade", "show", "d-md-none"], ["class", "timeDropdown dropdown-menu dropdown-menu-right end-0 mb-2 me-6", "keyboardTrap", "", 4, "dropdownMenu"], ["keyboardTrap", "", 1, "timeDropdown", "dropdown-menu", "dropdown-menu-right", "end-0", "mb-2", "me-6"], [1, "d-flex", "d-md-none", "justify-content-between", "align-items-center", "mb-2", "pt-0", "pt-md-2", "pb-2", "ps-4", "pe-3", "pe-md-4", "px-4", "px-md-9"], [1, "m-0", 3, "id"], ["type", "button", 1, "btn-close", 3, "click"], [1, "pt-0", "pt-md-2", "pb-2", "px-4", "px-md-9"], [1, "input-group", "justify-content-center"], ["name", "hours", "required", "", 1, "form-select", "w-auto", "flex-grow-0", "flex-shrink-0", "flex-auto", 3, "ngModelChange", "ngModel"], [4, "ngFor", "ngForOf"], ["name", "minutes", "required", "", 1, "form-select", "w-auto", "flex-grow-0", "flex-shrink-0", "flex-auto", 3, "ngModel"], ["name", "seconds", "required", "", 1, "form-select", "w-auto", "flex-grow-0", "flex-shrink-0", "flex-auto", 3, "ngModel"], ["name", "meridian", "required", "", 1, "form-select", "w-auto", "flex-grow-0", "flex-shrink-0", "flex-auto", 3, "ngModel"], [1, "timeDropdownFooter", "py-2", "px-4", "px-md-9"], ["type", "button", 1, "btn", "btn-primary", "w-100", "justify-content-center", 3, "click"], [3, "value", "selected"], ["name", "minutes", "required", "", 1, "form-select", "w-auto", "flex-grow-0", "flex-shrink-0", "flex-auto", 3, "ngModelChange", "ngModel"], ["name", "seconds", "required", "", 1, "form-select", "w-auto", "flex-grow-0", "flex-shrink-0", "flex-auto", 3, "ngModelChange", "ngModel"], ["name", "meridian", "required", "", 1, "form-select", "w-auto", "flex-grow-0", "flex-shrink-0", "flex-auto", 3, "ngModelChange", "ngModel"], ["value", "am", 3, "selected"], ["value", "pm", 3, "selected"]],
      template: function JanusFormDatetimepickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2)(1, "label", 3);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵelement(4, "janus-required", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, JanusFormDatetimepickerComponent_div_5_Template, 6, 5, "div", 5);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵpropertyInterpolate("id", ctx.elementId);
          i0.ɵɵproperty("formGroup", ctx.group)("ngClass", i0.ɵɵpureFunction4(16, _c4$4, !ctx.control.valid && (ctx.control.dirty || ctx.control.touched), ctx.config.lastChild, !ctx.config.lastChild, ctx.control.disabled));
          i0.ɵɵattribute("aria-labelledby", ctx.elementId + "-label")("aria-describedby", ctx.describedByValue);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("visually-hidden", ctx.config.hideLabel);
          i0.ɵɵpropertyInterpolate1("id", "", ctx.elementId, "-label");
          i0.ɵɵattribute("aria-required", ctx.isRequired);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 14, ctx.config.label), "");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("hasError", !ctx.control.valid && (ctx.control.dirty || ctx.control.touched))("isRequired", ctx.isRequired);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.readyToLoad);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.ɵNgNoValidate, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.RequiredValidator, i2$1.NgModel, i2$1.NgForm, i2$1.FormGroupDirective, KeyboardTrapDirective, i10.BsDropdownMenuDirective, i10.BsDropdownDirective, JanusRequiredComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      styles: [".row .field-widget{width:100%!important}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormDatetimepickerComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form-datetimepicker',
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"janus-field\"\n     id=\"{{elementId}}\"\n     role=\"group\"\n     [formGroup]=\"group\"\n     [ngClass]=\"{\n        'is-invalid': !control.valid && (control.dirty || control.touched), \n        'last':config.lastChild,\n        'mb-4': !config.lastChild,\n        'pe-none': control.disabled\n     }\"\n     [attr.aria-labelledby]=\"elementId + '-label'\"\n     [attr.aria-describedby]=\"describedByValue\"\n>\n    <label id=\"{{elementId}}-label\"\n           class=\"form-label\"\n           [class.visually-hidden]=\"config.hideLabel\"\n           [attr.aria-required]=\"isRequired\"\n    >\n        {{config.label | translate}}<janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\"></janus-required>\n    </label>\n    <div class=\"field-widget\" *ngIf=\"readyToLoad\">\n        <div class=\"invalid-feedback\" role=\"alert\" *ngIf=\"!control.valid && (control.dirty || control.touched)\">\n            <div class=\"field-error\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                </svg>\n                <ng-container *ngIf=\"control.errors?.required\">\n                    {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n                </ng-container>\n                <ng-container *ngIf=\"control.errors?.dateFormat\">\n                    {{ 'misc.Date must be in format.' | translate: { format: getDateTimeFormatForGuide() } }}\n                </ng-container>\n            </div>\n        </div>\n        <div *ngIf=\"config.blurb\" id=\"{{describedByValue}}\" class=\"form-text\" [innerHTML]=\"config.blurb | translate | safeHtml\"></div>\n        <div *ngIf=\"config.blurbTemplate && !config.blurb\" id=\"{{describedByValue}}\">\n            <ng-container *ngTemplateOutlet=\"config.blurbTemplate\"></ng-container>\n        </div>\n        <div class=\"row gap-2 gap-md-0 position-relative\" id=\"{{elementId + '-field'}}\" role=\"group\">\n            @if (readyToLoad) {\n                <duet-date-picker\n                        [dateAdapter]=\"dateAdapter\"\n                        [localization]=\"pickerLocalization\"\n                        [value]=\"duetDatePickerValue\"\n                        [identifier]=\"elementId\"\n                        [disabled]=\"config.disabled\"\n                        [direction]=\"'left'\"\n                        [firstDayOfWeek]=\"properties?.firstDayOfWeek\"\n                        [max]=\"properties?.max\"\n                        [min]=\"properties?.min\"\n                        [name]=\"properties?.name\"\n                        [role]=\"properties?.role || 'datepicker'\"\n                        [dateFormat]=\"dateConfig.format\"\n                        [disabled]=\"control.disabled\"\n                        [strictDateInput]=\"false\"\n                        (duetBlur)=\"checkFieldValueValid($event); triggerEvent('blur', $event)\"\n                        (duetChange)=\"selectDate($event)\"\n                        (duetFocus)=\"triggerEvent('focus', $event)\"\n                        (duetOpen)=\"states.datePickerOpen = true; backupValues(); resetTimeValues(); triggerEvent('open', $event)\"\n                        (duetClose)=\"states.datePickerOpen = false; cancelPickerSelects(!states.dateSelected); triggerEvent('close', $event)\"\n                ></duet-date-picker>\n\n                <div class=\"btn-group\" #timeModal dropdown #timeDropdown=\"bs-dropdown\" [autoClose]=\"true\">\n                    @if (states.timePickerOpen) {\n                        <div class=\"modal-backdrop fade show d-md-none\"></div>\n                    }\n                    <div class=\"timeDropdown dropdown-menu dropdown-menu-right end-0 mb-2 me-6\" *dropdownMenu keyboardTrap>\n                        <div class=\"d-flex d-md-none justify-content-between align-items-center mb-2 pt-0 pt-md-2 pb-2 ps-4 pe-3 pe-md-4 px-4 px-md-9\">\n                            <h4 id=\"{{elementId}}-timeSelector-label\" class=\"m-0\">{{config.label | translate}} - {{ 'misc.Time' | translate}}</h4>\n                            <button type=\"button\" class=\"btn-close\" (click)=\"closeTimeSelector($event)\" [attr.aria-label]=\"'misc.Close' | translate\"></button>\n                        </div>\n                        <div class=\"pt-0 pt-md-2 pb-2 px-4 px-md-9\">\n                            <form #timeForm=\"ngForm\" id=\"{{elementId}}-timeSelector\" [attr.aria-labelledby]=\"elementId + '-timeSelector-label'\">\n                                <div class=\"input-group justify-content-center\">\n                                    <select class=\"form-select w-auto flex-grow-0 flex-shrink-0 flex-auto\"\n                                            name=\"hours\"\n                                            [attr.aria-label]=\"timeConfig.ariaLabelHours | translate\"\n                                            [(ngModel)]=\"fieldValues.hours\"\n                                            required\n                                    >\n                                        <ng-container *ngFor=\"let num of timeConfig.options.hours\">\n                                            <option [value]=\"num\" [selected]=\"fieldValues.hours === num\">{{ num }}</option>\n                                        </ng-container>\n                                    </select>\n                                    @if (timeConfig.showMinutes) {\n                                        <select class=\"form-select w-auto flex-grow-0 flex-shrink-0 flex-auto\"\n                                                name=\"minutes\"\n                                                [attr.aria-label]=\"timeConfig.ariaLabelMinutes | translate\"\n                                                [(ngModel)]=\"fieldValues.minutes\"\n                                                required\n                                        >\n                                            <ng-container *ngFor=\"let num of timeConfig.options.minutes\">\n                                                <option [value]=\"num\" [selected]=\"fieldValues.minutes === num\">{{ num }}</option>\n                                            </ng-container>\n                                        </select>\n                                    }\n                                    @if (timeConfig.showSeconds) {\n                                        <select class=\"form-select w-auto flex-grow-0 flex-shrink-0 flex-auto\"\n                                                name=\"seconds\"\n                                                [attr.aria-label]=\"timeConfig.ariaLabelSeconds | translate\"\n                                                [(ngModel)]=\"fieldValues.seconds\"\n                                                required\n                                        >\n                                            <ng-container *ngFor=\"let num of timeConfig.options.seconds\">\n                                                <option [value]=\"num\" [selected]=\"fieldValues.seconds === num\">{{ num }}</option>\n                                            </ng-container>\n                                        </select>\n                                    }\n                                    @if (timeConfig.showMeridian) {\n                                        <select class=\"form-select w-auto flex-grow-0 flex-shrink-0 flex-auto\"\n                                                name=\"meridian\"\n                                                [attr.aria-label]=\"timeConfig.meridianPlaceholder | translate\"\n                                                [(ngModel)]=\"fieldValues.meridian\"\n                                                required\n                                        >\n                                            <option value=\"am\" [selected]=\"fieldValues.meridian === 'am'\">{{ 'misc.AM' | translate }}</option>\n                                            <option value=\"pm\" [selected]=\"fieldValues.meridian === 'pm'\">{{ 'misc.PM' | translate }}</option>\n                                        </select>\n                                    }\n                                </div>\n                            </form>\n                        </div>\n                        <div class=\"timeDropdownFooter py-2 px-4 px-md-9\">\n                            <button type=\"button\" class=\"btn btn-primary w-100 justify-content-center\" (click)=\"submitTimeForm(timeForm)\">{{'misc.Done' | translate}}</button>\n                        </div>\n                    </div>\n                </div>\n            }\n        </div>\n    </div>\n</div>",
      styles: [".row .field-widget{width:100%!important}\n"]
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }],
    timeForm: [{
      type: ViewChild,
      args: ['timeForm', {
        static: false
      }]
    }],
    timeModalTemplate: [{
      type: ViewChild,
      args: ['timeModal', {
        static: false
      }]
    }],
    timeDropdown: [{
      type: ViewChild,
      args: ['timeDropdown', {
        static: false
      }]
    }],
    duetDatePicker: [{
      type: ViewChild,
      args: ['duetDatePicker', {
        static: false
      }]
    }],
    clickOutside: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormDatetimepickerComponent, {
    className: "JanusFormDatetimepickerComponent",
    filePath: "janus/components/form-datetimepicker/janus-form-datetimepicker.component.ts",
    lineNumber: 16
  });
})();
const _c0$a = (a0, a1) => ({
  "is-invalid": a0,
  "last": a1
});
const _c1$7 = a0 => ({
  "visually-hidden": a0
});
const _c2$6 = a0 => ({
  field_name: a0
});
function JanusMonthYearPicker_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.blurb));
  }
}
function JanusMonthYearPicker_div_0_div_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 14);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-alert-circle", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, "misc.Field is required", i0.ɵɵpureFunction1(5, _c2$6, ctx_r1.translatedLabel)), " ");
  }
}
function JanusMonthYearPicker_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, JanusMonthYearPicker_div_0_div_7_div_1_Template, 5, 7, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.errors.required);
  }
}
function JanusMonthYearPicker_div_0_option_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const month_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", month_r3.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(month_r3.value);
  }
}
function JanusMonthYearPicker_div_0_option_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const year_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", year_r4.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(year_r4.value);
  }
}
function JanusMonthYearPicker_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "label", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "janus-required", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵtemplate(6, JanusMonthYearPicker_div_0_div_6_Template, 3, 3, "div", 5)(7, JanusMonthYearPicker_div_0_div_7_Template, 2, 1, "div", 6);
    i0.ɵɵelementStart(8, "div", 7)(9, "select", 8);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵlistener("change", function JanusMonthYearPicker_div_0_Template_select_change_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.checkTouched());
    });
    i0.ɵɵtemplate(11, JanusMonthYearPicker_div_0_option_11_Template, 2, 2, "option", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "select", 10);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵlistener("change", function JanusMonthYearPicker_div_0_Template_select_change_12_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.checkTouched());
    });
    i0.ɵɵtemplate(14, JanusMonthYearPicker_div_0_option_14_Template, 2, 2, "option", 9);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(25, _c0$a, !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched), ctx_r1.config.lastChild));
    i0.ɵɵattribute("aria-labelledby", ctx_r1.config.elementId + (ctx_r1.modal ? "modal" : "") + "-label");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "");
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.config.elementId, "", ctx_r1.modal ? "modal" : "", "-label");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(28, _c1$7, ctx_r1.config.hideLabel));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 19, ctx_r1.config.label), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hasError", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched))("isRequired", ctx_r1.isRequired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.blurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.control.valid && (ctx_r1.control.dirty || ctx_r1.control.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.dateGroup);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(10, 21, "misc.Month"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.monthOptions);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(13, 23, "misc.Year"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.yearOptions);
  }
}
class JanusMonthYearPicker extends MonthYearPicker {
  constructor() {
    super(...arguments);
    this.assetsPath = '/app/assets/';
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusMonthYearPicker_BaseFactory;
      return function JanusMonthYearPicker_Factory(__ngFactoryType__) {
        return (ɵJanusMonthYearPicker_BaseFactory || (ɵJanusMonthYearPicker_BaseFactory = i0.ɵɵgetInheritedFactory(JanusMonthYearPicker)))(__ngFactoryType__ || JanusMonthYearPicker);
      };
    })();
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusMonthYearPicker,
      selectors: [["janus-month-year-picker"]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "janus-field mb-4", "role", "group", 3, "ngClass", 4, "ngIf"], ["role", "group", 1, "janus-field", "mb-4", 3, "ngClass"], [1, "form-label", 3, "ngClass", "for", "id"], [3, "hasError", "isRequired"], [1, "field-widget"], ["class", "blurb field-blurb", 4, "ngIf"], ["class", "invalid-feedback", "role", "alert", 4, "ngIf"], [1, "d-flex", "gap-3", 3, "formGroup"], ["formControlName", "month", 1, "form-select", "w-auto", 3, "change"], [3, "value", 4, "ngFor", "ngForOf"], ["formControlName", "year", 1, "form-select", "w-auto", 3, "change"], [1, "blurb", "field-blurb"], ["role", "alert", 1, "invalid-feedback"], [4, "ngIf"], ["width", "1.25rem", "height", "1.25rem", 1, "mt-n1", "me-1"], [3, "value"]],
      template: function JanusMonthYearPicker_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusMonthYearPicker_div_0_Template, 15, 30, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.config.hideField);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, JanusRequiredComponent, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusMonthYearPicker, [{
    type: Component,
    args: [{
      selector: 'janus-month-year-picker',
      standalone: false,
      template: "\n<div\n    *ngIf=\"!config.hideField\"\n    class=\"janus-field mb-4\"\n    [ngClass]=\"{'is-invalid': !control.valid && (control.dirty || control.touched), 'last': config.lastChild}\"\n    role=\"group\"\n    [attr.aria-labelledby]=\"config.elementId + (modal?'modal':'') + '-label'\"\n>\n    <label [ngClass]=\"{'visually-hidden': config.hideLabel}\" class=\"field-label\" class=\"form-label\" for=\"{{config.elementId}}{{modal?'modal':''}}\" id=\"{{config.elementId}}{{modal?'modal':''}}-label\">\n        {{config.label | translate}}<janus-required [hasError]=\"(!control.valid && (control.dirty || control.touched))\" [isRequired]=\"isRequired\"></janus-required>\n    </label>\n    <div class=\"field-widget\">\n        <div *ngIf=\"config.blurb\" class=\"blurb field-blurb\">{{config.blurb | translate}}</div>\n        <div *ngIf=\"(!control.valid && (control.dirty || control.touched))\" class=\"invalid-feedback\" role=\"alert\">\n            <div *ngIf=\"control.errors.required\">\n                <svg width=\"1.25rem\" height=\"1.25rem\" class=\"mt-n1 me-1\">\n                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-alert-circle'\"></use>\n                </svg>\n                {{ 'misc.Field is required' | translate: {field_name: translatedLabel} }}\n            </div>\n        </div>\n        <div class=\"d-flex gap-3\" [formGroup]=\"dateGroup\">\n            <select formControlName=\"month\" class=\"form-select w-auto\" (change)=\"checkTouched()\" [attr.aria-label]=\"'misc.Month' | translate\">\n                <option *ngFor=\"let month of monthOptions\" [value]=\"month.id\" >{{month.value}}</option>\n            </select>\n            <select formControlName=\"year\" class=\"form-select w-auto\" (change)=\"checkTouched()\" [attr.aria-label]=\"'misc.Year' | translate\">\n                <option *ngFor=\"let year of yearOptions\" [value]=\"year.id\" >{{year.value}}</option>\n            </select>\n        </div>\n    </div>\n</div>\n"
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusMonthYearPicker, {
    className: "JanusMonthYearPicker",
    filePath: "janus/components/form-month-year/month-year-picker.component.ts",
    lineNumber: 10
  });
})();
const januscomponents = {
  input: JanusFormInputComponent,
  textarea: JanusFormTextareaComponent,
  radio: JanusFormRadioComponent,
  aclookup: JanusFormACLookupComponent,
  static: JanusFormStaticComponent,
  switch: JanusFormSwitchComponent,
  checkbox: JanusFormCheckboxComponent,
  hierpicklist: JanusFormHierpicklistComponent,
  select: JanusFormSelectComponent,
  number: JanusFormNumberComponent,
  datepicker: JanusFormDatePickerComponent,
  rangeDatePicker: JanusFormRangeDatePickerComponent,
  timepicker: JanusFormTimepickerComponent,
  richtext: JanusFormRichtextComponent,
  fileUpload: JanusFormFileUploadComponent,
  relation: JanusFormRelationComponent,
  rating: JanusFormRatingComponent,
  button: JanusFormButtonComponent,
  range: JanusFormRangeComponent,
  staticList: JanusFormStaticListComponent,
  multiselect: JanusFormMultiSelectComponent,
  ngselect: JanusFormNGSelectComponent,
  location: JanusFormLocationComponent,
  moxiemanager: JanusFormMoxieManagerComponent,
  imgstatic: JanusFormMoxieManagerStaticComponent,
  minmax: JanusFormMinMaxComponent,
  numberComparison: JanusFormNumberComparisonComponent,
  imageUpload: JanusFormImageUploadComponent,
  n1: JanusN1Component,
  datetimepicker: JanusFormDatetimepickerComponent,
  monthYearPicker: JanusMonthYearPicker
};
class JanusDynamicFieldDirective extends DynamicFieldDirective {
  constructor() {
    super(...arguments);
    this.assetsPath = '/app/assets/';
  }
  ngOnInit() {
    super.ngOnInit();
    this.component.instance.assetsPath = this.assetsPath;
  }
  getComponent(config) {
    if (januscomponents.hasOwnProperty(config.type)) {
      return januscomponents[config.type];
    } else if (config.type === 'custom' && config.hasOwnProperty('customWidget')) {
      return config.customWidget;
    }
  }
  static {
    this.ɵfac = /*@__PURE__*/(() => {
      let ɵJanusDynamicFieldDirective_BaseFactory;
      return function JanusDynamicFieldDirective_Factory(__ngFactoryType__) {
        return (ɵJanusDynamicFieldDirective_BaseFactory || (ɵJanusDynamicFieldDirective_BaseFactory = i0.ɵɵgetInheritedFactory(JanusDynamicFieldDirective)))(__ngFactoryType__ || JanusDynamicFieldDirective);
      };
    })();
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: JanusDynamicFieldDirective,
      selectors: [["", "janusDynamicField", ""]],
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusDynamicFieldDirective, [{
    type: Directive,
    args: [{
      selector: '[janusDynamicField]',
      standalone: false
    }]
  }], null, {
    assetsPath: [{
      type: Input
    }]
  });
})();
const _c0$9 = ["alertContainer"];
const _c1$6 = (a0, a1) => ({
  "alert-dismissible": a0,
  "alert-without-icon": a1
});
const _c2$5 = (a0, a1) => ({
  "mb-2": a0,
  "mb-0": a1
});
function JanusAlertComponent_div_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "janus-svg-icon", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", "circle-check")("title", "Success: ")("cssClasses", "me-2")("size", "xl");
  }
}
function JanusAlertComponent_div_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "janus-svg-icon", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r0.janusVersion === 1 ? "circle-x" : "alert-circle")("title", "Error: ")("cssClasses", "me-2")("size", "xl");
  }
}
function JanusAlertComponent_div_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "janus-svg-icon", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", "alert-triangle")("title", "Warning: ")("cssClasses", "me-2")("size", "xl");
  }
}
function JanusAlertComponent_div_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "janus-svg-icon", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", "info-circle")("title", "Information: ")("cssClasses", "me-2")("size", "xl");
  }
}
function JanusAlertComponent_div_2_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "janus-svg-icon", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", "circle-check")("title", "Success: ")("cssClasses", "me-2")("size", "xl");
  }
}
function JanusAlertComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementContainerStart(1, 8);
    i0.ɵɵtemplate(2, JanusAlertComponent_div_2_ng_container_2_Template, 2, 4, "ng-container", 9)(3, JanusAlertComponent_div_2_ng_container_3_Template, 2, 4, "ng-container", 9)(4, JanusAlertComponent_div_2_ng_container_4_Template, 2, 4, "ng-container", 9)(5, JanusAlertComponent_div_2_ng_container_5_Template, 2, 4, "ng-container", 9)(6, JanusAlertComponent_div_2_ng_container_6_Template, 2, 4, "ng-container", 10);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", ctx_r0.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "success");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "error");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "warning");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "info");
  }
}
function JanusAlertComponent_div_4_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2)(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c2$5, ctx_r0.content.body, !ctx_r0.content.body));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.content.title);
  }
}
function JanusAlertComponent_div_4_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusAlertComponent_div_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusAlertComponent_div_4_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.content.body);
  }
}
function JanusAlertComponent_div_4_ng_template_3_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
    i0.ɵɵpipe(1, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r0.content.body), i0.ɵɵsanitizeHtml);
  }
}
function JanusAlertComponent_div_4_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusAlertComponent_div_4_ng_template_3_div_0_Template, 2, 3, "div", 17);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.content.body);
  }
}
function JanusAlertComponent_div_4_hr_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr");
  }
}
function JanusAlertComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, JanusAlertComponent_div_4_p_1_Template, 3, 5, "p", 13)(2, JanusAlertComponent_div_4_ng_container_2_Template, 2, 1, "ng-container", 14)(3, JanusAlertComponent_div_4_ng_template_3_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, JanusAlertComponent_div_4_hr_5_Template, 1, 0, "hr", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const textContent_r2 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.content.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isTemplateRef(ctx_r0.content.body))("ngIfElse", textContent_r2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.items.length && ctx_r0.divider);
  }
}
function JanusAlertComponent_div_5_ng_container_1_li_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 21);
    i0.ɵɵlistener("click", function JanusAlertComponent_div_5_ng_container_1_li_2_ng_container_1_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const item_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.scrollToField(item_r4.elementId));
    })("keyup.enter", function JanusAlertComponent_div_5_ng_container_1_li_2_ng_container_1_Template_a_keyup_enter_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const item_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.scrollToField(item_r4.elementId));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r4.text);
  }
}
function JanusAlertComponent_div_5_ng_container_1_li_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r4, " ");
  }
}
function JanusAlertComponent_div_5_ng_container_1_li_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, JanusAlertComponent_div_5_ng_container_1_li_2_ng_container_1_Template, 3, 1, "ng-container", 15)(2, JanusAlertComponent_div_5_ng_container_1_li_2_ng_container_2_Template, 2, 1, "ng-container", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r4.elementId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r4.elementId);
  }
}
function JanusAlertComponent_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 19);
    i0.ɵɵtemplate(2, JanusAlertComponent_div_5_ng_container_1_li_2_Template, 3, 2, "li", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
  }
}
function JanusAlertComponent_div_5_ng_container_2_div_1_hr_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr");
  }
}
function JanusAlertComponent_div_5_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "p", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, JanusAlertComponent_div_5_ng_container_2_div_1_hr_3_Template, 1, 0, "hr", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const lastIndex_r6 = ctx.last;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.divider && !lastIndex_r6);
  }
}
function JanusAlertComponent_div_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusAlertComponent_div_5_ng_container_2_div_1_Template, 4, 2, "div", 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
  }
}
function JanusAlertComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, JanusAlertComponent_div_5_ng_container_1_Template, 3, 1, "ng-container", 15)(2, JanusAlertComponent_div_5_ng_container_2_Template, 2, 1, "ng-container", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.list);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.list);
  }
}
function JanusAlertComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "button", 24);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function JanusAlertComponent_div_6_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onCloseClick());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 1, "misc.Permanently dismiss this message"));
  }
}
class JanusAlertComponent {
  constructor(document, janusVersion, scroller) {
    this.document = document;
    this.janusVersion = janusVersion;
    this.scroller = scroller;
    this.id = '';
    this.type = 'primary';
    this.icon = true;
    this.dismissible = false;
    this.divider = false;
    this.list = false;
    this.content = {};
    this.items = [];
    this.cssClasses = '';
    this.calculateOffset = false;
    this.headerSelector = 'app-header > header > nav';
    this.tabindex = 1;
    this.onClose = new EventEmitter();
  }
  ngAfterViewInit() {
    if (this.calculateOffset) {
      const headerHeight = document.querySelector(this.headerSelector)?.clientHeight || 0;
      const alertElementPosition = this.alertContainer.nativeElement.getBoundingClientRect().top;
      const offsetPosition = alertElementPosition + window.pageYOffset - headerHeight;
      this.alertContainer.nativeElement.focus();
      if (this.type === 'error') {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    } else {
      if (this.type === 'error') {
        this.alertContainer.nativeElement.focus();
        this.alertContainer.nativeElement.scrollIntoView();
      }
    }
  }
  scrollToField(id) {
    const el = document.getElementById(id);
    el?.scrollIntoView({
      behavior: "smooth"
    });
    el?.focus();
    if (el?.nodeName.toLowerCase() === "div") {
      const comboEl = document.getElementById(id)?.children[1]?.querySelector('span')?.parentElement;
      comboEl?.setAttribute('tabindex', '-1');
      comboEl?.focus();
      comboEl?.setAttribute('tabindex', '0');
    }
    if (el?.nodeName.toLowerCase() === "legend") {
      const inputEl = el?.parentElement?.querySelector('input');
      inputEl?.focus();
      const buttonEl = el?.nextElementSibling?.querySelector('button');
      buttonEl?.focus();
    }
  }
  onCloseClick() {
    this.onClose.emit();
  }
  isTemplateRef(value) {
    return value instanceof TemplateRef;
  }
  static {
    this.ɵfac = function JanusAlertComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusAlertComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject('JANUS_VERSION', 8), i0.ɵɵdirectiveInject(i1.ViewportScroller));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusAlertComponent,
      selectors: [["janus-alert"]],
      viewQuery: function JanusAlertComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$9, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.alertContainer = _t.first);
        }
      },
      inputs: {
        id: "id",
        type: "type",
        icon: "icon",
        dismissible: "dismissible",
        divider: "divider",
        list: "list",
        content: "content",
        items: "items",
        cssClasses: "cssClasses",
        calculateOffset: "calculateOffset",
        headerSelector: "headerSelector",
        tabindex: "tabindex"
      },
      outputs: {
        onClose: "onClose"
      },
      standalone: false,
      decls: 7,
      vars: 12,
      consts: [["alertContainer", ""], ["textContent", ""], [3, "ngClass"], ["class", "flex-shrink-1 d-flex", 4, "ngIf"], [1, "d-flex", "flex-column", "flex-grow-1"], ["class", "flex-grow-1", 4, "ngIf"], ["class", "flex-shrink-1 mt-n1 mb-n1", 4, "ngIf"], [1, "flex-shrink-1", "d-flex"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [3, "icon", "title", "cssClasses", "size"], [1, "flex-grow-1"], [3, "ngClass", 4, "ngIf"], [4, "ngIf", "ngIfElse"], [4, "ngIf"], [4, "ngTemplateOutlet"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], [1, "list-disc", "ps-3", "mb-0"], [4, "ngFor", "ngForOf"], ["role", "button", "tabindex", "0", 1, "alert-link", "fw-normal", 3, "click", "keyup.enter"], [1, "mb-0"], [1, "flex-shrink-1", "mt-n1", "mb-n1"], ["type", "button", "data-bs-dismiss", "alert", 1, "btn-close", 3, "click"]],
      template: function JanusAlertComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2, 0);
          i0.ɵɵtemplate(2, JanusAlertComponent_div_2_Template, 7, 5, "div", 3);
          i0.ɵɵelementStart(3, "div", 4);
          i0.ɵɵtemplate(4, JanusAlertComponent_div_4_Template, 6, 4, "div", 5)(5, JanusAlertComponent_div_5_Template, 3, 2, "div", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, JanusAlertComponent_div_6_Template, 3, 3, "div", 6);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          let tmp_2_0;
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c1$6, ctx.dismissible, ctx.icon));
          i0.ɵɵattribute("id", (tmp_2_0 = ctx.id) !== null && tmp_2_0 !== undefined ? tmp_2_0 : null)("class", "alert d-flex alert-" + (ctx.type === "error" ? "danger" : ctx.type) + " " + ctx.cssClasses)("role", ctx.type === "error" ? "alert" : null)("tabindex", ctx.tabindex);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.icon);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.content.title || ctx.content.body);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.items.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.dismissible);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgSwitch, i1.NgSwitchCase, i1.NgSwitchDefault, JanusSVGIconComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusAlertComponent, [{
    type: Component,
    args: [{
      selector: 'janus-alert',
      standalone: false,
      template: "<div #alertContainer [attr.id]=\"id ?? null\" [attr.class]=\"'alert d-flex alert-' + (type === 'error' ? 'danger' : type) + ' ' + cssClasses\" [ngClass]=\"{'alert-dismissible' : dismissible, 'alert-without-icon' : icon}\" [attr.role]=\"type === 'error' ? 'alert' : null\" [attr.tabindex]=\"tabindex\">\n    <div class=\"flex-shrink-1 d-flex\" *ngIf=\"icon\">\n        <ng-container [ngSwitch]=\"type\">\n            <ng-container *ngSwitchCase=\"'success'\">\n                <janus-svg-icon [icon]=\"'circle-check'\" [title]=\"'Success: '\" [cssClasses]=\"'me-2'\" [size]=\"'xl'\"></janus-svg-icon>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'error'\">\n                <janus-svg-icon [icon]=\"janusVersion === 1 ? 'circle-x':'alert-circle'\" [title]=\"'Error: '\" [cssClasses]=\"'me-2'\" [size]=\"'xl'\"></janus-svg-icon>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'warning'\">\n                <janus-svg-icon [icon]=\"'alert-triangle'\" [title]=\"'Warning: '\" [cssClasses]=\"'me-2'\" [size]=\"'xl'\"></janus-svg-icon>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'info'\">\n                <janus-svg-icon [icon]=\"'info-circle'\" [title]=\"'Information: '\" [cssClasses]=\"'me-2'\" [size]=\"'xl'\"></janus-svg-icon>\n            </ng-container>\n            <ng-container *ngSwitchDefault>\n                <janus-svg-icon [icon]=\"'circle-check'\" [title]=\"'Success: '\" [cssClasses]=\"'me-2'\" [size]=\"'xl'\"></janus-svg-icon>\n            </ng-container>\n        </ng-container>\n    </div>\n    <div class=\"d-flex flex-column flex-grow-1\">\n        <div class=\"flex-grow-1\" *ngIf=\"content.title || content.body\">\n            <p [ngClass]=\"{ 'mb-2' : content.body ,  'mb-0' : !content.body}\" *ngIf=\"content.title\">\n                <strong>{{content.title}}</strong>\n            </p>\n            <ng-container *ngIf=\"isTemplateRef(content.body); else textContent\">\n                <ng-container *ngTemplateOutlet=\"content.body\"></ng-container>\n            </ng-container>\n            <ng-template #textContent>\n                <div *ngIf=\"content.body\" [innerHTML]=\"content.body | safeHtml\"></div>\n            </ng-template>\n            <hr *ngIf=\"items.length && divider\">\n        </div>\n        <div class=\"flex-grow-1\" *ngIf=\"items.length\">\n            <ng-container *ngIf=\"list\">\n                <ul class=\"list-disc ps-3 mb-0\">\n                    <li *ngFor=\"let item of items;\">\n                        <ng-container *ngIf=\"item.elementId\">\n                            <a role=\"button\" class=\"alert-link fw-normal\" (click)=\"scrollToField(item.elementId)\" (keyup.enter)=\"scrollToField(item.elementId)\" tabindex=\"0\">{{item.text}}</a>\n                        </ng-container>\n                        <ng-container *ngIf=\"!item.elementId\">\n                            {{item}}\n                        </ng-container>\n                    </li>\n                </ul>\n            </ng-container>\n            <ng-container *ngIf=\"!list\">\n                <div *ngFor=\"let item of items; let lastIndex = last;\">\n                    <p class=\"mb-0\">{{item}}</p>\n                    <hr *ngIf=\"divider && !lastIndex\">\n                </div>\n            </ng-container>\n        </div>\n    </div>\n    <div class=\"flex-shrink-1 mt-n1 mb-n1\" *ngIf=\"dismissible\">\n        <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"alert\" [attr.aria-label]=\"'misc.Permanently dismiss this message' | translate\" (click)=\"onCloseClick()\"></button>\n    </div>\n</div>"
    }]
  }], () => [{
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['JANUS_VERSION']
    }]
  }, {
    type: i1.ViewportScroller
  }], {
    id: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    dismissible: [{
      type: Input
    }],
    divider: [{
      type: Input
    }],
    list: [{
      type: Input
    }],
    content: [{
      type: Input
    }],
    items: [{
      type: Input
    }],
    cssClasses: [{
      type: Input
    }],
    calculateOffset: [{
      type: Input
    }],
    headerSelector: [{
      type: Input
    }],
    tabindex: [{
      type: Input
    }],
    onClose: [{
      type: Output
    }],
    alertContainer: [{
      type: ViewChild,
      args: ['alertContainer', {
        static: false
      }]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusAlertComponent, {
    className: "JanusAlertComponent",
    filePath: "janus/components/alert/alert.component.ts",
    lineNumber: 17
  });
})();
const _c0$8 = ["buttonSets"];
const _c1$5 = a0 => ({
  "form-readonly": a0
});
const _c2$4 = a0 => ({
  object_type: a0
});
const _c3$4 = a0 => ({
  body: a0
});
const _c4$3 = (a0, a1) => ({
  title: a0,
  body: a1
});
const _c5$1 = a0 => ({
  field_name: a0
});
const _c6$1 = (a0, a1) => ({
  field_name: a0,
  max: a1
});
const _c7$1 = (a0, a1) => ({
  field_name: a0,
  min: a1
});
const _c8 = a0 => ({
  styleClass: "header-buttonbar mb-4",
  config: a0
});
const _c9 = () => ({
  styleClass: "mb-4"
});
const _c10 = a0 => ({
  controls: a0
});
const _c11 = a0 => ({
  "mb-4": a0
});
const _c12 = (a0, a1) => ({
  "mb-2": a0,
  "mb-4": a1
});
const _c13 = (a0, a1) => ({
  "last mb-0": a0,
  "mb-3": a1
});
const _c14 = a0 => ({
  styleClass: "footer-buttonbar mt-4",
  config: a0
});
function JanusFormComponent_div_1_janus_alert_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-alert", 11);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", "success")("icon", true)("dismissible", false)("content", i0.ɵɵpureFunction1(10, _c3$4, i0.ɵɵpipeBind2(1, 5, "misc.Record saved successfully", i0.ɵɵpureFunction1(8, _c2$4, ctx_r1.objectType))))("cssClasses", "rounded-0");
  }
}
function JanusFormComponent_div_1_janus_alert_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-alert", 11);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("type", "danger")("icon", true)("dismissible", false)("content", i0.ɵɵpureFunction1(7, _c3$4, i0.ɵɵpipeBind1(1, 5, "misc.Object Update Error")))("cssClasses", "rounded-0");
  }
}
function JanusFormComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormComponent_div_1_janus_alert_1_Template, 2, 12, "janus-alert", 10);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, JanusFormComponent_div_1_janus_alert_3_Template, 2, 9, "janus-alert", 10);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r1.config.successStatus));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(4, 4, ctx_r1.config.successStatus));
  }
}
function JanusFormComponent_janus_alert_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-alert", 12);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const validationList_r3 = i0.ɵɵreference(6);
    i0.ɵɵproperty("id", "validation-box")("type", "error")("icon", true)("dismissible", false)("content", i0.ɵɵpureFunction2(8, _c4$3, i0.ɵɵpipeBind1(1, 6, "misc.Errors detected - please see below") + ":", validationList_r3))("cssClasses", "rounded-0");
  }
}
function JanusFormComponent_div_4_janus_alert_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-alert", 14);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", "success")("icon", true)("dismissible", false)("content", i0.ɵɵpureFunction1(9, _c3$4, i0.ɵɵpipeBind2(1, 4, "misc.Record saved successfully", i0.ɵɵpureFunction1(7, _c2$4, ctx_r1.objectType))));
  }
}
function JanusFormComponent_div_4_janus_alert_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-alert", 14);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵproperty("type", "danger")("icon", true)("dismissible", false)("content", i0.ɵɵpureFunction1(6, _c3$4, i0.ɵɵpipeBind1(1, 4, "misc.Object Update Error")));
  }
}
function JanusFormComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormComponent_div_4_janus_alert_1_Template, 2, 11, "janus-alert", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, JanusFormComponent_div_4_janus_alert_3_Template, 2, 8, "janus-alert", 13);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r1.config.successStatus));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(4, 4, ctx_r1.config.successStatus));
  }
}
function JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 3, "misc.Field is required", i0.ɵɵpureFunction1(6, _c5$1, i0.ɵɵpipeBind1(2, 1, field_r4.label))), " ");
  }
}
function JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "misc.invalid email error"), " ");
  }
}
function JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "misc.invalid url error"), " ");
  }
}
function JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Max length error", i0.ɵɵpureFunction2(4, _c6$1, field_r4.label, field_r4.errors.maxlength.requiredLength)), " ");
  }
}
function JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.Min length error", i0.ɵɵpureFunction2(4, _c7$1, field_r4.label, field_r4.errors.maxlength.requiredLength)), " ");
  }
}
function JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", field_r4.errorMessage, " ");
  }
}
function JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 17);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", field_r4.errors == null ? null : field_r4.errors.errorMessage, i0.ɵɵsanitizeHtml);
  }
}
function JanusFormComponent_ng_template_5_ng_container_1_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_1_Template, 4, 8, "ng-container", 5)(2, JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_2_Template, 3, 3, "ng-container", 5)(3, JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_3_Template, 3, 3, "ng-container", 5)(4, JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_4_Template, 3, 7, "ng-container", 5)(5, JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_5_Template, 3, 7, "ng-container", 5)(6, JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_6_Template, 2, 1, "ng-container", 5)(7, JanusFormComponent_ng_template_5_ng_container_1_li_1_ng_container_7_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.email);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.maxlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.minlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.responseError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors == null ? null : field_r4.errors.customError);
  }
}
function JanusFormComponent_ng_template_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormComponent_ng_template_5_ng_container_1_li_1_Template, 8, 7, "li", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r4.errors);
  }
}
function JanusFormComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 15);
    i0.ɵɵtemplate(1, JanusFormComponent_ng_template_5_ng_container_1_Template, 2, 1, "ng-container", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.validationBox);
  }
}
function JanusFormComponent_janus_alert_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-alert", 18);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const validationList_r3 = i0.ɵɵreference(6);
    i0.ɵɵproperty("id", "validation-box")("type", "error")("icon", true)("dismissible", false)("content", i0.ɵɵpureFunction2(7, _c4$3, i0.ɵɵpipeBind1(1, 5, "misc.Errors detected - please see below") + ":", validationList_r3));
  }
}
function JanusFormComponent_9_ng_template_0_Template(rf, ctx) {}
function JanusFormComponent_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormComponent_9_ng_template_0_Template, 0, 0, "ng-template", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const buttonSets_r5 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", buttonSets_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c8, ctx_r1.config));
  }
}
function JanusFormComponent_ng_container_10_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormComponent_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormComponent_ng_container_10_ng_container_1_Template, 1, 0, "ng-container", 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const requiredMessage_r6 = i0.ɵɵreference(19);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", requiredMessage_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction0(2, _c9));
  }
}
function JanusFormComponent_div_11_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormComponent_div_11_dl_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dl", 22)(1, "dt", 23);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "No defined fields"), " ");
  }
}
function JanusFormComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormComponent_div_11_ng_container_1_Template, 1, 0, "ng-container", 20)(2, JanusFormComponent_div_11_dl_2_Template, 4, 3, "dl", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const janusForm_r7 = i0.ɵɵreference(15);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", janusForm_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c10, ctx_r1.config.controls));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.controls.length);
  }
}
function JanusFormComponent_div_12_div_1_div_1_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormComponent_div_12_div_1_div_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormComponent_div_12_div_1_div_1_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 32);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(4);
    const requiredMessage_r6 = i0.ɵɵreference(19);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", requiredMessage_r6);
  }
}
function JanusFormComponent_div_12_div_1_div_1_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 33);
    i0.ɵɵpipe(1, "safeHtml");
  }
  if (rf & 2) {
    const group_r8 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, group_r8.groupBlurb), i0.ɵɵsanitizeHtml);
  }
}
function JanusFormComponent_div_12_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28)(1, "div", 29)(2, "h2", 30);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, JanusFormComponent_div_12_div_1_div_1_ng_container_4_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, JanusFormComponent_div_12_div_1_div_1_div_5_Template, 2, 3, "div", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    const group_r8 = ctx_r8.$implicit;
    const isFirst_r10 = ctx_r8.first;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c12, ctx_r1.janusVersion === 1, ctx_r1.janusVersion !== 1));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(group_r8.groupTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.janusVersion === 2 && ctx_r1.config.showReqFieldMsg !== false && isFirst_r10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r8.groupBlurb);
  }
}
function JanusFormComponent_div_12_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusFormComponent_div_12_div_1_dl_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dl", 34)(1, "dt", 35);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const group_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c13, ctx_r1.config.controlGroups.indexOf(group_r8) == ctx_r1.config.controlGroups.length - 1, !(ctx_r1.config.controlGroups.indexOf(group_r8) == ctx_r1.config.controlGroups.length - 1)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "No specific fields"), " ");
  }
}
function JanusFormComponent_div_12_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, JanusFormComponent_div_12_div_1_div_1_Template, 6, 7, "div", 26)(2, JanusFormComponent_div_12_div_1_ng_container_2_Template, 1, 0, "ng-container", 20)(3, JanusFormComponent_div_12_div_1_dl_3_Template, 4, 7, "dl", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r8 = ctx.$implicit;
    const isLast_r11 = ctx.last;
    i0.ɵɵnextContext(2);
    const janusForm_r7 = i0.ɵɵreference(15);
    i0.ɵɵclassMapInterpolate1("fieldgroup ", group_r8.styleClass == null ? null : group_r8.styleClass.trim(), "");
    i0.ɵɵpropertyInterpolate("id", group_r8.groupId);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c11, !isLast_r11));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r8.groupTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", janusForm_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction1(11, _c10, group_r8.controls));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !group_r8.controls.length);
  }
}
function JanusFormComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormComponent_div_12_div_1_Template, 4, 13, "div", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.controlGroups);
  }
}
function JanusFormComponent_13_ng_template_0_Template(rf, ctx) {}
function JanusFormComponent_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormComponent_13_ng_template_0_Template, 0, 0, "ng-template", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const buttonSets_r5 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", buttonSets_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c14, ctx_r1.config));
  }
}
function JanusFormComponent_ng_template_14_dl_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 37);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const control_r12 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("config", control_r12)("group", ctx_r1.form)("value", ctx_r1.resource[control_r12.name])("assetsPath", ctx_r1.assetsPath);
  }
}
function JanusFormComponent_ng_template_14_dl_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dl");
    i0.ɵɵtemplate(1, JanusFormComponent_ng_template_14_dl_0_ng_container_1_Template, 2, 4, "ng-container", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const controls_r13 = i0.ɵɵnextContext().controls;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", controls_r13);
  }
}
function JanusFormComponent_ng_template_14_ng_template_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 37);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const control_r14 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("config", control_r14)("group", ctx_r1.form)("value", ctx_r1.resource[control_r14.name])("assetsPath", ctx_r1.assetsPath);
  }
}
function JanusFormComponent_ng_template_14_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormComponent_ng_template_14_ng_template_1_ng_container_0_Template, 2, 4, "ng-container", 16);
  }
  if (rf & 2) {
    const controls_r13 = i0.ɵɵnextContext().controls;
    i0.ɵɵproperty("ngForOf", controls_r13);
  }
}
function JanusFormComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFormComponent_ng_template_14_dl_0_Template, 2, 1, "dl", 36)(1, JanusFormComponent_ng_template_14_ng_template_1_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const notReadOnly_r15 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.config.readOnly)("ngIfElse", notReadOnly_r15);
  }
}
function JanusFormComponent_ng_template_16_ng_container_1_button_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 42);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const config_r16 = i0.ɵɵnextContext(2).config;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.form.disabled || config_r16.isProcessing || config_r16.disableSubmitIfInvalid && ctx_r1.form.invalid ? true : null);
    i0.ɵɵattribute("form", config_r16.id)("aria-controls", config_r16.submitAriaControls ? config_r16.submitAriaControls : null)("aria-disabled", ctx_r1.form.disabled || config_r16.isProcessing || config_r16.disableSubmitIfInvalid && ctx_r1.form.invalid ? true : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 5, config_r16.submitLabel), " ");
  }
}
function JanusFormComponent_ng_template_16_ng_container_1_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵlistener("click", function JanusFormComponent_ng_template_16_ng_container_1_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r17);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.openEditForm());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const config_r16 = i0.ɵɵnextContext(2).config;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.form.disabled || config_r16.isProcessing ? true : null);
    i0.ɵɵattribute("aria-controls", config_r16.editAriaControls ? config_r16.editAriaControls : null)("aria-disabled", ctx_r1.form.disabled || config_r16.isProcessing ? true : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, config_r16.editLabel), " ");
  }
}
function JanusFormComponent_ng_template_16_ng_container_1_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 44);
    i0.ɵɵlistener("click", function JanusFormComponent_ng_template_16_ng_container_1_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const config_r16 = i0.ɵɵnextContext(2).config;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleCallback(config_r16.deleteFn, "deleteWarning"));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const config_r16 = i0.ɵɵnextContext(2).config;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.form.disabled || config_r16.isProcessing ? true : null);
    i0.ɵɵattribute("aria-controls", config_r16.deleteAriaControls ? config_r16.deleteAriaControls : null)("aria-disabled", ctx_r1.form.disabled || config_r16.isProcessing ? true : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, "misc.Delete"), " ");
  }
}
function JanusFormComponent_ng_template_16_ng_container_1_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 45);
    i0.ɵɵlistener("click", function JanusFormComponent_ng_template_16_ng_container_1_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r19);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.cancel());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const config_r16 = i0.ɵɵnextContext(2).config;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.form.disabled || config_r16.isProcessing ? true : null);
    i0.ɵɵattribute("aria-controls", config_r16.cancelAriaControls ? config_r16.cancelAriaControls : null)("aria-disabled", ctx_r1.form.disabled || config_r16.isProcessing ? true : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, config_r16.cancelLabel), " ");
  }
}
function JanusFormComponent_ng_template_16_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormComponent_ng_template_16_ng_container_1_button_1_Template, 3, 7, "button", 38)(2, JanusFormComponent_ng_template_16_ng_container_1_button_2_Template, 3, 6, "button", 39)(3, JanusFormComponent_ng_template_16_ng_container_1_button_3_Template, 3, 6, "button", 40)(4, JanusFormComponent_ng_template_16_ng_container_1_button_4_Template, 3, 6, "button", 41);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const config_r16 = i0.ɵɵnextContext().config;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", config_r16.submitFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", config_r16.editFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", config_r16.deleteFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", config_r16.submitFn);
  }
}
function JanusFormComponent_ng_template_16_ng_container_2_ng_container_1_janus_svg_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-svg-icon", 48);
  }
  if (rf & 2) {
    const button_r21 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("size", "xl")("icon", button_r21.icon);
  }
}
function JanusFormComponent_ng_template_16_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 46);
    i0.ɵɵlistener("click", function JanusFormComponent_ng_template_16_ng_container_2_ng_container_1_Template_button_click_1_listener($event) {
      const button_r21 = i0.ɵɵrestoreView(_r20).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(button_r21.onClick(ctx_r1.form, button_r21.action, $event));
    });
    i0.ɵɵtemplate(2, JanusFormComponent_ng_template_16_ng_container_2_ng_container_1_janus_svg_icon_2_Template, 1, 2, "janus-svg-icon", 47);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const button_r21 = ctx.$implicit;
    const config_r16 = i0.ɵɵnextContext(2).config;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", button_r21.class)("hide", button_r21.hide);
    i0.ɵɵattribute("type", button_r21.type)("disabled", (button_r21.disabled ? !ctx_r1.form.valid ? true : null : null) || ctx_r1.form.disabled || config_r16.isProcessing ? true : null)("aria-controls", button_r21.ariaControls ? button_r21.ariaControls : null)("aria-label", button_r21.ariaLabel ? button_r21.ariaLabel : null)("aria-disabled", (button_r21.disabled ? !ctx_r1.form.valid ? true : null : null) || ctx_r1.form.disabled || config_r16.isProcessing ? true : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", button_r21.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", button_r21.label, " ");
  }
}
function JanusFormComponent_ng_template_16_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormComponent_ng_template_16_ng_container_2_ng_container_1_Template, 4, 9, "ng-container", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const config_r16 = i0.ɵɵnextContext().config;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", config_r16.customButtons);
  }
}
function JanusFormComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormComponent_ng_template_16_ng_container_1_Template, 5, 4, "ng-container", 5)(2, JanusFormComponent_ng_template_16_ng_container_2_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const styleClass_r22 = ctx.styleClass;
    const config_r16 = ctx.config;
    i0.ɵɵclassMapInterpolate1("d-flex flex-wrap justify-content-end ", styleClass_r22, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !config_r16.useCustomButtons);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", config_r16.useCustomButtons);
  }
}
function JanusFormComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span", 49);
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " indicates a required field ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    const styleClass_r23 = ctx.styleClass;
    i0.ɵɵclassMapInterpolate1("required-message fs-5 gray-600 d-none d-sm-block text-end ", (tmp_6_0 = styleClass_r23) !== null && tmp_6_0 !== undefined ? tmp_6_0 : "", "");
  }
}
class JanusFormComponent extends FormComponent {
  constructor(fb, globalService, formErrorService, zone, _viewContainerRef, _route, translate, janusFormConfigService, janusVersion) {
    super(fb, globalService, formErrorService, zone, _viewContainerRef, _route, translate);
    this.fb = fb;
    this.globalService = globalService;
    this.formErrorService = formErrorService;
    this.zone = zone;
    this._viewContainerRef = _viewContainerRef;
    this._route = _route;
    this.translate = translate;
    this.janusFormConfigService = janusFormConfigService;
    this.janusVersion = janusVersion;
    this.winSize = inject(JanusWindowSizeService);
    this.assetsPath = '/app/assets/';
  }
  ngAfterViewInit() {
    setTimeout(() => {
      janusFormActionsDropdownHandler(this.winSize);
    }, 100);
  }
  renderButtonsOutsideForm(viewContainerRef, hasSidebar = false, customStyles = null) {
    viewContainerRef.createEmbeddedView(this.buttonSetsTemplate, {
      config: this.config,
      styleClass: customStyles !== null ? customStyles : this.janusFormConfigService.buttonsOutsideFormStyles(hasSidebar)
    });
  }
  static {
    this.ɵfac = function JanusFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusFormComponent)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(GlobalService), i0.ɵɵdirectiveInject(FormErrorService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1$7.Router), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(JanusFormConfigService), i0.ɵɵdirectiveInject('JANUS_VERSION', 8));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormComponent,
      selectors: [["janus-form"]],
      viewQuery: function JanusFormComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$8, 7);
          i0.ɵɵviewQuery(JanusDynamicFieldDirective, 5, JanusDynamicFieldDirective);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttonSetsTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formFields = _t);
        }
      },
      inputs: {
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 20,
      vars: 16,
      consts: [["validationList", ""], ["janusForm", ""], ["buttonSets", ""], ["requiredMessage", ""], ["notReadOnly", ""], [4, "ngIf"], [3, "id", "type", "icon", "dismissible", "content", "cssClasses", 4, "ngIf"], [1, "form", "columnar", 3, "ngClass"], [3, "id", "type", "icon", "dismissible", "content", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [3, "type", "icon", "dismissible", "content", "cssClasses", 4, "ngIf"], [3, "type", "icon", "dismissible", "content", "cssClasses"], [3, "id", "type", "icon", "dismissible", "content", "cssClasses"], [3, "type", "icon", "dismissible", "content", 4, "ngIf"], [3, "type", "icon", "dismissible", "content"], [1, "ps-3", "mb-0"], [4, "ngFor", "ngForOf"], [3, "innerHTML"], [3, "id", "type", "icon", "dismissible", "content"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "container-fluid p-0  mb-0", 4, "ngIf"], [1, "container-fluid", "p-0", "mb-0"], [1, "label", "form-label", "col-4", "col-sm-3"], [3, "id", "class", "ngClass", 4, "ngFor", "ngForOf"], [3, "id", "ngClass"], ["class", "fg-title", 3, "ngClass", 4, "ngIf"], ["class", "container-fluid p-0", 3, "ngClass", 4, "ngIf"], [1, "fg-title", 3, "ngClass"], [1, "d-flex", "justify-content-between", "align-items-baseline"], [1, "fs-3", "text-gray-900", "fw-normal", "m-0"], ["class", "fg-blurb fs-5 text-gray-600 mt-2", 3, "innerHTML", 4, "ngIf"], [4, "ngTemplateOutlet"], [1, "fg-blurb", "fs-5", "text-gray-600", "mt-2", 3, "innerHTML"], [1, "container-fluid", "p-0", 3, "ngClass"], [1, "label", "form-label"], [4, "ngIf", "ngIfElse"], ["janusDynamicField", "", 3, "config", "group", "value", "assetsPath"], ["type", "submit", "class", "btn btn-primary me-2", "catch-click", "", 3, "disabled", 4, "ngIf"], ["type", "button", "class", "btn btn-primary me-2", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "class", "btn me-2", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "class", "btn btn-outline-secondary", "catch-click", "", 3, "disabled", "click", 4, "ngIf"], ["type", "submit", "catch-click", "", 1, "btn", "btn-primary", "me-2", 3, "disabled"], ["type", "button", 1, "btn", "btn-primary", "me-2", 3, "click", "disabled"], ["type", "button", 1, "btn", "me-2", 3, "click", "disabled"], ["type", "button", "catch-click", "", 1, "btn", "btn-outline-secondary", 3, "click", "disabled"], [1, "btn", "me-2", 3, "click", "ngClass", "hide"], [3, "size", "icon", 4, "ngIf"], [3, "size", "icon"], [1, "req-indicator"]],
      template: function JanusFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div");
          i0.ɵɵtemplate(1, JanusFormComponent_div_1_Template, 5, 6, "div", 5)(2, JanusFormComponent_janus_alert_2_Template, 2, 11, "janus-alert", 6);
          i0.ɵɵelementStart(3, "div", 7);
          i0.ɵɵtemplate(4, JanusFormComponent_div_4_Template, 5, 6, "div", 5)(5, JanusFormComponent_ng_template_5_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(7, JanusFormComponent_janus_alert_7_Template, 2, 10, "janus-alert", 8);
          i0.ɵɵelementStart(8, "form", 9);
          i0.ɵɵlistener("ngSubmit", function JanusFormComponent_Template_form_ngSubmit_8_listener() {
            i0.ɵɵrestoreView(_r1);
            ctx.form.valid ? ctx.submitForm(ctx.form) : ctx.markFormGroupTouched(ctx.form);
            return i0.ɵɵresetView(ctx.setupValidationBox());
          });
          i0.ɵɵtemplate(9, JanusFormComponent_9_Template, 1, 4, null, 5)(10, JanusFormComponent_ng_container_10_Template, 2, 3, "ng-container", 5)(11, JanusFormComponent_div_11_Template, 3, 5, "div", 5)(12, JanusFormComponent_div_12_Template, 2, 1, "div", 5)(13, JanusFormComponent_13_Template, 1, 4, null, 5);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(14, JanusFormComponent_ng_template_14_Template, 3, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(16, JanusFormComponent_ng_template_16_Template, 3, 5, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(18, JanusFormComponent_ng_template_18_Template, 4, 3, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.janusVersion === 2 && ctx.enableErrorMsg);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.janusVersion === 2 && ctx.validationBox.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c1$5, ctx.config.readOnly));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.janusVersion === 1 && ctx.enableErrorMsg);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.janusVersion === 1 && ctx.validationBox.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵattribute("id", ctx.config.id)("aria-disabled", ctx.form.disabled)("role", ctx.config.readOnly ? "section" : null);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.hideButtonbar !== "top" && ctx.config.hideButtonbar !== "both" && !ctx.config.modal);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.janusVersion === 2 && ctx.config.showReqFieldMsg !== false && (!ctx.config.controlGroups || ctx.config.controlGroups && !ctx.config.controlGroups[0] && !ctx.config.controlGroups[0].groupTitle));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.config.useGroupedForm);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.useGroupedForm);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.hideButtonbar !== "bottom" && ctx.config.hideButtonbar !== "both" && !ctx.config.modal);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, Hide, CatchClickDirective, JanusSVGIconComponent, JanusDynamicFieldDirective, JanusAlertComponent, i1.AsyncPipe, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormComponent, [{
    type: Component,
    args: [{
      selector: 'janus-form',
      standalone: false,
      template: "<div>\n\n    <div *ngIf=\"janusVersion === 2 && enableErrorMsg\">\n        <janus-alert *ngIf=\"config.successStatus | async\"\n            [type]=\"'success'\"\n            [icon]=\"true\"\n            [dismissible]=\"false\"\n            [content]=\"{\n                body: 'misc.Record saved successfully' | translate: {object_type: objectType}\n            }\"\n            [cssClasses]=\"'rounded-0'\">\n        </janus-alert>\n\n        <janus-alert *ngIf=\"!(config.successStatus | async)\"\n            [type]=\"'danger'\"\n            [icon]=\"true\"\n            [dismissible]=\"false\"\n            [content]=\"{\n                body: 'misc.Object Update Error' | translate\n            }\"\n            [cssClasses]=\"'rounded-0'\">\n        </janus-alert>\n    </div>\n\n    <janus-alert *ngIf=\"janusVersion === 2 && validationBox.length\"\n        [id]=\"'validation-box'\"\n        [type]=\"'error'\"\n        [icon]=\"true\"\n        [dismissible]=\"false\"\n        [content]=\"{\n            title: ('misc.Errors detected - please see below' | translate) + ':',\n            body: validationList\n        }\"\n        [cssClasses]=\"'rounded-0'\">\n    </janus-alert>\n    <div class=\"form columnar\" [ngClass]=\"{'form-readonly': config.readOnly}\">\n        <div *ngIf=\"janusVersion === 1 && enableErrorMsg\">\n            <janus-alert *ngIf=\"config.successStatus | async\"\n                [type]=\"'success'\"\n                [icon]=\"true\"\n                [dismissible]=\"false\"\n                [content]=\"{\n                    body: 'misc.Record saved successfully' | translate: {object_type: objectType}\n                }\">\n            </janus-alert>\n\n            <janus-alert *ngIf=\"!(config.successStatus | async)\"\n                [type]=\"'danger'\"\n                [icon]=\"true\"\n                [dismissible]=\"false\"\n                [content]=\"{\n                    body: 'misc.Object Update Error' | translate\n                }\">\n            </janus-alert>\n        </div>\n\n        <ng-template #validationList>\n            <ul class=\"ps-3 mb-0\">\n                <ng-container *ngFor=\"let field of validationBox\">\n                    <li *ngIf=\"field.errors\">\n                        <ng-container *ngIf=\"field.errors?.required\">\n                            {{ 'misc.Field is required' | translate: {field_name: field.label | translate} }}\n                        </ng-container>\n                        <ng-container *ngIf=\"field.errors?.email\">\n                            {{ 'misc.invalid email error' | translate }}\n                        </ng-container>\n                        <ng-container *ngIf=\"field.errors?.url\">\n                            {{ 'misc.invalid url error' | translate }}\n                        </ng-container>\n                        <ng-container *ngIf=\"field.errors?.maxlength\">\n                            {{ 'misc.Max length error' | translate: {field_name: field.label, max: field.errors.maxlength.requiredLength} }}\n                        </ng-container>\n                        <ng-container *ngIf=\"field.errors?.minlength\">\n                            {{ 'misc.Min length error' | translate: {field_name: field.label, min: field.errors.maxlength.requiredLength} }}\n                        </ng-container>\n                        <ng-container *ngIf=\"field.errors?.responseError\">\n                            {{ field.errorMessage }}\n                        </ng-container>\n                        <ng-container *ngIf=\"field.errors?.customError\">\n                            <div [innerHTML]=\"field.errors?.errorMessage\"></div>\n                        </ng-container>\n                    </li>\n                </ng-container>\n            </ul>\n        </ng-template>\n\n        <janus-alert *ngIf=\"janusVersion === 1 && validationBox.length\"\n            [id]=\"'validation-box'\"\n            [type]=\"'error'\"\n            [icon]=\"true\"\n            [dismissible]=\"false\"\n            [content]=\"{\n                title: ('misc.Errors detected - please see below' | translate) + ':',\n                body: validationList\n            }\">\n        </janus-alert>\n\n        <form \n            [attr.id]=\"config.id\"\n            [formGroup]=\"form\"\n            [attr.aria-disabled]=\"form.disabled\"\n            [attr.role]=\"config.readOnly ? 'section' : null\"\n            (ngSubmit)=\"form.valid ? submitForm(form) : markFormGroupTouched(form); setupValidationBox();\"\n        >\n            <ng-template\n                    *ngIf=\"(config.hideButtonbar !== 'top' && config.hideButtonbar !== 'both')  && !config.modal\"\n                    [ngTemplateOutlet]=\"buttonSets\"\n                    [ngTemplateOutletContext]=\"{ styleClass: 'header-buttonbar mb-4', config: config }\"\n            ></ng-template>\n\n            <ng-container *ngIf=\"janusVersion === 2 && config.showReqFieldMsg !== false && (!config.controlGroups || (config.controlGroups && !config.controlGroups[0] && !config.controlGroups[0].groupTitle))\">\n                <ng-container *ngTemplateOutlet=\"requiredMessage; context: { styleClass: 'mb-4' }\"></ng-container>\n            </ng-container>\n\n            <div *ngIf=\"!config.useGroupedForm\">\n                <ng-container *ngTemplateOutlet=\"janusForm; context: { controls: config.controls }\"></ng-container>\n                <dl *ngIf=\"!config.controls.length\" class=\"container-fluid p-0  mb-0\">\n                    <dt class=\"label form-label col-4 col-sm-3\" >\n                        {{'No defined fields' | translate}}\n                    </dt>\n                </dl>\n            </div>\n            <div *ngIf=\"config.useGroupedForm\">\n                <div *ngFor=\"let group of config.controlGroups; first as isFirst; last as isLast\" id=\"{{group.groupId}}\" class=\"fieldgroup {{ group.styleClass?.trim() }}\" [ngClass]=\"{'mb-4': !isLast}\">\n                    <div *ngIf=\"group.groupTitle\" class=\"fg-title\" [ngClass]=\"{'mb-2': janusVersion === 1, 'mb-4': janusVersion !== 1}\">\n                        \n                        <div class=\"d-flex justify-content-between align-items-baseline\">\n                            <h2 class=\"fs-3 text-gray-900 fw-normal m-0\">{{group.groupTitle}}</h2>\n                            <ng-container *ngIf=\"janusVersion === 2 && config.showReqFieldMsg !== false && isFirst\">\n                                <ng-container *ngTemplateOutlet=\"requiredMessage\"></ng-container>\n                            </ng-container>\n                        </div>\n                        <div [innerHTML]=\"group.groupBlurb | safeHtml\" *ngIf=\"group.groupBlurb\" class=\"fg-blurb fs-5 text-gray-600 mt-2\"></div>\n                    </div>\n                    <ng-container *ngTemplateOutlet=\"janusForm; context: { controls: group.controls }\"></ng-container>\n                    <dl *ngIf=\"!group.controls.length\" class=\"container-fluid p-0\" [ngClass]=\"{'last mb-0': config.controlGroups.indexOf(group) == config.controlGroups.length - 1, 'mb-3': !(config.controlGroups.indexOf(group) == config.controlGroups.length - 1)}\">\n                        <dt class=\"label form-label\">\n                            {{'No specific fields' | translate}}\n                        </dt>\n                    </dl>\n                </div>\n            </div>\n\n            <ng-template \n                    *ngIf=\"(config.hideButtonbar !== 'bottom' && config.hideButtonbar !== 'both') && !config.modal\" \n                    [ngTemplateOutlet]=\"buttonSets\" \n                    [ngTemplateOutletContext]=\"{ styleClass: 'footer-buttonbar mt-4', config: config }\"\n            ></ng-template>\n        </form>\n    </div>\n</div>\n\n<ng-template #janusForm let-controls=\"controls\">\n\t<dl *ngIf=\"config.readOnly; else notReadOnly\">\n\t\t<ng-container *ngFor=\"let control of controls\">\n\t\t\t<ng-container janusDynamicField [config]=\"control\" [group]=\"form\" [value]=\"resource[control.name]\" [assetsPath]=\"assetsPath\"></ng-container>\n\t\t</ng-container>\n\t</dl>\n\t<ng-template #notReadOnly>\n\t\t<ng-container *ngFor=\"let control of controls\">\n\t\t\t<ng-container janusDynamicField [config]=\"control\" [group]=\"form\" [value]=\"resource[control.name]\" [assetsPath]=\"assetsPath\"></ng-container>\n\t\t</ng-container>\n\t</ng-template>\n</ng-template>\n\n\n<ng-template #buttonSets let-styleClass=\"styleClass\" let-config=\"config\">\n\t<div class=\"d-flex flex-wrap justify-content-end {{styleClass}}\">\n\n\t\t<ng-container *ngIf=\"!config.useCustomButtons\">\n\t\t\t<button \n\t\t\t\t*ngIf=\"config.submitFn\" \n\t\t\t\ttype=\"submit\" \n\t\t\t\tclass=\"btn btn-primary me-2\"\n\t\t\t\t[attr.form]=\"config.id\"\n\t\t\t\t[disabled]=\"form.disabled || config.isProcessing || (config.disableSubmitIfInvalid && form.invalid) ? true : null\"\n\t\t\t\t[attr.aria-controls]=\"config.submitAriaControls ? config.submitAriaControls : null\"\n\t\t\t\t[attr.aria-disabled]=\"form.disabled || config.isProcessing || (config.disableSubmitIfInvalid && form.invalid) ? true : null\"\n\t\t\t\tcatch-click\n\t\t\t>\n\t\t\t\t{{ config.submitLabel | translate }}\n\t\t\t</button>\n\t\t\t<button \n\t\t\t\t*ngIf=\"config.editFn\"\n\t\t\t\ttype=\"button\"\n\t\t\t\tclass=\"btn btn-primary me-2\"\n\t\t\t\t[disabled]=\"(form.disabled || config.isProcessing) ? true : null\"\n\t\t\t\t[attr.aria-controls]=\"config.editAriaControls ? config.editAriaControls : null\"\n\t\t\t\t[attr.aria-disabled]=\"(form.disabled || config.isProcessing) ? true : null\"\n\t\t\t\t(click)=\"openEditForm()\"\n\t\t\t>\n\t\t\t\t{{ config.editLabel | translate }}\n\t\t\t</button>\n\t\t\t<button\n\t\t\t\t*ngIf=\"config.deleteFn\"\n\t\t\t\ttype=\"button\"\n\t\t\t\tclass=\"btn me-2\"\n\t\t\t\t[disabled]=\"(form.disabled || config.isProcessing) ? true : null\"\n\t\t\t\t[attr.aria-controls]=\"config.deleteAriaControls ? config.deleteAriaControls : null\"\n\t\t\t\t[attr.aria-disabled]=\"(form.disabled || config.isProcessing) ? true : null\"\n\t\t\t\t(click)=\"handleCallback(config.deleteFn, 'deleteWarning')\"\n\t\t\t>\n\t\t\t\t{{ 'misc.Delete' | translate }}\n\t\t\t</button>\n\t\t\t<button\n\t\t\t\t*ngIf=\"config.submitFn\"\n\t\t\t\ttype=\"button\"\n\t\t\t\tclass=\"btn btn-outline-secondary\"\n\t\t\t\t[disabled]=\"(form.disabled || config.isProcessing) ? true : null\"\n\t\t\t\t[attr.aria-controls]=\"config.cancelAriaControls ? config.cancelAriaControls : null\"\n\t\t\t\t[attr.aria-disabled]=\"(form.disabled || config.isProcessing) ? true : null\"\n\t\t\t\t(click)=\"cancel()\"\n\t\t\t\tcatch-click\n\t\t\t>\n\t\t\t\t{{ config.cancelLabel | translate }}\n\t\t\t</button>\n\t\t</ng-container>\n\t\t\n\t\t<ng-container *ngIf=\"config.useCustomButtons\">\n\t\t\t<ng-container *ngFor=\"let button of config.customButtons; index as i\">\n\t\t\t\t<button class=\"btn me-2\" \n\t\t\t\t\t[attr.type]=\"button.type\" \n\t\t\t\t\t[ngClass]=\"button.class\" \n\t\t\t\t\t[attr.disabled]=\"((button.disabled ? (!form.valid ? true : null) : null) || form.disabled || config.isProcessing) ? true : null\" \n\t\t\t\t\t[attr.aria-controls]=\"button.ariaControls ? button.ariaControls : null\"\n\t\t\t\t\t[attr.aria-label]=\"button.ariaLabel ? button.ariaLabel : null\"\n\t\t\t\t\t[attr.aria-disabled]=\"((button.disabled ? (!form.valid ? true : null) : null) || form.disabled || config.isProcessing) ? true : null\" \n\t\t\t\t\t[hide]=\"button.hide\" \n\t\t\t\t\t(click)=\"button.onClick(form, button.action, $event)\"\n\t\t\t\t>\n\t\t\t\t\t<janus-svg-icon *ngIf=\"button.icon\" [size]=\"'xl'\" [icon]=\"button.icon\"></janus-svg-icon>\n\t\t\t\t\t{{button.label}}\n\t\t\t\t</button>\n\t\t\t</ng-container>\n\t\t\t\n\t\t</ng-container>\n\t\t\t\n\t</div>\n</ng-template>\n\n<ng-template #requiredMessage let-styleClass=\"styleClass\">\n    <div class=\"required-message fs-5 gray-600 d-none d-sm-block text-end {{styleClass ?? ''}}\">\n        <span class=\"req-indicator\">*</span> indicates a required field\n    </div>\n</ng-template>\n"
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }, {
    type: GlobalService
  }, {
    type: FormErrorService
  }, {
    type: i0.NgZone
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i1$7.Router
  }, {
    type: i1$1.TranslateService
  }, {
    type: JanusFormConfigService
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['JANUS_VERSION']
    }]
  }], {
    assetsPath: [{
      type: Input
    }],
    buttonSetsTemplate: [{
      type: ViewChild,
      args: ['buttonSets', {
        static: true
      }]
    }],
    formFields: [{
      type: ViewChildren,
      args: [JanusDynamicFieldDirective, {
        read: JanusDynamicFieldDirective
      }]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormComponent, {
    className: "JanusFormComponent",
    filePath: "janus/janus-form.component.ts",
    lineNumber: 18
  });
})();
function janusFormActionsDropdownHandler(winSize) {
  // Modify Save button classes for xs
  let saveButton = document.querySelector('.form_actions button[key="save"]');
  let submitButton = false;
  if (!saveButton) {
    submitButton = true;
    saveButton = document.querySelector('.form_actions button[key="submit"]');
    saveButton?.classList.remove('d-none');
  }
  if (saveButton) {
    if (winSize.smMin()) {
      saveButton.classList.remove('flex-fill', 'justify-content-center');
      if (!submitButton) {
        saveButton.classList.remove('btn-primary');
        saveButton.classList.add('btn-outline-primary');
      }
    } else {
      if (!submitButton) {
        saveButton.classList.remove('btn-outline-primary');
        saveButton.classList.add('btn-primary');
      }
      saveButton.classList.add('flex-fill', 'justify-content-center');
    }
  }
  const nonPrimaryActions = document.querySelectorAll('.non-primary-actions');
  if (nonPrimaryActions.length === 0) {
    return;
  } // Container everything is based on does not exist
  const nonPrimaryActionsContainer = nonPrimaryActions[0].parentNode;
  const actionItems = [...nonPrimaryActionsContainer.querySelectorAll('.non-primary-actions button')];
  // Modify More button classes for xs
  if (winSize.smMin()) {
    nonPrimaryActionsContainer.classList.add('flex-fill');
  } else {
    nonPrimaryActionsContainer.classList.remove('flex-fill');
  }
  if (actionItems.length === 0) {
    return;
  } // Non-primary form actions do not exist
  let moreDropdown = nonPrimaryActionsContainer.querySelector('[moredropdown]');
  let moreDropdownList = moreDropdown.querySelector('ul.dropdown-menu');
  moreDropdown.classList.add('d-none');
  moreDropdownList.innerHTML = '';
  let availableWidth = 0;
  let maxReached = false;
  if (winSize.lgMin()) {
    // Show all non-primary form actions and measure
    actionItems.forEach(item => item.classList.remove('d-none'));
    const minWidthToFit = nonPrimaryActions[0].offsetWidth;
    // Re-hide all non-primary form actions
    actionItems.forEach(item => item.classList.add('d-none'));
    // Measure container and all other parts
    availableWidth = nonPrimaryActionsContainer.offsetWidth;
    if (availableWidth >= minWidthToFit) {
      // All tabs fit without the need for dropdown
      actionItems.forEach(item => item.classList.remove('d-none'));
      return;
    }
  }
  // Show moredropdown
  moreDropdown.classList.remove('d-none');
  availableWidth -= moreDropdown.offsetWidth;
  let hasSecondaryAction = false;
  let hasDivider = false;
  // Loop to measure each button and display it until no more can fit
  actionItems.forEach(item => {
    let isTertiaryAction = false;
    item.classList.remove('d-none');
    let itemWidthMargin = item.offsetWidth + parseInt(window.getComputedStyle(item).getPropertyValue('margin-right'));
    if (availableWidth >= itemWidthMargin && !maxReached) {
      // button fits in available space
      availableWidth -= itemWidthMargin;
    } else {
      maxReached = true;
      item.classList.add('d-none');
      // Move remaining buttons into moredropdown
      const cloned = item.cloneNode(true);
      cloned.className = 'dropdown-item';
      cloned.classList.add('text-truncate');
      if (cloned.getAttribute('grouping') === 'secondary') {
        hasSecondaryAction = true;
      }
      if (cloned.getAttribute('grouping') === 'tertiary') {
        isTertiaryAction = true;
      }
      if (hasSecondaryAction && isTertiaryAction && !hasDivider) {
        let moreDiv = document.createElement('li');
        moreDiv.innerHTML = '<hr class="dropdown-divider">';
        moreDropdownList.append(moreDiv);
        hasDivider = true;
      }
      let liElement = document.createElement('li');
      liElement.append(cloned);
      moreDropdownList.append(liElement);
    }
  });
}
;
const _c0$7 = (a0, a1, a2) => ({
  "first": a0,
  "last": a1,
  "active": a2
});
const _c1$4 = a0 => ({
  "active": a0
});
const _c2$3 = a0 => [a0];
const _c3$3 = () => ["active"];
function JanusTabsComponent_ng_container_0_li_4_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 13)(1, "div", 14);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tab_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$4, tab_r1.active));
    i0.ɵɵattribute("aria-current", !!tab_r1.active)("href", tab_r1.link, i0.ɵɵsanitizeUrl)("title", tab_r1.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 5, tab_r1.title));
  }
}
function JanusTabsComponent_ng_container_0_li_4_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵlistener("isActiveChange", function JanusTabsComponent_ng_container_0_li_4_a_2_Template_a_isActiveChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const tab_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.tabActiveChange($event, tab_r1));
    });
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tab_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(8, _c2$3, tab_r1.routerLink))("routerLinkActive", i0.ɵɵpureFunction0(10, _c3$3))("ngClass", i0.ɵɵpureFunction1(11, _c1$4, tab_r1.active));
    i0.ɵɵattribute("aria-current", !!tab_r1.active)("title", tab_r1.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 6, tab_r1.title));
  }
}
function JanusTabsComponent_ng_container_0_li_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 10);
    i0.ɵɵtemplate(1, JanusTabsComponent_ng_container_0_li_4_a_1_Template, 4, 9, "a", 11)(2, JanusTabsComponent_ng_container_0_li_4_a_2_Template, 4, 13, "a", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    const last_r4 = ctx.last;
    const first_r5 = ctx.first;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c0$7, first_r5, last_r4, tab_r1.active));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r1.link && !tab_r1.routerLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r1.routerLink);
  }
}
function JanusTabsComponent_ng_container_0_li_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 16)(1, "a", 17);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r2.translateHref, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx_r2.translateText));
  }
}
function JanusTabsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "nav", 1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "ul", 2);
    i0.ɵɵtemplate(4, JanusTabsComponent_ng_container_0_li_4_Template, 3, 7, "li", 3);
    i0.ɵɵelementStart(5, "li", 4)(6, "button", 5)(7, "div")(8, "span");
    i0.ɵɵtext(9, "+00");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(10, "svg", 6);
    i0.ɵɵelement(11, "use", 7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(12, "ul", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, JanusTabsComponent_ng_container_0_li_13_Template, 4, 4, "li", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 3, "misc.Section Navigation"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2._tabs);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", ctx_r2.isTranslationMode);
  }
}
class JanusTabsComponent {
  get tabs() {
    return this._tabs;
  }
  set tabs(tabs) {
    if (!tabs) {
      return;
    }
    this._tabs = tabs.map(t => new JanusTabItem(t));
    setTimeout(() => {
      janusTabsDropdownHandler(this.translate);
    });
  }
  constructor(translate) {
    this.translate = translate;
    this._tabs = [];
    this.isTranslationMode = window.TRANSLATION_MODE === 1;
    this.translateText = window.LANG_TRANSLATION_MULTILINGUAL_MODE === 1 ? 'misc.Translate' : 'misc.Edit Text';
    this.translateHref = '/manager/index.php?___lt=1&lttype=tab&domain=tab%20manager&return_to_referrer=1';
  }
  tabActiveChange(active, tabActive) {
    if (!active) {
      return;
    }
    this._tabs = this._tabs.map(tab => {
      tab.active = false;
      if (tab.routerLink === tabActive.routerLink) {
        tab.active = true;
      }
      return tab;
    });
  }
  static {
    this.ɵfac = function JanusTabsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusTabsComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusTabsComponent,
      selectors: [["janus-tabs"]],
      inputs: {
        translateHref: "translateHref",
        tabs: "tabs"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [[4, "ngIf"], ["id", "page_tabs", 1, "tabs-container", "main_tabs_container"], [1, "nav", "nav-underline", "flex-nowrap", "px-3", "px-xl-4", "bg-gray-50", "border-bottom", "border-light"], ["class", "nav-item", 3, "ngClass", 4, "ngFor", "ngForOf"], ["tabdropdown", "", 1, "d-none"], ["data-bs-toggle", "dropdown", "aria-owns", "ax-tab-list", 1, "nav-link", "h-100", "text-nowrap", "d-inline-flex", "fs-5", "py-1", "py-sm-2", "lh-sm", "align-items-center"], ["width", "1rem", "height", "1rem"], [0, "xlink", "href", "/images/tabler-icons/tabler-sprite-nostroke.svg#tabler-caret-down-filled"], ["id", "ax-tab-list", 1, "dropdown-menu"], ["class", "fs-5 tab_text text-truncate-2", 4, "ngIf"], [1, "nav-item", 3, "ngClass"], ["class", "nav-link text-center h-100 py-1 py-sm-2 lh-sm d-flex align-items-center", 3, "ngClass", 4, "ngIf"], ["class", "nav-link text-center h-100 py-1 py-sm-2 lh-sm d-flex align-items-center", 3, "routerLink", "routerLinkActive", "ngClass", "isActiveChange", 4, "ngIf"], [1, "nav-link", "text-center", "h-100", "py-1", "py-sm-2", "lh-sm", "d-flex", "align-items-center", 3, "ngClass"], [1, "tab_text", "fs-5"], [1, "nav-link", "text-center", "h-100", "py-1", "py-sm-2", "lh-sm", "d-flex", "align-items-center", 3, "isActiveChange", "routerLink", "routerLinkActive", "ngClass"], [1, "fs-5", "tab_text", "text-truncate-2"], [1, "xlate"]],
      template: function JanusTabsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusTabsComponent_ng_container_0_Template, 14, 5, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", (ctx._tabs == null ? null : ctx._tabs.length) > 1);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1$7.RouterLink, i1$7.RouterLinkActive, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusTabsComponent, [{
    type: Component,
    args: [{
      selector: 'janus-tabs',
      template: `
        <ng-container *ngIf="_tabs?.length > 1">
            <nav id="page_tabs"
                class="tabs-container main_tabs_container" 
                [attr.aria-label]="'misc.Section Navigation' | translate"
            >
                <ul class="nav nav-underline flex-nowrap px-3 px-xl-4 bg-gray-50 border-bottom border-light">
                    <li *ngFor="let tab of _tabs; last as last; first as first;"
                        class="nav-item"
                        [ngClass]="{ 'first': first, 'last': last, 'active': tab.active }"
                    >
                        <a
                            *ngIf="tab.link && !tab.routerLink"
                            class="nav-link text-center h-100 py-1 py-sm-2 lh-sm d-flex align-items-center"
                            [attr.aria-current]="!!tab.active"
                            [attr.href]="tab.link"
                            [attr.title]="tab.title"
                            [ngClass]="{ 'active': tab.active }"
                        >
                            <div class="tab_text fs-5">{{ tab.title | translate }}</div>
                        </a>
                        <a
                            *ngIf="tab.routerLink"
                            [routerLink]="[tab.routerLink]"
                            [routerLinkActive]="['active']"
                            (isActiveChange)="tabActiveChange($event, tab)"
                            class="nav-link text-center h-100 py-1 py-sm-2 lh-sm d-flex align-items-center"
                            [attr.aria-current]="!!tab.active"
                            [attr.title]="tab.title"
                            [ngClass]="{ 'active': tab.active }"
                        >
                            <div class="tab_text fs-5">{{ tab.title | translate }}</div>
                        </a>
                    </li>
                        
                    <li tabdropdown class="d-none">
                        <button
                            data-bs-toggle="dropdown"
                            class="nav-link h-100 text-nowrap d-inline-flex fs-5 py-1 py-sm-2 lh-sm align-items-center"
                            aria-owns="ax-tab-list"
                        >
                            <div>
                                <span>+00</span>
                                <svg width="1rem" height="1rem"><use xlink:href="/images/tabler-icons/tabler-sprite-nostroke.svg#tabler-caret-down-filled"></use></svg>
                            </div>
                        </button>
                        <ul id="ax-tab-list" class="dropdown-menu"></ul>
                    </li>
                    <li *ngIf="isTranslationMode" class="fs-5 tab_text text-truncate-2">
                        <a class="xlate" [attr.href]="translateHref">{{ translateText | translate }}</a>
                    </li>
                </ul>
            </nav>
        </ng-container>
    `,
      standalone: false
    }]
  }], () => [{
    type: i1$1.TranslateService
  }], {
    translateHref: [{
      type: Input
    }],
    tabs: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusTabsComponent, {
    className: "JanusTabsComponent",
    filePath: "janus/components/tabs/janustabs.component.ts",
    lineNumber: 66
  });
})();
class JanusTabItem {
  constructor(obj) {
    this.orderby = obj.orderby;
    this.title = obj.title || obj.name;
    this.link = obj.link;
    this.routerLink = obj.routerLink;
    this.active = !!obj.active;
    this.shortname = obj.shortname;
  }
}
function janusTabsDropdownHandler(translate) {
  const tabsArray = [...document.querySelectorAll('nav.tabs-container ul.nav')];
  if (!tabsArray.length) {
    return;
  }
  tabsArray.forEach(tab => {
    // Reset
    let tabDropdown = tab.querySelector('[tabdropdown]');
    tabDropdown.classList.add('d-none');
    tabDropdown.querySelector('ul.dropdown-menu').innerHTML = '';
    let listItems = [...tab.querySelectorAll('.nav-item')];
    listItems.forEach(item => item.classList.remove('d-none'));
    tab.style['width'] = 'min-content';
    // End reset
    let minWidthToFit = tab.offsetWidth;
    tab.style['width'] = '';
    let availableWidth = tab.offsetWidth;
    if (availableWidth >= minWidthToFit) {
      // All tabs fit without the need for dropdown
      return;
    }
    // Need to setup dropdown with some tabs
    tabDropdown.classList.remove('d-none');
    tab.style['width'] = 'min-content';
    let idx = -1;
    let countTabsDropdown = 0;
    while (minWidthToFit > availableWidth && countTabsDropdown < listItems.length - 1) {
      let lastEl = listItems.slice(idx)[0];
      if (lastEl.classList.contains('d-none')) {
        break;
      }
      if (lastEl.classList.contains('active')) {
        idx--;
        continue;
      }
      const cloned = lastEl.cloneNode(true);
      cloned.querySelector('a').className = 'dropdown-item';
      let tabTextEl = cloned.querySelector('.tab_text');
      tabTextEl.classList.add('text-truncate');
      lastEl.classList.add('d-none');
      tabDropdown.querySelector('ul')?.prepend(cloned);
      countTabsDropdown++;
      minWidthToFit = tab.offsetWidth;
      idx--;
    }
    tabDropdown.querySelector('button span').textContent = '+' + countTabsDropdown;
    tabDropdown.querySelector('button')?.setAttribute('aria-label', translate.instant('misc.{x} more links', {
      x: countTabsDropdown
    }));
    tabDropdown.querySelector('button')?.setAttribute('title', translate.instant('misc.{x} more links', {
      x: countTabsDropdown
    }));
    tab.style['width'] = '';
  });
}
const _c0$6 = ["formButtons"];
const _c1$3 = ["janusForm"];
const _c2$2 = ["routerOutlet"];
const _c3$2 = ["form"];
const _c4$2 = ["wrappedForm"];
const _c5 = () => ({
  isForm: true
});
const _c6 = a0 => ({
  "mb-sm-2 mb-xl-3": a0
});
const _c7 = (a0, a1, a2, a3, a4) => ({
  "rounded": a0,
  "col-xl-7 col-xxl-8": a1,
  "bg-white": a2,
  "border-0": a3,
  "p-0": a4
});
function JanusManagerTemplatesComponent_ng_template_0_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusManagerTemplatesComponent_ng_template_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusManagerTemplatesComponent_ng_template_0_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.tabs.template)("ngTemplateOutletContext", ctx_r0.tabs.context);
  }
}
function JanusManagerTemplatesComponent_ng_template_0_Conditional_4_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusManagerTemplatesComponent_ng_template_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusManagerTemplatesComponent_ng_template_0_Conditional_4_ng_container_0_Template, 1, 0, "ng-container", 9);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const form_r2 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", form_r2);
  }
}
function JanusManagerTemplatesComponent_ng_template_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "router-outlet");
  }
}
function JanusManagerTemplatesComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, JanusManagerTemplatesComponent_ng_template_0_ng_container_1_Template, 2, 2, "ng-container", 5);
    i0.ɵɵelementStart(2, "div", 6)(3, "div", 7);
    i0.ɵɵtemplate(4, JanusManagerTemplatesComponent_ng_template_0_Conditional_4_Template, 1, 1, "ng-container")(5, JanusManagerTemplatesComponent_ng_template_0_Conditional_5_Template, 1, 0, "router-outlet");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const isForm_r3 = ctx.isForm;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.tabs.template);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(isForm_r3 ? 4 : 5);
  }
}
function JanusManagerTemplatesComponent_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusManagerTemplatesComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusManagerTemplatesComponent_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 8);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const routerOutlet_r4 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", routerOutlet_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction0(2, _c5));
  }
}
function JanusManagerTemplatesComponent_ng_template_4_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusManagerTemplatesComponent_ng_template_4_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusManagerTemplatesComponent_ng_template_4_ng_container_0_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.alerts.template)("ngTemplateOutletContext", ctx_r0.alerts.context);
  }
}
function JanusManagerTemplatesComponent_ng_template_4_ng_container_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "a", 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r0.translationLink.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.translationLink.label);
  }
}
function JanusManagerTemplatesComponent_ng_template_4_ng_container_0_ng_container_6_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusManagerTemplatesComponent_ng_template_4_ng_container_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtemplate(2, JanusManagerTemplatesComponent_ng_template_4_ng_container_0_ng_container_6_ng_container_2_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r0.buttonSetStyles);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.buttons.template)("ngTemplateOutletContext", ctx_r0.buttons.context);
  }
}
function JanusManagerTemplatesComponent_ng_template_4_ng_container_0_main_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusManagerTemplatesComponent_ng_template_4_ng_container_0_main_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "main", 18);
    i0.ɵɵtemplate(1, JanusManagerTemplatesComponent_ng_template_4_ng_container_0_main_8_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(4, _c7, ctx_r0.config.paddingBottom, ctx_r0.aside.template, !ctx_r0.config.backgroundless, ctx_r0.config.noBorder, ctx_r0.config.noPadding));
    i0.ɵɵattribute("tabindex", ctx_r0.config.focusableContentContainer ? 0 : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.main.template)("ngTemplateOutletContext", ctx_r0.main.context);
  }
}
function JanusManagerTemplatesComponent_ng_template_4_ng_container_0_aside_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusManagerTemplatesComponent_ng_template_4_ng_container_0_aside_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "aside", 19);
    i0.ɵɵtemplate(1, JanusManagerTemplatesComponent_ng_template_4_ng_container_0_aside_9_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.aside.template)("ngTemplateOutletContext", ctx_r0.aside.context);
  }
}
function JanusManagerTemplatesComponent_ng_template_4_ng_container_0_button_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "janus-svg-icon", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 3, "misc.Open sidebar"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", "layout-sidebar-right")("size", "xl");
  }
}
function JanusManagerTemplatesComponent_ng_template_4_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusManagerTemplatesComponent_ng_template_4_ng_container_0_ng_container_1_Template, 2, 2, "ng-container", 5);
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵtemplate(3, JanusManagerTemplatesComponent_ng_template_4_ng_container_0_div_3_Template, 3, 2, "div", 11);
    i0.ɵɵelementContainer(4, null, 3);
    i0.ɵɵtemplate(6, JanusManagerTemplatesComponent_ng_template_4_ng_container_0_ng_container_6_Template, 3, 4, "ng-container", 5);
    i0.ɵɵelementStart(7, "div", 12);
    i0.ɵɵtemplate(8, JanusManagerTemplatesComponent_ng_template_4_ng_container_0_main_8_Template, 2, 10, "main", 13)(9, JanusManagerTemplatesComponent_ng_template_4_ng_container_0_aside_9_Template, 2, 2, "aside", 14)(10, JanusManagerTemplatesComponent_ng_template_4_ng_container_0_button_10_Template, 3, 5, "button", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.alerts.template);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.translationLink && ctx_r0.inTranslationMode());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.buttons.template);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c6, ctx_r0.config.paddingBottom));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.main.template);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.aside.template);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.aside.template);
  }
}
function JanusManagerTemplatesComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusManagerTemplatesComponent_ng_template_4_ng_container_0_Template, 11, 9, "ng-container", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r0.loading);
  }
}
class JanusManagerTemplatesComponent {
  set formRef(ref) {
    if (ref) {
      ref.config.hideButtonbar = 'both';
      if (ref.config.customButtons.length > 0 || ref.config.submitFn || ref.config.editFn || ref.config.deleteFn) {
        this.hasFormButtons = true;
        ref.renderButtonsOutsideForm(this.formButtonsRef, this.aside.template ? true : false);
      }
      this._formRef = ref;
    }
  }
  get formRef() {
    return this._formRef;
  }
  constructor(viewContainerRef, janusFormConfigService) {
    this.viewContainerRef = viewContainerRef;
    this.janusFormConfigService = janusFormConfigService;
    this.loading = true;
    this.buttonSetStyles = '';
    this.hasFormButtons = false;
    this.template = '';
    this.tabs = {
      template: null,
      context: {}
    };
    this.main = {
      template: null,
      context: {}
    };
    this.alerts = {
      template: null,
      context: {}
    };
    this.buttons = {
      template: null,
      context: {}
    };
    this.aside = {
      template: null,
      context: {}
    };
    this.config = {
      backgroundless: false,
      noPadding: false,
      noBorder: false,
      paddingBottom: false,
      focusableContentContainer: false
    };
    this.translationLink = {
      label: '',
      link: ''
    };
    this.templates = {};
  }
  ngAfterViewInit() {
    this.loading = false;
    if (this.buttons.template) {
      this.buttonSetStyles = this.janusFormConfigService.buttonsOutsideFormStyles(this.aside.template ? true : false);
    }
    setTimeout(() => {
      this.templates['routerOutlet'] = this.routerOutletTemplate;
      this.templates['form'] = this.formTemplate;
      this.templates['wrappedForm'] = this.wrappedFormTemplate;
      const selectedTemplate = this.templates[this.template];
      if (selectedTemplate) {
        this.viewContainerRef.createEmbeddedView(selectedTemplate);
      }
    });
  }
  inTranslationMode() {
    return window.TRANSLATION_MODE === 1;
  }
  static {
    this.ɵfac = function JanusManagerTemplatesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusManagerTemplatesComponent)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(JanusFormConfigService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusManagerTemplatesComponent,
      selectors: [["janus-manager-templates"]],
      viewQuery: function JanusManagerTemplatesComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$6, 5, ViewContainerRef);
          i0.ɵɵviewQuery(_c1$3, 5);
          i0.ɵɵviewQuery(_c2$2, 7);
          i0.ɵɵviewQuery(_c3$2, 7);
          i0.ɵɵviewQuery(_c4$2, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formButtonsRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.janusFormRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.routerOutletTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.wrappedFormTemplate = _t.first);
        }
      },
      inputs: {
        template: "template",
        tabs: "tabs",
        main: "main",
        alerts: "alerts",
        buttons: "buttons",
        aside: "aside",
        config: "config",
        translationLink: "translationLink",
        formRef: "formRef"
      },
      standalone: false,
      decls: 6,
      vars: 0,
      consts: [["routerOutlet", ""], ["wrappedForm", ""], ["form", ""], ["formButtons", ""], [1, "module", "d-flex", "flex-column", "w-100", "h-100"], [4, "ngIf"], ["id", "main-content", 1, "content", "minh-0", "janus-radial-accent-bg", "h-100", "w-100"], [1, "innercontent", "d-flex", "flex-column", "h-100"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngTemplateOutlet"], [1, "d-flex", "flex-column", "h-100", "overflow-auto", "flex-fill"], ["class", "xlate-filterslyt-w text-end m-1", 4, "ngIf"], [1, "content-columns", "mt-0", "mt-sm-2", "mt-xl-3", "mb-0", 3, "ngClass"], ["class", "maincol col-12 overflow-auto position-relative", 3, "ngClass", 4, "ngIf"], ["id", "offcanvas-sidebar", "class", "offcanvas-xl offcanvas-end flex-fill overflow-auto bg-white border border-gray-200 rounded m-0 m-sm-3 m-xl-0", "tabindex", "-1", 4, "ngIf"], ["type", "button", "class", "avatar avatar-icon avatar-md z-3 avatar-rounded bg-gray-100 text-gray-600 me-2 me-sm-4 mt-2 end-0 d-xl-none position-absolute sidebar-offcanvas-trigger", "data-bs-toggle", "offcanvas", "data-bs-target", "#offcanvas-sidebar", "aria-controls", "offcanvas-sidebar", 4, "ngIf"], [1, "xlate-filterslyt-w", "text-end", "m-1"], [1, "xlate", 3, "href"], [1, "maincol", "col-12", "overflow-auto", "position-relative", 3, "ngClass"], ["id", "offcanvas-sidebar", "tabindex", "-1", 1, "offcanvas-xl", "offcanvas-end", "flex-fill", "overflow-auto", "bg-white", "border", "border-gray-200", "rounded", "m-0", "m-sm-3", "m-xl-0"], ["type", "button", "data-bs-toggle", "offcanvas", "data-bs-target", "#offcanvas-sidebar", "aria-controls", "offcanvas-sidebar", 1, "avatar", "avatar-icon", "avatar-md", "z-3", "avatar-rounded", "bg-gray-100", "text-gray-600", "me-2", "me-sm-4", "mt-2", "end-0", "d-xl-none", "position-absolute", "sidebar-offcanvas-trigger"], [3, "icon", "size"]],
      template: function JanusManagerTemplatesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, JanusManagerTemplatesComponent_ng_template_0_Template, 6, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, JanusManagerTemplatesComponent_ng_template_2_Template, 1, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, JanusManagerTemplatesComponent_ng_template_4_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        }
      },
      dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i1$7.RouterOutlet, JanusSVGIconComponent, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusManagerTemplatesComponent, [{
    type: Component,
    args: [{
      selector: 'janus-manager-templates',
      standalone: false,
      template: "<ng-template #routerOutlet let-isForm=\"isForm\">\n    <div class=\"module d-flex flex-column w-100 h-100\">\n        <ng-container *ngIf=\"tabs.template\">\n            <ng-container *ngTemplateOutlet=\"tabs.template; context: tabs.context\"></ng-container>\n        </ng-container>\n        <div id=\"main-content\" class=\"content minh-0 janus-radial-accent-bg h-100 w-100\">\n            <div class=\"innercontent d-flex flex-column h-100\">\n                @if (isForm) {\n                    <ng-container *ngTemplateOutlet=\"form\"></ng-container>\n                } @else {\n                    <router-outlet></router-outlet>\n                }\n            </div>\n        </div>\n    </div>\n</ng-template>\n\n<ng-template #wrappedForm>\n    <ng-container *ngTemplateOutlet=\"routerOutlet; context: {isForm: true}\"></ng-container>\n</ng-template>\n\n<ng-template #form>\n    <ng-container *ngIf=\"!loading\">\n        <ng-container *ngIf=\"alerts.template\">\n            <ng-container *ngTemplateOutlet=\"alerts.template; context: alerts.context\"></ng-container>\n        </ng-container>\n        <div class=\"d-flex flex-column h-100 overflow-auto flex-fill\">\n\n            <div class=\"xlate-filterslyt-w text-end m-1\" *ngIf=\"translationLink && inTranslationMode()\">\n                <a [href]=\"translationLink.link\" class=\"xlate\">{{translationLink.label}}</a>\n            </div>\n    \n            <ng-container #formButtons></ng-container>\n            <ng-container *ngIf=\"buttons.template\">\n                <div [class]=\"buttonSetStyles\">\n                    <ng-container *ngTemplateOutlet=\"buttons.template; context: buttons.context\"></ng-container>\n                </div>\n            </ng-container>\n            <div class=\"content-columns mt-0 mt-sm-2 mt-xl-3 mb-0\" [ngClass]=\"{ 'mb-sm-2 mb-xl-3': config.paddingBottom }\">\n                <main *ngIf=\"main.template\" class=\"maincol col-12 overflow-auto position-relative\" [ngClass]=\"{ 'rounded': config.paddingBottom, 'col-xl-7 col-xxl-8': aside.template, 'bg-white': !config.backgroundless, 'border-0': config.noBorder, 'p-0': config.noPadding}\" [attr.tabindex]=\"config.focusableContentContainer ? 0 : null\">\n                    <ng-container *ngTemplateOutlet=\"main.template; context: main.context\"></ng-container>\n                </main>\n                <aside *ngIf=\"aside.template\" id=\"offcanvas-sidebar\" class=\"offcanvas-xl offcanvas-end flex-fill overflow-auto bg-white border border-gray-200 rounded m-0 m-sm-3 m-xl-0\" tabindex=\"-1\">\n                    <ng-container *ngTemplateOutlet=\"aside.template; context: aside.context\"></ng-container>\n                </aside>\n\n                <button *ngIf=\"aside.template\"\n                    type=\"button\"\n                    class=\"avatar avatar-icon avatar-md z-3 avatar-rounded bg-gray-100 text-gray-600 me-2 me-sm-4 mt-2 end-0 d-xl-none position-absolute sidebar-offcanvas-trigger\"\n                    data-bs-toggle=\"offcanvas\"\n                    data-bs-target=\"#offcanvas-sidebar\"\n                    aria-controls=\"offcanvas-sidebar\"\n                    [attr.aria-label]=\"'misc.Open sidebar' | translate\"\n                >\n                    <janus-svg-icon [icon]=\"'layout-sidebar-right'\" [size]=\"'xl'\"></janus-svg-icon>\n                </button>\n            </div>\n        </div>\n    </ng-container>\n</ng-template>"
    }]
  }], () => [{
    type: i0.ViewContainerRef
  }, {
    type: JanusFormConfigService
  }], {
    formButtonsRef: [{
      type: ViewChild,
      args: ['formButtons', {
        read: ViewContainerRef
      }]
    }],
    janusFormRef: [{
      type: ViewChild,
      args: ['janusForm', {
        static: false
      }]
    }],
    routerOutletTemplate: [{
      type: ViewChild,
      args: ['routerOutlet', {
        static: true
      }]
    }],
    formTemplate: [{
      type: ViewChild,
      args: ['form', {
        static: true
      }]
    }],
    wrappedFormTemplate: [{
      type: ViewChild,
      args: ['wrappedForm', {
        static: true
      }]
    }],
    template: [{
      type: Input
    }],
    tabs: [{
      type: Input
    }],
    main: [{
      type: Input
    }],
    alerts: [{
      type: Input
    }],
    buttons: [{
      type: Input
    }],
    aside: [{
      type: Input
    }],
    config: [{
      type: Input
    }],
    translationLink: [{
      type: Input
    }],
    formRef: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusManagerTemplatesComponent, {
    className: "JanusManagerTemplatesComponent",
    filePath: "janus/components/templates/janus-manager-templates.component.ts",
    lineNumber: 13
  });
})();
class JanusLoadingSpinnerDirective {
  constructor(targetEl, renderer) {
    this.targetEl = targetEl;
    this.renderer = renderer;
    this.hostPosition = "relative";
    this.loadingSpinner = {
      loading: false,
      css: ''
    };
  }
  ngOnInit() {
    this.uid = "loading-spinner-" + Math.floor(Math.random() * 1000000);
    const loadingContainer = this.renderer.createElement("div");
    this.renderer.addClass(loadingContainer, this.loadingSpinner.loading ? "d-flex" : "d-none");
    this.renderer.addClass(loadingContainer, 'justify-content-center');
    this.renderer.addClass(loadingContainer, this.uid);
    if (this.loadingSpinner.css) {
      let cssList = this.loadingSpinner.css.split(' ');
      cssList.forEach(className => {
        this.renderer.addClass(loadingContainer, className);
      });
    }
    const spinnerContainer = this.renderer.createElement("div");
    this.renderer.addClass(spinnerContainer, "spinner-border");
    this.renderer.setAttribute(spinnerContainer, "role", "status");
    const a11yText = this.renderer.createElement("span");
    this.renderer.addClass(a11yText, "visually-hidden");
    this.renderer.setProperty(a11yText, 'innerHTML', "misc.Loading...");
    this.renderer.appendChild(spinnerContainer, a11yText);
    this.renderer.appendChild(loadingContainer, spinnerContainer);
    this.renderer.appendChild(this.targetEl.nativeElement, loadingContainer);
  }
  ngOnChanges(simpleChanges) {
    if (simpleChanges.loadingSpinner) {
      const container = this.targetEl.nativeElement;
      const div = container.querySelector("." + this.uid);
      if (div) {
        if (this.loadingSpinner.loading) {
          this.renderer.addClass(div, "d-flex");
          this.renderer.removeClass(div, "d-none");
        } else {
          this.renderer.addClass(div, "d-none");
          this.renderer.removeClass(div, "d-flex");
        }
      }
    }
  }
  static {
    this.ɵfac = function JanusLoadingSpinnerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusLoadingSpinnerDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: JanusLoadingSpinnerDirective,
      selectors: [["", "loadingSpinner", ""]],
      hostVars: 2,
      hostBindings: function JanusLoadingSpinnerDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleProp("position", ctx.hostPosition);
        }
      },
      inputs: {
        loadingSpinner: "loadingSpinner"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusLoadingSpinnerDirective, [{
    type: Directive,
    args: [{
      selector: "[loadingSpinner]",
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    hostPosition: [{
      type: HostBinding,
      args: ["style.position"]
    }],
    loadingSpinner: [{
      type: Input
    }]
  });
})();
const _c0$5 = a0 => ({
  loading: a0,
  css: "spinner-border-sm ms-2"
});
class JanusSessionTimeoutModalComponent {
  constructor(bsModalRef, http) {
    this.bsModalRef = bsModalRef;
    this.http = http;
    this.disableButtons = false;
  }
  keepSigned() {
    this.disableButtons = true;
    let payload = {
      ltarget: window.SUB_SYSTEM,
      ctracker: true
    };
    this.http.post('/utils/updateSessionTimeout.php', payload, {
      params: {
        mode: 'json'
      }
    }).subscribe(res => {
      this.bsModalRef.hide();
      this.disableButtons = false;
      if (!res.success) {
        this.signOut(true);
      }
    });
  }
  signOut(timeout = false) {
    window.location.href = "/logout.php?_to=" + timeout;
  }
  static {
    this.ɵfac = function JanusSessionTimeoutModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusSessionTimeoutModalComponent)(i0.ɵɵdirectiveInject(i1$3.BsModalRef), i0.ɵɵdirectiveInject(i2.HttpClient));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusSessionTimeoutModalComponent,
      selectors: [["janus-session-timeout-modal"]],
      standalone: false,
      decls: 17,
      vars: 17,
      consts: [[1, "modal-header"], ["tabindex", "-1", "ngbAutofocus", "", 1, "modal-title"], [1, "modal-body"], [1, "modal-footer"], [1, "buttonbar", "d-sm-flex", "d-grid", "gap-6", "w-100", "m-0", "justify-content-end"], [1, "btn", 3, "click", "disabled"], [1, "btn", "btn-primary", 3, "click", "disabled"], [3, "loadingSpinner"]],
      template: function JanusSessionTimeoutModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "h3", 1);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "div", 2)(5, "span");
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(8, "div", 3)(9, "div", 4)(10, "button", 5);
          i0.ɵɵlistener("click", function JanusSessionTimeoutModalComponent_Template_button_click_10_listener() {
            return ctx.signOut();
          });
          i0.ɵɵtext(11);
          i0.ɵɵpipe(12, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(13, "button", 6);
          i0.ɵɵlistener("click", function JanusSessionTimeoutModalComponent_Template_button_click_13_listener() {
            return ctx.keepSigned();
          });
          i0.ɵɵtext(14);
          i0.ɵɵpipe(15, "translate");
          i0.ɵɵelement(16, "div", 7);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 7, "misc.Still there?"));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 9, "misc.Your session is about to expire due to inactivity. Do you want to stay signed in?"));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("disabled", ctx.disableButtons);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 11, "misc.Sign out"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("disabled", ctx.disableButtons);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 13, "misc.Keep me signed in"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("loadingSpinner", i0.ɵɵpureFunction1(15, _c0$5, ctx.disableButtons));
        }
      },
      dependencies: [JanusLoadingSpinnerDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusSessionTimeoutModalComponent, [{
    type: Component,
    args: [{
      selector: 'janus-session-timeout-modal',
      standalone: false,
      template: "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" tabindex=\"-1\" ngbAutofocus>{{ 'misc.Still there?' | translate }}</h3>\n</div>\n<div class=\"modal-body\">\n    <span>{{ 'misc.Your session is about to expire due to inactivity. Do you want to stay signed in?' | translate}}</span>\n</div>\n<div class=\"modal-footer\">\n    <div class=\"buttonbar d-sm-flex d-grid gap-6 w-100 m-0 justify-content-end\">\n        <button class=\"btn\" (click)=\"signOut()\" [disabled]=\"disableButtons\">\n            {{ 'misc.Sign out' | translate}}\n        </button>\n        <button class=\"btn btn-primary\" (click)=\"keepSigned()\" [disabled]=\"disableButtons\">\n            {{ 'misc.Keep me signed in' | translate}}\n            <div [loadingSpinner]=\"{loading: disableButtons, css: 'spinner-border-sm ms-2'}\"></div>\n        </button>\n    </div>\n</div>"
    }]
  }], () => [{
    type: i1$3.BsModalRef
  }, {
    type: i2.HttpClient
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusSessionTimeoutModalComponent, {
    className: "JanusSessionTimeoutModalComponent",
    filePath: "janus/janus-session-timeout-modal.component.ts",
    lineNumber: 13
  });
})();
class JanusSessionTimeoutInterceptor extends SessionTimeoutInterceptor {
  constructor(modalService) {
    super();
    this.modalService = modalService;
  }
  openExpiringModal() {
    const initialState = {
      class: 'modal-md',
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.modalService.show(JanusSessionTimeoutModalComponent, initialState);
  }
  static {
    this.ɵfac = function JanusSessionTimeoutInterceptor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusSessionTimeoutInterceptor)(i0.ɵɵinject(i1$3.BsModalService));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: JanusSessionTimeoutInterceptor,
      factory: JanusSessionTimeoutInterceptor.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusSessionTimeoutInterceptor, [{
    type: Injectable
  }], () => [{
    type: i1$3.BsModalService
  }], null);
})();
const _c0$4 = ["toastElement"];
function ToastComponent_ng_container_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 11);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const alert_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-" + ctx_r1.alertIcon(alert_r1), null, "xlink");
  }
}
function ToastComponent_ng_container_1_p_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 15);
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const alert_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 1, alert_r1.title), i0.ɵɵsanitizeHtml);
  }
}
function ToastComponent_ng_container_1_p_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 12);
    i0.ɵɵtemplate(1, ToastComponent_ng_container_1_p_6_ng_container_1_Template, 3, 3, "ng-container", 13);
    i0.ɵɵelement(2, "span", 14);
    i0.ɵɵpipe(3, "safeHtml");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const alert_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", alert_r1.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(3, 2, alert_r1.message), i0.ɵɵsanitizeHtml);
  }
}
function ToastComponent_ng_container_1_div_7_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 15);
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const alert_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 1, alert_r1.title), i0.ɵɵsanitizeHtml);
  }
}
function ToastComponent_ng_container_1_div_7_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "button", 19);
    i0.ɵɵlistener("click", function ToastComponent_ng_container_1_div_7_div_5_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext(2);
      const alert_r1 = ctx_r3.$implicit;
      const i_r5 = ctx_r3.index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleCallback(alert_r1, i_r5));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const alert_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(alert_r1.config.label);
  }
}
function ToastComponent_ng_container_1_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "p", 12);
    i0.ɵɵtemplate(2, ToastComponent_ng_container_1_div_7_ng_container_2_Template, 3, 3, "ng-container", 13);
    i0.ɵɵelement(3, "span", 14);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ToastComponent_ng_container_1_div_7_div_5_Template, 3, 1, "div", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const alert_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", alert_r1.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 3, alert_r1.message), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", alert_r1.config);
  }
}
function ToastComponent_ng_container_1_div_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "button", 21);
    i0.ɵɵlistener("click", function ToastComponent_ng_container_1_div_8_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const alert_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.removeBSAlert(alert_r1.id));
    });
    i0.ɵɵelementEnd()();
  }
}
function ToastComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3, 0)(3, "div", 4);
    i0.ɵɵtemplate(4, ToastComponent_ng_container_1_div_4_Template, 3, 1, "div", 5);
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵtemplate(6, ToastComponent_ng_container_1_p_6_Template, 4, 4, "p", 7)(7, ToastComponent_ng_container_1_div_7_Template, 6, 5, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, ToastComponent_ng_container_1_div_8_Template, 2, 0, "div", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const alert_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("toast align-items-center text-white border-0 fade mb-2 ", ctx_r1.cssClass(alert_r1), "");
    i0.ɵɵattribute("id", alert_r1.id);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.alertIcon(alert_r1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !alert_r1.config);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", alert_r1.config);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", alert_r1.dismissable);
  }
}
class ToastComponent extends ToastAlertComponent {
  constructor(toastAlertService) {
    super(toastAlertService);
    this.toastAlertService = toastAlertService;
    this.assetsPath = '/app/assets/';
    this.position = 'top-right';
    this.alerts = [];
    this.alertToasts = [];
    this.customToastAlertPosition = false;
    this.customToastAlertPositionClasses = "";
    this.cd = inject(ChangeDetectorRef);
  }
  ngOnInit() {
    this.getAlert();
  }
  getAlert() {
    this.toastAlertService.getAlert().subscribe(alert => {
      this.customToastAlertPosition = false;
      if (!alert.message) {
        this.alerts = [];
        return;
      }
      if (alert.position) {
        this.customToastAlertPosition = true;
        this.customToastAlertPositionClasses = this.cssPosition(alert.position);
      }
      alert.id = this.getAlertId();
      this.alerts.push(alert);
      this.cd.detectChanges();
      setTimeout(() => {
        this.toastEls.forEach((toast, index) => {
          const toastElement = toast.nativeElement;
          if (!toastElement.classList.contains('show') && !this.alertToasts.some(t => t._element === toastElement)) {
            let alertToast = new Toast(toastElement, alert.timer ? {
              delay: alert.timer
            } : {
              autohide: false
            });
            this.alertToasts.push(alertToast);
            alertToast.show();
            toastElement.addEventListener('hidden.bs.toast', e => {
              this.alerts = this.alerts.filter(a => a.id !== e.target.id);
              this.alertToasts = this.alertToasts.filter(a => a._element.id !== e.target.id);
              this.cd.detectChanges();
            }, {
              once: true
            });
          }
        });
      });
    });
  }
  handleCallback(alert, index) {
    if (alert.config.callbackFn instanceof Function) {
      if (alert.config.objectId) {
        alert.config.callbackFn(alert.config.objectId);
      } else {
        alert.config.callbackFn();
      }
    }
    this.removeBSAlert(alert.id);
  }
  cssPosition(position) {
    switch (position) {
      case 'top-center':
        return 'top-0 start-50 translate-middle-x';
      case 'top-left':
        return 'top-0 start-0';
      case 'top-right':
        return 'top-0 end-0';
      case 'bottom-right':
        return 'bottom-0 end-0';
      case 'bottom-right-actions':
        return 'bottom-0 end-0 mb-5';
      case 'bottom-left':
        return 'bottom-0 start-0';
    }
    return '';
  }
  cssClass(alert) {
    if (!alert) {
      return;
    }
    switch (alert.type) {
      case ToastAlertType.Success:
        return 'bg-success';
      case ToastAlertType.Error:
        return 'bg-danger';
      case ToastAlertType.Info:
        return 'bg-info';
      case ToastAlertType.Warning:
        return 'bg-warning';
      case ToastAlertType.Neutral:
        return 'bg-dark';
    }
  }
  alertIcon(alert) {
    if (!alert) {
      return;
    }
    switch (alert.type) {
      case ToastAlertType.Success:
        return 'circle-check';
      case ToastAlertType.Error:
        return 'alert-circle';
      case ToastAlertType.Info:
        return 'info-circle';
      case ToastAlertType.Warning:
        return 'alert-triangle';
      case ToastAlertType.Neutral:
        return '';
    }
  }
  removeBSAlert(id) {
    let index = this.alerts.findIndex(alert => alert.id === id);
    if (index !== -1) {
      const toastElement = document.getElementById(id);
      if (toastElement && this.alertToasts[index]) {
        // Use the Bootstrap Toast hide method
        this.alertToasts[index].hide();
      } else {
        // If the element or Toast instance doesn't exist, just remove from our arrays
        this.alertToasts.splice(index, 1);
        this.alerts.splice(index, 1);
      }
    }
  }
  getAlertId() {
    return `janus-toast-${this.getUID()}`;
  }
  getUID() {
    const UIDs = this.alerts.filter(alert => !!alert.id).map(alert => alert.id);
    const UID = (new Date().getTime() * Math.random()).toString(36).replace('.', '');
    return !UIDs.includes(UID) ? UID : this.getUID();
  }
  onJanusToastEvent(e) {
    const detail = e.detail;
    const {
      type = 'success',
      message = '',
      timer = 4000,
      dismissable = true
    } = detail;
    this.toastAlertService[type](message, timer, dismissable);
  }
  static {
    this.ɵfac = function ToastComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastComponent)(i0.ɵɵdirectiveInject(ToastAlertService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: ToastComponent,
      selectors: [["janus-toast"]],
      viewQuery: function ToastComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$4, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toastEls = _t);
        }
      },
      hostBindings: function ToastComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("janus-toast", function ToastComponent_janus_toast_HostBindingHandler($event) {
            return ctx.onJanusToastEvent($event);
          });
        }
      },
      inputs: {
        assetsPath: "assetsPath",
        position: "position"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 4,
      consts: [["toastElement", ""], ["role", "alert", "aria-live", "assertive", "aria-relevant", "additions"], [4, "ngFor", "ngForOf"], ["aria-atomic", "true"], [1, "toast-body", "d-flex"], ["class", "flex-shrink-1 d-flex", 4, "ngIf"], [1, "flex-grow-1", "me-3"], ["class", "mb-0", 4, "ngIf"], ["class", "flex-fill", 4, "ngIf"], ["class", "flex-shrink-1 mt-n1 mb-n1", 4, "ngIf"], [1, "flex-shrink-1", "d-flex"], [1, "icon-lg-font-size", "me-2"], [1, "mb-0"], [4, "ngIf"], [3, "innerHTML"], [1, "fw-semibold", 3, "innerHTML"], [1, "flex-fill"], ["class", "flex-fill text-end", 4, "ngIf"], [1, "flex-fill", "text-end"], ["type", "button", 1, "btn-action", "bg-transparent", "text-white", "text-decoration-underline", "fw-normal", "ms-4", "border-0", "p-0", "pe-auto", 3, "click"], [1, "flex-shrink-1", "mt-n1", "mb-n1"], ["type", "button", "data-bs-dismiss", "toast", "aria-label", "Close", 1, "btn-close", "btn-close-white", 3, "click"]],
      template: function ToastComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵtemplate(1, ToastComponent_ng_container_1_Template, 9, 8, "ng-container", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMapInterpolate1("toaster mw-100 position-fixed px-3 py-2 m-16 ", !ctx.customToastAlertPosition ? ctx.cssPosition(ctx.position) : ctx.customToastAlertPositionClasses, "");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.alerts);
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, SafeHtmlPipe],
      styles: [".toaster[_ngcontent-%COMP%]{z-index:2000}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastComponent, [{
    type: Component,
    args: [{
      selector: 'janus-toast',
      template: `
    <div class="toaster mw-100 position-fixed px-3 py-2 m-16 {{!customToastAlertPosition ? cssPosition(position) : customToastAlertPositionClasses}}" role="alert" aria-live="assertive" aria-relevant="additions">
      <ng-container *ngFor="let alert of alerts; let i = index">
        <div
            #toastElement
            class="toast align-items-center text-white border-0 fade mb-2 {{cssClass(alert)}}"
            aria-atomic="true"
            [attr.id]="alert.id"
        >
          <div class="toast-body d-flex">
            <div class="flex-shrink-1 d-flex" *ngIf="alertIcon(alert)">
              <svg class="icon-lg-font-size me-2">
                <use [attr.xlink:href]="assetsPath + 'tabler-sprite-nostroke.svg#tabler-' + alertIcon(alert)"></use>
              </svg>
            </div>
            <div class="flex-grow-1 me-3">
              <p class="mb-0" *ngIf="!alert.config">
                <ng-container *ngIf="alert.title"><div class="fw-semibold" [innerHTML]="alert.title | safeHtml"></div></ng-container>
                <span [innerHTML]="alert.message | safeHtml"></span>
              </p>
              <div class="flex-fill" *ngIf="alert.config">
                <p class="mb-0">
                  <ng-container *ngIf="alert.title"><div class="fw-semibold" [innerHTML]="alert.title | safeHtml"></div></ng-container>
                  <span [innerHTML]="alert.message | safeHtml"></span>
                </p>
                <div class="flex-fill text-end" *ngIf="alert.config">
                  <button type="button" class="btn-action bg-transparent text-white text-decoration-underline fw-normal ms-4 border-0 p-0 pe-auto" (click)="handleCallback(alert, i)">{{alert.config.label}}</button>
                </div>
              </div>
            </div>
            <div class="flex-shrink-1 mt-n1 mb-n1" *ngIf="alert.dismissable">
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="toast" aria-label="Close" (click)="removeBSAlert(alert.id)"></button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  `,
      host: {
        '(janus-toast)': 'onJanusToastEvent($event)'
      },
      standalone: false,
      styles: [".toaster{z-index:2000}\n"]
    }]
  }], () => [{
    type: ToastAlertService
  }], {
    assetsPath: [{
      type: Input
    }],
    position: [{
      type: Input
    }],
    toastEls: [{
      type: ViewChildren,
      args: ['toastElement']
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ToastComponent, {
    className: "ToastComponent",
    filePath: "janus/components/toast/janus-toast.component.ts",
    lineNumber: 53
  });
})();
const _c0$3 = ["keywordFilterInput"];
const _c1$2 = ["moreFilterModal"];
const _c2$1 = a0 => ({
  "d-none": a0
});
const _c3$1 = a0 => ({
  number: a0
});
const _c4$1 = a0 => ({
  label: a0
});
const _forTrack0 = ($index, $item) => $item.name;
function JanusFiltersComponent_div_1_ng_container_3_ng_container_1_Conditional_1_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function JanusFiltersComponent_div_1_ng_container_3_ng_container_1_Conditional_1_Conditional_12_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      i0.ɵɵnextContext(4);
      const moreFilterModal_r6 = i0.ɵɵreference(7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openMoreFiltersModal(moreFilterModal_r6));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 23);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span", 24);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 25);
    i0.ɵɵtext(8);
    i0.ɵɵelementStart(9, "span", 26);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 6, "misc.Filters"));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-adjustments-horizontal", null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 8, "misc.Filters"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c2$1, ctx_r1.activeFiltersDisplayValues.length === 0));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.activeFiltersDisplayValues.length, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 10, "misc.active filters"));
  }
}
function JanusFiltersComponent_div_1_ng_container_3_ng_container_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13)(2, "label", 14);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 15);
    i0.ɵɵelement(4, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(5, "input", 16, 2);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementStart(8, "button", 17);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵlistener("click", function JanusFiltersComponent_div_1_ng_container_3_ng_container_1_Conditional_1_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r3);
      const controlConfig_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      ctx_r1.form.get(controlConfig_r4.name).reset();
      return i0.ɵɵresetView(ctx_r1.submitForm(ctx_r1.form));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(10, "svg", 15);
    i0.ɵɵelement(11, "use");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(12, JanusFiltersComponent_div_1_ng_container_3_ng_container_1_Conditional_1_Conditional_12_Template, 12, 14, "button", 18);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(13, "input", 19);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementStart(15, "label", 20);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(17, "svg", 21);
    i0.ɵɵelement(18, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const controlConfig_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("for", controlConfig_r4.id);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-search", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.form)("formControlName", controlConfig_r4.name);
    i0.ɵɵattribute("id", controlConfig_r4.id)("placeholder", i0.ɵɵpipeBind1(7, 14, "misc.Search"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c2$1, !ctx_r1.form.get(controlConfig_r4.name).value));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(9, 16, "misc.Clear"))("aria-describedby", controlConfig_r4.name);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-x", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.hasMoreFilters ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵattribute("value", i0.ɵɵpipeBind1(14, 18, "misc.Search"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(16, 20, "misc.Search"));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-search", null, "xlink");
  }
}
function JanusFiltersComponent_div_1_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFiltersComponent_div_1_ng_container_3_ng_container_1_Conditional_1_Template, 19, 24, "div", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const controlConfig_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional((controlConfig_r4.className == null ? null : controlConfig_r4.className.includes("keyword_search")) ? 1 : -1);
  }
}
function JanusFiltersComponent_div_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFiltersComponent_div_1_ng_container_3_ng_container_1_Template, 2, 1, "ng-container", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const controlGroup_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", controlGroup_r7.controls);
  }
}
function JanusFiltersComponent_div_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function JanusFiltersComponent_div_1_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      i0.ɵɵnextContext();
      const moreFilterModal_r6 = i0.ɵɵreference(7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openMoreFiltersModal(moreFilterModal_r6));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 23);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span", 24);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 28);
    i0.ɵɵtext(8);
    i0.ɵɵelementStart(9, "span", 26);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 6, "misc.Filters"));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-adjustments-horizontal", null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 8, "misc.Filters"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c2$1, ctx_r1.activeFiltersDisplayValues.length === 0));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.activeFiltersDisplayValues.length, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(11, 10, "misc.{number} active filters", i0.ɵɵpureFunction1(15, _c3$1, ctx_r1.activeFiltersDisplayValues.length)));
  }
}
function JanusFiltersComponent_div_1_Conditional_5_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "button", 31);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("click", function JanusFiltersComponent_div_1_Conditional_5_For_2_Template_button_click_3_listener() {
      const filter_r11 = i0.ɵɵrestoreView(_r10).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clearSingleFilter(filter_r11.name));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(5, "svg", 32);
    i0.ɵɵelement(6, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const filter_r11 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 4, filter_r11.filterLabel), ": ", filter_r11.value, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(4, 6, "misc.Remove {label} filter", i0.ɵɵpureFunction1(9, _c4$1, filter_r11.filterLabel + ": " + filter_r11.value)));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite.svg#tabler-x");
  }
}
function JanusFiltersComponent_div_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵrepeaterCreate(1, JanusFiltersComponent_div_1_Conditional_5_For_2_Template, 7, 11, "span", 29, _forTrack0);
    i0.ɵɵelementStart(3, "button", 30);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵlistener("click", function JanusFiltersComponent_div_1_Conditional_5_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearFilters());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.activeFiltersDisplayValues);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 2, "misc.Clear all filters"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, "misc.Clear"));
  }
}
function JanusFiltersComponent_div_1_ng_template_6_ng_container_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 44);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const control_r13 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("config", control_r13)("group", ctx_r1.form)("value", ctx_r1.storedFiltersValue[control_r13.name]);
  }
}
function JanusFiltersComponent_div_1_ng_template_6_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFiltersComponent_div_1_ng_template_6_ng_container_9_ng_container_1_Template, 2, 3, "ng-container", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const group_r14 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", group_r14.controls);
  }
}
function JanusFiltersComponent_div_1_ng_template_6_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 45);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function JanusFiltersComponent_div_1_ng_template_6_Conditional_14_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.submitAndSaveFilters(ctx_r1.form));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("value", i0.ɵɵpipeBind1(1, 2, "misc.save default"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "misc.Save Defaults"), " ");
  }
}
function JanusFiltersComponent_div_1_ng_template_6_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43)(1, "button", 46);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 47);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span", 26);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "ul", 48)(8, "li", 49);
    i0.ɵɵlistener("click", function JanusFiltersComponent_div_1_ng_template_6_Conditional_18_Template_li_click_8_listener() {
      i0.ɵɵrestoreView(_r17);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.submitAndSaveFilters(ctx_r1.form));
    });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-dots", null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 3, "misc.More"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 5, "misc.Save Defaults"), " ");
  }
}
function JanusFiltersComponent_div_1_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33)(1, "h3", 34);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 35);
    i0.ɵɵlistener("click", function JanusFiltersComponent_div_1_ng_template_6_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.modalRef == null ? null : ctx_r1.modalRef.hide());
    });
    i0.ɵɵelementStart(5, "span", 36);
    i0.ɵɵtext(6, "\u00D7");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 37)(8, "div", 38);
    i0.ɵɵtemplate(9, JanusFiltersComponent_div_1_ng_template_6_ng_container_9_Template, 2, 1, "ng-container", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 39)(11, "button", 40);
    i0.ɵɵlistener("click", function JanusFiltersComponent_div_1_ng_template_6_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r12);
      i0.ɵɵnextContext();
      const searchForm_r15 = i0.ɵɵreference(2);
      return i0.ɵɵresetView(searchForm_r15.ngSubmit.emit());
    });
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, JanusFiltersComponent_div_1_ng_template_6_Conditional_14_Template, 4, 6, "button", 41);
    i0.ɵɵelementStart(15, "button", 42);
    i0.ɵɵlistener("click", function JanusFiltersComponent_div_1_ng_template_6_Template_button_click_15_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearFilters());
    });
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, JanusFiltersComponent_div_1_ng_template_6_Conditional_18_Template, 11, 7, "div", 43);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 6, "misc.Filters"));
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", ctx_r1.modalFormControlGroup);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 8, "misc.Search"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.hasSaveDefault ? 14 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 10, "misc.Clear"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.hasSaveDefault ? 18 : -1);
  }
}
function JanusFiltersComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "form", 8, 0);
    i0.ɵɵlistener("ngSubmit", function JanusFiltersComponent_div_1_Template_form_ngSubmit_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.submitForm(ctx_r1.form));
    });
    i0.ɵɵtemplate(3, JanusFiltersComponent_div_1_ng_container_3_Template, 2, 1, "ng-container", 9)(4, JanusFiltersComponent_div_1_Conditional_4_Template, 12, 17, "button", 10)(5, JanusFiltersComponent_div_1_Conditional_5_Template, 7, 6, "div", 11)(6, JanusFiltersComponent_div_1_ng_template_6_Template, 19, 12, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.config.controlGroups);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.hasKeywordFilters && ctx_r1.hasMoreFilters ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.activeFiltersDisplayValues.length ? 5 : -1);
  }
}
function JanusFiltersComponent_div_2_ng_container_5_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 62);
  }
  if (rf & 2) {
    const controlConfig_r19 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", controlConfig_r19)("group", ctx_r1.form);
  }
}
function JanusFiltersComponent_div_2_ng_container_5_div_1_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 62);
  }
  if (rf & 2) {
    const controlConfig_r19 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", controlConfig_r19)("group", ctx_r1.form);
  }
}
function JanusFiltersComponent_div_2_ng_container_5_div_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusFiltersComponent_div_2_ng_container_5_div_1_ng_template_2_ng_container_0_Template, 1, 2, "ng-container", 63);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", ctx_r1.isFiltersVisible);
  }
}
function JanusFiltersComponent_div_2_ng_container_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵtemplate(1, JanusFiltersComponent_div_2_ng_container_5_div_1_div_1_Template, 1, 2, "div", 61)(2, JanusFiltersComponent_div_2_ng_container_5_div_1_ng_template_2_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const controlConfig_r19 = ctx.$implicit;
    const defaultFiltersTemplate_r20 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngClass", controlConfig_r19.type === "switch" ? "flex-grow-0" : "flex-grow-1");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", controlConfig_r19.className.includes("keyword_search") || controlConfig_r19.className.includes("initial_filter"))("ngIfElse", defaultFiltersTemplate_r20);
  }
}
function JanusFiltersComponent_div_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFiltersComponent_div_2_ng_container_5_div_1_Template, 4, 3, "div", 59);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const controlGroup_r21 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", controlGroup_r21.controls);
  }
}
function JanusFiltersComponent_div_2_div_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 55)(1, "button", 64);
    i0.ɵɵlistener("click", function JanusFiltersComponent_div_2_div_12_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r22);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearFilters());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "misc.clear"), " ");
  }
}
function JanusFiltersComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 50)(1, "form", 51);
    i0.ɵɵlistener("ngSubmit", function JanusFiltersComponent_div_2_Template_form_ngSubmit_1_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.submitForm(ctx_r1.form));
    });
    i0.ɵɵelementStart(2, "div", 52)(3, "div", 53)(4, "div", 54);
    i0.ɵɵtemplate(5, JanusFiltersComponent_div_2_ng_container_5_Template, 2, 1, "ng-container", 9);
    i0.ɵɵelementStart(6, "div", 55)(7, "button", 56);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(8, "svg", 57);
    i0.ɵɵelement(9, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(12, JanusFiltersComponent_div_2_div_12_Template, 4, 3, "div", 58);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.config.controlGroups);
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("href", ctx_r1.assetsPath + "tabler-sprite-nostroke.svg#tabler-search", null, "xlink");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 5, "misc.apply search"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showClearButton);
  }
}
class JanusFiltersComponent extends FiltersComponent {
  constructor(fb, backendService, bsModalService) {
    super(fb, backendService);
    this.fb = fb;
    this.backendService = backendService;
    this.bsModalService = bsModalService;
    this.assetsPath = '/app/assets/';
    this.showClearButton = false;
    this.isCsmApp = false;
    this.filteredCount = 0;
    this.hasMoreFilters = false;
    this.hasKeywordFilters = false;
    this.keywordFilterName = '';
    this.storedFiltersValue = {};
    this.activeFiltersDisplayValues = [];
  }
  ngOnInit() {
    this.isCsmApp = this.app_name === 'csm';
    super.ngOnInit();
    if (this.config && this.isCsmApp) {
      this.settingsForCSM();
      this.filteredCount = this.getSubmittedFiltersCount(this.filters);
    }
  }
  getFilterParams(filters) {
    return filters.map(filter => {
      if (this.isFilterActive(filter.value)) {
        switch (filter.type) {
          case 'aclookup':
          case 'hierpicklist':
            let params = `${filter.paramName}=${filter.value.id || filter.value.value}`;
            if (filter.multiple) {
              params = `${filter.paramName}=${filter.value.reduce(this.joinIds, '')}`;
            }
            return params;
          case 'range':
          case 'rangeDatePicker':
          case 'rangeTimePicker':
            let rangeValue = [filter.value['from'] || '', filter.value['to'] || ''];
            return `${filter.paramName}=` + rangeValue;
          case 'numberComparison':
            return `${filter.paramName}=${JSON.stringify(filter.value)}`;
          case 'location':
            let result = '';
            if (filter.value.value) {
              result += filter.value.value;
            }
            if (filter.value.data.indexOf('notFound') === -1) {
              result += "|" + filter.value.data;
            }
            if (filter.value.layer) {
              result += "|" + filter.value.layer;
            }
            return `${filter.paramName}=${result}`;
          default:
            return `${filter.paramName}=${filter.value}`;
        }
      } else {
        return null;
      }
    }).filter(Boolean);
  }
  settingsForCSM() {
    this.setActiveFilters();
    this.hasKeywordFilters = this.config.controlGroups.some(group => group.controls.some(control => {
      let isKeyword = control.className?.includes('keyword_search');
      if (isKeyword) {
        this.keywordFilterName = control.name;
      }
      return isKeyword;
    }));
    this.hasMoreFilters = this.config.controlGroups.some(group => group.controls.some(control => !control.className?.includes('keyword_search')));
  }
  clearFilters() {
    super.clearFilters();
    if (this.isCsmApp) {
      this.filteredCount = 0;
      this.storedFiltersValue = {};
      this.keywordFilterInput.nativeElement.value = '';
      this.modalRef?.hide();
      this.config.controlGroups.forEach(group => {
        group.controls.forEach(control => {
          control.value = null;
        });
      });
      this.setActiveFilters();
    }
  }
  clearSingleFilter(name) {
    this.form.get(name)?.reset();
    this.getConfig(name).value = null;
    this.submitForm();
  }
  submitAndSaveFilters(f) {
    super.submitAndSaveFilters(f);
    this.savingFilters();
    this.modalRef?.hide();
  }
  submitForm(f = this.form) {
    super.submitForm(f);
    this.savingFilters();
    this.setActiveFilters();
    this.modalRef?.hide();
  }
  setActiveFilters() {
    this.activeFiltersDisplayValues = [];
    const limitDisplayValues = 3;
    let active = this.filters.filter(f => this.isFilterActive(f.value));
    if (!active.length) return;
    for (let filter of active) {
      let config = this.getConfig(filter.name);
      if (config.options instanceof Observable) {
        config.options.subscribe(opts => {
          let labelsList = [];
          if (Array.isArray(filter.value)) {
            for (let i = 0; i < limitDisplayValues; i++) {
              let curVal = filter.value[i];
              if (curVal) {
                labelsList.push(opts.find(o => o.id == curVal).display);
              }
            }
            if (filter.value.length > limitDisplayValues) {
              labelsList.push(`+${filter.value.length - limitDisplayValues}`);
            }
          } else {
            labelsList = [opts.find(o => o.id == filter.value).display];
          }
          this.activeFiltersDisplayValues.push({
            name: filter.name,
            filterLabel: config.label,
            value: labelsList.join(', ')
          });
        });
        continue;
      }
      switch (config.type) {
        case 'rangeDatePicker':
          if (filter?.value.from && filter?.value.to) {
            this.activeFiltersDisplayValues.push({
              name: filter.name,
              filterLabel: config.label,
              value: `${filter.value.from} : ${filter.value.to}`
            });
          }
          break;
        case 'radio':
          const displayValue = config.options.find(c => c.id == filter.value).display;
          if (displayValue) {
            this.activeFiltersDisplayValues.push({
              name: filter.name,
              filterLabel: config.label,
              value: displayValue
            });
          }
          break;
      }
    }
  }
  getConfig(name) {
    for (let group of this.config.controlGroups) {
      let configResult = group.controls.find(c => c.name === name);
      if (configResult) {
        return configResult;
      }
    }
  }
  savingFilters() {
    if (this.isCsmApp) {
      this.filteredCount = this.getSubmittedFiltersCount(this.filters);
      this.storedFiltersValue = this.form.value;
      if (!this.modalRef) {
        return;
      }
      const keywordValue = this.form.get(this.keywordFilterName)?.value;
      this.keywordFilterInput.nativeElement.value = keywordValue;
    }
  }
  getSubmittedFiltersCount(list) {
    return _.filter(list, item => {
      const value = item.value;
      if (_.isNil(value) || value === '' || item.name === this.keywordFilterName) return false;
      if (_.isArray(value)) {
        return value.length > 0;
      }
      if (_.isObject(value)) {
        return _.some(value, val => !_.isNil(val) && val !== '');
      }
      return true;
    }).length;
  }
  openMoreFiltersModal(template) {
    this.modalFormControlGroup = _.cloneDeep(this.config.controlGroups);
    this.modalRef = this.bsModalService.show(template, {
      class: 'modal-lg modal-mobile modal-dialog-scrollable'
    });
  }
  static {
    this.ɵfac = function JanusFiltersComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusFiltersComponent)(i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(BackendService), i0.ɵɵdirectiveInject(i1$3.BsModalService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFiltersComponent,
      selectors: [["janus-filters"]],
      viewQuery: function JanusFiltersComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$3, 5);
          i0.ɵɵviewQuery(_c1$2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.keywordFilterInput = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.moreFilterModal = _t.first);
        }
      },
      inputs: {
        assetsPath: "assetsPath",
        showClearButton: "showClearButton"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 2,
      consts: [["searchForm", "ngForm"], ["moreFilterModal", ""], ["keywordFilterInput", ""], ["defaultFiltersTemplate", ""], [3, "ngSwitch"], ["class", "search-filters form", 4, "ngSwitchCase"], ["class", "search-filters form form-editmode", 4, "ngSwitchDefault"], [1, "search-filters", "form"], ["name", "search_filters", "method", "post", "role", "search", 1, "px-3", "px-xl-4", "pt-2", "pt-xl-3", 3, "ngSubmit", "formGroup"], [4, "ngFor", "ngForOf"], ["type", "button", "aria-describedby", "filter-nokeyword-badge", 1, "btn", "btn-outline-secondary", "input-group-text", "position-relative"], [1, "d-flex", "flex-wrap", "gap-1", "my-1", "d-none", "d-sm-flex"], [1, "input-group"], [1, "border-0", "form-control", "p-0", "rounded-end-0", "position-relative", "z-3"], [1, "position-absolute", "start-0", "h-100", "ms-2", "opacity-75", "d-none", "d-sm-block"], ["width", "1.2rem", "height", "1.2rem", 1, "h-100"], [1, "form-control", "d-inline-block", "rounded-end-0", "ps-sm-12", "pe-12", 3, "formGroup", "formControlName"], ["type", "button", 1, "btn", "position-absolute", "end-0", "btn-sm", "h-100", "opacity-75", "border-0", 3, "click", "ngClass"], ["type", "button", "aria-describedby", "filter-badge", 1, "btn", "btn-outline-secondary", "input-group-text", "position-relative"], ["id", "submit-filters-input", "type", "submit", "role", "button", 1, "btn", "btn-outline-secondary", "input-group-text", "rounded-end", "d-none", "d-sm-block"], ["for", "submit-filters-input", "role", "button", "tabindex", "0", 1, "btn", "btn-outline-secondary", "input-group-text", "d-sm-none", "z-1"], ["width", "1.2rem", "height", "1.25rem", 1, "h-100"], ["type", "button", "aria-describedby", "filter-badge", 1, "btn", "btn-outline-secondary", "input-group-text", "position-relative", 3, "click"], ["width", "1.2rem", "height", "1.25rem"], [1, "ms-1", "d-none", "d-sm-inline"], ["id", "filter-badge", 1, "position-absolute", "start-100", "translate-middle", "badge", "rounded-pill", "bg-primary", "fs-7", "py-1", "d-sm-none", 3, "ngClass"], [1, "visually-hidden"], ["type", "button", "aria-describedby", "filter-nokeyword-badge", 1, "btn", "btn-outline-secondary", "input-group-text", "position-relative", 3, "click"], ["id", "filter-nokeyword-badge", 1, "position-absolute", "top-0", "start-100", "translate-middle", "badge", "rounded-pill", "bg-primary", "fs-7", "py-1", "d-sm-none", 3, "ngClass"], [1, "d-flex", "align-items-center", "bg-white", "fs-5", "fw-medium", "border", "border-gray-300", "rounded-1", "text-gray-600", "minh-0", "p-0", "ps-2"], ["type", "button", 1, "btn", "btn-outline-secondary", "btn-sm", 3, "click"], ["type", "button", 1, "btn", "btn-sm", "p-1", 3, "click"], ["width", "1rem", "height", "1rem"], [1, "modal-header"], [1, "modal-title", "pull-left"], ["type", "button", "aria-label", "Close", 1, "btn-close", "close", "pull-right", 3, "click"], ["aria-hidden", "true", 1, "visually-hidden"], ["tabindex", "0", 1, "modal-body"], [1, "form", "columnar"], [1, "modal-footer", "bg-white"], ["name", "search_filters", 1, "btn", "btn-primary", 3, "click"], ["type", "button", "name", "search_filters", 1, "btn", "btn-outline-secondary", "d-none", "d-sm-inline-block", 3, "value"], ["type", "button", 1, "btn", "btn-outline-secondary", 3, "click"], ["ngbDropdown", "", "placement", "top-end", 1, "d-inline-block", "d-sm-none"], ["janusDynamicField", "", 3, "config", "group", "value"], ["type", "button", "name", "search_filters", 1, "btn", "btn-outline-secondary", "d-none", "d-sm-inline-block", 3, "click", "value"], ["type", "button", "id", "list-filters-more-dropdown-btn", "ngbDropdownToggle", "", 1, "btn", "btn-outline-secondary", "dropdown-toggle", "after-off"], ["width", "1.25rem", "height", "1.25rem"], ["id", "list-filters-more-dropdown", "ngbDropdownMenu", "", "aria-labelledby", "list-filters-more-dropdown-btn"], ["ngbDropdownItem", "", "role", "menuitem", 3, "click"], [1, "search-filters", "form", "form-editmode"], ["name", "search_filters", "method", "post", 1, "dynamic-form", "d-flex", "mx-3", "mw-100", 3, "ngSubmit", "formGroup"], [1, "card", "w-100", "mt-3"], [1, "card-body", "py-0", "px-3"], [1, "column-wrapper", "d-flex", "align-items-md-end", "flex-column", "flex-md-row", "gap-3", "py-3"], [1, "flex-shrink-1"], ["type", "submit", 1, "input-submit", "btn_search", "btn", "btn-outline-secondary", "fs-6", "text-capitalize", "text-nowrap", "w-100"], ["width", "1.125rem", "height", "1.125rem", 1, "mt-n1", "me-1"], ["class", "flex-shrink-1", 4, "ngIf"], [3, "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"], ["janusDynamicField", "", 3, "config", "group", 4, "ngIf", "ngIfElse"], ["janusDynamicField", "", 3, "config", "group"], ["janusDynamicField", "", 3, "config", "group", 4, "ngIf"], [1, "btn_reset", "btn", "btn-outline-secondary", "fs-6", "text-capitalize", "text-nowrap", "w-100", 3, "click"]],
      template: function JanusFiltersComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 4);
          i0.ɵɵtemplate(1, JanusFiltersComponent_div_1_Template, 8, 4, "div", 5)(2, JanusFiltersComponent_div_2_Template, 13, 7, "div", 6);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngSwitch", ctx.app_name);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "csm");
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgSwitch, i1.NgSwitchCase, i1.NgSwitchDefault, i2$1.ɵNgNoValidate, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, i1$4.NgbDropdown, i1$4.NgbDropdownToggle, i1$4.NgbDropdownMenu, i1$4.NgbDropdownItem, JanusDynamicFieldDirective, i1$1.TranslatePipe],
      styles: ["@media (max-width: 576px){.modal-mobile[_ngcontent-%COMP%]{margin:0}.modal-mobile[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{min-height:100vh;border:0;border-radius:0}}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFiltersComponent, [{
    type: Component,
    args: [{
      selector: 'janus-filters',
      standalone: false,
      template: "<div [ngSwitch]=\"app_name\">\n    <div *ngSwitchCase=\"'csm'\" class=\"search-filters form\">\n        <form name=\"search_filters\" class=\"px-3 px-xl-4 pt-2 pt-xl-3\" method=\"post\" [formGroup]=\"form\" (ngSubmit)=\"submitForm(form)\" #searchForm=\"ngForm\" role=\"search\">\n            <ng-container *ngFor=\"let controlGroup of config.controlGroups\">\n                <ng-container *ngFor=\"let controlConfig of controlGroup.controls\">\n                    @if (controlConfig.className?.includes('keyword_search')) {\n                        <div class=\"input-group\">\n                            <div class=\"border-0 form-control p-0 rounded-end-0 position-relative z-3\">\n                                <label [attr.for]=\"controlConfig.id\" class=\"position-absolute start-0 h-100 ms-2 opacity-75 d-none d-sm-block\">\n                                    <svg width=\"1.2rem\" height=\"1.2rem\" class=\"h-100\">\n                                        <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-search'\" />\n                                    </svg>\n                                </label>\n                                <input #keywordFilterInput\n                                       class=\"form-control d-inline-block rounded-end-0 ps-sm-12 pe-12\"\n                                       [formGroup]=\"form\"\n                                       [formControlName]=\"controlConfig.name\"\n                                       [attr.id]=\"controlConfig.id\"\n                                       [attr.placeholder]=\"'misc.Search' | translate\"\n                                />\n                                <button\n                                        type=\"button\"\n                                        class=\"btn position-absolute end-0 btn-sm h-100 opacity-75 border-0\"\n                                        [ngClass]=\"{ 'd-none': !form.get(controlConfig.name).value }\"\n                                        [attr.aria-label]=\"'misc.Clear'|translate\"\n                                        [attr.aria-describedby]=\"controlConfig.name\"\n                                        (click)=\"form.get(controlConfig.name).reset(); submitForm(form);\"\n                                >\n                                    <svg width=\"1.2rem\" height=\"1.2rem\" class=\"h-100\">\n                                        <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-x'\" />\n                                    </svg>\n                                </button>\n                            </div>\n\n                            @if (hasMoreFilters) {\n                                <button type=\"button\"\n                                    class=\"btn btn-outline-secondary input-group-text position-relative\"\n                                    [attr.aria-label]=\"'misc.Filters' | translate\"\n                                    aria-describedby=\"filter-badge\"\n                                    (click)=\"openMoreFiltersModal(moreFilterModal)\"\n                                >\n                                    <svg width=\"1.2rem\" height=\"1.25rem\">\n                                        <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-adjustments-horizontal'\" />\n                                    </svg>\n                                    <span class=\"ms-1 d-none d-sm-inline\">{{'misc.Filters' | translate}}</span>\n                                    <span id=\"filter-badge\"\n                                        class=\"position-absolute start-100 translate-middle badge rounded-pill bg-primary fs-7 py-1 d-sm-none\"\n                                        [ngClass]=\"{ 'd-none': activeFiltersDisplayValues.length === 0 }\"\n                                    >\n                                        {{activeFiltersDisplayValues.length}}\n                                        <span class=\"visually-hidden\">{{ 'misc.active filters'|translate }}</span>\n                                    </span>\n                                </button>\n                            }\n\n                            <input id=\"submit-filters-input\" type=\"submit\" class=\"btn btn-outline-secondary input-group-text rounded-end d-none d-sm-block\" [attr.value]=\"'misc.Search' | translate\" role=\"button\"/>\n                            <label for=\"submit-filters-input\" class=\"btn btn-outline-secondary input-group-text d-sm-none z-1\" role=\"button\" tabindex=\"0\" [attr.aria-label]=\"'misc.Search' | translate\">\n                                <svg width=\"1.2rem\" height=\"1.25rem\" class=\"h-100\">\n                                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-search'\" />\n                                </svg>\n                            </label>\n                        </div>\n                    }\n                </ng-container>\n            </ng-container>\n            \n            @if (!hasKeywordFilters && hasMoreFilters) {\n                <button type=\"button\" class=\"btn btn-outline-secondary input-group-text position-relative\" [attr.aria-label]=\"'misc.Filters' | translate\" aria-describedby=\"filter-nokeyword-badge\" (click)=\"openMoreFiltersModal(moreFilterModal)\">\n                    <svg width=\"1.2rem\" height=\"1.25rem\">\n                        <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-adjustments-horizontal'\" />\n                    </svg>\n                    <span class=\"ms-1 d-none d-sm-inline\">{{'misc.Filters' | translate}}</span>\n                        <span id=\"filter-nokeyword-badge\" class=\"position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary fs-7 py-1 d-sm-none\" [ngClass]=\"{ 'd-none': activeFiltersDisplayValues.length === 0 }\">\n                            {{activeFiltersDisplayValues.length}}\n                            <span class=\"visually-hidden\">{{'misc.{number} active filters' | translate: { number: activeFiltersDisplayValues.length } }}</span>\n                        </span>\n                </button>\n            }\n            @if (activeFiltersDisplayValues.length) {\n                <div class=\"d-flex flex-wrap gap-1 my-1 d-none d-sm-flex\">\n                    @for(filter of activeFiltersDisplayValues; track filter.name) {\n                        <span class=\"d-flex align-items-center bg-white fs-5 fw-medium border border-gray-300 rounded-1 text-gray-600 minh-0 p-0 ps-2\">\n                            {{filter.filterLabel | translate}}: {{filter.value}}\n                            <button type=\"button\" class=\"btn btn-sm p-1\" [attr.aria-label]=\"'misc.Remove {label} filter' | translate: { label: filter.filterLabel + ': ' + filter.value }\" (click)=\"clearSingleFilter(filter.name)\">\n                                <svg width=\"1rem\" height=\"1rem\">\n                                    <use [attr.href]=\"assetsPath + 'tabler-sprite.svg#tabler-x'\" />\n                                </svg>\n                            </button>\n                        </span>\n                    }\n                    <button type=\"button\" class=\"btn btn-outline-secondary btn-sm\" (click)=\"clearFilters()\" [attr.aria-label]=\"'misc.Clear all filters' | translate\">{{ 'misc.Clear' | translate }}</button>\n                </div>\n            }\n\n            <ng-template #moreFilterModal>\n                <div class=\"modal-header\">\n                    <h3 class=\"modal-title pull-left\">{{'misc.Filters' | translate}}</h3>\n                    <button type=\"button\" class=\"btn-close close pull-right\" aria-label=\"Close\" (click)=\"modalRef?.hide()\">\n                        <span aria-hidden=\"true\" class=\"visually-hidden\">&times;</span>\n                    </button>\n                </div>\n\n                <div class=\"modal-body\" tabindex=\"0\">\n                    <div class=\"form columnar\">\n                        <ng-container *ngFor=\"let group of modalFormControlGroup\">\n                            <ng-container *ngFor=\"let control of group.controls\">\n                                <ng-container janusDynamicField\n                                              [config]=\"control\"\n                                              [group]=\"form\"\n                                              [value]=\"storedFiltersValue[control.name]\"\n                                ></ng-container>\n                            </ng-container>\n                        </ng-container>\n                    </div>\n                </div>\n\n                <div class=\"modal-footer bg-white\">\n                    <button class=\"btn btn-primary\" name=\"search_filters\" (click)=\"searchForm.ngSubmit.emit()\">\n                        {{'misc.Search' | translate}}\n                    </button>\n                    \n                    @if (hasSaveDefault) {\n                        <button type=\"button\"\n                                class=\"btn btn-outline-secondary d-none d-sm-inline-block\"\n                                name=\"search_filters\"\n                                value=\"{{'misc.save default' | translate}}\"\n                                (click)=\"submitAndSaveFilters(form)\"\n                        >\n                            {{'misc.Save Defaults' | translate}}\n                        </button>\n                    }\n                    \n                    <button type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"clearFilters()\">\n                        {{'misc.Clear' | translate}}\n                    </button>\n\n                    @if (hasSaveDefault) {\n                        <div ngbDropdown \n                             class=\"d-inline-block d-sm-none\"\n                             placement=\"top-end\"\n                        >\n                            <button type=\"button\" \n                                    id=\"list-filters-more-dropdown-btn\" \n                                    class=\"btn btn-outline-secondary dropdown-toggle after-off\" \n                                    ngbDropdownToggle\n                            >\n                                <svg width=\"1.25rem\" height=\"1.25rem\">\n                                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-dots'\"></use>\n                                </svg>\n                                <span class=\"visually-hidden\">{{'misc.More' | translate}}</span>\n                            </button>\n                            <ul id=\"list-filters-more-dropdown\"\n                                ngbDropdownMenu\n                                aria-labelledby=\"list-filters-more-dropdown-btn\"\n                            >\n                                <li ngbDropdownItem role=\"menuitem\" (click)=\"submitAndSaveFilters(form)\">\n                                    {{'misc.Save Defaults' | translate}}\n                                </li>\n                            </ul>\n                        </div>\n                    }\n                </div>\n            </ng-template>\n        </form>\n    </div>\n    <div *ngSwitchDefault class=\"search-filters form form-editmode\">\n        <form name=\"search_filters\" method=\"post\" class=\"dynamic-form d-flex mx-3 mw-100\" [formGroup]=\"form\"\n              (ngSubmit)=\"submitForm(form);\">\n            <div class=\"card w-100 mt-3\">\n                <div class=\"card-body py-0 px-3\">\n                    <div class=\"column-wrapper d-flex align-items-md-end flex-column flex-md-row gap-3 py-3\">\n                        <ng-container *ngFor=\"let controlGroup of config.controlGroups\">\n                            <div *ngFor=\"let controlConfig of controlGroup.controls\" [ngClass]=\"controlConfig.type === 'switch' ? 'flex-grow-0' : 'flex-grow-1'\">\n                                <div janusDynamicField [config]=\"controlConfig\"\n                                                [group]=\"form\"\n                                                *ngIf=\"controlConfig.className.includes('keyword_search') || controlConfig.className.includes('initial_filter'); else defaultFiltersTemplate\"\n                                                ></div>\n                                <ng-template #defaultFiltersTemplate> \n                                        <ng-container janusDynamicField \n                                                    [config]=\"controlConfig\"\n                                                    [group]=\"form\" *ngIf=\"isFiltersVisible\"></ng-container>\n                                </ng-template>\n    \n                            </div>\n                        </ng-container>\n                        <div class=\"flex-shrink-1\">\n                            <button type=\"submit\" class=\"input-submit btn_search btn btn-outline-secondary fs-6 text-capitalize text-nowrap w-100\">\n                                <svg width=\"1.125rem\" height=\"1.125rem\" class=\"mt-n1 me-1\">\n                                    <use [attr.xlink:href]=\"assetsPath + 'tabler-sprite-nostroke.svg#tabler-search'\" />\n                                </svg> {{'misc.apply search' | translate}}\n                            </button>\n                        </div>\n                        <div *ngIf=\"showClearButton\" class=\"flex-shrink-1\">\n                            <button class=\"btn_reset btn btn-outline-secondary fs-6 text-capitalize text-nowrap w-100\" (click)=\"clearFilters()\">\n                                {{'misc.clear' | translate}}\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <!-- more filters will exist in the future -->\n        </form>\n    </div>\n</div>\n",
      styles: ["@media (max-width: 576px){.modal-mobile{margin:0}.modal-mobile .modal-content{min-height:100vh;border:0;border-radius:0}}\n"]
    }]
  }], () => [{
    type: i2$1.UntypedFormBuilder
  }, {
    type: BackendService
  }, {
    type: i1$3.BsModalService
  }], {
    assetsPath: [{
      type: Input
    }],
    showClearButton: [{
      type: Input
    }],
    keywordFilterInput: [{
      type: ViewChild,
      args: ['keywordFilterInput']
    }],
    moreFilterModal: [{
      type: ViewChild,
      args: ['moreFilterModal']
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFiltersComponent, {
    className: "JanusFiltersComponent",
    filePath: "janus/components/janus-filters/janus-filters.component.ts",
    lineNumber: 15
  });
})();
const _c0$2 = a0 => ({
  $implicit: a0
});
const _c1$1 = () => ["info", "warning"];
const _c2 = a0 => ({
  x: a0
});
const _c3 = a0 => ({
  "hint": a0
});
const _c4 = (a0, a1, a2) => ({
  "alert-info": a0,
  "alert-warning": a1,
  "alert-dismissible": a2
});
function JanusHelpComponent_ng_container_1_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusHelpComponent_ng_container_1_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusHelpComponent_ng_container_1_ng_container_2_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const help_r1 = ctx.$implicit;
    i0.ɵɵnextContext(3);
    const singleHint_r2 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", singleHint_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$2, help_r1));
  }
}
function JanusHelpComponent_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusHelpComponent_ng_container_1_ng_container_2_ng_container_1_Template, 2, 4, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", item_r3.value);
  }
}
function JanusHelpComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 5);
    i0.ɵɵtemplate(2, JanusHelpComponent_ng_container_1_ng_container_2_Template, 2, 1, "ng-container", 6);
    i0.ɵɵpipe(3, "keyvalue");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(3, 1, ctx_r3.groupedHints(), ctx_r3.originalOrder));
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_1_janus_svg_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-svg-icon", 26);
  }
  if (rf & 2) {
    i0.ɵɵproperty("icon", "info-circle")("rem", 1.5)("size", "")("cssClasses", "me-2 flex-shrink-0");
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_1_janus_svg_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-svg-icon", 26);
  }
  if (rf & 2) {
    i0.ɵɵproperty("icon", "alert-triangle")("rem", 1.5)("size", "")("cssClasses", "me-2 flex-shrink-0");
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵtemplate(2, JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_1_janus_svg_icon_2_Template, 1, 4, "janus-svg-icon", 22)(3, JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_1_janus_svg_icon_3_Template, 1, 4, "janus-svg-icon", 22);
    i0.ɵɵelementStart(4, "div", 23);
    i0.ɵɵelement(5, "span", 24)(6, "span", 25);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "janus-svg-icon", 26);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const type_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", type_r5 !== "warning");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", type_r5 === "warning");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r3.groupedHints()[type_r5][0].question, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r3.groupedHints()[type_r5][0].answer, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", "arrow-right")("rem", 1.5)("size", "")("cssClasses", "me-2 flex-shrink-0 rtl-invert");
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_2_janus_svg_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-svg-icon", 26);
  }
  if (rf & 2) {
    i0.ɵɵproperty("icon", "info-circle")("rem", 1.5)("size", "")("cssClasses", "me-2 flex-shrink-0");
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_2_janus_svg_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-svg-icon", 26);
  }
  if (rf & 2) {
    i0.ɵɵproperty("icon", "alert-triangle")("rem", 1.5)("size", "")("cssClasses", "me-2 flex-shrink-0");
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_2_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const type_r5 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.{x} Messages", i0.ɵɵpureFunction1(4, _c2, ctx_r3.groupedHints()[type_r5].length)), " ");
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_2_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 31);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const type_r5 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "misc.{x} Warnings", i0.ɵɵpureFunction1(4, _c2, ctx_r3.groupedHints()[type_r5].length)), " ");
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "span", 27);
    i0.ɵɵtemplate(3, JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_2_janus_svg_icon_3_Template, 1, 4, "janus-svg-icon", 22)(4, JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_2_janus_svg_icon_4_Template, 1, 4, "janus-svg-icon", 22)(5, JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_2_span_5_Template, 3, 6, "span", 28)(6, JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_2_span_6_Template, 3, 6, "span", 29);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "janus-svg-icon", 26);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const type_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", type_r5 !== "warning");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", type_r5 === "warning");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", type_r5 === "info");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", type_r5 === "warning");
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", "arrow-right")("rem", 1.5)("size", "")("cssClasses", "me-2 flex-shrink-0 rtl-invert");
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_button_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵtemplate(1, JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_1_Template, 8, 8, "ng-container", 4)(2, JanusHelpComponent_ng_container_2_ng_container_2_button_1_ng_container_2_Template, 8, 8, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const type_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("mb-0 w-100 alert alert-", type_r5, " d-flex justify-content-between");
    i0.ɵɵattribute("data-bs-toggle", "modal")("data-bs-target", "#" + type_r5 + "-hints-modal");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.groupedHints()[type_r5].length === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.groupedHints()[type_r5].length > 1);
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_h3_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "misc.Messages"));
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_h3_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "misc.Warnings"));
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_ng_container_12_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_ng_container_12_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusHelpComponent_ng_container_2_ng_container_2_ng_container_12_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const help_r6 = ctx.$implicit;
    i0.ɵɵnextContext(4);
    const singleHint_r2 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", singleHint_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$2, help_r6));
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusHelpComponent_ng_container_2_ng_container_2_ng_container_12_ng_container_1_Template, 2, 4, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const type_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.groupedHints()[type_r5]);
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "div");
    i0.ɵɵelement(2, "janus-svg-icon", 33);
    i0.ɵɵelementStart(3, "div", 34);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", "coffee")("rem", 5)("size", "")("cssClasses", "text-primary mb-4");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "misc.All caught up!"));
  }
}
function JanusHelpComponent_ng_container_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusHelpComponent_ng_container_2_ng_container_2_button_1_Template, 3, 7, "button", 11);
    i0.ɵɵelementStart(2, "div", 12)(3, "div", 13)(4, "div", 14)(5, "div", 15);
    i0.ɵɵtemplate(6, JanusHelpComponent_ng_container_2_ng_container_2_h3_6_Template, 3, 3, "h3", 4)(7, JanusHelpComponent_ng_container_2_ng_container_2_h3_7_Template, 3, 3, "h3", 4);
    i0.ɵɵelement(8, "button", 16);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 17)(11, "ul", 18);
    i0.ɵɵtemplate(12, JanusHelpComponent_ng_container_2_ng_container_2_ng_container_12_Template, 2, 1, "ng-container", 19)(13, JanusHelpComponent_ng_container_2_ng_container_2_ng_template_13_Template, 6, 7, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const type_r5 = ctx.$implicit;
    const emptyHints_r7 = i0.ɵɵreference(14);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.groupedHints()[type_r5].length >= 1);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", type_r5, "-hints-modal");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", type_r5 !== "warning");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", type_r5 === "warning");
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-bs-dismiss", "modal")("aria-label", i0.ɵɵpipeBind1(9, 9, "misc.Close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r3.groupedHints()[type_r5].length)("ngIfElse", emptyHints_r7);
  }
}
function JanusHelpComponent_ng_container_2_ng_container_5_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusHelpComponent_ng_container_2_ng_container_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusHelpComponent_ng_container_2_ng_container_5_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const help_r8 = ctx.$implicit;
    i0.ɵɵnextContext(3);
    const singleHint_r2 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", singleHint_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$2, help_r8));
  }
}
function JanusHelpComponent_ng_container_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 5);
    i0.ɵɵtemplate(2, JanusHelpComponent_ng_container_2_ng_container_5_ng_container_2_Template, 2, 4, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r9 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", item_r9.value);
  }
}
function JanusHelpComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵtemplate(2, JanusHelpComponent_ng_container_2_ng_container_2_Template, 15, 11, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 9)(4, "div", 10);
    i0.ɵɵtemplate(5, JanusHelpComponent_ng_container_2_ng_container_5_Template, 3, 1, "ng-container", 6);
    i0.ɵɵpipe(6, "keyvalue");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(5, _c1$1));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(6, 2, ctx_r3.groupedHints(), ctx_r3.originalOrder));
  }
}
function JanusHelpComponent_ng_template_3_li_0_janus_svg_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-svg-icon", 42);
  }
  if (rf & 2) {
    i0.ɵɵproperty("icon", "info-circle")("rem", 1.5)("size", "");
  }
}
function JanusHelpComponent_ng_template_3_li_0_janus_svg_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-svg-icon", 42);
  }
  if (rf & 2) {
    i0.ɵɵproperty("icon", "alert-triangle")("rem", 1.5)("size", "");
  }
}
function JanusHelpComponent_ng_template_3_li_0_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusHelpComponent_ng_template_3_li_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtemplate(1, JanusHelpComponent_ng_template_3_li_0_div_5_ng_container_1_Template, 1, 0, "ng-container", 44);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const help_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", help_r10.answer);
  }
}
function JanusHelpComponent_ng_template_3_li_0_ng_template_6_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelement(1, "span", 46);
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const help_r10 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 1, help_r10.answer), i0.ɵɵsanitizeHtml);
  }
}
function JanusHelpComponent_ng_template_3_li_0_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusHelpComponent_ng_template_3_li_0_ng_template_6_div_0_Template, 3, 3, "div", 45);
  }
  if (rf & 2) {
    const help_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r3.isTemplateRef(help_r10.answer));
  }
}
function JanusHelpComponent_ng_template_3_li_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47)(1, "button", 48);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("click", function JanusHelpComponent_ng_template_3_li_0_div_8_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r11);
      const help_r10 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.dismissHint(help_r10));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 1, "misc.Permanently dismiss this message"));
  }
}
function JanusHelpComponent_ng_template_3_li_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 36)(1, "div", 37)(2, "div", 38);
    i0.ɵɵtemplate(3, JanusHelpComponent_ng_template_3_li_0_janus_svg_icon_3_Template, 1, 3, "janus-svg-icon", 39)(4, JanusHelpComponent_ng_template_3_li_0_janus_svg_icon_4_Template, 1, 3, "janus-svg-icon", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, JanusHelpComponent_ng_template_3_li_0_div_5_Template, 2, 1, "div", 40)(6, JanusHelpComponent_ng_template_3_li_0_ng_template_6_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(8, JanusHelpComponent_ng_template_3_li_0_div_8_Template, 3, 3, "div", 41);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const textAnswer_r12 = i0.ɵɵreference(7);
    const help_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3, help_r10.system !== "manager"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(9, _c4, help_r10.type !== "warning", help_r10.type === "warning", help_r10.dismissible));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", help_r10.type !== "warning");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", help_r10.type === "warning");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.isTemplateRef(help_r10.answer))("ngIfElse", textAnswer_r12);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", help_r10.dismissible);
  }
}
function JanusHelpComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, JanusHelpComponent_ng_template_3_li_0_Template, 9, 13, "li", 35);
  }
  if (rf & 2) {
    const help_r10 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", !help_r10.dismissed);
  }
}
class JanusHelpComponent {
  constructor(helpService, winSize) {
    this.helpService = helpService;
    this.winSize = winSize;
    this.helpHints = model([]);
    this.enableCollapsed = input(false);
    this.groupedHints = computed(() => this.helpHints().reduce((grouped, currentHint) => {
      let currentType = !currentHint.type || currentHint.type === 'notice' ? 'info' : currentHint.type;
      grouped[currentType].push(currentHint);
      return grouped;
    }, {
      info: [],
      warning: [],
      error: []
    }));
    this.originalOrder = (a, b) => 0; // To keep obj order on keyvalue pipe
    effect(() => {
      this.enableCollapsed();
      janusHintsHandler(this.winSize);
    });
  }
  dismissHint(help) {
    help.dismissed = true;
    if (help.help_id) {
      this.helpService.dismissHint(help.help_id).subscribe();
    }
    this.helpHints.update(hints => {
      return hints.filter(help => !help.dismissed);
    });
  }
  isTemplateRef(value) {
    return value instanceof TemplateRef;
  }
  static {
    this.ɵfac = function JanusHelpComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusHelpComponent)(i0.ɵɵdirectiveInject(HelpService), i0.ɵɵdirectiveInject(JanusWindowSizeService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusHelpComponent,
      selectors: [["janus-help"]],
      inputs: {
        helpHints: [1, "helpHints"],
        enableCollapsed: [1, "enableCollapsed"]
      },
      outputs: {
        helpHints: "helpHintsChange"
      },
      standalone: false,
      decls: 5,
      vars: 4,
      consts: [["singleHint", ""], ["emptyHints", ""], ["textAnswer", ""], ["id", "all_user_hints"], [4, "ngIf"], [1, "list-unstyled", "mb-0"], [4, "ngFor", "ngForOf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["id", "hints-collapsed", 1, "d-none"], [1, "wrapper-hint-calc", "position-fixed", "top-0", "vh-100", "invisible", "top-100", 2, "height", "100svh !important"], [1, "hint-calc"], ["type", "button", 3, "class", 4, "ngIf"], ["tabindex", "-1", "aria-hidden", "true", 1, "modal", "fade", 3, "id"], [1, "modal-dialog", "modal-lg", "modal-fullscreen-sm-down"], [1, "modal-content"], [1, "modal-header"], [1, "btn-close"], [1, "modal-body"], [1, "list-unstyled"], [4, "ngIf", "ngIfElse"], ["type", "button"], [1, "d-flex", "minw-0"], [3, "icon", "rem", "size", "cssClasses", 4, "ngIf"], [1, "minw-0", "text-truncate", "text-truncate-children"], [1, "p-group", "fw-semibold", 3, "innerHTML"], [1, "p-group", 3, "innerHTML"], [3, "icon", "rem", "size", "cssClasses"], [1, "d-flex", "fw-semibold"], ["class", "hint-count-info", 4, "ngIf"], ["class", "hint-count-warning", 4, "ngIf"], [1, "hint-count-info"], [1, "hint-count-warning"], [1, "h-100", "d-flex", "flex-column", "justify-content-center", "align-items-center"], [1, "text-center", "d-block", 3, "icon", "rem", "size", "cssClasses"], [1, "fw-semibold"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], [1, "alert", "d-flex", 3, "ngClass"], [1, "flex-shrink-1", "d-flex", "me-2"], [3, "icon", "rem", "size", 4, "ngIf"], ["class", "flex-grow-1 p-group minw-0", 4, "ngIf", "ngIfElse"], ["class", "flex-shrink-1 mt-n1 mb-n1", 4, "ngIf"], [3, "icon", "rem", "size"], [1, "flex-grow-1", "p-group", "minw-0"], [4, "ngTemplateOutlet"], ["class", "flex-grow-1 p-group minw-0", 4, "ngIf"], [1, "hint_answer", 3, "innerHTML"], [1, "flex-shrink-1", "mt-n1", "mb-n1"], ["type", "button", "data-bs-dismiss", "alert", 1, "btn-close", 3, "click"]],
      template: function JanusHelpComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 3);
          i0.ɵɵtemplate(1, JanusHelpComponent_ng_container_1_Template, 4, 4, "ng-container", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(2, JanusHelpComponent_ng_container_2_Template, 7, 6, "ng-container", 4)(3, JanusHelpComponent_ng_template_3_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          let tmp_2_0;
          i0.ɵɵclassProp("d-none", ctx.enableCollapsed());
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", (tmp_2_0 = ctx.helpHints()) == null ? null : tmp_2_0.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.enableCollapsed());
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, JanusSVGIconComponent, i1.KeyValuePipe, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusHelpComponent, [{
    type: Component,
    args: [{
      selector: 'janus-help',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div id='all_user_hints' [class.d-none]=\"enableCollapsed()\">\n    <ng-container *ngIf=\"helpHints()?.length\">\n        <ul class=\"list-unstyled mb-0\">\n            <ng-container *ngFor=\"let item of groupedHints() | keyvalue: originalOrder;\">\n                <ng-container *ngFor=\"let help of item.value\">\n                    <ng-container *ngTemplateOutlet=\"singleHint; context: { $implicit: help }\"></ng-container>\n                </ng-container>\n            </ng-container>\n        </ul>\n    </ng-container>\n    </div>\n<ng-container *ngIf=\"enableCollapsed()\">\n    <div id=\"hints-collapsed\" class=\"d-none\">\n        <ng-container *ngFor=\"let type of ['info', 'warning']\">\n            <button *ngIf=\"groupedHints()[type].length >= 1\" type=\"button\" [attr.data-bs-toggle]=\"'modal'\" [attr.data-bs-target]=\"'#' + type + '-hints-modal'\" class=\"mb-0 w-100 alert alert-{{type}} d-flex justify-content-between\">\n                <ng-container *ngIf=\"groupedHints()[type].length === 1\">\n                    <div class=\"d-flex minw-0\">\n                        <janus-svg-icon *ngIf=\"type !== 'warning'\" [icon]=\"'info-circle'\" [rem]=\"1.5\" [size]=\"''\" [cssClasses]=\"'me-2 flex-shrink-0'\"></janus-svg-icon>\n                        <janus-svg-icon *ngIf=\"type === 'warning'\" [icon]=\"'alert-triangle'\" [rem]=\"1.5\" [size]=\"''\" [cssClasses]=\"'me-2 flex-shrink-0'\"></janus-svg-icon>\n                        <div class=\"minw-0 text-truncate text-truncate-children\">\n                            <span class=\"p-group fw-semibold\" [innerHTML]=\"groupedHints()[type][0].question\"></span>\n                            <span class=\"p-group\" [innerHTML]=\"groupedHints()[type][0].answer\"></span>\n                        </div>\n                    </div>\n                    <janus-svg-icon [icon]=\"'arrow-right'\" [rem]=\"1.5\" [size]=\"''\" [cssClasses]=\"'me-2 flex-shrink-0 rtl-invert'\"></janus-svg-icon>\n                </ng-container>\n                <ng-container *ngIf=\"groupedHints()[type].length > 1\">\n                    <div>\n                        <span class=\"d-flex fw-semibold\">\n                            <janus-svg-icon *ngIf=\"type !== 'warning'\" [icon]=\"'info-circle'\" [rem]=\"1.5\" [size]=\"''\" [cssClasses]=\"'me-2 flex-shrink-0'\"></janus-svg-icon>\n                            <janus-svg-icon *ngIf=\"type === 'warning'\" [icon]=\"'alert-triangle'\" [rem]=\"1.5\" [size]=\"''\" [cssClasses]=\"'me-2 flex-shrink-0'\"></janus-svg-icon>\n                            <span *ngIf=\"type === 'info'\" class=\"hint-count-info\">\n                                {{'misc.{x} Messages' | translate: { x: groupedHints()[type].length } }}\n                            </span>\n                            <span *ngIf=\"type === 'warning'\" class=\"hint-count-warning\">\n                                {{'misc.{x} Warnings' | translate: { x: groupedHints()[type].length } }}\n                            </span>\n                        </span>\n                    </div>\n                    <janus-svg-icon [icon]=\"'arrow-right'\" [rem]=\"1.5\" [size]=\"''\" [cssClasses]=\"'me-2 flex-shrink-0 rtl-invert'\"></janus-svg-icon>\n                </ng-container>\n            </button>\n            <div id=\"{{type}}-hints-modal\" class=\"modal fade\" tabindex=\"-1\" aria-hidden=\"true\">\n                <div class=\"modal-dialog modal-lg modal-fullscreen-sm-down\">\n                    <div class=\"modal-content\">\n                        <div class=\"modal-header\">\n                            <h3 *ngIf=\"type !== 'warning'\">{{'misc.Messages' | translate}}</h3>\n                            <h3 *ngIf=\"type === 'warning'\">{{'misc.Warnings' | translate}}</h3>\n                            <button class=\"btn-close\" [attr.data-bs-dismiss]=\"'modal'\" [attr.aria-label]=\"'misc.Close' | translate\"></button>\n                        </div>\n                        <div class=\"modal-body\">\n                            <ul class=\"list-unstyled\">\n                                <ng-container *ngIf=\"groupedHints()[type].length; else emptyHints\">\n                                    <ng-container *ngFor=\"let help of groupedHints()[type]\">\n                                        <ng-container *ngTemplateOutlet=\"singleHint; context: { $implicit: help }\"></ng-container>\n                                    </ng-container>\n                                </ng-container>\n                                <ng-template #emptyHints>\n                                    <div class=\"h-100 d-flex flex-column justify-content-center align-items-center\">\n                                        <div>\n                                            <janus-svg-icon [icon]=\"'coffee'\" [rem]=\"5\" [size]=\"''\" [cssClasses]=\"'text-primary mb-4'\" class=\"text-center d-block\"></janus-svg-icon>\n                                            <div class=\"fw-semibold\">{{'misc.All caught up!' | translate }}</div>\n                                        </div>\n                                    </div>\n                                </ng-template>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </ng-container>\n    </div>\n\n    <div class=\"wrapper-hint-calc position-fixed top-0 vh-100 invisible top-100\" style=\"height: 100svh !important;\">\n        <div class=\"hint-calc\">\n            <ng-container *ngFor=\"let item of groupedHints() | keyvalue: originalOrder;\">\n                <ul class=\"list-unstyled mb-0\">\n                    <ng-container *ngFor=\"let help of item.value\">\n                        <ng-container *ngTemplateOutlet=\"singleHint; context: { $implicit: help }\"></ng-container>\n                    </ng-container>\n                </ul>\n            </ng-container>\n        </div>\n    </div>\n</ng-container>\n\n<ng-template #singleHint let-help>\n    <li [ngClass]=\"{ 'hint': help.system !== 'manager'}\" *ngIf=\"!help.dismissed\">\n        <div \n            class=\"alert d-flex\"\n            [ngClass]=\"{ 'alert-info': help.type !== 'warning', 'alert-warning': help.type === 'warning', 'alert-dismissible': help.dismissible }\"\n        >\n            <div class=\"flex-shrink-1 d-flex me-2\">\n                <janus-svg-icon *ngIf=\"help.type !== 'warning'\" [icon]=\"'info-circle'\" [rem]=\"1.5\" [size]=\"''\"></janus-svg-icon>\n                <janus-svg-icon *ngIf=\"help.type === 'warning'\" [icon]=\"'alert-triangle'\" [rem]=\"1.5\" [size]=\"''\"></janus-svg-icon>\n            </div>\n            <div class=\"flex-grow-1 p-group minw-0\" *ngIf=\"isTemplateRef(help.answer); else textAnswer\">\n                <ng-container *ngTemplateOutlet=\"help.answer\"></ng-container>\n            </div>\n            <ng-template #textAnswer>\n                <div class=\"flex-grow-1 p-group minw-0\" *ngIf=\"!isTemplateRef(help.answer)\">\n                    <span [innerHTML]=\"help.answer | safeHtml\" class=\"hint_answer\"></span>\n                </div>\n            </ng-template>\n            <div *ngIf=\"help.dismissible\" class=\"flex-shrink-1 mt-n1 mb-n1\">\n                <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"alert\" [attr.aria-label]=\"'misc.Permanently dismiss this message' | translate\" (click)=\"dismissHint(help)\"></button>\n            </div>\n        </div>\n    </li>\n</ng-template>\n"
    }]
  }], () => [{
    type: HelpService
  }, {
    type: JanusWindowSizeService
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusHelpComponent, {
    className: "JanusHelpComponent",
    filePath: "janus/components/help/janus-help.component.ts",
    lineNumber: 13
  });
})();
function janusHintsHandler(winSize) {
  const placeHolderEl = document.getElementById('hint-placeholder');
  const hintsEl = document.getElementById('all_user_hints');
  const hintsCollapsedEl = document.getElementById('hints-collapsed');
  if (!hintsEl || !hintsCollapsedEl) return;
  const showAllHints = () => {
    hintsEl.classList.remove('d-none');
    hintsCollapsedEl.classList.add('d-none');
  };
  const showCollapsedHints = () => {
    hintsCollapsedEl.classList.remove('d-none');
    hintsEl.classList.add('d-none');
  };
  if (winSize.xsMax()) {
    showCollapsedHints();
    placeHolderEl?.remove();
    return;
  }
  const contentColEl = document.querySelector('.contentcol');
  const wrapperCalcEl = document.querySelector('.wrapper-hint-calc');
  if (!wrapperCalcEl) return;
  const hintCalcEl = wrapperCalcEl.querySelector('.hint-calc');
  const colWidth = contentColEl.offsetWidth;
  wrapperCalcEl.style.width = colWidth + 'px';
  if (hintCalcEl.offsetHeight >= wrapperCalcEl.offsetHeight * .25) {
    showCollapsedHints();
  } else {
    showAllHints();
  }
  placeHolderEl?.remove();
}
const _c0$1 = a0 => ({
  "rounded-pill": a0
});
class JanusBadgeComponent {
  constructor() {
    this.text = '';
    this.type = 'primary';
    this.tint = 'dark';
    this.rounded = false;
    this.cssClasses = '';
  }
  ngOnInit() {}
  static {
    this.ɵfac = function JanusBadgeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusBadgeComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusBadgeComponent,
      selectors: [["janus-badge"]],
      inputs: {
        text: "text",
        type: "type",
        tint: "tint",
        rounded: "rounded",
        cssClasses: "cssClasses"
      },
      standalone: false,
      decls: 2,
      vars: 5,
      consts: [[3, "ngClass"]],
      template: function JanusBadgeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "span", 0);
          i0.ɵɵtext(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$1, ctx.rounded));
          i0.ɵɵattribute("class", "badge bg-" + ctx.type + (ctx.type === "light" ? " text-dark" : " text-light") + " " + ctx.cssClasses);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.text, " ");
        }
      },
      dependencies: [i1.NgClass],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusBadgeComponent, [{
    type: Component,
    args: [{
      selector: 'janus-badge',
      template: `
    <span 
        [attr.class]="'badge bg-' + type + (type === 'light'? ' text-dark' : ' text-light') + ' ' + cssClasses" 
        [ngClass]="{'rounded-pill': rounded}">
            {{text}}
    </span>
  `,
      standalone: false
    }]
  }], () => [], {
    text: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    tint: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    cssClasses: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusBadgeComponent, {
    className: "JanusBadgeComponent",
    filePath: "janus/components/badge/janus-badge.component.ts",
    lineNumber: 14
  });
})();
class JanusModalService {
  constructor(bsModalService, document) {
    this.bsModalService = bsModalService;
    this.document = document;
    this.subscriptions = [];
    this.animationDelay = 150;
  }
  confirmDeleteObjectModal(data, callbackFn, message, closeBtn, header = '', isDeleteAll = false, person = false) {
    const type = person ? 'person' : isDeleteAll ? 'all' : 'it';
    const buttons = [{
      label: `No, keep ${type}`,
      css: 'btn-outline-secondary',
      action: modal => {
        modal.closeModal();
      }
    }, {
      label: `Yes, delete ${type}`,
      css: 'btn-primary',
      action: modal => {
        modal.closeModal();
        callbackFn(data);
      }
    }];
    this.openConfirmModal(message, closeBtn, header, buttons, 'end', {
      backdrop: true
    });
  }
  confirmModal(data, message, closeBtn, header, btnConfigs = [], buttonsOrientation = 'end', options = {}) {
    const buttons = [];
    btnConfigs.forEach((button, index) => {
      if (index === 0) {
        buttons.push({
          label: button?.label || 'No',
          css: button?.css || 'btn-outline-secondary',
          action: modal => {
            modal.closeModal();
            button?.callbackFn ? button?.callbackFn(data) : null;
          }
        });
      } else {
        buttons.push({
          label: button?.label || 'Yes',
          css: button?.css || 'btn-primary',
          action: modal => {
            modal.closeModal();
            button?.callbackFn ? button?.callbackFn(data) : null;
          }
        });
      }
    });
    this.openConfirmModal(message, closeBtn, header, buttons, buttonsOrientation, options);
  }
  showCustomModal(component, modalOptions) {
    this.modalRef = this.show(component || JanusModalComponent, modalOptions);
  }
  show(content, options) {
    const modalRef = this.bsModalService.show(content, {
      ...(options ?? {}),
      id: this.getModalId(options?.id)
    });
    const modalsContainers = this.document.querySelectorAll('modal-container');
    const modalContainer = modalsContainers.item(modalsContainers.length - 1);
    if (modalContainer) {
      modalContainer.setAttribute('id', modalRef.id);
      const modalFooter = modalContainer.querySelector('.modal-footer');
      if (modalFooter) {
        const buttons = modalFooter.querySelectorAll('button');
        buttons.forEach(button => {
          button.setAttribute('aria-controls', modalRef.id);
        });
      }
    }
    if (modalsContainers.length > 1 && options?.backdrop) {
      this.showModalBackdrop(modalRef, modalContainer, modalsContainers);
      modalRef.onHide?.pipe(take(1)).subscribe(() => this.hideModalBackdrop(modalRef, modalsContainers));
    }
    return modalRef;
  }
  async hide(modalRef) {
    if (!modalRef || !(modalRef instanceof BsModalRef)) {
      console.error('Provided value is not an instance of BsModalRef');
      return;
    }
    /**
     * Workaround to fix the known issue reported on ngx-bootstrap repository
     * https://github.com/valor-software/ngx-bootstrap/issues/6547
     *
     * 1. When using the `hide` method - either from BsModalRef or BsModalService - the animation is not working.
     *    Then, `show` class on `modal-container` tag has to be removed manually. This still works normally when modal is closed with ESC
     *    key or with a click outside - if the configuration allows any of those actions.
     *
     * 2. The manipulation of `body` tag - toggle `modal-open` css class and set `overflow-y` style to `hidden` - is handled on
     *    `ModalContainerComponent::_hide`, but when a modal is configured to not show a backdrop - main use case is with Actionbar modals -
     *    it stops working when the modal is closed using `hide` method. Then, both the class and styles should be removed manually.
     */
    const modalsContainers = this.document.querySelectorAll('modal-container');
    const modalContainer = this.document.getElementById(modalRef.id);
    /** 1. Restore the hide animation */
    modalContainer.classList.remove('show');
    await this.delay(this.animationDelay);
    modalRef.hide();
    let oneModalOpen = true;
    modalsContainers.forEach(element => {
      if (element.id !== modalContainer.id) {
        if (element.classList.contains('show')) {
          oneModalOpen = false;
        }
      }
    });
    /** 2. Restore scroll manually */
    if (modalsContainers.length === 1 || oneModalOpen) {
      this.document.body.classList.remove('modal-open');
      this.document.body.style.overflowY = '';
    }
  }
  openConfirmModal(message, closeBtn, header = '', buttons = [], buttonsOrientation = 'end', options = {}) {
    const initialState = {
      initialState: {
        config: {
          closeBtn: closeBtn,
          skipHeader: false,
          buttons: buttons,
          buttonsOrientation: buttonsOrientation,
          title: header
        },
        content: `<div class='text-muted'>${message}</div>`
      },
      class: 'modal-dialog modal-md',
      ...options
    };
    this.modalRef = this.show(JanusModalComponent, initialState);
  }
  async showModalBackdrop(modalRef, modalContainer, modalsContainers) {
    const backdropElement = this.document.createElement('div');
    const backdropZIndex = parseInt(window.getComputedStyle(modalsContainers.item(modalsContainers.length - 2)).zIndex) + 1;
    this.document.documentElement.classList.add('overflow-hidden');
    modalsContainers.item(modalsContainers.length - 2).classList.add('overflow-hidden');
    backdropElement.classList.add('modal-backdrop');
    backdropElement.classList.add('fade');
    backdropElement.classList.add('in');
    backdropElement.setAttribute('id', `${modalRef.id}-backdrop`);
    backdropElement.style.zIndex = backdropZIndex.toString();
    modalContainer.style.zIndex = (backdropZIndex + 1).toString();
    this.document.body.insertBefore(backdropElement, modalContainer);
    await this.delay(0);
    backdropElement.classList.add('show');
  }
  async hideModalBackdrop(modalRef, modalsContainers) {
    const backdropElement = this.document.getElementById(`${modalRef.id}-backdrop`);
    backdropElement.classList.remove('show');
    await this.delay(this.animationDelay);
    this.document.body.removeChild(backdropElement);
    this.document.documentElement.classList.remove('overflow-hidden');
    modalsContainers.item(modalsContainers.length - 2).classList.remove('overflow-hidden');
  }
  getModalId(id) {
    return `modal-${typeof id !== 'undefined' ? `${id}-` : ''}${new Date().getTime()}`;
  }
  delay(ms = 0) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  static {
    this.ɵfac = function JanusModalService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusModalService)(i0.ɵɵinject(i1$3.BsModalService), i0.ɵɵinject(DOCUMENT));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: JanusModalService,
      factory: JanusModalService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusModalService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$3.BsModalService
  }, {
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }], null);
})();
function JanusModalComponent_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.config.title);
  }
}
function JanusModalComponent_div_1_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function JanusModalComponent_div_1_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.closeModal());
    });
    i0.ɵɵelementEnd();
  }
}
function JanusModalComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, JanusModalComponent_div_1_div_1_Template, 2, 1, "div", 6)(2, JanusModalComponent_div_1_button_2_Template, 1, 0, "button", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.closeBtn);
  }
}
function JanusModalComponent_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function JanusModalComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, JanusModalComponent_div_2_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.modalTemplate);
  }
}
function JanusModalComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r0.content, i0.ɵɵsanitizeHtml);
  }
}
function JanusModalComponent_div_4_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 15);
    i0.ɵɵlistener("click", function JanusModalComponent_div_4_div_2_Template_button_click_1_listener() {
      const button_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleButtonAction(button_r4));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const button_r4 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("d-xs-block ", ctx_r0.config.buttonsClass, "");
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("btn w-100 ", button_r4.css, "");
    i0.ɵɵproperty("innerHtml", button_r4.label, i0.ɵɵsanitizeHtml);
  }
}
function JanusModalComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div");
    i0.ɵɵtemplate(2, JanusModalComponent_div_4_div_2_Template, 2, 7, "div", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r0.config.buttonsCustomClass ? ctx_r0.config.buttonsCustomClass : "buttonbar d-sm-flex d-grid gap-6 w-100 m-0 justify-content-" + ctx_r0.config.buttonsOrientation);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.buttons);
  }
}
class JanusModalComponent {
  constructor(bsModalRef, modalService) {
    this.bsModalRef = bsModalRef;
    this.modalService = modalService;
    this.config = {};
    this.content = '';
    this.prevAct = document.activeElement;
  }
  ngOnInit() {
    if (!this.config.buttonsOrientation) {
      this.config.buttonsOrientation = 'end';
    }
    this.onClose = new Subject();
  }
  handleButtonAction(button) {
    button.action(this);
  }
  closeModal() {
    this.onClose.next('Dismiss');
    this.modalService.hide(this.bsModalRef);
  }
  ngOnDestroy() {
    this.prevAct?.focus();
  }
  static {
    this.ɵfac = function JanusModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusModalComponent)(i0.ɵɵdirectiveInject(i1$3.BsModalRef), i0.ɵɵdirectiveInject(JanusModalService));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusModalComponent,
      selectors: [["janus-modal"]],
      inputs: {
        config: "config",
        content: "content",
        modalTemplate: "modalTemplate"
      },
      standalone: false,
      decls: 5,
      vars: 5,
      consts: [["trapFocus", ""], ["class", "modal-header", 4, "ngIf"], ["class", "modal-body", 4, "ngIf"], ["class", "modal-body", 3, "innerHtml", 4, "ngIf"], ["class", "modal-footer", 4, "ngIf"], [1, "modal-header"], ["class", "modal-title text-truncate", "role", "heading", 4, "ngIf"], ["type", "button", "class", "btn-close d-flex", "data-bs-dismiss", "modal", "aria-label", "Close", 3, "click", 4, "ngIf"], ["role", "heading", 1, "modal-title", "text-truncate"], ["type", "button", "data-bs-dismiss", "modal", "aria-label", "Close", 1, "btn-close", "d-flex", 3, "click"], [1, "modal-body"], [4, "ngTemplateOutlet"], [1, "modal-body", 3, "innerHtml"], [1, "modal-footer"], [3, "class", 4, "ngFor", "ngForOf"], ["type", "button", 3, "click", "innerHtml"]],
      template: function JanusModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, JanusModalComponent_div_1_Template, 3, 2, "div", 1)(2, JanusModalComponent_div_2_Template, 2, 1, "div", 2)(3, JanusModalComponent_div_3_Template, 1, 1, "div", 3)(4, JanusModalComponent_div_4_Template, 3, 3, "div", 4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.config.id);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.config.skipHeader);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.modalTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.content);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.buttons == null ? null : ctx.config.buttons.length);
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusModalComponent, [{
    type: Component,
    args: [{
      selector: 'janus-modal',
      standalone: false,
      template: "<div trapFocus [attr.id]=\"config.id\">\n    <div class=\"modal-header\" *ngIf=\"!config.skipHeader\">\n        <div class=\"modal-title text-truncate\" role=\"heading\" *ngIf=\"config.title\">{{config.title}}</div>\n        <button \n            type=\"button\"\n            class=\"btn-close d-flex\"\n            data-bs-dismiss=\"modal\"\n            aria-label=\"Close\"\n            *ngIf=\"config.closeBtn\"\n            (click)=\"closeModal()\"\n        >\n        </button>\n    </div>\n    <div class=\"modal-body\" *ngIf=\"modalTemplate\">\n        <ng-container *ngTemplateOutlet=\"modalTemplate\"></ng-container>\n    </div>\n    <div class=\"modal-body\" *ngIf=\"content\" [innerHtml]=\"content\">\n    </div>\n    <div class=\"modal-footer\" *ngIf=\"config.buttons?.length\">\n        <div [class]=\"config.buttonsCustomClass ? config.buttonsCustomClass : 'buttonbar d-sm-flex d-grid gap-6 w-100 m-0 justify-content-' + config.buttonsOrientation\">\n            <div class=\"d-xs-block {{config.buttonsClass}}\" *ngFor=\"let button of config.buttons\">\n                <button class=\"btn w-100 {{button.css}}\" type=\"button\" (click)=\"handleButtonAction(button)\" [innerHtml]=\"button.label\"></button>\n            </div>\n        </div>\n    </div>\n</div>\n"
    }]
  }], () => [{
    type: i1$3.BsModalRef
  }, {
    type: JanusModalService
  }], {
    config: [{
      type: Input
    }],
    content: [{
      type: Input
    }],
    modalTemplate: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusModalComponent, {
    className: "JanusModalComponent",
    filePath: "janus/components/modal/janus-modal.component.ts",
    lineNumber: 12
  });
})();
const _c0 = () => ({
  title: "Errors Detected:"
});
const _c1 = a0 => ({
  "mb-4": a0
});
function JanusModalFormComponent_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.modalConfig.title);
  }
}
function JanusModalFormComponent_div_1_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function JanusModalFormComponent_div_1_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.closeModal());
    });
    i0.ɵɵelementEnd();
  }
}
function JanusModalFormComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, JanusModalFormComponent_div_1_div_1_Template, 2, 1, "div", 11)(2, JanusModalFormComponent_div_1_button_2_Template, 1, 0, "button", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.modalConfig.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.modalConfig.closeBtn);
  }
}
function JanusModalFormComponent_janus_alert_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-alert", 15);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("type", "error")("icon", true)("content", i0.ɵɵpureFunction0(5, _c0))("list", true)("items", ctx_r0.errors);
  }
}
function JanusModalFormComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.modalConfig.parentLabel);
  }
}
function JanusModalFormComponent_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 18);
  }
  if (rf & 2) {
    const field_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r3)("group", ctx_r0.form)("value", ctx_r0.resource[field_r3.name])("assetsPath", ctx_r0.assetsPath);
  }
}
function JanusModalFormComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusModalFormComponent_div_5_ng_container_1_Template, 1, 4, "ng-container", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.controls);
  }
}
function JanusModalFormComponent_div_6_div_1_janus_subheading_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "janus-subheading", 24);
  }
  if (rf & 2) {
    const group_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("text", group_r4.groupTitle);
  }
}
function JanusModalFormComponent_div_6_div_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelement(1, "p", 26);
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1, !group_r4.controls.length && group_r4.read_only));
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 2, group_r4.groupBlurb), i0.ɵɵsanitizeHtml);
  }
}
function JanusModalFormComponent_div_6_div_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 18);
  }
  if (rf & 2) {
    const field_r5 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", field_r5)("group", ctx_r0.form)("value", ctx_r0.resource[field_r5.name])("assetsPath", ctx_r0.assetsPath);
  }
}
function JanusModalFormComponent_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtemplate(2, JanusModalFormComponent_div_6_div_1_janus_subheading_2_Template, 1, 1, "janus-subheading", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, JanusModalFormComponent_div_6_div_1_div_3_Template, 3, 6, "div", 23)(4, JanusModalFormComponent_div_6_div_1_ng_container_4_Template, 1, 4, "ng-container", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r4 = ctx.$implicit;
    const last_r6 = ctx.last;
    i0.ɵɵpropertyInterpolate("id", group_r4.groupId);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1, !last_r6));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", group_r4.groupTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r4.groupBlurb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", group_r4.controls);
  }
}
function JanusModalFormComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusModalFormComponent_div_6_div_1_Template, 5, 7, "div", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.config.controlGroups);
  }
}
function JanusModalFormComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "button", 28);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("click", function JanusModalFormComponent_div_9_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.closeModal());
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", (ctx_r0.cancelButton == null ? null : ctx_r0.cancelButton.ariaLabelFn) ? ctx_r0.cancelButton.ariaLabelFn(ctx_r0.getOutput(ctx_r0.form)) : i0.ɵɵpipeBind1(2, 3, (ctx_r0.cancelButton == null ? null : ctx_r0.cancelButton.aria_label) || ctx_r0.config.cancelLabel))("title", (ctx_r0.cancelButton == null ? null : ctx_r0.cancelButton.ariaLabelFn) ? ctx_r0.cancelButton.ariaLabelFn(ctx_r0.getOutput(ctx_r0.form)) : i0.ɵɵpipeBind1(3, 5, (ctx_r0.cancelButton == null ? null : ctx_r0.cancelButton.title) || ctx_r0.config.cancelLabel));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, ctx_r0.config.cancelLabel), " ");
  }
}
function JanusModalFormComponent_button_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r0.config.isProcessing ? true : null);
    i0.ɵɵattribute("aria-disabled", ctx_r0.config.isProcessing)("aria-label", (ctx_r0.submitButton == null ? null : ctx_r0.submitButton.ariaLabelFn) ? ctx_r0.submitButton.ariaLabelFn(ctx_r0.getOutput(ctx_r0.form)) : i0.ɵɵpipeBind1(1, 5, (ctx_r0.submitButton == null ? null : ctx_r0.submitButton.aria_label) || ctx_r0.config.submitLabel))("title", (ctx_r0.submitButton == null ? null : ctx_r0.submitButton.ariaLabelFn) ? ctx_r0.submitButton.ariaLabelFn(ctx_r0.getOutput(ctx_r0.form)) : i0.ɵɵpipeBind1(2, 7, (ctx_r0.submitButton == null ? null : ctx_r0.submitButton.title) || ctx_r0.config.submitLabel));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 9, ctx_r0.config.submitLabel), " ");
  }
}
class JanusModalFormComponent extends FormComponent {
  constructor(toastService, fb, globalService, janusFormConfigService, formErrorService, zone, _viewContainerRef, _route, translate, bsModalRef) {
    super(fb, globalService, formErrorService, zone, _viewContainerRef, _route, translate);
    this.toastService = toastService;
    this.fb = fb;
    this.globalService = globalService;
    this.janusFormConfigService = janusFormConfigService;
    this.formErrorService = formErrorService;
    this.zone = zone;
    this._viewContainerRef = _viewContainerRef;
    this._route = _route;
    this.translate = translate;
    this.bsModalRef = bsModalRef;
    this.modalConfig = {};
    this.callbacks = null;
    this.assetsPath = '/components/tabler-icons/';
    this.errors = [];
    this.destroyed$ = new Subject();
    this.prevAct = document.activeElement;
  }
  ngOnInit() {
    super.ngOnInit();
    if (typeof this.modalConfig.restorePrevActFocus === 'undefined') {
      this.modalConfig.restorePrevActFocus = true;
    }
  }
  ngAfterViewInit() {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl);
    });
    if (this.modalConfig.watchFormChanges) {
      this.watchFormChanges();
    }
  }
  ngOnDestroy() {
    if (this.modalConfig.restorePrevActFocus && this.prevAct) {
      this.prevAct.focus();
    }
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  getOutput(f) {
    let output = f.value;
    this.janusFormConfigService.preparePicklistValuesForSave(output, this.config);
    output.id = this.config.resourceID || null;
    return output;
  }
  closeModal() {
    this.bsModalRef.hide();
  }
  setErrors(errors) {
    this.errors = errors;
  }
  watchFormChanges() {
    this.formGroupDirective.ngSubmit.pipe(filter(() => !this.form.valid), takeUntil(this.destroyed$)).subscribe(() => this.showErrorMessages(true));
    this.form.statusChanges.pipe(filter(() => this.formGroupDirective.submitted), takeUntil(this.destroyed$)).subscribe(() => this.showErrorMessages(false));
  }
  showErrorMessages(showToastAlert) {
    const messages = this.janusFormConfigService.getFormErrors(this.config, this.form);
    this.errors = messages.map(message => message.text);
    if (showToastAlert) {
      this.toastService.custom(`${messages.length} required ${messages.length === 1 ? 'field has' : 'fields have'} not been completed.`, 5000, true, ToastAlertType.Error, 'bottom-right-actions');
    }
  }
  static {
    this.ɵfac = function JanusModalFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusModalFormComponent)(i0.ɵɵdirectiveInject(ToastAlertService), i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(GlobalService), i0.ɵɵdirectiveInject(JanusFormConfigService), i0.ɵɵdirectiveInject(FormErrorService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1$7.Router), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i1$3.BsModalRef));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusModalFormComponent,
      selectors: [["janus-modal-form"]],
      viewQuery: function JanusModalFormComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(FormGroupDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formGroupDirective = _t.first);
        }
      },
      inputs: {
        config: "config",
        modalConfig: "modalConfig",
        resource: "resource",
        callbacks: "callbacks",
        assetsPath: "assetsPath"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 12,
      vars: 11,
      consts: [["trapFocus", "", 1, "dynamic-form", "mw-100", 3, "ngSubmit", "id", "formGroup"], ["class", "modal-header", 4, "ngIf"], [1, "modal-body"], [3, "type", "icon", "content", "list", "items", 4, "ngIf"], [4, "ngIf"], [1, "modal-footer"], [1, "buttonbar", "d-sm-flex", "d-grid", "gap-6", "w-100", "m-0", "justify-content-sm-end"], ["class", "d-xs-block", 4, "ngIf"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", 1, "d-xs-block"], ["type", "submit", "class", "btn w-100 btn-primary", 3, "disabled", 4, "ngIf"], [1, "modal-header"], ["class", "modal-title", "role", "heading", 4, "ngIf"], ["type", "button", "class", "btn-close d-flex", "data-bs-dismiss", "modal", "aria-label", "Close", 3, "click", 4, "ngIf"], ["role", "heading", 1, "modal-title"], ["type", "button", "data-bs-dismiss", "modal", "aria-label", "Close", 1, "btn-close", "d-flex", 3, "click"], [3, "type", "icon", "content", "list", "items"], [1, "mb-4"], ["janusDynamicField", "", 3, "config", "group", "value", "assetsPath", 4, "ngFor", "ngForOf"], ["janusDynamicField", "", 3, "config", "group", "value", "assetsPath"], ["class", "fieldgroup", 3, "id", "ngClass", 4, "ngFor", "ngForOf"], [1, "fieldgroup", 3, "id", "ngClass"], [1, "mb-2"], [3, "text", 4, "ngIf"], ["class", "fg-blurb", 3, "ngClass", 4, "ngIf"], [3, "text"], [1, "fg-blurb", 3, "ngClass"], [1, "my-2", "form-text", 3, "innerHTML"], [1, "d-xs-block"], ["type", "button", "catch-click", "", 1, "btn", "w-100", 3, "click"], ["type", "submit", 1, "btn", "w-100", "btn-primary", 3, "disabled"]],
      template: function JanusModalFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "form", 0);
          i0.ɵɵlistener("ngSubmit", function JanusModalFormComponent_Template_form_ngSubmit_0_listener() {
            return ctx.form.valid ? ctx.submitForm(ctx.form) : ctx.markFormGroupTouched(ctx.form);
          });
          i0.ɵɵtemplate(1, JanusModalFormComponent_div_1_Template, 3, 2, "div", 1);
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵtemplate(3, JanusModalFormComponent_janus_alert_3_Template, 1, 6, "janus-alert", 3)(4, JanusModalFormComponent_ng_container_4_Template, 3, 1, "ng-container", 4)(5, JanusModalFormComponent_div_5_Template, 2, 1, "div", 4)(6, JanusModalFormComponent_div_6_Template, 2, 1, "div", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "div", 5)(8, "div", 6);
          i0.ɵɵtemplate(9, JanusModalFormComponent_div_9_Template, 6, 9, "div", 7);
          i0.ɵɵelementStart(10, "div", 8);
          i0.ɵɵtemplate(11, JanusModalFormComponent_button_11_Template, 5, 11, "button", 9);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵpropertyInterpolate("id", ctx.config.id);
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.modalConfig.skipHeader);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.errors.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.modalConfig.parentLabel);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.config.useGroupedForm);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.useGroupedForm);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.config.submitFn);
          i0.ɵɵadvance();
          i0.ɵɵattribute("aria-label", ctx.form.invalid ? "You may save once all the required fields are completed" : "")("data-bs-original-title", ctx.form.invalid ? "You may save once all the required fields are completed" : "");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.submitFn);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, CatchClickDirective, JanusDynamicFieldDirective, JanusAlertComponent, JanusSubheadingComponent, i1$1.TranslatePipe, SafeHtmlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusModalFormComponent, [{
    type: Component,
    args: [{
      selector: 'janus-modal-form',
      standalone: false,
      template: "<form\n    trapFocus\n    id=\"{{config.id}}\"\n    class=\"dynamic-form mw-100\"\n    [formGroup]=\"form\"\n    (ngSubmit)=\"form.valid ? submitForm(form) : markFormGroupTouched(form);\"\n>\n\n    <div class=\"modal-header\" *ngIf=\"!modalConfig.skipHeader\">\n        <div class=\"modal-title\" role=\"heading\" *ngIf=\"modalConfig.title\">{{modalConfig.title}}</div>\n        <button \n            type=\"button\"\n            class=\"btn-close d-flex\"\n            data-bs-dismiss=\"modal\"\n            aria-label=\"Close\"\n            *ngIf=\"modalConfig.closeBtn\"\n            (click)=\"closeModal()\"\n        >\n        </button>\n    </div>\n\n    <div class=\"modal-body\">\n        <janus-alert\n            *ngIf=\"errors.length\"\n            [type]=\"'error'\"\n            [icon]=\"true\"\n            [content]=\"{ title: 'Errors Detected:' }\"\n            [list]=\"true\"\n            [items]=\"errors\"\n        ></janus-alert>\n        <ng-container *ngIf=\"modalConfig.parentLabel\">\n            <p class=\"mb-4\">{{modalConfig.parentLabel}}</p>\n        </ng-container>\n        <div *ngIf=\"!config.useGroupedForm\">\n            <ng-container *ngFor=\"let field of config.controls\" janusDynamicField [config]=\"field\" [group]=\"form\" [value]=\"resource[field.name]\" [assetsPath]=\"assetsPath\"></ng-container>\n        </div>\n        <div *ngIf=\"config.useGroupedForm\">\n            <div *ngFor=\"let group of config.controlGroups; last as last\" id=\"{{group.groupId}}\" class=\"fieldgroup\" [ngClass]=\"{'mb-4': !last}\">\n                <div class=\"mb-2\">\n                    <janus-subheading *ngIf=\"group.groupTitle\" [text]=\"group.groupTitle\"></janus-subheading>\n                </div>\n                <div *ngIf=\"group.groupBlurb\" class=\"fg-blurb\" [ngClass]=\"{'mb-4': !group.controls.length && group.read_only}\">\n                    <p [innerHTML]=\"group.groupBlurb | safeHtml\" class=\"my-2 form-text\"></p>\n                </div>\n                <ng-container *ngFor=\"let field of group.controls\" janusDynamicField [config]=\"field\" [group]=\"form\" [value]=\"resource[field.name]\" [assetsPath]=\"assetsPath\"></ng-container>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"modal-footer\">\n        <div class=\"buttonbar d-sm-flex d-grid gap-6 w-100 m-0 justify-content-sm-end\">\n            <div class=\"d-xs-block\" *ngIf=\"config.submitFn\">\n                <button \n                    type=\"button\"\n                    class=\"btn w-100\"\n                    (click)=\"closeModal()\"\n                    [attr.aria-label]=\"cancelButton?.ariaLabelFn ? cancelButton.ariaLabelFn(getOutput(form)) : cancelButton?.aria_label || config.cancelLabel | translate\"\n                    [attr.title]=\"cancelButton?.ariaLabelFn ? cancelButton.ariaLabelFn(getOutput(form)) : cancelButton?.title || config.cancelLabel | translate\"\n                    catch-click\n                >\n                    {{config.cancelLabel | translate}}\n                </button>\n            </div>\n            <div \n                class=\"d-xs-block\" \n                [attr.aria-label]=\"form.invalid ? 'You may save once all the required fields are completed' : ''\"\n                data-bs-toggle=\"tooltip\"\n                data-bs-placement=\"top\"\n                [attr.data-bs-original-title]=\"form.invalid ? 'You may save once all the required fields are completed' : ''\">\n                <button \n                    *ngIf=\"config.submitFn\"\n                    type=\"submit\"\n                    class=\"btn w-100 btn-primary\"\n                    [disabled]=\"config.isProcessing ? true : null\"\n                    [attr.aria-disabled]=\"config.isProcessing\"\n                    [attr.aria-label]=\"submitButton?.ariaLabelFn ? submitButton.ariaLabelFn(getOutput(form)) : submitButton?.aria_label || config.submitLabel | translate\"\n                    [attr.title]=\"submitButton?.ariaLabelFn ? submitButton.ariaLabelFn(getOutput(form)) : submitButton?.title || config.submitLabel | translate\"\n                >\n                    {{config.submitLabel | translate}}\n                </button>\n            </div>\n        </div>\n    </div>\n</form>"
    }]
  }], () => [{
    type: ToastAlertService
  }, {
    type: i2$1.UntypedFormBuilder
  }, {
    type: GlobalService
  }, {
    type: JanusFormConfigService
  }, {
    type: FormErrorService
  }, {
    type: i0.NgZone
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i1$7.Router
  }, {
    type: i1$1.TranslateService
  }, {
    type: i1$3.BsModalRef
  }], {
    config: [{
      type: Input
    }],
    modalConfig: [{
      type: Input
    }],
    resource: [{
      type: Input
    }],
    callbacks: [{
      type: Input
    }],
    assetsPath: [{
      type: Input
    }],
    formGroupDirective: [{
      type: ViewChild,
      args: [FormGroupDirective]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusModalFormComponent, {
    className: "JanusModalFormComponent",
    filePath: "janus/components/modal/janus-modal-form.component.ts",
    lineNumber: 23
  });
})();
function JanusFormModalExtendedComponent_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 8);
  }
  if (rf & 2) {
    const field_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", field_r1)("group", ctx_r1.form)("value", ctx_r1.resource[field_r1.name]);
  }
}
function JanusFormModalExtendedComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormModalExtendedComponent_div_8_ng_container_1_Template, 1, 3, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.controls);
  }
}
function JanusFormModalExtendedComponent_div_9_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "h2");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const group_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(group_r3.groupTitle);
  }
}
function JanusFormModalExtendedComponent_div_9_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 8);
  }
  if (rf & 2) {
    const field_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("config", field_r4)("group", ctx_r1.form)("value", ctx_r1.resource[field_r4.name]);
  }
}
function JanusFormModalExtendedComponent_div_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, JanusFormModalExtendedComponent_div_9_div_1_div_1_Template, 3, 1, "div", 11)(2, JanusFormModalExtendedComponent_div_9_div_1_ng_container_2_Template, 1, 3, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r3 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("id", group_r3.groupId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r3.groupTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", group_r3.controls);
  }
}
function JanusFormModalExtendedComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JanusFormModalExtendedComponent_div_9_div_1_Template, 3, 3, "div", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.controlGroups);
  }
}
function JanusFormModalExtendedComponent_ng_container_11_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function JanusFormModalExtendedComponent_ng_container_11_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.cancel());
    });
    i0.ɵɵtext(1, "misc.Cancel");
    i0.ɵɵelementEnd();
  }
}
function JanusFormModalExtendedComponent_ng_container_11_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function JanusFormModalExtendedComponent_ng_container_11_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.cancel());
    });
    i0.ɵɵtext(1, "misc.Close");
    i0.ɵɵelementEnd();
  }
}
function JanusFormModalExtendedComponent_ng_container_11_button_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.submitLabel));
  }
}
function JanusFormModalExtendedComponent_ng_container_11_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function JanusFormModalExtendedComponent_ng_container_11_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.openEditForm());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.config.editLabel));
  }
}
function JanusFormModalExtendedComponent_ng_container_11_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function JanusFormModalExtendedComponent_ng_container_11_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleCallback(ctx_r1.config.unarchiveFn, "unarchiveWarning"));
    });
    i0.ɵɵtext(1, "misc.Unarchive");
    i0.ɵɵelementEnd();
  }
}
function JanusFormModalExtendedComponent_ng_container_11_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function JanusFormModalExtendedComponent_ng_container_11_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleCallback(ctx_r1.config.deleteFn, "deleteWarning"));
    });
    i0.ɵɵtext(1, "misc.Delete");
    i0.ɵɵelementEnd();
  }
}
function JanusFormModalExtendedComponent_ng_container_11_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function JanusFormModalExtendedComponent_ng_container_11_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleCallback(ctx_r1.config.archiveFn, "archiveWarning", ctx_r1.config.archiveValidationFn));
    });
    i0.ɵɵtext(1, "misc.Archive");
    i0.ɵɵelementEnd();
  }
}
function JanusFormModalExtendedComponent_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormModalExtendedComponent_ng_container_11_button_1_Template, 2, 0, "button", 13)(2, JanusFormModalExtendedComponent_ng_container_11_button_2_Template, 2, 0, "button", 13)(3, JanusFormModalExtendedComponent_ng_container_11_button_3_Template, 3, 3, "button", 14)(4, JanusFormModalExtendedComponent_ng_container_11_button_4_Template, 3, 3, "button", 15)(5, JanusFormModalExtendedComponent_ng_container_11_button_5_Template, 2, 0, "button", 13)(6, JanusFormModalExtendedComponent_ng_container_11_button_6_Template, 2, 0, "button", 13)(7, JanusFormModalExtendedComponent_ng_container_11_button_7_Template, 2, 0, "button", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.submitFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.submitFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.submitFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.editFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.unarchiveFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.deleteFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.archiveFn);
  }
}
function JanusFormModalExtendedComponent_ng_container_12_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function JanusFormModalExtendedComponent_ng_container_12_button_1_Template_button_click_0_listener() {
      const button_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(button_r12.onClick(ctx_r1.form, button_r12.action));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r12 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", button_r12.class);
    i0.ɵɵattribute("type", button_r12.type);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, button_r12.label));
  }
}
function JanusFormModalExtendedComponent_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, JanusFormModalExtendedComponent_ng_container_12_button_1_Template, 3, 5, "button", 19);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.customButtons);
  }
}
class JanusFormModalExtendedComponent extends JanusFormComponent {
  constructor(activeModal, _modalService, _viewContainerRef, fb, _route, translate, globalService, formErrorService, zone, janusFormConfigService, janusVersion) {
    super(fb, globalService, formErrorService, zone, _viewContainerRef, _route, translate, janusFormConfigService, janusVersion);
    this.activeModal = activeModal;
    this._modalService = _modalService;
    this._viewContainerRef = _viewContainerRef;
    this.fb = fb;
    this._route = _route;
    this.translate = translate;
    this.globalService = globalService;
    this.formErrorService = formErrorService;
    this.zone = zone;
    this.janusFormConfigService = janusFormConfigService;
    this.janusVersion = janusVersion;
    this.callbacks = null;
    this.config = null;
    this.janus = true;
  }
  ngOnInit() {
    this.form = this.createGroup();
  }
  static {
    this.ɵfac = function JanusFormModalExtendedComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusFormModalExtendedComponent)(i0.ɵɵdirectiveInject(i1$4.NgbActiveModal), i0.ɵɵdirectiveInject(i1$4.NgbModal), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i2$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(i1$7.Router), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(GlobalService), i0.ɵɵdirectiveInject(FormErrorService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(JanusFormConfigService), i0.ɵɵdirectiveInject('JANUS_VERSION', 8));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: JanusFormModalExtendedComponent,
      selectors: [["app-janus-form-modal-extended"]],
      hostVars: 2,
      hostBindings: function JanusFormModalExtendedComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap("modal-content");
        }
      },
      inputs: {
        modalId: "modalId",
        resource: "resource",
        callbacks: "callbacks",
        config: "config"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 13,
      vars: 12,
      consts: [[1, "modal-header"], ["id", "myModalLabel", 1, "mb-0"], ["type", "button", 1, "btn-close", 3, "click"], ["tabindex", "0", 1, "modal-body"], [1, "dynamic-form", 3, "ngSubmit", "id", "formGroup"], [4, "ngIf"], [1, "modal-footer"], ["janusDynamicField", "", 3, "config", "group", "value", 4, "ngFor", "ngForOf"], ["janusDynamicField", "", 3, "config", "group", "value"], ["class", "fieldgroup", 3, "id", 4, "ngFor", "ngForOf"], [1, "fieldgroup", 3, "id"], ["class", "fg-title", 4, "ngIf"], [1, "fg-title"], ["type", "button", "class", "btn btn-outline-secondary", "flow-btn", "", "translate", "", 3, "click", 4, "ngIf"], ["type", "submit", "class", "btn btn-primary", "flow-btn", "", 4, "ngIf"], ["type", "button", "class", "btn btn-outline-secondary", "flow-btn", "", 3, "click", 4, "ngIf"], ["type", "button", "flow-btn", "", "translate", "", 1, "btn", "btn-outline-secondary", 3, "click"], ["type", "submit", "flow-btn", "", 1, "btn", "btn-primary"], ["type", "button", "flow-btn", "", 1, "btn", "btn-outline-secondary", 3, "click"], ["flow-btn", "", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["flow-btn", "", 3, "click", "ngClass"]],
      template: function JanusFormModalExtendedComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "h3", 1);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "button", 2);
          i0.ɵɵpipe(5, "translate");
          i0.ɵɵlistener("click", function JanusFormModalExtendedComponent_Template_button_click_4_listener() {
            return ctx.activeModal.close();
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(6, "div", 3)(7, "form", 4);
          i0.ɵɵlistener("ngSubmit", function JanusFormModalExtendedComponent_Template_form_ngSubmit_7_listener() {
            return ctx.form.valid ? ctx.submitForm(ctx.form) : ctx.markFormGroupTouched(ctx.form);
          });
          i0.ɵɵtemplate(8, JanusFormModalExtendedComponent_div_8_Template, 2, 1, "div", 5)(9, JanusFormModalExtendedComponent_div_9_Template, 2, 1, "div", 5);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(10, "div", 6);
          i0.ɵɵtemplate(11, JanusFormModalExtendedComponent_ng_container_11_Template, 8, 7, "ng-container", 5)(12, JanusFormModalExtendedComponent_ng_container_12_Template, 2, 1, "ng-container", 5);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 8, ctx.config.title));
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 10, "misc.Close"));
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("id", ctx.config.id);
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.config.useGroupedForm);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.useGroupedForm);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.config.useCustomButtons);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.config.useCustomButtons);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i1$1.TranslateDirective, JanusDynamicFieldDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusFormModalExtendedComponent, [{
    type: Component,
    args: [{
      selector: 'app-janus-form-modal-extended',
      encapsulation: ViewEncapsulation.None,
      host: {
        '[class]': "'modal-content'"
      },
      standalone: false,
      template: "<div class=\"modal-header\">\n    <h3 id=\"myModalLabel\" class=\"mb-0\">{{config.title | translate}}</h3>\n    <button type=\"button\" class=\"btn-close\" (click)=\"activeModal.close()\" [attr.aria-label]=\"'misc.Close' | translate\"></button>\n</div>\n<div class=\"modal-body\" tabindex=\"0\">\n    <form\n            id=\"{{config.id}}\"\n            class=\"dynamic-form\"\n            [formGroup]=\"form\"\n            (ngSubmit)=\"form.valid ? submitForm(form) : markFormGroupTouched(form);\">\n        <div *ngIf=\"!config.useGroupedForm\">\n            <ng-container *ngFor=\"let field of config.controls\" janusDynamicField [config]=\"field\" [group]=\"form\" [value]=\"resource[field.name]\"></ng-container>\n        </div>\n        <div *ngIf=\"config.useGroupedForm\">\n            <div *ngFor=\"let group of config.controlGroups\" id=\"{{group.groupId}}\" class=\"fieldgroup\">\n                <div *ngIf=\"group.groupTitle\" class=\"fg-title\">\n                    <h2>{{group.groupTitle}}</h2>\n                </div>\n                <ng-container *ngFor=\"let field of group.controls\" janusDynamicField [config]=\"field\" [group]=\"form\" [value]=\"resource[field.name]\"></ng-container>\n            </div>\n        </div>\n    </form>\n</div>\n\n<div class=\"modal-footer\">\n    <ng-container *ngIf=\"!config.useCustomButtons\">\n        <button *ngIf=\"config.submitFn\" type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"cancel()\" flow-btn translate>misc.Cancel</button>\n        <button *ngIf=\"!config.submitFn\" type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"cancel()\" flow-btn translate>misc.Close</button>\n        <button *ngIf=\"config.submitFn\" type=\"submit\" class=\"btn btn-primary\" flow-btn>{{config.submitLabel | translate}}</button>\n        <button *ngIf=\"config.editFn\" type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"openEditForm()\" flow-btn>{{config.editLabel | translate}}</button>\n        <button *ngIf=\"config.unarchiveFn\" type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"handleCallback(config.unarchiveFn, 'unarchiveWarning')\" flow-btn translate>misc.Unarchive</button>\n        <button *ngIf=\"config.deleteFn\" type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"handleCallback(config.deleteFn, 'deleteWarning')\" flow-btn translate>misc.Delete</button>\n        <button *ngIf=\"config.archiveFn\" type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"handleCallback(config.archiveFn, 'archiveWarning', config.archiveValidationFn)\" flow-btn translate>misc.Archive</button>\n    </ng-container>\n    <ng-container *ngIf=\"config.useCustomButtons\">\n        <button *ngFor=\"let button of config.customButtons\" [attr.type]=\"button.type\" [ngClass]=\"button.class\" (click)=\"button.onClick(form, button.action)\" flow-btn>{{button.label | translate}}</button>\n    </ng-container>\n</div>"
    }]
  }], () => [{
    type: i1$4.NgbActiveModal
  }, {
    type: i1$4.NgbModal
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i2$1.UntypedFormBuilder
  }, {
    type: i1$7.Router
  }, {
    type: i1$1.TranslateService
  }, {
    type: GlobalService
  }, {
    type: FormErrorService
  }, {
    type: i0.NgZone
  }, {
    type: JanusFormConfigService
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: ['JANUS_VERSION']
    }]
  }], {
    modalId: [{
      type: Input
    }],
    resource: [{
      type: Input
    }],
    callbacks: [{
      type: Input
    }],
    config: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JanusFormModalExtendedComponent, {
    className: "JanusFormModalExtendedComponent",
    filePath: "janus/janus-form-modal-extended.component.ts",
    lineNumber: 21
  });
})();
class JanusUiModule {
  static forRoot() {
    return {
      ngModule: JanusUiModule,
      providers: [{
        provide: HTTP_INTERCEPTORS,
        useClass: JanusSessionTimeoutInterceptor,
        multi: true
      }]
    };
  }
  static {
    this.ɵfac = function JanusUiModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JanusUiModule)();
    };
  }
  static {
    this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
      type: JanusUiModule
    });
  }
  static {
    this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
      providers: [provideHttpClient(withInterceptorsFromDi())],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, DataTableModule, SyngCommonModule, DynamicFormModule, NgxSkeletonLoaderModule, TooltipModule.forRoot(), TypeaheadModule.forRoot(), ModalModule.forRoot(), TimepickerModule.forRoot(), EditorModule, TranslateModule, BsDropdownModule, NgbDropdownModule, CdkListboxModule, JanusSVGIconComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JanusUiModule, [{
    type: NgModule,
    args: [{
      declarations: [JanusDataTable, JanusDataTableRow, JanusDataTableColumn, JanusDataTableHeader, JanusDataTablePagination, JanusFormComponent, JanusDynamicFieldDirective, JanusFormInputComponent, JanusFormTextareaComponent, JanusFormRadioComponent, JanusFormACLookupComponent, JanusFormStaticComponent, JanusFormSwitchComponent, JanusFormCheckboxComponent, JanusFormHierpicklistComponent, JanusSessionTimeoutModalComponent, JanusLoadingSpinnerDirective, ToastComponent, JanusAlertComponent, JanusBadgeComponent, JanusSubheadingComponent, JanusHelpComponent, JanusFormSelectComponent, JanusFormNumberComponent, JanusFormDatePickerComponent, JanusFormRangeDatePickerComponent, JanusFormTimepickerComponent, JanusFiltersComponent, JanusModalComponent, JanusModalFormComponent, JanusFormRichtextComponent, JanusFormFileUploadComponent, JanusProgressSpinnerComponent, JanusTabsComponent, JanusFormRelationComponent, JanusFormRatingComponent, JanusFormButtonComponent, JanusFormRangeComponent, JanusFormStaticListComponent, JanusFormMultiSelectComponent, JanusFormNGSelectComponent, JanusFormLocationComponent, JanusFormMoxieManagerComponent, JanusFormMoxieManagerStaticComponent, JanusFormMinMaxComponent, JanusFormNumberComparisonComponent, JanusFormImageUploadComponent, JanusN1Component, JanusFormDatetimepickerComponent, JanusRequiredComponent, JanusMonthYearPicker, JanusManagerTemplatesComponent, JanusFormModalExtendedComponent],
      exports: [JanusFormComponent, JanusDynamicFieldDirective, JanusDataTable, JanusDataTableRow, JanusDataTableColumn, JanusDataTableHeader, JanusLoadingSpinnerDirective, ToastComponent, JanusAlertComponent, JanusBadgeComponent, JanusSubheadingComponent, JanusHelpComponent, JanusSVGIconComponent, JanusFormSelectComponent, JanusFormNumberComponent, JanusFormDatePickerComponent, JanusFormRangeDatePickerComponent, JanusFormTimepickerComponent, JanusFiltersComponent, JanusModalComponent, JanusModalFormComponent, JanusFormFileUploadComponent, JanusProgressSpinnerComponent, JanusTabsComponent, JanusManagerTemplatesComponent, JanusFormModalExtendedComponent],
      schemas: [CUSTOM_ELEMENTS_SCHEMA],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, DataTableModule, SyngCommonModule, DynamicFormModule, NgxSkeletonLoaderModule, TooltipModule.forRoot(), TypeaheadModule.forRoot(), ModalModule.forRoot(), TimepickerModule.forRoot(), EditorModule, TranslateModule, BsDropdownModule, NgbDropdownModule, CdkListboxModule, JanusSVGIconComponent],
      providers: [provideHttpClient(withInterceptorsFromDi())]
    }]
  }], null, null);
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(JanusUiModule, {
    declarations: [JanusDataTable, JanusDataTableRow, JanusDataTableColumn, JanusDataTableHeader, JanusDataTablePagination, JanusFormComponent, JanusDynamicFieldDirective, JanusFormInputComponent, JanusFormTextareaComponent, JanusFormRadioComponent, JanusFormACLookupComponent, JanusFormStaticComponent, JanusFormSwitchComponent, JanusFormCheckboxComponent, JanusFormHierpicklistComponent, JanusSessionTimeoutModalComponent, JanusLoadingSpinnerDirective, ToastComponent, JanusAlertComponent, JanusBadgeComponent, JanusSubheadingComponent, JanusHelpComponent, JanusFormSelectComponent, JanusFormNumberComponent, JanusFormDatePickerComponent, JanusFormRangeDatePickerComponent, JanusFormTimepickerComponent, JanusFiltersComponent, JanusModalComponent, JanusModalFormComponent, JanusFormRichtextComponent, JanusFormFileUploadComponent, JanusProgressSpinnerComponent, JanusTabsComponent, JanusFormRelationComponent, JanusFormRatingComponent, JanusFormButtonComponent, JanusFormRangeComponent, JanusFormStaticListComponent, JanusFormMultiSelectComponent, JanusFormNGSelectComponent, JanusFormLocationComponent, JanusFormMoxieManagerComponent, JanusFormMoxieManagerStaticComponent, JanusFormMinMaxComponent, JanusFormNumberComparisonComponent, JanusFormImageUploadComponent, JanusN1Component, JanusFormDatetimepickerComponent, JanusRequiredComponent, JanusMonthYearPicker, JanusManagerTemplatesComponent, JanusFormModalExtendedComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, DataTableModule, SyngCommonModule, DynamicFormModule, NgxSkeletonLoaderModule, i3$2.TooltipModule, i3$1.TypeaheadModule, i1$3.ModalModule, i4$1.TimepickerModule, EditorModule, TranslateModule, BsDropdownModule, NgbDropdownModule, CdkListboxModule, JanusSVGIconComponent],
    exports: [JanusFormComponent, JanusDynamicFieldDirective, JanusDataTable, JanusDataTableRow, JanusDataTableColumn, JanusDataTableHeader, JanusLoadingSpinnerDirective, ToastComponent, JanusAlertComponent, JanusBadgeComponent, JanusSubheadingComponent, JanusHelpComponent, JanusSVGIconComponent, JanusFormSelectComponent, JanusFormNumberComponent, JanusFormDatePickerComponent, JanusFormRangeDatePickerComponent, JanusFormTimepickerComponent, JanusFiltersComponent, JanusModalComponent, JanusModalFormComponent, JanusFormFileUploadComponent, JanusProgressSpinnerComponent, JanusTabsComponent, JanusManagerTemplatesComponent, JanusFormModalExtendedComponent]
  });
})();
i0.ɵɵsetComponentScope(JanusDataTable, function () {
  return [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1$7.RouterLink, i1$1.TranslateDirective, Hide, KeyboardTrapDirective, DragTableDirective, hierarchicalListWidgetComponent, i12.NgxSkeletonLoaderComponent, i1$4.NgbDropdown, i1$4.NgbDropdownToggle, i1$4.NgbDropdownMenu, JanusSVGIconComponent, JanusDataTableRow, JanusDataTableHeader, JanusDataTablePagination];
}, function () {
  return [i1.LowerCasePipe, i1.TitleCasePipe, i1$1.TranslatePipe, PixelConverter, MinPipe$1];
});
i0.ɵɵsetComponentScope(JanusFormSelectComponent, function () {
  return [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormControlName, JanusDynamicFieldDirective, JanusRequiredComponent];
}, function () {
  return [i1.AsyncPipe, i1.KeyValuePipe, i1$1.TranslatePipe, SafeHtmlPipe];
});
i0.ɵɵsetComponentScope(JanusFormRelationComponent, function () {
  return [i1.NgClass, i1.NgForOf, i1.NgIf, JanusDynamicFieldDirective];
}, function () {
  return [i1$1.TranslatePipe, SafeHtmlPipe];
});
i0.ɵɵsetComponentScope(JanusN1Component, function () {
  return [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.NgControlStatusGroup, i2$1.FormGroupDirective, i2$1.FormGroupName, i2$1.FormArrayName, JanusDynamicFieldDirective];
}, function () {
  return [i1$1.TranslatePipe, SafeHtmlPipe];
});

/**
 * Generated bundle index. Do not edit.
 */

export { AddNewItem, AnchorUrlModel, AutoColorDirective, BackendService, BreadcrumbsComponent, CLOSEST_SCROLL_CONTAINER_LIST, CallbackPipe, CatchClickDirective, CollapsableWellComponent, ContactChipComponent, DataTable, DataTableColumn, DataTableHeader, DataTableModule, DataTableResource, DataTableRow, DestroyEmitter, DisableRightClickDirective, DragTableDirective, DynamicFieldDirective, DynamicFormMobileFilterComponent, DynamicFormModule, EmptyState, EmptyStateActionButton, EmptyStateActionButtonModel, EmptyStateModel, ExpandableContentComponent, ExternalUrlComponent, FileExtensionPipe, FileSizePipe, FilterPipe, FiltersComponent, FormActionsComponent, FormComponent, FormConfig, FormErrorService, FormModalComponent, FormModalExtendedComponent, FormSidebarComponent, GlobalService, Help, HelpComponent, HelpService, Hide, HighlightSearchPipe, HtmlFormatterService, HttpFormErrorInterceptor, HttpLoaderFactory, IconButton, ImageCropComponent, Initials, JanusAlertComponent, JanusBadgeComponent, JanusDataTable, JanusDataTableColumn, JanusDataTableHeader, JanusDataTablePagination, JanusDataTableRow, JanusDynamicFieldDirective, JanusFiltersComponent, JanusFormButtonComponent, JanusFormCheckboxComponent, JanusFormComponent, JanusFormConfigService, JanusFormDatePickerComponent, JanusFormDatetimepickerComponent, JanusFormFileUploadComponent, JanusFormHierpicklistComponent, JanusFormImageUploadComponent, JanusFormInputComponent, JanusFormLocationComponent, JanusFormMinMaxComponent, JanusFormModalExtendedComponent, JanusFormMoxieManagerComponent, JanusFormMoxieManagerStaticComponent, JanusFormMultiSelectComponent, JanusFormNGSelectComponent, JanusFormNumberComparisonComponent, JanusFormNumberComponent, JanusFormRadioComponent, JanusFormRangeComponent, JanusFormRangeDatePickerComponent, JanusFormRatingComponent, JanusFormRelationComponent, JanusFormRichtextComponent, JanusFormSelectComponent, JanusFormStaticComponent, JanusFormStaticListComponent, JanusFormSwitchComponent, JanusFormTextareaComponent, JanusFormTimepickerComponent, JanusHelpComponent, JanusLoadingSpinnerDirective, JanusManagerTemplatesComponent, JanusModalComponent, JanusModalFormComponent, JanusN1Component, JanusProgressSpinnerComponent, JanusSVGIconComponent, JanusSubheadingComponent, JanusTabItem, JanusTabsComponent, JanusUiModule, JanusWindowSizeService, KeyboardTrapDirective, KeysPipe, ListFilterChipsComponent, ListFilterMultipleSelect, ListFilterMultipleSelectField, ListFilterSingleSelect, ListFilterSingleSelectOption, ListItemElement, ListItemFilterMatch, ListItemLabel, ListPageComponent, ListPageHeaderComponent, ListPagePaginationComponent, ListSimpleFilterComponent, ListSimpleFilterMultipleSelectComponent, ListSimpleFilterSingleSelectComponent, ListSorts, ListState, MailwizComponent, MainLayoutComponent, MinPipe$1 as MinPipe, ModalComponent, ModalWindowLayoutComponent, ModernTabComponent, Monogram, MonogramPipe, MyMissingTranslationHandler, NotificationsComponent, OrderByPipe, PageFooterComponent, PageHeaderComponent, PaginationComponent, PicklistValue, PixelConverter, ProgressBarComponent, ProgressSpinnerComponent, ReadMoreDirective, RowAnchorModel, SafeHtmlPipe, SanitizeHtmlPipe, SearchTextPipe$1 as SearchTextPipe, SelectedFilter, SessionTimeoutInterceptor, SidebarNavComponent, SimpleFilterModel, SizeDetectorComponent, SizeDetectorService, SkeletonLoaderModel, SocketService, StandardListPageModel, State, StripUnderscorePipe, SyngCommonModule, TabComponent, TabsComponent, Thumbnail, ToastAlertComponent, ToastAlertService, ToastAlertType, ToastComponent, TranslateMessageFormatCompilerFactory, TranslationButton, TranslationMenu, TranslationMenuItem, TranslationsModule, TriStateCheckboxComponent, TrueFalseValueDirective, TruncateTextPipe, ValkyrieAuthService, ValkyrieBackendService, ValkyrieCommonService, ValkyrieUiModule, ValkyrieUtilsService, WarningModalComponent, convertSoDependencies, debounce, defaultTranslations, fromMutationObserver, getCurrentCssVariableBreakpoint, getKeyboardFocusableElements, getRandomId, hasRequiredField, hierarchicalListWidgetComponent, janusFormActionsDropdownHandler, janusHintsHandler, janusSecondaryActionsDropdownHandler, janusTableActionsAriaLabelHandler, janusTabsDropdownHandler, tapOnce, uniqueElementId };
